// -- (function(scope){
// -- 'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (typeof x.$ === 'undefined')
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File !== 'undefined' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[36m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.p.nI === region.k.nI)
	{
		return 'on line ' + region.p.nI;
	}
	return 'on lines ' + region.p.nI + ' through ' + region.k.nI;
}



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return !isNaN(word)
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**_UNUSED/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (value.hasOwnProperty(key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	object[key] = _Json_unwrap(value);
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.nj,
		impl.n,
		impl.pp,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	var initPair = init(result.a);
	var model = initPair.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		var pair = A2(update, msg, model);
		stepper(model = pair.a, viewMetadata);
		_Platform_enqueueEffects(managers, pair.b, subscriptions(model));
	}

	_Platform_enqueueEffects(managers, initPair.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS
//
// Effects must be queued!
//
// Say your init contains a synchronous command, like Time.now or Time.here
//
//   - This will produce a batch of effects (FX_1)
//   - The synchronous task triggers the subsequent `update` call
//   - This will produce a batch of effects (FX_2)
//
// If we just start dispatching FX_2, subscriptions from FX_2 can be processed
// before subscriptions from FX_1. No good! Earlier versions of this code had
// this problem, leading to these reports:
//
//   https://github.com/elm/core/issues/980
//   https://github.com/elm/core/pull/981
//   https://github.com/elm/compiler/issues/1776
//
// The queue is necessary to avoid ordering issues for synchronous commands.


// Why use true/false here? Why not just check the length of the queue?
// The goal is to detect "are we currently dispatching effects?" If we
// are, we need to bail and let the ongoing while loop handle things.
//
// Now say the queue has 1 element. When we dequeue the final element,
// the queue will be empty, but we are still actively dispatching effects.
// So you could get queue jumping in a really tricky category of cases.
//
var _Platform_effectsQueue = [];
var _Platform_effectsActive = false;


function _Platform_enqueueEffects(managers, cmdBag, subBag)
{
	_Platform_effectsQueue.push({ p: managers, q: cmdBag, r: subBag });

	if (_Platform_effectsActive) return;

	_Platform_effectsActive = true;
	for (var fx; fx = _Platform_effectsQueue.shift(); )
	{
		_Platform_dispatchEffects(fx.p, fx.q, fx.r);
	}
	_Platform_effectsActive = false;
}


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				s: bag.n,
				t: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.t)
		{
			x = temp.s(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		u: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		u: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


/*
function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}

*/

/*
function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}
*/


/*
function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}

*/

/*
function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}
*/




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS
//
// For some reason, tabs can appear in href protocols and it still works.
// So '\tjava\tSCRIPT:alert("!!!")' and 'javascript:alert("!!!")' are the same
// in practice. That is why _VirtualDom_RE_js and _VirtualDom_RE_js_html look
// so freaky.
//
// Pulling the regular expressions out to the top level gives a slight speed
// boost in small benchmarks (4-10%) but hoisting values to reduce allocation
// can be unpredictable in large programs where JIT may have a harder time with
// functions are not fully self-contained. The benefit is more that the js and
// js_html ones are so weird that I prefer to see them near each other.


var _VirtualDom_RE_script = /^script$/i;
var _VirtualDom_RE_on_formAction = /^(on|formAction$)/i;
var _VirtualDom_RE_js = /^\s*j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:/i;
var _VirtualDom_RE_js_html = /^\s*(j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:|d\s*a\s*t\s*a\s*:\s*t\s*e\s*x\s*t\s*\/\s*h\s*t\s*m\s*l\s*(,|;))/i;


function _VirtualDom_noScript(tag)
{
	return _VirtualDom_RE_script.test(tag) ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return _VirtualDom_RE_on_formAction.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return _VirtualDom_RE_js.test(value)
		? /**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return _VirtualDom_RE_js_html.test(value)
		? /**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlJson(value)
{
	return (typeof _Json_unwrap(value) === 'string' && _VirtualDom_RE_js_html.test(_Json_unwrap(value)))
		? _Json_wrap(
			/**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		) : value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		nS: func(record.nS),
		le: record.le,
		kF: record.kF
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.nS;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.le;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.kF) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.nj,
		impl.n,
		impl.pp,
		function(sendToApp, initialModel) {
			var view = impl.pR;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.nj,
		impl.n,
		impl.pp,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.ib && impl.ib(sendToApp)
			var view = impl.pR;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.fv);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.fb) && (_VirtualDom_doc.title = title = doc.fb);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.os;
	var onUrlRequest = impl.ot;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		ib: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.oU === next.oU
							&& curr.ez === next.ez
							&& curr.oI.a === next.oI.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		nj: function(flags)
		{
			return A3(impl.nj, flags, _Browser_getUrl(), key);
		},
		pR: impl.pR,
		n: impl.n,
		pp: impl.pp
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { m5: 'hidden', l1: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { m5: 'mozHidden', l1: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { m5: 'msHidden', l1: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { m5: 'webkitHidden', l1: 'webkitvisibilitychange' }
		: { m5: 'hidden', l1: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		k2: _Browser_getScene(),
		pS: {
			pW: _Browser_window.pageXOffset,
			pX: _Browser_window.pageYOffset,
			y: _Browser_doc.documentElement.clientWidth,
			fW: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		y: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		fW: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			k2: {
				y: node.scrollWidth,
				fW: node.scrollHeight
			},
			pS: {
				pW: node.scrollLeft,
				pX: node.scrollTop,
				y: node.clientWidth,
				fW: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			k2: _Browser_getScene(),
			pS: {
				pW: x,
				pX: y,
				y: _Browser_doc.documentElement.clientWidth,
				fW: _Browser_doc.documentElement.clientHeight
			},
			jg: {
				pW: x + rect.left,
				pX: y + rect.top,
				y: rect.width,
				fW: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}



var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});



// SEND REQUEST

var _Http_toTask = F3(function(router, toTask, request)
{
	return _Scheduler_binding(function(callback)
	{
		function done(response) {
			callback(toTask(request.fN.a(response)));
		}

		var xhr = new XMLHttpRequest();
		xhr.addEventListener('error', function() { done($elm$http$Http$NetworkError_); });
		xhr.addEventListener('timeout', function() { done($elm$http$Http$Timeout_); });
		xhr.addEventListener('load', function() { done(_Http_toResponse(request.fN.b, xhr)); });
		$elm$core$Maybe$isJust(request.lr) && _Http_track(router, xhr, request.lr.a);

		try {
			xhr.open(request.bL, request.gL, true);
		} catch (e) {
			return done($elm$http$Http$BadUrl_(request.gL));
		}

		_Http_configureRequest(xhr, request);

		request.fv.a && xhr.setRequestHeader('Content-Type', request.fv.a);
		xhr.send(request.fv.b);

		return function() { xhr.c = true; xhr.abort(); };
	});
});


// CONFIGURE

function _Http_configureRequest(xhr, request)
{
	for (var headers = request.m4; headers.b; headers = headers.b) // WHILE_CONS
	{
		xhr.setRequestHeader(headers.a.a, headers.a.b);
	}
	xhr.timeout = request.am.a || 0;
	xhr.responseType = request.fN.d;
	xhr.withCredentials = request.lT;
}


// RESPONSES

function _Http_toResponse(toBody, xhr)
{
	return A2(
		200 <= xhr.status && xhr.status < 300 ? $elm$http$Http$GoodStatus_ : $elm$http$Http$BadStatus_,
		_Http_toMetadata(xhr),
		toBody(xhr.response)
	);
}


// METADATA

function _Http_toMetadata(xhr)
{
	return {
		gL: xhr.responseURL,
		pk: xhr.status,
		ld: xhr.statusText,
		m4: _Http_parseHeaders(xhr.getAllResponseHeaders())
	};
}


// HEADERS

function _Http_parseHeaders(rawHeaders)
{
	if (!rawHeaders)
	{
		return $elm$core$Dict$empty;
	}

	var headers = $elm$core$Dict$empty;
	var headerPairs = rawHeaders.split('\r\n');
	for (var i = headerPairs.length; i--; )
	{
		var headerPair = headerPairs[i];
		var index = headerPair.indexOf(': ');
		if (index > 0)
		{
			var key = headerPair.substring(0, index);
			var value = headerPair.substring(index + 2);

			headers = A3($elm$core$Dict$update, key, function(oldValue) {
				return $elm$core$Maybe$Just($elm$core$Maybe$isJust(oldValue)
					? value + ', ' + oldValue.a
					: value
				);
			}, headers);
		}
	}
	return headers;
}


// EXPECT

var _Http_expect = F3(function(type, toBody, toValue)
{
	return {
		$: 0,
		d: type,
		b: toBody,
		a: toValue
	};
});

var _Http_mapExpect = F2(function(func, expect)
{
	return {
		$: 0,
		d: expect.d,
		b: expect.b,
		a: function(x) { return func(expect.a(x)); }
	};
});

function _Http_toDataView(arrayBuffer)
{
	return new DataView(arrayBuffer);
}


// BODY and PARTS

var _Http_emptyBody = { $: 0 };
var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });

function _Http_toFormData(parts)
{
	for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
	{
		var part = parts.a;
		formData.append(part.a, part.b);
	}
	return formData;
}

var _Http_bytesToBlob = F2(function(mime, bytes)
{
	return new Blob([bytes], { type: mime });
});


// PROGRESS

function _Http_track(router, xhr, tracker)
{
	// TODO check out lengthComputable on loadstart event

	xhr.upload.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Sending({
			o9: event.loaded,
			gC: event.total
		}))));
	});
	xhr.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Receiving({
			oX: event.loaded,
			gC: event.lengthComputable ? $elm$core$Maybe$Just(event.total) : $elm$core$Maybe$Nothing
		}))));
	});
}

// CREATE

var _Regex_never = /.^/;

var _Regex_fromStringWith = F2(function(options, string)
{
	var flags = 'g';
	if (options.nX) { flags += 'm'; }
	if (options.l0) { flags += 'i'; }

	try
	{
		return $elm$core$Maybe$Just(new RegExp(string, flags));
	}
	catch(error)
	{
		return $elm$core$Maybe$Nothing;
	}
});


// USE

var _Regex_contains = F2(function(re, string)
{
	return string.match(re) !== null;
});


var _Regex_findAtMost = F3(function(n, re, str)
{
	var out = [];
	var number = 0;
	var string = str;
	var lastIndex = re.lastIndex;
	var prevLastIndex = -1;
	var result;
	while (number++ < n && (result = re.exec(string)))
	{
		if (prevLastIndex == re.lastIndex) break;
		var i = result.length - 1;
		var subs = new Array(i);
		while (i > 0)
		{
			var submatch = result[i];
			subs[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		out.push(A4($elm$regex$Regex$Match, result[0], result.index, number, _List_fromArray(subs)));
		prevLastIndex = re.lastIndex;
	}
	re.lastIndex = lastIndex;
	return _List_fromArray(out);
});


var _Regex_replaceAtMost = F4(function(n, re, replacer, string)
{
	var count = 0;
	function jsReplacer(match)
	{
		if (count++ >= n)
		{
			return match;
		}
		var i = arguments.length - 3;
		var submatches = new Array(i);
		while (i > 0)
		{
			var submatch = arguments[i];
			submatches[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		return replacer(A4($elm$regex$Regex$Match, match, arguments[arguments.length - 2], count, _List_fromArray(submatches)));
	}
	return string.replace(re, jsReplacer);
});

var _Regex_splitAtMost = F3(function(n, re, str)
{
	var string = str;
	var out = [];
	var start = re.lastIndex;
	var restoreLastIndex = re.lastIndex;
	while (n--)
	{
		var result = re.exec(string);
		if (!result) break;
		out.push(string.slice(start, result.index));
		start = re.lastIndex;
	}
	out.push(string.slice(start));
	re.lastIndex = restoreLastIndex;
	return _List_fromArray(out);
});

var _Regex_infinity = Infinity;


function _Url_percentEncode(string)
{
	return encodeURIComponent(string);
}

function _Url_percentDecode(string)
{
	try
	{
		return $elm$core$Maybe$Just(decodeURIComponent(string));
	}
	catch (e)
	{
		return $elm$core$Maybe$Nothing;
	}
}



// STRINGS


var _Parser_isSubString = F5(function(smallString, offset, row, col, bigString)
{
	var smallLength = smallString.length;
	var isGood = offset + smallLength <= bigString.length;

	for (var i = 0; isGood && i < smallLength; )
	{
		var code = bigString.charCodeAt(offset);
		isGood =
			smallString[i++] === bigString[offset++]
			&& (
				code === 0x000A /* \n */
					? ( row++, col=1 )
					: ( col++, (code & 0xF800) === 0xD800 ? smallString[i++] === bigString[offset++] : 1 )
			)
	}

	return _Utils_Tuple3(isGood ? offset : -1, row, col);
});



// CHARS


var _Parser_isSubChar = F3(function(predicate, offset, string)
{
	return (
		string.length <= offset
			? -1
			:
		(string.charCodeAt(offset) & 0xF800) === 0xD800
			? (predicate(_Utils_chr(string.substr(offset, 2))) ? offset + 2 : -1)
			:
		(predicate(_Utils_chr(string[offset]))
			? ((string[offset] === '\n') ? -2 : (offset + 1))
			: -1
		)
	);
});


var _Parser_isAsciiCode = F3(function(code, offset, string)
{
	return string.charCodeAt(offset) === code;
});



// NUMBERS


var _Parser_chompBase10 = F2(function(offset, string)
{
	for (; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (code < 0x30 || 0x39 < code)
		{
			return offset;
		}
	}
	return offset;
});


var _Parser_consumeBase = F3(function(base, offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var digit = string.charCodeAt(offset) - 0x30;
		if (digit < 0 || base <= digit) break;
		total = base * total + digit;
	}
	return _Utils_Tuple2(offset, total);
});


var _Parser_consumeBase16 = F2(function(offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (0x30 <= code && code <= 0x39)
		{
			total = 16 * total + code - 0x30;
		}
		else if (0x41 <= code && code <= 0x46)
		{
			total = 16 * total + code - 55;
		}
		else if (0x61 <= code && code <= 0x66)
		{
			total = 16 * total + code - 87;
		}
		else
		{
			break;
		}
	}
	return _Utils_Tuple2(offset, total);
});



// FIND STRING


var _Parser_findSubString = F5(function(smallString, offset, row, col, bigString)
{
	var newOffset = bigString.indexOf(smallString, offset);
	var target = newOffset < 0 ? bigString.length : newOffset + smallString.length;

	while (offset < target)
	{
		var code = bigString.charCodeAt(offset++);
		code === 0x000A /* \n */
			? ( col=1, row++ )
			: ( col++, (code & 0xF800) === 0xD800 && offset++ )
	}

	return _Utils_Tuple3(newOffset, row, col);
});



function _Time_now(millisToPosix)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(millisToPosix(Date.now())));
	});
}

var _Time_setInterval = F2(function(interval, task)
{
	return _Scheduler_binding(function(callback)
	{
		var id = setInterval(function() { _Scheduler_rawSpawn(task); }, interval);
		return function() { clearInterval(id); };
	});
});

function _Time_here()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(
			A2($elm$time$Time$customZone, -(new Date().getTimezoneOffset()), _List_Nil)
		));
	});
}


function _Time_getZoneName()
{
	return _Scheduler_binding(function(callback)
	{
		try
		{
			var name = $elm$time$Time$Name(Intl.DateTimeFormat().resolvedOptions().timeZone);
		}
		catch (e)
		{
			var name = $elm$time$Time$Offset(new Date().getTimezoneOffset());
		}
		callback(_Scheduler_succeed(name));
	});
}



// DECODER

var _File_decoder = _Json_decodePrim(function(value) {
	// NOTE: checks if `File` exists in case this is run on node
	return (typeof File !== 'undefined' && value instanceof File)
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FILE', value);
});


// METADATA

function _File_name(file) { return file.name; }
function _File_mime(file) { return file.type; }
function _File_size(file) { return file.size; }

function _File_lastModified(file)
{
	return $elm$time$Time$millisToPosix(file.lastModified);
}


// DOWNLOAD

var _File_downloadNode;

function _File_getDownloadNode()
{
	return _File_downloadNode || (_File_downloadNode = document.createElement('a'));
}

var _File_download = F3(function(name, mime, content)
{
	return _Scheduler_binding(function(callback)
	{
		var blob = new Blob([content], {type: mime});

		// for IE10+
		if (navigator.msSaveOrOpenBlob)
		{
			navigator.msSaveOrOpenBlob(blob, name);
			return;
		}

		// for HTML5
		var node = _File_getDownloadNode();
		var objectUrl = URL.createObjectURL(blob);
		node.href = objectUrl;
		node.download = name;
		_File_click(node);
		URL.revokeObjectURL(objectUrl);
	});
});

function _File_downloadUrl(href)
{
	return _Scheduler_binding(function(callback)
	{
		var node = _File_getDownloadNode();
		node.href = href;
		node.download = '';
		node.origin === location.origin || (node.target = '_blank');
		_File_click(node);
	});
}


// IE COMPATIBILITY

function _File_makeBytesSafeForInternetExplorer(bytes)
{
	// only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/10
	// all other browsers can just run `new Blob([bytes])` directly with no problem
	//
	return new Uint8Array(bytes.buffer, bytes.byteOffset, bytes.byteLength);
}

function _File_click(node)
{
	// only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/11
	// all other browsers have MouseEvent and do not need this conditional stuff
	//
	if (typeof MouseEvent === 'function')
	{
		node.dispatchEvent(new MouseEvent('click'));
	}
	else
	{
		var event = document.createEvent('MouseEvents');
		event.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
		document.body.appendChild(node);
		node.dispatchEvent(event);
		document.body.removeChild(node);
	}
}


// UPLOAD

var _File_node;

function _File_uploadOne(mimes)
{
	return _Scheduler_binding(function(callback)
	{
		_File_node = document.createElement('input');
		_File_node.type = 'file';
		_File_node.accept = A2($elm$core$String$join, ',', mimes);
		_File_node.addEventListener('change', function(event)
		{
			callback(_Scheduler_succeed(event.target.files[0]));
		});
		_File_click(_File_node);
	});
}

function _File_uploadOneOrMore(mimes)
{
	return _Scheduler_binding(function(callback)
	{
		_File_node = document.createElement('input');
		_File_node.type = 'file';
		_File_node.multiple = true;
		_File_node.accept = A2($elm$core$String$join, ',', mimes);
		_File_node.addEventListener('change', function(event)
		{
			var elmFiles = _List_fromArray(event.target.files);
			callback(_Scheduler_succeed(_Utils_Tuple2(elmFiles.a, elmFiles.b)));
		});
		_File_click(_File_node);
	});
}


// CONTENT

function _File_toString(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(reader.result));
		});
		reader.readAsText(blob);
		return function() { reader.abort(); };
	});
}

function _File_toBytes(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(new DataView(reader.result)));
		});
		reader.readAsArrayBuffer(blob);
		return function() { reader.abort(); };
	});
}

function _File_toUrl(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(reader.result));
		});
		reader.readAsDataURL(blob);
		return function() { reader.abort(); };
	});
}

var $author$project$Main$ChangedUrl = function (a) {
	return {$: 1, a: a};
};
var $author$project$Main$ClickedLink = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$EQ = 1;
var $elm$core$Basics$GT = 2;
var $elm$core$Basics$LT = 0;
var $elm$core$List$cons = _List_cons;
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$False = 1;
var $elm$core$Basics$add = _Basics_add;
var $elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Maybe$Nothing = {$: 1};
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\n    ',
		A2($elm$core$String$split, '\n', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 1) {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\n\n',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.D) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.H),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.H);
		} else {
			var treeLen = builder.D * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.N) : builder.N;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.D);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.H) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.H);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{N: nodeList, D: (len / $elm$core$Array$branchFactor) | 0, H: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = 0;
var $elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
var $elm$url$Url$Http = 0;
var $elm$url$Url$Https = 1;
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {mW: fragment, ez: host, gm: path, oI: port_, oU: protocol, dO: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$length = _String_length;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		0,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		1,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$Perform = $elm$core$Basics$identity;
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$init = $elm$core$Task$succeed(0);
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return 0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0;
		return A2($elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			A2($elm$core$Task$map, toMessage, task));
	});
var $elm$browser$Browser$application = _Browser_application;
var $author$project$Log$DebugBreadcrumb = 1;
var $author$project$Log$DebugLevel = 4;
var $author$project$Main$GotPageMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Main$Ignored = {$: 0};
var $author$project$Main$Redirect = {$: 0};
var $author$project$UpdateResult$addBreadcrumb = F2(
	function (breadcrumb, uResult) {
		return _Utils_update(
			uResult,
			{
				Y: A2($elm$core$List$cons, breadcrumb, uResult.Y)
			});
	});
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $author$project$Main$AdminMoved = {$: 3};
var $author$project$Main$Analysis = function (a) {
	return {$: 28, a: a};
};
var $author$project$Route$Analysis = {$: 44};
var $author$project$Main$Claim = F3(
	function (a, b, c) {
		return {$: 9, a: a, b: b, c: c};
	});
var $author$project$Route$Claim = F3(
	function (a, b, c) {
		return {$: 34, a: a, b: b, c: c};
	});
var $author$project$Main$ComingSoon = {$: 2};
var $author$project$Main$CommunityAbout = function (a) {
	return {$: 5, a: a};
};
var $author$project$Route$CommunityAbout = {$: 13};
var $author$project$Main$CommunityEditor = function (a) {
	return {$: 7, a: a};
};
var $author$project$Main$CommunityObjectives = function (a) {
	return {$: 6, a: a};
};
var $author$project$Route$CommunityObjectives = function (a) {
	return {$: 14, a: a};
};
var $author$project$Main$CommunitySelector = function (a) {
	return {$: 8, a: a};
};
var $author$project$Route$CommunitySelector = function (a) {
	return {$: 33, a: a};
};
var $author$project$Main$Dashboard = function (a) {
	return {$: 11, a: a};
};
var $author$project$Route$Dashboard = {$: 12};
var $author$project$Route$EditSale = F2(
	function (a, b) {
		return {$: 38, a: a, b: b};
	});
var $author$project$Main$GotAnalysisMsg = function (a) {
	return {$: 28, a: a};
};
var $author$project$Main$GotCommunityAboutMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Main$GotCommunityEditorMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Main$GotCommunityObjectivesMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Main$GotDashboardMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Main$GotInviteMsg = function (a) {
	return {$: 25, a: a};
};
var $author$project$Main$GotJoinMsg = function (a) {
	return {$: 26, a: a};
};
var $author$project$Page$GotLoggedInMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Main$GotLoginMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Main$GotNewsMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$Main$GotNotificationMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Main$GotPaymentHistoryMsg = function (a) {
	return {$: 13, a: a};
};
var $author$project$Main$GotProfileAddContactMsg = function (a) {
	return {$: 18, a: a};
};
var $author$project$Main$GotProfileAddKycMsg = function (a) {
	return {$: 16, a: a};
};
var $author$project$Main$GotProfileClaimsMsg = function (a) {
	return {$: 17, a: a};
};
var $author$project$Main$GotProfileEditorMsg = function (a) {
	return {$: 15, a: a};
};
var $author$project$Main$GotProfileMsg = function (a) {
	return {$: 14, a: a};
};
var $author$project$Main$GotRegisterMsg = function (a) {
	return {$: 19, a: a};
};
var $author$project$Main$GotSettingsMsg = function (a) {
	return {$: 20, a: a};
};
var $author$project$Main$GotShopEditorMsg = function (a) {
	return {$: 22, a: a};
};
var $author$project$Main$GotShopMsg = function (a) {
	return {$: 21, a: a};
};
var $author$project$Main$GotShopViewerMsg = function (a) {
	return {$: 23, a: a};
};
var $author$project$Session$LoggedIn$GotTimeInternal = function (a) {
	return {$: 25, a: a};
};
var $author$project$Main$GotTransferMsg = function (a) {
	return {$: 27, a: a};
};
var $author$project$Main$GotVerifyClaimMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Main$GotViewTransferScreenMsg = function (a) {
	return {$: 24, a: a};
};
var $author$project$Page$Guest = function (a) {
	return {$: 0, a: a};
};
var $author$project$Main$Invite = function (a) {
	return {$: 25, a: a};
};
var $author$project$Route$Invite = function (a) {
	return {$: 41, a: a};
};
var $author$project$Main$Join = function (a) {
	return {$: 26, a: a};
};
var $author$project$Route$Join = function (a) {
	return {$: 42, a: a};
};
var $author$project$Page$LoggedIn = function (a) {
	return {$: 1, a: a};
};
var $author$project$Main$Login = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Route$NewCommunity = {$: 15};
var $author$project$Route$NewSale = function (a) {
	return {$: 37, a: a};
};
var $author$project$Main$News = function (a) {
	return {$: 13, a: a};
};
var $author$project$Route$News = function (a) {
	return {$: 16, a: a};
};
var $author$project$Main$NotFound = {$: 1};
var $author$project$Main$Notification = function (a) {
	return {$: 10, a: a};
};
var $author$project$Route$Notification = {$: 5};
var $author$project$Main$PaymentHistory = function (a) {
	return {$: 4, a: a};
};
var $author$project$Route$PaymentHistory = function (a) {
	return {$: 10, a: a};
};
var $author$project$Main$Profile = function (a) {
	return {$: 14, a: a};
};
var $author$project$Route$Profile = function (a) {
	return {$: 11, a: a};
};
var $author$project$Main$ProfileAddContact = function (a) {
	return {$: 18, a: a};
};
var $author$project$Route$ProfileAddContact = {$: 9};
var $author$project$Main$ProfileAddKyc = function (a) {
	return {$: 16, a: a};
};
var $author$project$Route$ProfileAddKyc = {$: 7};
var $author$project$Main$ProfileClaims = function (a) {
	return {$: 17, a: a};
};
var $author$project$Route$ProfileClaims = function (a) {
	return {$: 8, a: a};
};
var $author$project$Main$ProfileEditor = function (a) {
	return {$: 15, a: a};
};
var $author$project$Route$ProfileEditor = {$: 6};
var $author$project$Main$Register = F3(
	function (a, b, c) {
		return {$: 19, a: a, b: b, c: c};
	});
var $author$project$Main$Settings = function (a) {
	return {$: 20, a: a};
};
var $author$project$Route$Settings = {$: 35};
var $author$project$Main$Shop = F2(
	function (a, b) {
		return {$: 21, a: a, b: b};
	});
var $author$project$Route$Shop = function (a) {
	return {$: 36, a: a};
};
var $author$project$Main$ShopEditor = F2(
	function (a, b) {
		return {$: 22, a: a, b: b};
	});
var $author$project$Main$ShopViewer = F2(
	function (a, b) {
		return {$: 23, a: a, b: b};
	});
var $author$project$Main$Transfer = function (a) {
	return {$: 27, a: a};
};
var $author$project$Route$Transfer = function (a) {
	return {$: 43, a: a};
};
var $author$project$Route$ViewSale = function (a) {
	return {$: 39, a: a};
};
var $author$project$Main$ViewTransfer = F2(
	function (a, b) {
		return {$: 24, a: a, b: b};
	});
var $author$project$Route$ViewTransfer = function (a) {
	return {$: 40, a: a};
};
var $author$project$Session$Guest$addAfterLoginRedirect = F2(
	function (route, model) {
		return _Utils_update(
			model,
			{
				lS: $elm$core$Maybe$Just(route)
			});
	});
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $author$project$Page$Community$About$CompletedLoadCommunity = function (a) {
	return {$: 1, a: a};
};
var $krisajenkins$remotedata$RemoteData$Loading = {$: 1};
var $author$project$Community$NewsField = 3;
var $author$project$Page$Community$About$NoOp = {$: 0};
var $author$project$Session$LoggedIn$RequestedCommunityField = function (a) {
	return {$: 7, a: a};
};
var $author$project$Community$UploadsField = 1;
var $author$project$UpdateResult$addCmd = F2(
	function (cmd, uResult) {
		return _Utils_update(
			uResult,
			{
				i0: _Utils_ap(
					uResult.i0,
					_List_fromArray(
						[cmd]))
			});
	});
var $author$project$UpdateResult$addExt = F2(
	function (eMsg, uResult) {
		return _Utils_update(
			uResult,
			{
				jo: _Utils_ap(
					uResult.jo,
					_List_fromArray(
						[eMsg]))
			});
	});
var $elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var $elm$core$Task$onError = _Scheduler_onError;
var $elm$core$Task$attempt = F2(
	function (resultToMessage, task) {
		return $elm$core$Task$command(
			A2(
				$elm$core$Task$onError,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
					$elm$core$Result$Err),
				A2(
					$elm$core$Task$andThen,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
						$elm$core$Result$Ok),
					task)));
	});
var $author$project$UpdateResult$init = function (model) {
	return {Y: _List_Nil, i0: _List_Nil, jm: _List_Nil, jo: _List_Nil, nV: model, kB: _List_Nil};
};
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $author$project$Session$LoggedIn$maybeInitWith = F3(
	function (toMsg, attribute, model) {
		var _v0 = attribute(model);
		if (_v0.$ === 3) {
			var value = _v0.a;
			return A2(
				$elm$core$Task$perform,
				toMsg,
				$elm$core$Task$succeed(value));
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $elm$browser$Browser$Dom$setViewport = _Browser_setViewport;
var $author$project$Page$Community$About$init = function (loggedIn) {
	return A2(
		$author$project$UpdateResult$addCmd,
		A2(
			$elm$core$Task$attempt,
			function (_v0) {
				return $author$project$Page$Community$About$NoOp;
			},
			A2($elm$browser$Browser$Dom$setViewport, 0, 0)),
		A2(
			$author$project$UpdateResult$addExt,
			$author$project$Session$LoggedIn$RequestedCommunityField(3),
			A2(
				$author$project$UpdateResult$addExt,
				$author$project$Session$LoggedIn$RequestedCommunityField(1),
				A2(
					$author$project$UpdateResult$addCmd,
					A3(
						$author$project$Session$LoggedIn$maybeInitWith,
						$author$project$Page$Community$About$CompletedLoadCommunity,
						function ($) {
							return $.o7;
						},
						loggedIn),
					$author$project$UpdateResult$init(
						{ff: $krisajenkins$remotedata$RemoteData$Loading})))));
};
var $author$project$Page$Community$Invite$CompletedLoadInvite = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Community$Invite$CompletedLoadProfile = {$: 1};
var $author$project$Page$Community$Invite$Closed = 0;
var $author$project$Page$Community$Invite$Loading = {$: 0};
var $author$project$Page$Community$Invite$initModel = function (invitationId) {
	return {ej: 0, jT: invitationId, eH: $elm$core$Maybe$Nothing, bk: $author$project$Page$Community$Invite$Loading};
};
var $elm$json$Json$Decode$null = _Json_decodeNull;
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $elm$json$Json$Decode$nullable = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder)
			]));
};
var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$Argument = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required = F3(
	function (fieldName, raw, encode) {
		return A2(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$Argument,
			fieldName,
			encode(raw));
	});
var $dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $dillonkearns$elm_graphql$Graphql$RawField$Composite = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$composite = F3(
	function (fieldName, args, fields) {
		return A3($dillonkearns$elm_graphql$Graphql$RawField$Composite, fieldName, args, fields);
	});
var $elm$json$Json$Decode$field = _Json_decodeField;
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $elm$core$String$concat = function (strings) {
	return A2($elm$core$String$join, '', strings);
};
var $dillonkearns$elm_graphql$Graphql$Document$Hash$HashData = F4(
	function (shift, seed, hash, charsProcessed) {
		return {cZ: charsProcessed, dg: hash, cI: seed, dU: shift};
	});
var $dillonkearns$elm_graphql$Graphql$Document$Hash$c1 = 3432918353;
var $dillonkearns$elm_graphql$Graphql$Document$Hash$c2 = 461845907;
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
var $elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
var $dillonkearns$elm_graphql$Graphql$Document$Hash$multiplyBy = F2(
	function (b, a) {
		return ((a & 65535) * b) + ((((a >>> 16) * b) & 65535) << 16);
	});
var $elm$core$Basics$neq = _Utils_notEqual;
var $elm$core$Bitwise$or = _Bitwise_or;
var $dillonkearns$elm_graphql$Graphql$Document$Hash$rotlBy = F2(
	function (b, a) {
		return (a << b) | (a >>> (32 - b));
	});
var $elm$core$Bitwise$xor = _Bitwise_xor;
var $dillonkearns$elm_graphql$Graphql$Document$Hash$finalize = function (data) {
	var acc = (!(!data.dg)) ? (data.cI ^ A2(
		$dillonkearns$elm_graphql$Graphql$Document$Hash$multiplyBy,
		$dillonkearns$elm_graphql$Graphql$Document$Hash$c2,
		A2(
			$dillonkearns$elm_graphql$Graphql$Document$Hash$rotlBy,
			15,
			A2($dillonkearns$elm_graphql$Graphql$Document$Hash$multiplyBy, $dillonkearns$elm_graphql$Graphql$Document$Hash$c1, data.dg)))) : data.cI;
	var h0 = acc ^ data.cZ;
	var h1 = A2($dillonkearns$elm_graphql$Graphql$Document$Hash$multiplyBy, 2246822507, h0 ^ (h0 >>> 16));
	var h2 = A2($dillonkearns$elm_graphql$Graphql$Document$Hash$multiplyBy, 3266489909, h1 ^ (h1 >>> 13));
	return (h2 ^ (h2 >>> 16)) >>> 0;
};
var $elm$core$String$foldl = _String_foldl;
var $dillonkearns$elm_graphql$Graphql$Document$Hash$mix = F2(
	function (h1, k1) {
		return A2(
			$dillonkearns$elm_graphql$Graphql$Document$Hash$multiplyBy,
			5,
			A2(
				$dillonkearns$elm_graphql$Graphql$Document$Hash$rotlBy,
				13,
				h1 ^ A2(
					$dillonkearns$elm_graphql$Graphql$Document$Hash$multiplyBy,
					$dillonkearns$elm_graphql$Graphql$Document$Hash$c2,
					A2(
						$dillonkearns$elm_graphql$Graphql$Document$Hash$rotlBy,
						15,
						A2($dillonkearns$elm_graphql$Graphql$Document$Hash$multiplyBy, $dillonkearns$elm_graphql$Graphql$Document$Hash$c1, k1))))) + 3864292196;
	});
var $dillonkearns$elm_graphql$Graphql$Document$Hash$hashFold = F2(
	function (c, data) {
		var res = data.dg | ((255 & $elm$core$Char$toCode(c)) << data.dU);
		var _v0 = data.dU;
		if (_v0 === 24) {
			return {
				cZ: data.cZ + 1,
				dg: 0,
				cI: A2($dillonkearns$elm_graphql$Graphql$Document$Hash$mix, data.cI, res),
				dU: 0
			};
		} else {
			return {cZ: data.cZ + 1, dg: res, cI: data.cI, dU: data.dU + 8};
		}
	});
var $dillonkearns$elm_graphql$Graphql$Document$Hash$hashString = F2(
	function (seed, str) {
		return $dillonkearns$elm_graphql$Graphql$Document$Hash$finalize(
			A3(
				$elm$core$String$foldl,
				$dillonkearns$elm_graphql$Graphql$Document$Hash$hashFold,
				A4($dillonkearns$elm_graphql$Graphql$Document$Hash$HashData, 0, seed, 0, 0),
				str));
	});
var $elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$Json = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$List = function (a) {
	return {$: 2, a: a};
};
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$Object = function (a) {
	return {$: 3, a: a};
};
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $elm$json$Json$Decode$keyValuePairs = _Json_decodeKeyValuePairs;
var $elm$json$Json$Decode$list = _Json_decodeList;
var $elm$core$Tuple$mapSecond = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			x,
			func(y));
	});
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$serialize = function (value) {
	var serializeJson = function (json) {
		var decoder = $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$map,
					A2(
						$elm$core$Basics$composeL,
						$dillonkearns$elm_graphql$Graphql$Internal$Encode$List,
						$elm$core$List$map($dillonkearns$elm_graphql$Graphql$Internal$Encode$Json)),
					$elm$json$Json$Decode$list($elm$json$Json$Decode$value)),
					A2(
					$elm$json$Json$Decode$map,
					A2(
						$elm$core$Basics$composeL,
						$dillonkearns$elm_graphql$Graphql$Internal$Encode$Object,
						$elm$core$List$map(
							$elm$core$Tuple$mapSecond($dillonkearns$elm_graphql$Graphql$Internal$Encode$Json))),
					$elm$json$Json$Decode$keyValuePairs($elm$json$Json$Decode$value))
				]));
		var _v2 = A2($elm$json$Json$Decode$decodeValue, decoder, json);
		if (!_v2.$) {
			var v = _v2.a;
			return $dillonkearns$elm_graphql$Graphql$Internal$Encode$serialize(v);
		} else {
			return A2($elm$json$Json$Encode$encode, 0, json);
		}
	};
	switch (value.$) {
		case 0:
			var enumValue = value.a;
			return enumValue;
		case 1:
			var json = value.a;
			return serializeJson(json);
		case 2:
			var values = value.a;
			return '[' + (A2(
				$elm$core$String$join,
				', ',
				A2($elm$core$List$map, $dillonkearns$elm_graphql$Graphql$Internal$Encode$serialize, values)) + ']');
		default:
			var keyValuePairs = value.a;
			return '{' + (A2(
				$elm$core$String$join,
				', ',
				A2(
					$elm$core$List$map,
					function (_v1) {
						var key = _v1.a;
						var objectValue = _v1.b;
						return key + (': ' + $dillonkearns$elm_graphql$Graphql$Internal$Encode$serialize(objectValue));
					},
					keyValuePairs)) + '}');
	}
};
var $dillonkearns$elm_graphql$Graphql$Document$Argument$argToString = function (_v0) {
	var name = _v0.a;
	var value = _v0.b;
	return name + (': ' + $dillonkearns$elm_graphql$Graphql$Internal$Encode$serialize(value));
};
var $dillonkearns$elm_graphql$Graphql$Document$Argument$serialize = function (args) {
	if (!args.b) {
		return '';
	} else {
		var nonemptyArgs = args;
		return '(' + (A2(
			$elm$core$String$join,
			', ',
			A2($elm$core$List$map, $dillonkearns$elm_graphql$Graphql$Document$Argument$argToString, nonemptyArgs)) + ')');
	}
};
var $elm$core$List$singleton = function (value) {
	return _List_fromArray(
		[value]);
};
var $dillonkearns$elm_graphql$Graphql$Document$Field$maybeAliasHash = function (field) {
	return A2(
		$elm$core$Maybe$map,
		$dillonkearns$elm_graphql$Graphql$Document$Hash$hashString(0),
		function () {
			if (!field.$) {
				var name = field.a;
				var _arguments = field.b;
				var children = field.c;
				return $elm$core$List$isEmpty(_arguments) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Document$Argument$serialize(_arguments));
			} else {
				var typeString = field.a.pH;
				var fieldName = field.a.jp;
				var _arguments = field.b;
				return (fieldName === '__typename') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					$elm$core$String$concat(
						A2(
							$elm$core$List$append,
							_List_fromArray(
								[typeString]),
							$elm$core$List$singleton(
								$dillonkearns$elm_graphql$Graphql$Document$Argument$serialize(_arguments)))));
			}
		}());
};
var $dillonkearns$elm_graphql$Graphql$RawField$name = function (field) {
	if (!field.$) {
		var fieldName = field.a;
		var argumentList = field.b;
		var fieldList = field.c;
		return fieldName;
	} else {
		var typeString = field.a.pH;
		var fieldName = field.a.jp;
		var argumentList = field.b;
		return fieldName;
	}
};
var $dillonkearns$elm_graphql$Graphql$Document$Field$alias = function (field) {
	return A2(
		$elm$core$Maybe$map,
		function (aliasHash) {
			return _Utils_ap(
				$dillonkearns$elm_graphql$Graphql$RawField$name(field),
				$elm$core$String$fromInt(aliasHash));
		},
		$dillonkearns$elm_graphql$Graphql$Document$Field$maybeAliasHash(field));
};
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $dillonkearns$elm_graphql$Graphql$Document$Field$hashedAliasName = function (field) {
	return A2(
		$elm$core$Maybe$withDefault,
		$dillonkearns$elm_graphql$Graphql$RawField$name(field),
		$dillonkearns$elm_graphql$Graphql$Document$Field$alias(field));
};
var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField = F4(
	function (fieldName, args, _v0, decoderTransform) {
		var fields = _v0.a;
		var decoder = _v0.b;
		return A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet,
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$composite, fieldName, args, fields)
				]),
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$json$Json$Decode$field,
						fieldName,
						decoderTransform(decoder)),
						A2(
						$elm$json$Json$Decode$field,
						$dillonkearns$elm_graphql$Graphql$Document$Field$hashedAliasName(
							A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$composite, fieldName, args, fields)),
						decoderTransform(decoder))
					])));
	});
var $elm$json$Json$Encode$string = _Json_wrap;
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$string = function (value) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$Json(
		$elm$json$Json$Encode$string(value));
};
var $author$project$Cambiatus$Query$invite = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'invite',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'id', requiredArgs____.R, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)
				]),
			object____,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
	});
var $author$project$Community$Invite = F2(
	function (community, creator) {
		return {b9: community, mq: creator};
	});
var $author$project$Cambiatus$Object$Invite$communityPreview = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'communityPreview', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Community$CommunityPreview = function (name) {
	return function (description) {
		return function (logo) {
			return function (symbol) {
				return function (subdomain) {
					return function (hasShop) {
						return function (hasObjectives) {
							return function (hasKyc) {
								return function (hasAutoInvite) {
									return function (uploads) {
										return function (memberCount) {
											return function (website) {
												return {bc: description, cj: hasAutoInvite, ck: hasKyc, cl: hasObjectives, cm: hasShop, hC: logo, gc: memberCount, ki: name, pl: subdomain, e9: symbol, bs: uploads, cQ: website};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $dillonkearns$elm_graphql$Graphql$RawField$Leaf = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$leaf = F2(
	function (details, args) {
		return A2($dillonkearns$elm_graphql$Graphql$RawField$Leaf, details, args);
	});
var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField = F4(
	function (typeString, fieldName, args, decoder) {
		var newLeaf = A2(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$leaf,
			{jp: fieldName, pH: typeString},
			args);
		return A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet,
			_List_fromArray(
				[newLeaf]),
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						A2($elm$json$Json$Decode$field, fieldName, decoder),
						A2(
						$elm$json$Json$Decode$field,
						$dillonkearns$elm_graphql$Graphql$Document$Field$hashedAliasName(newLeaf),
						decoder)
					])));
	});
var $author$project$Cambiatus$Object$CommunityPreview$autoInvite = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'autoInvite', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Constants$defaultCommunityLogo = 'https://cambiatus-uploads.s3.amazonaws.com/cambiatus-uploads/community_2.png';
var $elm$json$Json$Decode$string = _Json_decodeString;
var $author$project$Cambiatus$Object$CommunityPreview$description = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'description', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$CommunityPreview$hasKyc = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'hasKyc', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Cambiatus$Object$CommunityPreview$hasObjectives = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'hasObjectives', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Cambiatus$Object$CommunityPreview$hasShop = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'hasShop', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Cambiatus$Object$CommunityPreview$logo = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'logo',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $dillonkearns$elm_graphql$Graphql$SelectionSet$map = F2(
	function (mapFunction, _v0) {
		var selectionFields = _v0.a;
		var selectionDecoder = _v0.b;
		return A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet,
			selectionFields,
			A2($elm$json$Json$Decode$map, mapFunction, selectionDecoder));
	});
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $author$project$Cambiatus$Object$CommunityPreview$memberCount = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'memberCount', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$Cambiatus$Object$CommunityPreview$name = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'name', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$Subdomain$name = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'name', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Markdown$Markdown = $elm$core$Basics$identity;
var $author$project$Markdown$selectionSet = $dillonkearns$elm_graphql$Graphql$SelectionSet$map($elm$core$Basics$identity);
var $author$project$Cambiatus$Object$CommunityPreview$subdomain = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'subdomain',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed = function (constructor) {
	return A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet,
		_List_Nil,
		$elm$json$Json$Decode$succeed(constructor));
};
var $author$project$Cambiatus$Object$CommunityPreview$symbol = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'symbol', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Eos$Symbol = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$core$Maybe$andThen = F2(
	function (callback, maybeValue) {
		if (!maybeValue.$) {
			var value = maybeValue.a;
			return callback(value);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $elm$json$Json$Decode$fail = _Json_fail;
var $dillonkearns$elm_graphql$Graphql$SelectionSet$mapOrFail = F2(
	function (mapFunction, _v0) {
		var field = _v0.a;
		var decoder = _v0.b;
		return A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet,
			field,
			A2(
				$elm$json$Json$Decode$andThen,
				function (result) {
					if (!result.$) {
						var value = result.a;
						return $elm$json$Json$Decode$succeed(value);
					} else {
						var errorMessage = result.a;
						return $elm$json$Json$Decode$fail('Check your code for calls to mapOrFail, your map function returned an `Err` with the message: ' + errorMessage);
					}
				},
				A2($elm$json$Json$Decode$map, mapFunction, decoder)));
	});
var $dillonkearns$elm_graphql$Graphql$SelectionSet$with = F2(
	function (_v0, _v1) {
		var selectionFields1 = _v0.a;
		var selectionDecoder1 = _v0.b;
		var selectionFields2 = _v1.a;
		var selectionDecoder2 = _v1.b;
		return A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet,
			_Utils_ap(selectionFields1, selectionFields2),
			A3($elm$json$Json$Decode$map2, $elm$core$Basics$apR, selectionDecoder1, selectionDecoder2));
	});
var $author$project$Eos$symbolSelectionSet = function (field) {
	return A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$mapOrFail,
			function (s) {
				var _v1 = A2(
					$elm$core$Maybe$andThen,
					$elm$core$String$toInt,
					$elm$core$List$head(
						A2($elm$core$String$split, ',', s)));
				if (!_v1.$) {
					var e = _v1.a;
					return $elm$core$Result$Ok(e);
				} else {
					return $elm$core$Result$Err('Can\'t parse symbol');
				}
			},
			field),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$mapOrFail,
				function (s) {
					var _v0 = $elm$core$List$head(
						$elm$core$List$reverse(
							A2($elm$core$String$split, ',', s)));
					if (!_v0.$) {
						var e = _v0.a;
						return $elm$core$Result$Ok(e);
					} else {
						return $elm$core$Result$Err('Can\'t parse symbol');
					}
				},
				field),
			$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Eos$Symbol)));
};
var $author$project$Cambiatus$Object$CommunityPreview$uploads = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'uploads',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Cambiatus$Object$Upload$url = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'url', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$CommunityPreview$website = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'website',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault = function (_default) {
	return $dillonkearns$elm_graphql$Graphql$SelectionSet$map(
		$elm$core$Maybe$withDefault(_default));
};
var $author$project$Community$communityPreviewSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$CommunityPreview$website,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Cambiatus$Object$CommunityPreview$memberCount,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Cambiatus$Object$CommunityPreview$uploads($author$project$Cambiatus$Object$Upload$url),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Cambiatus$Object$CommunityPreview$autoInvite,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$Cambiatus$Object$CommunityPreview$hasKyc,
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$Cambiatus$Object$CommunityPreview$hasObjectives,
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							$author$project$Cambiatus$Object$CommunityPreview$hasShop,
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
								A2(
									$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
									$elm$core$Maybe$withDefault(''),
									$author$project$Cambiatus$Object$CommunityPreview$subdomain($author$project$Cambiatus$Object$Subdomain$name)),
								A2(
									$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
									$author$project$Eos$symbolSelectionSet($author$project$Cambiatus$Object$CommunityPreview$symbol),
									A2(
										$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
										A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, $author$project$Constants$defaultCommunityLogo, $author$project$Cambiatus$Object$CommunityPreview$logo),
										A2(
											$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
											$author$project$Markdown$selectionSet($author$project$Cambiatus$Object$CommunityPreview$description),
											A2(
												$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
												$author$project$Cambiatus$Object$CommunityPreview$name,
												$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Community$CommunityPreview)))))))))))));
var $author$project$Cambiatus$Object$Invite$creator = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'creator', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Profile$Minimal = F6(
	function (name, account, avatar, email, bio, contacts) {
		return {fl: account, cV: avatar, cW: bio, aq: contacts, jh: email, ki: name};
	});
var $author$project$Cambiatus$Object$User$account = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'account', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$User$avatar = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'avatar',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Cambiatus$Object$User$bio = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'bio',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Cambiatus$Object$User$email = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'email',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Markdown$maybeSelectionSet = $dillonkearns$elm_graphql$Graphql$SelectionSet$map(
	$elm$core$Maybe$map($elm$core$Basics$identity));
var $author$project$Cambiatus$Object$User$name = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'name',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Eos$Account$Name = $elm$core$Basics$identity;
var $author$project$Eos$Account$nameSelectionSet = $dillonkearns$elm_graphql$Graphql$SelectionSet$map($elm$core$Basics$identity);
var $author$project$Avatar$Avatar = $elm$core$Basics$identity;
var $author$project$Avatar$selectionSet = $dillonkearns$elm_graphql$Graphql$SelectionSet$map($elm$core$Basics$identity);
var $author$project$Cambiatus$Object$User$contacts = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'contacts',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (!_v0.$) {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $author$project$Profile$Contact$Normalized = $elm$core$Basics$identity;
var $author$project$Cambiatus$Object$Contact$externalId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'externalId',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Cambiatus$Object$Contact$label = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'label',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Cambiatus$Enum$ContactType$Email = 0;
var $author$project$Cambiatus$Enum$ContactType$Instagram = 1;
var $author$project$Cambiatus$Enum$ContactType$Link = 2;
var $author$project$Cambiatus$Enum$ContactType$Phone = 3;
var $author$project$Cambiatus$Enum$ContactType$Telegram = 4;
var $author$project$Cambiatus$Enum$ContactType$Whatsapp = 5;
var $author$project$Cambiatus$Enum$ContactType$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'EMAIL':
				return $elm$json$Json$Decode$succeed(0);
			case 'INSTAGRAM':
				return $elm$json$Json$Decode$succeed(1);
			case 'LINK':
				return $elm$json$Json$Decode$succeed(2);
			case 'PHONE':
				return $elm$json$Json$Decode$succeed(3);
			case 'TELEGRAM':
				return $elm$json$Json$Decode$succeed(4);
			case 'WHATSAPP':
				return $elm$json$Json$Decode$succeed(5);
			default:
				return $elm$json$Json$Decode$fail('Invalid ContactType type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$Contact$type_ = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe Enum.ContactType.ContactType)',
	'type',
	_List_Nil,
	$elm$json$Json$Decode$nullable($author$project$Cambiatus$Enum$ContactType$decoder));
var $author$project$Profile$Contact$selectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$Contact$label,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Cambiatus$Object$Contact$externalId,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Cambiatus$Object$Contact$type_,
			$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(
				F3(
					function (maybeType, maybeExternalId, label) {
						var _v0 = _Utils_Tuple2(maybeType, maybeExternalId);
						if ((!_v0.a.$) && (!_v0.b.$)) {
							var type_ = _v0.a.a;
							var externalId = _v0.b.a;
							return $elm$core$Maybe$Just(
								{me: externalId, mf: type_, nC: label});
						} else {
							return $elm$core$Maybe$Nothing;
						}
					})))));
var $author$project$Profile$userContactSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
	$elm$core$List$filterMap($elm$core$Basics$identity),
	$author$project$Cambiatus$Object$User$contacts($author$project$Profile$Contact$selectionSet));
var $author$project$Profile$minimalSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Profile$userContactSelectionSet,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Markdown$maybeSelectionSet($author$project$Cambiatus$Object$User$bio),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Cambiatus$Object$User$email,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Avatar$selectionSet($author$project$Cambiatus$Object$User$avatar),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$Eos$Account$nameSelectionSet($author$project$Cambiatus$Object$User$account),
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$Cambiatus$Object$User$name,
						$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Profile$Minimal)))))));
var $author$project$Community$inviteSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$Invite$creator($author$project$Profile$minimalSelectionSet),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Cambiatus$Object$Invite$communityPreview($author$project$Community$communityPreviewSelectionSet),
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Community$Invite)));
var $author$project$Community$inviteQuery = function (invitationId) {
	return A2(
		$author$project$Cambiatus$Query$invite,
		{R: invitationId},
		$author$project$Community$inviteSelectionSet);
};
var $krisajenkins$remotedata$RemoteData$Failure = function (a) {
	return {$: 2, a: a};
};
var $krisajenkins$remotedata$RemoteData$Success = function (a) {
	return {$: 3, a: a};
};
var $krisajenkins$remotedata$RemoteData$fromResult = function (result) {
	if (result.$ === 1) {
		var e = result.a;
		return $krisajenkins$remotedata$RemoteData$Failure(e);
	} else {
		var x = result.a;
		return $krisajenkins$remotedata$RemoteData$Success(x);
	}
};
var $dillonkearns$elm_graphql$Graphql$Http$Query = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $dillonkearns$elm_graphql$Graphql$Http$Request = $elm$core$Basics$identity;
var $dillonkearns$elm_graphql$Graphql$Document$decoder = function (_v0) {
	var fields = _v0.a;
	var decoder_ = _v0.b;
	return A2($elm$json$Json$Decode$field, 'data', decoder_);
};
var $dillonkearns$elm_graphql$Graphql$Http$queryRequest = F2(
	function (baseUrl, query) {
		return {
			ec: baseUrl,
			mz: A2($dillonkearns$elm_graphql$Graphql$Http$Query, $elm$core$Maybe$Nothing, query),
			fN: $dillonkearns$elm_graphql$Graphql$Document$decoder(query),
			m4: _List_Nil,
			cz: $elm$core$Maybe$Nothing,
			cG: _List_Nil,
			am: $elm$core$Maybe$Nothing,
			cS: false
		};
	});
var $elm$http$Http$Request = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$State = F2(
	function (reqs, subs) {
		return {kW: reqs, lh: subs};
	});
var $elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $elm$http$Http$init = $elm$core$Task$succeed(
	A2($elm$http$Http$State, $elm$core$Dict$empty, _List_Nil));
var $elm$http$Http$BadStatus_ = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$http$Http$BadUrl_ = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$GoodStatus_ = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$http$Http$NetworkError_ = {$: 2};
var $elm$http$Http$Receiving = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$Sending = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$Timeout_ = {$: 1};
var $elm$core$Maybe$isJust = function (maybe) {
	if (!maybe.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $elm$core$Dict$Black = 1;
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$Red = 0;
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1) {
				case 0:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === -1) && (dict.d.$ === -1)) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === -1) && (!left.a)) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === -1) && (right.a === 1)) {
					if (right.d.$ === -1) {
						if (right.d.a === 1) {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === -1) && (dict.d.$ === -1)) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor === 1) {
			if ((lLeft.$ === -1) && (!lLeft.a)) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === -1) {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === -1) && (left.a === 1)) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === -1) && (!lLeft.a)) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === -1) {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === -1) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === -1) {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _v0 = alter(
			A2($elm$core$Dict$get, targetKey, dictionary));
		if (!_v0.$) {
			var value = _v0.a;
			return A3($elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2($elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var $elm$core$Process$kill = _Scheduler_kill;
var $elm$core$Process$spawn = _Scheduler_spawn;
var $elm$http$Http$updateReqs = F3(
	function (router, cmds, reqs) {
		updateReqs:
		while (true) {
			if (!cmds.b) {
				return $elm$core$Task$succeed(reqs);
			} else {
				var cmd = cmds.a;
				var otherCmds = cmds.b;
				if (!cmd.$) {
					var tracker = cmd.a;
					var _v2 = A2($elm$core$Dict$get, tracker, reqs);
					if (_v2.$ === 1) {
						var $temp$router = router,
							$temp$cmds = otherCmds,
							$temp$reqs = reqs;
						router = $temp$router;
						cmds = $temp$cmds;
						reqs = $temp$reqs;
						continue updateReqs;
					} else {
						var pid = _v2.a;
						return A2(
							$elm$core$Task$andThen,
							function (_v3) {
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A2($elm$core$Dict$remove, tracker, reqs));
							},
							$elm$core$Process$kill(pid));
					}
				} else {
					var req = cmd.a;
					return A2(
						$elm$core$Task$andThen,
						function (pid) {
							var _v4 = req.lr;
							if (_v4.$ === 1) {
								return A3($elm$http$Http$updateReqs, router, otherCmds, reqs);
							} else {
								var tracker = _v4.a;
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A3($elm$core$Dict$insert, tracker, pid, reqs));
							}
						},
						$elm$core$Process$spawn(
							A3(
								_Http_toTask,
								router,
								$elm$core$Platform$sendToApp(router),
								req)));
				}
			}
		}
	});
var $elm$http$Http$onEffects = F4(
	function (router, cmds, subs, state) {
		return A2(
			$elm$core$Task$andThen,
			function (reqs) {
				return $elm$core$Task$succeed(
					A2($elm$http$Http$State, reqs, subs));
			},
			A3($elm$http$Http$updateReqs, router, cmds, state.kW));
	});
var $elm$http$Http$maybeSend = F4(
	function (router, desiredTracker, progress, _v0) {
		var actualTracker = _v0.a;
		var toMsg = _v0.b;
		return _Utils_eq(desiredTracker, actualTracker) ? $elm$core$Maybe$Just(
			A2(
				$elm$core$Platform$sendToApp,
				router,
				toMsg(progress))) : $elm$core$Maybe$Nothing;
	});
var $elm$http$Http$onSelfMsg = F3(
	function (router, _v0, state) {
		var tracker = _v0.a;
		var progress = _v0.b;
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$filterMap,
					A3($elm$http$Http$maybeSend, router, tracker, progress),
					state.lh)));
	});
var $elm$http$Http$Cancel = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$cmdMap = F2(
	function (func, cmd) {
		if (!cmd.$) {
			var tracker = cmd.a;
			return $elm$http$Http$Cancel(tracker);
		} else {
			var r = cmd.a;
			return $elm$http$Http$Request(
				{
					lT: r.lT,
					fv: r.fv,
					fN: A2(_Http_mapExpect, func, r.fN),
					m4: r.m4,
					bL: r.bL,
					am: r.am,
					lr: r.lr,
					gL: r.gL
				});
		}
	});
var $elm$http$Http$MySub = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$subMap = F2(
	function (func, _v0) {
		var tracker = _v0.a;
		var toMsg = _v0.b;
		return A2(
			$elm$http$Http$MySub,
			tracker,
			A2($elm$core$Basics$composeR, toMsg, func));
	});
_Platform_effectManagers['Http'] = _Platform_createManager($elm$http$Http$init, $elm$http$Http$onEffects, $elm$http$Http$onSelfMsg, $elm$http$Http$cmdMap, $elm$http$Http$subMap);
var $elm$http$Http$command = _Platform_leaf('Http');
var $elm$http$Http$subscription = _Platform_leaf('Http');
var $elm$http$Http$request = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{lT: false, fv: r.fv, fN: r.fN, m4: r.m4, bL: r.bL, am: r.am, lr: r.lr, gL: r.gL}));
};
var $elm$http$Http$riskyRequest = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{lT: true, fv: r.fv, fN: r.fN, m4: r.m4, bL: r.bL, am: r.am, lr: r.lr, gL: r.gL}));
};
var $dillonkearns$elm_graphql$Graphql$Http$GraphqlError = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $dillonkearns$elm_graphql$Graphql$Http$HttpError = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_graphql$Graphql$Http$convertResult = function (httpResult) {
	if (!httpResult.$) {
		var successOrError = httpResult.a;
		if (!successOrError.$) {
			var value = successOrError.a;
			return $elm$core$Result$Ok(value);
		} else {
			var _v2 = successOrError.a;
			var possiblyParsedData = _v2.a;
			var error = _v2.b;
			return $elm$core$Result$Err(
				A2($dillonkearns$elm_graphql$Graphql$Http$GraphqlError, possiblyParsedData, error));
		}
	} else {
		var httpError = httpResult.a;
		return $elm$core$Result$Err(
			$dillonkearns$elm_graphql$Graphql$Http$HttpError(httpError));
	}
};
var $dillonkearns$elm_graphql$Graphql$Http$BadPayload = function (a) {
	return {$: 4, a: a};
};
var $dillonkearns$elm_graphql$Graphql$Http$BadStatus = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $dillonkearns$elm_graphql$Graphql$Http$BadUrl = function (a) {
	return {$: 0, a: a};
};
var $dillonkearns$elm_graphql$Graphql$Http$NetworkError = {$: 2};
var $dillonkearns$elm_graphql$Graphql$Http$Timeout = {$: 1};
var $elm$json$Json$Decode$decodeString = _Json_runOnString;
var $elm$http$Http$expectStringResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'',
			$elm$core$Basics$identity,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $dillonkearns$elm_graphql$Graphql$Http$expectJson = F2(
	function (toMsg, decoder) {
		return A2(
			$elm$http$Http$expectStringResponse,
			toMsg,
			function (response) {
				switch (response.$) {
					case 0:
						var url = response.a;
						return $elm$core$Result$Err(
							$dillonkearns$elm_graphql$Graphql$Http$BadUrl(url));
					case 1:
						return $elm$core$Result$Err($dillonkearns$elm_graphql$Graphql$Http$Timeout);
					case 2:
						return $elm$core$Result$Err($dillonkearns$elm_graphql$Graphql$Http$NetworkError);
					case 3:
						var metadata = response.a;
						var body = response.b;
						return $elm$core$Result$Err(
							A2($dillonkearns$elm_graphql$Graphql$Http$BadStatus, metadata, body));
					default:
						var metadata = response.a;
						var body = response.b;
						var _v1 = A2($elm$json$Json$Decode$decodeString, decoder, body);
						if (!_v1.$) {
							var value = _v1.a;
							return $elm$core$Result$Ok(value);
						} else {
							var err = _v1.a;
							return $elm$core$Result$Err(
								$dillonkearns$elm_graphql$Graphql$Http$BadPayload(err));
						}
				}
			});
	});
var $dillonkearns$elm_graphql$Graphql$Http$QueryHelper$Get = 0;
var $dillonkearns$elm_graphql$Graphql$Http$QueryHelper$Post = 1;
var $elm$http$Http$emptyBody = _Http_emptyBody;
var $elm$core$Basics$ge = _Utils_ge;
var $elm$http$Http$jsonBody = function (value) {
	return A2(
		_Http_pair,
		'application/json',
		A2($elm$json$Json$Encode$encode, 0, value));
};
var $dillonkearns$elm_graphql$Graphql$Http$QueryHelper$maxLength = 2000;
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(0),
			pairs));
};
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $elm$core$String$dropRight = F2(
	function (n, string) {
		return (n < 1) ? string : A3($elm$core$String$slice, 0, -n, string);
	});
var $elm$core$Array$bitMask = 4294967295 >>> (32 - $elm$core$Array$shiftStep);
var $elm$core$Elm$JsArray$unsafeGet = _JsArray_unsafeGet;
var $elm$core$Array$getHelp = F3(
	function (shift, index, tree) {
		getHelp:
		while (true) {
			var pos = $elm$core$Array$bitMask & (index >>> shift);
			var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (!_v0.$) {
				var subTree = _v0.a;
				var $temp$shift = shift - $elm$core$Array$shiftStep,
					$temp$index = index,
					$temp$tree = subTree;
				shift = $temp$shift;
				index = $temp$index;
				tree = $temp$tree;
				continue getHelp;
			} else {
				var values = _v0.a;
				return A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, values);
			}
		}
	});
var $elm$core$Array$tailIndex = function (len) {
	return (len >>> 5) << 5;
};
var $elm$core$Array$get = F2(
	function (index, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? $elm$core$Maybe$Nothing : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? $elm$core$Maybe$Just(
			A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, tail)) : $elm$core$Maybe$Just(
			A3($elm$core$Array$getHelp, startShift, index, tree)));
	});
var $lukewestby$elm_string_interpolate$String$Interpolate$applyInterpolation = F2(
	function (replacements, _v0) {
		var match = _v0.eK;
		var ordinalString = A2(
			$elm$core$Basics$composeL,
			$elm$core$String$dropLeft(1),
			$elm$core$String$dropRight(1))(match);
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$andThen,
				function (value) {
					return A2($elm$core$Array$get, value, replacements);
				},
				$elm$core$String$toInt(ordinalString)));
	});
var $elm$core$Array$fromListHelp = F3(
	function (list, nodeList, nodeListSize) {
		fromListHelp:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, list);
			var jsArray = _v0.a;
			var remainingItems = _v0.b;
			if (_Utils_cmp(
				$elm$core$Elm$JsArray$length(jsArray),
				$elm$core$Array$branchFactor) < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					true,
					{N: nodeList, D: nodeListSize, H: jsArray});
			} else {
				var $temp$list = remainingItems,
					$temp$nodeList = A2(
					$elm$core$List$cons,
					$elm$core$Array$Leaf(jsArray),
					nodeList),
					$temp$nodeListSize = nodeListSize + 1;
				list = $temp$list;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue fromListHelp;
			}
		}
	});
var $elm$core$Array$fromList = function (list) {
	if (!list.b) {
		return $elm$core$Array$empty;
	} else {
		return A3($elm$core$Array$fromListHelp, list, _List_Nil, 0);
	}
};
var $elm$regex$Regex$Match = F4(
	function (match, index, number, submatches) {
		return {eB: index, eK: match, ay: number, ij: submatches};
	});
var $elm$regex$Regex$fromStringWith = _Regex_fromStringWith;
var $elm$regex$Regex$fromString = function (string) {
	return A2(
		$elm$regex$Regex$fromStringWith,
		{l0: false, nX: false},
		string);
};
var $elm$regex$Regex$never = _Regex_never;
var $lukewestby$elm_string_interpolate$String$Interpolate$interpolationRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('\\{\\d+\\}'));
var $elm$regex$Regex$replace = _Regex_replaceAtMost(_Regex_infinity);
var $lukewestby$elm_string_interpolate$String$Interpolate$interpolate = F2(
	function (string, args) {
		var asArray = $elm$core$Array$fromList(args);
		return A3(
			$elm$regex$Regex$replace,
			$lukewestby$elm_string_interpolate$String$Interpolate$interpolationRegex,
			$lukewestby$elm_string_interpolate$String$Interpolate$applyInterpolation(asArray),
			string);
	});
var $j_maas$elm_ordered_containers$OrderedDict$OrderedDict = $elm$core$Basics$identity;
var $j_maas$elm_ordered_containers$OrderedDict$empty = {w: $elm$core$Dict$empty, ou: _List_Nil};
var $j_maas$elm_ordered_containers$OrderedDict$get = F2(
	function (key, _v0) {
		var orderedDict = _v0;
		return A2($elm$core$Dict$get, key, orderedDict.w);
	});
var $elm$core$Basics$always = F2(
	function (a, _v0) {
		return a;
	});
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $elm$core$Dict$member = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$get, key, dict);
		if (!_v0.$) {
			return true;
		} else {
			return false;
		}
	});
var $j_maas$elm_ordered_containers$OrderedDict$insert = F3(
	function (key, value, _v0) {
		var orderedDict = _v0;
		var filteredOrder = A2($elm$core$Dict$member, key, orderedDict.w) ? A2(
			$elm$core$List$filter,
			function (k) {
				return !_Utils_eq(k, key);
			},
			orderedDict.ou) : orderedDict.ou;
		var newOrder = _Utils_ap(
			filteredOrder,
			_List_fromArray(
				[key]));
		return {
			w: A3($elm$core$Dict$insert, key, value, orderedDict.w),
			ou: newOrder
		};
	});
var $j_maas$elm_ordered_containers$OrderedDict$remove = F2(
	function (key, _v0) {
		var orderedDict = _v0;
		return {
			w: A2($elm$core$Dict$remove, key, orderedDict.w),
			ou: A2($elm$core$Dict$member, key, orderedDict.w) ? A2(
				$elm$core$List$filter,
				function (k) {
					return !_Utils_eq(k, key);
				},
				orderedDict.ou) : orderedDict.ou
		};
	});
var $j_maas$elm_ordered_containers$OrderedDict$update = F3(
	function (key, alter, original) {
		var orderedDict = original;
		var _v0 = A2($elm$core$Dict$get, key, orderedDict.w);
		if (!_v0.$) {
			var oldItem = _v0.a;
			var _v1 = alter(
				$elm$core$Maybe$Just(oldItem));
			if (!_v1.$) {
				var newItem = _v1.a;
				return {
					w: A3(
						$elm$core$Dict$update,
						key,
						$elm$core$Basics$always(
							$elm$core$Maybe$Just(newItem)),
						orderedDict.w),
					ou: orderedDict.ou
				};
			} else {
				return A2($j_maas$elm_ordered_containers$OrderedDict$remove, key, original);
			}
		} else {
			var _v2 = alter($elm$core$Maybe$Nothing);
			if (!_v2.$) {
				var newItem = _v2.a;
				return A3($j_maas$elm_ordered_containers$OrderedDict$insert, key, newItem, original);
			} else {
				return original;
			}
		}
	});
var $dillonkearns$elm_graphql$Graphql$Document$Field$canAllowHashing = function (rawFields) {
	var fieldCounts = A3(
		$elm$core$List$foldl,
		F2(
			function (fld, acc) {
				return A3(
					$j_maas$elm_ordered_containers$OrderedDict$update,
					fld,
					function (val) {
						return $elm$core$Maybe$Just(
							function () {
								if (val.$ === 1) {
									return 0;
								} else {
									var count = val.a;
									return count + 1;
								}
							}());
					},
					acc);
			}),
		$j_maas$elm_ordered_containers$OrderedDict$empty,
		A2($elm$core$List$map, $dillonkearns$elm_graphql$Graphql$RawField$name, rawFields));
	return A2(
		$elm$core$List$map,
		function (field) {
			return _Utils_Tuple2(
				field,
				(!A2(
					$elm$core$Maybe$withDefault,
					0,
					A2(
						$j_maas$elm_ordered_containers$OrderedDict$get,
						$dillonkearns$elm_graphql$Graphql$RawField$name(field),
						fieldCounts))) ? $elm$core$Maybe$Nothing : $dillonkearns$elm_graphql$Graphql$Document$Field$alias(field));
		},
		rawFields);
};
var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
var $elm$core$String$repeatHelp = F3(
	function (n, chunk, result) {
		return (n <= 0) ? result : A3(
			$elm$core$String$repeatHelp,
			n >> 1,
			_Utils_ap(chunk, chunk),
			(!(n & 1)) ? result : _Utils_ap(result, chunk));
	});
var $elm$core$String$repeat = F2(
	function (n, chunk) {
		return A3($elm$core$String$repeatHelp, n, chunk, '');
	});
var $dillonkearns$elm_graphql$Graphql$Document$Indent$generate = function (indentationLevel) {
	return A2($elm$core$String$repeat, indentationLevel, '  ');
};
var $dillonkearns$elm_graphql$Graphql$Document$Field$mergeFields = function (rawFields) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (field, mergedSoFar) {
				if (!field.$) {
					var newChildren = field.c;
					return A3(
						$j_maas$elm_ordered_containers$OrderedDict$update,
						$dillonkearns$elm_graphql$Graphql$Document$Field$hashedAliasName(field),
						function (maybeChildrenSoFar) {
							if (maybeChildrenSoFar.$ === 1) {
								return $elm$core$Maybe$Just(field);
							} else {
								if (!maybeChildrenSoFar.a.$) {
									var _v2 = maybeChildrenSoFar.a;
									var existingFieldName = _v2.a;
									var existingArgs = _v2.b;
									var existingChildren = _v2.c;
									return $elm$core$Maybe$Just(
										A3(
											$dillonkearns$elm_graphql$Graphql$RawField$Composite,
											existingFieldName,
											existingArgs,
											_Utils_ap(existingChildren, newChildren)));
								} else {
									return $elm$core$Maybe$Just(field);
								}
							}
						},
						mergedSoFar);
				} else {
					return A3(
						$j_maas$elm_ordered_containers$OrderedDict$update,
						$dillonkearns$elm_graphql$Graphql$Document$Field$hashedAliasName(field),
						function (maybeChildrenSoFar) {
							return $elm$core$Maybe$Just(
								A2($elm$core$Maybe$withDefault, field, maybeChildrenSoFar));
						},
						mergedSoFar);
				}
			}),
		$j_maas$elm_ordered_containers$OrderedDict$empty,
		rawFields);
};
var $j_maas$elm_ordered_containers$OrderedDict$values = function (_v0) {
	var orderedDict = _v0;
	return A2(
		$elm$core$List$filterMap,
		function (key) {
			return A2($elm$core$Dict$get, key, orderedDict.w);
		},
		orderedDict.ou);
};
var $dillonkearns$elm_graphql$Graphql$Document$Field$mergedFields = function (children) {
	return $j_maas$elm_ordered_containers$OrderedDict$values(
		$dillonkearns$elm_graphql$Graphql$Document$Field$mergeFields(children));
};
var $dillonkearns$elm_graphql$Graphql$RawField$typename = A2(
	$dillonkearns$elm_graphql$Graphql$RawField$Leaf,
	{jp: '__typename', pH: ''},
	_List_Nil);
var $dillonkearns$elm_graphql$Graphql$Document$Field$nonemptyChildren = function (children) {
	return $elm$core$List$isEmpty(children) ? A2($elm$core$List$cons, $dillonkearns$elm_graphql$Graphql$RawField$typename, children) : children;
};
var $dillonkearns$elm_graphql$Graphql$Document$Field$serialize = F3(
	function (aliasName, mIndentationLevel, field) {
		var prefix = function () {
			if (!aliasName.$) {
				var aliasName_ = aliasName.a;
				return _Utils_ap(
					aliasName_,
					function () {
						if (!mIndentationLevel.$) {
							return ': ';
						} else {
							return ':';
						}
					}());
			} else {
				return '';
			}
		}();
		return A2(
			$elm$core$Maybe$map,
			function (string) {
				return _Utils_ap(
					$dillonkearns$elm_graphql$Graphql$Document$Indent$generate(
						A2($elm$core$Maybe$withDefault, 0, mIndentationLevel)),
					_Utils_ap(prefix, string));
			},
			function () {
				if (!field.$) {
					var fieldName = field.a;
					var args = field.b;
					var children = field.c;
					if (mIndentationLevel.$ === 1) {
						return $elm$core$Maybe$Just(
							(fieldName + ($dillonkearns$elm_graphql$Graphql$Document$Argument$serialize(args) + ('{' + A2($dillonkearns$elm_graphql$Graphql$Document$Field$serializeChildren, $elm$core$Maybe$Nothing, children)))) + '}');
					} else {
						var indentationLevel = mIndentationLevel.a;
						return $elm$core$Maybe$Just(
							(fieldName + ($dillonkearns$elm_graphql$Graphql$Document$Argument$serialize(args) + (' {\n' + A2(
								$dillonkearns$elm_graphql$Graphql$Document$Field$serializeChildren,
								$elm$core$Maybe$Just(indentationLevel),
								children)))) + ('\n' + ($dillonkearns$elm_graphql$Graphql$Document$Indent$generate(indentationLevel) + '}')));
					}
				} else {
					var fieldName = field.a.jp;
					var args = field.b;
					return $elm$core$Maybe$Just(
						_Utils_ap(
							fieldName,
							$dillonkearns$elm_graphql$Graphql$Document$Argument$serialize(args)));
				}
			}());
	});
var $dillonkearns$elm_graphql$Graphql$Document$Field$serializeChildren = F2(
	function (indentationLevel, children) {
		return A2(
			$elm$core$String$join,
			function () {
				if (!indentationLevel.$) {
					return '\n';
				} else {
					return ' ';
				}
			}(),
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				A2(
					$elm$core$List$map,
					function (_v0) {
						var field = _v0.a;
						var maybeAlias = _v0.b;
						return A3(
							$dillonkearns$elm_graphql$Graphql$Document$Field$serialize,
							maybeAlias,
							A2(
								$elm$core$Maybe$map,
								$elm$core$Basics$add(1),
								indentationLevel),
							field);
					},
					$dillonkearns$elm_graphql$Graphql$Document$Field$canAllowHashing(
						$dillonkearns$elm_graphql$Graphql$Document$Field$nonemptyChildren(
							$dillonkearns$elm_graphql$Graphql$Document$Field$mergedFields(children))))));
	});
var $dillonkearns$elm_graphql$Graphql$Document$serialize = F2(
	function (operationType, queries) {
		return A2(
			$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
			'{0} {\n{1}\n}',
			_List_fromArray(
				[
					operationType,
					A2(
					$dillonkearns$elm_graphql$Graphql$Document$Field$serializeChildren,
					$elm$core$Maybe$Just(0),
					queries)
				]));
	});
var $dillonkearns$elm_graphql$Graphql$Document$serializeQuery = function (_v0) {
	var fields = _v0.a;
	var decoder_ = _v0.b;
	return A2($dillonkearns$elm_graphql$Graphql$Document$serialize, 'query', fields);
};
var $dillonkearns$elm_graphql$Graphql$Document$serializeQueryForUrl = function (_v0) {
	var fields = _v0.a;
	var decoder_ = _v0.b;
	return '{' + (A2($dillonkearns$elm_graphql$Graphql$Document$Field$serializeChildren, $elm$core$Maybe$Nothing, fields) + '}');
};
var $dillonkearns$elm_graphql$Graphql$Document$serializeQueryForUrlWithOperationName = F2(
	function (operationName, _v0) {
		var fields = _v0.a;
		var decoder_ = _v0.b;
		return 'query ' + (operationName + (' {' + (A2($dillonkearns$elm_graphql$Graphql$Document$Field$serializeChildren, $elm$core$Maybe$Nothing, fields) + '}')));
	});
var $dillonkearns$elm_graphql$Graphql$Document$serializeWithOperationName = F3(
	function (operationType, operationName, queries) {
		return A2(
			$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
			'{0} {1} {\n{2}\n}',
			_List_fromArray(
				[
					operationType,
					operationName,
					A2(
					$dillonkearns$elm_graphql$Graphql$Document$Field$serializeChildren,
					$elm$core$Maybe$Just(0),
					queries)
				]));
	});
var $dillonkearns$elm_graphql$Graphql$Document$serializeQueryWithOperationName = F2(
	function (operationName, _v0) {
		var fields = _v0.a;
		var decoder_ = _v0.b;
		return A3($dillonkearns$elm_graphql$Graphql$Document$serializeWithOperationName, 'query', operationName, fields);
	});
var $elm$url$Url$percentEncode = _Url_percentEncode;
var $dillonkearns$elm_graphql$Graphql$Http$QueryParams$replace = F2(
	function (old, _new) {
		return A2(
			$elm$core$Basics$composeR,
			$elm$core$String$split(old),
			$elm$core$String$join(_new));
	});
var $dillonkearns$elm_graphql$Graphql$Http$QueryParams$queryEscape = A2(
	$elm$core$Basics$composeR,
	$elm$url$Url$percentEncode,
	A2($dillonkearns$elm_graphql$Graphql$Http$QueryParams$replace, '%20', '+'));
var $dillonkearns$elm_graphql$Graphql$Http$QueryParams$queryPair = function (_v0) {
	var key = _v0.a;
	var value = _v0.b;
	return $dillonkearns$elm_graphql$Graphql$Http$QueryParams$queryEscape(key) + ('=' + $dillonkearns$elm_graphql$Graphql$Http$QueryParams$queryEscape(value));
};
var $dillonkearns$elm_graphql$Graphql$Http$QueryParams$joinUrlEncoded = function (args) {
	return A2(
		$elm$core$String$join,
		'&',
		A2($elm$core$List$map, $dillonkearns$elm_graphql$Graphql$Http$QueryParams$queryPair, args));
};
var $dillonkearns$elm_graphql$Graphql$Http$QueryParams$urlWithQueryParams = F2(
	function (queryParams, url) {
		return $elm$core$List$isEmpty(queryParams) ? url : (url + ('?' + $dillonkearns$elm_graphql$Graphql$Http$QueryParams$joinUrlEncoded(queryParams)));
	});
var $dillonkearns$elm_graphql$Graphql$Http$QueryHelper$build = F5(
	function (forceMethod, url, queryParams, maybeOperationName, queryDocument) {
		var _v0 = function () {
			if (!maybeOperationName.$) {
				var operationName = maybeOperationName.a;
				return _Utils_Tuple2(
					A2($dillonkearns$elm_graphql$Graphql$Document$serializeQueryForUrlWithOperationName, operationName, queryDocument),
					_List_fromArray(
						[
							_Utils_Tuple2('operationName', operationName)
						]));
			} else {
				return _Utils_Tuple2(
					$dillonkearns$elm_graphql$Graphql$Document$serializeQueryForUrl(queryDocument),
					_List_Nil);
			}
		}();
		var serializedQueryForGetRequest = _v0.a;
		var operationNameParamForGetRequest = _v0.b;
		var urlForGetRequest = A2(
			$dillonkearns$elm_graphql$Graphql$Http$QueryParams$urlWithQueryParams,
			_Utils_ap(
				queryParams,
				A2(
					$elm$core$List$cons,
					_Utils_Tuple2('query', serializedQueryForGetRequest),
					operationNameParamForGetRequest)),
			url);
		if (_Utils_eq(
			forceMethod,
			$elm$core$Maybe$Just(1)) || ((_Utils_cmp(
			$elm$core$String$length(urlForGetRequest),
			$dillonkearns$elm_graphql$Graphql$Http$QueryHelper$maxLength) > -1) && (!_Utils_eq(
			forceMethod,
			$elm$core$Maybe$Just(0))))) {
			var _v2 = function () {
				if (!maybeOperationName.$) {
					var operationName = maybeOperationName.a;
					return _Utils_Tuple2(
						A2($dillonkearns$elm_graphql$Graphql$Document$serializeQueryWithOperationName, operationName, queryDocument),
						_List_fromArray(
							[
								_Utils_Tuple2(
								'operationName',
								$elm$json$Json$Encode$string(operationName))
							]));
				} else {
					return _Utils_Tuple2(
						$dillonkearns$elm_graphql$Graphql$Document$serializeQuery(queryDocument),
						_List_Nil);
				}
			}();
			var serializedQuery = _v2.a;
			var operationNameParamForPostRequest = _v2.b;
			return {
				fv: $elm$http$Http$jsonBody(
					$elm$json$Json$Encode$object(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'query',
								$elm$json$Json$Encode$string(serializedQuery)),
							operationNameParamForPostRequest))),
				bL: 1,
				gL: A2($dillonkearns$elm_graphql$Graphql$Http$QueryParams$urlWithQueryParams, queryParams, url)
			};
		} else {
			return {fv: $elm$http$Http$emptyBody, bL: 0, gL: urlForGetRequest};
		}
	});
var $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$ParsedData = function (a) {
	return {$: 0, a: a};
};
var $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$UnparsedData = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$GraphqlError = F3(
	function (message, locations, details) {
		return {mz: details, nO: locations, nS: message};
	});
var $elm$core$Dict$fromList = function (assocs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, dict) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($elm$core$Dict$insert, key, value, dict);
			}),
		$elm$core$Dict$empty,
		assocs);
};
var $elm$json$Json$Decode$dict = function (decoder) {
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$Dict$fromList,
		$elm$json$Json$Decode$keyValuePairs(decoder));
};
var $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$Location = F2(
	function (line, column) {
		return {mc: column, nI: line};
	});
var $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$locationDecoder = A3(
	$elm$json$Json$Decode$map2,
	$dillonkearns$elm_graphql$Graphql$Http$GraphqlError$Location,
	A2($elm$json$Json$Decode$field, 'line', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'column', $elm$json$Json$Decode$int));
var $elm$json$Json$Decode$map3 = _Json_map3;
var $elm$json$Json$Decode$maybe = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder),
				$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
			]));
};
var $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$decoder = A2(
	$elm$json$Json$Decode$field,
	'errors',
	$elm$json$Json$Decode$list(
		A4(
			$elm$json$Json$Decode$map3,
			$dillonkearns$elm_graphql$Graphql$Http$GraphqlError$GraphqlError,
			A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string),
			$elm$json$Json$Decode$maybe(
				A2(
					$elm$json$Json$Decode$field,
					'locations',
					$elm$json$Json$Decode$list($dillonkearns$elm_graphql$Graphql$Http$GraphqlError$locationDecoder))),
			A2(
				$elm$json$Json$Decode$map,
				$elm$core$Dict$remove('locations'),
				A2(
					$elm$json$Json$Decode$map,
					$elm$core$Dict$remove('message'),
					$elm$json$Json$Decode$dict($elm$json$Json$Decode$value))))));
var $elm$core$Tuple$pair = F2(
	function (a, b) {
		return _Utils_Tuple2(a, b);
	});
var $dillonkearns$elm_graphql$Graphql$Http$decodeErrorWithData = function (data) {
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$Result$Err,
		A2(
			$elm$json$Json$Decode$map,
			$elm$core$Tuple$pair(data),
			$dillonkearns$elm_graphql$Graphql$Http$GraphqlError$decoder));
};
var $dillonkearns$elm_graphql$Graphql$Http$nullJsonValue = function (a) {
	nullJsonValue:
	while (true) {
		var _v0 = A2($elm$json$Json$Decode$decodeString, $elm$json$Json$Decode$value, 'null');
		if (!_v0.$) {
			var value = _v0.a;
			return value;
		} else {
			var $temp$a = 0;
			a = $temp$a;
			continue nullJsonValue;
		}
	}
};
var $dillonkearns$elm_graphql$Graphql$Http$errorDecoder = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$andThen,
				$dillonkearns$elm_graphql$Graphql$Http$decodeErrorWithData,
				A2($elm$json$Json$Decode$map, $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$ParsedData, decoder)),
				A2(
				$elm$json$Json$Decode$andThen,
				$dillonkearns$elm_graphql$Graphql$Http$decodeErrorWithData,
				A2(
					$elm$json$Json$Decode$map,
					$dillonkearns$elm_graphql$Graphql$Http$GraphqlError$UnparsedData,
					A2($elm$json$Json$Decode$field, 'data', $elm$json$Json$Decode$value))),
				A2(
				$elm$json$Json$Decode$andThen,
				$dillonkearns$elm_graphql$Graphql$Http$decodeErrorWithData,
				$elm$json$Json$Decode$succeed(
					$dillonkearns$elm_graphql$Graphql$Http$GraphqlError$UnparsedData(
						$dillonkearns$elm_graphql$Graphql$Http$nullJsonValue(0))))
			]));
};
var $dillonkearns$elm_graphql$Graphql$Http$decoderOrError = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$dillonkearns$elm_graphql$Graphql$Http$errorDecoder(decoder),
				A2($elm$json$Json$Decode$map, $elm$core$Result$Ok, decoder)
			]));
};
var $dillonkearns$elm_graphql$Graphql$Document$serializeMutation = function (_v0) {
	var fields = _v0.a;
	var decoder_ = _v0.b;
	return A2($dillonkearns$elm_graphql$Graphql$Document$serialize, 'mutation', fields);
};
var $dillonkearns$elm_graphql$Graphql$Document$serializeMutationWithOperationName = F2(
	function (operationName, _v0) {
		var fields = _v0.a;
		var decoder_ = _v0.b;
		return A3($dillonkearns$elm_graphql$Graphql$Document$serializeWithOperationName, 'mutation', operationName, fields);
	});
var $dillonkearns$elm_graphql$Graphql$Http$toReadyRequest = function (_v0) {
	var request = _v0;
	var _v1 = request.mz;
	if (!_v1.$) {
		var forcedRequestMethod = _v1.a;
		var querySelectionSet = _v1.b;
		var queryRequestDetails = A5(
			$dillonkearns$elm_graphql$Graphql$Http$QueryHelper$build,
			function () {
				if (!forcedRequestMethod.$) {
					if (!forcedRequestMethod.a) {
						var _v4 = forcedRequestMethod.a;
						return $elm$core$Maybe$Just(0);
					} else {
						var _v5 = forcedRequestMethod.a;
						return $elm$core$Maybe$Nothing;
					}
				} else {
					return $elm$core$Maybe$Just(1);
				}
			}(),
			request.ec,
			request.cG,
			request.cz,
			querySelectionSet);
		return {
			fv: queryRequestDetails.fv,
			jc: $dillonkearns$elm_graphql$Graphql$Http$decoderOrError(request.fN),
			m4: request.m4,
			bL: function () {
				var _v2 = queryRequestDetails.bL;
				if (!_v2) {
					return 'GET';
				} else {
					return 'Post';
				}
			}(),
			am: request.am,
			gL: queryRequestDetails.gL
		};
	} else {
		var mutationSelectionSet = _v1.a;
		var serializedMutation = function () {
			var _v7 = request.cz;
			if (!_v7.$) {
				var operationName = _v7.a;
				return A2($dillonkearns$elm_graphql$Graphql$Document$serializeMutationWithOperationName, operationName, mutationSelectionSet);
			} else {
				return $dillonkearns$elm_graphql$Graphql$Document$serializeMutation(mutationSelectionSet);
			}
		}();
		return {
			fv: $elm$http$Http$jsonBody(
				$elm$json$Json$Encode$object(
					A2(
						$elm$core$List$append,
						_List_fromArray(
							[
								_Utils_Tuple2(
								'query',
								$elm$json$Json$Encode$string(serializedMutation))
							]),
						function () {
							var _v6 = request.cz;
							if (!_v6.$) {
								var operationName = _v6.a;
								return _List_fromArray(
									[
										_Utils_Tuple2(
										'operationName',
										$elm$json$Json$Encode$string(operationName))
									]);
							} else {
								return _List_Nil;
							}
						}()))),
			jc: $dillonkearns$elm_graphql$Graphql$Http$decoderOrError(request.fN),
			m4: request.m4,
			bL: 'POST',
			am: request.am,
			gL: A2($dillonkearns$elm_graphql$Graphql$Http$QueryParams$urlWithQueryParams, request.cG, request.ec)
		};
	}
};
var $dillonkearns$elm_graphql$Graphql$Http$toHttpRequestRecord = F2(
	function (resultToMessage, fullRequest) {
		var request = fullRequest;
		return function (readyRequest) {
			return {
				fv: readyRequest.fv,
				fN: A2(
					$dillonkearns$elm_graphql$Graphql$Http$expectJson,
					A2($elm$core$Basics$composeR, $dillonkearns$elm_graphql$Graphql$Http$convertResult, resultToMessage),
					readyRequest.jc),
				m4: readyRequest.m4,
				bL: readyRequest.bL,
				am: readyRequest.am,
				lr: $elm$core$Maybe$Nothing,
				gL: readyRequest.gL
			};
		}(
			$dillonkearns$elm_graphql$Graphql$Http$toReadyRequest(fullRequest));
	});
var $dillonkearns$elm_graphql$Graphql$Http$send = F2(
	function (resultToMessage, fullRequest) {
		var request = fullRequest;
		return (request.cS ? $elm$http$Http$riskyRequest : $elm$http$Http$request)(
			A2($dillonkearns$elm_graphql$Graphql$Http$toHttpRequestRecord, resultToMessage, fullRequest));
	});
var $elm$http$Http$Header = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$header = $elm$http$Http$Header;
var $dillonkearns$elm_graphql$Graphql$Http$withHeader = F3(
	function (key, value, _v0) {
		var request = _v0;
		return _Utils_update(
			request,
			{
				m4: A2(
					$elm$core$List$cons,
					A2($elm$http$Http$header, key, value),
					request.m4)
			});
	});
var $author$project$Api$Graphql$withAuthToken = function (maybeToken) {
	if (!maybeToken.$) {
		var token = maybeToken.a;
		return A2($dillonkearns$elm_graphql$Graphql$Http$withHeader, 'authorization', 'Bearer ' + token);
	} else {
		return $elm$core$Basics$identity;
	}
};
var $author$project$Environment$Demo = 2;
var $author$project$Environment$Development = 0;
var $author$project$Environment$Production = 3;
var $author$project$Environment$Staging = 1;
var $elm$core$String$endsWith = _String_endsWith;
var $author$project$Environment$fromUrl = function (url) {
	return A2($elm$core$String$endsWith, 'localhost', url.ez) ? 0 : (A2($elm$core$String$endsWith, '.staging.cambiatus.io', url.ez) ? 1 : (A2($elm$core$String$endsWith, '.demo.cambiatus.io', url.ez) ? 2 : (A2($elm$core$String$endsWith, '.cambiatus.io', url.ez) ? 3 : 1)));
};
var $author$project$Environment$communitySubdomainParts = function (url) {
	var isStaging = function () {
		var _v4 = $author$project$Environment$fromUrl(url);
		switch (_v4) {
			case 0:
				return true;
			case 1:
				return true;
			default:
				return false;
		}
	}();
	var allParts = A2($elm$core$String$split, '.', url.ez);
	var addStaging = function (parts) {
		return isStaging ? _Utils_ap(
			parts,
			_List_fromArray(
				['staging'])) : parts;
	};
	if (!allParts.b) {
		return addStaging(
			_List_fromArray(
				['cambiatus']));
	} else {
		if (!allParts.b.b) {
			var subdomain = allParts.a;
			return addStaging(
				_List_fromArray(
					[subdomain]));
		} else {
			switch (allParts.b.a) {
				case 'localhost':
					var subdomain = allParts.a;
					var _v1 = allParts.b;
					return _List_fromArray(
						[subdomain, 'staging']);
				case 'cambiatus':
					var subdomain = allParts.a;
					var _v2 = allParts.b;
					return _List_fromArray(
						[subdomain]);
				default:
					var subdomain = allParts.a;
					var _v3 = allParts.b;
					var env = _v3.a;
					return _List_fromArray(
						[subdomain, env]);
			}
		}
	}
};
var $author$project$Environment$communityDomain = function (url) {
	return A2(
		$elm$core$String$join,
		'.',
		_Utils_ap(
			$author$project$Environment$communitySubdomainParts(url),
			_List_fromArray(
				['cambiatus', 'io'])));
};
var $elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var $elm$core$List$takeReverse = F3(
	function (n, list, kept) {
		takeReverse:
		while (true) {
			if (n <= 0) {
				return kept;
			} else {
				if (!list.b) {
					return kept;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs,
						$temp$kept = A2($elm$core$List$cons, x, kept);
					n = $temp$n;
					list = $temp$list;
					kept = $temp$kept;
					continue takeReverse;
				}
			}
		}
	});
var $elm$core$List$takeTailRec = F2(
	function (n, list) {
		return $elm$core$List$reverse(
			A3($elm$core$List$takeReverse, n, list, _List_Nil));
	});
var $elm$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (n <= 0) {
			return _List_Nil;
		} else {
			var _v0 = _Utils_Tuple2(n, list);
			_v0$1:
			while (true) {
				_v0$5:
				while (true) {
					if (!_v0.b.b) {
						return list;
					} else {
						if (_v0.b.b.b) {
							switch (_v0.a) {
								case 1:
									break _v0$1;
								case 2:
									var _v2 = _v0.b;
									var x = _v2.a;
									var _v3 = _v2.b;
									var y = _v3.a;
									return _List_fromArray(
										[x, y]);
								case 3:
									if (_v0.b.b.b.b) {
										var _v4 = _v0.b;
										var x = _v4.a;
										var _v5 = _v4.b;
										var y = _v5.a;
										var _v6 = _v5.b;
										var z = _v6.a;
										return _List_fromArray(
											[x, y, z]);
									} else {
										break _v0$5;
									}
								default:
									if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
										var _v7 = _v0.b;
										var x = _v7.a;
										var _v8 = _v7.b;
										var y = _v8.a;
										var _v9 = _v8.b;
										var z = _v9.a;
										var _v10 = _v9.b;
										var w = _v10.a;
										var tl = _v10.b;
										return (ctr > 1000) ? A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A2($elm$core$List$takeTailRec, n - 4, tl))))) : A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A3($elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
									} else {
										break _v0$5;
									}
							}
						} else {
							if (_v0.a === 1) {
								break _v0$1;
							} else {
								break _v0$5;
							}
						}
					}
				}
				return list;
			}
			var _v1 = _v0.b;
			var x = _v1.a;
			return _List_fromArray(
				[x]);
		}
	});
var $elm$core$List$take = F2(
	function (n, list) {
		return A3($elm$core$List$takeFast, 0, n, list);
	});
var $elm_community$list_extra$List$Extra$updateAt = F3(
	function (index, fn, list) {
		if (index < 0) {
			return list;
		} else {
			var tail = A2($elm$core$List$drop, index, list);
			if (tail.b) {
				var x = tail.a;
				var xs = tail.b;
				return _Utils_ap(
					A2($elm$core$List$take, index, list),
					A2(
						$elm$core$List$cons,
						fn(x),
						xs));
			} else {
				return list;
			}
		}
	});
var $author$project$Api$Graphql$withCommunityDomain = function (shared) {
	var communityDomain = function () {
		if (shared.pL) {
			return $author$project$Environment$communityDomain(shared.gL);
		} else {
			if (A2($elm$core$String$endsWith, '.cambiatus.io', shared.gL.gm)) {
				var sharedUrl = shared.gL;
				return _Utils_update(
					sharedUrl,
					{
						gm: A2(
							$elm$core$String$join,
							'.',
							A3(
								$elm_community$list_extra$List$Extra$updateAt,
								0,
								function (_v0) {
									return 'cambiatus';
								},
								A2($elm$core$String$split, '.', sharedUrl.gm)))
					}).gm;
			} else {
				return 'cambiatus.staging.cambiatus.io';
			}
		}
	}();
	return A2($dillonkearns$elm_graphql$Graphql$Http$withHeader, 'Community-Domain', 'https://' + communityDomain);
};
var $author$project$Api$Graphql$query = F4(
	function (shared, maybeAuthToken, query_, toMsg) {
		var endpoints = shared.mJ;
		return A2(
			$dillonkearns$elm_graphql$Graphql$Http$send,
			A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, toMsg),
			A2(
				$author$project$Api$Graphql$withAuthToken,
				maybeAuthToken,
				A2(
					$author$project$Api$Graphql$withCommunityDomain,
					shared,
					A2($dillonkearns$elm_graphql$Graphql$Http$queryRequest, endpoints.fS, query_))));
	});
var $author$project$Page$toShared = function (session) {
	if (session.$ === 1) {
		var loggedIn = session.a;
		return loggedIn.aM;
	} else {
		var guest = session.a;
		return guest.aM;
	}
};
var $author$project$Page$Community$Invite$init = F2(
	function (session, invitationId) {
		return _Utils_Tuple2(
			$author$project$Page$Community$Invite$initModel(invitationId),
			function () {
				if (!session.$) {
					return A4(
						$author$project$Api$Graphql$query,
						$author$project$Page$toShared(session),
						$elm$core$Maybe$Nothing,
						$author$project$Community$inviteQuery(invitationId),
						$author$project$Page$Community$Invite$CompletedLoadInvite);
				} else {
					var loggedIn = session.a;
					return A3(
						$author$project$Session$LoggedIn$maybeInitWith,
						function (_v1) {
							return $author$project$Page$Community$Invite$CompletedLoadProfile;
						},
						function ($) {
							return $.kJ;
						},
						loggedIn);
				}
			}());
	});
var $author$project$Page$Community$New$defaultLogos = _List_fromArray(
	['https://cambiatus-uploads.s3.amazonaws.com/cambiatus-uploads/community_1.png', 'https://cambiatus-uploads.s3.amazonaws.com/cambiatus-uploads/community_2.png', 'https://cambiatus-uploads.s3.amazonaws.com/cambiatus-uploads/community_3.png', 'https://cambiatus-uploads.s3.amazonaws.com/cambiatus-uploads/community_4.png', 'https://cambiatus-uploads.s3.amazonaws.com/cambiatus-uploads/community_5.png']);
var $author$project$Form$ErrorTracking = $elm$core$Basics$identity;
var $author$project$Form$Model = $elm$core$Basics$identity;
var $elm$core$Set$Set_elm_builtin = $elm$core$Basics$identity;
var $elm$core$Set$empty = $elm$core$Dict$empty;
var $author$project$Form$init = function (values) {
	return {
		cf: false,
		aG: {e2: false, bU: $elm$core$Set$empty},
		f7: $elm$core$Set$empty,
		s: values
	};
};
var $author$project$Form$RichText$Model = $elm$core$Basics$identity;
var $author$project$Form$RichText$NotShowing = {$: 0};
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $elm$core$List$concatMap = F2(
	function (f, list) {
		return $elm$core$List$concat(
			A2($elm$core$List$map, f, list));
	});
var $elm$core$Result$map = F2(
	function (func, ra) {
		if (!ra.$) {
			var a = ra.a;
			return $elm$core$Result$Ok(
				func(a));
		} else {
			var e = ra.a;
			return $elm$core$Result$Err(e);
		}
	});
var $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine = {$: 10};
var $dillonkearns$elm_markdown$Markdown$Block$BlockQuote = function (a) {
	return {$: 3, a: a};
};
var $dillonkearns$elm_markdown$Markdown$RawBlock$BlockQuote = function (a) {
	return {$: 11, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$Cdata = function (a) {
	return {$: 4, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$CodeBlock = function (a) {
	return {$: 7, a: a};
};
var $dillonkearns$elm_markdown$Markdown$RawBlock$CodeBlock = function (a) {
	return {$: 5, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$CodeSpan = function (a) {
	return {$: 6, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$CompletedTask = 2;
var $elm$parser$Parser$Advanced$Done = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$Emphasis = function (a) {
	return {$: 3, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Inline$Emphasis = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$Parser$EmptyBlock = {$: 0};
var $elm$parser$Parser$Expecting = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$ExpectingSymbol = function (a) {
	return {$: 8, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$HardLineBreak = {$: 8};
var $dillonkearns$elm_markdown$Markdown$Block$Heading = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$RawBlock$Heading = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$RawBlock$Html = function (a) {
	return {$: 2, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$HtmlBlock = function (a) {
	return {$: 0, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$HtmlComment = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$HtmlDeclaration = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$Block$HtmlElement = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $dillonkearns$elm_markdown$Markdown$Block$HtmlInline = function (a) {
	return {$: 0, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$Image = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $dillonkearns$elm_markdown$Markdown$Block$IncompleteTask = 1;
var $dillonkearns$elm_markdown$Markdown$RawBlock$IndentedCodeBlock = function (a) {
	return {$: 6, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Parser$InlineProblem = function (a) {
	return {$: 2, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$Link = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $dillonkearns$elm_markdown$Markdown$Block$ListItem = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$Loop = function (a) {
	return {$: 0, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$NoTask = 0;
var $dillonkearns$elm_markdown$Markdown$RawBlock$OpenBlockOrParagraph = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$OrderedList = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock = F6(
	function (a, b, c, d, e, f) {
		return {$: 4, a: a, b: b, c: c, d: d, e: e, f: f};
	});
var $dillonkearns$elm_markdown$Markdown$Block$Paragraph = function (a) {
	return {$: 5, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_markdown$Markdown$RawBlock$ParsedBlockQuote = function (a) {
	return {$: 12, a: a};
};
var $elm$parser$Parser$Problem = function (a) {
	return {$: 12, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$ProcessingInstruction = function (a) {
	return {$: 2, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$Strikethrough = function (a) {
	return {$: 5, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$Strong = function (a) {
	return {$: 4, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$Table = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$RawBlock$Table = function (a) {
	return {$: 8, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Table$Table = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$Table$TableDelimiterRow = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$Block$Text = function (a) {
	return {$: 7, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$ThematicBreak = {$: 8};
var $dillonkearns$elm_markdown$Markdown$RawBlock$ThematicBreak = {$: 7};
var $elm$parser$Parser$Advanced$Token = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$Block$UnorderedList = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock = F4(
	function (a, b, c, d) {
		return {$: 3, a: a, b: b, c: c, d: d};
	});
var $dillonkearns$elm_markdown$Markdown$RawBlock$UnparsedInlines = $elm$core$Basics$identity;
var $dillonkearns$elm_markdown$Markdown$Parser$addReference = F2(
	function (state, linkRef) {
		return {
			a: A2($elm$core$List$cons, linkRef, state.a),
			b: state.b
		};
	});
var $elm$parser$Parser$Advanced$Bad = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$Good = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$parser$Parser$Advanced$Parser = $elm$core$Basics$identity;
var $elm$parser$Parser$Advanced$andThen = F2(
	function (callback, _v0) {
		var parseA = _v0;
		return function (s0) {
			var _v1 = parseA(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				var _v2 = callback(a);
				var parseB = _v2;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3($elm$parser$Parser$Advanced$Good, p1 || p2, b, s2);
				}
			}
		};
	});
var $elm$parser$Parser$Advanced$backtrackable = function (_v0) {
	var parse = _v0;
	return function (s0) {
		var _v1 = parse(s0);
		if (_v1.$ === 1) {
			var x = _v1.b;
			return A2($elm$parser$Parser$Advanced$Bad, false, x);
		} else {
			var a = _v1.b;
			var s1 = _v1.c;
			return A3($elm$parser$Parser$Advanced$Good, false, a, s1);
		}
	};
};
var $elm$parser$Parser$Advanced$isSubChar = _Parser_isSubChar;
var $elm$parser$Parser$Advanced$chompWhileHelp = F5(
	function (isGood, offset, row, col, s0) {
		chompWhileHelp:
		while (true) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, offset, s0.$8);
			if (_Utils_eq(newOffset, -1)) {
				return A3(
					$elm$parser$Parser$Advanced$Good,
					_Utils_cmp(s0.d, offset) < 0,
					0,
					{i3: col, i: s0.i, o: s0.o, d: offset, o6: row, $8: s0.$8});
			} else {
				if (_Utils_eq(newOffset, -2)) {
					var $temp$isGood = isGood,
						$temp$offset = offset + 1,
						$temp$row = row + 1,
						$temp$col = 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				} else {
					var $temp$isGood = isGood,
						$temp$offset = newOffset,
						$temp$row = row,
						$temp$col = col + 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$chompWhile = function (isGood) {
	return function (s) {
		return A5($elm$parser$Parser$Advanced$chompWhileHelp, isGood, s.d, s.o6, s.i3, s);
	};
};
var $elm$parser$Parser$Advanced$map2 = F3(
	function (func, _v0, _v1) {
		var parseA = _v0;
		var parseB = _v1;
		return function (s0) {
			var _v2 = parseA(s0);
			if (_v2.$ === 1) {
				var p = _v2.a;
				var x = _v2.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v2.a;
				var a = _v2.b;
				var s1 = _v2.c;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3(
						$elm$parser$Parser$Advanced$Good,
						p1 || p2,
						A2(func, a, b),
						s2);
				}
			}
		};
	});
var $elm$parser$Parser$Advanced$ignorer = F2(
	function (keepParser, ignoreParser) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$always, keepParser, ignoreParser);
	});
var $dillonkearns$elm_markdown$Whitespace$isSpaceOrTab = function (_char) {
	switch (_char) {
		case ' ':
			return true;
		case '\t':
			return true;
		default:
			return false;
	}
};
var $dillonkearns$elm_markdown$Parser$Token$carriageReturn = A2(
	$elm$parser$Parser$Advanced$Token,
	'\r',
	$elm$parser$Parser$Expecting('a carriage return'));
var $dillonkearns$elm_markdown$Parser$Token$newline = A2(
	$elm$parser$Parser$Advanced$Token,
	'\n',
	$elm$parser$Parser$Expecting('a newline'));
var $elm$parser$Parser$Advanced$Empty = {$: 0};
var $elm$parser$Parser$Advanced$Append = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$oneOfHelp = F3(
	function (s0, bag, parsers) {
		oneOfHelp:
		while (true) {
			if (!parsers.b) {
				return A2($elm$parser$Parser$Advanced$Bad, false, bag);
			} else {
				var parse = parsers.a;
				var remainingParsers = parsers.b;
				var _v1 = parse(s0);
				if (!_v1.$) {
					var step = _v1;
					return step;
				} else {
					var step = _v1;
					var p = step.a;
					var x = step.b;
					if (p) {
						return step;
					} else {
						var $temp$s0 = s0,
							$temp$bag = A2($elm$parser$Parser$Advanced$Append, bag, x),
							$temp$parsers = remainingParsers;
						s0 = $temp$s0;
						bag = $temp$bag;
						parsers = $temp$parsers;
						continue oneOfHelp;
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$oneOf = function (parsers) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$oneOfHelp, s, $elm$parser$Parser$Advanced$Empty, parsers);
	};
};
var $elm$parser$Parser$Advanced$succeed = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, false, a, s);
	};
};
var $elm$parser$Parser$Advanced$AddRight = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$DeadEnd = F4(
	function (row, col, problem, contextStack) {
		return {i3: col, ml: contextStack, oO: problem, o6: row};
	});
var $elm$parser$Parser$Advanced$fromState = F2(
	function (s, x) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, s.o6, s.i3, x, s.i));
	});
var $elm$parser$Parser$Advanced$isSubString = _Parser_isSubString;
var $elm$core$Basics$not = _Basics_not;
var $elm$parser$Parser$Advanced$token = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	var progress = !$elm$core$String$isEmpty(str);
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$isSubString, str, s.d, s.o6, s.i3, s.$8);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : A3(
			$elm$parser$Parser$Advanced$Good,
			progress,
			0,
			{i3: newCol, i: s.i, o: s.o, d: newOffset, o6: newRow, $8: s.$8});
	};
};
var $dillonkearns$elm_markdown$Whitespace$lineEnd = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			$elm$parser$Parser$Advanced$token($dillonkearns$elm_markdown$Parser$Token$newline),
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$token($dillonkearns$elm_markdown$Parser$Token$carriageReturn),
			$elm$parser$Parser$Advanced$oneOf(
				_List_fromArray(
					[
						$elm$parser$Parser$Advanced$token($dillonkearns$elm_markdown$Parser$Token$newline),
						$elm$parser$Parser$Advanced$succeed(0)
					])))
		]));
var $elm$parser$Parser$Advanced$map = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					func(a),
					s1);
			} else {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			}
		};
	});
var $dillonkearns$elm_markdown$Markdown$Parser$blankLine = A2(
	$elm$parser$Parser$Advanced$map,
	function (_v0) {
		return $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine;
	},
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$backtrackable(
			$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab)),
		$dillonkearns$elm_markdown$Whitespace$lineEnd));
var $dillonkearns$elm_markdown$Parser$Token$space = A2(
	$elm$parser$Parser$Advanced$Token,
	' ',
	$elm$parser$Parser$Expecting('a space'));
var $elm$parser$Parser$Advanced$symbol = $elm$parser$Parser$Advanced$token;
var $dillonkearns$elm_markdown$Markdown$Parser$blockQuoteStarts = _List_fromArray(
	[
		$elm$parser$Parser$Advanced$symbol(
		A2(
			$elm$parser$Parser$Advanced$Token,
			'>',
			$elm$parser$Parser$Expecting('>'))),
		A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$backtrackable(
			$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$space)),
		$elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$Advanced$symbol(
					A2(
						$elm$parser$Parser$Advanced$Token,
						'>',
						$elm$parser$Parser$Expecting(' >'))),
					$elm$parser$Parser$Advanced$symbol(
					A2(
						$elm$parser$Parser$Advanced$Token,
						' >',
						$elm$parser$Parser$Expecting('  >'))),
					$elm$parser$Parser$Advanced$symbol(
					A2(
						$elm$parser$Parser$Advanced$Token,
						'  >',
						$elm$parser$Parser$Expecting('   >')))
				])))
	]);
var $dillonkearns$elm_markdown$Whitespace$isLineEnd = function (_char) {
	switch (_char) {
		case '\n':
			return true;
		case '\r':
			return true;
		default:
			return false;
	}
};
var $dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd = $elm$parser$Parser$Advanced$chompWhile(
	A2($elm$core$Basics$composeL, $elm$core$Basics$not, $dillonkearns$elm_markdown$Whitespace$isLineEnd));
var $elm$parser$Parser$Advanced$mapChompedString = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					A2(
						func,
						A3($elm$core$String$slice, s0.d, s1.d, s0.$8),
						a),
					s1);
			}
		};
	});
var $elm$parser$Parser$Advanced$getChompedString = function (parser) {
	return A2($elm$parser$Parser$Advanced$mapChompedString, $elm$core$Basics$always, parser);
};
var $elm$parser$Parser$Advanced$keeper = F2(
	function (parseFunc, parseArg) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$apL, parseFunc, parseArg);
	});
var $elm$parser$Parser$Advanced$end = function (x) {
	return function (s) {
		return _Utils_eq(
			$elm$core$String$length(s.$8),
			s.d) ? A3($elm$parser$Parser$Advanced$Good, false, 0, s) : A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $dillonkearns$elm_markdown$Helpers$endOfFile = $elm$parser$Parser$Advanced$end(
	$elm$parser$Parser$Expecting('the end of the input'));
var $dillonkearns$elm_markdown$Helpers$lineEndOrEnd = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[$dillonkearns$elm_markdown$Whitespace$lineEnd, $dillonkearns$elm_markdown$Helpers$endOfFile]));
var $dillonkearns$elm_markdown$Markdown$Parser$blockQuote = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$RawBlock$BlockQuote),
			$elm$parser$Parser$Advanced$oneOf($dillonkearns$elm_markdown$Markdown$Parser$blockQuoteStarts)),
		$elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$space),
					$elm$parser$Parser$Advanced$succeed(0)
				]))),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$getChompedString($dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd),
		$dillonkearns$elm_markdown$Helpers$lineEndOrEnd));
var $dillonkearns$elm_markdown$Markdown$Parser$problemToString = function (problem) {
	switch (problem.$) {
		case 0:
			var string = problem.a;
			return 'Expecting ' + string;
		case 1:
			return 'Expecting int';
		case 2:
			return 'Expecting hex';
		case 3:
			return 'Expecting octal';
		case 4:
			return 'Expecting binary';
		case 5:
			return 'Expecting float';
		case 6:
			return 'Expecting number';
		case 7:
			return 'Expecting variable';
		case 8:
			var string = problem.a;
			return 'Expecting symbol ' + string;
		case 9:
			var string = problem.a;
			return 'Expecting keyword ' + string;
		case 10:
			return 'Expecting keyword end';
		case 11:
			return 'Unexpected char';
		case 12:
			var problemDescription = problem.a;
			return problemDescription;
		default:
			return 'Bad repeat';
	}
};
var $dillonkearns$elm_markdown$Markdown$Parser$deadEndToString = function (deadEnd) {
	return 'Problem at row ' + ($elm$core$String$fromInt(deadEnd.o6) + ('\n' + $dillonkearns$elm_markdown$Markdown$Parser$problemToString(deadEnd.oO)));
};
var $dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString = function (deadEnds) {
	return A2(
		$elm$core$String$join,
		'\n',
		A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Parser$deadEndToString, deadEnds));
};
var $dillonkearns$elm_markdown$HtmlParser$Cdata = function (a) {
	return {$: 3, a: a};
};
var $dillonkearns$elm_markdown$HtmlParser$Element = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $dillonkearns$elm_markdown$HtmlParser$Text = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Advanced$chompIf = F2(
	function (isGood, expecting) {
		return function (s) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, s.d, s.$8);
			return _Utils_eq(newOffset, -1) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				false,
				A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : (_Utils_eq(newOffset, -2) ? A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{i3: 1, i: s.i, o: s.o, d: s.d + 1, o6: s.o6 + 1, $8: s.$8}) : A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{i3: s.i3 + 1, i: s.i, o: s.o, d: newOffset, o6: s.o6, $8: s.$8}));
		};
	});
var $dillonkearns$elm_markdown$HtmlParser$expectTagNameCharacter = $elm$parser$Parser$Expecting('at least 1 tag name character');
var $dillonkearns$elm_markdown$HtmlParser$tagNameCharacter = function (c) {
	switch (c) {
		case ' ':
			return false;
		case '\r':
			return false;
		case '\n':
			return false;
		case '\t':
			return false;
		case '/':
			return false;
		case '<':
			return false;
		case '>':
			return false;
		case '\"':
			return false;
		case '\'':
			return false;
		case '=':
			return false;
		default:
			return true;
	}
};
var $elm$core$String$toLower = _String_toLower;
var $dillonkearns$elm_markdown$HtmlParser$tagName = A2(
	$elm$parser$Parser$Advanced$mapChompedString,
	F2(
		function (name, _v0) {
			return $elm$core$String$toLower(name);
		}),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		A2($elm$parser$Parser$Advanced$chompIf, $dillonkearns$elm_markdown$HtmlParser$tagNameCharacter, $dillonkearns$elm_markdown$HtmlParser$expectTagNameCharacter),
		$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$HtmlParser$tagNameCharacter)));
var $dillonkearns$elm_markdown$HtmlParser$attributeName = $dillonkearns$elm_markdown$HtmlParser$tagName;
var $dillonkearns$elm_markdown$HtmlParser$symbol = function (str) {
	return $elm$parser$Parser$Advanced$token(
		A2(
			$elm$parser$Parser$Advanced$Token,
			str,
			$elm$parser$Parser$ExpectingSymbol(str)));
};
var $elm$parser$Parser$Advanced$loopHelp = F4(
	function (p, state, callback, s0) {
		loopHelp:
		while (true) {
			var _v0 = callback(state);
			var parse = _v0;
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p1 = _v1.a;
				var step = _v1.b;
				var s1 = _v1.c;
				if (!step.$) {
					var newState = step.a;
					var $temp$p = p || p1,
						$temp$state = newState,
						$temp$callback = callback,
						$temp$s0 = s1;
					p = $temp$p;
					state = $temp$state;
					callback = $temp$callback;
					s0 = $temp$s0;
					continue loopHelp;
				} else {
					var result = step.a;
					return A3($elm$parser$Parser$Advanced$Good, p || p1, result, s1);
				}
			} else {
				var p1 = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p || p1, x);
			}
		}
	});
var $elm$parser$Parser$Advanced$loop = F2(
	function (state, callback) {
		return function (s) {
			return A4($elm$parser$Parser$Advanced$loopHelp, false, state, callback, s);
		};
	});
var $dillonkearns$elm_markdown$HtmlParser$entities = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('amp', '&'),
			_Utils_Tuple2('lt', '<'),
			_Utils_Tuple2('gt', '>'),
			_Utils_Tuple2('apos', '\''),
			_Utils_Tuple2('quot', '\"')
		]));
var $elm$core$Char$fromCode = _Char_fromCode;
var $elm$core$Result$fromMaybe = F2(
	function (err, maybe) {
		if (!maybe.$) {
			var v = maybe.a;
			return $elm$core$Result$Ok(v);
		} else {
			return $elm$core$Result$Err(err);
		}
	});
var $elm$core$String$cons = _String_cons;
var $elm$core$String$fromChar = function (_char) {
	return A2($elm$core$String$cons, _char, '');
};
var $elm$core$Basics$pow = _Basics_pow;
var $rtfeldman$elm_hex$Hex$fromStringHelp = F3(
	function (position, chars, accumulated) {
		fromStringHelp:
		while (true) {
			if (!chars.b) {
				return $elm$core$Result$Ok(accumulated);
			} else {
				var _char = chars.a;
				var rest = chars.b;
				switch (_char) {
					case '0':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated;
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '1':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + A2($elm$core$Basics$pow, 16, position);
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '2':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (2 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '3':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (3 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '4':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (4 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '5':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (5 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '6':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (6 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '7':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (7 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '8':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (8 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '9':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (9 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'a':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (10 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'b':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (11 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'c':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (12 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'd':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (13 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'e':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (14 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'f':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (15 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					default:
						var nonHex = _char;
						return $elm$core$Result$Err(
							$elm$core$String$fromChar(nonHex) + ' is not a valid hexadecimal character.');
				}
			}
		}
	});
var $elm$core$Result$mapError = F2(
	function (f, result) {
		if (!result.$) {
			var v = result.a;
			return $elm$core$Result$Ok(v);
		} else {
			var e = result.a;
			return $elm$core$Result$Err(
				f(e));
		}
	});
var $elm$core$List$tail = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(xs);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$String$foldr = _String_foldr;
var $elm$core$String$toList = function (string) {
	return A3($elm$core$String$foldr, $elm$core$List$cons, _List_Nil, string);
};
var $rtfeldman$elm_hex$Hex$fromString = function (str) {
	if ($elm$core$String$isEmpty(str)) {
		return $elm$core$Result$Err('Empty strings are not valid hexadecimal strings.');
	} else {
		var result = function () {
			if (A2($elm$core$String$startsWith, '-', str)) {
				var list = A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					$elm$core$List$tail(
						$elm$core$String$toList(str)));
				return A2(
					$elm$core$Result$map,
					$elm$core$Basics$negate,
					A3(
						$rtfeldman$elm_hex$Hex$fromStringHelp,
						$elm$core$List$length(list) - 1,
						list,
						0));
			} else {
				return A3(
					$rtfeldman$elm_hex$Hex$fromStringHelp,
					$elm$core$String$length(str) - 1,
					$elm$core$String$toList(str),
					0);
			}
		}();
		var formatError = function (err) {
			return A2(
				$elm$core$String$join,
				' ',
				_List_fromArray(
					['\"' + (str + '\"'), 'is not a valid hexadecimal string because', err]));
		};
		return A2($elm$core$Result$mapError, formatError, result);
	}
};
var $dillonkearns$elm_markdown$HtmlParser$decodeEscape = function (s) {
	return A2($elm$core$String$startsWith, '#x', s) ? A2(
		$elm$core$Result$mapError,
		$elm$parser$Parser$Problem,
		A2(
			$elm$core$Result$map,
			$elm$core$Char$fromCode,
			$rtfeldman$elm_hex$Hex$fromString(
				A2($elm$core$String$dropLeft, 2, s)))) : (A2($elm$core$String$startsWith, '#', s) ? A2(
		$elm$core$Result$fromMaybe,
		$elm$parser$Parser$Problem('Invalid escaped character: ' + s),
		A2(
			$elm$core$Maybe$map,
			$elm$core$Char$fromCode,
			$elm$core$String$toInt(
				A2($elm$core$String$dropLeft, 1, s)))) : A2(
		$elm$core$Result$fromMaybe,
		$elm$parser$Parser$Problem('No entity named \"&' + (s + ';\" found.')),
		A2($elm$core$Dict$get, s, $dillonkearns$elm_markdown$HtmlParser$entities)));
};
var $elm$parser$Parser$Advanced$problem = function (x) {
	return function (s) {
		return A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $dillonkearns$elm_markdown$HtmlParser$escapedChar = function (end_) {
	var process = function (entityStr) {
		var _v0 = $dillonkearns$elm_markdown$HtmlParser$decodeEscape(entityStr);
		if (!_v0.$) {
			var c = _v0.a;
			return $elm$parser$Parser$Advanced$succeed(c);
		} else {
			var e = _v0.a;
			return $elm$parser$Parser$Advanced$problem(e);
		}
	};
	var isEntityChar = function (c) {
		return (!_Utils_eq(c, end_)) && (c !== ';');
	};
	return A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
			$dillonkearns$elm_markdown$HtmlParser$symbol('&')),
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$andThen,
				process,
				$elm$parser$Parser$Advanced$getChompedString(
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						A2(
							$elm$parser$Parser$Advanced$chompIf,
							isEntityChar,
							$elm$parser$Parser$Expecting('an entity character')),
						$elm$parser$Parser$Advanced$chompWhile(isEntityChar)))),
			$dillonkearns$elm_markdown$HtmlParser$symbol(';')));
};
var $dillonkearns$elm_markdown$HtmlParser$textStringStep = F3(
	function (closingChar, predicate, accum) {
		return A2(
			$elm$parser$Parser$Advanced$andThen,
			function (soFar) {
				return $elm$parser$Parser$Advanced$oneOf(
					_List_fromArray(
						[
							A2(
							$elm$parser$Parser$Advanced$map,
							function (escaped) {
								return $elm$parser$Parser$Advanced$Loop(
									_Utils_ap(
										accum,
										_Utils_ap(
											soFar,
											$elm$core$String$fromChar(escaped))));
							},
							$dillonkearns$elm_markdown$HtmlParser$escapedChar(closingChar)),
							$elm$parser$Parser$Advanced$succeed(
							$elm$parser$Parser$Advanced$Done(
								_Utils_ap(accum, soFar)))
						]));
			},
			$elm$parser$Parser$Advanced$getChompedString(
				$elm$parser$Parser$Advanced$chompWhile(predicate)));
	});
var $dillonkearns$elm_markdown$HtmlParser$textString = function (closingChar) {
	var predicate = function (c) {
		return (!_Utils_eq(c, closingChar)) && (c !== '&');
	};
	return A2(
		$elm$parser$Parser$Advanced$loop,
		'',
		A2($dillonkearns$elm_markdown$HtmlParser$textStringStep, closingChar, predicate));
};
var $dillonkearns$elm_markdown$HtmlParser$attributeValue = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
				$dillonkearns$elm_markdown$HtmlParser$symbol('\"')),
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$dillonkearns$elm_markdown$HtmlParser$textString('\"'),
				$dillonkearns$elm_markdown$HtmlParser$symbol('\"'))),
			A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
				$dillonkearns$elm_markdown$HtmlParser$symbol('\'')),
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$dillonkearns$elm_markdown$HtmlParser$textString('\''),
				$dillonkearns$elm_markdown$HtmlParser$symbol('\'')))
		]));
var $dillonkearns$elm_markdown$HtmlParser$keepOldest = F2(
	function (_new, mValue) {
		if (!mValue.$) {
			var v = mValue.a;
			return $elm$core$Maybe$Just(v);
		} else {
			return $elm$core$Maybe$Just(_new);
		}
	});
var $dillonkearns$elm_markdown$HtmlParser$isWhitespace = function (c) {
	switch (c) {
		case ' ':
			return true;
		case '\r':
			return true;
		case '\n':
			return true;
		case '\t':
			return true;
		default:
			return false;
	}
};
var $dillonkearns$elm_markdown$HtmlParser$whiteSpace = $elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$HtmlParser$isWhitespace);
var $dillonkearns$elm_markdown$HtmlParser$attributesStep = function (attrs) {
	var process = F2(
		function (name, value) {
			return $elm$parser$Parser$Advanced$Loop(
				A3(
					$elm$core$Dict$update,
					$elm$core$String$toLower(name),
					$dillonkearns$elm_markdown$HtmlParser$keepOldest(value),
					attrs));
		});
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$keeper,
					$elm$parser$Parser$Advanced$succeed(process),
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						A2(
							$elm$parser$Parser$Advanced$ignorer,
							A2($elm$parser$Parser$Advanced$ignorer, $dillonkearns$elm_markdown$HtmlParser$attributeName, $dillonkearns$elm_markdown$HtmlParser$whiteSpace),
							$dillonkearns$elm_markdown$HtmlParser$symbol('=')),
						$dillonkearns$elm_markdown$HtmlParser$whiteSpace)),
				A2($elm$parser$Parser$Advanced$ignorer, $dillonkearns$elm_markdown$HtmlParser$attributeValue, $dillonkearns$elm_markdown$HtmlParser$whiteSpace)),
				$elm$parser$Parser$Advanced$succeed(
				$elm$parser$Parser$Advanced$Done(attrs))
			]));
};
var $elm$core$Dict$foldl = F3(
	function (func, acc, dict) {
		foldl:
		while (true) {
			if (dict.$ === -2) {
				return acc;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldl, func, acc, left)),
					$temp$dict = right;
				func = $temp$func;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldl;
			}
		}
	});
var $dillonkearns$elm_markdown$HtmlParser$attributes = A2(
	$elm$parser$Parser$Advanced$map,
	A2(
		$elm$core$Dict$foldl,
		F3(
			function (key, value, accum) {
				return A2(
					$elm$core$List$cons,
					{ki: key, pO: value},
					accum);
			}),
		_List_Nil),
	A2($elm$parser$Parser$Advanced$loop, $elm$core$Dict$empty, $dillonkearns$elm_markdown$HtmlParser$attributesStep));
var $elm$parser$Parser$Advanced$chompUntilEndOr = function (str) {
	return function (s) {
		var _v0 = A5(_Parser_findSubString, str, s.d, s.o6, s.i3, s.$8);
		var newOffset = _v0.a;
		var newRow = _v0.b;
		var newCol = _v0.c;
		var adjustedOffset = (newOffset < 0) ? $elm$core$String$length(s.$8) : newOffset;
		return A3(
			$elm$parser$Parser$Advanced$Good,
			_Utils_cmp(s.d, adjustedOffset) < 0,
			0,
			{i3: newCol, i: s.i, o: s.o, d: adjustedOffset, o6: newRow, $8: s.$8});
	};
};
var $dillonkearns$elm_markdown$HtmlParser$cdata = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
		$dillonkearns$elm_markdown$HtmlParser$symbol('<![CDATA[')),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$getChompedString(
			$elm$parser$Parser$Advanced$chompUntilEndOr(']]>')),
		$dillonkearns$elm_markdown$HtmlParser$symbol(']]>')));
var $dillonkearns$elm_markdown$HtmlParser$childrenStep = F2(
	function (options, accum) {
		return A2(
			$elm$parser$Parser$Advanced$map,
			function (f) {
				return f(accum);
			},
			$elm$parser$Parser$Advanced$oneOf(options));
	});
var $dillonkearns$elm_markdown$HtmlParser$fail = function (str) {
	return $elm$parser$Parser$Advanced$problem(
		$elm$parser$Parser$Problem(str));
};
var $dillonkearns$elm_markdown$HtmlParser$closingTag = function (startTagName) {
	var closingTagName = A2(
		$elm$parser$Parser$Advanced$andThen,
		function (endTagName) {
			return _Utils_eq(startTagName, endTagName) ? $elm$parser$Parser$Advanced$succeed(0) : $dillonkearns$elm_markdown$HtmlParser$fail('tag name mismatch: ' + (startTagName + (' and ' + endTagName)));
		},
		$dillonkearns$elm_markdown$HtmlParser$tagName);
	return A2(
		$elm$parser$Parser$Advanced$ignorer,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$dillonkearns$elm_markdown$HtmlParser$symbol('</'),
					$dillonkearns$elm_markdown$HtmlParser$whiteSpace),
				closingTagName),
			$dillonkearns$elm_markdown$HtmlParser$whiteSpace),
		$dillonkearns$elm_markdown$HtmlParser$symbol('>'));
};
var $dillonkearns$elm_markdown$HtmlParser$Comment = function (a) {
	return {$: 2, a: a};
};
var $dillonkearns$elm_markdown$HtmlParser$toToken = function (str) {
	return A2(
		$elm$parser$Parser$Advanced$Token,
		str,
		$elm$parser$Parser$Expecting(str));
};
var $dillonkearns$elm_markdown$HtmlParser$comment = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$HtmlParser$Comment),
		$elm$parser$Parser$Advanced$token(
			$dillonkearns$elm_markdown$HtmlParser$toToken('<!--'))),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$getChompedString(
			$elm$parser$Parser$Advanced$chompUntilEndOr('-->')),
		$elm$parser$Parser$Advanced$token(
			$dillonkearns$elm_markdown$HtmlParser$toToken('-->'))));
var $dillonkearns$elm_markdown$HtmlParser$Declaration = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $dillonkearns$elm_markdown$HtmlParser$expectUppercaseCharacter = $elm$parser$Parser$Expecting('at least 1 uppercase character');
var $dillonkearns$elm_markdown$HtmlParser$allUppercase = $elm$parser$Parser$Advanced$getChompedString(
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		A2($elm$parser$Parser$Advanced$chompIf, $elm$core$Char$isUpper, $dillonkearns$elm_markdown$HtmlParser$expectUppercaseCharacter),
		$elm$parser$Parser$Advanced$chompWhile($elm$core$Char$isUpper)));
var $dillonkearns$elm_markdown$HtmlParser$oneOrMoreWhiteSpace = A2(
	$elm$parser$Parser$Advanced$ignorer,
	A2(
		$elm$parser$Parser$Advanced$chompIf,
		$dillonkearns$elm_markdown$HtmlParser$isWhitespace,
		$elm$parser$Parser$Expecting('at least one whitespace')),
	$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$HtmlParser$isWhitespace));
var $dillonkearns$elm_markdown$HtmlParser$docType = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$HtmlParser$Declaration),
			$dillonkearns$elm_markdown$HtmlParser$symbol('<!')),
		A2($elm$parser$Parser$Advanced$ignorer, $dillonkearns$elm_markdown$HtmlParser$allUppercase, $dillonkearns$elm_markdown$HtmlParser$oneOrMoreWhiteSpace)),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$getChompedString(
			$elm$parser$Parser$Advanced$chompUntilEndOr('>')),
		$dillonkearns$elm_markdown$HtmlParser$symbol('>')));
var $dillonkearns$elm_markdown$HtmlParser$ProcessingInstruction = function (a) {
	return {$: 4, a: a};
};
var $dillonkearns$elm_markdown$HtmlParser$processingInstruction = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$HtmlParser$ProcessingInstruction),
		$dillonkearns$elm_markdown$HtmlParser$symbol('<?')),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$getChompedString(
			$elm$parser$Parser$Advanced$chompUntilEndOr('?>')),
		$dillonkearns$elm_markdown$HtmlParser$symbol('?>')));
var $dillonkearns$elm_markdown$HtmlParser$isNotTextNodeIgnoreChar = function (c) {
	switch (c) {
		case '<':
			return false;
		case '&':
			return false;
		default:
			return true;
	}
};
var $dillonkearns$elm_markdown$HtmlParser$textNodeStringStepOptions = _List_fromArray(
	[
		A2(
		$elm$parser$Parser$Advanced$map,
		function (_v0) {
			return $elm$parser$Parser$Advanced$Loop(0);
		},
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$chompIf,
				$dillonkearns$elm_markdown$HtmlParser$isNotTextNodeIgnoreChar,
				$elm$parser$Parser$Expecting('is not & or <')),
			$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$HtmlParser$isNotTextNodeIgnoreChar))),
		A2(
		$elm$parser$Parser$Advanced$map,
		function (_v1) {
			return $elm$parser$Parser$Advanced$Loop(0);
		},
		$dillonkearns$elm_markdown$HtmlParser$escapedChar('<')),
		$elm$parser$Parser$Advanced$succeed(
		$elm$parser$Parser$Advanced$Done(0))
	]);
var $dillonkearns$elm_markdown$HtmlParser$textNodeStringStep = function (_v0) {
	return $elm$parser$Parser$Advanced$oneOf($dillonkearns$elm_markdown$HtmlParser$textNodeStringStepOptions);
};
var $dillonkearns$elm_markdown$HtmlParser$textNodeString = $elm$parser$Parser$Advanced$getChompedString(
	A2($elm$parser$Parser$Advanced$loop, 0, $dillonkearns$elm_markdown$HtmlParser$textNodeStringStep));
var $dillonkearns$elm_markdown$HtmlParser$children = function (startTagName) {
	return A2(
		$elm$parser$Parser$Advanced$loop,
		_List_Nil,
		$dillonkearns$elm_markdown$HtmlParser$childrenStep(
			$dillonkearns$elm_markdown$HtmlParser$childrenStepOptions(startTagName)));
};
var $dillonkearns$elm_markdown$HtmlParser$childrenStepOptions = function (startTagName) {
	return _List_fromArray(
		[
			A2(
			$elm$parser$Parser$Advanced$map,
			F2(
				function (_v1, accum) {
					return $elm$parser$Parser$Advanced$Done(
						$elm$core$List$reverse(accum));
				}),
			$dillonkearns$elm_markdown$HtmlParser$closingTag(startTagName)),
			A2(
			$elm$parser$Parser$Advanced$andThen,
			function (text) {
				return $elm$core$String$isEmpty(text) ? A2(
					$elm$parser$Parser$Advanced$map,
					F2(
						function (_v2, accum) {
							return $elm$parser$Parser$Advanced$Done(
								$elm$core$List$reverse(accum));
						}),
					$dillonkearns$elm_markdown$HtmlParser$closingTag(startTagName)) : $elm$parser$Parser$Advanced$succeed(
					function (accum) {
						return $elm$parser$Parser$Advanced$Loop(
							A2(
								$elm$core$List$cons,
								$dillonkearns$elm_markdown$HtmlParser$Text(text),
								accum));
					});
			},
			$dillonkearns$elm_markdown$HtmlParser$textNodeString),
			A2(
			$elm$parser$Parser$Advanced$map,
			F2(
				function (_new, accum) {
					return $elm$parser$Parser$Advanced$Loop(
						A2($elm$core$List$cons, _new, accum));
				}),
			$dillonkearns$elm_markdown$HtmlParser$cyclic$html())
		]);
};
var $dillonkearns$elm_markdown$HtmlParser$elementContinuation = function (startTagName) {
	return A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed(
					$dillonkearns$elm_markdown$HtmlParser$Element(startTagName)),
				$dillonkearns$elm_markdown$HtmlParser$whiteSpace),
			A2($elm$parser$Parser$Advanced$ignorer, $dillonkearns$elm_markdown$HtmlParser$attributes, $dillonkearns$elm_markdown$HtmlParser$whiteSpace)),
		$elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$Advanced$map,
					function (_v0) {
						return _List_Nil;
					},
					$dillonkearns$elm_markdown$HtmlParser$symbol('/>')),
					A2(
					$elm$parser$Parser$Advanced$keeper,
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
						$dillonkearns$elm_markdown$HtmlParser$symbol('>')),
					$dillonkearns$elm_markdown$HtmlParser$children(startTagName))
				])));
};
function $dillonkearns$elm_markdown$HtmlParser$cyclic$html() {
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2($elm$parser$Parser$Advanced$map, $dillonkearns$elm_markdown$HtmlParser$Cdata, $dillonkearns$elm_markdown$HtmlParser$cdata),
				$dillonkearns$elm_markdown$HtmlParser$processingInstruction,
				$dillonkearns$elm_markdown$HtmlParser$comment,
				$dillonkearns$elm_markdown$HtmlParser$docType,
				$dillonkearns$elm_markdown$HtmlParser$cyclic$element()
			]));
}
function $dillonkearns$elm_markdown$HtmlParser$cyclic$element() {
	return A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
			$dillonkearns$elm_markdown$HtmlParser$symbol('<')),
		A2($elm$parser$Parser$Advanced$andThen, $dillonkearns$elm_markdown$HtmlParser$elementContinuation, $dillonkearns$elm_markdown$HtmlParser$tagName));
}
var $dillonkearns$elm_markdown$HtmlParser$html = $dillonkearns$elm_markdown$HtmlParser$cyclic$html();
$dillonkearns$elm_markdown$HtmlParser$cyclic$html = function () {
	return $dillonkearns$elm_markdown$HtmlParser$html;
};
var $dillonkearns$elm_markdown$HtmlParser$element = $dillonkearns$elm_markdown$HtmlParser$cyclic$element();
$dillonkearns$elm_markdown$HtmlParser$cyclic$element = function () {
	return $dillonkearns$elm_markdown$HtmlParser$element;
};
var $dillonkearns$elm_markdown$Parser$Token$tab = A2(
	$elm$parser$Parser$Advanced$Token,
	'\t',
	$elm$parser$Parser$Expecting('a tab'));
var $dillonkearns$elm_markdown$Markdown$Parser$exactlyFourSpaces = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$tab),
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$backtrackable(
				$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$space)),
			$elm$parser$Parser$Advanced$oneOf(
				_List_fromArray(
					[
						$elm$parser$Parser$Advanced$symbol(
						A2(
							$elm$parser$Parser$Advanced$Token,
							'   ',
							$elm$parser$Parser$ExpectingSymbol('Indentation'))),
						$elm$parser$Parser$Advanced$symbol(
						A2(
							$elm$parser$Parser$Advanced$Token,
							' \t',
							$elm$parser$Parser$ExpectingSymbol('Indentation'))),
						$elm$parser$Parser$Advanced$symbol(
						A2(
							$elm$parser$Parser$Advanced$Token,
							'  \t',
							$elm$parser$Parser$ExpectingSymbol('Indentation')))
					])))
		]));
var $dillonkearns$elm_markdown$Markdown$Parser$indentedCodeBlock = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$RawBlock$IndentedCodeBlock),
		$dillonkearns$elm_markdown$Markdown$Parser$exactlyFourSpaces),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$getChompedString($dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd),
		$dillonkearns$elm_markdown$Helpers$lineEndOrEnd));
var $elm$core$Basics$modBy = _Basics_modBy;
var $dillonkearns$elm_markdown$Markdown$Helpers$isEven = function (_int) {
	return !A2($elm$core$Basics$modBy, 2, _int);
};
var $dillonkearns$elm_markdown$Markdown$Block$Loose = 0;
var $dillonkearns$elm_markdown$Markdown$Block$Tight = 1;
var $dillonkearns$elm_markdown$Markdown$Parser$isTightBoolToListDisplay = function (isTight) {
	return isTight ? 1 : 0;
};
var $dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith = F3(
	function (joinWith, string1, string2) {
		var _v0 = _Utils_Tuple2(string1, string2);
		if (_v0.a === '') {
			return string2;
		} else {
			if (_v0.b === '') {
				return string1;
			} else {
				return _Utils_ap(
					string1,
					_Utils_ap(joinWith, string2));
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$Parser$joinStringsPreserveAll = F2(
	function (string1, string2) {
		return string1 + ('\n' + string2);
	});
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $elm$core$List$member = F2(
	function (x, xs) {
		return A2(
			$elm$core$List$any,
			function (a) {
				return _Utils_eq(a, x);
			},
			xs);
	});
var $dillonkearns$elm_markdown$Markdown$Parser$innerParagraphParser = A2(
	$elm$parser$Parser$Advanced$mapChompedString,
	F2(
		function (rawLine, _v0) {
			return $dillonkearns$elm_markdown$Markdown$RawBlock$OpenBlockOrParagraph(rawLine);
		}),
	$dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd);
var $dillonkearns$elm_markdown$Markdown$Parser$openBlockOrParagraphParser = A2($elm$parser$Parser$Advanced$ignorer, $dillonkearns$elm_markdown$Markdown$Parser$innerParagraphParser, $dillonkearns$elm_markdown$Helpers$lineEndOrEnd);
var $dillonkearns$elm_markdown$Markdown$OrderedList$ListItem = F4(
	function (order, intended, marker, body) {
		return {fv: body, nq: intended, nP: marker, ou: order};
	});
var $elm$parser$Parser$Advanced$getCol = function (s) {
	return A3($elm$parser$Parser$Advanced$Good, false, s.i3, s);
};
var $dillonkearns$elm_markdown$Markdown$OrderedList$orderedListEmptyItemParser = A2(
	$elm$parser$Parser$Advanced$keeper,
	$elm$parser$Parser$Advanced$succeed(
		function (bodyStartPos) {
			return _Utils_Tuple2(bodyStartPos, '');
		}),
	A2($elm$parser$Parser$Advanced$ignorer, $elm$parser$Parser$Advanced$getCol, $dillonkearns$elm_markdown$Helpers$lineEndOrEnd));
var $dillonkearns$elm_markdown$Parser$Extra$chompOneOrMore = function (condition) {
	return A2(
		$elm$parser$Parser$Advanced$ignorer,
		A2(
			$elm$parser$Parser$Advanced$chompIf,
			condition,
			$elm$parser$Parser$Problem('Expected one or more character')),
		$elm$parser$Parser$Advanced$chompWhile(condition));
};
var $dillonkearns$elm_markdown$Markdown$OrderedList$orderedListItemBodyParser = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed(
				F2(
					function (bodyStartPos, item) {
						return _Utils_Tuple2(bodyStartPos, item);
					})),
			$dillonkearns$elm_markdown$Parser$Extra$chompOneOrMore($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab)),
		$elm$parser$Parser$Advanced$getCol),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$getChompedString($dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd),
		$dillonkearns$elm_markdown$Helpers$lineEndOrEnd));
var $dillonkearns$elm_markdown$Markdown$OrderedList$Dot = 0;
var $dillonkearns$elm_markdown$Markdown$OrderedList$Paren = 1;
var $dillonkearns$elm_markdown$Parser$Token$closingParen = A2(
	$elm$parser$Parser$Advanced$Token,
	')',
	$elm$parser$Parser$Expecting('a `)`'));
var $dillonkearns$elm_markdown$Parser$Token$dot = A2(
	$elm$parser$Parser$Advanced$Token,
	'.',
	$elm$parser$Parser$Expecting('a `.`'));
var $dillonkearns$elm_markdown$Markdown$OrderedList$orderedListMarkerParser = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed(0),
			$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$dot)),
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed(1),
			$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$closingParen))
		]));
var $dillonkearns$elm_markdown$Parser$Extra$positiveInteger = A2(
	$elm$parser$Parser$Advanced$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	$dillonkearns$elm_markdown$Parser$Extra$chompOneOrMore($elm$core$Char$isDigit));
var $dillonkearns$elm_markdown$Markdown$OrderedList$positiveIntegerMaxOf9Digits = A2(
	$elm$parser$Parser$Advanced$andThen,
	function (parsed) {
		return (parsed <= 999999999) ? $elm$parser$Parser$Advanced$succeed(parsed) : $elm$parser$Parser$Advanced$problem(
			$elm$parser$Parser$Problem('Starting numbers must be nine digits or less.'));
	},
	$dillonkearns$elm_markdown$Parser$Extra$positiveInteger);
var $dillonkearns$elm_markdown$Whitespace$space = $elm$parser$Parser$Advanced$token($dillonkearns$elm_markdown$Parser$Token$space);
var $elm$core$List$repeatHelp = F3(
	function (result, n, value) {
		repeatHelp:
		while (true) {
			if (n <= 0) {
				return result;
			} else {
				var $temp$result = A2($elm$core$List$cons, value, result),
					$temp$n = n - 1,
					$temp$value = value;
				result = $temp$result;
				n = $temp$n;
				value = $temp$value;
				continue repeatHelp;
			}
		}
	});
var $elm$core$List$repeat = F2(
	function (n, value) {
		return A3($elm$core$List$repeatHelp, _List_Nil, n, value);
	});
var $dillonkearns$elm_markdown$Parser$Extra$upTo = F2(
	function (n, parser) {
		var _v0 = A2($elm$core$List$repeat, n, parser);
		if (!_v0.b) {
			return $elm$parser$Parser$Advanced$succeed(0);
		} else {
			var firstParser = _v0.a;
			var remainingParsers = _v0.b;
			return A3(
				$elm$core$List$foldl,
				F2(
					function (p, parsers) {
						return $elm$parser$Parser$Advanced$oneOf(
							_List_fromArray(
								[
									A2($elm$parser$Parser$Advanced$ignorer, p, parsers),
									$elm$parser$Parser$Advanced$succeed(0)
								]));
					}),
				$elm$parser$Parser$Advanced$oneOf(
					_List_fromArray(
						[
							firstParser,
							$elm$parser$Parser$Advanced$succeed(0)
						])),
				remainingParsers);
		}
	});
var $dillonkearns$elm_markdown$Markdown$OrderedList$validateStartsWith1 = function (parsed) {
	if (parsed === 1) {
		return $elm$parser$Parser$Advanced$succeed(parsed);
	} else {
		return $elm$parser$Parser$Advanced$problem(
			$elm$parser$Parser$Problem('Lists inside a paragraph or after a paragraph without a blank line must start with 1'));
	}
};
var $dillonkearns$elm_markdown$Markdown$OrderedList$orderedListOrderParser = function (previousWasBody) {
	return previousWasBody ? A2(
		$elm$parser$Parser$Advanced$andThen,
		$dillonkearns$elm_markdown$Markdown$OrderedList$validateStartsWith1,
		A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
				A2($dillonkearns$elm_markdown$Parser$Extra$upTo, 3, $dillonkearns$elm_markdown$Whitespace$space)),
			$dillonkearns$elm_markdown$Markdown$OrderedList$positiveIntegerMaxOf9Digits)) : A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
			A2($dillonkearns$elm_markdown$Parser$Extra$upTo, 3, $dillonkearns$elm_markdown$Whitespace$space)),
		$dillonkearns$elm_markdown$Markdown$OrderedList$positiveIntegerMaxOf9Digits);
};
var $dillonkearns$elm_markdown$Markdown$OrderedList$parser = function (previousWasBody) {
	var parseSubsequentItem = F5(
		function (start, order, marker, mid, _v0) {
			var end = _v0.a;
			var body = _v0.b;
			return ((end - mid) <= 4) ? A4($dillonkearns$elm_markdown$Markdown$OrderedList$ListItem, order, end - start, marker, body) : A4(
				$dillonkearns$elm_markdown$Markdown$OrderedList$ListItem,
				order,
				(mid - start) + 1,
				marker,
				_Utils_ap(
					A2($elm$core$String$repeat, (end - mid) - 1, ' '),
					body));
		});
	return A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$keeper,
					A2(
						$elm$parser$Parser$Advanced$keeper,
						$elm$parser$Parser$Advanced$succeed(parseSubsequentItem),
						$elm$parser$Parser$Advanced$getCol),
					$elm$parser$Parser$Advanced$backtrackable(
						$dillonkearns$elm_markdown$Markdown$OrderedList$orderedListOrderParser(previousWasBody))),
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$OrderedList$orderedListMarkerParser)),
			$elm$parser$Parser$Advanced$getCol),
		previousWasBody ? $dillonkearns$elm_markdown$Markdown$OrderedList$orderedListItemBodyParser : $elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[$dillonkearns$elm_markdown$Markdown$OrderedList$orderedListEmptyItemParser, $dillonkearns$elm_markdown$Markdown$OrderedList$orderedListItemBodyParser])));
};
var $dillonkearns$elm_markdown$Markdown$Parser$orderedListBlock = function (previousWasBody) {
	return A2(
		$elm$parser$Parser$Advanced$map,
		function (item) {
			return A6($dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock, true, item.nq, item.nP, item.ou, _List_Nil, item.fv);
		},
		$dillonkearns$elm_markdown$Markdown$OrderedList$parser(previousWasBody));
};
var $dillonkearns$elm_markdown$Markdown$Inline$CodeInline = function (a) {
	return {$: 2, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Inline$HardLineBreak = {$: 1};
var $dillonkearns$elm_markdown$Markdown$Inline$HtmlInline = function (a) {
	return {$: 5, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Inline$Image = F3(
	function (a, b, c) {
		return {$: 4, a: a, b: b, c: c};
	});
var $dillonkearns$elm_markdown$Markdown$Inline$Link = F3(
	function (a, b, c) {
		return {$: 3, a: a, b: b, c: c};
	});
var $dillonkearns$elm_markdown$Markdown$Inline$Strikethrough = function (a) {
	return {$: 7, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Inline$Text = function (a) {
	return {$: 0, a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$matchToInline = function (_v0) {
	var match = _v0;
	var _v1 = match.d0;
	switch (_v1.$) {
		case 0:
			return $dillonkearns$elm_markdown$Markdown$Inline$Text(match.r);
		case 1:
			return $dillonkearns$elm_markdown$Markdown$Inline$HardLineBreak;
		case 2:
			return $dillonkearns$elm_markdown$Markdown$Inline$CodeInline(match.r);
		case 3:
			var _v2 = _v1.a;
			var text = _v2.a;
			var url = _v2.b;
			return A3(
				$dillonkearns$elm_markdown$Markdown$Inline$Link,
				url,
				$elm$core$Maybe$Nothing,
				_List_fromArray(
					[
						$dillonkearns$elm_markdown$Markdown$Inline$Text(text)
					]));
		case 4:
			var _v3 = _v1.a;
			var url = _v3.a;
			var maybeTitle = _v3.b;
			return A3(
				$dillonkearns$elm_markdown$Markdown$Inline$Link,
				url,
				maybeTitle,
				$dillonkearns$elm_markdown$Markdown$InlineParser$matchesToInlines(match.M));
		case 5:
			var _v4 = _v1.a;
			var url = _v4.a;
			var maybeTitle = _v4.b;
			return A3(
				$dillonkearns$elm_markdown$Markdown$Inline$Image,
				url,
				maybeTitle,
				$dillonkearns$elm_markdown$Markdown$InlineParser$matchesToInlines(match.M));
		case 6:
			var model = _v1.a;
			return $dillonkearns$elm_markdown$Markdown$Inline$HtmlInline(model);
		case 7:
			var length = _v1.a;
			return A2(
				$dillonkearns$elm_markdown$Markdown$Inline$Emphasis,
				length,
				$dillonkearns$elm_markdown$Markdown$InlineParser$matchesToInlines(match.M));
		default:
			return $dillonkearns$elm_markdown$Markdown$Inline$Strikethrough(
				$dillonkearns$elm_markdown$Markdown$InlineParser$matchesToInlines(match.M));
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$matchesToInlines = function (matches) {
	return A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$InlineParser$matchToInline, matches);
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$Match = $elm$core$Basics$identity;
var $dillonkearns$elm_markdown$Markdown$InlineParser$prepareChildMatch = F2(
	function (parentMatch, childMatch) {
		return {k: childMatch.k - parentMatch.O, M: childMatch.M, p: childMatch.p - parentMatch.O, r: childMatch.r, al: childMatch.al - parentMatch.O, O: childMatch.O - parentMatch.O, d0: childMatch.d0};
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$addChild = F2(
	function (parentMatch, childMatch) {
		return {
			k: parentMatch.k,
			M: A2(
				$elm$core$List$cons,
				A2($dillonkearns$elm_markdown$Markdown$InlineParser$prepareChildMatch, parentMatch, childMatch),
				parentMatch.M),
			p: parentMatch.p,
			r: parentMatch.r,
			al: parentMatch.al,
			O: parentMatch.O,
			d0: parentMatch.d0
		};
	});
var $elm$core$List$sortBy = _List_sortBy;
var $dillonkearns$elm_markdown$Markdown$InlineParser$organizeChildren = function (_v4) {
	var match = _v4;
	return {
		k: match.k,
		M: $dillonkearns$elm_markdown$Markdown$InlineParser$organizeMatches(match.M),
		p: match.p,
		r: match.r,
		al: match.al,
		O: match.O,
		d0: match.d0
	};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$organizeMatches = function (matches) {
	var _v2 = A2(
		$elm$core$List$sortBy,
		function (_v3) {
			var match = _v3;
			return match.p;
		},
		matches);
	if (!_v2.b) {
		return _List_Nil;
	} else {
		var first = _v2.a;
		var rest = _v2.b;
		return A3($dillonkearns$elm_markdown$Markdown$InlineParser$organizeMatchesHelp, rest, first, _List_Nil);
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$organizeMatchesHelp = F3(
	function (remaining, _v0, matchesTail) {
		organizeMatchesHelp:
		while (true) {
			var prevMatch = _v0;
			if (!remaining.b) {
				return A2(
					$elm$core$List$cons,
					$dillonkearns$elm_markdown$Markdown$InlineParser$organizeChildren(prevMatch),
					matchesTail);
			} else {
				var match = remaining.a;
				var rest = remaining.b;
				if (_Utils_cmp(prevMatch.k, match.p) < 1) {
					var $temp$remaining = rest,
						$temp$_v0 = match,
						$temp$matchesTail = A2(
						$elm$core$List$cons,
						$dillonkearns$elm_markdown$Markdown$InlineParser$organizeChildren(prevMatch),
						matchesTail);
					remaining = $temp$remaining;
					_v0 = $temp$_v0;
					matchesTail = $temp$matchesTail;
					continue organizeMatchesHelp;
				} else {
					if ((_Utils_cmp(prevMatch.p, match.p) < 0) && (_Utils_cmp(prevMatch.k, match.k) > 0)) {
						var $temp$remaining = rest,
							$temp$_v0 = A2($dillonkearns$elm_markdown$Markdown$InlineParser$addChild, prevMatch, match),
							$temp$matchesTail = matchesTail;
						remaining = $temp$remaining;
						_v0 = $temp$_v0;
						matchesTail = $temp$matchesTail;
						continue organizeMatchesHelp;
					} else {
						var $temp$remaining = rest,
							$temp$_v0 = prevMatch,
							$temp$matchesTail = matchesTail;
						remaining = $temp$remaining;
						_v0 = $temp$_v0;
						matchesTail = $temp$matchesTail;
						continue organizeMatchesHelp;
					}
				}
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$NormalType = {$: 0};
var $dillonkearns$elm_markdown$Markdown$Helpers$containsAmpersand = function (string) {
	return A2($elm$core$String$contains, '&', string);
};
var $dillonkearns$elm_markdown$Markdown$Entity$decimalRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('&#([0-9]{1,8});'));
var $dillonkearns$elm_markdown$Markdown$Entity$isBadEndUnicode = function (_int) {
	var remain_ = A2($elm$core$Basics$modBy, 16, _int);
	var remain = A2($elm$core$Basics$modBy, 131070, _int);
	return (_int >= 131070) && ((((0 <= remain) && (remain <= 15)) || ((65536 <= remain) && (remain <= 65551))) && ((remain_ === 14) || (remain_ === 15)));
};
var $dillonkearns$elm_markdown$Markdown$Entity$isValidUnicode = function (_int) {
	return (_int === 9) || ((_int === 10) || ((_int === 13) || ((_int === 133) || (((32 <= _int) && (_int <= 126)) || (((160 <= _int) && (_int <= 55295)) || (((57344 <= _int) && (_int <= 64975)) || (((65008 <= _int) && (_int <= 65533)) || ((65536 <= _int) && (_int <= 1114109)))))))));
};
var $dillonkearns$elm_markdown$Markdown$Entity$validUnicode = function (_int) {
	return ($dillonkearns$elm_markdown$Markdown$Entity$isValidUnicode(_int) && (!$dillonkearns$elm_markdown$Markdown$Entity$isBadEndUnicode(_int))) ? $elm$core$String$fromChar(
		$elm$core$Char$fromCode(_int)) : $elm$core$String$fromChar(
		$elm$core$Char$fromCode(65533));
};
var $dillonkearns$elm_markdown$Markdown$Entity$replaceDecimal = function (match) {
	var _v0 = match.ij;
	if (_v0.b && (!_v0.a.$)) {
		var first = _v0.a.a;
		var _v1 = $elm$core$String$toInt(first);
		if (!_v1.$) {
			var v = _v1.a;
			return $dillonkearns$elm_markdown$Markdown$Entity$validUnicode(v);
		} else {
			return match.eK;
		}
	} else {
		return match.eK;
	}
};
var $dillonkearns$elm_markdown$Markdown$Entity$replaceDecimals = A2($elm$regex$Regex$replace, $dillonkearns$elm_markdown$Markdown$Entity$decimalRegex, $dillonkearns$elm_markdown$Markdown$Entity$replaceDecimal);
var $dillonkearns$elm_markdown$Markdown$Entity$entitiesRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('&([0-9a-zA-Z]+);'));
var $dillonkearns$elm_markdown$Markdown$Entity$entities = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('quot', 34),
			_Utils_Tuple2('amp', 38),
			_Utils_Tuple2('apos', 39),
			_Utils_Tuple2('lt', 60),
			_Utils_Tuple2('gt', 62),
			_Utils_Tuple2('nbsp', 160),
			_Utils_Tuple2('iexcl', 161),
			_Utils_Tuple2('cent', 162),
			_Utils_Tuple2('pound', 163),
			_Utils_Tuple2('curren', 164),
			_Utils_Tuple2('yen', 165),
			_Utils_Tuple2('brvbar', 166),
			_Utils_Tuple2('sect', 167),
			_Utils_Tuple2('uml', 168),
			_Utils_Tuple2('copy', 169),
			_Utils_Tuple2('ordf', 170),
			_Utils_Tuple2('laquo', 171),
			_Utils_Tuple2('not', 172),
			_Utils_Tuple2('shy', 173),
			_Utils_Tuple2('reg', 174),
			_Utils_Tuple2('macr', 175),
			_Utils_Tuple2('deg', 176),
			_Utils_Tuple2('plusmn', 177),
			_Utils_Tuple2('sup2', 178),
			_Utils_Tuple2('sup3', 179),
			_Utils_Tuple2('acute', 180),
			_Utils_Tuple2('micro', 181),
			_Utils_Tuple2('para', 182),
			_Utils_Tuple2('middot', 183),
			_Utils_Tuple2('cedil', 184),
			_Utils_Tuple2('sup1', 185),
			_Utils_Tuple2('ordm', 186),
			_Utils_Tuple2('raquo', 187),
			_Utils_Tuple2('frac14', 188),
			_Utils_Tuple2('frac12', 189),
			_Utils_Tuple2('frac34', 190),
			_Utils_Tuple2('iquest', 191),
			_Utils_Tuple2('Agrave', 192),
			_Utils_Tuple2('Aacute', 193),
			_Utils_Tuple2('Acirc', 194),
			_Utils_Tuple2('Atilde', 195),
			_Utils_Tuple2('Auml', 196),
			_Utils_Tuple2('Aring', 197),
			_Utils_Tuple2('AElig', 198),
			_Utils_Tuple2('Ccedil', 199),
			_Utils_Tuple2('Egrave', 200),
			_Utils_Tuple2('Eacute', 201),
			_Utils_Tuple2('Ecirc', 202),
			_Utils_Tuple2('Euml', 203),
			_Utils_Tuple2('Igrave', 204),
			_Utils_Tuple2('Iacute', 205),
			_Utils_Tuple2('Icirc', 206),
			_Utils_Tuple2('Iuml', 207),
			_Utils_Tuple2('ETH', 208),
			_Utils_Tuple2('Ntilde', 209),
			_Utils_Tuple2('Ograve', 210),
			_Utils_Tuple2('Oacute', 211),
			_Utils_Tuple2('Ocirc', 212),
			_Utils_Tuple2('Otilde', 213),
			_Utils_Tuple2('Ouml', 214),
			_Utils_Tuple2('times', 215),
			_Utils_Tuple2('Oslash', 216),
			_Utils_Tuple2('Ugrave', 217),
			_Utils_Tuple2('Uacute', 218),
			_Utils_Tuple2('Ucirc', 219),
			_Utils_Tuple2('Uuml', 220),
			_Utils_Tuple2('Yacute', 221),
			_Utils_Tuple2('THORN', 222),
			_Utils_Tuple2('szlig', 223),
			_Utils_Tuple2('agrave', 224),
			_Utils_Tuple2('aacute', 225),
			_Utils_Tuple2('acirc', 226),
			_Utils_Tuple2('atilde', 227),
			_Utils_Tuple2('auml', 228),
			_Utils_Tuple2('aring', 229),
			_Utils_Tuple2('aelig', 230),
			_Utils_Tuple2('ccedil', 231),
			_Utils_Tuple2('egrave', 232),
			_Utils_Tuple2('eacute', 233),
			_Utils_Tuple2('ecirc', 234),
			_Utils_Tuple2('euml', 235),
			_Utils_Tuple2('igrave', 236),
			_Utils_Tuple2('iacute', 237),
			_Utils_Tuple2('icirc', 238),
			_Utils_Tuple2('iuml', 239),
			_Utils_Tuple2('eth', 240),
			_Utils_Tuple2('ntilde', 241),
			_Utils_Tuple2('ograve', 242),
			_Utils_Tuple2('oacute', 243),
			_Utils_Tuple2('ocirc', 244),
			_Utils_Tuple2('otilde', 245),
			_Utils_Tuple2('ouml', 246),
			_Utils_Tuple2('divide', 247),
			_Utils_Tuple2('oslash', 248),
			_Utils_Tuple2('ugrave', 249),
			_Utils_Tuple2('uacute', 250),
			_Utils_Tuple2('ucirc', 251),
			_Utils_Tuple2('uuml', 252),
			_Utils_Tuple2('yacute', 253),
			_Utils_Tuple2('thorn', 254),
			_Utils_Tuple2('yuml', 255),
			_Utils_Tuple2('OElig', 338),
			_Utils_Tuple2('oelig', 339),
			_Utils_Tuple2('Scaron', 352),
			_Utils_Tuple2('scaron', 353),
			_Utils_Tuple2('Yuml', 376),
			_Utils_Tuple2('fnof', 402),
			_Utils_Tuple2('circ', 710),
			_Utils_Tuple2('tilde', 732),
			_Utils_Tuple2('Alpha', 913),
			_Utils_Tuple2('Beta', 914),
			_Utils_Tuple2('Gamma', 915),
			_Utils_Tuple2('Delta', 916),
			_Utils_Tuple2('Epsilon', 917),
			_Utils_Tuple2('Zeta', 918),
			_Utils_Tuple2('Eta', 919),
			_Utils_Tuple2('Theta', 920),
			_Utils_Tuple2('Iota', 921),
			_Utils_Tuple2('Kappa', 922),
			_Utils_Tuple2('Lambda', 923),
			_Utils_Tuple2('Mu', 924),
			_Utils_Tuple2('Nu', 925),
			_Utils_Tuple2('Xi', 926),
			_Utils_Tuple2('Omicron', 927),
			_Utils_Tuple2('Pi', 928),
			_Utils_Tuple2('Rho', 929),
			_Utils_Tuple2('Sigma', 931),
			_Utils_Tuple2('Tau', 932),
			_Utils_Tuple2('Upsilon', 933),
			_Utils_Tuple2('Phi', 934),
			_Utils_Tuple2('Chi', 935),
			_Utils_Tuple2('Psi', 936),
			_Utils_Tuple2('Omega', 937),
			_Utils_Tuple2('alpha', 945),
			_Utils_Tuple2('beta', 946),
			_Utils_Tuple2('gamma', 947),
			_Utils_Tuple2('delta', 948),
			_Utils_Tuple2('epsilon', 949),
			_Utils_Tuple2('zeta', 950),
			_Utils_Tuple2('eta', 951),
			_Utils_Tuple2('theta', 952),
			_Utils_Tuple2('iota', 953),
			_Utils_Tuple2('kappa', 954),
			_Utils_Tuple2('lambda', 955),
			_Utils_Tuple2('mu', 956),
			_Utils_Tuple2('nu', 957),
			_Utils_Tuple2('xi', 958),
			_Utils_Tuple2('omicron', 959),
			_Utils_Tuple2('pi', 960),
			_Utils_Tuple2('rho', 961),
			_Utils_Tuple2('sigmaf', 962),
			_Utils_Tuple2('sigma', 963),
			_Utils_Tuple2('tau', 964),
			_Utils_Tuple2('upsilon', 965),
			_Utils_Tuple2('phi', 966),
			_Utils_Tuple2('chi', 967),
			_Utils_Tuple2('psi', 968),
			_Utils_Tuple2('omega', 969),
			_Utils_Tuple2('thetasym', 977),
			_Utils_Tuple2('upsih', 978),
			_Utils_Tuple2('piv', 982),
			_Utils_Tuple2('ensp', 8194),
			_Utils_Tuple2('emsp', 8195),
			_Utils_Tuple2('thinsp', 8201),
			_Utils_Tuple2('zwnj', 8204),
			_Utils_Tuple2('zwj', 8205),
			_Utils_Tuple2('lrm', 8206),
			_Utils_Tuple2('rlm', 8207),
			_Utils_Tuple2('ndash', 8211),
			_Utils_Tuple2('mdash', 8212),
			_Utils_Tuple2('lsquo', 8216),
			_Utils_Tuple2('rsquo', 8217),
			_Utils_Tuple2('sbquo', 8218),
			_Utils_Tuple2('ldquo', 8220),
			_Utils_Tuple2('rdquo', 8221),
			_Utils_Tuple2('bdquo', 8222),
			_Utils_Tuple2('dagger', 8224),
			_Utils_Tuple2('Dagger', 8225),
			_Utils_Tuple2('bull', 8226),
			_Utils_Tuple2('hellip', 8230),
			_Utils_Tuple2('permil', 8240),
			_Utils_Tuple2('prime', 8242),
			_Utils_Tuple2('Prime', 8243),
			_Utils_Tuple2('lsaquo', 8249),
			_Utils_Tuple2('rsaquo', 8250),
			_Utils_Tuple2('oline', 8254),
			_Utils_Tuple2('frasl', 8260),
			_Utils_Tuple2('euro', 8364),
			_Utils_Tuple2('image', 8465),
			_Utils_Tuple2('weierp', 8472),
			_Utils_Tuple2('real', 8476),
			_Utils_Tuple2('trade', 8482),
			_Utils_Tuple2('alefsym', 8501),
			_Utils_Tuple2('larr', 8592),
			_Utils_Tuple2('uarr', 8593),
			_Utils_Tuple2('rarr', 8594),
			_Utils_Tuple2('darr', 8595),
			_Utils_Tuple2('harr', 8596),
			_Utils_Tuple2('crarr', 8629),
			_Utils_Tuple2('lArr', 8656),
			_Utils_Tuple2('uArr', 8657),
			_Utils_Tuple2('rArr', 8658),
			_Utils_Tuple2('dArr', 8659),
			_Utils_Tuple2('hArr', 8660),
			_Utils_Tuple2('forall', 8704),
			_Utils_Tuple2('part', 8706),
			_Utils_Tuple2('exist', 8707),
			_Utils_Tuple2('empty', 8709),
			_Utils_Tuple2('nabla', 8711),
			_Utils_Tuple2('isin', 8712),
			_Utils_Tuple2('notin', 8713),
			_Utils_Tuple2('ni', 8715),
			_Utils_Tuple2('prod', 8719),
			_Utils_Tuple2('sum', 8721),
			_Utils_Tuple2('minus', 8722),
			_Utils_Tuple2('lowast', 8727),
			_Utils_Tuple2('radic', 8730),
			_Utils_Tuple2('prop', 8733),
			_Utils_Tuple2('infin', 8734),
			_Utils_Tuple2('ang', 8736),
			_Utils_Tuple2('and', 8743),
			_Utils_Tuple2('or', 8744),
			_Utils_Tuple2('cap', 8745),
			_Utils_Tuple2('cup', 8746),
			_Utils_Tuple2('int', 8747),
			_Utils_Tuple2('there4', 8756),
			_Utils_Tuple2('sim', 8764),
			_Utils_Tuple2('cong', 8773),
			_Utils_Tuple2('asymp', 8776),
			_Utils_Tuple2('ne', 8800),
			_Utils_Tuple2('equiv', 8801),
			_Utils_Tuple2('le', 8804),
			_Utils_Tuple2('ge', 8805),
			_Utils_Tuple2('sub', 8834),
			_Utils_Tuple2('sup', 8835),
			_Utils_Tuple2('nsub', 8836),
			_Utils_Tuple2('sube', 8838),
			_Utils_Tuple2('supe', 8839),
			_Utils_Tuple2('oplus', 8853),
			_Utils_Tuple2('otimes', 8855),
			_Utils_Tuple2('perp', 8869),
			_Utils_Tuple2('sdot', 8901),
			_Utils_Tuple2('lceil', 8968),
			_Utils_Tuple2('rceil', 8969),
			_Utils_Tuple2('lfloor', 8970),
			_Utils_Tuple2('rfloor', 8971),
			_Utils_Tuple2('lang', 9001),
			_Utils_Tuple2('rang', 9002),
			_Utils_Tuple2('loz', 9674),
			_Utils_Tuple2('spades', 9824),
			_Utils_Tuple2('clubs', 9827),
			_Utils_Tuple2('hearts', 9829),
			_Utils_Tuple2('diams', 9830)
		]));
var $dillonkearns$elm_markdown$Markdown$Entity$replaceEntity = function (match) {
	var _v0 = match.ij;
	if (_v0.b && (!_v0.a.$)) {
		var first = _v0.a.a;
		var _v1 = A2($elm$core$Dict$get, first, $dillonkearns$elm_markdown$Markdown$Entity$entities);
		if (!_v1.$) {
			var code = _v1.a;
			return $elm$core$String$fromChar(
				$elm$core$Char$fromCode(code));
		} else {
			return match.eK;
		}
	} else {
		return match.eK;
	}
};
var $dillonkearns$elm_markdown$Markdown$Entity$replaceEntities = A2($elm$regex$Regex$replace, $dillonkearns$elm_markdown$Markdown$Entity$entitiesRegex, $dillonkearns$elm_markdown$Markdown$Entity$replaceEntity);
var $dillonkearns$elm_markdown$Markdown$Helpers$escapableRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\\\\+)([!\"#$%&\\\'()*+,./:;<=>?@[\\\\\\]^_`{|}~-])'));
var $dillonkearns$elm_markdown$Markdown$Helpers$replaceEscapable = A2(
	$elm$regex$Regex$replace,
	$dillonkearns$elm_markdown$Markdown$Helpers$escapableRegex,
	function (regexMatch) {
		var _v0 = regexMatch.ij;
		if (((_v0.b && (!_v0.a.$)) && _v0.b.b) && (!_v0.b.a.$)) {
			var backslashes = _v0.a.a;
			var _v1 = _v0.b;
			var escapedStr = _v1.a.a;
			return _Utils_ap(
				A2(
					$elm$core$String$repeat,
					($elm$core$String$length(backslashes) / 2) | 0,
					'\\'),
				escapedStr);
		} else {
			return regexMatch.eK;
		}
	});
var $dillonkearns$elm_markdown$Markdown$Entity$hexadecimalRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('&#[Xx]([0-9a-fA-F]{1,8});'));
var $dillonkearns$elm_markdown$Markdown$Entity$hexToInt = function (string) {
	var folder = F2(
		function (hexDigit, _int) {
			return ((_int * 16) + A2(
				$elm$core$Basics$modBy,
				39,
				$elm$core$Char$toCode(hexDigit))) - 9;
		});
	return A3(
		$elm$core$String$foldl,
		folder,
		0,
		$elm$core$String$toLower(string));
};
var $dillonkearns$elm_markdown$Markdown$Entity$replaceHexadecimal = function (match) {
	var _v0 = match.ij;
	if (_v0.b && (!_v0.a.$)) {
		var first = _v0.a.a;
		return $dillonkearns$elm_markdown$Markdown$Entity$validUnicode(
			$dillonkearns$elm_markdown$Markdown$Entity$hexToInt(first));
	} else {
		return match.eK;
	}
};
var $dillonkearns$elm_markdown$Markdown$Entity$replaceHexadecimals = A2($elm$regex$Regex$replace, $dillonkearns$elm_markdown$Markdown$Entity$hexadecimalRegex, $dillonkearns$elm_markdown$Markdown$Entity$replaceHexadecimal);
var $dillonkearns$elm_markdown$Markdown$Helpers$formatStr = function (str) {
	var withEscapes = $dillonkearns$elm_markdown$Markdown$Helpers$replaceEscapable(str);
	return $dillonkearns$elm_markdown$Markdown$Helpers$containsAmpersand(withEscapes) ? $dillonkearns$elm_markdown$Markdown$Entity$replaceHexadecimals(
		$dillonkearns$elm_markdown$Markdown$Entity$replaceDecimals(
			$dillonkearns$elm_markdown$Markdown$Entity$replaceEntities(withEscapes))) : withEscapes;
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$normalMatch = function (text) {
	return {
		k: 0,
		M: _List_Nil,
		p: 0,
		r: $dillonkearns$elm_markdown$Markdown$Helpers$formatStr(text),
		al: 0,
		O: 0,
		d0: $dillonkearns$elm_markdown$Markdown$InlineParser$NormalType
	};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$parseTextMatch = F3(
	function (rawText, _v2, parsedMatches) {
		var matchModel = _v2;
		var updtMatch = {
			k: matchModel.k,
			M: A3($dillonkearns$elm_markdown$Markdown$InlineParser$parseTextMatches, matchModel.r, _List_Nil, matchModel.M),
			p: matchModel.p,
			r: matchModel.r,
			al: matchModel.al,
			O: matchModel.O,
			d0: matchModel.d0
		};
		if (!parsedMatches.b) {
			var finalStr = A2($elm$core$String$dropLeft, matchModel.k, rawText);
			return $elm$core$String$isEmpty(finalStr) ? _List_fromArray(
				[updtMatch]) : _List_fromArray(
				[
					updtMatch,
					$dillonkearns$elm_markdown$Markdown$InlineParser$normalMatch(finalStr)
				]);
		} else {
			var matchHead = parsedMatches.a;
			var matchesTail = parsedMatches.b;
			var _v4 = matchHead.d0;
			if (!_v4.$) {
				return A2($elm$core$List$cons, updtMatch, parsedMatches);
			} else {
				return _Utils_eq(matchModel.k, matchHead.p) ? A2($elm$core$List$cons, updtMatch, parsedMatches) : ((_Utils_cmp(matchModel.k, matchHead.p) < 0) ? A2(
					$elm$core$List$cons,
					updtMatch,
					A2(
						$elm$core$List$cons,
						$dillonkearns$elm_markdown$Markdown$InlineParser$normalMatch(
							A3($elm$core$String$slice, matchModel.k, matchHead.p, rawText)),
						parsedMatches)) : parsedMatches);
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$parseTextMatches = F3(
	function (rawText, parsedMatches, matches) {
		parseTextMatches:
		while (true) {
			if (!matches.b) {
				if (!parsedMatches.b) {
					return $elm$core$String$isEmpty(rawText) ? _List_Nil : _List_fromArray(
						[
							$dillonkearns$elm_markdown$Markdown$InlineParser$normalMatch(rawText)
						]);
				} else {
					var matchModel = parsedMatches.a;
					return (matchModel.p > 0) ? A2(
						$elm$core$List$cons,
						$dillonkearns$elm_markdown$Markdown$InlineParser$normalMatch(
							A2($elm$core$String$left, matchModel.p, rawText)),
						parsedMatches) : parsedMatches;
				}
			} else {
				var match = matches.a;
				var matchesTail = matches.b;
				var $temp$rawText = rawText,
					$temp$parsedMatches = A3($dillonkearns$elm_markdown$Markdown$InlineParser$parseTextMatch, rawText, match, parsedMatches),
					$temp$matches = matchesTail;
				rawText = $temp$rawText;
				parsedMatches = $temp$parsedMatches;
				matches = $temp$matches;
				continue parseTextMatches;
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$angleBracketLTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\\\\*)(\\<)'));
var $elm$regex$Regex$find = _Regex_findAtMost(_Regex_infinity);
var $dillonkearns$elm_markdown$Markdown$InlineParser$AngleBracketOpen = {$: 4};
var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToAngleBracketLToken = function (regMatch) {
	var _v0 = regMatch.ij;
	if ((_v0.b && _v0.b.b) && (!_v0.b.a.$)) {
		var maybeBackslashes = _v0.a;
		var _v1 = _v0.b;
		var delimiter = _v1.a.a;
		var backslashesLength = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Maybe$map, $elm$core$String$length, maybeBackslashes));
		return $dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength) ? $elm$core$Maybe$Just(
			{eB: regMatch.eB + backslashesLength, hB: 1, g: $dillonkearns$elm_markdown$Markdown$InlineParser$AngleBracketOpen}) : $elm$core$Maybe$Nothing;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$findAngleBracketLTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		$dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToAngleBracketLToken,
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$angleBracketLTokenRegex, str));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$angleBracketRTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\\\\*)(\\>)'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$AngleBracketClose = function (a) {
	return {$: 5, a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$Escaped = 0;
var $dillonkearns$elm_markdown$Markdown$InlineParser$NotEscaped = 1;
var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToAngleBracketRToken = function (regMatch) {
	var _v0 = regMatch.ij;
	if ((_v0.b && _v0.b.b) && (!_v0.b.a.$)) {
		var maybeBackslashes = _v0.a;
		var _v1 = _v0.b;
		var backslashesLength = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Maybe$map, $elm$core$String$length, maybeBackslashes));
		return $elm$core$Maybe$Just(
			{
				eB: regMatch.eB + backslashesLength,
				hB: 1,
				g: $dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength) ? $dillonkearns$elm_markdown$Markdown$InlineParser$AngleBracketClose(1) : $dillonkearns$elm_markdown$Markdown$InlineParser$AngleBracketClose(0)
			});
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$findAngleBracketRTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		$dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToAngleBracketRToken,
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$angleBracketRTokenRegex, str));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$asteriskEmphasisTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\\\\*)([^*])?(\\*+)([^*])?'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$EmphasisToken = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$isPunctuation = function (c) {
	switch (c) {
		case '!':
			return true;
		case '\"':
			return true;
		case '#':
			return true;
		case '%':
			return true;
		case '&':
			return true;
		case '\'':
			return true;
		case '(':
			return true;
		case ')':
			return true;
		case '*':
			return true;
		case ',':
			return true;
		case '-':
			return true;
		case '.':
			return true;
		case '/':
			return true;
		case ':':
			return true;
		case ';':
			return true;
		case '?':
			return true;
		case '@':
			return true;
		case '[':
			return true;
		case ']':
			return true;
		case '_':
			return true;
		case '{':
			return true;
		case '}':
			return true;
		case '~':
			return true;
		default:
			return false;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$containPunctuation = A2(
	$elm$core$String$foldl,
	F2(
		function (c, accum) {
			return accum || $dillonkearns$elm_markdown$Markdown$InlineParser$isPunctuation(c);
		}),
	false);
var $dillonkearns$elm_markdown$Markdown$InlineParser$isWhitespace = function (c) {
	switch (c) {
		case ' ':
			return true;
		case '\u000C':
			return true;
		case '\n':
			return true;
		case '\r':
			return true;
		case '\t':
			return true;
		case '\u000B':
			return true;
		case '\u00A0':
			return true;
		case '\u2028':
			return true;
		case '\u2029':
			return true;
		default:
			return false;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$containSpace = A2(
	$elm$core$String$foldl,
	F2(
		function (c, accum) {
			return accum || $dillonkearns$elm_markdown$Markdown$InlineParser$isWhitespace(c);
		}),
	false);
var $dillonkearns$elm_markdown$Markdown$InlineParser$getFringeRank = function (mstring) {
	if (!mstring.$) {
		var string = mstring.a;
		return ($elm$core$String$isEmpty(string) || $dillonkearns$elm_markdown$Markdown$InlineParser$containSpace(string)) ? 0 : ($dillonkearns$elm_markdown$Markdown$InlineParser$containPunctuation(string) ? 1 : 2);
	} else {
		return 0;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToEmphasisToken = F3(
	function (_char, rawText, regMatch) {
		var _v0 = regMatch.ij;
		if ((((_v0.b && _v0.b.b) && _v0.b.b.b) && (!_v0.b.b.a.$)) && _v0.b.b.b.b) {
			var maybeBackslashes = _v0.a;
			var _v1 = _v0.b;
			var maybeLeftFringe = _v1.a;
			var _v2 = _v1.b;
			var delimiter = _v2.a.a;
			var _v3 = _v2.b;
			var maybeRightFringe = _v3.a;
			var rFringeRank = $dillonkearns$elm_markdown$Markdown$InlineParser$getFringeRank(maybeRightFringe);
			var leftFringeLength = function () {
				if (!maybeLeftFringe.$) {
					var left = maybeLeftFringe.a;
					return $elm$core$String$length(left);
				} else {
					return 0;
				}
			}();
			var mLeftFringe = ((!(!regMatch.eB)) && (!leftFringeLength)) ? $elm$core$Maybe$Just(
				A3($elm$core$String$slice, regMatch.eB - 1, regMatch.eB, rawText)) : maybeLeftFringe;
			var backslashesLength = function () {
				if (!maybeBackslashes.$) {
					var backslashes = maybeBackslashes.a;
					return $elm$core$String$length(backslashes);
				} else {
					return 0;
				}
			}();
			var isEscaped = ((!$dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength)) && (!leftFringeLength)) || function () {
				if ((!mLeftFringe.$) && (mLeftFringe.a === '\\')) {
					return true;
				} else {
					return false;
				}
			}();
			var delimiterLength = isEscaped ? ($elm$core$String$length(delimiter) - 1) : $elm$core$String$length(delimiter);
			var lFringeRank = isEscaped ? 1 : $dillonkearns$elm_markdown$Markdown$InlineParser$getFringeRank(mLeftFringe);
			if ((delimiterLength <= 0) || ((_char === '_') && ((lFringeRank === 2) && (rFringeRank === 2)))) {
				return $elm$core$Maybe$Nothing;
			} else {
				var index = ((regMatch.eB + backslashesLength) + leftFringeLength) + (isEscaped ? 1 : 0);
				return $elm$core$Maybe$Just(
					{
						eB: index,
						hB: delimiterLength,
						g: A2(
							$dillonkearns$elm_markdown$Markdown$InlineParser$EmphasisToken,
							_char,
							{f6: lFringeRank, gr: rFringeRank})
					});
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$findAsteriskEmphasisTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		A2($dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToEmphasisToken, '*', str),
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$asteriskEmphasisTokenRegex, str));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$codeTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\\\\*)(\\`+)'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$CodeToken = function (a) {
	return {$: 0, a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToCodeToken = function (regMatch) {
	var _v0 = regMatch.ij;
	if ((_v0.b && _v0.b.b) && (!_v0.b.a.$)) {
		var maybeBackslashes = _v0.a;
		var _v1 = _v0.b;
		var backtick = _v1.a.a;
		var backslashesLength = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Maybe$map, $elm$core$String$length, maybeBackslashes));
		return $elm$core$Maybe$Just(
			{
				eB: regMatch.eB + backslashesLength,
				hB: $elm$core$String$length(backtick),
				g: $dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength) ? $dillonkearns$elm_markdown$Markdown$InlineParser$CodeToken(1) : $dillonkearns$elm_markdown$Markdown$InlineParser$CodeToken(0)
			});
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$findCodeTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		$dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToCodeToken,
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$codeTokenRegex, str));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$hardBreakTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(?:(\\\\+)|( {2,}))\\n'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakToken = {$: 9};
var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToHardBreakToken = function (regMatch) {
	var _v0 = regMatch.ij;
	_v0$2:
	while (true) {
		if (_v0.b) {
			if (!_v0.a.$) {
				var backslashes = _v0.a.a;
				var backslashesLength = $elm$core$String$length(backslashes);
				return (!$dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength)) ? $elm$core$Maybe$Just(
					{eB: (regMatch.eB + backslashesLength) - 1, hB: 2, g: $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakToken}) : $elm$core$Maybe$Nothing;
			} else {
				if (_v0.b.b && (!_v0.b.a.$)) {
					var _v1 = _v0.b;
					return $elm$core$Maybe$Just(
						{
							eB: regMatch.eB,
							hB: $elm$core$String$length(regMatch.eK),
							g: $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakToken
						});
				} else {
					break _v0$2;
				}
			}
		} else {
			break _v0$2;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToSoftHardBreakToken = function (regMatch) {
	var _v0 = regMatch.ij;
	_v0$2:
	while (true) {
		if (_v0.b) {
			if (!_v0.a.$) {
				var backslashes = _v0.a.a;
				var backslashesLength = $elm$core$String$length(backslashes);
				return $dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength) ? $elm$core$Maybe$Just(
					{eB: regMatch.eB + backslashesLength, hB: 1, g: $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakToken}) : $elm$core$Maybe$Just(
					{eB: (regMatch.eB + backslashesLength) - 1, hB: 2, g: $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakToken});
			} else {
				if (_v0.b.b) {
					var _v1 = _v0.b;
					var maybeSpaces = _v1.a;
					return $elm$core$Maybe$Just(
						{
							eB: regMatch.eB,
							hB: $elm$core$String$length(regMatch.eK),
							g: $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakToken
						});
				} else {
					break _v0$2;
				}
			}
		} else {
			break _v0$2;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$softAsHardLineBreak = false;
var $dillonkearns$elm_markdown$Markdown$InlineParser$softAsHardLineBreakTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(?:(\\\\+)|( *))\\n'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$findHardBreakTokens = function (str) {
	return $dillonkearns$elm_markdown$Markdown$InlineParser$softAsHardLineBreak ? A2(
		$elm$core$List$filterMap,
		$dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToSoftHardBreakToken,
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$softAsHardLineBreakTokenRegex, str)) : A2(
		$elm$core$List$filterMap,
		$dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToHardBreakToken,
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$hardBreakTokenRegex, str));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$linkImageCloseTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\\\\*)(\\])'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$SquareBracketClose = {$: 3};
var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToLinkImageCloseToken = function (regMatch) {
	var _v0 = regMatch.ij;
	if ((_v0.b && _v0.b.b) && (!_v0.b.a.$)) {
		var maybeBackslashes = _v0.a;
		var _v1 = _v0.b;
		var backslashesLength = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Maybe$map, $elm$core$String$length, maybeBackslashes));
		return $dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength) ? $elm$core$Maybe$Just(
			{eB: regMatch.eB + backslashesLength, hB: 1, g: $dillonkearns$elm_markdown$Markdown$InlineParser$SquareBracketClose}) : $elm$core$Maybe$Nothing;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$findLinkImageCloseTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		$dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToLinkImageCloseToken,
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$linkImageCloseTokenRegex, str));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$linkImageOpenTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\\\\*)(\\!)?(\\[)'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$Active = 0;
var $dillonkearns$elm_markdown$Markdown$InlineParser$ImageOpenToken = {$: 2};
var $dillonkearns$elm_markdown$Markdown$InlineParser$LinkOpenToken = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToLinkImageOpenToken = function (regMatch) {
	var _v0 = regMatch.ij;
	if (((_v0.b && _v0.b.b) && _v0.b.b.b) && (!_v0.b.b.a.$)) {
		var maybeBackslashes = _v0.a;
		var _v1 = _v0.b;
		var maybeImageOpen = _v1.a;
		var _v2 = _v1.b;
		var backslashesLength = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Maybe$map, $elm$core$String$length, maybeBackslashes));
		var isEscaped = !$dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength);
		var index = isEscaped ? ((regMatch.eB + backslashesLength) + 1) : (regMatch.eB + backslashesLength);
		if (isEscaped) {
			if (!maybeImageOpen.$) {
				return $elm$core$Maybe$Just(
					{
						eB: index,
						hB: 1,
						g: $dillonkearns$elm_markdown$Markdown$InlineParser$LinkOpenToken(0)
					});
			} else {
				return $elm$core$Maybe$Nothing;
			}
		} else {
			if (!maybeImageOpen.$) {
				return $elm$core$Maybe$Just(
					{eB: index, hB: 2, g: $dillonkearns$elm_markdown$Markdown$InlineParser$ImageOpenToken});
			} else {
				return $elm$core$Maybe$Just(
					{
						eB: index,
						hB: 1,
						g: $dillonkearns$elm_markdown$Markdown$InlineParser$LinkOpenToken(0)
					});
			}
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$findLinkImageOpenTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		$dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToLinkImageOpenToken,
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$linkImageOpenTokenRegex, str));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$StrikethroughToken = function (a) {
	return {$: 10, a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToStrikethroughToken = function (regMatch) {
	var _v0 = regMatch.ij;
	if ((_v0.b && _v0.b.b) && (!_v0.b.a.$)) {
		var maybeBackslashes = _v0.a;
		var _v1 = _v0.b;
		var tilde = _v1.a.a;
		var backslashesLength = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Maybe$map, $elm$core$String$length, maybeBackslashes));
		var _v2 = $dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength) ? _Utils_Tuple2(
			$elm$core$String$length(tilde),
			$dillonkearns$elm_markdown$Markdown$InlineParser$StrikethroughToken(1)) : _Utils_Tuple2(
			$elm$core$String$length(tilde),
			$dillonkearns$elm_markdown$Markdown$InlineParser$StrikethroughToken(0));
		var length = _v2.a;
		var meaning = _v2.b;
		return $elm$core$Maybe$Just(
			{eB: regMatch.eB + backslashesLength, hB: length, g: meaning});
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$strikethroughTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\\\\*)(~{2,})([^~])?'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$findStrikethroughTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		$dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToStrikethroughToken,
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$strikethroughTokenRegex, str));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$underlineEmphasisTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\\\\*)([^_])?(\\_+)([^_])?'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$findUnderlineEmphasisTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		A2($dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToEmphasisToken, '_', str),
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$underlineEmphasisTokenRegex, str));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex = F2(
	function (left, right) {
		if (left.b) {
			var lfirst = left.a;
			var lrest = left.b;
			if (right.b) {
				var rfirst = right.a;
				var rrest = right.b;
				return (_Utils_cmp(lfirst.eB, rfirst.eB) < 0) ? A2(
					$elm$core$List$cons,
					lfirst,
					A2($dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex, lrest, right)) : A2(
					$elm$core$List$cons,
					rfirst,
					A2($dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex, left, rrest));
			} else {
				return left;
			}
		} else {
			return right;
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$tokenize = function (rawText) {
	return A2(
		$dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex,
		$dillonkearns$elm_markdown$Markdown$InlineParser$findAngleBracketRTokens(rawText),
		A2(
			$dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex,
			$dillonkearns$elm_markdown$Markdown$InlineParser$findAngleBracketLTokens(rawText),
			A2(
				$dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex,
				$dillonkearns$elm_markdown$Markdown$InlineParser$findHardBreakTokens(rawText),
				A2(
					$dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex,
					$dillonkearns$elm_markdown$Markdown$InlineParser$findLinkImageCloseTokens(rawText),
					A2(
						$dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex,
						$dillonkearns$elm_markdown$Markdown$InlineParser$findLinkImageOpenTokens(rawText),
						A2(
							$dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex,
							$dillonkearns$elm_markdown$Markdown$InlineParser$findStrikethroughTokens(rawText),
							A2(
								$dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex,
								$dillonkearns$elm_markdown$Markdown$InlineParser$findUnderlineEmphasisTokens(rawText),
								A2(
									$dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex,
									$dillonkearns$elm_markdown$Markdown$InlineParser$findAsteriskEmphasisTokens(rawText),
									$dillonkearns$elm_markdown$Markdown$InlineParser$findCodeTokens(rawText)))))))));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$CodeType = {$: 2};
var $dillonkearns$elm_markdown$Markdown$InlineParser$EmphasisType = function (a) {
	return {$: 7, a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$HtmlType = function (a) {
	return {$: 6, a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$ImageType = function (a) {
	return {$: 5, a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$Inactive = 1;
var $dillonkearns$elm_markdown$Markdown$InlineParser$LinkType = function (a) {
	return {$: 4, a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$StrikethroughType = {$: 8};
var $dillonkearns$elm_markdown$Markdown$InlineParser$AutolinkType = function (a) {
	return {$: 3, a: a};
};
var $elm$regex$Regex$contains = _Regex_contains;
var $dillonkearns$elm_markdown$Markdown$InlineParser$decodeUrlRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('%(?:3B|2C|2F|3F|3A|40|26|3D|2B|24|23|25)'));
var $elm$url$Url$percentDecode = _Url_percentDecode;
var $dillonkearns$elm_markdown$Markdown$InlineParser$encodeUrl = A2(
	$elm$core$Basics$composeR,
	$elm$url$Url$percentEncode,
	A2(
		$elm$regex$Regex$replace,
		$dillonkearns$elm_markdown$Markdown$InlineParser$decodeUrlRegex,
		function (match) {
			return A2(
				$elm$core$Maybe$withDefault,
				match.eK,
				$elm$url$Url$percentDecode(match.eK));
		}));
var $dillonkearns$elm_markdown$Markdown$InlineParser$urlRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^([A-Za-z][A-Za-z0-9.+\\-]{1,31}:[^<>\\x00-\\x20]*)$'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$autolinkToMatch = function (_v0) {
	var match = _v0;
	return A2($elm$regex$Regex$contains, $dillonkearns$elm_markdown$Markdown$InlineParser$urlRegex, match.r) ? $elm$core$Result$Ok(
		_Utils_update(
			match,
			{
				d0: $dillonkearns$elm_markdown$Markdown$InlineParser$AutolinkType(
					_Utils_Tuple2(
						match.r,
						$dillonkearns$elm_markdown$Markdown$InlineParser$encodeUrl(match.r)))
			})) : $elm$core$Result$Err(match);
};
var $elm$regex$Regex$findAtMost = _Regex_findAtMost;
var $dillonkearns$elm_markdown$Markdown$Helpers$insideSquareBracketRegex = '[^\\[\\]\\\\]*(?:\\\\.[^\\[\\]\\\\]*)*';
var $dillonkearns$elm_markdown$Markdown$InlineParser$refLabelRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^\\[\\s*(' + ($dillonkearns$elm_markdown$Markdown$Helpers$insideSquareBracketRegex + ')\\s*\\]')));
var $dillonkearns$elm_markdown$Markdown$Helpers$cleanWhitespaces = function (original) {
	return original;
};
var $dillonkearns$elm_markdown$Markdown$Helpers$prepareRefLabel = A2($elm$core$Basics$composeR, $dillonkearns$elm_markdown$Markdown$Helpers$cleanWhitespaces, $elm$core$String$toLower);
var $dillonkearns$elm_markdown$Markdown$InlineParser$prepareUrlAndTitle = F2(
	function (rawUrl, maybeTitle) {
		return _Utils_Tuple2(
			$dillonkearns$elm_markdown$Markdown$InlineParser$encodeUrl(
				$dillonkearns$elm_markdown$Markdown$Helpers$formatStr(rawUrl)),
			A2($elm$core$Maybe$map, $dillonkearns$elm_markdown$Markdown$Helpers$formatStr, maybeTitle));
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$refRegexToMatch = F3(
	function (matchModel, references, maybeRegexMatch) {
		var refLabel = function (str) {
			return $elm$core$String$isEmpty(str) ? matchModel.r : str;
		}(
			A2(
				$elm$core$Maybe$withDefault,
				matchModel.r,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Maybe$Nothing,
					A2(
						$elm$core$Maybe$andThen,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.ij;
							},
							$elm$core$List$head),
						maybeRegexMatch))));
		var _v0 = A2(
			$elm$core$Dict$get,
			$dillonkearns$elm_markdown$Markdown$Helpers$prepareRefLabel(refLabel),
			references);
		if (_v0.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v1 = _v0.a;
			var rawUrl = _v1.a;
			var maybeTitle = _v1.b;
			var type_ = function () {
				var _v3 = matchModel.d0;
				if (_v3.$ === 5) {
					return $dillonkearns$elm_markdown$Markdown$InlineParser$ImageType(
						A2($dillonkearns$elm_markdown$Markdown$InlineParser$prepareUrlAndTitle, rawUrl, maybeTitle));
				} else {
					return $dillonkearns$elm_markdown$Markdown$InlineParser$LinkType(
						A2($dillonkearns$elm_markdown$Markdown$InlineParser$prepareUrlAndTitle, rawUrl, maybeTitle));
				}
			}();
			var regexMatchLength = function () {
				if (!maybeRegexMatch.$) {
					var match = maybeRegexMatch.a.eK;
					return $elm$core$String$length(match);
				} else {
					return 0;
				}
			}();
			return $elm$core$Maybe$Just(
				_Utils_update(
					matchModel,
					{k: matchModel.k + regexMatchLength, d0: type_}));
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$checkForInlineReferences = F3(
	function (remainText, _v0, references) {
		var tempMatch = _v0;
		var matches = A3($elm$regex$Regex$findAtMost, 1, $dillonkearns$elm_markdown$Markdown$InlineParser$refLabelRegex, remainText);
		return A3(
			$dillonkearns$elm_markdown$Markdown$InlineParser$refRegexToMatch,
			tempMatch,
			references,
			$elm$core$List$head(matches));
	});
var $dillonkearns$elm_markdown$Markdown$Helpers$lineEndChars = '\\f\\v\\r\\n';
var $dillonkearns$elm_markdown$Markdown$Helpers$whiteSpaceChars = ' \\t\\f\\v\\r\\n';
var $dillonkearns$elm_markdown$Markdown$InlineParser$hrefRegex = '(?:<([^<>' + ($dillonkearns$elm_markdown$Markdown$Helpers$lineEndChars + (']*)>|([^' + ($dillonkearns$elm_markdown$Markdown$Helpers$whiteSpaceChars + ('\\(\\)\\\\]*(?:\\\\.[^' + ($dillonkearns$elm_markdown$Markdown$Helpers$whiteSpaceChars + '\\(\\)\\\\]*)*))')))));
var $dillonkearns$elm_markdown$Markdown$Helpers$titleRegex = '(?:[' + ($dillonkearns$elm_markdown$Markdown$Helpers$whiteSpaceChars + (']+' + ('(?:\'([^\'\\\\]*(?:\\\\.[^\'\\\\]*)*)\'|' + ('\"([^\"\\\\]*(?:\\\\.[^\"\\\\]*)*)\"|' + '\\(([^\\)\\\\]*(?:\\\\.[^\\)\\\\]*)*)\\)))?'))));
var $dillonkearns$elm_markdown$Markdown$InlineParser$inlineLinkTypeOrImageTypeRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^\\(\\s*' + ($dillonkearns$elm_markdown$Markdown$InlineParser$hrefRegex + ($dillonkearns$elm_markdown$Markdown$Helpers$titleRegex + '\\s*\\)'))));
var $dillonkearns$elm_markdown$Markdown$Helpers$returnFirstJust = function (maybes) {
	var process = F2(
		function (a, maybeFound) {
			if (!maybeFound.$) {
				var found = maybeFound.a;
				return $elm$core$Maybe$Just(found);
			} else {
				return a;
			}
		});
	return A3($elm$core$List$foldl, process, $elm$core$Maybe$Nothing, maybes);
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$inlineLinkTypeOrImageTypeRegexToMatch = F2(
	function (matchModel, regexMatch) {
		var _v0 = regexMatch.ij;
		if ((((_v0.b && _v0.b.b) && _v0.b.b.b) && _v0.b.b.b.b) && _v0.b.b.b.b.b) {
			var maybeRawUrlAngleBrackets = _v0.a;
			var _v1 = _v0.b;
			var maybeRawUrlWithoutBrackets = _v1.a;
			var _v2 = _v1.b;
			var maybeTitleSingleQuotes = _v2.a;
			var _v3 = _v2.b;
			var maybeTitleDoubleQuotes = _v3.a;
			var _v4 = _v3.b;
			var maybeTitleParenthesis = _v4.a;
			var maybeTitle = $dillonkearns$elm_markdown$Markdown$Helpers$returnFirstJust(
				_List_fromArray(
					[maybeTitleSingleQuotes, maybeTitleDoubleQuotes, maybeTitleParenthesis]));
			var toMatch = function (rawUrl) {
				return _Utils_update(
					matchModel,
					{
						k: matchModel.k + $elm$core$String$length(regexMatch.eK),
						d0: function () {
							var _v5 = matchModel.d0;
							if (_v5.$ === 5) {
								return $dillonkearns$elm_markdown$Markdown$InlineParser$ImageType;
							} else {
								return $dillonkearns$elm_markdown$Markdown$InlineParser$LinkType;
							}
						}()(
							A2($dillonkearns$elm_markdown$Markdown$InlineParser$prepareUrlAndTitle, rawUrl, maybeTitle))
					});
			};
			var maybeRawUrl = $dillonkearns$elm_markdown$Markdown$Helpers$returnFirstJust(
				_List_fromArray(
					[maybeRawUrlAngleBrackets, maybeRawUrlWithoutBrackets]));
			return $elm$core$Maybe$Just(
				toMatch(
					A2($elm$core$Maybe$withDefault, '', maybeRawUrl)));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$checkForInlineLinkTypeOrImageType = F3(
	function (remainText, _v0, refs) {
		var tempMatch = _v0;
		var _v1 = A3($elm$regex$Regex$findAtMost, 1, $dillonkearns$elm_markdown$Markdown$InlineParser$inlineLinkTypeOrImageTypeRegex, remainText);
		if (_v1.b) {
			var first = _v1.a;
			var _v2 = A2($dillonkearns$elm_markdown$Markdown$InlineParser$inlineLinkTypeOrImageTypeRegexToMatch, tempMatch, first);
			if (!_v2.$) {
				var match = _v2.a;
				return $elm$core$Maybe$Just(match);
			} else {
				return A3($dillonkearns$elm_markdown$Markdown$InlineParser$checkForInlineReferences, remainText, tempMatch, refs);
			}
		} else {
			return A3($dillonkearns$elm_markdown$Markdown$InlineParser$checkForInlineReferences, remainText, tempMatch, refs);
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$checkParsedAheadOverlapping = F2(
	function (_v0, remainMatches) {
		var match = _v0;
		var overlappingMatches = $elm$core$List$filter(
			function (_v1) {
				var testMatch = _v1;
				return (_Utils_cmp(match.k, testMatch.p) > 0) && (_Utils_cmp(match.k, testMatch.k) < 0);
			});
		return ($elm$core$List$isEmpty(remainMatches) || $elm$core$List$isEmpty(
			overlappingMatches(remainMatches))) ? $elm$core$Maybe$Just(
			A2($elm$core$List$cons, match, remainMatches)) : $elm$core$Maybe$Nothing;
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$emailRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^([a-zA-Z0-9.!#$%&\'*+\\/=?^_`{|}~\\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9\\-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9\\-]{0,61}[a-zA-Z0-9])?)*)$'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$emailAutolinkTypeToMatch = function (_v0) {
	var match = _v0;
	return A2($elm$regex$Regex$contains, $dillonkearns$elm_markdown$Markdown$InlineParser$emailRegex, match.r) ? $elm$core$Result$Ok(
		_Utils_update(
			match,
			{
				d0: $dillonkearns$elm_markdown$Markdown$InlineParser$AutolinkType(
					_Utils_Tuple2(
						match.r,
						'mailto:' + $dillonkearns$elm_markdown$Markdown$InlineParser$encodeUrl(match.r)))
			})) : $elm$core$Result$Err(match);
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$findTokenHelp = F3(
	function (innerTokens, isToken, tokens) {
		findTokenHelp:
		while (true) {
			if (!tokens.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var nextToken = tokens.a;
				var remainingTokens = tokens.b;
				if (isToken(nextToken)) {
					return $elm$core$Maybe$Just(
						_Utils_Tuple3(
							nextToken,
							$elm$core$List$reverse(innerTokens),
							remainingTokens));
				} else {
					var $temp$innerTokens = A2($elm$core$List$cons, nextToken, innerTokens),
						$temp$isToken = isToken,
						$temp$tokens = remainingTokens;
					innerTokens = $temp$innerTokens;
					isToken = $temp$isToken;
					tokens = $temp$tokens;
					continue findTokenHelp;
				}
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$findToken = F2(
	function (isToken, tokens) {
		return A3($dillonkearns$elm_markdown$Markdown$InlineParser$findTokenHelp, _List_Nil, isToken, tokens);
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$HtmlToken = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$NotOpening = 1;
var $elm$parser$Parser$Advanced$getOffset = function (s) {
	return A3($elm$parser$Parser$Advanced$Good, false, s.d, s);
};
var $elm$parser$Parser$Advanced$bagToList = F2(
	function (bag, list) {
		bagToList:
		while (true) {
			switch (bag.$) {
				case 0:
					return list;
				case 1:
					var bag1 = bag.a;
					var x = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$core$List$cons, x, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
				default:
					var bag1 = bag.a;
					var bag2 = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$parser$Parser$Advanced$bagToList, bag2, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
			}
		}
	});
var $elm$parser$Parser$Advanced$run = F2(
	function (_v0, src) {
		var parse = _v0;
		var _v1 = parse(
			{i3: 1, i: _List_Nil, o: 1, d: 0, o6: 1, $8: src});
		if (!_v1.$) {
			var value = _v1.b;
			return $elm$core$Result$Ok(value);
		} else {
			var bag = _v1.b;
			return $elm$core$Result$Err(
				A2($elm$parser$Parser$Advanced$bagToList, bag, _List_Nil));
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$htmlToToken = F2(
	function (rawText, _v0) {
		var match = _v0;
		var consumedCharacters = A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$keeper,
					$elm$parser$Parser$Advanced$succeed(
						F3(
							function (startOffset, htmlTag, endOffset) {
								return {jG: htmlTag, hB: endOffset - startOffset};
							})),
					$elm$parser$Parser$Advanced$getOffset),
				$dillonkearns$elm_markdown$HtmlParser$html),
			$elm$parser$Parser$Advanced$getOffset);
		var parsed = A2(
			$elm$parser$Parser$Advanced$run,
			consumedCharacters,
			A2($elm$core$String$dropLeft, match.p, rawText));
		if (!parsed.$) {
			var htmlTag = parsed.a.jG;
			var length = parsed.a.hB;
			var htmlToken = A2($dillonkearns$elm_markdown$Markdown$InlineParser$HtmlToken, 1, htmlTag);
			return $elm$core$Maybe$Just(
				{eB: match.p, hB: length, g: htmlToken});
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $dillonkearns$elm_markdown$Markdown$Helpers$ifError = F2(
	function (_function, result) {
		if (!result.$) {
			return result;
		} else {
			var err = result.a;
			return _function(err);
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$isCloseToken = F2(
	function (htmlModel, token) {
		return false;
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$isCodeTokenPair = F2(
	function (closeToken, openToken) {
		var _v0 = openToken.g;
		if (!_v0.$) {
			if (!_v0.a) {
				var _v1 = _v0.a;
				return _Utils_eq(openToken.hB - 1, closeToken.hB);
			} else {
				var _v2 = _v0.a;
				return _Utils_eq(openToken.hB, closeToken.hB);
			}
		} else {
			return false;
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$isLinkTypeOrImageOpenToken = function (token) {
	var _v0 = token.g;
	switch (_v0.$) {
		case 1:
			return true;
		case 2:
			return true;
		default:
			return false;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$isOpenEmphasisToken = F2(
	function (closeToken, openToken) {
		var _v0 = openToken.g;
		if (_v0.$ === 7) {
			var openChar = _v0.a;
			var open = _v0.b;
			var _v1 = closeToken.g;
			if (_v1.$ === 7) {
				var closeChar = _v1.a;
				var close = _v1.b;
				return _Utils_eq(openChar, closeChar) ? ((_Utils_eq(open.f6, open.gr) || _Utils_eq(close.f6, close.gr)) ? ((!(!A2($elm$core$Basics$modBy, 3, closeToken.hB + openToken.hB))) || ((!A2($elm$core$Basics$modBy, 3, closeToken.hB)) && (!A2($elm$core$Basics$modBy, 3, openToken.hB)))) : true) : false;
			} else {
				return false;
			}
		} else {
			return false;
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$isStrikethroughTokenPair = F2(
	function (closeToken, openToken) {
		var _v0 = function () {
			var _v1 = openToken.g;
			if (_v1.$ === 10) {
				if (!_v1.a) {
					var _v2 = _v1.a;
					return _Utils_Tuple2(true, openToken.hB - 1);
				} else {
					var _v3 = _v1.a;
					return _Utils_Tuple2(true, openToken.hB);
				}
			} else {
				return _Utils_Tuple2(false, 0);
			}
		}();
		var openTokenIsStrikethrough = _v0.a;
		var openTokenLength = _v0.b;
		var _v4 = function () {
			var _v5 = closeToken.g;
			if (_v5.$ === 10) {
				if (!_v5.a) {
					var _v6 = _v5.a;
					return _Utils_Tuple2(true, closeToken.hB - 1);
				} else {
					var _v7 = _v5.a;
					return _Utils_Tuple2(true, closeToken.hB);
				}
			} else {
				return _Utils_Tuple2(false, 0);
			}
		}();
		var closeTokenIsStrikethrough = _v4.a;
		var closeTokenLength = _v4.b;
		return closeTokenIsStrikethrough && (openTokenIsStrikethrough && _Utils_eq(closeTokenLength, openTokenLength));
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakType = {$: 1};
var $dillonkearns$elm_markdown$Markdown$InlineParser$tokenToMatch = F2(
	function (token, type_) {
		return {k: token.eB + token.hB, M: _List_Nil, p: token.eB, r: '', al: 0, O: 0, d0: type_};
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$lineBreakTTM = F5(
	function (remaining, tokens, matches, refs, rawText) {
		lineBreakTTM:
		while (true) {
			if (!remaining.b) {
				return matches;
			} else {
				var token = remaining.a;
				var tokensTail = remaining.b;
				var _v1 = token.g;
				if (_v1.$ === 9) {
					var $temp$remaining = tokensTail,
						$temp$tokens = tokens,
						$temp$matches = A2(
						$elm$core$List$cons,
						A2($dillonkearns$elm_markdown$Markdown$InlineParser$tokenToMatch, token, $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakType),
						matches),
						$temp$refs = refs,
						$temp$rawText = rawText;
					remaining = $temp$remaining;
					tokens = $temp$tokens;
					matches = $temp$matches;
					refs = $temp$refs;
					rawText = $temp$rawText;
					continue lineBreakTTM;
				} else {
					var $temp$remaining = tokensTail,
						$temp$tokens = A2($elm$core$List$cons, token, tokens),
						$temp$matches = matches,
						$temp$refs = refs,
						$temp$rawText = rawText;
					remaining = $temp$remaining;
					tokens = $temp$tokens;
					matches = $temp$matches;
					refs = $temp$refs;
					rawText = $temp$rawText;
					continue lineBreakTTM;
				}
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$removeParsedAheadTokens = F2(
	function (_v0, tokensTail) {
		var match = _v0;
		return A2(
			$elm$core$List$filter,
			function (token) {
				return _Utils_cmp(token.eB, match.k) > -1;
			},
			tokensTail);
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$angleBracketsToMatch = F6(
	function (closeToken, escaped, matches, references, rawText, _v46) {
		var openToken = _v46.a;
		var remainTokens = _v46.c;
		var result = A2(
			$dillonkearns$elm_markdown$Markdown$Helpers$ifError,
			$dillonkearns$elm_markdown$Markdown$InlineParser$emailAutolinkTypeToMatch,
			$dillonkearns$elm_markdown$Markdown$InlineParser$autolinkToMatch(
				A7(
					$dillonkearns$elm_markdown$Markdown$InlineParser$tokenPairToMatch,
					references,
					rawText,
					function (s) {
						return s;
					},
					$dillonkearns$elm_markdown$Markdown$InlineParser$CodeType,
					openToken,
					closeToken,
					_List_Nil)));
		if (result.$ === 1) {
			var tempMatch = result.a;
			if (escaped === 1) {
				var _v49 = A2($dillonkearns$elm_markdown$Markdown$InlineParser$htmlToToken, rawText, tempMatch);
				if (!_v49.$) {
					var newToken = _v49.a;
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(
							A2($elm$core$List$cons, newToken, remainTokens),
							matches));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			} else {
				return $elm$core$Maybe$Nothing;
			}
		} else {
			var newMatch = result.a;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(
					remainTokens,
					A2($elm$core$List$cons, newMatch, matches)));
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$codeAutolinkTypeHtmlTagTTM = F5(
	function (remaining, tokens, matches, references, rawText) {
		codeAutolinkTypeHtmlTagTTM:
		while (true) {
			if (!remaining.b) {
				return A5(
					$dillonkearns$elm_markdown$Markdown$InlineParser$htmlElementTTM,
					$elm$core$List$reverse(tokens),
					_List_Nil,
					matches,
					references,
					rawText);
			} else {
				var token = remaining.a;
				var tokensTail = remaining.b;
				var _v38 = token.g;
				switch (_v38.$) {
					case 0:
						var isEscaped = _v38.a;
						var _v39 = A2(
							$dillonkearns$elm_markdown$Markdown$InlineParser$findToken,
							$dillonkearns$elm_markdown$Markdown$InlineParser$isCodeTokenPair(token),
							tokens);
						if (!_v39.$) {
							var code = _v39.a;
							var _v40 = A5($dillonkearns$elm_markdown$Markdown$InlineParser$codeToMatch, token, matches, references, rawText, code);
							var newTokens = _v40.a;
							var newMatches = _v40.b;
							var $temp$remaining = tokensTail,
								$temp$tokens = newTokens,
								$temp$matches = newMatches,
								$temp$references = references,
								$temp$rawText = rawText;
							remaining = $temp$remaining;
							tokens = $temp$tokens;
							matches = $temp$matches;
							references = $temp$references;
							rawText = $temp$rawText;
							continue codeAutolinkTypeHtmlTagTTM;
						} else {
							var $temp$remaining = tokensTail,
								$temp$tokens = A2($elm$core$List$cons, token, tokens),
								$temp$matches = matches,
								$temp$references = references,
								$temp$rawText = rawText;
							remaining = $temp$remaining;
							tokens = $temp$tokens;
							matches = $temp$matches;
							references = $temp$references;
							rawText = $temp$rawText;
							continue codeAutolinkTypeHtmlTagTTM;
						}
					case 5:
						var isEscaped = _v38.a;
						var isAngleBracketOpen = function (_v45) {
							var meaning = _v45.g;
							if (meaning.$ === 4) {
								return true;
							} else {
								return false;
							}
						};
						var _v41 = A2($dillonkearns$elm_markdown$Markdown$InlineParser$findToken, isAngleBracketOpen, tokens);
						if (!_v41.$) {
							var found = _v41.a;
							var _v42 = A6($dillonkearns$elm_markdown$Markdown$InlineParser$angleBracketsToMatch, token, isEscaped, matches, references, rawText, found);
							if (!_v42.$) {
								var _v43 = _v42.a;
								var newTokens = _v43.a;
								var newMatches = _v43.b;
								var $temp$remaining = tokensTail,
									$temp$tokens = A2(
									$elm$core$List$filter,
									A2($elm$core$Basics$composeL, $elm$core$Basics$not, isAngleBracketOpen),
									newTokens),
									$temp$matches = newMatches,
									$temp$references = references,
									$temp$rawText = rawText;
								remaining = $temp$remaining;
								tokens = $temp$tokens;
								matches = $temp$matches;
								references = $temp$references;
								rawText = $temp$rawText;
								continue codeAutolinkTypeHtmlTagTTM;
							} else {
								var $temp$remaining = tokensTail,
									$temp$tokens = A2(
									$elm$core$List$filter,
									A2($elm$core$Basics$composeL, $elm$core$Basics$not, isAngleBracketOpen),
									tokens),
									$temp$matches = matches,
									$temp$references = references,
									$temp$rawText = rawText;
								remaining = $temp$remaining;
								tokens = $temp$tokens;
								matches = $temp$matches;
								references = $temp$references;
								rawText = $temp$rawText;
								continue codeAutolinkTypeHtmlTagTTM;
							}
						} else {
							var $temp$remaining = tokensTail,
								$temp$tokens = A2(
								$elm$core$List$filter,
								A2($elm$core$Basics$composeL, $elm$core$Basics$not, isAngleBracketOpen),
								tokens),
								$temp$matches = matches,
								$temp$references = references,
								$temp$rawText = rawText;
							remaining = $temp$remaining;
							tokens = $temp$tokens;
							matches = $temp$matches;
							references = $temp$references;
							rawText = $temp$rawText;
							continue codeAutolinkTypeHtmlTagTTM;
						}
					default:
						var $temp$remaining = tokensTail,
							$temp$tokens = A2($elm$core$List$cons, token, tokens),
							$temp$matches = matches,
							$temp$references = references,
							$temp$rawText = rawText;
						remaining = $temp$remaining;
						tokens = $temp$tokens;
						matches = $temp$matches;
						references = $temp$references;
						rawText = $temp$rawText;
						continue codeAutolinkTypeHtmlTagTTM;
				}
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$codeToMatch = F5(
	function (closeToken, matches, references, rawText, _v34) {
		var openToken = _v34.a;
		var remainTokens = _v34.c;
		var updatedOpenToken = function () {
			var _v35 = openToken.g;
			if ((!_v35.$) && (!_v35.a)) {
				var _v36 = _v35.a;
				return _Utils_update(
					openToken,
					{eB: openToken.eB + 1, hB: openToken.hB - 1});
			} else {
				return openToken;
			}
		}();
		var match = A7($dillonkearns$elm_markdown$Markdown$InlineParser$tokenPairToMatch, references, rawText, $dillonkearns$elm_markdown$Markdown$Helpers$cleanWhitespaces, $dillonkearns$elm_markdown$Markdown$InlineParser$CodeType, updatedOpenToken, closeToken, _List_Nil);
		return _Utils_Tuple2(
			remainTokens,
			A2($elm$core$List$cons, match, matches));
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$emphasisTTM = F5(
	function (remaining, tokens, matches, references, rawText) {
		emphasisTTM:
		while (true) {
			if (!remaining.b) {
				return A5(
					$dillonkearns$elm_markdown$Markdown$InlineParser$strikethroughTTM,
					$elm$core$List$reverse(tokens),
					_List_Nil,
					matches,
					references,
					rawText);
			} else {
				var token = remaining.a;
				var tokensTail = remaining.b;
				var _v29 = token.g;
				if (_v29.$ === 7) {
					var _char = _v29.a;
					var leftFringeRank = _v29.b.f6;
					var rightFringeRank = _v29.b.gr;
					if (_Utils_eq(leftFringeRank, rightFringeRank)) {
						if ((!(!rightFringeRank)) && ((_char !== '_') || (rightFringeRank === 1))) {
							var _v30 = A2(
								$dillonkearns$elm_markdown$Markdown$InlineParser$findToken,
								$dillonkearns$elm_markdown$Markdown$InlineParser$isOpenEmphasisToken(token),
								tokens);
							if (!_v30.$) {
								var found = _v30.a;
								var _v31 = A5($dillonkearns$elm_markdown$Markdown$InlineParser$emphasisToMatch, references, rawText, token, tokensTail, found);
								var newRemaining = _v31.a;
								var match = _v31.b;
								var newTokens = _v31.c;
								var $temp$remaining = newRemaining,
									$temp$tokens = newTokens,
									$temp$matches = A2($elm$core$List$cons, match, matches),
									$temp$references = references,
									$temp$rawText = rawText;
								remaining = $temp$remaining;
								tokens = $temp$tokens;
								matches = $temp$matches;
								references = $temp$references;
								rawText = $temp$rawText;
								continue emphasisTTM;
							} else {
								var $temp$remaining = tokensTail,
									$temp$tokens = A2($elm$core$List$cons, token, tokens),
									$temp$matches = matches,
									$temp$references = references,
									$temp$rawText = rawText;
								remaining = $temp$remaining;
								tokens = $temp$tokens;
								matches = $temp$matches;
								references = $temp$references;
								rawText = $temp$rawText;
								continue emphasisTTM;
							}
						} else {
							var $temp$remaining = tokensTail,
								$temp$tokens = tokens,
								$temp$matches = matches,
								$temp$references = references,
								$temp$rawText = rawText;
							remaining = $temp$remaining;
							tokens = $temp$tokens;
							matches = $temp$matches;
							references = $temp$references;
							rawText = $temp$rawText;
							continue emphasisTTM;
						}
					} else {
						if (_Utils_cmp(leftFringeRank, rightFringeRank) < 0) {
							var $temp$remaining = tokensTail,
								$temp$tokens = A2($elm$core$List$cons, token, tokens),
								$temp$matches = matches,
								$temp$references = references,
								$temp$rawText = rawText;
							remaining = $temp$remaining;
							tokens = $temp$tokens;
							matches = $temp$matches;
							references = $temp$references;
							rawText = $temp$rawText;
							continue emphasisTTM;
						} else {
							var _v32 = A2(
								$dillonkearns$elm_markdown$Markdown$InlineParser$findToken,
								$dillonkearns$elm_markdown$Markdown$InlineParser$isOpenEmphasisToken(token),
								tokens);
							if (!_v32.$) {
								var found = _v32.a;
								var _v33 = A5($dillonkearns$elm_markdown$Markdown$InlineParser$emphasisToMatch, references, rawText, token, tokensTail, found);
								var newRemaining = _v33.a;
								var match = _v33.b;
								var newTokens = _v33.c;
								var $temp$remaining = newRemaining,
									$temp$tokens = newTokens,
									$temp$matches = A2($elm$core$List$cons, match, matches),
									$temp$references = references,
									$temp$rawText = rawText;
								remaining = $temp$remaining;
								tokens = $temp$tokens;
								matches = $temp$matches;
								references = $temp$references;
								rawText = $temp$rawText;
								continue emphasisTTM;
							} else {
								var $temp$remaining = tokensTail,
									$temp$tokens = tokens,
									$temp$matches = matches,
									$temp$references = references,
									$temp$rawText = rawText;
								remaining = $temp$remaining;
								tokens = $temp$tokens;
								matches = $temp$matches;
								references = $temp$references;
								rawText = $temp$rawText;
								continue emphasisTTM;
							}
						}
					}
				} else {
					var $temp$remaining = tokensTail,
						$temp$tokens = A2($elm$core$List$cons, token, tokens),
						$temp$matches = matches,
						$temp$references = references,
						$temp$rawText = rawText;
					remaining = $temp$remaining;
					tokens = $temp$tokens;
					matches = $temp$matches;
					references = $temp$references;
					rawText = $temp$rawText;
					continue emphasisTTM;
				}
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$emphasisToMatch = F5(
	function (references, rawText, closeToken, tokensTail, _v27) {
		var openToken = _v27.a;
		var innerTokens = _v27.b;
		var remainTokens = _v27.c;
		var remainLength = openToken.hB - closeToken.hB;
		var updt = (!remainLength) ? {fA: closeToken, eP: openToken, gq: remainTokens, gI: tokensTail} : ((remainLength > 0) ? {
			fA: closeToken,
			eP: _Utils_update(
				openToken,
				{eB: openToken.eB + remainLength, hB: closeToken.hB}),
			gq: A2(
				$elm$core$List$cons,
				_Utils_update(
					openToken,
					{hB: remainLength}),
				remainTokens),
			gI: tokensTail
		} : {
			fA: _Utils_update(
				closeToken,
				{hB: openToken.hB}),
			eP: openToken,
			gq: remainTokens,
			gI: A2(
				$elm$core$List$cons,
				_Utils_update(
					closeToken,
					{eB: closeToken.eB + openToken.hB, hB: -remainLength}),
				tokensTail)
		});
		var match = A7(
			$dillonkearns$elm_markdown$Markdown$InlineParser$tokenPairToMatch,
			references,
			rawText,
			function (s) {
				return s;
			},
			$dillonkearns$elm_markdown$Markdown$InlineParser$EmphasisType(updt.eP.hB),
			updt.eP,
			updt.fA,
			$elm$core$List$reverse(innerTokens));
		return _Utils_Tuple3(updt.gI, match, updt.gq);
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$htmlElementTTM = F5(
	function (remaining, tokens, matches, references, rawText) {
		htmlElementTTM:
		while (true) {
			if (!remaining.b) {
				return A5(
					$dillonkearns$elm_markdown$Markdown$InlineParser$linkImageTypeTTM,
					$elm$core$List$reverse(tokens),
					_List_Nil,
					matches,
					references,
					rawText);
			} else {
				var token = remaining.a;
				var tokensTail = remaining.b;
				var _v23 = token.g;
				if (_v23.$ === 6) {
					var isOpen = _v23.a;
					var htmlModel = _v23.b;
					if (isOpen === 1) {
						var $temp$remaining = tokensTail,
							$temp$tokens = tokens,
							$temp$matches = A2(
							$elm$core$List$cons,
							A2(
								$dillonkearns$elm_markdown$Markdown$InlineParser$tokenToMatch,
								token,
								$dillonkearns$elm_markdown$Markdown$InlineParser$HtmlType(htmlModel)),
							matches),
							$temp$references = references,
							$temp$rawText = rawText;
						remaining = $temp$remaining;
						tokens = $temp$tokens;
						matches = $temp$matches;
						references = $temp$references;
						rawText = $temp$rawText;
						continue htmlElementTTM;
					} else {
						var _v25 = A2(
							$dillonkearns$elm_markdown$Markdown$InlineParser$findToken,
							$dillonkearns$elm_markdown$Markdown$InlineParser$isCloseToken(htmlModel),
							tokensTail);
						if (_v25.$ === 1) {
							var $temp$remaining = tokensTail,
								$temp$tokens = tokens,
								$temp$matches = A2(
								$elm$core$List$cons,
								A2(
									$dillonkearns$elm_markdown$Markdown$InlineParser$tokenToMatch,
									token,
									$dillonkearns$elm_markdown$Markdown$InlineParser$HtmlType(htmlModel)),
								matches),
								$temp$references = references,
								$temp$rawText = rawText;
							remaining = $temp$remaining;
							tokens = $temp$tokens;
							matches = $temp$matches;
							references = $temp$references;
							rawText = $temp$rawText;
							continue htmlElementTTM;
						} else {
							var _v26 = _v25.a;
							var closeToken = _v26.a;
							var innerTokens = _v26.b;
							var newTail = _v26.c;
							var newMatch = A7(
								$dillonkearns$elm_markdown$Markdown$InlineParser$tokenPairToMatch,
								references,
								rawText,
								function (s) {
									return s;
								},
								$dillonkearns$elm_markdown$Markdown$InlineParser$HtmlType(htmlModel),
								token,
								closeToken,
								innerTokens);
							var $temp$remaining = newTail,
								$temp$tokens = tokens,
								$temp$matches = A2($elm$core$List$cons, newMatch, matches),
								$temp$references = references,
								$temp$rawText = rawText;
							remaining = $temp$remaining;
							tokens = $temp$tokens;
							matches = $temp$matches;
							references = $temp$references;
							rawText = $temp$rawText;
							continue htmlElementTTM;
						}
					}
				} else {
					var $temp$remaining = tokensTail,
						$temp$tokens = A2($elm$core$List$cons, token, tokens),
						$temp$matches = matches,
						$temp$references = references,
						$temp$rawText = rawText;
					remaining = $temp$remaining;
					tokens = $temp$tokens;
					matches = $temp$matches;
					references = $temp$references;
					rawText = $temp$rawText;
					continue htmlElementTTM;
				}
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$linkImageTypeTTM = F5(
	function (remaining, tokens, matches, references, rawText) {
		linkImageTypeTTM:
		while (true) {
			if (!remaining.b) {
				return A5(
					$dillonkearns$elm_markdown$Markdown$InlineParser$emphasisTTM,
					$elm$core$List$reverse(tokens),
					_List_Nil,
					matches,
					references,
					rawText);
			} else {
				var token = remaining.a;
				var tokensTail = remaining.b;
				var _v18 = token.g;
				if (_v18.$ === 3) {
					var _v19 = A2($dillonkearns$elm_markdown$Markdown$InlineParser$findToken, $dillonkearns$elm_markdown$Markdown$InlineParser$isLinkTypeOrImageOpenToken, tokens);
					if (!_v19.$) {
						var found = _v19.a;
						var _v20 = A6($dillonkearns$elm_markdown$Markdown$InlineParser$linkOrImageTypeToMatch, token, tokensTail, matches, references, rawText, found);
						if (!_v20.$) {
							var _v21 = _v20.a;
							var x = _v21.a;
							var newMatches = _v21.b;
							var newTokens = _v21.c;
							var $temp$remaining = x,
								$temp$tokens = newTokens,
								$temp$matches = newMatches,
								$temp$references = references,
								$temp$rawText = rawText;
							remaining = $temp$remaining;
							tokens = $temp$tokens;
							matches = $temp$matches;
							references = $temp$references;
							rawText = $temp$rawText;
							continue linkImageTypeTTM;
						} else {
							var $temp$remaining = tokensTail,
								$temp$tokens = tokens,
								$temp$matches = matches,
								$temp$references = references,
								$temp$rawText = rawText;
							remaining = $temp$remaining;
							tokens = $temp$tokens;
							matches = $temp$matches;
							references = $temp$references;
							rawText = $temp$rawText;
							continue linkImageTypeTTM;
						}
					} else {
						var $temp$remaining = tokensTail,
							$temp$tokens = tokens,
							$temp$matches = matches,
							$temp$references = references,
							$temp$rawText = rawText;
						remaining = $temp$remaining;
						tokens = $temp$tokens;
						matches = $temp$matches;
						references = $temp$references;
						rawText = $temp$rawText;
						continue linkImageTypeTTM;
					}
				} else {
					var $temp$remaining = tokensTail,
						$temp$tokens = A2($elm$core$List$cons, token, tokens),
						$temp$matches = matches,
						$temp$references = references,
						$temp$rawText = rawText;
					remaining = $temp$remaining;
					tokens = $temp$tokens;
					matches = $temp$matches;
					references = $temp$references;
					rawText = $temp$rawText;
					continue linkImageTypeTTM;
				}
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$linkOrImageTypeToMatch = F6(
	function (closeToken, tokensTail, oldMatches, references, rawText, _v8) {
		var openToken = _v8.a;
		var innerTokens = _v8.b;
		var remainTokens = _v8.c;
		var removeOpenToken = _Utils_Tuple3(
			tokensTail,
			oldMatches,
			_Utils_ap(innerTokens, remainTokens));
		var remainText = A2($elm$core$String$dropLeft, closeToken.eB + 1, rawText);
		var inactivateLinkOpenToken = function (token) {
			var _v16 = token.g;
			if (_v16.$ === 1) {
				return _Utils_update(
					token,
					{
						g: $dillonkearns$elm_markdown$Markdown$InlineParser$LinkOpenToken(1)
					});
			} else {
				return token;
			}
		};
		var findTempMatch = function (isLinkType) {
			return A7(
				$dillonkearns$elm_markdown$Markdown$InlineParser$tokenPairToMatch,
				references,
				rawText,
				function (s) {
					return s;
				},
				isLinkType ? $dillonkearns$elm_markdown$Markdown$InlineParser$LinkType(
					_Utils_Tuple2('', $elm$core$Maybe$Nothing)) : $dillonkearns$elm_markdown$Markdown$InlineParser$ImageType(
					_Utils_Tuple2('', $elm$core$Maybe$Nothing)),
				openToken,
				closeToken,
				$elm$core$List$reverse(innerTokens));
		};
		var _v9 = openToken.g;
		switch (_v9.$) {
			case 2:
				var tempMatch = findTempMatch(false);
				var _v10 = A3($dillonkearns$elm_markdown$Markdown$InlineParser$checkForInlineLinkTypeOrImageType, remainText, tempMatch, references);
				if (_v10.$ === 1) {
					return $elm$core$Maybe$Just(removeOpenToken);
				} else {
					var match = _v10.a;
					var _v11 = A2($dillonkearns$elm_markdown$Markdown$InlineParser$checkParsedAheadOverlapping, match, oldMatches);
					if (!_v11.$) {
						var matches = _v11.a;
						return $elm$core$Maybe$Just(
							_Utils_Tuple3(
								A2($dillonkearns$elm_markdown$Markdown$InlineParser$removeParsedAheadTokens, match, tokensTail),
								matches,
								remainTokens));
					} else {
						return $elm$core$Maybe$Just(removeOpenToken);
					}
				}
			case 1:
				if (!_v9.a) {
					var _v12 = _v9.a;
					var tempMatch = findTempMatch(true);
					var _v13 = A3($dillonkearns$elm_markdown$Markdown$InlineParser$checkForInlineLinkTypeOrImageType, remainText, tempMatch, references);
					if (_v13.$ === 1) {
						return $elm$core$Maybe$Just(removeOpenToken);
					} else {
						var match = _v13.a;
						var _v14 = A2($dillonkearns$elm_markdown$Markdown$InlineParser$checkParsedAheadOverlapping, match, oldMatches);
						if (!_v14.$) {
							var matches = _v14.a;
							return $elm$core$Maybe$Just(
								_Utils_Tuple3(
									A2($dillonkearns$elm_markdown$Markdown$InlineParser$removeParsedAheadTokens, match, tokensTail),
									matches,
									A2($elm$core$List$map, inactivateLinkOpenToken, remainTokens)));
						} else {
							return $elm$core$Maybe$Just(removeOpenToken);
						}
					}
				} else {
					var _v15 = _v9.a;
					return $elm$core$Maybe$Just(removeOpenToken);
				}
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$strikethroughTTM = F5(
	function (remaining, tokens, matches, references, rawText) {
		strikethroughTTM:
		while (true) {
			if (!remaining.b) {
				return A5(
					$dillonkearns$elm_markdown$Markdown$InlineParser$lineBreakTTM,
					$elm$core$List$reverse(tokens),
					_List_Nil,
					matches,
					references,
					rawText);
			} else {
				var token = remaining.a;
				var tokensTail = remaining.b;
				var _v5 = token.g;
				if (_v5.$ === 10) {
					var isEscaped = _v5.a;
					var _v6 = A2(
						$dillonkearns$elm_markdown$Markdown$InlineParser$findToken,
						$dillonkearns$elm_markdown$Markdown$InlineParser$isStrikethroughTokenPair(token),
						tokens);
					if (!_v6.$) {
						var content = _v6.a;
						var _v7 = A5($dillonkearns$elm_markdown$Markdown$InlineParser$strikethroughToMatch, token, matches, references, rawText, content);
						var newTokens = _v7.a;
						var newMatches = _v7.b;
						var $temp$remaining = tokensTail,
							$temp$tokens = newTokens,
							$temp$matches = newMatches,
							$temp$references = references,
							$temp$rawText = rawText;
						remaining = $temp$remaining;
						tokens = $temp$tokens;
						matches = $temp$matches;
						references = $temp$references;
						rawText = $temp$rawText;
						continue strikethroughTTM;
					} else {
						var $temp$remaining = tokensTail,
							$temp$tokens = A2($elm$core$List$cons, token, tokens),
							$temp$matches = matches,
							$temp$references = references,
							$temp$rawText = rawText;
						remaining = $temp$remaining;
						tokens = $temp$tokens;
						matches = $temp$matches;
						references = $temp$references;
						rawText = $temp$rawText;
						continue strikethroughTTM;
					}
				} else {
					var $temp$remaining = tokensTail,
						$temp$tokens = A2($elm$core$List$cons, token, tokens),
						$temp$matches = matches,
						$temp$references = references,
						$temp$rawText = rawText;
					remaining = $temp$remaining;
					tokens = $temp$tokens;
					matches = $temp$matches;
					references = $temp$references;
					rawText = $temp$rawText;
					continue strikethroughTTM;
				}
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$strikethroughToMatch = F5(
	function (closeToken, matches, references, rawText, _v1) {
		var openToken = _v1.a;
		var remainTokens = _v1.c;
		var updatedOpenToken = function () {
			var _v2 = openToken.g;
			if ((_v2.$ === 10) && (!_v2.a)) {
				var _v3 = _v2.a;
				return _Utils_update(
					openToken,
					{eB: openToken.eB + 1, hB: openToken.hB - 1});
			} else {
				return openToken;
			}
		}();
		var match = A7($dillonkearns$elm_markdown$Markdown$InlineParser$tokenPairToMatch, references, rawText, $dillonkearns$elm_markdown$Markdown$Helpers$cleanWhitespaces, $dillonkearns$elm_markdown$Markdown$InlineParser$StrikethroughType, updatedOpenToken, closeToken, _List_Nil);
		return _Utils_Tuple2(
			remainTokens,
			A2($elm$core$List$cons, match, matches));
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$tokenPairToMatch = F7(
	function (references, rawText, processText, type_, openToken, closeToken, innerTokens) {
		var textStart = openToken.eB + openToken.hB;
		var textEnd = closeToken.eB;
		var text = processText(
			A3($elm$core$String$slice, textStart, textEnd, rawText));
		var start = openToken.eB;
		var end = closeToken.eB + closeToken.hB;
		var match = {k: end, M: _List_Nil, p: start, r: text, al: textEnd, O: textStart, d0: type_};
		var matches = A2(
			$elm$core$List$map,
			function (_v0) {
				var matchModel = _v0;
				return A2($dillonkearns$elm_markdown$Markdown$InlineParser$prepareChildMatch, match, matchModel);
			},
			A4($dillonkearns$elm_markdown$Markdown$InlineParser$tokensToMatches, innerTokens, _List_Nil, references, rawText));
		return {k: end, M: matches, p: start, r: text, al: textEnd, O: textStart, d0: type_};
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$tokensToMatches = F4(
	function (tokens, matches, references, rawText) {
		return A5($dillonkearns$elm_markdown$Markdown$InlineParser$codeAutolinkTypeHtmlTagTTM, tokens, _List_Nil, matches, references, rawText);
	});
var $elm$core$String$trim = _String_trim;
var $dillonkearns$elm_markdown$Markdown$InlineParser$parse = F2(
	function (refs, rawText_) {
		var rawText = $elm$core$String$trim(rawText_);
		var tokens = $dillonkearns$elm_markdown$Markdown$InlineParser$tokenize(rawText);
		return $dillonkearns$elm_markdown$Markdown$InlineParser$matchesToInlines(
			A3(
				$dillonkearns$elm_markdown$Markdown$InlineParser$parseTextMatches,
				rawText,
				_List_Nil,
				$dillonkearns$elm_markdown$Markdown$InlineParser$organizeMatches(
					A4($dillonkearns$elm_markdown$Markdown$InlineParser$tokensToMatches, tokens, _List_Nil, refs, rawText))));
	});
var $dillonkearns$elm_markdown$Markdown$Parser$thisIsDefinitelyNotAnHtmlTag = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			$elm$parser$Parser$Advanced$token(
			A2(
				$elm$parser$Parser$Advanced$Token,
				' ',
				$elm$parser$Parser$Expecting(' '))),
			$elm$parser$Parser$Advanced$token(
			A2(
				$elm$parser$Parser$Advanced$Token,
				'>',
				$elm$parser$Parser$Expecting('>'))),
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$chompIf,
					$elm$core$Char$isAlpha,
					$elm$parser$Parser$Expecting('Alpha')),
				$elm$parser$Parser$Advanced$chompWhile(
					function (c) {
						return $elm$core$Char$isAlphaNum(c) || (c === '-');
					})),
			$elm$parser$Parser$Advanced$oneOf(
				_List_fromArray(
					[
						$elm$parser$Parser$Advanced$token(
						A2(
							$elm$parser$Parser$Advanced$Token,
							':',
							$elm$parser$Parser$Expecting(':'))),
						$elm$parser$Parser$Advanced$token(
						A2(
							$elm$parser$Parser$Advanced$Token,
							'@',
							$elm$parser$Parser$Expecting('@'))),
						$elm$parser$Parser$Advanced$token(
						A2(
							$elm$parser$Parser$Advanced$Token,
							'\\',
							$elm$parser$Parser$Expecting('\\'))),
						$elm$parser$Parser$Advanced$token(
						A2(
							$elm$parser$Parser$Advanced$Token,
							'+',
							$elm$parser$Parser$Expecting('+'))),
						$elm$parser$Parser$Advanced$token(
						A2(
							$elm$parser$Parser$Advanced$Token,
							'.',
							$elm$parser$Parser$Expecting('.')))
					])))
		]));
var $dillonkearns$elm_markdown$Markdown$Parser$parseAsParagraphInsteadOfHtmlBlock = $elm$parser$Parser$Advanced$backtrackable(
	A2(
		$elm$parser$Parser$Advanced$mapChompedString,
		F2(
			function (rawLine, _v0) {
				return $dillonkearns$elm_markdown$Markdown$RawBlock$OpenBlockOrParagraph(rawLine);
			}),
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$token(
						A2(
							$elm$parser$Parser$Advanced$Token,
							'<',
							$elm$parser$Parser$Expecting('<'))),
					$dillonkearns$elm_markdown$Markdown$Parser$thisIsDefinitelyNotAnHtmlTag),
				$dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd),
			$dillonkearns$elm_markdown$Helpers$lineEndOrEnd)));
var $dillonkearns$elm_markdown$Markdown$Table$TableHeader = $elm$core$Basics$identity;
var $dillonkearns$elm_markdown$Parser$Token$parseString = function (str) {
	return $elm$parser$Parser$Advanced$token(
		A2(
			$elm$parser$Parser$Advanced$Token,
			str,
			$elm$parser$Parser$Expecting(str)));
};
var $dillonkearns$elm_markdown$Markdown$TableParser$parseCellHelper = function (_v0) {
	var curr = _v0.a;
	var acc = _v0.b;
	var _return = A2(
		$elm$core$Maybe$withDefault,
		$elm$parser$Parser$Advanced$Done(acc),
		A2(
			$elm$core$Maybe$map,
			function (cell) {
				return $elm$parser$Parser$Advanced$Done(
					A2($elm$core$List$cons, cell, acc));
			},
			curr));
	var finishCell = A2(
		$elm$core$Maybe$withDefault,
		$elm$parser$Parser$Advanced$Loop(
			_Utils_Tuple2($elm$core$Maybe$Nothing, acc)),
		A2(
			$elm$core$Maybe$map,
			function (cell) {
				return $elm$parser$Parser$Advanced$Loop(
					_Utils_Tuple2(
						$elm$core$Maybe$Nothing,
						A2($elm$core$List$cons, cell, acc)));
			},
			curr));
	var addToCurrent = function (c) {
		return _Utils_ap(
			A2($elm$core$Maybe$withDefault, '', curr),
			c);
	};
	var continueCell = function (c) {
		return $elm$parser$Parser$Advanced$Loop(
			_Utils_Tuple2(
				$elm$core$Maybe$Just(
					addToCurrent(c)),
				acc));
	};
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$Advanced$map,
				function (_v1) {
					return _return;
				},
				$dillonkearns$elm_markdown$Parser$Token$parseString('|\n')),
				A2(
				$elm$parser$Parser$Advanced$map,
				function (_v2) {
					return _return;
				},
				$dillonkearns$elm_markdown$Parser$Token$parseString('\n')),
				A2(
				$elm$parser$Parser$Advanced$map,
				function (_v3) {
					return _return;
				},
				$elm$parser$Parser$Advanced$end(
					$elm$parser$Parser$Expecting('end'))),
				A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$backtrackable(
					$elm$parser$Parser$Advanced$succeed(
						continueCell('|'))),
				$dillonkearns$elm_markdown$Parser$Token$parseString('\\\\|')),
				A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$backtrackable(
					$elm$parser$Parser$Advanced$succeed(
						continueCell('\\'))),
				$dillonkearns$elm_markdown$Parser$Token$parseString('\\\\')),
				A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$backtrackable(
					$elm$parser$Parser$Advanced$succeed(
						continueCell('|'))),
				$dillonkearns$elm_markdown$Parser$Token$parseString('\\|')),
				A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$backtrackable(
					$elm$parser$Parser$Advanced$succeed(finishCell)),
				$dillonkearns$elm_markdown$Parser$Token$parseString('|')),
				A2(
				$elm$parser$Parser$Advanced$mapChompedString,
				F2(
					function (_char, _v4) {
						return continueCell(_char);
					}),
				A2(
					$elm$parser$Parser$Advanced$chompIf,
					$elm$core$Basics$always(true),
					$elm$parser$Parser$Problem('No character found')))
			]));
};
var $dillonkearns$elm_markdown$Markdown$TableParser$parseCells = A2(
	$elm$parser$Parser$Advanced$map,
	A2(
		$elm$core$List$foldl,
		F2(
			function (cell, acc) {
				return A2(
					$elm$core$List$cons,
					$elm$core$String$trim(cell),
					acc);
			}),
		_List_Nil),
	A2(
		$elm$parser$Parser$Advanced$loop,
		_Utils_Tuple2($elm$core$Maybe$Nothing, _List_Nil),
		$dillonkearns$elm_markdown$Markdown$TableParser$parseCellHelper));
var $dillonkearns$elm_markdown$Markdown$TableParser$rowParser = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
		$elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[
					$dillonkearns$elm_markdown$Parser$Token$parseString('|'),
					$elm$parser$Parser$Advanced$succeed(0)
				]))),
	$dillonkearns$elm_markdown$Markdown$TableParser$parseCells);
var $dillonkearns$elm_markdown$Markdown$TableParser$parseHeader = F2(
	function (_v0, headersRow) {
		var columnAlignments = _v0.b;
		var headersWithAlignment = function (headers) {
			return A3(
				$elm$core$List$map2,
				F2(
					function (headerCell, alignment) {
						return {fn: alignment, nC: headerCell};
					}),
				headers,
				columnAlignments);
		};
		var combineHeaderAndDelimiter = function (headers) {
			return _Utils_eq(
				$elm$core$List$length(headers),
				$elm$core$List$length(columnAlignments)) ? $elm$core$Result$Ok(
				headersWithAlignment(headers)) : $elm$core$Result$Err(
				'Tables must have the same number of header columns (' + ($elm$core$String$fromInt(
					$elm$core$List$length(headers)) + (') as delimiter columns (' + ($elm$core$String$fromInt(
					$elm$core$List$length(columnAlignments)) + ')'))));
		};
		var _v1 = A2($elm$parser$Parser$Advanced$run, $dillonkearns$elm_markdown$Markdown$TableParser$rowParser, headersRow);
		if (!_v1.$) {
			var headers = _v1.a;
			return combineHeaderAndDelimiter(headers);
		} else {
			return $elm$core$Result$Err('Unable to parse previous line as a table header');
		}
	});
var $dillonkearns$elm_markdown$Markdown$CodeBlock$CodeBlock = F2(
	function (language, body) {
		return {fv: body, hy: language};
	});
var $dillonkearns$elm_markdown$Markdown$CodeBlock$infoString = function (fenceCharacter) {
	var toInfoString = F2(
		function (str, _v2) {
			var _v1 = $elm$core$String$trim(str);
			if (_v1 === '') {
				return $elm$core$Maybe$Nothing;
			} else {
				var trimmed = _v1;
				return $elm$core$Maybe$Just(trimmed);
			}
		});
	var _v0 = fenceCharacter.eG;
	if (!_v0) {
		return A2(
			$elm$parser$Parser$Advanced$mapChompedString,
			toInfoString,
			$elm$parser$Parser$Advanced$chompWhile(
				function (c) {
					return (c !== '`') && (!$dillonkearns$elm_markdown$Whitespace$isLineEnd(c));
				}));
	} else {
		return A2(
			$elm$parser$Parser$Advanced$mapChompedString,
			toInfoString,
			$elm$parser$Parser$Advanced$chompWhile(
				A2($elm$core$Basics$composeL, $elm$core$Basics$not, $dillonkearns$elm_markdown$Whitespace$isLineEnd)));
	}
};
var $dillonkearns$elm_markdown$Markdown$CodeBlock$Backtick = 0;
var $dillonkearns$elm_markdown$Parser$Token$backtick = A2(
	$elm$parser$Parser$Advanced$Token,
	'`',
	$elm$parser$Parser$Expecting('a \'`\''));
var $dillonkearns$elm_markdown$Markdown$CodeBlock$backtick = {fx: '`', eG: 0, pC: $dillonkearns$elm_markdown$Parser$Token$backtick};
var $dillonkearns$elm_markdown$Markdown$CodeBlock$colToIndentation = function (_int) {
	switch (_int) {
		case 1:
			return $elm$parser$Parser$Advanced$succeed(0);
		case 2:
			return $elm$parser$Parser$Advanced$succeed(1);
		case 3:
			return $elm$parser$Parser$Advanced$succeed(2);
		case 4:
			return $elm$parser$Parser$Advanced$succeed(3);
		default:
			return $elm$parser$Parser$Advanced$problem(
				$elm$parser$Parser$Expecting('Fenced code blocks should be indented no more than 3 spaces'));
	}
};
var $dillonkearns$elm_markdown$Markdown$CodeBlock$fenceOfAtLeast = F2(
	function (minLength, fenceCharacter) {
		var builtTokens = A3(
			$elm$core$List$foldl,
			F2(
				function (t, p) {
					return A2($elm$parser$Parser$Advanced$ignorer, p, t);
				}),
			$elm$parser$Parser$Advanced$succeed(0),
			A2(
				$elm$core$List$repeat,
				minLength,
				$elm$parser$Parser$Advanced$token(fenceCharacter.pC)));
		return A2(
			$elm$parser$Parser$Advanced$mapChompedString,
			F2(
				function (str, _v0) {
					return _Utils_Tuple2(
						fenceCharacter,
						$elm$core$String$length(str));
				}),
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				builtTokens,
				$elm$parser$Parser$Advanced$chompWhile(
					$elm$core$Basics$eq(fenceCharacter.fx))));
	});
var $dillonkearns$elm_markdown$Markdown$CodeBlock$Tilde = 1;
var $dillonkearns$elm_markdown$Parser$Token$tilde = A2(
	$elm$parser$Parser$Advanced$Token,
	'~',
	$elm$parser$Parser$Expecting('a `~`'));
var $dillonkearns$elm_markdown$Markdown$CodeBlock$tilde = {fx: '~', eG: 1, pC: $dillonkearns$elm_markdown$Parser$Token$tilde};
var $dillonkearns$elm_markdown$Whitespace$upToThreeSpaces = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$dillonkearns$elm_markdown$Whitespace$space,
				$elm$parser$Parser$Advanced$oneOf(
					_List_fromArray(
						[
							$dillonkearns$elm_markdown$Whitespace$space,
							$elm$parser$Parser$Advanced$succeed(0)
						]))),
			$elm$parser$Parser$Advanced$oneOf(
				_List_fromArray(
					[
						$dillonkearns$elm_markdown$Whitespace$space,
						$elm$parser$Parser$Advanced$succeed(0)
					]))),
			$elm$parser$Parser$Advanced$succeed(0)
		]));
var $dillonkearns$elm_markdown$Markdown$CodeBlock$openingFence = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed(
				F2(
					function (indent, _v0) {
						var character = _v0.a;
						var length = _v0.b;
						return {fy: character, hs: indent, hB: length};
					})),
			$dillonkearns$elm_markdown$Whitespace$upToThreeSpaces),
		A2($elm$parser$Parser$Advanced$andThen, $dillonkearns$elm_markdown$Markdown$CodeBlock$colToIndentation, $elm$parser$Parser$Advanced$getCol)),
	$elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2($dillonkearns$elm_markdown$Markdown$CodeBlock$fenceOfAtLeast, 3, $dillonkearns$elm_markdown$Markdown$CodeBlock$backtick),
				A2($dillonkearns$elm_markdown$Markdown$CodeBlock$fenceOfAtLeast, 3, $dillonkearns$elm_markdown$Markdown$CodeBlock$tilde)
			])));
var $elm$parser$Parser$ExpectingEnd = {$: 10};
var $dillonkearns$elm_markdown$Whitespace$isSpace = $elm$core$Basics$eq(' ');
var $dillonkearns$elm_markdown$Markdown$CodeBlock$closingFence = F2(
	function (minLength, fenceCharacter) {
		return A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						$elm$parser$Parser$Advanced$succeed(0),
						$dillonkearns$elm_markdown$Whitespace$upToThreeSpaces),
					A2($dillonkearns$elm_markdown$Markdown$CodeBlock$fenceOfAtLeast, minLength, fenceCharacter)),
				$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isSpace)),
			$dillonkearns$elm_markdown$Helpers$lineEndOrEnd);
	});
var $dillonkearns$elm_markdown$Markdown$CodeBlock$codeBlockLine = function (indented) {
	return A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
			A2($dillonkearns$elm_markdown$Parser$Extra$upTo, indented, $dillonkearns$elm_markdown$Whitespace$space)),
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2($elm$parser$Parser$Advanced$ignorer, $elm$parser$Parser$Advanced$getOffset, $dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd),
			$dillonkearns$elm_markdown$Helpers$lineEndOrEnd));
};
var $elm$parser$Parser$Advanced$getSource = function (s) {
	return A3($elm$parser$Parser$Advanced$Good, false, s.$8, s);
};
var $dillonkearns$elm_markdown$Markdown$CodeBlock$remainingBlockHelp = function (_v0) {
	var fence = _v0.a;
	var body = _v0.b;
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed(
					$elm$parser$Parser$Advanced$Done(body)),
				$elm$parser$Parser$Advanced$end($elm$parser$Parser$ExpectingEnd)),
				A2(
				$elm$parser$Parser$Advanced$mapChompedString,
				F2(
					function (lineEnd, _v1) {
						return $elm$parser$Parser$Advanced$Loop(
							_Utils_Tuple2(
								fence,
								_Utils_ap(body, lineEnd)));
					}),
				$dillonkearns$elm_markdown$Whitespace$lineEnd),
				$elm$parser$Parser$Advanced$backtrackable(
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$succeed(
						$elm$parser$Parser$Advanced$Done(body)),
					A2($dillonkearns$elm_markdown$Markdown$CodeBlock$closingFence, fence.hB, fence.fy))),
				A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$keeper,
					A2(
						$elm$parser$Parser$Advanced$keeper,
						$elm$parser$Parser$Advanced$succeed(
							F3(
								function (start, end, source) {
									return $elm$parser$Parser$Advanced$Loop(
										_Utils_Tuple2(
											fence,
											_Utils_ap(
												body,
												A3($elm$core$String$slice, start, end, source))));
								})),
						$dillonkearns$elm_markdown$Markdown$CodeBlock$codeBlockLine(fence.hs)),
					$elm$parser$Parser$Advanced$getOffset),
				$elm$parser$Parser$Advanced$getSource)
			]));
};
var $dillonkearns$elm_markdown$Markdown$CodeBlock$remainingBlock = function (fence) {
	return A2(
		$elm$parser$Parser$Advanced$loop,
		_Utils_Tuple2(fence, ''),
		$dillonkearns$elm_markdown$Markdown$CodeBlock$remainingBlockHelp);
};
var $dillonkearns$elm_markdown$Markdown$CodeBlock$parser = A2(
	$elm$parser$Parser$Advanced$andThen,
	function (fence) {
		return A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$keeper,
				$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$CodeBlock$CodeBlock),
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$dillonkearns$elm_markdown$Markdown$CodeBlock$infoString(fence.fy),
					$dillonkearns$elm_markdown$Helpers$lineEndOrEnd)),
			$dillonkearns$elm_markdown$Markdown$CodeBlock$remainingBlock(fence));
	},
	$dillonkearns$elm_markdown$Markdown$CodeBlock$openingFence);
var $dillonkearns$elm_markdown$Markdown$Heading$dropTrailingHashes = function (headingString) {
	return A2($elm$core$String$endsWith, '#', headingString) ? $dillonkearns$elm_markdown$Markdown$Heading$dropTrailingHashes(
		A2($elm$core$String$dropRight, 1, headingString)) : headingString;
};
var $elm$core$String$trimRight = _String_trimRight;
var $dillonkearns$elm_markdown$Markdown$Heading$dropClosingSequence = function (headingString) {
	var droppedTrailingHashesString = $dillonkearns$elm_markdown$Markdown$Heading$dropTrailingHashes(headingString);
	return (A2($elm$core$String$endsWith, ' ', droppedTrailingHashesString) || $elm$core$String$isEmpty(droppedTrailingHashesString)) ? $elm$core$String$trimRight(droppedTrailingHashesString) : headingString;
};
var $dillonkearns$elm_markdown$Parser$Token$hash = A2(
	$elm$parser$Parser$Advanced$Token,
	'#',
	$elm$parser$Parser$Expecting('a `#`'));
var $dillonkearns$elm_markdown$Markdown$Heading$isHash = function (c) {
	if ('#' === c) {
		return true;
	} else {
		return false;
	}
};
var $elm$parser$Parser$Advanced$spaces = $elm$parser$Parser$Advanced$chompWhile(
	function (c) {
		return (c === ' ') || ((c === '\n') || (c === '\r'));
	});
var $dillonkearns$elm_markdown$Markdown$Heading$parser = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$RawBlock$Heading),
				A2(
					$elm$parser$Parser$Advanced$andThen,
					function (startingSpaces) {
						var startSpace = $elm$core$String$length(startingSpaces);
						return (startSpace >= 4) ? $elm$parser$Parser$Advanced$problem(
							$elm$parser$Parser$Expecting('heading with < 4 spaces in front')) : $elm$parser$Parser$Advanced$succeed(startSpace);
					},
					$elm$parser$Parser$Advanced$getChompedString($elm$parser$Parser$Advanced$spaces))),
			$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$hash)),
		A2(
			$elm$parser$Parser$Advanced$andThen,
			function (additionalHashes) {
				var level = $elm$core$String$length(additionalHashes) + 1;
				return (level >= 7) ? $elm$parser$Parser$Advanced$problem(
					$elm$parser$Parser$Expecting('heading with < 7 #\'s')) : $elm$parser$Parser$Advanced$succeed(level);
			},
			$elm$parser$Parser$Advanced$getChompedString(
				$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Markdown$Heading$isHash)))),
	$elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed(''),
				$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$newline)),
				A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
					$elm$parser$Parser$Advanced$oneOf(
						_List_fromArray(
							[
								$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$space),
								$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$tab)
							]))),
				A2(
					$elm$parser$Parser$Advanced$mapChompedString,
					F2(
						function (headingText, _v0) {
							return $dillonkearns$elm_markdown$Markdown$Heading$dropClosingSequence(
								$elm$core$String$trim(headingText));
						}),
					$dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd))
			])));
var $elm$parser$Parser$Advanced$findSubString = _Parser_findSubString;
var $elm$parser$Parser$Advanced$fromInfo = F4(
	function (row, col, x, context) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, row, col, x, context));
	});
var $elm$parser$Parser$Advanced$chompUntil = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$findSubString, str, s.d, s.o6, s.i3, s.$8);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A4($elm$parser$Parser$Advanced$fromInfo, newRow, newCol, expecting, s.i)) : A3(
			$elm$parser$Parser$Advanced$Good,
			_Utils_cmp(s.d, newOffset) < 0,
			0,
			{i3: newCol, i: s.i, o: s.o, d: newOffset, o6: newRow, $8: s.$8});
	};
};
var $dillonkearns$elm_markdown$Parser$Token$greaterThan = A2(
	$elm$parser$Parser$Advanced$Token,
	'>',
	$elm$parser$Parser$Expecting('a `>`'));
var $elm$parser$Parser$Advanced$Located = F3(
	function (row, col, context) {
		return {i3: col, i: context, o6: row};
	});
var $elm$parser$Parser$Advanced$changeContext = F2(
	function (newContext, s) {
		return {i3: s.i3, i: newContext, o: s.o, d: s.d, o6: s.o6, $8: s.$8};
	});
var $elm$parser$Parser$Advanced$inContext = F2(
	function (context, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(
				A2(
					$elm$parser$Parser$Advanced$changeContext,
					A2(
						$elm$core$List$cons,
						A3($elm$parser$Parser$Advanced$Located, s0.o6, s0.i3, context),
						s0.i),
					s0));
			if (!_v1.$) {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					a,
					A2($elm$parser$Parser$Advanced$changeContext, s0.i, s1));
			} else {
				var step = _v1;
				return step;
			}
		};
	});
var $dillonkearns$elm_markdown$Whitespace$isWhitespace = function (_char) {
	switch (_char) {
		case ' ':
			return true;
		case '\n':
			return true;
		case '\t':
			return true;
		case '\u000B':
			return true;
		case '\u000C':
			return true;
		case '\r':
			return true;
		default:
			return false;
	}
};
var $dillonkearns$elm_markdown$Parser$Token$lessThan = A2(
	$elm$parser$Parser$Advanced$Token,
	'<',
	$elm$parser$Parser$Expecting('a `<`'));
var $dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$destinationParser = A2(
	$elm$parser$Parser$Advanced$inContext,
	'link destination',
	$elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$succeed($elm$url$Url$percentEncode),
					$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$lessThan)),
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$getChompedString(
						$elm$parser$Parser$Advanced$chompUntil($dillonkearns$elm_markdown$Parser$Token$greaterThan)),
					$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$greaterThan))),
				$elm$parser$Parser$Advanced$getChompedString(
				$dillonkearns$elm_markdown$Parser$Extra$chompOneOrMore(
					A2($elm$core$Basics$composeL, $elm$core$Basics$not, $dillonkearns$elm_markdown$Whitespace$isWhitespace)))
			])));
var $dillonkearns$elm_markdown$Parser$Token$closingSquareBracket = A2(
	$elm$parser$Parser$Advanced$Token,
	']',
	$elm$parser$Parser$Expecting('a `]`'));
var $dillonkearns$elm_markdown$Parser$Token$openingSquareBracket = A2(
	$elm$parser$Parser$Advanced$Token,
	'[',
	$elm$parser$Parser$Expecting('a `[`'));
var $dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$labelParser = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$Helpers$prepareRefLabel),
		$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$openingSquareBracket)),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$getChompedString(
			$elm$parser$Parser$Advanced$chompUntil($dillonkearns$elm_markdown$Parser$Token$closingSquareBracket)),
		$elm$parser$Parser$Advanced$symbol(
			A2(
				$elm$parser$Parser$Advanced$Token,
				']:',
				$elm$parser$Parser$Expecting(']:')))));
var $dillonkearns$elm_markdown$Parser$Token$doubleQuote = A2(
	$elm$parser$Parser$Advanced$Token,
	'\"',
	$elm$parser$Parser$Expecting('a double quote'));
var $dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$hasNoBlankLine = function (str) {
	return A2($elm$core$String$contains, '\n\n', str) ? $elm$parser$Parser$Advanced$problem(
		$elm$parser$Parser$Expecting('no blank line')) : $elm$parser$Parser$Advanced$succeed(str);
};
var $dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$onlyWhitespaceTillNewline = A2(
	$elm$parser$Parser$Advanced$ignorer,
	$elm$parser$Parser$Advanced$chompWhile(
		function (c) {
			return (!$dillonkearns$elm_markdown$Whitespace$isLineEnd(c)) && $dillonkearns$elm_markdown$Whitespace$isWhitespace(c);
		}),
	$dillonkearns$elm_markdown$Helpers$lineEndOrEnd);
var $dillonkearns$elm_markdown$Whitespace$requiredWhitespace = A2(
	$elm$parser$Parser$Advanced$ignorer,
	A2(
		$elm$parser$Parser$Advanced$chompIf,
		$dillonkearns$elm_markdown$Whitespace$isWhitespace,
		$elm$parser$Parser$Expecting('Required whitespace')),
	$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isWhitespace));
var $dillonkearns$elm_markdown$Parser$Token$singleQuote = A2(
	$elm$parser$Parser$Advanced$Token,
	'\'',
	$elm$parser$Parser$Expecting('a single quote'));
var $dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$titleParser = function () {
	var inSingleQuotes = A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed($elm$core$Maybe$Just),
			$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$singleQuote)),
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$andThen,
					$dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$hasNoBlankLine,
					$elm$parser$Parser$Advanced$getChompedString(
						$elm$parser$Parser$Advanced$chompUntil($dillonkearns$elm_markdown$Parser$Token$singleQuote))),
				$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$singleQuote)),
			$dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$onlyWhitespaceTillNewline));
	var inDoubleQuotes = A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed($elm$core$Maybe$Just),
			$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$doubleQuote)),
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$andThen,
					$dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$hasNoBlankLine,
					$elm$parser$Parser$Advanced$getChompedString(
						$elm$parser$Parser$Advanced$chompUntil($dillonkearns$elm_markdown$Parser$Token$doubleQuote))),
				$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$doubleQuote)),
			$dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$onlyWhitespaceTillNewline));
	return A2(
		$elm$parser$Parser$Advanced$inContext,
		'title',
		$elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$Advanced$backtrackable(
					A2(
						$elm$parser$Parser$Advanced$keeper,
						A2(
							$elm$parser$Parser$Advanced$ignorer,
							$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
							$dillonkearns$elm_markdown$Whitespace$requiredWhitespace),
						$elm$parser$Parser$Advanced$oneOf(
							_List_fromArray(
								[
									inDoubleQuotes,
									inSingleQuotes,
									$elm$parser$Parser$Advanced$succeed($elm$core$Maybe$Nothing)
								])))),
					A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$succeed($elm$core$Maybe$Nothing),
					$dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$onlyWhitespaceTillNewline)
				])));
}();
var $dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$parser = A2(
	$elm$parser$Parser$Advanced$inContext,
	'link reference definition',
	A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$succeed(
						F3(
							function (label, destination, title) {
								return _Utils_Tuple2(
									label,
									{je: destination, fb: title});
							})),
					$dillonkearns$elm_markdown$Whitespace$upToThreeSpaces),
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						A2(
							$elm$parser$Parser$Advanced$ignorer,
							$dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$labelParser,
							$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab)),
						$elm$parser$Parser$Advanced$oneOf(
							_List_fromArray(
								[
									$dillonkearns$elm_markdown$Whitespace$lineEnd,
									$elm$parser$Parser$Advanced$succeed(0)
								]))),
					$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab))),
			$dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$destinationParser),
		$dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$titleParser));
var $dillonkearns$elm_markdown$ThematicBreak$ThematicBreak = 0;
var $dillonkearns$elm_markdown$ThematicBreak$whitespace = $elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab);
var $dillonkearns$elm_markdown$ThematicBreak$withChar = function (tchar) {
	var token = $dillonkearns$elm_markdown$Parser$Token$parseString(
		$elm$core$String$fromChar(tchar));
	return A2(
		$elm$parser$Parser$Advanced$ignorer,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						A2(
							$elm$parser$Parser$Advanced$ignorer,
							A2(
								$elm$parser$Parser$Advanced$ignorer,
								$elm$parser$Parser$Advanced$succeed(0),
								token),
							$dillonkearns$elm_markdown$ThematicBreak$whitespace),
						token),
					$dillonkearns$elm_markdown$ThematicBreak$whitespace),
				token),
			$elm$parser$Parser$Advanced$chompWhile(
				function (c) {
					return _Utils_eq(c, tchar) || $dillonkearns$elm_markdown$Whitespace$isSpaceOrTab(c);
				})),
		$dillonkearns$elm_markdown$Helpers$lineEndOrEnd);
};
var $dillonkearns$elm_markdown$ThematicBreak$parseThematicBreak = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			$dillonkearns$elm_markdown$ThematicBreak$withChar('-'),
			$dillonkearns$elm_markdown$ThematicBreak$withChar('*'),
			$dillonkearns$elm_markdown$ThematicBreak$withChar('_')
		]));
var $dillonkearns$elm_markdown$ThematicBreak$parser = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
						$dillonkearns$elm_markdown$Whitespace$space),
					$elm$parser$Parser$Advanced$oneOf(
						_List_fromArray(
							[
								$dillonkearns$elm_markdown$Whitespace$space,
								$elm$parser$Parser$Advanced$succeed(0)
							]))),
				$elm$parser$Parser$Advanced$oneOf(
					_List_fromArray(
						[
							$dillonkearns$elm_markdown$Whitespace$space,
							$elm$parser$Parser$Advanced$succeed(0)
						]))),
			$dillonkearns$elm_markdown$ThematicBreak$parseThematicBreak),
			$dillonkearns$elm_markdown$ThematicBreak$parseThematicBreak
		]));
var $dillonkearns$elm_markdown$Markdown$RawBlock$LevelOne = 0;
var $dillonkearns$elm_markdown$Markdown$RawBlock$LevelTwo = 1;
var $dillonkearns$elm_markdown$Markdown$RawBlock$SetextLine = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Parser$Token$equals = A2(
	$elm$parser$Parser$Advanced$Token,
	'=',
	$elm$parser$Parser$Expecting('a `=`'));
var $dillonkearns$elm_markdown$Parser$Token$minus = A2(
	$elm$parser$Parser$Advanced$Token,
	'-',
	$elm$parser$Parser$Expecting('a `-`'));
var $dillonkearns$elm_markdown$Markdown$Parser$setextLineParser = function () {
	var setextLevel = F3(
		function (level, levelToken, levelChar) {
			return A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$succeed(level),
					$elm$parser$Parser$Advanced$token(levelToken)),
				$elm$parser$Parser$Advanced$chompWhile(
					$elm$core$Basics$eq(levelChar)));
		});
	return A2(
		$elm$parser$Parser$Advanced$mapChompedString,
		F2(
			function (raw, level) {
				return A2($dillonkearns$elm_markdown$Markdown$RawBlock$SetextLine, level, raw);
			}),
		A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
				$dillonkearns$elm_markdown$Whitespace$upToThreeSpaces),
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$oneOf(
						_List_fromArray(
							[
								A3(setextLevel, 0, $dillonkearns$elm_markdown$Parser$Token$equals, '='),
								A3(setextLevel, 1, $dillonkearns$elm_markdown$Parser$Token$minus, '-')
							])),
					$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab)),
				$dillonkearns$elm_markdown$Helpers$lineEndOrEnd)));
}();
var $dillonkearns$elm_markdown$Markdown$RawBlock$TableDelimiter = function (a) {
	return {$: 9, a: a};
};
var $dillonkearns$elm_markdown$Markdown$TableParser$chompSinglelineWhitespace = $elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab);
var $dillonkearns$elm_markdown$Parser$Extra$maybeChomp = function (condition) {
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$Advanced$chompIf,
				condition,
				$elm$parser$Parser$Problem('Character not found')),
				$elm$parser$Parser$Advanced$succeed(0)
			]));
};
var $dillonkearns$elm_markdown$Markdown$TableParser$requirePipeIfNotFirst = function (columns) {
	return $elm$core$List$isEmpty(columns) ? $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				$dillonkearns$elm_markdown$Parser$Token$parseString('|'),
				$elm$parser$Parser$Advanced$succeed(0)
			])) : $dillonkearns$elm_markdown$Parser$Token$parseString('|');
};
var $dillonkearns$elm_markdown$Markdown$TableParser$delimiterRowHelp = function (revDelimiterColumns) {
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				$elm$parser$Parser$Advanced$backtrackable(
				A2(
					$elm$parser$Parser$Advanced$map,
					function (_v0) {
						return $elm$parser$Parser$Advanced$Done(revDelimiterColumns);
					},
					$dillonkearns$elm_markdown$Parser$Token$parseString('|\n'))),
				A2(
				$elm$parser$Parser$Advanced$map,
				function (_v1) {
					return $elm$parser$Parser$Advanced$Done(revDelimiterColumns);
				},
				$dillonkearns$elm_markdown$Parser$Token$parseString('\n')),
				A2(
				$elm$parser$Parser$Advanced$map,
				function (_v2) {
					return $elm$parser$Parser$Advanced$Done(revDelimiterColumns);
				},
				$elm$parser$Parser$Advanced$end(
					$elm$parser$Parser$Expecting('end'))),
				$elm$parser$Parser$Advanced$backtrackable(
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						$elm$parser$Parser$Advanced$succeed(
							$elm$parser$Parser$Advanced$Done(revDelimiterColumns)),
						$dillonkearns$elm_markdown$Parser$Token$parseString('|')),
					$elm$parser$Parser$Advanced$end(
						$elm$parser$Parser$Expecting('end')))),
				A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						$elm$parser$Parser$Advanced$succeed(
							function (column) {
								return $elm$parser$Parser$Advanced$Loop(
									A2($elm$core$List$cons, column, revDelimiterColumns));
							}),
						$dillonkearns$elm_markdown$Markdown$TableParser$requirePipeIfNotFirst(revDelimiterColumns)),
					$dillonkearns$elm_markdown$Markdown$TableParser$chompSinglelineWhitespace),
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$getChompedString(
						A2(
							$elm$parser$Parser$Advanced$ignorer,
							A2(
								$elm$parser$Parser$Advanced$ignorer,
								A2(
									$elm$parser$Parser$Advanced$ignorer,
									$elm$parser$Parser$Advanced$succeed(0),
									$dillonkearns$elm_markdown$Parser$Extra$maybeChomp(
										function (c) {
											return c === ':';
										})),
								$dillonkearns$elm_markdown$Parser$Extra$chompOneOrMore(
									function (c) {
										return c === '-';
									})),
							$dillonkearns$elm_markdown$Parser$Extra$maybeChomp(
								function (c) {
									return c === ':';
								}))),
					$dillonkearns$elm_markdown$Markdown$TableParser$chompSinglelineWhitespace))
			]));
};
var $dillonkearns$elm_markdown$Markdown$Block$AlignCenter = 2;
var $dillonkearns$elm_markdown$Markdown$Block$AlignLeft = 0;
var $dillonkearns$elm_markdown$Markdown$Block$AlignRight = 1;
var $dillonkearns$elm_markdown$Markdown$TableParser$delimiterToAlignment = function (cell) {
	var _v0 = _Utils_Tuple2(
		A2($elm$core$String$startsWith, ':', cell),
		A2($elm$core$String$endsWith, ':', cell));
	if (_v0.a) {
		if (_v0.b) {
			return $elm$core$Maybe$Just(2);
		} else {
			return $elm$core$Maybe$Just(0);
		}
	} else {
		if (_v0.b) {
			return $elm$core$Maybe$Just(1);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}
};
var $dillonkearns$elm_markdown$Markdown$TableParser$delimiterRowParser = A2(
	$elm$parser$Parser$Advanced$andThen,
	function (delimiterRow) {
		var trimmed = delimiterRow.a.lw;
		var headers = delimiterRow.b;
		return $elm$core$List$isEmpty(headers) ? $elm$parser$Parser$Advanced$problem(
			$elm$parser$Parser$Expecting('Must have at least one column in delimiter row.')) : ((($elm$core$List$length(headers) === 1) && (!(A2($elm$core$String$startsWith, '|', trimmed) && A2($elm$core$String$endsWith, '|', trimmed)))) ? $elm$parser$Parser$Advanced$problem(
			$elm$parser$Parser$Problem('Tables with a single column must have pipes at the start and end of the delimiter row to avoid ambiguity.')) : $elm$parser$Parser$Advanced$succeed(delimiterRow));
	},
	A2(
		$elm$parser$Parser$Advanced$mapChompedString,
		F2(
			function (delimiterText, revDelimiterColumns) {
				return A2(
					$dillonkearns$elm_markdown$Markdown$Table$TableDelimiterRow,
					{
						kO: delimiterText,
						lw: $elm$core$String$trim(delimiterText)
					},
					A2(
						$elm$core$List$map,
						$dillonkearns$elm_markdown$Markdown$TableParser$delimiterToAlignment,
						$elm$core$List$reverse(revDelimiterColumns)));
			}),
		A2($elm$parser$Parser$Advanced$loop, _List_Nil, $dillonkearns$elm_markdown$Markdown$TableParser$delimiterRowHelp)));
var $dillonkearns$elm_markdown$Markdown$Parser$tableDelimiterInOpenParagraph = A2($elm$parser$Parser$Advanced$map, $dillonkearns$elm_markdown$Markdown$RawBlock$TableDelimiter, $dillonkearns$elm_markdown$Markdown$TableParser$delimiterRowParser);
var $elm$core$List$all = F2(
	function (isOkay, list) {
		return !A2(
			$elm$core$List$any,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, isOkay),
			list);
	});
var $dillonkearns$elm_markdown$Markdown$TableParser$standardizeRowLength = F2(
	function (expectedLength, row) {
		var rowLength = $elm$core$List$length(row);
		var _v0 = A2($elm$core$Basics$compare, expectedLength, rowLength);
		switch (_v0) {
			case 0:
				return A2($elm$core$List$take, expectedLength, row);
			case 1:
				return row;
			default:
				return _Utils_ap(
					row,
					A2($elm$core$List$repeat, expectedLength - rowLength, ''));
		}
	});
var $dillonkearns$elm_markdown$Markdown$TableParser$bodyRowParser = function (expectedRowLength) {
	return A2(
		$elm$parser$Parser$Advanced$andThen,
		function (row) {
			return ($elm$core$List$isEmpty(row) || A2($elm$core$List$all, $elm$core$String$isEmpty, row)) ? $elm$parser$Parser$Advanced$problem(
				$elm$parser$Parser$Problem('A line must have at least one column')) : $elm$parser$Parser$Advanced$succeed(
				A2($dillonkearns$elm_markdown$Markdown$TableParser$standardizeRowLength, expectedRowLength, row));
		},
		$dillonkearns$elm_markdown$Markdown$TableParser$rowParser);
};
var $dillonkearns$elm_markdown$Markdown$Parser$tableRowIfTableStarted = function (_v0) {
	var headers = _v0.a;
	var body = _v0.b;
	return A2(
		$elm$parser$Parser$Advanced$map,
		function (row) {
			return $dillonkearns$elm_markdown$Markdown$RawBlock$Table(
				A2(
					$dillonkearns$elm_markdown$Markdown$Table$Table,
					headers,
					_Utils_ap(
						body,
						_List_fromArray(
							[row]))));
		},
		$dillonkearns$elm_markdown$Markdown$TableParser$bodyRowParser(
			$elm$core$List$length(headers)));
};
var $dillonkearns$elm_markdown$Markdown$Block$H1 = 0;
var $dillonkearns$elm_markdown$Markdown$Block$H2 = 1;
var $dillonkearns$elm_markdown$Markdown$Block$H3 = 2;
var $dillonkearns$elm_markdown$Markdown$Block$H4 = 3;
var $dillonkearns$elm_markdown$Markdown$Block$H5 = 4;
var $dillonkearns$elm_markdown$Markdown$Block$H6 = 5;
var $dillonkearns$elm_markdown$Markdown$Parser$toHeading = function (level) {
	switch (level) {
		case 1:
			return $elm$core$Result$Ok(0);
		case 2:
			return $elm$core$Result$Ok(1);
		case 3:
			return $elm$core$Result$Ok(2);
		case 4:
			return $elm$core$Result$Ok(3);
		case 5:
			return $elm$core$Result$Ok(4);
		case 6:
			return $elm$core$Result$Ok(5);
		default:
			return $elm$core$Result$Err(
				$elm$parser$Parser$Expecting(
					'A heading with 1 to 6 #\'s, but found ' + $elm$core$String$fromInt(level)));
	}
};
var $dillonkearns$elm_markdown$Markdown$ListItem$EmptyItem = {$: 2};
var $dillonkearns$elm_markdown$Markdown$ListItem$PlainItem = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_markdown$Markdown$ListItem$TaskItem = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$UnorderedList$getIntendedCodeItem = F4(
	function (markerStartPos, listMarker, markerEndPos, _v0) {
		var bodyStartPos = _v0.a;
		var item = _v0.b;
		var spaceNum = bodyStartPos - markerEndPos;
		if (spaceNum <= 4) {
			return _Utils_Tuple3(listMarker, bodyStartPos - markerStartPos, item);
		} else {
			var intendedCodeItem = function () {
				switch (item.$) {
					case 0:
						var completion = item.a;
						var string = item.b;
						return A2(
							$dillonkearns$elm_markdown$Markdown$ListItem$TaskItem,
							completion,
							_Utils_ap(
								A2($elm$core$String$repeat, spaceNum - 1, ' '),
								string));
					case 1:
						var string = item.a;
						return $dillonkearns$elm_markdown$Markdown$ListItem$PlainItem(
							_Utils_ap(
								A2($elm$core$String$repeat, spaceNum - 1, ' '),
								string));
					default:
						return $dillonkearns$elm_markdown$Markdown$ListItem$EmptyItem;
				}
			}();
			return _Utils_Tuple3(listMarker, (markerEndPos - markerStartPos) + 1, intendedCodeItem);
		}
	});
var $dillonkearns$elm_markdown$Markdown$UnorderedList$unorderedListEmptyItemParser = A2(
	$elm$parser$Parser$Advanced$keeper,
	$elm$parser$Parser$Advanced$succeed(
		function (bodyStartPos) {
			return _Utils_Tuple2(bodyStartPos, $dillonkearns$elm_markdown$Markdown$ListItem$EmptyItem);
		}),
	A2($elm$parser$Parser$Advanced$ignorer, $elm$parser$Parser$Advanced$getCol, $dillonkearns$elm_markdown$Helpers$lineEndOrEnd));
var $dillonkearns$elm_markdown$Markdown$ListItem$Complete = 1;
var $dillonkearns$elm_markdown$Markdown$ListItem$Incomplete = 0;
var $dillonkearns$elm_markdown$Markdown$ListItem$taskItemParser = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed(1),
			$elm$parser$Parser$Advanced$symbol(
				A2(
					$elm$parser$Parser$Advanced$Token,
					'[x] ',
					$elm$parser$Parser$ExpectingSymbol('[x] ')))),
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed(1),
			$elm$parser$Parser$Advanced$symbol(
				A2(
					$elm$parser$Parser$Advanced$Token,
					'[X] ',
					$elm$parser$Parser$ExpectingSymbol('[X] ')))),
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed(0),
			$elm$parser$Parser$Advanced$symbol(
				A2(
					$elm$parser$Parser$Advanced$Token,
					'[ ] ',
					$elm$parser$Parser$ExpectingSymbol('[ ] '))))
		]));
var $dillonkearns$elm_markdown$Markdown$ListItem$parser = A2(
	$elm$parser$Parser$Advanced$keeper,
	$elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$Advanced$keeper,
				$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$ListItem$TaskItem),
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$dillonkearns$elm_markdown$Markdown$ListItem$taskItemParser,
					$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab))),
				$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$ListItem$PlainItem)
			])),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$getChompedString($dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd),
		$dillonkearns$elm_markdown$Helpers$lineEndOrEnd));
var $dillonkearns$elm_markdown$Markdown$UnorderedList$unorderedListItemBodyParser = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed(
				F2(
					function (bodyStartPos, item) {
						return _Utils_Tuple2(bodyStartPos, item);
					})),
			$dillonkearns$elm_markdown$Parser$Extra$chompOneOrMore($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab)),
		$elm$parser$Parser$Advanced$getCol),
	$dillonkearns$elm_markdown$Markdown$ListItem$parser);
var $dillonkearns$elm_markdown$Markdown$UnorderedList$Asterisk = 2;
var $dillonkearns$elm_markdown$Markdown$UnorderedList$Minus = 0;
var $dillonkearns$elm_markdown$Markdown$UnorderedList$Plus = 1;
var $dillonkearns$elm_markdown$Markdown$UnorderedList$unorderedListMarkerParser = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed(0),
				A2($dillonkearns$elm_markdown$Parser$Extra$upTo, 3, $dillonkearns$elm_markdown$Whitespace$space)),
			$elm$parser$Parser$Advanced$symbol(
				A2(
					$elm$parser$Parser$Advanced$Token,
					'-',
					$elm$parser$Parser$ExpectingSymbol('-')))),
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed(1),
			$elm$parser$Parser$Advanced$symbol(
				A2(
					$elm$parser$Parser$Advanced$Token,
					'+',
					$elm$parser$Parser$ExpectingSymbol('+')))),
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed(2),
			$elm$parser$Parser$Advanced$symbol(
				A2(
					$elm$parser$Parser$Advanced$Token,
					'*',
					$elm$parser$Parser$ExpectingSymbol('*'))))
		]));
var $dillonkearns$elm_markdown$Markdown$UnorderedList$parser = function (previousWasBody) {
	return A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$keeper,
					$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$UnorderedList$getIntendedCodeItem),
					$elm$parser$Parser$Advanced$getCol),
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$UnorderedList$unorderedListMarkerParser)),
			$elm$parser$Parser$Advanced$getCol),
		previousWasBody ? $dillonkearns$elm_markdown$Markdown$UnorderedList$unorderedListItemBodyParser : $elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[$dillonkearns$elm_markdown$Markdown$UnorderedList$unorderedListEmptyItemParser, $dillonkearns$elm_markdown$Markdown$UnorderedList$unorderedListItemBodyParser])));
};
var $dillonkearns$elm_markdown$Markdown$Parser$unorderedListBlock = function (previousWasBody) {
	var parseListItem = F3(
		function (listmarker, intended, unparsedListItem) {
			switch (unparsedListItem.$) {
				case 0:
					var completion = unparsedListItem.a;
					var body = unparsedListItem.b;
					return {
						fv: body,
						nP: listmarker,
						B: $elm$core$Maybe$Just(
							function () {
								if (completion === 1) {
									return true;
								} else {
									return false;
								}
							}())
					};
				case 1:
					var body = unparsedListItem.a;
					return {fv: body, nP: listmarker, B: $elm$core$Maybe$Nothing};
				default:
					return {fv: '', nP: listmarker, B: $elm$core$Maybe$Nothing};
			}
		});
	return A2(
		$elm$parser$Parser$Advanced$map,
		function (_v0) {
			var listmarker = _v0.a;
			var intended = _v0.b;
			var unparsedListItem = _v0.c;
			return A4(
				$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
				true,
				intended,
				_List_Nil,
				A3(parseListItem, listmarker, intended, unparsedListItem));
		},
		$dillonkearns$elm_markdown$Markdown$UnorderedList$parser(previousWasBody));
};
var $elm$core$Result$withDefault = F2(
	function (def, result) {
		if (!result.$) {
			var a = result.a;
			return a;
		} else {
			return def;
		}
	});
var $dillonkearns$elm_markdown$Markdown$Parser$childToBlocks = F2(
	function (node, blocks) {
		switch (node.$) {
			case 0:
				var tag = node.a;
				var attributes = node.b;
				var children = node.c;
				var _v99 = $dillonkearns$elm_markdown$Markdown$Parser$nodesToBlocks(children);
				if (!_v99.$) {
					var childrenAsBlocks = _v99.a;
					var block = $dillonkearns$elm_markdown$Markdown$Block$HtmlBlock(
						A3($dillonkearns$elm_markdown$Markdown$Block$HtmlElement, tag, attributes, childrenAsBlocks));
					return $elm$core$Result$Ok(
						A2($elm$core$List$cons, block, blocks));
				} else {
					var err = _v99.a;
					return $elm$core$Result$Err(err);
				}
			case 1:
				var innerText = node.a;
				var _v100 = $dillonkearns$elm_markdown$Markdown$Parser$parse(innerText);
				if (!_v100.$) {
					var value = _v100.a;
					return $elm$core$Result$Ok(
						_Utils_ap(
							$elm$core$List$reverse(value),
							blocks));
				} else {
					var error = _v100.a;
					return $elm$core$Result$Err(
						$elm$parser$Parser$Expecting(
							A2(
								$elm$core$String$join,
								'\n',
								A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Parser$deadEndToString, error))));
				}
			case 2:
				var string = node.a;
				return $elm$core$Result$Ok(
					A2(
						$elm$core$List$cons,
						$dillonkearns$elm_markdown$Markdown$Block$HtmlBlock(
							$dillonkearns$elm_markdown$Markdown$Block$HtmlComment(string)),
						blocks));
			case 3:
				var string = node.a;
				return $elm$core$Result$Ok(
					A2(
						$elm$core$List$cons,
						$dillonkearns$elm_markdown$Markdown$Block$HtmlBlock(
							$dillonkearns$elm_markdown$Markdown$Block$Cdata(string)),
						blocks));
			case 4:
				var string = node.a;
				return $elm$core$Result$Ok(
					A2(
						$elm$core$List$cons,
						$dillonkearns$elm_markdown$Markdown$Block$HtmlBlock(
							$dillonkearns$elm_markdown$Markdown$Block$ProcessingInstruction(string)),
						blocks));
			default:
				var declarationType = node.a;
				var content = node.b;
				return $elm$core$Result$Ok(
					A2(
						$elm$core$List$cons,
						$dillonkearns$elm_markdown$Markdown$Block$HtmlBlock(
							A2($dillonkearns$elm_markdown$Markdown$Block$HtmlDeclaration, declarationType, content)),
						blocks));
		}
	});
var $dillonkearns$elm_markdown$Markdown$Parser$completeBlocks = function (state) {
	var _v84 = state.b;
	_v84$5:
	while (true) {
		if (_v84.b) {
			switch (_v84.a.$) {
				case 11:
					var body2 = _v84.a.a;
					var rest = _v84.b;
					var _v85 = A2(
						$elm$parser$Parser$Advanced$run,
						$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
						body2);
					if (!_v85.$) {
						var value = _v85.a;
						return $elm$parser$Parser$Advanced$succeed(
							{
								a: _Utils_ap(state.a, value.a),
								b: A2(
									$elm$core$List$cons,
									$dillonkearns$elm_markdown$Markdown$RawBlock$ParsedBlockQuote(value.b),
									rest)
							});
					} else {
						var error = _v85.a;
						return $elm$parser$Parser$Advanced$problem(
							$elm$parser$Parser$Problem(
								$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(error)));
					}
				case 3:
					var _v86 = _v84.a;
					var tight = _v86.a;
					var intended = _v86.b;
					var closeListItems = _v86.c;
					var openListItem = _v86.d;
					var rest = _v84.b;
					var _v87 = A2(
						$elm$parser$Parser$Advanced$run,
						$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
						openListItem.fv);
					if (!_v87.$) {
						var value = _v87.a;
						var tight2 = A2($elm$core$List$member, $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.b) ? false : tight;
						return $elm$parser$Parser$Advanced$succeed(
							{
								a: _Utils_ap(state.a, value.a),
								b: A2(
									$elm$core$List$cons,
									A4(
										$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
										tight2,
										intended,
										A2(
											$elm$core$List$cons,
											{fv: value.b, B: openListItem.B},
											closeListItems),
										openListItem),
									rest)
							});
					} else {
						var e = _v87.a;
						return $elm$parser$Parser$Advanced$problem(
							$elm$parser$Parser$Problem(
								$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
					}
				case 4:
					var _v92 = _v84.a;
					var tight = _v92.a;
					var intended = _v92.b;
					var marker = _v92.c;
					var order = _v92.d;
					var closeListItems = _v92.e;
					var openListItem = _v92.f;
					var rest = _v84.b;
					var _v93 = A2(
						$elm$parser$Parser$Advanced$run,
						$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
						openListItem);
					if (!_v93.$) {
						var value = _v93.a;
						var tight2 = A2($elm$core$List$member, $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.b) ? false : tight;
						return $elm$parser$Parser$Advanced$succeed(
							{
								a: _Utils_ap(state.a, value.a),
								b: A2(
									$elm$core$List$cons,
									A6(
										$dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock,
										tight2,
										intended,
										marker,
										order,
										A2($elm$core$List$cons, value.b, closeListItems),
										openListItem),
									rest)
							});
					} else {
						var e = _v93.a;
						return $elm$parser$Parser$Advanced$problem(
							$elm$parser$Parser$Problem(
								$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
					}
				case 10:
					if (_v84.b.b) {
						switch (_v84.b.a.$) {
							case 3:
								var _v88 = _v84.a;
								var _v89 = _v84.b;
								var _v90 = _v89.a;
								var tight = _v90.a;
								var intended = _v90.b;
								var closeListItems = _v90.c;
								var openListItem = _v90.d;
								var rest = _v89.b;
								var _v91 = A2(
									$elm$parser$Parser$Advanced$run,
									$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
									openListItem.fv);
								if (!_v91.$) {
									var value = _v91.a;
									var tight2 = A2($elm$core$List$member, $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.b) ? false : tight;
									return $elm$parser$Parser$Advanced$succeed(
										{
											a: _Utils_ap(state.a, value.a),
											b: A2(
												$elm$core$List$cons,
												A4(
													$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
													tight2,
													intended,
													A2(
														$elm$core$List$cons,
														{fv: value.b, B: openListItem.B},
														closeListItems),
													openListItem),
												rest)
										});
								} else {
									var e = _v91.a;
									return $elm$parser$Parser$Advanced$problem(
										$elm$parser$Parser$Problem(
											$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
								}
							case 4:
								var _v94 = _v84.a;
								var _v95 = _v84.b;
								var _v96 = _v95.a;
								var tight = _v96.a;
								var intended = _v96.b;
								var marker = _v96.c;
								var order = _v96.d;
								var closeListItems = _v96.e;
								var openListItem = _v96.f;
								var rest = _v95.b;
								var _v97 = A2(
									$elm$parser$Parser$Advanced$run,
									$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
									openListItem);
								if (!_v97.$) {
									var value = _v97.a;
									var tight2 = A2($elm$core$List$member, $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.b) ? false : tight;
									return $elm$parser$Parser$Advanced$succeed(
										{
											a: _Utils_ap(state.a, value.a),
											b: A2(
												$elm$core$List$cons,
												A6(
													$dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock,
													tight2,
													intended,
													marker,
													order,
													A2($elm$core$List$cons, value.b, closeListItems),
													openListItem),
												rest)
										});
								} else {
									var e = _v97.a;
									return $elm$parser$Parser$Advanced$problem(
										$elm$parser$Parser$Problem(
											$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
								}
							default:
								break _v84$5;
						}
					} else {
						break _v84$5;
					}
				default:
					break _v84$5;
			}
		} else {
			break _v84$5;
		}
	}
	return $elm$parser$Parser$Advanced$succeed(state);
};
var $dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks = F2(
	function (state, newRawBlock) {
		var _v41 = _Utils_Tuple2(newRawBlock, state.b);
		_v41$13:
		while (true) {
			if (_v41.b.b) {
				switch (_v41.b.a.$) {
					case 5:
						if (_v41.a.$ === 5) {
							var block1 = _v41.a.a;
							var _v42 = _v41.b;
							var block2 = _v42.a.a;
							var rest = _v42.b;
							return $elm$parser$Parser$Advanced$succeed(
								{
									a: state.a,
									b: A2(
										$elm$core$List$cons,
										$dillonkearns$elm_markdown$Markdown$RawBlock$CodeBlock(
											{
												fv: A2($dillonkearns$elm_markdown$Markdown$Parser$joinStringsPreserveAll, block2.fv, block1.fv),
												hy: $elm$core$Maybe$Nothing
											}),
										rest)
								});
						} else {
							break _v41$13;
						}
					case 6:
						switch (_v41.a.$) {
							case 6:
								var block1 = _v41.a.a;
								var _v43 = _v41.b;
								var block2 = _v43.a.a;
								var rest = _v43.b;
								return $elm$parser$Parser$Advanced$succeed(
									{
										a: state.a,
										b: A2(
											$elm$core$List$cons,
											$dillonkearns$elm_markdown$Markdown$RawBlock$IndentedCodeBlock(
												A2($dillonkearns$elm_markdown$Markdown$Parser$joinStringsPreserveAll, block2, block1)),
											rest)
									});
							case 10:
								var _v44 = _v41.a;
								var _v45 = _v41.b;
								var block = _v45.a.a;
								var rest = _v45.b;
								return $elm$parser$Parser$Advanced$succeed(
									{
										a: state.a,
										b: A2(
											$elm$core$List$cons,
											$dillonkearns$elm_markdown$Markdown$RawBlock$IndentedCodeBlock(
												A2($dillonkearns$elm_markdown$Markdown$Parser$joinStringsPreserveAll, block, '\n')),
											rest)
									});
							default:
								break _v41$13;
						}
					case 11:
						var _v46 = _v41.b;
						var body2 = _v46.a.a;
						var rest = _v46.b;
						switch (newRawBlock.$) {
							case 11:
								var body1 = newRawBlock.a;
								return $elm$parser$Parser$Advanced$succeed(
									{
										a: state.a,
										b: A2(
											$elm$core$List$cons,
											$dillonkearns$elm_markdown$Markdown$RawBlock$BlockQuote(
												A2($dillonkearns$elm_markdown$Markdown$Parser$joinStringsPreserveAll, body2, body1)),
											rest)
									});
							case 1:
								var body1 = newRawBlock.a;
								return $elm$parser$Parser$Advanced$succeed(
									{
										a: state.a,
										b: A2(
											$elm$core$List$cons,
											$dillonkearns$elm_markdown$Markdown$RawBlock$BlockQuote(
												A3($dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith, '\n', body2, body1)),
											rest)
									});
							default:
								var _v48 = A2(
									$elm$parser$Parser$Advanced$run,
									$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
									body2);
								if (!_v48.$) {
									var value = _v48.a;
									return $elm$parser$Parser$Advanced$succeed(
										{
											a: _Utils_ap(state.a, value.a),
											b: A2(
												$elm$core$List$cons,
												newRawBlock,
												A2(
													$elm$core$List$cons,
													$dillonkearns$elm_markdown$Markdown$RawBlock$ParsedBlockQuote(value.b),
													rest))
										});
								} else {
									var e = _v48.a;
									return $elm$parser$Parser$Advanced$problem(
										$elm$parser$Parser$Problem(
											$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
								}
						}
					case 3:
						var _v49 = _v41.b;
						var _v50 = _v49.a;
						var tight = _v50.a;
						var intended1 = _v50.b;
						var closeListItems2 = _v50.c;
						var openListItem2 = _v50.d;
						var rest = _v49.b;
						switch (newRawBlock.$) {
							case 3:
								var intended2 = newRawBlock.b;
								var closeListItems1 = newRawBlock.c;
								var openListItem1 = newRawBlock.d;
								if (_Utils_eq(openListItem2.nP, openListItem1.nP)) {
									var _v52 = A2(
										$elm$parser$Parser$Advanced$run,
										$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
										openListItem2.fv);
									if (!_v52.$) {
										var value = _v52.a;
										return A2($elm$core$List$member, $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.b) ? $elm$parser$Parser$Advanced$succeed(
											{
												a: _Utils_ap(state.a, value.a),
												b: A2(
													$elm$core$List$cons,
													A4(
														$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
														false,
														intended2,
														A2(
															$elm$core$List$cons,
															{fv: value.b, B: openListItem2.B},
															closeListItems2),
														openListItem1),
													rest)
											}) : $elm$parser$Parser$Advanced$succeed(
											{
												a: _Utils_ap(state.a, value.a),
												b: A2(
													$elm$core$List$cons,
													A4(
														$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
														tight,
														intended2,
														A2(
															$elm$core$List$cons,
															{fv: value.b, B: openListItem2.B},
															closeListItems2),
														openListItem1),
													rest)
											});
									} else {
										var e = _v52.a;
										return $elm$parser$Parser$Advanced$problem(
											$elm$parser$Parser$Problem(
												$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
									}
								} else {
									var _v53 = A2(
										$elm$parser$Parser$Advanced$run,
										$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
										openListItem2.fv);
									if (!_v53.$) {
										var value = _v53.a;
										var tight2 = A2($elm$core$List$member, $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.b) ? false : tight;
										return $elm$parser$Parser$Advanced$succeed(
											{
												a: _Utils_ap(state.a, value.a),
												b: A2(
													$elm$core$List$cons,
													newRawBlock,
													A2(
														$elm$core$List$cons,
														A4(
															$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
															tight2,
															intended1,
															A2(
																$elm$core$List$cons,
																{fv: value.b, B: openListItem2.B},
																closeListItems2),
															openListItem1),
														rest))
											});
									} else {
										var e = _v53.a;
										return $elm$parser$Parser$Advanced$problem(
											$elm$parser$Parser$Problem(
												$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
									}
								}
							case 1:
								var body1 = newRawBlock.a;
								return $elm$parser$Parser$Advanced$succeed(
									{
										a: state.a,
										b: A2(
											$elm$core$List$cons,
											A4(
												$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
												tight,
												intended1,
												closeListItems2,
												_Utils_update(
													openListItem2,
													{
														fv: A3($dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith, '\n', openListItem2.fv, body1)
													})),
											rest)
									});
							default:
								var _v54 = A2(
									$elm$parser$Parser$Advanced$run,
									$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
									openListItem2.fv);
								if (!_v54.$) {
									var value = _v54.a;
									var tight2 = A2($elm$core$List$member, $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.b) ? false : tight;
									return $elm$parser$Parser$Advanced$succeed(
										{
											a: _Utils_ap(state.a, value.a),
											b: A2(
												$elm$core$List$cons,
												newRawBlock,
												A2(
													$elm$core$List$cons,
													A4(
														$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
														tight2,
														intended1,
														A2(
															$elm$core$List$cons,
															{fv: value.b, B: openListItem2.B},
															closeListItems2),
														openListItem2),
													rest))
										});
								} else {
									var e = _v54.a;
									return $elm$parser$Parser$Advanced$problem(
										$elm$parser$Parser$Problem(
											$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
								}
						}
					case 4:
						var _v55 = _v41.b;
						var _v56 = _v55.a;
						var tight = _v56.a;
						var intended1 = _v56.b;
						var marker = _v56.c;
						var order = _v56.d;
						var closeListItems2 = _v56.e;
						var openListItem2 = _v56.f;
						var rest = _v55.b;
						switch (newRawBlock.$) {
							case 4:
								var intended2 = newRawBlock.b;
								var marker2 = newRawBlock.c;
								var closeListItems1 = newRawBlock.e;
								var openListItem1 = newRawBlock.f;
								if (_Utils_eq(marker, marker2)) {
									var _v58 = A2(
										$elm$parser$Parser$Advanced$run,
										$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
										openListItem2);
									if (!_v58.$) {
										var value = _v58.a;
										var tight2 = A2($elm$core$List$member, $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.b) ? false : tight;
										return $elm$parser$Parser$Advanced$succeed(
											{
												a: _Utils_ap(state.a, value.a),
												b: A2(
													$elm$core$List$cons,
													A6(
														$dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock,
														tight2,
														intended2,
														marker,
														order,
														A2($elm$core$List$cons, value.b, closeListItems2),
														openListItem1),
													rest)
											});
									} else {
										var e = _v58.a;
										return $elm$parser$Parser$Advanced$problem(
											$elm$parser$Parser$Problem(
												$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
									}
								} else {
									var _v59 = A2(
										$elm$parser$Parser$Advanced$run,
										$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
										openListItem2);
									if (!_v59.$) {
										var value = _v59.a;
										var tight2 = A2($elm$core$List$member, $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.b) ? false : tight;
										return $elm$parser$Parser$Advanced$succeed(
											{
												a: _Utils_ap(state.a, value.a),
												b: A2(
													$elm$core$List$cons,
													newRawBlock,
													A2(
														$elm$core$List$cons,
														A6(
															$dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock,
															tight2,
															intended1,
															marker,
															order,
															A2($elm$core$List$cons, value.b, closeListItems2),
															openListItem2),
														rest))
											});
									} else {
										var e = _v59.a;
										return $elm$parser$Parser$Advanced$problem(
											$elm$parser$Parser$Problem(
												$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
									}
								}
							case 1:
								var body1 = newRawBlock.a;
								return $elm$parser$Parser$Advanced$succeed(
									{
										a: state.a,
										b: A2(
											$elm$core$List$cons,
											A6($dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock, tight, intended1, marker, order, closeListItems2, openListItem2 + ('\n' + body1)),
											rest)
									});
							default:
								var _v60 = A2(
									$elm$parser$Parser$Advanced$run,
									$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
									openListItem2);
								if (!_v60.$) {
									var value = _v60.a;
									var tight2 = A2($elm$core$List$member, $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.b) ? false : tight;
									return $elm$parser$Parser$Advanced$succeed(
										{
											a: _Utils_ap(state.a, value.a),
											b: A2(
												$elm$core$List$cons,
												newRawBlock,
												A2(
													$elm$core$List$cons,
													A6(
														$dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock,
														tight2,
														intended1,
														marker,
														order,
														A2($elm$core$List$cons, value.b, closeListItems2),
														openListItem2),
													rest))
										});
								} else {
									var e = _v60.a;
									return $elm$parser$Parser$Advanced$problem(
										$elm$parser$Parser$Problem(
											$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
								}
						}
					case 1:
						switch (_v41.a.$) {
							case 1:
								var body1 = _v41.a.a;
								var _v61 = _v41.b;
								var body2 = _v61.a.a;
								var rest = _v61.b;
								return $elm$parser$Parser$Advanced$succeed(
									{
										a: state.a,
										b: A2(
											$elm$core$List$cons,
											$dillonkearns$elm_markdown$Markdown$RawBlock$OpenBlockOrParagraph(
												A3($dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith, '\n', body2, body1)),
											rest)
									});
							case 13:
								if (!_v41.a.a) {
									var _v62 = _v41.a;
									var _v63 = _v62.a;
									var _v64 = _v41.b;
									var unparsedInlines = _v64.a.a;
									var rest = _v64.b;
									return $elm$parser$Parser$Advanced$succeed(
										{
											a: state.a,
											b: A2(
												$elm$core$List$cons,
												A2($dillonkearns$elm_markdown$Markdown$RawBlock$Heading, 1, unparsedInlines),
												rest)
										});
								} else {
									var _v65 = _v41.a;
									var _v66 = _v65.a;
									var _v67 = _v41.b;
									var unparsedInlines = _v67.a.a;
									var rest = _v67.b;
									return $elm$parser$Parser$Advanced$succeed(
										{
											a: state.a,
											b: A2(
												$elm$core$List$cons,
												A2($dillonkearns$elm_markdown$Markdown$RawBlock$Heading, 2, unparsedInlines),
												rest)
										});
								}
							case 9:
								var _v68 = _v41.a.a;
								var text = _v68.a;
								var alignments = _v68.b;
								var _v69 = _v41.b;
								var rawHeaders = _v69.a.a;
								var rest = _v69.b;
								var _v70 = A2(
									$dillonkearns$elm_markdown$Markdown$TableParser$parseHeader,
									A2($dillonkearns$elm_markdown$Markdown$Table$TableDelimiterRow, text, alignments),
									rawHeaders);
								if (!_v70.$) {
									var headers = _v70.a;
									return $elm$parser$Parser$Advanced$succeed(
										{
											a: state.a,
											b: A2(
												$elm$core$List$cons,
												$dillonkearns$elm_markdown$Markdown$RawBlock$Table(
													A2($dillonkearns$elm_markdown$Markdown$Table$Table, headers, _List_Nil)),
												rest)
										});
								} else {
									return $elm$parser$Parser$Advanced$succeed(
										{
											a: state.a,
											b: A2(
												$elm$core$List$cons,
												$dillonkearns$elm_markdown$Markdown$RawBlock$OpenBlockOrParagraph(
													A3($dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith, '\n', rawHeaders, text.kO)),
												rest)
										});
								}
							default:
								break _v41$13;
						}
					case 8:
						if (_v41.a.$ === 8) {
							var updatedTable = _v41.a.a;
							var _v71 = _v41.b;
							var rest = _v71.b;
							return $elm$parser$Parser$Advanced$succeed(
								{
									a: state.a,
									b: A2(
										$elm$core$List$cons,
										$dillonkearns$elm_markdown$Markdown$RawBlock$Table(updatedTable),
										rest)
								});
						} else {
							break _v41$13;
						}
					case 10:
						if (_v41.b.b.b) {
							switch (_v41.b.b.a.$) {
								case 4:
									var _v72 = _v41.b;
									var _v73 = _v72.a;
									var _v74 = _v72.b;
									var _v75 = _v74.a;
									var tight = _v75.a;
									var intended1 = _v75.b;
									var marker = _v75.c;
									var order = _v75.d;
									var closeListItems2 = _v75.e;
									var openListItem2 = _v75.f;
									var rest = _v74.b;
									var _v76 = A2(
										$elm$parser$Parser$Advanced$run,
										$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
										openListItem2);
									if (!_v76.$) {
										var value = _v76.a;
										if (newRawBlock.$ === 4) {
											var intended2 = newRawBlock.b;
											var openListItem = newRawBlock.f;
											return $elm$parser$Parser$Advanced$succeed(
												{
													a: _Utils_ap(state.a, value.a),
													b: A2(
														$elm$core$List$cons,
														A6(
															$dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock,
															false,
															intended2,
															marker,
															order,
															A2($elm$core$List$cons, value.b, closeListItems2),
															openListItem),
														rest)
												});
										} else {
											return $elm$parser$Parser$Advanced$succeed(
												{
													a: _Utils_ap(state.a, value.a),
													b: A2(
														$elm$core$List$cons,
														newRawBlock,
														A2(
															$elm$core$List$cons,
															$dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine,
															A2(
																$elm$core$List$cons,
																A6(
																	$dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock,
																	tight,
																	intended1,
																	marker,
																	order,
																	A2($elm$core$List$cons, value.b, closeListItems2),
																	openListItem2),
																rest)))
												});
										}
									} else {
										var e = _v76.a;
										return $elm$parser$Parser$Advanced$problem(
											$elm$parser$Parser$Problem(
												$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
									}
								case 3:
									var _v78 = _v41.b;
									var _v79 = _v78.a;
									var _v80 = _v78.b;
									var _v81 = _v80.a;
									var tight = _v81.a;
									var intended1 = _v81.b;
									var closeListItems2 = _v81.c;
									var openListItem2 = _v81.d;
									var rest = _v80.b;
									var _v82 = A2(
										$elm$parser$Parser$Advanced$run,
										$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
										openListItem2.fv);
									if (!_v82.$) {
										var value = _v82.a;
										if (newRawBlock.$ === 3) {
											var openListItem = newRawBlock.d;
											return $elm$parser$Parser$Advanced$succeed(
												{
													a: _Utils_ap(state.a, value.a),
													b: A2(
														$elm$core$List$cons,
														A4(
															$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
															false,
															intended1,
															A2(
																$elm$core$List$cons,
																{fv: value.b, B: openListItem2.B},
																closeListItems2),
															openListItem),
														rest)
												});
										} else {
											return $elm$parser$Parser$Advanced$succeed(
												{
													a: _Utils_ap(state.a, value.a),
													b: A2(
														$elm$core$List$cons,
														newRawBlock,
														A2(
															$elm$core$List$cons,
															$dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine,
															A2(
																$elm$core$List$cons,
																A4(
																	$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
																	tight,
																	intended1,
																	A2(
																		$elm$core$List$cons,
																		{fv: value.b, B: openListItem2.B},
																		closeListItems2),
																	openListItem2),
																rest)))
												});
										}
									} else {
										var e = _v82.a;
										return $elm$parser$Parser$Advanced$problem(
											$elm$parser$Parser$Problem(
												$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
									}
								default:
									break _v41$13;
							}
						} else {
							break _v41$13;
						}
					default:
						break _v41$13;
				}
			} else {
				break _v41$13;
			}
		}
		return $elm$parser$Parser$Advanced$succeed(
			{
				a: state.a,
				b: A2($elm$core$List$cons, newRawBlock, state.b)
			});
	});
var $dillonkearns$elm_markdown$Markdown$Parser$inlineParseHelper = F2(
	function (referencesDict, _v36) {
		var unparsedInlines = _v36;
		var mappedReferencesDict = $elm$core$Dict$fromList(
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$mapSecond(
					function (_v37) {
						var destination = _v37.je;
						var title = _v37.fb;
						return _Utils_Tuple2(destination, title);
					}),
				referencesDict));
		return A2(
			$elm$core$List$map,
			$dillonkearns$elm_markdown$Markdown$Parser$mapInline,
			A2($dillonkearns$elm_markdown$Markdown$InlineParser$parse, mappedReferencesDict, unparsedInlines));
	});
var $dillonkearns$elm_markdown$Markdown$Parser$mapInline = function (inline) {
	switch (inline.$) {
		case 0:
			var string = inline.a;
			return $dillonkearns$elm_markdown$Markdown$Block$Text(string);
		case 1:
			return $dillonkearns$elm_markdown$Markdown$Block$HardLineBreak;
		case 2:
			var string = inline.a;
			return $dillonkearns$elm_markdown$Markdown$Block$CodeSpan(string);
		case 3:
			var string = inline.a;
			var maybeString = inline.b;
			var inlines = inline.c;
			return A3(
				$dillonkearns$elm_markdown$Markdown$Block$Link,
				string,
				maybeString,
				A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Parser$mapInline, inlines));
		case 4:
			var string = inline.a;
			var maybeString = inline.b;
			var inlines = inline.c;
			return A3(
				$dillonkearns$elm_markdown$Markdown$Block$Image,
				string,
				maybeString,
				A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Parser$mapInline, inlines));
		case 5:
			var node = inline.a;
			return $dillonkearns$elm_markdown$Markdown$Block$HtmlInline(
				$dillonkearns$elm_markdown$Markdown$Parser$nodeToRawBlock(node));
		case 6:
			var level = inline.a;
			var inlines = inline.b;
			switch (level) {
				case 1:
					return $dillonkearns$elm_markdown$Markdown$Block$Emphasis(
						A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Parser$mapInline, inlines));
				case 2:
					return $dillonkearns$elm_markdown$Markdown$Block$Strong(
						A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Parser$mapInline, inlines));
				default:
					return $dillonkearns$elm_markdown$Markdown$Helpers$isEven(level) ? $dillonkearns$elm_markdown$Markdown$Block$Strong(
						_List_fromArray(
							[
								$dillonkearns$elm_markdown$Markdown$Parser$mapInline(
								A2($dillonkearns$elm_markdown$Markdown$Inline$Emphasis, level - 2, inlines))
							])) : $dillonkearns$elm_markdown$Markdown$Block$Emphasis(
						_List_fromArray(
							[
								$dillonkearns$elm_markdown$Markdown$Parser$mapInline(
								A2($dillonkearns$elm_markdown$Markdown$Inline$Emphasis, level - 1, inlines))
							]));
			}
		default:
			var inlines = inline.a;
			return $dillonkearns$elm_markdown$Markdown$Block$Strikethrough(
				A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Parser$mapInline, inlines));
	}
};
var $dillonkearns$elm_markdown$Markdown$Parser$nodeToRawBlock = function (node) {
	switch (node.$) {
		case 1:
			var innerText = node.a;
			return $dillonkearns$elm_markdown$Markdown$Block$HtmlComment('TODO this never happens, but use types to drop this case.');
		case 0:
			var tag = node.a;
			var attributes = node.b;
			var children = node.c;
			var parseChild = function (child) {
				if (child.$ === 1) {
					var text = child.a;
					return $dillonkearns$elm_markdown$Markdown$Parser$textNodeToBlocks(text);
				} else {
					return _List_fromArray(
						[
							$dillonkearns$elm_markdown$Markdown$Block$HtmlBlock(
							$dillonkearns$elm_markdown$Markdown$Parser$nodeToRawBlock(child))
						]);
				}
			};
			return A3(
				$dillonkearns$elm_markdown$Markdown$Block$HtmlElement,
				tag,
				attributes,
				A2($elm$core$List$concatMap, parseChild, children));
		case 2:
			var string = node.a;
			return $dillonkearns$elm_markdown$Markdown$Block$HtmlComment(string);
		case 3:
			var string = node.a;
			return $dillonkearns$elm_markdown$Markdown$Block$Cdata(string);
		case 4:
			var string = node.a;
			return $dillonkearns$elm_markdown$Markdown$Block$ProcessingInstruction(string);
		default:
			var declarationType = node.a;
			var content = node.b;
			return A2($dillonkearns$elm_markdown$Markdown$Block$HtmlDeclaration, declarationType, content);
	}
};
var $dillonkearns$elm_markdown$Markdown$Parser$nodesToBlocks = function (children) {
	return A2($dillonkearns$elm_markdown$Markdown$Parser$nodesToBlocksHelp, children, _List_Nil);
};
var $dillonkearns$elm_markdown$Markdown$Parser$nodesToBlocksHelp = F2(
	function (remaining, soFar) {
		nodesToBlocksHelp:
		while (true) {
			if (remaining.b) {
				var node = remaining.a;
				var rest = remaining.b;
				var _v31 = A2($dillonkearns$elm_markdown$Markdown$Parser$childToBlocks, node, soFar);
				if (!_v31.$) {
					var newSoFar = _v31.a;
					var $temp$remaining = rest,
						$temp$soFar = newSoFar;
					remaining = $temp$remaining;
					soFar = $temp$soFar;
					continue nodesToBlocksHelp;
				} else {
					var e = _v31.a;
					return $elm$core$Result$Err(e);
				}
			} else {
				return $elm$core$Result$Ok(
					$elm$core$List$reverse(soFar));
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$Parser$parse = function (input) {
	var _v27 = A2(
		$elm$parser$Parser$Advanced$run,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
			$dillonkearns$elm_markdown$Helpers$endOfFile),
		input);
	if (_v27.$ === 1) {
		var e = _v27.a;
		return $elm$core$Result$Err(e);
	} else {
		var v = _v27.a;
		var _v28 = $dillonkearns$elm_markdown$Markdown$Parser$parseAllInlines(v);
		if (_v28.$ === 1) {
			var e = _v28.a;
			return A2(
				$elm$parser$Parser$Advanced$run,
				$elm$parser$Parser$Advanced$problem(e),
				'');
		} else {
			var blocks = _v28.a;
			var isNotEmptyParagraph = function (block) {
				if ((block.$ === 5) && (!block.a.b)) {
					return false;
				} else {
					return true;
				}
			};
			return $elm$core$Result$Ok(
				A2($elm$core$List$filter, isNotEmptyParagraph, blocks));
		}
	}
};
var $dillonkearns$elm_markdown$Markdown$Parser$parseAllInlines = function (state) {
	return A3($dillonkearns$elm_markdown$Markdown$Parser$parseAllInlinesHelp, state, state.b, _List_Nil);
};
var $dillonkearns$elm_markdown$Markdown$Parser$parseAllInlinesHelp = F3(
	function (state, rawBlocks, parsedBlocks) {
		parseAllInlinesHelp:
		while (true) {
			if (rawBlocks.b) {
				var rawBlock = rawBlocks.a;
				var rest = rawBlocks.b;
				var _v26 = A2($dillonkearns$elm_markdown$Markdown$Parser$parseInlines, state.a, rawBlock);
				switch (_v26.$) {
					case 1:
						var newParsedBlock = _v26.a;
						var $temp$state = state,
							$temp$rawBlocks = rest,
							$temp$parsedBlocks = A2($elm$core$List$cons, newParsedBlock, parsedBlocks);
						state = $temp$state;
						rawBlocks = $temp$rawBlocks;
						parsedBlocks = $temp$parsedBlocks;
						continue parseAllInlinesHelp;
					case 0:
						var $temp$state = state,
							$temp$rawBlocks = rest,
							$temp$parsedBlocks = parsedBlocks;
						state = $temp$state;
						rawBlocks = $temp$rawBlocks;
						parsedBlocks = $temp$parsedBlocks;
						continue parseAllInlinesHelp;
					default:
						var e = _v26.a;
						return $elm$core$Result$Err(e);
				}
			} else {
				return $elm$core$Result$Ok(parsedBlocks);
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$Parser$parseHeaderInlines = F2(
	function (linkReferences, header) {
		return A2(
			$elm$core$List$map,
			function (_v24) {
				var label = _v24.nC;
				var alignment = _v24.fn;
				return A3(
					$dillonkearns$elm_markdown$Markdown$Parser$parseRawInline,
					linkReferences,
					function (parsedHeaderLabel) {
						return {fn: alignment, nC: parsedHeaderLabel};
					},
					label);
			},
			header);
	});
var $dillonkearns$elm_markdown$Markdown$Parser$parseInlines = F2(
	function (linkReferences, rawBlock) {
		switch (rawBlock.$) {
			case 0:
				var level = rawBlock.a;
				var unparsedInlines = rawBlock.b;
				var _v17 = $dillonkearns$elm_markdown$Markdown$Parser$toHeading(level);
				if (!_v17.$) {
					var parsedLevel = _v17.a;
					return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
						A2(
							$dillonkearns$elm_markdown$Markdown$Block$Heading,
							parsedLevel,
							A2($dillonkearns$elm_markdown$Markdown$Parser$inlineParseHelper, linkReferences, unparsedInlines)));
				} else {
					var e = _v17.a;
					return $dillonkearns$elm_markdown$Markdown$Parser$InlineProblem(e);
				}
			case 1:
				var unparsedInlines = rawBlock.a;
				return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
					$dillonkearns$elm_markdown$Markdown$Block$Paragraph(
						A2($dillonkearns$elm_markdown$Markdown$Parser$inlineParseHelper, linkReferences, unparsedInlines)));
			case 2:
				var html = rawBlock.a;
				return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
					$dillonkearns$elm_markdown$Markdown$Block$HtmlBlock(html));
			case 3:
				var tight = rawBlock.a;
				var intended = rawBlock.b;
				var unparsedItems = rawBlock.c;
				var parseItem = F2(
					function (rawBlockTask, rawBlocks) {
						var blocksTask = function () {
							if (!rawBlockTask.$) {
								if (!rawBlockTask.a) {
									return 1;
								} else {
									return 2;
								}
							} else {
								return 0;
							}
						}();
						var blocks = function () {
							var _v18 = $dillonkearns$elm_markdown$Markdown$Parser$parseAllInlines(
								{a: linkReferences, b: rawBlocks});
							if (!_v18.$) {
								var parsedBlocks = _v18.a;
								return parsedBlocks;
							} else {
								var e = _v18.a;
								return _List_Nil;
							}
						}();
						return A2($dillonkearns$elm_markdown$Markdown$Block$ListItem, blocksTask, blocks);
					});
				return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
					A2(
						$dillonkearns$elm_markdown$Markdown$Block$UnorderedList,
						$dillonkearns$elm_markdown$Markdown$Parser$isTightBoolToListDisplay(tight),
						$elm$core$List$reverse(
							A2(
								$elm$core$List$map,
								function (item) {
									return A2(parseItem, item.B, item.fv);
								},
								unparsedItems))));
			case 4:
				var tight = rawBlock.a;
				var startingIndex = rawBlock.d;
				var unparsedItems = rawBlock.e;
				var parseItem = function (rawBlocks) {
					var _v20 = $dillonkearns$elm_markdown$Markdown$Parser$parseAllInlines(
						{a: linkReferences, b: rawBlocks});
					if (!_v20.$) {
						var parsedBlocks = _v20.a;
						return parsedBlocks;
					} else {
						var e = _v20.a;
						return _List_Nil;
					}
				};
				return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
					A3(
						$dillonkearns$elm_markdown$Markdown$Block$OrderedList,
						$dillonkearns$elm_markdown$Markdown$Parser$isTightBoolToListDisplay(tight),
						startingIndex,
						$elm$core$List$reverse(
							A2($elm$core$List$map, parseItem, unparsedItems))));
			case 5:
				var codeBlock = rawBlock.a;
				return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
					$dillonkearns$elm_markdown$Markdown$Block$CodeBlock(codeBlock));
			case 7:
				return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock($dillonkearns$elm_markdown$Markdown$Block$ThematicBreak);
			case 10:
				return $dillonkearns$elm_markdown$Markdown$Parser$EmptyBlock;
			case 11:
				var rawBlocks = rawBlock.a;
				return $dillonkearns$elm_markdown$Markdown$Parser$EmptyBlock;
			case 12:
				var rawBlocks = rawBlock.a;
				var _v21 = $dillonkearns$elm_markdown$Markdown$Parser$parseAllInlines(
					{a: linkReferences, b: rawBlocks});
				if (!_v21.$) {
					var parsedBlocks = _v21.a;
					return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
						$dillonkearns$elm_markdown$Markdown$Block$BlockQuote(parsedBlocks));
				} else {
					var e = _v21.a;
					return $dillonkearns$elm_markdown$Markdown$Parser$InlineProblem(e);
				}
			case 6:
				var codeBlockBody = rawBlock.a;
				return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
					$dillonkearns$elm_markdown$Markdown$Block$CodeBlock(
						{fv: codeBlockBody, hy: $elm$core$Maybe$Nothing}));
			case 8:
				var _v22 = rawBlock.a;
				var header = _v22.a;
				var rows = _v22.b;
				return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
					A2(
						$dillonkearns$elm_markdown$Markdown$Block$Table,
						A2($dillonkearns$elm_markdown$Markdown$Parser$parseHeaderInlines, linkReferences, header),
						A2($dillonkearns$elm_markdown$Markdown$Parser$parseRowInlines, linkReferences, rows)));
			case 9:
				var _v23 = rawBlock.a;
				var text = _v23.a;
				return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
					$dillonkearns$elm_markdown$Markdown$Block$Paragraph(
						A2($dillonkearns$elm_markdown$Markdown$Parser$inlineParseHelper, linkReferences, text.kO)));
			default:
				var raw = rawBlock.b;
				return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
					$dillonkearns$elm_markdown$Markdown$Block$Paragraph(
						A2($dillonkearns$elm_markdown$Markdown$Parser$inlineParseHelper, linkReferences, raw)));
		}
	});
var $dillonkearns$elm_markdown$Markdown$Parser$parseRawInline = F3(
	function (linkReferences, wrap, unparsedInlines) {
		return wrap(
			A2($dillonkearns$elm_markdown$Markdown$Parser$inlineParseHelper, linkReferences, unparsedInlines));
	});
var $dillonkearns$elm_markdown$Markdown$Parser$parseRowInlines = F2(
	function (linkReferences, rows) {
		return A2(
			$elm$core$List$map,
			function (row) {
				return A2(
					$elm$core$List$map,
					function (column) {
						return A3($dillonkearns$elm_markdown$Markdown$Parser$parseRawInline, linkReferences, $elm$core$Basics$identity, column);
					},
					row);
			},
			rows);
	});
var $dillonkearns$elm_markdown$Markdown$Parser$stepRawBlock = function (revStmts) {
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$Advanced$map,
				function (_v2) {
					return $elm$parser$Parser$Advanced$Done(revStmts);
				},
				$dillonkearns$elm_markdown$Helpers$endOfFile),
				A2(
				$elm$parser$Parser$Advanced$map,
				function (reference) {
					return $elm$parser$Parser$Advanced$Loop(
						A2($dillonkearns$elm_markdown$Markdown$Parser$addReference, revStmts, reference));
				},
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$parser)),
				function () {
				var _v3 = revStmts.b;
				_v3$6:
				while (true) {
					if (_v3.b) {
						switch (_v3.a.$) {
							case 1:
								return A2(
									$elm$parser$Parser$Advanced$map,
									function (block) {
										return $elm$parser$Parser$Advanced$Loop(block);
									},
									A2(
										$elm$parser$Parser$Advanced$andThen,
										$dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts),
										$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterOpenBlockOrParagraphParser()));
							case 8:
								var table = _v3.a.a;
								return A2(
									$elm$parser$Parser$Advanced$map,
									function (block) {
										return $elm$parser$Parser$Advanced$Loop(block);
									},
									A2(
										$elm$parser$Parser$Advanced$andThen,
										$dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts),
										$elm$parser$Parser$Advanced$oneOf(
											_List_fromArray(
												[
													$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser(),
													$dillonkearns$elm_markdown$Markdown$Parser$tableRowIfTableStarted(table)
												]))));
							case 3:
								var _v4 = _v3.a;
								var tight = _v4.a;
								var intended = _v4.b;
								var closeListItems = _v4.c;
								var openListItem = _v4.d;
								var rest = _v3.b;
								var completeOrMergeUnorderedListBlockBlankLine = F2(
									function (state, newString) {
										return _Utils_update(
											state,
											{
												b: A2(
													$elm$core$List$cons,
													$dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine,
													A2(
														$elm$core$List$cons,
														A4(
															$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
															tight,
															intended,
															closeListItems,
															_Utils_update(
																openListItem,
																{
																	fv: A3($dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith, '', openListItem.fv, newString)
																})),
														rest))
											});
									});
								var completeOrMergeUnorderedListBlock = F2(
									function (state, newString) {
										return _Utils_update(
											state,
											{
												b: A2(
													$elm$core$List$cons,
													A4(
														$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
														tight,
														intended,
														closeListItems,
														_Utils_update(
															openListItem,
															{
																fv: A3($dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith, '\n', openListItem.fv, newString)
															})),
													rest)
											});
									});
								return $elm$parser$Parser$Advanced$oneOf(
									_List_fromArray(
										[
											A2(
											$elm$parser$Parser$Advanced$map,
											function (block) {
												return $elm$parser$Parser$Advanced$Loop(block);
											},
											A2(
												$elm$parser$Parser$Advanced$map,
												function (_v5) {
													return A2(completeOrMergeUnorderedListBlockBlankLine, revStmts, '\n');
												},
												$dillonkearns$elm_markdown$Markdown$Parser$blankLine)),
											A2(
											$elm$parser$Parser$Advanced$map,
											function (block) {
												return $elm$parser$Parser$Advanced$Loop(block);
											},
											A2(
												$elm$parser$Parser$Advanced$map,
												completeOrMergeUnorderedListBlock(revStmts),
												A2(
													$elm$parser$Parser$Advanced$keeper,
													A2(
														$elm$parser$Parser$Advanced$ignorer,
														$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
														$elm$parser$Parser$Advanced$symbol(
															A2(
																$elm$parser$Parser$Advanced$Token,
																A2($elm$core$String$repeat, intended, ' '),
																$elm$parser$Parser$ExpectingSymbol('Indentation')))),
													A2(
														$elm$parser$Parser$Advanced$ignorer,
														$elm$parser$Parser$Advanced$getChompedString($dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd),
														$dillonkearns$elm_markdown$Helpers$lineEndOrEnd)))),
											A2(
											$elm$parser$Parser$Advanced$map,
											function (block) {
												return $elm$parser$Parser$Advanced$Loop(block);
											},
											A2(
												$elm$parser$Parser$Advanced$andThen,
												$dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts),
												$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterList()))
										]));
							case 4:
								var _v10 = _v3.a;
								var tight = _v10.a;
								var intended = _v10.b;
								var marker = _v10.c;
								var order = _v10.d;
								var closeListItems = _v10.e;
								var openListItem = _v10.f;
								var rest = _v3.b;
								var completeOrMergeUnorderedListBlockBlankLine = F2(
									function (state, newString) {
										return _Utils_update(
											state,
											{
												b: A2(
													$elm$core$List$cons,
													$dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine,
													A2(
														$elm$core$List$cons,
														A6($dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock, tight, intended, marker, order, closeListItems, openListItem + ('\n' + newString)),
														rest))
											});
									});
								var completeOrMergeUnorderedListBlock = F2(
									function (state, newString) {
										return _Utils_update(
											state,
											{
												b: A2(
													$elm$core$List$cons,
													A6($dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock, tight, intended, marker, order, closeListItems, openListItem + ('\n' + newString)),
													rest)
											});
									});
								return $elm$parser$Parser$Advanced$oneOf(
									_List_fromArray(
										[
											A2(
											$elm$parser$Parser$Advanced$map,
											function (block) {
												return $elm$parser$Parser$Advanced$Loop(block);
											},
											A2(
												$elm$parser$Parser$Advanced$map,
												function (_v11) {
													return A2(completeOrMergeUnorderedListBlockBlankLine, revStmts, '\n');
												},
												$dillonkearns$elm_markdown$Markdown$Parser$blankLine)),
											A2(
											$elm$parser$Parser$Advanced$map,
											function (block) {
												return $elm$parser$Parser$Advanced$Loop(block);
											},
											A2(
												$elm$parser$Parser$Advanced$map,
												completeOrMergeUnorderedListBlock(revStmts),
												A2(
													$elm$parser$Parser$Advanced$keeper,
													A2(
														$elm$parser$Parser$Advanced$ignorer,
														$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
														$elm$parser$Parser$Advanced$symbol(
															A2(
																$elm$parser$Parser$Advanced$Token,
																A2($elm$core$String$repeat, intended, ' '),
																$elm$parser$Parser$ExpectingSymbol('Indentation')))),
													A2(
														$elm$parser$Parser$Advanced$ignorer,
														$elm$parser$Parser$Advanced$getChompedString($dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd),
														$dillonkearns$elm_markdown$Helpers$lineEndOrEnd)))),
											A2(
											$elm$parser$Parser$Advanced$map,
											function (block) {
												return $elm$parser$Parser$Advanced$Loop(block);
											},
											A2(
												$elm$parser$Parser$Advanced$andThen,
												$dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts),
												$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterList()))
										]));
							case 10:
								if (_v3.b.b) {
									switch (_v3.b.a.$) {
										case 3:
											var _v6 = _v3.a;
											var _v7 = _v3.b;
											var _v8 = _v7.a;
											var tight = _v8.a;
											var intended = _v8.b;
											var closeListItems = _v8.c;
											var openListItem = _v8.d;
											var rest = _v7.b;
											var completeOrMergeUnorderedListBlockBlankLine = F2(
												function (state, newString) {
													return _Utils_update(
														state,
														{
															b: A2(
																$elm$core$List$cons,
																$dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine,
																A2(
																	$elm$core$List$cons,
																	A4(
																		$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
																		tight,
																		intended,
																		closeListItems,
																		_Utils_update(
																			openListItem,
																			{
																				fv: A3($dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith, '', openListItem.fv, newString)
																			})),
																	rest))
														});
												});
											var completeOrMergeUnorderedListBlock = F2(
												function (state, newString) {
													return _Utils_update(
														state,
														{
															b: A2(
																$elm$core$List$cons,
																A4(
																	$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
																	tight,
																	intended,
																	closeListItems,
																	_Utils_update(
																		openListItem,
																		{
																			fv: A3($dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith, '\n', openListItem.fv, newString)
																		})),
																rest)
														});
												});
											return ($elm$core$String$trim(openListItem.fv) === '') ? A2(
												$elm$parser$Parser$Advanced$map,
												function (block) {
													return $elm$parser$Parser$Advanced$Loop(block);
												},
												A2(
													$elm$parser$Parser$Advanced$andThen,
													$dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts),
													$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser())) : $elm$parser$Parser$Advanced$oneOf(
												_List_fromArray(
													[
														A2(
														$elm$parser$Parser$Advanced$map,
														function (block) {
															return $elm$parser$Parser$Advanced$Loop(block);
														},
														A2(
															$elm$parser$Parser$Advanced$map,
															function (_v9) {
																return A2(completeOrMergeUnorderedListBlockBlankLine, revStmts, '\n');
															},
															$dillonkearns$elm_markdown$Markdown$Parser$blankLine)),
														A2(
														$elm$parser$Parser$Advanced$map,
														function (block) {
															return $elm$parser$Parser$Advanced$Loop(block);
														},
														A2(
															$elm$parser$Parser$Advanced$map,
															completeOrMergeUnorderedListBlock(revStmts),
															A2(
																$elm$parser$Parser$Advanced$keeper,
																A2(
																	$elm$parser$Parser$Advanced$ignorer,
																	$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
																	$elm$parser$Parser$Advanced$symbol(
																		A2(
																			$elm$parser$Parser$Advanced$Token,
																			A2($elm$core$String$repeat, intended, ' '),
																			$elm$parser$Parser$ExpectingSymbol('Indentation')))),
																A2(
																	$elm$parser$Parser$Advanced$ignorer,
																	$elm$parser$Parser$Advanced$getChompedString($dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd),
																	$dillonkearns$elm_markdown$Helpers$lineEndOrEnd)))),
														A2(
														$elm$parser$Parser$Advanced$map,
														function (block) {
															return $elm$parser$Parser$Advanced$Loop(block);
														},
														A2(
															$elm$parser$Parser$Advanced$andThen,
															$dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts),
															$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser()))
													]));
										case 4:
											var _v12 = _v3.a;
											var _v13 = _v3.b;
											var _v14 = _v13.a;
											var tight = _v14.a;
											var intended = _v14.b;
											var marker = _v14.c;
											var order = _v14.d;
											var closeListItems = _v14.e;
											var openListItem = _v14.f;
											var rest = _v13.b;
											var completeOrMergeUnorderedListBlockBlankLine = F2(
												function (state, newString) {
													return _Utils_update(
														state,
														{
															b: A2(
																$elm$core$List$cons,
																$dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine,
																A2(
																	$elm$core$List$cons,
																	A6($dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock, tight, intended, marker, order, closeListItems, openListItem + ('\n' + newString)),
																	rest))
														});
												});
											var completeOrMergeUnorderedListBlock = F2(
												function (state, newString) {
													return _Utils_update(
														state,
														{
															b: A2(
																$elm$core$List$cons,
																A6($dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock, tight, intended, marker, order, closeListItems, openListItem + ('\n' + newString)),
																rest)
														});
												});
											return ($elm$core$String$trim(openListItem) === '') ? A2(
												$elm$parser$Parser$Advanced$map,
												function (block) {
													return $elm$parser$Parser$Advanced$Loop(block);
												},
												A2(
													$elm$parser$Parser$Advanced$andThen,
													$dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts),
													$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser())) : $elm$parser$Parser$Advanced$oneOf(
												_List_fromArray(
													[
														A2(
														$elm$parser$Parser$Advanced$map,
														function (block) {
															return $elm$parser$Parser$Advanced$Loop(block);
														},
														A2(
															$elm$parser$Parser$Advanced$map,
															function (_v15) {
																return A2(completeOrMergeUnorderedListBlockBlankLine, revStmts, '\n');
															},
															$dillonkearns$elm_markdown$Markdown$Parser$blankLine)),
														A2(
														$elm$parser$Parser$Advanced$map,
														function (block) {
															return $elm$parser$Parser$Advanced$Loop(block);
														},
														A2(
															$elm$parser$Parser$Advanced$map,
															completeOrMergeUnorderedListBlock(revStmts),
															A2(
																$elm$parser$Parser$Advanced$keeper,
																A2(
																	$elm$parser$Parser$Advanced$ignorer,
																	$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
																	$elm$parser$Parser$Advanced$symbol(
																		A2(
																			$elm$parser$Parser$Advanced$Token,
																			A2($elm$core$String$repeat, intended, ' '),
																			$elm$parser$Parser$ExpectingSymbol('Indentation')))),
																A2(
																	$elm$parser$Parser$Advanced$ignorer,
																	$elm$parser$Parser$Advanced$getChompedString($dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd),
																	$dillonkearns$elm_markdown$Helpers$lineEndOrEnd)))),
														A2(
														$elm$parser$Parser$Advanced$map,
														function (block) {
															return $elm$parser$Parser$Advanced$Loop(block);
														},
														A2(
															$elm$parser$Parser$Advanced$andThen,
															$dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts),
															$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser()))
													]));
										default:
											break _v3$6;
									}
								} else {
									break _v3$6;
								}
							default:
								break _v3$6;
						}
					} else {
						break _v3$6;
					}
				}
				return A2(
					$elm$parser$Parser$Advanced$map,
					function (block) {
						return $elm$parser$Parser$Advanced$Loop(block);
					},
					A2(
						$elm$parser$Parser$Advanced$andThen,
						$dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts),
						$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser()));
			}(),
				A2(
				$elm$parser$Parser$Advanced$map,
				function (block) {
					return $elm$parser$Parser$Advanced$Loop(block);
				},
				A2(
					$elm$parser$Parser$Advanced$andThen,
					$dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts),
					$dillonkearns$elm_markdown$Markdown$Parser$openBlockOrParagraphParser))
			]));
};
var $dillonkearns$elm_markdown$Markdown$Parser$textNodeToBlocks = function (textNodeValue) {
	return A2(
		$elm$core$Result$withDefault,
		_List_Nil,
		$dillonkearns$elm_markdown$Markdown$Parser$parse(textNodeValue));
};
var $dillonkearns$elm_markdown$Markdown$Parser$xmlNodeToHtmlNode = function (xmlNode) {
	switch (xmlNode.$) {
		case 1:
			var innerText = xmlNode.a;
			return $elm$parser$Parser$Advanced$succeed(
				$dillonkearns$elm_markdown$Markdown$RawBlock$OpenBlockOrParagraph(innerText));
		case 0:
			var tag = xmlNode.a;
			var attributes = xmlNode.b;
			var children = xmlNode.c;
			var _v1 = $dillonkearns$elm_markdown$Markdown$Parser$nodesToBlocks(children);
			if (!_v1.$) {
				var parsedChildren = _v1.a;
				return $elm$parser$Parser$Advanced$succeed(
					$dillonkearns$elm_markdown$Markdown$RawBlock$Html(
						A3($dillonkearns$elm_markdown$Markdown$Block$HtmlElement, tag, attributes, parsedChildren)));
			} else {
				var err = _v1.a;
				return $elm$parser$Parser$Advanced$problem(err);
			}
		case 2:
			var string = xmlNode.a;
			return $elm$parser$Parser$Advanced$succeed(
				$dillonkearns$elm_markdown$Markdown$RawBlock$Html(
					$dillonkearns$elm_markdown$Markdown$Block$HtmlComment(string)));
		case 3:
			var string = xmlNode.a;
			return $elm$parser$Parser$Advanced$succeed(
				$dillonkearns$elm_markdown$Markdown$RawBlock$Html(
					$dillonkearns$elm_markdown$Markdown$Block$Cdata(string)));
		case 4:
			var string = xmlNode.a;
			return $elm$parser$Parser$Advanced$succeed(
				$dillonkearns$elm_markdown$Markdown$RawBlock$Html(
					$dillonkearns$elm_markdown$Markdown$Block$ProcessingInstruction(string)));
		default:
			var declarationType = xmlNode.a;
			var content = xmlNode.b;
			return $elm$parser$Parser$Advanced$succeed(
				$dillonkearns$elm_markdown$Markdown$RawBlock$Html(
					A2($dillonkearns$elm_markdown$Markdown$Block$HtmlDeclaration, declarationType, content)));
	}
};
function $dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser() {
	return A2(
		$elm$parser$Parser$Advanced$andThen,
		$dillonkearns$elm_markdown$Markdown$Parser$completeBlocks,
		A2(
			$elm$parser$Parser$Advanced$loop,
			{a: _List_Nil, b: _List_Nil},
			$dillonkearns$elm_markdown$Markdown$Parser$stepRawBlock));
}
function $dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser() {
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				$dillonkearns$elm_markdown$Markdown$Parser$parseAsParagraphInsteadOfHtmlBlock,
				$dillonkearns$elm_markdown$Markdown$Parser$blankLine,
				$dillonkearns$elm_markdown$Markdown$Parser$blockQuote,
				A2(
				$elm$parser$Parser$Advanced$map,
				$dillonkearns$elm_markdown$Markdown$RawBlock$CodeBlock,
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$CodeBlock$parser)),
				$dillonkearns$elm_markdown$Markdown$Parser$indentedCodeBlock,
				A2(
				$elm$parser$Parser$Advanced$map,
				function (_v40) {
					return $dillonkearns$elm_markdown$Markdown$RawBlock$ThematicBreak;
				},
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$ThematicBreak$parser)),
				$dillonkearns$elm_markdown$Markdown$Parser$unorderedListBlock(false),
				$dillonkearns$elm_markdown$Markdown$Parser$orderedListBlock(false),
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$Heading$parser),
				$dillonkearns$elm_markdown$Markdown$Parser$cyclic$htmlParser()
			]));
}
function $dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterOpenBlockOrParagraphParser() {
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				$dillonkearns$elm_markdown$Markdown$Parser$parseAsParagraphInsteadOfHtmlBlock,
				$dillonkearns$elm_markdown$Markdown$Parser$blankLine,
				$dillonkearns$elm_markdown$Markdown$Parser$blockQuote,
				A2(
				$elm$parser$Parser$Advanced$map,
				$dillonkearns$elm_markdown$Markdown$RawBlock$CodeBlock,
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$CodeBlock$parser)),
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$Parser$setextLineParser),
				A2(
				$elm$parser$Parser$Advanced$map,
				function (_v39) {
					return $dillonkearns$elm_markdown$Markdown$RawBlock$ThematicBreak;
				},
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$ThematicBreak$parser)),
				$dillonkearns$elm_markdown$Markdown$Parser$unorderedListBlock(true),
				$dillonkearns$elm_markdown$Markdown$Parser$orderedListBlock(true),
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$Heading$parser),
				$dillonkearns$elm_markdown$Markdown$Parser$cyclic$htmlParser(),
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$Parser$tableDelimiterInOpenParagraph)
			]));
}
function $dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterList() {
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				$dillonkearns$elm_markdown$Markdown$Parser$parseAsParagraphInsteadOfHtmlBlock,
				$dillonkearns$elm_markdown$Markdown$Parser$blankLine,
				$dillonkearns$elm_markdown$Markdown$Parser$blockQuote,
				A2(
				$elm$parser$Parser$Advanced$map,
				$dillonkearns$elm_markdown$Markdown$RawBlock$CodeBlock,
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$CodeBlock$parser)),
				A2(
				$elm$parser$Parser$Advanced$map,
				function (_v38) {
					return $dillonkearns$elm_markdown$Markdown$RawBlock$ThematicBreak;
				},
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$ThematicBreak$parser)),
				$dillonkearns$elm_markdown$Markdown$Parser$unorderedListBlock(false),
				$dillonkearns$elm_markdown$Markdown$Parser$orderedListBlock(false),
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$Heading$parser),
				$dillonkearns$elm_markdown$Markdown$Parser$cyclic$htmlParser()
			]));
}
function $dillonkearns$elm_markdown$Markdown$Parser$cyclic$htmlParser() {
	return A2($elm$parser$Parser$Advanced$andThen, $dillonkearns$elm_markdown$Markdown$Parser$xmlNodeToHtmlNode, $dillonkearns$elm_markdown$HtmlParser$html);
}
var $dillonkearns$elm_markdown$Markdown$Parser$rawBlockParser = $dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser();
$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser = function () {
	return $dillonkearns$elm_markdown$Markdown$Parser$rawBlockParser;
};
var $dillonkearns$elm_markdown$Markdown$Parser$mergeableBlockNotAfterOpenBlockOrParagraphParser = $dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser();
$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser = function () {
	return $dillonkearns$elm_markdown$Markdown$Parser$mergeableBlockNotAfterOpenBlockOrParagraphParser;
};
var $dillonkearns$elm_markdown$Markdown$Parser$mergeableBlockAfterOpenBlockOrParagraphParser = $dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterOpenBlockOrParagraphParser();
$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterOpenBlockOrParagraphParser = function () {
	return $dillonkearns$elm_markdown$Markdown$Parser$mergeableBlockAfterOpenBlockOrParagraphParser;
};
var $dillonkearns$elm_markdown$Markdown$Parser$mergeableBlockAfterList = $dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterList();
$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterList = function () {
	return $dillonkearns$elm_markdown$Markdown$Parser$mergeableBlockAfterList;
};
var $dillonkearns$elm_markdown$Markdown$Parser$htmlParser = $dillonkearns$elm_markdown$Markdown$Parser$cyclic$htmlParser();
$dillonkearns$elm_markdown$Markdown$Parser$cyclic$htmlParser = function () {
	return $dillonkearns$elm_markdown$Markdown$Parser$htmlParser;
};
var $author$project$Markdown$Bold = {$: 0};
var $author$project$Markdown$Header = function (a) {
	return {$: 5, a: a};
};
var $author$project$Markdown$Italic = {$: 1};
var $author$project$Markdown$LinkFormatting = function (a) {
	return {$: 4, a: a};
};
var $author$project$Markdown$OrderedList = {$: 6};
var $author$project$Markdown$QuillOp = $elm$core$Basics$identity;
var $author$project$Markdown$Strike = {$: 2};
var $author$project$Markdown$Underline = {$: 3};
var $author$project$Markdown$UnorderedList = {$: 7};
var $dillonkearns$elm_markdown$Markdown$Block$headingLevelToInt = function (headingLevel) {
	switch (headingLevel) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		default:
			return 6;
	}
};
var $elm$core$List$intersperse = F2(
	function (sep, xs) {
		if (!xs.b) {
			return _List_Nil;
		} else {
			var hd = xs.a;
			var tl = xs.b;
			var step = F2(
				function (x, rest) {
					return A2(
						$elm$core$List$cons,
						sep,
						A2($elm$core$List$cons, x, rest));
				});
			var spersed = A3($elm$core$List$foldr, step, _List_Nil, tl);
			return A2($elm$core$List$cons, hd, spersed);
		}
	});
var $elm_community$list_extra$List$Extra$intercalate = function (xs) {
	return A2(
		$elm$core$Basics$composeL,
		$elm$core$List$concat,
		$elm$core$List$intersperse(xs));
};
var $author$project$Markdown$quillOpFromMarkdownBlock = function (block) {
	var parseList = F2(
		function (listType, children) {
			return function (list) {
				return A2(
					$elm$core$List$cons,
					{A: _List_Nil, aw: '\n'},
					list);
			}(
				A2(
					$elm$core$List$concatMap,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$map($author$project$Markdown$quillOpFromMarkdownBlock),
						A2(
							$elm$core$Basics$composeR,
							$elm_community$list_extra$List$Extra$intercalate(
								_List_fromArray(
									[
										{A: _List_Nil, aw: ' '}
									])),
							function (line) {
								return _Utils_ap(
									line,
									_List_fromArray(
										[
											{
											A: _List_fromArray(
												[listType]),
											aw: '\n'
										}
										]));
							})),
					children));
		});
	_v4$5:
	while (true) {
		switch (block.$) {
			case 1:
				var children = block.b;
				var listItemToList = function (_v5) {
					var children_ = _v5.b;
					return children_;
				};
				return A2(
					parseList,
					$author$project$Markdown$UnorderedList,
					A2($elm$core$List$map, listItemToList, children));
			case 2:
				var children = block.c;
				return A2(parseList, $author$project$Markdown$OrderedList, children);
			case 4:
				var headingLevel = block.a;
				var children = block.b;
				return function (l) {
					return _Utils_ap(
						l,
						_List_fromArray(
							[
								{
								A: _List_fromArray(
									[
										$author$project$Markdown$Header(
										$dillonkearns$elm_markdown$Markdown$Block$headingLevelToInt(headingLevel))
									]),
								aw: '\n'
							}
							]));
				}(
					A2($elm$core$List$concatMap, $author$project$Markdown$quillOpFromMarkdownInline, children));
			case 5:
				var children = block.a;
				return A2($elm$core$List$concatMap, $author$project$Markdown$quillOpFromMarkdownInline, children);
			case 0:
				if ((!block.a.$) && (block.a.a === 'u')) {
					var _v6 = block.a;
					var children = _v6.c;
					return A2(
						$elm$core$List$map,
						function (_v7) {
							var quillOp = _v7;
							return _Utils_update(
								quillOp,
								{
									A: A2($elm$core$List$cons, $author$project$Markdown$Underline, quillOp.A)
								});
						},
						A2($elm$core$List$concatMap, $author$project$Markdown$quillOpFromMarkdownBlock, children));
				} else {
					break _v4$5;
				}
			default:
				break _v4$5;
		}
	}
	return _List_Nil;
};
var $author$project$Markdown$quillOpFromMarkdownInline = function (inline) {
	var addFormatting = F2(
		function (children, formatting) {
			return A2(
				$elm$core$List$map,
				function (_v3) {
					var quillOp = _v3;
					return _Utils_update(
						quillOp,
						{
							A: A2($elm$core$List$cons, formatting, quillOp.A)
						});
				},
				A2($elm$core$List$concatMap, $author$project$Markdown$quillOpFromMarkdownInline, children));
		});
	_v0$6:
	while (true) {
		switch (inline.$) {
			case 1:
				var link = inline.a;
				var children = inline.c;
				return A2(
					addFormatting,
					children,
					$author$project$Markdown$LinkFormatting(link));
			case 3:
				var children = inline.a;
				return A2(addFormatting, children, $author$project$Markdown$Italic);
			case 4:
				var children = inline.a;
				return A2(addFormatting, children, $author$project$Markdown$Bold);
			case 5:
				var children = inline.a;
				return A2(addFormatting, children, $author$project$Markdown$Strike);
			case 7:
				var content = inline.a;
				return _List_fromArray(
					[
						{A: _List_Nil, aw: content}
					]);
			case 0:
				if ((!inline.a.$) && (inline.a.a === 'u')) {
					var _v1 = inline.a;
					var children = _v1.c;
					return A2(
						$elm$core$List$map,
						function (_v2) {
							var quillOp = _v2;
							return _Utils_update(
								quillOp,
								{
									A: A2($elm$core$List$cons, $author$project$Markdown$Underline, quillOp.A)
								});
						},
						A2($elm$core$List$concatMap, $author$project$Markdown$quillOpFromMarkdownBlock, children));
				} else {
					break _v0$6;
				}
			default:
				break _v0$6;
		}
	}
	return _List_Nil;
};
var $author$project$Markdown$toQuillOps = function (_v0) {
	var markdown = _v0;
	return A2(
		$elm$core$Result$withDefault,
		_List_Nil,
		A2(
			$elm$core$Result$map,
			$elm$core$List$concatMap($author$project$Markdown$quillOpFromMarkdownBlock),
			$dillonkearns$elm_markdown$Markdown$Parser$parse(markdown)));
};
var $author$project$Form$RichText$initModel = F2(
	function (id, maybeMarkdown) {
		return {
			fB: A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2($elm$core$Maybe$map, $author$project$Markdown$toQuillOps, maybeMarkdown)),
			R: id,
			nt: false,
			a0: $author$project$Form$RichText$NotShowing
		};
	});
var $author$project$Form$File$Loaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Form$File$LoadingFileType = {$: 0};
var $author$project$Form$File$MultipleModel = $elm$core$Basics$identity;
var $author$project$Form$File$WithImageCropper = function (a) {
	return {$: 1, a: a};
};
var $author$project$Form$File$WithoutImageCropper = {$: 0};
var $author$project$View$ImageCropper$Loading = {$: 0};
var $author$project$View$ImageCropper$init = function (_v0) {
	var aspectRatio = _v0.q;
	return {q: aspectRatio, aa: $author$project$View$ImageCropper$Loading, dn: false, bI: false, eE: false, nw: false};
};
var $author$project$Form$File$initMultiple = function (_v0) {
	var fileUrls = _v0.mU;
	var aspectRatio = _v0.q;
	return {
		q: aspectRatio,
		f: A2(
			$elm$core$List$map,
			function (file) {
				return {
					aH: $author$project$Form$File$LoadingFileType,
					ad: function () {
						if (aspectRatio.$ === 1) {
							return $author$project$Form$File$WithoutImageCropper;
						} else {
							var validAspectRatio = aspectRatio.a;
							return $author$project$Form$File$WithImageCropper(
								$author$project$View$ImageCropper$init(
									{q: validAspectRatio}));
						}
					}(),
					aD: $elm$core$Maybe$Nothing,
					gL: $author$project$Form$File$Loaded(file)
				};
			},
			fileUrls),
		ae: false,
		j: 0,
		G: 0,
		t: $elm$core$Maybe$Nothing
	};
};
var $author$project$Page$Community$New$initModel = {
	hk: $author$project$Form$init(
		{
			bc: A2($author$project$Form$RichText$initModel, 'description-editor', $elm$core$Maybe$Nothing),
			dl: '10',
			dm: '0',
			hC: $author$project$Form$File$initMultiple(
				{
					q: $elm$core$Maybe$Just(1),
					mU: $author$project$Page$Community$New$defaultLogos
				}),
			dC: '-100',
			ki: '',
			dQ: true,
			gw: 0,
			e9: '',
			gL: '',
			cQ: ''
		}),
	ns: false
};
var $author$project$Page$Community$New$init = function (_v0) {
	return _Utils_Tuple2($author$project$Page$Community$New$initModel, $elm$core$Platform$Cmd$none);
};
var $author$project$Page$Community$Objectives$NoOp = {$: 0};
var $author$project$Community$ObjectivesField = 0;
var $author$project$Session$LoggedIn$RequestedReloadCommunityField = function (a) {
	return {$: 6, a: a};
};
var $pzp1997$assoc_list$AssocList$D = $elm$core$Basics$identity;
var $pzp1997$assoc_list$AssocList$empty = _List_Nil;
var $pzp1997$assoc_list$AssocList$remove = F2(
	function (targetKey, _v0) {
		var alist = _v0;
		return A2(
			$elm$core$List$filter,
			function (_v1) {
				var key = _v1.a;
				return !_Utils_eq(key, targetKey);
			},
			alist);
	});
var $pzp1997$assoc_list$AssocList$insert = F3(
	function (key, value, dict) {
		var _v0 = A2($pzp1997$assoc_list$AssocList$remove, key, dict);
		var alteredAlist = _v0;
		return A2(
			$elm$core$List$cons,
			_Utils_Tuple2(key, value),
			alteredAlist);
	});
var $pzp1997$assoc_list$AssocList$fromList = function (alist) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, result) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($pzp1997$assoc_list$AssocList$insert, key, value, result);
			}),
		_List_Nil,
		alist);
};
var $author$project$Action$Id = $elm$core$Basics$identity;
var $author$project$Action$idFromInt = function (id) {
	return id;
};
var $author$project$Action$ObjectiveId = $elm$core$Basics$identity;
var $author$project$Action$objectiveIdFromInt = function (id) {
	return id;
};
var $author$project$Page$Community$Objectives$init = F2(
	function (selectedObjective, _v0) {
		return A2(
			$author$project$UpdateResult$addCmd,
			A2(
				$elm$core$Task$attempt,
				function (_v3) {
					return $author$project$Page$Community$Objectives$NoOp;
				},
				A2($elm$browser$Browser$Dom$setViewport, 0, 0)),
			A2(
				$author$project$UpdateResult$addExt,
				$author$project$Session$LoggedIn$RequestedReloadCommunityField(0),
				$author$project$UpdateResult$init(
					{
						cn: function () {
							if (selectedObjective.$ === 1) {
								return $elm$core$Maybe$Nothing;
							} else {
								var id = selectedObjective.a.R;
								var action = selectedObjective.a.iG;
								return $elm$core$Maybe$Just(
									{
										cT: A2($elm$core$Maybe$map, $author$project$Action$idFromInt, action),
										cx: $author$project$Action$objectiveIdFromInt(id)
									});
							}
						}(),
						E: function () {
							if (selectedObjective.$ === 1) {
								return $pzp1997$assoc_list$AssocList$empty;
							} else {
								var id = selectedObjective.a.R;
								return $pzp1997$assoc_list$AssocList$fromList(
									_List_fromArray(
										[
											_Utils_Tuple2(
											$author$project$Action$objectiveIdFromInt(id),
											{aR: $elm$core$Maybe$Nothing, a_: false, a4: $elm$core$Maybe$Nothing, bl: $elm$core$Maybe$Nothing, bm: $elm$core$Maybe$Nothing, bt: $elm$core$Maybe$Nothing, bu: $elm$core$Maybe$Nothing})
										]));
							}
						}()
					})));
	});
var $author$project$Page$Community$Selector$init = F2(
	function (maybeRedirect, _v0) {
		return _Utils_Tuple2(
			{j9: maybeRedirect},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Page$Community$Transfer$CompletedLoadCommunity = function (a) {
	return {$: 0, a: a};
};
var $author$project$Community$MembersField = 2;
var $author$project$Page$Community$Transfer$EditingTransfer = {$: 0};
var $author$project$Form$UserPicker$SinglePickerModel = $elm$core$Basics$identity;
var $author$project$View$Select$PrivateState = $elm$core$Basics$identity;
var $author$project$View$Select$Models$newState = function (id) {
	return {m7: $elm$core$Maybe$Nothing, R: id, dO: $elm$core$Maybe$Nothing, pc: false};
};
var $author$project$View$Select$newState = function (id) {
	return $author$project$View$Select$Models$newState(id);
};
var $author$project$Form$UserPicker$initSingle = function (_v0) {
	var id = _v0.R;
	return {
		R: id,
		dT: $author$project$View$Select$newState(id),
		W: $elm$core$Maybe$Nothing
	};
};
var $author$project$Page$Community$Transfer$initModel = function (maybeTo) {
	return {
		b5: $krisajenkins$remotedata$RemoteData$Loading,
		hk: $author$project$Form$init(
			{
				lU: '',
				ka: A2($author$project$Form$RichText$initModel, 'memo-editor', $elm$core$Maybe$Nothing),
				W: $author$project$Form$UserPicker$initSingle(
					{R: 'transfer-profile-select'})
			}),
		nR: maybeTo,
		pC: $krisajenkins$remotedata$RemoteData$Loading,
		aN: $author$project$Page$Community$Transfer$EditingTransfer
	};
};
var $author$project$Page$Community$Transfer$init = F2(
	function (loggedIn, maybeTo) {
		return A2(
			$author$project$UpdateResult$addExt,
			$author$project$Session$LoggedIn$RequestedReloadCommunityField(2),
			A2(
				$author$project$UpdateResult$addCmd,
				A3(
					$author$project$Session$LoggedIn$maybeInitWith,
					$author$project$Page$Community$Transfer$CompletedLoadCommunity,
					function ($) {
						return $.o7;
					},
					loggedIn),
				$author$project$UpdateResult$init(
					$author$project$Page$Community$Transfer$initModel(maybeTo))));
	});
var $author$project$Page$Dashboard$CompletedLoadCommunity = function (a) {
	return {$: 1, a: a};
};
var $author$project$Claim$Closed = {$: 1};
var $author$project$Page$Dashboard$InviteModalClosed = {$: 0};
var $author$project$Page$Dashboard$LoadingGraphql = function (a) {
	return {$: 0, a: a};
};
var $krisajenkins$remotedata$RemoteData$NotAsked = {$: 0};
var $justinmimbs$date$Date$RD = $elm$core$Basics$identity;
var $elm$core$Basics$clamp = F3(
	function (low, high, number) {
		return (_Utils_cmp(number, low) < 0) ? low : ((_Utils_cmp(number, high) > 0) ? high : number);
	});
var $justinmimbs$date$Date$isLeapYear = function (y) {
	return ((!A2($elm$core$Basics$modBy, 4, y)) && (!(!A2($elm$core$Basics$modBy, 100, y)))) || (!A2($elm$core$Basics$modBy, 400, y));
};
var $justinmimbs$date$Date$daysBeforeMonth = F2(
	function (y, m) {
		var leapDays = $justinmimbs$date$Date$isLeapYear(y) ? 1 : 0;
		switch (m) {
			case 0:
				return 0;
			case 1:
				return 31;
			case 2:
				return 59 + leapDays;
			case 3:
				return 90 + leapDays;
			case 4:
				return 120 + leapDays;
			case 5:
				return 151 + leapDays;
			case 6:
				return 181 + leapDays;
			case 7:
				return 212 + leapDays;
			case 8:
				return 243 + leapDays;
			case 9:
				return 273 + leapDays;
			case 10:
				return 304 + leapDays;
			default:
				return 334 + leapDays;
		}
	});
var $justinmimbs$date$Date$floorDiv = F2(
	function (a, b) {
		return $elm$core$Basics$floor(a / b);
	});
var $justinmimbs$date$Date$daysBeforeYear = function (y1) {
	var y = y1 - 1;
	var leapYears = (A2($justinmimbs$date$Date$floorDiv, y, 4) - A2($justinmimbs$date$Date$floorDiv, y, 100)) + A2($justinmimbs$date$Date$floorDiv, y, 400);
	return (365 * y) + leapYears;
};
var $justinmimbs$date$Date$daysInMonth = F2(
	function (y, m) {
		switch (m) {
			case 0:
				return 31;
			case 1:
				return $justinmimbs$date$Date$isLeapYear(y) ? 29 : 28;
			case 2:
				return 31;
			case 3:
				return 30;
			case 4:
				return 31;
			case 5:
				return 30;
			case 6:
				return 31;
			case 7:
				return 31;
			case 8:
				return 30;
			case 9:
				return 31;
			case 10:
				return 30;
			default:
				return 31;
		}
	});
var $justinmimbs$date$Date$fromCalendarDate = F3(
	function (y, m, d) {
		return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + A3(
			$elm$core$Basics$clamp,
			1,
			A2($justinmimbs$date$Date$daysInMonth, y, m),
			d);
	});
var $elm$time$Time$flooredDiv = F2(
	function (numerator, denominator) {
		return $elm$core$Basics$floor(numerator / denominator);
	});
var $elm$time$Time$posixToMillis = function (_v0) {
	var millis = _v0;
	return millis;
};
var $elm$time$Time$toAdjustedMinutesHelp = F3(
	function (defaultOffset, posixMinutes, eras) {
		toAdjustedMinutesHelp:
		while (true) {
			if (!eras.b) {
				return posixMinutes + defaultOffset;
			} else {
				var era = eras.a;
				var olderEras = eras.b;
				if (_Utils_cmp(era.p, posixMinutes) < 0) {
					return posixMinutes + era.d;
				} else {
					var $temp$defaultOffset = defaultOffset,
						$temp$posixMinutes = posixMinutes,
						$temp$eras = olderEras;
					defaultOffset = $temp$defaultOffset;
					posixMinutes = $temp$posixMinutes;
					eras = $temp$eras;
					continue toAdjustedMinutesHelp;
				}
			}
		}
	});
var $elm$time$Time$toAdjustedMinutes = F2(
	function (_v0, time) {
		var defaultOffset = _v0.a;
		var eras = _v0.b;
		return A3(
			$elm$time$Time$toAdjustedMinutesHelp,
			defaultOffset,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				60000),
			eras);
	});
var $elm$time$Time$toCivil = function (minutes) {
	var rawDay = A2($elm$time$Time$flooredDiv, minutes, 60 * 24) + 719468;
	var era = (((rawDay >= 0) ? rawDay : (rawDay - 146096)) / 146097) | 0;
	var dayOfEra = rawDay - (era * 146097);
	var yearOfEra = ((((dayOfEra - ((dayOfEra / 1460) | 0)) + ((dayOfEra / 36524) | 0)) - ((dayOfEra / 146096) | 0)) / 365) | 0;
	var dayOfYear = dayOfEra - (((365 * yearOfEra) + ((yearOfEra / 4) | 0)) - ((yearOfEra / 100) | 0));
	var mp = (((5 * dayOfYear) + 2) / 153) | 0;
	var month = mp + ((mp < 10) ? 3 : (-9));
	var year = yearOfEra + (era * 400);
	return {
		ja: (dayOfYear - ((((153 * mp) + 2) / 5) | 0)) + 1,
		kd: month,
		lI: year + ((month <= 2) ? 1 : 0)
	};
};
var $elm$time$Time$toDay = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).ja;
	});
var $elm$time$Time$Apr = 3;
var $elm$time$Time$Aug = 7;
var $elm$time$Time$Dec = 11;
var $elm$time$Time$Feb = 1;
var $elm$time$Time$Jan = 0;
var $elm$time$Time$Jul = 6;
var $elm$time$Time$Jun = 5;
var $elm$time$Time$Mar = 2;
var $elm$time$Time$May = 4;
var $elm$time$Time$Nov = 10;
var $elm$time$Time$Oct = 9;
var $elm$time$Time$Sep = 8;
var $elm$time$Time$toMonth = F2(
	function (zone, time) {
		var _v0 = $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).kd;
		switch (_v0) {
			case 1:
				return 0;
			case 2:
				return 1;
			case 3:
				return 2;
			case 4:
				return 3;
			case 5:
				return 4;
			case 6:
				return 5;
			case 7:
				return 6;
			case 8:
				return 7;
			case 9:
				return 8;
			case 10:
				return 9;
			case 11:
				return 10;
			default:
				return 11;
		}
	});
var $elm$time$Time$toYear = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).lI;
	});
var $justinmimbs$date$Date$fromPosix = F2(
	function (zone, posix) {
		return A3(
			$justinmimbs$date$Date$fromCalendarDate,
			A2($elm$time$Time$toYear, zone, posix),
			A2($elm$time$Time$toMonth, zone, posix),
			A2($elm$time$Time$toDay, zone, posix));
	});
var $author$project$Form$DatePicker$Model = $elm$core$Basics$identity;
var $CurrySoftware$elm_datepicker$DatePicker$DatePicker = $elm$core$Basics$identity;
var $CurrySoftware$elm_datepicker$DatePicker$initFromDate = function (date) {
	return {
		av: $elm$core$Maybe$Just(date),
		bE: false,
		aY: $elm$core$Maybe$Nothing,
		bj: false,
		pB: date
	};
};
var $author$project$Form$DatePicker$initModel = function (date) {
	return {
		cC: $CurrySoftware$elm_datepicker$DatePicker$initFromDate(date),
		bQ: $elm$core$Maybe$Just(date)
	};
};
var $author$project$Profile$Contact$Single = function (a) {
	return {$: 0, a: a};
};
var $author$project$Profile$Contact$defaultContactType = 5;
var $robinheghan$elm_phone_numbers$PhoneNumber$FixedLine = 0;
var $robinheghan$elm_phone_numbers$PhoneNumber$Mobile = 1;
var $robinheghan$elm_phone_numbers$PhoneNumber$NoInternationalDialling = 15;
var $robinheghan$elm_phone_numbers$PhoneNumber$PremiumRate = 3;
var $robinheghan$elm_phone_numbers$PhoneNumber$SharedCost = 4;
var $robinheghan$elm_phone_numbers$PhoneNumber$TollFree = 2;
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBR = {
	el: '55',
	jt: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-24679]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}')),
	R: 'BR',
	jR: $elm$core$Maybe$Just('00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)'),
	nZ: $elm$core$Maybe$Just('0'),
	kp: _List_fromArray(
		[
			{
			mN: '',
			hT: 15,
			ky: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('4020\\d{4}|[34]00\\d{5}'))
		},
			{
			mN: '1123456789',
			hT: 0,
			ky: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-5]\\d{7}'))
		},
			{
			mN: '11961234567',
			hT: 1,
			ky: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])(?:7|9\\d)\\d{7}'))
		},
			{
			mN: '800123456',
			hT: 2,
			ky: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('800\\d{6,7}'))
		},
			{
			mN: '300123456',
			hT: 3,
			ky: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('300\\d{6}|[59]00\\d{6,7}'))
		},
			{
			mN: '40041234',
			hT: 4,
			ky: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('300\\d{7}|[34]00\\d{5}|4(?:02|37)0\\d{4}'))
		}
		])
};
var $author$project$Profile$Contact$defaultCountry = {g5: $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryBR, aI: '/icons/flag-brazil.svg', az: '11 91234 5678'};
var $author$project$Profile$Contact$initBasic = function (contactType) {
	return {me: '', mf: contactType, jk: $elm$core$Maybe$Nothing, bD: $elm$core$Maybe$Nothing, nC: $elm$core$Maybe$Nothing, bV: false, aC: $author$project$Profile$Contact$defaultCountry};
};
var $author$project$Profile$Contact$initSingle = {
	ca: $elm$core$Maybe$Nothing,
	eG: $author$project$Profile$Contact$Single(
		$author$project$Profile$Contact$initBasic($author$project$Profile$Contact$defaultContactType)),
	X: $krisajenkins$remotedata$RemoteData$NotAsked
};
var $author$project$Page$Dashboard$initTransfersFilters = {c7: $elm$core$Maybe$Nothing, F: $elm$core$Maybe$Nothing, dJ: $elm$core$Maybe$Nothing};
var $author$project$Page$Dashboard$initModel = function (shared) {
	return {
		d6: false,
		b2: $author$project$Page$Dashboard$LoadingGraphql($elm$core$Maybe$Nothing),
		b5: $krisajenkins$remotedata$RemoteData$NotAsked,
		iZ: $author$project$Claim$Closed,
		ek: $author$project$Profile$Contact$initSingle,
		cb: false,
		aZ: $author$project$Page$Dashboard$InviteModalClosed,
		j0: '',
		eU: $elm$core$Maybe$Nothing,
		bT: false,
		cK: false,
		fh: $author$project$Form$init(
			{
				c7: $author$project$Form$DatePicker$initModel(
					A2($justinmimbs$date$Date$fromPosix, shared.ll, shared.gh)),
				F: $elm$core$Maybe$Nothing,
				gM: $author$project$Form$UserPicker$initSingle(
					{R: 'transfer-filters-user-picker'})
			}),
		an: $author$project$Page$Dashboard$LoadingGraphql($elm$core$Maybe$Nothing),
		bZ: $author$project$Page$Dashboard$initTransfersFilters
	};
};
var $author$project$Page$Dashboard$init = function (loggedIn) {
	var model = $author$project$Page$Dashboard$initModel(loggedIn.aM);
	return _Utils_Tuple2(
		model,
		A3(
			$author$project$Session$LoggedIn$maybeInitWith,
			$author$project$Page$Dashboard$CompletedLoadCommunity,
			function ($) {
				return $.o7;
			},
			loggedIn));
};
var $author$project$Page$Dashboard$Analysis$init = function (_v0) {
	return $author$project$UpdateResult$init(
		{});
};
var $author$project$Page$Dashboard$Claim$ClaimLoaded = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Encode$int = _Json_wrap;
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$int = function (value) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$Json(
		$elm$json$Json$Encode$int(value));
};
var $author$project$Cambiatus$Query$claim = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'claim',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'id', requiredArgs____.R, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int)
				]),
			object____,
			$elm$core$Basics$identity);
	});
var $author$project$Session$LoggedIn$RequestQuery = function (a) {
	return {$: 11, a: a};
};
var $author$project$Session$LoggedIn$RequiredAuthToken = function (a) {
	return {$: 10, a: a};
};
var $author$project$Api$Graphql$errorToString = function (errorData) {
	if (!errorData.$) {
		var graphqlErrors = errorData.b;
		return A2(
			$elm$core$String$join,
			'\n',
			A2(
				$elm$core$List$map,
				function ($) {
					return $.nS;
				},
				graphqlErrors));
	} else {
		return 'Http Error';
	}
};
var $author$project$Api$Graphql$isCertainError = F2(
	function (errorString, error) {
		return A2(
			$elm$core$String$contains,
			$elm$core$String$toLower(errorString),
			$elm$core$String$toLower(
				$author$project$Api$Graphql$errorToString(error)));
	});
var $author$project$Api$Graphql$isAuthError = $author$project$Api$Graphql$isCertainError('Please sign in first');
var $elm$core$Platform$Cmd$map = _Platform_map;
var $author$project$Session$LoggedIn$graphqlOperation = F4(
	function (operation, model, selectionSet, toMsg) {
		var operationCmd = F2(
			function (loggedIn, authToken) {
				return A4(
					operation,
					loggedIn,
					$elm$core$Maybe$Just(authToken),
					selectionSet,
					$elm$core$Basics$identity);
			});
		var treatAuthError = function (operationResult) {
			switch (operationResult.$) {
				case 3:
					var success = operationResult.a;
					return $elm$core$Result$Ok(
						toMsg(
							$krisajenkins$remotedata$RemoteData$Success(success)));
				case 2:
					var err = operationResult.a;
					return $author$project$Api$Graphql$isAuthError(err) ? $elm$core$Result$Err(
						{
							iU: function (newModel) {
								return A2(
									$elm$core$Basics$composeR,
									operationCmd(newModel),
									$elm$core$Platform$Cmd$map(toMsg));
							}
						}) : $elm$core$Result$Ok(
						toMsg(
							$krisajenkins$remotedata$RemoteData$Failure(err)));
				default:
					return $elm$core$Result$Ok(
						toMsg(operationResult));
			}
		};
		var _v0 = model.iN;
		if (_v0.$ === 1) {
			return $author$project$Session$LoggedIn$RequiredAuthToken(
				{
					iU: A2(
						$elm$core$Basics$composeR,
						operationCmd(model),
						$elm$core$Platform$Cmd$map(toMsg))
				});
		} else {
			var authToken = _v0.a;
			return $author$project$Session$LoggedIn$RequestQuery(
				A2(
					$elm$core$Platform$Cmd$map,
					treatAuthError,
					A2(operationCmd, model, authToken)));
		}
	});
var $author$project$Api$Graphql$withLoggedInCommunityDomain = function (loggedIn) {
	var _v0 = loggedIn.o7;
	if (_v0.$ === 3) {
		var subdomain = _v0.a.pl;
		return A2($dillonkearns$elm_graphql$Graphql$Http$withHeader, 'Community-Domain', 'https://' + subdomain);
	} else {
		return $author$project$Api$Graphql$withCommunityDomain(loggedIn.aM);
	}
};
var $author$project$Api$Graphql$loggedInQuery = F4(
	function (loggedIn, maybeAuthToken, query_, toMsg) {
		var shared = loggedIn.aM;
		return A2(
			$dillonkearns$elm_graphql$Graphql$Http$send,
			A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, toMsg),
			A2(
				$author$project$Api$Graphql$withAuthToken,
				maybeAuthToken,
				A2(
					$author$project$Api$Graphql$withLoggedInCommunityDomain,
					loggedIn,
					A2($dillonkearns$elm_graphql$Graphql$Http$queryRequest, shared.mJ.fS, query_))));
	});
var $author$project$Session$LoggedIn$query = F3(
	function (model, selectionSet, toMsg) {
		return A4($author$project$Session$LoggedIn$graphqlOperation, $author$project$Api$Graphql$loggedInQuery, model, selectionSet, toMsg);
	});
var $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent = {$: 1};
var $author$project$Claim$ActionCompleted = 2;
var $author$project$Claim$Cancelled = function (a) {
	return {$: 3, a: a};
};
var $author$project$Claim$DeadlineReached = 0;
var $author$project$Claim$Model = F8(
	function (id, status, claimer, action, checks, createdAt, proofPhoto, proofCode) {
		return {iG: action, S: checks, c$: claimer, fG: createdAt, R: id, h4: proofCode, eY: proofPhoto, gE: status};
	});
var $author$project$Claim$UsagesReached = 1;
var $author$project$Cambiatus$Object$Claim$action = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'action', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Claim$Check = F2(
	function (isApproved, validator) {
		return {be: isApproved, aE: validator};
	});
var $author$project$Cambiatus$Object$Check$isVerified = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'isVerified', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Cambiatus$Object$Check$validator = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'validator', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Claim$checkSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$Check$validator($author$project$Profile$minimalSelectionSet),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Cambiatus$Object$Check$isVerified,
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Claim$Check)));
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject = function (maybeValues) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$Object(
		A2(
			$elm$core$List$filterMap,
			function (_v0) {
				var key = _v0.a;
				var value = _v0.b;
				return A2(
					$elm$core$Maybe$andThen,
					function (actualValue) {
						return $elm$core$Maybe$Just(
							_Utils_Tuple2(key, actualValue));
					},
					value);
			},
			maybeValues));
};
var $elm$json$Json$Encode$null = _Json_encodeNull;
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$null = $dillonkearns$elm_graphql$Graphql$Internal$Encode$Json($elm$json$Json$Encode$null);
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$optional = F2(
	function (optionalValue, toValue) {
		switch (optionalValue.$) {
			case 0:
				var value = optionalValue.a;
				return $elm$core$Maybe$Just(
					toValue(value));
			case 1:
				return $elm$core$Maybe$Nothing;
			default:
				return $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$null);
		}
	});
var $author$project$Cambiatus$InputObject$encodeChecksInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'validator',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aE, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string))
			]));
};
var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional = F3(
	function (fieldName, maybeValue, toValue) {
		switch (maybeValue.$) {
			case 0:
				var value = maybeValue.a;
				return $elm$core$Maybe$Just(
					A2(
						$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$Argument,
						fieldName,
						toValue(value)));
			case 1:
				return $elm$core$Maybe$Nothing;
			default:
				return $elm$core$Maybe$Just(
					A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$Argument, fieldName, $dillonkearns$elm_graphql$Graphql$Internal$Encode$null));
		}
	});
var $author$project$Cambiatus$Object$Claim$checks = F2(
	function (fillInOptionals____, object____) {
		var filledInOptionals____ = fillInOptionals____(
			{nl: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
		var optionalArgs____ = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'input', filledInOptionals____.nl, $author$project$Cambiatus$InputObject$encodeChecksInput)
				]));
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'checks',
			optionalArgs____,
			object____,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
	});
var $author$project$Claim$Approved = {$: 0};
var $author$project$Claim$Pending = {$: 2};
var $author$project$Claim$Rejected = {$: 1};
var $author$project$Claim$claimStatusMap = function (v) {
	switch (v) {
		case 0:
			return $author$project$Claim$Approved;
		case 2:
			return $author$project$Claim$Rejected;
		default:
			return $author$project$Claim$Pending;
	}
};
var $author$project$Cambiatus$Object$Claim$claimer = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'claimer', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Cambiatus$Scalar$Date = $elm$core$Basics$identity;
var $author$project$Cambiatus$Scalar$DateTime = $elm$core$Basics$identity;
var $author$project$Cambiatus$Scalar$Id = $elm$core$Basics$identity;
var $author$project$Cambiatus$Scalar$NaiveDateTime = $elm$core$Basics$identity;
var $elm$json$Json$Decode$float = _Json_decodeFloat;
var $elm$core$String$fromFloat = _String_fromNumber;
var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			$elm$json$Json$Decode$string,
			A2($elm$json$Json$Decode$map, $elm$core$String$fromFloat, $elm$json$Json$Decode$float),
			A2($elm$json$Json$Decode$map, $elm$core$String$fromInt, $elm$json$Json$Decode$int),
			A2(
			$elm$json$Json$Decode$map,
			function (bool) {
				return bool ? 'true' : 'false';
			},
			$elm$json$Json$Decode$bool)
		]));
var $author$project$Cambiatus$Scalar$defaultCodecs = {
	l9: {
		jc: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		et: function (_v0) {
			var raw = _v0;
			return $elm$json$Json$Encode$string(raw);
		}
	},
	ma: {
		jc: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		et: function (_v1) {
			var raw = _v1;
			return $elm$json$Json$Encode$string(raw);
		}
	},
	eh: {
		jc: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		et: function (_v2) {
			var raw = _v2;
			return $elm$json$Json$Encode$string(raw);
		}
	},
	i2: {
		jc: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		et: function (_v3) {
			var raw = _v3;
			return $elm$json$Json$Encode$string(raw);
		}
	}
};
var $author$project$Cambiatus$Scalar$Codecs = $elm$core$Basics$identity;
var $author$project$Cambiatus$Scalar$defineCodecs = function (definitions) {
	return definitions;
};
var $author$project$Cambiatus$ScalarCodecs$codecs = $author$project$Cambiatus$Scalar$defineCodecs(
	{l9: $author$project$Cambiatus$Scalar$defaultCodecs.l9, ma: $author$project$Cambiatus$Scalar$defaultCodecs.ma, eh: $author$project$Cambiatus$Scalar$defaultCodecs.eh, i2: $author$project$Cambiatus$Scalar$defaultCodecs.i2});
var $author$project$Cambiatus$Scalar$unwrapCodecs = function (_v0) {
	var unwrappedCodecs = _v0;
	return unwrappedCodecs;
};
var $author$project$Cambiatus$Object$Claim$createdAt = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.DateTime',
	'createdAt',
	_List_Nil,
	$author$project$Cambiatus$Scalar$unwrapCodecs($author$project$Cambiatus$ScalarCodecs$codecs).ma.jc);
var $author$project$Claim$emptyStringToNothing = function (maybeString) {
	return A2(
		$elm$core$Maybe$andThen,
		function (s) {
			return $elm$core$String$isEmpty(s) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(s);
		},
		maybeString);
};
var $elm$time$Time$Posix = $elm$core$Basics$identity;
var $elm$time$Time$millisToPosix = $elm$core$Basics$identity;
var $elm$parser$Parser$andThen = $elm$parser$Parser$Advanced$andThen;
var $elm$parser$Parser$end = $elm$parser$Parser$Advanced$end($elm$parser$Parser$ExpectingEnd);
var $elm$parser$Parser$chompWhile = $elm$parser$Parser$Advanced$chompWhile;
var $elm$parser$Parser$getChompedString = $elm$parser$Parser$Advanced$getChompedString;
var $elm$parser$Parser$problem = function (msg) {
	return $elm$parser$Parser$Advanced$problem(
		$elm$parser$Parser$Problem(msg));
};
var $elm$core$Basics$round = _Basics_round;
var $elm$parser$Parser$succeed = $elm$parser$Parser$Advanced$succeed;
var $elm$core$String$toFloat = _String_toFloat;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs = A2(
	$elm$parser$Parser$andThen,
	function (str) {
		if ($elm$core$String$length(str) <= 9) {
			var _v0 = $elm$core$String$toFloat('0.' + str);
			if (!_v0.$) {
				var floatVal = _v0.a;
				return $elm$parser$Parser$succeed(
					$elm$core$Basics$round(floatVal * 1000));
			} else {
				return $elm$parser$Parser$problem('Invalid float: \"' + (str + '\"'));
			}
		} else {
			return $elm$parser$Parser$problem(
				'Expected at most 9 digits, but got ' + $elm$core$String$fromInt(
					$elm$core$String$length(str)));
		}
	},
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompWhile($elm$core$Char$isDigit)));
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts = F6(
	function (monthYearDayMs, hour, minute, second, ms, utcOffsetMinutes) {
		return $elm$time$Time$millisToPosix((((monthYearDayMs + (((hour * 60) * 60) * 1000)) + (((minute - utcOffsetMinutes) * 60) * 1000)) + (second * 1000)) + ms);
	});
var $elm$parser$Parser$ignorer = $elm$parser$Parser$Advanced$ignorer;
var $elm$parser$Parser$keeper = $elm$parser$Parser$Advanced$keeper;
var $elm$parser$Parser$oneOf = $elm$parser$Parser$Advanced$oneOf;
var $elm$parser$Parser$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$core$String$append = _String_append;
var $elm$parser$Parser$UnexpectedChar = {$: 11};
var $elm$parser$Parser$chompIf = function (isGood) {
	return A2($elm$parser$Parser$Advanced$chompIf, isGood, $elm$parser$Parser$UnexpectedChar);
};
var $elm$parser$Parser$map = $elm$parser$Parser$Advanced$map;
var $elm$parser$Parser$toAdvancedStep = function (step) {
	if (!step.$) {
		var s = step.a;
		return $elm$parser$Parser$Advanced$Loop(s);
	} else {
		var a = step.a;
		return $elm$parser$Parser$Advanced$Done(a);
	}
};
var $elm$parser$Parser$loop = F2(
	function (state, callback) {
		return A2(
			$elm$parser$Parser$Advanced$loop,
			state,
			function (s) {
				return A2(
					$elm$parser$Parser$map,
					$elm$parser$Parser$toAdvancedStep,
					callback(s));
			});
	});
var $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt = function (quantity) {
	var helper = function (str) {
		if (_Utils_eq(
			$elm$core$String$length(str),
			quantity)) {
			var _v0 = $elm$core$String$toInt(str);
			if (!_v0.$) {
				var intVal = _v0.a;
				return A2(
					$elm$parser$Parser$map,
					$elm$parser$Parser$Done,
					$elm$parser$Parser$succeed(intVal));
			} else {
				return $elm$parser$Parser$problem('Invalid integer: \"' + (str + '\"'));
			}
		} else {
			return A2(
				$elm$parser$Parser$map,
				function (nextChar) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$String$append, str, nextChar));
				},
				$elm$parser$Parser$getChompedString(
					$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
		}
	};
	return A2($elm$parser$Parser$loop, '', helper);
};
var $elm$parser$Parser$symbol = function (str) {
	return $elm$parser$Parser$Advanced$symbol(
		A2(
			$elm$parser$Parser$Advanced$Token,
			str,
			$elm$parser$Parser$ExpectingSymbol(str)));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear = 1970;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay = function (day) {
	return $elm$parser$Parser$problem(
		'Invalid day: ' + $elm$core$String$fromInt(day));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear = function (year) {
	return (!A2($elm$core$Basics$modBy, 4, year)) && ((!(!A2($elm$core$Basics$modBy, 100, year))) || (!A2($elm$core$Basics$modBy, 400, year)));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore = function (y1) {
	var y = y1 - 1;
	return (((y / 4) | 0) - ((y / 100) | 0)) + ((y / 400) | 0);
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay = 86400000;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear = 31536000000;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay = function (_v0) {
	var year = _v0.a;
	var month = _v0.b;
	var dayInMonth = _v0.c;
	if (dayInMonth < 0) {
		return $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth);
	} else {
		var succeedWith = function (extraMs) {
			var yearMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear * (year - $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear);
			var days = ((month < 3) || (!$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year))) ? (dayInMonth - 1) : dayInMonth;
			var dayMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay * (days + ($rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore(year) - $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore($rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear)));
			return $elm$parser$Parser$succeed((extraMs + yearMs) + dayMs);
		};
		switch (month) {
			case 1:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(0);
			case 2:
				return ((dayInMonth > 29) || ((dayInMonth === 29) && (!$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year)))) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(2678400000);
			case 3:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(5097600000);
			case 4:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(7776000000);
			case 5:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(10368000000);
			case 6:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(13046400000);
			case 7:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(15638400000);
			case 8:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(18316800000);
			case 9:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(20995200000);
			case 10:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(23587200000);
			case 11:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(26265600000);
			case 12:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(28857600000);
			default:
				return $elm$parser$Parser$problem(
					'Invalid month: \"' + ($elm$core$String$fromInt(month) + '\"'));
		}
	}
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs = A2(
	$elm$parser$Parser$andThen,
	$rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay,
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed(
					F3(
						function (year, month, day) {
							return _Utils_Tuple3(year, month, day);
						})),
				$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(4)),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$ignorer,
							$elm$parser$Parser$succeed($elm$core$Basics$identity),
							$elm$parser$Parser$symbol('-')),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
					]))),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed($elm$core$Basics$identity),
						$elm$parser$Parser$symbol('-')),
					$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
					$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
				]))));
var $rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes = function () {
	var utcOffsetMinutesFromParts = F3(
		function (multiplier, hours, minutes) {
			return (multiplier * (hours * 60)) + minutes;
		});
	return A2(
		$elm$parser$Parser$keeper,
		$elm$parser$Parser$succeed($elm$core$Basics$identity),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$map,
					function (_v0) {
						return 0;
					},
					$elm$parser$Parser$symbol('Z')),
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							$elm$parser$Parser$succeed(utcOffsetMinutesFromParts),
							$elm$parser$Parser$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$parser$Parser$map,
										function (_v1) {
											return 1;
										},
										$elm$parser$Parser$symbol('+')),
										A2(
										$elm$parser$Parser$map,
										function (_v2) {
											return -1;
										},
										$elm$parser$Parser$symbol('-'))
									]))),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$ignorer,
									$elm$parser$Parser$succeed($elm$core$Basics$identity),
									$elm$parser$Parser$symbol(':')),
								$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
								$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2),
								$elm$parser$Parser$succeed(0)
							]))),
					A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(0),
					$elm$parser$Parser$end)
				])));
}();
var $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601 = A2(
	$elm$parser$Parser$andThen,
	function (datePart) {
		return $elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed(
											$rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts(datePart)),
										$elm$parser$Parser$symbol('T')),
									$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
								$elm$parser$Parser$oneOf(
									_List_fromArray(
										[
											A2(
											$elm$parser$Parser$keeper,
											A2(
												$elm$parser$Parser$ignorer,
												$elm$parser$Parser$succeed($elm$core$Basics$identity),
												$elm$parser$Parser$symbol(':')),
											$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
											$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
										]))),
							$elm$parser$Parser$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$parser$Parser$keeper,
										A2(
											$elm$parser$Parser$ignorer,
											$elm$parser$Parser$succeed($elm$core$Basics$identity),
											$elm$parser$Parser$symbol(':')),
										$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
										$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2),
										$elm$parser$Parser$succeed(0)
									]))),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$symbol('.')),
									$rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs),
									$elm$parser$Parser$succeed(0)
								]))),
					A2($elm$parser$Parser$ignorer, $rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes, $elm$parser$Parser$end)),
					A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(
						A6($rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts, datePart, 0, 0, 0, 0, 0)),
					$elm$parser$Parser$end)
				]));
	},
	$rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs);
var $elm$parser$Parser$DeadEnd = F3(
	function (row, col, problem) {
		return {i3: col, oO: problem, o6: row};
	});
var $elm$parser$Parser$problemToDeadEnd = function (p) {
	return A3($elm$parser$Parser$DeadEnd, p.o6, p.i3, p.oO);
};
var $elm$parser$Parser$run = F2(
	function (parser, source) {
		var _v0 = A2($elm$parser$Parser$Advanced$run, parser, source);
		if (!_v0.$) {
			var a = _v0.a;
			return $elm$core$Result$Ok(a);
		} else {
			var problems = _v0.a;
			return $elm$core$Result$Err(
				A2($elm$core$List$map, $elm$parser$Parser$problemToDeadEnd, problems));
		}
	});
var $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime = function (str) {
	return A2($elm$parser$Parser$run, $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601, str);
};
var $author$project$Utils$fromDateTime = function (_v0) {
	var dateTime = _v0;
	return A2(
		$elm$core$Result$withDefault,
		$elm$time$Time$millisToPosix(0),
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(dateTime));
};
var $author$project$Cambiatus$Object$Claim$id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'id', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$Cambiatus$Object$Claim$proofCode = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'proofCode',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Cambiatus$Object$Claim$proofPhoto = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'proofPhoto',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Action$Action = function (id) {
	return function (description) {
		return function (image) {
			return function (objective) {
				return function (reward) {
					return function (verifierReward) {
						return function (creator) {
							return function (validators) {
								return function (usages) {
									return function (usagesLeft) {
										return function (deadline) {
											return function (verificationType) {
												return function (verifications) {
													return function (isCompleted) {
														return function (hasProofPhoto) {
															return function (hasProofCode) {
																return function (photoProofInstructions) {
																	return function (position) {
																		return function (claimCount) {
																			return function (maxClaimsPerAccount) {
																				return function (myClaimEligibility) {
																					return {l5: claimCount, mq: creator, ha: deadline, bc: description, m2: hasProofCode, m3: hasProofPhoto, R: id, jH: image, $7: isCompleted, j5: maxClaimsPerAccount, hP: myClaimEligibility, bi: objective, oD: photoProofInstructions, kC: position, h7: reward, lB: usages, lC: usagesLeft, pN: validators, lE: verificationType, pP: verifications, pQ: verifierReward};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$EnumValue = function (a) {
	return {$: 0, a: a};
};
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum = F2(
	function (enumToString, value) {
		return $dillonkearns$elm_graphql$Graphql$Internal$Encode$EnumValue(
			enumToString(value));
	});
var $author$project$Cambiatus$Enum$ClaimStatus$toString = function (enum____) {
	switch (enum____) {
		case 0:
			return 'APPROVED';
		case 1:
			return 'PENDING';
		default:
			return 'REJECTED';
	}
};
var $author$project$Cambiatus$Object$Action$claimCount = function (fillInOptionals____) {
	var filledInOptionals____ = fillInOptionals____(
		{gE: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
	var optionalArgs____ = A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		_List_fromArray(
			[
				A3(
				$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional,
				'status',
				filledInOptionals____.gE,
				$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Cambiatus$Enum$ClaimStatus$toString))
			]));
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'claimCount', optionalArgs____, $elm$json$Json$Decode$int);
};
var $author$project$Cambiatus$Object$Action$creatorId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'creatorId', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$Action$deadline = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe ScalarCodecs.DateTime)',
	'deadline',
	_List_Nil,
	$elm$json$Json$Decode$nullable(
		$author$project$Cambiatus$Scalar$unwrapCodecs($author$project$Cambiatus$ScalarCodecs$codecs).ma.jc));
var $author$project$Cambiatus$Object$Action$description = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'description', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Action$emptyStringToNothing = function (maybeString) {
	if (maybeString.$ === 1) {
		return $elm$core$Maybe$Nothing;
	} else {
		if (maybeString.a === '') {
			return $elm$core$Maybe$Nothing;
		} else {
			var nonEmptyString = maybeString.a;
			return $elm$core$Maybe$Just(nonEmptyString);
		}
	}
};
var $author$project$Cambiatus$Object$Action$hasProofCode = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe Bool)',
	'hasProofCode',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool));
var $author$project$Cambiatus$Object$Action$hasProofPhoto = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe Bool)',
	'hasProofPhoto',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool));
var $author$project$Cambiatus$Object$Action$id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'id', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$Action$idSelectionSet = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $elm$core$Basics$identity, $author$project$Cambiatus$Object$Action$id);
var $author$project$Cambiatus$Object$Action$image = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'image',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Cambiatus$Object$Action$isCompleted = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'isCompleted', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Cambiatus$Object$Action$objective = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'objective', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Action$Objective = F4(
	function (id, description, community, isCompleted) {
		return {b9: community, bc: description, R: id, $7: isCompleted};
	});
var $author$project$Cambiatus$Object$Objective$community = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'community', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Action$Community = F2(
	function (symbol, name) {
		return {ki: name, e9: symbol};
	});
var $author$project$Cambiatus$Object$Community$name = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'name', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$Community$symbol = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'symbol', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Action$communitySelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$Community$name,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Eos$symbolSelectionSet($author$project$Cambiatus$Object$Community$symbol),
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Action$Community)));
var $author$project$Cambiatus$Object$Objective$description = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'description', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$Objective$isCompleted = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'isCompleted', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Cambiatus$Object$Objective$id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'id', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$Action$objectiveIdSelectionSet = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $elm$core$Basics$identity, $author$project$Cambiatus$Object$Objective$id);
var $author$project$Action$objectiveSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$Objective$isCompleted,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Cambiatus$Object$Objective$community($author$project$Action$communitySelectionSet),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Markdown$selectionSet($author$project$Cambiatus$Object$Objective$description),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Action$objectiveIdSelectionSet,
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Action$Objective)))));
var $author$project$Cambiatus$Object$Action$photoProofInstructions = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'photoProofInstructions',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Cambiatus$Object$Action$position = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe Int)',
	'position',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int));
var $author$project$Cambiatus$Object$Action$reward = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Float', 'reward', _List_Nil, $elm$json$Json$Decode$float);
var $author$project$Cambiatus$Object$Action$usages = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'usages', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$Cambiatus$Object$Action$usagesLeft = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'usagesLeft', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$Cambiatus$Object$Action$validators = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'validators',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Cambiatus$Enum$VerificationType$Automatic = 0;
var $author$project$Cambiatus$Enum$VerificationType$Claimable = 1;
var $author$project$Cambiatus$Enum$VerificationType$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'AUTOMATIC':
				return $elm$json$Json$Decode$succeed(0);
			case 'CLAIMABLE':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('Invalid VerificationType type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$Action$verificationType = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.VerificationType.VerificationType', 'verificationType', _List_Nil, $author$project$Cambiatus$Enum$VerificationType$decoder);
var $author$project$Cambiatus$Object$Action$verifications = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'verifications', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$Cambiatus$Object$Action$verifierReward = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Float', 'verifierReward', _List_Nil, $elm$json$Json$Decode$float);
var $author$project$Action$actionFieldsSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$Action$claimCount(
		function (optionals) {
			return _Utils_update(
				optionals,
				{gE: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
		}),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Cambiatus$Object$Action$position,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Markdown$maybeSelectionSet($author$project$Cambiatus$Object$Action$photoProofInstructions),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
					$elm$core$Maybe$withDefault(false),
					$author$project$Cambiatus$Object$Action$hasProofCode),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
						$elm$core$Maybe$withDefault(false),
						$author$project$Cambiatus$Object$Action$hasProofPhoto),
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$Cambiatus$Object$Action$isCompleted,
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							$author$project$Cambiatus$Object$Action$verifications,
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
								$author$project$Cambiatus$Object$Action$verificationType,
								A2(
									$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
									$author$project$Cambiatus$Object$Action$deadline,
									A2(
										$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
										$author$project$Cambiatus$Object$Action$usagesLeft,
										A2(
											$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
											$author$project$Cambiatus$Object$Action$usages,
											A2(
												$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
												$author$project$Cambiatus$Object$Action$validators($author$project$Profile$minimalSelectionSet),
												A2(
													$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
													$author$project$Eos$Account$nameSelectionSet($author$project$Cambiatus$Object$Action$creatorId),
													A2(
														$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
														$author$project$Cambiatus$Object$Action$verifierReward,
														A2(
															$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
															$author$project$Cambiatus$Object$Action$reward,
															A2(
																$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																A2(
																	$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
																	function (o) {
																		return {b9: o.b9, bc: o.bc, R: o.R, $7: o.$7};
																	},
																	$author$project$Cambiatus$Object$Action$objective($author$project$Action$objectiveSelectionSet)),
																A2(
																	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																	A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Action$emptyStringToNothing, $author$project$Cambiatus$Object$Action$image),
																	A2(
																		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																		$author$project$Markdown$selectionSet($author$project$Cambiatus$Object$Action$description),
																		A2(
																			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																			$author$project$Action$idSelectionSet,
																			$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Action$Action))))))))))))))))))));
var $dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded = F2(
	function (constant, _v0) {
		var objectFields = _v0.a;
		var objectDecoder = _v0.b;
		return A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet,
			objectFields,
			A3(
				$elm$json$Json$Decode$map2,
				$elm$core$Basics$apR,
				$elm$json$Json$Decode$succeed(constant),
				objectDecoder));
	});
var $author$project$Action$selectionSetWithoutEligibility = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
	$elm$core$Maybe$Nothing,
	A2($dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded, $elm$core$Maybe$Nothing, $author$project$Action$actionFieldsSelectionSet));
var $author$project$Cambiatus$Enum$ClaimStatus$Approved = 0;
var $author$project$Cambiatus$Enum$ClaimStatus$Pending = 1;
var $author$project$Cambiatus$Enum$ClaimStatus$Rejected = 2;
var $author$project$Cambiatus$Enum$ClaimStatus$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'APPROVED':
				return $elm$json$Json$Decode$succeed(0);
			case 'PENDING':
				return $elm$json$Json$Decode$succeed(1);
			case 'REJECTED':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('Invalid ClaimStatus type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$Claim$status = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.ClaimStatus.ClaimStatus', 'status', _List_Nil, $author$project$Cambiatus$Enum$ClaimStatus$decoder);
var $author$project$Claim$selectionSet = function (now) {
	return A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
		function (claim) {
			var _v1 = claim.gE;
			if (_v1.$ === 2) {
				if (claim.iG.$7) {
					return _Utils_update(
						claim,
						{
							gE: $author$project$Claim$Cancelled(2)
						});
				} else {
					if ((!claim.iG.lC) && (claim.iG.lB > 0)) {
						return _Utils_update(
							claim,
							{
								gE: $author$project$Claim$Cancelled(1)
							});
					} else {
						var _v2 = claim.iG.ha;
						if (_v2.$ === 1) {
							return claim;
						} else {
							var deadline = _v2.a;
							return (_Utils_cmp(
								$elm$time$Time$posixToMillis(
									$author$project$Utils$fromDateTime(deadline)),
								$elm$time$Time$posixToMillis(now)) < 0) ? _Utils_update(
								claim,
								{
									gE: $author$project$Claim$Cancelled(0)
								}) : claim;
						}
					}
				}
			} else {
				return claim;
			}
		},
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Claim$emptyStringToNothing, $author$project$Cambiatus$Object$Claim$proofCode),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Claim$emptyStringToNothing, $author$project$Cambiatus$Object$Claim$proofPhoto),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$Cambiatus$Object$Claim$createdAt,
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						A2(
							$author$project$Cambiatus$Object$Claim$checks,
							function (_v0) {
								return {nl: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent};
							},
							$author$project$Claim$checkSelectionSet),
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							$author$project$Cambiatus$Object$Claim$action($author$project$Action$selectionSetWithoutEligibility),
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
								$author$project$Cambiatus$Object$Claim$claimer($author$project$Profile$minimalSelectionSet),
								A2(
									$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
									A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Claim$claimStatusMap, $author$project$Cambiatus$Object$Claim$status),
									A2(
										$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
										$author$project$Cambiatus$Object$Claim$id,
										$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Claim$Model))))))))));
};
var $author$project$Page$Dashboard$Claim$fetchClaim = F2(
	function (claimId, loggedIn) {
		return A3(
			$author$project$Session$LoggedIn$query,
			loggedIn,
			A2(
				$author$project$Cambiatus$Query$claim,
				{R: claimId},
				$author$project$Claim$selectionSet(loggedIn.aM.gh)),
			$author$project$Page$Dashboard$Claim$ClaimLoaded);
	});
var $author$project$Page$Dashboard$Claim$Loading = {$: 0};
var $author$project$Page$Dashboard$Claim$initModel = function (claimId) {
	return {l6: claimId, iZ: $author$project$Claim$Closed, a9: $author$project$Page$Dashboard$Claim$Loading};
};
var $author$project$Page$Dashboard$Claim$init = F2(
	function (loggedIn, claimId) {
		var model = $author$project$Page$Dashboard$Claim$initModel(claimId);
		return A2(
			$author$project$UpdateResult$addExt,
			A2($author$project$Page$Dashboard$Claim$fetchClaim, claimId, loggedIn),
			$author$project$UpdateResult$init(model));
	});
var $author$project$Page$Join$CompletedLoadCommunity = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Join$init = F2(
	function (session, maybeRedirect) {
		return _Utils_Tuple2(
			{j9: maybeRedirect},
			function () {
				if (!session.$) {
					return $elm$core$Platform$Cmd$none;
				} else {
					var loggedIn = session.a;
					return A3(
						$author$project$Session$LoggedIn$maybeInitWith,
						$author$project$Page$Join$CompletedLoadCommunity,
						function ($) {
							return $.o7;
						},
						loggedIn);
				}
			}());
	});
var $author$project$Page$Login$EnteringPassphrase = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Login$GotBip39 = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ports$JavascriptOut = $elm$core$Basics$identity;
var $author$project$Ports$javascriptOut = $elm$core$Basics$identity;
var $author$project$UpdateResult$addPort = F2(
	function (port_, uResult) {
		return _Utils_update(
			uResult,
			{
				kB: _Utils_ap(
					uResult.kB,
					_List_fromArray(
						[
							$author$project$Ports$javascriptOut(port_)
						]))
			});
	});
var $author$project$Page$Login$initPassphraseModel = {
	hk: $author$project$Form$init(
		{a6: ''}),
	bd: false
};
var $author$project$Page$Login$init = function (guest) {
	var requestBip39 = function () {
		var _v0 = guest.aM.ft;
		if (!_v0.$) {
			return $elm$core$Basics$identity;
		} else {
			return $author$project$UpdateResult$addPort(
				{
					i9: $elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string('getBip39'))
							])),
					kY: $author$project$Page$Login$GotBip39(
						{fL: $elm$core$Set$empty, gn: $elm$core$Set$empty, gD: $elm$core$Set$empty}),
					kZ: $elm$json$Json$Encode$null
				});
		}
	}();
	return requestBip39(
		$author$project$UpdateResult$init(
			$author$project$Page$Login$EnteringPassphrase($author$project$Page$Login$initPassphraseModel)));
};
var $author$project$Page$News$NoOp = {$: 0};
var $author$project$View$Components$PreventScrollOnMobile = 0;
var $author$project$Profile$Summary$init = function (isLarge) {
	return {
		fO: _List_Nil,
		eA: isLarge ? 'w-20 h-20' : 'h-10 w-10',
		dr: false,
		gp: 0,
		e$: $elm$core$Maybe$Nothing,
		e0: $elm$core$Maybe$Nothing,
		gz: true,
		gA: true,
		gB: true
	};
};
var $author$project$Page$News$init = F2(
	function (_v0, _v1) {
		var selectedNews = _v0.o8;
		var showOthers = _v0.pe;
		return A2(
			$author$project$UpdateResult$addCmd,
			A2(
				$elm$core$Task$perform,
				function (_v2) {
					return $author$project$Page$News$NoOp;
				},
				A2($elm$browser$Browser$Dom$setViewport, 0, 0)),
			A2(
				$author$project$UpdateResult$addExt,
				$author$project$Session$LoggedIn$RequestedReloadCommunityField(3),
				$author$project$UpdateResult$init(
					{
						eI: $author$project$Profile$Summary$init(false),
						bh: selectedNews,
						pd: showOthers,
						bW: false
					})));
	});
var $author$project$Page$Notification$CompletedLoadNotificationHistory = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Notification$Loading = {$: 0};
var $author$project$Page$Notification$initModel = $author$project$Page$Notification$Loading;
var $author$project$Cambiatus$Query$notificationHistory = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'notificationHistory',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Notification$History = F6(
	function (id, type_, isRead, payload, insertedAt, recipientId) {
		return {R: id, f_: insertedAt, nv: isRead, oA: payload, oY: recipientId, d0: type_};
	});
var $author$project$Cambiatus$Object$NotificationHistory$id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'id', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$Cambiatus$Object$NotificationHistory$insertedAt = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.DateTime',
	'insertedAt',
	_List_Nil,
	$author$project$Cambiatus$Scalar$unwrapCodecs($author$project$Cambiatus$ScalarCodecs$codecs).ma.jc);
var $author$project$Cambiatus$Object$NotificationHistory$isRead = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'isRead', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Cambiatus$Object$NotificationHistory$payload = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'payload', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Cambiatus$Object$NotificationHistory$recipientId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'recipientId', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Notification$Mint = function (a) {
	return {$: 2, a: a};
};
var $author$project$Notification$SaleHistory = function (a) {
	return {$: 1, a: a};
};
var $author$project$Notification$Transfer = function (a) {
	return {$: 0, a: a};
};
var $dillonkearns$elm_graphql$Graphql$SelectionSet$FragmentSelectionSet = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment = F2(
	function (fragmentTypeName, _v0) {
		var fields = _v0.a;
		var decoder = _v0.b;
		return A3($dillonkearns$elm_graphql$Graphql$SelectionSet$FragmentSelectionSet, fragmentTypeName, fields, decoder);
	});
var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFailureMessage = F2(
	function (typeSpecificSelections, typeName) {
		return A2(
			$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
			'Unhandled type `{0}` in exhaustive fragment handling. The following types had handlers registered to handle them: [{1}]. This happens if you are parsing either a Union or Interface. Do you need to rerun the `@dillonkearns/elm-graphql` command line tool?',
			_List_fromArray(
				[
					typeName,
					A2(
					$elm$core$String$join,
					', ',
					A2(
						$elm$core$List$map,
						function (_v0) {
							var fragmentType = _v0.a;
							var fields = _v0.b;
							var decoder = _v0.c;
							return fragmentType;
						},
						typeSpecificSelections))
				]));
	});
var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection = function (typeSpecificSelections) {
	var selections = A2(
		$elm$core$List$map,
		function (_v1) {
			var typeName = _v1.a;
			var fields = _v1.b;
			var decoder = _v1.c;
			return A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$composite, '...on ' + typeName, _List_Nil, fields);
		},
		typeSpecificSelections);
	return A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet,
		A2($elm$core$List$cons, $dillonkearns$elm_graphql$Graphql$RawField$typename, selections),
		A2(
			$elm$json$Json$Decode$andThen,
			function (typeName) {
				return A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Decode$fail(
						A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFailureMessage, typeSpecificSelections, typeName)),
					A2(
						$elm$core$Dict$get,
						typeName,
						$elm$core$Dict$fromList(
							A2(
								$elm$core$List$map,
								function (_v0) {
									var thisTypeName = _v0.a;
									var fields = _v0.b;
									var decoder = _v0.c;
									return _Utils_Tuple2(thisTypeName, decoder);
								},
								typeSpecificSelections))));
			},
			A2(
				$elm$json$Json$Decode$field,
				$dillonkearns$elm_graphql$Graphql$Document$Field$hashedAliasName($dillonkearns$elm_graphql$Graphql$RawField$typename),
				$elm$json$Json$Decode$string)));
};
var $author$project$Cambiatus$Union$NotificationType$fragments = function (selections____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(
		_List_fromArray(
			[
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'Mint', selections____.hX),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'Order', selections____.hY),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'Transfer', selections____.hZ)
			]));
};
var $author$project$Notification$MintData = F3(
	function (quantity, memo, community) {
		return {b9: community, ka: memo, oV: quantity};
	});
var $author$project$Cambiatus$Object$Mint$community = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'community', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Notification$Community = F3(
	function (logo, symbol, subdomain) {
		return {hC: logo, pl: subdomain, e9: symbol};
	});
var $author$project$Cambiatus$Object$Community$logo = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'logo',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Cambiatus$Object$Community$subdomain = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'subdomain',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$Notification$logoSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
		$elm$core$Maybe$withDefault(''),
		$author$project$Cambiatus$Object$Community$subdomain($author$project$Cambiatus$Object$Subdomain$name)),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Eos$symbolSelectionSet($author$project$Cambiatus$Object$Community$symbol),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, $author$project$Constants$defaultCommunityLogo, $author$project$Cambiatus$Object$Community$logo),
			$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Notification$Community))));
var $author$project$Cambiatus$Object$Mint$memo = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'memo',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Cambiatus$Object$Mint$quantity = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Float', 'quantity', _List_Nil, $elm$json$Json$Decode$float);
var $author$project$Notification$mintSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$Mint$community($author$project$Notification$logoSelectionSet),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Cambiatus$Object$Mint$memo,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Cambiatus$Object$Mint$quantity,
			$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Notification$MintData))));
var $author$project$Notification$OrderData = F4(
	function (amount, fromId, toId, product) {
		return {lU: amount, js: fromId, oP: product, lm: toId};
	});
var $author$project$Notification$Product = F4(
	function (id, title, images, community) {
		return {b9: community, R: id, hr: images, fb: title};
	});
var $author$project$Cambiatus$Object$Order$amount = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Float', 'amount', _List_Nil, $elm$json$Json$Decode$float);
var $author$project$Cambiatus$Object$Product$community = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'community', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Cambiatus$Object$Order$fromId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'fromId', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Shop$Id = $elm$core$Basics$identity;
var $author$project$Cambiatus$Object$Product$id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'id', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$Shop$idSelectionSet = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $elm$core$Basics$identity, $author$project$Cambiatus$Object$Product$id);
var $author$project$Cambiatus$Object$Product$images = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'images',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Cambiatus$Object$Order$product = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'product', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Cambiatus$Object$Product$title = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'title', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$Order$toId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'toId', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$ProductImage$uri = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'uri', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Notification$saleHistorySelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$Order$product(
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Cambiatus$Object$Product$community($author$project$Notification$logoSelectionSet),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Cambiatus$Object$Product$images($author$project$Cambiatus$Object$ProductImage$uri),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$Cambiatus$Object$Product$title,
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$Shop$idSelectionSet,
						$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Notification$Product)))))),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Eos$Account$nameSelectionSet($author$project$Cambiatus$Object$Order$toId),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Eos$Account$nameSelectionSet($author$project$Cambiatus$Object$Order$fromId),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Cambiatus$Object$Order$amount,
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Notification$OrderData)))));
var $author$project$Notification$TransferData = F7(
	function (id, amount, fromId, toId, memo, symbol, community) {
		return {lU: amount, b9: community, js: fromId, R: id, ka: memo, e9: symbol, lm: toId};
	});
var $author$project$Cambiatus$Object$Transfer$amount = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Float', 'amount', _List_Nil, $elm$json$Json$Decode$float);
var $author$project$Cambiatus$Object$Transfer$community = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'community', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Cambiatus$Object$Transfer$communityId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'communityId', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$Transfer$fromId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'fromId', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$Transfer$id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'id', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$Cambiatus$Object$Transfer$memo = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'memo',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Cambiatus$Object$Transfer$toId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'toId', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Notification$transferSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$Transfer$community($author$project$Notification$logoSelectionSet),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Eos$symbolSelectionSet($author$project$Cambiatus$Object$Transfer$communityId),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Cambiatus$Object$Transfer$memo,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Cambiatus$Object$Transfer$toId,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$Cambiatus$Object$Transfer$fromId,
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$Cambiatus$Object$Transfer$amount,
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							$author$project$Cambiatus$Object$Transfer$id,
							$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Notification$TransferData))))))));
var $author$project$Notification$typeUnionSelectionSet = $author$project$Cambiatus$Union$NotificationType$fragments(
	{
		hX: A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Notification$Mint, $author$project$Notification$mintSelectionSet),
		hY: A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Notification$SaleHistory, $author$project$Notification$saleHistorySelectionSet),
		hZ: A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Notification$Transfer, $author$project$Notification$transferSelectionSet)
	});
var $author$project$Cambiatus$Object$NotificationHistory$type_ = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'type', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Notification$notificationHistorySelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Eos$Account$nameSelectionSet($author$project$Cambiatus$Object$NotificationHistory$recipientId),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Cambiatus$Object$NotificationHistory$insertedAt,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Cambiatus$Object$NotificationHistory$payload($author$project$Notification$typeUnionSelectionSet),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Cambiatus$Object$NotificationHistory$isRead,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$Cambiatus$Object$NotificationHistory$type_,
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$Cambiatus$Object$NotificationHistory$id,
						$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Notification$History)))))));
var $author$project$Notification$notificationHistoryQuery = function (account) {
	return $author$project$Cambiatus$Query$notificationHistory($author$project$Notification$notificationHistorySelectionSet);
};
var $author$project$Page$Notification$init = function (loggedIn) {
	return A2(
		$author$project$UpdateResult$addExt,
		A3(
			$author$project$Session$LoggedIn$query,
			loggedIn,
			$author$project$Notification$notificationHistoryQuery(loggedIn.lM),
			$author$project$Page$Notification$CompletedLoadNotificationHistory),
		$author$project$UpdateResult$init($author$project$Page$Notification$initModel));
};
var $author$project$Page$PaymentHistory$CompletedLoadCommunity = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$PaymentHistory$Loading = {$: 0};
var $author$project$Avatar$empty = $elm$core$Maybe$Nothing;
var $author$project$Page$PaymentHistory$init = F2(
	function (recipientAccountName, loggedIn) {
		var recipientProfile = {fl: recipientAccountName, cV: $author$project$Avatar$empty, cW: $elm$core$Maybe$Nothing, aq: _List_Nil, jh: $elm$core$Maybe$Nothing, ki: $elm$core$Maybe$Nothing};
		var initModel = {
			eb: _List_Nil,
			fq: $elm$core$Maybe$Nothing,
			ep: $author$project$Form$DatePicker$initModel(
				A2($justinmimbs$date$Date$fromPosix, loggedIn.aM.ll, loggedIn.aM.gh)),
			cq: $elm$core$Maybe$Nothing,
			cr: $elm$core$Maybe$Nothing,
			ax: false,
			eZ: $author$project$Page$PaymentHistory$Loading,
			oZ: recipientProfile,
			bQ: $elm$core$Maybe$Nothing,
			cO: $author$project$Form$UserPicker$initSingle(
				{R: 'user-picker'})
		};
		return _Utils_Tuple2(
			initModel,
			A3(
				$author$project$Session$LoggedIn$maybeInitWith,
				$author$project$Page$PaymentHistory$CompletedLoadCommunity,
				function ($) {
					return $.o7;
				},
				loggedIn));
	});
var $author$project$Page$Profile$CompletedLoadCommunity = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Profile$CompletedLoadProfile = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Profile$Loading = function (a) {
	return {$: 1, a: a};
};
var $author$project$Eos$Account$nameToString = function (_v0) {
	var name = _v0;
	return name;
};
var $author$project$Profile$Model = function (name) {
	return function (account) {
		return function (avatar) {
			return function (email) {
				return function (bio) {
					return function (localization) {
						return function (contacts) {
							return function (interests) {
								return function (communities) {
									return function (roles) {
										return function (analysisCount) {
											return function (kyc) {
												return function (address) {
													return function (claimNotification) {
														return function (digest) {
															return function (transferNotification) {
																return function (preferredLanguage) {
																	return function (latestAcceptedTerms) {
																		return {fl: account, gP: address, lV: analysisCount, cV: avatar, cW: bio, c_: claimNotification, ei: communities, aq: contacts, c9: digest, jh: email, dj: interests, hx: kyc, nG: latestAcceptedTerms, nM: localization, ki: name, oJ: preferredLanguage, o5: roles, d$: transferNotification};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Cambiatus$Object$User$address = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'address',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$Cambiatus$Object$User$analysisCount = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'analysisCount', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$Cambiatus$Object$User$claimNotification = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'claimNotification', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Cambiatus$Object$User$communities = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'communities',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Profile$CommunityInfo = F7(
	function (symbol, name, logo, subdomain, hasShop, hasActions, hasKyc) {
		return {m_: hasActions, ck: hasKyc, cm: hasShop, hC: logo, ki: name, pl: subdomain, e9: symbol};
	});
var $author$project$Cambiatus$Object$Community$hasKyc = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'hasKyc', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Cambiatus$Object$Community$hasObjectives = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'hasObjectives', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Cambiatus$Object$Community$hasShop = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'hasShop', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Profile$communityInfoSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$Community$hasKyc,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Cambiatus$Object$Community$hasObjectives,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Cambiatus$Object$Community$hasShop,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
					$elm$core$Maybe$withDefault(''),
					$author$project$Cambiatus$Object$Community$subdomain($author$project$Cambiatus$Object$Subdomain$name)),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, $author$project$Constants$defaultCommunityLogo, $author$project$Cambiatus$Object$Community$logo),
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$Cambiatus$Object$Community$name,
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							$author$project$Eos$symbolSelectionSet($author$project$Cambiatus$Object$Community$symbol),
							$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Profile$CommunityInfo))))))));
var $author$project$Cambiatus$Object$User$digest = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'digest', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Utils$fromNaiveDateTime = function (_v0) {
	var dateTime = _v0;
	return A2(
		$elm$core$Result$withDefault,
		$elm$time$Time$millisToPosix(0),
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(dateTime));
};
var $author$project$Cambiatus$Object$User$interests = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'interests',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Cambiatus$Object$User$kyc = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'kyc',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$Translation$Amharic = 4;
var $author$project$Translation$English = 0;
var $author$project$Translation$Portuguese = 1;
var $author$project$Translation$Spanish = 2;
var $author$project$Cambiatus$Enum$Language$Amheth = 0;
var $author$project$Cambiatus$Enum$Language$Enus = 1;
var $author$project$Cambiatus$Enum$Language$Eses = 2;
var $author$project$Cambiatus$Enum$Language$Ptbr = 3;
var $author$project$Cambiatus$Enum$Language$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'AMHETH':
				return $elm$json$Json$Decode$succeed(0);
			case 'ENUS':
				return $elm$json$Json$Decode$succeed(1);
			case 'ESES':
				return $elm$json$Json$Decode$succeed(2);
			case 'PTBR':
				return $elm$json$Json$Decode$succeed(3);
			default:
				return $elm$json$Json$Decode$fail('Invalid Language type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$User$language = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe Enum.Language.Language)',
	'language',
	_List_Nil,
	$elm$json$Json$Decode$nullable($author$project$Cambiatus$Enum$Language$decoder));
var $author$project$Profile$languageSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
	$elm$core$Maybe$map(
		function (language) {
			switch (language) {
				case 0:
					return 4;
				case 1:
					return 0;
				case 2:
					return 2;
				default:
					return 1;
			}
		}),
	$author$project$Cambiatus$Object$User$language);
var $author$project$Cambiatus$Object$User$latestAcceptedTerms = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe ScalarCodecs.NaiveDateTime)',
	'latestAcceptedTerms',
	_List_Nil,
	$elm$json$Json$Decode$nullable(
		$author$project$Cambiatus$Scalar$unwrapCodecs($author$project$Cambiatus$ScalarCodecs$codecs).i2.jc));
var $author$project$Cambiatus$Object$User$location = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'location',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Profile$Role = F3(
	function (color, name, permissions) {
		return {mb: color, ki: name, oB: permissions};
	});
var $author$project$Cambiatus$Object$Role$color = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'color',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Cambiatus$Object$Role$name = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'name', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Cambiatus$Enum$Permission$Admin = 0;
var $author$project$Cambiatus$Enum$Permission$Award = 1;
var $author$project$Cambiatus$Enum$Permission$Claim = 2;
var $author$project$Cambiatus$Enum$Permission$Invite = 3;
var $author$project$Cambiatus$Enum$Permission$Order = 4;
var $author$project$Cambiatus$Enum$Permission$Sell = 5;
var $author$project$Cambiatus$Enum$Permission$Transfer = 6;
var $author$project$Cambiatus$Enum$Permission$Verify = 7;
var $author$project$Cambiatus$Enum$Permission$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'ADMIN':
				return $elm$json$Json$Decode$succeed(0);
			case 'AWARD':
				return $elm$json$Json$Decode$succeed(1);
			case 'CLAIM':
				return $elm$json$Json$Decode$succeed(2);
			case 'INVITE':
				return $elm$json$Json$Decode$succeed(3);
			case 'ORDER':
				return $elm$json$Json$Decode$succeed(4);
			case 'SELL':
				return $elm$json$Json$Decode$succeed(5);
			case 'TRANSFER':
				return $elm$json$Json$Decode$succeed(6);
			case 'VERIFY':
				return $elm$json$Json$Decode$succeed(7);
			default:
				return $elm$json$Json$Decode$fail('Invalid Permission type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$Role$permissions = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(List Enum.Permission.Permission)',
	'permissions',
	_List_Nil,
	$elm$json$Json$Decode$list($author$project$Cambiatus$Enum$Permission$decoder));
var $author$project$Profile$roleSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$Role$permissions,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Cambiatus$Object$Role$name,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Cambiatus$Object$Role$color,
			$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Profile$Role))));
var $author$project$Cambiatus$Object$User$roles = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'roles',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Kyc$ProfileKyc = F5(
	function (userType, documentType, document, phone, isVerified) {
		return {eq: document, er: documentType, ny: isVerified, eT: phone, lD: userType};
	});
var $author$project$Cambiatus$Object$KycData$document = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'document', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$KycData$documentType = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'documentType', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$KycData$isVerified = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'isVerified', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Cambiatus$Object$KycData$phone = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'phone', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$KycData$userType = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'userType', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Kyc$selectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$KycData$isVerified,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Cambiatus$Object$KycData$phone,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Cambiatus$Object$KycData$document,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Cambiatus$Object$KycData$documentType,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$Cambiatus$Object$KycData$userType,
					$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Kyc$ProfileKyc))))));
var $author$project$Profile$Address$Address = F7(
	function (country, state, city, neighborhood, street, number, zip) {
		return {l4: city, g5: country, n_: neighborhood, ay: number, X: state, ba: street, fk: zip};
	});
var $author$project$Cambiatus$Object$Address$city = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'city', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Profile$Address$City = function (name) {
	return {ki: name};
};
var $author$project$Cambiatus$Object$City$name = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'name', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Profile$Address$citySelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$City$name,
	$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Profile$Address$City));
var $author$project$Cambiatus$Object$Address$country = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'country', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Profile$Address$Country = function (name) {
	return {ki: name};
};
var $author$project$Cambiatus$Object$Country$name = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'name', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Profile$Address$countrySelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$Country$name,
	$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Profile$Address$Country));
var $author$project$Cambiatus$Object$Address$neighborhood = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'neighborhood', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Profile$Address$Neighborhood = function (name) {
	return {ki: name};
};
var $author$project$Cambiatus$Object$Neighborhood$name = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'name', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Profile$Address$neighborhoodSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$Neighborhood$name,
	$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Profile$Address$Neighborhood));
var $author$project$Cambiatus$Object$Address$number = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'number',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Cambiatus$Object$Address$state = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'state', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Profile$Address$State = function (name) {
	return {ki: name};
};
var $author$project$Cambiatus$Object$State$name = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'name', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Profile$Address$stateSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$State$name,
	$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Profile$Address$State));
var $author$project$Cambiatus$Object$Address$street = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'street', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$Address$zip = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'zip', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Profile$Address$selectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$Address$zip,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
			$elm$core$Maybe$withDefault(''),
			$author$project$Cambiatus$Object$Address$number),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Cambiatus$Object$Address$street,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
					function ($) {
						return $.ki;
					},
					$author$project$Cambiatus$Object$Address$neighborhood($author$project$Profile$Address$neighborhoodSelectionSet)),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
						function ($) {
							return $.ki;
						},
						$author$project$Cambiatus$Object$Address$city($author$project$Profile$Address$citySelectionSet)),
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
							function ($) {
								return $.ki;
							},
							$author$project$Cambiatus$Object$Address$state($author$project$Profile$Address$stateSelectionSet)),
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
								function ($) {
									return $.ki;
								},
								$author$project$Cambiatus$Object$Address$country($author$project$Profile$Address$countrySelectionSet)),
							$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Profile$Address$Address))))))));
var $author$project$Cambiatus$Object$User$transferNotification = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'transferNotification', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Profile$selectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
		$elm$core$Maybe$map($author$project$Utils$fromNaiveDateTime),
		$author$project$Cambiatus$Object$User$latestAcceptedTerms),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Profile$languageSelectionSet,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Cambiatus$Object$User$transferNotification,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Cambiatus$Object$User$digest,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$Cambiatus$Object$User$claimNotification,
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$Cambiatus$Object$User$address($author$project$Profile$Address$selectionSet),
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							$author$project$Cambiatus$Object$User$kyc($author$project$Kyc$selectionSet),
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
								$author$project$Cambiatus$Object$User$analysisCount,
								A2(
									$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
									$author$project$Cambiatus$Object$User$roles($author$project$Profile$roleSelectionSet),
									A2(
										$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
										$author$project$Cambiatus$Object$User$communities($author$project$Profile$communityInfoSelectionSet),
										A2(
											$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
											A2(
												$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
												function (maybeInterests) {
													return A2(
														$elm$core$Maybe$withDefault,
														_List_Nil,
														A2(
															$elm$core$Maybe$map,
															$elm$core$String$split(','),
															maybeInterests));
												},
												$author$project$Cambiatus$Object$User$interests),
											A2(
												$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
												$author$project$Profile$userContactSelectionSet,
												A2(
													$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
													$author$project$Cambiatus$Object$User$location,
													A2(
														$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
														$author$project$Markdown$maybeSelectionSet($author$project$Cambiatus$Object$User$bio),
														A2(
															$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
															$author$project$Cambiatus$Object$User$email,
															A2(
																$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																$author$project$Avatar$selectionSet($author$project$Cambiatus$Object$User$avatar),
																A2(
																	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																	$author$project$Eos$Account$nameSelectionSet($author$project$Cambiatus$Object$User$account),
																	A2(
																		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																		$author$project$Cambiatus$Object$User$name,
																		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Profile$Model)))))))))))))))))));
var $author$project$Cambiatus$Query$user = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'user',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'account', requiredArgs____.fl, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)
				]),
			object____,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
	});
var $author$project$Profile$query = function (account) {
	var nameString = $author$project$Eos$Account$nameToString(account);
	return A2(
		$author$project$Cambiatus$Query$user,
		{fl: nameString},
		$author$project$Profile$selectionSet);
};
var $author$project$Page$Profile$init = F2(
	function (loggedIn, profileName) {
		var model = {
			b5: $krisajenkins$remotedata$RemoteData$Loading,
			bF: $krisajenkins$remotedata$RemoteData$Loading,
			kJ: $krisajenkins$remotedata$RemoteData$Loading,
			oS: profileName,
			aO: $author$project$Page$Profile$Loading(_List_Nil)
		};
		var fetchProfile = _Utils_eq(loggedIn.lM, profileName) ? $author$project$UpdateResult$addCmd(
			A3(
				$author$project$Session$LoggedIn$maybeInitWith,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Maybe$Just,
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$Success, $author$project$Page$Profile$CompletedLoadProfile)),
				function ($) {
					return $.kJ;
				},
				loggedIn)) : $author$project$UpdateResult$addExt(
			A3(
				$author$project$Session$LoggedIn$query,
				loggedIn,
				$author$project$Profile$query(profileName),
				$author$project$Page$Profile$CompletedLoadProfile));
		return A2(
			$author$project$UpdateResult$addCmd,
			A3(
				$author$project$Session$LoggedIn$maybeInitWith,
				$author$project$Page$Profile$CompletedLoadCommunity,
				function ($) {
					return $.o7;
				},
				loggedIn),
			fetchProfile(
				$author$project$UpdateResult$init(model)));
	});
var $author$project$Page$Profile$AddContact$CompletedLoadProfile = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Profile$AddContact$init = function (loggedIn) {
	return _Utils_Tuple2(
		$krisajenkins$remotedata$RemoteData$Loading,
		A3(
			$author$project$Session$LoggedIn$maybeInitWith,
			$author$project$Page$Profile$AddContact$CompletedLoadProfile,
			function ($) {
				return $.kJ;
			},
			loggedIn));
};
var $author$project$Profile$EditKycForm$CedulaDoc = 0;
var $author$project$Profile$EditKycForm$init = {
	hk: $author$project$Form$init(
		{eq: '', er: 0, oC: ''})
};
var $author$project$Page$Profile$AddKyc$init = function (_v0) {
	return _Utils_Tuple2($author$project$Profile$EditKycForm$init, $elm$core$Platform$Cmd$none);
};
var $author$project$Page$Profile$Claims$CompletedLoadCommunity = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Profile$Claims$All = 0;
var $author$project$Page$Profile$Claims$Asc = 0;
var $author$project$Page$Profile$Claims$Loading = {$: 0};
var $author$project$Page$Profile$Claims$WaitingVote = 0;
var $author$project$Page$Profile$Claims$initModel = function (account) {
	return {lN: account, iZ: $author$project$Claim$Closed, fI: 0, es: 0, dH: 0, cJ: 0, dX: false, gE: $author$project$Page$Profile$Claims$Loading};
};
var $author$project$Page$Profile$Claims$init = F2(
	function (loggedIn, account) {
		return _Utils_Tuple2(
			$author$project$Page$Profile$Claims$initModel(account),
			A3(
				$author$project$Session$LoggedIn$maybeInitWith,
				$author$project$Page$Profile$Claims$CompletedLoadCommunity,
				function ($) {
					return $.o7;
				},
				loggedIn));
	});
var $author$project$Page$Profile$Editor$CompletedLoadProfile = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Profile$Editor$RequestedEditorData = {$: 2};
var $author$project$Page$Profile$Editor$Loading = {$: 0};
var $author$project$Page$Profile$Editor$initModel = {cg: $krisajenkins$remotedata$RemoteData$NotAsked, hk: $author$project$Page$Profile$Editor$Loading, kJ: $elm$core$Maybe$Nothing};
var $author$project$Utils$spawnMessage = function (msg) {
	return A2(
		$elm$core$Task$perform,
		$elm$core$Basics$identity,
		$elm$core$Task$succeed(msg));
};
var $author$project$Page$Profile$Editor$init = function (loggedIn) {
	return _Utils_Tuple2(
		$author$project$Page$Profile$Editor$initModel,
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A3(
					$author$project$Session$LoggedIn$maybeInitWith,
					$author$project$Page$Profile$Editor$CompletedLoadProfile,
					function ($) {
						return $.kJ;
					},
					loggedIn),
					$author$project$Utils$spawnMessage($author$project$Page$Profile$Editor$RequestedEditorData)
				])));
};
var $author$project$Page$Register$CompletedLoadCommunity = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Register$CompletedLoadInvite = function (a) {
	return {$: 9, a: a};
};
var $author$project$Page$Register$FillForm = 0;
var $author$project$Page$Register$Loading = {$: 0};
var $author$project$Session$Guest$maybeInitWith = F3(
	function (toMsg, attribute, model) {
		var _v0 = attribute(model);
		if (_v0.$ === 3) {
			var value = _v0.a;
			return A2(
				$elm$core$Task$perform,
				toMsg,
				$elm$core$Task$succeed(value));
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Page$Register$init = F2(
	function (invitationId, guest) {
		var shared = guest.aM;
		var loadInvitationData = function () {
			if (!invitationId.$) {
				var id = invitationId.a;
				return A4(
					$author$project$Api$Graphql$query,
					shared,
					$elm$core$Maybe$Nothing,
					$author$project$Community$inviteQuery(id),
					$author$project$Page$Register$CompletedLoadInvite);
			} else {
				return $elm$core$Platform$Cmd$none;
			}
		}();
		var initialModel = {fm: $elm$core$Maybe$Nothing, g5: $elm$core$Maybe$Nothing, ex: false, dk: $elm$core$Maybe$Nothing, jT: invitationId, f0: false, gE: $author$project$Page$Register$Loading, e8: 0};
		return _Utils_Tuple2(
			initialModel,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						loadInvitationData,
						A3(
						$author$project$Session$Guest$maybeInitWith,
						$author$project$Page$Register$CompletedLoadCommunity,
						function ($) {
							return $.b9;
						},
						guest)
					])));
	});
var $author$project$Page$Settings$NotUpdating = {$: 0};
var $author$project$Page$Settings$GotPinMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$View$Pin$Ignored = {$: 0};
var $author$project$View$Pin$Light = 0;
var $elm$browser$Browser$Dom$focus = _Browser_call('focus');
var $author$project$View$Pin$init = function (_v0) {
	var label = _v0.nC;
	var id = _v0.R;
	var withConfirmation = _v0.pU;
	var submitLabel = _v0.pm;
	var submittingLabel = _v0.po;
	var pinVisibility = _v0.oF;
	var lastKnownPin = _v0.nF;
	return _Utils_Tuple2(
		{
			fs: 0,
			cf: false,
			hk: $author$project$Form$init(
				{c3: '', oE: ''}),
			R: id,
			eD: pinVisibility,
			cu: pinVisibility,
			cv: false,
			nC: label,
			nF: lastKnownPin,
			hQ: withConfirmation,
			bn: _List_Nil,
			pm: submitLabel,
			po: submittingLabel
		},
		A2(
			$elm$core$Task$attempt,
			function (_v1) {
				return $author$project$View$Pin$Ignored;
			},
			$elm$browser$Browser$Dom$focus('pin-input')));
};
var $author$project$Page$Settings$initPin = function (loggedIn) {
	return A2(
		$elm$core$Tuple$mapSecond,
		$elm$core$Platform$Cmd$map($author$project$Page$Settings$GotPinMsg),
		$author$project$View$Pin$init(
			{R: 'new-pin-input', nC: 'profile.newPin', nF: loggedIn.fp.ag.nF, oF: loggedIn.aM.oF, pm: 'profile.pin.button', po: 'profile.pin.button', pU: false}));
};
var $author$project$Page$Settings$init = function (loggedIn) {
	var _v0 = $author$project$Page$Settings$initPin(loggedIn);
	var pinModel = _v0.a;
	var pinCmd = _v0.b;
	return _Utils_Tuple2(
		{b8: $author$project$Page$Settings$NotUpdating, ce: $author$project$Page$Settings$NotUpdating, dp: false, ds: false, du: false, cD: pinModel, cM: $author$project$Page$Settings$NotUpdating},
		pinCmd);
};
var $author$project$Shop$Where$Anywhere = {$: 0};
var $author$project$Page$Shop$CompletedLoadBalances = function (a) {
	return {$: 7, a: a};
};
var $author$project$Page$Shop$CompletedLoadPlaceRelease = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$Shop$CompletedSalesLoad = function (a) {
	return {$: 2, a: a};
};
var $author$project$Community$ShopCategoriesField = 4;
var $author$project$Eos$TableQuery = F4(
	function (code, scope, table, limit) {
		return {i1: code, j2: limit, k3: scope, lj: table};
	});
var $elm$url$Url$Builder$toQueryPair = function (_v0) {
	var key = _v0.a;
	var value = _v0.b;
	return key + ('=' + value);
};
var $elm$url$Url$Builder$toQuery = function (parameters) {
	if (!parameters.b) {
		return '';
	} else {
		return '?' + A2(
			$elm$core$String$join,
			'&',
			A2($elm$core$List$map, $elm$url$Url$Builder$toQueryPair, parameters));
	}
};
var $elm$url$Url$Builder$crossOrigin = F3(
	function (prePath, pathSegments, parameters) {
		return prePath + ('/' + (A2($elm$core$String$join, '/', pathSegments) + $elm$url$Url$Builder$toQuery(parameters)));
	});
var $author$project$Api$blockchainUrl = F3(
	function (_v0, paths, queryParams) {
		var endpoints = _v0.mJ;
		return A3(
			$elm$url$Url$Builder$crossOrigin,
			endpoints.mL,
			A2($elm$core$List$cons, 'v1', paths),
			queryParams);
	});
var $author$project$Api$Balance = F2(
	function (asset, lastActivity) {
		return {lY: asset, nE: lastActivity};
	});
var $author$project$Eos$Asset = F2(
	function (amount, symbol) {
		return {lU: amount, e9: symbol};
	});
var $author$project$Eos$assetStringToFloat = function (s) {
	return A2(
		$elm$core$Maybe$andThen,
		$elm$core$String$toFloat,
		$elm$core$List$head(
			A2($elm$core$String$split, ' ', s)));
};
var $author$project$Eos$getSymbolFromAssetString = function (s) {
	var assetArr = A2($elm$core$String$split, ' ', s);
	var precision = A2(
		$elm$core$Maybe$map,
		function (amountArr) {
			if ((amountArr.b && amountArr.b.b) && (!amountArr.b.b.b)) {
				var _v2 = amountArr.b;
				var p = _v2.a;
				return $elm$core$String$length(p);
			} else {
				return 0;
			}
		},
		A2(
			$elm$core$Maybe$map,
			function (amount) {
				return A2($elm$core$String$split, '.', amount);
			},
			$elm$core$List$head(assetArr)));
	var symbol = $elm$core$List$head(
		$elm$core$List$reverse(assetArr));
	var _v0 = _Utils_Tuple2(symbol, precision);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var symbolString = _v0.a.a;
		var p = _v0.b.a;
		return $elm$core$Maybe$Just(
			A2($author$project$Eos$Symbol, symbolString, p));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Eos$decodeAsset = A2(
	$elm$json$Json$Decode$andThen,
	function (s) {
		var value = A2(
			$elm$core$Maybe$withDefault,
			$elm$json$Json$Decode$fail('Fail to decode asset amount'),
			A2(
				$elm$core$Maybe$map,
				$elm$json$Json$Decode$succeed,
				$author$project$Eos$assetStringToFloat(s)));
		var symbol = A2(
			$elm$core$Maybe$withDefault,
			$elm$json$Json$Decode$fail('Fail to decode asset symbol'),
			A2(
				$elm$core$Maybe$map,
				$elm$json$Json$Decode$succeed,
				$author$project$Eos$getSymbolFromAssetString(s)));
		return A3($elm$json$Json$Decode$map2, $author$project$Eos$Asset, value, symbol);
	},
	$elm$json$Json$Decode$string);
var $author$project$Utils$decodeTimestamp = A2($elm$json$Json$Decode$map, $elm$time$Time$millisToPosix, $elm$json$Json$Decode$int);
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(
	function (key, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$field, key, valDecoder),
			decoder);
	});
var $author$project$Api$decodeBalance = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'last_activity',
	$author$project$Utils$decodeTimestamp,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'balance',
		$author$project$Eos$decodeAsset,
		$elm$json$Json$Decode$succeed($author$project$Api$Balance)));
var $elm$json$Json$Encode$bool = _Json_wrap;
var $author$project$Eos$encodeTableQuery = function (query) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'code',
				$elm$json$Json$Encode$string(query.i1)),
				_Utils_Tuple2(
				'scope',
				$elm$json$Json$Encode$string(query.k3)),
				_Utils_Tuple2(
				'table',
				$elm$json$Json$Encode$string(query.lj)),
				_Utils_Tuple2(
				'limit',
				$elm$json$Json$Encode$int(query.j2)),
				_Utils_Tuple2(
				'json',
				$elm$json$Json$Encode$bool(true))
			]));
};
var $elm$http$Http$BadBody = function (a) {
	return {$: 4, a: a};
};
var $elm$http$Http$BadStatus = function (a) {
	return {$: 3, a: a};
};
var $elm$http$Http$BadUrl = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$NetworkError = {$: 2};
var $elm$http$Http$Timeout = {$: 1};
var $elm$http$Http$resolve = F2(
	function (toResult, response) {
		switch (response.$) {
			case 0:
				var url = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadUrl(url));
			case 1:
				return $elm$core$Result$Err($elm$http$Http$Timeout);
			case 2:
				return $elm$core$Result$Err($elm$http$Http$NetworkError);
			case 3:
				var metadata = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadStatus(metadata.pk));
			default:
				var body = response.b;
				return A2(
					$elm$core$Result$mapError,
					$elm$http$Http$BadBody,
					toResult(body));
		}
	});
var $elm$http$Http$expectJson = F2(
	function (toMsg, decoder) {
		return A2(
			$elm$http$Http$expectStringResponse,
			toMsg,
			$elm$http$Http$resolve(
				function (string) {
					return A2(
						$elm$core$Result$mapError,
						$elm$json$Json$Decode$errorToString,
						A2($elm$json$Json$Decode$decodeString, decoder, string));
				}));
	});
var $elm$http$Http$post = function (r) {
	return $elm$http$Http$request(
		{fv: r.fv, fN: r.fN, m4: _List_Nil, bL: 'POST', am: $elm$core$Maybe$Nothing, lr: $elm$core$Maybe$Nothing, gL: r.gL});
};
var $author$project$Api$getBalances = F3(
	function (shared, accountName, toMsg) {
		var query = A4(
			$author$project$Eos$TableQuery,
			shared.mn.pC,
			$author$project$Eos$Account$nameToString(accountName),
			'accounts',
			1000);
		return $elm$http$Http$post(
			{
				fv: $elm$http$Http$jsonBody(
					$author$project$Eos$encodeTableQuery(query)),
				fN: A2(
					$elm$http$Http$expectJson,
					toMsg,
					A2(
						$elm$json$Json$Decode$field,
						'rows',
						$elm$json$Json$Decode$list($author$project$Api$decodeBalance))),
				gL: A3(
					$author$project$Api$blockchainUrl,
					shared,
					_List_fromArray(
						['chain', 'get_table_rows']),
					_List_Nil)
			});
	});
var $author$project$Page$Shop$Loading = {$: 0};
var $author$project$Page$Shop$initModel = function (filter) {
	return {
		gV: _List_Nil,
		ap: $author$project$Page$Shop$Loading,
		b6: $elm$core$Maybe$Nothing,
		b7: $author$project$Shop$Where$Anywhere,
		z: filter,
		bC: $author$project$Form$init(
			{cX: $pzp1997$assoc_list$AssocList$empty, oy: filter.oy}),
		dt: false,
		eV: false,
		d4: $krisajenkins$remotedata$RemoteData$NotAsked
	};
};
var $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present = function (a) {
	return {$: 0, a: a};
};
var $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe = function (maybeValue) {
	if (!maybeValue.$) {
		var value = maybeValue.a;
		return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(value);
	} else {
		return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent;
	}
};
var $author$project$Shop$Category$idToInt = function (_v0) {
	var id = _v0;
	return id;
};
var $author$project$Shop$NoTracking = {$: 0};
var $author$project$Shop$UnitTracking = function (a) {
	return {$: 1, a: a};
};
var $author$project$Cambiatus$Object$Product$categories = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'categories',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Cambiatus$Object$Product$communityId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'communityId', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$Product$creator = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'creator', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Cambiatus$Object$Product$creatorId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'creatorId', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$Product$description = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'description', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$Product$online = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'online', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Cambiatus$Object$Product$price = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Float', 'price', _List_Nil, $elm$json$Json$Decode$float);
var $author$project$Shop$Category$Model = function (id) {
	return function (name) {
		return function (slug) {
			return function (description) {
				return function (icon) {
					return function (image) {
						return function (parentId) {
							return function (metaTitle) {
								return function (metaDescription) {
									return function (metaKeywords) {
										return function (position) {
											return {bc: description, nb: icon, R: id, jH: image, hH: metaDescription, hI: metaKeywords, hJ: metaTitle, ki: name, h2: parentId, kC: position, ie: slug};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Cambiatus$Object$Category$description = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'description', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$Category$iconUri = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'iconUri',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Shop$Category$Id = $elm$core$Basics$identity;
var $author$project$Cambiatus$Object$Category$id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'id', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$Shop$Category$idSelectionSet = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $elm$core$Basics$identity, $author$project$Cambiatus$Object$Category$id);
var $author$project$Cambiatus$Object$Category$imageUri = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'imageUri',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Cambiatus$Object$Category$metaDescription = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'metaDescription',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Cambiatus$Object$Category$metaKeywords = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'metaKeywords',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Cambiatus$Object$Category$metaTitle = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'metaTitle',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Cambiatus$Object$Category$name = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'name', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$Category$parent = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'parent',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $hecrj$elm_slug$Slug$Slug = $elm$core$Basics$identity;
var $hecrj$elm_slug$Slug$isAlphanumeric = function (c) {
	return ((c >= '0') && (c <= '9')) || ((c >= 'a') && (c <= 'z'));
};
var $elm$core$String$map = _String_map;
var $hecrj$elm_slug$Slug$simpleQuoteRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('\''));
var $elm$core$String$words = _String_words;
var $hecrj$elm_slug$Slug$processWords = function () {
	var mapHelp = function (c) {
		return $hecrj$elm_slug$Slug$isAlphanumeric(c) ? c : ' ';
	};
	return A2(
		$elm$core$Basics$composeR,
		A2(
			$elm$regex$Regex$replace,
			$hecrj$elm_slug$Slug$simpleQuoteRegex,
			function (_v0) {
				return '';
			}),
		A2(
			$elm$core$Basics$composeR,
			$elm$core$String$toLower,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$String$map(mapHelp),
				$elm$core$String$words)));
}();
var $hecrj$elm_slug$Slug$generate = function (text) {
	var words = $hecrj$elm_slug$Slug$processWords(text);
	return _Utils_eq(
		words,
		_List_fromArray(
			[''])) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
		A2($elm$core$String$join, '-', words));
};
var $hecrj$elm_slug$Slug$toString = function (_v0) {
	var s = _v0;
	return s;
};
var $hecrj$elm_slug$Slug$parse = function (slug) {
	var _v0 = $hecrj$elm_slug$Slug$generate(slug);
	if (!_v0.$) {
		var s = _v0.a;
		return _Utils_eq(
			slug,
			$hecrj$elm_slug$Slug$toString(s)) ? $elm$core$Maybe$Just(s) : $elm$core$Maybe$Nothing;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Cambiatus$Object$Category$position = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'position', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$Cambiatus$Object$Category$slug = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'slug',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Shop$Category$selectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$Category$position,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$map(
					A2(
						$elm$core$Basics$composeR,
						$elm$core$String$split(','),
						$elm$core$List$map($elm$core$String$trim))),
				$elm$core$Maybe$withDefault(_List_Nil)),
			$author$project$Cambiatus$Object$Category$metaKeywords),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Cambiatus$Object$Category$metaDescription,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Cambiatus$Object$Category$metaTitle,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$Cambiatus$Object$Category$parent($author$project$Shop$Category$idSelectionSet),
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$Cambiatus$Object$Category$imageUri,
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							$author$project$Cambiatus$Object$Category$iconUri,
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
								$author$project$Markdown$selectionSet($author$project$Cambiatus$Object$Category$description),
								A2(
									$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
									A2(
										$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
										$elm$core$Maybe$andThen($hecrj$elm_slug$Slug$parse),
										$author$project$Cambiatus$Object$Category$slug),
									A2(
										$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
										$author$project$Cambiatus$Object$Category$name,
										A2(
											$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
											$author$project$Shop$Category$idSelectionSet,
											$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Shop$Category$Model))))))))))));
var $author$project$Cambiatus$Object$Product$trackStock = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'trackStock', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Cambiatus$Enum$OfferType$Basket = 0;
var $author$project$Cambiatus$Enum$OfferType$Service = 1;
var $author$project$Cambiatus$Enum$OfferType$Simple = 2;
var $author$project$Cambiatus$Enum$OfferType$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'BASKET':
				return $elm$json$Json$Decode$succeed(0);
			case 'SERVICE':
				return $elm$json$Json$Decode$succeed(1);
			case 'SIMPLE':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('Invalid OfferType type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$Product$type_ = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.OfferType.OfferType', 'type', _List_Nil, $author$project$Cambiatus$Enum$OfferType$decoder);
var $author$project$Cambiatus$Object$Product$units = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe Int)',
	'units',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int));
var $author$project$Shop$productSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$Product$type_,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Cambiatus$Object$Product$online,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Cambiatus$Object$Product$categories($author$project$Shop$Category$selectionSet),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Cambiatus$Object$Product$creator($author$project$Profile$minimalSelectionSet),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$Cambiatus$Object$Product$trackStock,
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$Cambiatus$Object$Product$units,
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							$author$project$Cambiatus$Object$Product$images($author$project$Cambiatus$Object$ProductImage$uri),
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
								$author$project$Eos$symbolSelectionSet($author$project$Cambiatus$Object$Product$communityId),
								A2(
									$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
									$author$project$Cambiatus$Object$Product$price,
									A2(
										$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
										$author$project$Eos$Account$nameSelectionSet($author$project$Cambiatus$Object$Product$creatorId),
										A2(
											$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
											$author$project$Markdown$selectionSet($author$project$Cambiatus$Object$Product$description),
											A2(
												$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
												$author$project$Cambiatus$Object$Product$title,
												A2(
													$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
													$author$project$Shop$idSelectionSet,
													$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(
														function (id) {
															return function (title) {
																return function (description) {
																	return function (creatorId) {
																		return function (price) {
																			return function (symbol) {
																				return function (images) {
																					return function (maybeUnits) {
																						return function (trackStock) {
																							return function (creator) {
																								return function (categories) {
																									return function (online) {
																										return function (offerType) {
																											return {
																												cX: categories,
																												mq: creator,
																												mr: creatorId,
																												bc: description,
																												R: id,
																												hr: A2(
																													$elm$core$List$filter,
																													A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
																													images),
																												hU: offerType,
																												dF: online,
																												h3: price,
																												ig: function () {
																													if (trackStock) {
																														if (maybeUnits.$ === 1) {
																															return $author$project$Shop$NoTracking;
																														} else {
																															var units = maybeUnits.a;
																															return $author$project$Shop$UnitTracking(
																																{iQ: units});
																														}
																													} else {
																														return $author$project$Shop$NoTracking;
																													}
																												}(),
																												e9: symbol,
																												fb: title
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														}))))))))))))));
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool = function (value) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$Json(
		$elm$json$Json$Encode$bool(value));
};
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$list = F2(
	function (toValue, value) {
		return $dillonkearns$elm_graphql$Graphql$Internal$Encode$List(
			A2($elm$core$List$map, toValue, value));
	});
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybe = function (encoder) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$Maybe$map(encoder),
		$elm$core$Maybe$withDefault($dillonkearns$elm_graphql$Graphql$Internal$Encode$null));
};
var $author$project$Cambiatus$InputObject$encodeProductsFilterInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'account',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.fl, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'categoriesIds',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.cY,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						$dillonkearns$elm_graphql$Graphql$Internal$Encode$maybe($dillonkearns$elm_graphql$Graphql$Internal$Encode$int)))),
				_Utils_Tuple2(
				'inStock',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.di, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'online',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.dF, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'placeId',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.dL, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int))
			]));
};
var $author$project$Cambiatus$Enum$OfferType$toString = function (enum____) {
	switch (enum____) {
		case 0:
			return 'BASKET';
		case 1:
			return 'SERVICE';
		default:
			return 'SIMPLE';
	}
};
var $author$project$Cambiatus$Query$products = F2(
	function (fillInOptionals____, object____) {
		var filledInOptionals____ = fillInOptionals____(
			{hi: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, d0: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
		var optionalArgs____ = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'filters', filledInOptionals____.hi, $author$project$Cambiatus$InputObject$encodeProductsFilterInput),
					A3(
					$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional,
					'type',
					filledInOptionals____.d0,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Cambiatus$Enum$OfferType$toString))
				]));
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'products',
			optionalArgs____,
			object____,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
	});
var $author$project$Shop$productsQuery = function (_v0) {
	var user = _v0.gM;
	var categories = _v0.cX;
	var where_ = _v0.iD;
	var offerType = _v0.hU;
	return A2(
		$author$project$Cambiatus$Query$products,
		function (_v1) {
			return {
				hi: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
					{
						fl: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(
							A2($elm$core$Maybe$map, $author$project$Eos$Account$nameToString, user)),
						cY: $elm$core$List$isEmpty(categories) ? $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent : $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
							A2(
								$elm$core$List$map,
								A2($elm$core$Basics$composeR, $author$project$Shop$Category$idToInt, $elm$core$Maybe$Just),
								categories)),
						di: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
						dF: function () {
							if (where_.$ === 2) {
								return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(true);
							} else {
								return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent;
							}
						}(),
						dL: function () {
							if (where_.$ === 1) {
								var placeId = where_.a;
								return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(placeId);
							} else {
								return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent;
							}
						}()
					}),
				d0: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(offerType)
			};
		},
		$author$project$Shop$productSelectionSet);
};
var $author$project$Eos$cambiatusSymbol = A2($author$project$Eos$Symbol, 'CMB', 0);
var $author$project$Cambiatus$Query$community = F2(
	function (fillInOptionals____, object____) {
		var filledInOptionals____ = fillInOptionals____(
			{pl: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, e9: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
		var optionalArgs____ = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'subdomain', filledInOptionals____.pl, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'symbol', filledInOptionals____.e9, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)
				]));
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'community',
			optionalArgs____,
			object____,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
	});
var $author$project$PlaceRelease$releaseKey = 'elm_places';
var $author$project$PlaceRelease$isReleased = function (releasedFeatures) {
	return A2($elm$core$List$member, $author$project$PlaceRelease$releaseKey, releasedFeatures);
};
var $author$project$Cambiatus$Object$Community$releasedFeatures = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(List String)',
	'releasedFeatures',
	_List_Nil,
	$elm$json$Json$Decode$list($elm$json$Json$Decode$string));
var $author$project$Eos$symbolToString = function (_v0) {
	var symbol = _v0.a;
	var precision = _v0.b;
	return $elm$core$String$concat(
		_List_fromArray(
			[
				$elm$core$String$fromInt(precision),
				',',
				symbol
			]));
};
var $author$project$PlaceRelease$query = function (loggedIn) {
	var symbol = function () {
		var _v0 = loggedIn.o7;
		if (_v0.$ === 3) {
			var community = _v0.a;
			return community.e9;
		} else {
			return A2($elm$core$Maybe$withDefault, $author$project$Eos$cambiatusSymbol, loggedIn.aM.o7);
		}
	}();
	return A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$withDefault(_List_Nil),
			$author$project$PlaceRelease$isReleased),
		A2(
			$author$project$Cambiatus$Query$community,
			function (optionals) {
				return _Utils_update(
					optionals,
					{
						e9: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
							$author$project$Eos$symbolToString(symbol))
					});
			},
			$author$project$Cambiatus$Object$Community$releasedFeatures));
};
var $author$project$Page$Shop$init = F2(
	function (loggedIn, filter) {
		return A2(
			$author$project$UpdateResult$addExt,
			A3(
				$author$project$Session$LoggedIn$query,
				loggedIn,
				$author$project$PlaceRelease$query(loggedIn),
				$author$project$Page$Shop$CompletedLoadPlaceRelease),
			A2(
				$author$project$UpdateResult$addExt,
				$author$project$Session$LoggedIn$RequestedCommunityField(4),
				A2(
					$author$project$UpdateResult$addExt,
					A3(
						$author$project$Session$LoggedIn$query,
						loggedIn,
						$author$project$Shop$productsQuery(
							{cX: filter.cX, hU: $elm$core$Maybe$Nothing, gM: filter.oy, iD: $author$project$Shop$Where$Anywhere}),
						$author$project$Page$Shop$CompletedSalesLoad),
					A2(
						$author$project$UpdateResult$addCmd,
						A3($author$project$Api$getBalances, loggedIn.aM, loggedIn.lM, $author$project$Page$Shop$CompletedLoadBalances),
						$author$project$UpdateResult$init(
							$author$project$Page$Shop$initModel(filter))))));
	});
var $author$project$Page$Shop$Viewer$AsGuest = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Shop$Viewer$AsGuestMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Page$Shop$Viewer$AsLoggedIn = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Shop$Viewer$AsLoggedInMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Page$Shop$Viewer$Closed = 0;
var $author$project$Page$Shop$Viewer$CompletedLoadBalances = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Shop$Viewer$CompletedSaleLoad = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Shop$Viewer$CompletedSalePreviewLoad = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$LoggedInExternal = function (a) {
	return {$: 0, a: a};
};
var $author$project$Log$map = F2(
	function (transform, event) {
		return {
			mm: event.mm,
			nH: event.nH,
			nN: event.nN,
			nS: event.nS,
			pu: event.pu,
			pE: transform(event.pE),
			pM: event.pM
		};
	});
var $author$project$Ports$mapAddress = F2(
	function (transform, _v0) {
		var js = _v0;
		return {
			i9: js.i9,
			kY: transform(js.kY),
			kZ: js.kZ
		};
	});
var $author$project$Log$mapBreadcrumb = F2(
	function (transform, breadcrumb) {
		return {
			fw: transform(breadcrumb.fw),
			i9: breadcrumb.i9,
			nH: breadcrumb.nH,
			nS: breadcrumb.nS,
			d0: breadcrumb.d0
		};
	});
var $author$project$UpdateResult$map = F4(
	function (toModel, toMsg, handleExtMsg, updateResult) {
		return A3(
			$elm$core$List$foldl,
			handleExtMsg,
			{
				Y: A2(
					$elm$core$List$map,
					$author$project$Log$mapBreadcrumb(toMsg),
					updateResult.Y),
				i0: _List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						toMsg,
						$elm$core$Platform$Cmd$batch(updateResult.i0))
					]),
				jm: A2(
					$elm$core$List$map,
					$author$project$Log$map(toMsg),
					updateResult.jm),
				jo: _List_Nil,
				nV: toModel(updateResult.nV),
				kB: A2(
					$elm$core$List$map,
					$author$project$Ports$mapAddress(toMsg),
					updateResult.kB)
			},
			updateResult.jo);
	});
var $author$project$Cambiatus$Query$productPreview = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'productPreview',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'id', requiredArgs____.R, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int)
				]),
			object____,
			$elm$core$Basics$identity);
	});
var $author$project$Cambiatus$Object$ProductPreview$communityId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'communityId', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$ProductPreview$creatorId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'creatorId', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$ProductPreview$description = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'description', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$ProductPreview$id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'id', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$Cambiatus$Object$ProductPreview$images = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'images',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Cambiatus$Object$ProductPreview$price = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Float', 'price', _List_Nil, $elm$json$Json$Decode$float);
var $author$project$Shop$productPreviewProfile = function (accountName) {
	return {
		fl: accountName,
		cV: $author$project$Avatar$empty,
		cW: $elm$core$Maybe$Nothing,
		aq: _List_Nil,
		jh: $elm$core$Maybe$Nothing,
		ki: $elm$core$Maybe$Just(
			$author$project$Eos$Account$nameToString(accountName))
	};
};
var $author$project$Cambiatus$Object$ProductPreview$title = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'title', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Shop$productPreviewSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$ProductPreview$title,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Cambiatus$Object$ProductPreview$price,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Cambiatus$Object$ProductPreview$images($author$project$Cambiatus$Object$ProductImage$uri),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $elm$core$Basics$identity, $author$project$Cambiatus$Object$ProductPreview$id),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$Markdown$selectionSet($author$project$Cambiatus$Object$ProductPreview$description),
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
							$author$project$Shop$productPreviewProfile,
							$author$project$Eos$Account$nameSelectionSet($author$project$Cambiatus$Object$ProductPreview$creatorId)),
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							$author$project$Eos$symbolSelectionSet($author$project$Cambiatus$Object$ProductPreview$communityId),
							$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(
								F7(
									function (communityId, creator, description, id, images, price, title) {
										return {
											mq: creator,
											bc: description,
											R: id,
											hr: A2(
												$elm$core$List$filter,
												A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
												images),
											h3: price,
											e9: communityId,
											fb: title
										};
									})))))))));
var $author$project$Shop$productPreviewQuery = function (_v0) {
	var productId = _v0;
	return A2(
		$author$project$Cambiatus$Query$productPreview,
		{R: productId},
		$author$project$Shop$productPreviewSelectionSet);
};
var $author$project$Cambiatus$Query$product = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'product',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'id', requiredArgs____.R, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int)
				]),
			object____,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
	});
var $author$project$Shop$productQuery = function (_v0) {
	var saleId = _v0;
	return A2(
		$author$project$Cambiatus$Query$product,
		{R: saleId},
		$author$project$Shop$productSelectionSet);
};
var $author$project$Page$Shop$Viewer$init = F2(
	function (session, saleId) {
		if (session.$ === 1) {
			var loggedIn = session.a;
			var shared = loggedIn.aM;
			var accountName = loggedIn.lM;
			var model = {
				cc: $elm$core$Maybe$Nothing,
				cs: false,
				cF: $elm$core$Maybe$Nothing,
				gE: $author$project$Page$Shop$Viewer$AsLoggedIn(
					{
						gV: _List_Nil,
						aS: 0,
						hk: $author$project$Form$init(
							{
								ka: A2($author$project$Form$RichText$initModel, 'memo-input', $elm$core$Maybe$Nothing),
								iy: '1'
							}),
						jy: false,
						eC: false,
						dq: false,
						gE: $krisajenkins$remotedata$RemoteData$Loading
					})
			};
			return A4(
				$author$project$UpdateResult$map,
				$elm$core$Basics$identity,
				$elm$core$Basics$identity,
				A2($elm$core$Basics$composeR, $author$project$Page$LoggedInExternal, $author$project$UpdateResult$addExt),
				A2(
					$author$project$UpdateResult$addExt,
					$author$project$Session$LoggedIn$RequestedCommunityField(4),
					A2(
						$author$project$UpdateResult$addCmd,
						A3(
							$author$project$Api$getBalances,
							shared,
							accountName,
							A2($elm$core$Basics$composeR, $author$project$Page$Shop$Viewer$CompletedLoadBalances, $author$project$Page$Shop$Viewer$AsLoggedInMsg)),
						A2(
							$author$project$UpdateResult$addExt,
							A3(
								$author$project$Session$LoggedIn$query,
								loggedIn,
								$author$project$Shop$productQuery(saleId),
								A2($elm$core$Basics$composeR, $author$project$Page$Shop$Viewer$CompletedSaleLoad, $author$project$Page$Shop$Viewer$AsLoggedInMsg)),
							$author$project$UpdateResult$init(model)))));
		} else {
			var guest = session.a;
			return A2(
				$author$project$UpdateResult$addCmd,
				A4(
					$author$project$Api$Graphql$query,
					guest.aM,
					$elm$core$Maybe$Nothing,
					$author$project$Shop$productPreviewQuery(saleId),
					A2($elm$core$Basics$composeR, $author$project$Page$Shop$Viewer$CompletedSalePreviewLoad, $author$project$Page$Shop$Viewer$AsGuestMsg)),
				$author$project$UpdateResult$init(
					{
						cc: $elm$core$Maybe$Nothing,
						cs: false,
						cF: $elm$core$Maybe$Nothing,
						gE: $author$project$Page$Shop$Viewer$AsGuest(
							{
								hk: $author$project$Form$init(
									{
										ka: A2($author$project$Form$RichText$initModel, 'memo-input', $elm$core$Maybe$Nothing),
										iy: '1'
									}),
								dN: $krisajenkins$remotedata$RemoteData$Loading,
								k0: saleId
							})
					}));
		}
	});
var $author$project$Page$ViewTransfer$CompletedTransferLoad = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$ViewTransfer$Loading = {$: 0};
var $author$project$Cambiatus$Query$transfer = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'transfer',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'id', requiredArgs____.R, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int)
				]),
			object____,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
	});
var $author$project$Transfer$CreatedTx = $elm$core$Basics$identity;
var $author$project$Transfer$Transfer = F9(
	function (id, to, from, value, memo, communityId, community, blockTime, createdTx) {
		return {fu: blockTime, b9: community, c1: communityId, mp: createdTx, ew: from, R: id, ka: memo, fc: to, pO: value};
	});
var $author$project$Transfer$Cmm = F2(
	function (symbol, subdomain) {
		return {pl: subdomain, e9: symbol};
	});
var $author$project$Transfer$communitySelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
		$elm$core$Maybe$withDefault(''),
		$author$project$Cambiatus$Object$Community$subdomain($author$project$Cambiatus$Object$Subdomain$name)),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Eos$symbolSelectionSet($author$project$Cambiatus$Object$Community$symbol),
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Transfer$Cmm)));
var $author$project$Cambiatus$Object$Transfer$createdAt = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.DateTime',
	'createdAt',
	_List_Nil,
	$author$project$Cambiatus$Scalar$unwrapCodecs($author$project$Cambiatus$ScalarCodecs$codecs).ma.jc);
var $author$project$Cambiatus$Object$Transfer$createdTx = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'createdTx', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$Transfer$from = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'from', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Cambiatus$Object$Transfer$to = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'to', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Transfer$transferItemSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $elm$core$Basics$identity, $author$project$Cambiatus$Object$Transfer$createdTx),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Cambiatus$Object$Transfer$createdAt,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Cambiatus$Object$Transfer$community($author$project$Transfer$communitySelectionSet),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Cambiatus$Object$Transfer$community($author$project$Cambiatus$Object$Community$name),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$Markdown$maybeSelectionSet($author$project$Cambiatus$Object$Transfer$memo),
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$Cambiatus$Object$Transfer$amount,
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							$author$project$Cambiatus$Object$Transfer$from($author$project$Profile$selectionSet),
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
								$author$project$Cambiatus$Object$Transfer$to($author$project$Profile$selectionSet),
								A2(
									$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
									$author$project$Cambiatus$Object$Transfer$id,
									$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Transfer$Transfer))))))))));
var $author$project$Transfer$transferQuery = function (tID) {
	var args = {R: tID};
	return A2($author$project$Cambiatus$Query$transfer, args, $author$project$Transfer$transferItemSelectionSet);
};
var $author$project$Page$ViewTransfer$init = F2(
	function (loggedIn, transferId) {
		var model = {gE: $author$project$Page$ViewTransfer$Loading, lt: transferId};
		return A2(
			$author$project$UpdateResult$addExt,
			A3(
				$author$project$Session$LoggedIn$query,
				loggedIn,
				$author$project$Transfer$transferQuery(transferId),
				$author$project$Page$ViewTransfer$CompletedTransferLoad),
			$author$project$UpdateResult$init(model));
	});
var $author$project$Page$Shop$Editor$EditingCreate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Shop$Editor$MainInformation = {$: 0};
var $author$project$Page$Shop$Editor$initFormData = {
	cX: $author$project$Form$init(
		{dF: false, ia: $pzp1997$assoc_list$AssocList$empty}),
	C: $author$project$Page$Shop$Editor$MainInformation,
	hr: $author$project$Form$init(
		$author$project$Form$File$initMultiple(
			{q: $elm$core$Maybe$Nothing, mU: _List_Nil})),
	bg: $author$project$Form$init(
		{
			bc: A2($author$project$Form$RichText$initModel, 'product-description-editor', $elm$core$Maybe$Nothing),
			hU: 2,
			fb: ''
		}),
	bN: $author$project$Form$init(
		{h3: '0', d_: false, cN: '0'})
};
var $author$project$Page$Shop$Editor$initCreate = function (_v0) {
	return A2(
		$author$project$UpdateResult$addExt,
		$author$project$Session$LoggedIn$RequestedReloadCommunityField(4),
		$author$project$UpdateResult$init(
			{
				dw: false,
				gE: $author$project$Page$Shop$Editor$EditingCreate($author$project$Page$Shop$Editor$initFormData)
			}));
};
var $author$project$Page$Shop$Editor$CompletedLoadCommunity = {$: 1};
var $author$project$Page$Shop$Editor$LoadingSaleUpdate = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Page$Shop$Editor$initUpdate = F3(
	function (productId, step, loggedIn) {
		return A2(
			$author$project$UpdateResult$addExt,
			$author$project$Session$LoggedIn$RequestedReloadCommunityField(4),
			A2(
				$author$project$UpdateResult$addCmd,
				A3(
					$author$project$Session$LoggedIn$maybeInitWith,
					function (_v0) {
						return $author$project$Page$Shop$Editor$CompletedLoadCommunity;
					},
					function ($) {
						return $.o7;
					},
					loggedIn),
				$author$project$UpdateResult$init(
					{
						dw: false,
						gE: A2($author$project$Page$Shop$Editor$LoadingSaleUpdate, productId, step)
					})));
	});
var $author$project$Page$GotGuestMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Route$Login = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Session$Guest$CompletedLoadCommunityPreview = function (a) {
	return {$: 5, a: a};
};
var $author$project$Cambiatus$Query$communityPreview = F2(
	function (fillInOptionals____, object____) {
		var filledInOptionals____ = fillInOptionals____(
			{pl: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, e9: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
		var optionalArgs____ = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'subdomain', filledInOptionals____.pl, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'symbol', filledInOptionals____.e9, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)
				]));
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'communityPreview',
			optionalArgs____,
			object____,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
	});
var $author$project$Community$communityPreviewQuery = function (subdomain) {
	return A2(
		$author$project$Cambiatus$Query$communityPreview,
		function (optionals) {
			return _Utils_update(
				optionals,
				{
					pl: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(subdomain)
				});
		},
		$author$project$Community$communityPreviewSelectionSet);
};
var $author$project$Community$communityPreviewSymbolQuery = function (symbol) {
	return A2(
		$author$project$Cambiatus$Query$communityPreview,
		function (optionals) {
			return _Utils_update(
				optionals,
				{
					e9: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
						$author$project$Eos$symbolToString(symbol))
				});
		},
		$author$project$Community$communityPreviewSelectionSet);
};
var $author$project$Session$Guest$fetchCommunity = function (shared) {
	if (shared.pL) {
		return A4(
			$author$project$Api$Graphql$query,
			shared,
			$elm$core$Maybe$Nothing,
			$author$project$Community$communityPreviewQuery(
				$author$project$Environment$communityDomain(shared.gL)),
			$author$project$Session$Guest$CompletedLoadCommunityPreview);
	} else {
		var symbol = A2($elm$core$Maybe$withDefault, $author$project$Eos$cambiatusSymbol, shared.o7);
		return A4(
			$author$project$Api$Graphql$query,
			shared,
			$elm$core$Maybe$Nothing,
			$author$project$Community$communityPreviewSymbolQuery(symbol),
			$author$project$Session$Guest$CompletedLoadCommunityPreview);
	}
};
var $author$project$View$Feedback$Hidden = {$: 0};
var $author$project$Session$Guest$initModel = function (shared) {
	return {lS: $elm$core$Maybe$Nothing, b9: $krisajenkins$remotedata$RemoteData$Loading, hf: $author$project$View$Feedback$Hidden, j8: $elm$core$Maybe$Nothing, aM: shared, a8: false};
};
var $author$project$Session$Guest$init = function (shared) {
	return _Utils_Tuple2(
		$author$project$Session$Guest$initModel(shared),
		$author$project$Session$Guest$fetchCommunity(shared));
};
var $elm$browser$Browser$Navigation$replaceUrl = _Browser_replaceUrl;
var $elm$url$Url$Builder$absolute = F2(
	function (pathSegments, parameters) {
		return '/' + (A2($elm$core$String$join, '/', pathSegments) + $elm$url$Url$Builder$toQuery(parameters));
	});
var $author$project$Route$boolToString = function (bool) {
	return bool ? 'true' : 'false';
};
var $author$project$Shop$idToString = function (_v0) {
	var id = _v0;
	return $elm$core$String$fromInt(id);
};
var $author$project$Shop$Category$idToString = function (_v0) {
	var id = _v0;
	return $elm$core$String$fromInt(id);
};
var $elm$url$Url$Builder$QueryParameter = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$url$Url$Builder$string = F2(
	function (key, value) {
		return A2(
			$elm$url$Url$Builder$QueryParameter,
			$elm$url$Url$percentEncode(key),
			$elm$url$Url$percentEncode(value));
	});
var $author$project$Route$queryBuilder = F3(
	function (fn, maybeRedirect, queryParam) {
		return A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			$elm$core$List$singleton(
				A2(
					$elm$core$Maybe$map,
					$elm$url$Url$Builder$string(queryParam),
					A2($elm$core$Maybe$map, fn, maybeRedirect))));
	});
var $author$project$Route$saleStepToString = function (step) {
	switch (step) {
		case 0:
			return 'mainInformation';
		case 1:
			return 'images';
		case 2:
			return 'categories';
		default:
			return 'priceAndInventory';
	}
};
var $author$project$Route$routeToString = function (route) {
	var _v0 = function () {
		switch (route.$) {
			case 0:
				return _Utils_Tuple2(_List_Nil, _List_Nil);
			case 1:
				return _Utils_Tuple2(
					_List_fromArray(
						['coming-soon']),
					_List_Nil);
			case 2:
				if (route.a.$ === 1) {
					var _v2 = route.a;
					var maybeRedirect = route.b;
					return _Utils_Tuple2(
						_List_fromArray(
							['register']),
						A3($author$project$Route$queryBuilder, $author$project$Route$routeToString, maybeRedirect, 'redirect'));
				} else {
					var invitation = route.a.a;
					var maybeRedirect = route.b;
					return _Utils_Tuple2(
						_List_fromArray(
							['register', invitation]),
						A3($author$project$Route$queryBuilder, $author$project$Route$routeToString, maybeRedirect, 'redirect'));
				}
			case 3:
				if (route.a.$ === 1) {
					var _v3 = route.a;
					var maybeRedirect = route.b;
					return _Utils_Tuple2(
						_List_fromArray(
							['login']),
						A3($author$project$Route$queryBuilder, $author$project$Route$routeToString, maybeRedirect, 'redirect'));
				} else {
					var invitation = route.a.a;
					var maybeRedirect = route.b;
					return _Utils_Tuple2(
						_List_fromArray(
							['login', invitation]),
						A3($author$project$Route$queryBuilder, $author$project$Route$routeToString, maybeRedirect, 'redirect'));
				}
			case 4:
				return _Utils_Tuple2(
					_List_fromArray(
						['logout']),
					_List_Nil);
			case 5:
				return _Utils_Tuple2(
					_List_fromArray(
						['notification']),
					_List_Nil);
			case 6:
				return _Utils_Tuple2(
					_List_fromArray(
						['profile', 'edit']),
					_List_Nil);
			case 7:
				return _Utils_Tuple2(
					_List_fromArray(
						['profile', 'add-kyc']),
					_List_Nil);
			case 8:
				var account = route.a;
				return _Utils_Tuple2(
					_List_fromArray(
						['profile', account, 'claims']),
					_List_Nil);
			case 9:
				return _Utils_Tuple2(
					_List_fromArray(
						['profile', 'add-contact']),
					_List_Nil);
			case 10:
				var accountName = route.a;
				return _Utils_Tuple2(
					_List_fromArray(
						[
							'payments',
							$author$project$Eos$Account$nameToString(accountName)
						]),
					_List_Nil);
			case 11:
				var accountName = route.a;
				return _Utils_Tuple2(
					_List_fromArray(
						[
							'profile',
							$author$project$Eos$Account$nameToString(accountName)
						]),
					_List_Nil);
			case 12:
				return _Utils_Tuple2(
					_List_fromArray(
						['dashboard']),
					_List_Nil);
			case 13:
				return _Utils_Tuple2(
					_List_fromArray(
						['community', 'about']),
					_List_Nil);
			case 14:
				var selectedObjective = route.a;
				var params = function () {
					if (selectedObjective.$ === 1) {
						return _List_Nil;
					} else {
						var id = selectedObjective.a.R;
						var action = selectedObjective.a.iG;
						if (action.$ === 1) {
							return _List_fromArray(
								[
									$elm$core$String$fromInt(id)
								]);
						} else {
							var actionId = action.a;
							return _List_fromArray(
								[
									$elm$core$String$fromInt(id),
									'action',
									$elm$core$String$fromInt(actionId)
								]);
						}
					}
				}();
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						'community',
						A2($elm$core$List$cons, 'objectives', params)),
					_List_Nil);
			case 17:
				return _Utils_Tuple2(
					_List_fromArray(
						['community', 'settings']),
					_List_Nil);
			case 18:
				return _Utils_Tuple2(
					_List_fromArray(
						['community', 'settings', 'features']),
					_List_Nil);
			case 19:
				return _Utils_Tuple2(
					_List_fromArray(
						['community', 'settings', 'info']),
					_List_Nil);
			case 20:
				return _Utils_Tuple2(
					_List_fromArray(
						['community', 'settings', 'news']),
					_List_Nil);
			case 21:
				switch (route.a.$) {
					case 0:
						var _v6 = route.a;
						return _Utils_Tuple2(
							_List_fromArray(
								['community', 'settings', 'news', 'new']),
							_List_Nil);
					case 1:
						var newsId = route.a.a;
						return _Utils_Tuple2(
							_List_fromArray(
								[
									'community',
									'settings',
									'news',
									'edit',
									$elm$core$String$fromInt(newsId)
								]),
							_List_Nil);
					default:
						var newsId = route.a.a;
						return _Utils_Tuple2(
							_List_fromArray(
								[
									'community',
									'settings',
									'news',
									'copy',
									$elm$core$String$fromInt(newsId)
								]),
							_List_Nil);
				}
			case 22:
				return _Utils_Tuple2(
					_List_fromArray(
						['community', 'settings', 'currency']),
					_List_Nil);
			case 23:
				return _Utils_Tuple2(
					_List_fromArray(
						['community', 'settings', 'sponsorship']),
					_List_Nil);
			case 24:
				return _Utils_Tuple2(
					_List_fromArray(
						['community', 'settings', 'sponsorship', 'fiat']),
					_List_Nil);
			case 25:
				return _Utils_Tuple2(
					_List_fromArray(
						['community', 'settings', 'sponsorship', 'thank-you']),
					_List_Nil);
			case 33:
				var maybeRedirect = route.a;
				return _Utils_Tuple2(
					_List_fromArray(
						['community', 'selector']),
					A3($author$project$Route$queryBuilder, $author$project$Route$routeToString, maybeRedirect, 'redirect'));
			case 15:
				return _Utils_Tuple2(
					_List_fromArray(
						['community', 'new']),
					_List_Nil);
			case 16:
				var selectedNews = route.a.o8;
				var showOthers = route.a.pe;
				if (selectedNews.$ === 1) {
					return _Utils_Tuple2(
						_List_fromArray(
							['news']),
						_List_Nil);
				} else {
					var newsId = selectedNews.a;
					return _Utils_Tuple2(
						_List_fromArray(
							[
								'news',
								$elm$core$String$fromInt(newsId)
							]),
						showOthers ? _List_Nil : A3(
							$author$project$Route$queryBuilder,
							$author$project$Route$boolToString,
							$elm$core$Maybe$Just(showOthers),
							'showOthers'));
				}
			case 26:
				return _Utils_Tuple2(
					_List_fromArray(
						['community', 'settings', 'objectives']),
					_List_Nil);
			case 27:
				return _Utils_Tuple2(
					_List_fromArray(
						['community', 'settings', 'objectives', 'new']),
					_List_Nil);
			case 28:
				var objectiveId = route.a;
				return _Utils_Tuple2(
					_List_fromArray(
						[
							'community',
							'settings',
							'objectives',
							$elm$core$String$fromInt(objectiveId),
							'edit'
						]),
					_List_Nil);
			case 29:
				var objectiveId = route.a;
				return _Utils_Tuple2(
					_List_fromArray(
						[
							'community',
							'settings',
							'objectives',
							$elm$core$String$fromInt(objectiveId),
							'action',
							'new'
						]),
					_List_Nil);
			case 30:
				var objectiveId = route.a;
				var actionId = route.b;
				return _Utils_Tuple2(
					_List_fromArray(
						[
							'community',
							'settings',
							'objectives',
							$elm$core$String$fromInt(objectiveId),
							'action',
							$elm$core$String$fromInt(actionId),
							'edit'
						]),
					_List_Nil);
			case 31:
				return _Utils_Tuple2(
					_List_fromArray(
						['community', 'settings', 'contacts']),
					_List_Nil);
			case 32:
				return _Utils_Tuple2(
					_List_fromArray(
						['community', 'settings', 'shop', 'categories']),
					_List_Nil);
			case 34:
				var objectiveId = route.a;
				var actionId = route.b;
				var claimId = route.c;
				return _Utils_Tuple2(
					_List_fromArray(
						[
							'objectives',
							$elm$core$String$fromInt(objectiveId),
							'action',
							$elm$core$String$fromInt(actionId),
							'claim',
							$elm$core$String$fromInt(claimId)
						]),
					_List_Nil);
			case 35:
				return _Utils_Tuple2(
					_List_fromArray(
						['settings']),
					_List_Nil);
			case 36:
				var owner = route.a.oy;
				var categories = route.a.cX;
				return _Utils_Tuple2(
					_List_fromArray(
						['shop']),
					A2(
						$elm$core$List$filterMap,
						$elm$core$Basics$identity,
						_List_fromArray(
							[
								A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									$author$project$Eos$Account$nameToString,
									$elm$url$Url$Builder$string('from')),
								owner),
								$elm$core$List$isEmpty(categories) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
								A2(
									$elm$url$Url$Builder$string,
									'categories',
									A2(
										$elm$core$String$join,
										',',
										A2($elm$core$List$map, $author$project$Shop$Category$idToString, categories))))
							])));
			case 37:
				var saleStep = route.a;
				return _Utils_Tuple2(
					_List_fromArray(
						['shop', 'new', 'sell']),
					A3(
						$author$project$Route$queryBuilder,
						$author$project$Route$saleStepToString,
						$elm$core$Maybe$Just(saleStep),
						'step'));
			case 38:
				var saleId = route.a;
				var saleStep = route.b;
				return _Utils_Tuple2(
					_List_fromArray(
						[
							'shop',
							$author$project$Shop$idToString(saleId),
							'edit'
						]),
					A3(
						$author$project$Route$queryBuilder,
						$author$project$Route$saleStepToString,
						$elm$core$Maybe$Just(saleStep),
						'step'));
			case 39:
				var saleId = route.a;
				return _Utils_Tuple2(
					_List_fromArray(
						[
							'shop',
							$author$project$Shop$idToString(saleId)
						]),
					_List_Nil);
			case 40:
				var transferId = route.a;
				return _Utils_Tuple2(
					_List_fromArray(
						[
							'transfer',
							$elm$core$String$fromInt(transferId)
						]),
					_List_Nil);
			case 41:
				var invitationId = route.a;
				return _Utils_Tuple2(
					_List_fromArray(
						['invite', invitationId]),
					_List_Nil);
			case 42:
				var maybeRedirect = route.a;
				return _Utils_Tuple2(
					_List_fromArray(
						['join']),
					A3($author$project$Route$queryBuilder, $author$project$Route$routeToString, maybeRedirect, 'redirect'));
			case 43:
				var maybeTo = route.a;
				return _Utils_Tuple2(
					_List_fromArray(
						['community', 'transfer']),
					_List_fromArray(
						[
							A2(
							$elm$url$Url$Builder$string,
							'to',
							A2(
								$elm$core$Maybe$withDefault,
								'',
								A2($elm$core$Maybe$map, $author$project$Eos$Account$nameToString, maybeTo)))
						]));
			default:
				return _Utils_Tuple2(
					_List_fromArray(
						['dashboard', 'analysis']),
					_List_Nil);
		}
	}();
	var paths = _v0.a;
	var queries = _v0.b;
	return A2($elm$url$Url$Builder$absolute, paths, queries);
};
var $author$project$Route$replaceUrl = F2(
	function (key, route) {
		return A2(
			$elm$browser$Browser$Navigation$replaceUrl,
			key,
			$author$project$Route$routeToString(route));
	});
var $author$project$Page$logout = function (_v0) {
	var shared = _v0.aM;
	var _v1 = $author$project$Session$Guest$init(shared);
	var guest = _v1.a;
	var guestCmd = _v1.b;
	return _Utils_Tuple2(
		$author$project$Page$Guest(
			_Utils_update(
				guest,
				{
					aM: _Utils_update(
						shared,
						{j6: $elm$core$Maybe$Nothing})
				})),
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2(
					$author$project$Route$replaceUrl,
					shared.eM,
					A2($author$project$Route$Login, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing)),
					A2($elm$core$Platform$Cmd$map, $author$project$Page$GotGuestMsg, guestCmd)
				])));
};
var $author$project$Page$Shop$Editor$Categories = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Page$Shop$Editor$CategoriesImageTarget = 0;
var $author$project$Page$Shop$Editor$CategoriesMainInformationTarget = 1;
var $author$project$Page$Shop$Editor$CategoriesMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Shop$Editor$GotFormMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$Shop$Editor$Images = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Shop$Editor$ImagesMainInformationTarget = 0;
var $author$project$Page$Shop$Editor$ImagesMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Shop$Editor$MainInformationMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Shop$Editor$PriceAndInventoryImageTarget = 1;
var $author$project$Page$Shop$Editor$PriceAndInventoryMainInformationTarget = 2;
var $author$project$Page$Shop$Editor$SubmittedCategories = function (a) {
	return {$: 6, a: a};
};
var $author$project$Page$Shop$Editor$SubmittedImages = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Page$Shop$Editor$SubmittedMainInformation = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$UpdateResult$addMsg = F2(
	function (msg, uResult) {
		return _Utils_update(
			uResult,
			{
				i0: _Utils_ap(
					uResult.i0,
					_List_fromArray(
						[
							A2(
							$elm$core$Task$perform,
							function (_v0) {
								return msg;
							},
							$elm$core$Task$succeed(0))
						]))
			});
	});
var $author$project$Page$Shop$Editor$CategoriesFormOutput = F2(
	function (categories, online) {
		return {cX: categories, dF: online};
	});
var $elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $elm$html$Html$Attributes$alt = $elm$html$Html$Attributes$stringProperty('alt');
var $author$project$Form$Arbitrary = function (a) {
	return {$: 10, a: a};
};
var $author$project$Form$Form = $elm$core$Basics$identity;
var $author$project$OptionalResult$OptNothing = {$: 2};
var $author$project$Form$ValidateOnBlur = 0;
var $author$project$Form$arbitrary = function (html) {
	return function (_v0) {
		return {
			l: _List_fromArray(
				[
					{
					mM: $elm$core$Maybe$Nothing,
					nx: false,
					X: $author$project$Form$Arbitrary(html),
					aP: 0
				}
				]),
			m: $author$project$OptionalResult$OptNothing
		};
	};
};
var $author$project$Form$Checkbox = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$core$Result$andThen = F2(
	function (callback, result) {
		if (!result.$) {
			var value = result.a;
			return callback(value);
		} else {
			var msg = result.a;
			return $elm$core$Result$Err(msg);
		}
	});
var $author$project$OptionalResult$OptErr = function (a) {
	return {$: 0, a: a};
};
var $author$project$OptionalResult$OptOk = function (a) {
	return {$: 1, a: a};
};
var $author$project$OptionalResult$fromResult = function (result) {
	if (!result.$) {
		var success = result.a;
		return $author$project$OptionalResult$OptOk(success);
	} else {
		var error = result.a;
		return $author$project$OptionalResult$OptErr(error);
	}
};
var $author$project$Form$Checkbox$getId = function (_v0) {
	var options = _v0;
	return options.R;
};
var $author$project$Form$DatePicker$getId = function (_v0) {
	var options = _v0;
	return options.R;
};
var $author$project$Form$File$getId = function (_v0) {
	var options = _v0;
	return options.R;
};
var $author$project$Form$Radio$getId = function (_v0) {
	var options = _v0;
	return options.R;
};
var $author$project$Form$RichText$getId = function (_v0) {
	var model = _v0;
	return model.R;
};
var $author$project$Form$Select$getId = function (_v0) {
	var options = _v0;
	return options.R;
};
var $author$project$Form$Text$getId = function (_v0) {
	var options = _v0;
	return options.R;
};
var $author$project$Form$Toggle$getId = function (_v0) {
	var options = _v0;
	return options.R;
};
var $author$project$Form$UserPicker$getId = function (_v0) {
	var model = _v0;
	return model.R;
};
var $author$project$Form$getId = function (state) {
	switch (state.$) {
		case 0:
			var options = state.a;
			return $author$project$Form$Text$getId(options);
		case 1:
			var baseField = state.b;
			return $author$project$Form$RichText$getId(baseField.pO);
		case 2:
			var options = state.a;
			return $author$project$Form$Toggle$getId(options);
		case 3:
			var options = state.a;
			return $author$project$Form$Checkbox$getId(options);
		case 4:
			var options = state.a;
			return $author$project$Form$Radio$getId(options);
		case 5:
			var options = state.a;
			return $author$project$Form$File$getId(options);
		case 6:
			var options = state.a;
			return $author$project$Form$Select$getId(options);
		case 7:
			var options = state.a;
			return $author$project$Form$DatePicker$getId(options);
		case 8:
			var baseField = state.b;
			return $author$project$Form$UserPicker$getId(baseField.pO);
		case 9:
			var fields = state.b;
			return A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.X;
						},
						$author$project$Form$getId),
					$elm$core$List$head(fields)));
		case 10:
			return '';
		default:
			return '';
	}
};
var $author$project$OptionalResult$mapError = F2(
	function (fn, optionalResult) {
		switch (optionalResult.$) {
			case 0:
				var error = optionalResult.a;
				return $author$project$OptionalResult$OptErr(
					fn(error));
			case 1:
				var success = optionalResult.a;
				return $author$project$OptionalResult$OptOk(success);
			default:
				return $author$project$OptionalResult$OptNothing;
		}
	});
var $author$project$Form$field = F2(
	function (build, config) {
		var parse_ = function (values) {
			return $author$project$OptionalResult$fromResult(
				A2(
					$elm$core$Result$andThen,
					function (output) {
						return A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Result$Ok(output),
							A2(
								$elm$core$Maybe$map,
								function (error) {
									return $elm$core$Result$Err(error);
								},
								config.ab(values)));
					},
					config.af(
						config.pO(values))));
		};
		var field_ = function (values) {
			return build(
				{
					aX: config.pO,
					n: function (newValue) {
						return A2(config.n, newValue, values);
					},
					bb: config.n,
					pO: config.pO(values)
				});
		};
		return function (values) {
			var result = parse_(values);
			return {
				l: _List_fromArray(
					[
						{
						mM: function () {
							switch (result.$) {
								case 0:
									var err = result.a;
									return $elm$core$Maybe$Just(err);
								case 1:
									return $elm$core$Maybe$Nothing;
								default:
									return $elm$core$Maybe$Nothing;
							}
						}(),
						nx: true,
						X: field_(values),
						aP: 0
					}
					]),
				m: A2(
					$author$project$OptionalResult$mapError,
					function (_v1) {
						return _Utils_Tuple2(
							$author$project$Form$getId(
								field_(values)),
							_List_Nil);
					},
					result)
			};
		};
	});
var $author$project$Form$checkbox = F2(
	function (config, options) {
		return A2(
			$author$project$Form$field,
			$author$project$Form$Checkbox(options),
			config);
	});
var $zwilias$elm_rosetree$Tree$children = function (_v0) {
	var c = _v0.b;
	return c;
};
var $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty('className');
var $zwilias$elm_rosetree$Tree$label = function (_v0) {
	var v = _v0.a;
	return v;
};
var $zwilias$elm_rosetree$Tree$Zipper$tree = function (_v0) {
	var focus = _v0.x;
	return focus;
};
var $zwilias$elm_rosetree$Tree$Zipper$label = function (zipper) {
	return $zwilias$elm_rosetree$Tree$label(
		$zwilias$elm_rosetree$Tree$Zipper$tree(zipper));
};
var $zwilias$elm_rosetree$Tree$Zipper$find = F3(
	function (predicate, move, zipper) {
		find:
		while (true) {
			var _v0 = move(zipper);
			if (!_v0.$) {
				var next = _v0.a;
				if (predicate(
					$zwilias$elm_rosetree$Tree$Zipper$label(next))) {
					return $elm$core$Maybe$Just(next);
				} else {
					var $temp$predicate = predicate,
						$temp$move = move,
						$temp$zipper = next;
					predicate = $temp$predicate;
					move = $temp$move;
					zipper = $temp$zipper;
					continue find;
				}
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}
	});
var $zwilias$elm_rosetree$Tree$Zipper$Zipper = $elm$core$Basics$identity;
var $zwilias$elm_rosetree$Tree$Zipper$firstChild = function (_v0) {
	var zipper = _v0;
	var _v1 = $zwilias$elm_rosetree$Tree$children(zipper.x);
	if (!_v1.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		var c = _v1.a;
		var cs = _v1.b;
		return $elm$core$Maybe$Just(
			{
				gQ: cs,
				gW: _List_Nil,
				Q: A2(
					$elm$core$List$cons,
					{
						gQ: zipper.gQ,
						gW: zipper.gW,
						nC: $zwilias$elm_rosetree$Tree$label(zipper.x)
					},
					zipper.Q),
				x: c
			});
	}
};
var $zwilias$elm_rosetree$Tree$Zipper$firstOf = F2(
	function (options, v) {
		firstOf:
		while (true) {
			if (!options.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var option = options.a;
				var rest = options.b;
				var _v1 = option(v);
				if (!_v1.$) {
					var r = _v1.a;
					return $elm$core$Maybe$Just(r);
				} else {
					var $temp$options = rest,
						$temp$v = v;
					options = $temp$options;
					v = $temp$v;
					continue firstOf;
				}
			}
		}
	});
var $zwilias$elm_rosetree$Tree$Zipper$nextSibling = function (_v0) {
	var zipper = _v0;
	var _v1 = zipper.gQ;
	if (!_v1.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		var next = _v1.a;
		var rest = _v1.b;
		return $elm$core$Maybe$Just(
			{
				gQ: rest,
				gW: A2($elm$core$List$cons, zipper.x, zipper.gW),
				Q: zipper.Q,
				x: next
			});
	}
};
var $zwilias$elm_rosetree$Tree$Tree = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $zwilias$elm_rosetree$Tree$tree = $zwilias$elm_rosetree$Tree$Tree;
var $zwilias$elm_rosetree$Tree$Zipper$reconstruct = F4(
	function (focus, before, after, l) {
		return A2(
			$zwilias$elm_rosetree$Tree$tree,
			l,
			_Utils_ap(
				$elm$core$List$reverse(before),
				_Utils_ap(
					_List_fromArray(
						[focus]),
					after)));
	});
var $zwilias$elm_rosetree$Tree$Zipper$parent = function (_v0) {
	var zipper = _v0;
	var _v1 = zipper.Q;
	if (!_v1.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		var crumb = _v1.a;
		var rest = _v1.b;
		return $elm$core$Maybe$Just(
			{
				gQ: crumb.gQ,
				gW: crumb.gW,
				Q: rest,
				x: A4($zwilias$elm_rosetree$Tree$Zipper$reconstruct, zipper.x, zipper.gW, zipper.gQ, crumb.nC)
			});
	}
};
var $zwilias$elm_rosetree$Tree$Zipper$nextSiblingOfAncestor = function (zipper) {
	nextSiblingOfAncestor:
	while (true) {
		var _v0 = $zwilias$elm_rosetree$Tree$Zipper$parent(zipper);
		if (_v0.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var parent_ = _v0.a;
			var _v1 = $zwilias$elm_rosetree$Tree$Zipper$nextSibling(parent_);
			if (_v1.$ === 1) {
				var $temp$zipper = parent_;
				zipper = $temp$zipper;
				continue nextSiblingOfAncestor;
			} else {
				var s = _v1.a;
				return $elm$core$Maybe$Just(s);
			}
		}
	}
};
var $zwilias$elm_rosetree$Tree$Zipper$forward = function (zipper) {
	return A2(
		$zwilias$elm_rosetree$Tree$Zipper$firstOf,
		_List_fromArray(
			[$zwilias$elm_rosetree$Tree$Zipper$firstChild, $zwilias$elm_rosetree$Tree$Zipper$nextSibling, $zwilias$elm_rosetree$Tree$Zipper$nextSiblingOfAncestor]),
		zipper);
};
var $zwilias$elm_rosetree$Tree$Zipper$findNext = F2(
	function (f, zipper) {
		return A3($zwilias$elm_rosetree$Tree$Zipper$find, f, $zwilias$elm_rosetree$Tree$Zipper$forward, zipper);
	});
var $zwilias$elm_rosetree$Tree$Zipper$previousSibling = function (_v0) {
	var zipper = _v0;
	var _v1 = zipper.gW;
	if (!_v1.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		var previous = _v1.a;
		var rest = _v1.b;
		return $elm$core$Maybe$Just(
			{
				gQ: A2($elm$core$List$cons, zipper.x, zipper.gQ),
				gW: rest,
				Q: zipper.Q,
				x: previous
			});
	}
};
var $zwilias$elm_rosetree$Tree$Zipper$firstSibling = function (zipper) {
	firstSibling:
	while (true) {
		var _v0 = $zwilias$elm_rosetree$Tree$Zipper$previousSibling(zipper);
		if (_v0.$ === 1) {
			return zipper;
		} else {
			var z = _v0.a;
			var $temp$zipper = z;
			zipper = $temp$zipper;
			continue firstSibling;
		}
	}
};
var $zwilias$elm_rosetree$Tree$Zipper$root = function (zipper) {
	root:
	while (true) {
		var _v0 = $zwilias$elm_rosetree$Tree$Zipper$parent(zipper);
		if (_v0.$ === 1) {
			return $zwilias$elm_rosetree$Tree$Zipper$firstSibling(zipper);
		} else {
			var z = _v0.a;
			var $temp$zipper = z;
			zipper = $temp$zipper;
			continue root;
		}
	}
};
var $zwilias$elm_rosetree$Tree$Zipper$findFromRoot = F2(
	function (f, zipper) {
		var r = $zwilias$elm_rosetree$Tree$Zipper$root(zipper);
		return f(
			$zwilias$elm_rosetree$Tree$Zipper$label(r)) ? $elm$core$Maybe$Just(r) : A2($zwilias$elm_rosetree$Tree$Zipper$findNext, f, r);
	});
var $zwilias$elm_rosetree$Tree$Zipper$fromForest = F2(
	function (t, ts) {
		return {gQ: ts, gW: _List_Nil, Q: _List_Nil, x: t};
	});
var $author$project$Utils$Tree$fromFlatForest = function (trees) {
	if (trees.b) {
		var first = trees.a;
		var others = trees.b;
		return $elm$core$Maybe$Just(
			A2($zwilias$elm_rosetree$Tree$Zipper$fromForest, first, others));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $pzp1997$assoc_list$AssocList$get = F2(
	function (targetKey, _v0) {
		get:
		while (true) {
			var alist = _v0;
			if (!alist.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var _v2 = alist.a;
				var key = _v2.a;
				var value = _v2.b;
				var rest = alist.b;
				if (_Utils_eq(key, targetKey)) {
					return $elm$core$Maybe$Just(value);
				} else {
					var $temp$targetKey = targetKey,
						$temp$_v0 = rest;
					targetKey = $temp$targetKey;
					_v0 = $temp$_v0;
					continue get;
				}
			}
		}
	});
var $author$project$Utils$Tree$getAllAncestorsHelper = F2(
	function (zipper, ancestors) {
		getAllAncestorsHelper:
		while (true) {
			var _v0 = $zwilias$elm_rosetree$Tree$Zipper$parent(zipper);
			if (_v0.$ === 1) {
				return ancestors;
			} else {
				var parent = _v0.a;
				var $temp$zipper = parent,
					$temp$ancestors = A2($elm$core$List$cons, parent, ancestors);
				zipper = $temp$zipper;
				ancestors = $temp$ancestors;
				continue getAllAncestorsHelper;
			}
		}
	});
var $author$project$Utils$Tree$getAllAncestors = function (zipper) {
	return A2($author$project$Utils$Tree$getAllAncestorsHelper, zipper, _List_Nil);
};
var $elm$html$Html$img = _VirtualDom_node('img');
var $author$project$Form$Checkbox$Options = $elm$core$Basics$identity;
var $author$project$Form$Checkbox$init = function (_v0) {
	var label = _v0.nC;
	var id = _v0.R;
	return {mg: _List_Nil, cf: false, R: id, nC: label};
};
var $author$project$Form$Group = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Form$fill = function (_v0) {
	var fill_ = _v0;
	return fill_;
};
var $author$project$Form$list = F2(
	function (groupAttrs, current) {
		return function (values) {
			var filledForms = A2(
				$elm$core$List$map,
				function (f) {
					return A2($author$project$Form$fill, f, values);
				},
				current);
			var combinedResult = A3(
				$elm$core$List$foldr,
				F2(
					function (currFilled, currResult) {
						var _v0 = _Utils_Tuple2(currFilled.m, currResult);
						_v0$3:
						while (true) {
							switch (_v0.a.$) {
								case 0:
									if (!_v0.b.$) {
										var _v1 = _v0.a.a;
										var currError = _v1.a;
										var currErrors = _v1.b;
										var _v2 = _v0.b.a;
										var resultError = _v2.a;
										var resultErrors = _v2.b;
										return $author$project$OptionalResult$OptErr(
											_Utils_Tuple2(
												currError,
												_Utils_ap(
													currErrors,
													A2($elm$core$List$cons, resultError, resultErrors))));
									} else {
										var _v3 = _v0.a.a;
										var currError = _v3.a;
										var currErrors = _v3.b;
										return $author$project$OptionalResult$OptErr(
											_Utils_Tuple2(currError, currErrors));
									}
								case 1:
									switch (_v0.b.$) {
										case 1:
											var currOk = _v0.a.a;
											var resultOk = _v0.b.a;
											return $author$project$OptionalResult$OptOk(
												A2($elm$core$List$cons, currOk, resultOk));
										case 0:
											break _v0$3;
										default:
											var currOk = _v0.a.a;
											var _v5 = _v0.b;
											return $author$project$OptionalResult$OptOk(
												_List_fromArray(
													[currOk]));
									}
								default:
									switch (_v0.b.$) {
										case 0:
											break _v0$3;
										case 1:
											var _v6 = _v0.a;
											var resultOk = _v0.b.a;
											return $author$project$OptionalResult$OptOk(resultOk);
										default:
											var _v7 = _v0.a;
											var _v8 = _v0.b;
											return $author$project$OptionalResult$OptNothing;
									}
							}
						}
						var _v4 = _v0.b.a;
						var resultError = _v4.a;
						var resultErrors = _v4.b;
						return $author$project$OptionalResult$OptErr(
							_Utils_Tuple2(resultError, resultErrors));
					}),
				$author$project$OptionalResult$OptOk(_List_Nil),
				filledForms);
			return {
				l: _List_fromArray(
					[
						{
						mM: $elm$core$Maybe$Nothing,
						nx: false,
						X: A2(
							$author$project$Form$Group,
							groupAttrs,
							A2(
								$elm$core$List$concatMap,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.l;
									},
									$elm$core$List$reverse),
								filledForms)),
						aP: 0
					}
					]),
				m: combinedResult
			};
		};
	});
var $author$project$OptionalResult$map = F2(
	function (fn, optionalResult) {
		switch (optionalResult.$) {
			case 1:
				var a = optionalResult.a;
				return $author$project$OptionalResult$OptOk(
					fn(a));
			case 0:
				var error = optionalResult.a;
				return $author$project$OptionalResult$OptErr(error);
			default:
				return $author$project$OptionalResult$OptNothing;
		}
	});
var $author$project$Form$mapOutput = F2(
	function (fn, form) {
		return function (values) {
			var filledForm = A2($author$project$Form$fill, form, values);
			return {
				l: filledForm.l,
				m: A2($author$project$OptionalResult$map, fn, filledForm.m)
			};
		};
	});
var $author$project$Form$Toggle$Right = $elm$core$Basics$identity;
var $elm$html$Html$div = _VirtualDom_node('div');
var $author$project$Form$Toggle$EnabledDisabled = 0;
var $author$project$Form$Toggle$Options = $elm$core$Basics$identity;
var $author$project$Form$Toggle$init = function (_v0) {
	var label = _v0.nC;
	var id = _v0.R;
	return {
		mg: _List_Nil,
		cf: false,
		R: id,
		nC: label,
		id: {jS: false},
		ld: 0,
		gH: _List_Nil,
		is: $elm$core$Maybe$Nothing,
		it: $elm$core$Maybe$Nothing
	};
};
var $elm$html$Html$p = _VirtualDom_node('p');
var $elm$html$Html$span = _VirtualDom_node('span');
var $author$project$Form$succeed = function (output) {
	return function (_v0) {
		return {
			l: _List_Nil,
			m: $author$project$OptionalResult$OptOk(output)
		};
	};
};
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
var $author$project$Form$Toggle = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Form$toggle = F2(
	function (config, options) {
		return A2(
			$author$project$Form$field,
			$author$project$Form$Toggle(options),
			config);
	});
var $author$project$Form$Toggle$withContainerAttrs = F2(
	function (attrs, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				mg: _Utils_ap(options.mg, attrs)
			});
	});
var $author$project$OptionalResult$map2 = F3(
	function (fn, first, second) {
		var _v0 = _Utils_Tuple2(first, second);
		_v0$2:
		while (true) {
			_v0$3:
			while (true) {
				switch (_v0.a.$) {
					case 1:
						switch (_v0.b.$) {
							case 1:
								var firstOk = _v0.a.a;
								var secondOk = _v0.b.a;
								return $author$project$OptionalResult$OptOk(
									A2(fn, firstOk, secondOk));
							case 0:
								break _v0$2;
							default:
								break _v0$3;
						}
					case 0:
						var error = _v0.a.a;
						return $author$project$OptionalResult$OptErr(error);
					default:
						if (!_v0.b.$) {
							break _v0$2;
						} else {
							break _v0$3;
						}
				}
			}
			return $author$project$OptionalResult$OptNothing;
		}
		var error = _v0.b.a;
		return $author$project$OptionalResult$OptErr(error);
	});
var $author$project$Form$accumulateResults = F3(
	function (first, second, combinator) {
		var getErrors = function (result) {
			if (!result.$) {
				var _v4 = result.a;
				var firstError = _v4.a;
				var otherErrors = _v4.b;
				return $elm$core$Maybe$Just(
					A2($elm$core$List$cons, firstError, otherErrors));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		};
		var allErrors = $elm$core$List$concat(
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						getErrors(first),
						getErrors(second)
					])));
		switch (combinator.$) {
			case 1:
				var fn = combinator.a;
				return A3($author$project$OptionalResult$map2, fn, first, second);
			case 0:
				var _v1 = combinator.a;
				var error = _v1.a;
				var errors = _v1.b;
				return $author$project$OptionalResult$OptErr(
					_Utils_Tuple2(
						error,
						_Utils_ap(errors, allErrors)));
			default:
				if (allErrors.b) {
					var error = allErrors.a;
					var errors = allErrors.b;
					return $author$project$OptionalResult$OptErr(
						_Utils_Tuple2(error, errors));
				} else {
					return $author$project$OptionalResult$OptNothing;
				}
		}
	});
var $author$project$Form$withGroup = F4(
	function (attributes, leftSide, rightSide, current) {
		return function (values) {
			var filledRight = A2($author$project$Form$fill, rightSide, values);
			var filledLeft = A2($author$project$Form$fill, leftSide, values);
			var filledCurrent = A2($author$project$Form$fill, current, values);
			return {
				l: A2(
					$elm$core$List$cons,
					{
						mM: $elm$core$Maybe$Nothing,
						nx: false,
						X: A2(
							$author$project$Form$Group,
							attributes,
							_Utils_ap(filledLeft.l, filledRight.l)),
						aP: 0
					},
					filledCurrent.l),
				m: A3($author$project$Form$accumulateResults, filledLeft.m, filledRight.m, filledCurrent.m)
			};
		};
	});
var $author$project$Form$Toggle$withToggleContainerAttrs = F2(
	function (attrs, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				gH: _Utils_ap(options.gH, attrs)
			});
	});
var $author$project$Form$Toggle$withToggleSide = F2(
	function (side, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{id: side});
	});
var $author$project$Page$Shop$Editor$onlineForm = function (translators) {
	return A4(
		$author$project$Form$withGroup,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('bg-gray-100 rounded-sm p-4 mt-8')
			]),
		A2(
			$author$project$Form$toggle,
			{
				ab: $elm$core$Basics$always($elm$core$Maybe$Nothing),
				af: $elm$core$Result$Ok,
				n: F2(
					function (newOnline, values) {
						return _Utils_update(
							values,
							{dF: newOnline});
					}),
				pO: function ($) {
					return $.dF;
				}
			},
			A2(
				$author$project$Form$Toggle$withToggleSide,
				{jS: true},
				A2(
					$author$project$Form$Toggle$withToggleContainerAttrs,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('ml-0 pl-0')
						]),
					A2(
						$author$project$Form$Toggle$withContainerAttrs,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex flex-col')
							]),
						$author$project$Form$Toggle$init(
							{
								R: 'product-online-toggle',
								nC: A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-gray-333 text-base mb-4')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('font-bold')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													translators.il('shop.steps.categories.online_label'))
												])),
											A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('mt-2')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													translators.il('shop.steps.categories.online_description'))
												]))
										]))
							}))))),
		$author$project$Form$succeed(0),
		$author$project$Form$succeed(
			F2(
				function (online, _v0) {
					return online;
				})));
};
var $elm$html$Html$Attributes$src = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'src',
		_VirtualDom_noJavaScriptOrHtmlUri(url));
};
var $author$project$Form$with = F2(
	function (_new, current) {
		return function (values) {
			var filledNew = A2($author$project$Form$fill, _new, values);
			var filledCurrent = A2($author$project$Form$fill, current, values);
			return {
				l: _Utils_ap(filledNew.l, filledCurrent.l),
				m: function () {
					var _v0 = filledCurrent.m;
					switch (_v0.$) {
						case 1:
							var fn = _v0.a;
							return A2($author$project$OptionalResult$map, fn, filledNew.m);
						case 2:
							var _v1 = filledNew.m;
							switch (_v1.$) {
								case 0:
									var errors = _v1.a;
									return $author$project$OptionalResult$OptErr(errors);
								case 1:
									return $author$project$OptionalResult$OptNothing;
								default:
									return $author$project$OptionalResult$OptNothing;
							}
						default:
							var _v2 = _v0.a;
							var firstError = _v2.a;
							var otherErrors = _v2.b;
							var _v3 = filledNew.m;
							switch (_v3.$) {
								case 1:
									return $author$project$OptionalResult$OptErr(
										_Utils_Tuple2(firstError, otherErrors));
								case 2:
									return $author$project$OptionalResult$OptErr(
										_Utils_Tuple2(firstError, otherErrors));
								default:
									var _v4 = _v3.a;
									var secondFirstError = _v4.a;
									var secondOtherErrors = _v4.b;
									return $author$project$OptionalResult$OptErr(
										_Utils_Tuple2(
											firstError,
											_Utils_ap(
												otherErrors,
												A2($elm$core$List$cons, secondFirstError, secondOtherErrors))));
							}
					}
				}()
			};
		};
	});
var $author$project$Form$Checkbox$withContainerAttrs = F2(
	function (attrs, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				mg: _Utils_ap(options.mg, attrs)
			});
	});
var $author$project$Form$withNoOutput = F2(
	function (_new, current) {
		return function (values) {
			var filledNew = A2($author$project$Form$fill, _new, values);
			var filledCurrent = A2($author$project$Form$fill, current, values);
			return {
				l: _Utils_ap(filledNew.l, filledCurrent.l),
				m: filledCurrent.m
			};
		};
	});
var $author$project$Page$Shop$Editor$categoriesForm = F2(
	function (translators, allCategories) {
		var checkbox = function (category) {
			return A2(
				$author$project$Form$checkbox,
				{
					ab: $elm$core$Basics$always($elm$core$Maybe$Nothing),
					af: function (value) {
						return value ? $elm$core$Result$Ok(
							$elm$core$Maybe$Just(category.R)) : $elm$core$Result$Ok($elm$core$Maybe$Nothing);
					},
					n: F2(
						function (input, values) {
							var ancestors = A2(
								$elm$core$List$map,
								$zwilias$elm_rosetree$Tree$Zipper$label,
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2(
										$elm$core$Maybe$map,
										$author$project$Utils$Tree$getAllAncestors,
										A2(
											$elm$core$Maybe$andThen,
											$zwilias$elm_rosetree$Tree$Zipper$findFromRoot(
												function (zipperCategory) {
													return _Utils_eq(zipperCategory.R, category.R);
												}),
											$author$project$Utils$Tree$fromFlatForest(allCategories)))));
							var selected = input ? A3(
								$pzp1997$assoc_list$AssocList$insert,
								category,
								input,
								A3(
									$elm$core$List$foldl,
									function (ancestor) {
										return A2($pzp1997$assoc_list$AssocList$insert, ancestor, true);
									},
									values.ia,
									ancestors)) : A3($pzp1997$assoc_list$AssocList$insert, category, input, values.ia);
							return _Utils_update(
								values,
								{ia: selected});
						}),
					pO: function (input) {
						return A2(
							$elm$core$Maybe$withDefault,
							false,
							A2($pzp1997$assoc_list$AssocList$get, category, input.ia));
					}
				},
				A2(
					$author$project$Form$Checkbox$withContainerAttrs,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex')
						]),
					$author$project$Form$Checkbox$init(
						{
							R: 'category-' + $author$project$Shop$Category$idToString(category.R),
							nC: A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('flex items-center gap-x-2')
									]),
								_List_fromArray(
									[
										function () {
										var _v1 = category.nb;
										if (_v1.$ === 1) {
											return $elm$html$Html$text('');
										} else {
											var icon = _v1.a;
											return A2(
												$elm$html$Html$img,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('w-5 h-5 rounded-full'),
														$elm$html$Html$Attributes$alt(''),
														$elm$html$Html$Attributes$src(icon)
													]),
												_List_Nil);
										}
									}(),
										$elm$html$Html$text(category.ki)
									]))
						})));
		};
		var treeToForm = function (tree) {
			return A4(
				$author$project$Form$withGroup,
				_List_Nil,
				checkbox(
					$zwilias$elm_rosetree$Tree$label(tree)),
				$elm$core$List$isEmpty(
					$zwilias$elm_rosetree$Tree$children(tree)) ? $author$project$Form$succeed(_List_Nil) : A2(
					$author$project$Form$mapOutput,
					$elm$core$List$concat,
					A2(
						$author$project$Form$list,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('ml-4 mt-6 flex flex-col gap-y-6')
							]),
						A2(
							$elm$core$List$map,
							treeToForm,
							$zwilias$elm_rosetree$Tree$children(tree)))),
				$author$project$Form$succeed(
					F2(
						function (label, children) {
							if (label.$ === 1) {
								return children;
							} else {
								var head = label.a;
								return A2($elm$core$List$cons, head, children);
							}
						})));
		};
		return A2(
			$author$project$Form$with,
			$author$project$Page$Shop$Editor$onlineForm(translators),
			A2(
				$author$project$Form$with,
				A2(
					$author$project$Form$mapOutput,
					$elm$core$List$concat,
					A2(
						$author$project$Form$list,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex flex-col gap-y-6')
							]),
						A2($elm$core$List$map, treeToForm, allCategories))),
				A2(
					$author$project$Form$withNoOutput,
					$author$project$Form$arbitrary(
						$elm$core$List$isEmpty(allCategories) ? $elm$html$Html$text('') : A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mb-4')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									translators.il('shop.steps.categories.guidance'))
								]))),
					$author$project$Form$succeed($author$project$Page$Shop$Editor$CategoriesFormOutput))));
	});
var $author$project$Community$CommunityError = function (a) {
	return {$: 0, a: a};
};
var $author$project$Community$FieldError = function (a) {
	return {$: 1, a: a};
};
var $krisajenkins$remotedata$RemoteData$andThen = F2(
	function (f, data) {
		switch (data.$) {
			case 3:
				var a = data.a;
				return f(a);
			case 2:
				var e = data.a;
				return $krisajenkins$remotedata$RemoteData$Failure(e);
			case 0:
				return $krisajenkins$remotedata$RemoteData$NotAsked;
			default:
				return $krisajenkins$remotedata$RemoteData$Loading;
		}
	});
var $krisajenkins$remotedata$RemoteData$map = F2(
	function (f, data) {
		switch (data.$) {
			case 3:
				var value = data.a;
				return $krisajenkins$remotedata$RemoteData$Success(
					f(value));
			case 1:
				return $krisajenkins$remotedata$RemoteData$Loading;
			case 0:
				return $krisajenkins$remotedata$RemoteData$NotAsked;
			default:
				var error = data.a;
				return $krisajenkins$remotedata$RemoteData$Failure(error);
		}
	});
var $krisajenkins$remotedata$RemoteData$mapError = F2(
	function (f, data) {
		switch (data.$) {
			case 3:
				var x = data.a;
				return $krisajenkins$remotedata$RemoteData$Success(x);
			case 2:
				var e = data.a;
				return $krisajenkins$remotedata$RemoteData$Failure(
					f(e));
			case 1:
				return $krisajenkins$remotedata$RemoteData$Loading;
			default:
				return $krisajenkins$remotedata$RemoteData$NotAsked;
		}
	});
var $author$project$Community$getField = F2(
	function (remoteDataModel, accessor) {
		return A2(
			$krisajenkins$remotedata$RemoteData$andThen,
			function (model) {
				return A2(
					$krisajenkins$remotedata$RemoteData$mapError,
					$author$project$Community$FieldError,
					A2(
						$krisajenkins$remotedata$RemoteData$map,
						function (field) {
							return _Utils_Tuple2(model, field);
						},
						accessor(model)));
			},
			A2($krisajenkins$remotedata$RemoteData$mapError, $author$project$Community$CommunityError, remoteDataModel));
	});
var $author$project$Page$Shop$Editor$getFormData = function (model) {
	var _v0 = model.gE;
	switch (_v0.$) {
		case 0:
			var formData = _v0.a;
			return $elm$core$Maybe$Just(formData);
		case 1:
			var formData = _v0.a;
			return $elm$core$Maybe$Just(formData);
		case 2:
			return $elm$core$Maybe$Nothing;
		case 3:
			var formData = _v0.b;
			return $elm$core$Maybe$Just(formData);
		case 4:
			var formData = _v0.b;
			return $elm$core$Maybe$Just(formData);
		case 5:
			var formData = _v0.b;
			return $elm$core$Maybe$Just(formData);
		case 6:
			var formData = _v0.b;
			return $elm$core$Maybe$Just(formData);
		case 7:
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Form$File = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Form$File$Model = $elm$core$Basics$identity;
var $author$project$Form$File$MultipleEntries = function (a) {
	return {$: 1, a: a};
};
var $author$project$Form$File$fromMultipleModel = function (_v0) {
	var model = _v0;
	return {
		q: model.q,
		f: $author$project$Form$File$MultipleEntries(model.f),
		ae: model.ae,
		j: model.j,
		G: model.G,
		t: model.t
	};
};
var $author$project$Form$mapBaseField = F3(
	function (fn, reverseFn, baseField) {
		return {
			aX: A2($elm$core$Basics$composeR, baseField.aX, fn),
			n: A2($elm$core$Basics$composeR, reverseFn, baseField.n),
			bb: A2($elm$core$Basics$composeR, reverseFn, baseField.bb),
			pO: fn(baseField.pO)
		};
	});
var $author$project$Form$File$parseUrlStatus = F2(
	function (_v0, urlStatus) {
		var t = _v0.il;
		switch (urlStatus.$) {
			case 0:
				return $elm$core$Result$Err(
					t('error.wait_file_upload'));
			case 1:
				var url = urlStatus.a;
				return $elm$core$Result$Ok(url);
			case 2:
				return $elm$core$Result$Err(
					t('error.wait_file_upload'));
			case 3:
				return $elm$core$Result$Err(
					t('error.wait_file_upload'));
			case 4:
				var croppedUrl = urlStatus.a.c6;
				return $elm$core$Result$Ok(croppedUrl);
			default:
				return $elm$core$Result$Err(
					t('error.file_upload'));
		}
	});
var $author$project$Form$File$parserMultiple = F2(
	function (translators, _v0) {
		var model = _v0;
		return A3(
			$elm$core$List$foldr,
			F2(
				function (entry, result) {
					var _v1 = A2($author$project$Form$File$parseUrlStatus, translators, entry.gL);
					if (_v1.$ === 1) {
						var err = _v1.a;
						return $elm$core$Result$Err(err);
					} else {
						var url = _v1.a;
						if (result.$ === 1) {
							var err = result.a;
							return $elm$core$Result$Err(err);
						} else {
							var validEntries = result.a;
							return $elm$core$Result$Ok(
								A2($elm$core$List$cons, url, validEntries));
						}
					}
				}),
			$elm$core$Result$Ok(_List_Nil),
			model.f);
	});
var $author$project$Form$File$toMultipleModel = function (_v0) {
	var model = _v0;
	return {
		q: model.q,
		f: function () {
			var _v1 = model.f;
			if (!_v1.$) {
				if (!_v1.a.$) {
					var entry = _v1.a.a;
					return _List_fromArray(
						[entry]);
				} else {
					var _v2 = _v1.a;
					return _List_Nil;
				}
			} else {
				var entries = _v1.a;
				return entries;
			}
		}(),
		ae: model.ae,
		j: model.j,
		G: model.G,
		t: model.t
	};
};
var $author$project$Form$fileMultiple = F2(
	function (config, options) {
		return A2(
			$author$project$Form$field,
			A2(
				$elm$core$Basics$composeR,
				A2($author$project$Form$mapBaseField, $author$project$Form$File$fromMultipleModel, $author$project$Form$File$toMultipleModel),
				$author$project$Form$File(options)),
			{
				ab: config.ab,
				af: A2(
					$elm$core$Basics$composeR,
					$author$project$Form$File$parserMultiple(config.iw),
					$elm$core$Result$andThen(config.af)),
				n: config.n,
				pO: config.pO
			});
	});
var $author$project$Form$File$DeleteEntry = {$: 0};
var $author$project$Form$File$Image = 1;
var $author$project$Form$File$Options = $elm$core$Basics$identity;
var $author$project$Form$File$ReplaceEntry = {$: 2};
var $author$project$Form$File$SaveEntry = {$: 3};
var $author$project$Form$File$init = function (_v0) {
	var id = _v0.R;
	return {
		iI: _List_Nil,
		gO: $elm$core$Maybe$Nothing,
		c4: _List_Nil,
		cf: false,
		db: function (_v1) {
			return _List_fromArray(
				[$author$project$Form$File$DeleteEntry, $author$project$Form$File$ReplaceEntry, $author$project$Form$File$SaveEntry]);
		},
		ch: function (_v2) {
			return _List_Nil;
		},
		hg: _List_fromArray(
			[1]),
		R: id,
		bG: '',
		fX: _List_Nil,
		hp: $elm$core$Maybe$Nothing,
		nC: $elm$core$Maybe$Nothing
	};
};
var $elm$svg$Svg$Attributes$class = _VirtualDom_attribute('class');
var $elm$svg$Svg$Attributes$clipRule = _VirtualDom_attribute('clip-rule');
var $elm$svg$Svg$Attributes$d = _VirtualDom_attribute('d');
var $elm$svg$Svg$Attributes$fill = _VirtualDom_attribute('fill');
var $elm$svg$Svg$Attributes$fillRule = _VirtualDom_attribute('fill-rule');
var $elm$svg$Svg$Attributes$height = _VirtualDom_attribute('height');
var $elm$svg$Svg$trustedNode = _VirtualDom_nodeNS('http://www.w3.org/2000/svg');
var $elm$svg$Svg$path = $elm$svg$Svg$trustedNode('path');
var $elm$svg$Svg$svg = $elm$svg$Svg$trustedNode('svg');
var $elm$svg$Svg$Attributes$viewBox = _VirtualDom_attribute('viewBox');
var $elm$svg$Svg$Attributes$width = _VirtualDom_attribute('width');
var $author$project$Icons$edit = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('currentColor'),
				$elm$svg$Svg$Attributes$height('26'),
				$elm$svg$Svg$Attributes$viewBox('0 0 24 26'),
				$elm$svg$Svg$Attributes$width('24'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M20.3091 24.2273H1.84628V1.77273H12.3085V0H1.84628C0.826607 0 0 0.793677 0 1.77273V24.2273C0 25.2063 0.826607 26 1.84628 26H20.3091C21.3287 26 22.1553 25.2063 22.1553 24.2273V13H20.3091V24.2273Z'),
						$elm$svg$Svg$Attributes$fill('currentColor'),
						$elm$svg$Svg$Attributes$fillRule('evenodd')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M23.46 2.20989L22.1553 0.957161C21.4345 0.265907 20.2668 0.265907 19.5459 0.957161C19.5459 0.957161 9.28678 10.7958 9.13292 11.3926L8.67135 13.1653C8.51335 13.7699 8.69759 14.4096 9.15659 14.8503C9.61558 15.2911 10.2819 15.468 10.9115 15.3163L12.7578 14.8731C13.3732 14.7194 23.46 4.72125 23.46 4.72125C24.18 4.02914 24.18 2.90791 23.46 2.2158V2.20989ZM13.4901 11.7826L12.2285 10.5713L12.1854 10.5358L20.8506 2.2158L22.1553 3.46852L13.4901 11.7826Z'),
						$elm$svg$Svg$Attributes$fill('currentColor'),
						$elm$svg$Svg$Attributes$fillRule('evenodd')
					]),
				_List_Nil)
			]));
};
var $author$project$Form$File$withEntryContainerAttributes = F2(
	function (attributes, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				ch: function (index) {
					return _Utils_ap(
						options.ch(index),
						attributes(index));
				}
			});
	});
var $author$project$Form$File$withImageSiblingElement = F2(
	function (sibling, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				hp: $elm$core$Maybe$Just(sibling)
			});
	});
var $author$project$Form$File$withEditIconOverlay = function (_v0) {
	var options = _v0;
	return A2(
		$author$project$Form$File$withEntryContainerAttributes,
		function (_v1) {
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('relative')
				]);
		},
		A2(
			$author$project$Form$File$withImageSiblingElement,
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('absolute top-0 bottom-0 left-0 right-0 bg-black/40 grid place-items-center hover:bg-black/50'),
						$elm$html$Html$Attributes$class(options.bG)
					]),
				_List_fromArray(
					[
						$author$project$Icons$edit('text-white')
					])),
			options));
};
var $author$project$Form$File$withImageClass = F2(
	function (class_, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{bG: options.bG + (' ' + class_)});
	});
var $author$project$Form$File$withImageCropperAttributes = F2(
	function (attributes, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				fX: _Utils_ap(options.fX, attributes)
			});
	});
var $author$project$Page$Shop$Editor$imagesForm = function (translators) {
	return A2(
		$author$project$Form$with,
		A2(
			$author$project$Form$fileMultiple,
			{
				ab: $elm$core$Basics$always($elm$core$Maybe$Nothing),
				af: $elm$core$Result$Ok,
				iw: translators,
				n: F2(
					function (_new, _v1) {
						return _new;
					}),
				pO: $elm$core$Basics$identity
			},
			$author$project$Form$File$withEditIconOverlay(
				A2(
					$author$project$Form$File$withImageCropperAttributes,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('rounded')
						]),
					A2(
						$author$project$Form$File$withImageClass,
						'max-w-24 max-h-24',
						A2(
							$author$project$Form$File$withEntryContainerAttributes,
							function (_v0) {
								return _List_fromArray(
									[
										$elm$html$Html$Attributes$class('w-24 h-24 bg-gray-100 rounded grid place-items-center overflow-hidden')
									]);
							},
							$author$project$Form$File$init(
								{R: 'product-images-input'})))))),
		A2(
			$author$project$Form$withNoOutput,
			$author$project$Form$arbitrary(
				A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mb-4')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							translators.il('shop.steps.images.guidance'))
						]))),
			$author$project$Form$succeed($elm$core$Basics$identity)));
};
var $author$project$Page$Shop$Editor$MainInformationFormOutput = F3(
	function (offerType, title, description) {
		return {bc: description, hU: offerType, fb: title};
	});
var $author$project$Form$RichText$Options = $elm$core$Basics$identity;
var $author$project$Form$RichText$init = function (_v0) {
	var label = _v0.nC;
	return {mg: _List_Nil, cf: false, fK: _List_Nil, nC: label, oG: $elm$core$Maybe$Nothing};
};
var $author$project$Form$Text$Options = $elm$core$Basics$identity;
var $author$project$Form$Text$Text = 0;
var $author$project$Form$Text$TextInput = {$: 0};
var $author$project$Form$Text$init = function (_v0) {
	var label = _v0.nC;
	var id = _v0.R;
	return {bz: $elm$core$Basics$identity, gX: $elm$core$Basics$identity, mg: _List_Nil, bA: $elm$core$Maybe$Nothing, fF: _List_Nil, cf: false, fM: _List_Nil, fO: _List_Nil, dd: _List_Nil, R: id, fY: _List_Nil, fZ: $author$project$Form$Text$TextInput, nC: label, f4: _List_Nil, ga: $elm$core$Maybe$Nothing, oG: $elm$core$Maybe$Nothing, d0: 0};
};
var $author$project$Form$Validate$Validator = $elm$core$Basics$identity;
var $author$project$Form$Validate$custom = F2(
	function (validation, _v0) {
		var validator = _v0;
		return A2($elm$core$Result$andThen, validation, validator);
	});
var $elm_community$maybe_extra$Maybe$Extra$combineHelp = F2(
	function (list, acc) {
		combineHelp:
		while (true) {
			if (list.b) {
				var head = list.a;
				var tail = list.b;
				if (!head.$) {
					var a = head.a;
					var $temp$list = tail,
						$temp$acc = A2($elm$core$List$cons, a, acc);
					list = $temp$list;
					acc = $temp$acc;
					continue combineHelp;
				} else {
					return $elm$core$Maybe$Nothing;
				}
			} else {
				return $elm$core$Maybe$Just(
					$elm$core$List$reverse(acc));
			}
		}
	});
var $elm_community$maybe_extra$Maybe$Extra$combine = function (list) {
	return A2($elm_community$maybe_extra$Maybe$Extra$combineHelp, list, _List_Nil);
};
var $dillonkearns$elm_markdown$Markdown$Block$foldl = F3(
	function (_function, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var block = list.a;
				var remainingBlocks = list.b;
				switch (block.$) {
					case 0:
						var html = block.a;
						if (!html.$) {
							var children = html.c;
							var $temp$function = _function,
								$temp$acc = A2(_function, block, acc),
								$temp$list = _Utils_ap(children, remainingBlocks);
							_function = $temp$function;
							acc = $temp$acc;
							list = $temp$list;
							continue foldl;
						} else {
							var $temp$function = _function,
								$temp$acc = A2(_function, block, acc),
								$temp$list = remainingBlocks;
							_function = $temp$function;
							acc = $temp$acc;
							list = $temp$list;
							continue foldl;
						}
					case 1:
						var tight = block.a;
						var blocks = block.b;
						var childBlocks = A2(
							$elm$core$List$concatMap,
							function (_v3) {
								var children = _v3.b;
								return children;
							},
							blocks);
						var $temp$function = _function,
							$temp$acc = A2(_function, block, acc),
							$temp$list = _Utils_ap(childBlocks, remainingBlocks);
						_function = $temp$function;
						acc = $temp$acc;
						list = $temp$list;
						continue foldl;
					case 2:
						var _int = block.b;
						var blocks = block.c;
						var $temp$function = _function,
							$temp$acc = A2(_function, block, acc),
							$temp$list = _Utils_ap(
							$elm$core$List$concat(blocks),
							remainingBlocks);
						_function = $temp$function;
						acc = $temp$acc;
						list = $temp$list;
						continue foldl;
					case 3:
						var blocks = block.a;
						var $temp$function = _function,
							$temp$acc = A2(_function, block, acc),
							$temp$list = _Utils_ap(blocks, remainingBlocks);
						_function = $temp$function;
						acc = $temp$acc;
						list = $temp$list;
						continue foldl;
					case 4:
						var $temp$function = _function,
							$temp$acc = A2(_function, block, acc),
							$temp$list = remainingBlocks;
						_function = $temp$function;
						acc = $temp$acc;
						list = $temp$list;
						continue foldl;
					case 5:
						var $temp$function = _function,
							$temp$acc = A2(_function, block, acc),
							$temp$list = remainingBlocks;
						_function = $temp$function;
						acc = $temp$acc;
						list = $temp$list;
						continue foldl;
					case 6:
						var $temp$function = _function,
							$temp$acc = A2(_function, block, acc),
							$temp$list = remainingBlocks;
						_function = $temp$function;
						acc = $temp$acc;
						list = $temp$list;
						continue foldl;
					case 7:
						var $temp$function = _function,
							$temp$acc = A2(_function, block, acc),
							$temp$list = remainingBlocks;
						_function = $temp$function;
						acc = $temp$acc;
						list = $temp$list;
						continue foldl;
					default:
						var $temp$function = _function,
							$temp$acc = A2(_function, block, acc),
							$temp$list = remainingBlocks;
						_function = $temp$function;
						acc = $temp$acc;
						list = $temp$list;
						continue foldl;
				}
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$Block$extractInlineBlockText = function (block) {
	switch (block.$) {
		case 5:
			var inlines = block.a;
			return $dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines);
		case 0:
			var html = block.a;
			if (!html.$) {
				var blocks = html.c;
				return A3(
					$dillonkearns$elm_markdown$Markdown$Block$foldl,
					F2(
						function (nestedBlock, soFar) {
							return _Utils_ap(
								soFar,
								$dillonkearns$elm_markdown$Markdown$Block$extractInlineBlockText(nestedBlock));
						}),
					'',
					blocks);
			} else {
				return '';
			}
		case 1:
			var tight = block.a;
			var items = block.b;
			return A2(
				$elm$core$String$join,
				'\n',
				A2(
					$elm$core$List$map,
					function (_v4) {
						var task = _v4.a;
						var blocks = _v4.b;
						return A2(
							$elm$core$String$join,
							'\n',
							A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Block$extractInlineBlockText, blocks));
					},
					items));
		case 2:
			var tight = block.a;
			var _int = block.b;
			var items = block.c;
			return A2(
				$elm$core$String$join,
				'\n',
				A2(
					$elm$core$List$map,
					function (blocks) {
						return A2(
							$elm$core$String$join,
							'\n',
							A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Block$extractInlineBlockText, blocks));
					},
					items));
		case 3:
			var blocks = block.a;
			return A2(
				$elm$core$String$join,
				'\n',
				A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Block$extractInlineBlockText, blocks));
		case 4:
			var headingLevel = block.a;
			var inlines = block.b;
			return $dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines);
		case 6:
			var header = block.a;
			var rows = block.b;
			return A2(
				$elm$core$String$join,
				'\n',
				$elm$core$List$concat(
					_List_fromArray(
						[
							A2(
							$elm$core$List$map,
							$dillonkearns$elm_markdown$Markdown$Block$extractInlineText,
							A2(
								$elm$core$List$map,
								function ($) {
									return $.nC;
								},
								header)),
							$elm$core$List$concat(
							A2(
								$elm$core$List$map,
								$elm$core$List$map($dillonkearns$elm_markdown$Markdown$Block$extractInlineText),
								rows))
						])));
		case 7:
			var body = block.a.fv;
			return body;
		default:
			return '';
	}
};
var $dillonkearns$elm_markdown$Markdown$Block$extractInlineText = function (inlines) {
	return A3($elm$core$List$foldl, $dillonkearns$elm_markdown$Markdown$Block$extractTextHelp, '', inlines);
};
var $dillonkearns$elm_markdown$Markdown$Block$extractTextHelp = F2(
	function (inline, text) {
		switch (inline.$) {
			case 7:
				var str = inline.a;
				return _Utils_ap(text, str);
			case 8:
				return text + ' ';
			case 6:
				var str = inline.a;
				return _Utils_ap(text, str);
			case 1:
				var inlines = inline.c;
				return _Utils_ap(
					text,
					$dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines));
			case 2:
				var inlines = inline.c;
				return _Utils_ap(
					text,
					$dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines));
			case 0:
				var html = inline.a;
				if (!html.$) {
					var blocks = html.c;
					return A3(
						$dillonkearns$elm_markdown$Markdown$Block$foldl,
						F2(
							function (block, soFar) {
								return _Utils_ap(
									soFar,
									$dillonkearns$elm_markdown$Markdown$Block$extractInlineBlockText(block));
							}),
						text,
						blocks);
				} else {
					return text;
				}
			case 4:
				var inlines = inline.a;
				return _Utils_ap(
					text,
					$dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines));
			case 3:
				var inlines = inline.a;
				return _Utils_ap(
					text,
					$dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines));
			default:
				var inlines = inline.a;
				return _Utils_ap(
					text,
					$dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines));
		}
	});
var $author$project$Markdown$removeFormattingFromBlock = function (block) {
	var removeFormattingFromList = F2(
		function (lineStarter, blocks) {
			return A2(
				$elm$core$String$join,
				'\n',
				A2(
					$elm$core$List$indexedMap,
					F2(
						function (index, blockChild) {
							return $elm$core$String$concat(
								A2(
									$elm$core$List$map,
									function (line) {
										return _Utils_ap(
											lineStarter(index),
											line);
									},
									A2($elm$core$List$filterMap, $author$project$Markdown$removeFormattingFromBlock, blockChild)));
						}),
					blocks));
		});
	_v0$5:
	while (true) {
		switch (block.$) {
			case 1:
				var children = block.b;
				return $elm$core$Maybe$Just(
					A2(
						removeFormattingFromList,
						function (_v2) {
							return '- ';
						},
						A2(
							$elm$core$List$map,
							function (_v1) {
								var children_ = _v1.b;
								return children_;
							},
							children)));
			case 2:
				var children = block.c;
				return $elm$core$Maybe$Just(
					A2(
						removeFormattingFromList,
						function (index) {
							return $elm$core$String$fromInt(index + 1) + '. ';
						},
						children));
			case 4:
				var inlines = block.b;
				return $elm$core$Maybe$Just(
					$dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines));
			case 5:
				var inlines = block.a;
				return $elm$core$Maybe$Just(
					$dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines));
			case 0:
				if (!block.a.$) {
					var _v3 = block.a;
					var children = _v3.c;
					return A2(
						$elm$core$Maybe$map,
						$elm$core$String$join(' '),
						$elm_community$maybe_extra$Maybe$Extra$combine(
							A2($elm$core$List$map, $author$project$Markdown$removeFormattingFromBlock, children)));
				} else {
					break _v0$5;
				}
			default:
				break _v0$5;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$Markdown$toUnformattedString = function (_v0) {
	var markdown = _v0;
	var _v1 = $dillonkearns$elm_markdown$Markdown$Parser$parse(markdown);
	if (!_v1.$) {
		var blocks = _v1.a;
		return $elm$core$String$trim(
			A2(
				$elm$core$Maybe$withDefault,
				markdown,
				A2(
					$elm$core$Maybe$map,
					$elm$core$String$join('\n'),
					$elm_community$maybe_extra$Maybe$Extra$combine(
						A2($elm$core$List$map, $author$project$Markdown$removeFormattingFromBlock, blocks)))));
	} else {
		return markdown;
	}
};
var $author$project$Form$Validate$markdownLongerThan = function (minLength) {
	return $author$project$Form$Validate$custom(
		function (markdownInput) {
			return (_Utils_cmp(
				$elm$core$String$length(
					$author$project$Markdown$toUnformattedString(markdownInput)),
				minLength) < 0) ? $elm$core$Result$Err(
				function (_v0) {
					var tr = _v0.iu;
					return A2(
						tr,
						'error.validator.text.longer_than',
						_List_fromArray(
							[
								_Utils_Tuple2(
								'base',
								$elm$core$String$fromInt(minLength))
							]));
				}) : $elm$core$Result$Ok(markdownInput);
		});
};
var $elm$html$Html$Attributes$maxlength = function (n) {
	return A2(
		_VirtualDom_attribute,
		'maxlength',
		$elm$core$String$fromInt(n));
};
var $author$project$Form$Radio$Horizontal = 0;
var $author$project$Cambiatus$Enum$OfferType$fromString = function (enumString____) {
	switch (enumString____) {
		case 'BASKET':
			return $elm$core$Maybe$Just(0);
		case 'SERVICE':
			return $elm$core$Maybe$Just(1);
		case 'SIMPLE':
			return $elm$core$Maybe$Just(2);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Form$Radio$Options = $elm$core$Basics$identity;
var $author$project$Form$Radio$init = function (_v0) {
	var label = _v0.nC;
	var id = _v0.R;
	var optionToString = _v0.dG;
	return {mg: _List_Nil, F: 0, cf: false, dh: false, R: id, nC: label, f4: _List_Nil, dG: optionToString, gk: _List_Nil};
};
var $author$project$Form$Radio = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Form$Radio$getOptionToString = function (_v0) {
	var options = _v0;
	return options.dG;
};
var $author$project$Form$Radio$map = F3(
	function (fn, reverseFn, _v0) {
		var options = _v0;
		return {
			mg: options.mg,
			F: options.F,
			cf: options.cf,
			dh: options.dh,
			R: options.R,
			nC: options.nC,
			f4: options.f4,
			dG: A2($elm$core$Basics$composeR, reverseFn, options.dG),
			gk: A2(
				$elm$core$List$map,
				function (_v1) {
					var option = _v1.gj;
					var label = _v1.nC;
					return {
						nC: label,
						gj: fn(option)
					};
				},
				options.gk)
		};
	});
var $author$project$Form$mapFieldConfig = F3(
	function (fn, reverseFn, config) {
		return {
			ab: config.ab,
			af: A2($elm$core$Basics$composeR, reverseFn, config.af),
			n: function (mappedInput) {
				return config.n(
					reverseFn(mappedInput));
			},
			pO: A2($elm$core$Basics$composeR, config.pO, fn)
		};
	});
var $author$project$Form$radio = F3(
	function (optionFromString, config, options) {
		var optionToString = $author$project$Form$Radio$getOptionToString(options);
		return A2(
			$author$project$Form$field,
			$author$project$Form$Radio(
				A3($author$project$Form$Radio$map, optionToString, optionFromString, options)),
			A3($author$project$Form$mapFieldConfig, optionToString, optionFromString, config));
	});
var $author$project$Form$Radio$withContainerAttrs = F2(
	function (attrs, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				mg: _Utils_ap(options.mg, attrs)
			});
	});
var $author$project$Form$Radio$withDirection = F2(
	function (direction, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{F: direction});
	});
var $author$project$Form$Radio$withOption = F3(
	function (optionValue, optionLabel, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				gk: A2(
					$elm$core$List$cons,
					{nC: optionLabel, gj: optionValue},
					options.gk)
			});
	});
var $author$project$Page$Shop$Editor$offerTypeForm = function (_v0) {
	var t = _v0.il;
	return A3(
		$author$project$Form$radio,
		function (string) {
			return A2(
				$elm$core$Maybe$withDefault,
				2,
				$author$project$Cambiatus$Enum$OfferType$fromString(string));
		},
		{
			ab: $elm$core$Basics$always($elm$core$Maybe$Nothing),
			af: $elm$core$Result$Ok,
			n: F2(
				function (newType, values) {
					return _Utils_update(
						values,
						{hU: newType});
				}),
			pO: function ($) {
				return $.hU;
			}
		},
		A2(
			$author$project$Form$Radio$withContainerAttrs,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mb-6')
				]),
			A2(
				$author$project$Form$Radio$withDirection,
				0,
				A3(
					$author$project$Form$Radio$withOption,
					1,
					$elm$html$Html$text(
						t('shop.steps.main_information.type_service')),
					A3(
						$author$project$Form$Radio$withOption,
						2,
						$elm$html$Html$text(
							t('shop.steps.main_information.type_product')),
						$author$project$Form$Radio$init(
							{
								R: 'product-type-radio',
								nC: t('shop.steps.main_information.type_label'),
								dG: $author$project$Cambiatus$Enum$OfferType$toString
							}))))));
};
var $author$project$Form$RichText = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm_community$list_extra$List$Extra$last = function (items) {
	last:
	while (true) {
		if (!items.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (!items.b.b) {
				var x = items.a;
				return $elm$core$Maybe$Just(x);
			} else {
				var rest = items.b;
				var $temp$items = rest;
				items = $temp$items;
				continue last;
			}
		}
	}
};
var $author$project$Markdown$formattingStrings = function (formatting) {
	switch (formatting.$) {
		case 0:
			return _Utils_Tuple2('**', '**');
		case 1:
			return _Utils_Tuple2('_', '_');
		case 2:
			return _Utils_Tuple2('~~', '~~');
		case 3:
			return _Utils_Tuple2('<u>', '</u>');
		case 4:
			var link = formatting.a;
			return _Utils_Tuple2('[', '](' + (link + ')'));
		case 5:
			var level = formatting.a;
			return _Utils_Tuple2(
				A2($elm$core$String$repeat, level, '#') + ' ',
				'');
		case 6:
			return _Utils_Tuple2('\n1. ', '');
		default:
			return _Utils_Tuple2('\n- ', '');
	}
};
var $elm$core$String$replace = F3(
	function (before, after, string) {
		return A2(
			$elm$core$String$join,
			after,
			A2($elm$core$String$split, before, string));
	});
var $elm_community$list_extra$List$Extra$takeWhile = function (predicate) {
	var takeWhileMemo = F2(
		function (memo, list) {
			takeWhileMemo:
			while (true) {
				if (!list.b) {
					return $elm$core$List$reverse(memo);
				} else {
					var x = list.a;
					var xs = list.b;
					if (predicate(x)) {
						var $temp$memo = A2($elm$core$List$cons, x, memo),
							$temp$list = xs;
						memo = $temp$memo;
						list = $temp$list;
						continue takeWhileMemo;
					} else {
						return $elm$core$List$reverse(memo);
					}
				}
			}
		});
	return takeWhileMemo(_List_Nil);
};
var $author$project$Markdown$quillOpToMarkdown = function (_v0) {
	var quillOp = _v0;
	var addFormatting = F2(
		function (formatting, unformattedText) {
			var shouldAddSurroundingSpaces = function () {
				switch (formatting.$) {
					case 0:
						return true;
					case 1:
						return true;
					case 2:
						return true;
					case 3:
						return true;
					default:
						return false;
				}
			}();
			var spacesAfter = shouldAddSurroundingSpaces ? $elm$core$List$length(
				A2(
					$elm_community$list_extra$List$Extra$takeWhile,
					$elm$core$Basics$eq(' '),
					$elm$core$List$reverse(
						$elm$core$String$toList(unformattedText)))) : 0;
			var spacesBefore = shouldAddSurroundingSpaces ? $elm$core$List$length(
				A2(
					$elm_community$list_extra$List$Extra$takeWhile,
					$elm$core$Basics$eq(' '),
					$elm$core$String$toList(unformattedText))) : 0;
			var maybeTrim = shouldAddSurroundingSpaces ? $elm$core$String$trim : $elm$core$Basics$identity;
			var _v1 = $author$project$Markdown$formattingStrings(formatting);
			var formatBefore = _v1.a;
			var formatAfter = _v1.b;
			return _Utils_ap(
				A2($elm$core$String$repeat, spacesBefore, ' '),
				_Utils_ap(
					formatBefore,
					_Utils_ap(
						maybeTrim(unformattedText),
						_Utils_ap(
							formatAfter,
							A2($elm$core$String$repeat, spacesAfter, ' ')))));
		});
	return $elm$core$String$isEmpty(
		$elm$core$String$trim(quillOp.aw)) ? '' : A3(
		$elm$core$String$replace,
		'___',
		'*_*',
		A3(
			$elm$core$String$replace,
			'_____',
			'**_**',
			A3(
				$elm$core$String$replace,
				'***',
				'_*_',
				A3(
					$elm$core$String$replace,
					'*****',
					'__*__',
					A3($elm$core$List$foldr, addFormatting, quillOp.aw, quillOp.A)))));
};
var $author$project$Markdown$fromQuillOps = function (quillOps) {
	var isHeader = function (formatting) {
		if (formatting.$ === 5) {
			return true;
		} else {
			return false;
		}
	};
	var headerLevel = function (formattings) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filterMap,
				function (formatting) {
					if (formatting.$ === 5) {
						var level = formatting.a;
						return $elm$core$Maybe$Just(level);
					} else {
						return $elm$core$Maybe$Nothing;
					}
				},
				formattings));
	};
	var foldFn = F2(
		function (_v2, _v3) {
			var currItem = _v2;
			var previousItems = _v3.cE;
			var currString = _v3.bB;
			if (A2($elm$core$List$member, $author$project$Markdown$OrderedList, currItem.A)) {
				return {
					bB: currString + ('1. ' + ($elm$core$String$concat(
						A2(
							$elm$core$List$map,
							$author$project$Markdown$quillOpToMarkdown,
							$elm$core$List$reverse(previousItems))) + '\n')),
					cE: _List_Nil
				};
			} else {
				if (A2($elm$core$List$member, $author$project$Markdown$UnorderedList, currItem.A)) {
					return {
						bB: currString + ('- ' + ($elm$core$String$concat(
							A2(
								$elm$core$List$map,
								$author$project$Markdown$quillOpToMarkdown,
								$elm$core$List$reverse(previousItems))) + '\n')),
						cE: _List_Nil
					};
				} else {
					if (A2($elm$core$List$any, isHeader, currItem.A)) {
						return {
							bB: currString + (function (level) {
								return A2($elm$core$String$repeat, level, '#');
							}(
								A2(
									$elm$core$Maybe$withDefault,
									0,
									headerLevel(currItem.A))) + (' ' + ($elm$core$String$concat(
								A2(
									$elm$core$List$map,
									$author$project$Markdown$quillOpToMarkdown,
									$elm$core$List$reverse(previousItems))) + '\n'))),
							cE: _List_Nil
						};
					} else {
						if (A2($elm$core$String$endsWith, '\n', currItem.aw)) {
							return {
								bB: _Utils_ap(
									currString,
									$elm$core$String$concat(
										A2(
											$elm$core$List$map,
											$author$project$Markdown$quillOpToMarkdown,
											$elm$core$List$reverse(
												A2($elm$core$List$cons, currItem, previousItems))))),
								cE: _List_Nil
							};
						} else {
							var currItems = A2(
								$elm$core$List$map,
								function (insert) {
									return {A: currItem.A, aw: insert};
								},
								A2($elm$core$String$split, '\n', currItem.aw));
							var _v0 = _Utils_Tuple2(
								A2(
									$elm$core$List$map,
									$author$project$Markdown$quillOpToMarkdown,
									A2(
										$elm$core$List$take,
										$elm$core$List$length(currItems) - 1,
										currItems)),
								$elm_community$list_extra$List$Extra$last(currItems));
							var firstItems = _v0.a;
							var lastItem = _v0.b;
							return {
								bB: $elm$core$List$isEmpty(firstItems) ? currString : (currString + ($elm$core$String$concat(
									A2(
										$elm$core$List$map,
										$author$project$Markdown$quillOpToMarkdown,
										$elm$core$List$reverse(previousItems))) + (A2($elm$core$String$join, '\n', firstItems) + '\n'))),
								cE: function () {
									if (lastItem.$ === 1) {
										return _List_Nil;
									} else {
										var lastItem_ = lastItem.a;
										return $elm$core$List$isEmpty(firstItems) ? A2($elm$core$List$cons, lastItem_, previousItems) : _List_fromArray(
											[lastItem_]);
									}
								}()
							};
						}
					}
				}
			}
		});
	return A3(
		$elm$core$List$foldl,
		foldFn,
		{bB: '', cE: _List_Nil},
		quillOps).bB;
};
var $author$project$Form$RichText$getMarkdownContent = function (_v0) {
	var model = _v0;
	return $author$project$Markdown$fromQuillOps(model.fB);
};
var $author$project$Form$richText = F2(
	function (config, options) {
		return A2(
			$author$project$Form$field,
			$author$project$Form$RichText(options),
			{
				ab: config.ab,
				af: A2($elm$core$Basics$composeR, $author$project$Form$RichText$getMarkdownContent, config.af),
				n: config.n,
				pO: config.pO
			});
	});
var $author$project$Form$Validate$stringLongerThan = function (minLength) {
	return $author$project$Form$Validate$custom(
		function (stringInput) {
			return (_Utils_cmp(
				$elm$core$String$length(stringInput),
				minLength) < 0) ? $elm$core$Result$Err(
				function (_v0) {
					var tr = _v0.iu;
					return A2(
						tr,
						'error.validator.text.longer_than',
						_List_fromArray(
							[
								_Utils_Tuple2(
								'base',
								$elm$core$String$fromInt(minLength))
							]));
				}) : $elm$core$Result$Ok(stringInput);
		});
};
var $author$project$Form$Validate$stringShorterThan = function (maxLength) {
	return $author$project$Form$Validate$custom(
		function (stringInput) {
			return (_Utils_cmp(
				$elm$core$String$length(stringInput),
				maxLength) > 0) ? $elm$core$Result$Err(
				function (_v0) {
					var tr = _v0.iu;
					return A2(
						tr,
						'error.valdator.text.shorter_than',
						_List_fromArray(
							[
								_Utils_Tuple2(
								'base',
								$elm$core$String$fromInt(maxLength))
							]));
				}) : $elm$core$Result$Ok(stringInput);
		});
};
var $author$project$Form$Validate$succeed = function (output) {
	return $elm$core$Result$Ok(output);
};
var $author$project$Form$Text = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Form$textField = F2(
	function (config, options) {
		return A2(
			$author$project$Form$field,
			$author$project$Form$Text(options),
			config);
	});
var $author$project$Form$Validate$validate = F2(
	function (translators, _v0) {
		var result = _v0;
		return A2(
			$elm$core$Result$mapError,
			function (error) {
				return error(translators);
			},
			result);
	});
var $author$project$Form$Text$withExtraAttrs = F2(
	function (attrs, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				fO: _Utils_ap(options.fO, attrs)
			});
	});
var $author$project$Form$RichText$withPlaceholder = F2(
	function (placeholder, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				oG: $elm$core$Maybe$Just(placeholder)
			});
	});
var $author$project$Form$Text$withPlaceholder = F2(
	function (placeholder, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				oG: $elm$core$Maybe$Just(placeholder)
			});
	});
var $author$project$Page$Shop$Editor$mainInformationForm = function (translators) {
	var t = translators.il;
	return A2(
		$author$project$Form$with,
		A2(
			$author$project$Form$richText,
			{
				ab: $elm$core$Basics$always($elm$core$Maybe$Nothing),
				af: A2(
					$elm$core$Basics$composeR,
					$author$project$Form$Validate$succeed,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Form$Validate$markdownLongerThan(10),
						$author$project$Form$Validate$validate(translators))),
				n: F2(
					function (newDescription, values) {
						return _Utils_update(
							values,
							{bc: newDescription});
					}),
				pO: function ($) {
					return $.bc;
				}
			},
			A2(
				$author$project$Form$RichText$withPlaceholder,
				t('shop.steps.main_information.description_placeholder'),
				$author$project$Form$RichText$init(
					{
						nC: t('shop.steps.main_information.description_label')
					}))),
		A2(
			$author$project$Form$with,
			A2(
				$author$project$Form$textField,
				{
					ab: $elm$core$Basics$always($elm$core$Maybe$Nothing),
					af: A2(
						$elm$core$Basics$composeR,
						$author$project$Form$Validate$succeed,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Form$Validate$stringShorterThan(255),
							A2(
								$elm$core$Basics$composeR,
								$author$project$Form$Validate$stringLongerThan(3),
								$author$project$Form$Validate$validate(translators)))),
					n: F2(
						function (newTitle, values) {
							return _Utils_update(
								values,
								{fb: newTitle});
						}),
					pO: function ($) {
						return $.fb;
					}
				},
				A2(
					$author$project$Form$Text$withPlaceholder,
					t('shop.steps.main_information.name_placeholder'),
					A2(
						$author$project$Form$Text$withExtraAttrs,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$maxlength(255)
							]),
						$author$project$Form$Text$init(
							{
								R: 'product-title-input',
								nC: t('shop.steps.main_information.name_label')
							})))),
			A2(
				$author$project$Form$with,
				$author$project$Page$Shop$Editor$offerTypeForm(translators),
				$author$project$Form$succeed($author$project$Page$Shop$Editor$MainInformationFormOutput))));
};
var $author$project$Form$ClickedSubmitWithErrors = function (a) {
	return {$: 7, a: a};
};
var $author$project$Form$NoOp = {$: 0};
var $author$project$Form$parse = F3(
	function (form, _v0, _v1) {
		var model = _v0;
		var onError = _v1.gi;
		var onSuccess = _v1.dE;
		var filledForm = A2($author$project$Form$fill, form, model.s);
		var _v2 = filledForm.m;
		switch (_v2.$) {
			case 0:
				var errors = _v2.a;
				return onError(
					$author$project$Form$ClickedSubmitWithErrors(errors));
			case 1:
				var validForm = _v2.a;
				return onSuccess(validForm);
			default:
				return onError($author$project$Form$NoOp);
		}
	});
var $author$project$Page$Shop$Editor$Creating = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Shop$Editor$EditingUpdate = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Page$Shop$Editor$EditingUpdateAsAdmin = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Page$Shop$Editor$Saving = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Page$Shop$Editor$SavingAsAdmin = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Page$Shop$Editor$setCurrentStep = F2(
	function (newStep, model) {
		var _v0 = model.gE;
		switch (_v0.$) {
			case 0:
				var formData = _v0.a;
				return _Utils_update(
					model,
					{
						gE: $author$project$Page$Shop$Editor$EditingCreate(
							_Utils_update(
								formData,
								{C: newStep}))
					});
			case 1:
				var formData = _v0.a;
				return _Utils_update(
					model,
					{
						gE: $author$project$Page$Shop$Editor$Creating(
							_Utils_update(
								formData,
								{C: newStep}))
					});
			case 2:
				return model;
			case 3:
				var product = _v0.a;
				var formData = _v0.b;
				return _Utils_update(
					model,
					{
						gE: A2(
							$author$project$Page$Shop$Editor$EditingUpdate,
							product,
							_Utils_update(
								formData,
								{C: newStep}))
					});
			case 4:
				var product = _v0.a;
				var formData = _v0.b;
				return _Utils_update(
					model,
					{
						gE: A2(
							$author$project$Page$Shop$Editor$Saving,
							product,
							_Utils_update(
								formData,
								{C: newStep}))
					});
			case 5:
				var product = _v0.a;
				var formData = _v0.b;
				return _Utils_update(
					model,
					{
						gE: A2(
							$author$project$Page$Shop$Editor$EditingUpdateAsAdmin,
							product,
							_Utils_update(
								formData,
								{C: newStep}))
					});
			case 6:
				var product = _v0.a;
				var formData = _v0.b;
				return _Utils_update(
					model,
					{
						gE: A2(
							$author$project$Page$Shop$Editor$SavingAsAdmin,
							product,
							_Utils_update(
								formData,
								{C: newStep}))
					});
			case 7:
				return model;
			default:
				return model;
		}
	});
var $author$project$Page$Shop$Editor$maybeSetStep = F3(
	function (loggedIn, step, model) {
		var translators = loggedIn.aM.iw;
		var maybeModelCmd = A2(
			$elm$core$Maybe$map,
			function (formData) {
				var _v1 = formData.C;
				switch (_v1.$) {
					case 0:
						switch (step) {
							case 0:
								return $author$project$UpdateResult$init(model);
							case 1:
								return A2(
									$author$project$UpdateResult$addMsg,
									A3(
										$author$project$Form$parse,
										$author$project$Page$Shop$Editor$mainInformationForm(translators),
										formData.bg,
										{
											gi: A2($elm$core$Basics$composeL, $author$project$Page$Shop$Editor$GotFormMsg, $author$project$Page$Shop$Editor$MainInformationMsg),
											dE: $author$project$Page$Shop$Editor$SubmittedMainInformation(0)
										}),
									$author$project$UpdateResult$init(model));
							case 2:
								return A2(
									$author$project$UpdateResult$addMsg,
									A3(
										$author$project$Form$parse,
										$author$project$Page$Shop$Editor$mainInformationForm(translators),
										formData.bg,
										{
											gi: A2($elm$core$Basics$composeL, $author$project$Page$Shop$Editor$GotFormMsg, $author$project$Page$Shop$Editor$MainInformationMsg),
											dE: $author$project$Page$Shop$Editor$SubmittedMainInformation(1)
										}),
									$author$project$UpdateResult$init(model));
							default:
								return A2(
									$author$project$UpdateResult$addMsg,
									A3(
										$author$project$Form$parse,
										$author$project$Page$Shop$Editor$mainInformationForm(translators),
										formData.bg,
										{
											gi: A2($elm$core$Basics$composeL, $author$project$Page$Shop$Editor$GotFormMsg, $author$project$Page$Shop$Editor$MainInformationMsg),
											dE: $author$project$Page$Shop$Editor$SubmittedMainInformation(2)
										}),
									$author$project$UpdateResult$init(model));
						}
					case 1:
						switch (step) {
							case 0:
								return $author$project$UpdateResult$init(
									A2($author$project$Page$Shop$Editor$setCurrentStep, $author$project$Page$Shop$Editor$MainInformation, model));
							case 1:
								return $author$project$UpdateResult$init(model);
							case 2:
								return A2(
									$author$project$UpdateResult$addMsg,
									A3(
										$author$project$Form$parse,
										$author$project$Page$Shop$Editor$imagesForm(translators),
										formData.hr,
										{
											gi: A2($elm$core$Basics$composeL, $author$project$Page$Shop$Editor$GotFormMsg, $author$project$Page$Shop$Editor$ImagesMsg),
											dE: $author$project$Page$Shop$Editor$SubmittedImages(0)
										}),
									$author$project$UpdateResult$init(model));
							default:
								return A2(
									$author$project$UpdateResult$addMsg,
									A3(
										$author$project$Form$parse,
										$author$project$Page$Shop$Editor$imagesForm(translators),
										formData.hr,
										{
											gi: A2($elm$core$Basics$composeL, $author$project$Page$Shop$Editor$GotFormMsg, $author$project$Page$Shop$Editor$ImagesMsg),
											dE: $author$project$Page$Shop$Editor$SubmittedImages(1)
										}),
									$author$project$UpdateResult$init(model));
						}
					case 2:
						var mainInformationOutput = _v1.a;
						switch (step) {
							case 0:
								return $author$project$UpdateResult$init(
									A2($author$project$Page$Shop$Editor$setCurrentStep, $author$project$Page$Shop$Editor$MainInformation, model));
							case 1:
								return $author$project$UpdateResult$init(
									A2(
										$author$project$Page$Shop$Editor$setCurrentStep,
										$author$project$Page$Shop$Editor$Images(mainInformationOutput),
										model));
							case 2:
								return $author$project$UpdateResult$init(model);
							default:
								var _v5 = A2(
									$author$project$Community$getField,
									loggedIn.o7,
									function ($) {
										return $.e1;
									});
								if (_v5.$ === 3) {
									var _v6 = _v5.a;
									var categories = _v6.b;
									return A2(
										$author$project$UpdateResult$addMsg,
										A3(
											$author$project$Form$parse,
											A2($author$project$Page$Shop$Editor$categoriesForm, translators, categories),
											formData.cX,
											{
												gi: A2($elm$core$Basics$composeL, $author$project$Page$Shop$Editor$GotFormMsg, $author$project$Page$Shop$Editor$CategoriesMsg),
												dE: $author$project$Page$Shop$Editor$SubmittedCategories
											}),
										$author$project$UpdateResult$init(model));
								} else {
									return $author$project$UpdateResult$init(
										_Utils_update(
											model,
											{dw: true}));
								}
						}
					default:
						var mainInformationOutput = _v1.a;
						var imagesOutput = _v1.b;
						switch (step) {
							case 0:
								return $author$project$UpdateResult$init(
									A2($author$project$Page$Shop$Editor$setCurrentStep, $author$project$Page$Shop$Editor$MainInformation, model));
							case 1:
								return $author$project$UpdateResult$init(
									A2(
										$author$project$Page$Shop$Editor$setCurrentStep,
										$author$project$Page$Shop$Editor$Images(mainInformationOutput),
										model));
							case 2:
								return $author$project$UpdateResult$init(
									A2(
										$author$project$Page$Shop$Editor$setCurrentStep,
										A2($author$project$Page$Shop$Editor$Categories, mainInformationOutput, imagesOutput),
										model));
							default:
								return $author$project$UpdateResult$init(model);
						}
				}
			},
			$author$project$Page$Shop$Editor$getFormData(model));
		if (maybeModelCmd.$ === 1) {
			return $author$project$UpdateResult$init(model);
		} else {
			var ur = maybeModelCmd.a;
			return ur;
		}
	});
var $elm$time$Time$Name = function (a) {
	return {$: 0, a: a};
};
var $elm$time$Time$Offset = function (a) {
	return {$: 1, a: a};
};
var $elm$time$Time$Zone = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$customZone = $elm$time$Time$Zone;
var $elm$time$Time$now = _Time_now($elm$time$Time$millisToPosix);
var $author$project$Route$Register = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Route$WithNoObjectiveSelected = {$: 1};
var $author$project$Route$SaleMainInformation = 0;
var $author$project$Route$SaleCategories = 2;
var $author$project$Route$SaleImages = 1;
var $author$project$Route$SalePriceAndInventory = 3;
var $author$project$Page$Shop$Editor$getCurrentStepFromFormData = function (formData) {
	var _v0 = formData.C;
	switch (_v0.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $author$project$Page$Shop$Editor$getCurrentStep = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		0,
		A2(
			$elm$core$Maybe$map,
			$author$project$Page$Shop$Editor$getCurrentStepFromFormData,
			$author$project$Page$Shop$Editor$getFormData(model)));
};
var $author$project$Main$statusToRoute = F2(
	function (status, session) {
		switch (status.$) {
			case 0:
				return $elm$core$Maybe$Nothing;
			case 1:
				return $elm$core$Maybe$Nothing;
			case 2:
				return $elm$core$Maybe$Nothing;
			case 3:
				return $elm$core$Maybe$Nothing;
			case 4:
				var subModel = status.a;
				return $elm$core$Maybe$Just(
					$author$project$Route$PaymentHistory(subModel.oZ.fl));
			case 5:
				return $elm$core$Maybe$Just($author$project$Route$CommunityAbout);
			case 6:
				return $elm$core$Maybe$Just(
					$author$project$Route$CommunityObjectives($author$project$Route$WithNoObjectiveSelected));
			case 7:
				return $elm$core$Maybe$Just($author$project$Route$NewCommunity);
			case 8:
				var subModel = status.a;
				return $elm$core$Maybe$Just(
					$author$project$Route$CommunitySelector(subModel.j9));
			case 9:
				var objectiveId = status.a;
				var actionId = status.b;
				var subModel = status.c;
				return $elm$core$Maybe$Just(
					A3($author$project$Route$Claim, objectiveId, actionId, subModel.l6));
			case 10:
				return $elm$core$Maybe$Just($author$project$Route$Notification);
			case 11:
				return $elm$core$Maybe$Just($author$project$Route$Dashboard);
			case 12:
				var maybeRedirect = status.a;
				var maybeInvitation = function () {
					if (session.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var guest = session.a;
						return guest.j8;
					}
				}();
				return $elm$core$Maybe$Just(
					A2($author$project$Route$Login, maybeInvitation, maybeRedirect));
			case 13:
				var subModel = status.a;
				return $elm$core$Maybe$Just(
					$author$project$Route$News(
						{o8: subModel.bh, pe: subModel.pd}));
			case 14:
				var subModel = status.a;
				return $elm$core$Maybe$Just(
					$author$project$Route$Profile(subModel.oS));
			case 15:
				return $elm$core$Maybe$Just($author$project$Route$ProfileEditor);
			case 16:
				return $elm$core$Maybe$Just($author$project$Route$ProfileAddKyc);
			case 17:
				var subModel = status.a;
				return $elm$core$Maybe$Just(
					$author$project$Route$ProfileClaims(subModel.lN));
			case 18:
				return $elm$core$Maybe$Just($author$project$Route$ProfileAddContact);
			case 19:
				var inviteId = status.a;
				var maybeRedirect = status.b;
				return $elm$core$Maybe$Just(
					A2($author$project$Route$Register, inviteId, maybeRedirect));
			case 20:
				return $elm$core$Maybe$Just($author$project$Route$Settings);
			case 21:
				var filter = status.a;
				return $elm$core$Maybe$Just(
					$author$project$Route$Shop(filter));
			case 22:
				var maybeSaleId = status.a;
				var subModel = status.b;
				if (maybeSaleId.$ === 1) {
					return $elm$core$Maybe$Just(
						$author$project$Route$NewSale(
							$author$project$Page$Shop$Editor$getCurrentStep(subModel)));
				} else {
					var saleId = maybeSaleId.a;
					return $elm$core$Maybe$Just(
						A2(
							$author$project$Route$EditSale,
							saleId,
							$author$project$Page$Shop$Editor$getCurrentStep(subModel)));
				}
			case 23:
				var saleId = status.a;
				return $elm$core$Maybe$Just(
					$author$project$Route$ViewSale(saleId));
			case 24:
				var transferId = status.a;
				return $elm$core$Maybe$Just(
					$author$project$Route$ViewTransfer(transferId));
			case 25:
				var subModel = status.a;
				return $elm$core$Maybe$Just(
					$author$project$Route$Invite(subModel.jT));
			case 26:
				var subModel = status.a;
				return $elm$core$Maybe$Just(
					$author$project$Route$Join(subModel.j9));
			case 27:
				var subModel = status.a;
				return $elm$core$Maybe$Just(
					$author$project$Route$Transfer(subModel.nR));
			default:
				return $elm$core$Maybe$Just($author$project$Route$Analysis);
		}
	});
var $author$project$Log$Info = 3;
var $author$project$Log$InfoBreadcrumb = 3;
var $author$project$Log$addBreadcrumbPort = _Platform_outgoingPort('addBreadcrumbPort', $elm$core$Basics$identity);
var $author$project$Log$breadcrumbTypeToString = function (breadcrumbType) {
	switch (breadcrumbType) {
		case 0:
			return 'default';
		case 1:
			return 'debug';
		case 2:
			return 'error';
		case 3:
			return 'info';
		default:
			return 'query';
	}
};
var $elm$json$Json$Encode$dict = F3(
	function (toKey, toValue, dictionary) {
		return _Json_wrap(
			A3(
				$elm$core$Dict$foldl,
				F3(
					function (key, value, obj) {
						return A3(
							_Json_addField,
							toKey(key),
							toValue(value),
							obj);
					}),
				_Json_emptyObject(0),
				dictionary));
	});
var $author$project$Log$levelToString = function (level) {
	switch (level) {
		case 0:
			return 'fatal';
		case 1:
			return 'error';
		case 2:
			return 'warning';
		case 3:
			return 'info';
		default:
			return 'debug';
	}
};
var $author$project$Log$addBreadcrumb = F2(
	function (msgToString, breadcrumb) {
		return $author$project$Log$addBreadcrumbPort(
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string(
							$author$project$Log$breadcrumbTypeToString(breadcrumb.d0))),
						_Utils_Tuple2(
						'category',
						$elm$json$Json$Encode$string(
							A2(
								$elm$core$String$join,
								'.',
								msgToString(breadcrumb.fw)))),
						_Utils_Tuple2(
						'message',
						$elm$json$Json$Encode$string(breadcrumb.nS)),
						_Utils_Tuple2(
						'data',
						A3($elm$json$Json$Encode$dict, $elm$core$Basics$identity, $elm$core$Basics$identity, breadcrumb.i9)),
						_Utils_Tuple2(
						'level',
						$elm$json$Json$Encode$string(
							$author$project$Log$levelToString(breadcrumb.nH)))
					])));
	});
var $author$project$Ports$createAbsintheSocket = _Platform_outgoingPort('createAbsintheSocket', $elm$json$Json$Encode$string);
var $author$project$Api$Graphql$createAbsintheSocket = function (_v0) {
	var token = _v0;
	return $author$project$Ports$createAbsintheSocket(token);
};
var $author$project$Eos$Account$encodeName = function (_v0) {
	var name = _v0;
	return $elm$json$Json$Encode$string(name);
};
var $author$project$Session$LoggedIn$CompletedLoadProfile = function (a) {
	return {$: 3, a: a};
};
var $author$project$Session$LoggedIn$CompletedLoadCommunity = function (a) {
	return {$: 4, a: a};
};
var $author$project$Session$LoggedIn$RequestedNewAuthTokenPhrase = function (a) {
	return {$: 29, a: a};
};
var $author$project$Session$LoggedIn$RequestedQueryInternal = function (a) {
	return {$: 36, a: a};
};
var $author$project$Session$LoggedIn$internalGraphqlOperation = F4(
	function (operation, model, selectionSet, toMsg) {
		var operationCmd = function (authToken) {
			return A4(
				operation,
				model,
				$elm$core$Maybe$Just(authToken),
				selectionSet,
				$elm$core$Basics$identity);
		};
		var treatAuthError = function (operationResult) {
			switch (operationResult.$) {
				case 3:
					var success = operationResult.a;
					return $elm$core$Result$Ok(
						toMsg(
							$krisajenkins$remotedata$RemoteData$Success(success)));
				case 2:
					var err = operationResult.a;
					return $author$project$Api$Graphql$isAuthError(err) ? $elm$core$Result$Err(
						function (newAuthToken) {
							return A2(
								$elm$core$Platform$Cmd$map,
								toMsg,
								operationCmd(newAuthToken));
						}) : $elm$core$Result$Ok(
						toMsg(operationResult));
				default:
					return $elm$core$Result$Ok(
						toMsg(operationResult));
			}
		};
		var _v0 = model.iN;
		if (_v0.$ === 1) {
			return $author$project$Utils$spawnMessage(
				$author$project$Session$LoggedIn$RequestedNewAuthTokenPhrase(
					A2(
						$elm$core$Basics$composeR,
						operationCmd,
						$elm$core$Platform$Cmd$map(toMsg))));
		} else {
			var authToken = _v0.a;
			return A2(
				$elm$core$Platform$Cmd$map,
				A2($elm$core$Basics$composeR, treatAuthError, $author$project$Session$LoggedIn$RequestedQueryInternal),
				operationCmd(authToken));
		}
	});
var $author$project$Session$LoggedIn$internalQuery = F3(
	function (model, selectionSet, toMsg) {
		return A4($author$project$Session$LoggedIn$internalGraphqlOperation, $author$project$Api$Graphql$loggedInQuery, model, selectionSet, toMsg);
	});
var $elm_community$maybe_extra$Maybe$Extra$or = F2(
	function (ma, mb) {
		if (ma.$ === 1) {
			return mb;
		} else {
			return ma;
		}
	});
var $author$project$Community$Model = function (name) {
	return function (description) {
		return function (symbol) {
			return function (logo) {
				return function (subdomain) {
					return function (creator) {
						return function (inviterReward) {
							return function (invitedReward) {
								return function (minBalance) {
									return function (maxSupply) {
										return function (memberCount) {
											return function (actionCount) {
												return function (claimCount) {
													return function (transferCount) {
														return function (productCount) {
															return function (orderCount) {
																return function (members) {
																	return function (news) {
																		return function (highlightedNews) {
																			return function (objectives) {
																				return function (hasObjectives) {
																					return function (hasShop) {
																						return function (hasKyc) {
																							return function (hasAutoInvite) {
																								return function (hasNews) {
																									return function (hideValidatorNames) {
																										return function (validators) {
																											return function (uploads) {
																												return function (website) {
																													return function (contacts) {
																														return function (shopCategories) {
																															return {lO: actionCount, l5: claimCount, aq: contacts, mq: creator, bc: description, cj: hasAutoInvite, ck: hasKyc, df: hasNews, cl: hasObjectives, cm: hasShop, m6: hideValidatorNames, m8: highlightedNews, dl: invitedReward, dm: inviterReward, hC: logo, nQ: maxSupply, gc: memberCount, hG: members, nT: minBalance, ki: name, eO: news, cy: objectives, ov: orderCount, oQ: productCount, e1: shopCategories, pl: subdomain, e9: symbol, pF: transferCount, bs: uploads, pN: validators, cQ: website};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Cambiatus$Object$Community$actionCount = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'actionCount', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$Cambiatus$Object$Community$autoInvite = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'autoInvite', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Cambiatus$Object$Community$claimCount = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'claimCount', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$Cambiatus$Object$Community$contacts = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'contacts',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Cambiatus$Object$Community$creator = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'creator', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$Community$description = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'description', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$Community$hasNews = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'hasNews', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Cambiatus$Object$Community$hideValidatorNames = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'hideValidatorNames', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Cambiatus$Object$Community$highlightedNews = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'highlightedNews',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$Cambiatus$Object$Community$invitedReward = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Float', 'invitedReward', _List_Nil, $elm$json$Json$Decode$float);
var $author$project$Cambiatus$Object$Community$inviterReward = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Float', 'inviterReward', _List_Nil, $elm$json$Json$Decode$float);
var $author$project$Cambiatus$Object$Community$maxSupply = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe Float)',
	'maxSupply',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float));
var $author$project$Cambiatus$Object$Community$memberCount = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'memberCount', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$Cambiatus$Object$Community$members = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'members',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Cambiatus$Object$Community$minBalance = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe Float)',
	'minBalance',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float));
var $author$project$Cambiatus$Object$Community$orderCount = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'orderCount', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$Cambiatus$Object$Community$productCount = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'productCount', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$Community$News$Model = F9(
	function (description, id, title, receipt, reactions, scheduling, insertedAt, updatedAt, creator) {
		return {mq: creator, bc: description, R: id, f_: insertedAt, kP: reactions, h5: receipt, h9: scheduling, fb: title, pK: updatedAt};
	});
var $author$project$Cambiatus$Object$News$description = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'description', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$News$id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'id', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$Cambiatus$Object$News$insertedAt = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.NaiveDateTime',
	'insertedAt',
	_List_Nil,
	$author$project$Cambiatus$Scalar$unwrapCodecs($author$project$Cambiatus$ScalarCodecs$codecs).i2.jc);
var $author$project$Community$News$ReactionWithCount = F2(
	function (count, reaction) {
		return {mo: count, e_: reaction};
	});
var $author$project$Cambiatus$Object$ReactionType$count = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'count', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$Cambiatus$Enum$ReactionEnum$ClappingHands = 0;
var $author$project$Cambiatus$Enum$ReactionEnum$FaceWithRaisedEyebrow = 1;
var $author$project$Cambiatus$Enum$ReactionEnum$GrinningFaceWithBigEyes = 2;
var $author$project$Cambiatus$Enum$ReactionEnum$PartyPopper = 3;
var $author$project$Cambiatus$Enum$ReactionEnum$RedHeart = 4;
var $author$project$Cambiatus$Enum$ReactionEnum$Rocket = 5;
var $author$project$Cambiatus$Enum$ReactionEnum$SlightlyFrowningFace = 6;
var $author$project$Cambiatus$Enum$ReactionEnum$SmilingFaceWithHeartEyes = 7;
var $author$project$Cambiatus$Enum$ReactionEnum$ThumbsDown = 8;
var $author$project$Cambiatus$Enum$ReactionEnum$ThumbsUp = 9;
var $author$project$Cambiatus$Enum$ReactionEnum$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'CLAPPING_HANDS':
				return $elm$json$Json$Decode$succeed(0);
			case 'FACE_WITH_RAISED_EYEBROW':
				return $elm$json$Json$Decode$succeed(1);
			case 'GRINNING_FACE_WITH_BIG_EYES':
				return $elm$json$Json$Decode$succeed(2);
			case 'PARTY_POPPER':
				return $elm$json$Json$Decode$succeed(3);
			case 'RED_HEART':
				return $elm$json$Json$Decode$succeed(4);
			case 'ROCKET':
				return $elm$json$Json$Decode$succeed(5);
			case 'SLIGHTLY_FROWNING_FACE':
				return $elm$json$Json$Decode$succeed(6);
			case 'SMILING_FACE_WITH_HEART_EYES':
				return $elm$json$Json$Decode$succeed(7);
			case 'THUMBS_DOWN':
				return $elm$json$Json$Decode$succeed(8);
			case 'THUMBS_UP':
				return $elm$json$Json$Decode$succeed(9);
			default:
				return $elm$json$Json$Decode$fail('Invalid ReactionEnum type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$ReactionType$reaction = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.ReactionEnum.ReactionEnum', 'reaction', _List_Nil, $author$project$Cambiatus$Enum$ReactionEnum$decoder);
var $author$project$Community$News$reactionWithCountSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$ReactionType$reaction,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Cambiatus$Object$ReactionType$count,
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Community$News$ReactionWithCount)));
var $author$project$Cambiatus$Object$News$reactions = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'reactions',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Cambiatus$Object$News$receipt = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'receipt',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$Community$News$Receipt = function (reactions) {
	return {kP: reactions};
};
var $author$project$Cambiatus$Object$NewsReceipt$reactions = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(List Enum.ReactionEnum.ReactionEnum)',
	'reactions',
	_List_Nil,
	$elm$json$Json$Decode$list($author$project$Cambiatus$Enum$ReactionEnum$decoder));
var $author$project$Community$News$receiptSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$NewsReceipt$reactions,
	$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Community$News$Receipt));
var $author$project$Cambiatus$Object$News$scheduling = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe ScalarCodecs.DateTime)',
	'scheduling',
	_List_Nil,
	$elm$json$Json$Decode$nullable(
		$author$project$Cambiatus$Scalar$unwrapCodecs($author$project$Cambiatus$ScalarCodecs$codecs).ma.jc));
var $author$project$Community$News$timeFromNaiveDateTime = function (_v0) {
	var dateTime = _v0;
	return A2(
		$elm$core$Result$withDefault,
		$elm$time$Time$millisToPosix(0),
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(dateTime));
};
var $author$project$Cambiatus$Object$News$title = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'title', _List_Nil, $elm$json$Json$Decode$string);
var $elm$core$Result$toMaybe = function (result) {
	if (!result.$) {
		var v = result.a;
		return $elm$core$Maybe$Just(v);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Cambiatus$Object$News$updatedAt = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.NaiveDateTime',
	'updatedAt',
	_List_Nil,
	$author$project$Cambiatus$Scalar$unwrapCodecs($author$project$Cambiatus$ScalarCodecs$codecs).i2.jc);
var $author$project$Cambiatus$Object$News$user = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'user', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Community$News$selectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$News$user($author$project$Profile$minimalSelectionSet),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Community$News$timeFromNaiveDateTime, $author$project$Cambiatus$Object$News$updatedAt),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Community$News$timeFromNaiveDateTime, $author$project$Cambiatus$Object$News$insertedAt),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
					$elm$core$Maybe$andThen(
						function (_v0) {
							var dateTime = _v0;
							return $elm$core$Result$toMaybe(
								$rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(dateTime));
						}),
					$author$project$Cambiatus$Object$News$scheduling),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$Cambiatus$Object$News$reactions($author$project$Community$News$reactionWithCountSelectionSet),
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$Cambiatus$Object$News$receipt($author$project$Community$News$receiptSelectionSet),
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							$author$project$Cambiatus$Object$News$title,
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
								$author$project$Cambiatus$Object$News$id,
								A2(
									$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
									$author$project$Markdown$selectionSet($author$project$Cambiatus$Object$News$description),
									$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Community$News$Model))))))))));
var $author$project$Contact$Valid = $elm$core$Basics$identity;
var $elm$core$Maybe$map2 = F3(
	function (func, ma, mb) {
		if (ma.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				return $elm$core$Maybe$Just(
					A2(func, a, b));
			}
		}
	});
var $author$project$Contact$selectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$Contact$label,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Cambiatus$Object$Contact$externalId,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Cambiatus$Object$Contact$type_,
			$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(
				F3(
					function (maybeType_, maybeExternalId, label) {
						return A3(
							$elm$core$Maybe$map2,
							F2(
								function (type_, externalId) {
									return {nC: label, d0: type_, pO: externalId};
								}),
							maybeType_,
							maybeExternalId);
					})))));
var $author$project$Cambiatus$Object$Community$transferCount = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'transferCount', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$Cambiatus$Object$Community$validators = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'validators',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Cambiatus$Object$Community$website = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'website',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Community$communitySelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
	$krisajenkins$remotedata$RemoteData$NotAsked,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
			$elm$core$List$filterMap($elm$core$Basics$identity),
			$author$project$Cambiatus$Object$Community$contacts($author$project$Contact$selectionSet)),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Cambiatus$Object$Community$website,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
				$krisajenkins$remotedata$RemoteData$NotAsked,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$Cambiatus$Object$Community$validators(
						$author$project$Eos$Account$nameSelectionSet($author$project$Cambiatus$Object$User$account)),
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$Cambiatus$Object$Community$hideValidatorNames,
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							$author$project$Cambiatus$Object$Community$hasNews,
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
								$author$project$Cambiatus$Object$Community$autoInvite,
								A2(
									$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
									$author$project$Cambiatus$Object$Community$hasKyc,
									A2(
										$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
										$author$project$Cambiatus$Object$Community$hasShop,
										A2(
											$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
											$author$project$Cambiatus$Object$Community$hasObjectives,
											A2(
												$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
												$krisajenkins$remotedata$RemoteData$NotAsked,
												A2(
													$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
													$author$project$Cambiatus$Object$Community$highlightedNews($author$project$Community$News$selectionSet),
													A2(
														$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
														$krisajenkins$remotedata$RemoteData$NotAsked,
														A2(
															$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
															$author$project$Cambiatus$Object$Community$members($author$project$Profile$minimalSelectionSet),
															A2(
																$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																$author$project$Cambiatus$Object$Community$orderCount,
																A2(
																	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																	$author$project$Cambiatus$Object$Community$productCount,
																	A2(
																		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																		$author$project$Cambiatus$Object$Community$transferCount,
																		A2(
																			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																			$author$project$Cambiatus$Object$Community$claimCount,
																			A2(
																				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																				$author$project$Cambiatus$Object$Community$actionCount,
																				A2(
																					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																					$author$project$Cambiatus$Object$Community$memberCount,
																					A2(
																						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																						$author$project$Cambiatus$Object$Community$maxSupply,
																						A2(
																							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																							$author$project$Cambiatus$Object$Community$minBalance,
																							A2(
																								$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																								$author$project$Cambiatus$Object$Community$invitedReward,
																								A2(
																									$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																									$author$project$Cambiatus$Object$Community$inviterReward,
																									A2(
																										$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																										$author$project$Eos$Account$nameSelectionSet($author$project$Cambiatus$Object$Community$creator),
																										A2(
																											$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																											A2(
																												$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
																												$elm$core$Maybe$withDefault(''),
																												$author$project$Cambiatus$Object$Community$subdomain($author$project$Cambiatus$Object$Subdomain$name)),
																											A2(
																												$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																												A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, $author$project$Constants$defaultCommunityLogo, $author$project$Cambiatus$Object$Community$logo),
																												A2(
																													$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																													$author$project$Eos$symbolSelectionSet($author$project$Cambiatus$Object$Community$symbol),
																													A2(
																														$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																														$author$project$Markdown$selectionSet($author$project$Cambiatus$Object$Community$description),
																														A2(
																															$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																															$author$project$Cambiatus$Object$Community$name,
																															$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Community$Model))))))))))))))))))))))))))))))));
var $author$project$Community$subdomainQuery = function (subdomain) {
	return A2(
		$author$project$Cambiatus$Query$community,
		function (optionals) {
			return _Utils_update(
				optionals,
				{
					pl: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(subdomain)
				});
		},
		$author$project$Community$communitySelectionSet);
};
var $author$project$Community$symbolQuery = function (symbol) {
	return A2(
		$author$project$Cambiatus$Query$community,
		function (optionals) {
			return _Utils_update(
				optionals,
				{
					e9: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
						$author$project$Eos$symbolToString(symbol))
				});
		},
		$author$project$Community$communitySelectionSet);
};
var $author$project$Session$LoggedIn$fetchCommunity = F2(
	function (model, maybeSymbol) {
		if (model.aM.pL) {
			return A3(
				$author$project$Session$LoggedIn$internalQuery,
				model,
				$author$project$Community$subdomainQuery(
					$author$project$Environment$communityDomain(model.aM.gL)),
				$author$project$Session$LoggedIn$CompletedLoadCommunity);
		} else {
			var symbol = A2(
				$elm$core$Maybe$withDefault,
				$author$project$Eos$cambiatusSymbol,
				A2($elm_community$maybe_extra$Maybe$Extra$or, maybeSymbol, model.aM.o7));
			return A3(
				$author$project$Session$LoggedIn$internalQuery,
				model,
				$author$project$Community$symbolQuery(symbol),
				$author$project$Session$LoggedIn$CompletedLoadCommunity);
		}
	});
var $author$project$Session$LoggedIn$CodeOfConductNotShown = {$: 0};
var $author$project$Session$LoggedIn$GotAuthMsg = function (a) {
	return {$: 15, a: a};
};
var $author$project$Auth$WithPrivateKey = function (a) {
	return {$: 1, a: a};
};
var $author$project$Auth$WithoutPrivateKey = {$: 0};
var $author$project$Auth$GotPinMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$View$Pin$withDisabled = F2(
	function (disabled, model) {
		return _Utils_update(
			model,
			{cf: disabled});
	});
var $author$project$Auth$initPinModel = F3(
	function (lastKnownPin, pinVisibility, status) {
		var _v0 = $author$project$View$Pin$init(
			{R: 'pinPopup', nC: 'auth.pinPopup.label', nF: lastKnownPin, oF: pinVisibility, pm: 'auth.login.continue', po: 'auth.login.continue', pU: false});
		var pinModel = _v0.a;
		var pinCmd = _v0.b;
		return _Utils_Tuple2(
			A2(
				$author$project$View$Pin$withDisabled,
				function () {
					if (!status.$) {
						return false;
					} else {
						return true;
					}
				}(),
				pinModel),
			A2($elm$core$Platform$Cmd$map, $author$project$Auth$GotPinMsg, pinCmd));
	});
var $author$project$Auth$init = F3(
	function (lastKnownPin, pinVisibility, maybePrivateKey_) {
		var status = function () {
			if (maybePrivateKey_.$ === 1) {
				return $author$project$Auth$WithoutPrivateKey;
			} else {
				var privateKey = maybePrivateKey_.a;
				return $author$project$Auth$WithPrivateKey(privateKey);
			}
		}();
		var _v0 = A3($author$project$Auth$initPinModel, lastKnownPin, pinVisibility, status);
		var pinModel = _v0.a;
		var pinCmd = _v0.b;
		return _Utils_Tuple2(
			{mM: $elm$core$Maybe$Nothing, ag: pinModel, gE: status},
			pinCmd);
	});
var $author$project$Notification$init = {jC: false, kQ: _List_Nil, lz: _List_Nil};
var $author$project$Search$Inactive = {$: 0};
var $Gizra$elm_debouncer$Debouncer$Internal$Config = $elm$core$Basics$identity;
var $Gizra$elm_debouncer$Debouncer$Internal$lastInput = F2(
	function (i, o) {
		return $elm$core$Maybe$Just(i);
	});
var $Gizra$elm_debouncer$Debouncer$Internal$manual = {b1: $Gizra$elm_debouncer$Debouncer$Internal$lastInput, aV: $elm$core$Maybe$Nothing, aW: $elm$core$Maybe$Nothing, a7: $elm$core$Maybe$Nothing};
var $Gizra$elm_debouncer$Debouncer$Basic$manual = $Gizra$elm_debouncer$Debouncer$Internal$manual;
var $Gizra$elm_debouncer$Debouncer$Internal$settleWhenQuietFor = F2(
	function (time, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{a7: time});
	});
var $Gizra$elm_debouncer$Debouncer$Basic$settleWhenQuietFor = $Gizra$elm_debouncer$Debouncer$Internal$settleWhenQuietFor;
var $Gizra$elm_debouncer$Debouncer$Basic$debounce = function (interval) {
	return A2(
		$Gizra$elm_debouncer$Debouncer$Basic$settleWhenQuietFor,
		$elm$core$Maybe$Just(interval),
		$Gizra$elm_debouncer$Debouncer$Basic$manual);
};
var $Gizra$elm_debouncer$Debouncer$Internal$fromSeconds = function (s) {
	return $elm$core$Basics$round(s * 1000);
};
var $Gizra$elm_debouncer$Debouncer$Basic$fromSeconds = $Gizra$elm_debouncer$Debouncer$Internal$fromSeconds;
var $Gizra$elm_debouncer$Debouncer$Internal$Debouncer = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $Gizra$elm_debouncer$Debouncer$Internal$Settled = {$: 0};
var $Gizra$elm_debouncer$Debouncer$Internal$nothingIfNegative = $elm$core$Maybe$andThen(
	function (num) {
		return (num < 0) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(num);
	});
var $Gizra$elm_debouncer$Debouncer$Internal$sanitizeConfig = function (_v0) {
	var config = _v0;
	return {
		b1: config.b1,
		aV: $Gizra$elm_debouncer$Debouncer$Internal$nothingIfNegative(config.aV),
		aW: $Gizra$elm_debouncer$Debouncer$Internal$nothingIfNegative(config.aW),
		a7: $Gizra$elm_debouncer$Debouncer$Internal$nothingIfNegative(config.a7)
	};
};
var $Gizra$elm_debouncer$Debouncer$Internal$toDebouncer = function (config) {
	return A2(
		$Gizra$elm_debouncer$Debouncer$Internal$Debouncer,
		$Gizra$elm_debouncer$Debouncer$Internal$sanitizeConfig(config),
		$Gizra$elm_debouncer$Debouncer$Internal$Settled);
};
var $Gizra$elm_debouncer$Debouncer$Basic$toDebouncer = $Gizra$elm_debouncer$Debouncer$Internal$toDebouncer;
var $author$project$Search$init = {
	fJ: $Gizra$elm_debouncer$Debouncer$Basic$toDebouncer(
		$Gizra$elm_debouncer$Debouncer$Basic$debounce(
			$Gizra$elm_debouncer$Debouncer$Basic$fromSeconds(0.3))),
	hk: $author$project$Form$init(
		{dO: ''}),
	bP: _List_Nil,
	X: $author$project$Search$Inactive
};
var $elm_community$maybe_extra$Maybe$Extra$isNothing = function (m) {
	if (m.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Session$LoggedIn$initModel = F5(
	function (shared, lastKnownPin, maybePrivateKey_, accountName, authToken) {
		var _v0 = A3($author$project$Auth$init, lastKnownPin, shared.oF, maybePrivateKey_);
		var authModel = _v0.a;
		var authCmd = _v0.b;
		return _Utils_Tuple2(
			{
				lM: accountName,
				fp: authModel,
				iN: authToken,
				T: $author$project$Session$LoggedIn$CodeOfConductNotShown,
				hf: $author$project$View$Feedback$Hidden,
				mZ: true,
				fV: false,
				bJ: false,
				j7: $elm$core$Maybe$Nothing,
				gf: $elm_community$maybe_extra$Maybe$Extra$isNothing(authToken),
				ko: $author$project$Notification$init,
				kJ: $krisajenkins$remotedata$RemoteData$Loading,
				bO: _List_Nil,
				gs: _List_Nil,
				ah: $author$project$Search$init,
				o7: $krisajenkins$remotedata$RemoteData$Loading,
				aM: shared,
				dV: false,
				bR: false,
				bS: false,
				bo: false,
				e4: false,
				e5: false,
				e6: false,
				aB: false,
				d1: 0,
				iA: 60 * 1000
			},
			A2($elm$core$Platform$Cmd$map, $author$project$Session$LoggedIn$GotAuthMsg, authCmd));
	});
var $author$project$Session$LoggedIn$initLogin = F5(
	function (shared, pin, maybePrivateKey_, profile_, authToken) {
		var loadedProfile = A2(
			$elm$core$Task$perform,
			$author$project$Session$LoggedIn$CompletedLoadProfile,
			$elm$core$Task$succeed(
				$krisajenkins$remotedata$RemoteData$Success(
					$elm$core$Maybe$Just(profile_))));
		var _v0 = A5(
			$author$project$Session$LoggedIn$initModel,
			shared,
			$elm$core$Maybe$Just(pin),
			maybePrivateKey_,
			profile_.fl,
			$elm$core$Maybe$Just(authToken));
		var model = _v0.a;
		var cmd = _v0.b;
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						loadedProfile,
						A2($author$project$Session$LoggedIn$fetchCommunity, model, $elm$core$Maybe$Nothing),
						A2($elm$core$Task$perform, $author$project$Session$LoggedIn$GotTimeInternal, $elm$time$Time$now),
						cmd,
						$author$project$Api$Graphql$createAbsintheSocket(authToken)
					])));
	});
var $author$project$Ports$javascriptOutPort = _Platform_outgoingPort('javascriptOutPort', $elm$core$Basics$identity);
var $elm$json$Json$Encode$list = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				$elm$core$List$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(0),
				entries));
	});
var $author$project$Ports$javascriptOutCmd = F2(
	function (toJsAddress, _v0) {
		var js = _v0;
		return $author$project$Ports$javascriptOutPort(
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'responseAddress',
						A2(
							$elm$json$Json$Encode$list,
							$elm$json$Json$Encode$string,
							toJsAddress(js.kY))),
						_Utils_Tuple2('responseData', js.kZ),
						_Utils_Tuple2('data', js.i9)
					])));
	});
var $author$project$UpdateResult$remoteDataToString = function (r) {
	switch (r.$) {
		case 0:
			return 'NotAsked';
		case 1:
			return 'Loading';
		case 3:
			return 'Success';
		default:
			return 'Failure';
	}
};
var $author$project$UpdateResult$resultToString = function (r) {
	if (!r.$) {
		return 'Ok';
	} else {
		return 'Err';
	}
};
var $author$project$Session$Guest$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			var r = msg.b;
			return _List_fromArray(
				[
					'CompletedLoadTranslation',
					$author$project$UpdateResult$resultToString(r)
				]);
		case 1:
			return _List_fromArray(
				['ClickedTryAgainTranslation']);
		case 2:
			return _List_fromArray(
				['ShowLanguageNav']);
		case 3:
			return _List_fromArray(
				['ClickedLanguage']);
		case 4:
			return _List_fromArray(
				['PressedEsc']);
		case 5:
			var r = msg.a;
			return _List_fromArray(
				[
					'CompletedLoadCommunityPreview',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
		default:
			return _List_fromArray(
				['GotFeedbackMsg']);
	}
};
var $author$project$Action$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['NoOp']);
		case 1:
			return _List_fromArray(
				['ClickedShareAction']);
		default:
			return _List_fromArray(
				['CopiedShareLinkToClipboard']);
	}
};
var $author$project$Form$DatePicker$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['NoOp']);
		case 1:
			return _List_fromArray(
				['GotDatePickerMsg']);
		case 2:
			return _List_fromArray(
				['ClickedCalendarIcon']);
		case 3:
			return _List_fromArray(
				['ClickedClear']);
		default:
			return _List_fromArray(
				['ClickedKey']);
	}
};
var $author$project$View$ImageCropper$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['ImageLoaded']);
		case 1:
			var r = msg.a;
			return _List_fromArray(
				[
					'GotImageDimmensions',
					$author$project$UpdateResult$resultToString(r)
				]);
		case 2:
			return _List_fromArray(
				['StartedDragging']);
		case 4:
			return _List_fromArray(
				['Dragged']);
		case 3:
			return _List_fromArray(
				['StoppedDragging']);
		case 5:
			return _List_fromArray(
				['ChangedDimmensions']);
		case 6:
			return _List_fromArray(
				['CompletedChangingDimmensions']);
		case 7:
			return _List_fromArray(
				['ClickedZoomOperation']);
		default:
			return _List_fromArray(
				['GotCroppedImage']);
	}
};
var $author$project$Form$File$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['RequestedUploadFiles']);
		case 1:
			return _List_fromArray(
				['RequestedReplaceFile']);
		case 2:
			return _List_fromArray(
				['CompletedUploadingFile']);
		case 3:
			return _List_fromArray(
				['ClickedEntry']);
		case 4:
			return _List_fromArray(
				['ClickedCloseEntryModal']);
		case 5:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotImageCropperMsg',
				$author$project$View$ImageCropper$msgToString(subMsg));
		case 6:
			return _List_fromArray(
				['DiscoveredFileType']);
		case 7:
			return _List_fromArray(
				['ClickedDeleteEntry']);
		default:
			return _List_fromArray(
				['ClickedSaveEntry']);
	}
};
var $author$project$Form$RichText$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['NoOp']);
		case 1:
			return _List_fromArray(
				['ClickedIncludeLink']);
		case 2:
			return _List_fromArray(
				['ClosedLinkModal']);
		case 3:
			return _List_fromArray(
				['EnteredLinkLabel']);
		case 4:
			return _List_fromArray(
				['EnteredLinkUrl']);
		case 5:
			return _List_fromArray(
				['ClickedAcceptLink']);
		case 6:
			return _List_fromArray(
				['ChangedText']);
		default:
			return _List_fromArray(
				['ComponentLoaded']);
	}
};
var $author$project$Profile$Summary$msgToString = function (msg) {
	switch (msg) {
		case 0:
			return _List_fromArray(
				['Ignored']);
		case 1:
			return _List_fromArray(
				['OpenedInfo']);
		default:
			return _List_fromArray(
				['ClosedInfo']);
	}
};
var $author$project$Form$UserPicker$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['NoOp']);
		case 1:
			return _List_fromArray(
				['GotSelectMsg']);
		case 2:
			return _List_fromArray(
				['SelectedUser']);
		case 3:
			var subMsg = msg.b;
			return A2(
				$elm$core$List$cons,
				'GotProfileSummaryMsg',
				$author$project$Profile$Summary$msgToString(subMsg));
		case 4:
			return _List_fromArray(
				['ClickedRemoveProfile']);
		default:
			return _List_fromArray(
				['BlurredPicker']);
	}
};
var $author$project$Form$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['NoOp']);
		case 2:
			var subMsg = msg.c;
			return A2(
				$elm$core$List$cons,
				'GotRichTextMsg',
				$author$project$Form$RichText$msgToString(subMsg));
		case 3:
			var subMsg = msg.d;
			return A2(
				$elm$core$List$cons,
				'GotFileMsg',
				$author$project$Form$File$msgToString(subMsg));
		case 4:
			var subMsg = msg.e;
			return A2(
				$elm$core$List$cons,
				'GotDatePickerMsg',
				$author$project$Form$DatePicker$msgToString(subMsg));
		case 5:
			var subMsg = msg.e;
			return A2(
				$elm$core$List$cons,
				'GotUserPickerMsg',
				$author$project$Form$UserPicker$msgToString(subMsg));
		case 1:
			return _List_fromArray(
				['ChangedValues']);
		case 6:
			return _List_fromArray(
				['BlurredField']);
		default:
			return _List_fromArray(
				['ClickedSubmitWithErrors']);
	}
};
var $author$project$View$Pin$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['Ignored']);
		case 1:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotFormMsg',
				$author$project$Form$msgToString(subMsg));
		case 2:
			return _List_fromArray(
				['SubmittedForm']);
		default:
			return _List_fromArray(
				['ToggledPinVisibility']);
	}
};
var $author$project$Auth$msgToString = function (msg) {
	switch (msg.$) {
		case 1:
			return _List_fromArray(
				['SubmittedPin']);
		case 2:
			var r = msg.a;
			return _List_fromArray(
				[
					'GotPrivateKey',
					$author$project$UpdateResult$resultToString(r)
				]);
		default:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotPinMsg',
				$author$project$View$Pin$msgToString(subMsg));
	}
};
var $author$project$Session$LoggedIn$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['NoOp']);
		case 25:
			return _List_fromArray(
				['GotTimeInternal']);
		case 23:
			return _List_fromArray(
				['ClickedNavLink']);
		case 24:
			return _List_fromArray(
				['ClosedSearch']);
		case 21:
			return _List_fromArray(
				['GotSearchMsg']);
		case 22:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotActionMsg',
				$author$project$Action$msgToString(subMsg));
		case 1:
			var r = msg.b;
			return _List_fromArray(
				[
					'CompletedLoadTranslation',
					$author$project$UpdateResult$resultToString(r)
				]);
		case 2:
			return _List_fromArray(
				['ClickedTryAgainTranslation']);
		case 3:
			var r = msg.a;
			return _List_fromArray(
				[
					'CompletedLoadProfile',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
		case 4:
			var r = msg.a;
			return _List_fromArray(
				[
					'CompletedLoadCommunity',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
		case 5:
			return _List_fromArray(
				['CompletedLoadCommunityField']);
		case 6:
			return _List_fromArray(
				['CompletedLoadCommunityFields']);
		case 7:
			return _List_fromArray(
				['ClickedTryAgainProfile']);
		case 8:
			return _List_fromArray(
				['ClickedLogout']);
		case 9:
			return _List_fromArray(
				['ShowUserNav']);
		case 10:
			return _List_fromArray(
				['ToggleLanguageItems']);
		case 11:
			return _List_fromArray(
				['ClickedLanguage']);
		case 12:
			var r = msg.a;
			return _List_fromArray(
				[
					'CompletedSendingLanguagePreference',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
		case 13:
			return _List_fromArray(
				['ClosedAuthModal']);
		case 14:
			return _List_fromArray(
				['ClosedInsufficientPermissionsModal']);
		case 15:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotAuthMsg',
				$author$project$Auth$msgToString(subMsg));
		case 16:
			return _List_fromArray(
				['CompletedLoadUnread']);
		case 17:
			return _List_fromArray(
				['OpenCommunitySelector']);
		case 18:
			return _List_fromArray(
				['CloseCommunitySelector']);
		case 19:
			return _List_fromArray(
				['SelectedCommunity']);
		case 20:
			return _List_fromArray(
				['GotFeedbackMsg']);
		case 27:
			return _List_fromArray(
				['ClosedHighlightedNews']);
		case 26:
			return _List_fromArray(
				['ClickedReadHighlightedNews']);
		case 28:
			return _List_fromArray(
				['ReceivedNewHighlightedNews']);
		case 29:
			return _List_fromArray(
				['RequestedNewAuthTokenPhrase']);
		case 30:
			return _List_fromArray(
				['RequestedNewAuthTokenPhraseExternal']);
		case 31:
			var r = msg.b;
			return _List_fromArray(
				[
					'GotAuthTokenPhrase',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
		case 32:
			var r = msg.b;
			return _List_fromArray(
				[
					'GotAuthTokenPhraseExternal',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
		case 33:
			return _List_fromArray(
				['SignedAuthTokenPhrase']);
		case 34:
			var r = msg.a;
			return _List_fromArray(
				[
					'CompletedGeneratingAuthToken',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
		case 35:
			var r = msg.a;
			return _List_fromArray(
				[
					'RequestedQuery',
					$author$project$UpdateResult$resultToString(r)
				]);
		case 36:
			var r = msg.a;
			return _List_fromArray(
				[
					'RequestedQueryInternal',
					$author$project$UpdateResult$resultToString(r)
				]);
		case 37:
			return _List_fromArray(
				['ClickedAcceptCodeOfConduct']);
		case 38:
			return _List_fromArray(
				['ClickedDenyCodeOfConduct']);
		case 39:
			var r = msg.a;
			return _List_fromArray(
				[
					'CompletedAcceptingCodeOfConduct',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
		case 40:
			return _List_fromArray(
				['EndedCodeOfConductWarningAnimation']);
		case 41:
			return _List_fromArray(
				['ClickedOpenCommunityContactsModal']);
		default:
			return _List_fromArray(
				['ClosedCommunityContactsModal']);
	}
};
var $author$project$Page$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['Ignored']);
		case 1:
			var r = msg.b;
			return _List_fromArray(
				[
					'CompletedLoadTranslation',
					$author$project$UpdateResult$resultToString(r)
				]);
		case 2:
			var r = msg.a;
			return _List_fromArray(
				[
					'GotTimezone',
					$author$project$UpdateResult$resultToString(r)
				]);
		case 3:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotGuestMsg',
				$author$project$Session$Guest$msgToString(subMsg));
		default:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotLoggedInMsg',
				$author$project$Session$LoggedIn$msgToString(subMsg));
	}
};
var $author$project$Page$Community$About$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['NoOp']);
		case 1:
			return _List_fromArray(
				['CompletedLoadCommunity']);
		case 2:
			var r = msg.a;
			return _List_fromArray(
				[
					'GotTokenInfo',
					$author$project$UpdateResult$resultToString(r)
				]);
		case 3:
			return _List_fromArray(
				['ClickedShareCommunity']);
		default:
			return _List_fromArray(
				['CopiedShareLinkToClipboard']);
	}
};
var $author$project$Page$Community$Invite$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			var r = msg.a;
			return _List_fromArray(
				[
					'CompletedLoadInvite',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
		case 1:
			return _List_fromArray(
				['CompletedLoadProfile']);
		case 2:
			return _List_fromArray(
				['OpenConfirmationModal']);
		case 3:
			return _List_fromArray(
				['CloseConfirmationModal']);
		case 4:
			return _List_fromArray(
				['InvitationRejected']);
		case 5:
			return _List_fromArray(
				['InvitationAccepted']);
		case 7:
			return _List_fromArray(
				['FormMsg']);
		default:
			return _List_fromArray(
				['SignedIn']);
	}
};
var $author$project$Page$Community$New$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotFormMsg',
				$author$project$Form$msgToString(subMsg));
		case 1:
			return _List_fromArray(
				['SelectedEntry']);
		case 2:
			return _List_fromArray(
				['SubmittedForm']);
		case 3:
			var r = msg.b;
			return _List_fromArray(
				[
					'GotDomainAvailableResponse',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
		case 4:
			return _List_fromArray(
				['StartedCreatingCommunity']);
		case 5:
			return _List_fromArray(
				['GotCreateCommunityResponse']);
		case 6:
			return _List_fromArray(
				['Redirect']);
		default:
			return _List_fromArray(
				['ClosedAuthModal']);
	}
};
var $author$project$Page$Community$Objectives$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['NoOp']);
		case 1:
			return _List_fromArray(
				['CompletedLoadObjectives']);
		case 2:
			return _List_fromArray(
				['ClickedToggleObjectiveVisibility']);
		case 3:
			return _List_fromArray(
				['FinishedOpeningActions']);
		case 4:
			return _List_fromArray(
				['FinishedClosingObjective']);
		case 5:
			return _List_fromArray(
				['GotObjectiveDetailsHeight']);
		case 6:
			return _List_fromArray(
				['GotObjectiveSummaryHeight']);
		case 7:
			return _List_fromArray(
				['GotVisibleActionViewport']);
		case 8:
			return _List_fromArray(
				['ClickedScrollToAction']);
		case 9:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotActionMsg',
				$author$project$Action$msgToString(subMsg));
		case 10:
			return _List_fromArray(
				['StartedIntersecting']);
		default:
			return _List_fromArray(
				['StoppedIntersecting']);
	}
};
var $author$project$Page$Community$Transfer$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['CompletedLoadCommunity']);
		case 1:
			var r = msg.a;
			return _List_fromArray(
				[
					'CompletedLoadBalance',
					$author$project$UpdateResult$resultToString(r)
				]);
		case 2:
			var r = msg.a;
			return _List_fromArray(
				[
					'CompletedLoadToken',
					$author$project$UpdateResult$resultToString(r)
				]);
		case 3:
			return _List_fromArray(
				['ClosedAuthModal']);
		case 4:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotFormMsg',
				$author$project$Form$msgToString(subMsg));
		case 5:
			return _List_fromArray(
				['SubmittedForm']);
		case 6:
			return _List_fromArray(
				['CreatedTransferSubscription']);
		case 7:
			var r = msg.a;
			return _List_fromArray(
				[
					'GotTransferTransactionResult',
					$author$project$UpdateResult$resultToString(r)
				]);
		default:
			return _List_fromArray(
				['GotTransferResultFromWebSocket']);
	}
};
var $author$project$Page$Dashboard$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['NoOp']);
		case 1:
			return _List_fromArray(
				['CompletedLoadCommunity']);
		case 20:
			var r = msg.a;
			return _List_fromArray(
				[
					'CompletedLoadPlaceRelease',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
		case 21:
			return _List_fromArray(
				['GotBrowserLocation']);
		case 22:
			var r = msg.a;
			return _List_fromArray(
				[
					'CompletedLocatePlace',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
		case 23:
			var r = msg.a;
			return _List_fromArray(
				[
					'CompletedLoadPlaceStatus',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
		case 24:
			return _List_fromArray(
				['ClickedDismissAddressNote']);
		case 2:
			var result = msg.a;
			return _List_fromArray(
				[
					'CompletedLoadBalance',
					$author$project$UpdateResult$resultToString(result)
				]);
		case 3:
			var result = msg.a;
			return _List_fromArray(
				[
					'CompletedLoadUserTransfers',
					$author$project$UpdateResult$remoteDataToString(result)
				]);
		case 4:
			var result = msg.a;
			return _List_fromArray(
				[
					'ClaimsLoaded',
					$author$project$UpdateResult$remoteDataToString(result)
				]);
		case 5:
			return _List_fromArray(
				['GotTransferCardProfileSummaryMsg']);
		case 6:
			return _List_fromArray(
				['RequestedMoreTransfers']);
		case 7:
			return _List_fromArray(
				['ClickedOpenTransferFilters']);
		case 8:
			return _List_fromArray(
				['ClosedTransfersFilters']);
		case 9:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotTransfersFiltersFormMsg',
				$author$project$Form$msgToString(subMsg));
		case 10:
			return _List_fromArray(
				['SubmittedTransfersFiltersForm']);
		case 11:
			return _List_fromArray(
				['ClickedTransferCard']);
		case 12:
			return _List_fromArray(
				['CreateInvite']);
		case 13:
			return _List_fromArray(
				['GotContactMsg']);
		case 14:
			return _List_fromArray(
				['ClosedAddContactModal']);
		case 15:
			return _List_fromArray(
				['CloseInviteModal']);
		case 16:
			return _List_fromArray(
				['CompletedInviteCreation']);
		case 17:
			return _List_fromArray(
				['CopyToClipboard']);
		case 18:
			return _List_fromArray(
				['CopiedToClipboard']);
		default:
			return _List_fromArray(
				['ClickedAcceptCodeOfConduct']);
	}
};
var $author$project$Page$Dashboard$Analysis$msgToString = function (msg) {
	return $elm$core$Basics$never(msg);
};
var $author$project$Page$Dashboard$Claim$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			var r = msg.a;
			return _List_fromArray(
				[
					'ClaimLoaded',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
		case 1:
			return _List_fromArray(
				['ClaimMsg']);
		default:
			var subMsg = msg.b;
			return A2(
				$elm$core$List$cons,
				'GotProfileSummaryMsg',
				$author$project$Profile$Summary$msgToString(subMsg));
	}
};
var $author$project$Page$Join$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['ClickedJoinCommunity']);
		case 1:
			return _List_fromArray(
				['CompletedLoadCommunity']);
		default:
			return _List_fromArray(
				['SignedIn']);
	}
};
var $author$project$Page$Login$passphraseMsgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['PassphraseIgnored']);
		case 1:
			return _List_fromArray(
				['ClickedPaste']);
		case 2:
			return _List_fromArray(
				['GotClipboardResponse']);
		case 3:
			return _List_fromArray(
				['ScrolledTextArea']);
		case 4:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotPassphraseFormMsg',
				$author$project$Form$msgToString(subMsg));
		default:
			return _List_fromArray(
				['ClickedNextStep']);
	}
};
var $author$project$Page$Login$pinMsgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['PinIgnored']);
		case 1:
			return _List_fromArray(
				['SubmittedPinWithSuccess']);
		case 2:
			var r = msg.a;
			return _List_fromArray(
				[
					'GotAccountName',
					$author$project$UpdateResult$resultToString(r)
				]);
		case 3:
			return _List_fromArray(
				['GeneratedAuthPhrase']);
		case 4:
			return _List_fromArray(
				['SignedAuthPhrase']);
		case 5:
			var r = msg.c;
			return _List_fromArray(
				[
					'GotSignInResult',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
		default:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotPinComponentMsg',
				$author$project$View$Pin$msgToString(subMsg));
	}
};
var $author$project$Page$Login$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['WentToPin']);
		case 1:
			var passphraseMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotPassphraseMsg',
				$author$project$Page$Login$passphraseMsgToString(passphraseMsg));
		case 2:
			var pinMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotPinMsg',
				$author$project$Page$Login$pinMsgToString(pinMsg));
		default:
			return _List_fromArray(
				['GotBip39']);
	}
};
var $author$project$Page$News$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['NoOp']);
		case 1:
			return _List_fromArray(
				['CompletedLoadNews']);
		case 2:
			var r = msg.a;
			return _List_fromArray(
				[
					'CompletedMarkingNewsAsRead',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
		case 3:
			return _List_fromArray(
				['ClickedToggleReactions']);
		case 4:
			return _List_fromArray(
				['ToggledReaction']);
		case 5:
			return _List_fromArray(
				['CompletedTogglingReaction']);
		default:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotLastEditorSummaryMsg',
				$author$project$Profile$Summary$msgToString(subMsg));
	}
};
var $author$project$Page$Notification$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			var r = msg.a;
			return _List_fromArray(
				[
					'CompletedLoadNotificationHistory',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
		case 1:
			return _List_fromArray(
				['MarkAsRead']);
		default:
			var r = msg.a;
			return _List_fromArray(
				[
					'CompletedReading',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
	}
};
var $author$project$Page$PaymentHistory$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['NoOp']);
		case 1:
			return _List_fromArray(
				['CompletedLoadCommunity']);
		case 6:
			return _List_fromArray(
				['ShowMore']);
		case 2:
			var r = msg.a;
			return _List_fromArray(
				[
					'RecipientProfileWithTransfersLoaded',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
		case 3:
			var r = msg.a;
			return _List_fromArray(
				[
					'AutocompleteProfilesLoaded',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
		case 4:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotUserPickerMsg',
				$author$project$Form$UserPicker$msgToString(subMsg));
		default:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotDatePickerMsg',
				$author$project$Form$DatePicker$msgToString(subMsg));
	}
};
var $author$project$Page$Profile$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			var r = msg.a;
			return _List_fromArray(
				[
					'CompletedLoadProfile',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
		case 1:
			return _List_fromArray(
				['CompletedLoadCommunity']);
		case 2:
			var r = msg.a;
			return _List_fromArray(
				[
					'CompletedLoadBalance',
					$author$project$UpdateResult$resultToString(r)
				]);
		case 3:
			var r = msg.a;
			return _List_fromArray(
				[
					'CompletedLoadGraphqlInfo',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
		case 4:
			var r = msg.a;
			return _List_fromArray(
				[
					'CompletedLoadUserTransfers',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
		case 5:
			var subMsg = msg.b;
			return A2(
				$elm$core$List$cons,
				'GotTransferCardProfileSummaryMsg',
				$author$project$Profile$Summary$msgToString(subMsg));
		case 6:
			return _List_fromArray(
				['ClickedTransferCard']);
		default:
			return _List_fromArray(
				['RequestedMoreTransfers']);
	}
};
var $author$project$Page$Profile$AddContact$msgToString = function (msg) {
	if (msg.$ === 1) {
		return _List_fromArray(
			['CompletedLoadProfile']);
	} else {
		return _List_fromArray(
			['GotContactMsg']);
	}
};
var $author$project$Page$Profile$AddKyc$msgToString = function (msg) {
	return _List_fromArray(
		['FormMsg']);
};
var $author$project$Page$Profile$Claims$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['NoOp']);
		case 1:
			var r = msg.a;
			return _List_fromArray(
				[
					'ClaimsLoaded',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
		case 2:
			return _List_fromArray(
				['CompletedLoadCommunity']);
		case 3:
			return _List_fromArray(
				['ClaimMsg']);
		case 4:
			return _List_fromArray(
				['SelectedTab']);
		case 5:
			return _List_fromArray(
				['OpenedFilterModal']);
		case 6:
			return _List_fromArray(
				['ClosedFilterModal']);
		case 7:
			return _List_fromArray(
				['ToggledSorting']);
		case 8:
			return _List_fromArray(
				['SelectedStatusFilter']);
		case 9:
			return _List_fromArray(
				['ClickedApplyFilters']);
		default:
			return _List_fromArray(
				['ClickedAcceptCodeOfConduct']);
	}
};
var $author$project$Form$LocalityPicker$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['NoOp']);
		case 1:
			return _List_fromArray(
				['GotSelectMsg']);
		case 2:
			return _List_fromArray(
				['SelectedLocality']);
		case 3:
			return _List_fromArray(
				['BlurredPicker']);
		case 4:
			return _List_fromArray(
				['DebounceElapsed']);
		default:
			var result = msg.b;
			return _List_fromArray(
				[
					'GotOptions',
					$author$project$UpdateResult$remoteDataToString(result)
				]);
	}
};
var $author$project$Page$Profile$Editor$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['NoOp']);
		case 1:
			return _List_fromArray(
				['CompletedLoadProfile']);
		case 2:
			return _List_fromArray(
				['RequestedEditorData']);
		case 3:
			var r = msg.a;
			return _List_fromArray(
				[
					'GotEditorData',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
		case 4:
			return _List_fromArray(
				['ClickedSave']);
		case 5:
			var r = msg.a;
			return _List_fromArray(
				[
					'GotSaveResult',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
		case 6:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotFormMsg',
				$author$project$Form$msgToString(subMsg));
		case 7:
			return _List_fromArray(
				['ChangedCountry']);
		case 8:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotMunicipalityPickerMsg',
				$author$project$Form$LocalityPicker$msgToString(subMsg));
		case 9:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotBairroPickerMsg',
				$author$project$Form$LocalityPicker$msgToString(subMsg));
		case 10:
			return _List_fromArray(
				['ClickedChangeMunicipality']);
		case 11:
			return _List_fromArray(
				['ClickedChangeBairro']);
		case 12:
			return _List_fromArray(
				['ClickedBairroNotListed']);
		case 13:
			return _List_fromArray(
				['ClickedBackToList']);
		case 14:
			return _List_fromArray(
				['ClickedClearPlace']);
		case 15:
			return _List_fromArray(
				['ChangedBairroText']);
		case 16:
			return _List_fromArray(
				['ChangedOtherText']);
		case 17:
			return _List_fromArray(
				['ChangedAddress']);
		case 18:
			var r = msg.b;
			return _List_fromArray(
				[
					'GotPostalLookup',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
		case 19:
			return _List_fromArray(
				['ClickedEditAddress']);
		case 20:
			return _List_fromArray(
				['ToggledFeedback']);
		case 21:
			return _List_fromArray(
				['ChangedFeedbackKind']);
		case 22:
			return _List_fromArray(
				['ChangedFeedbackBody']);
		case 23:
			return _List_fromArray(
				['ClickedSendFeedback']);
		default:
			var r = msg.a;
			return _List_fromArray(
				[
					'GotFeedbackResult',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
	}
};
var $author$project$Page$Register$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['NoOp']);
		case 1:
			return _List_fromArray(
				['CompletedLoadCommunity']);
		case 2:
			return _List_fromArray(
				['GotAccountAvailabilityResponse']);
		case 3:
			var r = msg.b;
			return _List_fromArray(
				[
					'AccountKeysGenerated',
					$author$project$UpdateResult$resultToString(r)
				]);
		case 4:
			return _List_fromArray(
				['AgreedToSave12Words']);
		case 7:
			return _List_fromArray(
				['CopyToClipboard']);
		case 8:
			return _List_fromArray(
				['CopiedToClipboard']);
		case 5:
			return _List_fromArray(
				['DownloadPdf']);
		case 6:
			return _List_fromArray(
				['PdfDownloaded']);
		case 9:
			return _List_fromArray(
				['CompletedLoadInvite']);
		case 11:
			return _List_fromArray(
				['AccountTypeSelected']);
		case 12:
			return _List_fromArray(
				['CompletedSignUp']);
		case 10:
			return _List_fromArray(
				['CompletedLoadCountry']);
		case 13:
			var subMsg = msg.a;
			var formMsgToString = function () {
				switch (subMsg.$) {
					case 0:
						var innerMsg = subMsg.a;
						return $author$project$Form$msgToString(innerMsg);
					case 1:
						var innerMsg = subMsg.a;
						return $author$project$Form$msgToString(innerMsg);
					default:
						var innerMsg = subMsg.a;
						return $author$project$Form$msgToString(innerMsg);
				}
			}();
			return A2($elm$core$List$cons, 'GotFormMsg', formMsgToString);
		default:
			return _List_fromArray(
				['SubmittedForm']);
	}
};
var $author$project$Page$Settings$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['NoOp']);
		case 1:
			return _List_fromArray(
				['ClickedDownloadPdf']);
		case 2:
			return _List_fromArray(
				['ClickedExportToSimpleos']);
		case 3:
			return _List_fromArray(
				['ClickedCopyPrivateKey']);
		case 4:
			return _List_fromArray(
				['CopiedPrivateKey']);
		case 5:
			return _List_fromArray(
				['ClosedExportToSimpleosModal']);
		case 6:
			return _List_fromArray(
				['ClickedChangePin']);
		case 7:
			return _List_fromArray(
				['ClosedNewPinModal']);
		case 8:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotPinMsg',
				$author$project$View$Pin$msgToString(subMsg));
		case 9:
			return _List_fromArray(
				['SubmittedNewPin']);
		case 10:
			return _List_fromArray(
				['ChangedToNewPin']);
		case 11:
			return _List_fromArray(
				['ClickedDeleteKyc']);
		case 12:
			return _List_fromArray(
				['ClosedDeleteKycModal']);
		case 13:
			return _List_fromArray(
				['AcceptedDeleteKyc']);
		case 14:
			var r = msg.a;
			return _List_fromArray(
				[
					'FinishedDeletingKyc',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
		case 15:
			return _List_fromArray(
				['ToggledClaimNotification']);
		case 16:
			return _List_fromArray(
				['ToggledTransferNotification']);
		case 17:
			return _List_fromArray(
				['ToggledDigestNotification']);
		default:
			var r = msg.b;
			return _List_fromArray(
				[
					'CompletedTogglingNotification',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
	}
};
var $author$project$Page$Shop$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['NoOp']);
		case 1:
			return _List_fromArray(
				['CompletedLoadingShopCategories']);
		case 2:
			var r = msg.a;
			return _List_fromArray(
				[
					'CompletedSalesLoad',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
		case 3:
			var r = msg.a;
			return _List_fromArray(
				[
					'CompletedLoadPlaceRelease',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
		case 4:
			var r = msg.a;
			return _List_fromArray(
				[
					'CompletedLoadWhereOptions',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
		case 5:
			return _List_fromArray(
				['ClickedWhere']);
		case 6:
			return _List_fromArray(
				['ClickedOfferType']);
		case 7:
			return _List_fromArray(
				['CompletedLoadBalances']);
		case 8:
			return _List_fromArray(
				['ClickedAcceptCodeOfConduct']);
		case 9:
			return _List_fromArray(
				['ClickedScrollToImage']);
		case 10:
			return _List_fromArray(
				['ImageStartedIntersecting']);
		case 11:
			return _List_fromArray(
				['ImageStoppedIntersecting']);
		case 12:
			return _List_fromArray(
				['ClickedOpenFiltersModal']);
		case 13:
			return _List_fromArray(
				['ClosedFiltersModal']);
		case 14:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotFiltersFormMsg',
				$author$project$Form$msgToString(subMsg));
		default:
			return _List_fromArray(
				['SubmittedFiltersForm']);
	}
};
var $author$project$Page$Shop$Editor$formMsgToString = function (msg) {
	switch (msg.$) {
		case 0:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'MainInformationMsg',
				$author$project$Form$msgToString(subMsg));
		case 1:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'ImagesMsg',
				$author$project$Form$msgToString(subMsg));
		case 2:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'CategoriesMsg',
				$author$project$Form$msgToString(subMsg));
		default:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'PriceAndInventoryMsg',
				$author$project$Form$msgToString(subMsg));
	}
};
var $author$project$Page$Shop$Editor$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['NoOp']);
		case 1:
			return _List_fromArray(
				['CompletedLoadCommunity']);
		case 2:
			var r = msg.a;
			return _List_fromArray(
				[
					'CompletedSaleLoad',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
		case 8:
			var r = msg.a;
			return _List_fromArray(
				[
					'GotSaveResponse',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
		case 3:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotFormMsg',
				$author$project$Page$Shop$Editor$formMsgToString(subMsg));
		case 4:
			return _List_fromArray(
				['SubmittedMainInformation']);
		case 5:
			return _List_fromArray(
				['SubmittedImages']);
		case 6:
			return _List_fromArray(
				['SubmittedCategories']);
		case 7:
			return _List_fromArray(
				['SubmittedPriceAndInventory']);
		case 9:
			return _List_fromArray(
				['ClickedDecrementStockUnits']);
		default:
			return _List_fromArray(
				['ClickedIncrementStockUnits']);
	}
};
var $author$project$Page$Shop$Viewer$formInteractionMsgToString = function (msg) {
	if (!msg) {
		return _List_fromArray(
			['ClickedDecrementUnits']);
	} else {
		return _List_fromArray(
			['ClickedIncrementUnits']);
	}
};
var $author$project$Page$Shop$Viewer$guestMsgToString = function (msg) {
	switch (msg.$) {
		case 0:
			var r = msg.a;
			return _List_fromArray(
				[
					'CompletedSalePreviewLoad',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
		case 1:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotFormInteractionMsgAsGuest',
				$author$project$Page$Shop$Viewer$formInteractionMsgToString(subMsg));
		default:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotFormMsgAsGuest',
				$author$project$Form$msgToString(subMsg));
	}
};
var $author$project$Page$Shop$Viewer$loggedInMsgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['ClosedAuthModal']);
		case 1:
			return _List_fromArray(
				['CompletedSaleLoad']);
		case 5:
			return _List_fromArray(
				['GotTransferResult']);
		case 3:
			return _List_fromArray(
				['ClickedTransfer']);
		case 4:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotFormMsg',
				$author$project$Form$msgToString(subMsg));
		case 2:
			return _List_fromArray(
				['CompletedLoadBalances']);
		case 6:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotFormInteractionMsg',
				$author$project$Page$Shop$Viewer$formInteractionMsgToString(subMsg));
		case 7:
			return _List_fromArray(
				['ClickedEditSale']);
		case 8:
			return _List_fromArray(
				['ClosedEditSaleModal']);
		case 9:
			return _List_fromArray(
				['ClickedDelete']);
		case 10:
			return _List_fromArray(
				['ClosedConfirmDeleteModal']);
		case 11:
			return _List_fromArray(
				['ClickedConfirmDelete']);
		default:
			var r = msg.a;
			return _List_fromArray(
				[
					'CompletedDeleteProduct',
					$author$project$UpdateResult$remoteDataToString(r)
				]);
	}
};
var $author$project$Page$Shop$Viewer$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['NoOp']);
		case 1:
			return _List_fromArray(
				['ClickedScrollToImage']);
		case 2:
			return _List_fromArray(
				['ImageStartedIntersecting']);
		case 3:
			return _List_fromArray(
				['ImageStoppedIntersecting']);
		case 4:
			return _List_fromArray(
				['ClickedOpenDetails']);
		case 5:
			return _List_fromArray(
				['ClosedDetailsModal']);
		case 6:
			return _List_fromArray(
				['ClickedShareOffer']);
		case 7:
			return _List_fromArray(
				['CopiedToClipboard']);
		case 8:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'AsGuestMsg',
				$author$project$Page$Shop$Viewer$guestMsgToString(subMsg));
		default:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'AsLoggedInMsg',
				$author$project$Page$Shop$Viewer$loggedInMsgToString(subMsg));
	}
};
var $author$project$Page$ViewTransfer$msgToString = function (msg) {
	if (!msg.$) {
		var r = msg.a;
		return _List_fromArray(
			[
				'CompletedTransferLoad',
				$author$project$UpdateResult$remoteDataToString(r)
			]);
	} else {
		var subMsg = msg.b;
		return A2(
			$elm$core$List$cons,
			'GotProfileSummaryMsg',
			$author$project$Profile$Summary$msgToString(subMsg));
	}
};
var $author$project$Main$msgToString = function (msg) {
	switch (msg.$) {
		case 0:
			return _List_fromArray(
				['Ignored']);
		case 1:
			return _List_fromArray(
				['ChangedUrl']);
		case 2:
			return _List_fromArray(
				['ClickedLink']);
		case 3:
			return _List_fromArray(
				['GotJavascriptData']);
		case 4:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotPageMsg',
				$author$project$Page$msgToString(subMsg));
		case 6:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotCommunityAboutMsg',
				$author$project$Page$Community$About$msgToString(subMsg));
		case 7:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotCommunityObjectivesMsg',
				$author$project$Page$Community$Objectives$msgToString(subMsg));
		case 8:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotCommunityEditorMsg',
				$author$project$Page$Community$New$msgToString(subMsg));
		case 9:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotVerifyClaimMsg',
				$author$project$Page$Dashboard$Claim$msgToString(subMsg));
		case 5:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotNotificationMsg',
				$author$project$Page$Notification$msgToString(subMsg));
		case 10:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotDashboardMsg',
				$author$project$Page$Dashboard$msgToString(subMsg));
		case 11:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotLoginMsg',
				$author$project$Page$Login$msgToString(subMsg));
		case 12:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotNewsMsg',
				$author$project$Page$News$msgToString(subMsg));
		case 13:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotPaymentHistoryMsg',
				$author$project$Page$PaymentHistory$msgToString(subMsg));
		case 14:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotProfileMsg',
				$author$project$Page$Profile$msgToString(subMsg));
		case 15:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotProfileEditorMsg',
				$author$project$Page$Profile$Editor$msgToString(subMsg));
		case 16:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotProfileAddKycMsg',
				$author$project$Page$Profile$AddKyc$msgToString(subMsg));
		case 17:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotProfileClaimsMsg',
				$author$project$Page$Profile$Claims$msgToString(subMsg));
		case 18:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotProfileAddContactMsg',
				$author$project$Page$Profile$AddContact$msgToString(subMsg));
		case 19:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotRegisterMsg',
				$author$project$Page$Register$msgToString(subMsg));
		case 20:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotSettingsMsg',
				$author$project$Page$Settings$msgToString(subMsg));
		case 21:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotShopMsg',
				$author$project$Page$Shop$msgToString(subMsg));
		case 22:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotShopEditorMsg',
				$author$project$Page$Shop$Editor$msgToString(subMsg));
		case 23:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotShopViewerMsg',
				$author$project$Page$Shop$Viewer$msgToString(subMsg));
		case 24:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotViewTransferScreenMsg',
				$author$project$Page$ViewTransfer$msgToString(subMsg));
		case 25:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotInviteMsg',
				$author$project$Page$Community$Invite$msgToString(subMsg));
		case 26:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotJoinMsg',
				$author$project$Page$Join$msgToString(subMsg));
		case 27:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotTransferMsg',
				$author$project$Page$Community$Transfer$msgToString(subMsg));
		default:
			var subMsg = msg.a;
			return A2(
				$elm$core$List$cons,
				'GotAnalysisMsg',
				$author$project$Page$Dashboard$Analysis$msgToString(subMsg));
	}
};
var $elm$browser$Browser$Navigation$pushUrl = _Browser_pushUrl;
var $author$project$Route$pushUrl = F2(
	function (key, route) {
		return A2(
			$elm$browser$Browser$Navigation$pushUrl,
			key,
			$author$project$Route$routeToString(route));
	});
var $author$project$Log$contextFromLocation = function (location) {
	return {
		mR: $elm$core$Dict$fromList(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'module',
					$elm$json$Json$Encode$string(location.nW)),
					_Utils_Tuple2(
					'function',
					$elm$json$Json$Encode$string(location.mX))
				])),
		ki: 'Location'
	};
};
var $author$project$Log$encodeContext = function (context) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(context.ki)),
				_Utils_Tuple2(
				'extras',
				A3($elm$json$Json$Encode$dict, $elm$core$Basics$identity, $elm$core$Basics$identity, context.mR))
			]));
};
var $author$project$Log$encodeTag = function (tag) {
	if (!tag.$) {
		var errorType = tag.a;
		var value = function () {
			switch (errorType) {
				case 0:
					return 'incompatible msg';
				case 1:
					return 'impossible error';
				case 2:
					return 'decoding error';
				case 3:
					return 'http error';
				case 4:
					return 'graphql error';
				case 5:
					return 'unknown error';
				case 6:
					return 'json value';
				default:
					return 'unsupported feature';
			}
		}();
		return _Utils_Tuple2(
			'cambiatus.type',
			$elm$json$Json$Encode$string(value));
	} else {
		var expectedAuthentication = tag.a;
		var value = function () {
			if (expectedAuthentication === 1) {
				return 'guest';
			} else {
				return 'logged in';
			}
		}();
		return _Utils_Tuple2(
			'cambiatus.expected-authentication',
			$elm$json$Json$Encode$string(value));
	}
};
var $author$project$Log$logEvent = _Platform_outgoingPort('logEvent', $elm$core$Basics$identity);
var $author$project$Log$send = F2(
	function (msgToString, event) {
		return $author$project$Log$logEvent(
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'user',
						function () {
							var _v0 = event.pM;
							if (_v0.$ === 1) {
								return $elm$json$Json$Encode$null;
							} else {
								var username = _v0.a;
								return $author$project$Eos$Account$encodeName(username);
							}
						}()),
						_Utils_Tuple2(
						'message',
						$elm$json$Json$Encode$string(event.nS)),
						_Utils_Tuple2(
						'tags',
						A3(
							$elm$json$Json$Encode$dict,
							$elm$core$Basics$identity,
							$elm$core$Basics$identity,
							$elm$core$Dict$fromList(
								A2($elm$core$List$map, $author$project$Log$encodeTag, event.pu)))),
						_Utils_Tuple2(
						'contexts',
						A2(
							$elm$json$Json$Encode$list,
							$author$project$Log$encodeContext,
							A2(
								$elm$core$List$cons,
								$author$project$Log$contextFromLocation(event.nN),
								event.mm))),
						_Utils_Tuple2(
						'transaction',
						$elm$json$Json$Encode$string(
							A2(
								$elm$core$String$join,
								'.',
								msgToString(event.pE)))),
						_Utils_Tuple2(
						'level',
						$elm$json$Json$Encode$string(
							$author$project$Log$levelToString(event.nH)))
					])));
	});
var $author$project$Main$updateGuestUResult = F4(
	function (toStatus, toMsg, model, uResult) {
		return function (_v7) {
			var model_ = _v7.a;
			var cmds_ = _v7.b;
			return _Utils_Tuple2(
				model_,
				$elm$core$Platform$Cmd$batch(
					A2(
						$elm$core$List$cons,
						A2(
							$elm$core$Platform$Cmd$map,
							toMsg,
							$elm$core$Platform$Cmd$batch(uResult.i0)),
						_Utils_ap(
							A2(
								$elm$core$List$map,
								A2(
									$elm$core$Basics$composeR,
									$author$project$Ports$mapAddress(toMsg),
									$author$project$Ports$javascriptOutCmd($author$project$Main$msgToString)),
								uResult.kB),
							_Utils_ap(
								A2(
									$elm$core$List$map,
									A2(
										$elm$core$Basics$composeR,
										$author$project$Log$map(toMsg),
										$author$project$Log$send($author$project$Main$msgToString)),
									uResult.jm),
								cmds_)))));
		}(
			A3(
				$elm$core$List$foldl,
				F2(
					function (commExtMsg, _v0) {
						var m = _v0.a;
						var cmds_ = _v0.b;
						var _v1 = m.c;
						if (_v1.$ === 1) {
							return _Utils_Tuple2(m, cmds_);
						} else {
							var guest = _v1.a;
							switch (commExtMsg.$) {
								case 0:
									var pin = commExtMsg.a.oE;
									var privateKey = commExtMsg.a.oN;
									var signInResponse = commExtMsg.a.pg;
									var shared = guest.aM;
									var redirectRoute = function () {
										var _v6 = guest.lS;
										if (!_v6.$) {
											if (_v6.a.$ === 41) {
												return $author$project$Route$Dashboard;
											} else {
												var route = _v6.a;
												return route;
											}
										} else {
											return $author$project$Route$Dashboard;
										}
									}();
									var _v3 = signInResponse;
									var profile = _v3.kJ;
									var token = _v3.pC;
									var userWithCommunity = _Utils_update(
										profile,
										{
											ei: function () {
												var _v5 = guest.b9;
												if (_v5.$ === 3) {
													var community = _v5.a;
													return A2(
														$elm$core$List$any,
														function (c) {
															return _Utils_eq(c.e9, community.e9);
														},
														profile.ei) ? profile.ei : A2(
														$elm$core$List$cons,
														{m_: community.cl, ck: community.ck, cm: community.cm, hC: community.hC, ki: community.ki, pl: community.pl, e9: community.e9},
														profile.ei);
												} else {
													return profile.ei;
												}
											}()
										});
									var _v4 = A5(
										$author$project$Session$LoggedIn$initLogin,
										shared,
										pin,
										$elm$core$Maybe$Just(privateKey),
										userWithCommunity,
										token);
									var session = _v4.a;
									var cmd = _v4.b;
									return _Utils_Tuple2(
										_Utils_update(
											m,
											{
												c: $author$project$Page$LoggedIn(session)
											}),
										A2(
											$elm$core$List$cons,
											A2(
												$elm$core$Platform$Cmd$map,
												A2($elm$core$Basics$composeR, $author$project$Page$GotLoggedInMsg, $author$project$Main$GotPageMsg),
												cmd),
											A2(
												$elm$core$List$cons,
												$author$project$Api$Graphql$createAbsintheSocket(token),
												A2(
													$elm$core$List$cons,
													A2($author$project$Route$pushUrl, guest.aM.eM, redirectRoute),
													A2(
														$elm$core$List$cons,
														A2(
															$author$project$Log$addBreadcrumb,
															$author$project$Main$msgToString,
															{
																fw: $author$project$Main$Ignored,
																i9: $elm$core$Dict$fromList(
																	_List_fromArray(
																		[
																			_Utils_Tuple2(
																			'username',
																			$author$project$Eos$Account$encodeName(profile.fl))
																		])),
																nH: 3,
																nS: 'Guest logged in',
																d0: 3
															}),
														cmds_)))));
								case 1:
									var feedback = commExtMsg.a;
									return _Utils_Tuple2(
										_Utils_update(
											m,
											{
												c: $author$project$Page$Guest(
													_Utils_update(
														guest,
														{hf: feedback}))
											}),
										cmds_);
								default:
									var newShared = commExtMsg.a;
									return _Utils_Tuple2(
										_Utils_update(
											m,
											{
												c: $author$project$Page$Guest(
													_Utils_update(
														guest,
														{aM: newShared}))
											}),
										cmds_);
							}
						}
					}),
				_Utils_Tuple2(
					_Utils_update(
						model,
						{
							gE: toStatus(uResult.nV)
						}),
					_List_Nil),
				uResult.jo));
	});
var $author$project$Page$Community$About$receiveBroadcast = function (broadcastMsg) {
	if (!broadcastMsg.$) {
		var community = broadcastMsg.a;
		return $elm$core$Maybe$Just(
			$author$project$Page$Community$About$CompletedLoadCommunity(community));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Page$Community$Invite$receiveBroadcast = function (broadcastMsg) {
	if (broadcastMsg.$ === 2) {
		return $elm$core$Maybe$Just($author$project$Page$Community$Invite$CompletedLoadProfile);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Page$Community$Objectives$CompletedLoadObjectives = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Community$Objectives$receiveBroadcast = function (broadcastMsg) {
	if ((broadcastMsg.$ === 1) && (!broadcastMsg.b.$)) {
		var objectives = broadcastMsg.b.a;
		return $elm$core$Maybe$Just(
			$author$project$Page$Community$Objectives$CompletedLoadObjectives(objectives));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Page$Community$Transfer$receiveBroadcast = function (broadcastMsg) {
	if (!broadcastMsg.$) {
		var community = broadcastMsg.a;
		return $elm$core$Maybe$Just(
			$author$project$Page$Community$Transfer$CompletedLoadCommunity(community));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Page$Dashboard$receiveBroadcast = function (broadcastMsg) {
	if (!broadcastMsg.$) {
		var community = broadcastMsg.a;
		return $elm$core$Maybe$Just(
			$author$project$Page$Dashboard$CompletedLoadCommunity(community));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Page$Join$receiveBroadcast = function (broadcastMsg) {
	if (!broadcastMsg.$) {
		var community = broadcastMsg.a;
		return $elm$core$Maybe$Just(
			$author$project$Page$Join$CompletedLoadCommunity(community));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Page$News$CompletedLoadNews = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$News$receiveBroadcast = function (broadcastMsg) {
	if ((broadcastMsg.$ === 1) && (broadcastMsg.b.$ === 3)) {
		var news = broadcastMsg.b.a;
		return $elm$core$Maybe$Just(
			$author$project$Page$News$CompletedLoadNews(news));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Page$PaymentHistory$receiveBroadcast = function (broadcastMsg) {
	if (!broadcastMsg.$) {
		var community = broadcastMsg.a;
		return $elm$core$Maybe$Just(
			$author$project$Page$PaymentHistory$CompletedLoadCommunity(community));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Page$Profile$receiveBroadcast = function (broadcastMsg) {
	switch (broadcastMsg.$) {
		case 2:
			var profile = broadcastMsg.a;
			return $elm$core$Maybe$Just(
				$author$project$Page$Profile$CompletedLoadProfile(
					$krisajenkins$remotedata$RemoteData$Success(
						$elm$core$Maybe$Just(profile))));
		case 0:
			var community = broadcastMsg.a;
			return $elm$core$Maybe$Just(
				$author$project$Page$Profile$CompletedLoadCommunity(community));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Page$Profile$AddContact$receiveBroadcast = function (broadcastMsg) {
	if (broadcastMsg.$ === 2) {
		var profile = broadcastMsg.a;
		return $elm$core$Maybe$Just(
			$author$project$Page$Profile$AddContact$CompletedLoadProfile(profile));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Page$Profile$Claims$receiveBroadcast = function (broadcastMsg) {
	if (!broadcastMsg.$) {
		var community = broadcastMsg.a;
		return $elm$core$Maybe$Just(
			$author$project$Page$Profile$Claims$CompletedLoadCommunity(community));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Page$Profile$Editor$receiveBroadcast = function (broadcastMsg) {
	if (broadcastMsg.$ === 2) {
		var profile = broadcastMsg.a;
		return $elm$core$Maybe$Just(
			$author$project$Page$Profile$Editor$CompletedLoadProfile(profile));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Page$Shop$CompletedLoadingShopCategories = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Shop$receiveBroadcast = function (broadcastMsg) {
	if ((broadcastMsg.$ === 1) && (broadcastMsg.b.$ === 4)) {
		var categories = broadcastMsg.b.a;
		return $elm$core$Maybe$Just(
			$author$project$Page$Shop$CompletedLoadingShopCategories(categories));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Page$Shop$Editor$receiveBroadcast = F3(
	function (translators, broadcastMsg, model) {
		_v0$2:
		while (true) {
			switch (broadcastMsg.$) {
				case 0:
					return $elm$core$Maybe$Just($author$project$Page$Shop$Editor$CompletedLoadCommunity);
				case 1:
					if (broadcastMsg.b.$ === 4) {
						var community = broadcastMsg.a;
						var categories = broadcastMsg.b.a;
						if (model.dw) {
							var _v1 = $author$project$Page$Shop$Editor$getFormData(model);
							if (_v1.$ === 1) {
								return $elm$core$Maybe$Nothing;
							} else {
								var formData = _v1.a;
								return $elm$core$Maybe$Just(
									A3(
										$author$project$Form$parse,
										A2($author$project$Page$Shop$Editor$categoriesForm, translators, categories),
										formData.cX,
										{
											gi: A2($elm$core$Basics$composeL, $author$project$Page$Shop$Editor$GotFormMsg, $author$project$Page$Shop$Editor$CategoriesMsg),
											dE: $author$project$Page$Shop$Editor$SubmittedCategories
										}));
							}
						} else {
							return $elm$core$Maybe$Nothing;
						}
					} else {
						break _v0$2;
					}
				default:
					break _v0$2;
			}
		}
		return $elm$core$Maybe$Nothing;
	});
var $author$project$Main$broadcast = F3(
	function (loggedIn, broadcastMessage, status) {
		var maybeMsg = function () {
			switch (status.$) {
				case 11:
					return A2(
						$elm$core$Maybe$map,
						$author$project$Main$GotDashboardMsg,
						$author$project$Page$Dashboard$receiveBroadcast(broadcastMessage));
				case 27:
					return A2(
						$elm$core$Maybe$map,
						$author$project$Main$GotTransferMsg,
						$author$project$Page$Community$Transfer$receiveBroadcast(broadcastMessage));
				case 17:
					return A2(
						$elm$core$Maybe$map,
						$author$project$Main$GotProfileClaimsMsg,
						$author$project$Page$Profile$Claims$receiveBroadcast(broadcastMessage));
				case 5:
					return A2(
						$elm$core$Maybe$map,
						$author$project$Main$GotCommunityAboutMsg,
						$author$project$Page$Community$About$receiveBroadcast(broadcastMessage));
				case 6:
					return A2(
						$elm$core$Maybe$map,
						$author$project$Main$GotCommunityObjectivesMsg,
						$author$project$Page$Community$Objectives$receiveBroadcast(broadcastMessage));
				case 18:
					return A2(
						$elm$core$Maybe$map,
						$author$project$Main$GotProfileAddContactMsg,
						$author$project$Page$Profile$AddContact$receiveBroadcast(broadcastMessage));
				case 15:
					return A2(
						$elm$core$Maybe$map,
						$author$project$Main$GotProfileEditorMsg,
						$author$project$Page$Profile$Editor$receiveBroadcast(broadcastMessage));
				case 14:
					return A2(
						$elm$core$Maybe$map,
						$author$project$Main$GotProfileMsg,
						$author$project$Page$Profile$receiveBroadcast(broadcastMessage));
				case 22:
					var subModel = status.b;
					return A2(
						$elm$core$Maybe$map,
						$author$project$Main$GotShopEditorMsg,
						A3($author$project$Page$Shop$Editor$receiveBroadcast, loggedIn.aM.iw, broadcastMessage, subModel));
				case 21:
					var subModel = status.b;
					return A2(
						$elm$core$Maybe$map,
						$author$project$Main$GotShopMsg,
						$author$project$Page$Shop$receiveBroadcast(broadcastMessage));
				case 25:
					return A2(
						$elm$core$Maybe$map,
						$author$project$Main$GotInviteMsg,
						$author$project$Page$Community$Invite$receiveBroadcast(broadcastMessage));
				case 26:
					return A2(
						$elm$core$Maybe$map,
						$author$project$Main$GotJoinMsg,
						$author$project$Page$Join$receiveBroadcast(broadcastMessage));
				case 13:
					return A2(
						$elm$core$Maybe$map,
						$author$project$Main$GotNewsMsg,
						$author$project$Page$News$receiveBroadcast(broadcastMessage));
				case 4:
					return A2(
						$elm$core$Maybe$map,
						$author$project$Main$GotPaymentHistoryMsg,
						$author$project$Page$PaymentHistory$receiveBroadcast(broadcastMessage));
				default:
					return $elm$core$Maybe$Nothing;
			}
		}();
		if (!maybeMsg.$) {
			var msg = maybeMsg.a;
			return $author$project$Utils$spawnMessage(msg);
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Session$LoggedIn$ClickedAcceptCodeOfConduct = {$: 37};
var $author$project$Session$LoggedIn$ClickedDenyCodeOfConduct = {$: 38};
var $author$project$Session$LoggedIn$ClickedLanguage = function (a) {
	return {$: 11, a: a};
};
var $author$project$Session$LoggedIn$ClickedLogout = {$: 8};
var $author$project$Session$LoggedIn$ClickedNavLink = {$: 23};
var $author$project$Session$LoggedIn$ClickedOpenCommunityContactsModal = {$: 41};
var $author$project$Session$LoggedIn$ClickedReadHighlightedNews = {$: 26};
var $author$project$Session$LoggedIn$ClickedTryAgainProfile = function (a) {
	return {$: 7, a: a};
};
var $author$project$Session$LoggedIn$ClickedTryAgainTranslation = {$: 2};
var $author$project$Session$LoggedIn$CloseCommunitySelector = {$: 18};
var $author$project$Session$LoggedIn$ClosedAuthModal = {$: 13};
var $author$project$Session$LoggedIn$ClosedCommunityContactsModal = {$: 42};
var $author$project$Session$LoggedIn$ClosedHighlightedNews = {$: 27};
var $author$project$Session$LoggedIn$ClosedInsufficientPermissionsModal = {$: 14};
var $author$project$Session$LoggedIn$ClosedSearch = {$: 24};
var $author$project$Session$LoggedIn$CompletedAcceptingCodeOfConduct = function (a) {
	return {$: 39, a: a};
};
var $author$project$Session$LoggedIn$CompletedGeneratingAuthToken = function (a) {
	return {$: 34, a: a};
};
var $author$project$Session$LoggedIn$CompletedLoadCommunityField = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Session$LoggedIn$CompletedLoadCommunityFields = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Session$LoggedIn$CompletedLoadTranslation = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Session$LoggedIn$CompletedLoadUnread = function (a) {
	return {$: 16, a: a};
};
var $author$project$Session$LoggedIn$CompletedSendingLanguagePreference = function (a) {
	return {$: 12, a: a};
};
var $author$project$Session$LoggedIn$EndedCodeOfConductWarningAnimation = {$: 40};
var $author$project$Session$LoggedIn$GotActionMsg = function (a) {
	return {$: 22, a: a};
};
var $author$project$Session$LoggedIn$GotAuthTokenPhrase = F2(
	function (a, b) {
		return {$: 31, a: a, b: b};
	});
var $author$project$Session$LoggedIn$GotAuthTokenPhraseExternal = F2(
	function (a, b) {
		return {$: 32, a: a, b: b};
	});
var $author$project$Session$LoggedIn$GotFeedbackMsg = function (a) {
	return {$: 20, a: a};
};
var $author$project$Session$LoggedIn$GotSearchMsg = function (a) {
	return {$: 21, a: a};
};
var $author$project$Session$LoggedIn$NoOp = {$: 0};
var $author$project$Session$LoggedIn$OpenCommunitySelector = {$: 17};
var $author$project$Session$LoggedIn$ReceivedNewHighlightedNews = function (a) {
	return {$: 28, a: a};
};
var $author$project$Session$LoggedIn$RequestedNewAuthTokenPhraseExternal = function (a) {
	return {$: 30, a: a};
};
var $author$project$Session$LoggedIn$RequestedQuery = function (a) {
	return {$: 35, a: a};
};
var $author$project$Session$LoggedIn$SelectedCommunity = function (a) {
	return {$: 19, a: a};
};
var $author$project$Session$LoggedIn$ShowUserNav = function (a) {
	return {$: 9, a: a};
};
var $author$project$Session$LoggedIn$SignedAuthTokenPhrase = function (a) {
	return {$: 33, a: a};
};
var $author$project$Session$LoggedIn$ToggleLanguageItems = {$: 10};
var $author$project$Session$LoggedIn$mapMsg = F2(
	function (mapFn, msg) {
		switch (msg.$) {
			case 0:
				return $author$project$Session$LoggedIn$NoOp;
			case 1:
				var language = msg.a;
				var result = msg.b;
				return A2($author$project$Session$LoggedIn$CompletedLoadTranslation, language, result);
			case 2:
				return $author$project$Session$LoggedIn$ClickedTryAgainTranslation;
			case 3:
				var result = msg.a;
				return $author$project$Session$LoggedIn$CompletedLoadProfile(result);
			case 4:
				var result = msg.a;
				return $author$project$Session$LoggedIn$CompletedLoadCommunity(result);
			case 5:
				var community = msg.a;
				var result = msg.b;
				return A2($author$project$Session$LoggedIn$CompletedLoadCommunityField, community, result);
			case 6:
				var community = msg.a;
				var result = msg.b;
				return A2($author$project$Session$LoggedIn$CompletedLoadCommunityFields, community, result);
			case 7:
				var account = msg.a;
				return $author$project$Session$LoggedIn$ClickedTryAgainProfile(account);
			case 8:
				return $author$project$Session$LoggedIn$ClickedLogout;
			case 9:
				var showUserNav = msg.a;
				return $author$project$Session$LoggedIn$ShowUserNav(showUserNav);
			case 10:
				return $author$project$Session$LoggedIn$ToggleLanguageItems;
			case 11:
				var language = msg.a;
				return $author$project$Session$LoggedIn$ClickedLanguage(language);
			case 12:
				var result = msg.a;
				return $author$project$Session$LoggedIn$CompletedSendingLanguagePreference(result);
			case 13:
				return $author$project$Session$LoggedIn$ClosedAuthModal;
			case 14:
				return $author$project$Session$LoggedIn$ClosedInsufficientPermissionsModal;
			case 15:
				var subMsg = msg.a;
				return $author$project$Session$LoggedIn$GotAuthMsg(subMsg);
			case 16:
				var jsonValue = msg.a;
				return $author$project$Session$LoggedIn$CompletedLoadUnread(jsonValue);
			case 17:
				return $author$project$Session$LoggedIn$OpenCommunitySelector;
			case 18:
				return $author$project$Session$LoggedIn$CloseCommunitySelector;
			case 19:
				var communityInfo = msg.a;
				return $author$project$Session$LoggedIn$SelectedCommunity(communityInfo);
			case 20:
				var subMsg = msg.a;
				return $author$project$Session$LoggedIn$GotFeedbackMsg(subMsg);
			case 21:
				var subMsg = msg.a;
				return $author$project$Session$LoggedIn$GotSearchMsg(subMsg);
			case 22:
				var subMsg = msg.a;
				return $author$project$Session$LoggedIn$GotActionMsg(subMsg);
			case 23:
				return $author$project$Session$LoggedIn$ClickedNavLink;
			case 24:
				return $author$project$Session$LoggedIn$ClosedSearch;
			case 25:
				var time = msg.a;
				return $author$project$Session$LoggedIn$GotTimeInternal(time);
			case 26:
				return $author$project$Session$LoggedIn$ClickedReadHighlightedNews;
			case 27:
				return $author$project$Session$LoggedIn$ClosedHighlightedNews;
			case 28:
				var jsonValue = msg.a;
				return $author$project$Session$LoggedIn$ReceivedNewHighlightedNews(jsonValue);
			case 29:
				var callback = msg.a;
				return $author$project$Session$LoggedIn$RequestedNewAuthTokenPhrase(
					A2(
						$elm$core$Basics$composeR,
						callback,
						$elm$core$Platform$Cmd$map(
							$author$project$Session$LoggedIn$mapMsg(mapFn))));
			case 30:
				var callback = msg.a;
				return $author$project$Session$LoggedIn$RequestedNewAuthTokenPhraseExternal(
					A2(
						$elm$core$Basics$composeR,
						callback,
						$elm$core$Platform$Cmd$map(mapFn)));
			case 31:
				var callback = msg.a;
				var result = msg.b;
				return A2(
					$author$project$Session$LoggedIn$GotAuthTokenPhrase,
					A2(
						$elm$core$Basics$composeR,
						callback,
						$elm$core$Platform$Cmd$map(
							$author$project$Session$LoggedIn$mapMsg(mapFn))),
					result);
			case 32:
				var callback = msg.a;
				var result = msg.b;
				return A2(
					$author$project$Session$LoggedIn$GotAuthTokenPhraseExternal,
					A2(
						$elm$core$Basics$composeR,
						callback,
						$elm$core$Platform$Cmd$map(mapFn)),
					result);
			case 33:
				var password = msg.a;
				return $author$project$Session$LoggedIn$SignedAuthTokenPhrase(password);
			case 34:
				var result = msg.a;
				return $author$project$Session$LoggedIn$CompletedGeneratingAuthToken(result);
			case 35:
				var result = msg.a;
				return $author$project$Session$LoggedIn$RequestedQuery(
					function () {
						if (result.$ === 1) {
							var callbackCmd = result.a.iU;
							return $elm$core$Result$Err(
								{
									iU: F2(
										function (shared, authToken) {
											return A2(
												$elm$core$Platform$Cmd$map,
												mapFn,
												A2(callbackCmd, shared, authToken));
										})
								});
						} else {
							var extMsg = result.a;
							return $elm$core$Result$Ok(
								mapFn(extMsg));
						}
					}());
			case 36:
				var result = msg.a;
				return $author$project$Session$LoggedIn$RequestedQueryInternal(
					function () {
						if (result.$ === 1) {
							var callbackCmd = result.a;
							return $elm$core$Result$Err(
								A2(
									$elm$core$Basics$composeR,
									callbackCmd,
									$elm$core$Platform$Cmd$map(
										$author$project$Session$LoggedIn$mapMsg(mapFn))));
						} else {
							var resultMsg = result.a;
							return $elm$core$Result$Ok(
								A2($author$project$Session$LoggedIn$mapMsg, mapFn, resultMsg));
						}
					}());
			case 37:
				return $author$project$Session$LoggedIn$ClickedAcceptCodeOfConduct;
			case 38:
				return $author$project$Session$LoggedIn$ClickedDenyCodeOfConduct;
			case 39:
				var result = msg.a;
				return $author$project$Session$LoggedIn$CompletedAcceptingCodeOfConduct(result);
			case 40:
				return $author$project$Session$LoggedIn$EndedCodeOfConductWarningAnimation;
			case 41:
				return $author$project$Session$LoggedIn$ClickedOpenCommunityContactsModal;
			default:
				return $author$project$Session$LoggedIn$ClosedCommunityContactsModal;
		}
	});
var $author$project$Session$LoggedIn$CodeOfConductShown = {$: 1};
var $author$project$Session$LoggedIn$CommunityFieldLoaded = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$View$Feedback$Visible = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Session$LoggedIn$askedAuthentication = function (model) {
	return _Utils_update(
		model,
		{dV: true, bR: false, bo: false, e5: false, e6: false, aB: false});
};
var $author$project$View$Pin$withLastKnownPin = F2(
	function (newPin, model) {
		return _Utils_update(
			model,
			{
				nF: $elm$core$Maybe$Just(newPin)
			});
	});
var $author$project$Auth$changeLastKnownPin = F2(
	function (newPin, model) {
		return _Utils_update(
			model,
			{
				ag: A2($author$project$View$Pin$withLastKnownPin, newPin, model.ag)
			});
	});
var $author$project$Eos$encodeSymbol = function (symbol) {
	return $elm$json$Json$Encode$string(
		$author$project$Eos$symbolToString(symbol));
};
var $author$project$Log$contextFromCommunity = function (remoteData) {
	return {
		mR: function () {
			if (remoteData.$ === 3) {
				var community = remoteData.a;
				return $elm$core$Dict$fromList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'symbol',
							$author$project$Eos$encodeSymbol(community.e9)),
							_Utils_Tuple2(
							'name',
							$elm$json$Json$Encode$string(community.ki))
						]));
			} else {
				return $elm$core$Dict$fromList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'error',
							$elm$json$Json$Encode$string('Impossible error: loggedIn.selectedCommunity /= RemoteData.Success'))
						]));
			}
		}(),
		ki: 'Community'
	};
};
var $elm_community$list_extra$List$Extra$dropWhile = F2(
	function (predicate, list) {
		dropWhile:
		while (true) {
			if (!list.b) {
				return _List_Nil;
			} else {
				var x = list.a;
				var xs = list.b;
				if (predicate(x)) {
					var $temp$predicate = predicate,
						$temp$list = xs;
					predicate = $temp$predicate;
					list = $temp$list;
					continue dropWhile;
				} else {
					return list;
				}
			}
		}
	});
var $author$project$Session$LoggedIn$externalMsgToString = function (externalMsg) {
	switch (externalMsg.$) {
		case 0:
			return _List_fromArray(
				['UpdatedLoggedIn']);
		case 1:
			return _List_fromArray(
				['PopFromRouteHistory']);
		case 2:
			return _List_fromArray(
				['ShowInsufficientPermissionsModal']);
		case 3:
			return _List_fromArray(
				['AddedCommunity']);
		case 4:
			return _List_fromArray(
				['ExternalBroadcast']);
		case 5:
			return _List_fromArray(
				['ReloadResource']);
		case 6:
			return _List_fromArray(
				['RequestedReloadCommunityField']);
		case 7:
			return _List_fromArray(
				['RequestedCommunityField']);
		case 8:
			return _List_fromArray(
				['SetCommunityField']);
		case 9:
			return _List_fromArray(
				['RequiredPrivateKey']);
		case 10:
			return _List_fromArray(
				['RequiredAuthToken']);
		case 11:
			return _List_fromArray(
				['RequestQuery']);
		case 12:
			return _List_fromArray(
				['ShowFeedback']);
		case 13:
			return _List_fromArray(
				['HideFeedback']);
		case 14:
			return _List_fromArray(
				['ShowCodeOfConductModal']);
		case 15:
			var subMsg = externalMsg.a;
			return A2(
				$elm$core$List$cons,
				'ExternalActionMsg',
				$author$project$Action$msgToString(subMsg));
		default:
			return _List_fromArray(
				['ChangedPin']);
	}
};
var $author$project$Community$MembersValue = function (a) {
	return {$: 2, a: a};
};
var $author$project$Community$NewsValue = function (a) {
	return {$: 3, a: a};
};
var $author$project$Community$ObjectivesValue = function (a) {
	return {$: 0, a: a};
};
var $author$project$Community$ShopCategories = function (a) {
	return {$: 4, a: a};
};
var $author$project$Community$UploadsValue = function (a) {
	return {$: 1, a: a};
};
var $author$project$Cambiatus$Object$Community$categories = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'categories',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Cambiatus$Object$Community$news = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'news',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Community$Objective = F6(
	function (id, description, creator, actions, community, isCompleted) {
		return {lP: actions, b9: community, mq: creator, bc: description, R: id, $7: isCompleted};
	});
var $author$project$Cambiatus$Enum$VerificationType$toString = function (enum____) {
	if (!enum____) {
		return 'AUTOMATIC';
	} else {
		return 'CLAIMABLE';
	}
};
var $author$project$Cambiatus$InputObject$encodeActionsInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'creator',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.mq, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'isCompleted',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.$7, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'validator',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aE, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'verificationType',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.lE,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Cambiatus$Enum$VerificationType$toString)))
			]));
};
var $author$project$Cambiatus$Object$Objective$actions = F2(
	function (fillInOptionals____, object____) {
		var filledInOptionals____ = fillInOptionals____(
			{nl: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
		var optionalArgs____ = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'input', filledInOptionals____.nl, $author$project$Cambiatus$InputObject$encodeActionsInput)
				]));
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'actions',
			optionalArgs____,
			object____,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
	});
var $author$project$Community$Metadata = F6(
	function (title, description, symbol, logo, creator, memberCount) {
		return {mq: creator, bc: description, hC: logo, gc: memberCount, e9: symbol, fb: title};
	});
var $author$project$Community$communitiesSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$Community$memberCount,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Eos$Account$nameSelectionSet($author$project$Cambiatus$Object$Community$creator),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, $author$project$Constants$defaultCommunityLogo, $author$project$Cambiatus$Object$Community$logo),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Eos$symbolSelectionSet($author$project$Cambiatus$Object$Community$symbol),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$Cambiatus$Object$Community$description,
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$Cambiatus$Object$Community$name,
						$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Community$Metadata)))))));
var $author$project$Cambiatus$Object$Objective$creatorId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'creatorId', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Action$ClaimEligibility = F3(
	function (status, availableAt, approvedCount) {
		return {gS: approvedCount, gU: availableAt, gE: status};
	});
var $author$project$Cambiatus$Object$ClaimEligibility$approvedCount = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'approvedCount', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$Cambiatus$Object$ClaimEligibility$availableAt = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe ScalarCodecs.DateTime)',
	'availableAt',
	_List_Nil,
	$elm$json$Json$Decode$nullable(
		$author$project$Cambiatus$Scalar$unwrapCodecs($author$project$Cambiatus$ScalarCodecs$codecs).ma.jc));
var $author$project$Cambiatus$Enum$ClaimEligibilityStatus$Available = 0;
var $author$project$Cambiatus$Enum$ClaimEligibilityStatus$Completed = 1;
var $author$project$Cambiatus$Enum$ClaimEligibilityStatus$Cooldown = 2;
var $author$project$Cambiatus$Enum$ClaimEligibilityStatus$Pending = 3;
var $author$project$Cambiatus$Enum$ClaimEligibilityStatus$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'AVAILABLE':
				return $elm$json$Json$Decode$succeed(0);
			case 'COMPLETED':
				return $elm$json$Json$Decode$succeed(1);
			case 'COOLDOWN':
				return $elm$json$Json$Decode$succeed(2);
			case 'PENDING':
				return $elm$json$Json$Decode$succeed(3);
			default:
				return $elm$json$Json$Decode$fail('Invalid ClaimEligibilityStatus type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$ClaimEligibility$status = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.ClaimEligibilityStatus.ClaimEligibilityStatus', 'status', _List_Nil, $author$project$Cambiatus$Enum$ClaimEligibilityStatus$decoder);
var $author$project$Action$claimEligibilitySelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$ClaimEligibility$approvedCount,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Cambiatus$Object$ClaimEligibility$availableAt,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Cambiatus$Object$ClaimEligibility$status,
			$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Action$ClaimEligibility))));
var $author$project$Cambiatus$Object$Action$maxClaimsPerAccount = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe Int)',
	'maxClaimsPerAccount',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int));
var $author$project$Cambiatus$Object$Action$myClaimEligibility = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'myClaimEligibility',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$Action$selectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$Action$myClaimEligibility($author$project$Action$claimEligibilitySelectionSet),
	A2($dillonkearns$elm_graphql$Graphql$SelectionSet$with, $author$project$Cambiatus$Object$Action$maxClaimsPerAccount, $author$project$Action$actionFieldsSelectionSet));
var $author$project$Community$objectiveSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$Objective$isCompleted,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Cambiatus$Object$Objective$community($author$project$Community$communitiesSelectionSet),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			A2($author$project$Cambiatus$Object$Objective$actions, $elm$core$Basics$identity, $author$project$Action$selectionSet),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Eos$Account$nameSelectionSet($author$project$Cambiatus$Object$Objective$creatorId),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$Markdown$selectionSet($author$project$Cambiatus$Object$Objective$description),
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$Action$objectiveIdSelectionSet,
						$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Community$Objective)))))));
var $author$project$Cambiatus$Object$Community$objectives = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'objectives',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Shop$Category$treesSelectionSet = function (categoriesSelectionSet) {
	var isRoot = function (category) {
		return $elm_community$maybe_extra$Maybe$Extra$isNothing(category.h2);
	};
	var createTree = F2(
		function (children, root) {
			return A2(
				$zwilias$elm_rosetree$Tree$tree,
				root,
				A2(
					$elm$core$List$sortBy,
					A2(
						$elm$core$Basics$composeR,
						$zwilias$elm_rosetree$Tree$label,
						function ($) {
							return $.kC;
						}),
					A2(
						$elm$core$List$filterMap,
						function (child) {
							return _Utils_eq(
								child.h2,
								$elm$core$Maybe$Just(root.R)) ? $elm$core$Maybe$Just(
								A2(createTree, children, child)) : $elm$core$Maybe$Nothing;
						},
						children)));
		});
	return A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
		function (allCategories) {
			return A2(
				$elm$core$List$sortBy,
				A2(
					$elm$core$Basics$composeR,
					$zwilias$elm_rosetree$Tree$label,
					function ($) {
						return $.kC;
					}),
				A2(
					$elm$core$List$filterMap,
					function (category) {
						return isRoot(category) ? $elm$core$Maybe$Just(
							A2(createTree, allCategories, category)) : $elm$core$Maybe$Nothing;
					},
					allCategories));
		},
		categoriesSelectionSet($author$project$Shop$Category$selectionSet));
};
var $author$project$Cambiatus$Object$Community$uploads = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'uploads',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Community$selectionSetForField = function (field) {
	switch (field) {
		case 0:
			return A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
				$author$project$Community$ObjectivesValue,
				$author$project$Cambiatus$Object$Community$objectives($author$project$Community$objectiveSelectionSet));
		case 1:
			return A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
				$author$project$Community$UploadsValue,
				$author$project$Cambiatus$Object$Community$uploads($author$project$Cambiatus$Object$Upload$url));
		case 2:
			return A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
				$author$project$Community$MembersValue,
				$author$project$Cambiatus$Object$Community$members($author$project$Profile$minimalSelectionSet));
		case 3:
			return A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
				$author$project$Community$NewsValue,
				$author$project$Cambiatus$Object$Community$news($author$project$Community$News$selectionSet));
		default:
			return A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
				$author$project$Community$ShopCategories,
				$author$project$Shop$Category$treesSelectionSet($author$project$Cambiatus$Object$Community$categories));
	}
};
var $author$project$Community$fieldSelectionSet = F2(
	function (symbol, field) {
		return A2(
			$author$project$Cambiatus$Query$community,
			function (optionals) {
				return _Utils_update(
					optionals,
					{
						e9: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
							$author$project$Eos$symbolToString(symbol))
					});
			},
			$author$project$Community$selectionSetForField(field));
	});
var $author$project$Log$Fatal = 0;
var $author$project$Log$ImpossibleError = 1;
var $author$project$Log$TypeTag = function (a) {
	return {$: 0, a: a};
};
var $author$project$Log$fromImpossible = F5(
	function (transaction, message, maybeUser, location, contexts) {
		return {
			mm: contexts,
			nH: 0,
			nN: location,
			nS: message,
			pu: _List_fromArray(
				[
					$author$project$Log$TypeTag(1)
				]),
			pE: transaction,
			pM: maybeUser
		};
	});
var $krisajenkins$remotedata$RemoteData$isLoading = function (data) {
	if (data.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Community$isFieldLoading = F2(
	function (field, model) {
		switch (field) {
			case 0:
				return $krisajenkins$remotedata$RemoteData$isLoading(model.cy);
			case 1:
				return $krisajenkins$remotedata$RemoteData$isLoading(model.bs);
			case 2:
				return false;
			case 3:
				return $krisajenkins$remotedata$RemoteData$isLoading(model.eO);
			default:
				return $krisajenkins$remotedata$RemoteData$isLoading(model.e1);
		}
	});
var $krisajenkins$remotedata$RemoteData$withDefault = F2(
	function (_default, data) {
		if (data.$ === 3) {
			var x = data.a;
			return x;
		} else {
			return _default;
		}
	});
var $krisajenkins$remotedata$RemoteData$toMaybe = A2(
	$elm$core$Basics$composeR,
	$krisajenkins$remotedata$RemoteData$map($elm$core$Maybe$Just),
	$krisajenkins$remotedata$RemoteData$withDefault($elm$core$Maybe$Nothing));
var $author$project$Community$maybeFieldValue = F2(
	function (field, model) {
		switch (field) {
			case 0:
				return A2(
					$elm$core$Maybe$map,
					$author$project$Community$ObjectivesValue,
					$krisajenkins$remotedata$RemoteData$toMaybe(model.cy));
			case 1:
				return A2(
					$elm$core$Maybe$map,
					$author$project$Community$UploadsValue,
					$krisajenkins$remotedata$RemoteData$toMaybe(model.bs));
			case 2:
				return $elm$core$Maybe$Just(
					$author$project$Community$MembersValue(model.hG));
			case 3:
				return A2(
					$elm$core$Maybe$map,
					$author$project$Community$NewsValue,
					$krisajenkins$remotedata$RemoteData$toMaybe(model.eO));
			default:
				return A2(
					$elm$core$Maybe$map,
					$author$project$Community$ShopCategories,
					$krisajenkins$remotedata$RemoteData$toMaybe(model.e1));
		}
	});
var $author$project$Session$LoggedIn$profile = function (model) {
	return $krisajenkins$remotedata$RemoteData$toMaybe(model.kJ);
};
var $author$project$Session$LoggedIn$getInvitation = function (model) {
	var _v0 = $elm$core$List$head(model.gs);
	_v0$3:
	while (true) {
		if (!_v0.$) {
			switch (_v0.a.$) {
				case 41:
					var invitation = _v0.a.a;
					return $elm$core$Maybe$Just(invitation);
				case 3:
					var _v1 = _v0.a;
					var maybeInvitation = _v1.a;
					return maybeInvitation;
				case 2:
					var _v2 = _v0.a;
					var maybeInvitation = _v2.a;
					return maybeInvitation;
				default:
					break _v0$3;
			}
		} else {
			break _v0$3;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$Ports$storeSelectedCommunitySymbol = _Platform_outgoingPort('storeSelectedCommunitySymbol', $elm$json$Json$Encode$string);
var $elm_community$list_extra$List$Extra$updateIf = F3(
	function (predicate, update, list) {
		return A2(
			$elm$core$List$map,
			function (item) {
				return predicate(item) ? update(item) : item;
			},
			list);
	});
var $author$project$Session$LoggedIn$setCommunity = F2(
	function (community, model) {
		var shared = model.aM;
		var storeCommunityCmd = $author$project$Ports$storeSelectedCommunitySymbol(
			$author$project$Eos$symbolToString(community.e9));
		var sharedWithCommunity = _Utils_update(
			shared,
			{
				o7: $elm$core$Maybe$Just(community.e9)
			});
		var isMember = function () {
			var _v2 = $author$project$Session$LoggedIn$profile(model);
			if (!_v2.$) {
				var profile_ = _v2.a;
				return A2(
					$elm$core$List$any,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.e9;
						},
						$elm$core$Basics$eq(community.e9)),
					profile_.ei);
			} else {
				return A2(
					$elm$core$List$any,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.fl;
						},
						$elm$core$Basics$eq(model.lM)),
					community.hG);
			}
		}();
		if (isMember) {
			var newProfile = function () {
				var _v0 = $author$project$Session$LoggedIn$profile(model);
				if (_v0.$ === 1) {
					return model.kJ;
				} else {
					var profile_ = _v0.a;
					return $krisajenkins$remotedata$RemoteData$Success(
						_Utils_update(
							profile_,
							{
								ei: A3(
									$elm_community$list_extra$List$Extra$updateIf,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.e9;
										},
										$elm$core$Basics$eq(community.e9)),
									function (c) {
										return _Utils_update(
											c,
											{ck: community.ck, hC: community.hC, ki: community.ki});
									},
									profile_.ei)
							}));
				}
			}();
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						kJ: newProfile,
						o7: $krisajenkins$remotedata$RemoteData$Success(community),
						aM: sharedWithCommunity
					}),
				storeCommunityCmd);
		} else {
			if (community.cj) {
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							o7: $krisajenkins$remotedata$RemoteData$Success(community),
							aM: sharedWithCommunity
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2(
								$author$project$Route$pushUrl,
								shared.eM,
								$author$project$Route$Join(
									$elm$core$List$head(model.gs))),
								storeCommunityCmd
							])));
			} else {
				var _v1 = $author$project$Session$LoggedIn$getInvitation(model);
				if (!_v1.$) {
					var invitation = _v1.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								o7: $krisajenkins$remotedata$RemoteData$Success(community),
								aM: sharedWithCommunity
							}),
						A2(
							$author$project$Route$pushUrl,
							shared.eM,
							$author$project$Route$Invite(invitation)));
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								o7: $krisajenkins$remotedata$RemoteData$Success(community),
								aM: sharedWithCommunity
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2(
									$author$project$Route$pushUrl,
									shared.eM,
									$author$project$Route$CommunitySelector(
										$elm$core$List$head(model.gs))),
									storeCommunityCmd
								])));
				}
			}
		}
	});
var $author$project$Community$setFieldAsLoading = F2(
	function (field, model) {
		switch (field) {
			case 0:
				return _Utils_update(
					model,
					{cy: $krisajenkins$remotedata$RemoteData$Loading});
			case 1:
				return _Utils_update(
					model,
					{bs: $krisajenkins$remotedata$RemoteData$Loading});
			case 2:
				return model;
			case 3:
				return _Utils_update(
					model,
					{eO: $krisajenkins$remotedata$RemoteData$Loading});
			default:
				return _Utils_update(
					model,
					{e1: $krisajenkins$remotedata$RemoteData$Loading});
		}
	});
var $author$project$Community$setFieldValue = F2(
	function (fieldValue, model) {
		switch (fieldValue.$) {
			case 0:
				var objectives = fieldValue.a;
				return _Utils_update(
					model,
					{
						cy: $krisajenkins$remotedata$RemoteData$Success(objectives)
					});
			case 1:
				var uploads = fieldValue.a;
				return _Utils_update(
					model,
					{
						bs: $krisajenkins$remotedata$RemoteData$Success(uploads)
					});
			case 2:
				var members = fieldValue.a;
				return _Utils_update(
					model,
					{hG: members});
			case 3:
				var news = fieldValue.a;
				return _Utils_update(
					model,
					{
						eO: $krisajenkins$remotedata$RemoteData$Success(news)
					});
			default:
				var categories = fieldValue.a;
				return _Utils_update(
					model,
					{
						e1: $krisajenkins$remotedata$RemoteData$Success(categories)
					});
		}
	});
var $author$project$Session$LoggedIn$signUpForCommunity = F2(
	function (model, communityInfo) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{o7: $krisajenkins$remotedata$RemoteData$Loading}),
			A3(
				$author$project$Session$LoggedIn$internalQuery,
				model,
				$author$project$Community$symbolQuery(communityInfo.e9),
				$author$project$Session$LoggedIn$CompletedLoadCommunity));
	});
var $author$project$Session$LoggedIn$updateExternal = F2(
	function (externalMsg, model) {
		var shared = model.aM;
		var defaultResult = {bv: $elm$core$Maybe$Nothing, l$: $elm$core$Maybe$Nothing, g0: $elm$core$Platform$Cmd$none, nV: model};
		switch (externalMsg.$) {
			case 0:
				var newModel = externalMsg.a;
				return _Utils_update(
					defaultResult,
					{nV: newModel});
			case 1:
				var dropFn = externalMsg.a;
				return _Utils_update(
					defaultResult,
					{
						nV: _Utils_update(
							model,
							{
								gs: A2($elm_community$list_extra$List$Extra$dropWhile, dropFn, model.gs)
							})
					});
			case 2:
				return _Utils_update(
					defaultResult,
					{
						nV: _Utils_update(
							model,
							{bo: true})
					});
			case 3:
				var communityInfo = externalMsg.a;
				var _v1 = A2($author$project$Session$LoggedIn$signUpForCommunity, model, communityInfo);
				var newModel = _v1.a;
				var cmd = _v1.b;
				var profileWithCommunity = function () {
					var _v2 = $author$project$Session$LoggedIn$profile(newModel);
					if (_v2.$ === 1) {
						return newModel.kJ;
					} else {
						var profile_ = _v2.a;
						return $krisajenkins$remotedata$RemoteData$Success(
							_Utils_update(
								profile_,
								{
									ei: A2($elm$core$List$cons, communityInfo, profile_.ei)
								}));
					}
				}();
				return _Utils_update(
					defaultResult,
					{
						g0: cmd,
						nV: _Utils_update(
							newModel,
							{kJ: profileWithCommunity})
					});
			case 4:
				var broadcastMsg = externalMsg.a;
				switch (broadcastMsg.$) {
					case 0:
						var community = broadcastMsg.a;
						var _v4 = A2($author$project$Session$LoggedIn$setCommunity, community, model);
						var newModel = _v4.a;
						var cmd = _v4.b;
						return _Utils_update(
							defaultResult,
							{
								l$: $elm$core$Maybe$Just(broadcastMsg),
								g0: cmd,
								nV: newModel
							});
					case 1:
						var community = broadcastMsg.a;
						var field = broadcastMsg.b;
						return _Utils_update(
							defaultResult,
							{
								l$: $elm$core$Maybe$Just(broadcastMsg),
								nV: _Utils_update(
									model,
									{
										o7: $krisajenkins$remotedata$RemoteData$Success(
											A2($author$project$Community$setFieldValue, field, community))
									})
							});
					case 2:
						var profile_ = broadcastMsg.a;
						return _Utils_update(
							defaultResult,
							{
								l$: $elm$core$Maybe$Just(broadcastMsg),
								nV: _Utils_update(
									model,
									{
										kJ: $krisajenkins$remotedata$RemoteData$Success(profile_)
									})
							});
					case 3:
						var time = broadcastMsg.a;
						return _Utils_update(
							defaultResult,
							{
								l$: $elm$core$Maybe$Just(broadcastMsg),
								nV: _Utils_update(
									model,
									{
										aM: _Utils_update(
											shared,
											{gh: time})
									})
							});
					default:
						return _Utils_update(
							defaultResult,
							{
								l$: $elm$core$Maybe$Just(broadcastMsg)
							});
				}
			case 5:
				var _v5 = externalMsg.a;
				return _Utils_update(
					defaultResult,
					{
						g0: A3(
							$author$project$Session$LoggedIn$internalQuery,
							model,
							$author$project$Profile$query(model.lM),
							$author$project$Session$LoggedIn$CompletedLoadProfile)
					});
			case 7:
				var field = externalMsg.a;
				var _v6 = model.o7;
				if (_v6.$ === 3) {
					var community = _v6.a;
					if (A2($author$project$Community$isFieldLoading, field, community)) {
						return defaultResult;
					} else {
						var _v7 = A2($author$project$Community$maybeFieldValue, field, community);
						if (!_v7.$) {
							var fieldValue = _v7.a;
							return _Utils_update(
								defaultResult,
								{
									l$: $elm$core$Maybe$Just(
										A2($author$project$Session$LoggedIn$CommunityFieldLoaded, community, fieldValue))
								});
						} else {
							return _Utils_update(
								defaultResult,
								{
									g0: A3(
										$author$project$Session$LoggedIn$internalQuery,
										model,
										A2($author$project$Community$fieldSelectionSet, community.e9, field),
										$author$project$Session$LoggedIn$CompletedLoadCommunityField(community)),
									nV: _Utils_update(
										model,
										{
											o7: $krisajenkins$remotedata$RemoteData$Success(
												A2($author$project$Community$setFieldAsLoading, field, community))
										})
								});
						}
					}
				} else {
					return _Utils_update(
						defaultResult,
						{
							nV: _Utils_update(
								model,
								{
									bO: A2($elm$core$List$cons, field, model.bO)
								})
						});
				}
			case 6:
				var field = externalMsg.a;
				var _v8 = model.o7;
				if (_v8.$ === 3) {
					var community = _v8.a;
					return _Utils_update(
						defaultResult,
						{
							g0: A3(
								$author$project$Session$LoggedIn$internalQuery,
								model,
								A2($author$project$Community$fieldSelectionSet, community.e9, field),
								$author$project$Session$LoggedIn$CompletedLoadCommunityField(community))
						});
				} else {
					return _Utils_update(
						defaultResult,
						{
							nV: _Utils_update(
								model,
								{
									bO: A2($elm$core$List$cons, field, model.bO)
								})
						});
				}
			case 8:
				var value = externalMsg.a;
				var _v9 = model.o7;
				if (_v9.$ === 3) {
					var community = _v9.a;
					return _Utils_update(
						defaultResult,
						{
							nV: _Utils_update(
								model,
								{
									o7: $krisajenkins$remotedata$RemoteData$Success(
										A2($author$project$Community$setFieldValue, value, community))
								})
						});
				} else {
					return _Utils_update(
						defaultResult,
						{
							g0: A2(
								$author$project$Log$send,
								$author$project$Session$LoggedIn$externalMsgToString,
								A5(
									$author$project$Log$fromImpossible,
									externalMsg,
									'Tried setting community field, but community wasn\'t loaded',
									$elm$core$Maybe$Just(model.lM),
									{mX: 'updateExternal', nW: 'Session.LoggedIn'},
									_List_fromArray(
										[
											$author$project$Log$contextFromCommunity(model.o7)
										])))
						});
				}
			case 9:
				var afterAuthMsg = externalMsg.a;
				return _Utils_update(
					defaultResult,
					{
						bv: $elm$core$Maybe$Just(afterAuthMsg),
						nV: $author$project$Session$LoggedIn$askedAuthentication(model)
					});
			case 10:
				var callbackCmd = externalMsg.a.iU;
				return _Utils_update(
					defaultResult,
					{
						g0: $author$project$Utils$spawnMessage(
							$author$project$Session$LoggedIn$RequestedNewAuthTokenPhraseExternal(callbackCmd))
					});
			case 11:
				var queryCmd = externalMsg.a;
				return _Utils_update(
					defaultResult,
					{
						g0: A2($elm$core$Platform$Cmd$map, $author$project$Session$LoggedIn$RequestedQuery, queryCmd)
					});
			case 12:
				var status = externalMsg.a;
				var message = externalMsg.b;
				return _Utils_update(
					defaultResult,
					{
						nV: _Utils_update(
							model,
							{
								hf: A2($author$project$View$Feedback$Visible, status, message)
							})
					});
			case 13:
				return _Utils_update(
					defaultResult,
					{
						nV: _Utils_update(
							model,
							{hf: $author$project$View$Feedback$Hidden})
					});
			case 14:
				return _Utils_update(
					defaultResult,
					{
						nV: _Utils_update(
							model,
							{T: $author$project$Session$LoggedIn$CodeOfConductShown})
					});
			case 15:
				var subMsg = externalMsg.a;
				return _Utils_update(
					defaultResult,
					{
						g0: $author$project$Utils$spawnMessage(
							$author$project$Session$LoggedIn$GotActionMsg(subMsg))
					});
			default:
				var newPin = externalMsg.a;
				return _Utils_update(
					defaultResult,
					{
						nV: _Utils_update(
							model,
							{
								fp: A2($author$project$Auth$changeLastKnownPin, newPin, model.fp)
							})
					});
		}
	});
var $author$project$Main$updateLoggedInUResult = F4(
	function (toStatus, toMsg, model, uResult) {
		return function (_v4) {
			var model_ = _v4.a;
			var cmds_ = _v4.b;
			return _Utils_Tuple2(
				model_,
				$elm$core$Platform$Cmd$batch(
					A2(
						$elm$core$List$cons,
						A2(
							$elm$core$Platform$Cmd$map,
							toMsg,
							$elm$core$Platform$Cmd$batch(uResult.i0)),
						_Utils_ap(
							A2(
								$elm$core$List$map,
								A2(
									$elm$core$Basics$composeR,
									$author$project$Ports$mapAddress(toMsg),
									$author$project$Ports$javascriptOutCmd($author$project$Main$msgToString)),
								uResult.kB),
							_Utils_ap(
								A2(
									$elm$core$List$map,
									A2(
										$elm$core$Basics$composeR,
										$author$project$Log$map(toMsg),
										$author$project$Log$send($author$project$Main$msgToString)),
									uResult.jm),
								cmds_)))));
		}(
			A3(
				$elm$core$List$foldl,
				F2(
					function (commExtMsg, _v0) {
						var m = _v0.a;
						var cmds_ = _v0.b;
						var _v1 = _Utils_Tuple2(commExtMsg, m.c);
						if (_v1.b.$ === 1) {
							var loggedIn = _v1.b.a;
							var updateResult = A2($author$project$Session$LoggedIn$updateExternal, commExtMsg, loggedIn);
							var broadcastCmd = function () {
								var _v3 = updateResult.l$;
								if (_v3.$ === 1) {
									return $elm$core$Platform$Cmd$none;
								} else {
									var broadcastMsg = _v3.a;
									return A3($author$project$Main$broadcast, loggedIn, broadcastMsg, m.gE);
								}
							}();
							return _Utils_Tuple2(
								_Utils_update(
									m,
									{
										bv: A2(
											$elm$core$Maybe$map,
											function (_v2) {
												var successMsg = _v2.ik;
												var errorMsg = _v2.he;
												return {
													he: toMsg(errorMsg),
													ik: toMsg(successMsg)
												};
											},
											updateResult.bv),
										c: $author$project$Page$LoggedIn(updateResult.nV)
									}),
								A2(
									$elm$core$List$cons,
									A2(
										$elm$core$Platform$Cmd$map,
										A2(
											$elm$core$Basics$composeR,
											$author$project$Session$LoggedIn$mapMsg(toMsg),
											A2($elm$core$Basics$composeR, $author$project$Page$GotLoggedInMsg, $author$project$Main$GotPageMsg)),
										updateResult.g0),
									A2($elm$core$List$cons, broadcastCmd, cmds_)));
						} else {
							if (!_v1.a.$) {
								var loggedIn = _v1.a.a;
								return _Utils_Tuple2(
									_Utils_update(
										m,
										{
											c: $author$project$Page$LoggedIn(loggedIn)
										}),
									cmds_);
							} else {
								return _Utils_Tuple2(m, cmds_);
							}
						}
					}),
				_Utils_Tuple2(
					_Utils_update(
						model,
						{
							gE: toStatus(uResult.nV)
						}),
					_List_Nil),
				uResult.jo));
	});
var $author$project$Main$updatePageUResult = F4(
	function (toStatus, toMsg, model, uResult) {
		var _v0 = model.c;
		if (!_v0.$) {
			return A4(
				$author$project$Main$updateGuestUResult,
				toStatus,
				toMsg,
				model,
				A4(
					$author$project$UpdateResult$map,
					$elm$core$Basics$identity,
					$elm$core$Basics$identity,
					F2(
						function (extMsg, currUResult) {
							if (extMsg.$ === 1) {
								var guestMsg = extMsg.a;
								return A2($author$project$UpdateResult$addExt, guestMsg, currUResult);
							} else {
								return currUResult;
							}
						}),
					uResult));
		} else {
			return A4(
				$author$project$Main$updateLoggedInUResult,
				toStatus,
				toMsg,
				model,
				A4(
					$author$project$UpdateResult$map,
					$elm$core$Basics$identity,
					$elm$core$Basics$identity,
					F2(
						function (extMsg, currUResult) {
							if (extMsg.$ === 1) {
								return currUResult;
							} else {
								var loggedInMsg = extMsg.a;
								return A2($author$project$UpdateResult$addExt, loggedInMsg, currUResult);
							}
						}),
					uResult));
		}
	});
var $author$project$Main$updateSessionWith = F3(
	function (toMsg, model, _v0) {
		var session = _v0.a;
		var subCmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{c: session}),
			A2($elm$core$Platform$Cmd$map, toMsg, subCmd));
	});
var $author$project$Main$updateStatusWith = F4(
	function (toStatus, toMsg, model, _v0) {
		var subModel = _v0.a;
		var subCmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					gE: toStatus(subModel)
				}),
			A2($elm$core$Platform$Cmd$map, toMsg, subCmd));
	});
var $author$project$Main$changeRouteTo = F2(
	function (maybeRoute, model) {
		var updateStatus = F2(
			function (model_, newStatus) {
				return _Utils_update(
					model_,
					{gE: newStatus});
			});
		var session = model.c;
		var shared = function () {
			if (!session.$) {
				var guest = session.a;
				return guest.aM;
			} else {
				var loggedIn = session.a;
				return loggedIn.aM;
			}
		}();
		var noCmd = function (model_) {
			return _Utils_Tuple2(model_, $elm$core$Platform$Cmd$none);
		};
		var addRouteToHistory = F2(
			function (status, loggedIn) {
				var _v43 = A2(
					$author$project$Main$statusToRoute,
					status,
					$author$project$Page$LoggedIn(loggedIn));
				if (_v43.$ === 1) {
					return loggedIn;
				} else {
					var newRoute = _v43.a;
					var _v44 = loggedIn.gs;
					if (_v44.b && _v44.b.b) {
						var routeHistory = _v44;
						var _v45 = routeHistory.b;
						var second = _v45.a;
						var rest = _v45.b;
						return _Utils_eq(newRoute, second) ? _Utils_update(
							loggedIn,
							{
								fV: loggedIn.fV || _Utils_eq(second, $author$project$Route$Dashboard),
								gs: A2($elm$core$List$cons, newRoute, rest)
							}) : _Utils_update(
							loggedIn,
							{
								fV: loggedIn.fV || _Utils_eq(second, $author$project$Route$Dashboard),
								gs: A2($elm$core$List$cons, newRoute, routeHistory)
							});
					} else {
						var routeHistory = _v44;
						return _Utils_update(
							loggedIn,
							{
								gs: A2($elm$core$List$cons, newRoute, routeHistory)
							});
					}
				}
			});
		var withLoggedIn = F2(
			function (route, fn) {
				if (session.$ === 1) {
					var loggedIn = session.a;
					var _v41 = fn(loggedIn);
					var newModel = _v41.a;
					var newCmd = _v41.b;
					var newSession = function () {
						var _v42 = newModel.c;
						if (_v42.$ === 1) {
							var newLoggedIn = _v42.a;
							return $author$project$Page$LoggedIn(
								A2(addRouteToHistory, newModel.gE, newLoggedIn));
						} else {
							var guest = _v42.a;
							return $author$project$Page$Guest(guest);
						}
					}();
					return _Utils_Tuple2(
						_Utils_update(
							newModel,
							{c: newSession}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									newCmd,
									A2(
									$elm$core$Task$perform,
									A2(
										$elm$core$Basics$composeR,
										$author$project$Session$LoggedIn$GotTimeInternal,
										A2($elm$core$Basics$composeR, $author$project$Page$GotLoggedInMsg, $author$project$Main$GotPageMsg)),
									$elm$time$Time$now)
								])));
				} else {
					var guest = session.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								c: $author$project$Page$Guest(
									A2($author$project$Session$Guest$addAfterLoginRedirect, route, guest)),
								gE: $author$project$Main$Redirect
							}),
						A2(
							$author$project$Route$replaceUrl,
							shared.eM,
							$author$project$Route$Join(
								$elm$core$Maybe$Just(route))));
				}
			});
		var addMaybeInvitation = F2(
			function (maybeInvitation, model_) {
				var _v39 = model_.c;
				if (_v39.$ === 1) {
					return model_;
				} else {
					var guest = _v39.a;
					return _Utils_update(
						model_,
						{
							c: $author$project$Page$Guest(
								_Utils_update(
									guest,
									{j8: maybeInvitation}))
						});
				}
			});
		var addAfterLoginRedirect = F2(
			function (maybeRedirect, model_) {
				var _v37 = model_.c;
				if (_v37.$ === 1) {
					return model_;
				} else {
					var guest = _v37.a;
					if (maybeRedirect.$ === 1) {
						return model_;
					} else {
						var redirect = maybeRedirect.a;
						return _Utils_update(
							model_,
							{
								c: $author$project$Page$Guest(
									A2($author$project$Session$Guest$addAfterLoginRedirect, redirect, guest))
							});
					}
				}
			});
		var withGuest = F3(
			function (maybeInvitation, maybeRedirect, fn) {
				if (session.$ === 1) {
					return _Utils_Tuple2(
						model,
						A2(
							$author$project$Route$replaceUrl,
							shared.eM,
							A2($elm$core$Maybe$withDefault, $author$project$Route$Dashboard, maybeRedirect)));
				} else {
					var guest = session.a;
					var _v36 = fn(guest);
					var newModel = _v36.a;
					var newCmd = _v36.b;
					return _Utils_Tuple2(
						A2(
							addMaybeInvitation,
							maybeInvitation,
							A2(addAfterLoginRedirect, maybeRedirect, newModel)),
						newCmd);
				}
			});
		var withSession = F2(
			function (route, fn) {
				var _v33 = fn(session);
				var newModel = _v33.a;
				var newCmd = _v33.b;
				var _v34 = newModel.c;
				if (_v34.$ === 1) {
					var loggedIn = _v34.a;
					var newSession = $author$project$Page$LoggedIn(
						A2(addRouteToHistory, newModel.gE, loggedIn));
					return _Utils_Tuple2(
						_Utils_update(
							newModel,
							{c: newSession}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									newCmd,
									A2(
									$elm$core$Task$perform,
									A2(
										$elm$core$Basics$composeR,
										$author$project$Session$LoggedIn$GotTimeInternal,
										A2($elm$core$Basics$composeR, $author$project$Page$GotLoggedInMsg, $author$project$Main$GotPageMsg)),
									$elm$time$Time$now)
								])));
				} else {
					return _Utils_Tuple2(
						A2(
							addAfterLoginRedirect,
							$elm$core$Maybe$Just(route),
							newModel),
						newCmd);
				}
			});
		if (maybeRoute.$ === 1) {
			return noCmd(
				A2(updateStatus, model, $author$project$Main$NotFound));
		} else {
			switch (maybeRoute.a.$) {
				case 0:
					var _v1 = maybeRoute.a;
					return _Utils_Tuple2(
						model,
						A2($author$project$Route$replaceUrl, shared.eM, $author$project$Route$Dashboard));
				case 1:
					var _v2 = maybeRoute.a;
					return noCmd(
						A2(updateStatus, model, $author$project$Main$ComingSoon));
				case 2:
					var _v3 = maybeRoute.a;
					var invitation = _v3.a;
					var maybeRedirect = _v3.b;
					return A3(
						withGuest,
						invitation,
						maybeRedirect,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Page$Register$init(invitation),
							A3(
								$author$project$Main$updateStatusWith,
								A2($author$project$Main$Register, invitation, maybeRedirect),
								$author$project$Main$GotRegisterMsg,
								model)));
				case 35:
					var _v4 = maybeRoute.a;
					return A2(
						withLoggedIn,
						$author$project$Route$Settings,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Page$Settings$init,
							A3($author$project$Main$updateStatusWith, $author$project$Main$Settings, $author$project$Main$GotSettingsMsg, model)));
				case 3:
					var _v5 = maybeRoute.a;
					var maybeInvitation = _v5.a;
					var maybeRedirect = _v5.b;
					return A3(
						withGuest,
						maybeInvitation,
						maybeRedirect,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Page$Login$init,
							A3(
								$author$project$Main$updateGuestUResult,
								$author$project$Main$Login(maybeRedirect),
								$author$project$Main$GotLoginMsg,
								model)));
				case 16:
					var config = maybeRoute.a.a;
					return A2(
						withLoggedIn,
						$author$project$Route$News(config),
						A2(
							$elm$core$Basics$composeR,
							$author$project$Page$News$init(config),
							A3($author$project$Main$updateLoggedInUResult, $author$project$Main$News, $author$project$Main$GotNewsMsg, model)));
				case 10:
					var accountName = maybeRoute.a.a;
					return A2(
						withLoggedIn,
						$author$project$Route$PaymentHistory(accountName),
						A2(
							$elm$core$Basics$composeR,
							$author$project$Page$PaymentHistory$init(accountName),
							A3($author$project$Main$updateStatusWith, $author$project$Main$PaymentHistory, $author$project$Main$GotPaymentHistoryMsg, model)));
				case 4:
					var _v6 = maybeRoute.a;
					return A2(
						withLoggedIn,
						$author$project$Route$Dashboard,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Page$logout,
							A2($author$project$Main$updateSessionWith, $author$project$Main$GotPageMsg, model)));
				case 5:
					var _v7 = maybeRoute.a;
					return A2(
						withLoggedIn,
						$author$project$Route$Notification,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Page$Notification$init,
							A3($author$project$Main$updateLoggedInUResult, $author$project$Main$Notification, $author$project$Main$GotNotificationMsg, model)));
				case 11:
					var profileName = maybeRoute.a.a;
					return A2(
						withLoggedIn,
						$author$project$Route$Profile(profileName),
						A2(
							$elm$core$Basics$composeR,
							function (loggedIn) {
								return A2($author$project$Page$Profile$init, loggedIn, profileName);
							},
							A3($author$project$Main$updateLoggedInUResult, $author$project$Main$Profile, $author$project$Main$GotProfileMsg, model)));
				case 6:
					var _v8 = maybeRoute.a;
					return A2(
						withLoggedIn,
						$author$project$Route$ProfileEditor,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Page$Profile$Editor$init,
							A3($author$project$Main$updateStatusWith, $author$project$Main$ProfileEditor, $author$project$Main$GotProfileEditorMsg, model)));
				case 7:
					var _v9 = maybeRoute.a;
					return A2(
						withLoggedIn,
						$author$project$Route$ProfileAddKyc,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Page$Profile$AddKyc$init,
							A3($author$project$Main$updateStatusWith, $author$project$Main$ProfileAddKyc, $author$project$Main$GotProfileAddKycMsg, model)));
				case 8:
					var account = maybeRoute.a.a;
					return A2(
						withLoggedIn,
						$author$project$Route$ProfileClaims(account),
						A2(
							$elm$core$Basics$composeR,
							function (l) {
								return A2($author$project$Page$Profile$Claims$init, l, account);
							},
							A3($author$project$Main$updateStatusWith, $author$project$Main$ProfileClaims, $author$project$Main$GotProfileClaimsMsg, model)));
				case 9:
					var _v10 = maybeRoute.a;
					return A2(
						withLoggedIn,
						$author$project$Route$ProfileAddContact,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Page$Profile$AddContact$init,
							A3($author$project$Main$updateStatusWith, $author$project$Main$ProfileAddContact, $author$project$Main$GotProfileAddContactMsg, model)));
				case 12:
					var _v11 = maybeRoute.a;
					return A2(
						withLoggedIn,
						$author$project$Route$Dashboard,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Page$Dashboard$init,
							A3($author$project$Main$updateStatusWith, $author$project$Main$Dashboard, $author$project$Main$GotDashboardMsg, model)));
				case 13:
					var _v12 = maybeRoute.a;
					return A2(
						withLoggedIn,
						$author$project$Route$CommunityAbout,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Page$Community$About$init,
							A3($author$project$Main$updateLoggedInUResult, $author$project$Main$CommunityAbout, $author$project$Main$GotCommunityAboutMsg, model)));
				case 14:
					var selectedObjective = maybeRoute.a.a;
					return A2(
						withLoggedIn,
						$author$project$Route$CommunityObjectives(selectedObjective),
						A2(
							$elm$core$Basics$composeR,
							$author$project$Page$Community$Objectives$init(selectedObjective),
							A3($author$project$Main$updateLoggedInUResult, $author$project$Main$CommunityObjectives, $author$project$Main$GotCommunityObjectivesMsg, model)));
				case 17:
					var _v13 = maybeRoute.a;
					return noCmd(
						A2(updateStatus, model, $author$project$Main$AdminMoved));
				case 32:
					var _v14 = maybeRoute.a;
					return noCmd(
						A2(updateStatus, model, $author$project$Main$AdminMoved));
				case 18:
					var _v15 = maybeRoute.a;
					return noCmd(
						A2(updateStatus, model, $author$project$Main$AdminMoved));
				case 19:
					var _v16 = maybeRoute.a;
					return noCmd(
						A2(updateStatus, model, $author$project$Main$AdminMoved));
				case 20:
					var _v17 = maybeRoute.a;
					return noCmd(
						A2(updateStatus, model, $author$project$Main$AdminMoved));
				case 21:
					return noCmd(
						A2(updateStatus, model, $author$project$Main$AdminMoved));
				case 22:
					var _v18 = maybeRoute.a;
					return noCmd(
						A2(updateStatus, model, $author$project$Main$AdminMoved));
				case 23:
					var _v19 = maybeRoute.a;
					return noCmd(
						A2(updateStatus, model, $author$project$Main$AdminMoved));
				case 24:
					var _v20 = maybeRoute.a;
					return noCmd(
						A2(updateStatus, model, $author$project$Main$AdminMoved));
				case 25:
					var _v21 = maybeRoute.a;
					return noCmd(
						A2(updateStatus, model, $author$project$Main$AdminMoved));
				case 33:
					var maybeRedirect = maybeRoute.a.a;
					return A2(
						withLoggedIn,
						$author$project$Route$CommunitySelector(maybeRedirect),
						A2(
							$elm$core$Basics$composeR,
							$author$project$Page$Community$Selector$init(maybeRedirect),
							A3(
								$author$project$Main$updateStatusWith,
								$author$project$Main$CommunitySelector,
								function (_v22) {
									return $author$project$Main$Ignored;
								},
								model)));
				case 15:
					var _v23 = maybeRoute.a;
					return A2(
						withLoggedIn,
						$author$project$Route$NewCommunity,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Page$Community$New$init,
							A3($author$project$Main$updateStatusWith, $author$project$Main$CommunityEditor, $author$project$Main$GotCommunityEditorMsg, model)));
				case 26:
					var _v24 = maybeRoute.a;
					return noCmd(
						A2(updateStatus, model, $author$project$Main$AdminMoved));
				case 27:
					var _v25 = maybeRoute.a;
					return noCmd(
						A2(updateStatus, model, $author$project$Main$AdminMoved));
				case 28:
					return noCmd(
						A2(updateStatus, model, $author$project$Main$AdminMoved));
				case 29:
					return noCmd(
						A2(updateStatus, model, $author$project$Main$AdminMoved));
				case 30:
					var _v26 = maybeRoute.a;
					return noCmd(
						A2(updateStatus, model, $author$project$Main$AdminMoved));
				case 31:
					var _v27 = maybeRoute.a;
					return noCmd(
						A2(updateStatus, model, $author$project$Main$AdminMoved));
				case 34:
					var _v28 = maybeRoute.a;
					var objectiveId = _v28.a;
					var actionId = _v28.b;
					var claimId = _v28.c;
					return A2(
						withLoggedIn,
						A3($author$project$Route$Claim, objectiveId, actionId, claimId),
						A2(
							$elm$core$Basics$composeR,
							function (l) {
								return A2($author$project$Page$Dashboard$Claim$init, l, claimId);
							},
							A3(
								$author$project$Main$updateLoggedInUResult,
								A2($author$project$Main$Claim, objectiveId, actionId),
								$author$project$Main$GotVerifyClaimMsg,
								model)));
				case 36:
					var maybeFilter = maybeRoute.a.a;
					return A2(
						withLoggedIn,
						$author$project$Route$Shop(maybeFilter),
						A2(
							$elm$core$Basics$composeR,
							function (l) {
								return A2($author$project$Page$Shop$init, l, maybeFilter);
							},
							A3(
								$author$project$Main$updateLoggedInUResult,
								$author$project$Main$Shop(maybeFilter),
								$author$project$Main$GotShopMsg,
								model)));
				case 37:
					var step = maybeRoute.a.a;
					var newModelCmd = function (l) {
						var _v29 = model.gE;
						if (_v29.$ === 22) {
							var shopEditorModel = _v29.b;
							return A3($author$project$Page$Shop$Editor$maybeSetStep, l, step, shopEditorModel);
						} else {
							return $author$project$Page$Shop$Editor$initCreate(l);
						}
					};
					return A2(
						withLoggedIn,
						$author$project$Route$NewSale(step),
						A2(
							$elm$core$Basics$composeR,
							newModelCmd,
							A3(
								$author$project$Main$updateLoggedInUResult,
								$author$project$Main$ShopEditor($elm$core$Maybe$Nothing),
								$author$project$Main$GotShopEditorMsg,
								model)));
				case 38:
					var _v30 = maybeRoute.a;
					var saleId = _v30.a;
					var saleStep = _v30.b;
					var newUpdateResult = function (l) {
						var _v31 = model.gE;
						if (_v31.$ === 22) {
							var shopEditorModel = _v31.b;
							return A3($author$project$Page$Shop$Editor$maybeSetStep, l, saleStep, shopEditorModel);
						} else {
							return A3($author$project$Page$Shop$Editor$initUpdate, saleId, saleStep, l);
						}
					};
					return A2(
						withLoggedIn,
						A2($author$project$Route$EditSale, saleId, saleStep),
						A2(
							$elm$core$Basics$composeR,
							newUpdateResult,
							A3(
								$author$project$Main$updateLoggedInUResult,
								$author$project$Main$ShopEditor(
									$elm$core$Maybe$Just(saleId)),
								$author$project$Main$GotShopEditorMsg,
								model)));
				case 39:
					var saleId = maybeRoute.a.a;
					return A2(
						withSession,
						$author$project$Route$ViewSale(saleId),
						A2(
							$elm$core$Basics$composeR,
							function (s) {
								return A2($author$project$Page$Shop$Viewer$init, s, saleId);
							},
							A3(
								$author$project$Main$updatePageUResult,
								$author$project$Main$ShopViewer(saleId),
								$author$project$Main$GotShopViewerMsg,
								model)));
				case 40:
					var transferId = maybeRoute.a.a;
					return A2(
						withLoggedIn,
						$author$project$Route$ViewTransfer(transferId),
						A2(
							$elm$core$Basics$composeR,
							function (l) {
								return A2($author$project$Page$ViewTransfer$init, l, transferId);
							},
							A3(
								$author$project$Main$updateLoggedInUResult,
								$author$project$Main$ViewTransfer(transferId),
								$author$project$Main$GotViewTransferScreenMsg,
								model)));
				case 41:
					var invitationId = maybeRoute.a.a;
					return A2(
						withSession,
						$author$project$Route$Invite(invitationId),
						A2(
							$elm$core$Basics$composeR,
							function (s) {
								return A2($author$project$Page$Community$Invite$init, s, invitationId);
							},
							A3($author$project$Main$updateStatusWith, $author$project$Main$Invite, $author$project$Main$GotInviteMsg, model)));
				case 42:
					var maybeRedirect = maybeRoute.a.a;
					return A2(
						withSession,
						$author$project$Route$Join(maybeRedirect),
						A2(
							$elm$core$Basics$composeR,
							function (s) {
								return A2($author$project$Page$Join$init, s, maybeRedirect);
							},
							A3($author$project$Main$updateStatusWith, $author$project$Main$Join, $author$project$Main$GotJoinMsg, model)));
				case 43:
					var maybeTo = maybeRoute.a.a;
					return A2(
						withLoggedIn,
						$author$project$Route$Transfer(maybeTo),
						A2(
							$elm$core$Basics$composeR,
							function (l) {
								return A2($author$project$Page$Community$Transfer$init, l, maybeTo);
							},
							A3($author$project$Main$updateLoggedInUResult, $author$project$Main$Transfer, $author$project$Main$GotTransferMsg, model)));
				default:
					var _v32 = maybeRoute.a;
					return A2(
						withLoggedIn,
						$author$project$Route$Analysis,
						A2(
							$elm$core$Basics$composeR,
							function (l) {
								return $author$project$Page$Dashboard$Analysis$init(l);
							},
							A3($author$project$Main$updateLoggedInUResult, $author$project$Main$Analysis, $author$project$Main$GotAnalysisMsg, model)));
			}
		}
	});
var $author$project$Flags$Flags = function (language) {
	return function (version) {
		return function (maybeAccount) {
			return function (endpoints) {
				return function (logo) {
					return function (logoMobile) {
						return function (now) {
							return function (allowCommunityCreation) {
								return function (tokenContract) {
									return function (communityContract) {
										return function (authToken) {
											return function (canReadClipboard) {
												return function (canShare) {
													return function (useSubdomain) {
														return function (selectedCommunity) {
															return function (pinVisibility) {
																return {iK: allowCommunityCreation, iN: authToken, iV: canReadClipboard, iW: canShare, i4: communityContract, mJ: endpoints, hy: language, hC: logo, j3: logoMobile, j6: maybeAccount, gh: now, oF: pinVisibility, o7: selectedCommunity, ln: tokenContract, pL: useSubdomain, lF: version};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Version$Version = $elm$core$Basics$identity;
var $author$project$Version$decode = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string);
var $author$project$Flags$Endpoints = F3(
	function (eosio, api, graphql) {
		return {lW: api, mL: eosio, fS: graphql};
	});
var $author$project$Flags$decodeEndpoints = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'graphql',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'api',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'eosio',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Flags$Endpoints))));
var $author$project$Eos$Account$nameDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string);
var $author$project$Eos$maxSymbolLength = 7;
var $author$project$Eos$minSymbolLength = 3;
var $elm$core$String$toUpper = _String_toUpper;
var $author$project$Eos$symbolFromString = function (str) {
	var details = A2(
		$elm$core$List$take,
		2,
		A2($elm$core$String$split, ',', str));
	var maybePrecision = A2(
		$elm$core$Maybe$andThen,
		$elm$core$String$toInt,
		$elm$core$List$head(details));
	var maybeSymbolCode = $elm$core$List$head(
		$elm$core$List$reverse(details));
	var _v0 = _Utils_Tuple2(maybeSymbolCode, maybePrecision);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var symbolCode = _v0.a.a;
		var precision = _v0.b.a;
		return (A2($elm$core$String$all, $elm$core$Char$isAlpha, symbolCode) && ((_Utils_cmp(
			$elm$core$String$length(symbolCode),
			$author$project$Eos$minSymbolLength) > -1) || (_Utils_cmp(
			$elm$core$String$length(symbolCode),
			$author$project$Eos$maxSymbolLength) < 1))) ? $elm$core$Maybe$Just(
			A2(
				$author$project$Eos$Symbol,
				$elm$core$String$toUpper(symbolCode),
				precision)) : $elm$core$Maybe$Nothing;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Eos$symbolDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		if (string === 'undefined') {
			return $elm$json$Json$Decode$fail('Cannot decode \'undefined\' symbol, check Javascript');
		} else {
			var _v0 = $author$project$Eos$symbolFromString(string);
			if (!_v0.$) {
				var symbol = _v0.a;
				return $elm$json$Json$Decode$succeed(symbol);
			} else {
				return $elm$json$Json$Decode$fail('Cannot decode given symbol');
			}
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Graphql$Token = $elm$core$Basics$identity;
var $author$project$Api$Graphql$tokenDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string);
var $author$project$Flags$decode = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'pinVisibility',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'selectedCommunity',
		$elm$json$Json$Decode$nullable($author$project$Eos$symbolDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'useSubdomain',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'canShare',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'canReadClipboard',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'authToken',
						$elm$json$Json$Decode$nullable($author$project$Api$Graphql$tokenDecoder),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'communityContract',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'tokenContract',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'allowCommunityCreation',
									$elm$json$Json$Decode$bool,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'now',
										$elm$json$Json$Decode$int,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'logoMobile',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'logo',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'endpoints',
													$author$project$Flags$decodeEndpoints,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'accountName',
														$elm$json$Json$Decode$nullable($author$project$Eos$Account$nameDecoder),
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'version',
															$author$project$Version$decode,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'language',
																$elm$json$Json$Decode$string,
																$elm$json$Json$Decode$succeed($author$project$Flags$Flags)))))))))))))))));
var $author$project$Version$default = '1.0.0';
var $author$project$Flags$defaultEndpoints = {lW: 'https://api.cambiatus.io', mL: 'https://eosio.cambiatus.io', fS: 'https://api.cambiatus.io/api/graph'};
var $author$project$Flags$default = {iK: true, iN: $elm$core$Maybe$Nothing, iV: false, iW: false, i4: 'bes.cmm', mJ: $author$project$Flags$defaultEndpoints, hy: 'en-US', hC: '/images/logo-cambiatus.png', j3: '/images/logo-cambiatus-mobile.svg', j6: $elm$core$Maybe$Nothing, gh: 0, oF: false, o7: $elm$core$Maybe$Nothing, ln: 'bes.token', pL: true, lF: $author$project$Version$default};
var $elm$url$Url$Parser$State = F5(
	function (visited, unvisited, params, frag, value) {
		return {ci: frag, cA: params, b_: unvisited, pO: value, cP: visited};
	});
var $elm$url$Url$Parser$getFirstMatch = function (states) {
	getFirstMatch:
	while (true) {
		if (!states.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var state = states.a;
			var rest = states.b;
			var _v1 = state.b_;
			if (!_v1.b) {
				return $elm$core$Maybe$Just(state.pO);
			} else {
				if ((_v1.a === '') && (!_v1.b.b)) {
					return $elm$core$Maybe$Just(state.pO);
				} else {
					var $temp$states = rest;
					states = $temp$states;
					continue getFirstMatch;
				}
			}
		}
	}
};
var $elm$url$Url$Parser$removeFinalEmpty = function (segments) {
	if (!segments.b) {
		return _List_Nil;
	} else {
		if ((segments.a === '') && (!segments.b.b)) {
			return _List_Nil;
		} else {
			var segment = segments.a;
			var rest = segments.b;
			return A2(
				$elm$core$List$cons,
				segment,
				$elm$url$Url$Parser$removeFinalEmpty(rest));
		}
	}
};
var $elm$url$Url$Parser$preparePath = function (path) {
	var _v0 = A2($elm$core$String$split, '/', path);
	if (_v0.b && (_v0.a === '')) {
		var segments = _v0.b;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	} else {
		var segments = _v0;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	}
};
var $elm$url$Url$Parser$addToParametersHelp = F2(
	function (value, maybeList) {
		if (maybeList.$ === 1) {
			return $elm$core$Maybe$Just(
				_List_fromArray(
					[value]));
		} else {
			var list = maybeList.a;
			return $elm$core$Maybe$Just(
				A2($elm$core$List$cons, value, list));
		}
	});
var $elm$url$Url$Parser$addParam = F2(
	function (segment, dict) {
		var _v0 = A2($elm$core$String$split, '=', segment);
		if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
			var rawKey = _v0.a;
			var _v1 = _v0.b;
			var rawValue = _v1.a;
			var _v2 = $elm$url$Url$percentDecode(rawKey);
			if (_v2.$ === 1) {
				return dict;
			} else {
				var key = _v2.a;
				var _v3 = $elm$url$Url$percentDecode(rawValue);
				if (_v3.$ === 1) {
					return dict;
				} else {
					var value = _v3.a;
					return A3(
						$elm$core$Dict$update,
						key,
						$elm$url$Url$Parser$addToParametersHelp(value),
						dict);
				}
			}
		} else {
			return dict;
		}
	});
var $elm$url$Url$Parser$prepareQuery = function (maybeQuery) {
	if (maybeQuery.$ === 1) {
		return $elm$core$Dict$empty;
	} else {
		var qry = maybeQuery.a;
		return A3(
			$elm$core$List$foldr,
			$elm$url$Url$Parser$addParam,
			$elm$core$Dict$empty,
			A2($elm$core$String$split, '&', qry));
	}
};
var $elm$url$Url$Parser$parse = F2(
	function (_v0, url) {
		var parser = _v0;
		return $elm$url$Url$Parser$getFirstMatch(
			parser(
				A5(
					$elm$url$Url$Parser$State,
					_List_Nil,
					$elm$url$Url$Parser$preparePath(url.gm),
					$elm$url$Url$Parser$prepareQuery(url.dO),
					url.mW,
					$elm$core$Basics$identity)));
	});
var $author$project$Route$ComingSoon = {$: 1};
var $author$project$Route$CommunitySettings = {$: 17};
var $author$project$Route$CommunitySettingsContacts = {$: 31};
var $author$project$Route$CommunitySettingsCurrency = {$: 22};
var $author$project$Route$CommunitySettingsEditAction = F2(
	function (a, b) {
		return {$: 30, a: a, b: b};
	});
var $author$project$Route$CommunitySettingsEditObjective = function (a) {
	return {$: 28, a: a};
};
var $author$project$Route$CommunitySettingsFeatures = {$: 18};
var $author$project$Route$CommunitySettingsInfo = {$: 19};
var $author$project$Route$CommunitySettingsNewAction = function (a) {
	return {$: 29, a: a};
};
var $author$project$Route$CommunitySettingsNewObjective = {$: 27};
var $author$project$Route$CommunitySettingsNews = {$: 20};
var $author$project$Route$CommunitySettingsNewsEditor = function (a) {
	return {$: 21, a: a};
};
var $author$project$Route$CommunitySettingsObjectives = {$: 26};
var $author$project$Route$CommunitySettingsShopCategories = {$: 32};
var $author$project$Route$CommunitySettingsSponsorship = {$: 23};
var $author$project$Route$CommunitySettingsSponsorshipFiat = {$: 24};
var $author$project$Route$CommunitySettingsSponsorshipThankYouMessage = {$: 25};
var $author$project$Route$CopyNews = function (a) {
	return {$: 2, a: a};
};
var $author$project$Route$CreateNews = {$: 0};
var $author$project$Route$EditNews = function (a) {
	return {$: 1, a: a};
};
var $author$project$Route$Logout = {$: 4};
var $author$project$Route$Root = {$: 0};
var $author$project$Route$WithObjectiveSelected = function (a) {
	return {$: 0, a: a};
};
var $author$project$Shop$Category$idFromString = function (id) {
	return A2(
		$elm$core$Maybe$map,
		$elm$core$Basics$identity,
		$elm$core$String$toInt(id));
};
var $elm$url$Url$Parser$Parser = $elm$core$Basics$identity;
var $elm$url$Url$Parser$custom = F2(
	function (tipe, stringToSomething) {
		return function (_v0) {
			var visited = _v0.cP;
			var unvisited = _v0.b_;
			var params = _v0.cA;
			var frag = _v0.ci;
			var value = _v0.pO;
			if (!unvisited.b) {
				return _List_Nil;
			} else {
				var next = unvisited.a;
				var rest = unvisited.b;
				var _v2 = stringToSomething(next);
				if (!_v2.$) {
					var nextValue = _v2.a;
					return _List_fromArray(
						[
							A5(
							$elm$url$Url$Parser$State,
							A2($elm$core$List$cons, next, visited),
							rest,
							params,
							frag,
							value(nextValue))
						]);
				} else {
					return _List_Nil;
				}
			}
		};
	});
var $elm$url$Url$Parser$int = A2($elm$url$Url$Parser$custom, 'NUMBER', $elm$core$String$toInt);
var $elm$url$Url$Parser$mapState = F2(
	function (func, _v0) {
		var visited = _v0.cP;
		var unvisited = _v0.b_;
		var params = _v0.cA;
		var frag = _v0.ci;
		var value = _v0.pO;
		return A5(
			$elm$url$Url$Parser$State,
			visited,
			unvisited,
			params,
			frag,
			func(value));
	});
var $elm$url$Url$Parser$map = F2(
	function (subValue, _v0) {
		var parseArg = _v0;
		return function (_v1) {
			var visited = _v1.cP;
			var unvisited = _v1.b_;
			var params = _v1.cA;
			var frag = _v1.ci;
			var value = _v1.pO;
			return A2(
				$elm$core$List$map,
				$elm$url$Url$Parser$mapState(value),
				parseArg(
					A5($elm$url$Url$Parser$State, visited, unvisited, params, frag, subValue)));
		};
	});
var $author$project$Shop$idUrlParser = A2($elm$url$Url$Parser$map, $elm$core$Basics$identity, $elm$url$Url$Parser$int);
var $elm$url$Url$Parser$Internal$Parser = $elm$core$Basics$identity;
var $elm$url$Url$Parser$Query$map = F2(
	function (func, _v0) {
		var a = _v0;
		return function (dict) {
			return func(
				a(dict));
		};
	});
var $elm$url$Url$Parser$oneOf = function (parsers) {
	return function (state) {
		return A2(
			$elm$core$List$concatMap,
			function (_v0) {
				var parser = _v0;
				return parser(state);
			},
			parsers);
	};
};
var $elm$url$Url$Parser$query = function (_v0) {
	var queryParser = _v0;
	return function (_v1) {
		var visited = _v1.cP;
		var unvisited = _v1.b_;
		var params = _v1.cA;
		var frag = _v1.ci;
		var value = _v1.pO;
		return _List_fromArray(
			[
				A5(
				$elm$url$Url$Parser$State,
				visited,
				unvisited,
				params,
				frag,
				value(
					queryParser(params)))
			]);
	};
};
var $elm$url$Url$Parser$slash = F2(
	function (_v0, _v1) {
		var parseBefore = _v0;
		var parseAfter = _v1;
		return function (state) {
			return A2(
				$elm$core$List$concatMap,
				parseAfter,
				parseBefore(state));
		};
	});
var $elm$url$Url$Parser$questionMark = F2(
	function (parser, queryParser) {
		return A2(
			$elm$url$Url$Parser$slash,
			parser,
			$elm$url$Url$Parser$query(queryParser));
	});
var $elm$url$Url$Parser$s = function (str) {
	return function (_v0) {
		var visited = _v0.cP;
		var unvisited = _v0.b_;
		var params = _v0.cA;
		var frag = _v0.ci;
		var value = _v0.pO;
		if (!unvisited.b) {
			return _List_Nil;
		} else {
			var next = unvisited.a;
			var rest = unvisited.b;
			return _Utils_eq(next, str) ? _List_fromArray(
				[
					A5(
					$elm$url$Url$Parser$State,
					A2($elm$core$List$cons, next, visited),
					rest,
					params,
					frag,
					value)
				]) : _List_Nil;
		}
	};
};
var $author$project$Route$saleStepFromString = function (stepString) {
	_v0$4:
	while (true) {
		if (!stepString.$) {
			switch (stepString.a) {
				case 'mainInformation':
					return 0;
				case 'images':
					return 1;
				case 'categories':
					return 2;
				case 'priceAndInventory':
					return 3;
				default:
					break _v0$4;
			}
		} else {
			break _v0$4;
		}
	}
	return 0;
};
var $elm$url$Url$Parser$string = A2($elm$url$Url$Parser$custom, 'STRING', $elm$core$Maybe$Just);
var $elm$url$Url$Parser$Query$custom = F2(
	function (key, func) {
		return function (dict) {
			return func(
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2($elm$core$Dict$get, key, dict)));
		};
	});
var $elm$url$Url$Parser$Query$string = function (key) {
	return A2(
		$elm$url$Url$Parser$Query$custom,
		key,
		function (stringList) {
			if (stringList.b && (!stringList.b.b)) {
				var str = stringList.a;
				return $elm$core$Maybe$Just(str);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		});
};
var $author$project$Eos$Account$stringToName = function (string) {
	return string;
};
var $elm$url$Url$Parser$top = function (state) {
	return _List_fromArray(
		[state]);
};
var $author$project$Route$parseRedirect = F2(
	function (url, maybeQuery) {
		var protocol = function () {
			var _v1 = url.oU;
			if (!_v1) {
				return 'http://';
			} else {
				return 'https://';
			}
		}();
		var port_ = function () {
			var _v0 = url.oI;
			if (_v0.$ === 1) {
				return '';
			} else {
				var p = _v0.a;
				return ':' + $elm$core$String$fromInt(p);
			}
		}();
		var host = url.ez;
		return A2(
			$elm$core$Maybe$andThen,
			function (url_) {
				return A2(
					$elm$url$Url$Parser$parse,
					$author$project$Route$parser(url_),
					url_);
			},
			A2(
				$elm$core$Maybe$andThen,
				function (query) {
					return $elm$url$Url$fromString(
						_Utils_ap(
							protocol,
							_Utils_ap(
								host,
								_Utils_ap(port_, query))));
				},
				maybeQuery));
	});
var $author$project$Route$parser = function (url) {
	return $elm$url$Url$Parser$oneOf(
		_List_fromArray(
			[
				A2($elm$url$Url$Parser$map, $author$project$Route$Root, $elm$url$Url$Parser$top),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$ComingSoon,
				$elm$url$Url$Parser$s('coming-soon')),
				A2(
				$elm$url$Url$Parser$map,
				A2($elm$core$Basics$composeR, $elm$core$Maybe$Just, $author$project$Route$Register),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('register'),
					A2(
						$elm$url$Url$Parser$questionMark,
						$elm$url$Url$Parser$string,
						A2(
							$elm$url$Url$Parser$Query$map,
							$author$project$Route$parseRedirect(url),
							$elm$url$Url$Parser$Query$string('redirect'))))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$Register($elm$core$Maybe$Nothing),
				A2(
					$elm$url$Url$Parser$questionMark,
					$elm$url$Url$Parser$s('register'),
					A2(
						$elm$url$Url$Parser$Query$map,
						$author$project$Route$parseRedirect(url),
						$elm$url$Url$Parser$Query$string('redirect')))),
				A2(
				$elm$url$Url$Parser$map,
				A2($elm$core$Basics$composeR, $elm$core$Maybe$Just, $author$project$Route$Login),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('login'),
					A2(
						$elm$url$Url$Parser$questionMark,
						$elm$url$Url$Parser$string,
						A2(
							$elm$url$Url$Parser$Query$map,
							$author$project$Route$parseRedirect(url),
							$elm$url$Url$Parser$Query$string('redirect'))))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$Login($elm$core$Maybe$Nothing),
				A2(
					$elm$url$Url$Parser$questionMark,
					$elm$url$Url$Parser$s('login'),
					A2(
						$elm$url$Url$Parser$Query$map,
						$author$project$Route$parseRedirect(url),
						$elm$url$Url$Parser$Query$string('redirect')))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$Logout,
				$elm$url$Url$Parser$s('logout')),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$ProfileEditor,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('profile'),
					$elm$url$Url$Parser$s('edit'))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$ProfileAddKyc,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('profile'),
					$elm$url$Url$Parser$s('add-kyc'))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$ProfileAddContact,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('profile'),
					$elm$url$Url$Parser$s('add-contact'))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$Profile,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('profile'),
					A2($elm$url$Url$Parser$map, $author$project$Eos$Account$stringToName, $elm$url$Url$Parser$string))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$ProfileClaims,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('profile'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						$elm$url$Url$Parser$s('claims')))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$PaymentHistory,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('payments'),
					A2($elm$url$Url$Parser$map, $author$project$Eos$Account$stringToName, $elm$url$Url$Parser$string))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$Notification,
				$elm$url$Url$Parser$s('notification')),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$Dashboard,
				$elm$url$Url$Parser$s('dashboard')),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$NewCommunity,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('community'),
					$elm$url$Url$Parser$s('new'))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$News(
					{o8: $elm$core$Maybe$Nothing, pe: true}),
				$elm$url$Url$Parser$s('news')),
				A2(
				$elm$url$Url$Parser$map,
				F2(
					function (newsId, showOthers) {
						return $author$project$Route$News(
							{
								o8: $elm$core$Maybe$Just(newsId),
								pe: showOthers
							});
					}),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('news'),
					A2(
						$elm$url$Url$Parser$questionMark,
						$elm$url$Url$Parser$int,
						A2(
							$elm$url$Url$Parser$Query$map,
							function (showOthers) {
								return !_Utils_eq(
									showOthers,
									$elm$core$Maybe$Just('false'));
							},
							$elm$url$Url$Parser$Query$string('showOthers'))))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$CommunityAbout,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('community'),
					$elm$url$Url$Parser$s('about'))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$CommunityObjectives($author$project$Route$WithNoObjectiveSelected),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('community'),
					$elm$url$Url$Parser$s('objectives'))),
				A2(
				$elm$url$Url$Parser$map,
				function (objectiveId) {
					return $author$project$Route$CommunityObjectives(
						$author$project$Route$WithObjectiveSelected(
							{iG: $elm$core$Maybe$Nothing, R: objectiveId}));
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('community'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('objectives'),
						$elm$url$Url$Parser$int))),
				A2(
				$elm$url$Url$Parser$map,
				F2(
					function (objectiveId, actionId) {
						return $author$project$Route$CommunityObjectives(
							$author$project$Route$WithObjectiveSelected(
								{
									iG: $elm$core$Maybe$Just(actionId),
									R: objectiveId
								}));
					}),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('community'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('objectives'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$int,
							A2(
								$elm$url$Url$Parser$slash,
								$elm$url$Url$Parser$s('action'),
								$elm$url$Url$Parser$int))))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$CommunitySettings,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('community'),
					$elm$url$Url$Parser$s('settings'))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$CommunitySettingsFeatures,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('community'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('settings'),
						$elm$url$Url$Parser$s('features')))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$CommunitySettingsInfo,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('community'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('settings'),
						$elm$url$Url$Parser$s('info')))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$CommunitySettingsNews,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('community'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('settings'),
						$elm$url$Url$Parser$s('news')))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$CommunitySettingsNewsEditor($author$project$Route$CreateNews),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('community'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('settings'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('news'),
							$elm$url$Url$Parser$s('new'))))),
				A2(
				$elm$url$Url$Parser$map,
				A2($elm$core$Basics$composeR, $author$project$Route$EditNews, $author$project$Route$CommunitySettingsNewsEditor),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('community'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('settings'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('news'),
							A2(
								$elm$url$Url$Parser$slash,
								$elm$url$Url$Parser$s('edit'),
								$elm$url$Url$Parser$int))))),
				A2(
				$elm$url$Url$Parser$map,
				A2($elm$core$Basics$composeR, $author$project$Route$CopyNews, $author$project$Route$CommunitySettingsNewsEditor),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('community'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('settings'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('news'),
							A2(
								$elm$url$Url$Parser$slash,
								$elm$url$Url$Parser$s('copy'),
								$elm$url$Url$Parser$int))))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$CommunitySettingsCurrency,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('community'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('settings'),
						$elm$url$Url$Parser$s('currency')))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$CommunitySettingsSponsorship,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('community'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('settings'),
						$elm$url$Url$Parser$s('sponsorship')))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$CommunitySettingsSponsorshipFiat,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('community'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('settings'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('sponsorship'),
							$elm$url$Url$Parser$s('fiat'))))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$CommunitySettingsSponsorshipThankYouMessage,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('community'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('settings'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('sponsorship'),
							$elm$url$Url$Parser$s('thank-you'))))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$CommunitySettingsObjectives,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('community'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('settings'),
						$elm$url$Url$Parser$s('objectives')))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$CommunitySelector,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('community'),
					A2(
						$elm$url$Url$Parser$questionMark,
						$elm$url$Url$Parser$s('selector'),
						A2(
							$elm$url$Url$Parser$Query$map,
							$author$project$Route$parseRedirect(url),
							$elm$url$Url$Parser$Query$string('redirect'))))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$CommunitySettingsNewObjective,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('community'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('settings'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('objectives'),
							$elm$url$Url$Parser$s('new'))))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$CommunitySettingsEditObjective,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('community'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('settings'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('objectives'),
							A2(
								$elm$url$Url$Parser$slash,
								$elm$url$Url$Parser$int,
								$elm$url$Url$Parser$s('edit')))))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$CommunitySettingsNewAction,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('community'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('settings'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('objectives'),
							A2(
								$elm$url$Url$Parser$slash,
								$elm$url$Url$Parser$int,
								A2(
									$elm$url$Url$Parser$slash,
									$elm$url$Url$Parser$s('action'),
									$elm$url$Url$Parser$s('new'))))))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$CommunitySettingsEditAction,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('community'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('settings'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('objectives'),
							A2(
								$elm$url$Url$Parser$slash,
								$elm$url$Url$Parser$int,
								A2(
									$elm$url$Url$Parser$slash,
									$elm$url$Url$Parser$s('action'),
									A2(
										$elm$url$Url$Parser$slash,
										$elm$url$Url$Parser$int,
										$elm$url$Url$Parser$s('edit')))))))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$CommunitySettingsContacts,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('community'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('settings'),
						$elm$url$Url$Parser$s('contacts')))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$CommunitySettingsShopCategories,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('community'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('settings'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('shop'),
							$elm$url$Url$Parser$s('categories'))))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$Claim,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('objectives'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$int,
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('action'),
							A2(
								$elm$url$Url$Parser$slash,
								$elm$url$Url$Parser$int,
								A2(
									$elm$url$Url$Parser$slash,
									$elm$url$Url$Parser$s('claim'),
									$elm$url$Url$Parser$int)))))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$Settings,
				$elm$url$Url$Parser$s('settings')),
				A2(
				$elm$url$Url$Parser$map,
				F2(
					function (maybeOwner, categoriesIds) {
						return $author$project$Route$Shop(
							{cX: categoriesIds, oy: maybeOwner});
					}),
				A2(
					$elm$url$Url$Parser$questionMark,
					A2(
						$elm$url$Url$Parser$questionMark,
						$elm$url$Url$Parser$s('shop'),
						A2(
							$elm$url$Url$Parser$Query$map,
							$elm$core$Maybe$map($author$project$Eos$Account$stringToName),
							$elm$url$Url$Parser$Query$string('from'))),
					A2(
						$elm$url$Url$Parser$Query$map,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Maybe$map(
								A2(
									$elm$core$Basics$composeR,
									$elm$core$String$split(','),
									$elm$core$List$filterMap($author$project$Shop$Category$idFromString))),
							$elm$core$Maybe$withDefault(_List_Nil)),
						$elm$url$Url$Parser$Query$string('categories')))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$NewSale,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('shop'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('new'),
						A2(
							$elm$url$Url$Parser$questionMark,
							$elm$url$Url$Parser$s('sell'),
							A2(
								$elm$url$Url$Parser$Query$map,
								$author$project$Route$saleStepFromString,
								$elm$url$Url$Parser$Query$string('step')))))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$ViewSale,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('shop'),
					$author$project$Shop$idUrlParser)),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$EditSale,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('shop'),
					A2(
						$elm$url$Url$Parser$slash,
						$author$project$Shop$idUrlParser,
						A2(
							$elm$url$Url$Parser$questionMark,
							$elm$url$Url$Parser$s('edit'),
							A2(
								$elm$url$Url$Parser$Query$map,
								$author$project$Route$saleStepFromString,
								$elm$url$Url$Parser$Query$string('step')))))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$ViewTransfer,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('transfer'),
					$elm$url$Url$Parser$int)),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$Invite,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('invite'),
					$elm$url$Url$Parser$string)),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$Join,
				A2(
					$elm$url$Url$Parser$questionMark,
					$elm$url$Url$Parser$s('join'),
					A2(
						$elm$url$Url$Parser$Query$map,
						$author$project$Route$parseRedirect(url),
						$elm$url$Url$Parser$Query$string('redirect')))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$Transfer,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('community'),
					A2(
						$elm$url$Url$Parser$questionMark,
						$elm$url$Url$Parser$s('transfer'),
						A2(
							$elm$url$Url$Parser$Query$map,
							$elm$core$Maybe$map($author$project$Eos$Account$stringToName),
							$elm$url$Url$Parser$Query$string('to'))))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$Analysis,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('dashboard'),
					$elm$url$Url$Parser$s('analysis')))
			]));
};
var $author$project$Route$fromUrl = function (url) {
	return A2(
		$elm$url$Url$Parser$parse,
		$author$project$Route$parser(url),
		url);
};
var $author$project$Page$Ignored = {$: 0};
var $author$project$Page$GotTimezone = function (a) {
	return {$: 2, a: a};
};
var $elm$time$Time$here = _Time_here(0);
var $author$project$Page$fetchTimezone = A2($elm$core$Task$attempt, $author$project$Page$GotTimezone, $elm$time$Time$here);
var $author$project$Page$CompletedLoadTranslation = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$http$Http$get = function (r) {
	return $elm$http$Http$request(
		{fv: $elm$http$Http$emptyBody, fN: r.fN, m4: _List_Nil, bL: 'GET', am: $elm$core$Maybe$Nothing, lr: $elm$core$Maybe$Nothing, gL: r.gL});
};
var $author$project$Version$toString = function (_v0) {
	var version = _v0;
	return version;
};
var $author$project$I18Next$Translations = $elm$core$Basics$identity;
var $author$project$I18Next$foldTree = F3(
	function (initialValue, dict, namespace) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (key, val, acc) {
					var newNamespace = function (currentKey) {
						return $elm$core$String$isEmpty(namespace) ? currentKey : (namespace + ('.' + currentKey));
					};
					if (val.$ === 1) {
						var str = val.a;
						return A3(
							$elm$core$Dict$insert,
							newNamespace(key),
							str,
							acc);
					} else {
						var children = val.a;
						return A3(
							$author$project$I18Next$foldTree,
							acc,
							children,
							newNamespace(key));
					}
				}),
			initialValue,
			dict);
	});
var $author$project$I18Next$initialTranslations = $elm$core$Dict$empty;
var $author$project$I18Next$mapTreeToDict = function (tree) {
	if (!tree.$) {
		var dict = tree.a;
		return A3($author$project$I18Next$foldTree, $elm$core$Dict$empty, dict, '');
	} else {
		return $author$project$I18Next$initialTranslations;
	}
};
var $author$project$I18Next$Branch = function (a) {
	return {$: 0, a: a};
};
var $author$project$I18Next$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$lazy = function (thunk) {
	return A2(
		$elm$json$Json$Decode$andThen,
		thunk,
		$elm$json$Json$Decode$succeed(0));
};
function $author$project$I18Next$cyclic$treeDecoder() {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, $author$project$I18Next$Leaf, $elm$json$Json$Decode$string),
				$elm$json$Json$Decode$lazy(
				function (_v0) {
					return A2(
						$elm$json$Json$Decode$map,
						$author$project$I18Next$Branch,
						$elm$json$Json$Decode$dict(
							$author$project$I18Next$cyclic$treeDecoder()));
				})
			]));
}
var $author$project$I18Next$treeDecoder = $author$project$I18Next$cyclic$treeDecoder();
$author$project$I18Next$cyclic$treeDecoder = function () {
	return $author$project$I18Next$treeDecoder;
};
var $author$project$I18Next$translationsDecoder = A2($elm$json$Json$Decode$map, $author$project$I18Next$mapTreeToDict, $author$project$I18Next$treeDecoder);
var $author$project$Translation$get = F3(
	function (version, language, toMsg) {
		var translation = function () {
			switch (language) {
				case 0:
					return 'en-US.json';
				case 1:
					return 'pt-BR.json';
				case 2:
					return 'es-ES.json';
				case 3:
					return 'cat-CAT.json';
				default:
					return 'amh-ETH.json';
			}
		}();
		return $elm$http$Http$get(
			{
				fN: A2($elm$http$Http$expectJson, toMsg, $author$project$I18Next$translationsDecoder),
				gL: A2(
					$elm$url$Url$Builder$absolute,
					_List_fromArray(
						['translations', translation]),
					_List_fromArray(
						[
							A2(
							$elm$url$Url$Builder$string,
							'version',
							$author$project$Version$toString(version))
						]))
			});
	});
var $author$project$Page$fetchTranslations = F2(
	function (version, language) {
		return A3(
			$author$project$Translation$get,
			version,
			language,
			$author$project$Page$CompletedLoadTranslation(language));
	});
var $author$project$Session$LoggedIn$init = F3(
	function (shared, accountName, authToken) {
		var _v0 = A5($author$project$Session$LoggedIn$initModel, shared, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, accountName, authToken);
		var model = _v0.a;
		var cmd = _v0.b;
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A3(
						$author$project$Session$LoggedIn$internalQuery,
						model,
						$author$project$Profile$query(accountName),
						$author$project$Session$LoggedIn$CompletedLoadProfile),
						A2($author$project$Session$LoggedIn$fetchCommunity, model, $elm$core$Maybe$Nothing),
						A2($elm$core$Task$perform, $author$project$Session$LoggedIn$GotTimeInternal, $elm$time$Time$now),
						cmd,
						function () {
						if (authToken.$ === 1) {
							return $elm$core$Platform$Cmd$none;
						} else {
							var token = authToken.a;
							return $author$project$Api$Graphql$createAbsintheSocket(token);
						}
					}()
					])));
	});
var $author$project$Session$Shared$Bip39NotLoaded = {$: 1};
var $author$project$Session$Shared$LoadingTranslation = {$: 0};
var $author$project$Translation$defaultLanguage = 0;
var $author$project$Translation$Catalan = 3;
var $author$project$Translation$languageFromLanguageCode = function (locale) {
	var _v0 = $elm$core$String$toLower(locale);
	switch (_v0) {
		case 'en-us':
			return $elm$core$Maybe$Just(0);
		case 'pt-br':
			return $elm$core$Maybe$Just(1);
		case 'es':
			return $elm$core$Maybe$Just(2);
		case 'cat':
			return $elm$core$Maybe$Just(3);
		case 'amh':
			return $elm$core$Maybe$Just(4);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Translation$languageFromLocale = function (locale) {
	var _v0 = $elm$core$String$toLower(locale);
	switch (_v0) {
		case 'en-us':
			return $elm$core$Maybe$Just(0);
		case 'pt-br':
			return $elm$core$Maybe$Just(1);
		case 'es-es':
			return $elm$core$Maybe$Just(2);
		case 'ca-es':
			return $elm$core$Maybe$Just(3);
		case 'am-et':
			return $elm$core$Maybe$Just(4);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$I18Next$Curly = 0;
var $author$project$I18Next$t = F2(
	function (_v0, key) {
		var translations = _v0;
		return A2(
			$elm$core$Maybe$withDefault,
			key,
			A2($elm$core$Dict$get, key, translations));
	});
var $author$project$I18Next$delimsToTuple = function (delims) {
	return _Utils_Tuple2('{{', '}}');
};
var $author$project$I18Next$replacePlaceholders = F3(
	function (replacements, delims, string) {
		var _v0 = $author$project$I18Next$delimsToTuple(delims);
		var start = _v0.a;
		var end = _v0.b;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v1, acc) {
					var key = _v1.a;
					var value = _v1.b;
					return A3(
						$elm$core$String$replace,
						_Utils_ap(
							start,
							_Utils_ap(key, end)),
						value,
						acc);
				}),
			string,
			replacements);
	});
var $author$project$I18Next$tr = F4(
	function (_v0, delims, key, replacements) {
		var translations = _v0;
		return A2(
			$elm$core$Maybe$withDefault,
			key,
			A2(
				$elm$core$Maybe$map,
				A2($author$project$I18Next$replacePlaceholders, replacements, delims),
				A2($elm$core$Dict$get, key, translations)));
	});
var $author$project$Session$Shared$makeTranslators = function (translations) {
	var tr = A2($author$project$I18Next$tr, translations, 0);
	var t = $author$project$I18Next$t(translations);
	return {il: t, iu: tr};
};
var $elm$time$Time$utc = A2($elm$time$Time$Zone, 0, _List_Nil);
var $author$project$Session$Shared$init = F3(
	function (flags, navKey, url) {
		var maybeAccount = flags.j6;
		var endpoints = flags.mJ;
		var allowCommunityCreation = flags.iK;
		var tokenContract = flags.ln;
		var communityContract = flags.i4;
		var environment = $author$project$Environment$fromUrl(url);
		var addMatomoScriptCmd = A2(
			$author$project$Ports$javascriptOutCmd,
			function (_v2) {
				return _List_Nil;
			},
			$author$project$Ports$javascriptOut(
				{
					i9: $elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string('addMatomoScript'))
							])),
					kY: 0,
					kZ: $elm$json$Json$Encode$null
				}));
		return _Utils_Tuple2(
			{
				iK: allowCommunityCreation,
				ft: $author$project$Session$Shared$Bip39NotLoaded,
				iV: flags.iV,
				iW: flags.iW,
				mn: {b9: communityContract, pC: tokenContract},
				mJ: endpoints,
				mK: environment,
				hy: function () {
					var _v0 = $author$project$Translation$languageFromLanguageCode(flags.hy);
					if (!_v0.$) {
						var lang = _v0.a;
						return lang;
					} else {
						return A2(
							$elm$core$Maybe$withDefault,
							$author$project$Translation$defaultLanguage,
							$author$project$Translation$languageFromLocale(flags.hy));
					}
				}(),
				hC: flags.hC,
				j3: flags.j3,
				j6: maybeAccount,
				eM: navKey,
				gh: $elm$time$Time$millisToPosix(flags.gh),
				oF: flags.oF,
				o7: flags.o7,
				ll: $elm$time$Time$utc,
				fi: $author$project$I18Next$initialTranslations,
				bq: $author$project$Session$Shared$LoadingTranslation,
				iw: $author$project$Session$Shared$makeTranslators($author$project$I18Next$initialTranslations),
				gL: url,
				pL: flags.pL,
				lF: flags.lF
			},
			function () {
				if (environment === 3) {
					return addMatomoScriptCmd;
				} else {
					return $elm$core$Platform$Cmd$none;
				}
			}());
	});
var $author$project$Page$init = F3(
	function (flags, navKey, url) {
		var _v0 = A3($author$project$Session$Shared$init, flags, navKey, url);
		var shared = _v0.a;
		var sharedCmd = _v0.b;
		var initialCmds = $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2($author$project$Page$fetchTranslations, shared.lF, shared.hy),
					$author$project$Page$fetchTimezone,
					sharedCmd
				]));
		var _v1 = shared.j6;
		if (!_v1.$) {
			var accountName = _v1.a;
			var _v2 = A3($author$project$Session$LoggedIn$init, shared, accountName, flags.iN);
			var model = _v2.a;
			var cmd = _v2.b;
			return A2(
				$author$project$UpdateResult$addBreadcrumb,
				{fw: $author$project$Page$Ignored, i9: $elm$core$Dict$empty, nH: 4, nS: 'Started Elm app with loggedIn user', d0: 1},
				A2(
					$author$project$UpdateResult$addCmd,
					A2($elm$core$Platform$Cmd$map, $author$project$Page$GotLoggedInMsg, cmd),
					A2(
						$author$project$UpdateResult$addCmd,
						initialCmds,
						$author$project$UpdateResult$init(
							$author$project$Page$LoggedIn(model)))));
		} else {
			var _v3 = $author$project$Session$Guest$init(shared);
			var model = _v3.a;
			var cmd = _v3.b;
			return A2(
				$author$project$UpdateResult$addBreadcrumb,
				{fw: $author$project$Page$Ignored, i9: $elm$core$Dict$empty, nH: 4, nS: 'Started Elm app with guest user', d0: 1},
				A2(
					$author$project$UpdateResult$addCmd,
					A2($elm$core$Platform$Cmd$map, $author$project$Page$GotGuestMsg, cmd),
					A2(
						$author$project$UpdateResult$addCmd,
						initialCmds,
						$author$project$UpdateResult$init(
							$author$project$Page$Guest(model)))));
		}
	});
var $author$project$Log$DecodingError = 2;
var $author$project$Log$Error = 1;
var $author$project$Log$encodeDecodingError = function (error) {
	switch (error.$) {
		case 0:
			var fieldName = error.a;
			var fieldError = error.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('Decode.Field')),
						_Utils_Tuple2(
						'fieldName',
						$elm$json$Json$Encode$string(fieldName)),
						_Utils_Tuple2(
						'fieldError',
						$author$project$Log$encodeDecodingError(fieldError))
					]));
		case 1:
			var index = error.a;
			var indexError = error.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('Decode.Index')),
						_Utils_Tuple2(
						'index',
						$elm$json$Json$Encode$int(index)),
						_Utils_Tuple2(
						'indexError',
						$author$project$Log$encodeDecodingError(indexError))
					]));
		case 2:
			var errors = error.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('Decode.OneOf')),
						_Utils_Tuple2(
						'errors',
						A2($elm$json$Json$Encode$list, $author$project$Log$encodeDecodingError, errors))
					]));
		default:
			var failureString = error.a;
			var failureValue = error.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('Decode.Failure')),
						_Utils_Tuple2(
						'failureString',
						$elm$json$Json$Encode$string(failureString)),
						_Utils_Tuple2('failureValue', failureValue)
					]));
	}
};
var $author$project$Log$fromDecodeError = F6(
	function (transaction, maybeUser, description, location, contexts, error) {
		return {
			mm: A2(
				$elm$core$List$cons,
				{
					mR: $elm$core$Dict$fromList(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'Description',
								$elm$json$Json$Encode$string(description)),
								_Utils_Tuple2(
								'Error',
								$author$project$Log$encodeDecodingError(error))
							])),
					ki: 'Decode error'
				},
				contexts),
			nH: 1,
			nN: location,
			nS: 'Got an error when trying to decode a JSON value',
			pu: _List_fromArray(
				[
					$author$project$Log$TypeTag(2)
				]),
			pE: transaction,
			pM: maybeUser
		};
	});
var $author$project$UpdateResult$logEvent = F2(
	function (event, uResult) {
		return _Utils_update(
			uResult,
			{
				jm: A2($elm$core$List$cons, event, uResult.jm)
			});
	});
var $author$project$UpdateResult$logDecodingError = F6(
	function (transaction, maybeUser, description, location, contexts, error) {
		return $author$project$UpdateResult$logEvent(
			A6($author$project$Log$fromDecodeError, transaction, maybeUser, description, location, contexts, error));
	});
var $author$project$UpdateResult$toModelCmd = F3(
	function (transformEMsg, msgToString, uResult) {
		toModelCmd:
		while (true) {
			var _v0 = uResult.jo;
			if (_v0.b) {
				var ext = _v0.a;
				var extTail = _v0.b;
				var _v1 = A2(transformEMsg, ext, uResult.nV);
				var newM = _v1.a;
				var newCmd = _v1.b;
				var $temp$transformEMsg = transformEMsg,
					$temp$msgToString = msgToString,
					$temp$uResult = _Utils_update(
					uResult,
					{
						i0: _Utils_ap(
							uResult.i0,
							_List_fromArray(
								[newCmd])),
						jo: extTail,
						nV: newM
					});
				transformEMsg = $temp$transformEMsg;
				msgToString = $temp$msgToString;
				uResult = $temp$uResult;
				continue toModelCmd;
			} else {
				return _Utils_Tuple2(
					uResult.nV,
					$elm$core$Platform$Cmd$batch(
						_Utils_ap(
							uResult.i0,
							_Utils_ap(
								A2(
									$elm$core$List$map,
									$author$project$Log$addBreadcrumb(msgToString),
									$elm$core$List$reverse(uResult.Y)),
								_Utils_ap(
									A2(
										$elm$core$List$map,
										$author$project$Ports$javascriptOutCmd(msgToString),
										uResult.kB),
									A2(
										$elm$core$List$map,
										$author$project$Log$send(msgToString),
										$elm$core$List$reverse(uResult.jm)))))));
			}
		}
	});
var $author$project$Main$init = F3(
	function (flagsValue, url, navKey) {
		var _v0 = function () {
			var _v1 = A2($elm$json$Json$Decode$decodeValue, $author$project$Flags$decode, flagsValue);
			if (!_v1.$) {
				var flags = _v1.a;
				return A3(
					$author$project$UpdateResult$toModelCmd,
					F2(
						function (_v3, m) {
							return _Utils_Tuple2(m, $elm$core$Platform$Cmd$none);
						}),
					$author$project$Main$msgToString,
					A2(
						$author$project$UpdateResult$addBreadcrumb,
						{fw: $author$project$Main$Ignored, i9: $elm$core$Dict$empty, nH: 4, nS: 'Started elm app with flags being decoded', d0: 1},
						A4(
							$author$project$UpdateResult$map,
							$elm$core$Basics$identity,
							$author$project$Main$GotPageMsg,
							F2(
								function (_v2, uR) {
									return uR;
								}),
							A3($author$project$Page$init, flags, navKey, url))));
			} else {
				var e = _v1.a;
				return A3(
					$author$project$UpdateResult$toModelCmd,
					F2(
						function (_v5, m) {
							return _Utils_Tuple2(m, $elm$core$Platform$Cmd$none);
						}),
					$author$project$Main$msgToString,
					A7(
						$author$project$UpdateResult$logDecodingError,
						$author$project$Main$Ignored,
						$elm$core$Maybe$Nothing,
						'Could not decode flags',
						{mX: 'init', nW: 'Main'},
						_List_Nil,
						e,
						A4(
							$author$project$UpdateResult$map,
							$elm$core$Basics$identity,
							$author$project$Main$GotPageMsg,
							F2(
								function (_v4, uR) {
									return uR;
								}),
							A3($author$project$Page$init, $author$project$Flags$default, navKey, url))));
			}
		}();
		var session = _v0.a;
		var pageCmd = _v0.b;
		var _v6 = A2(
			$author$project$Main$changeRouteTo,
			$author$project$Route$fromUrl(url),
			{bv: $elm$core$Maybe$Nothing, bw: _List_Nil, cU: _List_Nil, c: session, gE: $author$project$Main$Redirect});
		var model = _v6.a;
		var routeCmd = _v6.b;
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[pageCmd, routeCmd])));
	});
var $author$project$Main$GotJavascriptData = function (a) {
	return {$: 3, a: a};
};
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $author$project$Ports$javascriptInPort = _Platform_incomingPort('javascriptInPort', $elm$json$Json$Decode$value);
var $elm$core$Platform$Sub$map = _Platform_map;
var $author$project$Session$Guest$PressedEsc = {$: 4};
var $elm$browser$Browser$Events$Document = 0;
var $elm$browser$Browser$Events$MySub = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$browser$Browser$Events$State = F2(
	function (subs, pids) {
		return {kA: pids, lh: subs};
	});
var $elm$browser$Browser$Events$init = $elm$core$Task$succeed(
	A2($elm$browser$Browser$Events$State, _List_Nil, $elm$core$Dict$empty));
var $elm$browser$Browser$Events$nodeToKey = function (node) {
	if (!node) {
		return 'd_';
	} else {
		return 'w_';
	}
};
var $elm$browser$Browser$Events$addKey = function (sub) {
	var node = sub.a;
	var name = sub.b;
	return _Utils_Tuple2(
		_Utils_ap(
			$elm$browser$Browser$Events$nodeToKey(node),
			name),
		sub);
};
var $elm$core$Dict$merge = F6(
	function (leftStep, bothStep, rightStep, leftDict, rightDict, initialResult) {
		var stepState = F3(
			function (rKey, rValue, _v0) {
				stepState:
				while (true) {
					var list = _v0.a;
					var result = _v0.b;
					if (!list.b) {
						return _Utils_Tuple2(
							list,
							A3(rightStep, rKey, rValue, result));
					} else {
						var _v2 = list.a;
						var lKey = _v2.a;
						var lValue = _v2.b;
						var rest = list.b;
						if (_Utils_cmp(lKey, rKey) < 0) {
							var $temp$rKey = rKey,
								$temp$rValue = rValue,
								$temp$_v0 = _Utils_Tuple2(
								rest,
								A3(leftStep, lKey, lValue, result));
							rKey = $temp$rKey;
							rValue = $temp$rValue;
							_v0 = $temp$_v0;
							continue stepState;
						} else {
							if (_Utils_cmp(lKey, rKey) > 0) {
								return _Utils_Tuple2(
									list,
									A3(rightStep, rKey, rValue, result));
							} else {
								return _Utils_Tuple2(
									rest,
									A4(bothStep, lKey, lValue, rValue, result));
							}
						}
					}
				}
			});
		var _v3 = A3(
			$elm$core$Dict$foldl,
			stepState,
			_Utils_Tuple2(
				$elm$core$Dict$toList(leftDict),
				initialResult),
			rightDict);
		var leftovers = _v3.a;
		var intermediateResult = _v3.b;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v4, result) {
					var k = _v4.a;
					var v = _v4.b;
					return A3(leftStep, k, v, result);
				}),
			intermediateResult,
			leftovers);
	});
var $elm$browser$Browser$Events$Event = F2(
	function (key, event) {
		return {jl: event, eF: key};
	});
var $elm$browser$Browser$Events$spawn = F3(
	function (router, key, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var actualNode = function () {
			if (!node) {
				return _Browser_doc;
			} else {
				return _Browser_window;
			}
		}();
		return A2(
			$elm$core$Task$map,
			function (value) {
				return _Utils_Tuple2(key, value);
			},
			A3(
				_Browser_on,
				actualNode,
				name,
				function (event) {
					return A2(
						$elm$core$Platform$sendToSelf,
						router,
						A2($elm$browser$Browser$Events$Event, key, event));
				}));
	});
var $elm$core$Dict$union = F2(
	function (t1, t2) {
		return A3($elm$core$Dict$foldl, $elm$core$Dict$insert, t2, t1);
	});
var $elm$browser$Browser$Events$onEffects = F3(
	function (router, subs, state) {
		var stepRight = F3(
			function (key, sub, _v6) {
				var deads = _v6.a;
				var lives = _v6.b;
				var news = _v6.c;
				return _Utils_Tuple3(
					deads,
					lives,
					A2(
						$elm$core$List$cons,
						A3($elm$browser$Browser$Events$spawn, router, key, sub),
						news));
			});
		var stepLeft = F3(
			function (_v4, pid, _v5) {
				var deads = _v5.a;
				var lives = _v5.b;
				var news = _v5.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, pid, deads),
					lives,
					news);
			});
		var stepBoth = F4(
			function (key, pid, _v2, _v3) {
				var deads = _v3.a;
				var lives = _v3.b;
				var news = _v3.c;
				return _Utils_Tuple3(
					deads,
					A3($elm$core$Dict$insert, key, pid, lives),
					news);
			});
		var newSubs = A2($elm$core$List$map, $elm$browser$Browser$Events$addKey, subs);
		var _v0 = A6(
			$elm$core$Dict$merge,
			stepLeft,
			stepBoth,
			stepRight,
			state.kA,
			$elm$core$Dict$fromList(newSubs),
			_Utils_Tuple3(_List_Nil, $elm$core$Dict$empty, _List_Nil));
		var deadPids = _v0.a;
		var livePids = _v0.b;
		var makeNewPids = _v0.c;
		return A2(
			$elm$core$Task$andThen,
			function (pids) {
				return $elm$core$Task$succeed(
					A2(
						$elm$browser$Browser$Events$State,
						newSubs,
						A2(
							$elm$core$Dict$union,
							livePids,
							$elm$core$Dict$fromList(pids))));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$sequence(makeNewPids);
				},
				$elm$core$Task$sequence(
					A2($elm$core$List$map, $elm$core$Process$kill, deadPids))));
	});
var $elm$browser$Browser$Events$onSelfMsg = F3(
	function (router, _v0, state) {
		var key = _v0.eF;
		var event = _v0.jl;
		var toMessage = function (_v2) {
			var subKey = _v2.a;
			var _v3 = _v2.b;
			var node = _v3.a;
			var name = _v3.b;
			var decoder = _v3.c;
			return _Utils_eq(subKey, key) ? A2(_Browser_decodeEvent, decoder, event) : $elm$core$Maybe$Nothing;
		};
		var messages = A2($elm$core$List$filterMap, toMessage, state.lh);
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Platform$sendToApp(router),
					messages)));
	});
var $elm$browser$Browser$Events$subMap = F2(
	function (func, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var decoder = _v0.c;
		return A3(
			$elm$browser$Browser$Events$MySub,
			node,
			name,
			A2($elm$json$Json$Decode$map, func, decoder));
	});
_Platform_effectManagers['Browser.Events'] = _Platform_createManager($elm$browser$Browser$Events$init, $elm$browser$Browser$Events$onEffects, $elm$browser$Browser$Events$onSelfMsg, 0, $elm$browser$Browser$Events$subMap);
var $elm$browser$Browser$Events$subscription = _Platform_leaf('Browser.Events');
var $elm$browser$Browser$Events$on = F3(
	function (node, name, decoder) {
		return $elm$browser$Browser$Events$subscription(
			A3($elm$browser$Browser$Events$MySub, node, name, decoder));
	});
var $elm$browser$Browser$Events$onKeyDown = A2($elm$browser$Browser$Events$on, 0, 'keydown');
var $author$project$Utils$escSubscription = function (toMsg) {
	return A2(
		$elm$core$Platform$Sub$map,
		function (_v0) {
			return toMsg;
		},
		$elm$browser$Browser$Events$onKeyDown(
			A2(
				$elm$json$Json$Decode$andThen,
				function (key) {
					return ((key === 'Esc') || (key === 'Escape')) ? $elm$json$Json$Decode$succeed(0) : $elm$json$Json$Decode$fail('Expecting Escape key');
				},
				A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string))));
};
var $author$project$Session$Guest$subscriptions = function (_v0) {
	return $author$project$Utils$escSubscription($author$project$Session$Guest$PressedEsc);
};
var $author$project$Search$CancelClicked = {$: 2};
var $author$project$Search$closeMsg = $author$project$Search$CancelClicked;
var $elm$time$Time$Every = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$State = F2(
	function (taggers, processes) {
		return {kI: processes, lk: taggers};
	});
var $elm$time$Time$init = $elm$core$Task$succeed(
	A2($elm$time$Time$State, $elm$core$Dict$empty, $elm$core$Dict$empty));
var $elm$time$Time$addMySub = F2(
	function (_v0, state) {
		var interval = _v0.a;
		var tagger = _v0.b;
		var _v1 = A2($elm$core$Dict$get, interval, state);
		if (_v1.$ === 1) {
			return A3(
				$elm$core$Dict$insert,
				interval,
				_List_fromArray(
					[tagger]),
				state);
		} else {
			var taggers = _v1.a;
			return A3(
				$elm$core$Dict$insert,
				interval,
				A2($elm$core$List$cons, tagger, taggers),
				state);
		}
	});
var $elm$time$Time$setInterval = _Time_setInterval;
var $elm$time$Time$spawnHelp = F3(
	function (router, intervals, processes) {
		if (!intervals.b) {
			return $elm$core$Task$succeed(processes);
		} else {
			var interval = intervals.a;
			var rest = intervals.b;
			var spawnTimer = $elm$core$Process$spawn(
				A2(
					$elm$time$Time$setInterval,
					interval,
					A2($elm$core$Platform$sendToSelf, router, interval)));
			var spawnRest = function (id) {
				return A3(
					$elm$time$Time$spawnHelp,
					router,
					rest,
					A3($elm$core$Dict$insert, interval, id, processes));
			};
			return A2($elm$core$Task$andThen, spawnRest, spawnTimer);
		}
	});
var $elm$time$Time$onEffects = F3(
	function (router, subs, _v0) {
		var processes = _v0.kI;
		var rightStep = F3(
			function (_v6, id, _v7) {
				var spawns = _v7.a;
				var existing = _v7.b;
				var kills = _v7.c;
				return _Utils_Tuple3(
					spawns,
					existing,
					A2(
						$elm$core$Task$andThen,
						function (_v5) {
							return kills;
						},
						$elm$core$Process$kill(id)));
			});
		var newTaggers = A3($elm$core$List$foldl, $elm$time$Time$addMySub, $elm$core$Dict$empty, subs);
		var leftStep = F3(
			function (interval, taggers, _v4) {
				var spawns = _v4.a;
				var existing = _v4.b;
				var kills = _v4.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, interval, spawns),
					existing,
					kills);
			});
		var bothStep = F4(
			function (interval, taggers, id, _v3) {
				var spawns = _v3.a;
				var existing = _v3.b;
				var kills = _v3.c;
				return _Utils_Tuple3(
					spawns,
					A3($elm$core$Dict$insert, interval, id, existing),
					kills);
			});
		var _v1 = A6(
			$elm$core$Dict$merge,
			leftStep,
			bothStep,
			rightStep,
			newTaggers,
			processes,
			_Utils_Tuple3(
				_List_Nil,
				$elm$core$Dict$empty,
				$elm$core$Task$succeed(0)));
		var spawnList = _v1.a;
		var existingDict = _v1.b;
		var killTask = _v1.c;
		return A2(
			$elm$core$Task$andThen,
			function (newProcesses) {
				return $elm$core$Task$succeed(
					A2($elm$time$Time$State, newTaggers, newProcesses));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v2) {
					return A3($elm$time$Time$spawnHelp, router, spawnList, existingDict);
				},
				killTask));
	});
var $elm$time$Time$onSelfMsg = F3(
	function (router, interval, state) {
		var _v0 = A2($elm$core$Dict$get, interval, state.lk);
		if (_v0.$ === 1) {
			return $elm$core$Task$succeed(state);
		} else {
			var taggers = _v0.a;
			var tellTaggers = function (time) {
				return $elm$core$Task$sequence(
					A2(
						$elm$core$List$map,
						function (tagger) {
							return A2(
								$elm$core$Platform$sendToApp,
								router,
								tagger(time));
						},
						taggers));
			};
			return A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$succeed(state);
				},
				A2($elm$core$Task$andThen, tellTaggers, $elm$time$Time$now));
		}
	});
var $elm$time$Time$subMap = F2(
	function (f, _v0) {
		var interval = _v0.a;
		var tagger = _v0.b;
		return A2(
			$elm$time$Time$Every,
			interval,
			A2($elm$core$Basics$composeL, f, tagger));
	});
_Platform_effectManagers['Time'] = _Platform_createManager($elm$time$Time$init, $elm$time$Time$onEffects, $elm$time$Time$onSelfMsg, 0, $elm$time$Time$subMap);
var $elm$time$Time$subscription = _Platform_leaf('Time');
var $elm$time$Time$every = F2(
	function (interval, tagger) {
		return $elm$time$Time$subscription(
			A2($elm$time$Time$Every, interval, tagger));
	});
var $elm$core$Platform$Sub$none = $elm$core$Platform$Sub$batch(_List_Nil);
var $author$project$Search$GotRecentSearches = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ports$gotRecentSearches = _Platform_incomingPort('gotRecentSearches', $elm$json$Json$Decode$string);
var $author$project$Search$subscriptions = $elm$core$Platform$Sub$batch(
	_List_fromArray(
		[
			$author$project$Ports$gotRecentSearches($author$project$Search$GotRecentSearches),
			$author$project$Utils$escSubscription($author$project$Search$CancelClicked)
		]));
var $author$project$Session$LoggedIn$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$core$Platform$Sub$map, $author$project$Session$LoggedIn$GotSearchMsg, $author$project$Search$subscriptions),
				A2($elm$time$Time$every, model.iA, $author$project$Session$LoggedIn$GotTimeInternal),
				model.aB ? $author$project$Utils$escSubscription(
				$author$project$Session$LoggedIn$ShowUserNav(false)) : $elm$core$Platform$Sub$none,
				function () {
				var _v0 = model.ah.X;
				if (!_v0.$) {
					return $elm$core$Platform$Sub$none;
				} else {
					return $author$project$Utils$escSubscription(
						$author$project$Session$LoggedIn$GotSearchMsg($author$project$Search$closeMsg));
				}
			}()
			]));
};
var $author$project$Page$subscriptions = function (session) {
	if (!session.$) {
		var guest = session.a;
		return A2(
			$elm$core$Platform$Sub$map,
			$author$project$Page$GotGuestMsg,
			$author$project$Session$Guest$subscriptions(guest));
	} else {
		var loggedIn = session.a;
		return A2(
			$elm$core$Platform$Sub$map,
			$author$project$Page$GotLoggedInMsg,
			$author$project$Session$LoggedIn$subscriptions(loggedIn));
	}
};
var $author$project$Main$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Main$GotPageMsg,
				$author$project$Page$subscriptions(model.c)),
				$author$project$Ports$javascriptInPort($author$project$Main$GotJavascriptData)
			]));
};
var $author$project$Log$ExpectedGuest = 1;
var $author$project$Log$ExpectedLoggedIn = 0;
var $author$project$Log$IncompatibleAuthentication = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Register$receiveBroadcast = function (broadcastMsg) {
	var community = broadcastMsg;
	return $elm$core$Maybe$Just(
		$author$project$Page$Register$CompletedLoadCommunity(community));
};
var $author$project$Main$broadcastGuest = F2(
	function (broadcastMessage, status) {
		var maybeMsg = function () {
			if (status.$ === 19) {
				return A2(
					$elm$core$Maybe$map,
					$author$project$Main$GotRegisterMsg,
					$author$project$Page$Register$receiveBroadcast(broadcastMessage));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		if (!maybeMsg.$) {
			var msg = maybeMsg.a;
			return $author$project$Utils$spawnMessage(msg);
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Main$hideFeedback = function (model) {
	var _v0 = model.c;
	if (_v0.$ === 1) {
		var loggedIn = _v0.a;
		return _Utils_update(
			model,
			{
				c: $author$project$Page$LoggedIn(
					_Utils_update(
						loggedIn,
						{hf: $author$project$View$Feedback$Hidden}))
			});
	} else {
		var guest = _v0.a;
		return _Utils_update(
			model,
			{
				c: $author$project$Page$Guest(
					_Utils_update(
						guest,
						{hf: $author$project$View$Feedback$Hidden}))
			});
	}
};
var $author$project$Api$Graphql$Password = $elm$core$Basics$identity;
var $author$project$Api$Graphql$decodeSignedPhrasePort = F2(
	function (toMsg, val) {
		return $elm$core$Result$toMaybe(
			A2(
				$elm$json$Json$Decode$decodeValue,
				A2(
					$elm$json$Json$Decode$map,
					A2($elm$core$Basics$composeR, $elm$core$Basics$identity, toMsg),
					A2($elm$json$Json$Decode$field, 'signed', $elm$json$Json$Decode$string)),
				val));
	});
var $author$project$Action$CopiedShareLinkToClipboard = function (a) {
	return {$: 2, a: a};
};
var $author$project$Action$NoOp = {$: 0};
var $author$project$Action$decodeId = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$int);
var $author$project$Action$jsAddressToMsg = F2(
	function (addr, val) {
		if (addr.b && (addr.a === 'ClickedShareAction')) {
			var _v1 = A2(
				$elm$json$Json$Decode$decodeValue,
				A3(
					$elm$json$Json$Decode$map2,
					F2(
						function (hasCopied, actionId) {
							return hasCopied ? $elm$core$Maybe$Just(actionId) : $elm$core$Maybe$Nothing;
						}),
					A2($elm$json$Json$Decode$field, 'copied', $elm$json$Json$Decode$bool),
					A2($elm$json$Json$Decode$field, 'addressData', $author$project$Action$decodeId)),
				val);
			if (!_v1.$) {
				if (!_v1.a.$) {
					var actionId = _v1.a.a;
					return $elm$core$Maybe$Just(
						$author$project$Action$CopiedShareLinkToClipboard(actionId));
				} else {
					var _v2 = _v1.a;
					return $elm$core$Maybe$Just($author$project$Action$NoOp);
				}
			} else {
				return $elm$core$Maybe$Just($author$project$Action$NoOp);
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Auth$GotPrivateKey = function (a) {
	return {$: 2, a: a};
};
var $author$project$Eos$Account$PrivateKey = $elm$core$Basics$identity;
var $author$project$Eos$Account$privateKeyDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string);
var $author$project$Auth$jsAddressToMsg = F2(
	function (addr, val) {
		if ((addr.b && (addr.a === 'SubmittedPin')) && (!addr.b.b)) {
			return $elm$core$Result$toMaybe(
				A2(
					$elm$json$Json$Decode$decodeValue,
					$elm$json$Json$Decode$oneOf(
						_List_fromArray(
							[
								A2(
								$elm$json$Json$Decode$map,
								A2($elm$core$Basics$composeR, $elm$core$Result$Ok, $author$project$Auth$GotPrivateKey),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'privateKey',
									$author$project$Eos$Account$privateKeyDecoder,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'accountName',
										$author$project$Eos$Account$nameDecoder,
										$elm$json$Json$Decode$succeed($elm$core$Tuple$pair)))),
								A2(
								$elm$json$Json$Decode$map,
								A2($elm$core$Basics$composeR, $elm$core$Result$Err, $author$project$Auth$GotPrivateKey),
								A2($elm$json$Json$Decode$field, 'error', $elm$json$Json$Decode$string))
							])),
					val));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Session$LoggedIn$jsAddressToMsg = F2(
	function (addr, val) {
		_v0$6:
		while (true) {
			if (addr.b) {
				switch (addr.a) {
					case 'GotAuthMsg':
						var remainAddress = addr.b;
						return A2(
							$elm$core$Maybe$map,
							$author$project$Session$LoggedIn$GotAuthMsg,
							A2($author$project$Auth$jsAddressToMsg, remainAddress, val));
					case 'CompletedLoadUnread':
						if (!addr.b.b) {
							return $elm$core$Result$toMaybe(
								A2(
									$elm$core$Result$map,
									$author$project$Session$LoggedIn$CompletedLoadUnread,
									A2(
										$elm$json$Json$Decode$decodeValue,
										A2($elm$json$Json$Decode$field, 'meta', $elm$json$Json$Decode$value),
										val)));
						} else {
							break _v0$6;
						}
					case 'ReceivedNewHighlightedNews':
						return $elm$core$Result$toMaybe(
							A2(
								$elm$core$Result$map,
								$author$project$Session$LoggedIn$ReceivedNewHighlightedNews,
								A2(
									$elm$json$Json$Decode$decodeValue,
									A2($elm$json$Json$Decode$field, 'meta', $elm$json$Json$Decode$value),
									val)));
					case 'GotActionMsg':
						var remainAddress = addr.b;
						return A2(
							$elm$core$Maybe$map,
							$author$project$Session$LoggedIn$GotActionMsg,
							A2($author$project$Action$jsAddressToMsg, remainAddress, val));
					case 'GotAuthTokenPhrase':
						return A2($author$project$Api$Graphql$decodeSignedPhrasePort, $author$project$Session$LoggedIn$SignedAuthTokenPhrase, val);
					case 'GotAuthTokenPhraseExternal':
						return A2($author$project$Api$Graphql$decodeSignedPhrasePort, $author$project$Session$LoggedIn$SignedAuthTokenPhrase, val);
					default:
						break _v0$6;
				}
			} else {
				break _v0$6;
			}
		}
		return $elm$core$Maybe$Nothing;
	});
var $author$project$Page$jsAddressToMsg = F2(
	function (addr, val) {
		if (addr.b && (addr.a === 'GotLoggedInMsg')) {
			var remainAddress = addr.b;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Page$GotLoggedInMsg,
				A2($author$project$Session$LoggedIn$jsAddressToMsg, remainAddress, val));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Page$Community$About$CopiedShareLinkToClipboard = {$: 4};
var $author$project$Page$Community$About$jsAddressToMsg = F2(
	function (addr, val) {
		if (addr.b && (addr.a === 'ClickedShareCommunity')) {
			var _v1 = A2(
				$elm$json$Json$Decode$decodeValue,
				A2($elm$json$Json$Decode$field, 'copied', $elm$json$Json$Decode$bool),
				val);
			if (!_v1.$) {
				if (_v1.a) {
					return $elm$core$Maybe$Just($author$project$Page$Community$About$CopiedShareLinkToClipboard);
				} else {
					return $elm$core$Maybe$Just($author$project$Page$Community$About$NoOp);
				}
			} else {
				return $elm$core$Maybe$Just($author$project$Page$Community$About$NoOp);
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Page$Community$New$GotCreateCommunityResponse = function (a) {
	return {$: 5, a: a};
};
var $author$project$Page$Community$New$Redirect = function (a) {
	return {$: 6, a: a};
};
var $author$project$Page$Community$New$StartedCreatingCommunity = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $author$project$Community$CreateCommunityData = function (cmmAsset) {
	return function (creator) {
		return function (logoUrl) {
			return function (name) {
				return function (description) {
					return function (subdomain) {
						return function (inviterReward) {
							return function (invitedReward) {
								return function (hasShop) {
									return function (hasObjectives) {
										return function (hasKyc) {
											return function (hasAutoInvite) {
												return function (website) {
													return {g1: cmmAsset, mq: creator, bc: description, cj: hasAutoInvite, ck: hasKyc, cl: hasObjectives, cm: hasShop, dl: invitedReward, dm: inviterReward, eJ: logoUrl, ki: name, pl: subdomain, cQ: website};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Markdown$decoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string);
var $author$project$Eos$EosFalse = 1;
var $author$project$Eos$EosTrue = 0;
var $author$project$Eos$intToEosBool = function (v) {
	return (v === 1) ? 0 : 1;
};
var $author$project$Eos$eosBoolDecoder = A2($elm$json$Json$Decode$map, $author$project$Eos$intToEosBool, $elm$json$Json$Decode$int);
var $author$project$Community$createCommunityDataDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'website',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'auto_invite',
		$author$project$Eos$eosBoolDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'has_kyc',
			$author$project$Eos$eosBoolDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'has_objectives',
				$author$project$Eos$eosBoolDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'has_shop',
					$author$project$Eos$eosBoolDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'invited_reward',
						$author$project$Eos$decodeAsset,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'inviter_reward',
							$author$project$Eos$decodeAsset,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'subdomain',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'description',
									$author$project$Markdown$decoder,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'name',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'logo',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'creator',
												$author$project$Eos$Account$nameDecoder,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'cmm_asset',
													$author$project$Eos$decodeAsset,
													$elm$json$Json$Decode$succeed($author$project$Community$CreateCommunityData))))))))))))));
var $author$project$Token$CreateTokenData = F4(
	function (creator, maxSupply, minBalance, tokenType) {
		return {mq: creator, nQ: maxSupply, nT: minBalance, pD: tokenType};
	});
var $author$project$Token$Expiry = 1;
var $author$project$Token$Mcc = 0;
var $author$project$Token$tokenTypeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (typeString) {
		switch (typeString) {
			case 'mcc':
				return $elm$json$Json$Decode$succeed(0);
			case 'expiry':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('Expected token type to be mcc or expiry');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Token$createTokenDataDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'type',
	$author$project$Token$tokenTypeDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'min_balance',
		$author$project$Eos$decodeAsset,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'max_supply',
			$author$project$Eos$decodeAsset,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'issuer',
				$author$project$Eos$Account$nameDecoder,
				$elm$json$Json$Decode$succeed($author$project$Token$CreateTokenData)))));
var $author$project$Page$Community$New$jsAddressToMsg = F2(
	function (addr, val) {
		_v0$2:
		while (true) {
			if (addr.b) {
				switch (addr.a) {
					case 'GotDomainAvailableResponse':
						var response = A2(
							$elm$json$Json$Decode$decodeValue,
							A3(
								$elm$json$Json$Decode$map2,
								$elm$core$Tuple$pair,
								A2($elm$json$Json$Decode$field, 'state', $elm$json$Json$Decode$string),
								A2(
									$elm$json$Json$Decode$field,
									'addressData',
									A3(
										$elm$json$Json$Decode$map2,
										$elm$core$Tuple$pair,
										A2($elm$json$Json$Decode$field, 'createCommunityData', $author$project$Community$createCommunityDataDecoder),
										A2($elm$json$Json$Decode$field, 'createTokenData', $author$project$Token$createTokenDataDecoder)))),
							val);
						_v1$2:
						while (true) {
							if (!response.$) {
								switch (response.a.a) {
									case 'starting':
										var _v2 = response.a;
										var _v3 = _v2.b;
										var createCommunityData = _v3.a;
										var createTokenData = _v3.b;
										return $elm$core$Maybe$Just(
											A2($author$project$Page$Community$New$StartedCreatingCommunity, createCommunityData, createTokenData));
									case 'responded':
										var _v4 = response.a;
										var _v5 = _v4.b;
										var createCommunityData = _v5.a;
										return $elm$core$Maybe$Just(
											$author$project$Page$Community$New$Redirect(createCommunityData));
									default:
										break _v1$2;
								}
							} else {
								break _v1$2;
							}
						}
						return $elm$core$Maybe$Nothing;
					case 'StartedCreatingCommunity':
						if (!addr.b.b) {
							return $elm$core$Maybe$Just(
								$author$project$Page$Community$New$GotCreateCommunityResponse(
									A2(
										$elm$core$Result$mapError,
										function (_v7) {
											return val;
										},
										A2(
											$elm$json$Json$Decode$decodeValue,
											A3(
												$elm$json$Json$Decode$map2,
												F2(
													function (_v6, symbol) {
														return symbol;
													}),
												A2($elm$json$Json$Decode$field, 'transactionId', $elm$json$Json$Decode$string),
												A2(
													$elm$json$Json$Decode$at,
													_List_fromArray(
														['addressData', 'symbol']),
													$author$project$Eos$symbolDecoder)),
											val))));
						} else {
							break _v0$2;
						}
					default:
						break _v0$2;
				}
			} else {
				break _v0$2;
			}
		}
		return $elm$core$Maybe$Nothing;
	});
var $author$project$Page$Community$Transfer$CreatedTransferSubscription = {$: 6};
var $author$project$Page$Community$Transfer$GotTransferResultFromWebSocket = function (a) {
	return {$: 8, a: a};
};
var $author$project$Page$Community$Transfer$GotTransferTransactionResult = function (a) {
	return {$: 7, a: a};
};
var $author$project$Page$Community$Transfer$jsAddressToMsg = F2(
	function (addr, val) {
		_v0$2:
		while (true) {
			if (addr.b && (!addr.b.b)) {
				switch (addr.a) {
					case 'SubmittedForm':
						var result = A2(
							$elm$json$Json$Decode$decodeValue,
							A2($elm$json$Json$Decode$field, 'state', $elm$json$Json$Decode$string),
							val);
						_v1$2:
						while (true) {
							if (!result.$) {
								switch (result.a) {
									case 'starting':
										return $elm$core$Maybe$Just($author$project$Page$Community$Transfer$CreatedTransferSubscription);
									case 'responded':
										return $elm$core$Result$toMaybe(
											A2(
												$elm$core$Result$map,
												$author$project$Page$Community$Transfer$GotTransferResultFromWebSocket,
												A2(
													$elm$json$Json$Decode$decodeValue,
													A2($elm$json$Json$Decode$field, 'data', $elm$json$Json$Decode$value),
													val)));
									default:
										break _v1$2;
								}
							} else {
								break _v1$2;
							}
						}
						return $elm$core$Maybe$Nothing;
					case 'CreatedTransferSubscription':
						return A2(
							$elm$core$Result$withDefault,
							$elm$core$Maybe$Nothing,
							A2(
								$elm$core$Result$map,
								A2($elm$core$Basics$composeL, $elm$core$Maybe$Just, $author$project$Page$Community$Transfer$GotTransferTransactionResult),
								A2(
									$elm$json$Json$Decode$decodeValue,
									$elm$json$Json$Decode$oneOf(
										_List_fromArray(
											[
												A2(
												$elm$json$Json$Decode$map,
												$elm$core$Result$Ok,
												A2($elm$json$Json$Decode$field, 'transactionId', $elm$json$Json$Decode$string)),
												A2(
												$elm$json$Json$Decode$map,
												$elm$core$Result$Err,
												A2(
													$elm$json$Json$Decode$field,
													'error',
													$elm$json$Json$Decode$nullable($elm$json$Json$Decode$value)))
											])),
									val)));
					default:
						break _v0$2;
				}
			} else {
				break _v0$2;
			}
		}
		return $elm$core$Maybe$Nothing;
	});
var $author$project$Page$Dashboard$CopiedToClipboard = {$: 18};
var $author$project$Page$Dashboard$GotBrowserLocation = function (a) {
	return {$: 21, a: a};
};
var $author$project$Page$Dashboard$jsAddressToMsg = F2(
	function (addr, val) {
		_v0$2:
		while (true) {
			if (addr.b) {
				switch (addr.a) {
					case 'CopiedToClipboard':
						return $elm$core$Maybe$Just($author$project$Page$Dashboard$CopiedToClipboard);
					case 'GotBrowserLocation':
						return $elm$core$Maybe$Just(
							$author$project$Page$Dashboard$GotBrowserLocation(val));
					default:
						break _v0$2;
				}
			} else {
				break _v0$2;
			}
		}
		return $elm$core$Maybe$Nothing;
	});
var $author$project$Page$Dashboard$Analysis$jsAddressToMsg = F2(
	function (_v0, _v1) {
		return $elm$core$Maybe$Nothing;
	});
var $author$project$Page$Dashboard$Claim$jsAddressToMsg = F2(
	function (_v0, _v1) {
		return $elm$core$Maybe$Nothing;
	});
var $author$project$Page$Login$Denied = {$: 0};
var $author$project$Page$Login$GotAccountName = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Login$GotClipboardResponse = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Login$GotPassphraseMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Login$GotPinMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Login$NotSupported = {$: 1};
var $author$project$Page$Login$PinIgnored = {$: 0};
var $author$project$Page$Login$SignedAuthPhrase = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$Login$WithContent = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Login$WithError = {$: 3};
var $elm$core$Set$insert = F2(
	function (key, _v0) {
		var dict = _v0;
		return A3($elm$core$Dict$insert, key, 0, dict);
	});
var $elm$core$Set$fromList = function (list) {
	return A3($elm$core$List$foldl, $elm$core$Set$insert, $elm$core$Set$empty, list);
};
var $author$project$Page$Login$jsAddressToMsg = F2(
	function (addr, val) {
		_v0$5:
		while (true) {
			if (addr.b) {
				if (addr.b.b) {
					switch (addr.a) {
						case 'GotPassphraseMsg':
							if ((addr.b.a === 'ClickedPaste') && (!addr.b.b.b)) {
								var _v1 = addr.b;
								return $elm$core$Result$toMaybe(
									A2(
										$elm$json$Json$Decode$decodeValue,
										A2(
											$elm$json$Json$Decode$map,
											A2($elm$core$Basics$composeL, $author$project$Page$Login$GotPassphraseMsg, $author$project$Page$Login$GotClipboardResponse),
											$elm$json$Json$Decode$oneOf(
												_List_fromArray(
													[
														A2(
														$elm$json$Json$Decode$map,
														function (_v2) {
															return $author$project$Page$Login$Denied;
														},
														A2($elm$json$Json$Decode$field, 'isDenied', $elm$json$Json$Decode$bool)),
														A2(
														$elm$json$Json$Decode$map,
														function (_v3) {
															return $author$project$Page$Login$NotSupported;
														},
														A2($elm$json$Json$Decode$field, 'notSupported', $elm$json$Json$Decode$bool)),
														A2(
														$elm$json$Json$Decode$map,
														$author$project$Page$Login$WithContent,
														A2($elm$json$Json$Decode$field, 'clipboardContent', $elm$json$Json$Decode$string)),
														A2(
														$elm$json$Json$Decode$map,
														function (_v4) {
															return $author$project$Page$Login$WithError;
														},
														A2($elm$json$Json$Decode$field, 'error', $elm$json$Json$Decode$string))
													]))),
										val));
							} else {
								break _v0$5;
							}
						case 'GotPinMsg':
							switch (addr.b.a) {
								case 'SubmittedPinWithSuccess':
									if (!addr.b.b.b) {
										var _v5 = addr.b;
										return $elm$core$Result$toMaybe(
											A2(
												$elm$json$Json$Decode$decodeValue,
												$elm$json$Json$Decode$oneOf(
													_List_fromArray(
														[
															A2(
															$elm$json$Json$Decode$map,
															A2(
																$elm$core$Basics$composeR,
																$elm$core$Result$Ok,
																A2($elm$core$Basics$composeR, $author$project$Page$Login$GotAccountName, $author$project$Page$Login$GotPinMsg)),
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'privateKey',
																$author$project$Eos$Account$privateKeyDecoder,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'accountName',
																	$author$project$Eos$Account$nameDecoder,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'addressData',
																		$elm$json$Json$Decode$string,
																		$elm$json$Json$Decode$succeed(
																			F3(
																				function (pin, account, privateKey) {
																					return {lM: account, oE: pin, oN: privateKey};
																				})))))),
															A2(
															$elm$json$Json$Decode$map,
															A2(
																$elm$core$Basics$composeR,
																$elm$core$Result$Err,
																A2($elm$core$Basics$composeR, $author$project$Page$Login$GotAccountName, $author$project$Page$Login$GotPinMsg)),
															A2($elm$json$Json$Decode$field, 'error', $elm$json$Json$Decode$string))
														])),
												val));
									} else {
										break _v0$5;
									}
								case 'GeneratedAuthPhrase':
									var _v6 = addr.b;
									return A2(
										$author$project$Api$Graphql$decodeSignedPhrasePort,
										A2($elm$core$Basics$composeR, $author$project$Page$Login$SignedAuthPhrase, $author$project$Page$Login$GotPinMsg),
										val);
								case 'PinIgnored':
									if (!addr.b.b.b) {
										var _v7 = addr.b;
										return $elm$core$Maybe$Just(
											$author$project$Page$Login$GotPinMsg($author$project$Page$Login$PinIgnored));
									} else {
										break _v0$5;
									}
								default:
									break _v0$5;
							}
						default:
							break _v0$5;
					}
				} else {
					if (addr.a === 'GotBip39') {
						var decodeLanguage = function (key) {
							return A2(
								$elm$json$Json$Decode$map,
								$elm$core$Set$fromList,
								A2(
									$elm$json$Json$Decode$field,
									key,
									$elm$json$Json$Decode$list($elm$json$Json$Decode$string)));
						};
						return $elm$core$Result$toMaybe(
							A2(
								$elm$core$Result$map,
								$author$project$Page$Login$GotBip39,
								A2(
									$elm$json$Json$Decode$decodeValue,
									A4(
										$elm$json$Json$Decode$map3,
										F3(
											function (english, portuguese, spanish) {
												return {fL: english, gn: portuguese, gD: spanish};
											}),
										decodeLanguage('english'),
										decodeLanguage('portuguese'),
										decodeLanguage('spanish')),
									val)));
					} else {
						break _v0$5;
					}
				}
			} else {
				break _v0$5;
			}
		}
		return $elm$core$Maybe$Nothing;
	});
var $author$project$Page$Profile$Claims$jsAddressToMsg = F2(
	function (_v0, _v1) {
		return $elm$core$Maybe$Nothing;
	});
var $author$project$Page$Register$AccountKeys = F5(
	function (ownerKey, activeKey, accountName, words, privateKey) {
		return {lM: accountName, lQ: activeKey, kw: ownerKey, oN: privateKey, gN: words};
	});
var $author$project$Page$Register$AccountKeysGenerated = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Page$Register$CopiedToClipboard = {$: 8};
var $author$project$Page$Register$GotAccountAvailabilityResponse = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Page$Register$PdfDownloaded = {$: 6};
var $author$project$Page$Register$DefaultFormOutput = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Register$JuridicalFormOutput = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Register$NaturalFormOutput = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Register$DefaultForm$FormOutput = F3(
	function (name, account, email) {
		return {fl: account, jh: email, ki: name};
	});
var $author$project$Page$Register$DefaultForm$decoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Page$Register$DefaultForm$FormOutput,
	A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'account', $author$project$Eos$Account$nameDecoder),
	A2($elm$json$Json$Decode$field, 'email', $elm$json$Json$Decode$string));
var $author$project$Page$Register$JuridicalForm$FormOutput = function (companyType) {
	return function (document) {
		return function (name) {
			return function (email) {
				return function (phone) {
					return function (account) {
						return function (state) {
							return function (city) {
								return function (district) {
									return function (street) {
										return function (number) {
											return function (zip) {
												return {fl: account, l4: city, md: companyType, mC: district, eq: document, jh: email, ki: name, ay: number, eT: phone, X: state, ba: street, fk: zip};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Page$Register$JuridicalForm$Corporation = 1;
var $author$project$Page$Register$JuridicalForm$MIPYME = 0;
var $author$project$Page$Register$JuridicalForm$companyTypeFromString = function (type_) {
	switch (type_) {
		case 'mipyme':
			return $elm$core$Maybe$Just(0);
		case 'gran_empresa':
			return $elm$core$Maybe$Just(1);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Page$Register$JuridicalForm$decoder = function () {
	var decodeIdAndName = A3(
		$elm$json$Json$Decode$map2,
		F2(
			function (id, name) {
				return {R: id, ki: name};
			}),
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$string);
	return A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'zip',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'number',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'street',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'district',
					decodeIdAndName,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'city',
						decodeIdAndName,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'state',
							decodeIdAndName,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'account',
								$author$project$Eos$Account$nameDecoder,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'phone',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'email',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'name',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'document',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'companyType',
													A2(
														$elm$json$Json$Decode$andThen,
														function (companyType) {
															var _v0 = $author$project$Page$Register$JuridicalForm$companyTypeFromString(companyType);
															if (_v0.$ === 1) {
																return $elm$json$Json$Decode$fail('Invalid company type');
															} else {
																var type_ = _v0.a;
																return $elm$json$Json$Decode$succeed(type_);
															}
														},
														$elm$json$Json$Decode$string),
													$elm$json$Json$Decode$succeed($author$project$Page$Register$JuridicalForm$FormOutput)))))))))))));
}();
var $author$project$Page$Register$NaturalForm$FormOutput = F6(
	function (documentType, document, name, email, phoneNumber, account) {
		return {fl: account, eq: document, er: documentType, jh: email, ki: name, oC: phoneNumber};
	});
var $author$project$Page$Register$NaturalForm$DIMEX = 1;
var $author$project$Page$Register$NaturalForm$NITE = 2;
var $author$project$Page$Register$NaturalForm$SSN = 0;
var $author$project$Page$Register$NaturalForm$documentTypeFromString = function (document) {
	switch (document) {
		case 'cedula_de_identidad':
			return $elm$core$Maybe$Just(0);
		case 'dimex':
			return $elm$core$Maybe$Just(1);
		case 'nite':
			return $elm$core$Maybe$Just(2);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Page$Register$NaturalForm$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'account',
	$author$project$Eos$Account$nameDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'phoneNumber',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'email',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'name',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'document',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'documentType',
						A2(
							$elm$json$Json$Decode$andThen,
							function (documentType) {
								var _v0 = $author$project$Page$Register$NaturalForm$documentTypeFromString(documentType);
								if (_v0.$ === 1) {
									return $elm$json$Json$Decode$fail('Invalid document type');
								} else {
									var doc = _v0.a;
									return $elm$json$Json$Decode$succeed(doc);
								}
							},
							$elm$json$Json$Decode$string),
						$elm$json$Json$Decode$succeed($author$project$Page$Register$NaturalForm$FormOutput)))))));
var $author$project$Page$Register$formOutputDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2($elm$json$Json$Decode$map, $author$project$Page$Register$NaturalFormOutput, $author$project$Page$Register$NaturalForm$decoder),
			A2($elm$json$Json$Decode$map, $author$project$Page$Register$JuridicalFormOutput, $author$project$Page$Register$JuridicalForm$decoder),
			A2($elm$json$Json$Decode$map, $author$project$Page$Register$DefaultFormOutput, $author$project$Page$Register$DefaultForm$decoder)
		]));
var $author$project$Page$Register$jsAddressToMsg = F2(
	function (addr, val) {
		_v0$4:
		while (true) {
			if (addr.b) {
				switch (addr.a) {
					case 'SubmittedForm':
						return $elm$core$Result$toMaybe(
							A2(
								$elm$json$Json$Decode$decodeValue,
								A3(
									$elm$json$Json$Decode$map2,
									$author$project$Page$Register$GotAccountAvailabilityResponse,
									A2($elm$json$Json$Decode$field, 'addressData', $author$project$Page$Register$formOutputDecoder),
									A2($elm$json$Json$Decode$field, 'isAvailable', $elm$json$Json$Decode$bool)),
								val));
					case 'GotAccountAvailabilityResponse':
						var decodeAccount = A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'privateKey',
							$author$project$Eos$Account$privateKeyDecoder,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'words',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'accountName',
									$author$project$Eos$Account$nameDecoder,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'activeKey',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'ownerKey',
											$elm$json$Json$Decode$string,
											$elm$json$Json$Decode$succeed($author$project$Page$Register$AccountKeys))))));
						var decodedAccount = A2(
							$elm$json$Json$Decode$decodeValue,
							A2($elm$json$Json$Decode$field, 'data', decodeAccount),
							val);
						return A2(
							$elm$core$Maybe$map,
							function (formOutput) {
								return A2($author$project$Page$Register$AccountKeysGenerated, formOutput, decodedAccount);
							},
							$elm$core$Result$toMaybe(
								A2(
									$elm$json$Json$Decode$decodeValue,
									A2($elm$json$Json$Decode$field, 'addressData', $author$project$Page$Register$formOutputDecoder),
									val)));
					case 'PdfDownloaded':
						return $elm$core$Maybe$Just($author$project$Page$Register$PdfDownloaded);
					case 'CopiedToClipboard':
						return $elm$core$Maybe$Just($author$project$Page$Register$CopiedToClipboard);
					default:
						break _v0$4;
				}
			} else {
				break _v0$4;
			}
		}
		return $elm$core$Maybe$Nothing;
	});
var $author$project$Page$Settings$ChangedToNewPin = function (a) {
	return {$: 10, a: a};
};
var $author$project$Page$Settings$CopiedPrivateKey = {$: 4};
var $author$project$Page$Settings$NoOp = {$: 0};
var $author$project$Page$Settings$jsAddressToMsg = F2(
	function (addr, val) {
		_v0$3:
		while (true) {
			if (addr.b) {
				switch (addr.a) {
					case 'ClickedDownloadPdf':
						return $elm$core$Result$toMaybe(
							A2(
								$elm$core$Result$map,
								function (_v1) {
									return $author$project$Page$Settings$NoOp;
								},
								A2(
									$elm$json$Json$Decode$decodeValue,
									A2($elm$json$Json$Decode$field, 'isDownloaded', $elm$json$Json$Decode$bool),
									val)));
					case 'ClickedCopyPrivateKey':
						var _v2 = A2(
							$elm$json$Json$Decode$decodeValue,
							A2($elm$json$Json$Decode$field, 'copied', $elm$json$Json$Decode$bool),
							val);
						if (!_v2.$) {
							if (_v2.a) {
								return $elm$core$Maybe$Just($author$project$Page$Settings$CopiedPrivateKey);
							} else {
								return $elm$core$Maybe$Just($author$project$Page$Settings$NoOp);
							}
						} else {
							return $elm$core$Maybe$Just($author$project$Page$Settings$NoOp);
						}
					case 'SubmittedNewPin':
						return $elm$core$Result$toMaybe(
							A2(
								$elm$core$Result$map,
								$author$project$Page$Settings$ChangedToNewPin,
								A2(
									$elm$json$Json$Decode$decodeValue,
									A2($elm$json$Json$Decode$field, 'addressData', $elm$json$Json$Decode$string),
									val)));
					default:
						break _v0$3;
				}
			} else {
				break _v0$3;
			}
		}
		return $elm$core$Maybe$Nothing;
	});
var $author$project$Page$Shop$Viewer$CopiedToClipboard = {$: 7};
var $author$project$Page$Shop$Viewer$GotTransferResult = function (a) {
	return {$: 5, a: a};
};
var $author$project$Page$Shop$Viewer$jsAddressToLoggedInMsg = F2(
	function (addr, val) {
		if ((addr.b && (addr.a === 'ClickedTransfer')) && (!addr.b.b)) {
			return A2(
				$elm$core$Result$withDefault,
				$elm$core$Maybe$Nothing,
				A2(
					$elm$core$Result$map,
					A2($elm$core$Basics$composeL, $elm$core$Maybe$Just, $author$project$Page$Shop$Viewer$GotTransferResult),
					A2(
						$elm$json$Json$Decode$decodeValue,
						$elm$json$Json$Decode$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$json$Json$Decode$map,
									$elm$core$Result$Ok,
									A2($elm$json$Json$Decode$field, 'transactionId', $elm$json$Json$Decode$string)),
									A2(
									$elm$json$Json$Decode$map,
									$elm$core$Result$Err,
									A2(
										$elm$json$Json$Decode$field,
										'error',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$value)))
								])),
						val)));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Page$Shop$Viewer$jsAddressToMsg = F2(
	function (addr, val) {
		_v0$2:
		while (true) {
			if (addr.b) {
				switch (addr.a) {
					case 'ClickedShareOffer':
						return A2(
							$elm$core$Result$withDefault,
							$elm$core$Maybe$Nothing,
							A2(
								$elm$core$Result$map,
								function (type_) {
									return (type_ === 'copyToClipboard') ? $elm$core$Maybe$Just($author$project$Page$Shop$Viewer$CopiedToClipboard) : $elm$core$Maybe$Nothing;
								},
								A2(
									$elm$json$Json$Decode$decodeValue,
									A2(
										$elm$json$Json$Decode$at,
										_List_fromArray(
											['addressData', 'type']),
										$elm$json$Json$Decode$string),
									val)));
					case 'AsLoggedInMsg':
						var rAddress = addr.b;
						return A2(
							$elm$core$Maybe$map,
							$author$project$Page$Shop$Viewer$AsLoggedInMsg,
							A2($author$project$Page$Shop$Viewer$jsAddressToLoggedInMsg, rAddress, val));
					default:
						break _v0$2;
				}
			} else {
				break _v0$2;
			}
		}
		return $elm$core$Maybe$Nothing;
	});
var $author$project$Main$jsAddressToMsg = F2(
	function (address, val) {
		_v0$12:
		while (true) {
			if (address.b) {
				switch (address.a) {
					case 'GotPageMsg':
						var rAddress = address.b;
						return A2(
							$elm$core$Maybe$map,
							$author$project$Main$GotPageMsg,
							A2($author$project$Page$jsAddressToMsg, rAddress, val));
					case 'GotLoginMsg':
						var rAddress = address.b;
						return A2(
							$elm$core$Maybe$map,
							$author$project$Main$GotLoginMsg,
							A2($author$project$Page$Login$jsAddressToMsg, rAddress, val));
					case 'GotDashboardMsg':
						var rAddress = address.b;
						return A2(
							$elm$core$Maybe$map,
							$author$project$Main$GotDashboardMsg,
							A2($author$project$Page$Dashboard$jsAddressToMsg, rAddress, val));
					case 'GotCommunityAboutMsg':
						var rAddress = address.b;
						return A2(
							$elm$core$Maybe$map,
							$author$project$Main$GotCommunityAboutMsg,
							A2($author$project$Page$Community$About$jsAddressToMsg, rAddress, val));
					case 'GotCommunityEditorMsg':
						var rAddress = address.b;
						return A2(
							$elm$core$Maybe$map,
							$author$project$Main$GotCommunityEditorMsg,
							A2($author$project$Page$Community$New$jsAddressToMsg, rAddress, val));
					case 'GotShopViewerMsg':
						var rAddress = address.b;
						return A2(
							$elm$core$Maybe$map,
							$author$project$Main$GotShopViewerMsg,
							A2($author$project$Page$Shop$Viewer$jsAddressToMsg, rAddress, val));
					case 'GotRegisterMsg':
						var rAddress = address.b;
						return A2(
							$elm$core$Maybe$map,
							$author$project$Main$GotRegisterMsg,
							A2($author$project$Page$Register$jsAddressToMsg, rAddress, val));
					case 'GotSettingsMsg':
						var rAddress = address.b;
						return A2(
							$elm$core$Maybe$map,
							$author$project$Main$GotSettingsMsg,
							A2($author$project$Page$Settings$jsAddressToMsg, rAddress, val));
					case 'GotVerifyClaimMsg':
						var rAddress = address.b;
						return A2(
							$elm$core$Maybe$map,
							$author$project$Main$GotVerifyClaimMsg,
							A2($author$project$Page$Dashboard$Claim$jsAddressToMsg, rAddress, val));
					case 'GotTransferMsg':
						var rAddress = address.b;
						return A2(
							$elm$core$Maybe$map,
							$author$project$Main$GotTransferMsg,
							A2($author$project$Page$Community$Transfer$jsAddressToMsg, rAddress, val));
					case 'GotAnalysisMsg':
						var rAddress = address.b;
						return A2(
							$elm$core$Maybe$map,
							$author$project$Main$GotAnalysisMsg,
							A2($author$project$Page$Dashboard$Analysis$jsAddressToMsg, rAddress, val));
					case 'GotProfileClaimsMsg':
						var rAddress = address.b;
						return A2(
							$elm$core$Maybe$map,
							$author$project$Main$GotProfileClaimsMsg,
							A2($author$project$Page$Profile$Claims$jsAddressToMsg, rAddress, val));
					default:
						break _v0$12;
				}
			} else {
				break _v0$12;
			}
		}
		return $elm$core$Maybe$Nothing;
	});
var $elm$browser$Browser$Navigation$load = _Browser_load;
var $author$project$Page$maybeAccountName = function (session) {
	if (session.$ === 1) {
		var loggedIn = session.a;
		return $elm$core$Maybe$Just(loggedIn.lM);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$url$Url$addPort = F2(
	function (maybePort, starter) {
		if (maybePort.$ === 1) {
			return starter;
		} else {
			var port_ = maybePort.a;
			return starter + (':' + $elm$core$String$fromInt(port_));
		}
	});
var $elm$url$Url$addPrefixed = F3(
	function (prefix, maybeSegment, starter) {
		if (maybeSegment.$ === 1) {
			return starter;
		} else {
			var segment = maybeSegment.a;
			return _Utils_ap(
				starter,
				_Utils_ap(prefix, segment));
		}
	});
var $elm$url$Url$toString = function (url) {
	var http = function () {
		var _v0 = url.oU;
		if (!_v0) {
			return 'http://';
		} else {
			return 'https://';
		}
	}();
	return A3(
		$elm$url$Url$addPrefixed,
		'#',
		url.mW,
		A3(
			$elm$url$Url$addPrefixed,
			'?',
			url.dO,
			_Utils_ap(
				A2(
					$elm$url$Url$addPort,
					url.oI,
					_Utils_ap(http, url.ez)),
				url.gm)));
};
var $author$project$Session$LoggedIn$Broadcast = function (a) {
	return {$: 7, a: a};
};
var $author$project$Page$GuestBroadcastMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$LoggedInExternalMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Session$LoggedIn$TranslationsLoaded = {$: 4};
var $author$project$Translation$languageToLocale = function (language) {
	switch (language) {
		case 0:
			return 'en-us';
		case 1:
			return 'pt-br';
		case 2:
			return 'es-es';
		case 3:
			return 'ca-es';
		default:
			return 'am-et';
	}
};
var $author$project$Session$Shared$LoadedTranslation = {$: 2};
var $author$project$Session$Shared$LoadingAnotherTranslationFailed = {$: 4};
var $author$project$Session$Shared$LoadingTranslationFailed = function (a) {
	return {$: 1, a: a};
};
var $author$project$Session$Shared$loadTranslation = F2(
	function (result, shared) {
		if (result.$ === 1) {
			var err = result.a;
			return _Utils_update(
				shared,
				{
					bq: function () {
						var _v1 = shared.bq;
						switch (_v1.$) {
							case 0:
								return $author$project$Session$Shared$LoadingTranslationFailed(err);
							case 3:
								return $author$project$Session$Shared$LoadingAnotherTranslationFailed;
							default:
								return shared.bq;
						}
					}()
				});
		} else {
			var _v2 = result.a;
			var language = _v2.a;
			var translations = _v2.b;
			return _Utils_update(
				shared,
				{
					hy: language,
					fi: translations,
					bq: $author$project$Session$Shared$LoadedTranslation,
					iw: $author$project$Session$Shared$makeTranslators(translations)
				});
		}
	});
var $author$project$Log$HttpErrorType = 3;
var $author$project$Log$encodeHttpError = function (error) {
	switch (error.$) {
		case 0:
			var url = error.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('Http.BadUrl')),
						_Utils_Tuple2(
						'providedUrl',
						$elm$json$Json$Encode$string(url))
					]));
		case 1:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('Http.Timeout'))
					]));
		case 2:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('Http.NetworkError'))
					]));
		case 3:
			var status = error.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('Http.BadStatus')),
						_Utils_Tuple2(
						'status',
						$elm$json$Json$Encode$int(status))
					]));
		default:
			var body = error.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('Http.BadBody')),
						_Utils_Tuple2(
						'body',
						$elm$json$Json$Encode$string(body))
					]));
	}
};
var $author$project$Log$fromHttpError = F6(
	function (transaction, maybeUser, description, location, contexts, error) {
		return {
			mm: A2(
				$elm$core$List$cons,
				{
					mR: $elm$core$Dict$fromList(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'Description',
								$elm$json$Json$Encode$string(description)),
								_Utils_Tuple2(
								'Error',
								$author$project$Log$encodeHttpError(error))
							])),
					ki: 'HTTP error'
				},
				contexts),
			nH: 1,
			nN: location,
			nS: 'Got an error when performing an HTTP request',
			pu: _List_fromArray(
				[
					$author$project$Log$TypeTag(3)
				]),
			pE: transaction,
			pM: maybeUser
		};
	});
var $author$project$UpdateResult$logHttpError = F6(
	function (transaction, maybeUser, description, location, contexts, error) {
		return $author$project$UpdateResult$logEvent(
			A6($author$project$Log$fromHttpError, transaction, maybeUser, description, location, contexts, error));
	});
var $author$project$Log$IncompatibleMsg = 0;
var $author$project$Log$fromIncompatibleMsg = F4(
	function (transaction, maybeUser, location, contexts) {
		return {
			mm: contexts,
			nH: 3,
			nN: location,
			nS: 'Msg does not correspond with Model',
			pu: _List_fromArray(
				[
					$author$project$Log$TypeTag(0)
				]),
			pE: transaction,
			pM: maybeUser
		};
	});
var $author$project$UpdateResult$logIncompatibleMsg = F4(
	function (transaction, maybeUser, location, contexts) {
		return $author$project$UpdateResult$logEvent(
			A4($author$project$Log$fromIncompatibleMsg, transaction, maybeUser, location, contexts));
	});
var $author$project$Ports$storeLanguage = _Platform_outgoingPort('storeLanguage', $elm$json$Json$Encode$string);
var $author$project$Session$Guest$CommunityLoaded = $elm$core$Basics$identity;
var $author$project$Log$DefaultBreadcrumb = 0;
var $author$project$Log$ErrorBreadcrumb = 2;
var $author$project$Log$Warning = 2;
var $author$project$Session$Guest$CompletedLoadTranslation = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Session$Guest$fetchTranslations = F2(
	function (version, language) {
		return A3(
			$author$project$Translation$get,
			version,
			language,
			$author$project$Session$Guest$CompletedLoadTranslation(language));
	});
var $author$project$Session$Guest$invalidCommunityRedirectUrl = F2(
	function (currentUrl, useSubdomain) {
		return useSubdomain ? (A2(
			$elm$core$String$contains,
			'localhost:',
			$elm$url$Url$toString(currentUrl)) ? $elm$core$Maybe$Just(
			$elm$url$Url$toString(
				_Utils_update(
					currentUrl,
					{ez: 'cambiatus.staging.localhost'}))) : (A2($elm$core$String$endsWith, 'staging.cambiatus.io', currentUrl.ez) ? $elm$core$Maybe$Just(
			$elm$url$Url$toString(
				_Utils_update(
					currentUrl,
					{ez: 'cambiatus.staging.cambiatus.io'}))) : (A2($elm$core$String$endsWith, 'demo.cambiatus.io', currentUrl.ez) ? $elm$core$Maybe$Just('https://www.cambiatus.com/welcome-demo') : $elm$core$Maybe$Just('https://www.cambiatus.com/welcome')))) : $elm$core$Maybe$Nothing;
	});
var $author$project$Log$GraphqlErrorType = 4;
var $author$project$Log$encodeGraphqlError = function (error) {
	var encodeGraphqlInternalError = function (internalError) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'message',
					$elm$json$Json$Encode$string(internalError.nS)),
					_Utils_Tuple2(
					'locations',
					function () {
						var _v3 = internalError.nO;
						if (_v3.$ === 1) {
							return $elm$json$Json$Encode$null;
						} else {
							var locations = _v3.a;
							return A2(
								$elm$json$Json$Encode$list,
								function (location) {
									return $elm$json$Json$Encode$object(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'line',
												$elm$json$Json$Encode$int(location.nI)),
												_Utils_Tuple2(
												'column',
												$elm$json$Json$Encode$int(location.mc))
											]));
								},
								locations);
						}
					}()),
					_Utils_Tuple2(
					'details',
					A3($elm$json$Json$Encode$dict, $elm$core$Basics$identity, $elm$core$Basics$identity, internalError.mz))
				]));
	};
	if (!error.$) {
		var possiblyParsedData = error.a;
		var graphqlErrors = error.b;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('Graphql.Http.GraphqlError')),
					_Utils_Tuple2(
					'data',
					function () {
						if (!possiblyParsedData.$) {
							return $elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'status',
										$elm$json$Json$Encode$string('Graphql.Http.GraphqlError.ParsedData'))
									]));
						} else {
							var unparsedData = possiblyParsedData.a;
							return $elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'status',
										$elm$json$Json$Encode$string('Graphql.Http.GraphqlError.UnparsedData')),
										_Utils_Tuple2('unparsedData', unparsedData)
									]));
						}
					}()),
					_Utils_Tuple2(
					'errors',
					A2($elm$json$Json$Encode$list, encodeGraphqlInternalError, graphqlErrors))
				]));
	} else {
		var httpError = error.a;
		switch (httpError.$) {
			case 0:
				var url = httpError.a;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('Graphql.Http.BadUrl')),
							_Utils_Tuple2(
							'providedUrl',
							$elm$json$Json$Encode$string(url))
						]));
			case 1:
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('Graphql.Http.Timeout'))
						]));
			case 2:
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('Graphql.Http.NetworkError'))
						]));
			case 3:
				var metadata = httpError.a;
				var body = httpError.b;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('Graphql.Http.BadStatus')),
							_Utils_Tuple2(
							'metadata',
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'url',
										$elm$json$Json$Encode$string(metadata.gL)),
										_Utils_Tuple2(
										'statusCode',
										$elm$json$Json$Encode$int(metadata.pk)),
										_Utils_Tuple2(
										'statusText',
										$elm$json$Json$Encode$string(metadata.ld)),
										_Utils_Tuple2(
										'headers',
										A3($elm$json$Json$Encode$dict, $elm$core$Basics$identity, $elm$json$Json$Encode$string, metadata.m4))
									]))),
							_Utils_Tuple2(
							'body',
							$elm$json$Json$Encode$string(body))
						]));
			default:
				var jsonError = httpError.a;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('Graphql.Http.BadPayload')),
							_Utils_Tuple2(
							'jsonError',
							$author$project$Log$encodeDecodingError(jsonError))
						]));
		}
	}
};
var $author$project$Log$fromGraphqlHttpError = F6(
	function (transaction, maybeUser, description, location, contexts, error) {
		return {
			mm: A2(
				$elm$core$List$cons,
				{
					mR: $elm$core$Dict$fromList(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'Description',
								$elm$json$Json$Encode$string(description)),
								_Utils_Tuple2(
								'Error',
								$author$project$Log$encodeGraphqlError(error))
							])),
					ki: 'Graphql error'
				},
				contexts),
			nH: 1,
			nN: location,
			nS: 'Got an error when performing a GraphQL request',
			pu: _List_fromArray(
				[
					$author$project$Log$TypeTag(4)
				]),
			pE: transaction,
			pM: maybeUser
		};
	});
var $author$project$UpdateResult$logGraphqlError = F6(
	function (transaction, maybeUser, description, location, contexts, error) {
		return $author$project$UpdateResult$logEvent(
			A6($author$project$Log$fromGraphqlHttpError, transaction, maybeUser, description, location, contexts, error));
	});
var $author$project$Session$Shared$LoadingAnotherTranslation = {$: 3};
var $author$project$Session$Shared$toLoadingTranslation = function (shared) {
	return _Utils_update(
		shared,
		{
			bq: function () {
				var _v0 = shared.bq;
				switch (_v0.$) {
					case 2:
						return $author$project$Session$Shared$LoadingAnotherTranslation;
					case 4:
						return $author$project$Session$Shared$LoadingAnotherTranslation;
					default:
						return $author$project$Session$Shared$LoadingTranslation;
				}
			}()
		});
};
var $author$project$View$Feedback$update = F2(
	function (msg, _v0) {
		return $author$project$View$Feedback$Hidden;
	});
var $author$project$Session$Guest$update = F2(
	function (msg, model) {
		var shared = model.aM;
		var currentUrl = shared.gL;
		switch (msg.$) {
			case 0:
				if (!msg.b.$) {
					var lang = msg.a;
					var transl = msg.b.a;
					return A2(
						$author$project$UpdateResult$addCmd,
						$author$project$Ports$storeLanguage(
							$author$project$Translation$languageToLocale(lang)),
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									aM: A2(
										$author$project$Session$Shared$loadTranslation,
										$elm$core$Result$Ok(
											_Utils_Tuple2(lang, transl)),
										shared)
								})));
				} else {
					var err = msg.b.a;
					return A7(
						$author$project$UpdateResult$logHttpError,
						msg,
						$elm$core$Maybe$Nothing,
						'Got an error when loading translation as a guest',
						{mX: 'update', nW: 'Session.Guest'},
						_List_Nil,
						err,
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									aM: A2(
										$author$project$Session$Shared$loadTranslation,
										$elm$core$Result$Err(err),
										shared)
								})));
				}
			case 1:
				return A2(
					$author$project$UpdateResult$addBreadcrumb,
					{fw: msg, i9: $elm$core$Dict$empty, nH: 2, nS: 'Clicked to fetch translation again', d0: 2},
					A2(
						$author$project$UpdateResult$addCmd,
						A2($author$project$Session$Guest$fetchTranslations, shared.lF, shared.hy),
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									aM: $author$project$Session$Shared$toLoadingTranslation(shared)
								}))));
			case 2:
				var b = msg.a;
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{a8: b}));
			case 3:
				var lang = msg.a;
				return A2(
					$author$project$UpdateResult$addCmd,
					A2($author$project$Session$Guest$fetchTranslations, shared.lF, lang),
					$author$project$UpdateResult$init(
						_Utils_update(
							model,
							{
								aM: $author$project$Session$Shared$toLoadingTranslation(shared),
								a8: false
							})));
			case 4:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{a8: false}));
			case 5:
				switch (msg.a.$) {
					case 3:
						if (!msg.a.a.$) {
							var communityPreview = msg.a.a.a;
							return A2(
								$author$project$UpdateResult$addPort,
								{
									i9: $elm$json$Json$Encode$object(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'name',
												$elm$json$Json$Encode$string('setFavicon')),
												_Utils_Tuple2(
												'favicon',
												$elm$json$Json$Encode$string(communityPreview.hC))
											])),
									kY: msg,
									kZ: $elm$json$Json$Encode$null
								},
								A2(
									$author$project$UpdateResult$addBreadcrumb,
									{
										fw: msg,
										i9: $elm$core$Dict$fromList(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'symbol',
													$author$project$Eos$encodeSymbol(communityPreview.e9)),
													_Utils_Tuple2(
													'name',
													$elm$json$Json$Encode$string(communityPreview.ki))
												])),
										nH: 3,
										nS: 'Community preview loaded successfully',
										d0: 0
									},
									A2(
										$author$project$UpdateResult$addExt,
										communityPreview,
										$author$project$UpdateResult$init(
											_Utils_update(
												model,
												{
													b9: $krisajenkins$remotedata$RemoteData$Success(communityPreview)
												})))));
						} else {
							var _v1 = msg.a.a;
							return A2(
								$author$project$UpdateResult$addCmd,
								function () {
									var _v2 = A2($author$project$Session$Guest$invalidCommunityRedirectUrl, currentUrl, shared.pL);
									if (_v2.$ === 1) {
										return $elm$core$Platform$Cmd$none;
									} else {
										var redirectUrl = _v2.a;
										return $elm$browser$Browser$Navigation$load(redirectUrl);
									}
								}(),
								$author$project$UpdateResult$init(model));
						}
					case 2:
						var err = msg.a.a;
						return A2(
							$author$project$UpdateResult$addCmd,
							function () {
								var _v3 = A2($author$project$Session$Guest$invalidCommunityRedirectUrl, currentUrl, shared.pL);
								if (_v3.$ === 1) {
									return $elm$core$Platform$Cmd$none;
								} else {
									var redirectUrl = _v3.a;
									return $elm$browser$Browser$Navigation$load(redirectUrl);
								}
							}(),
							A7(
								$author$project$UpdateResult$logGraphqlError,
								msg,
								$elm$core$Maybe$Nothing,
								'Got an error when loading community preview as a guest',
								{mX: 'update', nW: 'Session.Guest'},
								_List_Nil,
								err,
								$author$project$UpdateResult$init(
									_Utils_update(
										model,
										{
											b9: $krisajenkins$remotedata$RemoteData$Failure(err)
										}))));
					case 0:
						var _v4 = msg.a;
						return $author$project$UpdateResult$init(
							_Utils_update(
								model,
								{b9: $krisajenkins$remotedata$RemoteData$NotAsked}));
					default:
						var _v5 = msg.a;
						return $author$project$UpdateResult$init(
							_Utils_update(
								model,
								{b9: $krisajenkins$remotedata$RemoteData$Loading}));
				}
			default:
				var subMsg = msg.a;
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{
							hf: A2($author$project$View$Feedback$update, subMsg, model.hf)
						}));
		}
	});
var $author$project$Session$LoggedIn$AddAfterAuthTokenCallback = function (a) {
	return {$: 2, a: a};
};
var $author$project$Session$LoggedIn$AddAfterAuthTokenCallbackInternal = function (a) {
	return {$: 3, a: a};
};
var $author$project$Session$LoggedIn$AuthenticationFailed = {$: 1};
var $author$project$Session$LoggedIn$AuthenticationSucceed = {$: 0};
var $author$project$Session$LoggedIn$CodeOfConductShownWithWarning = function (a) {
	return {$: 2, a: a};
};
var $author$project$Session$LoggedIn$CommunityLoaded = function (a) {
	return {$: 0, a: a};
};
var $author$project$View$Feedback$Failure = 1;
var $author$project$Session$LoggedIn$GotTime = function (a) {
	return {$: 3, a: a};
};
var $author$project$Session$LoggedIn$ProfileLoaded = function (a) {
	return {$: 2, a: a};
};
var $author$project$Session$LoggedIn$RunAfterAuthTokenCallbacks = function (a) {
	return {$: 4, a: a};
};
var $author$project$Session$LoggedIn$RunAfterPrivateKeyCallbacks = {$: 6};
var $author$project$Session$LoggedIn$RunExternalMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Cambiatus$Mutation$acceptTerms = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'acceptTerms',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$Api$Graphql$Phrase = $elm$core$Basics$identity;
var $author$project$Cambiatus$Mutation$genAuth = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'genAuth',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'account', requiredArgs____.fl, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)
				]),
			object____,
			$elm$core$Basics$identity);
	});
var $dillonkearns$elm_graphql$Graphql$Http$Mutation = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_graphql$Graphql$Http$mutationRequest = F2(
	function (baseUrl, mutationSelectionSet) {
		return {
			ec: baseUrl,
			mz: $dillonkearns$elm_graphql$Graphql$Http$Mutation(mutationSelectionSet),
			fN: $dillonkearns$elm_graphql$Graphql$Document$decoder(mutationSelectionSet),
			m4: _List_Nil,
			cz: $elm$core$Maybe$Nothing,
			cG: _List_Nil,
			am: $elm$core$Maybe$Nothing,
			cS: false
		};
	});
var $author$project$Api$Graphql$mutation = F4(
	function (shared, maybeAuthToken, mutation_, toMsg) {
		var endpoints = shared.mJ;
		return A2(
			$dillonkearns$elm_graphql$Graphql$Http$send,
			A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, toMsg),
			A2(
				$author$project$Api$Graphql$withAuthToken,
				maybeAuthToken,
				A2(
					$author$project$Api$Graphql$withCommunityDomain,
					shared,
					A2($dillonkearns$elm_graphql$Graphql$Http$mutationRequest, endpoints.fS, mutation_))));
	});
var $author$project$Cambiatus$Object$Request$phrase = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'phrase', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Api$Graphql$askForPhrase = F3(
	function (shared, account, toMsg) {
		return A4(
			$author$project$Api$Graphql$mutation,
			shared,
			$elm$core$Maybe$Nothing,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
				$elm$core$Basics$identity,
				A2(
					$author$project$Cambiatus$Mutation$genAuth,
					{
						fl: $author$project$Eos$Account$nameToString(account)
					},
					$author$project$Cambiatus$Object$Request$phrase)),
			toMsg);
	});
var $author$project$Session$LoggedIn$closeModal = function (uResult) {
	var model = uResult.nV;
	return _Utils_update(
		uResult,
		{
			nV: _Utils_update(
				model,
				{dV: false, bR: false, bo: false, e5: false, e6: false, aB: false})
		});
};
var $author$project$Form$updateValues = F2(
	function (updateFn, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{
				s: updateFn(model.s)
			});
	});
var $author$project$Search$closeSearch = function (model) {
	return _Utils_update(
		model,
		{
			hk: A2(
				$author$project$Form$updateValues,
				function (form) {
					return _Utils_update(
						form,
						{dO: ''});
				},
				model.hk),
			X: $author$project$Search$Inactive
		});
};
var $author$project$Session$LoggedIn$fetchTranslations = F2(
	function (version, language) {
		return A3(
			$author$project$Translation$get,
			version,
			language,
			$author$project$Session$LoggedIn$CompletedLoadTranslation(language));
	});
var $dillonkearns$elm_graphql$Graphql$SelectionSet$empty = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet,
	_List_Nil,
	$elm$json$Json$Decode$succeed(0));
var $dillonkearns$elm_graphql$Graphql$SelectionSet$map2 = F3(
	function (combine, _v0, _v1) {
		var selectionFields1 = _v0.a;
		var selectionDecoder1 = _v0.b;
		var selectionFields2 = _v1.a;
		var selectionDecoder2 = _v1.b;
		return A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet,
			_Utils_ap(selectionFields1, selectionFields2),
			A3($elm$json$Json$Decode$map2, combine, selectionDecoder1, selectionDecoder2));
	});
var $dillonkearns$elm_graphql$Graphql$SelectionSet$list = function (selections) {
	return A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
		$elm$core$List$reverse,
		A3(
			$elm$core$List$foldl,
			$dillonkearns$elm_graphql$Graphql$SelectionSet$map2($elm$core$List$cons),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
				function (_v0) {
					return _List_Nil;
				},
				$dillonkearns$elm_graphql$Graphql$SelectionSet$empty),
			selections));
};
var $elm_community$list_extra$List$Extra$uniqueHelp = F4(
	function (f, existing, remaining, accumulator) {
		uniqueHelp:
		while (true) {
			if (!remaining.b) {
				return $elm$core$List$reverse(accumulator);
			} else {
				var first = remaining.a;
				var rest = remaining.b;
				var computedFirst = f(first);
				if (A2($elm$core$List$member, computedFirst, existing)) {
					var $temp$f = f,
						$temp$existing = existing,
						$temp$remaining = rest,
						$temp$accumulator = accumulator;
					f = $temp$f;
					existing = $temp$existing;
					remaining = $temp$remaining;
					accumulator = $temp$accumulator;
					continue uniqueHelp;
				} else {
					var $temp$f = f,
						$temp$existing = A2($elm$core$List$cons, computedFirst, existing),
						$temp$remaining = rest,
						$temp$accumulator = A2($elm$core$List$cons, first, accumulator);
					f = $temp$f;
					existing = $temp$existing;
					remaining = $temp$remaining;
					accumulator = $temp$accumulator;
					continue uniqueHelp;
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$unique = function (list) {
	return A4($elm_community$list_extra$List$Extra$uniqueHelp, $elm$core$Basics$identity, _List_Nil, list, _List_Nil);
};
var $author$project$Community$fieldsSelectionSet = F2(
	function (symbol, fields) {
		return A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault,
			_List_Nil,
			A2(
				$author$project$Cambiatus$Query$community,
				function (optionals) {
					return _Utils_update(
						optionals,
						{
							e9: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
								$author$project$Eos$symbolToString(symbol))
						});
				},
				$dillonkearns$elm_graphql$Graphql$SelectionSet$list(
					A2(
						$elm$core$List$map,
						$author$project$Community$selectionSetForField,
						$elm_community$list_extra$List$Extra$unique(fields)))));
	});
var $author$project$UpdateResult$addChild = F5(
	function (childResult, addChildModel, fromChildMsg, fromChildExt, parentResult) {
		var applyChildExts = function (parent) {
			return A3($elm$core$List$foldl, fromChildExt, parent, childResult.jo);
		};
		return applyChildExts(
			{
				Y: _Utils_ap(
					A2(
						$elm$core$List$map,
						$author$project$Log$mapBreadcrumb(fromChildMsg),
						childResult.Y),
					parentResult.Y),
				i0: _Utils_ap(
					A2(
						$elm$core$List$map,
						$elm$core$Platform$Cmd$map(fromChildMsg),
						childResult.i0),
					parentResult.i0),
				jm: _Utils_ap(
					A2(
						$elm$core$List$map,
						$author$project$Log$map(fromChildMsg),
						childResult.jm),
					parentResult.jm),
				jo: parentResult.jo,
				nV: A2(addChildModel, childResult.nV, parentResult.nV),
				kB: _Utils_ap(
					A2(
						$elm$core$List$map,
						$author$project$Ports$mapAddress(fromChildMsg),
						childResult.kB),
					parentResult.kB)
			});
	});
var $author$project$UpdateResult$fromChild = F5(
	function (addChildModel, fromChildMsg, fromChildExt, parent, childResult) {
		return A5(
			$author$project$UpdateResult$addChild,
			childResult,
			F2(
				function (child, _v0) {
					return addChildModel(child);
				}),
			fromChildMsg,
			fromChildExt,
			$author$project$UpdateResult$init(parent));
	});
var $author$project$Ports$getRecentSearches = _Platform_outgoingPort(
	'getRecentSearches',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Cambiatus$Subscription$highlightedNews = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'highlightedNews',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$Session$LoggedIn$highlightedNewsSubscription = $author$project$Cambiatus$Subscription$highlightedNews($author$project$Community$News$selectionSet);
var $author$project$Api$Graphql$loggedInMutation = F4(
	function (loggedIn, maybeAuthToken, mutation_, toMsg) {
		var shared = loggedIn.aM;
		return A2(
			$dillonkearns$elm_graphql$Graphql$Http$send,
			A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, toMsg),
			A2(
				$author$project$Api$Graphql$withAuthToken,
				maybeAuthToken,
				A2(
					$author$project$Api$Graphql$withLoggedInCommunityDomain,
					loggedIn,
					A2($dillonkearns$elm_graphql$Graphql$Http$mutationRequest, shared.mJ.fS, mutation_))));
	});
var $author$project$Session$LoggedIn$internalMutation = F3(
	function (model, selectionSet, toMsg) {
		return A4($author$project$Session$LoggedIn$internalGraphqlOperation, $author$project$Api$Graphql$loggedInMutation, model, selectionSet, toMsg);
	});
var $elm_community$maybe_extra$Maybe$Extra$isJust = function (m) {
	if (m.$ === 1) {
		return false;
	} else {
		return true;
	}
};
var $author$project$Api$Graphql$isNonExistingCommunityError = $author$project$Api$Graphql$isCertainError('no community found using the domain');
var $author$project$Search$isOpenMsg = function (msg) {
	if (msg.$ === 3) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Session$LoggedIn$loadCommunity = F2(
	function (model, maybeSymbol) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{o7: $krisajenkins$remotedata$RemoteData$Loading, bS: false}),
			A2($author$project$Session$LoggedIn$fetchCommunity, model, maybeSymbol));
	});
var $author$project$UpdateResult$logImpossible = F5(
	function (transaction, message, maybeUser, location, contexts) {
		return $author$project$UpdateResult$logEvent(
			A5($author$project$Log$fromImpossible, transaction, message, maybeUser, location, contexts));
	});
var $author$project$UpdateResult$mapModel = F2(
	function (transform, uResult) {
		return {
			Y: uResult.Y,
			i0: uResult.i0,
			jm: uResult.jm,
			jo: uResult.jo,
			nV: transform(uResult.nV),
			kB: uResult.kB
		};
	});
var $author$project$Community$mergeFields = F2(
	function (loadedCommunity, newCommunity) {
		if (loadedCommunity.$ === 3) {
			var oldCommunity = loadedCommunity.a;
			return _Utils_update(
				newCommunity,
				{cy: oldCommunity.cy, bs: oldCommunity.bs});
		} else {
			return newCommunity;
		}
	});
var $author$project$Auth$removePrivateKey = function (model) {
	return _Utils_update(
		model,
		{gE: $author$project$Auth$WithoutPrivateKey});
};
var $author$project$Route$externalCommunityLink = F3(
	function (shared, subdomain, route) {
		var environments = _List_fromArray(
			['staging', 'demo']);
		var defaultEnding = 'cambiatus.io';
		var possibleEndings = _List_fromArray(
			['localhost', defaultEnding]);
		var currentUrl = shared.gL;
		var ending = A2(
			$elm$core$Maybe$withDefault,
			defaultEnding,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (possibleEnding) {
						return A2($elm$core$String$endsWith, possibleEnding, currentUrl.ez);
					},
					possibleEndings)));
		var communitySubdomain = A2(
			$elm$core$Maybe$withDefault,
			subdomain,
			$elm$core$List$head(
				A2($elm$core$String$split, '.', subdomain)));
		var communityHost = function () {
			var _v0 = A2(
				$elm$core$List$filter,
				A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
				A2(
					$elm$core$String$split,
					'.',
					A2(
						$elm$core$String$dropRight,
						$elm$core$String$length(ending),
						currentUrl.ez)));
			if (!_v0.b) {
				return A2(
					$elm$core$String$join,
					'.',
					_List_fromArray(
						[communitySubdomain, ending]));
			} else {
				if (!_v0.b.b) {
					var singlePart = _v0.a;
					return A2($elm$core$List$member, singlePart, environments) ? A2(
						$elm$core$String$join,
						'.',
						_List_fromArray(
							[communitySubdomain, singlePart, ending])) : A2(
						$elm$core$String$join,
						'.',
						_List_fromArray(
							[communitySubdomain, ending]));
				} else {
					var _v1 = _v0.b;
					var env = _v1.a;
					return A2(
						$elm$core$String$join,
						'.',
						_List_fromArray(
							[communitySubdomain, env, ending]));
				}
			}
		}();
		return _Utils_update(
			currentUrl,
			{
				ez: communityHost,
				gm: $author$project$Route$routeToString(route)
			});
	});
var $author$project$Route$loadExternalCommunity = F3(
	function (shared, community, route) {
		return shared.pL ? $elm$browser$Browser$Navigation$load(
			$elm$url$Url$toString(
				A3($author$project$Route$externalCommunityLink, shared, community.pl, route))) : A2($author$project$Route$pushUrl, shared.eM, route);
	});
var $author$project$Session$LoggedIn$selectCommunity = F3(
	function (model, community, route) {
		var shared = model.aM;
		return shared.pL ? _Utils_Tuple2(
			model,
			A3($author$project$Route$loadExternalCommunity, shared, community, route)) : _Utils_Tuple2(
			_Utils_update(
				model,
				{o7: $krisajenkins$remotedata$RemoteData$Loading}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$author$project$Session$LoggedIn$fetchCommunity,
						model,
						$elm$core$Maybe$Just(community.e9)),
						A2($author$project$Route$replaceUrl, shared.eM, route)
					])));
	});
var $author$project$Cambiatus$Enum$Language$toString = function (enum____) {
	switch (enum____) {
		case 0:
			return 'AMHETH';
		case 1:
			return 'ENUS';
		case 2:
			return 'ESES';
		default:
			return 'PTBR';
	}
};
var $author$project$Cambiatus$Mutation$preference = F2(
	function (fillInOptionals____, object____) {
		var filledInOptionals____ = fillInOptionals____(
			{c_: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, c9: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, hy: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, d$: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, iB: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
		var optionalArgs____ = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'claimNotification', filledInOptionals____.c_, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'digest', filledInOptionals____.c9, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool),
					A3(
					$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional,
					'language',
					filledInOptionals____.hy,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Cambiatus$Enum$Language$toString)),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'transferNotification', filledInOptionals____.d$, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'validatorEmail', filledInOptionals____.iB, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)
				]));
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'preference',
			optionalArgs____,
			object____,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
	});
var $author$project$Session$LoggedIn$sendPreferredLanguage = F2(
	function (model, language) {
		var languageEnum = function () {
			switch (language) {
				case 4:
					return $elm$core$Maybe$Just(0);
				case 0:
					return $elm$core$Maybe$Just(1);
				case 2:
					return $elm$core$Maybe$Just(2);
				case 1:
					return $elm$core$Maybe$Just(3);
				default:
					return $elm$core$Maybe$Nothing;
			}
		}();
		if (languageEnum.$ === 1) {
			return $elm$core$Platform$Cmd$none;
		} else {
			var languageArg = languageEnum.a;
			return A3(
				$author$project$Session$LoggedIn$internalMutation,
				model,
				A2(
					$author$project$Cambiatus$Mutation$preference,
					function (optionals) {
						return _Utils_update(
							optionals,
							{
								hy: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(languageArg)
							});
					},
					$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(0)),
				$author$project$Session$LoggedIn$CompletedSendingLanguagePreference);
		}
	});
var $dillonkearns$elm_graphql$Graphql$Document$serializeSubscription = function (_v0) {
	var fields = _v0.a;
	var decoder_ = _v0.b;
	return A2($dillonkearns$elm_graphql$Graphql$Document$serialize, 'subscription', fields);
};
var $author$project$Api$Graphql$SignInResponse = F2(
	function (profile, token) {
		return {kJ: profile, pC: token};
	});
var $author$project$Cambiatus$Mutation$signIn = F3(
	function (fillInOptionals____, requiredArgs____, object____) {
		var filledInOptionals____ = fillInOptionals____(
			{jT: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
		var optionalArgs____ = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'invitationId', filledInOptionals____.jT, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)
				]));
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'signIn',
			_Utils_ap(
				optionalArgs____,
				_List_fromArray(
					[
						A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'account', requiredArgs____.fl, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string),
						A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'password', requiredArgs____.kx, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)
					])),
			object____,
			$elm$core$Basics$identity);
	});
var $author$project$Cambiatus$Object$Session$token = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'token', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$Session$user = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'user', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Api$Graphql$signIn = F3(
	function (shared, _v0, toMsg) {
		var account = _v0.fl;
		var password = _v0.kx;
		var invitationId = _v0.jT;
		var _v1 = password;
		var unwrappedPassword = _v1;
		return A4(
			$author$project$Api$Graphql$mutation,
			shared,
			$elm$core$Maybe$Nothing,
			A3(
				$author$project$Cambiatus$Mutation$signIn,
				function (opts) {
					return _Utils_update(
						opts,
						{
							jT: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(invitationId)
						});
				},
				{
					fl: $author$project$Eos$Account$nameToString(account),
					kx: unwrappedPassword
				},
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $elm$core$Basics$identity, $author$project$Cambiatus$Object$Session$token),
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$Cambiatus$Object$Session$user($author$project$Profile$selectionSet),
						$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Api$Graphql$SignInResponse)))),
			toMsg);
	});
var $author$project$Eos$Account$encodePrivateKey = function (_v0) {
	var pk = _v0;
	return $elm$json$Json$Encode$string(pk);
};
var $author$project$Api$Graphql$signPhrasePort = F3(
	function (responseAddress, privateKey, _v0) {
		var phrase = _v0;
		return {
			i9: $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'name',
						$elm$json$Json$Encode$string('signString')),
						_Utils_Tuple2(
						'input',
						$elm$json$Json$Encode$string(phrase)),
						_Utils_Tuple2(
						'privateKey',
						$author$project$Eos$Account$encodePrivateKey(privateKey))
					])),
			kY: responseAddress,
			kZ: $elm$json$Json$Encode$null
		};
	});
var $author$project$Ports$storeAuthToken = _Platform_outgoingPort('storeAuthToken', $elm$json$Json$Encode$string);
var $author$project$Api$Graphql$storeToken = function (_v0) {
	var token = _v0;
	return $author$project$Ports$storeAuthToken(token);
};
var $author$project$Cambiatus$Object$UnreadNotifications$unreads = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'unreads', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$Session$LoggedIn$unreadSelection = $author$project$Cambiatus$Object$UnreadNotifications$unreads;
var $author$project$Cambiatus$InputObject$encodeUnreadNotificationsSubscriptionInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'account',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.fl)))
			]));
};
var $author$project$Cambiatus$Subscription$unreads = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'unreads',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.nl, $author$project$Cambiatus$InputObject$encodeUnreadNotificationsSubscriptionInput)
				]),
			object____,
			$elm$core$Basics$identity);
	});
var $author$project$Session$LoggedIn$unreadCountSubscription = function (name) {
	var stringName = $author$project$Eos$Account$nameToString(name);
	var args = {
		nl: {fl: stringName}
	};
	return A2($author$project$Cambiatus$Subscription$unreads, args, $author$project$Session$LoggedIn$unreadSelection);
};
var $author$project$Action$ShowFeedback = $elm$core$Basics$identity;
var $author$project$View$Feedback$Success = 0;
var $author$project$Route$addRouteToUrl = F2(
	function (shared, route) {
		var protocol = function () {
			var _v1 = shared.gL.oU;
			if (!_v1) {
				return 'http://';
			} else {
				return 'https://';
			}
		}();
		var port_ = function () {
			var _v0 = shared.gL.oI;
			if (_v0.$ === 1) {
				return '';
			} else {
				var p = _v0.a;
				return ':' + $elm$core$String$fromInt(p);
			}
		}();
		return A2(
			$elm$core$Maybe$withDefault,
			shared.gL,
			$elm$url$Url$fromString(
				_Utils_ap(
					protocol,
					_Utils_ap(
						shared.gL.ez,
						_Utils_ap(
							port_,
							$author$project$Route$routeToString(route))))));
	});
var $author$project$Markdown$encode = function (_v0) {
	var markdown = _v0;
	return $elm$json$Json$Encode$string(
		$elm$core$String$trim(markdown));
};
var $author$project$Action$encodeId = function (_v0) {
	var id = _v0;
	return $elm$json$Json$Encode$int(id);
};
var $author$project$Action$idToInt = function (_v0) {
	var id = _v0;
	return id;
};
var $author$project$Action$objectiveIdToInt = function (_v0) {
	var id = _v0;
	return id;
};
var $author$project$Action$shareActionButtonId = function (actionId) {
	return 'share-action-button-' + $elm$core$String$fromInt(
		$author$project$Action$idToInt(actionId));
};
var $author$project$Action$shareActionFallbackId = function (actionId) {
	return 'share-action-fallback-' + $elm$core$String$fromInt(
		$author$project$Action$idToInt(actionId));
};
var $author$project$Action$update = F2(
	function (msg, loggedIn) {
		switch (msg.$) {
			case 0:
				return $author$project$UpdateResult$init(0);
			case 1:
				var action = msg.a;
				var sharePort = loggedIn.aM.iW ? {
					i9: $elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string('share')),
								_Utils_Tuple2(
								'title',
								$author$project$Markdown$encode(action.bc)),
								_Utils_Tuple2(
								'url',
								$elm$json$Json$Encode$string(
									$elm$url$Url$toString(
										A2(
											$author$project$Route$addRouteToUrl,
											loggedIn.aM,
											$author$project$Route$CommunityObjectives(
												$author$project$Route$WithObjectiveSelected(
													{
														iG: $elm$core$Maybe$Just(
															$author$project$Action$idToInt(action.R)),
														R: $author$project$Action$objectiveIdToInt(action.bi.R)
													}))))))
							])),
					kY: msg,
					kZ: $elm$json$Json$Encode$null
				} : {
					i9: $elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string('copyToClipboard')),
								_Utils_Tuple2(
								'id',
								$elm$json$Json$Encode$string(
									$author$project$Action$shareActionFallbackId(action.R)))
							])),
					kY: msg,
					kZ: $author$project$Action$encodeId(action.R)
				};
				return A2(
					$author$project$UpdateResult$addPort,
					sharePort,
					$author$project$UpdateResult$init(0));
			default:
				var actionId = msg.a;
				return A2(
					$author$project$UpdateResult$addCmd,
					A2(
						$elm$core$Task$attempt,
						function (_v1) {
							return $author$project$Action$NoOp;
						},
						$elm$browser$Browser$Dom$focus(
							$author$project$Action$shareActionButtonId(actionId))),
					A2(
						$author$project$UpdateResult$addExt,
						A2(
							$author$project$View$Feedback$Visible,
							0,
							loggedIn.aM.iw.il('copied_to_clipboard')),
						$author$project$UpdateResult$init(0)));
		}
	});
var $author$project$Auth$CompletedAuth = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$View$Pin$Pin = 0;
var $author$project$Auth$SetFeedback = function (a) {
	return {$: 2, a: a};
};
var $author$project$Auth$SubmittedPin = function (a) {
	return {$: 1, a: a};
};
var $author$project$Log$UnknownError = 5;
var $author$project$Auth$UpdatedShared = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ports$storePinVisibility = _Platform_outgoingPort('storePinVisibility', $elm$json$Json$Encode$bool);
var $author$project$View$Pin$postSubmitAction = F4(
	function (model, pin, shared, toMsg) {
		return _Utils_Tuple2(
			_Utils_update(
				shared,
				{oF: model.cu}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Task$perform,
						toMsg,
						$elm$core$Task$succeed(pin)),
						$author$project$Ports$storePinVisibility(model.cu)
					])));
	});
var $author$project$View$Pin$GotFormMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$View$Pin$PinConfirmation = 1;
var $author$project$View$Pin$SendFeedback = function (a) {
	return {$: 1, a: a};
};
var $author$project$View$Pin$SubmitPin = function (a) {
	return {$: 0, a: a};
};
var $author$project$Form$getValue = F2(
	function (getter, _v0) {
		var model = _v0;
		return getter(model.s);
	});
var $author$project$Form$GotDatePickerMsg = F5(
	function (a, b, c, d, e) {
		return {$: 4, a: a, b: b, c: c, d: d, e: e};
	});
var $author$project$Form$GotFileMsg = F4(
	function (a, b, c, d) {
		return {$: 3, a: a, b: b, c: c, d: d};
	});
var $author$project$Form$GotRichTextMsg = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $author$project$Form$GotUserPickerMsg = F5(
	function (a, b, c, d, e) {
		return {$: 5, a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Set$remove = F2(
	function (key, _v0) {
		var dict = _v0;
		return A2($elm$core$Dict$remove, key, dict);
	});
var $justinmimbs$date$Date$Days = 3;
var $author$project$Form$DatePicker$NoOp = {$: 0};
var $justinmimbs$date$Date$Months = 1;
var $elm$core$Basics$min = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) < 0) ? x : y;
	});
var $justinmimbs$date$Date$monthToNumber = function (m) {
	switch (m) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		case 6:
			return 7;
		case 7:
			return 8;
		case 8:
			return 9;
		case 9:
			return 10;
		case 10:
			return 11;
		default:
			return 12;
	}
};
var $justinmimbs$date$Date$numberToMonth = function (mn) {
	var _v0 = A2($elm$core$Basics$max, 1, mn);
	switch (_v0) {
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		case 4:
			return 3;
		case 5:
			return 4;
		case 6:
			return 5;
		case 7:
			return 6;
		case 8:
			return 7;
		case 9:
			return 8;
		case 10:
			return 9;
		case 11:
			return 10;
		default:
			return 11;
	}
};
var $justinmimbs$date$Date$toCalendarDateHelp = F3(
	function (y, m, d) {
		toCalendarDateHelp:
		while (true) {
			var monthDays = A2($justinmimbs$date$Date$daysInMonth, y, m);
			var mn = $justinmimbs$date$Date$monthToNumber(m);
			if ((mn < 12) && (_Utils_cmp(d, monthDays) > 0)) {
				var $temp$y = y,
					$temp$m = $justinmimbs$date$Date$numberToMonth(mn + 1),
					$temp$d = d - monthDays;
				y = $temp$y;
				m = $temp$m;
				d = $temp$d;
				continue toCalendarDateHelp;
			} else {
				return {ja: d, kd: m, lI: y};
			}
		}
	});
var $justinmimbs$date$Date$divWithRemainder = F2(
	function (a, b) {
		return _Utils_Tuple2(
			A2($justinmimbs$date$Date$floorDiv, a, b),
			A2($elm$core$Basics$modBy, b, a));
	});
var $justinmimbs$date$Date$year = function (_v0) {
	var rd = _v0;
	var _v1 = A2($justinmimbs$date$Date$divWithRemainder, rd, 146097);
	var n400 = _v1.a;
	var r400 = _v1.b;
	var _v2 = A2($justinmimbs$date$Date$divWithRemainder, r400, 36524);
	var n100 = _v2.a;
	var r100 = _v2.b;
	var _v3 = A2($justinmimbs$date$Date$divWithRemainder, r100, 1461);
	var n4 = _v3.a;
	var r4 = _v3.b;
	var _v4 = A2($justinmimbs$date$Date$divWithRemainder, r4, 365);
	var n1 = _v4.a;
	var r1 = _v4.b;
	var n = (!r1) ? 0 : 1;
	return ((((n400 * 400) + (n100 * 100)) + (n4 * 4)) + n1) + n;
};
var $justinmimbs$date$Date$toOrdinalDate = function (_v0) {
	var rd = _v0;
	var y = $justinmimbs$date$Date$year(rd);
	return {
		h$: rd - $justinmimbs$date$Date$daysBeforeYear(y),
		lI: y
	};
};
var $justinmimbs$date$Date$toCalendarDate = function (_v0) {
	var rd = _v0;
	var date = $justinmimbs$date$Date$toOrdinalDate(rd);
	return A3($justinmimbs$date$Date$toCalendarDateHelp, date.lI, 0, date.h$);
};
var $justinmimbs$date$Date$add = F3(
	function (unit, n, _v0) {
		var rd = _v0;
		switch (unit) {
			case 0:
				return A3($justinmimbs$date$Date$add, 1, 12 * n, rd);
			case 1:
				var date = $justinmimbs$date$Date$toCalendarDate(rd);
				var wholeMonths = ((12 * (date.lI - 1)) + ($justinmimbs$date$Date$monthToNumber(date.kd) - 1)) + n;
				var m = $justinmimbs$date$Date$numberToMonth(
					A2($elm$core$Basics$modBy, 12, wholeMonths) + 1);
				var y = A2($justinmimbs$date$Date$floorDiv, wholeMonths, 12) + 1;
				return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + A2(
					$elm$core$Basics$min,
					date.ja,
					A2($justinmimbs$date$Date$daysInMonth, y, m));
			case 2:
				return rd + (7 * n);
			default:
				return rd + n;
		}
	});
var $CurrySoftware$elm_datepicker$DatePicker$isOpen = function (_v0) {
	var model = _v0;
	return model.bj;
};
var $CurrySoftware$elm_datepicker$DatePicker$Focus = {$: 5};
var $CurrySoftware$elm_datepicker$DatePicker$open = $CurrySoftware$elm_datepicker$DatePicker$Focus;
var $CurrySoftware$elm_datepicker$DatePicker$Pick = function (a) {
	return {$: 2, a: a};
};
var $CurrySoftware$elm_datepicker$DatePicker$pick = $CurrySoftware$elm_datepicker$DatePicker$Pick;
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $elm$time$Time$Sun = 6;
var $justinmimbs$date$Date$day = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.ja;
	});
var $justinmimbs$date$Date$month = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.kd;
	});
var $justinmimbs$date$Date$monthNumber = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToNumber);
var $justinmimbs$date$Date$ordinalDay = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toOrdinalDate,
	function ($) {
		return $.h$;
	});
var $elm$core$String$padLeft = F3(
	function (n, _char, string) {
		return _Utils_ap(
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)),
			string);
	});
var $elm$core$Basics$abs = function (n) {
	return (n < 0) ? (-n) : n;
};
var $justinmimbs$date$Date$padSignedInt = F2(
	function (length, _int) {
		return _Utils_ap(
			(_int < 0) ? '-' : '',
			A3(
				$elm$core$String$padLeft,
				length,
				'0',
				$elm$core$String$fromInt(
					$elm$core$Basics$abs(_int))));
	});
var $justinmimbs$date$Date$monthToQuarter = function (m) {
	return (($justinmimbs$date$Date$monthToNumber(m) + 2) / 3) | 0;
};
var $justinmimbs$date$Date$quarter = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToQuarter);
var $elm$core$String$right = F2(
	function (n, string) {
		return (n < 1) ? '' : A3(
			$elm$core$String$slice,
			-n,
			$elm$core$String$length(string),
			string);
	});
var $justinmimbs$date$Date$weekdayNumber = function (_v0) {
	var rd = _v0;
	var _v1 = A2($elm$core$Basics$modBy, 7, rd);
	if (!_v1) {
		return 7;
	} else {
		var n = _v1;
		return n;
	}
};
var $justinmimbs$date$Date$daysBeforeWeekYear = function (y) {
	var jan4 = $justinmimbs$date$Date$daysBeforeYear(y) + 4;
	return jan4 - $justinmimbs$date$Date$weekdayNumber(jan4);
};
var $elm$time$Time$Fri = 4;
var $elm$time$Time$Mon = 0;
var $elm$time$Time$Sat = 5;
var $elm$time$Time$Thu = 3;
var $elm$time$Time$Tue = 1;
var $elm$time$Time$Wed = 2;
var $justinmimbs$date$Date$numberToWeekday = function (wdn) {
	var _v0 = A2($elm$core$Basics$max, 1, wdn);
	switch (_v0) {
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		case 4:
			return 3;
		case 5:
			return 4;
		case 6:
			return 5;
		default:
			return 6;
	}
};
var $justinmimbs$date$Date$toWeekDate = function (_v0) {
	var rd = _v0;
	var wdn = $justinmimbs$date$Date$weekdayNumber(rd);
	var wy = $justinmimbs$date$Date$year(rd + (4 - wdn));
	var week1Day1 = $justinmimbs$date$Date$daysBeforeWeekYear(wy) + 1;
	return {
		lG: 1 + (((rd - week1Day1) / 7) | 0),
		lH: wy,
		pT: $justinmimbs$date$Date$numberToWeekday(wdn)
	};
};
var $justinmimbs$date$Date$weekNumber = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toWeekDate,
	function ($) {
		return $.lG;
	});
var $justinmimbs$date$Date$weekYear = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toWeekDate,
	function ($) {
		return $.lH;
	});
var $justinmimbs$date$Date$weekday = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$weekdayNumber, $justinmimbs$date$Date$numberToWeekday);
var $justinmimbs$date$Date$ordinalSuffix = function (n) {
	var nn = A2($elm$core$Basics$modBy, 100, n);
	var _v0 = A2(
		$elm$core$Basics$min,
		(nn < 20) ? nn : A2($elm$core$Basics$modBy, 10, nn),
		4);
	switch (_v0) {
		case 1:
			return 'st';
		case 2:
			return 'nd';
		case 3:
			return 'rd';
		default:
			return 'th';
	}
};
var $justinmimbs$date$Date$withOrdinalSuffix = function (n) {
	return _Utils_ap(
		$elm$core$String$fromInt(n),
		$justinmimbs$date$Date$ordinalSuffix(n));
};
var $justinmimbs$date$Date$formatField = F4(
	function (language, _char, length, date) {
		switch (_char) {
			case 'y':
				if (length === 2) {
					return A2(
						$elm$core$String$right,
						2,
						A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$year(date))));
				} else {
					return A2(
						$justinmimbs$date$Date$padSignedInt,
						length,
						$justinmimbs$date$Date$year(date));
				}
			case 'Y':
				if (length === 2) {
					return A2(
						$elm$core$String$right,
						2,
						A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$weekYear(date))));
				} else {
					return A2(
						$justinmimbs$date$Date$padSignedInt,
						length,
						$justinmimbs$date$Date$weekYear(date));
				}
			case 'Q':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 2:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 3:
						return 'Q' + $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 4:
						return $justinmimbs$date$Date$withOrdinalSuffix(
							$justinmimbs$date$Date$quarter(date));
					case 5:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					default:
						return '';
				}
			case 'M':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$monthNumber(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$monthNumber(date)));
					case 3:
						return language.ge(
							$justinmimbs$date$Date$month(date));
					case 4:
						return language.hM(
							$justinmimbs$date$Date$month(date));
					case 5:
						return A2(
							$elm$core$String$left,
							1,
							language.ge(
								$justinmimbs$date$Date$month(date)));
					default:
						return '';
				}
			case 'w':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekNumber(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$weekNumber(date)));
					default:
						return '';
				}
			case 'd':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$day(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$day(date)));
					case 3:
						return language.g9(
							$justinmimbs$date$Date$day(date));
					default:
						return '';
				}
			case 'D':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$ordinalDay(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$ordinalDay(date)));
					case 3:
						return A3(
							$elm$core$String$padLeft,
							3,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$ordinalDay(date)));
					default:
						return '';
				}
			case 'E':
				switch (length) {
					case 1:
						return language.cR(
							$justinmimbs$date$Date$weekday(date));
					case 2:
						return language.cR(
							$justinmimbs$date$Date$weekday(date));
					case 3:
						return language.cR(
							$justinmimbs$date$Date$weekday(date));
					case 4:
						return language.iC(
							$justinmimbs$date$Date$weekday(date));
					case 5:
						return A2(
							$elm$core$String$left,
							1,
							language.cR(
								$justinmimbs$date$Date$weekday(date)));
					case 6:
						return A2(
							$elm$core$String$left,
							2,
							language.cR(
								$justinmimbs$date$Date$weekday(date)));
					default:
						return '';
				}
			case 'e':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekdayNumber(date));
					case 2:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekdayNumber(date));
					default:
						return A4($justinmimbs$date$Date$formatField, language, 'E', length, date);
				}
			default:
				return '';
		}
	});
var $justinmimbs$date$Date$formatWithTokens = F3(
	function (language, tokens, date) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (token, formatted) {
					if (!token.$) {
						var _char = token.a;
						var length = token.b;
						return _Utils_ap(
							A4($justinmimbs$date$Date$formatField, language, _char, length, date),
							formatted);
					} else {
						var str = token.a;
						return _Utils_ap(str, formatted);
					}
				}),
			'',
			tokens);
	});
var $justinmimbs$date$Pattern$Literal = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$toToken = function (str) {
	return A2(
		$elm$parser$Parser$Advanced$Token,
		str,
		$elm$parser$Parser$Expecting(str));
};
var $elm$parser$Parser$token = function (str) {
	return $elm$parser$Parser$Advanced$token(
		$elm$parser$Parser$toToken(str));
};
var $justinmimbs$date$Pattern$escapedQuote = A2(
	$elm$parser$Parser$ignorer,
	$elm$parser$Parser$succeed(
		$justinmimbs$date$Pattern$Literal('\'')),
	$elm$parser$Parser$token('\'\''));
var $justinmimbs$date$Pattern$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$getOffset = $elm$parser$Parser$Advanced$getOffset;
var $justinmimbs$date$Pattern$fieldRepeats = function (str) {
	var _v0 = $elm$core$String$toList(str);
	if (_v0.b && (!_v0.b.b)) {
		var _char = _v0.a;
		return A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed(
					F2(
						function (x, y) {
							return A2($justinmimbs$date$Pattern$Field, _char, 1 + (y - x));
						})),
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$getOffset,
					$elm$parser$Parser$chompWhile(
						$elm$core$Basics$eq(_char)))),
			$elm$parser$Parser$getOffset);
	} else {
		return $elm$parser$Parser$problem('expected exactly one char');
	}
};
var $justinmimbs$date$Pattern$field = A2(
	$elm$parser$Parser$andThen,
	$justinmimbs$date$Pattern$fieldRepeats,
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompIf($elm$core$Char$isAlpha)));
var $justinmimbs$date$Pattern$finalize = A2(
	$elm$core$List$foldl,
	F2(
		function (token, tokens) {
			var _v0 = _Utils_Tuple2(token, tokens);
			if (((_v0.a.$ === 1) && _v0.b.b) && (_v0.b.a.$ === 1)) {
				var x = _v0.a.a;
				var _v1 = _v0.b;
				var y = _v1.a.a;
				var rest = _v1.b;
				return A2(
					$elm$core$List$cons,
					$justinmimbs$date$Pattern$Literal(
						_Utils_ap(x, y)),
					rest);
			} else {
				return A2($elm$core$List$cons, token, tokens);
			}
		}),
	_List_Nil);
var $elm$parser$Parser$Advanced$lazy = function (thunk) {
	return function (s) {
		var _v0 = thunk(0);
		var parse = _v0;
		return parse(s);
	};
};
var $elm$parser$Parser$lazy = $elm$parser$Parser$Advanced$lazy;
var $justinmimbs$date$Pattern$isLiteralChar = function (_char) {
	return (_char !== '\'') && (!$elm$core$Char$isAlpha(_char));
};
var $justinmimbs$date$Pattern$literal = A2(
	$elm$parser$Parser$map,
	$justinmimbs$date$Pattern$Literal,
	$elm$parser$Parser$getChompedString(
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(0),
				$elm$parser$Parser$chompIf($justinmimbs$date$Pattern$isLiteralChar)),
			$elm$parser$Parser$chompWhile($justinmimbs$date$Pattern$isLiteralChar))));
var $justinmimbs$date$Pattern$quotedHelp = function (result) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$andThen,
				function (str) {
					return $justinmimbs$date$Pattern$quotedHelp(
						_Utils_ap(result, str));
				},
				$elm$parser$Parser$getChompedString(
					A2(
						$elm$parser$Parser$ignorer,
						A2(
							$elm$parser$Parser$ignorer,
							$elm$parser$Parser$succeed(0),
							$elm$parser$Parser$chompIf(
								$elm$core$Basics$neq('\''))),
						$elm$parser$Parser$chompWhile(
							$elm$core$Basics$neq('\''))))),
				A2(
				$elm$parser$Parser$andThen,
				function (_v0) {
					return $justinmimbs$date$Pattern$quotedHelp(result + '\'');
				},
				$elm$parser$Parser$token('\'\'')),
				$elm$parser$Parser$succeed(result)
			]));
};
var $justinmimbs$date$Pattern$quoted = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed($justinmimbs$date$Pattern$Literal),
		$elm$parser$Parser$chompIf(
			$elm$core$Basics$eq('\''))),
	A2(
		$elm$parser$Parser$ignorer,
		$justinmimbs$date$Pattern$quotedHelp(''),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$chompIf(
					$elm$core$Basics$eq('\'')),
					$elm$parser$Parser$end
				]))));
var $justinmimbs$date$Pattern$patternHelp = function (tokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$andThen,
				function (token) {
					return $justinmimbs$date$Pattern$patternHelp(
						A2($elm$core$List$cons, token, tokens));
				},
				$elm$parser$Parser$oneOf(
					_List_fromArray(
						[$justinmimbs$date$Pattern$field, $justinmimbs$date$Pattern$literal, $justinmimbs$date$Pattern$escapedQuote, $justinmimbs$date$Pattern$quoted]))),
				$elm$parser$Parser$lazy(
				function (_v0) {
					return $elm$parser$Parser$succeed(
						$justinmimbs$date$Pattern$finalize(tokens));
				})
			]));
};
var $justinmimbs$date$Pattern$fromString = function (str) {
	return A2(
		$elm$core$Result$withDefault,
		_List_fromArray(
			[
				$justinmimbs$date$Pattern$Literal(str)
			]),
		A2(
			$elm$parser$Parser$run,
			$justinmimbs$date$Pattern$patternHelp(_List_Nil),
			str));
};
var $justinmimbs$date$Date$formatWithLanguage = F2(
	function (language, pattern) {
		var tokens = $elm$core$List$reverse(
			$justinmimbs$date$Pattern$fromString(pattern));
		return A2($justinmimbs$date$Date$formatWithTokens, language, tokens);
	});
var $justinmimbs$date$Date$monthToName = function (m) {
	switch (m) {
		case 0:
			return 'January';
		case 1:
			return 'February';
		case 2:
			return 'March';
		case 3:
			return 'April';
		case 4:
			return 'May';
		case 5:
			return 'June';
		case 6:
			return 'July';
		case 7:
			return 'August';
		case 8:
			return 'September';
		case 9:
			return 'October';
		case 10:
			return 'November';
		default:
			return 'December';
	}
};
var $justinmimbs$date$Date$weekdayToName = function (wd) {
	switch (wd) {
		case 0:
			return 'Monday';
		case 1:
			return 'Tuesday';
		case 2:
			return 'Wednesday';
		case 3:
			return 'Thursday';
		case 4:
			return 'Friday';
		case 5:
			return 'Saturday';
		default:
			return 'Sunday';
	}
};
var $justinmimbs$date$Date$language_en = {
	g9: $justinmimbs$date$Date$withOrdinalSuffix,
	hM: $justinmimbs$date$Date$monthToName,
	ge: A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$monthToName,
		$elm$core$String$left(3)),
	iC: $justinmimbs$date$Date$weekdayToName,
	cR: A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$weekdayToName,
		$elm$core$String$left(3))
};
var $justinmimbs$date$Date$format = function (pattern) {
	return A2($justinmimbs$date$Date$formatWithLanguage, $justinmimbs$date$Date$language_en, pattern);
};
var $CurrySoftware$elm_datepicker$DatePicker$formatCell = function (day) {
	return $elm$html$Html$text(day);
};
var $CurrySoftware$elm_datepicker$DatePicker$Date$formatDay = function (day) {
	switch (day) {
		case 0:
			return 'Mo';
		case 1:
			return 'Tu';
		case 2:
			return 'We';
		case 3:
			return 'Th';
		case 4:
			return 'Fr';
		case 5:
			return 'Sa';
		default:
			return 'Su';
	}
};
var $CurrySoftware$elm_datepicker$DatePicker$Date$formatMonth = function (month) {
	switch (month) {
		case 0:
			return 'January';
		case 1:
			return 'February';
		case 2:
			return 'March';
		case 3:
			return 'April';
		case 4:
			return 'May';
		case 5:
			return 'June';
		case 6:
			return 'July';
		case 7:
			return 'August';
		case 8:
			return 'September';
		case 9:
			return 'October';
		case 10:
			return 'November';
		default:
			return 'December';
	}
};
var $justinmimbs$date$Date$deadEndToString = function (_v0) {
	var problem = _v0.oO;
	if (problem.$ === 12) {
		var message = problem.a;
		return message;
	} else {
		return 'Expected a date in ISO 8601 format';
	}
};
var $justinmimbs$date$Date$MonthAndDay = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $justinmimbs$date$Date$OrdinalDay = function (a) {
	return {$: 2, a: a};
};
var $justinmimbs$date$Date$WeekAndWeekday = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$backtrackable = $elm$parser$Parser$Advanced$backtrackable;
var $elm$parser$Parser$Advanced$commit = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, true, a, s);
	};
};
var $elm$parser$Parser$commit = $elm$parser$Parser$Advanced$commit;
var $elm$parser$Parser$mapChompedString = $elm$parser$Parser$Advanced$mapChompedString;
var $justinmimbs$date$Date$int1 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	$elm$parser$Parser$chompIf($elm$core$Char$isDigit));
var $justinmimbs$date$Date$int2 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed(0),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $justinmimbs$date$Date$int3 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(0),
				$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $justinmimbs$date$Date$dayOfYear = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed($elm$core$Basics$identity),
				$elm$parser$Parser$token('-')),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$elm$parser$Parser$backtrackable(
						A2(
							$elm$parser$Parser$andThen,
							$elm$parser$Parser$commit,
							A2($elm$parser$Parser$map, $justinmimbs$date$Date$OrdinalDay, $justinmimbs$date$Date$int3))),
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							$elm$parser$Parser$succeed($justinmimbs$date$Date$MonthAndDay),
							$justinmimbs$date$Date$int2),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$token('-')),
									$justinmimbs$date$Date$int2),
									$elm$parser$Parser$succeed(1)
								]))),
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							A2(
								$elm$parser$Parser$ignorer,
								$elm$parser$Parser$succeed($justinmimbs$date$Date$WeekAndWeekday),
								$elm$parser$Parser$token('W')),
							$justinmimbs$date$Date$int2),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$token('-')),
									$justinmimbs$date$Date$int1),
									$elm$parser$Parser$succeed(1)
								])))
					]))),
			$elm$parser$Parser$backtrackable(
			A2(
				$elm$parser$Parser$andThen,
				$elm$parser$Parser$commit,
				A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						$elm$parser$Parser$succeed($justinmimbs$date$Date$MonthAndDay),
						$justinmimbs$date$Date$int2),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								$justinmimbs$date$Date$int2,
								$elm$parser$Parser$succeed(1)
							]))))),
			A2($elm$parser$Parser$map, $justinmimbs$date$Date$OrdinalDay, $justinmimbs$date$Date$int3),
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($justinmimbs$date$Date$WeekAndWeekday),
					$elm$parser$Parser$token('W')),
				$justinmimbs$date$Date$int2),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$justinmimbs$date$Date$int1,
						$elm$parser$Parser$succeed(1)
					]))),
			$elm$parser$Parser$succeed(
			$justinmimbs$date$Date$OrdinalDay(1))
		]));
var $justinmimbs$date$Date$isBetweenInt = F3(
	function (a, b, x) {
		return (_Utils_cmp(a, x) < 1) && (_Utils_cmp(x, b) < 1);
	});
var $justinmimbs$date$Date$fromCalendarParts = F3(
	function (y, mn, d) {
		return (A3($justinmimbs$date$Date$isBetweenInt, 1, 12, mn) && A3(
			$justinmimbs$date$Date$isBetweenInt,
			1,
			A2(
				$justinmimbs$date$Date$daysInMonth,
				y,
				$justinmimbs$date$Date$numberToMonth(mn)),
			d)) ? $elm$core$Result$Ok(
			($justinmimbs$date$Date$daysBeforeYear(y) + A2(
				$justinmimbs$date$Date$daysBeforeMonth,
				y,
				$justinmimbs$date$Date$numberToMonth(mn))) + d) : $elm$core$Result$Err(
			'Invalid calendar date (' + ($elm$core$String$fromInt(y) + (', ' + ($elm$core$String$fromInt(mn) + (', ' + ($elm$core$String$fromInt(d) + ')'))))));
	});
var $justinmimbs$date$Date$fromOrdinalParts = F2(
	function (y, od) {
		return (A3($justinmimbs$date$Date$isBetweenInt, 1, 365, od) || ((od === 366) && $justinmimbs$date$Date$isLeapYear(y))) ? $elm$core$Result$Ok(
			$justinmimbs$date$Date$daysBeforeYear(y) + od) : $elm$core$Result$Err(
			'Invalid ordinal date (' + ($elm$core$String$fromInt(y) + (', ' + ($elm$core$String$fromInt(od) + ')'))));
	});
var $justinmimbs$date$Date$firstOfYear = function (y) {
	return $justinmimbs$date$Date$daysBeforeYear(y) + 1;
};
var $justinmimbs$date$Date$is53WeekYear = function (y) {
	var wdnJan1 = $justinmimbs$date$Date$weekdayNumber(
		$justinmimbs$date$Date$firstOfYear(y));
	return (wdnJan1 === 4) || ((wdnJan1 === 3) && $justinmimbs$date$Date$isLeapYear(y));
};
var $justinmimbs$date$Date$fromWeekParts = F3(
	function (wy, wn, wdn) {
		return (A3($justinmimbs$date$Date$isBetweenInt, 1, 7, wdn) && (A3($justinmimbs$date$Date$isBetweenInt, 1, 52, wn) || ((wn === 53) && $justinmimbs$date$Date$is53WeekYear(wy)))) ? $elm$core$Result$Ok(
			($justinmimbs$date$Date$daysBeforeWeekYear(wy) + ((wn - 1) * 7)) + wdn) : $elm$core$Result$Err(
			'Invalid week date (' + ($elm$core$String$fromInt(wy) + (', ' + ($elm$core$String$fromInt(wn) + (', ' + ($elm$core$String$fromInt(wdn) + ')'))))));
	});
var $justinmimbs$date$Date$fromYearAndDayOfYear = function (_v0) {
	var y = _v0.a;
	var doy = _v0.b;
	switch (doy.$) {
		case 0:
			var mn = doy.a;
			var d = doy.b;
			return A3($justinmimbs$date$Date$fromCalendarParts, y, mn, d);
		case 1:
			var wn = doy.a;
			var wdn = doy.b;
			return A3($justinmimbs$date$Date$fromWeekParts, y, wn, wdn);
		default:
			var od = doy.a;
			return A2($justinmimbs$date$Date$fromOrdinalParts, y, od);
	}
};
var $justinmimbs$date$Date$int4 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed(0),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									$elm$parser$Parser$chompIf(
									function (c) {
										return c === '-';
									}),
									$elm$parser$Parser$succeed(0)
								]))),
					$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
				$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $justinmimbs$date$Date$resultToParser = function (result) {
	if (!result.$) {
		var x = result.a;
		return $elm$parser$Parser$succeed(x);
	} else {
		var message = result.a;
		return $elm$parser$Parser$problem(message);
	}
};
var $justinmimbs$date$Date$parser = A2(
	$elm$parser$Parser$andThen,
	A2($elm$core$Basics$composeR, $justinmimbs$date$Date$fromYearAndDayOfYear, $justinmimbs$date$Date$resultToParser),
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed($elm$core$Tuple$pair),
			$justinmimbs$date$Date$int4),
		$justinmimbs$date$Date$dayOfYear));
var $justinmimbs$date$Date$fromIsoString = A2(
	$elm$core$Basics$composeR,
	$elm$parser$Parser$run(
		A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			A2(
				$elm$parser$Parser$ignorer,
				$justinmimbs$date$Date$parser,
				A2(
					$elm$parser$Parser$andThen,
					$justinmimbs$date$Date$resultToParser,
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								A2($elm$parser$Parser$map, $elm$core$Result$Ok, $elm$parser$Parser$end),
								A2(
								$elm$parser$Parser$map,
								$elm$core$Basics$always(
									$elm$core$Result$Err('Expected a date only, not a date and time')),
								$elm$parser$Parser$chompIf(
									$elm$core$Basics$eq('T'))),
								$elm$parser$Parser$succeed(
								$elm$core$Result$Err('Expected a date only'))
							])))))),
	$elm$core$Result$mapError(
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$head,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$map($justinmimbs$date$Date$deadEndToString),
				$elm$core$Maybe$withDefault('')))));
var $CurrySoftware$elm_datepicker$DatePicker$Date$Off = {$: 0};
var $CurrySoftware$elm_datepicker$DatePicker$off = $CurrySoftware$elm_datepicker$DatePicker$Date$Off;
var $elm$html$Html$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $elm$html$Html$Attributes$required = $elm$html$Html$Attributes$boolProperty('required');
var $CurrySoftware$elm_datepicker$DatePicker$defaultSettings = {
	gZ: $CurrySoftware$elm_datepicker$DatePicker$formatCell,
	l2: $CurrySoftware$elm_datepicker$DatePicker$off,
	c0: 'elm-datepicker--',
	mi: _List_Nil,
	mx: $justinmimbs$date$Date$format('yyyy-MM-dd'),
	g8: $CurrySoftware$elm_datepicker$DatePicker$Date$formatDay,
	fP: 6,
	nm: _List_fromArray(
		[
			$elm$html$Html$Attributes$required(false)
		]),
	no: _List_Nil,
	np: $elm$core$Maybe$Nothing,
	ht: $elm$core$Maybe$Nothing,
	ns: $elm$core$Basics$always(false),
	hL: $CurrySoftware$elm_datepicker$DatePicker$Date$formatMonth,
	af: $justinmimbs$date$Date$fromIsoString,
	oG: 'Please pick a date...',
	iF: $elm$core$String$fromInt
};
var $elm$html$Html$Attributes$disabled = $elm$html$Html$Attributes$boolProperty('disabled');
var $author$project$Form$DatePicker$settings = F2(
	function (_v0, viewConfig) {
		var options = _v0;
		var defaultSettings_ = $CurrySoftware$elm_datepicker$DatePicker$defaultSettings;
		return _Utils_update(
			defaultSettings_,
			{
				l2: $CurrySoftware$elm_datepicker$DatePicker$off,
				mi: _List_fromArray(
					[
						_Utils_Tuple2('relative-table w-full', !options.d5)
					]),
				mx: $justinmimbs$date$Date$format('E, d MMM y'),
				nm: _List_fromArray(
					[
						$elm$html$Html$Attributes$disabled(options.cf),
						A2($elm$html$Html$Attributes$attribute, 'inputmode', 'none')
					]),
				no: _List_fromArray(
					[
						_Utils_Tuple2('input w-full', true),
						_Utils_Tuple2('with-error', viewConfig.m$)
					]),
				np: $elm$core$Maybe$Just(options.R),
				ns: function (_v1) {
					return options.cf;
				},
				oG: viewConfig.iw.il('dates.select')
			});
	});
var $CurrySoftware$elm_datepicker$DatePicker$Disabled = function (a) {
	return {$: 2, a: a};
};
var $CurrySoftware$elm_datepicker$DatePicker$EmptyString = {$: 1};
var $CurrySoftware$elm_datepicker$DatePicker$FailedInput = function (a) {
	return {$: 1, a: a};
};
var $CurrySoftware$elm_datepicker$DatePicker$Invalid = function (a) {
	return {$: 0, a: a};
};
var $CurrySoftware$elm_datepicker$DatePicker$None = {$: 0};
var $CurrySoftware$elm_datepicker$DatePicker$Picked = function (a) {
	return {$: 2, a: a};
};
var $CurrySoftware$elm_datepicker$DatePicker$update = F3(
	function (settings, msg, _v0) {
		var model = _v0;
		var forceOpen = model.bE;
		var focused = model.av;
		switch (msg.$) {
			case 0:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							av: $elm$core$Maybe$Just(date),
							pB: date
						}),
					$CurrySoftware$elm_datepicker$DatePicker$None);
			case 1:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							av: $elm$core$Maybe$Just(date)
						}),
					$CurrySoftware$elm_datepicker$DatePicker$None);
			case 2:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{av: $elm$core$Maybe$Nothing, aY: $elm$core$Maybe$Nothing, bj: false}),
					$CurrySoftware$elm_datepicker$DatePicker$Picked(date));
			case 3:
				var text = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aY: $elm$core$Maybe$Just(text)
						}),
					$CurrySoftware$elm_datepicker$DatePicker$None);
			case 4:
				if (forceOpen) {
					return _Utils_Tuple2(model, $CurrySoftware$elm_datepicker$DatePicker$None);
				} else {
					var dateEvent = function () {
						var _v5 = model.aY;
						if (_v5.$ === 1) {
							return $CurrySoftware$elm_datepicker$DatePicker$FailedInput($CurrySoftware$elm_datepicker$DatePicker$EmptyString);
						} else {
							if (_v5.a === '') {
								return $CurrySoftware$elm_datepicker$DatePicker$FailedInput($CurrySoftware$elm_datepicker$DatePicker$EmptyString);
							} else {
								var rawInput = _v5.a;
								var _v6 = settings.af(rawInput);
								if (!_v6.$) {
									var date = _v6.a;
									return settings.ns(date) ? $CurrySoftware$elm_datepicker$DatePicker$FailedInput(
										$CurrySoftware$elm_datepicker$DatePicker$Disabled(date)) : $CurrySoftware$elm_datepicker$DatePicker$Picked(date);
								} else {
									var e = _v6.a;
									return $CurrySoftware$elm_datepicker$DatePicker$FailedInput(
										$CurrySoftware$elm_datepicker$DatePicker$Invalid(e));
								}
							}
						}
					}();
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								av: function () {
									if (dateEvent.$ === 2) {
										var date = dateEvent.a;
										return $elm$core$Maybe$Just(date);
									} else {
										return model.av;
									}
								}(),
								aY: function () {
									if (dateEvent.$ === 2) {
										return $elm$core$Maybe$Nothing;
									} else {
										return model.aY;
									}
								}()
							}),
						dateEvent);
				}
			case 5:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bE: false, bj: true}),
					$CurrySoftware$elm_datepicker$DatePicker$None);
			case 6:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bj: forceOpen}),
					$CurrySoftware$elm_datepicker$DatePicker$None);
			case 7:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bE: true}),
					$CurrySoftware$elm_datepicker$DatePicker$None);
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bE: false}),
					$CurrySoftware$elm_datepicker$DatePicker$None);
		}
	});
var $author$project$Form$DatePicker$updateDatePicker = F5(
	function (_v0, options, viewConfig, msg, _v1) {
		var usingArrowKeys = _v0.d2;
		var model = _v1;
		var openWithArrowKeys = function (newModel) {
			return usingArrowKeys ? A5(
				$author$project$Form$DatePicker$updateDatePicker,
				{d2: false},
				options,
				viewConfig,
				$CurrySoftware$elm_datepicker$DatePicker$open,
				newModel) : _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$none);
		};
		var _v2 = A3(
			$CurrySoftware$elm_datepicker$DatePicker$update,
			A2($author$project$Form$DatePicker$settings, options, viewConfig),
			msg,
			model.cC);
		if (_v2.b.$ === 2) {
			var newPicker = _v2.a;
			var newDate = _v2.b.a;
			return openWithArrowKeys(
				_Utils_update(
					model,
					{
						cC: newPicker,
						bQ: $elm$core$Maybe$Just(newDate)
					}));
		} else {
			var newPicker = _v2.a;
			return openWithArrowKeys(
				_Utils_update(
					model,
					{cC: newPicker}));
		}
	});
var $author$project$Form$DatePicker$update = F4(
	function (wrappedOptions, viewConfig, msg, _v0) {
		var options = wrappedOptions;
		var model = _v0;
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 1:
				var usingArrowKeys = msg.a;
				var subMsg = msg.b;
				return A5($author$project$Form$DatePicker$updateDatePicker, usingArrowKeys, wrappedOptions, viewConfig, subMsg, model);
			case 2:
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$Task$attempt,
						function (_v2) {
							return $author$project$Form$DatePicker$NoOp;
						},
						$elm$browser$Browser$Dom$focus(options.R)));
			case 3:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bQ: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none);
			default:
				var key = msg.a;
				var pickOrOpen = function () {
					if ($CurrySoftware$elm_datepicker$DatePicker$isOpen(model.cC)) {
						var _v5 = model.bQ;
						if (_v5.$ === 1) {
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						} else {
							var selectedDate = _v5.a;
							return A5(
								$author$project$Form$DatePicker$updateDatePicker,
								{d2: false},
								wrappedOptions,
								viewConfig,
								$CurrySoftware$elm_datepicker$DatePicker$pick(selectedDate),
								model);
						}
					} else {
						return A5(
							$author$project$Form$DatePicker$updateDatePicker,
							{d2: false},
							wrappedOptions,
							viewConfig,
							$CurrySoftware$elm_datepicker$DatePicker$open,
							model);
					}
				}();
				var addDays = function (amount) {
					var _v4 = model.bQ;
					if (_v4.$ === 1) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var selectedDate = _v4.a;
						return A5(
							$author$project$Form$DatePicker$updateDatePicker,
							{d2: true},
							wrappedOptions,
							viewConfig,
							$CurrySoftware$elm_datepicker$DatePicker$pick(
								A3($justinmimbs$date$Date$add, 3, amount, selectedDate)),
							model);
					}
				};
				switch (key) {
					case 2:
						return pickOrOpen;
					case 1:
						return pickOrOpen;
					case 3:
						return addDays(-7);
					case 4:
						return addDays(7);
					case 5:
						return addDays(-1);
					case 6:
						return addDays(1);
					default:
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$Form$File$GotImageCropperMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Form$File$LoadedFileType = function (a) {
	return {$: 1, a: a};
};
var $author$project$Form$File$LoadedWithCropped = function (a) {
	return {$: 2, a: a};
};
var $author$project$Form$File$Loading = function (a) {
	return {$: 0, a: a};
};
var $author$project$Form$File$LoadingWithCropped = function (a) {
	return {$: 3, a: a};
};
var $author$project$Form$File$SetLoadingState = $elm$core$Basics$identity;
var $author$project$Form$File$SingleEntry = function (a) {
	return {$: 0, a: a};
};
var $author$project$Form$File$WithError = function (a) {
	return {$: 5, a: a};
};
var $author$project$Form$File$Pdf = 0;
var $author$project$Form$File$fileTypeFromString = function (fileType) {
	if (fileType === 'application/pdf') {
		return $elm$core$Maybe$Just(0);
	} else {
		return A2($elm$core$String$startsWith, 'image/', fileType) ? $elm$core$Maybe$Just(1) : $elm$core$Maybe$Nothing;
	}
};
var $elm$file$File$mime = _File_mime;
var $author$project$Form$File$entryFromFile = F2(
	function (_v0, file) {
		var aspectRatio = _v0.q;
		var uploadId = _v0.aD;
		return A2(
			$elm$core$Maybe$map,
			function (fileType) {
				return {
					aH: $author$project$Form$File$LoadedFileType(fileType),
					ad: function () {
						if (aspectRatio.$ === 1) {
							return $author$project$Form$File$WithoutImageCropper;
						} else {
							var validAspectRatio = aspectRatio.a;
							if (!fileType) {
								return $author$project$Form$File$WithoutImageCropper;
							} else {
								return $author$project$Form$File$WithImageCropper(
									$author$project$View$ImageCropper$init(
										{q: validAspectRatio}));
							}
						}
					}(),
					aD: $elm$core$Maybe$Just(uploadId),
					gL: $author$project$Form$File$Loading(file)
				};
			},
			$author$project$Form$File$fileTypeFromString(
				$elm$file$File$mime(file)));
	});
var $author$project$Form$File$fileTypeFromPdfViewerFileType = function (fileType) {
	if (!fileType) {
		return 0;
	} else {
		return 1;
	}
};
var $elm_community$list_extra$List$Extra$getAt = F2(
	function (idx, xs) {
		return (idx < 0) ? $elm$core$Maybe$Nothing : $elm$core$List$head(
			A2($elm$core$List$drop, idx, xs));
	});
var $author$project$Form$File$originalUrlFromUrlStatus = function (urlStatus) {
	switch (urlStatus.$) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			var url = urlStatus.a;
			return $elm$core$Maybe$Just(url);
		case 2:
			var original = urlStatus.a.u;
			return $elm$core$Maybe$Just(original);
		case 3:
			var original = urlStatus.a.u;
			return $elm$core$Maybe$Just(original);
		case 4:
			var original = urlStatus.a.u;
			return $elm$core$Maybe$Just(original);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Form$File$imageCropperFromPreviousEntry = function (_v0) {
	var previous = _v0.kG;
	var _new = _v0.kk;
	var previousImageCropper = _v0.kH;
	var _v1 = _Utils_Tuple2(
		$author$project$Form$File$originalUrlFromUrlStatus(previous),
		$author$project$Form$File$originalUrlFromUrlStatus(_new));
	if ((!_v1.a.$) && (!_v1.b.$)) {
		var previousUrl = _v1.a.a;
		var newUrl = _v1.b.a;
		return _Utils_eq(previousUrl, newUrl) ? previousImageCropper : $author$project$Form$File$WithoutImageCropper;
	} else {
		return $author$project$Form$File$WithoutImageCropper;
	}
};
var $elm_community$list_extra$List$Extra$removeAt = F2(
	function (index, l) {
		if (index < 0) {
			return l;
		} else {
			var _v0 = A2($elm$core$List$drop, index, l);
			if (!_v0.b) {
				return l;
			} else {
				var rest = _v0.b;
				return _Utils_ap(
					A2($elm$core$List$take, index, l),
					rest);
			}
		}
	});
var $elm_community$list_extra$List$Extra$setAt = F2(
	function (index, value) {
		return A2(
			$elm_community$list_extra$List$Extra$updateAt,
			index,
			$elm$core$Basics$always(value));
	});
var $author$project$View$ImageCropper$CompletedCropping = $elm$core$Basics$identity;
var $author$project$View$ImageCropper$GotImageDimmensions = function (a) {
	return {$: 1, a: a};
};
var $author$project$View$ImageCropper$Loaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$View$ImageCropper$StartedDragging = {$: 2};
var $author$project$View$ImageCropper$calculateSelectionDimmensions = F2(
	function (model, dimmensions) {
		var calculatedSelectionWidth = dimmensions.K.y * dimmensions.aL;
		var calculatedSelectionHeight = calculatedSelectionWidth / model.q;
		var selectionWidth = (_Utils_cmp(calculatedSelectionHeight, dimmensions.K.fW) > 0) ? (dimmensions.K.fW * model.q) : calculatedSelectionWidth;
		return {fW: selectionWidth / model.q, y: selectionWidth};
	});
var $author$project$View$ImageCropper$entireImageId = 'image-cropper-bg-image';
var $elm$browser$Browser$Dom$getElement = _Browser_getElement;
var $author$project$View$ImageCropper$imageContainerId = 'image-cropper-image-container';
var $author$project$View$ImageCropper$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				return A2(
					$author$project$UpdateResult$addCmd,
					A2(
						$elm$core$Task$attempt,
						$author$project$View$ImageCropper$GotImageDimmensions,
						A2(
							$elm$core$Task$andThen,
							function (imageElement) {
								return A2(
									$elm$core$Task$map,
									function (containerElement) {
										return {i5: containerElement, jI: imageElement};
									},
									$elm$browser$Browser$Dom$getElement($author$project$View$ImageCropper$imageContainerId));
							},
							$elm$browser$Browser$Dom$getElement($author$project$View$ImageCropper$entireImageId))),
					$author$project$UpdateResult$init(model));
			case 1:
				if (!msg.a.$) {
					var imageElement = msg.a.a.jI;
					var containerElement = msg.a.a.i5;
					var image = imageElement.jg;
					var isExistingImage = function () {
						var _v3 = model.aa;
						if (!_v3.$) {
							return false;
						} else {
							var existingDimmensions = _v3.a;
							return _Utils_eq(existingDimmensions.jH.y, image.y) && _Utils_eq(existingDimmensions.jH.fW, image.fW);
						}
					}();
					var normalizeFromExisting = function (dimmensions) {
						var _v2 = model.aa;
						if (!_v2.$) {
							return dimmensions;
						} else {
							var existingDimmensions = _v2.a;
							return isExistingImage ? _Utils_update(
								dimmensions,
								{bK: (existingDimmensions.bK + dimmensions.K.j1) - existingDimmensions.K.j1, aL: existingDimmensions.aL, bY: (existingDimmensions.bY + dimmensions.K.bp) - existingDimmensions.K.bp}) : dimmensions;
						}
					};
					var container = containerElement.jg;
					var maximumWidthPossible = A2($elm$core$Basics$min, container.y, container.fW * model.q);
					var center = function (dimmensions) {
						if (isExistingImage) {
							return dimmensions;
						} else {
							var selection = A2($author$project$View$ImageCropper$calculateSelectionDimmensions, model, dimmensions);
							return _Utils_update(
								dimmensions,
								{bK: dimmensions.bK - (selection.y / 2), bY: dimmensions.bY - (selection.fW / 2)});
						}
					};
					var newDimmensions = center(
						normalizeFromExisting(
							{
								K: {fW: container.fW, j1: container.pW, bp: container.pX, y: container.y},
								jH: {fW: image.fW, j1: image.pW, bp: image.pX, y: image.y},
								bK: image.pW + (image.y / 2),
								eL: maximumWidthPossible / container.y,
								aL: (maximumWidthPossible / image.y) * 0.75,
								bY: image.pX + (image.fW / 2)
							}));
					return $author$project$UpdateResult$init(
						_Utils_update(
							model,
							{
								aa: $author$project$View$ImageCropper$Loaded(newDimmensions),
								eE: function () {
									var _v1 = model.aa;
									if (!_v1.$) {
										return false;
									} else {
										var existingDimmensions = _v1.a;
										return ($elm$core$Basics$abs(existingDimmensions.jH.y - newDimmensions.jH.y) > 50) || ($elm$core$Basics$abs(existingDimmensions.jH.fW - newDimmensions.jH.fW) > 50);
									}
								}()
							}));
				} else {
					var id = msg.a.a;
					return A6(
						$author$project$UpdateResult$logImpossible,
						msg,
						'Could not get image dimmensions',
						$elm$core$Maybe$Nothing,
						{mX: 'update', nW: 'View.ImageCropper'},
						_List_fromArray(
							[
								{
								mR: $elm$core$Dict$fromList(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'id',
											$elm$json$Json$Encode$string(id))
										])),
								ki: 'Browser.Dom error'
							}
							]),
						$author$project$UpdateResult$init(model));
				}
			case 2:
				return A2(
					$author$project$UpdateResult$addPort,
					{
						i9: $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'name',
									$elm$json$Json$Encode$string('addClassToDocument')),
									_Utils_Tuple2(
									'className',
									$elm$json$Json$Encode$string('cursor-move'))
								])),
						kY: $author$project$View$ImageCropper$StartedDragging,
						kZ: $elm$json$Json$Encode$null
					},
					$author$project$UpdateResult$init(
						_Utils_update(
							model,
							{bI: true})));
			case 3:
				return A2(
					$author$project$UpdateResult$addPort,
					{
						i9: $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'name',
									$elm$json$Json$Encode$string('removeClassFromDocument')),
									_Utils_Tuple2(
									'className',
									$elm$json$Json$Encode$string('cursor-move'))
								])),
						kY: $author$project$View$ImageCropper$StartedDragging,
						kZ: $elm$json$Json$Encode$null
					},
					$author$project$UpdateResult$init(
						_Utils_update(
							model,
							{bI: false, nw: true})));
			case 4:
				var x = msg.a.pW;
				var y = msg.a.pX;
				var _v4 = model.aa;
				if (!_v4.$) {
					return $author$project$UpdateResult$init(model);
				} else {
					var dimmensions = _v4.a;
					if (!model.bI) {
						return $author$project$UpdateResult$init(model);
					} else {
						var selection = A2($author$project$View$ImageCropper$calculateSelectionDimmensions, model, dimmensions);
						return $author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									aa: $author$project$View$ImageCropper$Loaded(
										_Utils_update(
											dimmensions,
											{bK: x - (selection.y / 2), bY: y - (selection.fW / 2)}))
								}));
					}
				}
			case 5:
				var percentageString = msg.a;
				var _v5 = model.aa;
				if (!_v5.$) {
					return $author$project$UpdateResult$init(model);
				} else {
					var dimmensions = _v5.a;
					var _v6 = $elm$core$String$toFloat(percentageString);
					if (_v6.$ === 1) {
						return $author$project$UpdateResult$init(model);
					} else {
						var percentageValue = _v6.a;
						return $author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									aa: $author$project$View$ImageCropper$Loaded(
										_Utils_update(
											dimmensions,
											{aL: percentageValue})),
									dn: $elm$core$Basics$abs(percentageValue - dimmensions.aL) <= 0.05
								}));
					}
				}
			case 6:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{dn: false, nw: true}));
			case 7:
				var operation = msg.a;
				var _v7 = model.aa;
				if (!_v7.$) {
					return $author$project$UpdateResult$init(model);
				} else {
					var dimmensions = _v7.a;
					var entireRange = dimmensions.eL - 0.1;
					var delta = 0.1 * entireRange;
					var clampPossibleValues = A2($elm$core$Basics$clamp, 0.1, dimmensions.eL);
					return $author$project$UpdateResult$init(
						_Utils_update(
							model,
							{
								aa: $author$project$View$ImageCropper$Loaded(
									_Utils_update(
										dimmensions,
										{
											aL: function () {
												if (!operation) {
													return clampPossibleValues(dimmensions.aL - delta);
												} else {
													return clampPossibleValues(dimmensions.aL + delta);
												}
											}()
										}))
							}));
				}
			default:
				var file = msg.a;
				return A2(
					$author$project$UpdateResult$addExt,
					file,
					$author$project$UpdateResult$init(
						_Utils_update(
							model,
							{nw: false})));
		}
	});
var $author$project$Form$File$LoadedWithCroppedUploaded = function (a) {
	return {$: 4, a: a};
};
var $author$project$Form$File$urlStatusFromResult = function (result) {
	if (!result.$) {
		var url = result.a;
		return $author$project$Form$File$Loaded(url);
	} else {
		var err = result.a;
		return $author$project$Form$File$WithError(err);
	}
};
var $author$project$Form$File$updateUrlStatusWithResult = F2(
	function (result, maybePreviousStatus) {
		if (maybePreviousStatus.$ === 1) {
			return $author$project$Form$File$urlStatusFromResult(result);
		} else {
			var previousStatus = maybePreviousStatus.a;
			if (result.$ === 1) {
				var err = result.a;
				return $author$project$Form$File$WithError(err);
			} else {
				var url = result.a;
				switch (previousStatus.$) {
					case 0:
						return $author$project$Form$File$Loaded(url);
					case 1:
						return $author$project$Form$File$Loaded(url);
					case 2:
						var original = previousStatus.a.u;
						var cropped = previousStatus.a._;
						return $author$project$Form$File$LoadedWithCroppedUploaded(
							{_: cropped, c6: url, u: original});
					case 3:
						var original = previousStatus.a.u;
						var cropped = previousStatus.a._;
						return $author$project$Form$File$LoadedWithCroppedUploaded(
							{_: cropped, c6: url, u: original});
					case 4:
						var original = previousStatus.a.u;
						var cropped = previousStatus.a._;
						return $author$project$Form$File$LoadedWithCroppedUploaded(
							{_: cropped, c6: url, u: original});
					default:
						return $author$project$Form$File$Loaded(url);
				}
			}
		}
	});
var $author$project$Form$File$CompletedUploadingFile = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Api$backendUrl = F3(
	function (_v0, paths, queryParams) {
		var endpoints = _v0.mJ;
		return A3(
			$elm$url$Url$Builder$crossOrigin,
			endpoints.lW,
			A2($elm$core$List$cons, 'api', paths),
			queryParams);
	});
var $elm$http$Http$filePart = _Http_pair;
var $elm$http$Http$multipartBody = function (parts) {
	return A2(
		_Http_pair,
		'',
		_Http_toFormData(parts));
};
var $author$project$Api$uploadImage = F3(
	function (shared, file, toMsg) {
		return $elm$http$Http$post(
			{
				fv: $elm$http$Http$multipartBody(
					_List_fromArray(
						[
							A2($elm$http$Http$filePart, 'file', file)
						])),
				fN: A2(
					$elm$http$Http$expectJson,
					toMsg,
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['data']),
						$elm$json$Json$Decode$string)),
				gL: A3(
					$author$project$Api$backendUrl,
					shared,
					_List_fromArray(
						['upload']),
					_List_Nil)
			});
	});
var $author$project$Form$File$uploadEntry = F3(
	function (shared, uploadId, entry) {
		var _v0 = entry.gL;
		switch (_v0.$) {
			case 0:
				var file = _v0.a;
				return A3(
					$author$project$Api$uploadImage,
					shared,
					file,
					$author$project$Form$File$CompletedUploadingFile(uploadId));
			case 1:
				return $elm$core$Platform$Cmd$none;
			case 2:
				var cropped = _v0.a._;
				return A3(
					$author$project$Api$uploadImage,
					shared,
					cropped,
					$author$project$Form$File$CompletedUploadingFile(uploadId));
			case 3:
				var cropped = _v0.a._;
				return A3(
					$author$project$Api$uploadImage,
					shared,
					cropped,
					$author$project$Form$File$CompletedUploadingFile(uploadId));
			case 4:
				return $elm$core$Platform$Cmd$none;
			default:
				return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Form$File$update = F3(
	function (shared, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var files = msg.a;
				var _v2 = model.f;
				if (!_v2.$) {
					var _v3 = A2(
						$elm$core$Maybe$andThen,
						$author$project$Form$File$entryFromFile(
							{q: model.q, aD: model.j}),
						$elm$core$List$head(files));
					if (!_v3.$) {
						var newEntry = _v3.a;
						return A2(
							$author$project$UpdateResult$addExt,
							true,
							A2(
								$author$project$UpdateResult$addCmd,
								A3($author$project$Form$File$uploadEntry, shared, model.j, newEntry),
								$author$project$UpdateResult$init(
									_Utils_update(
										model,
										{
											f: $author$project$Form$File$SingleEntry(
												$elm$core$Maybe$Just(newEntry)),
											j: model.j + 1,
											G: 1
										}))));
					} else {
						return A6(
							$author$project$UpdateResult$logImpossible,
							msg,
							'Input file is not a valid entry',
							$elm$core$Maybe$Nothing,
							{mX: 'update', nW: 'Form.File'},
							_List_Nil,
							$author$project$UpdateResult$init(model));
					}
				} else {
					var entries = _v2.a;
					var newEntries = A2(
						$elm$core$List$filterMap,
						$elm$core$Basics$identity,
						A2(
							$elm$core$List$indexedMap,
							F2(
								function (index, file) {
									return A2(
										$author$project$Form$File$entryFromFile,
										{q: model.q, aD: model.j + index},
										file);
								}),
							files));
					var uploadNewEntries = $elm$core$Platform$Cmd$batch(
						A2(
							$elm$core$List$filterMap,
							function (entry) {
								return A2(
									$elm$core$Maybe$map,
									function (uploadId) {
										return A3($author$project$Form$File$uploadEntry, shared, uploadId, entry);
									},
									entry.aD);
							},
							newEntries));
					return A2(
						$author$project$UpdateResult$addExt,
						true,
						A2(
							$author$project$UpdateResult$addCmd,
							uploadNewEntries,
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{
										f: $author$project$Form$File$MultipleEntries(
											_Utils_ap(entries, newEntries)),
										j: model.j + $elm$core$List$length(files),
										G: model.G + $elm$core$List$length(newEntries)
									}))));
				}
			case 1:
				var file = msg.a;
				var _v4 = A2(
					$author$project$Form$File$entryFromFile,
					{q: model.q, aD: model.j},
					file);
				if (!_v4.$) {
					var newEntry = _v4.a;
					var _v5 = function () {
						var _v6 = model.f;
						if (!_v6.$) {
							return _Utils_Tuple3(
								$author$project$Form$File$SingleEntry(
									$elm$core$Maybe$Just(newEntry)),
								A3($author$project$Form$File$uploadEntry, shared, model.j, newEntry),
								true);
						} else {
							var entries = _v6.a;
							var _v7 = model.t;
							if (!_v7.$) {
								var index = _v7.a;
								return _Utils_Tuple3(
									$author$project$Form$File$MultipleEntries(
										A3($elm_community$list_extra$List$Extra$setAt, index, newEntry, entries)),
									A3($author$project$Form$File$uploadEntry, shared, model.j, newEntry),
									true);
							} else {
								return _Utils_Tuple3(model.f, $elm$core$Platform$Cmd$none, false);
							}
						}
					}();
					var newEntries = _v5.a;
					var uploadEntryCmd = _v5.b;
					var succeeded = _v5.c;
					var addMaybeExtMsg = succeeded ? $author$project$UpdateResult$addExt(true) : $elm$core$Basics$identity;
					return addMaybeExtMsg(
						A2(
							$author$project$UpdateResult$addCmd,
							uploadEntryCmd,
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{
										f: newEntries,
										j: succeeded ? (model.j + 1) : model.j,
										G: succeeded ? (model.G + 1) : model.G
									}))));
				} else {
					return A6(
						$author$project$UpdateResult$logImpossible,
						msg,
						'Input file is not a valid entry to replace',
						$elm$core$Maybe$Nothing,
						{mX: 'update', nW: 'Form.File'},
						_List_Nil,
						$author$project$UpdateResult$init(model));
				}
			case 2:
				var uploadId = msg.a;
				var result = msg.b;
				var ownsThisUpload = function (entry) {
					return _Utils_eq(
						entry.aD,
						$elm$core$Maybe$Just(uploadId));
				};
				var maybeSetLoadingStateAsFalse = (model.G === 1) ? $author$project$UpdateResult$addExt(false) : $elm$core$Basics$identity;
				var isStale = function () {
					var _v10 = model.f;
					if (!_v10.$) {
						var maybeEntry = _v10.a;
						return !A2(
							$elm$core$Maybe$withDefault,
							false,
							A2($elm$core$Maybe$map, ownsThisUpload, maybeEntry));
					} else {
						var entries = _v10.a;
						return !A2($elm$core$List$any, ownsThisUpload, entries);
					}
				}();
				var applyResult = function (previousEntry) {
					var newUrlStatus = A2(
						$author$project$Form$File$updateUrlStatusWithResult,
						result,
						$elm$core$Maybe$Just(previousEntry.gL));
					return {
						aH: $author$project$Form$File$LoadingFileType,
						ad: $author$project$Form$File$imageCropperFromPreviousEntry(
							{kk: newUrlStatus, kG: previousEntry.gL, kH: previousEntry.ad}),
						aD: $elm$core$Maybe$Nothing,
						gL: newUrlStatus
					};
				};
				return isStale ? maybeSetLoadingStateAsFalse(
					$author$project$UpdateResult$init(
						_Utils_update(
							model,
							{G: model.G - 1}))) : maybeSetLoadingStateAsFalse(
					$author$project$UpdateResult$init(
						_Utils_update(
							model,
							{
								f: function () {
									var _v8 = model.f;
									if (!_v8.$) {
										var maybeEntry = _v8.a;
										return $author$project$Form$File$SingleEntry(
											A2($elm$core$Maybe$map, applyResult, maybeEntry));
									} else {
										var entries = _v8.a;
										return $author$project$Form$File$MultipleEntries(
											A2(
												$elm$core$List$map,
												function (entry) {
													return ownsThisUpload(entry) ? applyResult(entry) : entry;
												},
												entries));
									}
								}(),
								ae: false,
								G: model.G - 1,
								t: function () {
									var _v9 = model.f;
									if (!_v9.$) {
										return model.ae ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(0);
									} else {
										return model.t;
									}
								}()
							})));
			case 3:
				var index = msg.a;
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{
							t: $elm$core$Maybe$Just(index)
						}));
			case 4:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{t: $elm$core$Maybe$Nothing}));
			case 5:
				var subMsg = msg.a;
				var setEntryFile = F2(
					function (file, entry) {
						return _Utils_update(
							entry,
							{
								gL: function () {
									var _v20 = entry.gL;
									switch (_v20.$) {
										case 1:
											var original = _v20.a;
											return $author$project$Form$File$LoadedWithCropped(
												{_: file, u: original});
										case 2:
											var original = _v20.a.u;
											return $author$project$Form$File$LoadedWithCropped(
												{_: file, u: original});
										case 3:
											var original = _v20.a.u;
											return $author$project$Form$File$LoadingWithCropped(
												{_: file, u: original});
										case 4:
											var original = _v20.a.u;
											return $author$project$Form$File$LoadedWithCropped(
												{_: file, u: original});
										case 5:
											var err = _v20.a;
											return $author$project$Form$File$WithError(err);
										default:
											var loading = _v20.a;
											return $author$project$Form$File$Loading(loading);
									}
								}()
							});
					});
				var handleExt = F3(
					function (getEntry, updateEntryInModel, _v19) {
						var newFile = _v19;
						return $author$project$UpdateResult$mapModel(
							function (m) {
								var _v18 = getEntry(m);
								if (_v18.$ === 1) {
									return m;
								} else {
									var entry = _v18.a;
									return A2(
										updateEntryInModel,
										m,
										A2(setEntryFile, newFile, entry));
								}
							});
					});
				var updateEntry = F2(
					function (getEntry, updateEntryInModel) {
						var _v16 = getEntry(model);
						if (_v16.$ === 1) {
							return $author$project$UpdateResult$init(model);
						} else {
							var entry = _v16.a;
							var _v17 = entry.ad;
							if (!_v17.$) {
								return $author$project$UpdateResult$init(model);
							} else {
								var imageCropper = _v17.a;
								return A5(
									$author$project$UpdateResult$fromChild,
									function (newImageCropper) {
										return A2(
											updateEntryInModel,
											model,
											_Utils_update(
												entry,
												{
													ad: $author$project$Form$File$WithImageCropper(newImageCropper)
												}));
									},
									$author$project$Form$File$GotImageCropperMsg,
									A2(handleExt, getEntry, updateEntryInModel),
									model,
									A2($author$project$View$ImageCropper$update, subMsg, imageCropper));
							}
						}
					});
				return A2(
					updateEntry,
					function (_v11) {
						var m = _v11;
						var _v12 = m.f;
						if (!_v12.$) {
							var maybeEntry = _v12.a;
							return maybeEntry;
						} else {
							var entries = _v12.a;
							return A2(
								$elm$core$Maybe$andThen,
								function (index) {
									return A2($elm_community$list_extra$List$Extra$getAt, index, entries);
								},
								m.t);
						}
					},
					F2(
						function (_v13, newEntry) {
							var m = _v13;
							var _v14 = m.f;
							if (!_v14.$) {
								return _Utils_update(
									m,
									{
										f: $author$project$Form$File$SingleEntry(
											$elm$core$Maybe$Just(newEntry))
									});
							} else {
								var entries = _v14.a;
								var _v15 = m.t;
								if (_v15.$ === 1) {
									return m;
								} else {
									var index = _v15.a;
									return _Utils_update(
										m,
										{
											f: $author$project$Form$File$MultipleEntries(
												A3($elm_community$list_extra$List$Extra$setAt, index, newEntry, entries))
										});
								}
							}
						}));
			case 6:
				var index = msg.a;
				var fileType = msg.b;
				var updateEntry = function (entry) {
					return _Utils_update(
						entry,
						{
							aH: $author$project$Form$File$LoadedFileType(
								$author$project$Form$File$fileTypeFromPdfViewerFileType(fileType)),
							ad: function () {
								var _v23 = $author$project$Form$File$fileTypeFromPdfViewerFileType(fileType);
								if (_v23 === 1) {
									var _v24 = model.q;
									if (_v24.$ === 1) {
										return $author$project$Form$File$WithoutImageCropper;
									} else {
										var aspectRatio = _v24.a;
										var _v25 = entry.ad;
										if (!_v25.$) {
											return $author$project$Form$File$WithImageCropper(
												$author$project$View$ImageCropper$init(
													{q: aspectRatio}));
										} else {
											var cropper = _v25.a;
											return $author$project$Form$File$WithImageCropper(cropper);
										}
									}
								} else {
									return $author$project$Form$File$WithoutImageCropper;
								}
							}()
						});
				};
				var _v21 = model.f;
				if (!_v21.$) {
					if (_v21.a.$ === 1) {
						var _v22 = _v21.a;
						return $author$project$UpdateResult$init(model);
					} else {
						var entry = _v21.a.a;
						return $author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									f: $author$project$Form$File$SingleEntry(
										$elm$core$Maybe$Just(
											updateEntry(entry)))
								}));
					}
				} else {
					var entries = _v21.a;
					return $author$project$UpdateResult$init(
						_Utils_update(
							model,
							{
								f: $author$project$Form$File$MultipleEntries(
									A3($elm_community$list_extra$List$Extra$updateAt, index, updateEntry, entries))
							}));
				}
			case 7:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{
							f: function () {
								var _v26 = model.f;
								if (!_v26.$) {
									return $author$project$Form$File$SingleEntry($elm$core$Maybe$Nothing);
								} else {
									var entries = _v26.a;
									var _v27 = model.t;
									if (_v27.$ === 1) {
										return $author$project$Form$File$MultipleEntries(entries);
									} else {
										var index = _v27.a;
										return $author$project$Form$File$MultipleEntries(
											A2($elm_community$list_extra$List$Extra$removeAt, index, entries));
									}
								}
							}(),
							t: $elm$core$Maybe$Nothing
						}));
			default:
				var updateEntry = F2(
					function (uploadId, entry) {
						var fromOriginalAndCropped = function (data) {
							var newEntry = _Utils_update(
								entry,
								{
									aD: $elm$core$Maybe$Just(uploadId),
									gL: $author$project$Form$File$LoadingWithCropped(data)
								});
							return _Utils_Tuple2(
								newEntry,
								A3($author$project$Form$File$uploadEntry, shared, uploadId, newEntry));
						};
						var _v34 = entry.gL;
						switch (_v34.$) {
							case 2:
								var data = _v34.a;
								return fromOriginalAndCropped(data);
							case 3:
								var data = _v34.a;
								return fromOriginalAndCropped(data);
							case 4:
								var original = _v34.a.u;
								var cropped = _v34.a._;
								return fromOriginalAndCropped(
									{_: cropped, u: original});
							case 0:
								return _Utils_Tuple2(entry, $elm$core$Platform$Cmd$none);
							case 1:
								return _Utils_Tuple2(entry, $elm$core$Platform$Cmd$none);
							default:
								return _Utils_Tuple2(entry, $elm$core$Platform$Cmd$none);
						}
					});
				var _v28 = model.f;
				if (!_v28.$) {
					if (_v28.a.$ === 1) {
						var _v29 = _v28.a;
						return $author$project$UpdateResult$init(
							_Utils_update(
								model,
								{ae: true, t: $elm$core$Maybe$Nothing}));
					} else {
						var entry = _v28.a.a;
						var _v30 = A2(updateEntry, model.j, entry);
						var newEntry = _v30.a;
						var cmd = _v30.b;
						return A2(
							$author$project$UpdateResult$addCmd,
							cmd,
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{
										f: $author$project$Form$File$SingleEntry(
											$elm$core$Maybe$Just(newEntry)),
										ae: true,
										j: model.j + 1,
										t: $elm$core$Maybe$Nothing
									})));
					}
				} else {
					var entries = _v28.a;
					var _v31 = model.t;
					if (_v31.$ === 1) {
						return $author$project$UpdateResult$init(model);
					} else {
						var openImageCropperIndex = _v31.a;
						var _v32 = A2($elm_community$list_extra$List$Extra$getAt, openImageCropperIndex, entries);
						if (_v32.$ === 1) {
							return $author$project$UpdateResult$init(
								_Utils_update(
									model,
									{t: $elm$core$Maybe$Nothing}));
						} else {
							var entry = _v32.a;
							var _v33 = A2(updateEntry, model.j, entry);
							var newEntry = _v33.a;
							var cmd = _v33.b;
							return A2(
								$author$project$UpdateResult$addCmd,
								cmd,
								$author$project$UpdateResult$init(
									_Utils_update(
										model,
										{
											f: $author$project$Form$File$MultipleEntries(
												A3($elm_community$list_extra$List$Extra$setAt, openImageCropperIndex, newEntry, entries)),
											j: model.j + 1,
											t: $elm$core$Maybe$Nothing
										})));
						}
					}
				}
		}
	});
var $author$project$Form$RichText$Showing = function (a) {
	return {$: 1, a: a};
};
var $author$project$Markdown$encodeFormatting = function (formatting) {
	switch (formatting.$) {
		case 0:
			return _Utils_Tuple2(
				'bold',
				$elm$json$Json$Encode$bool(true));
		case 1:
			return _Utils_Tuple2(
				'italic',
				$elm$json$Json$Encode$bool(true));
		case 2:
			return _Utils_Tuple2(
				'strike',
				$elm$json$Json$Encode$bool(true));
		case 3:
			return _Utils_Tuple2(
				'underline',
				$elm$json$Json$Encode$bool(true));
		case 4:
			var url = formatting.a;
			return _Utils_Tuple2(
				'link',
				$elm$json$Json$Encode$string(url));
		case 5:
			var level = formatting.a;
			return _Utils_Tuple2(
				'header',
				$elm$json$Json$Encode$int(level));
		case 6:
			return _Utils_Tuple2(
				'list',
				$elm$json$Json$Encode$string('ordered'));
		default:
			return _Utils_Tuple2(
				'list',
				$elm$json$Json$Encode$string('bullet'));
	}
};
var $author$project$Markdown$encodeQuillOp = function (_v0) {
	var quillOp = _v0;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'insert',
				$elm$json$Json$Encode$string(quillOp.aw)),
				_Utils_Tuple2(
				'attributes',
				$elm$json$Json$Encode$object(
					A2($elm$core$List$map, $author$project$Markdown$encodeFormatting, quillOp.A)))
			]));
};
var $author$project$Ports$markdownLink = _Platform_outgoingPort('markdownLink', $elm$core$Basics$identity);
var $author$project$Ports$sendMarkdownLink = function (_v0) {
	var id = _v0.R;
	var label = _v0.nC;
	var url = _v0.gL;
	return $author$project$Ports$markdownLink(
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$string(id)),
					_Utils_Tuple2(
					'label',
					$elm$json$Json$Encode$string(label)),
					_Utils_Tuple2(
					'url',
					$elm$json$Json$Encode$string(url))
				])));
};
var $author$project$Ports$setMarkdown = _Platform_outgoingPort('setMarkdown', $elm$core$Basics$identity);
var $author$project$Ports$setMarkdownContent = function (_v0) {
	var id = _v0.R;
	var content = _v0.mk;
	return $author$project$Ports$setMarkdown(
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$string(id)),
					_Utils_Tuple2('content', content)
				])));
};
var $author$project$Form$RichText$update = F2(
	function (msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 1:
				var link = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							a0: $author$project$Form$RichText$Showing(link)
						}),
					$elm$core$Platform$Cmd$none);
			case 2:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{a0: $author$project$Form$RichText$NotShowing}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var label = msg.a;
				var _v2 = model.a0;
				if (_v2.$ === 1) {
					var link = _v2.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								a0: $author$project$Form$RichText$Showing(
									_Utils_update(
										link,
										{nC: label}))
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 4:
				var url = msg.a;
				var _v3 = model.a0;
				if (_v3.$ === 1) {
					var link = _v3.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								a0: $author$project$Form$RichText$Showing(
									_Utils_update(
										link,
										{gL: url}))
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 5:
				var _v4 = model.a0;
				if (_v4.$ === 1) {
					var label = _v4.a.nC;
					var url = _v4.a.gL;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{a0: $author$project$Form$RichText$NotShowing}),
						$author$project$Ports$sendMarkdownLink(
							{R: model.R, nC: label, gL: url}));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 6:
				var quillOps = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{fB: quillOps}),
					$elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(
					model,
					$author$project$Ports$setMarkdownContent(
						{
							mk: A2($elm$json$Json$Encode$list, $author$project$Markdown$encodeQuillOp, model.fB),
							R: model.R
						}));
		}
	});
var $author$project$Form$UserPicker$Model = $elm$core$Basics$identity;
var $author$project$Form$UserPicker$Single = $elm$core$Basics$identity;
var $author$project$Form$UserPicker$BlurredPicker = {$: 5};
var $author$project$Form$UserPicker$NoOp = {$: 0};
var $author$project$Form$UserPicker$SelectedUser = function (a) {
	return {$: 2, a: a};
};
var $NoRedInk$elm_simple_fuzzy$Simple$Fuzzy$isJust = function (maybeThing) {
	if (!maybeThing.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$String$filter = _String_filter;
var $NoRedInk$elm_simple_fuzzy$Simple$Fuzzy$root = function (string) {
	return A2(
		$elm$core$String$filter,
		function (c) {
			return $elm$core$Char$isLower(c) || $elm$core$Char$isDigit(c);
		},
		$elm$core$String$toLower(string));
};
var $NoRedInk$elm_simple_fuzzy$Simple$Fuzzy$searchHelper = F2(
	function (letter, restOfWord) {
		if (!restOfWord.$) {
			var string = restOfWord.a;
			var _v1 = A2(
				$elm$core$String$indexes,
				$elm$core$String$fromChar(letter),
				string);
			if (!_v1.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var found = _v1.a;
				return $elm$core$Maybe$Just(
					A2($elm$core$String$dropLeft, found + 1, string));
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $NoRedInk$elm_simple_fuzzy$Simple$Fuzzy$match = F2(
	function (needle, haystack) {
		return $NoRedInk$elm_simple_fuzzy$Simple$Fuzzy$isJust(
			A3(
				$elm$core$String$foldl,
				$NoRedInk$elm_simple_fuzzy$Simple$Fuzzy$searchHelper,
				$elm$core$Maybe$Just(
					$NoRedInk$elm_simple_fuzzy$Simple$Fuzzy$root(haystack)),
				$NoRedInk$elm_simple_fuzzy$Simple$Fuzzy$root(needle)));
	});
var $NoRedInk$elm_simple_fuzzy$Simple$Fuzzy$filter = F3(
	function (map, needle, records) {
		return A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeL,
				$NoRedInk$elm_simple_fuzzy$Simple$Fuzzy$match(needle),
				map),
			records);
	});
var $author$project$View$Select$PrivateConfig = $elm$core$Basics$identity;
var $author$project$View$Select$Styles$inputId = 'elm-select-input';
var $author$project$View$Select$Config$newConfig = function (requiredConfig) {
	return {i8: $elm$core$Maybe$Nothing, cf: false, ji: '', mH: false, hh: requiredConfig.hh, jE: '', jF: _List_Nil, nn: '', no: _List_Nil, jK: '', jL: _List_Nil, np: $author$project$View$Select$Styles$inputId, jM: _List_Nil, jN: '', jO: _List_Nil, jV: false, nA: '', nB: $elm$core$Maybe$Nothing, jY: _List_Nil, dB: '', kb: _List_Nil, ke: '', kf: '', kg: _List_Nil, kh: _List_Nil, kl: 'No results found', n9: '', km: true, kn: _List_Nil, od: $elm$core$Maybe$Nothing, ks: $elm$core$Maybe$Nothing, oj: requiredConfig.oj, kt: $elm$core$Maybe$Nothing, ku: $elm$core$Maybe$Nothing, kv: requiredConfig.kv, oT: '', kL: '', kM: _List_Nil, kS: '', kT: _List_Nil, k4: 2000, pz: requiredConfig.pz, lu: $elm$core$Basics$identity, lx: '', ly: _List_Nil};
};
var $author$project$View$Select$newConfig = function (requiredConfig) {
	return $author$project$View$Select$Config$newConfig(requiredConfig);
};
var $author$project$Icons$accountCircleSolid = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$viewBox('0 0 43 43'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M21.5 0C33.378 0 43 9.622 43 21.5 43 33.306 33.426 43 21.5 43 9.598 43 0 33.33 0 21.5 0 9.622 9.622 0 21.5 0zm14.853 32.418c2.232-3.071 3.576-6.839 3.576-10.918 0-10.15-8.279-18.429-18.429-18.429-10.15 0-18.429 8.279-18.429 18.429 0 4.08 1.344 7.847 3.576 10.918.864-4.295 2.951-7.847 7.342-7.847 1.944 1.896 4.584 3.072 7.511 3.072 2.927 0 5.567-1.176 7.51-3.072 4.392 0 6.48 3.552 7.343 7.847zm-5.639-15.525c0 5.087-4.127 9.214-9.214 9.214-5.087 0-9.214-4.127-9.214-9.214 0-5.087 4.127-9.214 9.214-9.214 5.087 0 9.214 4.127 9.214 9.214z')
					]),
				_List_Nil)
			]));
};
var $author$project$Avatar$view = F2(
	function (_v0, cls) {
		var maybeUrl = _v0;
		if (maybeUrl.$ === 1) {
			return $author$project$Icons$accountCircleSolid(cls);
		} else {
			var url = maybeUrl.a;
			return $elm$core$String$isEmpty(
				$elm$core$String$trim(url)) ? $author$project$Icons$accountCircleSolid(cls) : A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(cls)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$img,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('object-cover rounded-full ' + cls),
								$elm$html$Html$Attributes$src(url),
								$elm$html$Html$Attributes$alt('')
							]),
						_List_Nil)
					]));
		}
	});
var $author$project$Form$UserPicker$viewUserItem = function (_v0) {
	var avatar = _v0.cV;
	var name = _v0.ki;
	var account = _v0.fl;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex flex-row items-center z-30 pt-4 pb-2 px-4')
			]),
		_List_fromArray(
			[
				A2($author$project$Avatar$view, avatar, 'h-10 w-10 mr-4'),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex flex-col border-dotted border-b border-gray-500 pb-1 w-full text-white text-left')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('font-bold')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2($elm$core$Maybe$withDefault, '', name))
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('font-light')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Eos$Account$nameToString(account))
							]))
					]))
			]));
};
var $author$project$View$Select$unwrapConfig = function (config) {
	var c = config;
	return c;
};
var $author$project$View$Select$mapConfig = F2(
	function (fn, config) {
		var config_ = $author$project$View$Select$unwrapConfig(config);
		return fn(config_);
	});
var $author$project$View$Select$withDisabled = F2(
	function (isDisabled, config) {
		var fn = function (c) {
			return _Utils_update(
				c,
				{cf: isDisabled});
		};
		return A2($author$project$View$Select$mapConfig, fn, config);
	});
var $author$project$View$Select$withEmptyMenuClass = F2(
	function (classes, config) {
		var fn = function (c) {
			return _Utils_update(
				c,
				{
					ji: A2(
						$elm$core$String$join,
						' ',
						_List_fromArray(
							[c.ji, classes]))
				});
		};
		return A2($author$project$View$Select$mapConfig, fn, config);
	});
var $author$project$View$Select$withInputClass = F2(
	function (classes, config) {
		var fn = function (c) {
			return _Utils_update(
				c,
				{nn: classes});
		};
		return A2($author$project$View$Select$mapConfig, fn, config);
	});
var $author$project$View$Select$withInputClassList = F2(
	function (classes, config) {
		var fn = function (c) {
			return _Utils_update(
				c,
				{no: classes});
		};
		return A2($author$project$View$Select$mapConfig, fn, config);
	});
var $author$project$View$Select$withItemClass = F2(
	function (classes, config) {
		var fn = function (c) {
			return _Utils_update(
				c,
				{nA: classes});
		};
		return A2($author$project$View$Select$mapConfig, fn, config);
	});
var $author$project$View$Select$withItemHtml = F2(
	function (html, config) {
		var fn = function (c) {
			return _Utils_update(
				c,
				{
					nB: $elm$core$Maybe$Just(html)
				});
		};
		return A2($author$project$View$Select$mapConfig, fn, config);
	});
var $author$project$View$Select$withMenuClass = F2(
	function (classes, config) {
		var fn = function (c) {
			return _Utils_update(
				c,
				{
					dB: A2(
						$elm$core$String$join,
						' ',
						_List_fromArray(
							[c.dB, classes]))
				});
		};
		return A2($author$project$View$Select$mapConfig, fn, config);
	});
var $author$project$View$Select$withNotFound = F2(
	function (text, config) {
		var fn = function (c) {
			return _Utils_update(
				c,
				{kl: text});
		};
		return A2($author$project$View$Select$mapConfig, fn, config);
	});
var $author$project$View$Select$withNotFoundClass = F2(
	function (_class, config) {
		var fn = function (c) {
			return _Utils_update(
				c,
				{n9: _class});
		};
		return A2($author$project$View$Select$mapConfig, fn, config);
	});
var $author$project$View$Select$withOnBlur = F2(
	function (msg, config) {
		var fn = function (c) {
			return _Utils_update(
				c,
				{
					od: $elm$core$Maybe$Just(msg)
				});
		};
		return A2($author$project$View$Select$mapConfig, fn, config);
	});
var $author$project$View$Select$withPrompt = F2(
	function (prompt, config) {
		var fn = function (c) {
			return _Utils_update(
				c,
				{oT: prompt});
		};
		return A2($author$project$View$Select$mapConfig, fn, config);
	});
var $author$project$Form$UserPicker$settings = F2(
	function (_v0, viewConfig) {
		var options = _v0;
		var toLabel = function (p) {
			return $author$project$Eos$Account$nameToString(p.fl);
		};
		var minQueryLength = 2;
		var _v1 = viewConfig.iw;
		var t = _v1.il;
		return A2(
			$author$project$View$Select$withOnBlur,
			$author$project$Form$UserPicker$BlurredPicker,
			A2(
				$author$project$View$Select$withEmptyMenuClass,
				'bg-indigo-500 px-4 py-1',
				A2(
					$author$project$View$Select$withMenuClass,
					'flex flex-col w-full border-t-none border-solid border-gray-100 border rounded-sm z-30 bg-white max-h-80 overflow-auto ' + options.dB,
					A2(
						$author$project$View$Select$withNotFoundClass,
						'text-red border-solid border-gray-100 border rounded !bg-white px-8 max-w-max',
						A2(
							$author$project$View$Select$withNotFound,
							t('community.actions.form.verifier_not_found'),
							A2(
								$author$project$View$Select$withItemHtml,
								$author$project$Form$UserPicker$viewUserItem,
								A2(
									$author$project$View$Select$withPrompt,
									t('community.actions.form.verifier_placeholder'),
									A2(
										$author$project$View$Select$withItemClass,
										'bg-indigo-500 hover:bg-opacity-80 focus:bg-opacity-80 active:bg-opacity-90',
										A2(
											$author$project$View$Select$withDisabled,
											options.cf,
											A2(
												$author$project$View$Select$withInputClassList,
												_List_fromArray(
													[
														_Utils_Tuple2('with-error', viewConfig.m$)
													]),
												A2(
													$author$project$View$Select$withInputClass,
													'w-full input',
													$author$project$View$Select$newConfig(
														{
															hh: F2(
																function (query, items) {
																	if (_Utils_cmp(
																		$elm$core$String$length(query),
																		minQueryLength) < 0) {
																		return $elm$core$Maybe$Nothing;
																	} else {
																		var nameItems = A3(
																			$NoRedInk$elm_simple_fuzzy$Simple$Fuzzy$filter,
																			function (profile) {
																				return A2($elm$core$Maybe$withDefault, '', profile.ki);
																			},
																			query,
																			items);
																		var accountItems = A3($NoRedInk$elm_simple_fuzzy$Simple$Fuzzy$filter, toLabel, query, items);
																		return $elm$core$Maybe$Just(
																			$elm_community$list_extra$List$Extra$unique(
																				_Utils_ap(accountItems, nameItems)));
																	}
																}),
															oj: $author$project$Form$UserPicker$NoOp,
															kv: $author$project$Form$UserPicker$SelectedUser,
															pz: toLabel
														}))))))))))));
	});
var $author$project$Profile$Summary$update = F2(
	function (msg, model) {
		switch (msg) {
			case 0:
				return model;
			case 1:
				return _Utils_update(
					model,
					{dr: true});
			default:
				return _Utils_update(
					model,
					{dr: false});
		}
	});
var $author$project$View$Select$unwrapModel = function (model) {
	var m = model;
	return m;
};
var $author$project$View$Select$unwrapMsg = function (msg) {
	var m = msg;
	return m;
};
var $author$project$View$Select$Update$focusItem = F2(
	function (_v0, onFocusItem) {
		var inputId = _v0.np;
		var itemIndex = _v0.f2;
		return A2(
			$elm$core$Task$attempt,
			function (_v1) {
				return onFocusItem;
			},
			$elm$browser$Browser$Dom$focus(
				inputId + ('-menu-item-' + $elm$core$String$fromInt(itemIndex))));
	});
var $author$project$View$Select$Update$update = F3(
	function (config, msg, model) {
		var queryChangeCmd = function (value) {
			var _v13 = config.kt;
			if (_v13.$ === 1) {
				return $elm$core$Platform$Cmd$none;
			} else {
				var constructor = _v13.a;
				return A2(
					$elm$core$Task$perform,
					constructor,
					$elm$core$Task$succeed(value));
			}
		};
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 4:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{pc: false}),
					$elm$core$Platform$Cmd$none);
			case 5:
				var newHightlightedItem = function () {
					var _v1 = model.m7;
					if (_v1.$ === 1) {
						return 0;
					} else {
						var n = _v1.a;
						return n + 1;
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							m7: $elm$core$Maybe$Just(newHightlightedItem)
						}),
					A2(
						$author$project$View$Select$Update$focusItem,
						{np: config.np, f2: newHightlightedItem},
						config.oj));
			case 6:
				var newHightlightedItem = function () {
					var _v4 = model.m7;
					if (_v4.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						if (!_v4.a) {
							return $elm$core$Maybe$Nothing;
						} else {
							var n = _v4.a;
							return $elm$core$Maybe$Just(n - 1);
						}
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{m7: newHightlightedItem}),
					function () {
						if (newHightlightedItem.$ === 1) {
							return A2(
								$elm$core$Task$attempt,
								function (_v3) {
									return A2($elm$core$Maybe$withDefault, config.oj, config.ks);
								},
								$elm$browser$Browser$Dom$focus(config.np));
						} else {
							var highlightedItem = newHightlightedItem.a;
							return A2(
								$author$project$View$Select$Update$focusItem,
								{np: config.np, f2: highlightedItem},
								config.oj);
						}
					}());
			case 7:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							m7: $elm$core$Maybe$Just(0)
						}),
					A2(
						$author$project$View$Select$Update$focusItem,
						{np: config.np, f2: 0},
						config.oj));
			case 1:
				var cmd = function () {
					var _v5 = config.ks;
					if (_v5.$ === 1) {
						return $elm$core$Platform$Cmd$none;
					} else {
						var focusMessage = _v5.a;
						return A2(
							$elm$core$Task$perform,
							function (_v6) {
								return focusMessage;
							},
							$elm$core$Task$succeed($elm$core$Maybe$Nothing));
					}
				}();
				return config.mH ? _Utils_Tuple2(
					_Utils_update(
						model,
						{
							dO: $elm$core$Maybe$Just(''),
							pc: true
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								cmd,
								queryChangeCmd('')
							]))) : _Utils_Tuple2(
					_Utils_update(
						model,
						{pc: true}),
					cmd);
			case 2:
				var cmd = function () {
					var _v7 = config.od;
					if (_v7.$ === 1) {
						return $elm$core$Platform$Cmd$none;
					} else {
						var blurMessage = _v7.a;
						return A2(
							$elm$core$Task$perform,
							function (_v8) {
								return blurMessage;
							},
							$elm$core$Task$succeed($elm$core$Maybe$Nothing));
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{pc: false}),
					cmd);
			case 3:
				var item = msg.a;
				var cmd = function () {
					var _v9 = config.ku;
					if (!_v9.$) {
						var onRemoveItem = _v9.a;
						return A2(
							$elm$core$Task$perform,
							onRemoveItem,
							$elm$core$Task$succeed(item));
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				return _Utils_Tuple2(model, cmd);
			case 8:
				var value = msg.a;
				var newQuery = config.lu(value);
				var cmd = function () {
					if (newQuery === '') {
						return $elm$core$Platform$Cmd$none;
					} else {
						return queryChangeCmd(newQuery);
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							m7: $elm$core$Maybe$Nothing,
							dO: $elm$core$Maybe$Just(value)
						}),
					cmd);
			default:
				var item = msg.a;
				var cmd = A2(
					$elm$core$Task$perform,
					config.kv,
					$elm$core$Task$succeed(item));
				var blurCmd = function () {
					var _v11 = config.od;
					if (_v11.$ === 1) {
						return $elm$core$Platform$Cmd$none;
					} else {
						var blurMessage = _v11.a;
						return A2(
							$elm$core$Task$perform,
							function (_v12) {
								return blurMessage;
							},
							$elm$core$Task$succeed($elm$core$Maybe$Nothing));
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dO: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[cmd, blurCmd])));
		}
	});
var $author$project$View$Select$update = F3(
	function (config, msg, model) {
		var msg_ = $author$project$View$Select$unwrapMsg(msg);
		var model_ = $author$project$View$Select$unwrapModel(model);
		var config_ = $author$project$View$Select$unwrapConfig(config);
		var _v0 = A3($author$project$View$Select$Update$update, config_, msg_, model_);
		var mdl = _v0.a;
		var cmd = _v0.b;
		return _Utils_Tuple2(mdl, cmd);
	});
var $author$project$Form$UserPicker$update = F4(
	function (options, viewConfig, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
			case 1:
				var subMsg = msg.a;
				var _v2 = A3(
					$author$project$View$Select$update,
					A2($author$project$Form$UserPicker$settings, options, viewConfig),
					subMsg,
					model.dT);
				var newState = _v2.a;
				var cmd = _v2.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dT: newState}),
					cmd,
					$elm$core$Maybe$Nothing);
			case 2:
				var profile = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							W: function () {
								var _v3 = model.W;
								return $elm$core$Maybe$Just(
									{
										kJ: profile,
										dZ: $author$project$Profile$Summary$init(false)
									});
							}()
						}),
					$elm$core$Platform$Cmd$none,
					$elm$core$Maybe$Nothing);
			case 3:
				var targetProfile = msg.a;
				var subMsg = msg.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							W: function () {
								var _v4 = model.W;
								if (_v4.$ === 1) {
									var _v5 = _v4;
									return $elm$core$Maybe$Nothing;
								} else {
									var profile = _v4.a;
									return $elm$core$Maybe$Just(
										_Utils_update(
											profile,
											{
												dZ: A2($author$project$Profile$Summary$update, subMsg, profile.dZ)
											}));
								}
							}()
						}),
					$elm$core$Platform$Cmd$none,
					$elm$core$Maybe$Nothing);
			case 4:
				var profileToRemove = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							W: function () {
								var _v6 = model.W;
								return $elm$core$Maybe$Nothing;
							}()
						}),
					$elm$core$Platform$Cmd$none,
					$elm$core$Maybe$Nothing);
			default:
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					$elm$core$Maybe$Just(viewConfig.od));
		}
	});
var $author$project$Form$update = F3(
	function (shared, msg, _v0) {
		var model = _v0;
		var _v1 = model.aG;
		var errorTracking = _v1;
		var removeFieldError = function (fieldId) {
			return _Utils_update(
				errorTracking,
				{
					bU: A2($elm$core$Set$remove, fieldId, errorTracking.bU)
				});
		};
		switch (msg.$) {
			case 0:
				return $author$project$UpdateResult$init(model);
			case 1:
				var fieldId = msg.a.ac;
				var newValues = msg.b;
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{
							aG: removeFieldError(fieldId),
							s: newValues
						}));
			case 2:
				var getModel = msg.a;
				var updateFn = msg.b;
				var subMsg = msg.c;
				var _v3 = A2(
					$author$project$Form$RichText$update,
					subMsg,
					getModel(model.s));
				var newModel = _v3.a;
				var cmd = _v3.b;
				return A2(
					$author$project$UpdateResult$addCmd,
					A2(
						$elm$core$Platform$Cmd$map,
						A2($author$project$Form$GotRichTextMsg, getModel, updateFn),
						cmd),
					$author$project$UpdateResult$init(
						_Utils_update(
							model,
							{
								aG: removeFieldError(
									$author$project$Form$RichText$getId(newModel)),
								s: A2(updateFn, newModel, model.s)
							})));
			case 3:
				var fieldId = msg.a.ac;
				var getModel = msg.b;
				var updateFn = msg.c;
				var subMsg = msg.d;
				return A5(
					$author$project$UpdateResult$fromChild,
					function (newFile) {
						return _Utils_update(
							model,
							{
								s: A2(updateFn, newFile, model.s)
							});
					},
					A3(
						$author$project$Form$GotFileMsg,
						{ac: fieldId},
						getModel,
						updateFn),
					function (_v4) {
						var isLoading = _v4;
						return $author$project$UpdateResult$mapModel(
							function (_v5) {
								var m = _v5;
								var insertOrRemove = isLoading ? $elm$core$Set$insert : $elm$core$Set$remove;
								return _Utils_update(
									m,
									{
										f7: A2(insertOrRemove, fieldId, m.f7)
									});
							});
					},
					model,
					A3(
						$author$project$Form$File$update,
						shared,
						subMsg,
						getModel(model.s)));
			case 4:
				var options = msg.a;
				var viewConfig = msg.b;
				var getModel = msg.c;
				var updateFn = msg.d;
				var subMsg = msg.e;
				var _v6 = A4(
					$author$project$Form$DatePicker$update,
					options,
					viewConfig,
					subMsg,
					getModel(model.s));
				var newModel = _v6.a;
				var cmd = _v6.b;
				return A2(
					$author$project$UpdateResult$addCmd,
					A2(
						$elm$core$Platform$Cmd$map,
						A4($author$project$Form$GotDatePickerMsg, options, viewConfig, getModel, updateFn),
						cmd),
					$author$project$UpdateResult$init(
						_Utils_update(
							model,
							{
								s: A2(updateFn, newModel, model.s)
							})));
			case 5:
				var options = msg.a;
				var viewConfig = msg.b;
				var getModel = msg.c;
				var updateFn = msg.d;
				var subMsg = msg.e;
				var maybeAddMsg = function (maybeMsg) {
					if (maybeMsg.$ === 1) {
						return $elm$core$Basics$identity;
					} else {
						var externalMsg = maybeMsg.a;
						return $author$project$UpdateResult$addMsg(externalMsg);
					}
				};
				var _v7 = A4(
					$author$project$Form$UserPicker$update,
					options,
					viewConfig,
					subMsg,
					getModel(model.s));
				var newModel = _v7.a;
				var cmd = _v7.b;
				var maybeExternalMsg = _v7.c;
				return A2(
					maybeAddMsg,
					maybeExternalMsg,
					A2(
						$author$project$UpdateResult$addCmd,
						A2(
							$elm$core$Platform$Cmd$map,
							A4($author$project$Form$GotUserPickerMsg, options, viewConfig, getModel, updateFn),
							cmd),
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									s: A2(updateFn, newModel, model.s)
								}))));
			case 6:
				var fieldInfo = msg.a;
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{
							aG: _Utils_update(
								errorTracking,
								{
									bU: fieldInfo.hu ? A2($elm$core$Set$insert, fieldInfo.ac, errorTracking.bU) : A2($elm$core$Set$remove, fieldInfo.ac, errorTracking.bU)
								})
						}));
			default:
				var _v9 = msg.a;
				var firstError = _v9.a;
				return A2(
					$author$project$UpdateResult$addCmd,
					A2(
						$elm$core$Task$attempt,
						function (_v10) {
							return $author$project$Form$NoOp;
						},
						$elm$browser$Browser$Dom$focus(firstError)),
					$author$project$UpdateResult$init(
						_Utils_update(
							model,
							{
								aG: _Utils_update(
									errorTracking,
									{e2: true})
							})));
		}
	});
var $author$project$View$Pin$update = F3(
	function (shared, msg, model) {
		switch (msg.$) {
			case 0:
				return $author$project$UpdateResult$init(model);
			case 1:
				var subMsg = msg.a;
				var hasChangedField = F2(
					function (field, newForm) {
						return !_Utils_eq(
							A2($author$project$Form$getValue, field, model.hk),
							A2($author$project$Form$getValue, field, newForm));
					});
				var clearFieldErrors = F3(
					function (field, fieldAccessor, ur) {
						var newForm = ur.nV.hk;
						return A2(hasChangedField, fieldAccessor, newForm) ? A2(
							$author$project$UpdateResult$mapModel,
							function (m) {
								return _Utils_update(
									m,
									{
										bn: A2(
											$elm$core$List$filter,
											function (_v1) {
												var field_ = _v1.a;
												return !_Utils_eq(field, field_);
											},
											m.bn)
									});
							},
							ur) : ur;
					});
				return A3(
					clearFieldErrors,
					1,
					function ($) {
						return $.c3;
					},
					A3(
						clearFieldErrors,
						0,
						function ($) {
							return $.oE;
						},
						A5(
							$author$project$UpdateResult$fromChild,
							function (newForm) {
								return _Utils_update(
									model,
									{hk: newForm});
							},
							$author$project$View$Pin$GotFormMsg,
							function (feedback) {
								return $author$project$UpdateResult$addExt(
									$author$project$View$Pin$SendFeedback(feedback));
							},
							model,
							A3($author$project$Form$update, shared, subMsg, model.hk))));
			case 2:
				var pin = msg.a.oE;
				return A2(
					$author$project$UpdateResult$addExt,
					$author$project$View$Pin$SubmitPin(pin),
					$author$project$UpdateResult$init(
						_Utils_update(
							model,
							{
								cv: true,
								nF: $elm$core$Maybe$Just(pin),
								bn: _List_Nil
							})));
			default:
				var field = msg.a;
				if (!field) {
					return A2(
						$author$project$UpdateResult$addCmd,
						A2(
							$elm$core$Task$attempt,
							function (_v3) {
								return $author$project$View$Pin$Ignored;
							},
							$elm$browser$Browser$Dom$focus('pin-input')),
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{cu: !model.cu})));
				} else {
					return A2(
						$author$project$UpdateResult$addCmd,
						A2(
							$elm$core$Task$attempt,
							function (_v4) {
								return $author$project$View$Pin$Ignored;
							},
							$elm$browser$Browser$Dom$focus('pin-confirmation-input')),
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{eD: !model.eD})));
				}
		}
	});
var $author$project$View$Pin$withIsSubmitting = F2(
	function (isSubmitting, model) {
		return _Utils_update(
			model,
			{cv: isSubmitting});
	});
var $author$project$View$Pin$withProblem = F3(
	function (field, problem, model) {
		return _Utils_update(
			model,
			{
				bn: A2(
					$elm$core$List$cons,
					_Utils_Tuple2(field, problem),
					model.bn)
			});
	});
var $author$project$Auth$update = F3(
	function (msg, shared, model) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				return A5(
					$author$project$UpdateResult$fromChild,
					function (pinModel) {
						return _Utils_update(
							model,
							{ag: pinModel});
					},
					$author$project$Auth$GotPinMsg,
					F2(
						function (ext, ur) {
							if (ext.$ === 1) {
								var feedback = ext.a;
								return A2(
									$author$project$UpdateResult$addExt,
									$author$project$Auth$SetFeedback(feedback),
									ur);
							} else {
								var pin = ext.a;
								var _v2 = A4($author$project$View$Pin$postSubmitAction, ur.nV.ag, pin, shared, $author$project$Auth$SubmittedPin);
								var newShared = _v2.a;
								var submitCmd = _v2.b;
								return A2(
									$author$project$UpdateResult$addExt,
									$author$project$Auth$UpdatedShared(newShared),
									A2($author$project$UpdateResult$addCmd, submitCmd, ur));
							}
						}),
					model,
					A3($author$project$View$Pin$update, shared, subMsg, model.ag));
			case 1:
				var pin = msg.a;
				return A2(
					$author$project$UpdateResult$addPort,
					{
						i9: $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'name',
									$elm$json$Json$Encode$string('getPrivateKey')),
									_Utils_Tuple2(
									'pin',
									$elm$json$Json$Encode$string(pin))
								])),
						kY: $author$project$Auth$SubmittedPin(pin),
						kZ: $elm$json$Json$Encode$null
					},
					$author$project$UpdateResult$init(
						_Utils_update(
							model,
							{
								ag: A2($author$project$View$Pin$withDisabled, true, model.ag)
							})));
			default:
				if (!msg.a.$) {
					var _v3 = msg.a.a;
					var accountName = _v3.a;
					var privateKey = _v3.b;
					var newModel = _Utils_update(
						model,
						{
							ag: A2(
								$author$project$View$Pin$withIsSubmitting,
								false,
								A2($author$project$View$Pin$withDisabled, false, model.ag)),
							gE: $author$project$Auth$WithPrivateKey(privateKey)
						});
					return A2(
						$author$project$UpdateResult$addExt,
						A2($author$project$Auth$CompletedAuth, accountName, newModel),
						$author$project$UpdateResult$init(newModel));
				} else {
					var err = msg.a.a;
					return A2(
						$author$project$UpdateResult$logEvent,
						{
							mm: _List_fromArray(
								[
									{
									mR: $elm$core$Dict$fromList(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'errorValue',
												$elm$json$Json$Encode$string(err))
											])),
									ki: 'Error'
								}
								]),
							nH: 1,
							nN: {mX: 'update', nW: 'Auth'},
							nS: 'Got an error when submitting PIN',
							pu: _List_fromArray(
								[
									$author$project$Log$TypeTag(5)
								]),
							pE: msg,
							pM: $elm$core$Maybe$Nothing
						},
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									mM: $elm$core$Maybe$Nothing,
									ag: A2(
										$author$project$View$Pin$withIsSubmitting,
										false,
										A2(
											$author$project$View$Pin$withDisabled,
											false,
											A3($author$project$View$Pin$withProblem, 0, err, model.ag))),
									gE: $author$project$Auth$WithoutPrivateKey
								})));
				}
		}
	});
var $author$project$Search$GotDebouncerMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Search$GotFormMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Search$NoOp = {$: 0};
var $author$project$Search$QuerySubmitted = {$: 7};
var $author$project$Search$RecentSearchesShowed = {$: 1};
var $author$project$Search$RequestedNewResults = function (a) {
	return {$: 10, a: a};
};
var $author$project$Search$ResultsShowed = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Search$SetFeedback = function (a) {
	return {$: 0, a: a};
};
var $author$project$Search$maximumRecentSearches = 10;
var $Gizra$elm_debouncer$Debouncer$Basic$ProvideInput = function (a) {
	return {$: 0, a: a};
};
var $Gizra$elm_debouncer$Debouncer$Basic$provideInput = $Gizra$elm_debouncer$Debouncer$Basic$ProvideInput;
var $author$project$Search$GotSearchResults = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Search$RequestQuery = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Cambiatus$Query$search = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'search', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Cambiatus$Object$SearchResult$actions = F2(
	function (fillInOptionals____, object____) {
		var filledInOptionals____ = fillInOptionals____(
			{dO: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
		var optionalArgs____ = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'query', filledInOptionals____.dO, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)
				]));
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'actions',
			optionalArgs____,
			object____,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
	});
var $author$project$Action$isObjectiveClosed = function (action) {
	return action.bi.$7;
};
var $author$project$Cambiatus$Enum$Direction$toString = function (enum____) {
	if (!enum____) {
		return 'ASC';
	} else {
		return 'DESC';
	}
};
var $author$project$Cambiatus$Enum$OrderByFields$toString = function (enum____) {
	switch (enum____) {
		case 0:
			return 'account';
		case 1:
			return 'created_at';
		default:
			return 'name';
	}
};
var $author$project$Cambiatus$Enum$SearchByFields$toString = function (enum____) {
	switch (enum____) {
		case 0:
			return 'account';
		case 1:
			return 'bio';
		case 2:
			return 'email';
		default:
			return 'name';
	}
};
var $author$project$Cambiatus$InputObject$encodeMembersFilterInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'orderDirection',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.dH,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Cambiatus$Enum$Direction$toString))),
				_Utils_Tuple2(
				'orderMembersBy',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.dI,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Cambiatus$Enum$OrderByFields$toString))),
				_Utils_Tuple2(
				'searchMembersBy',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.dR,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						$dillonkearns$elm_graphql$Graphql$Internal$Encode$maybe(
							$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Cambiatus$Enum$SearchByFields$toString))))),
				_Utils_Tuple2(
				'searchString',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.dS, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string))
			]));
};
var $author$project$Cambiatus$Object$SearchResult$members = F2(
	function (fillInOptionals____, object____) {
		var filledInOptionals____ = fillInOptionals____(
			{hi: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
		var optionalArgs____ = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'filters', filledInOptionals____.hi, $author$project$Cambiatus$InputObject$encodeMembersFilterInput)
				]));
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'members',
			optionalArgs____,
			object____,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
	});
var $author$project$Cambiatus$Object$SearchResult$products = F2(
	function (fillInOptionals____, object____) {
		var filledInOptionals____ = fillInOptionals____(
			{dO: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
		var optionalArgs____ = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'query', filledInOptionals____.dO, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)
				]));
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'products',
			optionalArgs____,
			object____,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
	});
var $author$project$Search$searchResultSelectionSet = function (queryString) {
	return A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		A2(
			$author$project$Cambiatus$Object$SearchResult$members,
			function (_v2) {
				return {
					hi: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
						{
							dH: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
							dI: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
							dR: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
							dS: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(queryString)
						})
				};
			},
			$author$project$Profile$minimalSelectionSet),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			A2(
				$author$project$Cambiatus$Object$SearchResult$actions,
				function (_v1) {
					return {
						dO: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(queryString)
					};
				},
				$author$project$Action$selectionSet),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				A2(
					$author$project$Cambiatus$Object$SearchResult$products,
					function (_v0) {
						return {
							dO: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(queryString)
						};
					},
					$author$project$Shop$productSelectionSet),
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(
					F3(
						function (products, actions, members) {
							return {
								lP: A2(
									$elm$core$List$filter,
									A2($elm$core$Basics$composeL, $elm$core$Basics$not, $author$project$Action$isObjectiveClosed),
									actions),
								hG: members,
								a2: A2(
									$elm$core$List$map,
									function (product) {
										return {cc: $elm$core$Maybe$Nothing, cF: $elm$core$Maybe$Nothing, oP: product};
									},
									products)
							};
						})))));
};
var $author$project$Search$sendSearchQuery = function (queryString) {
	return A2(
		$author$project$Search$RequestQuery,
		$author$project$Cambiatus$Query$search(
			$author$project$Search$searchResultSelectionSet(queryString)),
		$author$project$Search$GotSearchResults(
			{jr: queryString}));
};
var $author$project$Ports$storeRecentSearches = _Platform_outgoingPort('storeRecentSearches', $elm$json$Json$Encode$string);
var $author$project$Search$storeRecentSearches = function (recentSearches) {
	return $author$project$Ports$storeRecentSearches(
		A2(
			$elm$json$Json$Encode$encode,
			0,
			A2(
				$elm$json$Json$Encode$list,
				$elm$json$Json$Encode$string,
				A2(
					$elm$core$List$take,
					$author$project$Search$maximumRecentSearches,
					$elm_community$list_extra$List$Extra$unique(recentSearches)))));
};
var $Gizra$elm_debouncer$Debouncer$Internal$Check = function (a) {
	return {$: 4, a: a};
};
var $Gizra$elm_debouncer$Debouncer$Internal$InputProvidedAt = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $Gizra$elm_debouncer$Debouncer$Internal$ManualEmitAt = function (a) {
	return {$: 3, a: a};
};
var $Gizra$elm_debouncer$Debouncer$Basic$MsgInternal = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Process$sleep = _Process_sleep;
var $Gizra$elm_debouncer$Debouncer$Internal$Unsettled = function (a) {
	return {$: 1, a: a};
};
var $Gizra$elm_debouncer$Debouncer$Internal$cancel = function (_v0) {
	var config = _v0.a;
	var state = _v0.b;
	return A2($Gizra$elm_debouncer$Debouncer$Internal$Debouncer, config, $Gizra$elm_debouncer$Debouncer$Internal$Settled);
};
var $elm$core$Tuple$mapFirst = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			func(x),
			y);
	});
var $elm$core$List$partition = F2(
	function (pred, list) {
		var step = F2(
			function (x, _v0) {
				var trues = _v0.a;
				var falses = _v0.b;
				return pred(x) ? _Utils_Tuple2(
					A2($elm$core$List$cons, x, trues),
					falses) : _Utils_Tuple2(
					trues,
					A2($elm$core$List$cons, x, falses));
			});
		return A3(
			$elm$core$List$foldr,
			step,
			_Utils_Tuple2(_List_Nil, _List_Nil),
			list);
	});
var $Gizra$elm_debouncer$Debouncer$Internal$update = F2(
	function (msg, debouncer) {
		var wrappedConfig = debouncer.a;
		var config = wrappedConfig;
		var state = debouncer.b;
		switch (msg.$) {
			case 0:
				var input = msg.a;
				var time = msg.b;
				var newState = function () {
					if (!state.$) {
						return $Gizra$elm_debouncer$Debouncer$Internal$Unsettled(
							{
								dx: $elm$core$Maybe$Nothing,
								f5: time,
								aK: A2(config.b1, input, $elm$core$Maybe$Nothing),
								gK: time
							});
					} else {
						var unsettled = state.a;
						return $Gizra$elm_debouncer$Debouncer$Internal$Unsettled(
							_Utils_update(
								unsettled,
								{
									f5: time,
									aK: A2(config.b1, input, unsettled.aK)
								}));
					}
				}();
				var newDebouncer = A2($Gizra$elm_debouncer$Debouncer$Internal$Debouncer, wrappedConfig, newState);
				var checks = function () {
					if (!state.$) {
						return $elm_community$list_extra$List$Extra$unique(
							A2(
								$elm$core$List$filterMap,
								$elm$core$Basics$identity,
								_List_fromArray(
									[config.aV, config.aW, config.a7])));
					} else {
						return A2(
							$elm$core$List$filterMap,
							$elm$core$Basics$identity,
							_List_fromArray(
								[config.a7]));
					}
				}();
				var _v1 = A2(
					$elm$core$Tuple$mapFirst,
					A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$List$isEmpty),
					A2(
						$elm$core$List$partition,
						function (interval) {
							return interval <= 0;
						},
						checks));
				var checkNow = _v1.a;
				var checkLater = _v1.b;
				var _v2 = checkNow ? A2(
					$Gizra$elm_debouncer$Debouncer$Internal$update,
					$Gizra$elm_debouncer$Debouncer$Internal$Check(time),
					newDebouncer) : _Utils_Tuple3(newDebouncer, _List_Nil, $elm$core$Maybe$Nothing);
				var checkedDebouncer = _v2.a;
				var checkedIntervals = _v2.b;
				var emit = _v2.c;
				return _Utils_Tuple3(
					checkedDebouncer,
					_Utils_ap(checkedIntervals, checkLater),
					emit);
			case 1:
				return _Utils_Tuple3(
					$Gizra$elm_debouncer$Debouncer$Internal$cancel(debouncer),
					_List_Nil,
					$elm$core$Maybe$Nothing);
			case 2:
				var emit = function () {
					if (!state.$) {
						return $elm$core$Maybe$Nothing;
					} else {
						var unsettled = state.a;
						return unsettled.aK;
					}
				}();
				return _Utils_Tuple3(
					$Gizra$elm_debouncer$Debouncer$Internal$cancel(debouncer),
					_List_Nil,
					emit);
			case 3:
				var time = msg.a;
				if (!state.$) {
					return _Utils_Tuple3(debouncer, _List_Nil, $elm$core$Maybe$Nothing);
				} else {
					var unsettled = state.a;
					var _v7 = unsettled.aK;
					if (!_v7.$) {
						var newState = $Gizra$elm_debouncer$Debouncer$Internal$Unsettled(
							_Utils_update(
								unsettled,
								{
									dx: $elm$core$Maybe$Just(time),
									aK: $elm$core$Maybe$Nothing
								}));
						var intervals = function () {
							var _v8 = config.aV;
							if (!_v8.$) {
								var emit = _v8.a;
								return _List_fromArray(
									[emit]);
							} else {
								return _List_Nil;
							}
						}();
						return _Utils_Tuple3(
							A2($Gizra$elm_debouncer$Debouncer$Internal$Debouncer, wrappedConfig, newState),
							intervals,
							unsettled.aK);
					} else {
						return _Utils_Tuple3(debouncer, _List_Nil, $elm$core$Maybe$Nothing);
					}
				}
			default:
				var time = msg.a;
				if (!state.$) {
					return _Utils_Tuple3(debouncer, _List_Nil, $elm$core$Maybe$Nothing);
				} else {
					var unsettled = state.a;
					var shouldSettle = A2(
						$elm$core$Maybe$withDefault,
						false,
						A2(
							$elm$core$Maybe$map,
							function (interval) {
								return _Utils_cmp(unsettled.f5 + interval, time) < 1;
							},
							config.a7));
					var becauseEmitWhileUnsettled = function () {
						var _v13 = config.aW;
						if (!_v13.$) {
							var interval = _v13.a;
							var _v14 = unsettled.dx;
							if (!_v14.$) {
								var lastEmittedAt = _v14.a;
								return _Utils_cmp(lastEmittedAt + interval, time) < 1;
							} else {
								return _Utils_cmp(unsettled.gK + interval, time) < 1;
							}
						} else {
							return false;
						}
					}();
					var becauseEmitWhenUnsettled = function () {
						var _v11 = config.aV;
						if (!_v11.$) {
							var interval = _v11.a;
							var _v12 = unsettled.dx;
							if (!_v12.$) {
								return false;
							} else {
								return _Utils_cmp(unsettled.gK + interval, time) < 1;
							}
						} else {
							return false;
						}
					}();
					var shouldEmit = (!_Utils_eq(unsettled.aK, $elm$core$Maybe$Nothing)) && (shouldSettle || (becauseEmitWhenUnsettled || becauseEmitWhileUnsettled));
					var emit = shouldEmit ? unsettled.aK : $elm$core$Maybe$Nothing;
					var intervals = function () {
						if (shouldEmit && (!shouldSettle)) {
							var _v10 = config.aW;
							if (!_v10.$) {
								var interval = _v10.a;
								return _List_fromArray(
									[interval]);
							} else {
								return _List_Nil;
							}
						} else {
							return _List_Nil;
						}
					}();
					var newState = shouldSettle ? $Gizra$elm_debouncer$Debouncer$Internal$Settled : (shouldEmit ? $Gizra$elm_debouncer$Debouncer$Internal$Unsettled(
						_Utils_update(
							unsettled,
							{
								dx: $elm$core$Maybe$Just(time),
								aK: $elm$core$Maybe$Nothing
							})) : state);
					return _Utils_Tuple3(
						A2($Gizra$elm_debouncer$Debouncer$Internal$Debouncer, wrappedConfig, newState),
						intervals,
						emit);
				}
		}
	});
var $Gizra$elm_debouncer$Debouncer$Basic$update = F2(
	function (msg, debouncer) {
		switch (msg.$) {
			case 0:
				var input = msg.a;
				return _Utils_Tuple3(
					debouncer,
					A2(
						$elm$core$Task$perform,
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								$Gizra$elm_debouncer$Debouncer$Basic$MsgInternal,
								$Gizra$elm_debouncer$Debouncer$Internal$InputProvidedAt(input)),
							$elm$time$Time$posixToMillis),
						$elm$time$Time$now),
					$elm$core$Maybe$Nothing);
			case 1:
				return _Utils_Tuple3(
					debouncer,
					A2(
						$elm$core$Task$perform,
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $Gizra$elm_debouncer$Debouncer$Basic$MsgInternal, $Gizra$elm_debouncer$Debouncer$Internal$ManualEmitAt),
							$elm$time$Time$posixToMillis),
						$elm$time$Time$now),
					$elm$core$Maybe$Nothing);
			default:
				var subMsg = msg.a;
				var _v1 = A2($Gizra$elm_debouncer$Debouncer$Internal$update, subMsg, debouncer);
				var updatedDebouncer = _v1.a;
				var intervals = _v1.b;
				var output = _v1.c;
				var cmds = $elm$core$Platform$Cmd$batch(
					A2(
						$elm$core$List$map,
						function (interval) {
							return A2(
								$elm$core$Task$perform,
								A2(
									$elm$core$Basics$composeL,
									A2($elm$core$Basics$composeL, $Gizra$elm_debouncer$Debouncer$Basic$MsgInternal, $Gizra$elm_debouncer$Debouncer$Internal$Check),
									$elm$time$Time$posixToMillis),
								A2(
									$elm$core$Task$andThen,
									$elm$core$Basics$always($elm$time$Time$now),
									$elm$core$Process$sleep(interval)));
						},
						intervals));
				return _Utils_Tuple3(updatedDebouncer, cmds, output);
		}
	});
var $author$project$Search$update = F3(
	function (shared, model, msg) {
		update:
		while (true) {
			switch (msg.$) {
				case 0:
					return $author$project$UpdateResult$init(model);
				case 1:
					var subMsg = msg.a;
					var _v1 = A2($Gizra$elm_debouncer$Debouncer$Basic$update, subMsg, model.fJ);
					var subModel = _v1.a;
					var subCmd = _v1.b;
					var emittedMsg = _v1.c;
					var mappedCmd = A2($elm$core$Platform$Cmd$map, $author$project$Search$GotDebouncerMsg, subCmd);
					var updatedModel = _Utils_update(
						model,
						{fJ: subModel});
					if (!emittedMsg.$) {
						var emitted = emittedMsg.a;
						return A2(
							$author$project$UpdateResult$addCmd,
							mappedCmd,
							A3($author$project$Search$update, shared, updatedModel, emitted));
					} else {
						return A2(
							$author$project$UpdateResult$addCmd,
							mappedCmd,
							$author$project$UpdateResult$init(updatedModel));
					}
				case 12:
					return $author$project$UpdateResult$init(
						_Utils_update(
							model,
							{
								hk: A2(
									$author$project$Form$updateValues,
									function (form) {
										return _Utils_update(
											form,
											{dO: ''});
									},
									model.hk),
								X: $author$project$Search$Inactive
							}));
				case 5:
					var q = msg.a;
					var $temp$shared = shared,
						$temp$model = _Utils_update(
						model,
						{
							hk: A2(
								$author$project$Form$updateValues,
								function (form) {
									return _Utils_update(
										form,
										{dO: q});
								},
								model.hk),
							X: A2($author$project$Search$ResultsShowed, $krisajenkins$remotedata$RemoteData$Loading, $elm$core$Maybe$Nothing)
						}),
						$temp$msg = $author$project$Search$QuerySubmitted;
					shared = $temp$shared;
					model = $temp$model;
					msg = $temp$msg;
					continue update;
				case 8:
					var activeTab = msg.a;
					var _v3 = model.X;
					if (_v3.$ === 2) {
						var r = _v3.a;
						var previousActiveTab = _v3.b;
						var newRecentQueries = A2(
							$elm$core$List$take,
							$author$project$Search$maximumRecentSearches,
							$elm_community$list_extra$List$Extra$unique(
								A2(
									$elm$core$List$cons,
									A2(
										$author$project$Form$getValue,
										function ($) {
											return $.dO;
										},
										model.hk),
									model.bP)));
						return A2(
							$author$project$UpdateResult$addCmd,
							function () {
								if (previousActiveTab.$ === 1) {
									return $author$project$Search$storeRecentSearches(newRecentQueries);
								} else {
									return $elm$core$Platform$Cmd$none;
								}
							}(),
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{
										bP: newRecentQueries,
										X: A2(
											$author$project$Search$ResultsShowed,
											r,
											$elm$core$Maybe$Just(activeTab))
									})));
					} else {
						return $author$project$UpdateResult$init(model);
					}
				case 6:
					var _for = msg.a.jr;
					var res = msg.b;
					return $author$project$UpdateResult$init(
						_Utils_update(
							model,
							{
								X: $elm$core$String$isEmpty(
									A2(
										$author$project$Form$getValue,
										function ($) {
											return $.dO;
										},
										model.hk)) ? model.X : (_Utils_eq(
									_for,
									A2(
										$author$project$Form$getValue,
										function ($) {
											return $.dO;
										},
										model.hk)) ? A2($author$project$Search$ResultsShowed, res, $elm$core$Maybe$Nothing) : model.X)
							}));
				case 4:
					var queries = msg.a;
					var _v5 = A2(
						$elm$json$Json$Decode$decodeString,
						$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
						queries);
					if (!_v5.$) {
						var queryList = _v5.a;
						return $author$project$UpdateResult$init(
							_Utils_update(
								model,
								{bP: queryList}));
					} else {
						return $author$project$UpdateResult$init(model);
					}
				case 2:
					return $author$project$UpdateResult$init(
						$author$project$Search$closeSearch(model));
				case 9:
					var subMsg = msg.a;
					var updateResult = A5(
						$author$project$UpdateResult$fromChild,
						function (newForm) {
							return _Utils_update(
								model,
								{hk: newForm});
						},
						$author$project$Search$GotFormMsg,
						A2($elm$core$Basics$composeR, $author$project$Search$SetFeedback, $author$project$UpdateResult$addExt),
						model,
						A3($author$project$Form$update, shared, subMsg, model.hk));
					var oldQuery = A2(
						$author$project$Form$getValue,
						function ($) {
							return $.dO;
						},
						model.hk);
					var newQuery = A2(
						$author$project$Form$getValue,
						function ($) {
							return $.dO;
						},
						updateResult.nV.hk);
					var actOnQueryChange = $elm$core$String$isEmpty(newQuery) ? $author$project$UpdateResult$mapModel(
						function (m) {
							return _Utils_update(
								m,
								{X: $author$project$Search$RecentSearchesShowed});
						}) : ((!_Utils_eq(oldQuery, newQuery)) ? $author$project$UpdateResult$addMsg(
						$author$project$Search$GotDebouncerMsg(
							$Gizra$elm_debouncer$Debouncer$Basic$provideInput(
								$author$project$Search$RequestedNewResults(newQuery)))) : $elm$core$Basics$identity);
					return actOnQueryChange(updateResult);
				case 10:
					var queryString = msg.a;
					return A2(
						$author$project$UpdateResult$addExt,
						$author$project$Search$sendSearchQuery(queryString),
						$author$project$UpdateResult$init(model));
				case 11:
					return A2(
						$author$project$UpdateResult$addCmd,
						A2(
							$elm$core$Task$attempt,
							function (_v6) {
								return $author$project$Search$NoOp;
							},
							$elm$browser$Browser$Dom$focus('searchInput')),
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									hk: A2(
										$author$project$Form$updateValues,
										function (form) {
											return _Utils_update(
												form,
												{dO: ''});
										},
										model.hk),
									X: $author$project$Search$RecentSearchesShowed
								})));
				case 3:
					return $author$project$UpdateResult$init(
						_Utils_update(
							model,
							{
								X: function () {
									var _v7 = model.X;
									if (!_v7.$) {
										return $author$project$Search$RecentSearchesShowed;
									} else {
										return model.X;
									}
								}()
							}));
				case 7:
					var currentQuery = A2(
						$author$project$Form$getValue,
						function ($) {
							return $.dO;
						},
						model.hk);
					var newRecentSearches = A2(
						$elm$core$List$take,
						$author$project$Search$maximumRecentSearches,
						$elm_community$list_extra$List$Extra$unique(
							A2($elm$core$List$cons, currentQuery, model.bP)));
					return A2(
						$author$project$UpdateResult$addExt,
						$author$project$Search$sendSearchQuery(currentQuery),
						A2(
							$author$project$UpdateResult$addCmd,
							$author$project$Search$storeRecentSearches(newRecentSearches),
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{
										bP: newRecentSearches,
										X: A2($author$project$Search$ResultsShowed, $krisajenkins$remotedata$RemoteData$Loading, $elm$core$Maybe$Nothing)
									}))));
				case 13:
					var containerId = msg.a.mj;
					var imageId = msg.a.nf;
					return A2(
						$author$project$UpdateResult$addPort,
						{
							i9: $elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'name',
										$elm$json$Json$Encode$string('smoothHorizontalScroll')),
										_Utils_Tuple2(
										'containerId',
										$elm$json$Json$Encode$string(containerId)),
										_Utils_Tuple2(
										'targetId',
										$elm$json$Json$Encode$string(imageId))
									])),
							kY: $author$project$Search$NoOp,
							kZ: $elm$json$Json$Encode$null
						},
						$author$project$UpdateResult$init(model));
				case 14:
					var productId = msg.a;
					var imageId = msg.b;
					var _v8 = model.X;
					if ((_v8.$ === 2) && (_v8.a.$ === 3)) {
						var searchResults = _v8.a.a;
						var activeTab = _v8.b;
						var newOffers = A3(
							$elm_community$list_extra$List$Extra$updateIf,
							function (_v9) {
								var product = _v9.oP;
								return _Utils_eq(product.R, productId);
							},
							function (productInfo) {
								return _Utils_update(
									productInfo,
									{
										cc: $elm$core$Maybe$Just(imageId),
										cF: productInfo.cc
									});
							},
							searchResults.a2);
						return $author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									X: A2(
										$author$project$Search$ResultsShowed,
										$krisajenkins$remotedata$RemoteData$Success(
											_Utils_update(
												searchResults,
												{a2: newOffers})),
										activeTab)
								}));
					} else {
						return $author$project$UpdateResult$init(model);
					}
				default:
					var productId = msg.a;
					var imageId = msg.b;
					var _v10 = model.X;
					if ((_v10.$ === 2) && (_v10.a.$ === 3)) {
						var searchResults = _v10.a.a;
						var activeTab = _v10.b;
						var newOffers = A3(
							$elm_community$list_extra$List$Extra$updateIf,
							function (_v11) {
								var product = _v11.oP;
								return _Utils_eq(product.R, productId);
							},
							function (productInfo) {
								return _Utils_eq(
									$elm$core$Maybe$Just(imageId),
									productInfo.cc) ? _Utils_update(
									productInfo,
									{cc: productInfo.cF, cF: $elm$core$Maybe$Nothing}) : (_Utils_eq(
									$elm$core$Maybe$Just(imageId),
									productInfo.cF) ? _Utils_update(
									productInfo,
									{cF: $elm$core$Maybe$Nothing}) : productInfo);
							},
							searchResults.a2);
						return $author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									X: A2(
										$author$project$Search$ResultsShowed,
										$krisajenkins$remotedata$RemoteData$Success(
											_Utils_update(
												searchResults,
												{a2: newOffers})),
										activeTab)
								}));
					} else {
						return $author$project$UpdateResult$init(model);
					}
			}
		}
	});
var $author$project$Session$LoggedIn$AddAfterPrivateKeyCallback = function (a) {
	return {$: 5, a: a};
};
var $author$project$Auth$withPrivateKey = F4(
	function (model, _v0, config, successfulUR) {
		var requiredPermissions = _v0.o1;
		var currentPermissions = _v0.mv;
		var actWithPrivateKey = function () {
			var _v2 = model.gE;
			if (!_v2.$) {
				return config.oc(
					$author$project$UpdateResult$init(config.hb));
			} else {
				var privateKey = _v2.a;
				return successfulUR(privateKey);
			}
		}();
		if ($elm$core$List$isEmpty(requiredPermissions)) {
			return actWithPrivateKey;
		} else {
			if (currentPermissions.$ === 1) {
				return config.ob(
					$author$project$UpdateResult$init(config.hb));
			} else {
				var permissions = currentPermissions.a;
				return A2(
					$elm$core$List$all,
					function (permission) {
						return A2($elm$core$List$member, permission, permissions);
					},
					requiredPermissions) ? actWithPrivateKey : config.ok(
					$author$project$UpdateResult$init(config.hb));
			}
		}
	});
var $author$project$Session$LoggedIn$withPrivateKeyInternal = F4(
	function (msg, model, requiredPermissions, successfulUR) {
		return A4(
			$author$project$Auth$withPrivateKey,
			model.fp,
			{
				mv: A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.o5;
						},
						$elm$core$List$concatMap(
							function ($) {
								return $.oB;
							})),
					$author$project$Session$LoggedIn$profile(model)),
				o1: requiredPermissions
			},
			{
				hb: model,
				ob: A5(
					$author$project$UpdateResult$logImpossible,
					msg,
					'Tried signing eos transaction internally, but profile wasn\'t loaded',
					$elm$core$Maybe$Just(model.lM),
					{mX: 'withPrivateKeyInternal', nW: 'Session.LoggedIn'},
					_List_Nil),
				oc: A2(
					$elm$core$Basics$composeR,
					$author$project$UpdateResult$mapModel($author$project$Session$LoggedIn$askedAuthentication),
					$author$project$UpdateResult$addExt(
						$author$project$Session$LoggedIn$AddAfterPrivateKeyCallback(msg))),
				ok: $author$project$UpdateResult$mapModel(
					function (m) {
						return _Utils_update(
							m,
							{bo: true});
					})
			},
			successfulUR);
	});
var $author$project$Session$LoggedIn$update = F2(
	function (msg, model) {
		var shared = model.aM;
		var closeAllModals = _Utils_update(
			model,
			{dV: false, bR: false, bo: false, e5: false, e6: false, aB: false});
		switch (msg.$) {
			case 0:
				return $author$project$UpdateResult$init(model);
			case 25:
				var time = msg.a;
				return A2(
					$author$project$UpdateResult$addExt,
					$author$project$Session$LoggedIn$Broadcast(
						$author$project$Session$LoggedIn$GotTime(time)),
					$author$project$UpdateResult$init(
						_Utils_update(
							model,
							{
								aM: _Utils_update(
									shared,
									{gh: time})
							})));
			case 22:
				var subMsg = msg.a;
				return A5(
					$author$project$UpdateResult$fromChild,
					function (_v1) {
						return model;
					},
					$author$project$Session$LoggedIn$GotActionMsg,
					function (ext) {
						var feedbackModel = ext;
						return $author$project$UpdateResult$mapModel(
							function (m) {
								return _Utils_update(
									m,
									{hf: feedbackModel});
							});
					},
					model,
					A2($author$project$Action$update, subMsg, model));
			case 23:
				return $author$project$UpdateResult$init(
					_Utils_update(
						closeAllModals,
						{
							ah: $author$project$Search$closeSearch(model.ah)
						}));
			case 24:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{
							ah: $author$project$Search$closeSearch(model.ah)
						}));
			case 21:
				var searchMsg = msg.a;
				return A2(
					$author$project$UpdateResult$mapModel,
					function (newModel) {
						return _Utils_update(
							newModel,
							{
								fV: newModel.fV || $author$project$Search$isOpenMsg(searchMsg)
							});
					},
					A5(
						$author$project$UpdateResult$fromChild,
						function (searchModel) {
							return _Utils_update(
								model,
								{ah: searchModel});
						},
						$author$project$Session$LoggedIn$GotSearchMsg,
						F2(
							function (extMsg, ur) {
								if (!extMsg.$) {
									var feedback = extMsg.a;
									return A2(
										$author$project$UpdateResult$mapModel,
										function (newModel) {
											return _Utils_update(
												newModel,
												{hf: feedback});
										},
										ur);
								} else {
									var selectionSet = extMsg.a;
									var resultMsg = extMsg.b;
									return A2(
										$author$project$UpdateResult$addCmd,
										A3(
											$author$project$Session$LoggedIn$internalQuery,
											ur.nV,
											selectionSet,
											A2($elm$core$Basics$composeR, resultMsg, $author$project$Session$LoggedIn$GotSearchMsg)),
										ur);
								}
							}),
						_Utils_update(
							model,
							{
								fV: model.fV || $author$project$Search$isOpenMsg(searchMsg)
							}),
						A3($author$project$Search$update, shared, model.ah, searchMsg)));
			case 1:
				if (!msg.b.$) {
					var lang = msg.a;
					var transl = msg.b.a;
					var _v4 = model.kJ;
					if (_v4.$ === 3) {
						return A2(
							$author$project$UpdateResult$addExt,
							$author$project$Session$LoggedIn$Broadcast($author$project$Session$LoggedIn$TranslationsLoaded),
							A2(
								$author$project$UpdateResult$addCmd,
								$author$project$Ports$storeLanguage(
									$author$project$Translation$languageToLocale(lang)),
								$author$project$UpdateResult$init(
									_Utils_update(
										model,
										{
											aM: A2(
												$author$project$Session$Shared$loadTranslation,
												$elm$core$Result$Ok(
													_Utils_Tuple2(lang, transl)),
												shared)
										}))));
					} else {
						return $author$project$UpdateResult$init(model);
					}
				} else {
					var err = msg.b.a;
					return A7(
						$author$project$UpdateResult$logHttpError,
						msg,
						$elm$core$Maybe$Just(model.lM),
						'Got an error when loading translation as a logged in user',
						{mX: 'update', nW: 'Session.LoggedIn'},
						_List_Nil,
						err,
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									aM: A2(
										$author$project$Session$Shared$loadTranslation,
										$elm$core$Result$Err(err),
										shared)
								})));
				}
			case 2:
				return A2(
					$author$project$UpdateResult$addBreadcrumb,
					{fw: msg, i9: $elm$core$Dict$empty, nH: 2, nS: 'Clicked to fetch translation again', d0: 2},
					A2(
						$author$project$UpdateResult$addCmd,
						A2($author$project$Session$LoggedIn$fetchTranslations, shared.lF, shared.hy),
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									aM: $author$project$Session$Shared$toLoadingTranslation(shared)
								}))));
			case 3:
				switch (msg.a.$) {
					case 3:
						var profile_ = msg.a.a;
						var subscriptionDoc = $dillonkearns$elm_graphql$Graphql$Document$serializeSubscription(
							$author$project$Session$LoggedIn$unreadCountSubscription(model.lM));
						if (!profile_.$) {
							var p = profile_.a;
							var sendLanguagePreference = function () {
								var _v6 = p.oJ;
								if (_v6.$ === 1) {
									return A2($author$project$Session$LoggedIn$sendPreferredLanguage, model, model.aM.hy);
								} else {
									return $elm$core$Platform$Cmd$none;
								}
							}();
							var hasAcceptedCodeOfConduct = $elm_community$maybe_extra$Maybe$Extra$isJust(p.nG);
							return A2(
								$author$project$UpdateResult$addBreadcrumb,
								{
									fw: msg,
									i9: $elm$core$Dict$fromList(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'username',
												$author$project$Eos$Account$encodeName(p.fl))
											])),
									nH: 3,
									nS: 'User profile successfully loaded',
									d0: 0
								},
								A2(
									$author$project$UpdateResult$addPort,
									{
										i9: $elm$json$Json$Encode$object(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'name',
													$elm$json$Json$Encode$string('subscribeToUnreadCount')),
													_Utils_Tuple2(
													'subscription',
													$elm$json$Json$Encode$string(subscriptionDoc))
												])),
										kY: $author$project$Session$LoggedIn$CompletedLoadUnread(
											$elm$json$Json$Encode$string('')),
										kZ: $elm$json$Json$Encode$null
									},
									A2(
										$author$project$UpdateResult$addExt,
										$author$project$Session$LoggedIn$Broadcast(
											$author$project$Session$LoggedIn$ProfileLoaded(p)),
										A2(
											$author$project$UpdateResult$addCmd,
											sendLanguagePreference,
											$author$project$UpdateResult$init(
												_Utils_update(
													model,
													{
														T: hasAcceptedCodeOfConduct ? $author$project$Session$LoggedIn$CodeOfConductNotShown : $author$project$Session$LoggedIn$CodeOfConductShown,
														mZ: model.mZ || hasAcceptedCodeOfConduct,
														kJ: $krisajenkins$remotedata$RemoteData$Success(p)
													}))))));
						} else {
							return A2(
								$author$project$UpdateResult$addCmd,
								A2($author$project$Route$replaceUrl, shared.eM, $author$project$Route$Logout),
								$author$project$UpdateResult$init(model));
						}
					case 2:
						var err = msg.a.a;
						return A7(
							$author$project$UpdateResult$logGraphqlError,
							msg,
							$elm$core$Maybe$Just(model.lM),
							'Got an error when trying to load profile',
							{mX: 'update', nW: 'Session.LoggedIn'},
							_List_Nil,
							err,
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{
										kJ: function () {
											var _v7 = model.kJ;
											if (_v7.$ === 1) {
												return $krisajenkins$remotedata$RemoteData$Failure(err);
											} else {
												return model.kJ;
											}
										}()
									})));
					case 0:
						var _v8 = msg.a;
						return $author$project$UpdateResult$init(model);
					default:
						var _v9 = msg.a;
						return $author$project$UpdateResult$init(model);
				}
			case 4:
				switch (msg.a.$) {
					case 3:
						if (!msg.a.a.$) {
							var community = msg.a.a.a;
							var _v10 = A2(
								$author$project$Session$LoggedIn$setCommunity,
								A2($author$project$Community$mergeFields, model.o7, community),
								model);
							var newModel = _v10.a;
							var cmd = _v10.b;
							var newCommunity = function (comm) {
								return A3($elm$core$List$foldl, $author$project$Community$setFieldAsLoading, comm, newModel.bO);
							}(
								A2($author$project$Community$mergeFields, newModel.o7, community));
							return A2(
								$author$project$UpdateResult$addBreadcrumb,
								{
									fw: msg,
									i9: $elm$core$Dict$fromList(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'symbol',
												$author$project$Eos$encodeSymbol(community.e9)),
												_Utils_Tuple2(
												'name',
												$elm$json$Json$Encode$string(community.ki))
											])),
									nH: 3,
									nS: 'Community successfully loaded',
									d0: 0
								},
								A2(
									$author$project$UpdateResult$addCmd,
									A3(
										$author$project$Session$LoggedIn$internalQuery,
										newModel,
										A2($author$project$Community$fieldsSelectionSet, community.e9, newModel.bO),
										$author$project$Session$LoggedIn$CompletedLoadCommunityFields(newCommunity)),
									A2(
										$author$project$UpdateResult$addExt,
										$author$project$Session$LoggedIn$Broadcast(
											$author$project$Session$LoggedIn$CommunityLoaded(newCommunity)),
										A2(
											$author$project$UpdateResult$addPort,
											{
												i9: $elm$json$Json$Encode$object(
													_List_fromArray(
														[
															_Utils_Tuple2(
															'name',
															$elm$json$Json$Encode$string('subscribeToHighlightedNewsChanged')),
															_Utils_Tuple2(
															'subscription',
															$elm$json$Json$Encode$string(
																$dillonkearns$elm_graphql$Graphql$Document$serializeSubscription($author$project$Session$LoggedIn$highlightedNewsSubscription)))
														])),
												kY: $author$project$Session$LoggedIn$ReceivedNewHighlightedNews($elm$json$Json$Encode$null),
												kZ: $elm$json$Json$Encode$null
											},
											A2(
												$author$project$UpdateResult$addPort,
												{
													i9: $elm$json$Json$Encode$object(
														_List_fromArray(
															[
																_Utils_Tuple2(
																'name',
																$elm$json$Json$Encode$string('setFavicon')),
																_Utils_Tuple2(
																'favicon',
																$elm$json$Json$Encode$string(community.hC))
															])),
													kY: $author$project$Session$LoggedIn$NoOp,
													kZ: $elm$json$Json$Encode$null
												},
												A2(
													$author$project$UpdateResult$addCmd,
													$author$project$Ports$getRecentSearches(0),
													A2(
														$author$project$UpdateResult$addCmd,
														cmd,
														$author$project$UpdateResult$init(
															_Utils_update(
																newModel,
																{
																	j7: community.m8,
																	o7: $krisajenkins$remotedata$RemoteData$Success(newCommunity)
																})))))))));
						} else {
							var _v11 = msg.a.a;
							return A2(
								$author$project$UpdateResult$addCmd,
								A2(
									$author$project$Route$pushUrl,
									shared.eM,
									$author$project$Route$CommunitySelector(
										$elm$core$List$head(model.gs))),
								$author$project$UpdateResult$init(model));
						}
					case 2:
						var e = msg.a.a;
						var communityExists = !$author$project$Api$Graphql$isNonExistingCommunityError(e);
						return (communityExists ? $elm$core$Basics$identity : $author$project$UpdateResult$addCmd(
							A2(
								$author$project$Route$pushUrl,
								shared.eM,
								$author$project$Route$CommunitySelector(
									$elm$core$List$head(model.gs)))))(
							A7(
								$author$project$UpdateResult$logGraphqlError,
								msg,
								$elm$core$Maybe$Just(model.lM),
								'Got an error when loading community as logged in',
								{mX: 'update', nW: 'Session.LoggedIn'},
								_List_Nil,
								e,
								$author$project$UpdateResult$init(
									_Utils_update(
										model,
										{
											o7: $krisajenkins$remotedata$RemoteData$Failure(e)
										}))));
					case 0:
						var _v12 = msg.a;
						return $author$project$UpdateResult$init(
							_Utils_update(
								model,
								{o7: $krisajenkins$remotedata$RemoteData$NotAsked}));
					default:
						var _v13 = msg.a;
						return $author$project$UpdateResult$init(
							_Utils_update(
								model,
								{o7: $krisajenkins$remotedata$RemoteData$Loading}));
				}
			case 5:
				switch (msg.b.$) {
					case 3:
						if (!msg.b.a.$) {
							var community = msg.a;
							var fieldValue = msg.b.a.a;
							var newCommunity = A2(
								$author$project$Community$setFieldValue,
								fieldValue,
								A2($krisajenkins$remotedata$RemoteData$withDefault, community, model.o7));
							return A2(
								$author$project$UpdateResult$addExt,
								$author$project$Session$LoggedIn$Broadcast(
									A2($author$project$Session$LoggedIn$CommunityFieldLoaded, newCommunity, fieldValue)),
								$author$project$UpdateResult$init(
									_Utils_update(
										model,
										{
											o7: $krisajenkins$remotedata$RemoteData$Success(newCommunity)
										})));
						} else {
							var community = msg.a;
							var _v14 = msg.b.a;
							return A6(
								$author$project$UpdateResult$logImpossible,
								msg,
								'Tried loading community field, but got Nothing in return',
								$elm$core$Maybe$Just(model.lM),
								{mX: 'update', nW: 'Session.LoggedIn'},
								_List_fromArray(
									[
										$author$project$Log$contextFromCommunity(
										$krisajenkins$remotedata$RemoteData$Success(community))
									]),
								$author$project$UpdateResult$init(model));
						}
					case 2:
						var err = msg.b.a;
						return A7(
							$author$project$UpdateResult$logGraphqlError,
							msg,
							$elm$core$Maybe$Just(model.lM),
							'Got an error when loading community field',
							{mX: 'update', nW: 'Session.LoggedIn'},
							_List_Nil,
							err,
							$author$project$UpdateResult$init(model));
					case 0:
						var _v15 = msg.b;
						return $author$project$UpdateResult$init(model);
					default:
						var _v16 = msg.b;
						return $author$project$UpdateResult$init(model);
				}
			case 6:
				switch (msg.b.$) {
					case 3:
						var community = msg.a;
						var fieldValues = msg.b.a;
						var newCommunity = A3(
							$elm$core$List$foldl,
							$author$project$Community$setFieldValue,
							A2($krisajenkins$remotedata$RemoteData$withDefault, community, model.o7),
							fieldValues);
						var addBroadcasts = function (uResult) {
							return A3(
								$elm$core$List$foldl,
								function (field) {
									return $author$project$UpdateResult$addExt(
										$author$project$Session$LoggedIn$Broadcast(
											A2($author$project$Session$LoggedIn$CommunityFieldLoaded, community, field)));
								},
								uResult,
								fieldValues);
						};
						return addBroadcasts(
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{
										o7: $krisajenkins$remotedata$RemoteData$Success(newCommunity)
									})));
					case 2:
						var err = msg.b.a;
						return A7(
							$author$project$UpdateResult$logGraphqlError,
							msg,
							$elm$core$Maybe$Just(model.lM),
							'Got an error when loading multiple community fields',
							{mX: 'update', nW: 'Session.LoggedIn'},
							_List_Nil,
							err,
							$author$project$UpdateResult$init(model));
					case 0:
						var _v17 = msg.b;
						return $author$project$UpdateResult$init(model);
					default:
						var _v18 = msg.b;
						return $author$project$UpdateResult$init(model);
				}
			case 7:
				var accountName = msg.a;
				return A2(
					$author$project$UpdateResult$addCmd,
					A3(
						$author$project$Session$LoggedIn$internalQuery,
						model,
						$author$project$Profile$query(accountName),
						$author$project$Session$LoggedIn$CompletedLoadProfile),
					$author$project$UpdateResult$init(
						_Utils_update(
							model,
							{kJ: $krisajenkins$remotedata$RemoteData$Loading})));
			case 8:
				return A2(
					$author$project$UpdateResult$addPort,
					{
						i9: $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'name',
									$elm$json$Json$Encode$string('logout'))
								])),
						kY: $author$project$Session$LoggedIn$ClickedLogout,
						kZ: $elm$json$Json$Encode$null
					},
					A2(
						$author$project$UpdateResult$addCmd,
						A2($author$project$Route$replaceUrl, shared.eM, $author$project$Route$Logout),
						$author$project$UpdateResult$init(model)));
			case 9:
				var b = msg.a;
				return $author$project$UpdateResult$init(
					_Utils_update(
						closeAllModals,
						{aB: b}));
			case 10:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{e4: !model.e4}));
			case 11:
				var lang = msg.a;
				return A2(
					$author$project$UpdateResult$addCmd,
					A2($author$project$Session$LoggedIn$sendPreferredLanguage, model, lang),
					A2(
						$author$project$UpdateResult$addCmd,
						A2($author$project$Session$LoggedIn$fetchTranslations, shared.lF, lang),
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									aM: $author$project$Session$Shared$toLoadingTranslation(shared),
									aB: false
								}))));
			case 12:
				if (msg.a.$ === 2) {
					var err = msg.a.a;
					return A7(
						$author$project$UpdateResult$logGraphqlError,
						msg,
						$elm$core$Maybe$Just(model.lM),
						'Got an error when sending language preference',
						{mX: 'update', nW: 'Session.LoggedIn'},
						_List_Nil,
						err,
						$author$project$UpdateResult$init(model));
				} else {
					return $author$project$UpdateResult$init(model);
				}
			case 13:
				return A2(
					$author$project$UpdateResult$addExt,
					$author$project$Session$LoggedIn$AuthenticationFailed,
					$author$project$UpdateResult$init(closeAllModals));
			case 14:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{bo: false}));
			case 15:
				var authMsg = msg.a;
				return A4(
					$author$project$UpdateResult$map,
					function (a) {
						return _Utils_update(
							model,
							{fp: a});
					},
					$author$project$Session$LoggedIn$GotAuthMsg,
					F2(
						function (extMsg, uResult) {
							switch (extMsg.$) {
								case 0:
									var accountName = extMsg.a;
									var auth = extMsg.b;
									return A2(
										$author$project$UpdateResult$addBreadcrumb,
										{
											fw: msg,
											i9: $elm$core$Dict$fromList(
												_List_fromArray(
													[
														_Utils_Tuple2(
														'username',
														$author$project$Eos$Account$encodeName(accountName))
													])),
											nH: 3,
											nS: 'Successfully authenticated user through PIN',
											d0: 0
										},
										A2(
											$author$project$UpdateResult$addExt,
											$author$project$Session$LoggedIn$RunAfterPrivateKeyCallbacks,
											A2(
												$author$project$UpdateResult$addExt,
												$author$project$Session$LoggedIn$AuthenticationSucceed,
												A2(
													$author$project$UpdateResult$mapModel,
													function (m) {
														return _Utils_update(
															m,
															{fp: auth});
													},
													$author$project$Session$LoggedIn$closeModal(uResult)))));
								case 1:
									var newShared = extMsg.a;
									return A2(
										$author$project$UpdateResult$mapModel,
										function (m) {
											return _Utils_update(
												m,
												{aM: newShared});
										},
										uResult);
								default:
									var feedbackModel = extMsg.a;
									return A2(
										$author$project$UpdateResult$mapModel,
										function (m) {
											return _Utils_update(
												m,
												{hf: feedbackModel});
										},
										uResult);
							}
						}),
					A3($author$project$Auth$update, authMsg, shared, model.fp));
			case 16:
				var payload = msg.a;
				var _v20 = A2(
					$elm$json$Json$Decode$decodeValue,
					$dillonkearns$elm_graphql$Graphql$Document$decoder(
						$author$project$Session$LoggedIn$unreadCountSubscription(model.lM)),
					payload);
				if (!_v20.$) {
					var res = _v20.a;
					return $author$project$UpdateResult$init(
						_Utils_update(
							model,
							{d1: res}));
				} else {
					var err = _v20.a;
					return A7(
						$author$project$UpdateResult$logDecodingError,
						msg,
						$elm$core$Maybe$Just(model.lM),
						'Got an error when loading unread notifications',
						{mX: 'update', nW: 'Session.LoggedIn'},
						_List_Nil,
						err,
						$author$project$UpdateResult$init(model));
				}
			case 20:
				var subMsg = msg.a;
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{
							hf: A2($author$project$View$Feedback$update, subMsg, model.hf)
						}));
			case 17:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{bS: true}));
			case 18:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{bS: false}));
			case 19:
				var newCommunity = msg.a;
				var symbol = newCommunity.e9;
				var _v21 = A2(
					$author$project$Session$LoggedIn$loadCommunity,
					model,
					$elm$core$Maybe$Just(symbol));
				var loadCommunityModel = _v21.a;
				var loadCommunityCmd = _v21.b;
				var _v22 = model.o7;
				switch (_v22.$) {
					case 3:
						var selectedCommunity = _v22.a;
						if (_Utils_eq(symbol, selectedCommunity.e9)) {
							return $author$project$UpdateResult$init(
								_Utils_update(
									model,
									{bS: false}));
						} else {
							var _v23 = A3(
								$author$project$Session$LoggedIn$selectCommunity,
								model,
								newCommunity,
								A2(
									$elm$core$Maybe$withDefault,
									$author$project$Route$Dashboard,
									$elm$core$List$head(model.gs)));
							var newModel = _v23.a;
							var cmd = _v23.b;
							return A2(
								$author$project$UpdateResult$addCmd,
								cmd,
								$author$project$UpdateResult$init(
									_Utils_update(
										newModel,
										{bS: false})));
						}
					case 0:
						return A2(
							$author$project$UpdateResult$addCmd,
							loadCommunityCmd,
							$author$project$UpdateResult$init(loadCommunityModel));
					case 2:
						return A2(
							$author$project$UpdateResult$addCmd,
							loadCommunityCmd,
							$author$project$UpdateResult$init(loadCommunityModel));
					default:
						return $author$project$UpdateResult$init(model);
				}
			case 27:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{j7: $elm$core$Maybe$Nothing}));
			case 26:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{j7: $elm$core$Maybe$Nothing}));
			case 28:
				var payload = msg.a;
				var _v24 = model.o7;
				if (_v24.$ === 3) {
					var community = _v24.a;
					var _v25 = A2(
						$elm$json$Json$Decode$decodeValue,
						$dillonkearns$elm_graphql$Graphql$Document$decoder($author$project$Session$LoggedIn$highlightedNewsSubscription),
						payload);
					if (!_v25.$) {
						var highlightedNews = _v25.a;
						return $author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									j7: highlightedNews,
									o7: $krisajenkins$remotedata$RemoteData$Success(
										_Utils_update(
											community,
											{m8: highlightedNews}))
								}));
					} else {
						var err = _v25.a;
						return A7(
							$author$project$UpdateResult$logDecodingError,
							msg,
							$elm$core$Maybe$Just(model.lM),
							'Got an error when loading highlighted news',
							{mX: 'update', nW: 'Session.LoggedIn'},
							_List_Nil,
							err,
							$author$project$UpdateResult$init(model));
					}
				} else {
					return A6(
						$author$project$UpdateResult$logImpossible,
						msg,
						'Received new highlighted news, but community wasn\'t loaded',
						$elm$core$Maybe$Just(model.lM),
						{mX: 'update', nW: 'Session.LoggedIn'},
						_List_fromArray(
							[
								$author$project$Log$contextFromCommunity(model.o7)
							]),
						$author$project$UpdateResult$init(model));
				}
			case 29:
				var callback = msg.a;
				return model.bJ ? A2(
					$author$project$UpdateResult$addExt,
					$author$project$Session$LoggedIn$AddAfterAuthTokenCallbackInternal(callback),
					$author$project$UpdateResult$init(model)) : A2(
					$author$project$UpdateResult$addCmd,
					A3(
						$author$project$Api$Graphql$askForPhrase,
						model.aM,
						model.lM,
						$author$project$Session$LoggedIn$GotAuthTokenPhrase(callback)),
					$author$project$UpdateResult$init(
						_Utils_update(
							model,
							{bJ: true})));
			case 30:
				var callback = msg.a;
				return model.bJ ? A2(
					$author$project$UpdateResult$addExt,
					$author$project$Session$LoggedIn$AddAfterAuthTokenCallback(callback),
					$author$project$UpdateResult$init(model)) : A2(
					$author$project$UpdateResult$addCmd,
					A3(
						$author$project$Api$Graphql$askForPhrase,
						model.aM,
						model.lM,
						$author$project$Session$LoggedIn$GotAuthTokenPhraseExternal(callback)),
					$author$project$UpdateResult$init(
						_Utils_update(
							model,
							{bJ: true})));
			case 31:
				switch (msg.b.$) {
					case 3:
						var callback = msg.a;
						var phrase = msg.b.a;
						return A4(
							$author$project$Session$LoggedIn$withPrivateKeyInternal,
							msg,
							model,
							_List_Nil,
							function (privateKey) {
								return A2(
									$author$project$UpdateResult$addExt,
									$author$project$Session$LoggedIn$AddAfterAuthTokenCallbackInternal(callback),
									A2(
										$author$project$UpdateResult$addPort,
										A3($author$project$Api$Graphql$signPhrasePort, msg, privateKey, phrase),
										$author$project$UpdateResult$init(model)));
							});
					case 2:
						var err = msg.b.a;
						return A7(
							$author$project$UpdateResult$logGraphqlError,
							msg,
							$elm$core$Maybe$Just(model.lM),
							'Got an error when fetching phrase to sign for auth token',
							{mX: 'update', nW: 'Session.LoggedIn'},
							_List_Nil,
							err,
							A2(
								$author$project$UpdateResult$addPort,
								{
									i9: $elm$json$Json$Encode$object(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'name',
												$elm$json$Json$Encode$string('logout'))
											])),
									kY: $author$project$Session$LoggedIn$NoOp,
									kZ: $elm$json$Json$Encode$null
								},
								$author$project$UpdateResult$init(
									_Utils_update(
										model,
										{
											fp: $author$project$Auth$removePrivateKey(model.fp),
											hf: A2(
												$author$project$View$Feedback$Visible,
												1,
												shared.iw.il('auth.failed'))
										}))));
					default:
						return $author$project$UpdateResult$init(model);
				}
			case 32:
				switch (msg.b.$) {
					case 3:
						var callback = msg.a;
						var phrase = msg.b.a;
						return A4(
							$author$project$Session$LoggedIn$withPrivateKeyInternal,
							msg,
							model,
							_List_Nil,
							function (privateKey) {
								return A2(
									$author$project$UpdateResult$addExt,
									$author$project$Session$LoggedIn$AddAfterAuthTokenCallback(callback),
									A2(
										$author$project$UpdateResult$addPort,
										A3($author$project$Api$Graphql$signPhrasePort, msg, privateKey, phrase),
										$author$project$UpdateResult$init(model)));
							});
					case 2:
						var err = msg.b.a;
						return A7(
							$author$project$UpdateResult$logGraphqlError,
							msg,
							$elm$core$Maybe$Just(model.lM),
							'Got an error when fetching phrase to sign for auth token (using an external msg)',
							{mX: 'update', nW: 'Session.LoggedIn'},
							_List_Nil,
							err,
							A2(
								$author$project$UpdateResult$addPort,
								{
									i9: $elm$json$Json$Encode$object(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'name',
												$elm$json$Json$Encode$string('logout'))
											])),
									kY: $author$project$Session$LoggedIn$NoOp,
									kZ: $elm$json$Json$Encode$null
								},
								$author$project$UpdateResult$init(
									_Utils_update(
										model,
										{
											fp: $author$project$Auth$removePrivateKey(model.fp),
											hf: A2(
												$author$project$View$Feedback$Visible,
												1,
												shared.iw.il('auth.failed'))
										}))));
					default:
						return $author$project$UpdateResult$init(model);
				}
			case 33:
				var signedPhrase = msg.a;
				return A2(
					$author$project$UpdateResult$addCmd,
					A3(
						$author$project$Api$Graphql$signIn,
						shared,
						{
							fl: model.lM,
							jT: $author$project$Session$LoggedIn$getInvitation(model),
							kx: signedPhrase
						},
						$author$project$Session$LoggedIn$CompletedGeneratingAuthToken),
					$author$project$UpdateResult$init(model));
			case 34:
				switch (msg.a.$) {
					case 3:
						var signInResponse = msg.a.a;
						var createAbsintheSocket = model.gf ? $author$project$Api$Graphql$createAbsintheSocket(signInResponse.pC) : $elm$core$Platform$Cmd$none;
						return A2(
							$author$project$UpdateResult$addExt,
							$author$project$Session$LoggedIn$RunAfterAuthTokenCallbacks(signInResponse.pC),
							A2(
								$author$project$UpdateResult$addCmd,
								createAbsintheSocket,
								A2(
									$author$project$UpdateResult$addCmd,
									$author$project$Api$Graphql$storeToken(signInResponse.pC),
									$author$project$UpdateResult$init(
										_Utils_update(
											model,
											{
												iN: $elm$core$Maybe$Just(signInResponse.pC),
												bJ: false,
												gf: false,
												kJ: $krisajenkins$remotedata$RemoteData$Success(signInResponse.kJ)
											})))));
					case 2:
						var err = msg.a.a;
						return A7(
							$author$project$UpdateResult$logGraphqlError,
							msg,
							$elm$core$Maybe$Just(model.lM),
							'Got an error when signing in',
							{mX: 'update', nW: 'Session.LoggedIn'},
							_List_Nil,
							err,
							A2(
								$author$project$UpdateResult$addPort,
								{
									i9: $elm$json$Json$Encode$object(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'name',
												$elm$json$Json$Encode$string('logout'))
											])),
									kY: $author$project$Session$LoggedIn$NoOp,
									kZ: $elm$json$Json$Encode$null
								},
								$author$project$UpdateResult$init(
									_Utils_update(
										model,
										{
											fp: $author$project$Auth$removePrivateKey(model.fp),
											hf: A2(
												$author$project$View$Feedback$Visible,
												1,
												shared.iw.il('auth.failed')),
											bJ: false
										}))));
					default:
						return $author$project$UpdateResult$init(model);
				}
			case 35:
				if (!msg.a.$) {
					var externalMsg = msg.a.a;
					return A2(
						$author$project$UpdateResult$addExt,
						$author$project$Session$LoggedIn$RunExternalMsg(externalMsg),
						$author$project$UpdateResult$init(model));
				} else {
					var callbackCmd = msg.a.a.iU;
					return A2(
						$author$project$UpdateResult$addMsg,
						$author$project$Session$LoggedIn$RequestedNewAuthTokenPhraseExternal(
							callbackCmd(model)),
						$author$project$UpdateResult$init(model));
				}
			case 36:
				if (!msg.a.$) {
					var resultMsg = msg.a.a;
					return A2(
						$author$project$UpdateResult$addMsg,
						resultMsg,
						$author$project$UpdateResult$init(model));
				} else {
					var callbackCmd = msg.a.a;
					return A2(
						$author$project$UpdateResult$addMsg,
						$author$project$Session$LoggedIn$RequestedNewAuthTokenPhrase(callbackCmd),
						$author$project$UpdateResult$init(model));
				}
			case 37:
				return A2(
					$author$project$UpdateResult$addCmd,
					A3(
						$author$project$Session$LoggedIn$internalMutation,
						model,
						$author$project$Cambiatus$Mutation$acceptTerms(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(0)),
						$author$project$Session$LoggedIn$CompletedAcceptingCodeOfConduct),
					$author$project$UpdateResult$init(
						_Utils_update(
							model,
							{T: $author$project$Session$LoggedIn$CodeOfConductNotShown})));
			case 38:
				var _v26 = model.T;
				switch (_v26.$) {
					case 0:
						return A6(
							$author$project$UpdateResult$logImpossible,
							msg,
							'Denied code of conduct, but modal wasn\'t shown',
							$elm$core$Maybe$Just(model.lM),
							{mX: 'update', nW: 'Session.LoggedIn'},
							_List_Nil,
							$author$project$UpdateResult$init(model));
					case 1:
						return $author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									T: $author$project$Session$LoggedIn$CodeOfConductShownWithWarning(
										{fU: false})
								}));
					default:
						var hasCompletedAnimation = _v26.a.fU;
						return (!hasCompletedAnimation) ? $author$project$UpdateResult$init(model) : $author$project$UpdateResult$init(
							_Utils_update(
								model,
								{T: $author$project$Session$LoggedIn$CodeOfConductNotShown, mZ: false}));
				}
			case 39:
				if (msg.a.$ === 2) {
					var err = msg.a.a;
					return A7(
						$author$project$UpdateResult$logGraphqlError,
						msg,
						$elm$core$Maybe$Just(model.lM),
						'Got an error when accepting code of conduct',
						{mX: 'update', nW: 'Session.LoggedIn'},
						_List_Nil,
						err,
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									hf: A2(
										$author$project$View$Feedback$Visible,
										1,
										shared.iw.il('terms_of_conduct.error_accepting'))
								})));
				} else {
					return $author$project$UpdateResult$init(
						_Utils_update(
							model,
							{mZ: true}));
				}
			case 40:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{
							T: function () {
								var _v27 = model.T;
								if (_v27.$ === 2) {
									return $author$project$Session$LoggedIn$CodeOfConductShownWithWarning(
										{fU: true});
								} else {
									return model.T;
								}
							}()
						}));
			case 41:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{bR: true}));
			default:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{bR: false}));
		}
	});
var $author$project$Page$updateShared = F2(
	function (session, transform) {
		if (!session.$) {
			var subModel = session.a;
			return $author$project$Page$Guest(
				_Utils_update(
					subModel,
					{
						aM: transform(subModel.aM)
					}));
		} else {
			var subModel = session.a;
			return $author$project$Page$LoggedIn(
				_Utils_update(
					subModel,
					{
						aM: transform(subModel.aM)
					}));
		}
	});
var $author$project$Page$update = F2(
	function (msg, session) {
		var _v0 = _Utils_Tuple2(msg, session);
		_v0$7:
		while (true) {
			switch (_v0.a.$) {
				case 0:
					var _v1 = _v0.a;
					return $author$project$UpdateResult$init(session);
				case 1:
					if (!_v0.a.b.$) {
						var _v2 = _v0.a;
						var lang = _v2.a;
						var transl = _v2.b.a;
						return A2(
							$author$project$UpdateResult$addExt,
							$author$project$Page$LoggedInExternalMsg(
								$author$project$Session$LoggedIn$Broadcast($author$project$Session$LoggedIn$TranslationsLoaded)),
							A2(
								$author$project$UpdateResult$addCmd,
								$author$project$Ports$storeLanguage(
									$author$project$Translation$languageToLocale(lang)),
								$author$project$UpdateResult$init(
									A2(
										$author$project$Page$updateShared,
										session,
										$author$project$Session$Shared$loadTranslation(
											$elm$core$Result$Ok(
												_Utils_Tuple2(lang, transl)))))));
					} else {
						var _v3 = _v0.a;
						var err = _v3.b.a;
						return A7(
							$author$project$UpdateResult$logHttpError,
							msg,
							$author$project$Page$maybeAccountName(session),
							'Got an error when loading translations',
							{mX: 'update', nW: 'Page'},
							_List_Nil,
							err,
							$author$project$UpdateResult$init(
								A2(
									$author$project$Page$updateShared,
									session,
									$author$project$Session$Shared$loadTranslation(
										$elm$core$Result$Err(err)))));
					}
				case 2:
					if (!_v0.a.a.$) {
						var zone = _v0.a.a.a;
						return $author$project$UpdateResult$init(
							A2(
								$author$project$Page$updateShared,
								session,
								function (shared) {
									return _Utils_update(
										shared,
										{ll: zone});
								}));
					} else {
						return $author$project$UpdateResult$init(session);
					}
				case 3:
					if (!_v0.b.$) {
						var subMsg = _v0.a.a;
						var subModel = _v0.b.a;
						return A4(
							$author$project$UpdateResult$map,
							$author$project$Page$Guest,
							$author$project$Page$GotGuestMsg,
							F2(
								function (extMsg, uR) {
									return A2(
										$author$project$UpdateResult$addExt,
										$author$project$Page$GuestBroadcastMsg(extMsg),
										uR);
								}),
							A2($author$project$Session$Guest$update, subMsg, subModel));
					} else {
						break _v0$7;
					}
				default:
					if (_v0.b.$ === 1) {
						var subMsg = _v0.a.a;
						var subModel = _v0.b.a;
						return A4(
							$author$project$UpdateResult$map,
							$author$project$Page$LoggedIn,
							$author$project$Page$GotLoggedInMsg,
							F2(
								function (extMsg, uR) {
									return A2(
										$author$project$UpdateResult$addExt,
										$author$project$Page$LoggedInExternalMsg(extMsg),
										uR);
								}),
							A2($author$project$Session$LoggedIn$update, subMsg, subModel));
					} else {
						break _v0$7;
					}
			}
		}
		return A5(
			$author$project$UpdateResult$logIncompatibleMsg,
			msg,
			$author$project$Page$maybeAccountName(session),
			{mX: 'update', nW: 'Page'},
			_List_Nil,
			$author$project$UpdateResult$init(session));
	});
var $author$project$Page$Community$About$GotTokenInfo = function (a) {
	return {$: 2, a: a};
};
var $author$project$Session$LoggedIn$ShowFeedback = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Token$Model = F5(
	function (supply, maxSupply, minBalance, issuer, type_) {
		return {nz: issuer, nQ: maxSupply, nT: minBalance, pq: supply, d0: type_};
	});
var $author$project$Token$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'type',
	$author$project$Token$tokenTypeDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'issuer',
		$author$project$Eos$Account$nameDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'min_balance',
			$author$project$Eos$decodeAsset,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'max_supply',
				$author$project$Eos$decodeAsset,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'supply',
					$author$project$Eos$decodeAsset,
					$elm$json$Json$Decode$succeed($author$project$Token$Model))))));
var $author$project$Api$getFromBlockchain = F4(
	function (shared, query, decoder, toMsg) {
		return $elm$http$Http$post(
			{
				fv: $elm$http$Http$jsonBody(
					$author$project$Eos$encodeTableQuery(query)),
				fN: A2($elm$http$Http$expectJson, toMsg, decoder),
				gL: A3(
					$author$project$Api$blockchainUrl,
					shared,
					_List_fromArray(
						['chain', 'get_table_rows']),
					_List_Nil)
			});
	});
var $elm$json$Json$Decode$index = _Json_decodeIndex;
var $author$project$Eos$symbolToSymbolCodeString = function (_v0) {
	var s = _v0.a;
	return s;
};
var $author$project$Token$getToken = F3(
	function (shared, symbol, toMsg) {
		return A4(
			$author$project$Api$getFromBlockchain,
			shared,
			{
				i1: shared.mn.pC,
				j2: 1,
				k3: $author$project$Eos$symbolToSymbolCodeString(symbol),
				lj: 'stat'
			},
			A2(
				$elm$json$Json$Decode$field,
				'rows',
				A2($elm$json$Json$Decode$index, 0, $author$project$Token$decoder)),
			toMsg);
	});
var $author$project$Page$Community$About$urlToShareable = function (url) {
	return _Utils_update(
		url,
		{mW: $elm$core$Maybe$Nothing, gm: '', dO: $elm$core$Maybe$Nothing});
};
var $author$project$Page$Community$About$update = F3(
	function (msg, model, loggedIn) {
		switch (msg.$) {
			case 0:
				return $author$project$UpdateResult$init(model);
			case 1:
				var community = msg.a;
				return A2(
					$author$project$UpdateResult$addCmd,
					A3($author$project$Token$getToken, loggedIn.aM, community.e9, $author$project$Page$Community$About$GotTokenInfo),
					$author$project$UpdateResult$init(model));
			case 2:
				if (!msg.a.$) {
					var tokenInfo = msg.a.a;
					return $author$project$UpdateResult$init(
						_Utils_update(
							model,
							{
								ff: $krisajenkins$remotedata$RemoteData$Success(tokenInfo)
							}));
				} else {
					var err = msg.a.a;
					return A7(
						$author$project$UpdateResult$logHttpError,
						msg,
						$elm$core$Maybe$Just(loggedIn.lM),
						'Got an error when retrieving token info',
						{mX: 'update', nW: 'Page.Community.About'},
						_List_fromArray(
							[
								$author$project$Log$contextFromCommunity(loggedIn.o7)
							]),
						err,
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									ff: $krisajenkins$remotedata$RemoteData$Failure(err)
								})));
				}
			case 3:
				var _v1 = loggedIn.o7;
				if (_v1.$ === 3) {
					var community = _v1.a;
					var sharePort = loggedIn.aM.iW ? {
						i9: $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'name',
									$elm$json$Json$Encode$string('share')),
									_Utils_Tuple2(
									'title',
									$elm$json$Json$Encode$string(community.ki)),
									_Utils_Tuple2(
									'url',
									$elm$json$Json$Encode$string(
										$elm$url$Url$toString(
											$author$project$Page$Community$About$urlToShareable(loggedIn.aM.gL))))
								])),
						kY: msg,
						kZ: $elm$json$Json$Encode$null
					} : {
						i9: $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'name',
									$elm$json$Json$Encode$string('copyToClipboard')),
									_Utils_Tuple2(
									'id',
									$elm$json$Json$Encode$string('share-fallback-input'))
								])),
						kY: msg,
						kZ: $elm$json$Json$Encode$null
					};
					return A2(
						$author$project$UpdateResult$addPort,
						sharePort,
						$author$project$UpdateResult$init(model));
				} else {
					return A6(
						$author$project$UpdateResult$logImpossible,
						msg,
						'Tried sharing community, but community wasn\'t loaded',
						$elm$core$Maybe$Just(loggedIn.lM),
						{mX: 'update', nW: 'Page.Community.About'},
						_List_Nil,
						$author$project$UpdateResult$init(model));
				}
			default:
				return A2(
					$author$project$UpdateResult$addExt,
					A2(
						$author$project$Session$LoggedIn$ShowFeedback,
						0,
						loggedIn.aM.iw.il('copied_to_clipboard')),
					$author$project$UpdateResult$init(model));
		}
	});
var $author$project$Session$LoggedIn$AddedCommunity = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$Community$Invite$AlreadyMemberNotice = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$Community$Invite$Failed = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Community$Invite$FormMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Page$Community$Invite$JoinConfirmation = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$Community$Invite$KycInfo = function (a) {
	return {$: 5, a: a};
};
var $author$project$Page$Community$Invite$NotFound = {$: 1};
var $author$project$Page$Community$Invite$Open = 1;
var $author$project$Page$Community$Invite$SignedIn = {$: 6};
var $author$project$Session$LoggedIn$HideFeedback = {$: 13};
var $author$project$Session$LoggedIn$executeFeedback = function (feedback) {
	if (feedback.$ === 1) {
		var status = feedback.a;
		var message = feedback.b;
		return A2($author$project$Session$LoggedIn$ShowFeedback, status, message);
	} else {
		return $author$project$Session$LoggedIn$HideFeedback;
	}
};
var $author$project$Session$LoggedIn$addFeedback = F2(
	function (feedback, ur) {
		return A2(
			$author$project$UpdateResult$addExt,
			$author$project$Session$LoggedIn$executeFeedback(feedback),
			ur);
	});
var $author$project$Page$Community$Invite$getInvite = function (model) {
	var _v0 = model.bk;
	switch (_v0.$) {
		case 3:
			var invite = _v0.a;
			return $elm$core$Maybe$Just(invite);
		case 4:
			var invite = _v0.a;
			return $elm$core$Maybe$Just(invite);
		case 5:
			var invite = _v0.a;
			return $elm$core$Maybe$Just(invite);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Session$LoggedIn$ChangedPin = function (a) {
	return {$: 16, a: a};
};
var $author$project$Session$LoggedIn$DropFromRouteHistoryWhile = function (a) {
	return {$: 1, a: a};
};
var $author$project$Session$LoggedIn$ExternalActionMsg = function (a) {
	return {$: 15, a: a};
};
var $author$project$Session$LoggedIn$ExternalBroadcast = function (a) {
	return {$: 4, a: a};
};
var $author$project$Session$LoggedIn$ReloadResource = function (a) {
	return {$: 5, a: a};
};
var $author$project$Session$LoggedIn$RequiredPrivateKey = function (a) {
	return {$: 9, a: a};
};
var $author$project$Session$LoggedIn$SetCommunityField = function (a) {
	return {$: 8, a: a};
};
var $author$project$Session$LoggedIn$ShowCodeOfConductModal = {$: 14};
var $author$project$Session$LoggedIn$ShowInsufficientPermissionsModal = {$: 2};
var $author$project$Session$LoggedIn$UpdatedLoggedIn = function (a) {
	return {$: 0, a: a};
};
var $author$project$Session$LoggedIn$mapExternal = F2(
	function (mapFn, msg) {
		switch (msg.$) {
			case 0:
				var model = msg.a;
				return $author$project$Session$LoggedIn$UpdatedLoggedIn(model);
			case 1:
				var dropFn = msg.a;
				return $author$project$Session$LoggedIn$DropFromRouteHistoryWhile(dropFn);
			case 2:
				return $author$project$Session$LoggedIn$ShowInsufficientPermissionsModal;
			case 3:
				var communityInfo = msg.a;
				return $author$project$Session$LoggedIn$AddedCommunity(communityInfo);
			case 4:
				var broadcastMsg = msg.a;
				return $author$project$Session$LoggedIn$ExternalBroadcast(broadcastMsg);
			case 5:
				var resource = msg.a;
				return $author$project$Session$LoggedIn$ReloadResource(resource);
			case 7:
				var field = msg.a;
				return $author$project$Session$LoggedIn$RequestedCommunityField(field);
			case 8:
				var value = msg.a;
				return $author$project$Session$LoggedIn$SetCommunityField(value);
			case 6:
				var field = msg.a;
				return $author$project$Session$LoggedIn$RequestedReloadCommunityField(field);
			case 9:
				var successMsg = msg.a.ik;
				var errorMsg = msg.a.he;
				return $author$project$Session$LoggedIn$RequiredPrivateKey(
					{
						he: mapFn(errorMsg),
						ik: mapFn(successMsg)
					});
			case 10:
				var callbackCmd = msg.a.iU;
				return $author$project$Session$LoggedIn$RequiredAuthToken(
					{
						iU: A2(
							$elm$core$Basics$composeR,
							callbackCmd,
							$elm$core$Platform$Cmd$map(mapFn))
					});
			case 11:
				var externalCmdResult = msg.a;
				return $author$project$Session$LoggedIn$RequestQuery(
					A2(
						$elm$core$Platform$Cmd$map,
						function (result) {
							if (result.$ === 1) {
								var callbackCmd = result.a.iU;
								return $elm$core$Result$Err(
									{
										iU: F2(
											function (model, authToken) {
												return A2(
													$elm$core$Platform$Cmd$map,
													mapFn,
													A2(callbackCmd, model, authToken));
											})
									});
							} else {
								var callbackMsg = result.a;
								return $elm$core$Result$Ok(
									mapFn(callbackMsg));
							}
						},
						externalCmdResult));
			case 12:
				var status = msg.a;
				var message = msg.b;
				return A2($author$project$Session$LoggedIn$ShowFeedback, status, message);
			case 13:
				return $author$project$Session$LoggedIn$HideFeedback;
			case 14:
				return $author$project$Session$LoggedIn$ShowCodeOfConductModal;
			case 15:
				var subMsg = msg.a;
				return $author$project$Session$LoggedIn$ExternalActionMsg(subMsg);
			default:
				var newPin = msg.a;
				return $author$project$Session$LoggedIn$ChangedPin(newPin);
		}
	});
var $author$project$Profile$EditKycForm$Saved = function (a) {
	return {$: 2, a: a};
};
var $author$project$Profile$EditKycForm$docToString = function (docType) {
	switch (docType) {
		case 1:
			return 'DIMEX';
		case 2:
			return 'NITE';
		default:
			return 'cedula_de_identidad';
	}
};
var $author$project$Session$LoggedIn$mutation = F3(
	function (model, selectionSet, toMsg) {
		return A4($author$project$Session$LoggedIn$graphqlOperation, $author$project$Api$Graphql$loggedInMutation, model, selectionSet, toMsg);
	});
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$fromJson = function (jsonValue) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$Json(jsonValue);
};
var $author$project$Cambiatus$Scalar$unwrapEncoder = F2(
	function (getter, _v0) {
		var unwrappedCodecs = _v0;
		return A2(
			$elm$core$Basics$composeR,
			getter(unwrappedCodecs).et,
			$dillonkearns$elm_graphql$Graphql$Internal$Encode$fromJson);
	});
var $author$project$Cambiatus$InputObject$encodeKycDataUpdateInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'countryId',
				$elm$core$Maybe$Just(
					A2(
						$author$project$Cambiatus$Scalar$unwrapEncoder,
						function ($) {
							return $.eh;
						},
						$author$project$Cambiatus$ScalarCodecs$codecs)(input____.aT))),
				_Utils_Tuple2(
				'document',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.eq))),
				_Utils_Tuple2(
				'documentType',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.er))),
				_Utils_Tuple2(
				'phone',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.eT))),
				_Utils_Tuple2(
				'userType',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.lD)))
			]));
};
var $author$project$Cambiatus$Mutation$upsertKyc = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'upsertKyc',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.nl, $author$project$Cambiatus$InputObject$encodeKycDataUpdateInput)
				]),
			object____,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
	});
var $author$project$Profile$upsertKycMutation = function (data) {
	return A2(
		$author$project$Cambiatus$Mutation$upsertKyc,
		{
			nl: {aT: '1', eq: data.eq, er: data.er, eT: data.eT, lD: 'natural'}
		},
		$author$project$Kyc$selectionSet);
};
var $author$project$Profile$EditKycForm$saveKycData = F2(
	function (loggedIn, formOutput) {
		var data = {
			eq: formOutput.eq,
			er: $elm$core$String$toLower(
				$author$project$Profile$EditKycForm$docToString(formOutput.er)),
			ny: false,
			eT: formOutput.oC,
			lD: 'natural'
		};
		return A3(
			$author$project$Session$LoggedIn$mutation,
			loggedIn,
			$author$project$Profile$upsertKycMutation(data),
			$author$project$Profile$EditKycForm$Saved);
	});
var $author$project$Profile$EditKycForm$GotFormMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Profile$EditKycForm$update = F3(
	function (shared, model, msg) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				return A5(
					$author$project$UpdateResult$fromChild,
					function (newForm) {
						return _Utils_update(
							model,
							{hk: newForm});
					},
					$author$project$Profile$EditKycForm$GotFormMsg,
					$author$project$UpdateResult$addExt,
					model,
					A3($author$project$Form$update, shared, subMsg, model.hk));
			case 1:
				return $author$project$UpdateResult$init(model);
			default:
				return $author$project$UpdateResult$init(model);
		}
	});
var $author$project$Page$Community$Invite$update = F3(
	function (session, msg, model) {
		switch (msg.$) {
			case 7:
				var kycFormMsg = msg.a;
				if (session.$ === 1) {
					var loggedIn = session.a;
					var shared = loggedIn.aM;
					var formUpdateResult = function () {
						var _v5 = model.eH;
						if (!_v5.$) {
							var f = _v5.a;
							return A3($author$project$Profile$EditKycForm$update, shared, f, kycFormMsg);
						} else {
							return A3($author$project$Profile$EditKycForm$update, shared, $author$project$Profile$EditKycForm$init, kycFormMsg);
						}
					}();
					var newModel = A5(
						$author$project$UpdateResult$fromChild,
						function (newForm) {
							return _Utils_update(
								model,
								{
									eH: $elm$core$Maybe$Just(newForm)
								});
						},
						$author$project$Page$Community$Invite$FormMsg,
						$author$project$Session$LoggedIn$addFeedback,
						model,
						formUpdateResult);
					switch (kycFormMsg.$) {
						case 1:
							var formOutput = kycFormMsg.a;
							return A2(
								$author$project$UpdateResult$addExt,
								A2(
									$author$project$Session$LoggedIn$mapExternal,
									$author$project$Page$Community$Invite$FormMsg,
									A2($author$project$Profile$EditKycForm$saveKycData, loggedIn, formOutput)),
								newModel);
						case 2:
							var result = kycFormMsg.a;
							if (result.$ === 2) {
								return A2(
									$author$project$UpdateResult$addExt,
									A2(
										$author$project$Session$LoggedIn$ShowFeedback,
										1,
										shared.iw.il('error.unknown')),
									newModel);
							} else {
								return A2(
									$author$project$UpdateResult$addExt,
									$author$project$Session$LoggedIn$RequiredAuthToken(
										{
											iU: function (_v4) {
												return $author$project$Utils$spawnMessage($author$project$Page$Community$Invite$SignedIn);
											}
										}),
									newModel);
							}
						default:
							return newModel;
					}
				} else {
					return $author$project$UpdateResult$init(model);
				}
			case 0:
				switch (msg.a.$) {
					case 3:
						if (!msg.a.a.$) {
							var invite = msg.a.a.a;
							var userCommunities = function () {
								if (session.$ === 1) {
									var profile = session.a.kJ;
									if (profile.$ === 3) {
										var p = profile.a;
										return p.ei;
									} else {
										return _List_Nil;
									}
								} else {
									return _List_Nil;
								}
							}();
							var isAlreadyMember = function () {
								var isMember = function (c) {
									return _Utils_eq(
										$author$project$Eos$symbolToString(c.e9),
										$author$project$Eos$symbolToString(invite.b9.e9));
								};
								return A2($elm$core$List$any, isMember, userCommunities);
							}();
							var newPageStatus = isAlreadyMember ? $author$project$Page$Community$Invite$AlreadyMemberNotice : $author$project$Page$Community$Invite$JoinConfirmation;
							return A2(
								$author$project$UpdateResult$addBreadcrumb,
								{fw: msg, i9: $elm$core$Dict$empty, nH: 4, nS: 'Completed loading invite', d0: 1},
								$author$project$UpdateResult$init(
									_Utils_update(
										model,
										{
											bk: newPageStatus(invite)
										})));
						} else {
							var _v8 = msg.a.a;
							return $author$project$UpdateResult$init(
								_Utils_update(
									model,
									{bk: $author$project$Page$Community$Invite$NotFound}));
						}
					case 2:
						var error = msg.a.a;
						return A7(
							$author$project$UpdateResult$logGraphqlError,
							msg,
							$author$project$Page$maybeAccountName(session),
							'Got an error when trying to load invite',
							{mX: 'update', nW: 'Page.Community.Invite'},
							_List_Nil,
							error,
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{
										bk: $author$project$Page$Community$Invite$Failed(error)
									})));
					default:
						return $author$project$UpdateResult$init(model);
				}
			case 1:
				return A2(
					$author$project$UpdateResult$addCmd,
					A4(
						$author$project$Api$Graphql$query,
						$author$project$Page$toShared(session),
						$elm$core$Maybe$Nothing,
						$author$project$Community$inviteQuery(model.jT),
						$author$project$Page$Community$Invite$CompletedLoadInvite),
					$author$project$UpdateResult$init(model));
			case 2:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{ej: 1}));
			case 3:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{ej: 0}));
			case 4:
				var addBreadcrumb = $author$project$UpdateResult$addBreadcrumb(
					{fw: msg, i9: $elm$core$Dict$empty, nH: 4, nS: 'Rejected invitation', d0: 1});
				if (session.$ === 1) {
					var loggedIn = session.a;
					return addBreadcrumb(
						A2(
							$author$project$UpdateResult$addCmd,
							A2($author$project$Route$replaceUrl, loggedIn.aM.eM, $author$project$Route$Dashboard),
							$author$project$UpdateResult$init(model)));
				} else {
					var guest = session.a;
					return addBreadcrumb(
						A2(
							$author$project$UpdateResult$addCmd,
							A2(
								$author$project$Route$replaceUrl,
								guest.aM.eM,
								A2($author$project$Route$Register, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing)),
							$author$project$UpdateResult$init(model)));
				}
			case 5:
				var invitationId = msg.a;
				var invite = msg.b;
				var userKyc = function () {
					if (session.$ === 1) {
						var profile = session.a.kJ;
						if (profile.$ === 3) {
							var p = profile.a;
							return p.hx;
						} else {
							return $elm$core$Maybe$Nothing;
						}
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}();
				var areUserKycFieldsFilled = function () {
					if (!userKyc.$) {
						return true;
					} else {
						return false;
					}
				}();
				var allowedToJoinCommunity = (invite.b9.ck && areUserKycFieldsFilled) || (!invite.b9.ck);
				var addBreadcrumb = $author$project$UpdateResult$addBreadcrumb(
					{fw: msg, i9: $elm$core$Dict$empty, nH: 4, nS: 'Accepted invitation', d0: 1});
				if (session.$ === 1) {
					return allowedToJoinCommunity ? addBreadcrumb(
						A2(
							$author$project$UpdateResult$addExt,
							$author$project$Session$LoggedIn$RequiredAuthToken(
								{
									iU: function (_v11) {
										return $author$project$Utils$spawnMessage($author$project$Page$Community$Invite$SignedIn);
									}
								}),
							$author$project$UpdateResult$init(model))) : addBreadcrumb(
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									bk: $author$project$Page$Community$Invite$KycInfo(invite)
								})));
				} else {
					var guest = session.a;
					return addBreadcrumb(
						A2(
							$author$project$UpdateResult$addCmd,
							A2(
								$author$project$Route$replaceUrl,
								guest.aM.eM,
								A2(
									$author$project$Route$Register,
									$elm$core$Maybe$Just(invitationId),
									$elm$core$Maybe$Nothing)),
							$author$project$UpdateResult$init(model)));
				}
			default:
				var _v15 = $author$project$Page$Community$Invite$getInvite(model);
				if (_v15.$ === 1) {
					return A6(
						$author$project$UpdateResult$logImpossible,
						msg,
						'Completed signin in, but invite was unavailable',
						$author$project$Page$maybeAccountName(session),
						{mX: 'update', nW: 'Page.Community.Invite'},
						_List_Nil,
						$author$project$UpdateResult$init(model));
				} else {
					var community = _v15.a.b9;
					var redirectRoute = function () {
						if (session.$ === 1) {
							return $author$project$Route$Dashboard;
						} else {
							var guest = session.a;
							return A2($elm$core$Maybe$withDefault, $author$project$Route$Dashboard, guest.lS);
						}
					}();
					var navKey = $author$project$Page$toShared(session).eM;
					var communityInfo = {m_: community.cl, ck: community.ck, cm: community.cm, hC: community.hC, ki: community.ki, pl: community.pl, e9: community.e9};
					return A2(
						$author$project$UpdateResult$addBreadcrumb,
						{fw: msg, i9: $elm$core$Dict$empty, nH: 3, nS: 'Signed in', d0: 3},
						A2(
							$author$project$UpdateResult$addCmd,
							A2($author$project$Route$pushUrl, navKey, redirectRoute),
							A2(
								$author$project$UpdateResult$addExt,
								$author$project$Session$LoggedIn$AddedCommunity(communityInfo),
								$author$project$UpdateResult$init(model))));
				}
		}
	});
var $author$project$Page$Community$New$ClosedAuthModal = {$: 7};
var $author$project$Page$Community$New$GotDomainAvailableResponse = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Page$Community$New$GotFormMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Eos$boolToEosBool = function (b) {
	return b ? 0 : 1;
};
var $author$project$Community$createCommunityData = function (params) {
	return {
		g1: {lU: 0, e9: params.e9},
		mq: params.lM,
		bc: params.bc,
		cj: $author$project$Eos$boolToEosBool(params.cj),
		ck: $author$project$Eos$boolToEosBool(params.ck),
		cl: $author$project$Eos$boolToEosBool(params.cl),
		cm: $author$project$Eos$boolToEosBool(params.cm),
		dl: {lU: params.dl, e9: params.e9},
		dm: {lU: params.dm, e9: params.e9},
		eJ: params.eJ,
		ki: params.ki,
		pl: params.pl,
		cQ: params.cQ
	};
};
var $author$project$Cambiatus$Query$domainAvailable = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'domainAvailable',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'domain', requiredArgs____.jf, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)
				]),
			object____,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
	});
var $author$project$Cambiatus$Object$Exists$exists = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe Bool)',
	'exists',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool));
var $author$project$Community$domainAvailableSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
	$elm$core$Maybe$withDefault(false),
	$author$project$Cambiatus$Object$Exists$exists);
var $author$project$Community$domainAvailableQuery = function (domain) {
	return A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$map($elm$core$Basics$not),
			$elm$core$Maybe$withDefault(false)),
		A2(
			$author$project$Cambiatus$Query$domainAvailable,
			{jf: domain},
			$author$project$Community$domainAvailableSelectionSet));
};
var $henriquecbuss$elm_mask$Mask$Precisely = function (a) {
	return {$: 0, a: a};
};
var $henriquecbuss$elm_mask$Mask$addThousandsSeparator = F2(
	function (separator, value) {
		return A2(
			$elm$core$String$join,
			separator,
			A2(
				$elm$core$List$filter,
				A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
				function (_v1) {
					var currentGroups = _v1.en;
					var currentGroup = _v1.em;
					return A2($elm$core$List$cons, currentGroup, currentGroups);
				}(
					A3(
						$elm$core$String$foldr,
						F2(
							function (currentChar, _v0) {
								var currentCount = _v0.fH;
								var currentGroups = _v0.en;
								var currentGroup = _v0.em;
								return (currentCount === 2) ? {
									fH: 0,
									em: '',
									en: A2(
										$elm$core$List$cons,
										A2($elm$core$String$cons, currentChar, currentGroup),
										currentGroups)
								} : {
									fH: currentCount + 1,
									em: A2($elm$core$String$cons, currentChar, currentGroup),
									en: currentGroups
								};
							}),
						{fH: 0, em: '', en: _List_Nil},
						value))));
	});
var $henriquecbuss$elm_mask$Mask$padFloat = F2(
	function (decimalDigits, maybeAfterSeparator) {
		var emptyStringToNothing = function (str) {
			return $elm$core$String$isEmpty(str) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(str);
		};
		if (!decimalDigits.$) {
			var n = decimalDigits.a;
			if (maybeAfterSeparator.$ === 1) {
				return emptyStringToNothing(
					A2($elm$core$String$repeat, n, '0'));
			} else {
				var afterSeparator = maybeAfterSeparator.a;
				return emptyStringToNothing(
					A2(
						$elm$core$String$left,
						n,
						_Utils_ap(
							afterSeparator,
							A2(
								$elm$core$String$repeat,
								n - $elm$core$String$length(afterSeparator),
								'0'))));
			}
		} else {
			var n = decimalDigits.a;
			return A2(
				$elm$core$Maybe$andThen,
				emptyStringToNothing,
				A2(
					$elm$core$Maybe$map,
					$elm$core$String$left(n),
					maybeAfterSeparator));
		}
	});
var $henriquecbuss$elm_mask$Mask$float = F3(
	function (decimalDigits, _v0, value) {
		var decimalSeparator = _v0.jb;
		var thousandsSeparator = _v0.px;
		var _v1 = A2(
			$elm$core$String$split,
			'.',
			$elm$core$String$fromFloat(value));
		if (!_v1.b) {
			return $elm$core$String$fromFloat(value);
		} else {
			if (!_v1.b.b) {
				var noSeparator = _v1.a;
				return A2(
					$elm$core$String$join,
					decimalSeparator,
					A2(
						$elm$core$List$filterMap,
						$elm$core$Basics$identity,
						_List_fromArray(
							[
								$elm$core$Maybe$Just(
								A2($henriquecbuss$elm_mask$Mask$addThousandsSeparator, thousandsSeparator, noSeparator)),
								A2($henriquecbuss$elm_mask$Mask$padFloat, decimalDigits, $elm$core$Maybe$Nothing)
							])));
			} else {
				var beforeSeparator = _v1.a;
				var _v2 = _v1.b;
				var afterSeparator = _v2.a;
				return A2(
					$elm$core$String$join,
					decimalSeparator,
					A2(
						$elm$core$List$filterMap,
						$elm$core$Basics$identity,
						_List_fromArray(
							[
								$elm$core$Maybe$Just(
								A2($henriquecbuss$elm_mask$Mask$addThousandsSeparator, thousandsSeparator, beforeSeparator)),
								A2(
								$henriquecbuss$elm_mask$Mask$padFloat,
								decimalDigits,
								$elm$core$Maybe$Just(afterSeparator))
							])));
			}
		}
	});
var $author$project$Utils$formatFloat = F3(
	function (maybeTranslators, decimalCases, number) {
		return A3(
			$henriquecbuss$elm_mask$Mask$float,
			$henriquecbuss$elm_mask$Mask$Precisely(decimalCases),
			function () {
				if (!maybeTranslators.$) {
					var t = maybeTranslators.a.il;
					return {
						jb: t('decimal_separator'),
						px: t('thousands_separator')
					};
				} else {
					return {jb: '.', px: ''};
				}
			}(),
			number);
	});
var $author$project$Eos$getSymbolPrecision = function (_v0) {
	var precision = _v0.b;
	return precision;
};
var $author$project$Eos$encodeAsset = function (asset) {
	return $elm$json$Json$Encode$string(
		A3(
			$author$project$Utils$formatFloat,
			$elm$core$Maybe$Nothing,
			$author$project$Eos$getSymbolPrecision(asset.e9),
			asset.lU) + (' ' + $author$project$Eos$symbolToSymbolCodeString(asset.e9)));
};
var $author$project$Eos$encodeEosBool = function (eosBool) {
	if (!eosBool) {
		return $elm$json$Json$Encode$int(1);
	} else {
		return $elm$json$Json$Encode$int(0);
	}
};
var $author$project$Community$encodeCreateCommunityData = function (c) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'cmm_asset',
				$author$project$Eos$encodeAsset(c.g1)),
				_Utils_Tuple2(
				'creator',
				$author$project$Eos$Account$encodeName(c.mq)),
				_Utils_Tuple2(
				'logo',
				$elm$json$Json$Encode$string(c.eJ)),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(c.ki)),
				_Utils_Tuple2(
				'description',
				$author$project$Markdown$encode(c.bc)),
				_Utils_Tuple2(
				'subdomain',
				$elm$json$Json$Encode$string(c.pl)),
				_Utils_Tuple2(
				'inviter_reward',
				$author$project$Eos$encodeAsset(c.dm)),
				_Utils_Tuple2(
				'invited_reward',
				$author$project$Eos$encodeAsset(c.dl)),
				_Utils_Tuple2(
				'has_objectives',
				$author$project$Eos$encodeEosBool(c.cl)),
				_Utils_Tuple2(
				'has_shop',
				$author$project$Eos$encodeEosBool(c.cm)),
				_Utils_Tuple2(
				'has_kyc',
				$author$project$Eos$encodeEosBool(c.ck)),
				_Utils_Tuple2(
				'auto_invite',
				$author$project$Eos$encodeEosBool(c.cj)),
				_Utils_Tuple2(
				'website',
				$elm$json$Json$Encode$string(c.cQ))
			]));
};
var $author$project$Token$tokenTypeToString = function (tokenType) {
	if (!tokenType) {
		return 'mcc';
	} else {
		return 'expiry';
	}
};
var $author$project$Token$encodeTokenType = A2($elm$core$Basics$composeR, $author$project$Token$tokenTypeToString, $elm$json$Json$Encode$string);
var $author$project$Token$encodeCreateTokenData = function (c) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'issuer',
				$author$project$Eos$Account$encodeName(c.mq)),
				_Utils_Tuple2(
				'max_supply',
				$author$project$Eos$encodeAsset(c.nQ)),
				_Utils_Tuple2(
				'min_balance',
				$author$project$Eos$encodeAsset(c.nT)),
				_Utils_Tuple2(
				'type',
				$author$project$Token$encodeTokenType(c.pD))
			]));
};
var $author$project$Eos$Account$encodePermissionName = function (_v0) {
	var permissionName = _v0;
	return $elm$json$Json$Encode$string(permissionName);
};
var $author$project$Eos$encodeAuthorization = function (authorization) {
	return A2(
		$elm$json$Json$Encode$list,
		function (a) {
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'actor',
						$author$project$Eos$Account$encodeName(a.iH)),
						_Utils_Tuple2(
						'permission',
						$author$project$Eos$Account$encodePermissionName(a.kz))
					]));
		},
		_List_fromArray(
			[authorization]));
};
var $author$project$Eos$encodeAction = function (action) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'account',
				$elm$json$Json$Encode$string(action.lM)),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(action.ki)),
				_Utils_Tuple2(
				'authorization',
				$author$project$Eos$encodeAuthorization(action.iP)),
				_Utils_Tuple2('data', action.i9)
			]));
};
var $author$project$Eos$encodeTransaction = function (transaction) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string('eosTransaction')),
				_Utils_Tuple2(
				'actions',
				A2($elm$json$Json$Encode$list, $author$project$Eos$encodeAction, transaction))
			]));
};
var $author$project$Eos$eosBoolToBool = function (eosBool) {
	if (!eosBool) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Log$JsonValue = 6;
var $author$project$Log$fromJsonValue = F6(
	function (transaction, maybeUser, message, location, contexts, value) {
		return {
			mm: A2(
				$elm$core$List$cons,
				{
					mR: $elm$core$Dict$fromList(
						_List_fromArray(
							[
								_Utils_Tuple2('Value', value)
							])),
					ki: 'JSON value'
				},
				contexts),
			nH: 3,
			nN: location,
			nS: message,
			pu: _List_fromArray(
				[
					$author$project$Log$TypeTag(6)
				]),
			pE: transaction,
			pM: maybeUser
		};
	});
var $author$project$UpdateResult$logJsonValue = F6(
	function (transaction, maybeUser, message, location, contexts, jsonValue) {
		return $author$project$UpdateResult$logEvent(
			A6($author$project$Log$fromJsonValue, transaction, maybeUser, message, location, contexts, jsonValue));
	});
var $author$project$Cambiatus$InputObject$encodeNewCommunityInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'symbol',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.e9)))
			]));
};
var $author$project$Cambiatus$Subscription$newcommunity = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'newcommunity',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.nl, $author$project$Cambiatus$InputObject$encodeNewCommunityInput)
				]),
			object____,
			$elm$core$Basics$identity);
	});
var $author$project$Community$newCommunitySubscription = function (symbol) {
	var stringSymbol = $elm$core$String$toUpper(
		$author$project$Eos$symbolToString(symbol));
	var selectionSet = $author$project$Cambiatus$Object$Community$name;
	var args = {
		nl: {e9: stringSymbol}
	};
	return A2($author$project$Cambiatus$Subscription$newcommunity, args, selectionSet);
};
var $author$project$Eos$Account$PermissionName = $elm$core$Basics$identity;
var $author$project$Eos$Account$samplePermission = 'active';
var $author$project$Session$LoggedIn$withPrivateKey = F5(
	function (model, requiredPermissions, subModel, subMsg, successfulUR) {
		return A4(
			$author$project$Auth$withPrivateKey,
			model.fp,
			{
				mv: A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.o5;
						},
						$elm$core$List$concatMap(
							function ($) {
								return $.oB;
							})),
					$author$project$Session$LoggedIn$profile(model)),
				o1: requiredPermissions
			},
			{
				hb: subModel,
				ob: A5(
					$author$project$UpdateResult$logImpossible,
					subMsg.ik,
					'Tried signing eos transaction, but profile wasn\'t loaded',
					$elm$core$Maybe$Just(model.lM),
					{mX: 'withPrivateKey', nW: 'Session.LoggedIn'},
					_List_Nil),
				oc: $author$project$UpdateResult$addExt(
					$author$project$Session$LoggedIn$RequiredPrivateKey(subMsg)),
				ok: $author$project$UpdateResult$addExt($author$project$Session$LoggedIn$ShowInsufficientPermissionsModal)
			},
			function (_v0) {
				return successfulUR;
			});
	});
var $author$project$Page$Community$New$update = F3(
	function (msg, model, loggedIn) {
		var t = loggedIn.aM.iw.il;
		switch (msg.$) {
			case 2:
				var formOutput = msg.a;
				return A2(
					$author$project$UpdateResult$addExt,
					A3(
						$author$project$Session$LoggedIn$query,
						loggedIn,
						$author$project$Community$domainAvailableQuery(formOutput.gL.ez),
						$author$project$Page$Community$New$GotDomainAvailableResponse(formOutput)),
					$author$project$UpdateResult$init(
						_Utils_update(
							model,
							{ns: true})));
			case 1:
				var index = msg.a;
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{
							hk: A2(
								$author$project$Form$updateValues,
								function (form) {
									return _Utils_update(
										form,
										{gw: index});
								},
								model.hk)
						}));
			case 3:
				switch (msg.b.$) {
					case 3:
						if (msg.b.a) {
							var formOutput = msg.a;
							var createTokenData = {
								mq: loggedIn.lM,
								nQ: {lU: 21000000.0, e9: formOutput.e9},
								nT: {lU: formOutput.dC, e9: formOutput.e9},
								pD: 0
							};
							var createCommunityData = $author$project$Community$createCommunityData(
								{
									lM: loggedIn.lM,
									bc: formOutput.bc,
									cj: !formOutput.dQ,
									ck: false,
									cl: true,
									cm: true,
									dl: formOutput.dl,
									dm: formOutput.dm,
									eJ: formOutput.hC,
									ki: formOutput.ki,
									pl: formOutput.gL.ez,
									e9: formOutput.e9,
									cQ: function () {
										var _v1 = formOutput.cQ;
										if (_v1.$ === 1) {
											return '';
										} else {
											var website = _v1.a;
											return (A2($elm$core$String$startsWith, 'https://', website) || A2($elm$core$String$startsWith, 'http://', website)) ? website : ('http://' + website);
										}
									}()
								});
							var subscriptionDoc = $dillonkearns$elm_graphql$Graphql$Document$serializeSubscription(
								$author$project$Community$newCommunitySubscription(createCommunityData.g1.e9));
							return A2(
								$author$project$UpdateResult$addBreadcrumb,
								{
									fw: msg,
									i9: $elm$core$Dict$fromList(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'domain',
												$elm$json$Json$Encode$string(formOutput.gL.ez))
											])),
									nH: 4,
									nS: 'Checked that domain is available',
									d0: 1
								},
								A5(
									$author$project$Session$LoggedIn$withPrivateKey,
									loggedIn,
									_List_Nil,
									model,
									{he: $author$project$Page$Community$New$ClosedAuthModal, ik: msg},
									A2(
										$author$project$UpdateResult$addPort,
										{
											i9: $elm$json$Json$Encode$object(
												_List_fromArray(
													[
														_Utils_Tuple2(
														'name',
														$elm$json$Json$Encode$string('subscribeToNewCommunity')),
														_Utils_Tuple2(
														'subscription',
														$elm$json$Json$Encode$string(subscriptionDoc))
													])),
											kY: A2(
												$author$project$Page$Community$New$GotDomainAvailableResponse,
												formOutput,
												$krisajenkins$remotedata$RemoteData$Success(true)),
											kZ: $elm$json$Json$Encode$object(
												_List_fromArray(
													[
														_Utils_Tuple2(
														'createCommunityData',
														$author$project$Community$encodeCreateCommunityData(createCommunityData)),
														_Utils_Tuple2(
														'createTokenData',
														$author$project$Token$encodeCreateTokenData(createTokenData))
													]))
										},
										$author$project$UpdateResult$init(
											_Utils_update(
												model,
												{ns: true})))));
						} else {
							var formOutput = msg.a;
							return A2(
								$author$project$UpdateResult$addBreadcrumb,
								{
									fw: msg,
									i9: $elm$core$Dict$fromList(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'domain',
												$elm$json$Json$Encode$string(formOutput.gL.ez))
											])),
									nH: 4,
									nS: 'Tried domain that is unavailable',
									d0: 1
								},
								A2(
									$author$project$UpdateResult$addExt,
									A2(
										$author$project$Session$LoggedIn$ShowFeedback,
										1,
										loggedIn.aM.iw.il('settings.community_info.errors.url.already_taken')),
									$author$project$UpdateResult$init(
										_Utils_update(
											model,
											{ns: false}))));
						}
					case 2:
						var formOutput = msg.a;
						var err = msg.b.a;
						return A2(
							$author$project$UpdateResult$addExt,
							A2(
								$author$project$Session$LoggedIn$ShowFeedback,
								1,
								loggedIn.aM.iw.il('error.unknown')),
							A7(
								$author$project$UpdateResult$logGraphqlError,
								msg,
								$elm$core$Maybe$Just(loggedIn.lM),
								'Got an error when checking if community domain is available',
								{mX: 'update', nW: 'Page.Community.New'},
								_List_fromArray(
									[
										{
										mR: $elm$core$Dict$fromList(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'tried',
													$elm$json$Json$Encode$string(formOutput.gL.ez))
												])),
										ki: 'Domain'
									}
									]),
								err,
								$author$project$UpdateResult$init(
									_Utils_update(
										model,
										{ns: false}))));
					case 0:
						var _v2 = msg.b;
						return $author$project$UpdateResult$init(model);
					default:
						var _v3 = msg.b;
						return $author$project$UpdateResult$init(model);
				}
			case 4:
				var createCommunityData = msg.a;
				var createTokenData = msg.b;
				var authorization = {iH: loggedIn.lM, kz: $author$project$Eos$Account$samplePermission};
				return A2(
					$author$project$UpdateResult$addPort,
					{
						i9: $author$project$Eos$encodeTransaction(
							_List_fromArray(
								[
									{
									lM: loggedIn.aM.mn.b9,
									iP: authorization,
									i9: $author$project$Community$encodeCreateCommunityData(createCommunityData),
									ki: 'create'
								},
									{
									lM: loggedIn.aM.mn.pC,
									iP: authorization,
									i9: $author$project$Token$encodeCreateTokenData(createTokenData),
									ki: 'create'
								}
								])),
						kY: A2($author$project$Page$Community$New$StartedCreatingCommunity, createCommunityData, createTokenData),
						kZ: $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'symbol',
									$author$project$Eos$encodeSymbol(createCommunityData.g1.e9)),
									_Utils_Tuple2(
									'subdomain',
									$elm$json$Json$Encode$string(createCommunityData.pl))
								]))
					},
					$author$project$UpdateResult$init(model));
			case 5:
				if (!msg.a.$) {
					return A2(
						$author$project$UpdateResult$addCmd,
						A2($author$project$Route$pushUrl, loggedIn.aM.eM, $author$project$Route$Dashboard),
						A2(
							$author$project$UpdateResult$addExt,
							A2(
								$author$project$Session$LoggedIn$ShowFeedback,
								0,
								loggedIn.aM.iw.il('community.create.created')),
							$author$project$UpdateResult$init(model)));
				} else {
					var val = msg.a.a;
					return A7(
						$author$project$UpdateResult$logJsonValue,
						msg,
						$elm$core$Maybe$Just(loggedIn.lM),
						'Got an error when creating a community',
						{mX: 'update', nW: 'Page.Community.New'},
						_List_Nil,
						val,
						A2(
							$author$project$UpdateResult$addExt,
							A2(
								$author$project$Session$LoggedIn$ShowFeedback,
								1,
								t('error.unknown')),
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{ns: false}))));
				}
			case 6:
				var communityData = msg.a;
				var communityInfo = {
					m_: $author$project$Eos$eosBoolToBool(communityData.cl),
					ck: $author$project$Eos$eosBoolToBool(communityData.ck),
					cm: $author$project$Eos$eosBoolToBool(communityData.cm),
					hC: communityData.eJ,
					ki: communityData.ki,
					pl: communityData.pl,
					e9: communityData.g1.e9
				};
				return A2(
					$author$project$UpdateResult$addExt,
					$author$project$Session$LoggedIn$AddedCommunity(communityInfo),
					$author$project$UpdateResult$init(model));
			case 7:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{ns: false}));
			default:
				var subMsg = msg.a;
				return A5(
					$author$project$UpdateResult$fromChild,
					function (newForm) {
						return _Utils_update(
							model,
							{hk: newForm});
					},
					$author$project$Page$Community$New$GotFormMsg,
					$author$project$Session$LoggedIn$addFeedback,
					model,
					A3($author$project$Form$update, loggedIn.aM, subMsg, model.hk));
		}
	});
var $author$project$Page$Community$Objectives$GotObjectiveDetailsHeight = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Page$Community$Objectives$GotObjectiveSummaryHeight = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Page$Community$Objectives$GotVisibleActionViewport = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Action$idToString = function (_v0) {
	var id = _v0;
	return $elm$core$String$fromInt(id);
};
var $author$project$Page$Community$Objectives$actionCardId = function (actionId) {
	return 'action-card-' + $author$project$Action$idToString(actionId);
};
var $elm_community$list_extra$List$Extra$find = F2(
	function (predicate, list) {
		find:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var first = list.a;
				var rest = list.b;
				if (predicate(first)) {
					return $elm$core$Maybe$Just(first);
				} else {
					var $temp$predicate = predicate,
						$temp$list = rest;
					predicate = $temp$predicate;
					list = $temp$list;
					continue find;
				}
			}
		}
	});
var $pzp1997$assoc_list$AssocList$foldl = F3(
	function (func, initialResult, _v0) {
		var alist = _v0;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v1, result) {
					var key = _v1.a;
					var value = _v1.b;
					return A3(func, key, value, result);
				}),
			initialResult,
			alist);
	});
var $elm$browser$Browser$Dom$getViewportOf = _Browser_getViewportOf;
var $author$project$Action$idFromString = A2(
	$elm$core$Basics$composeR,
	$elm$core$String$toInt,
	$elm$core$Maybe$map($elm$core$Basics$identity));
var $author$project$Page$Community$Objectives$idFromActionCardId = function (elementId) {
	return $author$project$Action$idFromString(
		A2($elm$core$String$dropLeft, 12, elementId));
};
var $author$project$Page$Community$Objectives$objectiveContainerId = function (objective) {
	return 'objective-container-' + $elm$core$String$fromInt(
		$author$project$Action$objectiveIdToInt(objective.R));
};
var $author$project$Page$Community$Objectives$objectiveDetailsId = function (objective) {
	return 'objective-details-' + $elm$core$String$fromInt(
		$author$project$Action$objectiveIdToInt(objective.R));
};
var $author$project$Page$Community$Objectives$objectiveSummaryId = function (objective) {
	return 'objective-summary-' + $elm$core$String$fromInt(
		$author$project$Action$objectiveIdToInt(objective.R));
};
var $pzp1997$assoc_list$AssocList$update = F3(
	function (targetKey, alter, dict) {
		var alist = dict;
		var maybeValue = A2($pzp1997$assoc_list$AssocList$get, targetKey, dict);
		if (!maybeValue.$) {
			var _v1 = alter(maybeValue);
			if (!_v1.$) {
				var alteredValue = _v1.a;
				return A2(
					$elm$core$List$map,
					function (entry) {
						var key = entry.a;
						return _Utils_eq(key, targetKey) ? _Utils_Tuple2(targetKey, alteredValue) : entry;
					},
					alist);
			} else {
				return A2($pzp1997$assoc_list$AssocList$remove, targetKey, dict);
			}
		} else {
			var _v2 = alter($elm$core$Maybe$Nothing);
			if (!_v2.$) {
				var alteredValue = _v2.a;
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(targetKey, alteredValue),
					alist);
			} else {
				return dict;
			}
		}
	});
var $author$project$Page$Community$Objectives$update = F3(
	function (msg, model, loggedIn) {
		switch (msg.$) {
			case 0:
				return $author$project$UpdateResult$init(model);
			case 1:
				var objectives = msg.a;
				var scrollActionIntoView = function () {
					var _v1 = model.cn;
					if (_v1.$ === 1) {
						return $elm$core$Basics$identity;
					} else {
						var objectiveId = _v1.a.cx;
						var actionId = _v1.a.cT;
						var maybeAction = A2(
							$elm$core$Maybe$andThen,
							function (foundObjective) {
								return A2(
									$elm_community$list_extra$List$Extra$find,
									function (action) {
										return _Utils_eq(
											$elm$core$Maybe$Just(action.R),
											actionId);
									},
									foundObjective.lP);
							},
							A2(
								$elm_community$list_extra$List$Extra$find,
								function (objective) {
									return _Utils_eq(objective.R, objectiveId);
								},
								objectives));
						var getHighlightedObjectiveSummaryHeight = function () {
							var _v3 = A2(
								$elm_community$list_extra$List$Extra$find,
								function (objective) {
									return _Utils_eq(objective.R, objectiveId);
								},
								objectives);
							if (!_v3.$) {
								var objective = _v3.a;
								return $author$project$UpdateResult$addCmd(
									A2(
										$elm$core$Task$attempt,
										$author$project$Page$Community$Objectives$GotObjectiveSummaryHeight(objective),
										$elm$browser$Browser$Dom$getElement(
											$author$project$Page$Community$Objectives$objectiveSummaryId(objective))));
							} else {
								return $elm$core$Basics$identity;
							}
						}();
						if (maybeAction.$ === 1) {
							var hasObjective = A2(
								$elm$core$List$any,
								function (objective) {
									return _Utils_eq(objective.R, objectiveId);
								},
								objectives);
							return hasObjective ? A2(
								$elm$core$Basics$composeR,
								$author$project$UpdateResult$addPort(
									{
										i9: $elm$json$Json$Encode$object(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'name',
													$elm$json$Json$Encode$string('scrollIntoView')),
													_Utils_Tuple2(
													'id',
													$elm$json$Json$Encode$string(
														$author$project$Page$Community$Objectives$objectiveDetailsId(
															{R: objectiveId})))
												])),
										kY: $author$project$Page$Community$Objectives$NoOp,
										kZ: $elm$json$Json$Encode$null
									}),
								getHighlightedObjectiveSummaryHeight) : $elm$core$Basics$identity;
						} else {
							var highlightedAction = maybeAction.a;
							return A2(
								$elm$core$Basics$composeR,
								$author$project$UpdateResult$addPort(
									{
										i9: $elm$json$Json$Encode$object(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'name',
													$elm$json$Json$Encode$string('scrollIntoView')),
													_Utils_Tuple2(
													'id',
													$elm$json$Json$Encode$string(
														$author$project$Page$Community$Objectives$actionCardId(highlightedAction.R)))
												])),
										kY: $author$project$Page$Community$Objectives$NoOp,
										kZ: $elm$json$Json$Encode$null
									}),
								getHighlightedObjectiveSummaryHeight);
						}
					}
				}();
				return scrollActionIntoView(
					$author$project$UpdateResult$init(model));
			case 2:
				var objective = msg.a;
				return A2(
					$author$project$UpdateResult$addCmd,
					A2(
						$elm$core$Task$attempt,
						$author$project$Page$Community$Objectives$GotObjectiveSummaryHeight(objective),
						$elm$browser$Browser$Dom$getElement(
							$author$project$Page$Community$Objectives$objectiveSummaryId(objective))),
					$author$project$UpdateResult$init(
						_Utils_update(
							model,
							{
								cn: $elm$core$Maybe$Nothing,
								E: A3(
									$pzp1997$assoc_list$AssocList$update,
									objective.R,
									function (currentValue) {
										if (currentValue.$ === 1) {
											return $elm$core$Maybe$Just(
												{aR: $elm$core$Maybe$Nothing, a_: false, a4: $elm$core$Maybe$Nothing, bl: $elm$core$Maybe$Nothing, bm: $elm$core$Maybe$Nothing, bt: $elm$core$Maybe$Nothing, bu: $elm$core$Maybe$Nothing});
										} else {
											var value = currentValue.a;
											return $elm$core$Maybe$Just(
												_Utils_update(
													value,
													{a_: true}));
										}
									},
									model.E)
							})));
			case 3:
				var objective = msg.a;
				return A2(
					$author$project$UpdateResult$addCmd,
					A2(
						$elm$core$Task$attempt,
						$author$project$Page$Community$Objectives$GotObjectiveDetailsHeight(objective),
						$elm$browser$Browser$Dom$getElement(
							$author$project$Page$Community$Objectives$objectiveDetailsId(objective))),
					$author$project$UpdateResult$init(model));
			case 4:
				var objective = msg.a;
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{
							E: A2($pzp1997$assoc_list$AssocList$remove, objective.R, model.E)
						}));
			case 5:
				if (!msg.b.$) {
					var objective = msg.a;
					var element = msg.b.a.jg;
					return $author$project$UpdateResult$init(
						_Utils_update(
							model,
							{
								E: A3(
									$pzp1997$assoc_list$AssocList$update,
									objective.R,
									$elm$core$Maybe$map(
										function (value) {
											return _Utils_update(
												value,
												{
													a4: $elm$core$Maybe$Just(element.fW)
												});
										}),
									model.E)
							}));
				} else {
					var id = msg.b.a;
					return A6(
						$author$project$UpdateResult$logImpossible,
						msg,
						'Couldn\'t get objective details height',
						$elm$core$Maybe$Just(loggedIn.lM),
						{mX: 'update', nW: 'Page.Community.Objectives'},
						_List_fromArray(
							[
								{
								mR: $elm$core$Dict$fromList(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'type',
											$elm$json$Json$Encode$string('Browser.Dom.NotFound')),
											_Utils_Tuple2(
											'id',
											$elm$json$Json$Encode$string(id))
										])),
								ki: 'Error'
							}
							]),
						$author$project$UpdateResult$init(model));
				}
			case 6:
				if (!msg.b.$) {
					var objective = msg.a;
					var element = msg.b.a.jg;
					return $author$project$UpdateResult$init(
						_Utils_update(
							model,
							{
								E: A3(
									$pzp1997$assoc_list$AssocList$update,
									objective.R,
									$elm$core$Maybe$map(
										function (value) {
											return _Utils_update(
												value,
												{
													aR: $elm$core$Maybe$Just(element.fW)
												});
										}),
									model.E)
							}));
				} else {
					var id = msg.b.a;
					return A6(
						$author$project$UpdateResult$logImpossible,
						msg,
						'Couldn\'t get objective summary height',
						$elm$core$Maybe$Just(loggedIn.lM),
						{mX: 'update', nW: 'Page.Community.Objectives'},
						_List_fromArray(
							[
								{
								mR: $elm$core$Dict$fromList(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'type',
											$elm$json$Json$Encode$string('Browser.Dom.NotFound')),
											_Utils_Tuple2(
											'id',
											$elm$json$Json$Encode$string(id))
										])),
								ki: 'Error'
							}
							]),
						$author$project$UpdateResult$init(model));
				}
			case 7:
				if (!msg.b.$) {
					var objectiveId = msg.a.cx;
					var actionId = msg.a.cT;
					var viewport = msg.b.a.pS;
					return $author$project$UpdateResult$init(
						_Utils_update(
							model,
							{
								E: A3(
									$pzp1997$assoc_list$AssocList$update,
									objectiveId,
									function (maybeValue) {
										if (maybeValue.$ === 1) {
											return $elm$core$Maybe$Just(
												{
													aR: $elm$core$Maybe$Nothing,
													a_: false,
													a4: $elm$core$Maybe$Nothing,
													bl: $elm$core$Maybe$Nothing,
													bm: $elm$core$Maybe$Nothing,
													bt: $elm$core$Maybe$Just(actionId),
													bu: $elm$core$Maybe$Just(viewport.fW)
												});
										} else {
											var value = maybeValue.a;
											return $elm$core$Maybe$Just(
												_Utils_update(
													value,
													{
														bu: $elm$core$Maybe$Just(viewport.fW)
													}));
										}
									},
									model.E)
							}));
				} else {
					return $author$project$UpdateResult$init(model);
				}
			case 8:
				var action = msg.a;
				return A2(
					$author$project$UpdateResult$addPort,
					{
						i9: $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'name',
									$elm$json$Json$Encode$string('smoothHorizontalScroll')),
									_Utils_Tuple2(
									'containerId',
									$elm$json$Json$Encode$string(
										$author$project$Page$Community$Objectives$objectiveContainerId(action.bi))),
									_Utils_Tuple2(
									'targetId',
									$elm$json$Json$Encode$string(
										$author$project$Page$Community$Objectives$actionCardId(action.R)))
								])),
						kY: $author$project$Page$Community$Objectives$NoOp,
						kZ: $elm$json$Json$Encode$null
					},
					$author$project$UpdateResult$init(model));
			case 9:
				var subMsg = msg.a;
				return A2(
					$author$project$UpdateResult$addExt,
					$author$project$Session$LoggedIn$ExternalActionMsg(subMsg),
					$author$project$UpdateResult$init(model));
			case 10:
				var actionCard = msg.a;
				var _v6 = A2(
					$author$project$Community$getField,
					loggedIn.o7,
					function ($) {
						return $.cy;
					});
				if (_v6.$ === 3) {
					var _v7 = _v6.a;
					var objectives = _v7.b;
					var maybeActionIdAndParentObjective = A2(
						$elm$core$Maybe$andThen,
						function (actionId) {
							return A2(
								$elm$core$Maybe$map,
								$elm$core$Tuple$pair(actionId),
								A2(
									$elm_community$list_extra$List$Extra$find,
									function (objective) {
										return A2(
											$elm$core$List$member,
											actionId,
											A2(
												$elm$core$List$map,
												function ($) {
													return $.R;
												},
												objective.lP));
									},
									objectives));
						},
						$author$project$Page$Community$Objectives$idFromActionCardId(actionCard));
					if (maybeActionIdAndParentObjective.$ === 1) {
						return $author$project$UpdateResult$init(model);
					} else {
						var _v9 = maybeActionIdAndParentObjective.a;
						var actionId = _v9.a;
						var parentObjective = _v9.b;
						return A2(
							$author$project$UpdateResult$addCmd,
							A2(
								$elm$core$Task$attempt,
								$author$project$Page$Community$Objectives$GotVisibleActionViewport(
									{cT: actionId, cx: parentObjective.R}),
								$elm$browser$Browser$Dom$getViewportOf(actionCard)),
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{
										E: A3(
											$pzp1997$assoc_list$AssocList$update,
											parentObjective.R,
											function (maybeValue) {
												if (maybeValue.$ === 1) {
													return $elm$core$Maybe$Just(
														{
															aR: $elm$core$Maybe$Nothing,
															a_: false,
															a4: $elm$core$Maybe$Nothing,
															bl: $elm$core$Maybe$Nothing,
															bm: $elm$core$Maybe$Nothing,
															bt: $elm$core$Maybe$Just(actionId),
															bu: $elm$core$Maybe$Nothing
														});
												} else {
													var value = maybeValue.a;
													return $elm$core$Maybe$Just(
														{
															aR: value.aR,
															a_: value.a_,
															a4: value.a4,
															bl: value.bt,
															bm: value.bu,
															bt: $elm$core$Maybe$Just(actionId),
															bu: $elm$core$Maybe$Nothing
														});
												}
											},
											model.E)
									})));
					}
				} else {
					return A6(
						$author$project$UpdateResult$logImpossible,
						msg,
						'Action started showing up, but objectives weren\'t loaded',
						$elm$core$Maybe$Just(loggedIn.lM),
						{mX: 'update', nW: 'Page.Community.Objectives'},
						_List_fromArray(
							[
								$author$project$Log$contextFromCommunity(loggedIn.o7)
							]),
						$author$project$UpdateResult$init(model));
				}
			default:
				var targetId = msg.a;
				var newShownObjectives = A3(
					$pzp1997$assoc_list$AssocList$foldl,
					F3(
						function (objectiveId, value, currDict) {
							return _Utils_eq(
								value.bt,
								$author$project$Page$Community$Objectives$idFromActionCardId(targetId)) ? A3(
								$pzp1997$assoc_list$AssocList$insert,
								objectiveId,
								{aR: value.aR, a_: value.a_, a4: value.a4, bl: $elm$core$Maybe$Nothing, bm: $elm$core$Maybe$Nothing, bt: value.bl, bu: value.bm},
								currDict) : (_Utils_eq(
								value.bl,
								$author$project$Page$Community$Objectives$idFromActionCardId(targetId)) ? A3(
								$pzp1997$assoc_list$AssocList$insert,
								objectiveId,
								_Utils_update(
									value,
									{bl: $elm$core$Maybe$Nothing, bm: $elm$core$Maybe$Nothing}),
								currDict) : A3($pzp1997$assoc_list$AssocList$insert, objectiveId, value, currDict));
						}),
					$pzp1997$assoc_list$AssocList$empty,
					model.E);
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{E: newShownObjectives}));
		}
	});
var $author$project$Page$Community$Transfer$BalanceNotFound = {$: 0};
var $author$project$Page$Community$Transfer$ClosedAuthModal = {$: 3};
var $author$project$Page$Community$Transfer$CompletedLoadToken = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Community$Transfer$CreatingSubscription = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Community$Transfer$GotFormMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$Community$Transfer$SendingTransfer = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Community$Transfer$SubmittedForm = function (a) {
	return {$: 5, a: a};
};
var $author$project$Page$Community$Transfer$WithHttpError = function (a) {
	return {$: 1, a: a};
};
var $author$project$Transfer$encodeEosActionWithMarkdown = function (data) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'from',
				$author$project$Eos$Account$encodeName(data.ew)),
				_Utils_Tuple2(
				'to',
				$author$project$Eos$Account$encodeName(data.fc)),
				_Utils_Tuple2(
				'quantity',
				$author$project$Eos$encodeAsset(data.pO)),
				_Utils_Tuple2(
				'memo',
				$author$project$Markdown$encode(data.ka))
			]));
};
var $author$project$Page$Community$Transfer$CompletedLoadBalance = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Community$Transfer$fetchBalance = F3(
	function (shared, accountName, community) {
		return A3(
			$author$project$Api$getBalances,
			shared,
			accountName,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Result$map(
					function (balances) {
						return A2(
							$elm_community$list_extra$List$Extra$find,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.lY;
								},
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.e9;
									},
									$elm$core$Basics$eq(community.e9))),
							balances);
					}),
				$author$project$Page$Community$Transfer$CompletedLoadBalance));
	});
var $author$project$Eos$EosError$decodeErrorDetails = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['error', 'details']),
	$elm$json$Json$Decode$list(
		A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string)));
var $author$project$Eos$EosError$extractFailure = function (json) {
	var eosErrorMessages = A2($elm$json$Json$Decode$decodeValue, $author$project$Eos$EosError$decodeErrorDetails, json);
	if ((!eosErrorMessages.$) && eosErrorMessages.a.b) {
		var _v1 = eosErrorMessages.a;
		var firstMessage = _v1.a;
		var _v2 = A2($elm$core$String$split, ': ', firstMessage);
		if ((_v2.b && _v2.b.b) && (!_v2.b.b.b)) {
			var _v3 = _v2.b;
			var msg = _v3.a;
			return msg;
		} else {
			return firstMessage;
		}
	} else {
		return 'error.unknown';
	}
};
var $author$project$Eos$EosError$parseErrorMessage = F4(
	function (_v0, translationPrefix, translationDefault, eosErrorString) {
		var t = _v0.il;
		return t(
			function () {
				if (!eosErrorString.$) {
					var err = eosErrorString.a;
					return _Utils_ap(
						translationPrefix,
						$author$project$Eos$EosError$extractFailure(err));
				} else {
					return translationDefault;
				}
			}());
	});
var $author$project$Eos$EosError$parseTransferError = F2(
	function (translators, eosErrorString) {
		return A4($author$project$Eos$EosError$parseErrorMessage, translators, 'error.contracts.transfer.', 'account.my_wallet.transfer.error', eosErrorString);
	});
var $author$project$Form$UserPicker$setSingle = F2(
	function (maybeProfile, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{
				W: A2(
					$elm$core$Maybe$map,
					function (profile) {
						return {
							kJ: profile,
							dZ: $author$project$Profile$Summary$init(false)
						};
					},
					maybeProfile)
			});
	});
var $author$project$Cambiatus$InputObject$encodeTransferSucceedInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'from',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.ew))),
				_Utils_Tuple2(
				'symbol',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.e9))),
				_Utils_Tuple2(
				'to',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.fc)))
			]));
};
var $author$project$Cambiatus$Subscription$transfersucceed = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'transfersucceed',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.nl, $author$project$Cambiatus$InputObject$encodeTransferSucceedInput)
				]),
			object____,
			$elm$core$Basics$identity);
	});
var $author$project$Transfer$transferSucceedSubscription = F2(
	function (symbol, _v0) {
		var from = _v0.ew;
		var to = _v0.fc;
		var args = {
			nl: {
				ew: $author$project$Eos$Account$nameToString(from),
				e9: $elm$core$String$toUpper(
					$author$project$Eos$symbolToString(symbol)),
				fc: $author$project$Eos$Account$nameToString(to)
			}
		};
		return A2($author$project$Cambiatus$Subscription$transfersucceed, args, $author$project$Transfer$transferItemSelectionSet);
	});
var $author$project$Page$Community$Transfer$update = F3(
	function (msg, model, loggedIn) {
		var shared = loggedIn.aM;
		var onlyLogImpossible = function (desc) {
			return A6(
				$author$project$UpdateResult$logImpossible,
				msg,
				desc,
				$elm$core$Maybe$Just(loggedIn.lM),
				{mX: 'update', nW: 'Page.Community.Transfer'},
				_List_Nil,
				$author$project$UpdateResult$init(model));
		};
		switch (msg.$) {
			case 0:
				var community = msg.a;
				var newModel = function () {
					var _v1 = model.nR;
					if (_v1.$ === 1) {
						return model;
					} else {
						var toAccount = _v1.a;
						return _Utils_update(
							model,
							{
								hk: A2(
									$author$project$Form$updateValues,
									function (values) {
										return _Utils_update(
											values,
											{
												W: A2(
													$author$project$Form$UserPicker$setSingle,
													A2(
														$elm_community$list_extra$List$Extra$find,
														A2(
															$elm$core$Basics$composeR,
															function ($) {
																return $.fl;
															},
															$elm$core$Basics$eq(toAccount)),
														community.hG),
													values.W)
											});
									},
									model.hk)
							});
					}
				}();
				return A2(
					$author$project$UpdateResult$addCmd,
					A3($author$project$Token$getToken, shared, community.e9, $author$project$Page$Community$Transfer$CompletedLoadToken),
					A2(
						$author$project$UpdateResult$addCmd,
						A3($author$project$Page$Community$Transfer$fetchBalance, shared, loggedIn.lM, community),
						$author$project$UpdateResult$init(newModel)));
			case 1:
				if (!msg.a.$) {
					if (!msg.a.a.$) {
						var balance = msg.a.a.a;
						return $author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									b5: $krisajenkins$remotedata$RemoteData$Success(balance)
								}));
					} else {
						var _v2 = msg.a.a;
						return A6(
							$author$project$UpdateResult$logImpossible,
							msg,
							'Couldn\'t find balance related to community on transfer page',
							$elm$core$Maybe$Just(loggedIn.lM),
							{mX: 'update', nW: 'Page.Community.Transfer'},
							_List_fromArray(
								[
									$author$project$Log$contextFromCommunity(loggedIn.o7)
								]),
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{
										b5: $krisajenkins$remotedata$RemoteData$Failure($author$project$Page$Community$Transfer$BalanceNotFound)
									})));
					}
				} else {
					var httpError = msg.a.a;
					return A7(
						$author$project$UpdateResult$logHttpError,
						msg,
						$elm$core$Maybe$Just(loggedIn.lM),
						'Got an error when loading balance on the transfer page',
						{mX: 'update', nW: 'Page.Community.Transfer'},
						_List_fromArray(
							[
								$author$project$Log$contextFromCommunity(loggedIn.o7)
							]),
						httpError,
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									b5: $krisajenkins$remotedata$RemoteData$Failure(
										$author$project$Page$Community$Transfer$WithHttpError(httpError))
								})));
				}
			case 2:
				if (!msg.a.$) {
					var token = msg.a.a;
					return A2(
						$author$project$UpdateResult$addBreadcrumb,
						{fw: msg, i9: $elm$core$Dict$empty, nH: 3, nS: 'Completed loading token on transfer page', d0: 3},
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									pC: $krisajenkins$remotedata$RemoteData$Success(token)
								})));
				} else {
					var httpError = msg.a.a;
					return A7(
						$author$project$UpdateResult$logHttpError,
						msg,
						$elm$core$Maybe$Just(loggedIn.lM),
						'Got an error when loading token on the transfer page',
						{mX: 'update', nW: 'Page.Community.Transfer'},
						_List_fromArray(
							[
								$author$project$Log$contextFromCommunity(loggedIn.o7)
							]),
						httpError,
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									pC: $krisajenkins$remotedata$RemoteData$Failure(httpError)
								})));
				}
			case 3:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{aN: $author$project$Page$Community$Transfer$EditingTransfer}));
			case 4:
				var subMsg = msg.a;
				return A5(
					$author$project$UpdateResult$fromChild,
					function (formModel) {
						return _Utils_update(
							model,
							{hk: formModel});
					},
					$author$project$Page$Community$Transfer$GotFormMsg,
					$author$project$Session$LoggedIn$addFeedback,
					model,
					A3($author$project$Form$update, shared, subMsg, model.hk));
			case 5:
				var formOutput = msg.a;
				if (!_Utils_eq(model.aN, $author$project$Page$Community$Transfer$EditingTransfer)) {
					return $author$project$UpdateResult$init(model);
				} else {
					var subscriptionDoc = $dillonkearns$elm_graphql$Graphql$Document$serializeSubscription(
						A2(
							$author$project$Transfer$transferSucceedSubscription,
							formOutput.lU.e9,
							{ew: loggedIn.lM, fc: formOutput.W.fl}));
					return A2(
						$author$project$UpdateResult$addPort,
						{
							i9: $elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'name',
										$elm$json$Json$Encode$string('subscribeToTransfer')),
										_Utils_Tuple2(
										'subscription',
										$elm$json$Json$Encode$string(subscriptionDoc))
									])),
							kY: $author$project$Page$Community$Transfer$SubmittedForm(formOutput),
							kZ: $elm$json$Json$Encode$null
						},
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									aN: $author$project$Page$Community$Transfer$CreatingSubscription(formOutput)
								})));
				}
			case 6:
				var _v3 = model.aN;
				if (_v3.$ === 1) {
					var formOutput = _v3.a;
					return A5(
						$author$project$Session$LoggedIn$withPrivateKey,
						loggedIn,
						_List_Nil,
						model,
						{he: $author$project$Page$Community$Transfer$ClosedAuthModal, ik: msg},
						A2(
							$author$project$UpdateResult$addPort,
							{
								i9: $author$project$Eos$encodeTransaction(
									_List_fromArray(
										[
											{
											lM: loggedIn.aM.mn.pC,
											iP: {iH: loggedIn.lM, kz: $author$project$Eos$Account$samplePermission},
											i9: $author$project$Transfer$encodeEosActionWithMarkdown(
												{ew: loggedIn.lM, ka: formOutput.ka, fc: formOutput.W.fl, pO: formOutput.lU}),
											ki: 'transfer'
										}
										])),
								kY: $author$project$Page$Community$Transfer$CreatedTransferSubscription,
								kZ: $elm$json$Json$Encode$null
							},
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{
										aN: $author$project$Page$Community$Transfer$SendingTransfer(formOutput)
									}))));
				} else {
					return $author$project$UpdateResult$init(model);
				}
			case 7:
				if (!msg.a.$) {
					return $author$project$UpdateResult$init(model);
				} else {
					var eosErrorString = msg.a.a;
					var _v4 = model.aN;
					if (_v4.$ === 2) {
						var errorMessage = A2($author$project$Eos$EosError$parseTransferError, loggedIn.aM.iw, eosErrorString);
						return A2(
							$author$project$UpdateResult$addExt,
							A2($author$project$Session$LoggedIn$ShowFeedback, 1, errorMessage),
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{aN: $author$project$Page$Community$Transfer$EditingTransfer})));
					} else {
						return onlyLogImpossible('Got transfer result with error, but wasn\'t sending transfer');
					}
				}
			default:
				var value = msg.a;
				var _v5 = model.aN;
				if (_v5.$ === 2) {
					var formOutput = _v5.a;
					var subscriptionDecoder = $dillonkearns$elm_graphql$Graphql$Document$decoder(
						A2(
							$author$project$Transfer$transferSucceedSubscription,
							formOutput.lU.e9,
							{ew: loggedIn.lM, fc: formOutput.W.fl}));
					var _v6 = A2($elm$json$Json$Decode$decodeValue, subscriptionDecoder, value);
					if (!_v6.$) {
						var res = _v6.a;
						return A2(
							$author$project$UpdateResult$addCmd,
							A2(
								$author$project$Route$replaceUrl,
								shared.eM,
								$author$project$Route$ViewTransfer(res.R)),
							$author$project$UpdateResult$init(model));
					} else {
						var err = _v6.a;
						return A7(
							$author$project$UpdateResult$logDecodingError,
							msg,
							$elm$core$Maybe$Just(loggedIn.lM),
							'Got an error when decoding transfer subscription',
							{mX: 'update', nW: 'Page.Community.Transfer'},
							_List_Nil,
							err,
							$author$project$UpdateResult$init(model));
					}
				} else {
					return $author$project$UpdateResult$init(model);
				}
		}
	});
var $author$project$Page$Dashboard$CompletedInviteCreation = function (a) {
	return {$: 16, a: a};
};
var $author$project$Page$Dashboard$CompletedLoadPlaceRelease = function (a) {
	return {$: 20, a: a};
};
var $author$project$Page$Dashboard$CompletedLoadPlaceStatus = function (a) {
	return {$: 23, a: a};
};
var $author$project$Page$Dashboard$CompletedLocatePlace = function (a) {
	return {$: 22, a: a};
};
var $author$project$Page$Dashboard$FailedGraphql = {$: 2};
var $author$project$Page$Dashboard$GotContactMsg = function (a) {
	return {$: 13, a: a};
};
var $author$project$Page$Dashboard$GotTransfersFiltersFormMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Page$Dashboard$InviteModalFailed = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Dashboard$InviteModalLoaded = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$Dashboard$InviteModalLoading = {$: 1};
var $author$project$Page$Dashboard$LoadedGraphql = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Page$Dashboard$NoOp = {$: 0};
var $author$project$Api$communityInvite = F4(
	function (shared, symbol, inviter, toMsg) {
		return $elm$http$Http$post(
			{
				fv: $elm$http$Http$jsonBody(
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'creator_id',
								$author$project$Eos$Account$encodeName(inviter)),
								_Utils_Tuple2(
								'community_id',
								$elm$json$Json$Encode$string(
									$author$project$Eos$symbolToString(symbol)))
							]))),
				fN: A2(
					$elm$http$Http$expectJson,
					toMsg,
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['data', 'id']),
						$elm$json$Json$Decode$string)),
				gL: A3(
					$author$project$Api$backendUrl,
					shared,
					_List_fromArray(
						['invite']),
					_List_Nil)
			});
	});
var $author$project$Cambiatus$Enum$Direction$Asc = 0;
var $author$project$Page$Dashboard$ClaimsLoaded = function (a) {
	return {$: 4, a: a};
};
var $author$project$Cambiatus$InputObject$buildClaimsFilter = function (fillOptionals____) {
	var optionals____ = fillOptionals____(
		{c$: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, F: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, gE: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
	return {c$: optionals____.c$, F: optionals____.F, gE: optionals____.gE};
};
var $author$project$Claim$Paginated = F3(
	function (edges, pageInfo, count) {
		return {mo: count, mF: edges, oz: pageInfo};
	});
var $author$project$Api$Relay$Edge = F2(
	function (cursor, node) {
		return {mw: cursor, n1: node};
	});
var $author$project$Cambiatus$Object$ClaimEdge$cursor = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'cursor',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Cambiatus$Object$ClaimEdge$node = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'node',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$Claim$claimEdgeSelectionSet = function (now) {
	return A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Cambiatus$Object$ClaimEdge$node(
			$author$project$Claim$selectionSet(now)),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Cambiatus$Object$ClaimEdge$cursor,
			$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Api$Relay$Edge)));
};
var $author$project$Cambiatus$Object$ClaimConnection$count = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe Int)',
	'count',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int));
var $author$project$Cambiatus$Object$ClaimConnection$edges = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'edges',
		_List_Nil,
		object____,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Basics$identity,
			A2(
				$elm$core$Basics$composeR,
				$elm$json$Json$Decode$nullable,
				A2($elm$core$Basics$composeR, $elm$json$Json$Decode$list, $elm$json$Json$Decode$nullable))));
};
var $author$project$Cambiatus$Object$ClaimConnection$pageInfo = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'pageInfo', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Api$Relay$PageInfo = F4(
	function (endCursor, hasNextPage, hasPreviousPage, startCursor) {
		return {mI: endCursor, m0: hasNextPage, m1: hasPreviousPage, pi: startCursor};
	});
var $author$project$Cambiatus$Object$PageInfo$endCursor = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'endCursor',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Cambiatus$Object$PageInfo$hasNextPage = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'hasNextPage', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Cambiatus$Object$PageInfo$hasPreviousPage = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'hasPreviousPage', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Cambiatus$Object$PageInfo$startCursor = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'startCursor',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Api$Relay$pageInfoSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$PageInfo$startCursor,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Cambiatus$Object$PageInfo$hasPreviousPage,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Cambiatus$Object$PageInfo$hasNextPage,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Cambiatus$Object$PageInfo$endCursor,
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Api$Relay$PageInfo)))));
var $author$project$Claim$claimPaginatedSelectionSet = function (now) {
	return A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Cambiatus$Object$ClaimConnection$count,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Cambiatus$Object$ClaimConnection$pageInfo($author$project$Api$Relay$pageInfoSelectionSet),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Cambiatus$Object$ClaimConnection$edges(
					$author$project$Claim$claimEdgeSelectionSet(now)),
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Claim$Paginated))));
};
var $author$project$Cambiatus$InputObject$encodeClaimsFilter = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'claimer',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c$, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'direction',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.F,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Cambiatus$Enum$Direction$toString))),
				_Utils_Tuple2(
				'status',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gE, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string))
			]));
};
var $author$project$Cambiatus$Query$pendingClaims = F2(
	function (fillInOptionals____, object____) {
		var filledInOptionals____ = fillInOptionals____(
			{gQ: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, gW: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, hh: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, hj: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, hz: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
		var optionalArgs____ = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'after', filledInOptionals____.gQ, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'before', filledInOptionals____.gW, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'filter', filledInOptionals____.hh, $author$project$Cambiatus$InputObject$encodeClaimsFilter),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'first', filledInOptionals____.hj, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'last', filledInOptionals____.hz, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int)
				]));
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'pendingClaims',
			optionalArgs____,
			object____,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
	});
var $author$project$Page$Dashboard$fetchAvailableAnalysis = F2(
	function (loggedIn, maybeCursor) {
		var optionalArguments = function (a) {
			return _Utils_update(
				a,
				{
					gQ: function () {
						if (maybeCursor.$ === 1) {
							return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent;
						} else {
							if (maybeCursor.a === '') {
								return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent;
							} else {
								var cursor = maybeCursor.a;
								return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(cursor);
							}
						}
					}(),
					hh: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
						$author$project$Cambiatus$InputObject$buildClaimsFilter(
							function (claimsFilter) {
								return _Utils_update(
									claimsFilter,
									{
										F: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(0)
									});
							})),
					hj: function () {
						if (!maybeCursor.$) {
							return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(1);
						} else {
							return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(5);
						}
					}()
				});
		};
		return A3(
			$author$project$Session$LoggedIn$query,
			loggedIn,
			A2(
				$author$project$Cambiatus$Query$pendingClaims,
				optionalArguments,
				$author$project$Claim$claimPaginatedSelectionSet(loggedIn.aM.gh)),
			$author$project$Page$Dashboard$ClaimsLoaded);
	});
var $author$project$Page$Dashboard$CompletedLoadBalance = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Dashboard$fetchBalance = F3(
	function (shared, accountName, community) {
		return A3(
			$author$project$Api$getBalances,
			shared,
			accountName,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Result$map(
					function (balances) {
						var maybeBalance = A2(
							$elm_community$list_extra$List$Extra$find,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.lY;
								},
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.e9;
									},
									$elm$core$Basics$eq(community.e9))),
							balances);
						if (!maybeBalance.$) {
							var b = maybeBalance.a;
							return $elm$core$Maybe$Just(b);
						} else {
							return $elm$core$List$head(balances);
						}
					}),
				$author$project$Page$Dashboard$CompletedLoadBalance));
	});
var $author$project$Page$Dashboard$CompletedLoadUserTransfers = function (a) {
	return {$: 3, a: a};
};
var $justinmimbs$date$Date$toIsoString = $justinmimbs$date$Date$format('yyyy-MM-dd');
var $author$project$Transfer$QueryTransfers = function (transfers) {
	return {an: transfers};
};
var $author$project$Api$Relay$PageConnection = F2(
	function (edges, pageInfo) {
		return {mF: edges, oz: pageInfo};
	});
var $author$project$Cambiatus$Object$TransferConnection$edges = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'edges',
		_List_Nil,
		object____,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Basics$identity,
			A2(
				$elm$core$Basics$composeR,
				$elm$json$Json$Decode$nullable,
				A2($elm$core$Basics$composeR, $elm$json$Json$Decode$list, $elm$json$Json$Decode$nullable))));
};
var $author$project$Cambiatus$Object$TransferConnection$pageInfo = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'pageInfo', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Cambiatus$Object$TransferEdge$cursor = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'cursor',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Cambiatus$Object$TransferEdge$node = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'node',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$Transfer$transferEdgeSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$TransferEdge$node($author$project$Transfer$transferItemSelectionSet),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Cambiatus$Object$TransferEdge$cursor,
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Api$Relay$Edge)));
var $author$project$Transfer$transferConnectionSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$TransferConnection$pageInfo($author$project$Api$Relay$pageInfoSelectionSet),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Cambiatus$Object$TransferConnection$edges($author$project$Transfer$transferEdgeSelectionSet),
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Api$Relay$PageConnection)));
var $author$project$Cambiatus$Enum$TransferDirectionValue$toString = function (enum____) {
	if (!enum____) {
		return 'RECEIVING';
	} else {
		return 'SENDING';
	}
};
var $author$project$Cambiatus$InputObject$encodeTransferDirection = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'direction',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.F,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Cambiatus$Enum$TransferDirectionValue$toString))),
				_Utils_Tuple2(
				'otherAccount',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.dJ, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string))
			]));
};
var $author$project$Cambiatus$InputObject$encodeTransferFilter = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'communityId',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c1, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'date',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.c7,
					A2(
						$author$project$Cambiatus$Scalar$unwrapEncoder,
						function ($) {
							return $.l9;
						},
						$author$project$Cambiatus$ScalarCodecs$codecs))),
				_Utils_Tuple2(
				'direction',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.F, $author$project$Cambiatus$InputObject$encodeTransferDirection))
			]));
};
var $author$project$Cambiatus$Object$User$transfers = F2(
	function (fillInOptionals____, object____) {
		var filledInOptionals____ = fillInOptionals____(
			{gQ: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, gW: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, hh: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, hj: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, hz: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
		var optionalArgs____ = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'after', filledInOptionals____.gQ, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'before', filledInOptionals____.gW, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'filter', filledInOptionals____.hh, $author$project$Cambiatus$InputObject$encodeTransferFilter),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'first', filledInOptionals____.hj, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'last', filledInOptionals____.hz, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int)
				]));
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'transfers',
			optionalArgs____,
			object____,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
	});
var $author$project$Transfer$profileTransfersSelectionSet = function (paginateArgs) {
	var transfers = A2($author$project$Cambiatus$Object$User$transfers, paginateArgs, $author$project$Transfer$transferConnectionSelectionSet);
	return A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		transfers,
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Transfer$QueryTransfers));
};
var $author$project$Transfer$transfersUserQuery = F2(
	function (name, paginateArgs) {
		return A2(
			$author$project$Cambiatus$Query$user,
			{
				fl: $author$project$Eos$Account$nameToString(name)
			},
			$author$project$Transfer$profileTransfersSelectionSet(paginateArgs));
	});
var $author$project$Page$Dashboard$fetchTransfers = F4(
	function (loggedIn, community, maybeCursor, model) {
		return A3(
			$author$project$Session$LoggedIn$query,
			loggedIn,
			A2(
				$author$project$Transfer$transfersUserQuery,
				loggedIn.lM,
				function (args) {
					return _Utils_update(
						args,
						{
							gQ: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(maybeCursor),
							hh: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
								{
									c1: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
										$author$project$Eos$symbolToString(community.e9)),
									c7: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(
										A2(
											$elm$core$Maybe$map,
											A2($elm$core$Basics$composeR, $justinmimbs$date$Date$toIsoString, $elm$core$Basics$identity),
											model.bZ.c7)),
									F: function () {
										var _v0 = _Utils_Tuple2(model.bZ.F, model.bZ.dJ);
										if ((_v0.a.$ === 1) && (_v0.b.$ === 1)) {
											var _v1 = _v0.a;
											var _v2 = _v0.b;
											return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent;
										} else {
											return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
												{
													F: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(model.bZ.F),
													dJ: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(
														A2(
															$elm$core$Maybe$map,
															A2(
																$elm$core$Basics$composeR,
																function ($) {
																	return $.fl;
																},
																$author$project$Eos$Account$nameToString),
															model.bZ.dJ))
												});
										}
									}()
								}),
							hj: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(10)
						});
				}),
			$author$project$Page$Dashboard$CompletedLoadUserTransfers);
	});
var $author$project$Transfer$getTransfers = function (maybeObj) {
	var toNodes = function (maybeNodes) {
		return A2($elm$core$List$filterMap, $elm$core$Basics$identity, maybeNodes);
	};
	var toMaybeNodes = function (edges) {
		return A2(
			$elm$core$List$map,
			function (a) {
				return A2(
					$elm$core$Maybe$andThen,
					function (b) {
						return b.n1;
					},
					a);
			},
			edges);
	};
	var toMaybeEdges = function (maybeConn) {
		return A2(
			$elm$core$Maybe$andThen,
			function (a) {
				return a.mF;
			},
			maybeConn);
	};
	var toMaybeConn = function (maybeObj_) {
		return A2(
			$elm$core$Maybe$andThen,
			function (a) {
				return a.an;
			},
			maybeObj_);
	};
	var toEdges = function (maybeEdges) {
		return A2($elm$core$Maybe$withDefault, _List_Nil, maybeEdges);
	};
	return toNodes(
		toMaybeNodes(
			toEdges(
				toMaybeEdges(
					toMaybeConn(maybeObj)))));
};
var $author$project$Session$LoggedIn$hasPermissions = F2(
	function (profile_, requiredPermissions) {
		var allPermissions = A2(
			$elm$core$List$concatMap,
			function ($) {
				return $.oB;
			},
			profile_.o5);
		return A2(
			$elm$core$List$all,
			function (permission) {
				return A2($elm$core$List$member, permission, allPermissions);
			},
			requiredPermissions);
	});
var $elm$json$Json$Encode$float = _Json_wrap;
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$float = function (value) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$Json(
		$elm$json$Json$Encode$float(value));
};
var $author$project$Cambiatus$Mutation$locatePlace = F2(
	function (fillInOptionals____, object____) {
		var filledInOptionals____ = fillInOptionals____(
			{hA: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, hD: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
		var optionalArgs____ = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'latitude', filledInOptionals____.hA, $dillonkearns$elm_graphql$Graphql$Internal$Encode$float),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'longitude', filledInOptionals____.hD, $dillonkearns$elm_graphql$Graphql$Internal$Encode$float)
				]));
		return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'locatePlace', optionalArgs____, object____, $elm$core$Basics$identity);
	});
var $author$project$PlaceLocation$Status = F3(
	function (label, source, hasDefaultAddress) {
		return {jz: hasDefaultAddress, nC: label, ph: source};
	});
var $author$project$Cambiatus$Object$PlaceStatus$hasDefaultAddress = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'hasDefaultAddress', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Cambiatus$Object$PlaceStatus$label = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'label',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Cambiatus$Enum$PlaceSource$Address = 0;
var $author$project$Cambiatus$Enum$PlaceSource$Chosen = 1;
var $author$project$Cambiatus$Enum$PlaceSource$Located = 2;
var $author$project$Cambiatus$Enum$PlaceSource$None = 3;
var $author$project$Cambiatus$Enum$PlaceSource$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'ADDRESS':
				return $elm$json$Json$Decode$succeed(0);
			case 'CHOSEN':
				return $elm$json$Json$Decode$succeed(1);
			case 'LOCATED':
				return $elm$json$Json$Decode$succeed(2);
			case 'NONE':
				return $elm$json$Json$Decode$succeed(3);
			default:
				return $elm$json$Json$Decode$fail('Invalid PlaceSource type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$PlaceStatus$source = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.PlaceSource.PlaceSource', 'source', _List_Nil, $author$project$Cambiatus$Enum$PlaceSource$decoder);
var $author$project$PlaceLocation$selectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$PlaceStatus$hasDefaultAddress,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Cambiatus$Object$PlaceStatus$source,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Cambiatus$Object$PlaceStatus$label,
			$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$PlaceLocation$Status))));
var $author$project$PlaceLocation$locate = function (position) {
	return A2(
		$author$project$Cambiatus$Mutation$locatePlace,
		function (optionals) {
			if (!position.$) {
				var latitude = position.a.hA;
				var longitude = position.a.hD;
				return _Utils_update(
					optionals,
					{
						hA: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(latitude),
						hD: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(longitude)
					});
			} else {
				return optionals;
			}
		},
		$author$project$PlaceLocation$selectionSet);
};
var $author$project$Claim$paginatedPageInfo = function (maybePaginated) {
	return A2(
		$elm$core$Maybe$map,
		function (a) {
			return a.oz;
		},
		maybePaginated);
};
var $author$project$Claim$paginatedToList = function (maybeObj) {
	var toNodes = function (maybeNodes) {
		return A2($elm$core$List$filterMap, $elm$core$Basics$identity, maybeNodes);
	};
	var toMaybeNodes = function (edges) {
		return A2(
			$elm$core$List$map,
			function (a) {
				return A2(
					$elm$core$Maybe$andThen,
					function (b) {
						return b.n1;
					},
					a);
			},
			edges);
	};
	var toMaybeEdges = function (maybeConn) {
		return A2(
			$elm$core$Maybe$andThen,
			function (a) {
				return a.mF;
			},
			maybeConn);
	};
	var toEdges = function (maybeEdges) {
		return A2($elm$core$Maybe$withDefault, _List_Nil, maybeEdges);
	};
	return toNodes(
		toMaybeNodes(
			toEdges(
				toMaybeEdges(maybeObj))));
};
var $author$project$PlaceLocation$Located = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$PlaceLocation$Skipped = function (a) {
	return {$: 2, a: a};
};
var $author$project$PlaceLocation$Unavailable = function (a) {
	return {$: 1, a: a};
};
var $author$project$PlaceLocation$replyDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (_v0) {
		var kind = _v0.a;
		var dismissed = _v0.b;
		var flags = {oa: dismissed};
		switch (kind) {
			case 'located':
				return A3(
					$elm$json$Json$Decode$map2,
					F2(
						function (latitude, longitude) {
							return A2(
								$author$project$PlaceLocation$Located,
								{hA: latitude, hD: longitude},
								flags);
						}),
					A2($elm$json$Json$Decode$field, 'lat', $elm$json$Json$Decode$float),
					A2($elm$json$Json$Decode$field, 'lng', $elm$json$Json$Decode$float));
			case 'unavailable':
				return $elm$json$Json$Decode$succeed(
					$author$project$PlaceLocation$Unavailable(flags));
			default:
				return $elm$json$Json$Decode$succeed(
					$author$project$PlaceLocation$Skipped(flags));
		}
	},
	A3(
		$elm$json$Json$Decode$map2,
		F2(
			function (kind, dismissed) {
				return _Utils_Tuple2(kind, dismissed);
			}),
		A2($elm$json$Json$Decode$field, 'kind', $elm$json$Json$Decode$string),
		$elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2($elm$json$Json$Decode$field, 'noteDismissed', $elm$json$Json$Decode$bool),
					$elm$json$Json$Decode$succeed(false)
				]))));
var $author$project$Page$Dashboard$shouldShowContactModal = F2(
	function (loggedIn, model) {
		var _v0 = loggedIn.kJ;
		if (_v0.$ === 3) {
			var profile = _v0.a;
			var addContactLimitDate = 1643374799000;
			var showContactModalFromDate = (addContactLimitDate - $elm$time$Time$posixToMillis(loggedIn.aM.gh)) > 0;
			return showContactModalFromDate && $elm$core$List$isEmpty(profile.aq);
		} else {
			return false;
		}
	});
var $author$project$Cambiatus$Query$placeStatus = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'placeStatus',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$PlaceLocation$status = $author$project$Cambiatus$Query$placeStatus($author$project$PlaceLocation$selectionSet);
var $author$project$Profile$Contact$CompletedDeleteContact = function (a) {
	return {$: 10, a: a};
};
var $author$project$Profile$Contact$CompletedUpdateContact = function (a) {
	return {$: 9, a: a};
};
var $author$project$Profile$Contact$GotContacts = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $author$project$Profile$Contact$GotContactsError = function (a) {
	return {$: 1, a: a};
};
var $author$project$Profile$Contact$GotMutationRequest = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Profile$Contact$Multiple = function (a) {
	return {$: 1, a: a};
};
var $author$project$Profile$Contact$NoOp = {$: 0};
var $robinheghan$elm_phone_numbers$PhoneNumber$PersonalNumber = 5;
var $robinheghan$elm_phone_numbers$PhoneNumber$Voip = 6;
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCA = {
	el: '1',
	jt: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:[2-8]\\d|90)\\d{8}')),
	R: 'CA',
	jR: $elm$core$Maybe$Just('011'),
	nZ: $elm$core$Maybe$Just('1'),
	kp: _List_fromArray(
		[
			{
			mN: '5062345678',
			hT: 0,
			ky: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:2(?:04|[23]6|[48]9|50)|3(?:06|43|6[57])|4(?:03|1[68]|3[178]|50)|5(?:06|1[49]|48|79|8[17])|6(?:04|13|39|47|72)|7(?:0[59]|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}'))
		},
			{
			mN: '5062345678',
			hT: 1,
			ky: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:2(?:04|[23]6|[48]9|50)|3(?:06|43|6[57])|4(?:03|1[68]|3[178]|50)|5(?:06|1[49]|48|79|8[17])|6(?:04|13|39|47|72)|7(?:0[59]|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}'))
		},
			{
			mN: '8002123456',
			hT: 2,
			ky: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('8(?:00|33|44|55|66|77|88)[2-9]\\d{6}'))
		},
			{
			mN: '9002123456',
			hT: 3,
			ky: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('900[2-9]\\d{6}'))
		},
			{
			mN: '5002345678',
			hT: 5,
			ky: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|(?:5(?:00|2[12]|33|44|66|77|88)|622)[2-9]\\d{6}'))
		},
			{
			mN: '6002012345',
			hT: 6,
			ky: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('600[2-9]\\d{6}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCR = {
	el: '506',
	jt: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}')),
	R: 'CR',
	jR: $elm$core$Maybe$Just('00'),
	nZ: $elm$core$Maybe$Nothing,
	kp: _List_fromArray(
		[
			{
			mN: '22123456',
			hT: 0,
			ky: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('210[7-9]\\d{4}|2(?:[024-7]\\d|1[1-9])\\d{5}'))
		},
			{
			mN: '83123456',
			hT: 1,
			ky: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:3005\\d|6500[01])\\d{3}|(?:5[07]|6[0-4]|7[0-3]|8[3-9])\\d{6}'))
		},
			{
			mN: '8001234567',
			hT: 2,
			ky: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('800\\d{7}'))
		},
			{
			mN: '9001234567',
			hT: 3,
			ky: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('90[059]\\d{7}'))
		},
			{
			mN: '40001234',
			hT: 6,
			ky: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:210[0-6]|4\\d{3}|5100)\\d{4}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryET = {
	el: '251',
	jt: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:11|[2-59]\\d)\\d{7}')),
	R: 'ET',
	jR: $elm$core$Maybe$Just('00'),
	nZ: $elm$core$Maybe$Just('0'),
	kp: _List_fromArray(
		[
			{
			mN: '111112345',
			hT: 0,
			ky: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('11667[01]\\d{3}|(?:11(?:1(?:1[124]|2[2-7]|3[1-5]|5[5-8]|8[6-8])|2(?:13|3[6-8]|5[89]|7[05-9]|8[2-6])|3(?:2[01]|3[0-289]|4[1289]|7[1-4]|87)|4(?:1[69]|3[2-49]|4[0-3]|6[5-8])|5(?:1[578]|44|5[0-4])|6(?:1[78]|2[69]|39|4[5-7]|5[1-5]|6[0-59]|8[015-8]))|2(?:2(?:11[1-9]|22[0-7]|33\\d|44[1467]|66[1-68])|5(?:11[124-6]|33[2-8]|44[1467]|55[14]|66[1-3679]|77[124-79]|880))|3(?:3(?:11[0-46-8]|(?:22|55)[0-6]|33[0134689]|44[04]|66[01467])|4(?:44[0-8]|55[0-69]|66[0-3]|77[1-5]))|4(?:6(?:119|22[0-24-7]|33[1-5]|44[13-69]|55[14-689]|660|88[1-4])|7(?:(?:11|22)[1-9]|33[13-7]|44[13-6]|55[1-689]))|5(?:7(?:227|55[05]|(?:66|77)[14-8])|8(?:11[149]|22[013-79]|33[0-68]|44[013-8]|550|66[1-5]|77\\d)))\\d{4}'))
		},
			{
			mN: '911234567',
			hT: 1,
			ky: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('9\\d{8}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Pager = 7;
var $robinheghan$elm_phone_numbers$PhoneNumber$Uan = 8;
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGB = {
	el: '44',
	jt: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}')),
	R: 'GB',
	jR: $elm$core$Maybe$Just('00'),
	nZ: $elm$core$Maybe$Just('0'),
	kp: _List_fromArray(
		[
			{
			mN: '1212345678',
			hT: 0,
			ky: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:1(?:1(?:3(?:[0-58]\\d\\d|73[03])|(?:4[0-5]|5[0-26-9]|6[0-4]|[78][0-49])\\d\\d)|2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d\\d|1(?:[0-7]\\d\\d|8(?:0\\d|20)))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}'))
		},
			{
			mN: '7400123456',
			hT: 1,
			ky: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}'))
		},
			{
			mN: '7640123456',
			hT: 7,
			ky: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|81|9[139])\\d{6}'))
		},
			{
			mN: '8001234567',
			hT: 2,
			ky: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('80[08]\\d{7}|800\\d{6}|8001111'))
		},
			{
			mN: '9012345678',
			hT: 3,
			ky: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d'))
		},
			{
			mN: '7012345678',
			hT: 5,
			ky: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('70\\d{8}'))
		},
			{
			mN: '5612345678',
			hT: 6,
			ky: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('56\\d{8}'))
		},
			{
			mN: '5512345678',
			hT: 8,
			ky: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:3[0347]|55)\\d{8}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryNZ = {
	el: '64',
	jt: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[29]\\d{7,9}|50\\d{5}(?:\\d{2,3})?|6[0-35-9]\\d{6}|7\\d{7,8}|8\\d{4,9}|(?:11\\d|[34])\\d{7}')),
	R: 'NZ',
	jR: $elm$core$Maybe$Just('0(?:0|161)'),
	nZ: $elm$core$Maybe$Just('0'),
	kp: _List_fromArray(
		[
			{
			mN: '32345678',
			hT: 0,
			ky: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('24099\\d{3}|(?:3[2-79]|[49][2-9]|6[235-9]|7[2-57-9])\\d{6}'))
		},
			{
			mN: '211234567',
			hT: 1,
			ky: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('2[0-27-9]\\d{7,8}|21\\d{6}'))
		},
			{
			mN: '26123456',
			hT: 7,
			ky: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('[28]6\\d{6,7}'))
		},
			{
			mN: '800123456',
			hT: 2,
			ky: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('508\\d{6,7}|80\\d{6,8}'))
		},
			{
			mN: '900123456',
			hT: 3,
			ky: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:11\\d{5}|50(?:0[08]|30|66|77))\\d{3}|90\\d{6,8}'))
		},
			{
			mN: '701234567',
			hT: 5,
			ky: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('70\\d{7}'))
		},
			{
			mN: '83012378',
			hT: 8,
			ky: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('83\\d{3,8}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Voicemail = 10;
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryPT = {
	el: '351',
	jt: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(?:[26-9]\\d|30)\\d{7}')),
	R: 'PT',
	jR: $elm$core$Maybe$Just('00'),
	nZ: $elm$core$Maybe$Nothing,
	kp: _List_fromArray(
		[
			{
			mN: '212345678',
			hT: 0,
			ky: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('2(?:[12]\\d|[35][1-689]|4[1-59]|6[1-35689]|7[1-9]|8[1-69]|9[1256])\\d{6}'))
		},
			{
			mN: '912345678',
			hT: 1,
			ky: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('6[356]9230\\d{3}|(?:6[036]93|9(?:[1-36]\\d\\d|480))\\d{5}'))
		},
			{
			mN: '800123456',
			hT: 2,
			ky: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('80[02]\\d{6}'))
		},
			{
			mN: '760123456',
			hT: 3,
			ky: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:6(?:0[178]|4[68])\\d|76(?:0[1-57]|1[2-47]|2[237]))\\d{5}'))
		},
			{
			mN: '808123456',
			hT: 4,
			ky: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('80(?:8\\d|9[1579])\\d{5}'))
		},
			{
			mN: '884123456',
			hT: 5,
			ky: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('884[0-4689]\\d{5}'))
		},
			{
			mN: '301234567',
			hT: 6,
			ky: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('30\\d{7}'))
		},
			{
			mN: '707123456',
			hT: 8,
			ky: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('70(?:7\\d|8[17])\\d{5}'))
		},
			{
			mN: '600110000',
			hT: 10,
			ky: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('600\\d{6}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryUS = {
	el: '1',
	jt: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[2-9]\\d{9}')),
	R: 'US',
	jR: $elm$core$Maybe$Just('011'),
	nZ: $elm$core$Maybe$Just('1'),
	kp: _List_fromArray(
		[
			{
			mN: '2015550123',
			hT: 0,
			ky: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[01356]|3[0-24679]|4[167]|5[12]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[0235]|58|6[39]|7[0589]|8[04])|5(?:0[1-57-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-47]|7[013-5]|8[056])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[0179]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[02-59]|8[156])|8(?:0[1-68]|1[02-8]|2[08]|3[0-289]|4[3578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[0179]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}'))
		},
			{
			mN: '2015550123',
			hT: 1,
			ky: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[01356]|3[0-24679]|4[167]|5[12]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[0235]|58|6[39]|7[0589]|8[04])|5(?:0[1-57-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-47]|7[013-5]|8[056])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[0179]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[02-59]|8[156])|8(?:0[1-68]|1[02-8]|2[08]|3[0-289]|4[3578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[0179]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}'))
		},
			{
			mN: '8002345678',
			hT: 2,
			ky: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('8(?:00|33|44|55|66|77|88)[2-9]\\d{6}'))
		},
			{
			mN: '9002345678',
			hT: 3,
			ky: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('900[2-9]\\d{6}'))
		},
			{
			mN: '5002345678',
			hT: 5,
			ky: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}'))
		}
		])
};
var $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryZA = {
	el: '27',
	jt: A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[1-79]\\d{8}|8\\d{4,9}')),
	R: 'ZA',
	jR: $elm$core$Maybe$Just('00'),
	nZ: $elm$core$Maybe$Just('0'),
	kp: _List_fromArray(
		[
			{
			mN: '101234567',
			hT: 0,
			ky: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:2(?:0330|4302)|52087)0\\d{3}|(?:1[0-8]|2[1-378]|3[1-69]|4\\d|5[1346-8])\\d{7}'))
		},
			{
			mN: '711234567',
			hT: 1,
			ky: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:1(?:3492[0-25]|4495[0235]|549(?:20|5[01]))|4[34]492[01])\\d{3}|8[1-4]\\d{3,7}|(?:2[27]|47|54)4950\\d{3}|(?:1(?:049[2-4]|9[12]\\d\\d)|(?:6\\d|7[0-46-9])\\d{3}|8(?:5\\d{3}|7(?:08[67]|158|28[5-9]|310)))\\d{4}|(?:1[6-8]|28|3[2-69]|4[025689]|5[36-8])4920\\d{3}|(?:12|[2-5]1)492\\d{4}'))
		},
			{
			mN: '801234567',
			hT: 2,
			ky: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('80\\d{7}'))
		},
			{
			mN: '862345678',
			hT: 3,
			ky: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('(?:86[2-9]|9[0-2]\\d)\\d{6}'))
		},
			{
			mN: '860123456',
			hT: 4,
			ky: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('860\\d{6}'))
		},
			{
			mN: '871234567',
			hT: 6,
			ky: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('87(?:08[0-589]|15[0-79]|28[0-4]|31[1-9])\\d{4}|87(?:[02][0-79]|1[0-46-9]|3[02-9]|[4-9]\\d)\\d{5}'))
		},
			{
			mN: '861123456',
			hT: 8,
			ky: A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('861\\d{6,7}'))
		}
		])
};
var $author$project$Profile$Contact$supportedCountries = _List_fromArray(
	[
		$author$project$Profile$Contact$defaultCountry,
		{g5: $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCA, aI: '/icons/flag-canada.svg', az: '123 456 7890'},
		{g5: $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryCR, aI: '/icons/flag-costa-rica.svg', az: '8123 4567'},
		{g5: $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryET, aI: '/icons/flag-ethiopia.svg', az: '91 234 5678'},
		{g5: $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryGB, aI: '/icons/flag-united-kingdom.svg', az: '20 1234 5678'},
		{g5: $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryNZ, aI: '/icons/flag-new-zealand.svg', az: '2123 4567(89)'},
		{g5: $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryPT, aI: '/icons/flag-portugal.svg', az: '12 345 6789'},
		{g5: $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryUS, aI: '/icons/flag-usa.svg', az: '209 123 4567'},
		{g5: $robinheghan$elm_phone_numbers$PhoneNumber$Countries$countryZA, aI: '/icons/flag-south-africa.svg', az: '71 123 4567'}
	]);
var $author$project$Profile$Contact$countryOptions = function (supportedCountry) {
	return A2(
		$elm$core$List$cons,
		supportedCountry,
		A2(
			$elm$core$List$filter,
			function (country) {
				return !_Utils_eq(country, supportedCountry);
			},
			$author$project$Profile$Contact$supportedCountries));
};
var $elm_community$list_extra$List$Extra$findIndexHelp = F3(
	function (index, predicate, list) {
		findIndexHelp:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var x = list.a;
				var xs = list.b;
				if (predicate(x)) {
					return $elm$core$Maybe$Just(index);
				} else {
					var $temp$index = index + 1,
						$temp$predicate = predicate,
						$temp$list = xs;
					index = $temp$index;
					predicate = $temp$predicate;
					list = $temp$list;
					continue findIndexHelp;
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$findIndex = $elm_community$list_extra$List$Extra$findIndexHelp(0);
var $elm_community$list_extra$List$Extra$elemIndex = function (x) {
	return $elm_community$list_extra$List$Extra$findIndex(
		$elm$core$Basics$eq(x));
};
var $author$project$Cambiatus$Enum$ContactType$toString = function (enum____) {
	switch (enum____) {
		case 0:
			return 'EMAIL';
		case 1:
			return 'INSTAGRAM';
		case 2:
			return 'LINK';
		case 3:
			return 'PHONE';
		case 4:
			return 'TELEGRAM';
		default:
			return 'WHATSAPP';
	}
};
var $author$project$Profile$Contact$flagId = F2(
	function (supportedCountry, contactType) {
		return 'flag-' + (supportedCountry.g5.R + ('-' + $author$project$Cambiatus$Enum$ContactType$toString(contactType)));
	});
var $author$project$Profile$Contact$flagSelectorId = function (contactType) {
	return $author$project$Cambiatus$Enum$ContactType$toString(contactType) + '_select';
};
var $author$project$Profile$Contact$Profile = F2(
	function (account, contacts) {
		return {fl: account, aq: contacts};
	});
var $author$project$Profile$Contact$profileSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
		$elm$core$List$filterMap($elm$core$Basics$identity),
		$author$project$Cambiatus$Object$User$contacts($author$project$Profile$Contact$selectionSet)),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Eos$Account$nameSelectionSet($author$project$Cambiatus$Object$User$account),
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Profile$Contact$Profile)));
var $author$project$Cambiatus$InputObject$encodeContactInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'externalId',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.dc, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'label',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.nC, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'type',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.d0,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Cambiatus$Enum$ContactType$toString)))
			]));
};
var $author$project$Cambiatus$InputObject$encodeDeliveryAddressInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'complement',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c2, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'number',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ay, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'postalCode',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.dM, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'street',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.ba)))
			]));
};
var $author$project$Cambiatus$InputObject$encodeUserUpdateInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'avatar',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cV, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'bio',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cW, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'claimNotification',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c_, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'contacts',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aq,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Cambiatus$InputObject$encodeContactInput))),
				_Utils_Tuple2(
				'deliveryAddress',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c8, $author$project$Cambiatus$InputObject$encodeDeliveryAddressInput)),
				_Utils_Tuple2(
				'digest',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c9, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'email',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.jh, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'interests',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.dj, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'location',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.nN, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'locationBairroId',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.dy, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int)),
				_Utils_Tuple2(
				'locationBairroText',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.dz, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'locationMunicipalityId',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.dA, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int)),
				_Utils_Tuple2(
				'name',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ki, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'transferNotification',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.d$, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool))
			]));
};
var $author$project$Cambiatus$Mutation$user = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'user',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.nl, $author$project$Cambiatus$InputObject$encodeUserUpdateInput)
				]),
			object____,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
	});
var $author$project$Profile$Contact$mutation = function (contacts) {
	var contactInput = function (_v0) {
		var contactType = _v0.mf;
		var contact = _v0.me;
		var label = _v0.nC;
		return {
			dc: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(contact),
			nC: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(label),
			d0: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(contactType)
		};
	};
	return A2(
		$author$project$Cambiatus$Mutation$user,
		{
			nl: {
				cV: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
				cW: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
				c_: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
				aq: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
					A2($elm$core$List$map, contactInput, contacts)),
				c8: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
				c9: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
				jh: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
				dj: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
				nN: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
				dy: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
				dz: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
				dA: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
				ki: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
				d$: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
			}
		},
		$author$project$Profile$Contact$profileSelectionSet);
};
var $author$project$Profile$Contact$removeErrors = function (kind) {
	if (!kind.$) {
		var contact = kind.a;
		return $author$project$Profile$Contact$Single(
			_Utils_update(
				contact,
				{jk: $elm$core$Maybe$Nothing}));
	} else {
		var contacts = kind.a;
		return $author$project$Profile$Contact$Multiple(
			A2(
				$elm$core$List$map,
				function (contact) {
					return _Utils_update(
						contact,
						{jk: $elm$core$Maybe$Nothing});
				},
				contacts));
	}
};
var $author$project$Profile$Contact$addErrors = F2(
	function (errors, basic) {
		if (!errors.b) {
			return _Utils_update(
				basic,
				{jk: $elm$core$Maybe$Nothing});
		} else {
			var err = errors.a;
			return _Utils_update(
				basic,
				{
					jk: $elm$core$Maybe$Just(
						_List_fromArray(
							[err]))
				});
		}
	});
var $rtfeldman$elm_validate$Validate$fromValid = function (_v0) {
	var subject = _v0;
	return subject;
};
var $author$project$Profile$Contact$normalize = F2(
	function (_v0, validatedContact) {
		var country = _v0.g5;
		var _v1 = $rtfeldman$elm_validate$Validate$fromValid(validatedContact);
		var contactType = _v1.mf;
		var contact = _v1.me;
		var label = _v1.nC;
		return {
			me: function () {
				switch (contactType) {
					case 1:
						return 'https://instagram.com/' + contact;
					case 3:
						return A2(
							$elm$core$String$join,
							' ',
							_List_fromArray(
								['+' + country.el, contact]));
					case 4:
						return 'https://t.me/' + contact;
					case 5:
						return A2(
							$elm$core$String$join,
							' ',
							_List_fromArray(
								['+' + country.el, contact]));
					case 0:
						return contact;
					default:
						return contact;
				}
			}(),
			mf: contactType,
			nC: label
		};
	});
var $rtfeldman$elm_validate$Validate$Valid = $elm$core$Basics$identity;
var $rtfeldman$elm_validate$Validate$validate = F2(
	function (_v0, subject) {
		var getErrors = _v0;
		var _v1 = getErrors(subject);
		if (!_v1.b) {
			return $elm$core$Result$Ok(subject);
		} else {
			var errors = _v1;
			return $elm$core$Result$Err(errors);
		}
	});
var $rtfeldman$elm_validate$Validate$Validator = $elm$core$Basics$identity;
var $rtfeldman$elm_validate$Validate$all = function (validators) {
	var newGetErrors = function (subject) {
		var accumulateErrors = F2(
			function (_v0, totalErrors) {
				var getErrors = _v0;
				return _Utils_ap(
					totalErrors,
					getErrors(subject));
			});
		return A3($elm$core$List$foldl, accumulateErrors, _List_Nil, validators);
	};
	return newGetErrors;
};
var $rtfeldman$elm_validate$Validate$fromErrors = function (toErrors) {
	return toErrors;
};
var $rtfeldman$elm_validate$Validate$ifTrue = F2(
	function (test, error) {
		var getErrors = function (subject) {
			return test(subject) ? _List_fromArray(
				[error]) : _List_Nil;
		};
		return getErrors;
	});
var $rtfeldman$elm_validate$Validate$isWhitespaceChar = function (_char) {
	return (_char === ' ') || ((_char === '\n') || ((_char === '\t') || (_char === '\u000D')));
};
var $rtfeldman$elm_validate$Validate$isBlank = function (str) {
	isBlank:
	while (true) {
		var _v0 = $elm$core$String$uncons(str);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var _char = _v1.a;
			var rest = _v1.b;
			if ($rtfeldman$elm_validate$Validate$isWhitespaceChar(_char)) {
				var $temp$str = rest;
				str = $temp$str;
				continue isBlank;
			} else {
				return false;
			}
		} else {
			return true;
		}
	}
};
var $rtfeldman$elm_validate$Validate$ifBlank = F2(
	function (subjectToString, error) {
		return A2(
			$rtfeldman$elm_validate$Validate$ifTrue,
			function (subject) {
				return $rtfeldman$elm_validate$Validate$isBlank(
					subjectToString(subject));
			},
			error);
	});
var $rtfeldman$elm_validate$Validate$validEmail = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	A2(
		$elm$regex$Regex$fromStringWith,
		{l0: true, nX: false},
		'^[a-zA-Z0-9.!#$%&\'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$'));
var $rtfeldman$elm_validate$Validate$isValidEmail = function (email) {
	return A2($elm$regex$Regex$contains, $rtfeldman$elm_validate$Validate$validEmail, email);
};
var $rtfeldman$elm_validate$Validate$ifInvalidEmail = F2(
	function (subjectToEmail, errorFromEmail) {
		var getErrors = function (subject) {
			var email = subjectToEmail(subject);
			return $rtfeldman$elm_validate$Validate$isValidEmail(email) ? _List_Nil : _List_fromArray(
				[
					errorFromEmail(email)
				]);
		};
		return getErrors;
	});
var $author$project$Profile$Contact$instagramRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^[\\w](?!.*?\\.{2})[\\w.]{1,28}[\\w]$'));
var $author$project$Profile$Contact$telegramRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^[\\w]{5,32}$'));
var $robinheghan$elm_phone_numbers$PhoneNumber$CarrierSpecific = 13;
var $robinheghan$elm_phone_numbers$PhoneNumber$Emergency = 9;
var $robinheghan$elm_phone_numbers$PhoneNumber$ShortCode = 11;
var $robinheghan$elm_phone_numbers$PhoneNumber$SmsServices = 14;
var $robinheghan$elm_phone_numbers$PhoneNumber$StandardRate = 12;
var $robinheghan$elm_phone_numbers$PhoneNumber$anyType = _List_fromArray(
	[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15]);
var $robinheghan$elm_phone_numbers$PhoneNumber$localizeNumber = F2(
	function (country, number) {
		var _v0 = country.jR;
		if (_v0.$ === 1) {
			return $elm$core$Maybe$Just(number);
		} else {
			var prefix = _v0.a;
			var prefixLength = $elm$core$String$length(prefix);
			var countryCodeLength = $elm$core$String$length(country.el);
			return A2($elm$core$String$startsWith, '+', number) ? (_Utils_eq(
				country.el,
				A2(
					$elm$core$String$left,
					countryCodeLength,
					A2($elm$core$String$dropLeft, 1, number))) ? $elm$core$Maybe$Just(
				A2($elm$core$String$dropLeft, countryCodeLength + 1, number)) : $elm$core$Maybe$Nothing) : (A2($elm$core$String$startsWith, prefix, number) ? (_Utils_eq(
				country.el,
				A2(
					$elm$core$String$left,
					countryCodeLength,
					A2($elm$core$String$dropLeft, prefixLength, number))) ? $elm$core$Maybe$Just(
				A2($elm$core$String$dropLeft, prefixLength + countryCodeLength, number)) : $elm$core$Maybe$Nothing) : $elm$core$Maybe$Just(number));
		}
	});
var $robinheghan$elm_phone_numbers$PhoneNumber$regexExactMatch = F2(
	function (regex, str) {
		var _v0 = A2($elm$regex$Regex$find, regex, str);
		if (_v0.b && (!_v0.b.b)) {
			var match = _v0.a;
			return _Utils_eq(match.eK, str);
		} else {
			return false;
		}
	});
var $robinheghan$elm_phone_numbers$PhoneNumber$matchingCountry = F4(
	function (number, defaultCountry, relevantTypes, country) {
		var maybeLocalNumber = A2($robinheghan$elm_phone_numbers$PhoneNumber$localizeNumber, country, number);
		var matchesSpec = F2(
			function (localNumber, desc) {
				return A2($robinheghan$elm_phone_numbers$PhoneNumber$regexExactMatch, desc.ky, localNumber);
			});
		var isDefaultCountry = _Utils_eq(defaultCountry.R, country.R);
		if (maybeLocalNumber.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var localNumber = maybeLocalNumber.a;
			if (_Utils_eq(localNumber, number) && (!isDefaultCountry)) {
				return $elm$core$Maybe$Nothing;
			} else {
				var matchingTypes = A2(
					$elm$core$List$map,
					function ($) {
						return $.hT;
					},
					A2(
						$elm$core$List$filter,
						matchesSpec(localNumber),
						A2(
							$elm$core$List$filter,
							function (nt) {
								return A2($elm$core$List$member, nt.hT, relevantTypes);
							},
							country.kp)));
				if (!matchingTypes.b) {
					return A2($robinheghan$elm_phone_numbers$PhoneNumber$regexExactMatch, country.jt, localNumber) ? $elm$core$Maybe$Just(
						_Utils_Tuple2(country, _List_Nil)) : $elm$core$Maybe$Nothing;
				} else {
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(country, matchingTypes));
				}
			}
		}
	});
var $robinheghan$elm_phone_numbers$PhoneNumber$sanitizeNumber = function (str) {
	return A2(
		$elm$core$String$filter,
		function (c) {
			return c !== ' ';
		},
		str);
};
var $robinheghan$elm_phone_numbers$PhoneNumber$matches = F2(
	function (config, number) {
		var sanitizedNumber = $robinheghan$elm_phone_numbers$PhoneNumber$sanitizeNumber(number);
		return A2(
			$elm$core$List$filterMap,
			A3($robinheghan$elm_phone_numbers$PhoneNumber$matchingCountry, sanitizedNumber, config.my, config.pI),
			A2($elm$core$List$cons, config.my, config.ox));
	});
var $robinheghan$elm_phone_numbers$PhoneNumber$valid = F2(
	function (config, number) {
		var _v0 = A2($robinheghan$elm_phone_numbers$PhoneNumber$matches, config, number);
		if (!_v0.b) {
			return false;
		} else {
			return true;
		}
	});
var $author$project$Profile$Contact$validatePhone = function (error) {
	return $rtfeldman$elm_validate$Validate$fromErrors(
		function (_v0) {
			var supportedCountry = _v0.aC;
			var contact = _v0.me;
			return A2(
				$robinheghan$elm_phone_numbers$PhoneNumber$valid,
				{my: supportedCountry.g5, ox: _List_Nil, pI: $robinheghan$elm_phone_numbers$PhoneNumber$anyType},
				contact) ? _List_Nil : _List_fromArray(
				[error]);
		});
};
var $author$project$Profile$Contact$validateRegex = F2(
	function (regex, error) {
		return $rtfeldman$elm_validate$Validate$fromErrors(
			function (_v0) {
				var contact = _v0.me;
				return A2($elm$regex$Regex$contains, regex, contact) ? _List_Nil : _List_fromArray(
					[error]);
			});
	});
var $author$project$Profile$Contact$validator = F2(
	function (contactType, translators) {
		var baseTranslation = 'contact_form.validation';
		var _v0 = function () {
			switch (contactType) {
				case 3:
					return _Utils_Tuple2($author$project$Profile$Contact$validatePhone, 'phone');
				case 5:
					return _Utils_Tuple2($author$project$Profile$Contact$validatePhone, 'phone');
				case 1:
					return _Utils_Tuple2(
						$author$project$Profile$Contact$validateRegex($author$project$Profile$Contact$instagramRegex),
						'username');
				case 4:
					return _Utils_Tuple2(
						$author$project$Profile$Contact$validateRegex($author$project$Profile$Contact$telegramRegex),
						'username');
				case 0:
					return _Utils_Tuple2(
						function (error) {
							return A2(
								$rtfeldman$elm_validate$Validate$ifInvalidEmail,
								function ($) {
									return $.me;
								},
								function (_v2) {
									return error;
								});
						},
						'email');
				default:
					return _Utils_Tuple2(
						function (error) {
							return $rtfeldman$elm_validate$Validate$fromErrors(
								function (_v3) {
									var contact = _v3.me;
									var withProtocol = $elm$core$String$isEmpty(contact) ? '' : ((A2($elm$core$String$startsWith, 'https://', contact) || A2($elm$core$String$startsWith, 'http://', contact)) ? contact : ('http://' + contact));
									var _v4 = $elm$url$Url$fromString(withProtocol);
									if (_v4.$ === 1) {
										return _List_fromArray(
											[error]);
									} else {
										return _List_Nil;
									}
								});
						},
						'link');
			}
		}();
		var specificValidation = _v0.a;
		var field = _v0.b;
		return $rtfeldman$elm_validate$Validate$all(
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_validate$Validate$ifBlank,
					function ($) {
						return $.me;
					},
					translators.il(
						A2(
							$elm$core$String$join,
							'.',
							_List_fromArray(
								[baseTranslation, field, 'blank'])))),
					specificValidation(
					translators.il(
						A2(
							$elm$core$String$join,
							'.',
							_List_fromArray(
								[baseTranslation, field, 'invalid']))))
				]));
	});
var $author$project$Profile$Contact$submitSingle = F2(
	function (translators, basic) {
		return A2(
			$elm$core$Result$map,
			function (valid) {
				return A2($author$project$Profile$Contact$normalize, basic.aC, valid);
			},
			A2(
				$elm$core$Result$mapError,
				function (errors) {
					return A2($author$project$Profile$Contact$addErrors, errors, basic);
				},
				A2(
					$rtfeldman$elm_validate$Validate$validate,
					A2($author$project$Profile$Contact$validator, basic.mf, translators),
					basic)));
	});
var $author$project$Profile$Contact$submitMultiple = F2(
	function (translators, basics) {
		var _v0 = A3(
			$elm$core$List$foldr,
			F2(
				function (basic, _v1) {
					var basicsAcc = _v1.a;
					var normalizedsAcc = _v1.b;
					var _v2 = A2($author$project$Profile$Contact$submitSingle, translators, basic);
					if (_v2.$ === 1) {
						var basicWithErrors = _v2.a;
						return _Utils_Tuple2(
							A2($elm$core$List$cons, basicWithErrors, basicsAcc),
							normalizedsAcc);
					} else {
						var normalized = _v2.a;
						return _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								_Utils_update(
									basic,
									{jk: $elm$core$Maybe$Nothing}),
								basicsAcc),
							A2($elm$core$List$cons, normalized, normalizedsAcc));
					}
				}),
			_Utils_Tuple2(_List_Nil, _List_Nil),
			basics);
		var withError = _v0.a;
		var valid = _v0.b;
		return A2(
			$elm$core$List$all,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.me;
				},
				$elm$core$String$isEmpty),
			basics) ? $elm$core$Result$Ok(_List_Nil) : (($elm$core$List$length(valid) > 0) ? $elm$core$Result$Ok(valid) : $elm$core$Result$Err(withError));
	});
var $author$project$Profile$Contact$submit = F2(
	function (translators, kind) {
		if (!kind.$) {
			var contact = kind.a;
			return A2(
				$elm$core$Result$map,
				$elm$core$List$singleton,
				A2(
					$elm$core$Result$mapError,
					$author$project$Profile$Contact$Single,
					A2($author$project$Profile$Contact$submitSingle, translators, contact)));
		} else {
			var contacts = kind.a;
			return A2(
				$elm$core$Result$mapError,
				$author$project$Profile$Contact$Multiple,
				A2($author$project$Profile$Contact$submitMultiple, translators, contacts));
		}
	});
var $author$project$Profile$Contact$updateIfContactType = F3(
	function (contactType, fn, contacts) {
		return A3(
			$elm_community$list_extra$List$Extra$updateIf,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.mf;
				},
				$elm$core$Basics$eq(contactType)),
			fn,
			contacts);
	});
var $author$project$Profile$Contact$update = F4(
	function (msg, model, translators, profileContacts) {
		var updateKind = F2(
			function (contactType, updateFn) {
				return _Utils_update(
					model,
					{
						eG: function () {
							var _v15 = model.eG;
							if (!_v15.$) {
								var contact = _v15.a;
								return $author$project$Profile$Contact$Single(
									updateFn(contact));
							} else {
								var contacts = _v15.a;
								return $author$project$Profile$Contact$Multiple(
									A3($author$project$Profile$Contact$updateIfContactType, contactType, updateFn, contacts));
							}
						}()
					});
			});
		var toggleFlags = function (contact) {
			var showFlags = contact.bV;
			return _Utils_update(
				contact,
				{
					bD: showFlags ? $elm$core$Maybe$Nothing : contact.bD,
					bV: !showFlags
				});
		};
		var setFocusedFlag = F2(
			function (supportedCountry, contact) {
				return _Utils_update(
					contact,
					{
						bD: $elm$core$Maybe$Just(supportedCountry)
					});
			});
		var setCountry = F2(
			function (newCountry, contact) {
				return _Utils_update(
					contact,
					{jk: $elm$core$Maybe$Nothing, bD: $elm$core$Maybe$Nothing, aC: newCountry});
			});
		var setContact = F2(
			function (newContact, contact) {
				return _Utils_update(
					contact,
					{me: newContact});
			});
		var feedbackScope = function () {
			var _v14 = model.eG;
			if (!_v14.$) {
				return 'single';
			} else {
				return 'multiple';
			}
		}();
		var currentFocusedFlag = function (contactType) {
			var _v13 = model.eG;
			if (!_v13.$) {
				var contact = _v13.a;
				return A2($elm$core$Maybe$withDefault, $author$project$Profile$Contact$defaultCountry, contact.bD);
			} else {
				var contacts = _v13.a;
				return A2(
					$elm$core$Maybe$withDefault,
					$author$project$Profile$Contact$defaultCountry,
					A2(
						$elm$core$Maybe$andThen,
						function ($) {
							return $.bD;
						},
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.mf;
									},
									$elm$core$Basics$eq(contactType)),
								contacts))));
			}
		};
		var currentCountry = function (contactType) {
			var _v12 = model.eG;
			if (!_v12.$) {
				var contact = _v12.a;
				return contact.aC;
			} else {
				var contacts = _v12.a;
				return A2(
					$elm$core$Maybe$withDefault,
					$author$project$Profile$Contact$defaultCountry,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.aC;
						},
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.mf;
									},
									$elm$core$Basics$eq(contactType)),
								contacts))));
			}
		};
		switch (msg.$) {
			case 0:
				return $author$project$UpdateResult$init(model);
			case 1:
				var contactType = msg.a;
				var country = msg.b;
				return A2(
					$author$project$UpdateResult$addCmd,
					A2(
						$elm$core$Task$attempt,
						function (_v1) {
							return $author$project$Profile$Contact$NoOp;
						},
						$elm$browser$Browser$Dom$focus(
							$author$project$Profile$Contact$flagSelectorId(contactType))),
					$author$project$UpdateResult$init(
						A2(
							updateKind,
							contactType,
							setCountry(country))));
			case 2:
				var contactType = msg.a;
				return A2(
					$author$project$UpdateResult$addCmd,
					A2(
						$elm$core$Task$attempt,
						function (_v2) {
							return $author$project$Profile$Contact$NoOp;
						},
						$elm$browser$Browser$Dom$focus(
							$author$project$Profile$Contact$flagSelectorId(contactType))),
					$author$project$UpdateResult$init(
						A2(updateKind, contactType, toggleFlags)));
			case 3:
				var contactType = msg.a;
				var newContact = msg.b;
				return $author$project$UpdateResult$init(
					A2(
						updateKind,
						contactType,
						setContact(newContact)));
			case 5:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{ca: $elm$core$Maybe$Nothing}));
			case 4:
				var contactType = msg.a;
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{
							ca: $elm$core$Maybe$Just(contactType)
						}));
			case 6:
				var contactTypeToDelete = msg.a;
				var withoutContact = A2(
					updateKind,
					contactTypeToDelete,
					function (basic) {
						return _Utils_update(
							basic,
							{me: '', jk: $elm$core$Maybe$Nothing});
					});
				var newContacts = A2(
					$elm$core$List$filter,
					function (_v3) {
						var contactType = _v3.mf;
						return !_Utils_eq(contactType, contactTypeToDelete);
					},
					profileContacts);
				return A2(
					$author$project$UpdateResult$addExt,
					A2(
						$author$project$Profile$Contact$GotMutationRequest,
						$author$project$Profile$Contact$mutation(newContacts),
						$author$project$Profile$Contact$CompletedDeleteContact),
					$author$project$UpdateResult$init(
						_Utils_update(
							withoutContact,
							{ca: $elm$core$Maybe$Nothing, X: $krisajenkins$remotedata$RemoteData$Loading})));
			case 7:
				var option = msg.a;
				var _v4 = model.eG;
				if (!_v4.$) {
					var contact = _v4.a;
					return $author$project$UpdateResult$init(
						_Utils_update(
							model,
							{
								eG: $author$project$Profile$Contact$Single(
									_Utils_update(
										contact,
										{me: '', mf: option, jk: $elm$core$Maybe$Nothing}))
							}));
				} else {
					return $author$project$UpdateResult$init(model);
				}
			case 8:
				var _v5 = A2($author$project$Profile$Contact$submit, translators, model.eG);
				if (_v5.$ === 1) {
					var withError = _v5.a;
					return $author$project$UpdateResult$init(
						_Utils_update(
							model,
							{eG: withError}));
				} else {
					var normalized = _v5.a;
					return A2(
						$author$project$UpdateResult$addExt,
						A2(
							$author$project$Profile$Contact$GotMutationRequest,
							$author$project$Profile$Contact$mutation(normalized),
							$author$project$Profile$Contact$CompletedUpdateContact),
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									eG: $author$project$Profile$Contact$removeErrors(model.eG),
									X: $krisajenkins$remotedata$RemoteData$Loading
								})));
				}
			case 9:
				var result = msg.a;
				var feedbackString = function (isSuccess) {
					return translators.il(
						A2(
							$elm$core$String$join,
							'.',
							_List_fromArray(
								[
									'contact_form.feedback',
									feedbackScope,
									isSuccess ? 'success' : 'failure'
								])));
				};
				var addContactResponse = function () {
					switch (result.$) {
						case 3:
							if (!result.a.$) {
								var profile = result.a.a;
								return $author$project$UpdateResult$addExt(
									A3(
										$author$project$Profile$Contact$GotContacts,
										feedbackString(true),
										profile.aq,
										true));
							} else {
								var _v7 = result.a;
								return $author$project$UpdateResult$addExt(
									$author$project$Profile$Contact$GotContactsError(
										feedbackString(false)));
							}
						case 2:
							return $author$project$UpdateResult$addExt(
								$author$project$Profile$Contact$GotContactsError(
									feedbackString(false)));
						case 0:
							return $elm$core$Basics$identity;
						default:
							return $elm$core$Basics$identity;
					}
				}();
				return addContactResponse(
					$author$project$UpdateResult$init(
						_Utils_update(
							model,
							{X: result})));
			case 10:
				var result = msg.a;
				var feedbackString = function (isSuccess) {
					return translators.il(
						A2(
							$elm$core$String$join,
							'.',
							_List_fromArray(
								[
									'contact_form.feedback.delete',
									isSuccess ? 'success' : 'failure'
								])));
				};
				var addContactResponse = function () {
					switch (result.$) {
						case 3:
							if (!result.a.$) {
								var profile = result.a.a;
								return $author$project$UpdateResult$addExt(
									A3(
										$author$project$Profile$Contact$GotContacts,
										feedbackString(true),
										profile.aq,
										false));
							} else {
								var _v9 = result.a;
								return $author$project$UpdateResult$addExt(
									$author$project$Profile$Contact$GotContactsError(
										feedbackString(false)));
							}
						case 2:
							return $author$project$UpdateResult$addExt(
								$author$project$Profile$Contact$GotContactsError(
									feedbackString(false)));
						case 0:
							return $elm$core$Basics$identity;
						default:
							return $elm$core$Basics$identity;
					}
				}();
				return addContactResponse(
					$author$project$UpdateResult$init(
						_Utils_update(
							model,
							{X: $krisajenkins$remotedata$RemoteData$NotAsked})));
			case 11:
				var contactType = msg.a;
				var countries = $author$project$Profile$Contact$countryOptions(
					currentCountry(contactType));
				var nextCountry = A2(
					$elm$core$Maybe$withDefault,
					$author$project$Profile$Contact$defaultCountry,
					A2(
						$elm$core$Maybe$andThen,
						function (index) {
							return A2($elm_community$list_extra$List$Extra$getAt, index, countries);
						},
						A2(
							$elm$core$Maybe$map,
							function (nextIndex) {
								return (nextIndex <= 0) ? ($elm$core$List$length(countries) - 1) : (nextIndex - 1);
							},
							A2(
								$elm_community$list_extra$List$Extra$elemIndex,
								currentFocusedFlag(contactType),
								countries))));
				return A2(
					$author$project$UpdateResult$addCmd,
					A2(
						$elm$core$Task$attempt,
						function (_v10) {
							return $author$project$Profile$Contact$NoOp;
						},
						$elm$browser$Browser$Dom$focus(
							A2($author$project$Profile$Contact$flagId, nextCountry, contactType))),
					$author$project$UpdateResult$init(
						A2(
							updateKind,
							contactType,
							setFocusedFlag(nextCountry))));
			default:
				var contactType = msg.a;
				var countries = $author$project$Profile$Contact$countryOptions(
					currentCountry(contactType));
				var nextCountry = A2(
					$elm$core$Maybe$withDefault,
					$author$project$Profile$Contact$defaultCountry,
					A2(
						$elm$core$Maybe$andThen,
						function (index) {
							return A2($elm_community$list_extra$List$Extra$getAt, index, countries);
						},
						A2(
							$elm$core$Maybe$map,
							function (nextIndex) {
								return (_Utils_cmp(
									nextIndex,
									$elm$core$List$length(countries) - 1) > -1) ? 0 : (nextIndex + 1);
							},
							A2(
								$elm_community$list_extra$List$Extra$elemIndex,
								currentFocusedFlag(contactType),
								countries))));
				return A2(
					$author$project$UpdateResult$addCmd,
					A2(
						$elm$core$Task$attempt,
						function (_v11) {
							return $author$project$Profile$Contact$NoOp;
						},
						$elm$browser$Browser$Dom$focus(
							A2($author$project$Profile$Contact$flagId, nextCountry, contactType))),
					$author$project$UpdateResult$init(
						A2(
							updateKind,
							contactType,
							setFocusedFlag(nextCountry))));
		}
	});
var $author$project$Page$Dashboard$update = F3(
	function (msg, model, loggedIn) {
		var shared = loggedIn.aM;
		var accountName = loggedIn.lM;
		switch (msg.$) {
			case 0:
				return $author$project$UpdateResult$init(model);
			case 1:
				var community = msg.a;
				return A2(
					$author$project$UpdateResult$addExt,
					A3(
						$author$project$Session$LoggedIn$query,
						loggedIn,
						$author$project$PlaceRelease$query(loggedIn),
						$author$project$Page$Dashboard$CompletedLoadPlaceRelease),
					A2(
						$author$project$UpdateResult$addExt,
						A4($author$project$Page$Dashboard$fetchTransfers, loggedIn, community, $elm$core$Maybe$Nothing, model),
						A2(
							$author$project$UpdateResult$addExt,
							A2($author$project$Page$Dashboard$fetchAvailableAnalysis, loggedIn, $elm$core$Maybe$Nothing),
							A2(
								$author$project$UpdateResult$addCmd,
								A3($author$project$Page$Dashboard$fetchBalance, shared, accountName, community),
								$author$project$UpdateResult$init(
									_Utils_update(
										model,
										{
											b2: $author$project$Page$Dashboard$LoadingGraphql($elm$core$Maybe$Nothing),
											b5: $krisajenkins$remotedata$RemoteData$Loading,
											bT: A2($author$project$Page$Dashboard$shouldShowContactModal, loggedIn, model)
										}))))));
			case 20:
				if ((msg.a.$ === 3) && msg.a.a) {
					return A2(
						$author$project$UpdateResult$addPort,
						{
							i9: $elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'name',
										$elm$json$Json$Encode$string('memberLocation'))
									])),
							kY: $author$project$Page$Dashboard$GotBrowserLocation($elm$json$Json$Encode$null),
							kZ: $elm$json$Json$Encode$null
						},
						$author$project$UpdateResult$init(model));
				} else {
					return $author$project$UpdateResult$init(model);
				}
			case 21:
				var value = msg.a;
				var dismissed = function (flags) {
					return _Utils_update(
						model,
						{d6: flags.oa});
				};
				var _v1 = A2($elm$json$Json$Decode$decodeValue, $author$project$PlaceLocation$replyDecoder, value);
				if (!_v1.$) {
					switch (_v1.a.$) {
						case 0:
							var _v2 = _v1.a;
							var position = _v2.a;
							var flags = _v2.b;
							return A2(
								$author$project$UpdateResult$addExt,
								A3(
									$author$project$Session$LoggedIn$mutation,
									loggedIn,
									$author$project$PlaceLocation$locate(
										$elm$core$Maybe$Just(position)),
									$author$project$Page$Dashboard$CompletedLocatePlace),
								$author$project$UpdateResult$init(
									dismissed(flags)));
						case 1:
							var flags = _v1.a.a;
							return A2(
								$author$project$UpdateResult$addExt,
								A3(
									$author$project$Session$LoggedIn$mutation,
									loggedIn,
									$author$project$PlaceLocation$locate($elm$core$Maybe$Nothing),
									$author$project$Page$Dashboard$CompletedLocatePlace),
								$author$project$UpdateResult$init(
									dismissed(flags)));
						default:
							var flags = _v1.a.a;
							return A2(
								$author$project$UpdateResult$addExt,
								A3($author$project$Session$LoggedIn$query, loggedIn, $author$project$PlaceLocation$status, $author$project$Page$Dashboard$CompletedLoadPlaceStatus),
								$author$project$UpdateResult$init(
									dismissed(flags)));
					}
				} else {
					return $author$project$UpdateResult$init(model);
				}
			case 22:
				if (msg.a.$ === 3) {
					var placeStatus = msg.a.a;
					return $author$project$UpdateResult$init(
						_Utils_update(
							model,
							{
								eU: $elm$core$Maybe$Just(placeStatus)
							}));
				} else {
					return $author$project$UpdateResult$init(model);
				}
			case 23:
				if (msg.a.$ === 3) {
					var maybeStatus = msg.a.a;
					return $author$project$UpdateResult$init(
						_Utils_update(
							model,
							{eU: maybeStatus}));
				} else {
					return $author$project$UpdateResult$init(model);
				}
			case 24:
				return A2(
					$author$project$UpdateResult$addPort,
					{
						i9: $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'name',
									$elm$json$Json$Encode$string('dismissAddressNote'))
								])),
						kY: $author$project$Page$Dashboard$NoOp,
						kZ: $elm$json$Json$Encode$null
					},
					$author$project$UpdateResult$init(
						_Utils_update(
							model,
							{d6: true})));
			case 2:
				if (!msg.a.$) {
					var balance = msg.a.a;
					return $author$project$UpdateResult$init(
						_Utils_update(
							model,
							{
								b5: $krisajenkins$remotedata$RemoteData$Success(balance)
							}));
				} else {
					var httpError = msg.a.a;
					return A7(
						$author$project$UpdateResult$logHttpError,
						msg,
						$elm$core$Maybe$Just(loggedIn.lM),
						'Got an error when loading balance on the dashboard',
						{mX: 'update', nW: 'Page.Dashboard'},
						_List_fromArray(
							[
								$author$project$Log$contextFromCommunity(loggedIn.o7)
							]),
						httpError,
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									b5: $krisajenkins$remotedata$RemoteData$Failure(httpError)
								})));
				}
			case 4:
				switch (msg.a.$) {
					case 3:
						var claims = msg.a.a;
						var analysis = {
							i_: $author$project$Claim$paginatedToList(claims),
							mo: A2(
								$elm$core$Maybe$withDefault,
								0,
								A2(
									$elm$core$Maybe$andThen,
									function ($) {
										return $.mo;
									},
									claims))
						};
						return $author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									b2: A2(
										$author$project$Page$Dashboard$LoadedGraphql,
										analysis,
										$author$project$Claim$paginatedPageInfo(claims))
								}));
					case 2:
						var err = msg.a.a;
						return A7(
							$author$project$UpdateResult$logGraphqlError,
							msg,
							$elm$core$Maybe$Just(loggedIn.lM),
							'Got an error when loading claims on the dashboard',
							{mX: 'update', nW: 'Page.Dashboard'},
							_List_fromArray(
								[
									$author$project$Log$contextFromCommunity(loggedIn.o7)
								]),
							err,
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{b2: $author$project$Page$Dashboard$FailedGraphql})));
					default:
						return $author$project$UpdateResult$init(model);
				}
			case 3:
				switch (msg.a.$) {
					case 3:
						var maybeTransfers = msg.a.a;
						var previousTransfers = function () {
							var _v3 = model.an;
							_v3$2:
							while (true) {
								switch (_v3.$) {
									case 1:
										var previousTransfers_ = _v3.a;
										return previousTransfers_;
									case 0:
										if (!_v3.a.$) {
											var previousTransfers_ = _v3.a.a;
											return previousTransfers_;
										} else {
											break _v3$2;
										}
									default:
										break _v3$2;
								}
							}
							return _List_Nil;
						}();
						var maybePageInfo = A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.oz;
							},
							A2(
								$elm$core$Maybe$andThen,
								function ($) {
									return $.an;
								},
								maybeTransfers));
						return $author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									an: function (transfers) {
										return A2(
											$author$project$Page$Dashboard$LoadedGraphql,
											_Utils_ap(previousTransfers, transfers),
											maybePageInfo);
									}(
										A2(
											$elm$core$List$map,
											function (transfer) {
												return _Utils_Tuple2(
													transfer,
													$author$project$Profile$Summary$init(false));
											},
											$author$project$Transfer$getTransfers(maybeTransfers)))
								}));
					case 2:
						var err = msg.a.a;
						return A7(
							$author$project$UpdateResult$logGraphqlError,
							msg,
							$elm$core$Maybe$Just(loggedIn.lM),
							'Got an error when trying to load user\'s transfers',
							{mX: 'update', nW: 'Page.Dashboard'},
							_List_fromArray(
								[
									$author$project$Log$contextFromCommunity(loggedIn.o7)
								]),
							err,
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{an: $author$project$Page$Dashboard$FailedGraphql})));
					default:
						return $author$project$UpdateResult$init(model);
				}
			case 5:
				var transferId = msg.a;
				var subMsg = msg.b;
				var updateTransfers = function (transfers) {
					return A3(
						$elm_community$list_extra$List$Extra$updateIf,
						function (_v5) {
							var transfer = _v5.a;
							return _Utils_eq(transfer.R, transferId);
						},
						function (_v6) {
							var transfer = _v6.a;
							var profileSummary = _v6.b;
							return _Utils_Tuple2(
								transfer,
								A2($author$project$Profile$Summary$update, subMsg, profileSummary));
						},
						transfers);
				};
				var _v4 = model.an;
				switch (_v4.$) {
					case 1:
						var transfers = _v4.a;
						var pageInfo = _v4.b;
						return $author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									an: A2(
										$author$project$Page$Dashboard$LoadedGraphql,
										updateTransfers(transfers),
										pageInfo)
								}));
					case 0:
						var maybeTransfers = _v4.a;
						return $author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									an: $author$project$Page$Dashboard$LoadingGraphql(
										A2($elm$core$Maybe$map, updateTransfers, maybeTransfers))
								}));
					default:
						return $author$project$UpdateResult$init(model);
				}
			case 6:
				var _v7 = _Utils_Tuple2(model.an, loggedIn.o7);
				if ((_v7.a.$ === 1) && (_v7.b.$ === 3)) {
					var _v8 = _v7.a;
					var transfers = _v8.a;
					var maybePageInfo = _v8.b;
					var community = _v7.b.a;
					var maybeCursor = A2(
						$elm$core$Maybe$andThen,
						function ($) {
							return $.mI;
						},
						maybePageInfo);
					return A2(
						$author$project$UpdateResult$addExt,
						A4($author$project$Page$Dashboard$fetchTransfers, loggedIn, community, maybeCursor, model),
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									an: $author$project$Page$Dashboard$LoadingGraphql(
										$elm$core$Maybe$Just(transfers))
								})));
				} else {
					return $author$project$UpdateResult$init(model);
				}
			case 7:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{cK: true}));
			case 8:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{cK: false}));
			case 9:
				var subMsg = msg.a;
				return A5(
					$author$project$UpdateResult$fromChild,
					function (newForm) {
						return _Utils_update(
							model,
							{fh: newForm});
					},
					$author$project$Page$Dashboard$GotTransfersFiltersFormMsg,
					$author$project$Session$LoggedIn$addFeedback,
					model,
					A3($author$project$Form$update, shared, subMsg, model.fh));
			case 10:
				var formOutput = msg.a;
				var _v9 = loggedIn.o7;
				if (_v9.$ === 3) {
					var community = _v9.a;
					var newModel = _Utils_update(
						model,
						{
							cK: false,
							an: $author$project$Page$Dashboard$LoadingGraphql($elm$core$Maybe$Nothing),
							bZ: formOutput
						});
					return A2(
						$author$project$UpdateResult$addExt,
						A4($author$project$Page$Dashboard$fetchTransfers, loggedIn, community, $elm$core$Maybe$Nothing, newModel),
						$author$project$UpdateResult$init(newModel));
				} else {
					return A6(
						$author$project$UpdateResult$logImpossible,
						msg,
						'Applied filters on transfer list, but community wasn\'t loaded',
						$elm$core$Maybe$Just(loggedIn.lM),
						{mX: 'update', nW: 'Page.Dashboard'},
						_List_Nil,
						$author$project$UpdateResult$init(model));
				}
			case 11:
				var transferId = msg.a;
				return A2(
					$author$project$UpdateResult$addCmd,
					A2(
						$author$project$Route$pushUrl,
						loggedIn.aM.eM,
						$author$project$Route$ViewTransfer(transferId)),
					$author$project$UpdateResult$init(model));
			case 12:
				var _v10 = loggedIn.kJ;
				if (_v10.$ === 3) {
					var profile = _v10.a;
					if (A2(
						$author$project$Session$LoggedIn$hasPermissions,
						profile,
						_List_fromArray(
							[3]))) {
						var _v11 = model.b5;
						if ((_v11.$ === 3) && (!_v11.a.$)) {
							var b = _v11.a.a;
							return A2(
								$author$project$UpdateResult$addCmd,
								A4($author$project$Api$communityInvite, loggedIn.aM, b.lY.e9, loggedIn.lM, $author$project$Page$Dashboard$CompletedInviteCreation),
								$author$project$UpdateResult$init(
									_Utils_update(
										model,
										{aZ: $author$project$Page$Dashboard$InviteModalLoading})));
						} else {
							return A6(
								$author$project$UpdateResult$logImpossible,
								msg,
								'Created invitation, but balance wasn\'t loaded',
								$elm$core$Maybe$Just(loggedIn.lM),
								{mX: 'update', nW: 'Page.Dashboard'},
								_List_Nil,
								$author$project$UpdateResult$init(model));
						}
					} else {
						return A2(
							$author$project$UpdateResult$addExt,
							$author$project$Session$LoggedIn$ShowInsufficientPermissionsModal,
							$author$project$UpdateResult$init(model));
					}
				} else {
					return A6(
						$author$project$UpdateResult$logImpossible,
						msg,
						'Tried creating invitation, but profile wasn\'t loaded',
						$elm$core$Maybe$Just(loggedIn.lM),
						{mX: 'update', nW: 'Page.Dashboard'},
						_List_Nil,
						$author$project$UpdateResult$init(model));
				}
			case 13:
				var subMsg = msg.a;
				var _v12 = $author$project$Session$LoggedIn$profile(loggedIn);
				if (!_v12.$) {
					var userProfile = _v12.a;
					var handleExtMsg = function (extMsg) {
						switch (extMsg.$) {
							case 0:
								var successMessage = extMsg.a;
								var contacts = extMsg.b;
								return A2(
									$elm$core$Basics$composeR,
									$author$project$UpdateResult$mapModel(
										function (model_) {
											return _Utils_update(
												model_,
												{bT: false});
										}),
									A2(
										$elm$core$Basics$composeR,
										$author$project$UpdateResult$addExt(
											A2($author$project$Session$LoggedIn$ShowFeedback, 0, successMessage)),
										$author$project$UpdateResult$addExt(
											$author$project$Session$LoggedIn$ExternalBroadcast(
												$author$project$Session$LoggedIn$ProfileLoaded(
													_Utils_update(
														userProfile,
														{aq: contacts}))))));
							case 1:
								var errorMessage = extMsg.a;
								return A2(
									$elm$core$Basics$composeR,
									$author$project$UpdateResult$mapModel(
										function (model_) {
											return _Utils_update(
												model_,
												{bT: false});
										}),
									$author$project$UpdateResult$addExt(
										A2($author$project$Session$LoggedIn$ShowFeedback, 1, errorMessage)));
							default:
								var selectionSet = extMsg.a;
								var responseMsg = extMsg.b;
								return $author$project$UpdateResult$addExt(
									A3(
										$author$project$Session$LoggedIn$mutation,
										loggedIn,
										selectionSet,
										A2($elm$core$Basics$composeR, responseMsg, $author$project$Page$Dashboard$GotContactMsg)));
						}
					};
					return A5(
						$author$project$UpdateResult$fromChild,
						function (newContactModel) {
							return _Utils_update(
								model,
								{ek: newContactModel});
						},
						$author$project$Page$Dashboard$GotContactMsg,
						handleExtMsg,
						model,
						A4($author$project$Profile$Contact$update, subMsg, model.ek, loggedIn.aM.iw, userProfile.aq));
				} else {
					return $author$project$UpdateResult$init(model);
				}
			case 14:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{bT: false}));
			case 15:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{cb: false, aZ: $author$project$Page$Dashboard$InviteModalClosed}));
			case 16:
				if (!msg.a.$) {
					var invitationId = msg.a.a;
					return A2(
						$author$project$UpdateResult$addCmd,
						A2(
							$elm$core$Task$attempt,
							function (_v14) {
								return $author$project$Page$Dashboard$NoOp;
							},
							$elm$browser$Browser$Dom$focus('copy-invite-button')),
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									aZ: $author$project$Page$Dashboard$InviteModalLoaded(invitationId)
								})));
				} else {
					var httpError = msg.a.a;
					return A7(
						$author$project$UpdateResult$logHttpError,
						msg,
						$elm$core$Maybe$Just(loggedIn.lM),
						'Got an error when creating an invite',
						{mX: 'update', nW: 'Page.Dashboard'},
						_List_fromArray(
							[
								$author$project$Log$contextFromCommunity(loggedIn.o7)
							]),
						httpError,
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									aZ: $author$project$Page$Dashboard$InviteModalFailed(
										loggedIn.aM.iw.il('community.invite.failed'))
								})));
				}
			case 17:
				var elementId = msg.a;
				return A2(
					$author$project$UpdateResult$addPort,
					{
						i9: $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'id',
									$elm$json$Json$Encode$string(elementId)),
									_Utils_Tuple2(
									'name',
									$elm$json$Json$Encode$string('copyToClipboard'))
								])),
						kY: $author$project$Page$Dashboard$CopiedToClipboard,
						kZ: $elm$json$Json$Encode$null
					},
					$author$project$UpdateResult$init(model));
			case 18:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{cb: true}));
			default:
				return A2(
					$author$project$UpdateResult$addExt,
					$author$project$Session$LoggedIn$ShowCodeOfConductModal,
					$author$project$UpdateResult$init(model));
		}
	});
var $author$project$Page$Dashboard$Analysis$update = F3(
	function (msg, _v0, _v1) {
		return $elm$core$Basics$never(msg);
	});
var $author$project$Page$Dashboard$Claim$Failed = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Dashboard$Claim$Loaded = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Profile$Summary$initMany = F2(
	function (isLarge, amount) {
		return A2(
			$elm$core$List$repeat,
			amount,
			$author$project$Profile$Summary$init(isLarge));
	});
var $author$project$Page$Dashboard$Claim$pendingValidators = function (claim) {
	return A2(
		$elm$core$List$filter,
		function (validator) {
			return !A2(
				$elm$core$List$member,
				validator.fl,
				A2(
					$elm$core$List$map,
					function (c) {
						return c.aE.fl;
					},
					claim.S));
		},
		claim.iG.pN);
};
var $author$project$Claim$PhotoModal = function (a) {
	return {$: 0, a: a};
};
var $author$project$Claim$updateClaimModalStatus = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_update(
					model,
					{iZ: $author$project$Claim$Closed});
			case 1:
				var claimId = msg.a;
				return _Utils_update(
					model,
					{
						iZ: $author$project$Claim$PhotoModal(claimId)
					});
			default:
				return model;
		}
	});
var $author$project$Page$Dashboard$Claim$update = F3(
	function (msg, model, loggedIn) {
		var _v0 = loggedIn.aM.iw;
		var tr = _v0.iu;
		switch (msg.$) {
			case 0:
				switch (msg.a.$) {
					case 3:
						var response = msg.a.a;
						var voterSummaries = A2(
							$author$project$Profile$Summary$initMany,
							false,
							$elm$core$List$length(response.S));
						var pendingCount = $elm$core$List$length(
							$author$project$Page$Dashboard$Claim$pendingValidators(response));
						var pendingSummaries = A2($author$project$Profile$Summary$initMany, false, pendingCount);
						var claimerSummary = $author$project$Profile$Summary$init(true);
						return $author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									a9: A2(
										$author$project$Page$Dashboard$Claim$Loaded,
										response,
										{c$: claimerSummary, dK: pendingSummaries, b$: voterSummaries})
								}));
					case 2:
						var err = msg.a.a;
						return A7(
							$author$project$UpdateResult$logGraphqlError,
							msg,
							$elm$core$Maybe$Just(loggedIn.lM),
							'Got an error when trying to load claim',
							{mX: 'update', nW: 'Page.Dashboard.Claim'},
							_List_Nil,
							err,
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{
										a9: $author$project$Page$Dashboard$Claim$Failed(err)
									})));
					default:
						return $author$project$UpdateResult$init(model);
				}
			case 1:
				var m = msg.a;
				return $author$project$UpdateResult$init(
					A2($author$project$Claim$updateClaimModalStatus, m, model));
			default:
				var profileSummaryKind = msg.a;
				var subMsg = msg.b;
				var _v2 = model.a9;
				if (_v2.$ === 1) {
					var claim = _v2.a;
					var profileSummaries = _v2.b;
					switch (profileSummaryKind.$) {
						case 1:
							var index = profileSummaryKind.a;
							return $author$project$UpdateResult$init(
								_Utils_update(
									model,
									{
										a9: A2(
											$author$project$Page$Dashboard$Claim$Loaded,
											claim,
											_Utils_update(
												profileSummaries,
												{
													dK: A3(
														$elm_community$list_extra$List$Extra$updateAt,
														index,
														$author$project$Profile$Summary$update(subMsg),
														profileSummaries.dK)
												}))
									}));
						case 2:
							var index = profileSummaryKind.a;
							return $author$project$UpdateResult$init(
								_Utils_update(
									model,
									{
										a9: A2(
											$author$project$Page$Dashboard$Claim$Loaded,
											claim,
											_Utils_update(
												profileSummaries,
												{
													b$: A3(
														$elm_community$list_extra$List$Extra$updateAt,
														index,
														$author$project$Profile$Summary$update(subMsg),
														profileSummaries.b$)
												}))
									}));
						default:
							return $author$project$UpdateResult$init(
								_Utils_update(
									model,
									{
										a9: A2(
											$author$project$Page$Dashboard$Claim$Loaded,
											claim,
											_Utils_update(
												profileSummaries,
												{
													c$: A2($author$project$Profile$Summary$update, subMsg, profileSummaries.c$)
												}))
									}));
					}
				} else {
					return A6(
						$author$project$UpdateResult$logImpossible,
						msg,
						'Got a Profile.Summary.Msg, but claims aren\'t loaded',
						$elm$core$Maybe$Just(loggedIn.lM),
						{mX: 'update', nW: 'Page.Dashboard.Claim'},
						_List_Nil,
						$author$project$UpdateResult$init(model));
				}
		}
	});
var $author$project$Page$Join$SignedIn = {$: 2};
var $author$project$Page$Join$update = F3(
	function (session, msg, model) {
		switch (msg.$) {
			case 0:
				if (!session.$) {
					var guest = session.a;
					return A2(
						$author$project$UpdateResult$addCmd,
						A2(
							$author$project$Route$pushUrl,
							guest.aM.eM,
							A2($author$project$Route$Register, $elm$core$Maybe$Nothing, model.j9)),
						$author$project$UpdateResult$init(model));
				} else {
					return A2(
						$author$project$UpdateResult$addExt,
						$author$project$Session$LoggedIn$RequiredAuthToken(
							{
								iU: function (_v2) {
									return $author$project$Utils$spawnMessage($author$project$Page$Join$SignedIn);
								}
							}),
						$author$project$UpdateResult$init(model));
				}
			case 1:
				var community = msg.a;
				if (!session.$) {
					return A6(
						$author$project$UpdateResult$logImpossible,
						msg,
						'Completed load community, but is still guest',
						$elm$core$Maybe$Nothing,
						{mX: 'update', nW: 'Page.Join'},
						_List_Nil,
						$author$project$UpdateResult$init(model));
				} else {
					var loggedIn = session.a;
					var isMember = A2(
						$elm$core$List$member,
						loggedIn.lM,
						A2(
							$elm$core$List$map,
							function ($) {
								return $.fl;
							},
							community.hG));
					var addAction = isMember ? $author$project$UpdateResult$addCmd(
						A2(
							$author$project$Route$pushUrl,
							loggedIn.aM.eM,
							A2($elm$core$Maybe$withDefault, $author$project$Route$Dashboard, model.j9))) : $author$project$UpdateResult$addExt(
						$author$project$Session$LoggedIn$RequestedCommunityField(1));
					return addAction(
						$author$project$UpdateResult$init(model));
				}
			default:
				if (!session.$) {
					return A6(
						$author$project$UpdateResult$logImpossible,
						msg,
						'Signed in, but is still guest',
						$elm$core$Maybe$Nothing,
						{mX: 'update', nW: 'Page.Join'},
						_List_Nil,
						$author$project$UpdateResult$init(model));
				} else {
					var loggedIn = session.a;
					var addCommunity = function () {
						var _v5 = _Utils_Tuple2(loggedIn.o7, loggedIn.kJ);
						if ((_v5.a.$ === 3) && (_v5.b.$ === 3)) {
							var community = _v5.a.a;
							var profile = _v5.b.a;
							var minimalProfile = {fl: profile.fl, cV: profile.cV, cW: profile.cW, aq: profile.aq, jh: profile.jh, ki: profile.ki};
							var communityInfo = {m_: community.cl, ck: community.ck, cm: community.cm, hC: community.hC, ki: community.ki, pl: community.pl, e9: community.e9};
							return A2(
								$elm$core$Basics$composeR,
								$author$project$UpdateResult$addExt(
									$author$project$Session$LoggedIn$ExternalBroadcast(
										$author$project$Session$LoggedIn$CommunityLoaded(
											_Utils_update(
												community,
												{
													hG: A2($elm$core$List$cons, minimalProfile, community.hG)
												})))),
								$author$project$UpdateResult$addExt(
									$author$project$Session$LoggedIn$ExternalBroadcast(
										$author$project$Session$LoggedIn$ProfileLoaded(
											_Utils_update(
												profile,
												{
													ei: A2($elm$core$List$cons, communityInfo, profile.ei)
												})))));
						} else {
							return A5(
								$author$project$UpdateResult$logImpossible,
								msg,
								'Completed sign in, but community or profile weren\'t loaded',
								$elm$core$Maybe$Just(loggedIn.lM),
								{mX: 'update', nW: 'Page.Join'},
								_List_Nil);
						}
					}();
					return A2(
						$author$project$UpdateResult$addCmd,
						A2(
							$author$project$Route$replaceUrl,
							loggedIn.aM.eM,
							A2($elm$core$Maybe$withDefault, $author$project$Route$Dashboard, model.j9)),
						addCommunity(
							$author$project$UpdateResult$init(model)));
				}
		}
	});
var $author$project$Session$Shared$Bip39Loaded = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Login$EnteringPin = function (a) {
	return {$: 1, a: a};
};
var $author$project$Session$Guest$UpdatedShared = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Login$WentToPin = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Login$GotPinComponentMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Page$Login$InputtingPin = {$: 0};
var $author$project$Page$Login$initPinModel = F2(
	function (pinVisibility, passphrase) {
		var _v0 = $author$project$View$Pin$init(
			{R: 'pinInput', nC: 'auth.pin.label', nF: $elm$core$Maybe$Nothing, oF: pinVisibility, pm: 'auth.login.submit', po: 'auth.login.submitting', pU: true});
		var pinModel = _v0.a;
		var pinCmd = _v0.b;
		return _Utils_Tuple2(
			{a6: passphrase, ag: pinModel, gE: $author$project$Page$Login$InputtingPin},
			A2($elm$core$Platform$Cmd$map, $author$project$Page$Login$GotPinComponentMsg, pinCmd));
	});
var $author$project$UpdateResult$setModel = F2(
	function (uResult, model) {
		return {Y: uResult.Y, i0: uResult.i0, jm: uResult.jm, jo: uResult.jo, nV: model, kB: uResult.kB};
	});
var $author$project$Page$Login$ClickedPaste = {$: 1};
var $author$project$Page$Login$FinishedEnteringPassphrase = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Login$GotPassphraseFormMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$Login$PassphraseGuestExternal = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Login$PassphraseIgnored = {$: 0};
var $author$project$Session$Guest$SetFeedback = function (a) {
	return {$: 1, a: a};
};
var $author$project$Log$UnsupportedFeature = 7;
var $elm$browser$Browser$Dom$setViewportOf = _Browser_setViewportOf;
var $author$project$Page$Login$updateWithPassphrase = F3(
	function (msg, model, _v0) {
		var shared = _v0.aM;
		switch (msg.$) {
			case 0:
				return $author$project$UpdateResult$init(model);
			case 1:
				return A2(
					$author$project$UpdateResult$addExt,
					$author$project$Page$Login$PassphraseGuestExternal(
						$author$project$Session$Guest$SetFeedback($author$project$View$Feedback$Hidden)),
					A2(
						$author$project$UpdateResult$addCmd,
						A2(
							$elm$core$Task$attempt,
							function (_v2) {
								return $author$project$Page$Login$PassphraseIgnored;
							},
							$elm$browser$Browser$Dom$focus('passphrase-input')),
						A2(
							$author$project$UpdateResult$addPort,
							{
								i9: $elm$json$Json$Encode$object(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'name',
											$elm$json$Json$Encode$string('readClipboard'))
										])),
								kY: $author$project$Page$Login$ClickedPaste,
								kZ: $elm$json$Json$Encode$null
							},
							$author$project$UpdateResult$init(model))));
			case 2:
				switch (msg.a.$) {
					case 0:
						var _v3 = msg.a;
						return A2(
							$author$project$UpdateResult$addExt,
							$author$project$Page$Login$PassphraseGuestExternal(
								$author$project$Session$Guest$SetFeedback(
									A2(
										$author$project$View$Feedback$Visible,
										1,
										shared.iw.il('error.clipboard.permissionDenied')))),
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{bd: false})));
					case 1:
						var _v4 = msg.a;
						return A2(
							$author$project$UpdateResult$logEvent,
							{
								mm: _List_Nil,
								nH: 2,
								nN: {mX: 'updateWithPassphrase', nW: 'Page.Login'},
								nS: 'Clipboard API not supported',
								pu: _List_fromArray(
									[
										$author$project$Log$TypeTag(7)
									]),
								pE: msg,
								pM: $elm$core$Maybe$Nothing
							},
							A2(
								$author$project$UpdateResult$addExt,
								$author$project$Page$Login$PassphraseGuestExternal(
									$author$project$Session$Guest$SetFeedback(
										A2(
											$author$project$View$Feedback$Visible,
											1,
											shared.iw.il('error.clipboard.paste.notSupported')))),
								$author$project$UpdateResult$init(
									_Utils_update(
										model,
										{bd: false}))));
					case 3:
						var _v5 = msg.a;
						return A2(
							$author$project$UpdateResult$addExt,
							$author$project$Page$Login$PassphraseGuestExternal(
								$author$project$Session$Guest$SetFeedback(
									A2(
										$author$project$View$Feedback$Visible,
										1,
										shared.iw.il('error.unknown')))),
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{bd: false})));
					default:
						var content = msg.a.a;
						return A2(
							$author$project$UpdateResult$addExt,
							$author$project$Page$Login$PassphraseGuestExternal(
								$author$project$Session$Guest$SetFeedback($author$project$View$Feedback$Hidden)),
							A2(
								$author$project$UpdateResult$addCmd,
								A2(
									$elm$core$Task$attempt,
									function (_v6) {
										return $author$project$Page$Login$PassphraseIgnored;
									},
									$elm$browser$Browser$Dom$focus('passphrase-input')),
								$author$project$UpdateResult$init(
									_Utils_update(
										model,
										{
											hk: A2(
												$author$project$Form$updateValues,
												function (oldForm) {
													return _Utils_update(
														oldForm,
														{a6: content});
												},
												model.hk),
											bd: true
										}))));
				}
			case 3:
				var scrollTop = msg.a.k5;
				return A2(
					$author$project$UpdateResult$addCmd,
					A2(
						$elm$core$Task$attempt,
						function (_v7) {
							return $author$project$Page$Login$PassphraseIgnored;
						},
						A3($elm$browser$Browser$Dom$setViewportOf, 'highlights', 0, scrollTop)),
					$author$project$UpdateResult$init(model));
			case 4:
				var subMsg = msg.a;
				return A5(
					$author$project$UpdateResult$fromChild,
					function (newForm) {
						return _Utils_update(
							model,
							{hk: newForm});
					},
					$author$project$Page$Login$GotPassphraseFormMsg,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Session$Guest$SetFeedback,
						A2($elm$core$Basics$composeR, $author$project$Page$Login$PassphraseGuestExternal, $author$project$UpdateResult$addExt)),
					model,
					A3($author$project$Form$update, shared, subMsg, model.hk));
			default:
				var passphrase = msg.a;
				return A2(
					$author$project$UpdateResult$addExt,
					$author$project$Page$Login$FinishedEnteringPassphrase(passphrase),
					$author$project$UpdateResult$init(model));
		}
	});
var $author$project$Page$Login$GeneratedAuthPhrase = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$Login$GettingAccountName = {$: 1};
var $author$project$Page$Login$GotSignInResult = F3(
	function (a, b, c) {
		return {$: 5, a: a, b: b, c: c};
	});
var $author$project$Session$Guest$LoggedIn = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Login$LoggingIn = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Login$PinGuestExternal = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Login$RevertProcess = {$: 1};
var $author$project$Page$Login$SubmittedPinWithSuccess = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Login$updateWithPin = F3(
	function (msg, model, guest) {
		var shared = guest.aM;
		switch (msg.$) {
			case 0:
				return $author$project$UpdateResult$init(model);
			case 1:
				var pin = msg.a;
				return A2(
					$author$project$UpdateResult$addPort,
					{
						i9: $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'name',
									$elm$json$Json$Encode$string('getAccountFrom12Words')),
									_Utils_Tuple2(
									'passphrase',
									$elm$json$Json$Encode$string(model.a6))
								])),
						kY: $author$project$Page$Login$SubmittedPinWithSuccess(pin),
						kZ: $elm$json$Json$Encode$string(pin)
					},
					$author$project$UpdateResult$init(
						_Utils_update(
							model,
							{gE: $author$project$Page$Login$GettingAccountName})));
			case 2:
				if (!msg.a.$) {
					var userData = msg.a.a;
					return A2(
						$author$project$UpdateResult$addCmd,
						A3($author$project$Api$Graphql$askForPhrase, shared, userData.lM, $author$project$Page$Login$GeneratedAuthPhrase),
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									gE: $author$project$Page$Login$LoggingIn(userData)
								})));
				} else {
					var err = msg.a.a;
					return A2(
						$author$project$UpdateResult$addExt,
						$author$project$Page$Login$RevertProcess,
						A2(
							$author$project$UpdateResult$addExt,
							$author$project$Page$Login$PinGuestExternal(
								$author$project$Session$Guest$SetFeedback(
									A2(
										$author$project$View$Feedback$Visible,
										1,
										shared.iw.il(err)))),
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{gE: $author$project$Page$Login$InputtingPin}))));
				}
			case 3:
				switch (msg.a.$) {
					case 3:
						var phrase = msg.a.a;
						var _v1 = model.gE;
						if (_v1.$ === 2) {
							var privateKey = _v1.a.oN;
							return A2(
								$author$project$UpdateResult$addPort,
								A3($author$project$Api$Graphql$signPhrasePort, msg, privateKey, phrase),
								$author$project$UpdateResult$init(model));
						} else {
							return A6(
								$author$project$UpdateResult$logImpossible,
								msg,
								'Generated auth phrase, but wasn\'t logging in',
								$elm$core$Maybe$Nothing,
								{mX: 'updateWithPin', nW: 'Page.Login'},
								_List_Nil,
								$author$project$UpdateResult$init(model));
						}
					case 2:
						var err = msg.a.a;
						return A2(
							$author$project$UpdateResult$addExt,
							$author$project$Page$Login$RevertProcess,
							A7(
								$author$project$UpdateResult$logGraphqlError,
								msg,
								$elm$core$Maybe$Nothing,
								'Got an error when generating auth phrase for login',
								{mX: 'updateWithPin', nW: 'Page.Login'},
								_List_Nil,
								err,
								A2(
									$author$project$UpdateResult$addExt,
									$author$project$Page$Login$PinGuestExternal(
										$author$project$Session$Guest$SetFeedback(
											A2(
												$author$project$View$Feedback$Visible,
												1,
												shared.iw.il('auth.failed_generating_phrase')))),
									$author$project$UpdateResult$init(model))));
					default:
						return $author$project$UpdateResult$init(model);
				}
			case 4:
				var signedPhrase = msg.a;
				var _v2 = model.gE;
				if (_v2.$ === 2) {
					var userData = _v2.a;
					return A2(
						$author$project$UpdateResult$addCmd,
						A3(
							$author$project$Api$Graphql$signIn,
							shared,
							{fl: userData.lM, jT: guest.j8, kx: signedPhrase},
							A2($author$project$Page$Login$GotSignInResult, userData.oN, userData.oE)),
						$author$project$UpdateResult$init(model));
				} else {
					return A6(
						$author$project$UpdateResult$logImpossible,
						msg,
						'Signed auth phrase, but wasn\'t logging in',
						$elm$core$Maybe$Nothing,
						{mX: 'updateWithPin', nW: 'Page.Login'},
						_List_Nil,
						$author$project$UpdateResult$init(model));
				}
			case 5:
				switch (msg.c.$) {
					case 3:
						var privateKey = msg.a;
						var pin = msg.b;
						var signInResponse = msg.c.a;
						return A2(
							$author$project$UpdateResult$addExt,
							$author$project$Page$Login$PinGuestExternal(
								$author$project$Session$Guest$LoggedIn(
									{oE: pin, oN: privateKey, pg: signInResponse})),
							A2(
								$author$project$UpdateResult$addPort,
								{
									i9: $elm$json$Json$Encode$object(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'name',
												$elm$json$Json$Encode$string('login')),
												_Utils_Tuple2(
												'privateKey',
												$author$project$Eos$Account$encodePrivateKey(privateKey)),
												_Utils_Tuple2(
												'passphrase',
												$elm$json$Json$Encode$string(model.a6)),
												_Utils_Tuple2(
												'accountName',
												$author$project$Eos$Account$encodeName(signInResponse.kJ.fl)),
												_Utils_Tuple2(
												'pin',
												$elm$json$Json$Encode$string(pin))
											])),
									kY: $author$project$Page$Login$PinIgnored,
									kZ: $elm$json$Json$Encode$null
								},
								A2(
									$author$project$UpdateResult$addCmd,
									$author$project$Api$Graphql$storeToken(signInResponse.pC),
									$author$project$UpdateResult$init(model))));
					case 2:
						var err = msg.c.a;
						return A2(
							$author$project$UpdateResult$addExt,
							$author$project$Page$Login$RevertProcess,
							A2(
								$author$project$UpdateResult$addExt,
								$author$project$Page$Login$PinGuestExternal(
									$author$project$Session$Guest$SetFeedback(
										A2(
											$author$project$View$Feedback$Visible,
											1,
											shared.iw.il('auth.failed')))),
								A2(
									$author$project$UpdateResult$addPort,
									{
										i9: $elm$json$Json$Encode$object(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'name',
													$elm$json$Json$Encode$string('logout'))
												])),
										kY: $author$project$Page$Login$PinIgnored,
										kZ: $elm$json$Json$Encode$null
									},
									A7(
										$author$project$UpdateResult$logGraphqlError,
										msg,
										$elm$core$Maybe$Nothing,
										'Got an error when trying to login',
										{mX: 'updateWithPin', nW: 'Page.Login'},
										_List_Nil,
										err,
										$author$project$UpdateResult$init(model)))));
					case 0:
						var _v3 = msg.c;
						return $author$project$UpdateResult$init(model);
					default:
						var _v4 = msg.c;
						return $author$project$UpdateResult$init(model);
				}
			default:
				var subMsg = msg.a;
				return A5(
					$author$project$UpdateResult$fromChild,
					function (pinModel) {
						return _Utils_update(
							model,
							{ag: pinModel});
					},
					$author$project$Page$Login$GotPinComponentMsg,
					F2(
						function (ext, ur) {
							if (ext.$ === 1) {
								var feedback = ext.a;
								return A2(
									$author$project$UpdateResult$addExt,
									$author$project$Page$Login$PinGuestExternal(
										$author$project$Session$Guest$SetFeedback(feedback)),
									ur);
							} else {
								var pin = ext.a;
								var _v6 = A4($author$project$View$Pin$postSubmitAction, ur.nV.ag, pin, shared, $author$project$Page$Login$SubmittedPinWithSuccess);
								var newShared = _v6.a;
								var submitCmd = _v6.b;
								return A2(
									$author$project$UpdateResult$addExt,
									$author$project$Page$Login$PinGuestExternal(
										$author$project$Session$Guest$UpdatedShared(newShared)),
									A2($author$project$UpdateResult$addCmd, submitCmd, ur));
							}
						}),
					model,
					A3($author$project$View$Pin$update, shared, subMsg, model.ag));
		}
	});
var $author$project$Page$Login$update = F3(
	function (msg, model, guest) {
		var _v0 = _Utils_Tuple2(msg, model);
		switch (_v0.a.$) {
			case 3:
				var bip39 = _v0.a.a;
				var oldShared = guest.aM;
				return A2(
					$author$project$UpdateResult$addExt,
					$author$project$Session$Guest$UpdatedShared(
						_Utils_update(
							oldShared,
							{
								ft: $author$project$Session$Shared$Bip39Loaded(bip39)
							})),
					$author$project$UpdateResult$init(model));
			case 1:
				if (!_v0.b.$) {
					var passphraseMsg = _v0.a.a;
					var passphraseModel = _v0.b.a;
					return A4(
						$author$project$UpdateResult$map,
						$author$project$Page$Login$EnteringPassphrase,
						$author$project$Page$Login$GotPassphraseMsg,
						F2(
							function (ext, ur) {
								if (!ext.$) {
									var validPassphrase = ext.a;
									return A2(
										$author$project$UpdateResult$addMsg,
										$author$project$Page$Login$WentToPin(validPassphrase),
										ur);
								} else {
									var guestExternal = ext.a;
									return A2($author$project$UpdateResult$addExt, guestExternal, ur);
								}
							}),
						A3($author$project$Page$Login$updateWithPassphrase, passphraseMsg, passphraseModel, guest));
				} else {
					return A5(
						$author$project$UpdateResult$logIncompatibleMsg,
						msg,
						$elm$core$Maybe$Nothing,
						{mX: 'update', nW: 'Page.Login'},
						_List_Nil,
						$author$project$UpdateResult$init(model));
				}
			case 0:
				if (!_v0.b.$) {
					var passphrase = _v0.a.a;
					var _v2 = A2($author$project$Page$Login$initPinModel, guest.aM.oF, passphrase);
					var pinModel = _v2.a;
					var pinCmd = _v2.b;
					return A2(
						$author$project$UpdateResult$addCmd,
						A2($elm$core$Platform$Cmd$map, $author$project$Page$Login$GotPinMsg, pinCmd),
						$author$project$UpdateResult$init(
							$author$project$Page$Login$EnteringPin(pinModel)));
				} else {
					return A5(
						$author$project$UpdateResult$logIncompatibleMsg,
						msg,
						$elm$core$Maybe$Nothing,
						{mX: 'update', nW: 'Page.Login'},
						_List_Nil,
						$author$project$UpdateResult$init(model));
				}
			default:
				if (_v0.b.$ === 1) {
					var pinMsg = _v0.a.a;
					var pinModel = _v0.b.a;
					return A4(
						$author$project$UpdateResult$map,
						$author$project$Page$Login$EnteringPin,
						$author$project$Page$Login$GotPinMsg,
						F2(
							function (ext, ur) {
								if (!ext.$) {
									var guestExternal = ext.a;
									return A2($author$project$UpdateResult$addExt, guestExternal, ur);
								} else {
									return A2(
										$author$project$UpdateResult$setModel,
										ur,
										$author$project$Page$Login$EnteringPassphrase($author$project$Page$Login$initPassphraseModel));
								}
							}),
						A3($author$project$Page$Login$updateWithPin, pinMsg, pinModel, guest));
				} else {
					return A5(
						$author$project$UpdateResult$logIncompatibleMsg,
						msg,
						$elm$core$Maybe$Nothing,
						{mX: 'update', nW: 'Page.Login'},
						_List_Nil,
						$author$project$UpdateResult$init(model));
				}
		}
	});
var $author$project$Page$News$CompletedMarkingNewsAsRead = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$News$CompletedTogglingReaction = F3(
	function (a, b, c) {
		return {$: 5, a: a, b: b, c: c};
	});
var $author$project$Cambiatus$Enum$ReactionEnum$toString = function (enum____) {
	switch (enum____) {
		case 0:
			return 'CLAPPING_HANDS';
		case 1:
			return 'FACE_WITH_RAISED_EYEBROW';
		case 2:
			return 'GRINNING_FACE_WITH_BIG_EYES';
		case 3:
			return 'PARTY_POPPER';
		case 4:
			return 'RED_HEART';
		case 5:
			return 'ROCKET';
		case 6:
			return 'SLIGHTLY_FROWNING_FACE';
		case 7:
			return 'SMILING_FACE_WITH_HEART_EYES';
		case 8:
			return 'THUMBS_DOWN';
		default:
			return 'THUMBS_UP';
	}
};
var $author$project$Cambiatus$Mutation$reactToNews = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'reactToNews',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'newsId', requiredArgs____.bh, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int),
					A3(
					$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required,
					'reactions',
					requiredArgs____.kP,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Cambiatus$Enum$ReactionEnum$toString)))
				]),
			object____,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
	});
var $author$project$Community$News$reactToNews = F2(
	function (news, args) {
		return A2(
			$author$project$Cambiatus$Mutation$reactToNews,
			{
				bh: args.bh,
				kP: function () {
					var _v0 = news.h5;
					if (_v0.$ === 1) {
						return _List_fromArray(
							[args.e_]);
					} else {
						var receipt = _v0.a;
						return A2($elm$core$List$member, args.e_, receipt.kP) ? A2(
							$elm$core$List$filter,
							$elm$core$Basics$neq(args.e_),
							receipt.kP) : A2($elm$core$List$cons, args.e_, receipt.kP);
					}
				}()
			},
			$author$project$Community$News$receiptSelectionSet);
	});
var $author$project$Cambiatus$Mutation$read = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'read',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'newsId', requiredArgs____.bh, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int)
				]),
			object____,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
	});
var $elm$core$Tuple$second = function (_v0) {
	var y = _v0.b;
	return y;
};
var $author$project$Page$News$update = F3(
	function (msg, model, loggedIn) {
		switch (msg.$) {
			case 0:
				return $author$project$UpdateResult$init(model);
			case 1:
				var news = msg.a;
				var markNewsAsRead = function () {
					var _v1 = A2(
						$elm$core$Maybe$andThen,
						function (newsId) {
							return A2(
								$elm_community$list_extra$List$Extra$find,
								function (_v2) {
									var id = _v2.R;
									return _Utils_eq(id, newsId);
								},
								news);
						},
						model.bh);
					if (_v1.$ === 1) {
						return $elm$core$Basics$identity;
					} else {
						var selectedNews = _v1.a;
						var _v3 = selectedNews.h5;
						if (!_v3.$) {
							return $elm$core$Basics$identity;
						} else {
							return $author$project$UpdateResult$addExt(
								A3(
									$author$project$Session$LoggedIn$mutation,
									loggedIn,
									A2(
										$author$project$Cambiatus$Mutation$read,
										{bh: selectedNews.R},
										$author$project$Community$News$receiptSelectionSet),
									$author$project$Page$News$CompletedMarkingNewsAsRead));
						}
					}
				}();
				return markNewsAsRead(
					$author$project$UpdateResult$init(model));
			case 2:
				switch (msg.a.$) {
					case 3:
						var maybeReceipt = msg.a.a;
						return A2(
							$author$project$UpdateResult$addBreadcrumb,
							{
								fw: msg,
								i9: function () {
									var _v4 = model.bh;
									if (_v4.$ === 1) {
										return $elm$core$Dict$empty;
									} else {
										var newsId = _v4.a;
										return $elm$core$Dict$fromList(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'News id',
													$elm$json$Json$Encode$int(newsId))
												]));
									}
								}(),
								nH: 3,
								nS: 'Completed marking news as read',
								d0: 3
							},
							A2(
								$author$project$UpdateResult$addExt,
								$author$project$Session$LoggedIn$UpdatedLoggedIn(
									_Utils_update(
										loggedIn,
										{
											j7: A2(
												$elm$core$Maybe$map,
												function (highlightedNews) {
													return _Utils_update(
														highlightedNews,
														{h5: maybeReceipt});
												},
												loggedIn.j7)
										})),
								$author$project$UpdateResult$init(model)));
					case 2:
						var err = msg.a.a;
						return A7(
							$author$project$UpdateResult$logGraphqlError,
							msg,
							$elm$core$Maybe$Just(loggedIn.lM),
							'Got an error when marking news as read',
							{mX: 'update', nW: 'Page.News'},
							_List_Nil,
							err,
							$author$project$UpdateResult$init(model));
					case 0:
						var _v5 = msg.a;
						return $author$project$UpdateResult$init(model);
					default:
						var _v6 = msg.a;
						return $author$project$UpdateResult$init(model);
				}
			case 3:
				return A2(
					$author$project$UpdateResult$addCmd,
					model.bW ? A2(
						$elm$core$Task$attempt,
						function (_v7) {
							return $author$project$Page$News$NoOp;
						},
						$elm$browser$Browser$Dom$focus('reaction-picker')) : A2(
						$elm$core$Task$attempt,
						function (_v8) {
							return $author$project$Page$News$NoOp;
						},
						$elm$browser$Browser$Dom$focus('reaction-0')),
					$author$project$UpdateResult$init(
						_Utils_update(
							model,
							{bW: !model.bW})));
			case 4:
				var reaction = msg.a;
				var maybeSelectedNews = A2(
					$elm$core$Maybe$andThen,
					function (news) {
						return A2(
							$elm$core$Maybe$andThen,
							function (currentId) {
								return A2(
									$elm_community$list_extra$List$Extra$find,
									function (_v10) {
										var id = _v10.R;
										return _Utils_eq(id, currentId);
									},
									news);
							},
							model.bh);
					},
					A2(
						$elm$core$Maybe$map,
						$elm$core$Tuple$second,
						$krisajenkins$remotedata$RemoteData$toMaybe(
							A2(
								$author$project$Community$getField,
								loggedIn.o7,
								function ($) {
									return $.eO;
								}))));
				if (!maybeSelectedNews.$) {
					var selectedNews = maybeSelectedNews.a;
					return A2(
						$author$project$UpdateResult$addExt,
						A3(
							$author$project$Session$LoggedIn$mutation,
							loggedIn,
							A2(
								$author$project$Community$News$reactToNews,
								selectedNews,
								{bh: selectedNews.R, e_: reaction}),
							A2($author$project$Page$News$CompletedTogglingReaction, reaction, selectedNews)),
						$author$project$UpdateResult$init(model));
				} else {
					return $author$project$UpdateResult$init(model);
				}
			case 5:
				switch (msg.c.$) {
					case 3:
						var reaction = msg.a;
						var selectedNews = msg.b;
						var receipt = msg.c.a;
						var _v11 = A2(
							$author$project$Community$getField,
							loggedIn.o7,
							function ($) {
								return $.eO;
							});
						if (_v11.$ === 3) {
							var _v12 = _v11.a;
							var news = _v12.b;
							var reactionAlreadyExists = A2(
								$elm$core$List$any,
								function (reactionWithCount) {
									return _Utils_eq(reactionWithCount.e_, reaction);
								},
								selectedNews.kP);
							var hasAdded = A2(
								$elm$core$List$member,
								reaction,
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2(
										$elm$core$Maybe$map,
										function ($) {
											return $.kP;
										},
										receipt)));
							var newReactions = reactionAlreadyExists ? A3(
								$elm_community$list_extra$List$Extra$updateIf,
								function (reactionWithCount) {
									return _Utils_eq(reactionWithCount.e_, reaction);
								},
								function (prevReaction) {
									return {
										mo: hasAdded ? (prevReaction.mo + 1) : (prevReaction.mo - 1),
										e_: reaction
									};
								},
								selectedNews.kP) : A2(
								$elm$core$List$cons,
								{mo: 1, e_: reaction},
								selectedNews.kP);
							var newNews = A3(
								$elm_community$list_extra$List$Extra$updateIf,
								$elm$core$Basics$eq(selectedNews),
								function (_v13) {
									return _Utils_update(
										selectedNews,
										{kP: newReactions, h5: receipt});
								},
								news);
							return A2(
								$author$project$UpdateResult$addExt,
								$author$project$Session$LoggedIn$SetCommunityField(
									$author$project$Community$NewsValue(newNews)),
								$author$project$UpdateResult$init(model));
						} else {
							return A6(
								$author$project$UpdateResult$logImpossible,
								msg,
								'Completed toggling reaction, but community wasn\'t loaded',
								$elm$core$Maybe$Just(loggedIn.lM),
								{mX: 'update', nW: 'Page.News'},
								_List_fromArray(
									[
										$author$project$Log$contextFromCommunity(loggedIn.o7)
									]),
								$author$project$UpdateResult$init(model));
						}
					case 2:
						var err = msg.c.a;
						return A7(
							$author$project$UpdateResult$logGraphqlError,
							msg,
							$elm$core$Maybe$Just(loggedIn.lM),
							'Got an error when reacting to news',
							{mX: 'update', nW: 'Page.News'},
							_List_Nil,
							err,
							$author$project$UpdateResult$init(model));
					case 1:
						var _v14 = msg.c;
						return $author$project$UpdateResult$init(model);
					default:
						var _v15 = msg.c;
						return $author$project$UpdateResult$init(model);
				}
			default:
				var subMsg = msg.a;
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{
							eI: A2($author$project$Profile$Summary$update, subMsg, model.eI)
						}));
		}
	});
var $author$project$Page$Notification$CompletedReading = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Notification$Loaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Cambiatus$InputObject$encodeReadNotificationInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$int(input____.R)))
			]));
};
var $author$project$Cambiatus$Mutation$readNotification = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'readNotification',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.nl, $author$project$Cambiatus$InputObject$encodeReadNotificationInput)
				]),
			object____,
			$elm$core$Basics$identity);
	});
var $author$project$Notification$markAsReadMutation = function (id) {
	return A2(
		$author$project$Cambiatus$Mutation$readNotification,
		{
			nl: {R: id}
		},
		$author$project$Notification$notificationHistorySelectionSet);
};
var $author$project$Page$Notification$update = F3(
	function (msg, model, loggedIn) {
		switch (msg.$) {
			case 0:
				switch (msg.a.$) {
					case 3:
						var notifications = msg.a.a;
						return $author$project$UpdateResult$init(
							$author$project$Page$Notification$Loaded(notifications));
					case 2:
						var err = msg.a.a;
						return A7(
							$author$project$UpdateResult$logGraphqlError,
							msg,
							$elm$core$Maybe$Just(loggedIn.lM),
							'Got an error when trying to load notification history',
							{mX: 'update', nW: 'Page.Notification'},
							_List_fromArray(
								[
									$author$project$Log$contextFromCommunity(loggedIn.o7)
								]),
							err,
							$author$project$UpdateResult$init(model));
					default:
						return $author$project$UpdateResult$init(model);
				}
			case 1:
				var notificationId = msg.a;
				var data = msg.b;
				var redirectCmd = function (newCommunity) {
					var _v2 = loggedIn.o7;
					if (_v2.$ === 3) {
						var community = _v2.a;
						return _Utils_eq(community.e9, newCommunity.e9) ? $author$project$Route$replaceUrl(loggedIn.aM.eM) : A2($author$project$Route$loadExternalCommunity, loggedIn.aM, newCommunity);
					} else {
						return function (_v3) {
							return $elm$core$Platform$Cmd$none;
						};
					}
				};
				var markAsRead = A3(
					$author$project$Session$LoggedIn$mutation,
					loggedIn,
					$author$project$Notification$markAsReadMutation(notificationId),
					$author$project$Page$Notification$CompletedReading);
				switch (data.$) {
					case 0:
						var transfer = data.a;
						return A2(
							$author$project$UpdateResult$addCmd,
							A2(
								redirectCmd,
								transfer.b9,
								$author$project$Route$ViewTransfer(transfer.R)),
							A2(
								$author$project$UpdateResult$addExt,
								markAsRead,
								$author$project$UpdateResult$init(model)));
					case 2:
						return A2(
							$author$project$UpdateResult$addExt,
							markAsRead,
							$author$project$UpdateResult$init(model));
					default:
						var sale = data.a;
						return A2(
							$author$project$UpdateResult$addCmd,
							A2(
								redirectCmd,
								sale.oP.b9,
								$author$project$Route$ViewSale(sale.oP.R)),
							A2(
								$author$project$UpdateResult$addExt,
								markAsRead,
								$author$project$UpdateResult$init(model)));
				}
			default:
				switch (msg.a.$) {
					case 3:
						var hist = msg.a.a;
						if (model.$ === 1) {
							var histories = model.a;
							var updatedHistories = A2(
								$elm$core$List$map,
								function (h) {
									return _Utils_eq(h.R, hist.R) ? _Utils_update(
										h,
										{nv: true}) : h;
								},
								histories);
							return $author$project$UpdateResult$init(
								$author$project$Page$Notification$Loaded(updatedHistories));
						} else {
							return A6(
								$author$project$UpdateResult$logImpossible,
								msg,
								'Completed reading notification, but notifications weren\'t loaded',
								$elm$core$Maybe$Just(loggedIn.lM),
								{mX: 'update', nW: 'Page.Notification'},
								_List_Nil,
								$author$project$UpdateResult$init(model));
						}
					case 2:
						var e = msg.a.a;
						return A7(
							$author$project$UpdateResult$logGraphqlError,
							msg,
							$elm$core$Maybe$Just(loggedIn.lM),
							'Got an error when reading notification',
							{mX: 'update', nW: 'Page.Notification'},
							_List_Nil,
							e,
							$author$project$UpdateResult$init(model));
					default:
						return $author$project$UpdateResult$init(model);
				}
		}
	});
var $author$project$Page$PaymentHistory$Failed = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$PaymentHistory$GotDatePickerMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Page$PaymentHistory$GotUserPickerMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$PaymentHistory$Loaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$PaymentHistory$NoOp = {$: 0};
var $author$project$Form$DatePicker$Options = $elm$core$Basics$identity;
var $author$project$Form$DatePicker$init = function (_v0) {
	var label = _v0.nC;
	var id = _v0.R;
	return {d5: true, mg: _List_Nil, cf: false, R: id, nC: label};
};
var $author$project$Form$DatePicker$withContainerAttrs = F2(
	function (attrs, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				mg: _Utils_ap(options.mg, attrs)
			});
	});
var $author$project$Page$PaymentHistory$datePickerOptions = function (_v0) {
	var translators = _v0.iw;
	return A2(
		$author$project$Form$DatePicker$withContainerAttrs,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('my-4')
			]),
		$author$project$Form$DatePicker$init(
			{
				R: 'date-picker',
				nC: translators.il('payment_history.date')
			}));
};
var $author$project$Page$PaymentHistory$datePickerViewConfig = F2(
	function (_v0, model) {
		var translators = _v0.iw;
		return {
			mM: $elm$html$Html$text(''),
			m$: false,
			nx: false,
			iw: translators,
			pO: model.ep
		};
	});
var $author$project$Page$PaymentHistory$RecipientProfileWithTransfersLoaded = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$PaymentHistory$ProfileWithTransfers = F7(
	function (name, account, avatar, email, bio, contacts, transfers) {
		return {fl: account, cV: avatar, cW: bio, aq: contacts, jh: email, ki: name, an: transfers};
	});
var $author$project$Cambiatus$Enum$TransferDirectionValue$Receiving = 0;
var $author$project$Page$PaymentHistory$profileWithTransfersSelectionSet = F2(
	function (community, model) {
		var optionalFromAccount = function () {
			var _v2 = model.fq;
			if (!_v2.$) {
				var p = _v2.a;
				return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
					$author$project$Eos$Account$nameToString(p.fl));
			} else {
				return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent;
			}
		}();
		var optionalDate = function () {
			var _v1 = model.bQ;
			if (!_v1.$) {
				var d = _v1.a;
				return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
					$justinmimbs$date$Date$toIsoString(d));
			} else {
				return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent;
			}
		}();
		var endCursor = A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.mI;
			},
			model.cr);
		var afterOption = function () {
			if (!endCursor.$) {
				var ec = endCursor.a;
				return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(ec);
			} else {
				return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent;
			}
		}();
		var optionalArgsFn = function (r) {
			return _Utils_update(
				r,
				{
					gQ: afterOption,
					hh: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
						{
							c1: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
								$author$project$Eos$symbolToString(community.e9)),
							c7: optionalDate,
							F: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
								{
									F: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(0),
									dJ: optionalFromAccount
								})
						}),
					hj: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(16)
				});
		};
		return A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			A2($author$project$Cambiatus$Object$User$transfers, optionalArgsFn, $author$project$Transfer$transferConnectionSelectionSet),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Profile$userContactSelectionSet,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$Markdown$maybeSelectionSet($author$project$Cambiatus$Object$User$bio),
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$Cambiatus$Object$User$email,
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							$author$project$Avatar$selectionSet($author$project$Cambiatus$Object$User$avatar),
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
								$author$project$Eos$Account$nameSelectionSet($author$project$Cambiatus$Object$User$account),
								A2(
									$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
									$author$project$Cambiatus$Object$User$name,
									$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Page$PaymentHistory$ProfileWithTransfers))))))));
	});
var $author$project$Page$PaymentHistory$fetchProfileWithTransfers = F3(
	function (loggedIn, community, model) {
		var accountName = $author$project$Eos$Account$nameToString(model.oZ.fl);
		return A3(
			$author$project$Session$LoggedIn$query,
			loggedIn,
			A2(
				$author$project$Cambiatus$Query$user,
				{fl: accountName},
				A2($author$project$Page$PaymentHistory$profileWithTransfersSelectionSet, community, model)),
			$author$project$Page$PaymentHistory$RecipientProfileWithTransfersLoaded);
	});
var $author$project$Page$PaymentHistory$AutocompleteProfilesLoaded = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$PaymentHistory$ProfileWithOnlyAutocomplete = function (getPayersByAccount) {
	return {jv: getPayersByAccount};
};
var $author$project$Cambiatus$Object$User$getPayersByAccount = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'getPayersByAccount',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'account', requiredArgs____.fl, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)
				]),
			object____,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Basics$identity,
				A2(
					$elm$core$Basics$composeR,
					$elm$json$Json$Decode$nullable,
					A2($elm$core$Basics$composeR, $elm$json$Json$Decode$list, $elm$json$Json$Decode$nullable))));
	});
var $author$project$Page$PaymentHistory$fetchProfilesForAutocomplete = F3(
	function (loggedIn, model, payerAccount) {
		var autocompleteSelectionSet = A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Profile$userContactSelectionSet,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Markdown$maybeSelectionSet($author$project$Cambiatus$Object$User$bio),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$Cambiatus$Object$User$email,
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$Avatar$selectionSet($author$project$Cambiatus$Object$User$avatar),
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							$author$project$Eos$Account$nameSelectionSet($author$project$Cambiatus$Object$User$account),
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
								$author$project$Cambiatus$Object$User$name,
								$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Profile$Minimal)))))));
		var selectionSet = A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
			$author$project$Page$PaymentHistory$ProfileWithOnlyAutocomplete,
			A2(
				$author$project$Cambiatus$Object$User$getPayersByAccount,
				{fl: payerAccount},
				autocompleteSelectionSet));
		var accountName = $author$project$Eos$Account$nameToString(model.oZ.fl);
		return A3(
			$author$project$Session$LoggedIn$query,
			loggedIn,
			A2(
				$author$project$Cambiatus$Query$user,
				{fl: accountName},
				selectionSet),
			$author$project$Page$PaymentHistory$AutocompleteProfilesLoaded);
	});
var $author$project$Form$UserPicker$fromSinglePicker = function (_v0) {
	var model = _v0;
	return {R: model.R, dT: model.dT, W: model.W};
};
var $author$project$View$Select$queryFromState = function (model) {
	return $author$project$View$Select$unwrapModel(model).dO;
};
var $author$project$Form$UserPicker$getCurrentQuery = function (_v0) {
	var model = _v0;
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		$author$project$View$Select$queryFromState(model.dT));
};
var $author$project$Form$DatePicker$getDate = function (_v0) {
	var model = _v0;
	return model.bQ;
};
var $author$project$Form$UserPicker$getSingleProfile = function (_v0) {
	var model = _v0;
	return A2(
		$elm$core$Maybe$map,
		function ($) {
			return $.kJ;
		},
		model.W);
};
var $author$project$Page$PaymentHistory$getTransfers = function (maybeObj) {
	var toNodes = function (maybeNodes) {
		return A2($elm$core$List$filterMap, $elm$core$Basics$identity, maybeNodes);
	};
	var toMaybeNodes = function (edges) {
		return A2(
			$elm$core$List$map,
			function (a) {
				return A2(
					$elm$core$Maybe$andThen,
					function (b) {
						return b.n1;
					},
					a);
			},
			edges);
	};
	var toMaybeEdges = function (maybeConn) {
		return A2(
			$elm$core$Maybe$andThen,
			function (a) {
				return a.mF;
			},
			maybeConn);
	};
	var toEdges = function (maybeEdges) {
		return A2($elm$core$Maybe$withDefault, _List_Nil, maybeEdges);
	};
	return toNodes(
		toMaybeNodes(
			toEdges(
				toMaybeEdges(maybeObj))));
};
var $author$project$Form$UserPicker$toSinglePicker = function (_v0) {
	var model = _v0;
	var _v1 = model.W;
	var maybeProfile = _v1;
	return {R: model.R, dT: model.dT, W: maybeProfile};
};
var $elm_community$list_extra$List$Extra$uniqueBy = F2(
	function (f, list) {
		return A4($elm_community$list_extra$List$Extra$uniqueHelp, f, _List_Nil, list, _List_Nil);
	});
var $author$project$Form$UserPicker$Options = $elm$core$Basics$identity;
var $author$project$Form$UserPicker$init = function (_v0) {
	var label = _v0.nC;
	var currentUser = _v0.eo;
	var profiles = _v0.eX;
	return {
		d9: true,
		mg: _List_Nil,
		eo: currentUser,
		cf: false,
		nC: label,
		dB: '',
		eW: {dP: $elm$core$Maybe$Nothing, gv: $elm$core$Maybe$Nothing},
		eX: profiles
	};
};
var $author$project$Form$UserPicker$withContainerAttrs = F2(
	function (attrs, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				mg: _Utils_ap(options.mg, attrs)
			});
	});
var $author$project$Page$PaymentHistory$userPickerOptions = F2(
	function (loggedIn, profiles) {
		return A2(
			$author$project$Form$UserPicker$withContainerAttrs,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('my-4')
				]),
			$author$project$Form$UserPicker$init(
				{
					eo: loggedIn.lM,
					nC: loggedIn.aM.iw.il('payment_history.user'),
					eX: profiles
				}));
	});
var $author$project$Page$PaymentHistory$userPickerViewConfig = F2(
	function (_v0, model) {
		var translators = _v0.iw;
		return {
			mM: $elm$html$Html$text(''),
			m$: false,
			od: $author$project$Page$PaymentHistory$NoOp,
			iw: translators,
			pO: $author$project$Form$UserPicker$fromSinglePicker(model.cO)
		};
	});
var $author$project$Page$PaymentHistory$update = F3(
	function (msg, model, loggedIn) {
		var shared = loggedIn.aM;
		switch (msg.$) {
			case 0:
				return $author$project$UpdateResult$init(model);
			case 1:
				var community = msg.a;
				return A2(
					$author$project$UpdateResult$addExt,
					A3($author$project$Page$PaymentHistory$fetchProfileWithTransfers, loggedIn, community, model),
					$author$project$UpdateResult$init(
						_Utils_update(
							model,
							{ax: true})));
			case 3:
				switch (msg.a.$) {
					case 3:
						var maybeProfileWithPayers = msg.a.a;
						if (!maybeProfileWithPayers.$) {
							var profileWithPayers = maybeProfileWithPayers.a;
							var toList = function (p) {
								if (!p.$) {
									var val = p.a;
									return _List_fromArray(
										[val]);
								} else {
									return _List_Nil;
								}
							};
							var payers = A2($elm$core$Maybe$withDefault, _List_Nil, profileWithPayers.jv);
							var profiles = A2($elm$core$List$concatMap, toList, payers);
							return $author$project$UpdateResult$init(
								_Utils_update(
									model,
									{eb: profiles}));
						} else {
							return $author$project$UpdateResult$init(model);
						}
					case 2:
						var err = msg.a.a;
						return A7(
							$author$project$UpdateResult$logGraphqlError,
							msg,
							$elm$core$Maybe$Just(loggedIn.lM),
							'Got an error when loading profiles for auto complete',
							{mX: 'update', nW: 'Page.PaymentHistory'},
							_List_fromArray(
								[
									$author$project$Log$contextFromCommunity(loggedIn.o7)
								]),
							err,
							$author$project$UpdateResult$init(model));
					default:
						return $author$project$UpdateResult$init(model);
				}
			case 2:
				switch (msg.a.$) {
					case 3:
						var maybeProfile = msg.a.a;
						if (!maybeProfile.$) {
							var profile = maybeProfile.a;
							var recipientProfile = {fl: profile.fl, cV: profile.cV, cW: profile.cW, aq: profile.aq, jh: profile.jh, ki: profile.ki};
							var pageInfo = A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.oz;
								},
								profile.an);
							var newIncomingTransfers = function () {
								var _v4 = model.cq;
								if (!_v4.$) {
									var transfers = _v4.a;
									return A2(
										$elm_community$list_extra$List$Extra$uniqueBy,
										function ($) {
											return $.R;
										},
										_Utils_ap(
											transfers,
											$author$project$Page$PaymentHistory$getTransfers(profile.an)));
								} else {
									return $author$project$Page$PaymentHistory$getTransfers(profile.an);
								}
							}();
							var newModel = _Utils_update(
								model,
								{
									cq: $elm$core$Maybe$Just(newIncomingTransfers),
									cr: pageInfo,
									ax: false,
									eZ: $author$project$Page$PaymentHistory$Loaded(profile),
									oZ: recipientProfile
								});
							return $author$project$UpdateResult$init(newModel);
						} else {
							return $author$project$UpdateResult$init(
								_Utils_update(
									model,
									{ax: false}));
						}
					case 2:
						var err = msg.a.a;
						return A7(
							$author$project$UpdateResult$logGraphqlError,
							msg,
							$elm$core$Maybe$Just(loggedIn.lM),
							'Got an error when loading recipient profile with transfers',
							{mX: 'update', nW: 'Page.PaymentHistory'},
							_List_Nil,
							err,
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{
										ax: false,
										eZ: $author$project$Page$PaymentHistory$Failed(err)
									})));
					default:
						return $author$project$UpdateResult$init(
							_Utils_update(
								model,
								{ax: false}));
				}
			case 6:
				if (model.ax) {
					return $author$project$UpdateResult$init(model);
				} else {
					var _v5 = loggedIn.o7;
					if (_v5.$ === 3) {
						var community = _v5.a;
						return A2(
							$author$project$UpdateResult$addExt,
							A3($author$project$Page$PaymentHistory$fetchProfileWithTransfers, loggedIn, community, model),
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{ax: true})));
					} else {
						return A6(
							$author$project$UpdateResult$logImpossible,
							msg,
							'Clicked show more, but community wasn\'t loaded',
							$elm$core$Maybe$Just(loggedIn.lM),
							{mX: 'update', nW: 'Page.PaymentHistory'},
							_List_Nil,
							$author$project$UpdateResult$init(model));
					}
				}
			case 4:
				var subMsg = msg.a;
				var _v6 = function (_v7) {
					var userPicker = _v7.a;
					var cmd = _v7.b;
					var maybeMsg_ = _v7.c;
					return _Utils_Tuple3(
						$author$project$Form$UserPicker$toSinglePicker(userPicker),
						cmd,
						maybeMsg_);
				}(
					A4(
						$author$project$Form$UserPicker$update,
						A2($author$project$Page$PaymentHistory$userPickerOptions, loggedIn, model.eb),
						A2($author$project$Page$PaymentHistory$userPickerViewConfig, loggedIn.aM, model),
						subMsg,
						$author$project$Form$UserPicker$fromSinglePicker(model.cO)));
				var newUserPicker = _v6.a;
				var userPickerCmd = _v6.b;
				var maybeMsg = _v6.c;
				var fetchProfileInfo = _Utils_eq(
					$author$project$Form$UserPicker$getCurrentQuery(
						$author$project$Form$UserPicker$fromSinglePicker(newUserPicker)),
					$author$project$Form$UserPicker$getCurrentQuery(
						$author$project$Form$UserPicker$fromSinglePicker(model.cO))) ? $elm$core$Basics$identity : $author$project$UpdateResult$addExt(
					A3(
						$author$project$Page$PaymentHistory$fetchProfilesForAutocomplete,
						loggedIn,
						model,
						$author$project$Form$UserPicker$getCurrentQuery(
							$author$project$Form$UserPicker$fromSinglePicker(newUserPicker))));
				var modelWithUserPicker = _Utils_update(
					model,
					{
						fq: $author$project$Form$UserPicker$getSingleProfile(newUserPicker),
						cO: newUserPicker
					});
				var _v8 = function () {
					if (_Utils_eq(
						$author$project$Form$UserPicker$getSingleProfile(newUserPicker),
						$author$project$Form$UserPicker$getSingleProfile(model.cO))) {
						return _Utils_Tuple2(modelWithUserPicker, $elm$core$Basics$identity);
					} else {
						var _v9 = loggedIn.o7;
						if (_v9.$ === 3) {
							var community = _v9.a;
							var newModel_ = _Utils_update(
								modelWithUserPicker,
								{cq: $elm$core$Maybe$Nothing, cr: $elm$core$Maybe$Nothing, ax: true});
							return _Utils_Tuple2(
								newModel_,
								$author$project$UpdateResult$addExt(
									A3($author$project$Page$PaymentHistory$fetchProfileWithTransfers, loggedIn, community, newModel_)));
						} else {
							return _Utils_Tuple2(
								modelWithUserPicker,
								A5(
									$author$project$UpdateResult$logImpossible,
									msg,
									'Picked a user, but community wasn\'t loaded',
									$elm$core$Maybe$Just(loggedIn.lM),
									{mX: 'update', nW: 'Page.PaymentHistory'},
									_List_Nil));
						}
					}
				}();
				var newModel = _v8.a;
				var fetchProfiles = _v8.b;
				return fetchProfileInfo(
					fetchProfiles(
						A2(
							$author$project$UpdateResult$addMsg,
							A2($elm$core$Maybe$withDefault, $author$project$Page$PaymentHistory$NoOp, maybeMsg),
							A2(
								$author$project$UpdateResult$addCmd,
								A2($elm$core$Platform$Cmd$map, $author$project$Page$PaymentHistory$GotUserPickerMsg, userPickerCmd),
								$author$project$UpdateResult$init(newModel)))));
			default:
				var subMsg = msg.a;
				var _v10 = A4(
					$author$project$Form$DatePicker$update,
					$author$project$Page$PaymentHistory$datePickerOptions(shared),
					A2($author$project$Page$PaymentHistory$datePickerViewConfig, shared, model),
					subMsg,
					model.ep);
				var newDatePicker = _v10.a;
				var datePickerCmd = _v10.b;
				var modelWithDatePicker = _Utils_update(
					model,
					{
						ep: newDatePicker,
						bQ: $author$project$Form$DatePicker$getDate(newDatePicker)
					});
				var _v11 = function () {
					if (_Utils_eq(modelWithDatePicker.bQ, model.bQ)) {
						return _Utils_Tuple2(modelWithDatePicker, $elm$core$Basics$identity);
					} else {
						var _v12 = loggedIn.o7;
						if (_v12.$ === 3) {
							var community = _v12.a;
							var newModel_ = _Utils_update(
								modelWithDatePicker,
								{cq: $elm$core$Maybe$Nothing, cr: $elm$core$Maybe$Nothing, ax: true});
							return _Utils_Tuple2(
								newModel_,
								$author$project$UpdateResult$addExt(
									A3($author$project$Page$PaymentHistory$fetchProfileWithTransfers, loggedIn, community, newModel_)));
						} else {
							return _Utils_Tuple2(
								modelWithDatePicker,
								A5(
									$author$project$UpdateResult$logImpossible,
									msg,
									'Picked a date, but community wasn\'t loaded',
									$elm$core$Maybe$Just(loggedIn.lM),
									{mX: 'update', nW: 'Page.PaymentHistory'},
									_List_Nil));
						}
					}
				}();
				var newModel = _v11.a;
				var fetchProfile = _v11.b;
				return fetchProfile(
					A2(
						$author$project$UpdateResult$addCmd,
						A2($elm$core$Platform$Cmd$map, $author$project$Page$PaymentHistory$GotDatePickerMsg, datePickerCmd),
						$author$project$UpdateResult$init(newModel)));
		}
	});
var $author$project$Page$Profile$CompletedLoadBalance = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Profile$CompletedLoadGraphqlInfo = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$Profile$FailedLoading = {$: 2};
var $author$project$Page$Profile$Loaded = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Page$Profile$ResultNotFound = {$: 0};
var $author$project$Page$Profile$ResultWithError = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Profile$CompletedLoadUserTransfers = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$Profile$fetchTransfers = F3(
	function (loggedIn, community, maybeCursor) {
		return A3(
			$author$project$Session$LoggedIn$query,
			loggedIn,
			A2(
				$author$project$Transfer$transfersUserQuery,
				loggedIn.lM,
				function (args) {
					return _Utils_update(
						args,
						{
							gQ: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(maybeCursor),
							hh: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
								{
									c1: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
										$author$project$Eos$symbolToString(community.e9)),
									c7: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
									F: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
								}),
							hj: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(10)
						});
				}),
			$author$project$Page$Profile$CompletedLoadUserTransfers);
	});
var $author$project$Page$Profile$GraphqlInfo = F4(
	function (totalTransfers, totalClaims, totalProducts, createdDate) {
		return {g6: createdDate, lo: totalClaims, lp: totalProducts, lq: totalTransfers};
	});
var $author$project$Page$Profile$claimSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$Claim$id,
	$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(
		function (id) {
			return {R: id};
		}));
var $author$project$Cambiatus$Object$User$claims = F2(
	function (fillInOptionals____, object____) {
		var filledInOptionals____ = fillInOptionals____(
			{c1: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
		var optionalArgs____ = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'communityId', filledInOptionals____.c1, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)
				]));
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'claims',
			optionalArgs____,
			object____,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
	});
var $author$project$Cambiatus$Object$User$network = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'network',
		_List_Nil,
		object____,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Basics$identity,
			A2(
				$elm$core$Basics$composeR,
				$elm$json$Json$Decode$nullable,
				A2($elm$core$Basics$composeR, $elm$json$Json$Decode$list, $elm$json$Json$Decode$nullable))));
};
var $author$project$Page$Profile$Network = F2(
	function (symbol, createdAt) {
		return {fG: createdAt, e9: symbol};
	});
var $author$project$Cambiatus$Object$Network$communityId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'communityId', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$Network$createdAt = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.DateTime',
	'createdAt',
	_List_Nil,
	$author$project$Cambiatus$Scalar$unwrapCodecs($author$project$Cambiatus$ScalarCodecs$codecs).ma.jc);
var $author$project$Page$Profile$networkSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Utils$fromDateTime, $author$project$Cambiatus$Object$Network$createdAt),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Eos$symbolSelectionSet($author$project$Cambiatus$Object$Network$communityId),
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Page$Profile$Network)));
var $author$project$Page$Profile$productSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Eos$symbolSelectionSet($author$project$Cambiatus$Object$Product$communityId),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Cambiatus$Object$Product$id,
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(
			F2(
				function (id, symbol) {
					return {R: id, e9: symbol};
				}))));
var $author$project$Cambiatus$Object$User$products = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'products',
		_List_Nil,
		object____,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Basics$identity,
			A2($elm$core$Basics$composeR, $elm$json$Json$Decode$nullable, $elm$json$Json$Decode$list)));
};
var $author$project$Cambiatus$Object$TransferConnection$count = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe Int)',
	'count',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int));
var $author$project$Page$Profile$transfersSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
		$elm$core$Maybe$withDefault(0),
		$author$project$Cambiatus$Object$TransferConnection$count),
	$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($elm$core$Basics$identity));
var $author$project$Page$Profile$graphqlInfoSelectionSet = function (communitySymbol) {
	return A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
			function (networks) {
				return A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.fG;
					},
					A2(
						$elm_community$list_extra$List$Extra$find,
						function (network) {
							return _Utils_eq(network.e9, communitySymbol);
						},
						A2(
							$elm$core$List$filterMap,
							$elm$core$Basics$identity,
							A2($elm$core$Maybe$withDefault, _List_Nil, networks))));
			},
			$author$project$Cambiatus$Object$User$network($author$project$Page$Profile$networkSelectionSet)),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
				function (products) {
					return $elm$core$List$length(
						A2(
							$elm$core$List$filter,
							function (_v0) {
								var symbol = _v0.e9;
								return _Utils_eq(symbol, communitySymbol);
							},
							A2($elm$core$List$filterMap, $elm$core$Basics$identity, products)));
				},
				$author$project$Cambiatus$Object$User$products($author$project$Page$Profile$productSelectionSet)),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
					$elm$core$List$length,
					A2($author$project$Cambiatus$Object$User$claims, $elm$core$Basics$identity, $author$project$Page$Profile$claimSelectionSet)),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
						$elm$core$Maybe$withDefault(0),
						A2(
							$author$project$Cambiatus$Object$User$transfers,
							function (optionals) {
								return _Utils_update(
									optionals,
									{
										hh: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
											{
												c1: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
													$author$project$Eos$symbolToString(communitySymbol)),
												c7: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
												F: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
											}),
										hj: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(0)
									});
							},
							$author$project$Page$Profile$transfersSelectionSet)),
					$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Page$Profile$GraphqlInfo)))));
};
var $author$project$Page$Profile$graphqlInfoQuery = F2(
	function (profileName, communitySymbol) {
		return A2(
			$author$project$Cambiatus$Query$user,
			{
				fl: $author$project$Eos$Account$nameToString(profileName)
			},
			$author$project$Page$Profile$graphqlInfoSelectionSet(communitySymbol));
	});
var $author$project$Page$Profile$update = F3(
	function (msg, model, loggedIn) {
		switch (msg.$) {
			case 0:
				switch (msg.a.$) {
					case 3:
						if (!msg.a.a.$) {
							var profile = msg.a.a.a;
							return _Utils_eq(profile.fl, model.oS) ? $author$project$UpdateResult$init(
								_Utils_update(
									model,
									{
										kJ: $krisajenkins$remotedata$RemoteData$Success(profile)
									})) : $author$project$UpdateResult$init(model);
						} else {
							var _v1 = msg.a.a;
							return A6(
								$author$project$UpdateResult$logImpossible,
								msg,
								'Profile was not found',
								$elm$core$Maybe$Just(loggedIn.lM),
								{mX: 'update', nW: 'Page.Profile'},
								_List_Nil,
								$author$project$UpdateResult$init(
									_Utils_update(
										model,
										{
											kJ: $krisajenkins$remotedata$RemoteData$Failure($author$project$Page$Profile$ResultNotFound)
										})));
						}
					case 2:
						var error = msg.a.a;
						return A7(
							$author$project$UpdateResult$logGraphqlError,
							msg,
							$elm$core$Maybe$Just(loggedIn.lM),
							'Got a graphql error when loading profile page',
							{mX: 'update', nW: 'Page.Profile'},
							_List_Nil,
							error,
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{
										kJ: $krisajenkins$remotedata$RemoteData$Failure(
											$author$project$Page$Profile$ResultWithError(error))
									})));
					case 1:
						var _v2 = msg.a;
						return $author$project$UpdateResult$init(model);
					default:
						var _v3 = msg.a;
						return $author$project$UpdateResult$init(model);
				}
			case 1:
				var community = msg.a;
				var fetchBalance = A3(
					$author$project$Api$getBalances,
					loggedIn.aM,
					model.oS,
					function (balancesResult) {
						if (!balancesResult.$) {
							var balances = balancesResult.a;
							return $author$project$Page$Profile$CompletedLoadBalance(
								A2(
									$elm$core$Result$fromMaybe,
									$author$project$Page$Profile$ResultNotFound,
									A2(
										$elm_community$list_extra$List$Extra$find,
										function (balance) {
											return _Utils_eq(balance.lY.e9, community.e9);
										},
										balances)));
						} else {
							var error = balancesResult.a;
							return $author$project$Page$Profile$CompletedLoadBalance(
								$elm$core$Result$Err(
									$author$project$Page$Profile$ResultWithError(error)));
						}
					});
				return A2(
					$author$project$UpdateResult$addExt,
					A3($author$project$Page$Profile$fetchTransfers, loggedIn, community, $elm$core$Maybe$Nothing),
					A2(
						$author$project$UpdateResult$addExt,
						A3(
							$author$project$Session$LoggedIn$query,
							loggedIn,
							A2($author$project$Page$Profile$graphqlInfoQuery, model.oS, community.e9),
							$author$project$Page$Profile$CompletedLoadGraphqlInfo),
						A2(
							$author$project$UpdateResult$addCmd,
							fetchBalance,
							$author$project$UpdateResult$init(model))));
			case 2:
				if (!msg.a.$) {
					var balance = msg.a.a;
					return $author$project$UpdateResult$init(
						_Utils_update(
							model,
							{
								b5: $krisajenkins$remotedata$RemoteData$Success(
									_Utils_update(
										balance,
										{
											nE: $elm$time$Time$millisToPosix(
												1000 * $elm$time$Time$posixToMillis(balance.nE))
										}))
							}));
				} else {
					var err = msg.a.a;
					var logError = function () {
						if (!err.$) {
							return A5(
								$author$project$UpdateResult$logImpossible,
								msg,
								'Balance was not found on profile page',
								$elm$core$Maybe$Just(loggedIn.lM),
								{mX: 'update', nW: 'Page.Profile'},
								_List_Nil);
						} else {
							var httpError = err.a;
							return A6(
								$author$project$UpdateResult$logHttpError,
								msg,
								$elm$core$Maybe$Just(loggedIn.lM),
								'Got an HTTP error when loading balance on profile page',
								{mX: 'update', nW: 'Page.Profile'},
								_List_Nil,
								httpError);
						}
					}();
					return logError(
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									b5: $krisajenkins$remotedata$RemoteData$Failure(err)
								})));
				}
			case 3:
				switch (msg.a.$) {
					case 3:
						if (!msg.a.a.$) {
							var graphqlInfo = msg.a.a.a;
							var reportCreatedDateNotFound = function () {
								var _v6 = graphqlInfo.g6;
								if (_v6.$ === 1) {
									return A5(
										$author$project$UpdateResult$logImpossible,
										msg,
										'Profile\'s createdDate is null',
										$elm$core$Maybe$Just(loggedIn.lM),
										{mX: 'update', nW: 'Page.Profile'},
										_List_Nil);
								} else {
									return $elm$core$Basics$identity;
								}
							}();
							return reportCreatedDateNotFound(
								$author$project$UpdateResult$init(
									_Utils_update(
										model,
										{
											bF: $krisajenkins$remotedata$RemoteData$Success(graphqlInfo)
										})));
						} else {
							var _v7 = msg.a.a;
							return A6(
								$author$project$UpdateResult$logImpossible,
								msg,
								'Profile\'s graphql info not found',
								$elm$core$Maybe$Just(loggedIn.lM),
								{mX: 'update', nW: 'Page.Profile'},
								_List_Nil,
								$author$project$UpdateResult$init(
									_Utils_update(
										model,
										{
											bF: $krisajenkins$remotedata$RemoteData$Failure($author$project$Page$Profile$ResultNotFound)
										})));
						}
					case 2:
						var error = msg.a.a;
						return A7(
							$author$project$UpdateResult$logGraphqlError,
							msg,
							$elm$core$Maybe$Just(loggedIn.lM),
							'Got an error when loading profile\'s graphql info',
							{mX: 'update', nW: 'Page.Profile'},
							_List_Nil,
							error,
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{
										bF: $krisajenkins$remotedata$RemoteData$Failure(
											$author$project$Page$Profile$ResultWithError(error))
									})));
					case 1:
						var _v8 = msg.a;
						return $author$project$UpdateResult$init(model);
					default:
						var _v9 = msg.a;
						return $author$project$UpdateResult$init(model);
				}
			case 4:
				switch (msg.a.$) {
					case 3:
						var maybeTransfers = msg.a.a;
						var previousTransfers = function () {
							var _v10 = model.aO;
							switch (_v10.$) {
								case 0:
									var previousTransfers_ = _v10.a;
									return previousTransfers_;
								case 1:
									var previousTransfers_ = _v10.a;
									return previousTransfers_;
								default:
									return _List_Nil;
							}
						}();
						var maybePageInfo = A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.oz;
							},
							A2(
								$elm$core$Maybe$andThen,
								function ($) {
									return $.an;
								},
								maybeTransfers));
						return $author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									aO: function (transfers) {
										return A2(
											$author$project$Page$Profile$Loaded,
											_Utils_ap(previousTransfers, transfers),
											maybePageInfo);
									}(
										A2(
											$elm$core$List$map,
											function (transfer) {
												return _Utils_Tuple2(
													transfer,
													$author$project$Profile$Summary$init(false));
											},
											$author$project$Transfer$getTransfers(maybeTransfers)))
								}));
					case 2:
						var err = msg.a.a;
						return A7(
							$author$project$UpdateResult$logGraphqlError,
							msg,
							$elm$core$Maybe$Just(loggedIn.lM),
							'Got an error when trying to load user\'s transfers on profile',
							{mX: 'update', nW: 'Page.Profile'},
							_List_fromArray(
								[
									$author$project$Log$contextFromCommunity(loggedIn.o7)
								]),
							err,
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{aO: $author$project$Page$Profile$FailedLoading})));
					case 1:
						var _v11 = msg.a;
						return $author$project$UpdateResult$init(model);
					default:
						var _v12 = msg.a;
						return $author$project$UpdateResult$init(model);
				}
			case 5:
				var transferId = msg.a;
				var subMsg = msg.b;
				var updateTransfers = function (transfers) {
					return A3(
						$elm_community$list_extra$List$Extra$updateIf,
						function (_v14) {
							var transfer = _v14.a;
							return _Utils_eq(transfer.R, transferId);
						},
						function (_v15) {
							var transfer = _v15.a;
							var profileSummary = _v15.b;
							return _Utils_Tuple2(
								transfer,
								A2($author$project$Profile$Summary$update, subMsg, profileSummary));
						},
						transfers);
				};
				var _v13 = model.aO;
				switch (_v13.$) {
					case 0:
						var transfers = _v13.a;
						var pageInfo = _v13.b;
						return $author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									aO: A2(
										$author$project$Page$Profile$Loaded,
										updateTransfers(transfers),
										pageInfo)
								}));
					case 1:
						var transfers = _v13.a;
						return $author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									aO: $author$project$Page$Profile$Loading(
										updateTransfers(transfers))
								}));
					default:
						return $author$project$UpdateResult$init(model);
				}
			case 6:
				var transferId = msg.a;
				return A2(
					$author$project$UpdateResult$addCmd,
					A2(
						$author$project$Route$pushUrl,
						loggedIn.aM.eM,
						$author$project$Route$ViewTransfer(transferId)),
					$author$project$UpdateResult$init(model));
			default:
				var _v16 = _Utils_Tuple2(model.aO, loggedIn.o7);
				if ((!_v16.a.$) && (_v16.b.$ === 3)) {
					var _v17 = _v16.a;
					var transfers = _v17.a;
					var maybePageInfo = _v17.b;
					var community = _v16.b.a;
					var maybeCursor = A2(
						$elm$core$Maybe$andThen,
						function ($) {
							return $.mI;
						},
						maybePageInfo);
					return A2(
						$author$project$UpdateResult$addExt,
						A3($author$project$Page$Profile$fetchTransfers, loggedIn, community, maybeCursor),
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									aO: $author$project$Page$Profile$Loading(transfers)
								})));
				} else {
					return $author$project$UpdateResult$init(model);
				}
		}
	});
var $author$project$Page$Profile$AddContact$GotContactMsg = function (a) {
	return {$: 0, a: a};
};
var $elm$core$String$fromList = _String_fromList;
var $author$project$Profile$Contact$usesPhone = function (contactType) {
	return A2(
		$elm$core$List$member,
		contactType,
		_List_fromArray(
			[5, 3]));
};
var $author$project$Profile$Contact$countryFromNormalized = function (_v0) {
	var contactType = _v0.mf;
	var contact = _v0.me;
	if ($author$project$Profile$Contact$usesPhone(contactType)) {
		var countryCode = $elm$core$String$fromList(
			A2(
				$elm_community$list_extra$List$Extra$takeWhile,
				$elm$core$Basics$neq(' '),
				$elm$core$String$toList(
					A2($elm$core$String$dropLeft, 1, contact))));
		var supportedCountry = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.g5;
					},
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.el;
						},
						$elm$core$Basics$eq(countryCode))),
				$author$project$Profile$Contact$supportedCountries));
		var newContact = function (n) {
			return $elm$core$String$trim(
				A2($elm$core$String$dropLeft, n, contact));
		}(
			A2(
				$elm$core$Maybe$withDefault,
				0,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.g5;
						},
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.el;
							},
							A2(
								$elm$core$Basics$composeR,
								$elm$core$String$length,
								$elm$core$Basics$add(1)))),
					supportedCountry)));
		return _Utils_Tuple2(supportedCountry, newContact);
	} else {
		return _Utils_Tuple2($elm$core$Maybe$Nothing, contact);
	}
};
var $author$project$Profile$Contact$initBasicWith = function (normalized) {
	var contactType = normalized.mf;
	var initial = $author$project$Profile$Contact$initBasic(contactType);
	var _v0 = $author$project$Profile$Contact$countryFromNormalized(normalized);
	var maybeCountry = _v0.a;
	var newPhoneContact = _v0.b;
	var newContact = function () {
		switch (contactType) {
			case 3:
				return newPhoneContact;
			case 5:
				return newPhoneContact;
			case 4:
				return A2($elm$core$String$dropLeft, 13, newPhoneContact);
			case 1:
				return A2($elm$core$String$dropLeft, 22, newPhoneContact);
			case 0:
				return newPhoneContact;
			default:
				return newPhoneContact;
		}
	}();
	return _Utils_update(
		initial,
		{
			me: newContact,
			aC: A2($elm$core$Maybe$withDefault, $author$project$Profile$Contact$defaultCountry, maybeCountry)
		});
};
var $author$project$Cambiatus$Enum$ContactType$list = _List_fromArray(
	[0, 1, 2, 3, 4, 5]);
var $author$project$Profile$Contact$initMultiple = function (initialContacts) {
	return {
		ca: $elm$core$Maybe$Nothing,
		eG: $author$project$Profile$Contact$Multiple(
			A2(
				$elm$core$List$map,
				function (type_) {
					return A2(
						$elm$core$Maybe$withDefault,
						$author$project$Profile$Contact$initBasic(type_),
						A2(
							$elm$core$Maybe$map,
							$author$project$Profile$Contact$initBasicWith,
							A2(
								$elm_community$list_extra$List$Extra$find,
								function (_v0) {
									var contactType = _v0.mf;
									return _Utils_eq(type_, contactType);
								},
								initialContacts)));
				},
				$author$project$Cambiatus$Enum$ContactType$list)),
		X: $krisajenkins$remotedata$RemoteData$NotAsked
	};
};
var $author$project$Page$Profile$AddContact$update = F3(
	function (msg, model, loggedIn) {
		var shared = loggedIn.aM;
		if (msg.$ === 1) {
			var profile = msg.a;
			return $author$project$UpdateResult$init(
				$krisajenkins$remotedata$RemoteData$Success(
					$author$project$Profile$Contact$initMultiple(profile.aq)));
		} else {
			var subMsg = msg.a;
			var _v1 = _Utils_Tuple2(
				model,
				$author$project$Session$LoggedIn$profile(loggedIn));
			if ((_v1.a.$ === 3) && (!_v1.b.$)) {
				var contactModel = _v1.a.a;
				var profile_ = _v1.b.a;
				var handleExtMsg = function (extMsg) {
					switch (extMsg.$) {
						case 0:
							var successMessage = extMsg.a;
							var contacts = extMsg.b;
							var shouldRedirect = extMsg.c;
							var _v3 = loggedIn.kJ;
							if (_v3.$ === 3) {
								var profile = _v3.a;
								return A2(
									$elm$core$Basics$composeR,
									$author$project$UpdateResult$addExt(
										A2($author$project$Session$LoggedIn$ShowFeedback, 0, successMessage)),
									A2(
										$elm$core$Basics$composeR,
										$author$project$UpdateResult$addExt(
											$author$project$Session$LoggedIn$ExternalBroadcast(
												$author$project$Session$LoggedIn$ProfileLoaded(
													_Utils_update(
														profile,
														{aq: contacts})))),
										shouldRedirect ? $author$project$UpdateResult$addCmd(
											A2(
												$author$project$Route$replaceUrl,
												shared.eM,
												$author$project$Route$Profile(loggedIn.lM))) : $elm$core$Basics$identity));
							} else {
								return A5(
									$author$project$UpdateResult$logImpossible,
									msg,
									'Tried updating contacts, but profile is not loaded',
									$elm$core$Maybe$Just(loggedIn.lM),
									{mX: 'update', nW: 'Page.Profile.AddContact'},
									_List_Nil);
							}
						case 1:
							var errorMessage = extMsg.a;
							return $author$project$UpdateResult$addExt(
								A2($author$project$Session$LoggedIn$ShowFeedback, 1, errorMessage));
						default:
							var selectionSet = extMsg.a;
							var responseMsg = extMsg.b;
							return $author$project$UpdateResult$addExt(
								A3(
									$author$project$Session$LoggedIn$mutation,
									loggedIn,
									selectionSet,
									A2($elm$core$Basics$composeR, responseMsg, $author$project$Page$Profile$AddContact$GotContactMsg)));
					}
				};
				return A5(
					$author$project$UpdateResult$fromChild,
					$krisajenkins$remotedata$RemoteData$Success,
					$author$project$Page$Profile$AddContact$GotContactMsg,
					handleExtMsg,
					model,
					A4($author$project$Profile$Contact$update, subMsg, contactModel, shared.iw, profile_.aq));
			} else {
				return $author$project$UpdateResult$init(model);
			}
		}
	});
var $author$project$Page$Profile$AddKyc$FormMsg = $elm$core$Basics$identity;
var $author$project$Session$LoggedIn$ProfileResource = 0;
var $author$project$Page$Profile$AddKyc$update = F3(
	function (msg, model, loggedIn) {
		var _v0 = loggedIn.aM.iw;
		var t = _v0.il;
		var kycFormMsg = msg;
		var formUpdateResult = A5(
			$author$project$UpdateResult$fromChild,
			$elm$core$Basics$identity,
			$elm$core$Basics$identity,
			$author$project$Session$LoggedIn$addFeedback,
			model,
			A3($author$project$Profile$EditKycForm$update, loggedIn.aM, model, kycFormMsg));
		switch (kycFormMsg.$) {
			case 1:
				var formOutput = kycFormMsg.a;
				return A2(
					$author$project$UpdateResult$addExt,
					A2(
						$author$project$Session$LoggedIn$mapExternal,
						$elm$core$Basics$identity,
						A2($author$project$Profile$EditKycForm$saveKycData, loggedIn, formOutput)),
					A2(
						$author$project$UpdateResult$addExt,
						$author$project$Session$LoggedIn$UpdatedLoggedIn(
							_Utils_update(
								loggedIn,
								{kJ: $krisajenkins$remotedata$RemoteData$Loading})),
						formUpdateResult));
			case 2:
				var result = kycFormMsg.a;
				if (result.$ === 2) {
					return A2(
						$author$project$UpdateResult$addExt,
						A2(
							$author$project$Session$LoggedIn$ShowFeedback,
							1,
							t('error.unknown')),
						formUpdateResult);
				} else {
					return A2(
						$author$project$UpdateResult$addExt,
						A2(
							$author$project$Session$LoggedIn$ShowFeedback,
							0,
							t('community.kyc.add.success')),
						A2(
							$author$project$UpdateResult$addExt,
							$author$project$Session$LoggedIn$ReloadResource(0),
							A2(
								$author$project$UpdateResult$addCmd,
								A2(
									$author$project$Route$replaceUrl,
									loggedIn.aM.eM,
									$author$project$Route$Profile(loggedIn.lM)),
								formUpdateResult)));
				}
			default:
				return formUpdateResult;
		}
	});
var $author$project$Page$Profile$Claims$Desc = 1;
var $author$project$Page$Profile$Claims$Failed = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$Profile$Claims$Loaded = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Page$Profile$Claims$NotFound = {$: 2};
var $author$project$Log$QueryBreadcrumb = 4;
var $author$project$Claim$pendingValidators = function (claim) {
	return A2(
		$elm$core$List$filter,
		function (validator) {
			return !A2(
				$elm$core$List$member,
				validator.fl,
				A2(
					$elm$core$List$map,
					function (c) {
						return c.aE.fl;
					},
					claim.S));
		},
		claim.iG.pN);
};
var $author$project$Claim$initClaimProfileSummaries = function (claim) {
	return {
		ed: $author$project$Profile$Summary$init(false),
		cB: A2(
			$author$project$Profile$Summary$initMany,
			false,
			$elm$core$List$length(
				$author$project$Claim$pendingValidators(claim))),
		e3: false,
		fg: $author$project$Profile$Summary$init(true),
		b0: A2(
			$author$project$Profile$Summary$initMany,
			false,
			$elm$core$List$length(claim.S))
	};
};
var $author$project$Page$Profile$Claims$ClaimsLoaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Profile$Claims$selectionSet = F2(
	function (now, communityId) {
		return A2(
			$author$project$Cambiatus$Object$User$claims,
			function (_v0) {
				return {
					c1: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
						$author$project$Eos$symbolToString(communityId))
				};
			},
			$author$project$Claim$selectionSet(now));
	});
var $author$project$Page$Profile$Claims$profileClaimQuery = F3(
	function (loggedIn, accountName, symbol) {
		return A3(
			$author$project$Session$LoggedIn$query,
			loggedIn,
			A2(
				$author$project$Cambiatus$Query$user,
				{fl: accountName},
				A2($author$project$Page$Profile$Claims$selectionSet, loggedIn.aM.gh, symbol)),
			$author$project$Page$Profile$Claims$ClaimsLoaded);
	});
var $author$project$Claim$updateProfileSummaries = F2(
	function (externalMsg, claimProfileSummaries) {
		switch (externalMsg.$) {
			case 0:
				return _Utils_update(
					claimProfileSummaries,
					{e3: true});
			case 1:
				return _Utils_update(
					claimProfileSummaries,
					{e3: false});
			default:
				var profileSummaryKind = externalMsg.a;
				var subMsg = externalMsg.b;
				switch (profileSummaryKind.$) {
					case 0:
						return _Utils_update(
							claimProfileSummaries,
							{
								ed: A2($author$project$Profile$Summary$update, subMsg, claimProfileSummaries.ed)
							});
					case 1:
						return _Utils_update(
							claimProfileSummaries,
							{
								fg: A2($author$project$Profile$Summary$update, subMsg, claimProfileSummaries.fg)
							});
					case 2:
						var index = profileSummaryKind.a;
						return _Utils_update(
							claimProfileSummaries,
							{
								b0: A3(
									$elm_community$list_extra$List$Extra$updateAt,
									index,
									$author$project$Profile$Summary$update(subMsg),
									claimProfileSummaries.b0)
							});
					default:
						var index = profileSummaryKind.a;
						return _Utils_update(
							claimProfileSummaries,
							{
								cB: A3(
									$elm_community$list_extra$List$Extra$updateAt,
									index,
									$author$project$Profile$Summary$update(subMsg),
									claimProfileSummaries.cB)
							});
				}
		}
	});
var $author$project$Page$Profile$Claims$update = F3(
	function (msg, model, loggedIn) {
		switch (msg.$) {
			case 0:
				return $author$project$UpdateResult$init(model);
			case 1:
				switch (msg.a.$) {
					case 3:
						var results = msg.a.a;
						if (!results.$) {
							var claims = results.a;
							var profileSummaries = A2($elm$core$List$map, $author$project$Claim$initClaimProfileSummaries, claims);
							return $author$project$UpdateResult$init(
								_Utils_update(
									model,
									{
										gE: A2(
											$author$project$Page$Profile$Claims$Loaded,
											profileSummaries,
											$elm$core$List$reverse(claims))
									}));
						} else {
							return $author$project$UpdateResult$init(
								_Utils_update(
									model,
									{gE: $author$project$Page$Profile$Claims$NotFound}));
						}
					case 2:
						var e = msg.a.a;
						return $author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									gE: $author$project$Page$Profile$Claims$Failed(e)
								}));
					default:
						return $author$project$UpdateResult$init(model);
				}
			case 2:
				var community = msg.a;
				return A2(
					$author$project$UpdateResult$addExt,
					A3($author$project$Page$Profile$Claims$profileClaimQuery, loggedIn, model.lN, community.e9),
					$author$project$UpdateResult$init(model));
			case 3:
				var claimIndex = msg.a;
				var m = msg.b;
				var updatedModel = function () {
					var _v2 = _Utils_Tuple2(model.gE, m);
					if ((_v2.a.$ === 1) && (_v2.b.$ === 2)) {
						var _v3 = _v2.a;
						var profileSummaries = _v3.a;
						var profileClaims = _v3.b;
						var subMsg = _v2.b.a;
						return _Utils_update(
							model,
							{
								gE: A2(
									$author$project$Page$Profile$Claims$Loaded,
									A3(
										$elm_community$list_extra$List$Extra$updateAt,
										claimIndex,
										$author$project$Claim$updateProfileSummaries(subMsg),
										profileSummaries),
									profileClaims)
							});
					} else {
						return model;
					}
				}();
				return $author$project$UpdateResult$init(
					A2($author$project$Claim$updateClaimModalStatus, m, updatedModel));
			case 4:
				var tab = msg.a;
				var tabToString = function (tab_) {
					if (!tab_) {
						return 'waiting vote';
					} else {
						return 'analyzed';
					}
				};
				return A2(
					$author$project$UpdateResult$addBreadcrumb,
					{
						fw: msg,
						i9: $elm$core$Dict$fromList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'tab',
									$elm$json$Json$Encode$string(
										tabToString(tab)))
								])),
						nH: 3,
						nS: 'Selected claims tab',
						d0: 3
					},
					$author$project$UpdateResult$init(
						_Utils_update(
							model,
							{cJ: tab})));
			case 5:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{dX: true}));
			case 6:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{dX: false}));
			case 7:
				var newDirection = function () {
					var _v6 = model.dH;
					if (!_v6) {
						return 1;
					} else {
						return 0;
					}
				}();
				var directionToString = function (direction) {
					if (!direction) {
						return 'ASC';
					} else {
						return 'DESC';
					}
				};
				return A2(
					$author$project$UpdateResult$addBreadcrumb,
					{
						fw: msg,
						i9: $elm$core$Dict$fromList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'newSorting',
									$elm$json$Json$Encode$string(
										directionToString(newDirection)))
								])),
						nH: 3,
						nS: 'Toggled sorting',
						d0: 4
					},
					$author$project$UpdateResult$init(
						_Utils_update(
							model,
							{dH: newDirection})));
			case 8:
				var statusFilter = msg.a;
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{es: statusFilter}));
			case 9:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{fI: model.es, dX: false}));
			default:
				return A2(
					$author$project$UpdateResult$addExt,
					$author$project$Session$LoggedIn$ShowCodeOfConductModal,
					$author$project$UpdateResult$init(model));
		}
	});
var $author$project$Page$Profile$Editor$CepFound = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Profile$Editor$CepLoading = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Profile$Editor$CepNotFound = {$: 3};
var $author$project$Page$Profile$Editor$CepUnavailable = {$: 4};
var $author$project$Page$Profile$Editor$FailedToSend = 3;
var $author$project$Page$Profile$Editor$GotBairroPickerMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Page$Profile$Editor$GotEditorData = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$Profile$Editor$GotFeedbackResult = function (a) {
	return {$: 24, a: a};
};
var $author$project$Page$Profile$Editor$GotFormMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Page$Profile$Editor$GotMunicipalityPickerMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Page$Profile$Editor$GotSaveResult = function (a) {
	return {$: 5, a: a};
};
var $author$project$Page$Profile$Editor$Loaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Profile$Editor$NoOp = {$: 0};
var $author$project$Page$Profile$Editor$Sending = 1;
var $author$project$Page$Profile$Editor$Sent = 2;
var $author$project$Page$Profile$Editor$Writing = 0;
var $author$project$Page$Profile$Editor$addPickerRequest = F4(
	function (loggedIn, toMsg, maybeRequest, ur) {
		if (maybeRequest.$ === 1) {
			return ur;
		} else {
			var request = maybeRequest.a;
			return A2(
				$author$project$UpdateResult$addExt,
				A3(
					$author$project$Session$LoggedIn$query,
					loggedIn,
					request.k6,
					A2($elm$core$Basics$composeR, request.pA, toMsg)),
				ur);
		}
	});
var $author$project$Profile$Location$Brazil = 0;
var $author$project$Profile$Location$cleanText = function (text) {
	return A2(
		$elm$core$String$join,
		' ',
		$elm$core$String$words(text));
};
var $author$project$Profile$Location$nonEmptyOr = F2(
	function (fallback, maybeText) {
		if (!maybeText.$) {
			var text = maybeText.a;
			return (text === '') ? fallback : text;
		} else {
			return fallback;
		}
	});
var $author$project$Profile$Location$applyLookup = F2(
	function (lookup, _v0) {
		var place = _v0.e;
		var address = _v0.gP;
		var withMunicipality = function () {
			var _v1 = lookup.cw;
			if (!_v1.$) {
				var municipality = _v1.a;
				return _Utils_update(
					place,
					{
						by: lookup.by,
						aF: function () {
							var _v2 = lookup.by;
							if (!_v2.$) {
								return '';
							} else {
								return A2(
									$elm$core$Maybe$withDefault,
									'',
									A2($elm$core$Maybe$map, $author$project$Profile$Location$cleanText, lookup.aF));
							}
						}(),
						g5: 0,
						cw: $elm$core$Maybe$Just(municipality)
					});
			} else {
				return place;
			}
		}();
		return {
			gP: _Utils_update(
				address,
				{
					dM: lookup.dM,
					ba: A2(
						$author$project$Profile$Location$nonEmptyOr,
						address.ba,
						A2($elm$core$Maybe$map, $author$project$Profile$Location$cleanText, lookup.ba))
				}),
			e: withMunicipality
		};
	});
var $author$project$Page$Profile$Editor$CepIdle = {$: 0};
var $author$project$Page$Profile$Editor$GotPostalLookup = F2(
	function (a, b) {
		return {$: 18, a: a, b: b};
	});
var $author$project$Page$Profile$Editor$isLookupFor = F2(
	function (digits, cep) {
		switch (cep.$) {
			case 1:
				var asked = cep.a;
				return _Utils_eq(asked, digits);
			case 2:
				var lookup = cep.a.f8;
				return _Utils_eq(lookup.dM, digits);
			default:
				return false;
		}
	});
var $elm$core$String$any = _String_any;
var $author$project$Profile$Location$normalizeCep = function (text) {
	var hasStrangeCharacters = A2(
		$elm$core$String$any,
		function (_char) {
			return !($elm$core$Char$isDigit(_char) || A2(
				$elm$core$List$member,
				_char,
				_List_fromArray(
					['.', '-', ' '])));
		},
		text);
	var digits = A2($elm$core$String$filter, $elm$core$Char$isDigit, text);
	return (($elm$core$String$length(digits) === 8) && (!hasStrangeCharacters)) ? $elm$core$Maybe$Just(digits) : $elm$core$Maybe$Nothing;
};
var $author$project$Profile$Location$PostalLookup = F6(
	function (postalCode, street, bairroText, bairro, municipality, stateCode) {
		return {by: bairro, aF: bairroText, cw: municipality, dM: postalCode, lc: stateCode, ba: street};
	});
var $author$project$Cambiatus$Object$PostalCodeAddress$bairro = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'bairro',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$Cambiatus$Object$PostalCodeAddress$bairroText = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'bairroText',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Profile$Location$Locality = F6(
	function (id, name, kind, country, stateCode, code) {
		return {i1: code, g5: country, R: id, eG: kind, ki: name, lc: stateCode};
	});
var $author$project$Cambiatus$Object$Locality$code = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'code',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Cambiatus$Object$Locality$country = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'country', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$Locality$id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'id', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$Cambiatus$Object$Locality$kind = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'kind', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$Locality$name = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'name', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$Locality$stateCode = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'stateCode',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Profile$Location$localitySelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$Locality$code,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Cambiatus$Object$Locality$stateCode,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Cambiatus$Object$Locality$country,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Cambiatus$Object$Locality$kind,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$Cambiatus$Object$Locality$name,
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$Cambiatus$Object$Locality$id,
						$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Profile$Location$Locality)))))));
var $author$project$Cambiatus$Object$PostalCodeAddress$municipality = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'municipality',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$Cambiatus$Object$PostalCodeAddress$postalCode = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'postalCode', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Cambiatus$Query$postalCodeLookup = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'postalCodeLookup',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'postalCode', requiredArgs____.dM, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)
				]),
			object____,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
	});
var $author$project$Cambiatus$Object$PostalCodeAddress$stateCode = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'stateCode',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Cambiatus$Object$PostalCodeAddress$street = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'street',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Profile$Location$postalLookupQuery = function (digits) {
	return A2(
		$author$project$Cambiatus$Query$postalCodeLookup,
		{dM: digits},
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Cambiatus$Object$PostalCodeAddress$stateCode,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Cambiatus$Object$PostalCodeAddress$municipality($author$project$Profile$Location$localitySelectionSet),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$Cambiatus$Object$PostalCodeAddress$bairro($author$project$Profile$Location$localitySelectionSet),
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$Cambiatus$Object$PostalCodeAddress$bairroText,
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							$author$project$Cambiatus$Object$PostalCodeAddress$street,
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
								$author$project$Cambiatus$Object$PostalCodeAddress$postalCode,
								$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Profile$Location$PostalLookup))))))));
};
var $author$project$Page$Profile$Editor$setLocation = F2(
	function (location, model) {
		var _v0 = model.hk;
		if (_v0.$ === 1) {
			var loaded = _v0.a;
			return _Utils_update(
				model,
				{
					hk: $author$project$Page$Profile$Editor$Loaded(
						_Utils_update(
							loaded,
							{
								nN: $elm$core$Maybe$Just(location)
							}))
				});
		} else {
			return model;
		}
	});
var $author$project$Page$Profile$Editor$changedPostalCode = F3(
	function (loggedIn, location, model) {
		var _v0 = _Utils_Tuple2(
			location.e.g5,
			$author$project$Profile$Location$normalizeCep(location.gP.dM));
		if ((!_v0.a) && (!_v0.b.$)) {
			var _v1 = _v0.a;
			var digits = _v0.b.a;
			return A2($author$project$Page$Profile$Editor$isLookupFor, digits, location.Z) ? $author$project$UpdateResult$init(
				A2($author$project$Page$Profile$Editor$setLocation, location, model)) : A2(
				$author$project$UpdateResult$addExt,
				A3(
					$author$project$Session$LoggedIn$query,
					loggedIn,
					$author$project$Profile$Location$postalLookupQuery(digits),
					$author$project$Page$Profile$Editor$GotPostalLookup(digits)),
				$author$project$UpdateResult$init(
					A2(
						$author$project$Page$Profile$Editor$setLocation,
						_Utils_update(
							location,
							{
								Z: $author$project$Page$Profile$Editor$CepLoading(digits)
							}),
						model)));
		} else {
			return $author$project$UpdateResult$init(
				A2(
					$author$project$Page$Profile$Editor$setLocation,
					_Utils_update(
						location,
						{Z: $author$project$Page$Profile$Editor$CepIdle}),
					model));
		}
	});
var $author$project$Profile$Location$Address = F4(
	function (street, number, complement, postalCode) {
		return {c2: complement, ay: number, dM: postalCode, ba: street};
	});
var $author$project$Cambiatus$Object$DeliveryAddress$complement = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'complement',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Cambiatus$Object$DeliveryAddress$number = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'number',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Cambiatus$Object$DeliveryAddress$postalCode = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'postalCode',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Cambiatus$Object$DeliveryAddress$street = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'street', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Profile$Location$addressSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
		$elm$core$Maybe$withDefault(''),
		$author$project$Cambiatus$Object$DeliveryAddress$postalCode),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
			$elm$core$Maybe$withDefault(''),
			$author$project$Cambiatus$Object$DeliveryAddress$complement),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
				$elm$core$Maybe$withDefault(''),
				$author$project$Cambiatus$Object$DeliveryAddress$number),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Cambiatus$Object$DeliveryAddress$street,
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Profile$Location$Address)))));
var $author$project$Cambiatus$Object$User$deliveryAddress = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'deliveryAddress',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$Cambiatus$Object$User$locationPlace = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'locationPlace',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$Profile$Location$Saved = F4(
	function (municipality, bairro, bairroText, label) {
		return {by: bairro, aF: bairroText, nC: label, cw: municipality};
	});
var $author$project$Cambiatus$Object$LocationPlace$bairro = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'bairro',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$Cambiatus$Object$LocationPlace$bairroText = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'bairroText',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Cambiatus$Object$LocationPlace$label = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'label', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Cambiatus$Object$LocationPlace$municipality = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'municipality', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Profile$Location$savedSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$LocationPlace$label,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Cambiatus$Object$LocationPlace$bairroText,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Cambiatus$Object$LocationPlace$bairro($author$project$Profile$Location$localitySelectionSet),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Cambiatus$Object$LocationPlace$municipality($author$project$Profile$Location$localitySelectionSet),
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Profile$Location$Saved)))));
var $author$project$Profile$Location$userSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$User$deliveryAddress($author$project$Profile$Location$addressSelectionSet),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Cambiatus$Object$User$locationPlace($author$project$Profile$Location$savedSelectionSet),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
				$elm$core$Maybe$withDefault(''),
				$author$project$Cambiatus$Object$User$location),
			$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(
				F3(
					function (location, saved, address) {
						return {gP: address, h8: saved, bX: location};
					})))));
var $author$project$Profile$Location$editorSelectionSet = function (_v0) {
	var account = _v0.fl;
	var symbol = _v0.e9;
	return A3(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$map2,
		F2(
			function (maybeUser, maybeFeatures) {
				return A2(
					$elm$core$Maybe$map,
					function (user) {
						return {
							gP: user.gP,
							kR: A2($elm$core$Maybe$withDefault, _List_Nil, maybeFeatures),
							h8: user.h8,
							bX: user.bX
						};
					},
					maybeUser);
			}),
		A2(
			$author$project$Cambiatus$Query$user,
			{
				fl: $author$project$Eos$Account$nameToString(account)
			},
			$author$project$Profile$Location$userSelectionSet),
		A2(
			$author$project$Cambiatus$Query$community,
			function (optionals) {
				return _Utils_update(
					optionals,
					{
						e9: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
							$author$project$Eos$symbolToString(symbol))
					});
			},
			$author$project$Cambiatus$Object$Community$releasedFeatures));
};
var $author$project$Avatar$fromString = A2($elm$core$Basics$composeR, $elm$core$Maybe$Just, $elm$core$Basics$identity);
var $author$project$Profile$Location$Other = 2;
var $author$project$Profile$Location$isPicked = function (place) {
	return (place.g5 !== 2) && (!_Utils_eq(place.cw, $elm$core$Maybe$Nothing));
};
var $author$project$Profile$Location$CostaRica = 1;
var $author$project$Profile$Location$NumberRequired = 1;
var $author$project$Profile$Location$PostalCodeInvalid = 2;
var $author$project$Profile$Location$PostalCodeRequired = 3;
var $author$project$Profile$Location$StreetRequired = 0;
var $author$project$Profile$Location$dropUnusedFields = F2(
	function (country, address) {
		if (country === 1) {
			return _Utils_update(
				address,
				{c2: '', ay: ''});
		} else {
			return address;
		}
	});
var $author$project$Profile$Location$errorIf = F2(
	function (condition, error) {
		return condition ? $elm$core$Maybe$Just(error) : $elm$core$Maybe$Nothing;
	});
var $author$project$Profile$Location$emptyAddress = {c2: '', ay: '', dM: '', ba: ''};
var $author$project$Profile$Location$normalizeAddress = function (address) {
	return {
		c2: $author$project$Profile$Location$cleanText(address.c2),
		ay: $author$project$Profile$Location$cleanText(address.ay),
		dM: A2($elm$core$String$filter, $elm$core$Char$isAlphaNum, address.dM),
		ba: $author$project$Profile$Location$cleanText(address.ba)
	};
};
var $author$project$Profile$Location$isAddressEmpty = function (address) {
	return _Utils_eq(
		$author$project$Profile$Location$normalizeAddress(address),
		$author$project$Profile$Location$emptyAddress);
};
var $author$project$Profile$Location$validateAddress = F2(
	function (country, address) {
		var normalized = $author$project$Profile$Location$normalizeAddress(address);
		var expectedLength = function () {
			if (country === 1) {
				return 5;
			} else {
				return 8;
			}
		}();
		var postalCodeValid = A2($elm$core$String$all, $elm$core$Char$isDigit, normalized.dM) && _Utils_eq(
			$elm$core$String$length(normalized.dM),
			expectedLength);
		var errors = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A2($author$project$Profile$Location$errorIf, normalized.ba === '', 0),
					A2($author$project$Profile$Location$errorIf, (country !== 1) && (normalized.ay === ''), 1),
					A2($author$project$Profile$Location$errorIf, (country === 2) && (normalized.dM === ''), 3),
					A2($author$project$Profile$Location$errorIf, (normalized.dM !== '') && (!postalCodeValid), 2)
				]));
		return $author$project$Profile$Location$isAddressEmpty(address) ? $elm$core$Result$Ok($elm$core$Maybe$Nothing) : ($elm$core$List$isEmpty(errors) ? $elm$core$Result$Ok(
			$elm$core$Maybe$Just(
				A2($author$project$Profile$Location$dropUnusedFields, country, normalized))) : $elm$core$Result$Err(errors));
	});
var $author$project$Profile$Location$BairroNotPlain = 1;
var $author$project$Profile$Location$BairroTooLong = 0;
var $author$project$Profile$Location$cepRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(^|\\s)\\d{5}-?\\d{3}($|\\s)'));
var $author$project$Profile$Location$digitAfterCommaRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString(',\\s*\\d+'));
var $author$project$Profile$Location$streetWordRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	A2(
		$elm$regex$Regex$fromStringWith,
		{l0: true, nX: false},
		'(^|\\s)(rua|r\\.|avenida|av\\.?|travessa|tv\\.|alameda|estrada|rodovia|praça|praca|calle)(\\s|$)'));
var $author$project$Profile$Location$looksLikeAddress = function (text) {
	var hasDigit = A2($elm$core$String$any, $elm$core$Char$isDigit, text);
	return A2($elm$regex$Regex$contains, $author$project$Profile$Location$cepRegex, text) || ((hasDigit && A2($elm$regex$Regex$contains, $author$project$Profile$Location$streetWordRegex, text)) || A2($elm$regex$Regex$contains, $author$project$Profile$Location$digitAfterCommaRegex, text));
};
var $author$project$Profile$Location$maxBairroLength = 60;
var $author$project$Profile$Location$phoneRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\\d[\\s().-]*){8,}'));
var $author$project$Profile$Location$urlRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	A2(
		$elm$regex$Regex$fromStringWith,
		{l0: true, nX: false},
		'(https?://|www\\.)\\S+'));
var $author$project$Profile$Location$validateBairroText = function (raw) {
	var cleaned = $author$project$Profile$Location$cleanText(raw);
	return (_Utils_cmp(
		$elm$core$String$length(cleaned),
		$author$project$Profile$Location$maxBairroLength) > 0) ? $elm$core$Result$Err(0) : ((A2($elm$core$String$contains, '@', cleaned) || (A2($elm$regex$Regex$contains, $author$project$Profile$Location$urlRegex, cleaned) || (A2($elm$regex$Regex$contains, $author$project$Profile$Location$cepRegex, cleaned) || (A2($elm$regex$Regex$contains, $author$project$Profile$Location$phoneRegex, cleaned) || $author$project$Profile$Location$looksLikeAddress(cleaned))))) ? $elm$core$Result$Err(1) : $elm$core$Result$Ok(cleaned));
};
var $author$project$Page$Profile$Editor$hasLocationErrors = function (_v0) {
	var place = _v0.e;
	var address = _v0.gP;
	var bairroInvalid = function () {
		var _v2 = _Utils_Tuple2(
			place.by,
			$author$project$Profile$Location$validateBairroText(place.aF));
		if ((_v2.a.$ === 1) && (_v2.b.$ === 1)) {
			var _v3 = _v2.a;
			return true;
		} else {
			return false;
		}
	}();
	var addressInvalid = function () {
		var _v1 = A2($author$project$Profile$Location$validateAddress, place.g5, address);
		if (!_v1.$) {
			return false;
		} else {
			return true;
		}
	}();
	return ($author$project$Profile$Location$isPicked(place) && (bairroInvalid || addressInvalid)) || ((place.g5 === 2) && addressInvalid);
};
var $author$project$Profile$Location$noSaveFields = {c8: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, nN: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, dy: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, dz: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, dA: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent};
var $author$project$Profile$Location$legacySaveFields = function (location) {
	return _Utils_update(
		$author$project$Profile$Location$noSaveFields,
		{
			nN: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(location)
		});
};
var $author$project$Form$File$SingleModel = $elm$core$Basics$identity;
var $author$project$Form$File$initSingle = function (_v0) {
	var fileUrl = _v0.mT;
	var aspectRatio = _v0.q;
	return {
		q: aspectRatio,
		ev: A2(
			$elm$core$Maybe$map,
			function (file) {
				return {
					aH: $author$project$Form$File$LoadingFileType,
					ad: function () {
						if (aspectRatio.$ === 1) {
							return $author$project$Form$File$WithoutImageCropper;
						} else {
							var validAspectRatio = aspectRatio.a;
							return $author$project$Form$File$WithImageCropper(
								$author$project$View$ImageCropper$init(
									{q: validAspectRatio}));
						}
					}(),
					aD: $elm$core$Maybe$Nothing,
					gL: $author$project$Form$File$Loaded(file)
				};
			},
			fileUrl),
		hv: false,
		f$: false,
		ae: false,
		j: 0
	};
};
var $author$project$Avatar$toMaybeString = function (_v0) {
	var s = _v0;
	return s;
};
var $author$project$Page$Profile$Editor$initForm = F2(
	function (profile, hasLocationPicker) {
		var nullable = function (a) {
			return A2($elm$core$Maybe$withDefault, '', a);
		};
		return $author$project$Form$init(
			{
				cV: $author$project$Form$File$initSingle(
					{
						q: $elm$core$Maybe$Just(1),
						mT: $author$project$Avatar$toMaybeString(profile.cV)
					}),
				cW: A2($author$project$Form$RichText$initModel, 'bio-input', profile.cW),
				jh: nullable(profile.jh),
				de: nullable(profile.ki),
				bH: '',
				dj: profile.dj,
				nN: hasLocationPicker ? '' : nullable(profile.nM)
			});
	});
var $author$project$Page$Profile$Editor$loadProfile = F2(
	function (profile, model) {
		var _v0 = model.hk;
		if (_v0.$ === 1) {
			var loaded = _v0.a;
			return _Utils_update(
				model,
				{
					hk: $author$project$Page$Profile$Editor$Loaded(
						_Utils_update(
							loaded,
							{
								hk: A2(
									$author$project$Page$Profile$Editor$initForm,
									profile,
									!_Utils_eq(loaded.nN, $elm$core$Maybe$Nothing))
							}))
				});
		} else {
			return model;
		}
	});
var $author$project$Page$Profile$Editor$mapFeedback = F2(
	function (fn, location) {
		return _Utils_update(
			location,
			{
				hf: fn(location.hf)
			});
	});
var $author$project$Page$Profile$Editor$mapPlace = F2(
	function (fn, location) {
		return _Utils_update(
			location,
			{
				e: fn(location.e)
			});
	});
var $author$project$Form$LocalityPicker$Bairros = function (a) {
	return {$: 1, a: a};
};
var $author$project$Form$LocalityPicker$Model = $elm$core$Basics$identity;
var $author$project$Form$LocalityPicker$Unknown = 0;
var $author$project$Form$LocalityPicker$GotOptions = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Profile$Location$countryCode = function (country) {
	switch (country) {
		case 0:
			return $elm$core$Maybe$Just('BR');
		case 1:
			return $elm$core$Maybe$Just('CR');
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Cambiatus$Query$localities = F2(
	function (fillInOptionals____, object____) {
		var filledInOptionals____ = fillInOptionals____(
			{g5: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, hj: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, eG: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, hO: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, dO: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
		var optionalArgs____ = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'country', filledInOptionals____.g5, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'first', filledInOptionals____.hj, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'kind', filledInOptionals____.eG, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'municipalityId', filledInOptionals____.hO, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'query', filledInOptionals____.dO, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)
				]));
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'localities',
			optionalArgs____,
			object____,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
	});
var $author$project$Form$LocalityPicker$request = F3(
	function (kind, counter, maybeQuery) {
		var fill = function (optionals) {
			if (!kind.$) {
				var country = kind.a;
				return _Utils_update(
					optionals,
					{
						g5: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(
							$author$project$Profile$Location$countryCode(country)),
						hj: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(10),
						dO: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(maybeQuery)
					});
			} else {
				var municipalityId = kind.a.hO;
				return _Utils_update(
					optionals,
					{
						hj: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(50),
						eG: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present('bairro'),
						hO: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(municipalityId),
						dO: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(maybeQuery)
					});
			}
		};
		return {
			k6: A2($author$project$Cambiatus$Query$localities, fill, $author$project$Profile$Location$localitySelectionSet),
			pA: $author$project$Form$LocalityPicker$GotOptions(counter)
		};
	});
var $author$project$Form$LocalityPicker$init = function (_v0) {
	var id = _v0.R;
	var kind = _v0.eG;
	var model = {
		fr: 0,
		bA: 1,
		R: id,
		eG: kind,
		gk: _List_Nil,
		dT: $author$project$View$Select$newState(id)
	};
	if (!kind.$) {
		return _Utils_Tuple2(model, $elm$core$Maybe$Nothing);
	} else {
		return _Utils_Tuple2(
			model,
			$elm$core$Maybe$Just(
				A3($author$project$Form$LocalityPicker$request, kind, 1, $elm$core$Maybe$Nothing)));
	}
};
var $author$project$Page$Profile$Editor$bairroPickerFor = F2(
	function (country, municipality) {
		return A2(
			$elm$core$Tuple$mapFirst,
			$elm$core$Maybe$Just,
			$author$project$Form$LocalityPicker$init(
				{
					R: 'location-bairro-input',
					eG: $author$project$Form$LocalityPicker$Bairros(
						{g5: country, hO: municipality.R})
				}));
	});
var $author$project$Form$LocalityPicker$Municipalities = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Profile$Editor$newMunicipalityPicker = function (country) {
	return $author$project$Form$LocalityPicker$init(
		{
			R: 'location-municipality-input',
			eG: $author$project$Form$LocalityPicker$Municipalities(country)
		}).a;
};
var $author$project$Profile$Location$countryFromCode = function (code) {
	switch (code) {
		case 'BR':
			return 0;
		case 'CR':
			return 1;
		default:
			return 2;
	}
};
var $author$project$Profile$Location$emptyPlace = {by: $elm$core$Maybe$Nothing, aF: '', g5: 0, cw: $elm$core$Maybe$Nothing, h0: ''};
var $author$project$Profile$Location$otherPlace = function (storedText) {
	return _Utils_update(
		$author$project$Profile$Location$emptyPlace,
		{
			g5: 2,
			h0: $author$project$Profile$Location$cleanText(storedText)
		});
};
var $author$project$Profile$Location$placeFromSaved = function (_v0) {
	var storedText = _v0.bX;
	var saved = _v0.h8;
	if (!saved.$) {
		var municipality = saved.a.cw;
		var bairro = saved.a.by;
		var bairroText = saved.a.aF;
		var _v2 = $author$project$Profile$Location$countryFromCode(municipality.g5);
		if (_v2 === 2) {
			return $author$project$Profile$Location$otherPlace(storedText);
		} else {
			var country = _v2;
			return {
				by: bairro,
				aF: A2($elm$core$Maybe$withDefault, '', bairroText),
				g5: country,
				cw: $elm$core$Maybe$Just(municipality),
				h0: ''
			};
		}
	} else {
		return (($author$project$Profile$Location$cleanText(storedText) === '') || $author$project$Profile$Location$looksLikeAddress(storedText)) ? $author$project$Profile$Location$emptyPlace : $author$project$Profile$Location$otherPlace(storedText);
	}
};
var $author$project$Page$Profile$Editor$initLocation = function (data) {
	var place = $author$project$Profile$Location$placeFromSaved(
		{h8: data.h8, bX: data.bX});
	var address = A2($elm$core$Maybe$withDefault, $author$project$Profile$Location$emptyAddress, data.gP);
	var _v0 = function () {
		var _v1 = _Utils_Tuple2(place.g5, place.cw);
		_v1$0:
		while (true) {
			if (_v1.b.$ === 1) {
				if (_v1.a === 2) {
					break _v1$0;
				} else {
					var _v3 = _v1.b;
					return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
				}
			} else {
				if (_v1.a === 2) {
					break _v1$0;
				} else {
					var country = _v1.a;
					var municipality = _v1.b.a;
					return A2($author$project$Page$Profile$Editor$bairroPickerFor, country, municipality);
				}
			}
		}
		var _v2 = _v1.a;
		return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
	}();
	var bairroPicker = _v0.a;
	var request = _v0.b;
	return _Utils_Tuple2(
		{
			gP: address,
			b4: bairroPicker,
			Z: $author$project$Page$Profile$Editor$CepIdle,
			hf: {fv: '', dv: false, eG: 'problem', gE: 0},
			dD: $author$project$Page$Profile$Editor$newMunicipalityPicker(place.g5),
			u: {gP: address, e: place},
			e: place,
			gy: false,
			dW: false,
			bX: data.bX,
			br: _Utils_eq(place.by, $elm$core$Maybe$Nothing) && ($author$project$Profile$Location$cleanText(place.aF) !== '')
		},
		request);
};
var $author$project$Page$Profile$Editor$releaseKey = 'location_picker';
var $author$project$Page$Profile$Editor$maybeBuild = F2(
	function (loggedIn, model) {
		var _v0 = _Utils_Tuple3(model.hk, model.kJ, model.cg);
		if (((!_v0.a.$) && (!_v0.b.$)) && (_v0.c.$ === 3)) {
			var _v1 = _v0.a;
			var profile = _v0.b.a;
			var data = _v0.c.a;
			if (A2($elm$core$List$member, $author$project$Page$Profile$Editor$releaseKey, data.kR)) {
				var _v2 = $author$project$Page$Profile$Editor$initLocation(data);
				var location = _v2.a;
				var request = _v2.b;
				return A4(
					$author$project$Page$Profile$Editor$addPickerRequest,
					loggedIn,
					$author$project$Page$Profile$Editor$GotBairroPickerMsg,
					request,
					$author$project$UpdateResult$init(
						_Utils_update(
							model,
							{
								hk: $author$project$Page$Profile$Editor$Loaded(
									{
										hk: A2($author$project$Page$Profile$Editor$initForm, profile, true),
										nN: $elm$core$Maybe$Just(location)
									})
							})));
			} else {
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{
							hk: $author$project$Page$Profile$Editor$Loaded(
								{
									hk: A2($author$project$Page$Profile$Editor$initForm, profile, false),
									nN: $elm$core$Maybe$Nothing
								})
						}));
			}
		} else {
			return $author$project$UpdateResult$init(model);
		}
	});
var $author$project$Markdown$toRawString = function (_v0) {
	var markdown = _v0;
	return $elm$core$String$trim(markdown);
};
var $author$project$Profile$Contact$unwrap = function (_v0) {
	var contact = _v0;
	return contact;
};
var $author$project$Profile$mutationWith = F2(
	function (fields, form) {
		var interestString = A2(
			$elm$core$String$join,
			',',
			A2(
				$elm$core$List$filter,
				$elm$core$Basics$neq(''),
				A2($elm$core$List$cons, form.bH, form.dj)));
		var contactInput = function (_v0) {
			var contactType = _v0.mf;
			var contact = _v0.me;
			var label = _v0.nC;
			return {
				dc: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(contact),
				nC: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(label),
				d0: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(contactType)
			};
		};
		var avatarInput = A2(
			$elm$core$Maybe$withDefault,
			$dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
			A2($elm$core$Maybe$map, $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present, form.cV));
		return A2(
			$author$project$Cambiatus$Mutation$user,
			{
				nl: {
					cV: avatarInput,
					cW: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
						$author$project$Markdown$toRawString(form.cW)),
					c_: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
					aq: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
						A2(
							$elm$core$List$map,
							A2($elm$core$Basics$composeR, $author$project$Profile$Contact$unwrap, contactInput),
							form.aq)),
					c8: fields.c8,
					c9: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
					jh: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(form.jh),
					dj: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(interestString),
					nN: fields.nN,
					dy: fields.dy,
					dz: fields.dz,
					dA: fields.dA,
					ki: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(form.ki),
					d$: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
				}
			},
			$author$project$Profile$selectionSet);
	});
var $author$project$Profile$Location$needsPostalCode = function (error) {
	if (!error.$) {
		var errors = error.b;
		return A2(
			$elm$core$List$any,
			function (graphqlError) {
				return A2(
					$elm$core$List$member,
					'needs_postal_code',
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$andThen,
							A2(
								$elm$core$Basics$composeR,
								$elm$json$Json$Decode$decodeValue(
									A2(
										$elm$json$Json$Decode$at,
										_List_fromArray(
											['delivery_address']),
										$elm$json$Json$Decode$list($elm$json$Json$Decode$string))),
								$elm$core$Result$toMaybe),
							A2($elm$core$Dict$get, 'details', graphqlError.mz))));
			},
			errors);
	} else {
		return false;
	}
};
var $author$project$Page$Profile$Editor$tl = F2(
	function (_v0, key) {
		var t = _v0.il;
		return t('profile.edit.location.' + key);
	});
var $author$project$Page$Profile$Editor$pickerConfig = function (translators) {
	return {
		m$: false,
		nC: '',
		kl: A2($author$project$Page$Profile$Editor$tl, translators, 'not_found'),
		oG: ''
	};
};
var $author$project$Markdown$empty = '';
var $author$project$Profile$profileToForm = function (_v0) {
	var name = _v0.ki;
	var email = _v0.jh;
	var bio = _v0.cW;
	var localization = _v0.nM;
	var avatar = _v0.cV;
	var interests = _v0.dj;
	var contacts = _v0.aq;
	return {
		cV: $author$project$Avatar$toMaybeString(avatar),
		cW: A2($elm$core$Maybe$withDefault, $author$project$Markdown$empty, bio),
		aq: contacts,
		jh: A2($elm$core$Maybe$withDefault, '', email),
		jk: $elm$core$Dict$empty,
		bH: '',
		dj: interests,
		nM: A2($elm$core$Maybe$withDefault, '', localization),
		ki: A2($elm$core$Maybe$withDefault, '', name)
	};
};
var $author$project$Page$Profile$Editor$resetPlace = F2(
	function (country, location) {
		return _Utils_update(
			location,
			{
				b4: $elm$core$Maybe$Nothing,
				Z: $author$project$Page$Profile$Editor$CepIdle,
				dD: $author$project$Page$Profile$Editor$newMunicipalityPicker(country),
				e: {by: $elm$core$Maybe$Nothing, aF: '', g5: country, cw: $elm$core$Maybe$Nothing, h0: ''},
				br: false
			});
	});
var $dillonkearns$elm_graphql$Graphql$OptionalArgument$Null = {$: 2};
var $author$project$Profile$Location$optionalText = function (value) {
	return (value === '') ? $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent : $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(value);
};
var $author$project$Profile$Location$toInput = F2(
	function (country, address) {
		var toSend = A2(
			$author$project$Profile$Location$dropUnusedFields,
			country,
			$author$project$Profile$Location$normalizeAddress(address));
		return {
			c2: $author$project$Profile$Location$optionalText(toSend.c2),
			ay: $author$project$Profile$Location$optionalText(toSend.ay),
			dM: $author$project$Profile$Location$optionalText(toSend.dM),
			ba: toSend.ba
		};
	});
var $author$project$Profile$Location$addressField = function (_v0) {
	var place = _v0.e;
	var address = _v0.gP;
	return $author$project$Profile$Location$isAddressEmpty(address) ? $dillonkearns$elm_graphql$Graphql$OptionalArgument$Null : $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
		A2($author$project$Profile$Location$toInput, place.g5, address));
};
var $author$project$Profile$Location$NoPlace = {$: 0};
var $author$project$Profile$Location$OtherPlace = function (a) {
	return {$: 1, a: a};
};
var $author$project$Profile$Location$PickedPlace = function (a) {
	return {$: 2, a: a};
};
var $author$project$Profile$Location$nonEmptyText = function (text) {
	var _v0 = $author$project$Profile$Location$cleanText(text);
	if (_v0 === '') {
		return $elm$core$Maybe$Nothing;
	} else {
		var cleaned = _v0;
		return $elm$core$Maybe$Just(cleaned);
	}
};
var $author$project$Profile$Location$placeKey = function (place) {
	var _v0 = _Utils_Tuple2(place.g5, place.cw);
	_v0$0:
	while (true) {
		if (_v0.b.$ === 1) {
			if (_v0.a === 2) {
				break _v0$0;
			} else {
				var _v2 = _v0.b;
				return $author$project$Profile$Location$NoPlace;
			}
		} else {
			if (_v0.a === 2) {
				break _v0$0;
			} else {
				var municipality = _v0.b.a;
				return $author$project$Profile$Location$PickedPlace(
					{
						iR: A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.R;
							},
							place.by),
						aF: _Utils_eq(place.by, $elm$core$Maybe$Nothing) ? $author$project$Profile$Location$cleanText(place.aF) : '',
						hO: municipality.R
					});
			}
		}
	}
	var _v1 = _v0.a;
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Profile$Location$NoPlace,
		A2(
			$elm$core$Maybe$map,
			$author$project$Profile$Location$OtherPlace,
			$author$project$Profile$Location$nonEmptyText(place.h0)));
};
var $author$project$Profile$Location$saveFields = function (_v0) {
	var original = _v0.u;
	var current = _v0.mt;
	var currentKey = $author$project$Profile$Location$placeKey(current.e);
	var placeChanged = !_Utils_eq(
		$author$project$Profile$Location$placeKey(original.e),
		currentKey);
	var legacyLocation = function (text) {
		return placeChanged ? _Utils_update(
			$author$project$Profile$Location$noSaveFields,
			{
				nN: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(text)
			}) : $author$project$Profile$Location$noSaveFields;
	};
	var addressChanged = !_Utils_eq(
		$author$project$Profile$Location$normalizeAddress(original.gP),
		$author$project$Profile$Location$normalizeAddress(current.gP));
	switch (currentKey.$) {
		case 0:
			return legacyLocation('');
		case 1:
			var text = currentKey.a;
			var withAddress = function (fields) {
				return addressChanged ? _Utils_update(
					fields,
					{
						c8: $author$project$Profile$Location$addressField(current)
					}) : fields;
			};
			return withAddress(
				legacyLocation(text));
		default:
			var picked = currentKey.a;
			return (placeChanged || addressChanged) ? {
				c8: addressChanged ? $author$project$Profile$Location$addressField(current) : $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
				nN: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
				dy: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(picked.iR),
				dz: $author$project$Profile$Location$optionalText(picked.aF),
				dA: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(picked.hO)
			} : $author$project$Profile$Location$noSaveFields;
	}
};
var $author$project$Page$Profile$Editor$selectMunicipality = F2(
	function (municipality, location) {
		var _v0 = A2($author$project$Page$Profile$Editor$bairroPickerFor, location.e.g5, municipality);
		var bairroPicker = _v0.a;
		var request = _v0.b;
		return _Utils_Tuple2(
			A2(
				$author$project$Page$Profile$Editor$mapPlace,
				function (place) {
					return _Utils_update(
						place,
						{
							by: $elm$core$Maybe$Nothing,
							aF: '',
							cw: $elm$core$Maybe$Just(municipality)
						});
				},
				_Utils_update(
					location,
					{b4: bairroPicker, br: false})),
			request);
	});
var $author$project$Cambiatus$InputObject$encodeReleaseFeedbackInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'body',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.fv))),
				_Utils_Tuple2(
				'key',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.eF))),
				_Utils_Tuple2(
				'kind',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.eG))),
				_Utils_Tuple2(
				'path',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.gm)))
			]));
};
var $author$project$Cambiatus$Mutation$sendReleaseFeedback = function (requiredArgs____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
		'(Maybe Bool)',
		'sendReleaseFeedback',
		_List_fromArray(
			[
				A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.nl, $author$project$Cambiatus$InputObject$encodeReleaseFeedbackInput)
			]),
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool));
};
var $author$project$Page$Profile$Editor$setAddressField = F3(
	function (field, text, address) {
		switch (field) {
			case 0:
				return _Utils_update(
					address,
					{ba: text});
			case 1:
				return _Utils_update(
					address,
					{ay: text});
			case 2:
				return _Utils_update(
					address,
					{c2: text});
			default:
				return _Utils_update(
					address,
					{dM: text});
		}
	});
var $author$project$Form$LocalityPicker$DebounceElapsed = function (a) {
	return {$: 4, a: a};
};
var $author$project$Form$LocalityPicker$debounceMillis = 250;
var $author$project$Form$LocalityPicker$nonEmpty = function (query) {
	var _v0 = $elm$core$String$trim(query);
	if (_v0 === '') {
		return $elm$core$Maybe$Nothing;
	} else {
		var trimmed = _v0;
		return $elm$core$Maybe$Just(trimmed);
	}
};
var $author$project$Form$LocalityPicker$BlurredPicker = {$: 3};
var $author$project$Form$LocalityPicker$NoOp = {$: 0};
var $author$project$Form$LocalityPicker$SelectedLocality = function (a) {
	return {$: 2, a: a};
};
var $author$project$Form$LocalityPicker$isBairros = function (kind) {
	if (kind.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Profile$Location$provinceName = function (code) {
	switch (code) {
		case 'A':
			return 'Alajuela';
		case 'C':
			return 'Cartago';
		case 'G':
			return 'Guanacaste';
		case 'H':
			return 'Heredia';
		case 'L':
			return 'Limón';
		case 'P':
			return 'Puntarenas';
		case 'SJ':
			return 'San José';
		default:
			var other = code;
			return other;
	}
};
var $author$project$Profile$Location$municipalityRow = F2(
	function (country, municipality) {
		var _v0 = _Utils_Tuple2(country, municipality.lc);
		if (!_v0.b.$) {
			if (_v0.a === 1) {
				var _v1 = _v0.a;
				var code = _v0.b.a;
				return municipality.ki + (' – ' + $author$project$Profile$Location$provinceName(code));
			} else {
				var code = _v0.b.a;
				return municipality.ki + (' – ' + code);
			}
		} else {
			var _v2 = _v0.b;
			return municipality.ki;
		}
	});
var $author$project$Form$LocalityPicker$rowLabel = F2(
	function (kind, locality) {
		if (kind.$ === 1) {
			return locality.ki;
		} else {
			var country = kind.a;
			return A2($author$project$Profile$Location$municipalityRow, country, locality);
		}
	});
var $author$project$Form$LocalityPicker$viewRow = F2(
	function (kind, locality) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('px-4 py-3 text-gray-333 text-left')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$Form$LocalityPicker$rowLabel, kind, locality))
						]))
				]));
	});
var $author$project$View$Select$withEmptySearch = F2(
	function (emptySearch, config) {
		var fn = function (c) {
			return _Utils_update(
				c,
				{mH: emptySearch});
		};
		return A2($author$project$View$Select$mapConfig, fn, config);
	});
var $author$project$Form$LocalityPicker$settings = F2(
	function (config, kind) {
		return A2(
			$author$project$View$Select$withOnBlur,
			$author$project$Form$LocalityPicker$BlurredPicker,
			A2(
				$author$project$View$Select$withEmptySearch,
				$author$project$Form$LocalityPicker$isBairros(kind),
				A2(
					$author$project$View$Select$withMenuClass,
					'flex flex-col w-full border border-solid border-gray-300 rounded-sm z-30 bg-white max-h-72 overflow-auto shadow-lg',
					A2(
						$author$project$View$Select$withNotFoundClass,
						'px-4 py-3 text-gray-333',
						A2(
							$author$project$View$Select$withNotFound,
							config.kl,
							A2(
								$author$project$View$Select$withItemClass,
								'block w-full text-left hover:bg-gray-100 focus:bg-gray-100 active:bg-gray-200',
								A2(
									$author$project$View$Select$withItemHtml,
									$author$project$Form$LocalityPicker$viewRow(kind),
									A2(
										$author$project$View$Select$withPrompt,
										config.oG,
										A2(
											$author$project$View$Select$withInputClassList,
											_List_fromArray(
												[
													_Utils_Tuple2('with-error', config.m$)
												]),
											A2(
												$author$project$View$Select$withInputClass,
												'w-full input',
												$author$project$View$Select$newConfig(
													{
														hh: F2(
															function (_v0, items) {
																return $elm$core$Maybe$Just(items);
															}),
														oj: $author$project$Form$LocalityPicker$NoOp,
														kv: $author$project$Form$LocalityPicker$SelectedLocality,
														pz: $author$project$Form$LocalityPicker$rowLabel(kind)
													})))))))))));
	});
var $author$project$Form$LocalityPicker$Available = 1;
var $author$project$Form$LocalityPicker$Unavailable = 2;
var $author$project$Form$LocalityPicker$settleAvailability = F2(
	function (current, options) {
		if (!current) {
			return $elm$core$List$isEmpty(options) ? 2 : 1;
		} else {
			return current;
		}
	});
var $author$project$Form$LocalityPicker$shouldSearch = F2(
	function (kind, query) {
		if (!kind.$) {
			return $elm$core$String$length(
				$elm$core$String$trim(query)) >= 2;
		} else {
			return true;
		}
	});
var $author$project$Form$LocalityPicker$update = F3(
	function (config, msg, _v0) {
		var model = _v0;
		var unchanged = {g0: $elm$core$Platform$Cmd$none, nV: model, h6: $elm$core$Maybe$Nothing, ia: $elm$core$Maybe$Nothing};
		switch (msg.$) {
			case 0:
				return unchanged;
			case 3:
				return unchanged;
			case 1:
				var subMsg = msg.a;
				var _v2 = A3(
					$author$project$View$Select$update,
					A2($author$project$Form$LocalityPicker$settings, config, model.eG),
					subMsg,
					model.dT);
				var newState = _v2.a;
				var cmd = _v2.b;
				var queryChanged = !_Utils_eq(
					$author$project$View$Select$queryFromState(newState),
					$author$project$View$Select$queryFromState(model.dT));
				var counter = queryChanged ? (model.bA + 1) : model.bA;
				var debounce = queryChanged ? A2(
					$elm$core$Task$perform,
					function (_v3) {
						return $author$project$Form$LocalityPicker$DebounceElapsed(counter);
					},
					$elm$core$Process$sleep($author$project$Form$LocalityPicker$debounceMillis)) : $elm$core$Platform$Cmd$none;
				return _Utils_update(
					unchanged,
					{
						g0: $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[cmd, debounce])),
						nV: _Utils_update(
							model,
							{bA: counter, dT: newState})
					});
			case 2:
				var locality = msg.a;
				return _Utils_update(
					unchanged,
					{
						nV: _Utils_update(
							model,
							{bA: model.bA + 1}),
						ia: $elm$core$Maybe$Just(locality)
					});
			case 4:
				var counter = msg.a;
				if (!_Utils_eq(counter, model.bA)) {
					return unchanged;
				} else {
					var _v4 = $author$project$View$Select$queryFromState(model.dT);
					if (_v4.$ === 1) {
						return unchanged;
					} else {
						var query = _v4.a;
						return A2($author$project$Form$LocalityPicker$shouldSearch, model.eG, query) ? _Utils_update(
							unchanged,
							{
								h6: $elm$core$Maybe$Just(
									A3(
										$author$project$Form$LocalityPicker$request,
										model.eG,
										counter,
										$author$project$Form$LocalityPicker$nonEmpty(query)))
							}) : _Utils_update(
							unchanged,
							{
								nV: _Utils_update(
									model,
									{gk: _List_Nil})
							});
					}
				}
			default:
				var counter = msg.a;
				var result = msg.b;
				var showOptions = function (options) {
					return _Utils_update(
						unchanged,
						{
							nV: _Utils_update(
								model,
								{
									fr: A2($author$project$Form$LocalityPicker$settleAvailability, model.fr, options),
									gk: options
								})
						});
				};
				if (!_Utils_eq(counter, model.bA)) {
					return unchanged;
				} else {
					switch (result.$) {
						case 3:
							var options = result.a;
							return showOptions(options);
						case 2:
							return showOptions(_List_Nil);
						default:
							return unchanged;
					}
				}
		}
	});
var $author$project$Page$Profile$Editor$withLocation = F2(
	function (model, fn) {
		var _v0 = model.hk;
		if (_v0.$ === 1) {
			var location = _v0.a.nN;
			if (!location.$) {
				var locationState = location.a;
				return fn(locationState);
			} else {
				return $author$project$UpdateResult$init(model);
			}
		} else {
			return $author$project$UpdateResult$init(model);
		}
	});
var $author$project$Page$Profile$Editor$updateLocation = F2(
	function (model, fn) {
		return A2(
			$author$project$Page$Profile$Editor$withLocation,
			model,
			function (location) {
				return $author$project$UpdateResult$init(
					A2(
						$author$project$Page$Profile$Editor$setLocation,
						fn(location),
						model));
			});
	});
var $author$project$Page$Profile$Editor$update = F3(
	function (msg, model, loggedIn) {
		var _v0 = loggedIn.aM.iw;
		var t = _v0.il;
		switch (msg.$) {
			case 0:
				return $author$project$UpdateResult$init(model);
			case 1:
				var profile = msg.a;
				return A2(
					$author$project$Page$Profile$Editor$maybeBuild,
					loggedIn,
					A2(
						$author$project$Page$Profile$Editor$loadProfile,
						profile,
						_Utils_update(
							model,
							{
								kJ: $elm$core$Maybe$Just(profile)
							})));
			case 2:
				var symbol = function () {
					var _v2 = loggedIn.o7;
					if (_v2.$ === 3) {
						var community = _v2.a;
						return community.e9;
					} else {
						return A2($elm$core$Maybe$withDefault, $author$project$Eos$cambiatusSymbol, loggedIn.aM.o7);
					}
				}();
				return A2(
					$author$project$UpdateResult$addExt,
					A3(
						$author$project$Session$LoggedIn$query,
						loggedIn,
						$author$project$Profile$Location$editorSelectionSet(
							{fl: loggedIn.lM, e9: symbol}),
						$author$project$Page$Profile$Editor$GotEditorData),
					$author$project$UpdateResult$init(
						_Utils_update(
							model,
							{cg: $krisajenkins$remotedata$RemoteData$Loading})));
			case 3:
				var result = msg.a;
				switch (result.$) {
					case 3:
						var maybeData = result.a;
						return A2(
							$author$project$Page$Profile$Editor$maybeBuild,
							loggedIn,
							_Utils_update(
								model,
								{
									cg: $krisajenkins$remotedata$RemoteData$Success(
										A2(
											$elm$core$Maybe$withDefault,
											{gP: $elm$core$Maybe$Nothing, kR: _List_Nil, h8: $elm$core$Maybe$Nothing, bX: ''},
											maybeData))
								}));
					case 2:
						var e = result.a;
						return A7(
							$author$project$UpdateResult$logGraphqlError,
							msg,
							$elm$core$Maybe$Just(loggedIn.lM),
							'Got an error when trying to load the place and address of the profile editor',
							{mX: 'update', nW: 'Page.Profile.Editor'},
							_List_Nil,
							e,
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{
										cg: $krisajenkins$remotedata$RemoteData$Failure(e)
									})));
					default:
						return $author$project$UpdateResult$init(model);
				}
			case 4:
				var formOutput = msg.a;
				var _v4 = _Utils_Tuple2(loggedIn.kJ, model.hk);
				if ((_v4.a.$ === 3) && (_v4.b.$ === 1)) {
					var profile = _v4.a.a;
					var loaded = _v4.b.a;
					var newProfile = _Utils_update(
						profile,
						{
							cV: A2(
								$elm$core$Maybe$withDefault,
								profile.cV,
								A2($elm$core$Maybe$map, $author$project$Avatar$fromString, formOutput.cV)),
							cW: $elm$core$Maybe$Just(formOutput.cW),
							jh: $elm$core$Maybe$Just(formOutput.jh),
							dj: formOutput.dj,
							nM: $elm$core$Maybe$Just(formOutput.nN),
							ki: $elm$core$Maybe$Just(formOutput.de)
						});
					var save = function (fields) {
						return A2(
							$author$project$UpdateResult$addExt,
							A3(
								$author$project$Session$LoggedIn$mutation,
								loggedIn,
								A2(
									$author$project$Profile$mutationWith,
									fields,
									$author$project$Profile$profileToForm(newProfile)),
								$author$project$Page$Profile$Editor$GotSaveResult),
							A2(
								$author$project$UpdateResult$addExt,
								$author$project$Session$LoggedIn$UpdatedLoggedIn(
									_Utils_update(
										loggedIn,
										{kJ: $krisajenkins$remotedata$RemoteData$Loading})),
								$author$project$UpdateResult$init(model)));
					};
					var _v5 = loaded.nN;
					if (_v5.$ === 1) {
						return save(
							$author$project$Profile$Location$legacySaveFields(formOutput.nN));
					} else {
						var location = _v5.a;
						return $author$project$Page$Profile$Editor$hasLocationErrors(location) ? $author$project$UpdateResult$init(
							A2(
								$author$project$Page$Profile$Editor$setLocation,
								_Utils_update(
									location,
									{dW: true}),
								model)) : save(
							$author$project$Profile$Location$saveFields(
								{
									mt: {gP: location.gP, e: location.e},
									u: location.u
								}));
					}
				} else {
					return A6(
						$author$project$UpdateResult$logImpossible,
						msg,
						'Tried saving profile, but current profile wasn\'t loaded',
						$elm$core$Maybe$Just(loggedIn.lM),
						{mX: 'update', nW: 'Page.Profile.Editor'},
						_List_Nil,
						$author$project$UpdateResult$init(model));
				}
			case 5:
				switch (msg.a.$) {
					case 3:
						if (!msg.a.a.$) {
							var profile = msg.a.a.a;
							return A2(
								$author$project$UpdateResult$addBreadcrumb,
								{fw: msg, i9: $elm$core$Dict$empty, nH: 4, nS: 'Successfully saved profile', d0: 1},
								A2(
									$author$project$UpdateResult$addCmd,
									A2(
										$author$project$Route$pushUrl,
										loggedIn.aM.eM,
										$author$project$Route$Profile(loggedIn.lM)),
									A2(
										$author$project$UpdateResult$addExt,
										A2(
											$author$project$Session$LoggedIn$ShowFeedback,
											0,
											t('profile.edit_success')),
										A2(
											$author$project$UpdateResult$addExt,
											$author$project$Session$LoggedIn$ExternalBroadcast(
												$author$project$Session$LoggedIn$ProfileLoaded(profile)),
											$author$project$UpdateResult$init(model)))));
						} else {
							var _v6 = msg.a.a;
							return $author$project$UpdateResult$init(model);
						}
					case 2:
						var e = msg.a.a;
						return $author$project$Profile$Location$needsPostalCode(e) ? A2(
							$author$project$Page$Profile$Editor$withLocation,
							model,
							function (location) {
								return A2(
									$author$project$UpdateResult$addExt,
									$author$project$Session$LoggedIn$UpdatedLoggedIn(
										_Utils_update(
											loggedIn,
											{
												kJ: A2(
													$elm$core$Maybe$withDefault,
													loggedIn.kJ,
													A2($elm$core$Maybe$map, $krisajenkins$remotedata$RemoteData$Success, model.kJ))
											})),
									$author$project$UpdateResult$init(
										A2(
											$author$project$Page$Profile$Editor$setLocation,
											_Utils_update(
												location,
												{gy: true, dW: true}),
											model)));
							}) : A7(
							$author$project$UpdateResult$logGraphqlError,
							msg,
							$elm$core$Maybe$Just(loggedIn.lM),
							'Got an error when trying to save profile',
							{mX: 'update', nW: 'Page.Profile.Editor'},
							_List_Nil,
							e,
							A2(
								$author$project$UpdateResult$addExt,
								$author$project$Session$LoggedIn$UpdatedLoggedIn(
									_Utils_update(
										loggedIn,
										{
											kJ: $krisajenkins$remotedata$RemoteData$Failure(e)
										})),
								$author$project$UpdateResult$init(model)));
					default:
						return $author$project$UpdateResult$init(model);
				}
			case 6:
				var subMsg = msg.a;
				var _v7 = model.hk;
				if (!_v7.$) {
					return $author$project$UpdateResult$init(model);
				} else {
					var loaded = _v7.a;
					return A5(
						$author$project$UpdateResult$fromChild,
						function (newForm) {
							return _Utils_update(
								model,
								{
									hk: $author$project$Page$Profile$Editor$Loaded(
										_Utils_update(
											loaded,
											{hk: newForm}))
								});
						},
						$author$project$Page$Profile$Editor$GotFormMsg,
						$author$project$Session$LoggedIn$addFeedback,
						model,
						A3($author$project$Form$update, loggedIn.aM, subMsg, loaded.hk));
				}
			case 7:
				var country = msg.a;
				return A2(
					$author$project$Page$Profile$Editor$updateLocation,
					model,
					function (location) {
						return A2($author$project$Page$Profile$Editor$resetPlace, country, location);
					});
			case 8:
				var subMsg = msg.a;
				return A2(
					$author$project$Page$Profile$Editor$withLocation,
					model,
					function (location) {
						var result = A3(
							$author$project$Form$LocalityPicker$update,
							$author$project$Page$Profile$Editor$pickerConfig(loggedIn.aM.iw),
							subMsg,
							location.dD);
						var withPicker = _Utils_update(
							location,
							{dD: result.nV});
						var _v8 = function () {
							var _v9 = result.ia;
							if (!_v9.$) {
								var municipality = _v9.a;
								return A2($author$project$Page$Profile$Editor$selectMunicipality, municipality, withPicker);
							} else {
								return _Utils_Tuple2(withPicker, $elm$core$Maybe$Nothing);
							}
						}();
						var newLocation = _v8.a;
						var extraRequest = _v8.b;
						return A4(
							$author$project$Page$Profile$Editor$addPickerRequest,
							loggedIn,
							$author$project$Page$Profile$Editor$GotBairroPickerMsg,
							extraRequest,
							A4(
								$author$project$Page$Profile$Editor$addPickerRequest,
								loggedIn,
								$author$project$Page$Profile$Editor$GotMunicipalityPickerMsg,
								result.h6,
								A2(
									$author$project$UpdateResult$addCmd,
									A2($elm$core$Platform$Cmd$map, $author$project$Page$Profile$Editor$GotMunicipalityPickerMsg, result.g0),
									$author$project$UpdateResult$init(
										A2($author$project$Page$Profile$Editor$setLocation, newLocation, model)))));
					});
			case 9:
				var subMsg = msg.a;
				return A2(
					$author$project$Page$Profile$Editor$withLocation,
					model,
					function (location) {
						var _v10 = location.b4;
						if (_v10.$ === 1) {
							return $author$project$UpdateResult$init(model);
						} else {
							var picker = _v10.a;
							var result = A3(
								$author$project$Form$LocalityPicker$update,
								$author$project$Page$Profile$Editor$pickerConfig(loggedIn.aM.iw),
								subMsg,
								picker);
							var withPicker = _Utils_update(
								location,
								{
									b4: $elm$core$Maybe$Just(result.nV)
								});
							var newLocation = function () {
								var _v11 = result.ia;
								if (!_v11.$) {
									var bairro = _v11.a;
									return A2(
										$author$project$Page$Profile$Editor$mapPlace,
										function (place) {
											return _Utils_update(
												place,
												{
													by: $elm$core$Maybe$Just(bairro),
													aF: ''
												});
										},
										withPicker);
								} else {
									return withPicker;
								}
							}();
							return A4(
								$author$project$Page$Profile$Editor$addPickerRequest,
								loggedIn,
								$author$project$Page$Profile$Editor$GotBairroPickerMsg,
								result.h6,
								A2(
									$author$project$UpdateResult$addCmd,
									A2($elm$core$Platform$Cmd$map, $author$project$Page$Profile$Editor$GotBairroPickerMsg, result.g0),
									$author$project$UpdateResult$init(
										A2($author$project$Page$Profile$Editor$setLocation, newLocation, model))));
						}
					});
			case 10:
				return A2(
					$author$project$Page$Profile$Editor$updateLocation,
					model,
					function (location) {
						return A2($author$project$Page$Profile$Editor$resetPlace, location.e.g5, location);
					});
			case 11:
				return A2(
					$author$project$Page$Profile$Editor$updateLocation,
					model,
					function (location) {
						return A2(
							$author$project$Page$Profile$Editor$mapPlace,
							function (place) {
								return _Utils_update(
									place,
									{by: $elm$core$Maybe$Nothing, aF: ''});
							},
							_Utils_update(
								location,
								{br: false}));
					});
			case 12:
				return A2(
					$author$project$Page$Profile$Editor$updateLocation,
					model,
					function (location) {
						return _Utils_update(
							location,
							{br: true});
					});
			case 13:
				return A2(
					$author$project$Page$Profile$Editor$updateLocation,
					model,
					function (location) {
						return A2(
							$author$project$Page$Profile$Editor$mapPlace,
							function (place) {
								return _Utils_update(
									place,
									{aF: ''});
							},
							_Utils_update(
								location,
								{br: false}));
					});
			case 14:
				return A2(
					$author$project$Page$Profile$Editor$updateLocation,
					model,
					function (location) {
						return A2($author$project$Page$Profile$Editor$resetPlace, location.e.g5, location);
					});
			case 15:
				var text = msg.a;
				return A2(
					$author$project$Page$Profile$Editor$updateLocation,
					model,
					$author$project$Page$Profile$Editor$mapPlace(
						function (place) {
							return _Utils_update(
								place,
								{aF: text});
						}));
			case 16:
				var text = msg.a;
				return A2(
					$author$project$Page$Profile$Editor$updateLocation,
					model,
					$author$project$Page$Profile$Editor$mapPlace(
						function (place) {
							return _Utils_update(
								place,
								{h0: text});
						}));
			case 17:
				var field = msg.a;
				var text = msg.b;
				return A2(
					$author$project$Page$Profile$Editor$withLocation,
					model,
					function (location) {
						var withText = _Utils_update(
							location,
							{
								gP: A3($author$project$Page$Profile$Editor$setAddressField, field, text, location.gP)
							});
						if (field === 3) {
							return A3($author$project$Page$Profile$Editor$changedPostalCode, loggedIn, withText, model);
						} else {
							return $author$project$UpdateResult$init(
								A2($author$project$Page$Profile$Editor$setLocation, withText, model));
						}
					});
			case 18:
				var digits = msg.a;
				var result = msg.b;
				return A2(
					$author$project$Page$Profile$Editor$withLocation,
					model,
					function (location) {
						if (!_Utils_eq(
							location.Z,
							$author$project$Page$Profile$Editor$CepLoading(digits))) {
							return $author$project$UpdateResult$init(model);
						} else {
							if (result.$ === 3) {
								if (!result.a.$) {
									var lookup = result.a.a;
									var folded = A2(
										$author$project$Profile$Location$applyLookup,
										lookup,
										{gP: location.gP, e: location.e});
									var focusId = _Utils_eq(lookup.ba, $elm$core$Maybe$Nothing) ? 'address-street-input' : 'address-number-input';
									var _v14 = function () {
										var _v15 = lookup.cw;
										if (!_v15.$) {
											var municipality = _v15.a;
											return A2($author$project$Page$Profile$Editor$selectMunicipality, municipality, location);
										} else {
											return _Utils_Tuple2(location, $elm$core$Maybe$Nothing);
										}
									}();
									var withMunicipality = _v14.a;
									var request = _v14.b;
									var newLocation = _Utils_update(
										withMunicipality,
										{
											gP: folded.gP,
											Z: $author$project$Page$Profile$Editor$CepFound(
												{
													fQ: !_Utils_eq(lookup.cw, $elm$core$Maybe$Nothing),
													f8: lookup
												}),
											e: folded.e,
											br: _Utils_eq(folded.e.by, $elm$core$Maybe$Nothing) && (folded.e.aF !== '')
										});
									return A2(
										$author$project$UpdateResult$addCmd,
										A2(
											$elm$core$Task$attempt,
											function (_v16) {
												return $author$project$Page$Profile$Editor$NoOp;
											},
											$elm$browser$Browser$Dom$focus(focusId)),
										A4(
											$author$project$Page$Profile$Editor$addPickerRequest,
											loggedIn,
											$author$project$Page$Profile$Editor$GotBairroPickerMsg,
											request,
											$author$project$UpdateResult$init(
												A2($author$project$Page$Profile$Editor$setLocation, newLocation, model))));
								} else {
									var _v17 = result.a;
									return $author$project$UpdateResult$init(
										A2(
											$author$project$Page$Profile$Editor$setLocation,
											_Utils_update(
												location,
												{Z: $author$project$Page$Profile$Editor$CepNotFound}),
											model));
								}
							} else {
								return $author$project$UpdateResult$init(
									A2(
										$author$project$Page$Profile$Editor$setLocation,
										_Utils_update(
											location,
											{Z: $author$project$Page$Profile$Editor$CepUnavailable}),
										model));
							}
						}
					});
			case 19:
				return A2(
					$author$project$Page$Profile$Editor$updateLocation,
					model,
					function (location) {
						var _v18 = location.Z;
						if (_v18.$ === 2) {
							var found = _v18.a;
							return _Utils_update(
								location,
								{
									Z: $author$project$Page$Profile$Editor$CepFound(
										_Utils_update(
											found,
											{fQ: false}))
								});
						} else {
							return location;
						}
					});
			case 20:
				return A2(
					$author$project$Page$Profile$Editor$updateLocation,
					model,
					$author$project$Page$Profile$Editor$mapFeedback(
						function (feedback) {
							return _Utils_update(
								feedback,
								{dv: !feedback.dv, gE: 0});
						}));
			case 21:
				var kind = msg.a;
				return A2(
					$author$project$Page$Profile$Editor$updateLocation,
					model,
					$author$project$Page$Profile$Editor$mapFeedback(
						function (feedback) {
							return _Utils_update(
								feedback,
								{eG: kind});
						}));
			case 22:
				var body = msg.a;
				return A2(
					$author$project$Page$Profile$Editor$updateLocation,
					model,
					$author$project$Page$Profile$Editor$mapFeedback(
						function (feedback) {
							return _Utils_update(
								feedback,
								{fv: body});
						}));
			case 23:
				return A2(
					$author$project$Page$Profile$Editor$withLocation,
					model,
					function (location) {
						var feedback = location.hf;
						return (($elm$core$String$trim(feedback.fv) === '') || (feedback.gE === 1)) ? $author$project$UpdateResult$init(model) : A2(
							$author$project$UpdateResult$addExt,
							A3(
								$author$project$Session$LoggedIn$mutation,
								loggedIn,
								$author$project$Cambiatus$Mutation$sendReleaseFeedback(
									{
										nl: {
											fv: $elm$core$String$trim(feedback.fv),
											eF: $author$project$Page$Profile$Editor$releaseKey,
											eG: feedback.eG,
											gm: '/profile/edit'
										}
									}),
								$author$project$Page$Profile$Editor$GotFeedbackResult),
							$author$project$UpdateResult$init(
								A2(
									$author$project$Page$Profile$Editor$setLocation,
									_Utils_update(
										location,
										{
											hf: _Utils_update(
												feedback,
												{gE: 1})
										}),
									model)));
					});
			default:
				var result = msg.a;
				return A2(
					$author$project$Page$Profile$Editor$updateLocation,
					model,
					$author$project$Page$Profile$Editor$mapFeedback(
						function (feedback) {
							switch (result.$) {
								case 3:
									if ((!result.a.$) && result.a.a) {
										return _Utils_update(
											feedback,
											{fv: '', dv: false, gE: 2});
									} else {
										return _Utils_update(
											feedback,
											{gE: 3});
									}
								case 2:
									return _Utils_update(
										feedback,
										{gE: 3});
								default:
									return feedback;
							}
						}));
		}
	});
var $author$project$Page$Register$AccountCreated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$Register$AccountTypeSelectorShowed = {$: 1};
var $author$project$Page$Register$DefaultForm = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Register$DefaultFormMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Register$ErrorShowed = {$: 4};
var $author$project$Page$Register$FormShowed = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Page$Register$GotFormMsg = function (a) {
	return {$: 13, a: a};
};
var $author$project$Page$Register$JuridicalForm = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Register$JuridicalFormMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Register$NaturalForm = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Register$NaturalFormMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Register$NoOp = {$: 0};
var $author$project$Page$Register$NotFound = {$: 5};
var $author$project$Page$Register$SavePassphrase = 1;
var $author$project$Page$Register$SubmittedForm = function (a) {
	return {$: 14, a: a};
};
var $author$project$Page$Register$DefaultForm$encode = function (output) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(output.ki)),
				_Utils_Tuple2(
				'account',
				$author$project$Eos$Account$encodeName(output.fl)),
				_Utils_Tuple2(
				'email',
				$elm$json$Json$Encode$string(output.jh))
			]));
};
var $author$project$Page$Register$JuridicalForm$companyTypeToString = function (type_) {
	if (!type_) {
		return 'mipyme';
	} else {
		return 'gran_empresa';
	}
};
var $author$project$Page$Register$JuridicalForm$encode = function (output) {
	var encodeIdAndName = function (_v0) {
		var id = _v0.R;
		var name = _v0.ki;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$string(id)),
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string(name))
				]));
	};
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'companyType',
				$elm$json$Json$Encode$string(
					$author$project$Page$Register$JuridicalForm$companyTypeToString(output.md))),
				_Utils_Tuple2(
				'document',
				$elm$json$Json$Encode$string(output.eq)),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(output.ki)),
				_Utils_Tuple2(
				'email',
				$elm$json$Json$Encode$string(output.jh)),
				_Utils_Tuple2(
				'phone',
				$elm$json$Json$Encode$string(output.eT)),
				_Utils_Tuple2(
				'account',
				$author$project$Eos$Account$encodeName(output.fl)),
				_Utils_Tuple2(
				'state',
				encodeIdAndName(output.X)),
				_Utils_Tuple2(
				'city',
				encodeIdAndName(output.l4)),
				_Utils_Tuple2(
				'district',
				encodeIdAndName(output.mC)),
				_Utils_Tuple2(
				'street',
				$elm$json$Json$Encode$string(output.ba)),
				_Utils_Tuple2(
				'number',
				$elm$json$Json$Encode$string(output.ay)),
				_Utils_Tuple2(
				'zip',
				$elm$json$Json$Encode$string(output.fk))
			]));
};
var $author$project$Page$Register$NaturalForm$documentTypeToString = function (document) {
	switch (document) {
		case 0:
			return 'cedula_de_identidad';
		case 1:
			return 'dimex';
		default:
			return 'nite';
	}
};
var $author$project$Page$Register$NaturalForm$encode = function (output) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'documentType',
				$elm$json$Json$Encode$string(
					$author$project$Page$Register$NaturalForm$documentTypeToString(output.er))),
				_Utils_Tuple2(
				'document',
				$elm$json$Json$Encode$string(output.eq)),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(output.ki)),
				_Utils_Tuple2(
				'email',
				$elm$json$Json$Encode$string(output.jh)),
				_Utils_Tuple2(
				'phoneNumber',
				$elm$json$Json$Encode$string(output.oC)),
				_Utils_Tuple2(
				'account',
				$author$project$Eos$Account$encodeName(output.fl))
			]));
};
var $author$project$Page$Register$encodeFormOutput = function (output) {
	switch (output.$) {
		case 0:
			var natural = output.a;
			return $author$project$Page$Register$NaturalForm$encode(natural);
		case 1:
			var juridical = output.a;
			return $author$project$Page$Register$JuridicalForm$encode(juridical);
		default:
			var _default = output.a;
			return $author$project$Page$Register$DefaultForm$encode(_default);
	}
};
var $author$project$Page$Register$getSignUpFields = function (form) {
	var extract = function (f) {
		return {fl: f.fl, jh: f.jh, ki: f.ki};
	};
	switch (form.$) {
		case 1:
			var f = form.a;
			return extract(f);
		case 0:
			var f = form.a;
			return extract(f);
		default:
			var f = form.a;
			return extract(f);
	}
};
var $author$project$Page$Register$JuridicalForm$init = function (country) {
	return $author$project$Form$init(
		{fl: '', l4: $elm$core$Maybe$Nothing, md: 0, g5: country, mC: $elm$core$Maybe$Nothing, eq: '', jh: '', ki: '', ay: '', oC: '', X: $elm$core$Maybe$Nothing, ba: '', fk: ''});
};
var $author$project$Page$Register$NaturalForm$init = $author$project$Form$init(
	{fl: '', eq: '', er: 0, jh: '', ki: '', oC: ''});
var $author$project$Page$Register$CompletedLoadCountry = function (a) {
	return {$: 10, a: a};
};
var $author$project$Cambiatus$InputObject$encodeCountryInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.ki)))
			]));
};
var $author$project$Cambiatus$Query$country = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'country',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.nl, $author$project$Cambiatus$InputObject$encodeCountryInput)
				]),
			object____,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
	});
var $author$project$Address$Country = F3(
	function (id, name, states) {
		return {R: id, ki: name, pj: states};
	});
var $author$project$Cambiatus$Object$Country$id = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.Id',
	'id',
	_List_Nil,
	$author$project$Cambiatus$Scalar$unwrapCodecs($author$project$Cambiatus$ScalarCodecs$codecs).eh.jc);
var $author$project$Address$State = F3(
	function (id, name, cities) {
		return {l3: cities, R: id, ki: name};
	});
var $author$project$Cambiatus$Object$State$cities = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'cities',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Address$City = F3(
	function (id, name, neighborhoods) {
		return {R: id, ki: name, n$: neighborhoods};
	});
var $author$project$Cambiatus$Object$City$id = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.Id',
	'id',
	_List_Nil,
	$author$project$Cambiatus$Scalar$unwrapCodecs($author$project$Cambiatus$ScalarCodecs$codecs).eh.jc);
var $author$project$Address$Neighborhood = F2(
	function (id, name) {
		return {R: id, ki: name};
	});
var $author$project$Cambiatus$Object$Neighborhood$id = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.Id',
	'id',
	_List_Nil,
	$author$project$Cambiatus$Scalar$unwrapCodecs($author$project$Cambiatus$ScalarCodecs$codecs).eh.jc);
var $author$project$Address$neighborhoodSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$Neighborhood$name,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Cambiatus$Object$Neighborhood$id,
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Address$Neighborhood)));
var $author$project$Cambiatus$Object$City$neighborhoods = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'neighborhoods',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Address$citySelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$City$neighborhoods($author$project$Address$neighborhoodSelectionSet),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Cambiatus$Object$City$name,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Cambiatus$Object$City$id,
			$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Address$City))));
var $author$project$Cambiatus$Object$State$id = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.Id',
	'id',
	_List_Nil,
	$author$project$Cambiatus$Scalar$unwrapCodecs($author$project$Cambiatus$ScalarCodecs$codecs).eh.jc);
var $author$project$Address$stateSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$State$cities($author$project$Address$citySelectionSet),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Cambiatus$Object$State$name,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Cambiatus$Object$State$id,
			$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Address$State))));
var $author$project$Cambiatus$Object$Country$states = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'states',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Address$countrySelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$Country$states($author$project$Address$stateSelectionSet),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Cambiatus$Object$Country$name,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Cambiatus$Object$Country$id,
			$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Address$Country))));
var $author$project$Address$countryQuery = function (name) {
	return A2(
		$author$project$Cambiatus$Query$country,
		{
			nl: {ki: name}
		},
		$author$project$Address$countrySelectionSet);
};
var $author$project$Page$Register$DefaultForm$init = $author$project$Form$init(
	{fl: '', jh: '', ki: ''});
var $author$project$Page$Register$loadedCommunity = F4(
	function (shared, model, community, maybeInvite) {
		if (community.ck) {
			var loadCountryData = A4(
				$author$project$Api$Graphql$query,
				shared,
				$elm$core$Maybe$Nothing,
				$author$project$Address$countryQuery('Costa Rica'),
				$author$project$Page$Register$CompletedLoadCountry);
			return A2(
				$author$project$UpdateResult$addCmd,
				loadCountryData,
				$author$project$UpdateResult$init(
					_Utils_update(
						model,
						{dk: maybeInvite, gE: $author$project$Page$Register$Loading})));
		} else {
			return $author$project$UpdateResult$init(
				_Utils_update(
					model,
					{
						dk: maybeInvite,
						gE: A2(
							$author$project$Page$Register$FormShowed,
							{gJ: $elm$core$Set$empty},
							$author$project$Page$Register$DefaultForm($author$project$Page$Register$DefaultForm$init))
					}));
		}
	});
var $author$project$Page$Register$CompletedSignUp = function (a) {
	return {$: 12, a: a};
};
var $author$project$Api$Graphql$SignUpResponse = F2(
	function (profile, token) {
		return {kJ: profile, pC: token};
	});
var $author$project$Cambiatus$InputObject$encodeAddressUpdateInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'cityId',
				$elm$core$Maybe$Just(
					A2(
						$author$project$Cambiatus$Scalar$unwrapEncoder,
						function ($) {
							return $.eh;
						},
						$author$project$Cambiatus$ScalarCodecs$codecs)(input____.ef))),
				_Utils_Tuple2(
				'countryId',
				$elm$core$Maybe$Just(
					A2(
						$author$project$Cambiatus$Scalar$unwrapEncoder,
						function ($) {
							return $.eh;
						},
						$author$project$Cambiatus$ScalarCodecs$codecs)(input____.aT))),
				_Utils_Tuple2(
				'neighborhoodId',
				$elm$core$Maybe$Just(
					A2(
						$author$project$Cambiatus$Scalar$unwrapEncoder,
						function ($) {
							return $.eh;
						},
						$author$project$Cambiatus$ScalarCodecs$codecs)(input____.eN))),
				_Utils_Tuple2(
				'number',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ay, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'stateId',
				$elm$core$Maybe$Just(
					A2(
						$author$project$Cambiatus$Scalar$unwrapEncoder,
						function ($) {
							return $.eh;
						},
						$author$project$Cambiatus$ScalarCodecs$codecs)(input____.e7))),
				_Utils_Tuple2(
				'street',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.ba))),
				_Utils_Tuple2(
				'zip',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.fk)))
			]));
};
var $author$project$Cambiatus$Mutation$signUp = F3(
	function (fillInOptionals____, requiredArgs____, object____) {
		var filledInOptionals____ = fillInOptionals____(
			{gP: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, jT: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, hx: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
		var optionalArgs____ = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'address', filledInOptionals____.gP, $author$project$Cambiatus$InputObject$encodeAddressUpdateInput),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'invitationId', filledInOptionals____.jT, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'kyc', filledInOptionals____.hx, $author$project$Cambiatus$InputObject$encodeKycDataUpdateInput)
				]));
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'signUp',
			_Utils_ap(
				optionalArgs____,
				_List_fromArray(
					[
						A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'account', requiredArgs____.fl, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string),
						A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'email', requiredArgs____.jh, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string),
						A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'name', requiredArgs____.ki, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string),
						A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'publicKey', requiredArgs____.kN, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string),
						A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'userType', requiredArgs____.lD, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)
					])),
			object____,
			$elm$core$Basics$identity);
	});
var $author$project$Api$Graphql$signUp = F4(
	function (shared, requiredArgs, fillOptionals, toMsg) {
		return A4(
			$author$project$Api$Graphql$mutation,
			shared,
			$elm$core$Maybe$Nothing,
			A3(
				$author$project$Cambiatus$Mutation$signUp,
				fillOptionals,
				{
					fl: $author$project$Eos$Account$nameToString(requiredArgs.lM),
					jh: requiredArgs.jh,
					ki: requiredArgs.ki,
					kN: requiredArgs.kN,
					lD: requiredArgs.lD
				},
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $elm$core$Basics$identity, $author$project$Cambiatus$Object$Session$token),
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$Cambiatus$Object$Session$user($author$project$Profile$minimalSelectionSet),
						$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Api$Graphql$SignUpResponse)))),
			toMsg);
	});
var $author$project$Page$Register$signUp = F4(
	function (shared, _v0, invitationId, formOutput) {
		var accountName = _v0.lM;
		var ownerKey = _v0.kw;
		var _v1 = $author$project$Page$Register$getSignUpFields(formOutput);
		var email = _v1.jh;
		var name = _v1.ki;
		var _v2 = function () {
			switch (formOutput.$) {
				case 2:
					return _Utils_Tuple2($dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent);
				case 0:
					var f = formOutput.a;
					return _Utils_Tuple2(
						$dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
							{
								aT: '1',
								eq: f.eq,
								er: $author$project$Page$Register$NaturalForm$documentTypeToString(f.er),
								eT: f.oC,
								lD: 'natural'
							}),
						$dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent);
				default:
					var f = formOutput.a;
					return _Utils_Tuple2(
						$dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
							{
								aT: '1',
								eq: f.eq,
								er: $author$project$Page$Register$JuridicalForm$companyTypeToString(f.md),
								eT: f.eT,
								lD: 'juridical'
							}),
						$dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
							{
								ef: f.l4.R,
								aT: '1',
								eN: f.mC.R,
								ay: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(f.ay),
								e7: f.X.R,
								ba: f.ba,
								fk: f.fk
							}));
			}
		}();
		var kycOpts = _v2.a;
		var addressOpts = _v2.b;
		var fillOptionals = function (opts) {
			return _Utils_update(
				opts,
				{
					gP: addressOpts,
					jT: A2(
						$elm$core$Maybe$withDefault,
						$dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
						A2($elm$core$Maybe$map, $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present, invitationId)),
					hx: kycOpts
				});
		};
		return A4(
			$author$project$Api$Graphql$signUp,
			shared,
			{
				lM: accountName,
				jh: email,
				ki: name,
				kN: ownerKey,
				lD: function () {
					if (formOutput.$ === 1) {
						return 'juridical';
					} else {
						return 'natural';
					}
				}()
			},
			fillOptionals,
			$author$project$Page$Register$CompletedSignUp);
	});
var $author$project$Form$withShowAllErrors = F2(
	function (showAllErrors, _v0) {
		var model = _v0;
		var _v1 = model.aG;
		var errorTracking = _v1;
		return _Utils_update(
			model,
			{
				aG: _Utils_update(
					errorTracking,
					{e2: showAllErrors})
			});
	});
var $author$project$Page$Register$withShowAllErrors = F2(
	function (showAllErrors, formModel) {
		switch (formModel.$) {
			case 0:
				var form = formModel.a;
				return $author$project$Page$Register$NaturalForm(
					A2($author$project$Form$withShowAllErrors, showAllErrors, form));
			case 1:
				var form = formModel.a;
				return $author$project$Page$Register$JuridicalForm(
					A2($author$project$Form$withShowAllErrors, showAllErrors, form));
			default:
				var form = formModel.a;
				return $author$project$Page$Register$DefaultForm(
					A2($author$project$Form$withShowAllErrors, showAllErrors, form));
		}
	});
var $author$project$Page$Register$update = F4(
	function (_v0, msg, model, guest) {
		var shared = guest.aM;
		var scrollTop = $author$project$UpdateResult$addCmd(
			A2(
				$elm$core$Task$attempt,
				function (_v13) {
					return $author$project$Page$Register$NoOp;
				},
				A2($elm$browser$Browser$Dom$setViewport, 0, 0)));
		var _v1 = shared.iw;
		var t = _v1.il;
		switch (msg.$) {
			case 0:
				return $author$project$UpdateResult$init(model);
			case 1:
				var community = msg.a;
				var canRegister = community.cj || (!_Utils_eq(model.jT, $elm$core$Maybe$Nothing));
				return canRegister ? A4($author$project$Page$Register$loadedCommunity, shared, model, community, model.dk) : A2(
					$author$project$UpdateResult$addCmd,
					A2(
						$author$project$Route$pushUrl,
						shared.eM,
						$author$project$Route$Join(guest.lS)),
					$author$project$UpdateResult$init(model));
			case 11:
				var accountType = msg.a;
				var selectedKycForm = function () {
					if (!accountType.$) {
						return $author$project$Page$Register$NaturalForm($author$project$Page$Register$NaturalForm$init);
					} else {
						var country = accountType.a;
						return $author$project$Page$Register$JuridicalForm(
							$author$project$Page$Register$JuridicalForm$init(country));
					}
				}();
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{
							gE: A2(
								$author$project$Page$Register$FormShowed,
								{gJ: $elm$core$Set$empty},
								selectedKycForm)
						}));
			case 2:
				var formOutput = msg.a;
				var isAvailable = msg.b;
				var account = $author$project$Page$Register$getSignUpFields(formOutput).fl;
				if (isAvailable) {
					return A2(
						$author$project$UpdateResult$addPort,
						{
							i9: $elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'name',
										$elm$json$Json$Encode$string('generateKeys')),
										_Utils_Tuple2(
										'account',
										$author$project$Eos$Account$encodeName(account))
									])),
							kY: A2($author$project$Page$Register$GotAccountAvailabilityResponse, formOutput, isAvailable),
							kZ: $author$project$Page$Register$encodeFormOutput(formOutput)
						},
						$author$project$UpdateResult$init(model));
				} else {
					var newStatus = function () {
						var _v4 = model.gE;
						if (_v4.$ === 2) {
							var unavailableAccounts = _v4.a.gJ;
							var formModel = _v4.b;
							return A2(
								$author$project$Page$Register$FormShowed,
								{
									gJ: A2(
										$elm$core$Set$insert,
										$author$project$Eos$Account$nameToString(account),
										unavailableAccounts)
								},
								A2($author$project$Page$Register$withShowAllErrors, true, formModel));
						} else {
							return model.gE;
						}
					}();
					return $author$project$UpdateResult$init(
						_Utils_update(
							model,
							{gE: newStatus}));
				}
			case 3:
				if (msg.b.$ === 1) {
					var v = msg.b.a;
					return A7(
						$author$project$UpdateResult$logDecodingError,
						msg,
						$elm$core$Maybe$Nothing,
						'Could not decode account keys',
						{mX: 'update', nW: 'Page.Register'},
						_List_Nil,
						v,
						$author$project$UpdateResult$init(model));
				} else {
					var formOutput = msg.a;
					var accountKeys = msg.b.a;
					return A2(
						$author$project$UpdateResult$addCmd,
						A4($author$project$Page$Register$signUp, shared, accountKeys, model.jT, formOutput),
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									fm: $elm$core$Maybe$Just(accountKeys)
								})));
				}
			case 4:
				var val = msg.a;
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{ex: val}));
			case 7:
				var elementId = msg.a;
				return A2(
					$author$project$UpdateResult$addPort,
					{
						i9: $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'id',
									$elm$json$Json$Encode$string(elementId)),
									_Utils_Tuple2(
									'name',
									$elm$json$Json$Encode$string('copyToClipboard'))
								])),
						kY: $author$project$Page$Register$CopiedToClipboard,
						kZ: $elm$json$Json$Encode$null
					},
					$author$project$UpdateResult$init(model));
			case 8:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{f0: true}));
			case 5:
				var passphrase = msg.a.a6;
				var accountName = msg.a.lM;
				return A2(
					$author$project$UpdateResult$addPort,
					{
						i9: $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'name',
									$elm$json$Json$Encode$string('downloadAuthPdfFromRegistration')),
									_Utils_Tuple2(
									'accountName',
									$elm$json$Json$Encode$string(accountName)),
									_Utils_Tuple2(
									'passphrase',
									$elm$json$Json$Encode$string(passphrase))
								])),
						kY: $author$project$Page$Register$PdfDownloaded,
						kZ: $elm$json$Json$Encode$null
					},
					$author$project$UpdateResult$init(model));
			case 6:
				return A2(
					$author$project$UpdateResult$addCmd,
					A2(
						$author$project$Route$replaceUrl,
						shared.eM,
						A2($author$project$Route$Login, guest.j8, guest.lS)),
					$author$project$UpdateResult$init(model));
			case 12:
				switch (msg.a.$) {
					case 3:
						var _v5 = model.fm;
						if (_v5.$ === 1) {
							return A6(
								$author$project$UpdateResult$logImpossible,
								msg,
								'Completed signing up, but didn\'t have account keys',
								$elm$core$Maybe$Nothing,
								{mX: 'update', nW: 'Page.Register'},
								_List_Nil,
								$author$project$UpdateResult$init(model));
						} else {
							var accountKeys = _v5.a;
							return $author$project$UpdateResult$init(
								_Utils_update(
									model,
									{
										gE: $author$project$Page$Register$AccountCreated(accountKeys),
										e8: 1
									}));
						}
					case 2:
						var error = msg.a.a;
						return scrollTop(
							A7(
								$author$project$UpdateResult$logGraphqlError,
								msg,
								$elm$core$Maybe$Nothing,
								'Got an error when trying to sign up',
								{mX: 'update', nW: 'Page.Register'},
								_List_Nil,
								error,
								A2(
									$author$project$UpdateResult$addExt,
									$author$project$Session$Guest$SetFeedback(
										A2(
											$author$project$View$Feedback$Visible,
											1,
											t('register.account_error.title'))),
									$author$project$UpdateResult$init(model))));
					default:
						return $author$project$UpdateResult$init(model);
				}
			case 9:
				switch (msg.a.$) {
					case 3:
						if (!msg.a.a.$) {
							var invitation = msg.a.a.a;
							return A4(
								$author$project$Page$Register$loadedCommunity,
								shared,
								model,
								invitation.b9,
								$elm$core$Maybe$Just(invitation));
						} else {
							var _v6 = msg.a.a;
							return $author$project$UpdateResult$init(
								_Utils_update(
									model,
									{gE: $author$project$Page$Register$NotFound}));
						}
					case 2:
						var error = msg.a.a;
						return A7(
							$author$project$UpdateResult$logGraphqlError,
							msg,
							$elm$core$Maybe$Nothing,
							'Got an error when trying to load invite',
							{mX: 'update', nW: 'Page.Register'},
							_List_Nil,
							error,
							A2(
								$author$project$UpdateResult$addExt,
								$author$project$Session$Guest$SetFeedback(
									A2(
										$author$project$View$Feedback$Visible,
										1,
										t('error.unknown'))),
								$author$project$UpdateResult$init(
									_Utils_update(
										model,
										{gE: $author$project$Page$Register$ErrorShowed}))));
					default:
						return $author$project$UpdateResult$init(model);
				}
			case 10:
				switch (msg.a.$) {
					case 3:
						if (!msg.a.a.$) {
							var country = msg.a.a.a;
							return $author$project$UpdateResult$init(
								_Utils_update(
									model,
									{
										g5: $elm$core$Maybe$Just(country),
										gE: $author$project$Page$Register$AccountTypeSelectorShowed
									}));
						} else {
							var _v7 = msg.a.a;
							return $author$project$UpdateResult$init(
								_Utils_update(
									model,
									{gE: $author$project$Page$Register$NotFound}));
						}
					case 2:
						var error = msg.a.a;
						return A7(
							$author$project$UpdateResult$logGraphqlError,
							msg,
							$elm$core$Maybe$Nothing,
							'Got an error when loading country data',
							{mX: 'update', nW: 'Page.Register'},
							_List_Nil,
							error,
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{gE: $author$project$Page$Register$ErrorShowed})));
					default:
						return $author$project$UpdateResult$init(model);
				}
			case 13:
				var subMsg = msg.a;
				var _v8 = _Utils_Tuple2(model.gE, subMsg);
				_v8$3:
				while (true) {
					if (_v8.a.$ === 2) {
						switch (_v8.a.b.$) {
							case 0:
								if (_v8.b.$ === 1) {
									var _v9 = _v8.a;
									var isAccountTaken = _v9.a;
									var formModel = _v9.b.a;
									var formMsg = _v8.b.a;
									return A5(
										$author$project$UpdateResult$fromChild,
										function (newForm) {
											return _Utils_update(
												model,
												{
													gE: A2(
														$author$project$Page$Register$FormShowed,
														isAccountTaken,
														$author$project$Page$Register$NaturalForm(newForm))
												});
										},
										A2($elm$core$Basics$composeR, $author$project$Page$Register$NaturalFormMsg, $author$project$Page$Register$GotFormMsg),
										A2($elm$core$Basics$composeR, $author$project$Session$Guest$SetFeedback, $author$project$UpdateResult$addExt),
										model,
										A3($author$project$Form$update, shared, formMsg, formModel));
								} else {
									break _v8$3;
								}
							case 1:
								if (!_v8.b.$) {
									var _v10 = _v8.a;
									var isAccountTaken = _v10.a;
									var formModel = _v10.b.a;
									var formMsg = _v8.b.a;
									return A5(
										$author$project$UpdateResult$fromChild,
										function (newForm) {
											return _Utils_update(
												model,
												{
													gE: A2(
														$author$project$Page$Register$FormShowed,
														isAccountTaken,
														$author$project$Page$Register$JuridicalForm(newForm))
												});
										},
										A2($elm$core$Basics$composeR, $author$project$Page$Register$JuridicalFormMsg, $author$project$Page$Register$GotFormMsg),
										A2($elm$core$Basics$composeR, $author$project$Session$Guest$SetFeedback, $author$project$UpdateResult$addExt),
										model,
										A3($author$project$Form$update, shared, formMsg, formModel));
								} else {
									break _v8$3;
								}
							default:
								if (_v8.b.$ === 2) {
									var _v11 = _v8.a;
									var isAccountTaken = _v11.a;
									var formModel = _v11.b.a;
									var formMsg = _v8.b.a;
									return A5(
										$author$project$UpdateResult$fromChild,
										function (newForm) {
											return _Utils_update(
												model,
												{
													gE: A2(
														$author$project$Page$Register$FormShowed,
														isAccountTaken,
														$author$project$Page$Register$DefaultForm(newForm))
												});
										},
										A2($elm$core$Basics$composeR, $author$project$Page$Register$DefaultFormMsg, $author$project$Page$Register$GotFormMsg),
										A2($elm$core$Basics$composeR, $author$project$Session$Guest$SetFeedback, $author$project$UpdateResult$addExt),
										model,
										A3($author$project$Form$update, shared, formMsg, formModel));
								} else {
									break _v8$3;
								}
						}
					} else {
						break _v8$3;
					}
				}
				return $author$project$UpdateResult$init(model);
			default:
				var formOutput = msg.a;
				var account = function () {
					switch (formOutput.$) {
						case 0:
							var output = formOutput.a;
							return output.fl;
						case 1:
							var output = formOutput.a;
							return output.fl;
						default:
							var output = formOutput.a;
							return output.fl;
					}
				}();
				return A2(
					$author$project$UpdateResult$addPort,
					{
						i9: $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'name',
									$elm$json$Json$Encode$string('checkAccountAvailability')),
									_Utils_Tuple2(
									'account',
									$author$project$Eos$Account$encodeName(account))
								])),
						kY: $author$project$Page$Register$SubmittedForm(formOutput),
						kZ: $author$project$Page$Register$encodeFormOutput(formOutput)
					},
					$author$project$UpdateResult$init(model));
		}
	});
var $author$project$Page$Settings$Claim = 0;
var $author$project$Page$Settings$Digest = 2;
var $author$project$Page$Settings$FinishedDeletingKyc = function (a) {
	return {$: 14, a: a};
};
var $author$project$Page$Settings$SubmittedNewPin = function (a) {
	return {$: 9, a: a};
};
var $author$project$Page$Settings$Transfer = 1;
var $author$project$Page$Settings$CompletedTogglingNotification = F2(
	function (a, b) {
		return {$: 18, a: a, b: b};
	});
var $author$project$Page$Settings$UpdatingTo = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Settings$Preferences = F3(
	function (transferNotification, claimNotification, digest) {
		return {c_: claimNotification, c9: digest, d$: transferNotification};
	});
var $author$project$Page$Settings$preferencesSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$User$digest,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Cambiatus$Object$User$claimNotification,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Cambiatus$Object$User$transferNotification,
			$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Page$Settings$Preferences))));
var $author$project$Page$Settings$actOnNotificationPreferenceToggle = F3(
	function (loggedIn, notification, newValue) {
		var updatePreferencesMutation = A3(
			$author$project$Session$LoggedIn$mutation,
			loggedIn,
			A2(
				$author$project$Cambiatus$Mutation$preference,
				function (optionalArgs) {
					switch (notification) {
						case 1:
							return _Utils_update(
								optionalArgs,
								{
									d$: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(newValue)
								});
						case 0:
							return _Utils_update(
								optionalArgs,
								{
									c_: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(newValue)
								});
						default:
							return _Utils_update(
								optionalArgs,
								{
									c9: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(newValue)
								});
					}
				},
				$author$project$Page$Settings$preferencesSelectionSet),
			$author$project$Page$Settings$CompletedTogglingNotification(notification));
		var updateModel = function (model) {
			switch (notification) {
				case 1:
					return _Utils_update(
						model,
						{
							cM: $author$project$Page$Settings$UpdatingTo(newValue)
						});
				case 0:
					return _Utils_update(
						model,
						{
							b8: $author$project$Page$Settings$UpdatingTo(newValue)
						});
				default:
					return _Utils_update(
						model,
						{
							ce: $author$project$Page$Settings$UpdatingTo(newValue)
						});
			}
		};
		return A2(
			$elm$core$Basics$composeR,
			$author$project$UpdateResult$mapModel(updateModel),
			$author$project$UpdateResult$addExt(updatePreferencesMutation));
	});
var $author$project$Cambiatus$Mutation$deleteKyc = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'deleteKyc',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$Page$Settings$update = F3(
	function (msg, model, loggedIn) {
		switch (msg.$) {
			case 0:
				return $author$project$UpdateResult$init(model);
			case 1:
				var addDownloadPdfPort = function () {
					var _v1 = loggedIn.fp.ag.nF;
					if (_v1.$ === 1) {
						return $elm$core$Basics$identity;
					} else {
						var pin = _v1.a;
						return $author$project$UpdateResult$addPort(
							{
								i9: $elm$json$Json$Encode$object(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'name',
											$elm$json$Json$Encode$string('downloadAuthPdfFromProfile')),
											_Utils_Tuple2(
											'pin',
											$elm$json$Json$Encode$string(pin))
										])),
								kY: msg,
								kZ: $elm$json$Json$Encode$null
							});
					}
				}();
				return A5(
					$author$project$Session$LoggedIn$withPrivateKey,
					loggedIn,
					_List_Nil,
					model,
					{he: $author$project$Page$Settings$NoOp, ik: msg},
					addDownloadPdfPort(
						$author$project$UpdateResult$init(model)));
			case 2:
				return A5(
					$author$project$Session$LoggedIn$withPrivateKey,
					loggedIn,
					_List_Nil,
					model,
					{he: $author$project$Page$Settings$NoOp, ik: msg},
					$author$project$UpdateResult$init(
						_Utils_update(
							model,
							{ds: true})));
			case 3:
				return A2(
					$author$project$UpdateResult$addPort,
					{
						i9: $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'name',
									$elm$json$Json$Encode$string('copyToClipboard')),
									_Utils_Tuple2(
									'id',
									$elm$json$Json$Encode$string('private-key-copy-input'))
								])),
						kY: msg,
						kZ: $elm$json$Json$Encode$null
					},
					$author$project$UpdateResult$init(model));
			case 4:
				return A2(
					$author$project$UpdateResult$addExt,
					A2(
						$author$project$Session$LoggedIn$ShowFeedback,
						0,
						loggedIn.aM.iw.il('settings.account.copied_private_key')),
					$author$project$UpdateResult$init(
						_Utils_update(
							model,
							{ds: false})));
			case 5:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{ds: false}));
			case 6:
				var _v2 = $author$project$Page$Settings$initPin(loggedIn);
				var newPin = _v2.a;
				var pinCmd = _v2.b;
				return A2(
					$author$project$UpdateResult$addCmd,
					pinCmd,
					$author$project$UpdateResult$init(
						_Utils_update(
							model,
							{du: true, cD: newPin})));
			case 7:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{du: false}));
			case 8:
				var subMsg = msg.a;
				return A5(
					$author$project$UpdateResult$fromChild,
					function (newPinInput) {
						return _Utils_update(
							model,
							{cD: newPinInput});
					},
					$author$project$Page$Settings$GotPinMsg,
					F2(
						function (ext, ur) {
							if (ext.$ === 1) {
								var feedback = ext.a;
								return A2($author$project$Session$LoggedIn$addFeedback, feedback, ur);
							} else {
								var pin = ext.a;
								var _v4 = A4($author$project$View$Pin$postSubmitAction, ur.nV.cD, pin, loggedIn.aM, $author$project$Page$Settings$SubmittedNewPin);
								var newShared = _v4.a;
								var submitCmd = _v4.b;
								return A2(
									$author$project$UpdateResult$addExt,
									$author$project$Session$LoggedIn$UpdatedLoggedIn(
										_Utils_update(
											loggedIn,
											{aM: newShared})),
									A2(
										$author$project$UpdateResult$addCmd,
										submitCmd,
										A2(
											$author$project$UpdateResult$mapModel,
											function (m) {
												return _Utils_update(
													m,
													{du: false});
											},
											ur)));
							}
						}),
					model,
					A3($author$project$View$Pin$update, loggedIn.aM, subMsg, model.cD));
			case 9:
				var newPin = msg.a;
				var addChangePinPort = function () {
					var _v5 = loggedIn.fp.ag.nF;
					if (_v5.$ === 1) {
						return $elm$core$Basics$identity;
					} else {
						var currentPin = _v5.a;
						return $author$project$UpdateResult$addPort(
							{
								i9: $elm$json$Json$Encode$object(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'name',
											$elm$json$Json$Encode$string('changePin')),
											_Utils_Tuple2(
											'currentPin',
											$elm$json$Json$Encode$string(currentPin)),
											_Utils_Tuple2(
											'newPin',
											$elm$json$Json$Encode$string(newPin))
										])),
								kY: msg,
								kZ: $elm$json$Json$Encode$string(newPin)
							});
					}
				}();
				return A5(
					$author$project$Session$LoggedIn$withPrivateKey,
					loggedIn,
					_List_Nil,
					model,
					{he: $author$project$Page$Settings$NoOp, ik: msg},
					addChangePinPort(
						$author$project$UpdateResult$init(model)));
			case 10:
				var newPin = msg.a;
				return A2(
					$author$project$UpdateResult$addExt,
					$author$project$Session$LoggedIn$ChangedPin(newPin),
					A2(
						$author$project$UpdateResult$addExt,
						A2(
							$author$project$Session$LoggedIn$ShowFeedback,
							0,
							loggedIn.aM.iw.il('profile.pin.successMsg')),
						$author$project$UpdateResult$init(model)));
			case 11:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{dp: true}));
			case 12:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{dp: false}));
			case 13:
				return A2(
					$author$project$UpdateResult$addExt,
					$author$project$Session$LoggedIn$UpdatedLoggedIn(
						_Utils_update(
							loggedIn,
							{kJ: $krisajenkins$remotedata$RemoteData$Loading})),
					A2(
						$author$project$UpdateResult$addExt,
						A3(
							$author$project$Session$LoggedIn$mutation,
							loggedIn,
							$author$project$Cambiatus$Mutation$deleteKyc($dillonkearns$elm_graphql$Graphql$SelectionSet$empty),
							$author$project$Page$Settings$FinishedDeletingKyc),
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{dp: false}))));
			case 14:
				switch (msg.a.$) {
					case 3:
						return A2(
							$author$project$UpdateResult$addExt,
							A2(
								$author$project$Session$LoggedIn$ShowFeedback,
								0,
								loggedIn.aM.iw.il('community.kyc.delete.success')),
							A2(
								$author$project$UpdateResult$addExt,
								$author$project$Session$LoggedIn$ReloadResource(0),
								$author$project$UpdateResult$init(model)));
					case 1:
						var _v6 = msg.a;
						return $author$project$UpdateResult$init(model);
					case 0:
						var _v7 = msg.a;
						return $author$project$UpdateResult$init(model);
					default:
						var error = msg.a.a;
						return A7(
							$author$project$UpdateResult$logGraphqlError,
							msg,
							$elm$core$Maybe$Just(loggedIn.lM),
							'Got an error when trying to delete KYC',
							{mX: 'update', nW: 'Page.Settings'},
							_List_Nil,
							error,
							$author$project$UpdateResult$init(model));
				}
			case 15:
				var newValue = msg.a;
				return A4(
					$author$project$Page$Settings$actOnNotificationPreferenceToggle,
					loggedIn,
					0,
					newValue,
					$author$project$UpdateResult$init(model));
			case 16:
				var newValue = msg.a;
				return A4(
					$author$project$Page$Settings$actOnNotificationPreferenceToggle,
					loggedIn,
					1,
					newValue,
					$author$project$UpdateResult$init(model));
			case 17:
				var newValue = msg.a;
				return A4(
					$author$project$Page$Settings$actOnNotificationPreferenceToggle,
					loggedIn,
					2,
					newValue,
					$author$project$UpdateResult$init(model));
			default:
				switch (msg.b.$) {
					case 3:
						if (!msg.b.a.$) {
							var preference = msg.a;
							var preferences = msg.b.a.a;
							var newProfile = function () {
								var _v9 = loggedIn.kJ;
								if (_v9.$ === 3) {
									var oldProfile = _v9.a;
									return $krisajenkins$remotedata$RemoteData$Success(
										_Utils_update(
											oldProfile,
											{c_: preferences.c_, c9: preferences.c9, d$: preferences.d$}));
								} else {
									return loggedIn.kJ;
								}
							}();
							var newModel = function () {
								switch (preference) {
									case 1:
										return _Utils_update(
											model,
											{cM: $author$project$Page$Settings$NotUpdating});
									case 0:
										return _Utils_update(
											model,
											{b8: $author$project$Page$Settings$NotUpdating});
									default:
										return _Utils_update(
											model,
											{ce: $author$project$Page$Settings$NotUpdating});
								}
							}();
							return A2(
								$author$project$UpdateResult$addExt,
								$author$project$Session$LoggedIn$UpdatedLoggedIn(
									_Utils_update(
										loggedIn,
										{kJ: newProfile})),
								$author$project$UpdateResult$init(newModel));
						} else {
							var preference = msg.a;
							var _v10 = msg.b.a;
							var newModel = function () {
								switch (preference) {
									case 1:
										return _Utils_update(
											model,
											{cM: $author$project$Page$Settings$NotUpdating});
									case 0:
										return _Utils_update(
											model,
											{b8: $author$project$Page$Settings$NotUpdating});
									default:
										return _Utils_update(
											model,
											{ce: $author$project$Page$Settings$NotUpdating});
								}
							}();
							return A6(
								$author$project$UpdateResult$logImpossible,
								msg,
								'Got Nothing when toggling notification preference',
								$elm$core$Maybe$Just(loggedIn.lM),
								{mX: 'update', nW: 'Page.Settings'},
								_List_Nil,
								A2(
									$author$project$UpdateResult$addExt,
									A2(
										$author$project$Session$LoggedIn$ShowFeedback,
										1,
										loggedIn.aM.iw.il('profile.preferences.error')),
									$author$project$UpdateResult$init(newModel)));
						}
					case 2:
						var preference = msg.a;
						var err = msg.b.a;
						var newModel = function () {
							switch (preference) {
								case 1:
									return _Utils_update(
										model,
										{cM: $author$project$Page$Settings$NotUpdating});
								case 0:
									return _Utils_update(
										model,
										{b8: $author$project$Page$Settings$NotUpdating});
								default:
									return _Utils_update(
										model,
										{ce: $author$project$Page$Settings$NotUpdating});
							}
						}();
						return A7(
							$author$project$UpdateResult$logGraphqlError,
							msg,
							$elm$core$Maybe$Just(loggedIn.lM),
							'Got an error when settings notification preferences',
							{mX: 'update', nW: 'Page.Settings'},
							_List_Nil,
							err,
							A2(
								$author$project$UpdateResult$addExt,
								A2(
									$author$project$Session$LoggedIn$ShowFeedback,
									1,
									loggedIn.aM.iw.il('profile.preferences.error')),
								$author$project$UpdateResult$init(newModel)));
					default:
						return $author$project$UpdateResult$init(model);
				}
		}
	});
var $author$project$Page$Shop$CompletedLoadWhereOptions = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$Shop$GotFiltersFormMsg = function (a) {
	return {$: 14, a: a};
};
var $author$project$Page$Shop$Loaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Shop$LoadingFailed = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Shop$NoOp = {$: 0};
var $author$project$Shop$isOutOfStock = function (product) {
	var _v0 = product.ig;
	if (!_v0.$) {
		return false;
	} else {
		var availableUnits = _v0.a.iQ;
		return !availableUnits;
	}
};
var $author$project$Page$Shop$cardFromSale = function (p) {
	return {
		cc: $elm$core$Maybe$Nothing,
		bf: !$author$project$Shop$isOutOfStock(p),
		cF: $elm$core$Maybe$Nothing,
		oP: p,
		kK: $author$project$Profile$Summary$init(false)
	};
};
var $author$project$Utils$Tree$findZipperInForest = F2(
	function (fn, trees) {
		if (!trees.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var firstTree = trees.a;
			var otherTrees = trees.b;
			return A2(
				$zwilias$elm_rosetree$Tree$Zipper$findFromRoot,
				fn,
				A2($zwilias$elm_rosetree$Tree$Zipper$fromForest, firstTree, otherTrees));
		}
	});
var $author$project$Utils$Tree$findInForest = F2(
	function (fn, trees) {
		return A2(
			$elm$core$Maybe$map,
			$zwilias$elm_rosetree$Tree$Zipper$label,
			A2($author$project$Utils$Tree$findZipperInForest, fn, trees));
	});
var $author$project$Shop$Where$ChipPlace = F2(
	function (place, count) {
		return {mo: count, e: place};
	});
var $author$project$Cambiatus$Object$PlaceCount$count = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'count', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$Cambiatus$Object$PlaceCount$locality = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'locality', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Shop$Where$Place = F3(
	function (id, name, stateCode) {
		return {R: id, ki: name, lc: stateCode};
	});
var $author$project$Shop$Where$placeSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$Locality$stateCode,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Cambiatus$Object$Locality$name,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Cambiatus$Object$Locality$id,
			$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Shop$Where$Place))));
var $author$project$Shop$Where$chipPlaceSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Cambiatus$Object$PlaceCount$count,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Cambiatus$Object$PlaceCount$locality($author$project$Shop$Where$placeSelectionSet),
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Shop$Where$ChipPlace)));
var $author$project$Shop$Where$homeSelectionSet = $author$project$Cambiatus$Object$User$locationPlace(
	$author$project$Cambiatus$Object$LocationPlace$municipality($author$project$Shop$Where$placeSelectionSet));
var $author$project$Cambiatus$Object$PlaceCounts$online = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'online', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$Cambiatus$Query$placeCounts = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'placeCounts',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$Cambiatus$Object$PlaceCounts$places = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'places',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Shop$Where$query = function (account) {
	return A3(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$map2,
		F2(
			function (home, counts) {
				return {
					m9: home,
					dF: A2(
						$elm$core$Maybe$withDefault,
						0,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.dF;
							},
							counts)),
					oH: A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.oH;
							},
							counts))
				};
			}),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
			$elm$core$Maybe$andThen($elm$core$Basics$identity),
			A2(
				$author$project$Cambiatus$Query$user,
				{
					fl: $author$project$Eos$Account$nameToString(account)
				},
				$author$project$Shop$Where$homeSelectionSet)),
		$author$project$Cambiatus$Query$placeCounts(
			A3(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$map2,
				F2(
					function (online, places) {
						return {dF: online, oH: places};
					}),
				$author$project$Cambiatus$Object$PlaceCounts$online,
				$author$project$Cambiatus$Object$PlaceCounts$places($author$project$Shop$Where$chipPlaceSelectionSet))));
};
var $author$project$Page$Shop$update = F3(
	function (msg, model, loggedIn) {
		switch (msg.$) {
			case 0:
				return $author$project$UpdateResult$init(model);
			case 1:
				var categories = msg.a;
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{
							bC: A2(
								$author$project$Form$updateValues,
								function (values) {
									return _Utils_update(
										values,
										{
											cX: $pzp1997$assoc_list$AssocList$fromList(
												A2(
													$elm$core$List$filterMap,
													function (categoryId) {
														return A2(
															$elm$core$Maybe$map,
															function (category) {
																return _Utils_Tuple2(category, true);
															},
															A2(
																$author$project$Utils$Tree$findInForest,
																function (category) {
																	return _Utils_eq(category.R, categoryId);
																},
																categories));
													},
													model.z.cX))
										});
								},
								model.bC)
						}));
			case 2:
				switch (msg.a.$) {
					case 3:
						var sales = msg.a.a;
						return $author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									ap: $author$project$Page$Shop$Loaded(
										A2($elm$core$List$map, $author$project$Page$Shop$cardFromSale, sales))
								}));
					case 2:
						var err = msg.a.a;
						return A7(
							$author$project$UpdateResult$logGraphqlError,
							msg,
							$elm$core$Maybe$Just(loggedIn.lM),
							'Got an error when loading sales from shop',
							{mX: 'update', nW: 'Page.Shop'},
							_List_Nil,
							err,
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{
										ap: $author$project$Page$Shop$LoadingFailed(err)
									})));
					default:
						return $author$project$UpdateResult$init(model);
				}
			case 3:
				if ((msg.a.$ === 3) && msg.a.a) {
					return A2(
						$author$project$UpdateResult$addExt,
						A3(
							$author$project$Session$LoggedIn$query,
							loggedIn,
							$author$project$Shop$Where$query(loggedIn.lM),
							$author$project$Page$Shop$CompletedLoadWhereOptions),
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{eV: true, d4: $krisajenkins$remotedata$RemoteData$Loading})));
				} else {
					return $author$project$UpdateResult$init(model);
				}
			case 4:
				var result = msg.a;
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{d4: result}));
			case 5:
				var chosen = msg.a;
				return _Utils_eq(chosen, model.b7) ? $author$project$UpdateResult$init(model) : A2(
					$author$project$UpdateResult$addExt,
					A3(
						$author$project$Session$LoggedIn$query,
						loggedIn,
						$author$project$Shop$productsQuery(
							{cX: model.z.cX, hU: model.b6, gM: model.z.oy, iD: chosen}),
						$author$project$Page$Shop$CompletedSalesLoad),
					$author$project$UpdateResult$init(
						_Utils_update(
							model,
							{ap: $author$project$Page$Shop$Loading, b7: chosen})));
			case 6:
				var chosen = msg.a;
				return _Utils_eq(chosen, model.b6) ? $author$project$UpdateResult$init(model) : A2(
					$author$project$UpdateResult$addExt,
					A3(
						$author$project$Session$LoggedIn$query,
						loggedIn,
						$author$project$Shop$productsQuery(
							{cX: model.z.cX, hU: chosen, gM: model.z.oy, iD: model.b7}),
						$author$project$Page$Shop$CompletedSalesLoad),
					$author$project$UpdateResult$init(
						_Utils_update(
							model,
							{ap: $author$project$Page$Shop$Loading, b6: chosen})));
			case 7:
				var res = msg.a;
				if (!res.$) {
					var bals = res.a;
					return $author$project$UpdateResult$init(
						_Utils_update(
							model,
							{gV: bals}));
				} else {
					return $author$project$UpdateResult$init(model);
				}
			case 8:
				return A2(
					$author$project$UpdateResult$addExt,
					$author$project$Session$LoggedIn$ShowCodeOfConductModal,
					$author$project$UpdateResult$init(model));
			case 9:
				var containerId = msg.a.mj;
				var imageId = msg.a.nf;
				return A2(
					$author$project$UpdateResult$addPort,
					{
						i9: $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'name',
									$elm$json$Json$Encode$string('smoothHorizontalScroll')),
									_Utils_Tuple2(
									'containerId',
									$elm$json$Json$Encode$string(containerId)),
									_Utils_Tuple2(
									'targetId',
									$elm$json$Json$Encode$string(imageId))
								])),
						kY: $author$project$Page$Shop$NoOp,
						kZ: $elm$json$Json$Encode$null
					},
					$author$project$UpdateResult$init(model));
			case 10:
				var cardId = msg.a;
				var imageId = msg.b;
				var _v2 = model.ap;
				if (_v2.$ === 1) {
					var cards = _v2.a;
					var newCards = A3(
						$elm_community$list_extra$List$Extra$updateIf,
						function (card) {
							return _Utils_eq(card.oP.R, cardId);
						},
						function (card) {
							return _Utils_update(
								card,
								{
									cc: $elm$core$Maybe$Just(imageId),
									cF: card.cc
								});
						},
						cards);
					return $author$project$UpdateResult$init(
						_Utils_update(
							model,
							{
								ap: $author$project$Page$Shop$Loaded(newCards)
							}));
				} else {
					return $author$project$UpdateResult$init(model);
				}
			case 11:
				var cardId = msg.a;
				var imageId = msg.b;
				var _v3 = model.ap;
				if (_v3.$ === 1) {
					var cards = _v3.a;
					var newCards = A3(
						$elm_community$list_extra$List$Extra$updateIf,
						function (card) {
							return _Utils_eq(card.oP.R, cardId);
						},
						function (card) {
							return _Utils_eq(
								$elm$core$Maybe$Just(imageId),
								card.cc) ? _Utils_update(
								card,
								{cc: card.cF, cF: $elm$core$Maybe$Nothing}) : (_Utils_eq(
								$elm$core$Maybe$Just(imageId),
								card.cF) ? _Utils_update(
								card,
								{cF: $elm$core$Maybe$Nothing}) : card);
						},
						cards);
					return $author$project$UpdateResult$init(
						_Utils_update(
							model,
							{
								ap: $author$project$Page$Shop$Loaded(newCards)
							}));
				} else {
					return $author$project$UpdateResult$init(model);
				}
			case 12:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{dt: true}));
			case 13:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{dt: false}));
			case 14:
				var subMsg = msg.a;
				return A5(
					$author$project$UpdateResult$fromChild,
					function (newForm) {
						return _Utils_update(
							model,
							{bC: newForm});
					},
					$author$project$Page$Shop$GotFiltersFormMsg,
					$author$project$Session$LoggedIn$addFeedback,
					model,
					A3($author$project$Form$update, loggedIn.aM, subMsg, model.bC));
			default:
				var formOutput = msg.a;
				return A2(
					$author$project$UpdateResult$addCmd,
					A2(
						$author$project$Route$pushUrl,
						loggedIn.aM.eM,
						$author$project$Route$Shop(formOutput)),
					$author$project$UpdateResult$init(
						_Utils_update(
							model,
							{dt: false})));
		}
	});
var $author$project$Page$Shop$Editor$CompletedSaleLoad = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Shop$Editor$GotSaveResponse = function (a) {
	return {$: 8, a: a};
};
var $author$project$Page$Shop$Editor$LoadSaleFailed = function (a) {
	return {$: 7, a: a};
};
var $author$project$Page$Shop$Editor$NoOp = {$: 0};
var $author$project$Page$Shop$Editor$PriceAndInventory = F3(
	function (a, b, c) {
		return {$: 3, a: a, b: b, c: c};
	});
var $author$project$Page$Shop$Editor$UnauthorizedToEdit = {$: 8};
var $author$project$Cambiatus$Mutation$product = F2(
	function (fillInOptionals____, object____) {
		var filledInOptionals____ = fillInOptionals____(
			{cX: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, bc: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, R: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, hr: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, dF: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, h3: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, fb: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, iv: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, d0: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, iy: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
		var optionalArgs____ = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3(
					$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional,
					'categories',
					filledInOptionals____.cX,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$int)),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'description', filledInOptionals____.bc, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'id', filledInOptionals____.R, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int),
					A3(
					$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional,
					'images',
					filledInOptionals____.hr,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'online', filledInOptionals____.dF, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'price', filledInOptionals____.h3, $dillonkearns$elm_graphql$Graphql$Internal$Encode$float),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'title', filledInOptionals____.fb, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'trackStock', filledInOptionals____.iv, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool),
					A3(
					$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional,
					'type',
					filledInOptionals____.d0,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Cambiatus$Enum$OfferType$toString)),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'units', filledInOptionals____.iy, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int)
				]));
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'product',
			optionalArgs____,
			object____,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
	});
var $author$project$Shop$upsert = function (_v0) {
	var id = _v0.R;
	var title = _v0.fb;
	var description = _v0.bc;
	var images = _v0.hr;
	var categories = _v0.cX;
	var price = _v0.h3;
	var stockTracking = _v0.ig;
	var online = _v0.dF;
	var offerType = _v0.hU;
	return $author$project$Cambiatus$Mutation$product(
		function (_v1) {
			return {
				cX: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
					A2($elm$core$List$map, $author$project$Shop$Category$idToInt, categories)),
				bc: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
					$author$project$Markdown$toRawString(description)),
				R: function () {
					if (id.$ === 1) {
						return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent;
					} else {
						var unwrappedId = id.a;
						return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(unwrappedId);
					}
				}(),
				hr: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(images),
				dF: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(online),
				h3: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(price),
				fb: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(title),
				iv: function () {
					if (!stockTracking.$) {
						return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(false);
					} else {
						return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(true);
					}
				}(),
				d0: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(offerType),
				iy: function () {
					if (!stockTracking.$) {
						return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(0);
					} else {
						var availableUnits = stockTracking.a.iQ;
						return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(availableUnits);
					}
				}()
			};
		});
};
var $author$project$Shop$createProduct = F2(
	function (options, selectionSet) {
		return A2(
			$author$project$Shop$upsert,
			{cX: options.cX, bc: options.bc, R: $elm$core$Maybe$Nothing, hr: options.hr, hU: options.hU, dF: options.dF, h3: options.h3, ig: options.ig, fb: options.fb},
			selectionSet);
	});
var $author$project$Eos$formatSymbolAmount = F3(
	function (translators, _v0, amount) {
		var precision = _v0.b;
		return A3(
			$author$project$Utils$formatFloat,
			$elm$core$Maybe$Just(translators),
			precision,
			amount);
	});
var $author$project$Shop$hasUnitTracking = function (product) {
	var _v0 = product.ig;
	if (!_v0.$) {
		return false;
	} else {
		return true;
	}
};
var $author$project$Page$Shop$Editor$mainInformationInput = function (product) {
	return {
		bc: A2(
			$author$project$Form$RichText$initModel,
			'product-description-editor',
			$elm$core$Maybe$Just(product.bc)),
		hU: product.hU,
		fb: product.fb
	};
};
var $author$project$Page$Shop$Editor$initEditingFormData = F3(
	function (translators, product, step) {
		return {
			cX: $author$project$Form$init(
				{
					dF: product.dF,
					ia: A3(
						$elm$core$List$foldl,
						function (category) {
							return A2($pzp1997$assoc_list$AssocList$insert, category, true);
						},
						$pzp1997$assoc_list$AssocList$empty,
						product.cX)
				}),
			C: function () {
				switch (step) {
					case 0:
						return $author$project$Page$Shop$Editor$MainInformation;
					case 1:
						return $author$project$Page$Shop$Editor$Images(
							{bc: product.bc, hU: product.hU, fb: product.fb});
					case 2:
						return A2(
							$author$project$Page$Shop$Editor$Categories,
							{bc: product.bc, hU: product.hU, fb: product.fb},
							product.hr);
					default:
						return A3(
							$author$project$Page$Shop$Editor$PriceAndInventory,
							{bc: product.bc, hU: product.hU, fb: product.fb},
							product.hr,
							{
								cX: A2(
									$elm$core$List$map,
									function ($) {
										return $.R;
									},
									product.cX),
								dF: product.dF
							});
				}
			}(),
			hr: $author$project$Form$init(
				$author$project$Form$File$initMultiple(
					{q: $elm$core$Maybe$Nothing, mU: product.hr})),
			bg: $author$project$Form$init(
				$author$project$Page$Shop$Editor$mainInformationInput(product)),
			bN: $author$project$Form$init(
				{
					h3: A3($author$project$Eos$formatSymbolAmount, translators, product.e9, product.h3),
					d_: $author$project$Shop$hasUnitTracking(product),
					cN: function () {
						var _v1 = product.ig;
						if (!_v1.$) {
							return $elm$core$String$fromInt(0);
						} else {
							var availableUnits = _v1.a.iQ;
							return $elm$core$String$fromInt(availableUnits);
						}
					}()
				})
		};
	});
var $author$project$Page$Shop$Editor$setCurrentStepInRoute = F2(
	function (model, step) {
		var _v0 = model.gE;
		switch (_v0.$) {
			case 0:
				return $elm$core$Maybe$Just(
					$author$project$Route$NewSale(step));
			case 1:
				return $elm$core$Maybe$Just(
					$author$project$Route$NewSale(step));
			case 2:
				return $elm$core$Maybe$Nothing;
			case 3:
				var product = _v0.a;
				return $elm$core$Maybe$Just(
					A2($author$project$Route$EditSale, product.R, step));
			case 4:
				var product = _v0.a;
				return $elm$core$Maybe$Just(
					A2($author$project$Route$EditSale, product.R, step));
			case 5:
				var product = _v0.a;
				return $elm$core$Maybe$Just(
					A2($author$project$Route$EditSale, product.R, step));
			case 6:
				var product = _v0.a;
				return $elm$core$Maybe$Just(
					A2($author$project$Route$EditSale, product.R, step));
			case 7:
				return $elm$core$Maybe$Nothing;
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Page$Shop$Editor$setCurrentStepInUrl = F3(
	function (shared, model, step) {
		var _v0 = A2($author$project$Page$Shop$Editor$setCurrentStepInRoute, model, step);
		if (_v0.$ === 1) {
			return $elm$core$Platform$Cmd$none;
		} else {
			var route = _v0.a;
			return A2($author$project$Route$replaceUrl, shared.eM, route);
		}
	});
var $author$project$Page$Shop$Editor$PriceAndInventoryMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$Shop$Editor$updateForm = F3(
	function (shared, formMsg, model) {
		var maybeFormInfo = function () {
			var _v3 = model.gE;
			switch (_v3.$) {
				case 0:
					var form = _v3.a;
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(form, $author$project$Page$Shop$Editor$EditingCreate));
				case 1:
					var form = _v3.a;
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(form, $author$project$Page$Shop$Editor$Creating));
				case 3:
					var product = _v3.a;
					var form = _v3.b;
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(
							form,
							$author$project$Page$Shop$Editor$EditingUpdate(product)));
				case 4:
					var product = _v3.a;
					var form = _v3.b;
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(
							form,
							$author$project$Page$Shop$Editor$Saving(product)));
				case 5:
					var product = _v3.a;
					var form = _v3.b;
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(
							form,
							$author$project$Page$Shop$Editor$EditingUpdateAsAdmin(product)));
				case 6:
					var product = _v3.a;
					var form = _v3.b;
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(
							form,
							$author$project$Page$Shop$Editor$SavingAsAdmin(product)));
				case 2:
					return $elm$core$Maybe$Nothing;
				case 7:
					return $elm$core$Maybe$Nothing;
				default:
					return $elm$core$Maybe$Nothing;
			}
		}();
		if (maybeFormInfo.$ === 1) {
			return $author$project$UpdateResult$init(model);
		} else {
			var _v1 = maybeFormInfo.a;
			var formData = _v1.a;
			var updateStatus = _v1.b;
			switch (formMsg.$) {
				case 0:
					var subMsg = formMsg.a;
					return A5(
						$author$project$UpdateResult$fromChild,
						function (newMainInformation) {
							return _Utils_update(
								model,
								{
									gE: updateStatus(
										_Utils_update(
											formData,
											{bg: newMainInformation}))
								});
						},
						A2($elm$core$Basics$composeL, $author$project$Page$Shop$Editor$GotFormMsg, $author$project$Page$Shop$Editor$MainInformationMsg),
						$author$project$Session$LoggedIn$addFeedback,
						model,
						A3($author$project$Form$update, shared, subMsg, formData.bg));
				case 1:
					var subMsg = formMsg.a;
					return A5(
						$author$project$UpdateResult$fromChild,
						function (newImagesForm) {
							return _Utils_update(
								model,
								{
									gE: updateStatus(
										_Utils_update(
											formData,
											{hr: newImagesForm}))
								});
						},
						A2($elm$core$Basics$composeL, $author$project$Page$Shop$Editor$GotFormMsg, $author$project$Page$Shop$Editor$ImagesMsg),
						$author$project$Session$LoggedIn$addFeedback,
						model,
						A3($author$project$Form$update, shared, subMsg, formData.hr));
				case 2:
					var subMsg = formMsg.a;
					return A5(
						$author$project$UpdateResult$fromChild,
						function (newCategoriesForm) {
							return _Utils_update(
								model,
								{
									gE: updateStatus(
										_Utils_update(
											formData,
											{cX: newCategoriesForm}))
								});
						},
						A2($elm$core$Basics$composeL, $author$project$Page$Shop$Editor$GotFormMsg, $author$project$Page$Shop$Editor$CategoriesMsg),
						$author$project$Session$LoggedIn$addFeedback,
						model,
						A3($author$project$Form$update, shared, subMsg, formData.cX));
				default:
					var subMsg = formMsg.a;
					return A5(
						$author$project$UpdateResult$fromChild,
						function (newPriceAndInventory) {
							return _Utils_update(
								model,
								{
									gE: updateStatus(
										_Utils_update(
											formData,
											{bN: newPriceAndInventory}))
								});
						},
						A2($elm$core$Basics$composeL, $author$project$Page$Shop$Editor$GotFormMsg, $author$project$Page$Shop$Editor$PriceAndInventoryMsg),
						$author$project$Session$LoggedIn$addFeedback,
						model,
						A3($author$project$Form$update, shared, subMsg, formData.bN));
			}
		}
	});
var $author$project$Page$Shop$Editor$updateFormStockUnits = F2(
	function (updateFn, model) {
		var maybeFormInfo = function () {
			var _v3 = model.gE;
			switch (_v3.$) {
				case 0:
					var form = _v3.a;
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(form, $author$project$Page$Shop$Editor$EditingCreate));
				case 1:
					var form = _v3.a;
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(form, $author$project$Page$Shop$Editor$Creating));
				case 2:
					return $elm$core$Maybe$Nothing;
				case 3:
					var product = _v3.a;
					var form = _v3.b;
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(
							form,
							$author$project$Page$Shop$Editor$EditingUpdate(product)));
				case 4:
					var product = _v3.a;
					var form = _v3.b;
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(
							form,
							$author$project$Page$Shop$Editor$Saving(product)));
				case 5:
					var product = _v3.a;
					var form = _v3.b;
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(
							form,
							$author$project$Page$Shop$Editor$EditingUpdateAsAdmin(product)));
				case 6:
					var product = _v3.a;
					var form = _v3.b;
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(
							form,
							$author$project$Page$Shop$Editor$SavingAsAdmin(product)));
				case 7:
					return $elm$core$Maybe$Nothing;
				default:
					return $elm$core$Maybe$Nothing;
			}
		}();
		if (maybeFormInfo.$ === 1) {
			return $author$project$UpdateResult$init(model);
		} else {
			var _v1 = maybeFormInfo.a;
			var formData = _v1.a;
			var updateStatus = _v1.b;
			return $author$project$UpdateResult$init(
				function (newFormData) {
					return _Utils_update(
						model,
						{
							gE: updateStatus(newFormData)
						});
				}(
					function (priceAndInventory) {
						return _Utils_update(
							formData,
							{bN: priceAndInventory});
					}(
						A2(
							$author$project$Form$updateValues,
							function (values) {
								var _v2 = $elm$core$String$toInt(values.cN);
								if (!_v2.$) {
									var unitsInStock = _v2.a;
									return _Utils_update(
										values,
										{
											cN: $elm$core$String$fromInt(
												A2(
													$elm$core$Basics$max,
													0,
													updateFn(unitsInStock)))
										});
								} else {
									return values;
								}
							},
							formData.bN))));
		}
	});
var $author$project$Shop$updateProduct = F2(
	function (options, selectionSet) {
		return A2(
			$author$project$Shop$upsert,
			{
				cX: options.cX,
				bc: options.bc,
				R: $elm$core$Maybe$Just(options.R),
				hr: options.hr,
				hU: options.hU,
				dF: options.dF,
				h3: options.h3,
				ig: options.ig,
				fb: options.fb
			},
			selectionSet);
	});
var $author$project$Shop$updateProductCategories = F2(
	function (_v0, selectionSet) {
		var id = _v0.R;
		var categories = _v0.cX;
		var online = _v0.dF;
		var _v1 = id;
		var unwrappedId = _v1;
		return A2(
			$author$project$Cambiatus$Mutation$product,
			function (optionals) {
				return _Utils_update(
					optionals,
					{
						cX: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
							A2($elm$core$List$map, $author$project$Shop$Category$idToInt, categories)),
						R: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(unwrappedId),
						dF: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(online)
					});
			},
			selectionSet);
	});
var $author$project$Page$Shop$Editor$update = F3(
	function (msg, model, loggedIn) {
		var t = loggedIn.aM.iw.il;
		switch (msg.$) {
			case 0:
				return $author$project$UpdateResult$init(model);
			case 1:
				var _v1 = model.gE;
				if (_v1.$ === 2) {
					var productId = _v1.a;
					return A2(
						$author$project$UpdateResult$addExt,
						A3(
							$author$project$Session$LoggedIn$query,
							loggedIn,
							$author$project$Shop$productQuery(productId),
							$author$project$Page$Shop$Editor$CompletedSaleLoad),
						$author$project$UpdateResult$init(model));
				} else {
					return $author$project$UpdateResult$init(model);
				}
			case 2:
				switch (msg.a.$) {
					case 3:
						var maybeSale = msg.a.a;
						var _v2 = _Utils_Tuple2(model.gE, maybeSale);
						if ((_v2.a.$ === 2) && (!_v2.b.$)) {
							var _v3 = _v2.a;
							var step = _v3.b;
							var sale = _v2.b.a;
							if (_Utils_eq(sale.mr, loggedIn.lM)) {
								return $author$project$UpdateResult$init(
									_Utils_update(
										model,
										{
											gE: A2(
												$author$project$Page$Shop$Editor$EditingUpdate,
												sale,
												A3($author$project$Page$Shop$Editor$initEditingFormData, loggedIn.aM.iw, sale, step))
										}));
							} else {
								var _v4 = loggedIn.o7;
								if (_v4.$ === 3) {
									var community = _v4.a;
									return _Utils_eq(community.mq, loggedIn.lM) ? $author$project$UpdateResult$init(
										_Utils_update(
											model,
											{
												gE: A2(
													$author$project$Page$Shop$Editor$EditingUpdateAsAdmin,
													sale,
													A3($author$project$Page$Shop$Editor$initEditingFormData, loggedIn.aM.iw, sale, step))
											})) : $author$project$UpdateResult$init(
										_Utils_update(
											model,
											{gE: $author$project$Page$Shop$Editor$UnauthorizedToEdit}));
								} else {
									return A6(
										$author$project$UpdateResult$logImpossible,
										msg,
										'Completed loading sale, but community wasn\'t loaded',
										$elm$core$Maybe$Just(loggedIn.lM),
										{mX: 'update', nW: 'Page.Shop.Editor'},
										_List_fromArray(
											[
												$author$project$Log$contextFromCommunity(loggedIn.o7)
											]),
										$author$project$UpdateResult$init(model));
								}
							}
						} else {
							return A6(
								$author$project$UpdateResult$logImpossible,
								msg,
								'Completed loading sale, but sale was unavailable or user wasn\'t editing sale',
								$elm$core$Maybe$Just(loggedIn.lM),
								{mX: 'update', nW: 'Page.Shop.Editor'},
								_List_Nil,
								$author$project$UpdateResult$init(model));
						}
					case 2:
						var error = msg.a.a;
						return A7(
							$author$project$UpdateResult$logGraphqlError,
							msg,
							$elm$core$Maybe$Just(loggedIn.lM),
							'Got an error when loading sale',
							{mX: 'update', nW: 'Page.Shop.Editor'},
							_List_Nil,
							error,
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{
										gE: $author$project$Page$Shop$Editor$LoadSaleFailed(error)
									})));
					default:
						return $author$project$UpdateResult$init(model);
				}
			case 8:
				switch (msg.a.$) {
					case 3:
						var maybeId = msg.a.a;
						var redirectUrl = function () {
							if (maybeId.$ === 1) {
								return $author$project$Route$Shop(
									{cX: _List_Nil, oy: $elm$core$Maybe$Nothing});
							} else {
								var id = maybeId.a;
								return $author$project$Route$ViewSale(id);
							}
						}();
						var maybeFeedbackMessage = function () {
							var _v7 = model.gE;
							switch (_v7.$) {
								case 1:
									return $elm$core$Maybe$Just('shop.create_offer_success');
								case 4:
									return $elm$core$Maybe$Just('shop.update_offer_success');
								case 6:
									return $elm$core$Maybe$Just('shop.update_offer_success');
								default:
									return $elm$core$Maybe$Nothing;
							}
						}();
						var maybeAddFeedback = function () {
							if (maybeFeedbackMessage.$ === 1) {
								return $elm$core$Basics$identity;
							} else {
								var feedbackMessage = maybeFeedbackMessage.a;
								return $author$project$UpdateResult$addExt(
									A2(
										$author$project$Session$LoggedIn$ShowFeedback,
										0,
										t(feedbackMessage)));
							}
						}();
						return maybeAddFeedback(
							A2(
								$author$project$UpdateResult$addExt,
								$author$project$Session$LoggedIn$DropFromRouteHistoryWhile(
									function (route) {
										switch (route.$) {
											case 37:
												return true;
											case 38:
												return true;
											case 39:
												return true;
											default:
												return false;
										}
									}),
								A2(
									$author$project$UpdateResult$addCmd,
									A2($author$project$Route$replaceUrl, loggedIn.aM.eM, redirectUrl),
									$author$project$UpdateResult$init(model))));
					case 2:
						var error = msg.a.a;
						var internalError = loggedIn.aM.iw.il('error.unknown');
						var _v9 = model.gE;
						switch (_v9.$) {
							case 1:
								var form = _v9.a;
								return A7(
									$author$project$UpdateResult$logGraphqlError,
									msg,
									$elm$core$Maybe$Just(loggedIn.lM),
									'Got an error when creating a shop offer',
									{mX: 'update', nW: 'Page.Shop.Editor'},
									_List_Nil,
									error,
									A2(
										$author$project$UpdateResult$addExt,
										A2($author$project$Session$LoggedIn$ShowFeedback, 1, internalError),
										$author$project$UpdateResult$init(
											_Utils_update(
												model,
												{
													gE: $author$project$Page$Shop$Editor$EditingCreate(form)
												}))));
							case 4:
								var sale = _v9.a;
								var form = _v9.b;
								return A7(
									$author$project$UpdateResult$logGraphqlError,
									msg,
									$elm$core$Maybe$Just(loggedIn.lM),
									'Got an error when editing a shop offer',
									{mX: 'update', nW: 'Page.Shop.Editor'},
									_List_Nil,
									error,
									A2(
										$author$project$UpdateResult$addExt,
										A2($author$project$Session$LoggedIn$ShowFeedback, 1, internalError),
										$author$project$UpdateResult$init(
											_Utils_update(
												model,
												{
													gE: A2($author$project$Page$Shop$Editor$EditingUpdate, sale, form)
												}))));
							case 6:
								var sale = _v9.a;
								var form = _v9.b;
								return A7(
									$author$project$UpdateResult$logGraphqlError,
									msg,
									$elm$core$Maybe$Just(loggedIn.lM),
									'Got an error when editing a shop offer',
									{mX: 'update', nW: 'Page.Shop.Editor'},
									_List_Nil,
									error,
									A2(
										$author$project$UpdateResult$addExt,
										A2($author$project$Session$LoggedIn$ShowFeedback, 1, internalError),
										$author$project$UpdateResult$init(
											_Utils_update(
												model,
												{
													gE: A2($author$project$Page$Shop$Editor$EditingUpdateAsAdmin, sale, form)
												}))));
							default:
								return A6(
									$author$project$UpdateResult$logImpossible,
									msg,
									'Saved shop item, but wasn\'t creating or editing',
									$elm$core$Maybe$Just(loggedIn.lM),
									{mX: 'update', nW: 'Page.Shop.Editor'},
									_List_Nil,
									$author$project$UpdateResult$init(model));
						}
					default:
						return $author$project$UpdateResult$init(model);
				}
			case 3:
				var subMsg = msg.a;
				return A3($author$project$Page$Shop$Editor$updateForm, loggedIn.aM, subMsg, model);
			case 4:
				var target = msg.a;
				var formOutput = msg.b;
				var targetCmd = function () {
					switch (target) {
						case 0:
							return A3($author$project$Page$Shop$Editor$setCurrentStepInUrl, loggedIn.aM, model, 1);
						case 1:
							var _v13 = $author$project$Page$Shop$Editor$getFormData(model);
							if (_v13.$ === 1) {
								return $elm$core$Platform$Cmd$none;
							} else {
								var formData = _v13.a;
								return $author$project$Utils$spawnMessage(
									A3(
										$author$project$Form$parse,
										$author$project$Page$Shop$Editor$imagesForm(loggedIn.aM.iw),
										formData.hr,
										{
											gi: A2($elm$core$Basics$composeL, $author$project$Page$Shop$Editor$GotFormMsg, $author$project$Page$Shop$Editor$ImagesMsg),
											dE: $author$project$Page$Shop$Editor$SubmittedImages(0)
										}));
							}
						default:
							var _v14 = $author$project$Page$Shop$Editor$getFormData(model);
							if (_v14.$ === 1) {
								return $elm$core$Platform$Cmd$none;
							} else {
								var formData = _v14.a;
								return $author$project$Utils$spawnMessage(
									A3(
										$author$project$Form$parse,
										$author$project$Page$Shop$Editor$imagesForm(loggedIn.aM.iw),
										formData.hr,
										{
											gi: A2($elm$core$Basics$composeL, $author$project$Page$Shop$Editor$GotFormMsg, $author$project$Page$Shop$Editor$ImagesMsg),
											dE: $author$project$Page$Shop$Editor$SubmittedImages(1)
										}));
							}
					}
				}();
				var maybeCurrentStep = A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.C;
					},
					$author$project$Page$Shop$Editor$getFormData(model));
				if ((!maybeCurrentStep.$) && (!maybeCurrentStep.a.$)) {
					var _v11 = maybeCurrentStep.a;
					return A2(
						$author$project$UpdateResult$addCmd,
						targetCmd,
						$author$project$UpdateResult$init(
							A2(
								$author$project$Page$Shop$Editor$setCurrentStep,
								$author$project$Page$Shop$Editor$Images(formOutput),
								model)));
				} else {
					return A6(
						$author$project$UpdateResult$logImpossible,
						msg,
						'Submitted main information, but was in another step',
						$elm$core$Maybe$Just(loggedIn.lM),
						{mX: 'update', nW: 'Page.Shop.Editor'},
						_List_Nil,
						$author$project$UpdateResult$init(model));
				}
			case 5:
				var target = msg.a;
				var formOutput = msg.b;
				var targetTransformation = function () {
					if (!target) {
						return $author$project$UpdateResult$addCmd(
							A3($author$project$Page$Shop$Editor$setCurrentStepInUrl, loggedIn.aM, model, 2));
					} else {
						var _v17 = $author$project$Page$Shop$Editor$getFormData(model);
						if (_v17.$ === 1) {
							return $elm$core$Basics$identity;
						} else {
							var formData = _v17.a;
							var _v18 = A2(
								$author$project$Community$getField,
								loggedIn.o7,
								function ($) {
									return $.e1;
								});
							if (_v18.$ === 3) {
								var _v19 = _v18.a;
								var categories = _v19.b;
								return $author$project$UpdateResult$addMsg(
									A3(
										$author$project$Form$parse,
										A2($author$project$Page$Shop$Editor$categoriesForm, loggedIn.aM.iw, categories),
										formData.cX,
										{
											gi: A2($elm$core$Basics$composeL, $author$project$Page$Shop$Editor$GotFormMsg, $author$project$Page$Shop$Editor$CategoriesMsg),
											dE: $author$project$Page$Shop$Editor$SubmittedCategories
										}));
							} else {
								return $author$project$UpdateResult$mapModel(
									function (m) {
										return _Utils_update(
											m,
											{dw: true});
									});
							}
						}
					}
				}();
				var maybeCurrentStep = A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.C;
					},
					$author$project$Page$Shop$Editor$getFormData(model));
				if ((!maybeCurrentStep.$) && (maybeCurrentStep.a.$ === 1)) {
					var mainInformation = maybeCurrentStep.a.a;
					return targetTransformation(
						$author$project$UpdateResult$init(
							A2(
								$author$project$Page$Shop$Editor$setCurrentStep,
								A2($author$project$Page$Shop$Editor$Categories, mainInformation, formOutput),
								model)));
				} else {
					return A6(
						$author$project$UpdateResult$logImpossible,
						msg,
						'Submitted images, but was in another step',
						$elm$core$Maybe$Just(loggedIn.lM),
						{mX: 'update', nW: 'Page.Shop.Editor'},
						_List_Nil,
						$author$project$UpdateResult$init(model));
				}
			case 6:
				var formOutput = msg.a;
				var maybeCurrentStep = A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.C;
					},
					$author$project$Page$Shop$Editor$getFormData(model));
				if ((!maybeCurrentStep.$) && (maybeCurrentStep.a.$ === 2)) {
					var _v21 = maybeCurrentStep.a;
					var mainInformation = _v21.a;
					var images = _v21.b;
					var _v22 = model.gE;
					if (_v22.$ === 5) {
						var sale = _v22.a;
						var formData = _v22.b;
						return A2(
							$author$project$UpdateResult$addExt,
							A3(
								$author$project$Session$LoggedIn$mutation,
								loggedIn,
								A2(
									$author$project$Shop$updateProductCategories,
									{cX: formOutput.cX, R: sale.R, dF: formOutput.dF},
									$author$project$Shop$idSelectionSet),
								$author$project$Page$Shop$Editor$GotSaveResponse),
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{
										gE: A2($author$project$Page$Shop$Editor$SavingAsAdmin, sale, formData)
									})));
					} else {
						return A2(
							$author$project$UpdateResult$addCmd,
							A3($author$project$Page$Shop$Editor$setCurrentStepInUrl, loggedIn.aM, model, 3),
							$author$project$UpdateResult$init(
								A2(
									$author$project$Page$Shop$Editor$setCurrentStep,
									A3($author$project$Page$Shop$Editor$PriceAndInventory, mainInformation, images, formOutput),
									model)));
					}
				} else {
					return A6(
						$author$project$UpdateResult$logImpossible,
						msg,
						'Submitted categories, but was in another step',
						$elm$core$Maybe$Just(loggedIn.lM),
						{mX: 'update', nW: 'Page.Shop.Editor'},
						_List_Nil,
						$author$project$UpdateResult$init(model));
				}
			case 7:
				var priceAndInventory = msg.a;
				var maybeCurrentStep = A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.C;
					},
					$author$project$Page$Shop$Editor$getFormData(model));
				if ((!maybeCurrentStep.$) && (maybeCurrentStep.a.$ === 3)) {
					var _v24 = maybeCurrentStep.a;
					var mainInformation = _v24.a;
					var images = _v24.b;
					var categoriesOutput = _v24.c;
					var _v25 = model.gE;
					switch (_v25.$) {
						case 0:
							var formData = _v25.a;
							return A5(
								$author$project$Session$LoggedIn$withPrivateKey,
								loggedIn,
								_List_fromArray(
									[5]),
								model,
								{he: $author$project$Page$Shop$Editor$NoOp, ik: msg},
								A2(
									$author$project$UpdateResult$addExt,
									A3(
										$author$project$Session$LoggedIn$mutation,
										loggedIn,
										A2(
											$author$project$Shop$createProduct,
											{cX: categoriesOutput.cX, bc: mainInformation.bc, hr: images, hU: mainInformation.hU, dF: categoriesOutput.dF, h3: priceAndInventory.h3.lU, ig: priceAndInventory.ix, fb: mainInformation.fb},
											$author$project$Shop$idSelectionSet),
										$author$project$Page$Shop$Editor$GotSaveResponse),
									$author$project$UpdateResult$init(
										_Utils_update(
											model,
											{
												gE: $author$project$Page$Shop$Editor$Creating(formData)
											}))));
						case 3:
							var sale = _v25.a;
							var formData = _v25.b;
							return A5(
								$author$project$Session$LoggedIn$withPrivateKey,
								loggedIn,
								_List_fromArray(
									[5]),
								model,
								{he: $author$project$Page$Shop$Editor$NoOp, ik: msg},
								A2(
									$author$project$UpdateResult$addExt,
									A3(
										$author$project$Session$LoggedIn$mutation,
										loggedIn,
										A2(
											$author$project$Shop$updateProduct,
											{cX: categoriesOutput.cX, bc: mainInformation.bc, R: sale.R, hr: images, hU: mainInformation.hU, dF: categoriesOutput.dF, h3: priceAndInventory.h3.lU, ig: priceAndInventory.ix, fb: mainInformation.fb},
											$author$project$Shop$idSelectionSet),
										$author$project$Page$Shop$Editor$GotSaveResponse),
									$author$project$UpdateResult$init(
										_Utils_update(
											model,
											{
												gE: A2($author$project$Page$Shop$Editor$Saving, sale, formData)
											}))));
						default:
							return A6(
								$author$project$UpdateResult$logImpossible,
								msg,
								'Clicked save shop item, but wasn\'t editing or creating shop offer',
								$elm$core$Maybe$Just(loggedIn.lM),
								{mX: 'update', nW: 'Page.Shop.Editor'},
								_List_Nil,
								$author$project$UpdateResult$init(model));
					}
				} else {
					return A6(
						$author$project$UpdateResult$logImpossible,
						msg,
						'Submitted price and inventory, but was in another step',
						$elm$core$Maybe$Just(loggedIn.lM),
						{mX: 'update', nW: 'Page.Shop.Editor'},
						_List_Nil,
						$author$project$UpdateResult$init(model));
				}
			case 9:
				return A2(
					$author$project$Page$Shop$Editor$updateFormStockUnits,
					function (price) {
						return price - 1;
					},
					model);
			default:
				return A2(
					$author$project$Page$Shop$Editor$updateFormStockUnits,
					function (price) {
						return price + 1;
					},
					model);
		}
	});
var $author$project$Page$GuestExternal = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Shop$Viewer$NoOp = {$: 0};
var $author$project$Page$Shop$Viewer$GotFormMsgAsGuest = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Shop$Viewer$updateFormInteraction = F3(
	function (msg, _v0, model) {
		var maxUnits = _v0.hE;
		return A2(
			$author$project$Form$updateValues,
			function (values) {
				return _Utils_update(
					values,
					{
						iy: function () {
							var _v1 = $elm$core$String$toInt(values.iy);
							if (_v1.$ === 1) {
								return values.iy;
							} else {
								var units = _v1.a;
								var newUnits = function () {
									if (msg === 1) {
										if (maxUnits.$ === 1) {
											return units + 1;
										} else {
											var maximum = maxUnits.a;
											return A2($elm$core$Basics$min, maximum, units + 1);
										}
									} else {
										return A2($elm$core$Basics$max, 1, units - 1);
									}
								}();
								return $elm$core$String$fromInt(newUnits);
							}
						}()
					});
			},
			model);
	});
var $author$project$Page$Shop$Viewer$updateAsGuest = F3(
	function (msg, model, guest) {
		switch (msg.$) {
			case 0:
				switch (msg.a.$) {
					case 3:
						var productPreview = msg.a.a;
						return $author$project$UpdateResult$init(
							_Utils_update(
								model,
								{
									dN: $krisajenkins$remotedata$RemoteData$Success(productPreview)
								}));
					case 2:
						var err = msg.a.a;
						return A7(
							$author$project$UpdateResult$logGraphqlError,
							msg,
							$elm$core$Maybe$Nothing,
							'Got an error when loading sale preview',
							{mX: 'updateAsGuest', nW: 'Page.Shop.Viewer'},
							_List_Nil,
							err,
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{
										dN: $krisajenkins$remotedata$RemoteData$Failure(err)
									})));
					case 0:
						var _v1 = msg.a;
						return $author$project$UpdateResult$init(model);
					default:
						var _v2 = msg.a;
						return $author$project$UpdateResult$init(model);
				}
			case 1:
				var subMsg = msg.a;
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{
							hk: A3(
								$author$project$Page$Shop$Viewer$updateFormInteraction,
								subMsg,
								{hE: $elm$core$Maybe$Nothing},
								model.hk)
						}));
			default:
				var subMsg = msg.a;
				return A5(
					$author$project$UpdateResult$fromChild,
					function (newForm) {
						return _Utils_update(
							model,
							{hk: newForm});
					},
					$author$project$Page$Shop$Viewer$GotFormMsgAsGuest,
					A2($elm$core$Basics$composeR, $author$project$Session$Guest$SetFeedback, $author$project$UpdateResult$addExt),
					model,
					A3($author$project$Form$update, guest.aM, subMsg, model.hk));
		}
	});
var $author$project$Page$Shop$Viewer$ClickedTransfer = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Page$Shop$Viewer$ClosedAuthModal = {$: 0};
var $author$project$Page$Shop$Viewer$CompletedDeleteProduct = function (a) {
	return {$: 12, a: a};
};
var $author$project$Page$Shop$Viewer$Deleting = 2;
var $author$project$Page$Shop$Viewer$GotFormMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$Shop$Viewer$Open = 1;
var $author$project$Cambiatus$Mutation$deleteProduct = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'deleteProduct',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'id', requiredArgs____.R, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int)
				]),
			object____,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
	});
var $author$project$Shop$deleteProduct = function (_v0) {
	var id = _v0;
	return $author$project$Cambiatus$Mutation$deleteProduct(
		{R: id});
};
var $author$project$Transfer$encodeEosActionData = function (data) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'from',
				$author$project$Eos$Account$encodeName(data.ew)),
				_Utils_Tuple2(
				'to',
				$author$project$Eos$Account$encodeName(data.fc)),
				_Utils_Tuple2(
				'quantity',
				$author$project$Eos$encodeAsset(data.pO)),
				_Utils_Tuple2(
				'memo',
				$author$project$Markdown$encode(data.ka))
			]));
};
var $author$project$Shop$encodeId = function (_v0) {
	var id = _v0;
	return $elm$json$Json$Encode$int(id);
};
var $author$project$Shop$encodeTransferSale = function (t) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'sale_id',
				$author$project$Shop$encodeId(t.R)),
				_Utils_Tuple2(
				'from',
				$author$project$Eos$Account$encodeName(t.ew)),
				_Utils_Tuple2(
				'to',
				$author$project$Eos$Account$encodeName(t.fc)),
				_Utils_Tuple2(
				'quantity',
				$author$project$Eos$encodeAsset(t.oV)),
				_Utils_Tuple2(
				'units',
				$elm$json$Json$Encode$int(t.iy))
			]));
};
var $author$project$Shop$getAvailableUnits = function (product) {
	var _v0 = product.ig;
	if (!_v0.$) {
		return $elm$core$Maybe$Nothing;
	} else {
		var availableUnits = _v0.a.iQ;
		return $elm$core$Maybe$Just(availableUnits);
	}
};
var $author$project$Page$Shop$Viewer$updateAsLoggedIn = F3(
	function (msg, model, loggedIn) {
		var _v0 = loggedIn.aM.iw;
		var t = _v0.il;
		switch (msg.$) {
			case 0:
				return $author$project$UpdateResult$init(model);
			case 5:
				if (!msg.a.$) {
					var _v3 = model.gE;
					if (_v3.$ === 3) {
						return A2(
							$author$project$UpdateResult$addCmd,
							A2(
								$author$project$Route$replaceUrl,
								loggedIn.aM.eM,
								$author$project$Route$Shop(
									{cX: _List_Nil, oy: $elm$core$Maybe$Nothing})),
							A2(
								$author$project$UpdateResult$addExt,
								A2(
									$author$project$Session$LoggedIn$ShowFeedback,
									0,
									t('shop.transfer.success')),
								$author$project$UpdateResult$init(model)));
					} else {
						return $author$project$UpdateResult$init(
							_Utils_update(
								model,
								{eC: false}));
					}
				} else {
					var eosErrorString = msg.a.a;
					var errorMessage = A2($author$project$Eos$EosError$parseTransferError, loggedIn.aM.iw, eosErrorString);
					return A2(
						$author$project$UpdateResult$addExt,
						A2($author$project$Session$LoggedIn$ShowFeedback, 1, errorMessage),
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{eC: false})));
				}
			case 1:
				switch (msg.a.$) {
					case 3:
						var maybeSale = msg.a.a;
						if (maybeSale.$ === 1) {
							return A6(
								$author$project$UpdateResult$logImpossible,
								msg,
								'Couldn\'t find the sale',
								$elm$core$Maybe$Just(loggedIn.lM),
								{mX: 'updateAsLoggedIn', nW: 'Page.Shop.Viewer'},
								_List_Nil,
								$author$project$UpdateResult$init(model));
						} else {
							var sale = maybeSale.a;
							return $author$project$UpdateResult$init(
								_Utils_update(
									model,
									{
										gE: $krisajenkins$remotedata$RemoteData$Success(sale)
									}));
						}
					case 2:
						var err = msg.a.a;
						return A7(
							$author$project$UpdateResult$logGraphqlError,
							msg,
							$elm$core$Maybe$Just(loggedIn.lM),
							'Got an error when trying to load shop sale',
							{mX: 'updateAsLoggedIn', nW: 'Page.Shop.Viewer'},
							_List_Nil,
							err,
							$author$project$UpdateResult$init(
								_Utils_update(
									model,
									{
										gE: $krisajenkins$remotedata$RemoteData$Failure(err)
									})));
					default:
						return $author$project$UpdateResult$init(model);
				}
			case 3:
				var sale = msg.a;
				var formOutput = msg.b;
				var value = {lU: sale.h3 * formOutput.iy, e9: sale.e9};
				var unitPrice = {lU: sale.h3, e9: sale.e9};
				var authorization = {iH: loggedIn.lM, kz: $author$project$Eos$Account$samplePermission};
				return A5(
					$author$project$Session$LoggedIn$withPrivateKey,
					loggedIn,
					_List_fromArray(
						[4]),
					model,
					{he: $author$project$Page$Shop$Viewer$ClosedAuthModal, ik: msg},
					A2(
						$author$project$UpdateResult$addPort,
						{
							i9: $author$project$Eos$encodeTransaction(
								_List_fromArray(
									[
										{
										lM: loggedIn.aM.mn.pC,
										iP: authorization,
										i9: $author$project$Transfer$encodeEosActionData(
											{ew: loggedIn.lM, ka: formOutput.ka, fc: sale.mr, pO: value}),
										ki: 'transfer'
									},
										{
										lM: loggedIn.aM.mn.b9,
										iP: authorization,
										i9: $author$project$Shop$encodeTransferSale(
											{ew: loggedIn.lM, R: sale.R, oV: unitPrice, fc: sale.mr, iy: formOutput.iy}),
										ki: 'transfersale'
									}
									])),
							kY: A2($author$project$Page$Shop$Viewer$ClickedTransfer, sale, formOutput),
							kZ: $elm$json$Json$Encode$null
						},
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{eC: true}))));
			case 4:
				var subMsg = msg.a;
				return A5(
					$author$project$UpdateResult$fromChild,
					function (newForm) {
						return _Utils_update(
							model,
							{hk: newForm});
					},
					$author$project$Page$Shop$Viewer$GotFormMsg,
					$author$project$Session$LoggedIn$addFeedback,
					model,
					A3($author$project$Form$update, loggedIn.aM, subMsg, model.hk));
			case 2:
				var res = msg.a;
				if (!res.$) {
					var bals = res.a;
					return $author$project$UpdateResult$init(
						_Utils_update(
							model,
							{gV: bals}));
				} else {
					return $author$project$UpdateResult$init(model);
				}
			case 6:
				var subMsg = msg.a;
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{
							hk: A3(
								$author$project$Page$Shop$Viewer$updateFormInteraction,
								subMsg,
								{
									hE: function () {
										var _v5 = model.gE;
										if (_v5.$ === 3) {
											var product = _v5.a;
											return $author$project$Shop$getAvailableUnits(product);
										} else {
											return $elm$core$Maybe$Nothing;
										}
									}()
								},
								model.hk)
						}));
			case 7:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{dq: true}));
			case 8:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{dq: false}));
			case 9:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{aS: 1}));
			case 10:
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{aS: 0}));
			case 11:
				var _v6 = model.gE;
				if (_v6.$ === 3) {
					var sale = _v6.a;
					return A2(
						$author$project$UpdateResult$addExt,
						A3(
							$author$project$Session$LoggedIn$mutation,
							loggedIn,
							A2($author$project$Shop$deleteProduct, sale.R, $dillonkearns$elm_graphql$Graphql$SelectionSet$empty),
							$author$project$Page$Shop$Viewer$CompletedDeleteProduct),
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{aS: 2})));
				} else {
					return $author$project$UpdateResult$init(model);
				}
			default:
				switch (msg.a.$) {
					case 3:
						return A2(
							$author$project$UpdateResult$addCmd,
							A2(
								$author$project$Route$pushUrl,
								loggedIn.aM.eM,
								$author$project$Route$Shop(
									{cX: _List_Nil, oy: $elm$core$Maybe$Nothing})),
							A2(
								$author$project$UpdateResult$addExt,
								A2(
									$author$project$Session$LoggedIn$ShowFeedback,
									0,
									t('shop.delete_offer_success')),
								$author$project$UpdateResult$init(
									_Utils_update(
										model,
										{aS: 0}))));
					case 2:
						var err = msg.a.a;
						return A2(
							$author$project$UpdateResult$addExt,
							A2(
								$author$project$Session$LoggedIn$ShowFeedback,
								1,
								t('shop.delete_offer_failure')),
							A7(
								$author$project$UpdateResult$logGraphqlError,
								msg,
								$elm$core$Maybe$Just(loggedIn.lM),
								'Got an error when deleting product',
								{mX: 'updateAsLoggedIn', nW: 'Page.Shop.Viewer'},
								_List_Nil,
								err,
								$author$project$UpdateResult$init(
									_Utils_update(
										model,
										{aS: 0, dq: false}))));
					default:
						return $author$project$UpdateResult$init(model);
				}
		}
	});
var $author$project$Page$Shop$Viewer$update = F3(
	function (msg, model, session) {
		var _v0 = _Utils_Tuple3(msg, model.gE, session);
		_v0$10:
		while (true) {
			switch (_v0.a.$) {
				case 0:
					var _v1 = _v0.a;
					return $author$project$UpdateResult$init(model);
				case 1:
					var containerId = _v0.a.a.mj;
					var imageId = _v0.a.a.nf;
					return A2(
						$author$project$UpdateResult$addPort,
						{
							i9: $elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'name',
										$elm$json$Json$Encode$string('smoothHorizontalScroll')),
										_Utils_Tuple2(
										'containerId',
										$elm$json$Json$Encode$string(containerId)),
										_Utils_Tuple2(
										'targetId',
										$elm$json$Json$Encode$string(imageId))
									])),
							kY: $author$project$Page$Shop$Viewer$NoOp,
							kZ: $elm$json$Json$Encode$null
						},
						$author$project$UpdateResult$init(model));
				case 2:
					var imageId = _v0.a.a;
					return $author$project$UpdateResult$init(
						_Utils_update(
							model,
							{
								cc: $elm$core$Maybe$Just(imageId),
								cF: model.cc
							}));
				case 3:
					var imageId = _v0.a.a;
					return _Utils_eq(
						$elm$core$Maybe$Just(imageId),
						model.cc) ? $author$project$UpdateResult$init(
						_Utils_update(
							model,
							{cc: model.cF, cF: $elm$core$Maybe$Nothing})) : (_Utils_eq(
						$elm$core$Maybe$Just(imageId),
						model.cF) ? $author$project$UpdateResult$init(
						_Utils_update(
							model,
							{cF: $elm$core$Maybe$Nothing})) : $author$project$UpdateResult$init(model));
				case 4:
					var _v2 = _v0.a;
					return $author$project$UpdateResult$init(
						_Utils_update(
							model,
							{cs: true}));
				case 5:
					var _v3 = _v0.a;
					return $author$project$UpdateResult$init(
						_Utils_update(
							model,
							{cs: false}));
				case 6:
					var sale = _v0.a.a;
					var shared = $author$project$Page$toShared(session);
					var sharePort = shared.iW ? {
						i9: $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'name',
									$elm$json$Json$Encode$string('share')),
									_Utils_Tuple2(
									'title',
									$elm$json$Json$Encode$string(sale.fb)),
									_Utils_Tuple2(
									'text',
									$elm$json$Json$Encode$string(
										$author$project$Markdown$toUnformattedString(sale.bc))),
									_Utils_Tuple2(
									'url',
									$elm$json$Json$Encode$string(
										$elm$url$Url$toString(
											A2(
												$author$project$Route$addRouteToUrl,
												shared,
												$author$project$Route$ViewSale(sale.R)))))
								])),
						kY: msg,
						kZ: $elm$json$Json$Encode$null
					} : {
						i9: $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'name',
									$elm$json$Json$Encode$string('copyToClipboard')),
									_Utils_Tuple2(
									'id',
									$elm$json$Json$Encode$string('share-fallback-input'))
								])),
						kY: msg,
						kZ: $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'type',
									$elm$json$Json$Encode$string('copyToClipboard'))
								]))
					};
					return A2(
						$author$project$UpdateResult$addPort,
						sharePort,
						$author$project$UpdateResult$init(model));
				case 7:
					var _v4 = _v0.a;
					var shared = $author$project$Page$toShared(session);
					var feedbackExternalMsg = function () {
						if (session.$ === 1) {
							return $author$project$Page$LoggedInExternal(
								A2(
									$author$project$Session$LoggedIn$ShowFeedback,
									0,
									shared.iw.il('copied_to_clipboard')));
						} else {
							return $author$project$Page$GuestExternal(
								$author$project$Session$Guest$SetFeedback(
									A2(
										$author$project$View$Feedback$Visible,
										0,
										shared.iw.il('copied_to_clipboard'))));
						}
					}();
					return A2(
						$author$project$UpdateResult$addExt,
						feedbackExternalMsg,
						$author$project$UpdateResult$init(
							_Utils_update(
								model,
								{cs: false})));
				case 8:
					if ((!_v0.b.$) && (!_v0.c.$)) {
						var subMsg = _v0.a.a;
						var subModel = _v0.b.a;
						var guest = _v0.c.a;
						return A4(
							$author$project$UpdateResult$map,
							function (guestModel) {
								return _Utils_update(
									model,
									{
										gE: $author$project$Page$Shop$Viewer$AsGuest(guestModel)
									});
							},
							$author$project$Page$Shop$Viewer$AsGuestMsg,
							A2($elm$core$Basics$composeR, $author$project$Page$GuestExternal, $author$project$UpdateResult$addExt),
							A3($author$project$Page$Shop$Viewer$updateAsGuest, subMsg, subModel, guest));
					} else {
						break _v0$10;
					}
				default:
					if ((_v0.b.$ === 1) && (_v0.c.$ === 1)) {
						var subMsg = _v0.a.a;
						var subModel = _v0.b.a;
						var loggedIn = _v0.c.a;
						return A4(
							$author$project$UpdateResult$map,
							function (loggedInModel) {
								return _Utils_update(
									model,
									{
										gE: $author$project$Page$Shop$Viewer$AsLoggedIn(loggedInModel)
									});
							},
							$author$project$Page$Shop$Viewer$AsLoggedInMsg,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Session$LoggedIn$mapExternal($author$project$Page$Shop$Viewer$AsLoggedInMsg),
								A2($elm$core$Basics$composeR, $author$project$Page$LoggedInExternal, $author$project$UpdateResult$addExt)),
							A3($author$project$Page$Shop$Viewer$updateAsLoggedIn, subMsg, subModel, loggedIn));
					} else {
						break _v0$10;
					}
			}
		}
		return A5(
			$author$project$UpdateResult$logIncompatibleMsg,
			msg,
			$author$project$Page$maybeAccountName(session),
			{mX: 'update', nW: 'Page.Shop.Viewer'},
			_List_Nil,
			$author$project$UpdateResult$init(model));
	});
var $author$project$Page$ViewTransfer$LoadFailed = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$ViewTransfer$Loaded = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $author$project$Cambiatus$Enum$TransferDirectionValue$Sending = 1;
var $author$project$Page$ViewTransfer$findDirection = F2(
	function (maybeTransfer, _v0) {
		var accountName = _v0.lM;
		if (!maybeTransfer.$) {
			var transfer = maybeTransfer.a;
			return _Utils_eq(transfer.fc.fl, accountName) ? 0 : 1;
		} else {
			return 1;
		}
	});
var $author$project$Transfer$updateProfileSummaries = F3(
	function (profileSummaries, isLeft, profileSummaryMsg) {
		return isLeft ? _Utils_update(
			profileSummaries,
			{
				j1: A2($author$project$Profile$Summary$update, profileSummaryMsg, profileSummaries.j1)
			}) : _Utils_update(
			profileSummaries,
			{
				k_: A2($author$project$Profile$Summary$update, profileSummaryMsg, profileSummaries.k_)
			});
	});
var $author$project$Page$ViewTransfer$updateStatus = F2(
	function (status, model) {
		return _Utils_update(
			model,
			{gE: status});
	});
var $author$project$Page$ViewTransfer$update = F3(
	function (msg, model, user) {
		if (!msg.$) {
			switch (msg.a.$) {
				case 3:
					var transfer = msg.a.a;
					var summary = $author$project$Profile$Summary$init(false);
					var direction = A2($author$project$Page$ViewTransfer$findDirection, transfer, user);
					return $author$project$UpdateResult$init(
						_Utils_update(
							model,
							{
								gE: A3(
									$author$project$Page$ViewTransfer$Loaded,
									transfer,
									direction,
									{j1: summary, k_: summary})
							}));
				case 2:
					var error = msg.a.a;
					return A7(
						$author$project$UpdateResult$logGraphqlError,
						msg,
						$elm$core$Maybe$Just(user.lM),
						'Got an error when loading transfer',
						{mX: 'update', nW: 'Page.ViewTransfer'},
						_List_Nil,
						error,
						$author$project$UpdateResult$init(
							A2(
								$author$project$Page$ViewTransfer$updateStatus,
								$author$project$Page$ViewTransfer$LoadFailed(error),
								model)));
				default:
					return $author$project$UpdateResult$init(model);
			}
		} else {
			var isLeft = msg.a;
			var subMsg = msg.b;
			var _v1 = model.gE;
			if (_v1.$ === 2) {
				var maybeTransfer = _v1.a;
				var direction = _v1.b;
				var profileSummaries = _v1.c;
				return $author$project$UpdateResult$init(
					_Utils_update(
						model,
						{
							gE: A3(
								$author$project$Page$ViewTransfer$Loaded,
								maybeTransfer,
								direction,
								A3($author$project$Transfer$updateProfileSummaries, profileSummaries, isLeft, subMsg))
						}));
			} else {
				return A6(
					$author$project$UpdateResult$logImpossible,
					msg,
					'Got a Profile.Summary.Msg, but transfer wasn\'t loaded',
					$elm$core$Maybe$Just(user.lM),
					{mX: 'update', nW: 'Page.ViewTransfer'},
					_List_Nil,
					$author$project$UpdateResult$init(model));
			}
		}
	});
var $author$project$Main$update = F2(
	function (msg, model) {
		update:
		while (true) {
			var withSession = function (fn) {
				return fn(model.c);
			};
			var withLoggedIn = function (fn) {
				var _v20 = model.c;
				if (!_v20.$) {
					return _Utils_Tuple2(
						model,
						A2(
							$author$project$Log$send,
							$author$project$Main$msgToString,
							{
								mm: _List_Nil,
								nH: 1,
								nN: {mX: 'update', nW: 'Main'},
								nS: 'Expected user to be logged in, but they\'re a guest',
								pu: _List_fromArray(
									[
										$author$project$Log$IncompatibleAuthentication(0)
									]),
								pE: msg,
								pM: $elm$core$Maybe$Nothing
							}));
				} else {
					var loggedIn = _v20.a;
					return fn(loggedIn);
				}
			};
			var withGuest = function (fn) {
				var _v19 = model.c;
				if (!_v19.$) {
					var guest = _v19.a;
					return fn(guest);
				} else {
					return _Utils_Tuple2(
						model,
						A2(
							$author$project$Log$send,
							$author$project$Main$msgToString,
							{
								mm: _List_Nil,
								nH: 1,
								nN: {mX: 'update', nW: 'Main'},
								nS: 'Expected user to be a guest, but they\'re logged in',
								pu: _List_fromArray(
									[
										$author$project$Log$IncompatibleAuthentication(1)
									]),
								pE: msg,
								pM: $elm$core$Maybe$Nothing
							}));
				}
			};
			var _v7 = _Utils_Tuple2(msg, model.gE);
			_v7$29:
			while (true) {
				switch (_v7.a.$) {
					case 0:
						var _v8 = _v7.a;
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					case 1:
						var url = _v7.a.a;
						return A2(
							$author$project$Main$changeRouteTo,
							$author$project$Route$fromUrl(url),
							model);
					case 2:
						var urlRequest = _v7.a.a;
						if (!urlRequest.$) {
							var url = urlRequest.a;
							return _Utils_Tuple2(
								$author$project$Main$hideFeedback(model),
								A2(
									$elm$browser$Browser$Navigation$pushUrl,
									function ($) {
										return $.eM;
									}(
										$author$project$Page$toShared(model.c)),
									$elm$url$Url$toString(url)));
						} else {
							var href = urlRequest.a;
							return _Utils_Tuple2(
								$author$project$Main$hideFeedback(model),
								$elm$browser$Browser$Navigation$load(href));
						}
					case 3:
						var val = _v7.a.a;
						var jsAddressResult = A2(
							$elm$json$Json$Decode$decodeValue,
							A2(
								$elm$json$Json$Decode$field,
								'address',
								$elm$json$Json$Decode$list($elm$json$Json$Decode$string)),
							val);
						if (!jsAddressResult.$) {
							var jsAddress = jsAddressResult.a;
							var _v11 = A2($author$project$Main$jsAddressToMsg, jsAddress, val);
							if (_v11.$ === 1) {
								return _Utils_Tuple2(
									model,
									A2(
										$author$project$Log$send,
										$author$project$Main$msgToString,
										A5(
											$author$project$Log$fromImpossible,
											msg,
											'Got invalid address from JavaScript',
											$author$project$Page$maybeAccountName(model.c),
											{mX: 'update', nW: 'Main'},
											_List_fromArray(
												[
													{
													mR: $elm$core$Dict$fromList(
														_List_fromArray(
															[
																_Utils_Tuple2(
																'address',
																A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, jsAddress))
															])),
													ki: 'Data'
												}
												]))));
							} else {
								var jsMsg = _v11.a;
								var $temp$msg = jsMsg,
									$temp$model = model;
								msg = $temp$msg;
								model = $temp$model;
								continue update;
							}
						} else {
							var decodeError = jsAddressResult.a;
							return _Utils_Tuple2(
								model,
								A2(
									$author$project$Log$send,
									$author$project$Main$msgToString,
									A6(
										$author$project$Log$fromDecodeError,
										msg,
										$author$project$Page$maybeAccountName(model.c),
										'Could not decode JavaScript address',
										{mX: 'update', nW: 'Main'},
										_List_Nil,
										decodeError)));
						}
					case 4:
						var subMsg = _v7.a.a;
						return A3(
							$author$project$UpdateResult$toModelCmd,
							$author$project$Main$updateExternal,
							$author$project$Main$msgToString,
							A4(
								$author$project$UpdateResult$map,
								function (s) {
									return _Utils_update(
										model,
										{c: s});
								},
								$author$project$Main$GotPageMsg,
								F2(
									function (extMsg, uR) {
										return A2($author$project$UpdateResult$addExt, extMsg, uR);
									}),
								A2($author$project$Page$update, subMsg, model.c)));
					case 19:
						if (_v7.b.$ === 19) {
							var subMsg = _v7.a.a;
							var _v12 = _v7.b;
							var maybeInvitation = _v12.a;
							var maybeRedirect = _v12.b;
							var subModel = _v12.c;
							return withGuest(
								A2(
									$elm$core$Basics$composeR,
									A3($author$project$Page$Register$update, maybeInvitation, subMsg, subModel),
									A3(
										$author$project$Main$updateGuestUResult,
										A2($author$project$Main$Register, maybeInvitation, maybeRedirect),
										$author$project$Main$GotRegisterMsg,
										model)));
						} else {
							break _v7$29;
						}
					case 20:
						if (_v7.b.$ === 20) {
							var subMsg = _v7.a.a;
							var subModel = _v7.b.a;
							return withLoggedIn(
								A2(
									$elm$core$Basics$composeR,
									A2($author$project$Page$Settings$update, subMsg, subModel),
									A3($author$project$Main$updateLoggedInUResult, $author$project$Main$Settings, $author$project$Main$GotSettingsMsg, model)));
						} else {
							break _v7$29;
						}
					case 13:
						if (_v7.b.$ === 4) {
							var subMsg = _v7.a.a;
							var subModel = _v7.b.a;
							return withLoggedIn(
								A2(
									$elm$core$Basics$composeR,
									A2($author$project$Page$PaymentHistory$update, subMsg, subModel),
									A3($author$project$Main$updateLoggedInUResult, $author$project$Main$PaymentHistory, $author$project$Main$GotPaymentHistoryMsg, model)));
						} else {
							break _v7$29;
						}
					case 11:
						if (_v7.b.$ === 12) {
							var subMsg = _v7.a.a;
							var _v13 = _v7.b;
							var maybeRedirect = _v13.a;
							var subModel = _v13.b;
							return withGuest(
								A2(
									$elm$core$Basics$composeR,
									A2($author$project$Page$Login$update, subMsg, subModel),
									A3(
										$author$project$Main$updateGuestUResult,
										$author$project$Main$Login(maybeRedirect),
										$author$project$Main$GotLoginMsg,
										model)));
						} else {
							break _v7$29;
						}
					case 12:
						if (_v7.b.$ === 13) {
							var subMsg = _v7.a.a;
							var subModel = _v7.b.a;
							return withLoggedIn(
								A2(
									$elm$core$Basics$composeR,
									A2($author$project$Page$News$update, subMsg, subModel),
									A3($author$project$Main$updateLoggedInUResult, $author$project$Main$News, $author$project$Main$GotNewsMsg, model)));
						} else {
							break _v7$29;
						}
					case 5:
						if (_v7.b.$ === 10) {
							var subMsg = _v7.a.a;
							var subModel = _v7.b.a;
							return withLoggedIn(
								A2(
									$elm$core$Basics$composeR,
									A2($author$project$Page$Notification$update, subMsg, subModel),
									A3($author$project$Main$updateLoggedInUResult, $author$project$Main$Notification, $author$project$Main$GotNotificationMsg, model)));
						} else {
							break _v7$29;
						}
					case 6:
						if (_v7.b.$ === 5) {
							var subMsg = _v7.a.a;
							var subModel = _v7.b.a;
							return withLoggedIn(
								A2(
									$elm$core$Basics$composeR,
									A2($author$project$Page$Community$About$update, subMsg, subModel),
									A3($author$project$Main$updateLoggedInUResult, $author$project$Main$CommunityAbout, $author$project$Main$GotCommunityAboutMsg, model)));
						} else {
							break _v7$29;
						}
					case 7:
						if (_v7.b.$ === 6) {
							var subMsg = _v7.a.a;
							var subModel = _v7.b.a;
							return withLoggedIn(
								A2(
									$elm$core$Basics$composeR,
									A2($author$project$Page$Community$Objectives$update, subMsg, subModel),
									A3($author$project$Main$updateLoggedInUResult, $author$project$Main$CommunityObjectives, $author$project$Main$GotCommunityObjectivesMsg, model)));
						} else {
							break _v7$29;
						}
					case 8:
						if (_v7.b.$ === 7) {
							var subMsg = _v7.a.a;
							var subModel = _v7.b.a;
							return withLoggedIn(
								A2(
									$elm$core$Basics$composeR,
									A2($author$project$Page$Community$New$update, subMsg, subModel),
									A3($author$project$Main$updateLoggedInUResult, $author$project$Main$CommunityEditor, $author$project$Main$GotCommunityEditorMsg, model)));
						} else {
							break _v7$29;
						}
					case 10:
						if (_v7.b.$ === 11) {
							var subMsg = _v7.a.a;
							var subModel = _v7.b.a;
							return withLoggedIn(
								A2(
									$elm$core$Basics$composeR,
									A2($author$project$Page$Dashboard$update, subMsg, subModel),
									A3($author$project$Main$updateLoggedInUResult, $author$project$Main$Dashboard, $author$project$Main$GotDashboardMsg, model)));
						} else {
							break _v7$29;
						}
					case 14:
						if (_v7.b.$ === 14) {
							var subMsg = _v7.a.a;
							var subModel = _v7.b.a;
							return withLoggedIn(
								A2(
									$elm$core$Basics$composeR,
									A2($author$project$Page$Profile$update, subMsg, subModel),
									A3($author$project$Main$updateLoggedInUResult, $author$project$Main$Profile, $author$project$Main$GotProfileMsg, model)));
						} else {
							break _v7$29;
						}
					case 15:
						if (_v7.b.$ === 15) {
							var subMsg = _v7.a.a;
							var subModel = _v7.b.a;
							return withLoggedIn(
								A2(
									$elm$core$Basics$composeR,
									A2($author$project$Page$Profile$Editor$update, subMsg, subModel),
									A3($author$project$Main$updateLoggedInUResult, $author$project$Main$ProfileEditor, $author$project$Main$GotProfileEditorMsg, model)));
						} else {
							break _v7$29;
						}
					case 16:
						if (_v7.b.$ === 16) {
							var subMsg = _v7.a.a;
							var subModel = _v7.b.a;
							return withLoggedIn(
								A2(
									$elm$core$Basics$composeR,
									A2($author$project$Page$Profile$AddKyc$update, subMsg, subModel),
									A3($author$project$Main$updateLoggedInUResult, $author$project$Main$ProfileAddKyc, $author$project$Main$GotProfileAddKycMsg, model)));
						} else {
							break _v7$29;
						}
					case 17:
						if (_v7.b.$ === 17) {
							var subMsg = _v7.a.a;
							var subModel = _v7.b.a;
							return withLoggedIn(
								A2(
									$elm$core$Basics$composeR,
									A2($author$project$Page$Profile$Claims$update, subMsg, subModel),
									A3($author$project$Main$updateLoggedInUResult, $author$project$Main$ProfileClaims, $author$project$Main$GotProfileClaimsMsg, model)));
						} else {
							break _v7$29;
						}
					case 18:
						if (_v7.b.$ === 18) {
							var subMsg = _v7.a.a;
							var subModel = _v7.b.a;
							return withLoggedIn(
								A2(
									$elm$core$Basics$composeR,
									A2($author$project$Page$Profile$AddContact$update, subMsg, subModel),
									A3($author$project$Main$updateLoggedInUResult, $author$project$Main$ProfileAddContact, $author$project$Main$GotProfileAddContactMsg, model)));
						} else {
							break _v7$29;
						}
					case 21:
						if (_v7.b.$ === 21) {
							var subMsg = _v7.a.a;
							var _v14 = _v7.b;
							var maybeFilter = _v14.a;
							var subModel = _v14.b;
							return withLoggedIn(
								A2(
									$elm$core$Basics$composeR,
									A2($author$project$Page$Shop$update, subMsg, subModel),
									A3(
										$author$project$Main$updateLoggedInUResult,
										$author$project$Main$Shop(maybeFilter),
										$author$project$Main$GotShopMsg,
										model)));
						} else {
							break _v7$29;
						}
					case 22:
						if (_v7.b.$ === 22) {
							var subMsg = _v7.a.a;
							var _v15 = _v7.b;
							var id = _v15.a;
							var subModel = _v15.b;
							return withLoggedIn(
								A2(
									$elm$core$Basics$composeR,
									A2($author$project$Page$Shop$Editor$update, subMsg, subModel),
									A3(
										$author$project$Main$updateLoggedInUResult,
										$author$project$Main$ShopEditor(id),
										$author$project$Main$GotShopEditorMsg,
										model)));
						} else {
							break _v7$29;
						}
					case 23:
						if (_v7.b.$ === 23) {
							var subMsg = _v7.a.a;
							var _v16 = _v7.b;
							var saleId = _v16.a;
							var subModel = _v16.b;
							return withSession(
								A2(
									$elm$core$Basics$composeR,
									A2($author$project$Page$Shop$Viewer$update, subMsg, subModel),
									A3(
										$author$project$Main$updatePageUResult,
										$author$project$Main$ShopViewer(saleId),
										$author$project$Main$GotShopViewerMsg,
										model)));
						} else {
							break _v7$29;
						}
					case 9:
						if (_v7.b.$ === 9) {
							var subMsg = _v7.a.a;
							var _v17 = _v7.b;
							var objectiveId = _v17.a;
							var actionId = _v17.b;
							var subModel = _v17.c;
							return withLoggedIn(
								A2(
									$elm$core$Basics$composeR,
									A2($author$project$Page$Dashboard$Claim$update, subMsg, subModel),
									A3(
										$author$project$Main$updateLoggedInUResult,
										A2($author$project$Main$Claim, objectiveId, actionId),
										$author$project$Main$GotVerifyClaimMsg,
										model)));
						} else {
							break _v7$29;
						}
					case 24:
						if (_v7.b.$ === 24) {
							var subMsg = _v7.a.a;
							var _v18 = _v7.b;
							var transferId = _v18.a;
							var subModel = _v18.b;
							return withLoggedIn(
								A2(
									$elm$core$Basics$composeR,
									A2($author$project$Page$ViewTransfer$update, subMsg, subModel),
									A3(
										$author$project$Main$updateLoggedInUResult,
										$author$project$Main$ViewTransfer(transferId),
										$author$project$Main$GotViewTransferScreenMsg,
										model)));
						} else {
							break _v7$29;
						}
					case 25:
						if (_v7.b.$ === 25) {
							var subMsg = _v7.a.a;
							var subModel = _v7.b.a;
							return A4(
								$author$project$Main$updateLoggedInUResult,
								$author$project$Main$Invite,
								$author$project$Main$GotInviteMsg,
								model,
								A3($author$project$Page$Community$Invite$update, model.c, subMsg, subModel));
						} else {
							break _v7$29;
						}
					case 26:
						if (_v7.b.$ === 26) {
							var subMsg = _v7.a.a;
							var subModel = _v7.b.a;
							return A4(
								$author$project$Main$updateLoggedInUResult,
								$author$project$Main$Join,
								$author$project$Main$GotJoinMsg,
								model,
								A3($author$project$Page$Join$update, model.c, subMsg, subModel));
						} else {
							break _v7$29;
						}
					case 27:
						if (_v7.b.$ === 27) {
							var subMsg = _v7.a.a;
							var subModel = _v7.b.a;
							return withLoggedIn(
								A2(
									$elm$core$Basics$composeR,
									A2($author$project$Page$Community$Transfer$update, subMsg, subModel),
									A3($author$project$Main$updateLoggedInUResult, $author$project$Main$Transfer, $author$project$Main$GotTransferMsg, model)));
						} else {
							break _v7$29;
						}
					default:
						if (_v7.b.$ === 28) {
							var subMsg = _v7.a.a;
							var subModel = _v7.b.a;
							return withLoggedIn(
								A2(
									$elm$core$Basics$composeR,
									A2($author$project$Page$Dashboard$Analysis$update, subMsg, subModel),
									A3($author$project$Main$updateLoggedInUResult, $author$project$Main$Analysis, $author$project$Main$GotAnalysisMsg, model)));
						} else {
							break _v7$29;
						}
				}
			}
			return _Utils_Tuple2(
				model,
				A2(
					$author$project$Log$addBreadcrumb,
					$author$project$Main$msgToString,
					{fw: msg, i9: $elm$core$Dict$empty, nH: 3, nS: 'Msg does not correspond with Model', d0: 3}));
		}
	});
var $author$project$Main$updateExternal = F2(
	function (extMsg, model) {
		if (!extMsg.$) {
			switch (extMsg.a.$) {
				case 0:
					var _v1 = extMsg.a;
					var _v2 = model.bv;
					if (_v2.$ === 1) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var aMsg = _v2.a;
						return A2(
							$author$project$Main$update,
							aMsg.ik,
							_Utils_update(
								model,
								{bv: $elm$core$Maybe$Nothing}));
					}
				case 1:
					var _v3 = extMsg.a;
					var _v4 = model.bv;
					if (_v4.$ === 1) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var aMsg = _v4.a;
						return A2(
							$author$project$Main$update,
							aMsg.he,
							_Utils_update(
								model,
								{bv: $elm$core$Maybe$Nothing}));
					}
				case 2:
					var callback = extMsg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								bw: A2($elm$core$List$cons, callback, model.bw)
							}),
						$elm$core$Platform$Cmd$none);
				case 3:
					var callback = extMsg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								bw: A2(
									$elm$core$List$cons,
									function (token) {
										return A2(
											$elm$core$Platform$Cmd$map,
											A2($elm$core$Basics$composeR, $author$project$Page$GotLoggedInMsg, $author$project$Main$GotPageMsg),
											callback(token));
									},
									model.bw)
							}),
						$elm$core$Platform$Cmd$none);
				case 4:
					var authToken = extMsg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{bw: _List_Nil}),
						$elm$core$Platform$Cmd$batch(
							A2(
								$elm$core$List$map,
								function (callback) {
									return callback(authToken);
								},
								model.bw)));
				case 5:
					var callbackMsg = extMsg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								cU: A2(
									$elm$core$List$cons,
									$author$project$Main$GotPageMsg(
										$author$project$Page$GotLoggedInMsg(callbackMsg)),
									model.cU)
							}),
						$elm$core$Platform$Cmd$none);
				case 6:
					var _v5 = extMsg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{cU: _List_Nil}),
						$elm$core$Platform$Cmd$batch(
							A2($elm$core$List$map, $author$project$Utils$spawnMessage, model.cU)));
				case 7:
					var broadcastMsg = extMsg.a.a;
					var _v6 = model.c;
					if (_v6.$ === 1) {
						var loggedIn = _v6.a;
						return _Utils_Tuple2(
							model,
							A3($author$project$Main$broadcast, loggedIn, broadcastMsg, model.gE));
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				default:
					var subExternalMsg = extMsg.a.a;
					return _Utils_Tuple2(
						model,
						$author$project$Utils$spawnMessage(subExternalMsg));
			}
		} else {
			var broadcastMsg = extMsg.a;
			return _Utils_Tuple2(
				model,
				A2($author$project$Main$broadcastGuest, broadcastMsg, model.gE));
		}
	});
var $author$project$Session$Guest$AdminMoved = 3;
var $author$project$Session$LoggedIn$AdminMoved = {$: 3};
var $author$project$Session$LoggedIn$Analysis = {$: 26};
var $author$project$Session$LoggedIn$Claim = {$: 11};
var $author$project$Session$Guest$ComingSoon = 2;
var $author$project$Session$LoggedIn$ComingSoon = {$: 2};
var $author$project$Session$LoggedIn$CommunityAbout = {$: 7};
var $author$project$Session$LoggedIn$CommunityEditor = {$: 9};
var $author$project$Session$LoggedIn$CommunityObjectives = {$: 8};
var $author$project$Session$LoggedIn$CommunitySelector = {$: 10};
var $author$project$Session$LoggedIn$Dashboard = {$: 5};
var $elm$browser$Browser$Document = F2(
	function (title, body) {
		return {fv: body, fb: title};
	});
var $author$project$Session$Guest$Invite = 6;
var $author$project$Session$LoggedIn$Invite = {$: 4};
var $author$project$Session$Guest$Join = 7;
var $author$project$Session$LoggedIn$Join = {$: 27};
var $author$project$Session$Guest$Login = 5;
var $author$project$Session$LoggedIn$News = function (a) {
	return {$: 6, a: a};
};
var $author$project$Session$Guest$NotFound = 1;
var $author$project$Session$LoggedIn$NotFound = {$: 1};
var $author$project$Session$LoggedIn$Notification = {$: 12};
var $author$project$Session$LoggedIn$PaymentHistory = {$: 23};
var $author$project$Session$LoggedIn$Profile = {$: 17};
var $author$project$Session$LoggedIn$ProfileAddContact = {$: 22};
var $author$project$Session$LoggedIn$ProfileAddKyc = {$: 20};
var $author$project$Session$LoggedIn$ProfileClaims = {$: 21};
var $author$project$Session$LoggedIn$ProfileEditor = {$: 19};
var $author$project$Session$Guest$Redirect = 0;
var $author$project$Session$LoggedIn$Redirect = {$: 0};
var $author$project$Session$Guest$Register = 4;
var $author$project$Session$LoggedIn$Settings = {$: 13};
var $author$project$Session$LoggedIn$Shop = {$: 14};
var $author$project$Session$LoggedIn$ShopEditor = {$: 15};
var $author$project$Session$Guest$ShopViewer = 8;
var $author$project$Session$LoggedIn$ShopViewer = {$: 16};
var $author$project$Session$LoggedIn$Transfer = {$: 24};
var $author$project$Session$LoggedIn$ViewTransfer = {$: 25};
var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
var $elm$html$Html$map = $elm$virtual_dom$VirtualDom$map;
var $author$project$Page$AdminMoved$loginUrl = function (apiUrl) {
	return (A2($elm$core$String$endsWith, '/', apiUrl) ? A2($elm$core$String$dropRight, 1, apiUrl) : apiUrl) + '/app/login';
};
var $elm$html$Html$a = _VirtualDom_node('a');
var $elm$html$Html$h1 = _VirtualDom_node('h1');
var $elm$html$Html$Attributes$href = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'href',
		_VirtualDom_noJavaScriptUri(url));
};
var $author$project$Route$href = function (targetRoute) {
	return $elm$html$Html$Attributes$href(
		$author$project$Route$routeToString(targetRoute));
};
var $elm$html$Html$Attributes$id = $elm$html$Html$Attributes$stringProperty('id');
var $elm$html$Html$Attributes$target = $elm$html$Html$Attributes$stringProperty('target');
var $author$project$Page$AdminMoved$viewContent = F2(
	function (_v0, url) {
		var t = _v0.il;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container mx-auto px-4 py-16 md:py-24 flex flex-col items-center text-center')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-2xl leading-tight font-bold text-black')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							t('admin_moved.title'))
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mt-4 max-w-md text-gray-333')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							t('admin_moved.body'))
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mt-2 max-w-md text-gray-700')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							t('admin_moved.login_hint'))
						])),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id('admin-moved-login'),
							$elm$html$Html$Attributes$href(url),
							$elm$html$Html$Attributes$target('_self'),
							$elm$html$Html$Attributes$class('button button-primary w-full md:w-auto mt-8')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							t('admin_moved.go'))
						])),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$author$project$Route$href($author$project$Route$Dashboard),
							$elm$html$Html$Attributes$class('button button-secondary w-full md:w-auto mt-4')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							t('admin_moved.back'))
						]))
				]));
	});
var $author$project$Page$AdminMoved$view = function (session) {
	var shared = $author$project$Page$toShared(session);
	return {
		mk: A2(
			$author$project$Page$AdminMoved$viewContent,
			shared.iw,
			$author$project$Page$AdminMoved$loginUrl(shared.mJ.lW)),
		fb: shared.iw.il('admin_moved.title')
	};
};
var $author$project$Page$viewTitle = function (text_) {
	return A2(
		$elm$html$Html$p,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('text-lg font-bold my-3')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(text_)
			]));
};
var $author$project$Page$ComingSoon$view = function (session) {
	var shared = $author$project$Page$toShared(session);
	return {
		mk: A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Page$viewTitle(
					shared.iw.il('menu.coming_soon')),
					$elm$html$Html$text(
					shared.iw.il('menu.coming_soon'))
				])),
		fb: shared.iw.il('menu.coming_soon')
	};
};
var $fapian$elm_html_aria$Html$Attributes$Aria$boolAttribute = F2(
	function (name, val) {
		return A2(
			$elm$html$Html$Attributes$attribute,
			name,
			A2(
				$elm$json$Json$Encode$encode,
				0,
				$elm$json$Json$Encode$bool(val)));
	});
var $fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden = $fapian$elm_html_aria$Html$Attributes$Aria$boolAttribute('aria-hidden');
var $fapian$elm_html_aria$Html$Attributes$Aria$ariaLabel = $elm$html$Html$Attributes$attribute('aria-label');
var $elm$html$Html$Attributes$classList = function (classes) {
	return $elm$html$Html$Attributes$class(
		A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$first,
				A2($elm$core$List$filter, $elm$core$Tuple$second, classes))));
};
var $author$project$Page$fullPageGraphQLError = F2(
	function (title_, e) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mx-auto container p-16 flex flex-wrap')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('w-full')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-2xl font-bold text-center')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(title_)
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-center')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Api$Graphql$errorToString(e))
								]))
						])),
					A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('w-full'),
							$elm$html$Html$Attributes$src('/images/error.svg')
						]),
					_List_Nil)
				]));
	});
var $author$project$View$Components$loadingLogoWithCustomText = F3(
	function (_v0, customTextKey, class_) {
		var t = _v0.il;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('w-full text-center ' + class_)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('h-16 mx-auto mt-8'),
							$elm$html$Html$Attributes$src('/images/loading.svg')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('font-bold text-xl')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							t('loading.title'))
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-sm')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							t(customTextKey))
						]))
				]));
	});
var $author$project$View$Components$loadingLogoAnimated = F2(
	function (translators, class_) {
		return A3($author$project$View$Components$loadingLogoWithCustomText, translators, 'loading.subtitle', class_);
	});
var $author$project$Page$fullPageLoading = function (_v0) {
	var translators = _v0.iw;
	return A2($author$project$View$Components$loadingLogoAnimated, translators, '');
};
var $elm$html$Html$h2 = _VirtualDom_node('h2');
var $elm$html$Html$Attributes$media = _VirtualDom_attribute('media');
var $elm$virtual_dom$VirtualDom$node = function (tag) {
	return _VirtualDom_node(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$node = $elm$virtual_dom$VirtualDom$node;
var $author$project$Page$Community$About$showNewsCard = function (community) {
	return community.df;
};
var $elm$html$Html$source = _VirtualDom_node('source');
var $elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
var $elm$html$Html$Attributes$style = $elm$virtual_dom$VirtualDom$style;
var $author$project$Page$Community$About$ClickedShareCommunity = {$: 3};
var $author$project$Form$Text$TextareaInput = function (a) {
	return {$: 1, a: a};
};
var $elm$html$Html$button = _VirtualDom_node('button');
var $elm$virtual_dom$VirtualDom$mapAttribute = _VirtualDom_mapAttribute;
var $elm$html$Html$Attributes$map = $elm$virtual_dom$VirtualDom$mapAttribute;
var $author$project$Contact$typeToAriaLabel = F2(
	function (_v0, type_) {
		var t = _v0.il;
		switch (type_) {
			case 3:
				return t('contact_form.reach_out.phone');
			case 1:
				return t('contact_form.reach_out.instagram');
			case 4:
				return t('contact_form.reach_out.telegram');
			case 5:
				return t('contact_form.reach_out.whatsapp');
			case 0:
				return t('contact_form.reach_out.email');
			default:
				return t('contact_form.reach_out.link');
		}
	});
var $author$project$Icons$instagram = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('24'),
				$elm$svg$Svg$Attributes$height('24'),
				$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
				$elm$svg$Svg$Attributes$fill('#E1306C'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M12.0005 0.36364C8.84036 0.36364 8.44377 0.377458 7.20259 0.433943C5.96384 0.49067 5.11829 0.686791 4.37843 0.974549C3.61312 1.27176 2.96393 1.66934 2.31716 2.31637C1.66991 2.96316 1.27235 3.61237 0.974173 4.37746C0.685697 5.11758 0.48934 5.9634 0.433584 7.2017C0.37807 8.44291 0.363525 8.83976 0.363525 12C0.363525 15.1602 0.377586 15.5556 0.433827 16.7969C0.490794 18.0356 0.68691 18.8812 0.974416 19.6211C1.27186 20.3864 1.66943 21.0356 2.31644 21.6824C2.96296 22.3297 3.61215 22.7282 4.37698 23.0255C5.11732 23.3132 5.96311 23.5093 7.20162 23.5661C8.4428 23.6226 8.83915 23.6364 11.9991 23.6364C15.1594 23.6364 15.5548 23.6226 16.796 23.5661C18.0347 23.5093 18.8813 23.3132 19.6216 23.0255C20.3867 22.7282 21.0349 22.3297 21.6814 21.6824C22.3287 21.0356 22.7262 20.3864 23.0244 19.6213C23.3105 18.8812 23.5068 18.0354 23.565 16.7971C23.6208 15.5559 23.6353 15.1602 23.6353 12C23.6353 8.83976 23.6208 8.44316 23.565 7.20194C23.5068 5.96316 23.3105 5.11758 23.0244 4.3777C22.7262 3.61237 22.3287 2.96316 21.6814 2.31637C21.0342 1.66909 20.3869 1.27152 19.6209 0.974549C18.8791 0.686791 18.0331 0.49067 16.7943 0.433943C15.5531 0.377458 15.158 0.36364 11.9969 0.36364H12.0005ZM10.9567 2.46061C11.2665 2.46012 11.6122 2.46061 12.0005 2.46061C15.1073 2.46061 15.4756 2.47176 16.7024 2.52752C17.8369 2.5794 18.4527 2.76897 18.8628 2.92825C19.4059 3.13916 19.793 3.39128 20.2 3.79855C20.6073 4.20582 20.8594 4.5937 21.0708 5.13673C21.23 5.54643 21.4199 6.16219 21.4715 7.29673C21.5272 8.5234 21.5394 8.89188 21.5394 11.9973C21.5394 15.1028 21.5272 15.4713 21.4715 16.6979C21.4196 17.8325 21.23 18.4482 21.0708 18.8579C20.8599 19.401 20.6073 19.7876 20.2 20.1947C19.7928 20.6019 19.4061 20.8541 18.8628 21.065C18.4532 21.225 17.8369 21.4141 16.7024 21.4659C15.4758 21.5217 15.1073 21.5338 12.0005 21.5338C8.89345 21.5338 8.52522 21.5217 7.29859 21.4659C6.16408 21.4136 5.54834 21.224 5.13793 21.0647C4.59491 20.8538 4.20705 20.6017 3.79978 20.1944C3.39252 19.7872 3.14041 19.4002 2.92902 18.857C2.76976 18.4473 2.57994 17.8315 2.52831 16.697C2.47255 15.4703 2.4614 15.1018 2.4614 11.9944C2.4614 8.88703 2.47255 8.52049 2.52831 7.29382C2.58019 6.15928 2.76976 5.54352 2.92902 5.13334C3.13993 4.59031 3.39252 4.20243 3.79978 3.79516C4.20705 3.38788 4.59491 3.13576 5.13793 2.92437C5.5481 2.76437 6.16408 2.57528 7.29859 2.52316C8.37201 2.47467 8.788 2.46012 10.9567 2.4577V2.46061ZM18.2117 4.39273C17.4408 4.39273 16.8154 5.01746 16.8154 5.78861C16.8154 6.55952 17.4408 7.18497 18.2117 7.18497C18.9826 7.18497 19.608 6.55952 19.608 5.78861C19.608 5.0177 18.9826 4.39225 18.2117 4.39225V4.39273ZM12.0005 6.02425C8.70048 6.02425 6.02493 8.69988 6.02493 12C6.02493 15.3001 8.70048 17.9746 12.0005 17.9746C15.3005 17.9746 17.9751 15.3001 17.9751 12C17.9751 8.69988 15.3003 6.02425 12.0003 6.02425H12.0005ZM12.0005 8.12122C14.1425 8.12122 15.8792 9.8577 15.8792 12C15.8792 14.1421 14.1425 15.8788 12.0005 15.8788C9.85827 15.8788 8.12184 14.1421 8.12184 12C8.12184 9.8577 9.85827 8.12122 12.0005 8.12122Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Icons$link = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('32'),
				$elm$svg$Svg$Attributes$height('32'),
				$elm$svg$Svg$Attributes$viewBox('0 0 32 32'),
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M17.8712 5.87117C18.9662 4.77614 20.4514 4.16095 22 4.16095C23.5486 4.16095 25.0338 4.77614 26.1288 5.87117C27.2239 6.96621 27.839 8.45139 27.839 10C27.839 11.5486 27.2239 13.0338 26.1288 14.1288L20.7994 19.4583C20.261 20.0067 19.6188 20.4424 18.9103 20.7401C18.2 21.0386 17.4372 21.1923 16.6667 21.1923C15.8961 21.1923 15.1334 21.0386 14.423 20.7401C13.7127 20.4416 13.069 20.0044 12.5298 19.454C12.0949 19.0102 12.1022 18.2979 12.546 17.8631C12.9898 17.4283 13.7021 17.4355 14.1369 17.8793C14.4667 18.2159 14.8603 18.4833 15.2947 18.6658C15.729 18.8483 16.1955 18.9423 16.6667 18.9423C17.1378 18.9423 17.6043 18.8483 18.0387 18.6658C18.4731 18.4833 18.8667 18.2159 19.1964 17.8793L19.2045 17.8711L19.2045 17.8712L24.5378 12.5378C25.2109 11.8648 25.589 10.9519 25.589 10C25.589 9.04813 25.2109 8.13524 24.5378 7.46216C23.8648 6.78908 22.9519 6.41095 22 6.41095C21.0481 6.41095 20.1352 6.78908 19.4622 7.46216L18.7955 8.12883C18.3562 8.56817 17.6438 8.56817 17.2045 8.12883C16.7652 7.68949 16.7652 6.97718 17.2045 6.53784L17.8712 5.87117Z'),
						$elm$svg$Svg$Attributes$fill('#F99D33')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M13.0897 11.2599C13.8 10.9614 14.5628 10.8077 15.3333 10.8077C16.1039 10.8077 16.8666 10.9614 17.577 11.2599C18.2873 11.5584 18.931 11.9956 19.4702 12.546C19.9051 12.9898 19.8978 13.7021 19.454 14.1369C19.0102 14.5717 18.2979 14.5645 17.8631 14.1207C17.5333 13.7841 17.1397 13.5167 16.7053 13.3342C16.271 13.1517 15.8045 13.0577 15.3333 13.0577C14.8622 13.0577 14.3957 13.1517 13.9613 13.3342C13.5269 13.5167 13.1333 13.7841 12.8036 14.1207L12.7955 14.1289L12.7955 14.1288L7.46216 19.4622C6.78908 20.1352 6.41095 21.0481 6.41095 22C6.41095 22.9519 6.78908 23.8648 7.46216 24.5378C8.13524 25.2109 9.04813 25.589 10 25.589C10.9519 25.589 11.8648 25.2109 12.5378 24.5378L13.2045 23.8712C13.6438 23.4318 14.3562 23.4318 14.7955 23.8712C15.2348 24.3105 15.2348 25.0228 14.7955 25.4622L14.1288 26.1288C13.0338 27.2239 11.5486 27.839 10 27.839C8.45139 27.839 6.9662 27.2239 5.87117 26.1288C4.77614 25.0338 4.16095 23.5486 4.16095 22C4.16095 20.4514 4.77614 18.9662 5.87117 17.8712L11.2007 12.5417C11.7391 11.9933 12.3812 11.5576 13.0897 11.2599Z'),
						$elm$svg$Svg$Attributes$fill('#F99D33')
					]),
				_List_Nil)
			]));
};
var $elm$svg$Svg$Attributes$stroke = _VirtualDom_attribute('stroke');
var $elm$svg$Svg$Attributes$strokeLinecap = _VirtualDom_attribute('stroke-linecap');
var $elm$svg$Svg$Attributes$strokeLinejoin = _VirtualDom_attribute('stroke-linejoin');
var $elm$svg$Svg$Attributes$strokeOpacity = _VirtualDom_attribute('stroke-opacity');
var $elm$svg$Svg$Attributes$strokeWidth = _VirtualDom_attribute('stroke-width');
var $author$project$Icons$mail = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$class(class_),
				$elm$svg$Svg$Attributes$width('24'),
				$elm$svg$Svg$Attributes$height('20'),
				$elm$svg$Svg$Attributes$viewBox('0 0 24 20'),
				$elm$svg$Svg$Attributes$fill('none')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M6 5H18C18.825 5 19.5 5.5625 19.5 6.25V13.75C19.5 14.4375 18.825 15 18 15H6C5.175 15 4.5 14.4375 4.5 13.75V6.25C4.5 5.5625 5.175 5 6 5Z'),
						$elm$svg$Svg$Attributes$stroke('#F99D33'),
						$elm$svg$Svg$Attributes$strokeOpacity('0.8'),
						$elm$svg$Svg$Attributes$strokeWidth('2'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M19.5 6.25L12 10.625L4.5 6.25'),
						$elm$svg$Svg$Attributes$stroke('#F99D33'),
						$elm$svg$Svg$Attributes$strokeOpacity('0.8'),
						$elm$svg$Svg$Attributes$strokeWidth('2'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_Nil)
			]));
};
var $author$project$Icons$phoneInverted = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$class(class_),
				$elm$svg$Svg$Attributes$width('24'),
				$elm$svg$Svg$Attributes$height('24'),
				$elm$svg$Svg$Attributes$viewBox('0 0 24 24')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M18.4342 14.729L16.6993 12.9878C16.351 12.6268 15.93 12.4337 15.4804 12.4337C15.034 12.4337 14.6098 12.6237 14.252 12.9814L13.3593 13.871C13.3498 13.8647 13.3403 13.8615 13.3276 13.8552C13.2991 13.8425 13.2738 13.8267 13.2453 13.8109C13.1345 13.7571 13.0332 13.7032 12.9509 13.6526C12.0328 13.0701 11.197 12.3071 10.396 11.3257C10.0509 10.8888 9.8103 10.5247 9.62984 10.1543C9.82613 9.96749 10.0129 9.78071 10.1934 9.59708L10.2599 9.5306C10.3042 9.48628 10.3485 9.43879 10.3928 9.39447C10.4371 9.35015 10.4815 9.30582 10.5258 9.2615C10.8899 8.89742 11.0862 8.46686 11.0862 8.02047C11.0862 7.57408 10.893 7.14669 10.5258 6.77944L9.6615 5.91515C9.56336 5.81701 9.46522 5.71887 9.37024 5.61756C9.18345 5.42444 8.98084 5.21866 8.76872 5.02237C8.42364 4.68046 8.00574 4.5 7.56568 4.5C7.12562 4.5 6.70139 4.68046 6.34365 5.02554L5.26091 6.11777C4.82085 6.55783 4.57075 7.09603 4.51376 7.71971C4.43461 8.68214 4.71321 9.57176 4.93166 10.1574C5.45403 11.5694 6.23601 12.8706 7.38839 14.2573C8.79405 15.9384 10.4878 17.2617 12.419 18.1956C13.1693 18.5502 14.1697 18.9681 15.2841 19.0378C15.3569 19.0409 15.4266 19.0441 15.4931 19.0441C16.2846 19.0441 16.9494 18.7592 17.4718 18.1925L17.4939 18.1672V18.164C17.4939 18.1608 17.4971 18.1608 17.4971 18.1577C17.6396 17.9835 17.8073 17.8221 17.9846 17.6511L18.0258 17.61C18.1904 17.4517 18.3234 17.3187 18.4437 17.1952C18.7951 16.8311 18.9787 16.4038 18.9787 15.9574C18.9819 15.511 18.7919 15.0836 18.4342 14.729ZM9.36391 8.63782L9.36074 8.64099C9.07898 8.92908 8.83837 9.16652 8.5756 9.40713C8.56927 9.41346 8.55661 9.42296 8.54394 9.43879C8.17037 9.82186 8.297 10.2239 8.34133 10.3569L8.35399 10.3917L8.35716 10.3981C8.58827 10.9553 8.91119 11.484 9.40823 12.114L9.41773 12.1266C10.3073 13.2189 11.2413 14.0705 12.2734 14.7227C12.4127 14.8113 12.5488 14.8778 12.6818 14.9443C12.7926 14.9981 12.8939 15.0519 12.9794 15.1026L12.9984 15.1121C13.011 15.1184 13.0237 15.1279 13.0332 15.1342C13.1693 15.2007 13.3023 15.2355 13.4384 15.2355C13.7867 15.2355 13.9956 15.0266 14.0653 14.9569L15.148 13.8742C15.2303 13.7919 15.3506 13.6969 15.4804 13.6969C15.6134 13.6969 15.7274 13.7982 15.7843 13.8615L17.5414 15.6186C17.7662 15.8402 17.782 16.0333 17.5952 16.2581C17.5952 16.2581 16.7404 17.1066 16.5378 17.344C16.2592 17.6416 15.93 17.7777 15.4994 17.7777C15.4551 17.7777 15.4076 17.7777 15.3664 17.7746C14.461 17.7176 13.6125 17.3599 12.973 17.0528C11.2065 16.198 9.65517 14.9823 8.36982 13.4468C7.30924 12.1678 6.59375 10.9806 6.1252 9.71106C5.84344 8.95441 5.73896 8.37189 5.78328 7.81785C5.81178 7.4981 5.93525 7.23216 6.16003 7.00422L7.23643 5.92782C7.35357 5.81701 7.47071 5.76002 7.57518 5.76002C7.70498 5.76002 7.81895 5.84867 7.89177 5.92149L7.90443 5.93415C8.08489 6.10194 8.25901 6.27923 8.46796 6.49451C8.51545 6.54517 8.5661 6.59582 8.61359 6.64331L8.61992 6.64964C8.67058 6.70029 8.71807 6.75095 8.77189 6.80477L9.63618 7.66906C9.89261 7.92549 9.89261 8.10595 9.63618 8.35922C9.60452 8.39088 9.57286 8.42254 9.54436 8.45103C9.48105 8.52068 9.42406 8.57767 9.36391 8.63782Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Icons$telegramInverted = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$class(class_),
				$elm$svg$Svg$Attributes$width('24'),
				$elm$svg$Svg$Attributes$height('24'),
				$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
				$elm$svg$Svg$Attributes$fill('none')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M3.32359 11.7622L7.90888 14.0601C8.08622 14.1481 8.29561 14.1418 8.46514 14.042L12.5465 11.6561L10.0761 13.8574C9.95034 13.9698 9.87846 14.13 9.87846 14.2989V19.6607C9.87846 20.2263 10.5965 20.4644 10.9332 20.015L12.9153 17.3651L17.817 20.1721C18.1607 20.3709 18.6014 20.1713 18.6811 19.7762L21.7382 4.45683C21.8296 3.99647 21.3741 3.62095 20.9507 3.79221L3.37203 10.6859C2.90014 10.8713 2.86967 11.5352 3.32359 11.7622ZM20.3788 5.28172L17.692 18.7447L13.0473 16.0846C12.7942 15.9393 12.4684 16.0037 12.2887 16.2425L11.0504 17.8978V14.5637L17.731 8.61191C18.26 8.14133 17.6521 7.30466 17.0482 7.66132L8.14951 12.8636L5.03067 11.301L20.3788 5.28172Z'),
						$elm$svg$Svg$Attributes$fill('#0088CC')
					]),
				_List_Nil)
			]));
};
var $author$project$Icons$whatsappInverted = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$class(class_),
				$elm$svg$Svg$Attributes$width('24'),
				$elm$svg$Svg$Attributes$height('24'),
				$elm$svg$Svg$Attributes$viewBox('0 0 24 24')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M2.18182 21.8182L3.56867 16.7748C2.71144 15.2958 2.26119 13.6181 2.26332 11.9107C2.26332 6.54637 6.65123 2.18182 12.0404 2.18182C13.3251 2.182 14.5971 2.43408 15.7839 2.92364C16.9706 3.41321 18.0488 4.13067 18.9568 5.03504C19.8649 5.93941 20.5849 7.01296 21.0759 8.19436C21.5669 9.37575 21.8191 10.6418 21.8182 11.9203C21.8182 17.2846 17.4296 21.6498 12.0411 21.6498H12.037C10.4046 21.6498 8.7983 21.2425 7.36486 20.4653L2.18182 21.8182ZM7.60456 18.7036L7.90179 18.8787C9.15391 19.6167 10.5824 20.0061 12.0377 20.006H12.0411C16.5201 20.006 20.1656 16.3782 20.1677 11.9189C20.1677 10.6659 19.8752 9.43006 19.3132 8.30882C18.7512 7.18758 17.935 6.21163 16.9292 5.45797C15.9233 4.70431 14.7552 4.19355 13.517 3.96598C12.2789 3.73841 11.0045 3.80026 9.79449 4.14665C8.58445 4.49304 7.47185 5.1145 6.54446 5.96199C5.61706 6.80948 4.90023 7.85983 4.45053 9.03017C4.00083 10.2005 3.83055 11.4588 3.95313 12.7059C4.0757 13.9529 4.48779 15.1545 5.15686 16.216L5.34999 16.522L4.52816 19.5064L7.60456 18.7036Z')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M16.9666 14.2334C16.9057 14.1318 16.7427 14.0712 16.4982 13.9492C16.2537 13.8272 15.0531 13.2397 14.8292 13.1593C14.6052 13.0789 14.4422 13.0373 14.2813 13.2813C14.1203 13.5253 13.6505 14.0726 13.5081 14.2354C13.3656 14.3983 13.2232 14.4181 12.9787 14.2961C12.7342 14.1741 11.9473 13.9178 11.0145 13.0891C10.2878 12.4444 9.79748 11.6483 9.65572 11.405C9.51395 11.1617 9.64065 11.0302 9.76255 10.9089C9.87282 10.7998 10.007 10.6247 10.129 10.4829C10.2297 10.3589 10.312 10.2212 10.3735 10.074C10.4058 10.0069 10.4209 9.93279 10.4173 9.85843C10.4137 9.78406 10.3916 9.71176 10.3529 9.64803C10.292 9.52604 9.80501 8.32994 9.59956 7.84333C9.40163 7.36626 9.1996 7.43441 9.05167 7.42555C8.90374 7.41669 8.74622 7.41737 8.58322 7.41737C8.45947 7.42062 8.33772 7.44929 8.22564 7.5016C8.11356 7.55391 8.01356 7.62872 7.93192 7.72134C7.70797 7.96464 7.07721 8.55281 7.07721 9.74958C7.07721 10.9464 7.95246 12.1022 8.07505 12.2644C8.19764 12.4266 9.79748 14.8822 12.2486 15.9352C12.7035 16.1304 13.1685 16.3015 13.6416 16.4477C14.1399 16.5983 14.6665 16.6312 15.1798 16.5438C15.6496 16.4756 16.6256 15.9556 16.829 15.3852C17.0324 14.8147 17.0276 14.3349 16.9666 14.2334Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Contact$typeToIconInverted = F2(
	function (class_, type_) {
		switch (type_) {
			case 3:
				return $author$project$Icons$phoneInverted(class_);
			case 1:
				return $author$project$Icons$instagram(class_);
			case 4:
				return $author$project$Icons$telegramInverted(class_);
			case 5:
				return $author$project$Icons$whatsappInverted(class_);
			case 0:
				return $author$project$Icons$mail(class_);
			default:
				return $author$project$Icons$link(class_);
		}
	});
var $author$project$Contact$circularIconWithGrayBgInternal = F3(
	function (attrs, translators, type_) {
		var defaultClass = function () {
			switch (type_) {
				case 5:
					return 'fill-current text-green ';
				case 3:
					return 'fill-current text-orange-500';
				default:
					return '';
			}
		}();
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$map,
				$elm$html$Html$Attributes$map($elm$core$Basics$never),
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$class('p-2 flex-shrink-0 bg-gray-100 rounded-full flex items-center justify-center'),
					A2(
						$elm$core$List$cons,
						$fapian$elm_html_aria$Html$Attributes$Aria$ariaLabel(
							A2($author$project$Contact$typeToAriaLabel, translators, type_)),
						attrs))),
			_List_fromArray(
				[
					A2($author$project$Contact$typeToIconInverted, defaultClass, type_)
				]));
	});
var $author$project$Contact$circularIconWithGrayBg = F3(
	function (attrs, translators, _v0) {
		var valid = _v0;
		return A3($author$project$Contact$circularIconWithGrayBgInternal, attrs, translators, valid.d0);
	});
var $elm$html$Html$li = _VirtualDom_node('li');
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 0, a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $elm$html$Html$Events$on = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $elm$html$Html$Events$onClick = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$svg$Svg$g = $elm$svg$Svg$trustedNode('g');
var $author$project$Icons$share = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('20'),
				$elm$svg$Svg$Attributes$height('20'),
				$elm$svg$Svg$Attributes$viewBox('0 0 20 20'),
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$g,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$d('M5.42829 12.2863C6.69066 12.2863 7.71401 11.2629 7.71401 10.0006C7.71401 8.73819 6.69066 7.71484 5.42829 7.71484C4.16593 7.71484 3.14258 8.73819 3.14258 10.0006C3.14258 11.2629 4.16593 12.2863 5.42829 12.2863Z'),
								$elm$svg$Svg$Attributes$stroke('#F99D33'),
								$elm$svg$Svg$Attributes$strokeWidth('1.5'),
								$elm$svg$Svg$Attributes$strokeLinecap('round'),
								$elm$svg$Svg$Attributes$strokeLinejoin('round')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$d('M14.5714 7.71401C15.8337 7.71401 16.8571 6.69066 16.8571 5.42829C16.8571 4.16593 15.8337 3.14258 14.5714 3.14258C13.309 3.14258 12.2856 4.16593 12.2856 5.42829C12.2856 6.69066 13.309 7.71401 14.5714 7.71401Z'),
								$elm$svg$Svg$Attributes$stroke('#F99D33'),
								$elm$svg$Svg$Attributes$strokeWidth('1.5'),
								$elm$svg$Svg$Attributes$strokeLinecap('round'),
								$elm$svg$Svg$Attributes$strokeLinejoin('round')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$d('M14.5714 16.8576C15.8337 16.8576 16.8571 15.8342 16.8571 14.5718C16.8571 13.3095 15.8337 12.2861 14.5714 12.2861C13.309 12.2861 12.2856 13.3095 12.2856 14.5718C12.2856 15.8342 13.309 16.8576 14.5714 16.8576Z'),
								$elm$svg$Svg$Attributes$stroke('#F99D33'),
								$elm$svg$Svg$Attributes$strokeWidth('1.5'),
								$elm$svg$Svg$Attributes$strokeLinecap('round'),
								$elm$svg$Svg$Attributes$strokeLinejoin('round')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$d('M7.48535 9.0104L12.5139 6.41992'),
								$elm$svg$Svg$Attributes$stroke('#F99D33'),
								$elm$svg$Svg$Attributes$strokeWidth('1.5'),
								$elm$svg$Svg$Attributes$strokeLinecap('round'),
								$elm$svg$Svg$Attributes$strokeLinejoin('round')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$d('M7.48535 10.9902L12.5139 13.5807'),
								$elm$svg$Svg$Attributes$stroke('#F99D33'),
								$elm$svg$Svg$Attributes$strokeWidth('1.5'),
								$elm$svg$Svg$Attributes$strokeLinecap('round'),
								$elm$svg$Svg$Attributes$strokeLinejoin('round')
							]),
						_List_Nil)
					]))
			]));
};
var $elm$html$Html$Attributes$tabindex = function (n) {
	return A2(
		_VirtualDom_attribute,
		'tabIndex',
		$elm$core$String$fromInt(n));
};
var $elm$html$Html$Attributes$title = $elm$html$Html$Attributes$stringProperty('title');
var $author$project$Contact$toHref = function (_v0) {
	var valid = _v0;
	var _v1 = valid.d0;
	switch (_v1) {
		case 0:
			return 'mailto:' + valid.pO;
		case 1:
			return valid.pO;
		case 2:
			return valid.pO;
		case 3:
			return 'tel:' + valid.pO;
		case 4:
			return valid.pO;
		default:
			return 'https://api.whatsapp.com/send?phone=' + A2($elm$core$String$filter, $elm$core$Char$isAlphaNum, valid.pO);
	}
};
var $author$project$Contact$typeToString = F2(
	function (translators, type_) {
		return translators.il(
			function (asString) {
				return 'contact_form.types.' + asString;
			}(
				$elm$core$String$toLower(
					$author$project$Cambiatus$Enum$ContactType$toString(type_))));
	});
var $author$project$Contact$toLabel = F2(
	function (translators, _v0) {
		var valid = _v0;
		return A2(
			$elm$core$Maybe$withDefault,
			A2($author$project$Contact$typeToString, translators, valid.d0),
			valid.nC);
	});
var $elm$html$Html$ul = _VirtualDom_node('ul');
var $elm$html$Html$Attributes$for = $elm$html$Html$Attributes$stringProperty('htmlFor');
var $elm$html$Html$label = _VirtualDom_node('label');
var $author$project$View$Components$label = F2(
	function (attrs, _v0) {
		var targetId = _v0.pv;
		var labelText = _v0.nD;
		return A2(
			$elm$html$Html$label,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('label'),
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$for(targetId),
					attrs)),
			_List_fromArray(
				[
					$elm$html$Html$text(labelText)
				]));
	});
var $author$project$Translation$decimalSeparators = function (translators) {
	return {
		jb: translators.il('decimal_separator'),
		px: translators.il('thousands_separator')
	};
};
var $henriquecbuss$elm_mask$Mask$floatString = F3(
	function (decimalDigits, separators, value) {
		var needsZeroDigits = function () {
			_v1$2:
			while (true) {
				if (!decimalDigits.$) {
					if (!decimalDigits.a) {
						return true;
					} else {
						break _v1$2;
					}
				} else {
					if (!decimalDigits.a) {
						return true;
					} else {
						break _v1$2;
					}
				}
			}
			return false;
		}();
		var valueWithTrailingZero = (A2($elm$core$String$endsWith, '.', value) && (!needsZeroDigits)) ? (value + '0') : value;
		return $elm$core$String$isEmpty(value) ? $elm$core$Maybe$Just(
			A3($henriquecbuss$elm_mask$Mask$float, decimalDigits, separators, 0)) : A2(
			$elm$core$Maybe$map,
			function (floatValue) {
				var formattedFloat = A3($henriquecbuss$elm_mask$Mask$float, decimalDigits, separators, floatValue);
				if (!decimalDigits.$) {
					return formattedFloat;
				} else {
					var n = decimalDigits.a;
					return ((n > 0) && A2($elm$core$String$endsWith, '.', value)) ? _Utils_ap(formattedFloat, separators.jb) : formattedFloat;
				}
			},
			$elm$core$String$toFloat(valueWithTrailingZero));
	});
var $elm$html$Html$input = _VirtualDom_node('input');
var $elm$html$Html$Events$onBlur = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'blur',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$Events$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var $elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
	return {$: 1, a: a};
};
var $elm$html$Html$Events$stopPropagationOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
	});
var $elm$html$Html$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $elm$html$Html$Events$onInput = function (tagger) {
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'input',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysStop,
			A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetValue)));
};
var $elm$html$Html$Attributes$placeholder = $elm$html$Html$Attributes$stringProperty('placeholder');
var $elm$html$Html$textarea = _VirtualDom_node('textarea');
var $author$project$Form$Text$typeToString = function (type_) {
	switch (type_) {
		case 0:
			return 'text';
		case 1:
			return 'tel';
		case 2:
			return 'number';
		case 3:
			return 'url';
		default:
			return 'password';
	}
};
var $elm$html$Html$Attributes$type_ = $elm$html$Html$Attributes$stringProperty('type');
var $henriquecbuss$elm_mask$Mask$removeFloat = F2(
	function (_v0, value) {
		var decimalSeparator = _v0.jb;
		var thousandsSeparator = _v0.px;
		return A3(
			$elm$core$String$replace,
			decimalSeparator,
			'.',
			A3($elm$core$String$replace, thousandsSeparator, '', value));
	});
var $henriquecbuss$elm_mask$Mask$updateFloatString = F3(
	function (decimalDigits, separators, _v0) {
		var decimalSeparator = separators.jb;
		var previousValue = _v0.oK;
		var newValue = _v0.n0;
		var removeZeroes = function (value) {
			var _v6 = $elm$core$String$toFloat(previousValue);
			if (_v6.$ === 1) {
				return value;
			} else {
				var floatValue = _v6.a;
				if (!floatValue) {
					var _v7 = $elm$core$String$toFloat(value);
					if (_v7.$ === 1) {
						return A3($elm$core$String$replace, '0', '', value);
					} else {
						var currentFloatValue = _v7.a;
						return (currentFloatValue >= 1) ? A3($elm$core$String$replace, '0', '', value) : value;
					}
				} else {
					return value;
				}
			}
		};
		var decimalDigitsAmount = function () {
			if (!decimalDigits.$) {
				var x = decimalDigits.a;
				return x;
			} else {
				var x = decimalDigits.a;
				return x;
			}
		}();
		var handleDeletingSeparator = function (value) {
			if (A2($elm$core$String$contains, '.', previousValue) && (!A2($elm$core$String$contains, '.', newValue))) {
				var _v3 = A2($elm$core$String$split, decimalSeparator, value);
				if ((_v3.b && _v3.b.b) && (!_v3.b.b.b)) {
					var beforeSeparator = _v3.a;
					var _v4 = _v3.b;
					var afterSeparator = _v4.a;
					return A2(
						$elm$core$String$endsWith,
						A2($elm$core$String$repeat, decimalDigitsAmount, '0'),
						beforeSeparator) ? _Utils_ap(
						A2($elm$core$String$dropRight, decimalDigitsAmount, beforeSeparator),
						_Utils_ap(decimalSeparator, afterSeparator)) : _Utils_ap(
						beforeSeparator,
						_Utils_ap(decimalSeparator, afterSeparator));
				} else {
					return value;
				}
			} else {
				return value;
			}
		};
		var multiplyBy10 = function (value) {
			var _v1 = A2($elm$core$String$split, '.', value);
			_v1$2:
			while (true) {
				if (_v1.b) {
					if (!_v1.b.b) {
						var beforeSeparator = _v1.a;
						return ($elm$core$String$length(beforeSeparator) === 1) ? ('0.' + (A2($elm$core$String$repeat, decimalDigitsAmount - 1, '0') + beforeSeparator)) : beforeSeparator;
					} else {
						if (!_v1.b.b.b) {
							var beforeSeparator = _v1.a;
							var _v2 = _v1.b;
							var afterSeparator = _v2.a;
							return (_Utils_cmp(
								$elm$core$String$length(afterSeparator),
								decimalDigitsAmount) > 0) ? A2(
								$elm$core$String$join,
								'.',
								_List_fromArray(
									[
										_Utils_ap(
										beforeSeparator,
										A2($elm$core$String$left, 1, afterSeparator)),
										A2($elm$core$String$dropLeft, 1, afterSeparator)
									])) : ((_Utils_cmp(
								$elm$core$String$length(afterSeparator),
								decimalDigitsAmount) < 0) ? A2(
								$elm$core$String$join,
								'.',
								_List_fromArray(
									[
										A2($elm$core$String$dropRight, 1, beforeSeparator),
										_Utils_ap(
										A2($elm$core$String$right, 1, beforeSeparator),
										afterSeparator)
									])) : value);
						} else {
							break _v1$2;
						}
					}
				} else {
					break _v1$2;
				}
			}
			return value;
		};
		return A2(
			$elm$core$Maybe$withDefault,
			previousValue,
			A2(
				$elm$core$Maybe$map,
				handleDeletingSeparator,
				A3(
					$henriquecbuss$elm_mask$Mask$floatString,
					decimalDigits,
					separators,
					removeZeroes(
						multiplyBy10(
							A2($henriquecbuss$elm_mask$Mask$removeFloat, separators, newValue))))));
	});
var $elm$html$Html$Attributes$value = $elm$html$Html$Attributes$stringProperty('value');
var $author$project$Form$Text$viewInput = F2(
	function (_v0, viewConfig) {
		var options = _v0;
		var onChange = viewConfig.oe;
		var value = viewConfig.pO;
		var hasError = viewConfig.m$;
		var onBlur = viewConfig.od;
		var translators = viewConfig.iw;
		var isRequired = viewConfig.nx;
		var _v1 = function () {
			var _v2 = options.fZ;
			if (!_v2.$) {
				return _Utils_Tuple2(
					$elm$html$Html$input,
					$elm$html$Html$Attributes$type_(
						$author$project$Form$Text$typeToString(options.d0)));
			} else {
				return _Utils_Tuple2(
					$elm$html$Html$textarea,
					$elm$html$Html$Attributes$class(''));
			}
		}();
		var inputElement = _v1.a;
		var typeAttr = _v1.b;
		var _v3 = function () {
			var _v4 = options.ga;
			if ((!_v4.$) && (!_v4.a.$)) {
				var decimalDigits = _v4.a.a;
				var separators = $author$project$Translation$decimalSeparators(translators);
				var decimalDigitsAmount = function () {
					if (!decimalDigits.$) {
						var x = decimalDigits.a;
						return x;
					} else {
						var x = decimalDigits.a;
						return x;
					}
				}();
				var previousDecimalSeparator = (!decimalDigitsAmount) ? separators.jb : A2(
					$elm$core$String$right,
					1,
					A2($elm$core$String$dropRight, decimalDigitsAmount, value));
				var valueWithoutSeparator = A2(
					$elm$core$Basics$composeR,
					$elm$core$String$filter(
						function (_char) {
							return $elm$core$Char$isDigit(_char) || (_Utils_eq(
								$elm$core$String$fromChar(_char),
								previousDecimalSeparator) || (_char === '-'));
						}),
					A2($elm$core$String$replace, previousDecimalSeparator, '.'));
				return _Utils_Tuple3(
					function (v) {
						return A2(
							$elm$core$Maybe$withDefault,
							valueWithoutSeparator(v),
							A3(
								$henriquecbuss$elm_mask$Mask$floatString,
								decimalDigits,
								separators,
								valueWithoutSeparator(v)));
					},
					function (v) {
						return A3(
							$henriquecbuss$elm_mask$Mask$updateFloatString,
							decimalDigits,
							separators,
							{n0: v, oK: value});
					},
					A3(
						$elm$html$Html$node,
						'masked-input-helper',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'target-id', options.R),
								A2($elm$html$Html$Attributes$attribute, 'mask-type', 'number'),
								A2($elm$html$Html$Attributes$attribute, 'decimal-separator', separators.jb)
							]),
						_List_Nil));
			} else {
				return _Utils_Tuple3(
					options.gX,
					options.bz,
					$elm$html$Html$text(''));
			}
		}();
		var beforeRenderingValue = _v3.a;
		var beforeChangeEvent = _v3.b;
		var maskHelper = _v3.c;
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('relative'),
				options.fY),
			A2(
				$elm$core$List$cons,
				A2(
					inputElement,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$id(options.R),
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Events$onInput(
								A2($elm$core$Basics$composeR, beforeChangeEvent, onChange)),
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Events$onBlur(onBlur),
								A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$class('w-full input peer'),
									A2(
										$elm$core$List$cons,
										$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('with-error', hasError)
												])),
										A2(
											$elm$core$List$cons,
											$elm$html$Html$Attributes$disabled(options.cf),
											A2(
												$elm$core$List$cons,
												$elm$html$Html$Attributes$value(
													beforeRenderingValue(value)),
												A2(
													$elm$core$List$cons,
													$elm$html$Html$Attributes$placeholder(
														A2($elm$core$Maybe$withDefault, '', options.oG)),
													A2(
														$elm$core$List$cons,
														typeAttr,
														A2(
															$elm$core$List$cons,
															$elm$html$Html$Attributes$required(isRequired),
															options.fO)))))))))),
					_List_Nil),
				A2(
					$elm$core$List$cons,
					maskHelper,
					A2(
						$elm$core$List$map,
						function (element) {
							return element(viewConfig);
						},
						options.dd))));
	});
var $author$project$Form$Text$view = F2(
	function (_v0, viewConfig) {
		var options = _v0;
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('relative mb-10'),
				options.mg),
			_List_fromArray(
				[
					$elm$core$String$isEmpty(options.nC) ? $elm$html$Html$text('') : A2(
					$author$project$View$Components$label,
					options.f4,
					{nD: options.nC, pv: options.R}),
					A2($author$project$Form$Text$viewInput, options, viewConfig),
					((!viewConfig.m$) && $elm_community$maybe_extra$Maybe$Extra$isNothing(options.bA)) ? $elm$html$Html$text('') : A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex w-full px-1')
						]),
					_List_fromArray(
						[
							viewConfig.mM,
							function () {
							var _v1 = options.bA;
							if (_v1.$ === 1) {
								return $elm$html$Html$text('');
							} else {
								var counter = _v1.a;
								var _v2 = function () {
									if (!counter.$) {
										var maxLetters = counter.a;
										return _Utils_Tuple2(
											$elm$core$String$length(viewConfig.pO),
											maxLetters);
									} else {
										var maxWords = counter.a;
										return _Utils_Tuple2(
											$elm$core$List$length(
												A2(
													$elm$core$List$filter,
													A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
													$elm$core$String$words(viewConfig.pO))),
											maxWords);
									}
								}();
								var currentLength = _v2.a;
								var max = _v2.b;
								return A2(
									$elm$html$Html$p,
									A2(
										$elm$core$List$cons,
										$elm$html$Html$Attributes$class('text-purple-100 mt-2 ml-auto uppercase font-bold text-sm flex-shrink-0'),
										options.fF),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												viewConfig.iw.iu,
												'edit.input_counter',
												_List_fromArray(
													[
														_Utils_Tuple2(
														'current',
														$elm$core$String$fromInt(currentLength)),
														_Utils_Tuple2(
														'max',
														$elm$core$String$fromInt(max))
													])))
										]));
							}
						}()
						]))
				]));
	});
var $elm$html$Html$Attributes$align = $elm$html$Html$Attributes$stringProperty('align');
var $elm$html$Html$blockquote = _VirtualDom_node('blockquote');
var $elm$html$Html$br = _VirtualDom_node('br');
var $elm$html$Html$Attributes$checked = $elm$html$Html$Attributes$boolProperty('checked');
var $elm$html$Html$code = _VirtualDom_node('code');
var $elm$html$Html$del = _VirtualDom_node('del');
var $elm$html$Html$em = _VirtualDom_node('em');
var $elm$html$Html$h3 = _VirtualDom_node('h3');
var $elm$html$Html$h4 = _VirtualDom_node('h4');
var $elm$html$Html$h5 = _VirtualDom_node('h5');
var $elm$html$Html$h6 = _VirtualDom_node('h6');
var $elm$html$Html$hr = _VirtualDom_node('hr');
var $elm$html$Html$ol = _VirtualDom_node('ol');
var $dillonkearns$elm_markdown$Markdown$HtmlRenderer$HtmlRenderer = $elm$core$Basics$identity;
var $dillonkearns$elm_markdown$Markdown$Html$resultOr = F2(
	function (ra, rb) {
		if (ra.$ === 1) {
			var singleError = ra.a;
			if (!rb.$) {
				var okValue = rb.a;
				return $elm$core$Result$Ok(okValue);
			} else {
				var errorsSoFar = rb.a;
				return $elm$core$Result$Err(
					A2($elm$core$List$cons, singleError, errorsSoFar));
			}
		} else {
			var okValue = ra.a;
			return $elm$core$Result$Ok(okValue);
		}
	});
var $dillonkearns$elm_markdown$Markdown$Html$attributesToString = function (attributes) {
	return A2(
		$elm$core$String$join,
		' ',
		A2(
			$elm$core$List$map,
			function (_v0) {
				var name = _v0.ki;
				var value = _v0.pO;
				return name + ('=\"' + (value + '\"'));
			},
			attributes));
};
var $dillonkearns$elm_markdown$Markdown$Html$tagToString = F2(
	function (tagName, attributes) {
		return $elm$core$List$isEmpty(attributes) ? ('<' + (tagName + '>')) : ('<' + (tagName + (' ' + ($dillonkearns$elm_markdown$Markdown$Html$attributesToString(attributes) + '>'))));
	});
var $dillonkearns$elm_markdown$Markdown$Html$oneOf = function (decoders) {
	var unwrappedDecoders = A2(
		$elm$core$List$map,
		function (_v1) {
			var rawDecoder = _v1;
			return rawDecoder;
		},
		decoders);
	return function (rawDecoder) {
		return F3(
			function (tagName, attributes, innerBlocks) {
				return A2(
					$elm$core$Result$mapError,
					function (errors) {
						if (!errors.b) {
							return 'Ran into a oneOf with no possibilities!';
						} else {
							if (!errors.b.b) {
								var singleError = errors.a;
								return 'Problem with the given value:\n\n' + (A2($dillonkearns$elm_markdown$Markdown$Html$tagToString, tagName, attributes) + ('\n\n' + (singleError + '\n')));
							} else {
								return 'oneOf failed parsing this value:\n    ' + (A2($dillonkearns$elm_markdown$Markdown$Html$tagToString, tagName, attributes) + ('\n\nParsing failed in the following 2 ways:\n\n\n' + (A2(
									$elm$core$String$join,
									'\n\n',
									A2(
										$elm$core$List$indexedMap,
										F2(
											function (index, error) {
												return '(' + ($elm$core$String$fromInt(index + 1) + (') ' + error));
											}),
										errors)) + '\n')));
							}
						}
					},
					A3(rawDecoder, tagName, attributes, innerBlocks));
			});
	}(
		A3(
			$elm$core$List$foldl,
			F2(
				function (decoder, soFar) {
					return F3(
						function (tagName, attributes, children) {
							return A2(
								$dillonkearns$elm_markdown$Markdown$Html$resultOr,
								A3(decoder, tagName, attributes, children),
								A3(soFar, tagName, attributes, children));
						});
				}),
			F3(
				function (tagName, attributes, children) {
					return $elm$core$Result$Err(_List_Nil);
				}),
			unwrappedDecoders));
};
var $elm$html$Html$pre = _VirtualDom_node('pre');
var $elm$html$Html$Attributes$start = function (n) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'start',
		$elm$core$String$fromInt(n));
};
var $elm$html$Html$strong = _VirtualDom_node('strong');
var $elm$html$Html$table = _VirtualDom_node('table');
var $elm$html$Html$tbody = _VirtualDom_node('tbody');
var $elm$html$Html$td = _VirtualDom_node('td');
var $elm$html$Html$th = _VirtualDom_node('th');
var $elm$html$Html$thead = _VirtualDom_node('thead');
var $elm$html$Html$tr = _VirtualDom_node('tr');
var $dillonkearns$elm_markdown$Markdown$Renderer$defaultHtmlRenderer = {
	gY: $elm$html$Html$blockquote(_List_Nil),
	g2: function (_v0) {
		var body = _v0.fv;
		var language = _v0.hy;
		var classes = function () {
			var _v1 = A2($elm$core$Maybe$map, $elm$core$String$words, language);
			if ((!_v1.$) && _v1.a.b) {
				var _v2 = _v1.a;
				var actualLanguage = _v2.a;
				return _List_fromArray(
					[
						$elm$html$Html$Attributes$class('language-' + actualLanguage)
					]);
			} else {
				return _List_Nil;
			}
		}();
		return A2(
			$elm$html$Html$pre,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$code,
					classes,
					_List_fromArray(
						[
							$elm$html$Html$text(body)
						]))
				]));
	},
	g3: function (content) {
		return A2(
			$elm$html$Html$code,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(content)
				]));
	},
	hd: function (children) {
		return A2($elm$html$Html$em, _List_Nil, children);
	},
	hm: A2($elm$html$Html$br, _List_Nil, _List_Nil),
	hn: function (_v3) {
		var level = _v3.nH;
		var children = _v3.iY;
		switch (level) {
			case 0:
				return A2($elm$html$Html$h1, _List_Nil, children);
			case 1:
				return A2($elm$html$Html$h2, _List_Nil, children);
			case 2:
				return A2($elm$html$Html$h3, _List_Nil, children);
			case 3:
				return A2($elm$html$Html$h4, _List_Nil, children);
			case 4:
				return A2($elm$html$Html$h5, _List_Nil, children);
			default:
				return A2($elm$html$Html$h6, _List_Nil, children);
		}
	},
	na: $dillonkearns$elm_markdown$Markdown$Html$oneOf(_List_Nil),
	jH: function (imageInfo) {
		var _v5 = imageInfo.fb;
		if (!_v5.$) {
			var title = _v5.a;
			return A2(
				$elm$html$Html$img,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$src(imageInfo.$8),
						$elm$html$Html$Attributes$alt(imageInfo.gR),
						$elm$html$Html$Attributes$title(title)
					]),
				_List_Nil);
		} else {
			return A2(
				$elm$html$Html$img,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$src(imageInfo.$8),
						$elm$html$Html$Attributes$alt(imageInfo.gR)
					]),
				_List_Nil);
		}
	},
	nJ: F2(
		function (link, content) {
			var _v6 = link.fb;
			if (!_v6.$) {
				var title = _v6.a;
				return A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(link.je),
							$elm$html$Html$Attributes$title(title)
						]),
					content);
			} else {
				return A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(link.je)
						]),
					content);
			}
		}),
	h_: F2(
		function (startingIndex, items) {
			return A2(
				$elm$html$Html$ol,
				function () {
					if (startingIndex === 1) {
						return _List_fromArray(
							[
								$elm$html$Html$Attributes$start(startingIndex)
							]);
					} else {
						return _List_Nil;
					}
				}(),
				A2(
					$elm$core$List$map,
					function (itemBlocks) {
						return A2($elm$html$Html$li, _List_Nil, itemBlocks);
					},
					items));
		}),
	h1: $elm$html$Html$p(_List_Nil),
	ih: function (children) {
		return A2($elm$html$Html$del, _List_Nil, children);
	},
	ii: function (children) {
		return A2($elm$html$Html$strong, _List_Nil, children);
	},
	lj: $elm$html$Html$table(_List_Nil),
	im: $elm$html$Html$tbody(_List_Nil),
	$9: function (maybeAlignment) {
		var attrs = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				$elm$core$List$singleton,
				A2(
					$elm$core$Maybe$map,
					$elm$html$Html$Attributes$align,
					A2(
						$elm$core$Maybe$map,
						function (alignment) {
							switch (alignment) {
								case 0:
									return 'left';
								case 2:
									return 'center';
								default:
									return 'right';
							}
						},
						maybeAlignment))));
		return $elm$html$Html$td(attrs);
	},
	io: $elm$html$Html$thead(_List_Nil),
	ip: function (maybeAlignment) {
		var attrs = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				$elm$core$List$singleton,
				A2(
					$elm$core$Maybe$map,
					$elm$html$Html$Attributes$align,
					A2(
						$elm$core$Maybe$map,
						function (alignment) {
							switch (alignment) {
								case 0:
									return 'left';
								case 2:
									return 'center';
								default:
									return 'right';
							}
						},
						maybeAlignment))));
		return $elm$html$Html$th(attrs);
	},
	gG: $elm$html$Html$tr(_List_Nil),
	r: $elm$html$Html$text,
	ir: A2($elm$html$Html$hr, _List_Nil, _List_Nil),
	iz: function (items) {
		return A2(
			$elm$html$Html$ul,
			_List_Nil,
			A2(
				$elm$core$List$map,
				function (item) {
					var task = item.a;
					var children = item.b;
					var checkbox = function () {
						switch (task) {
							case 0:
								return $elm$html$Html$text('');
							case 1:
								return A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$disabled(true),
											$elm$html$Html$Attributes$checked(false),
											$elm$html$Html$Attributes$type_('checkbox')
										]),
									_List_Nil);
							default:
								return A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$disabled(true),
											$elm$html$Html$Attributes$checked(true),
											$elm$html$Html$Attributes$type_('checkbox')
										]),
									_List_Nil);
						}
					}();
					return A2(
						$elm$html$Html$li,
						_List_Nil,
						A2($elm$core$List$cons, checkbox, children));
				},
				items));
	}
};
var $elm$core$Result$map2 = F3(
	function (func, ra, rb) {
		if (ra.$ === 1) {
			var x = ra.a;
			return $elm$core$Result$Err(x);
		} else {
			var a = ra.a;
			if (rb.$ === 1) {
				var x = rb.a;
				return $elm$core$Result$Err(x);
			} else {
				var b = rb.a;
				return $elm$core$Result$Ok(
					A2(func, a, b));
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$Renderer$combineResults = A2(
	$elm$core$List$foldr,
	$elm$core$Result$map2($elm$core$List$cons),
	$elm$core$Result$Ok(_List_Nil));
var $dillonkearns$elm_markdown$Markdown$Renderer$renderHtml = F5(
	function (tagName, attributes, children, _v0, renderedChildren) {
		var htmlRenderer = _v0;
		return A2(
			$elm$core$Result$andThen,
			function (okChildren) {
				return A2(
					$elm$core$Result$map,
					function (myRenderer) {
						return myRenderer(okChildren);
					},
					A3(htmlRenderer, tagName, attributes, children));
			},
			$dillonkearns$elm_markdown$Markdown$Renderer$combineResults(renderedChildren));
	});
var $dillonkearns$elm_markdown$Markdown$Renderer$foldThing = F3(
	function (renderer, topLevelInline, soFar) {
		var _v12 = A2($dillonkearns$elm_markdown$Markdown$Renderer$renderSingleInline, renderer, topLevelInline);
		if (!_v12.$) {
			var inline = _v12.a;
			return A2($elm$core$List$cons, inline, soFar);
		} else {
			return soFar;
		}
	});
var $dillonkearns$elm_markdown$Markdown$Renderer$renderHelper = F2(
	function (renderer, blocks) {
		return A2(
			$elm$core$List$filterMap,
			$dillonkearns$elm_markdown$Markdown$Renderer$renderHelperSingle(renderer),
			blocks);
	});
var $dillonkearns$elm_markdown$Markdown$Renderer$renderHelperSingle = function (renderer) {
	return function (block) {
		switch (block.$) {
			case 4:
				var level = block.a;
				var content = block.b;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Result$map,
						function (children) {
							return renderer.hn(
								{
									iY: children,
									nH: level,
									oW: $dillonkearns$elm_markdown$Markdown$Block$extractInlineText(content)
								});
						},
						A2($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled, renderer, content)));
			case 5:
				var content = block.a;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Result$map,
						renderer.h1,
						A2($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled, renderer, content)));
			case 0:
				var html = block.a;
				if (!html.$) {
					var tag = html.a;
					var attributes = html.b;
					var children = html.c;
					return $elm$core$Maybe$Just(
						A4($dillonkearns$elm_markdown$Markdown$Renderer$renderHtmlNode, renderer, tag, attributes, children));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			case 1:
				var tight = block.a;
				var items = block.b;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Result$map,
						function (listItems) {
							return renderer.iz(
								A2(
									$elm$core$List$map,
									function (_v7) {
										var task = _v7.a;
										var children = _v7.b;
										return A2(
											$dillonkearns$elm_markdown$Markdown$Block$ListItem,
											task,
											$elm$core$List$concat(children));
									},
									listItems));
						},
						$dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
							A2(
								$elm$core$List$map,
								function (_v4) {
									var task = _v4.a;
									var children = _v4.b;
									return A2(
										$elm$core$Result$map,
										$dillonkearns$elm_markdown$Markdown$Block$ListItem(task),
										$dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
											function (blocks) {
												return A2(
													$elm$core$List$filterMap,
													function (listItemBlock) {
														var _v5 = _Utils_Tuple2(tight, listItemBlock);
														if ((_v5.a === 1) && (_v5.b.$ === 5)) {
															var _v6 = _v5.a;
															var content = _v5.b.a;
															return $elm$core$Maybe$Just(
																A2($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled, renderer, content));
														} else {
															return A2(
																$elm$core$Maybe$map,
																$elm$core$Result$map($elm$core$List$singleton),
																A2($dillonkearns$elm_markdown$Markdown$Renderer$renderHelperSingle, renderer, listItemBlock));
														}
													},
													blocks);
											}(children)));
								},
								items))));
			case 2:
				var tight = block.a;
				var startingIndex = block.b;
				var items = block.c;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Result$map,
						function (listItems) {
							return A2(
								renderer.h_,
								startingIndex,
								A2(
									$elm$core$List$map,
									function (children) {
										return $elm$core$List$concat(children);
									},
									listItems));
						},
						$dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
							A2(
								$elm$core$List$map,
								function (itemsblocks) {
									return $dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
										function (blocks) {
											return A2(
												$elm$core$List$filterMap,
												function (listItemBlock) {
													var _v8 = _Utils_Tuple2(tight, listItemBlock);
													if ((_v8.a === 1) && (_v8.b.$ === 5)) {
														var _v9 = _v8.a;
														var content = _v8.b.a;
														return $elm$core$Maybe$Just(
															A2($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled, renderer, content));
													} else {
														return A2(
															$elm$core$Maybe$map,
															$elm$core$Result$map($elm$core$List$singleton),
															A2($dillonkearns$elm_markdown$Markdown$Renderer$renderHelperSingle, renderer, listItemBlock));
													}
												},
												blocks);
										}(itemsblocks));
								},
								items))));
			case 7:
				var codeBlock = block.a;
				return $elm$core$Maybe$Just(
					$elm$core$Result$Ok(
						renderer.g2(codeBlock)));
			case 8:
				return $elm$core$Maybe$Just(
					$elm$core$Result$Ok(renderer.ir));
			case 3:
				var nestedBlocks = block.a;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Result$map,
						renderer.gY,
						$dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
							A2($dillonkearns$elm_markdown$Markdown$Renderer$renderHelper, renderer, nestedBlocks))));
			default:
				var header = block.a;
				var rows = block.b;
				var renderedHeaderCells = $dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
					A2(
						$elm$core$List$map,
						function (_v11) {
							var label = _v11.nC;
							var alignment = _v11.fn;
							return A2(
								$elm$core$Result$map,
								$elm$core$Tuple$pair(alignment),
								A2($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled, renderer, label));
						},
						header));
				var renderedHeader = A2(
					$elm$core$Result$map,
					function (listListView) {
						return renderer.io(
							$elm$core$List$singleton(
								renderer.gG(
									A2(
										$elm$core$List$map,
										function (_v10) {
											var maybeAlignment = _v10.a;
											var item = _v10.b;
											return A2(renderer.ip, maybeAlignment, item);
										},
										listListView))));
					},
					renderedHeaderCells);
				var renderedBody = function (r) {
					return $elm$core$List$isEmpty(r) ? _List_Nil : _List_fromArray(
						[
							renderer.im(r)
						]);
				};
				var alignmentForColumn = function (columnIndex) {
					return A2(
						$elm$core$Maybe$andThen,
						function ($) {
							return $.fn;
						},
						$elm$core$List$head(
							A2($elm$core$List$drop, columnIndex, header)));
				};
				var renderRow = function (cells) {
					return A2(
						$elm$core$Result$map,
						renderer.gG,
						A2(
							$elm$core$Result$map,
							$elm$core$List$indexedMap(
								F2(
									function (index, cell) {
										return A2(
											renderer.$9,
											alignmentForColumn(index),
											cell);
									})),
							$dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
								A2(
									$elm$core$List$map,
									$dillonkearns$elm_markdown$Markdown$Renderer$renderStyled(renderer),
									cells))));
				};
				var renderedRows = $dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
					A2($elm$core$List$map, renderRow, rows));
				return $elm$core$Maybe$Just(
					A3(
						$elm$core$Result$map2,
						F2(
							function (h, r) {
								return renderer.lj(
									A2(
										$elm$core$List$cons,
										h,
										renderedBody(r)));
							}),
						renderedHeader,
						renderedRows));
		}
	};
};
var $dillonkearns$elm_markdown$Markdown$Renderer$renderHtmlNode = F4(
	function (renderer, tag, attributes, children) {
		return A5(
			$dillonkearns$elm_markdown$Markdown$Renderer$renderHtml,
			tag,
			attributes,
			children,
			renderer.na,
			A2($dillonkearns$elm_markdown$Markdown$Renderer$renderHelper, renderer, children));
	});
var $dillonkearns$elm_markdown$Markdown$Renderer$renderSingleInline = F2(
	function (renderer, inline) {
		switch (inline.$) {
			case 4:
				var innerInlines = inline.a;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Result$map,
						renderer.ii,
						A2($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled, renderer, innerInlines)));
			case 3:
				var innerInlines = inline.a;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Result$map,
						renderer.hd,
						A2($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled, renderer, innerInlines)));
			case 5:
				var innerInlines = inline.a;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Result$map,
						renderer.ih,
						A2($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled, renderer, innerInlines)));
			case 2:
				var src = inline.a;
				var title = inline.b;
				var children = inline.c;
				return $elm$core$Maybe$Just(
					$elm$core$Result$Ok(
						renderer.jH(
							{
								gR: $dillonkearns$elm_markdown$Markdown$Block$extractInlineText(children),
								$8: src,
								fb: title
							})));
			case 7:
				var string = inline.a;
				return $elm$core$Maybe$Just(
					$elm$core$Result$Ok(
						renderer.r(string)));
			case 6:
				var string = inline.a;
				return $elm$core$Maybe$Just(
					$elm$core$Result$Ok(
						renderer.g3(string)));
			case 1:
				var destination = inline.a;
				var title = inline.b;
				var inlines = inline.c;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Result$andThen,
						function (children) {
							return $elm$core$Result$Ok(
								A2(
									renderer.nJ,
									{je: destination, fb: title},
									children));
						},
						A2($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled, renderer, inlines)));
			case 8:
				return $elm$core$Maybe$Just(
					$elm$core$Result$Ok(renderer.hm));
			default:
				var html = inline.a;
				if (!html.$) {
					var tag = html.a;
					var attributes = html.b;
					var children = html.c;
					return $elm$core$Maybe$Just(
						A4($dillonkearns$elm_markdown$Markdown$Renderer$renderHtmlNode, renderer, tag, attributes, children));
				} else {
					return $elm$core$Maybe$Nothing;
				}
		}
	});
var $dillonkearns$elm_markdown$Markdown$Renderer$renderStyled = F2(
	function (renderer, styledStrings) {
		return $dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
			A3(
				$elm$core$List$foldr,
				$dillonkearns$elm_markdown$Markdown$Renderer$foldThing(renderer),
				_List_Nil,
				styledStrings));
	});
var $dillonkearns$elm_markdown$Markdown$Renderer$render = F2(
	function (renderer, ast) {
		return $dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
			A2($dillonkearns$elm_markdown$Markdown$Renderer$renderHelper, renderer, ast));
	});
var $dillonkearns$elm_markdown$Markdown$Html$tag = F2(
	function (expectedTag, a) {
		return F3(
			function (tagName, attributes, children) {
				return _Utils_eq(tagName, expectedTag) ? $elm$core$Result$Ok(a) : $elm$core$Result$Err('Expected ' + (expectedTag + (' but was ' + tagName)));
			});
	});
var $elm$html$Html$u = _VirtualDom_node('u');
var $author$project$Markdown$view = F2(
	function (attributes, _v0) {
		var content = _v0;
		var _v1 = $dillonkearns$elm_markdown$Markdown$Parser$parse(content);
		if (!_v1.$) {
			var blocks = _v1.a;
			var defaultRenderer = $dillonkearns$elm_markdown$Markdown$Renderer$defaultHtmlRenderer;
			var renderer = _Utils_update(
				defaultRenderer,
				{
					na: $dillonkearns$elm_markdown$Markdown$Html$oneOf(
						_List_fromArray(
							[
								A2(
								$dillonkearns$elm_markdown$Markdown$Html$tag,
								'u',
								function (children) {
									return A2(
										$elm$html$Html$u,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('inline-children')
											]),
										children);
								})
							])),
					nJ: F2(
						function (link, linkContent) {
							var _v3 = link.fb;
							if (!_v3.$) {
								var title = _v3.a;
								return A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href(link.je),
											$elm$html$Html$Attributes$title(title),
											$elm$html$Html$Attributes$target('_blank')
										]),
									linkContent);
							} else {
								return A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href(link.je),
											$elm$html$Html$Attributes$target('_blank')
										]),
									linkContent);
							}
						})
				});
			var _v2 = A2($dillonkearns$elm_markdown$Markdown$Renderer$render, renderer, blocks);
			if (!_v2.$) {
				var asHtml = _v2.a;
				return A2(
					$elm$html$Html$div,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$class('markdown-viewer break-words'),
						attributes),
					asHtml);
			} else {
				return $elm$html$Html$text('');
			}
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Form$Text$withContainerAttrs = F2(
	function (attrs, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				mg: _Utils_ap(options.mg, attrs)
			});
	});
var $author$project$Form$Text$withInputElement = F2(
	function (inputElement, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{fZ: inputElement});
	});
var $author$project$Page$Community$About$viewCommunityCard = F2(
	function (shared, community) {
		var translators = shared.iw;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'lg:col-start-2 lg:col-span-4',
							!$author$project$Page$Community$About$showNewsCard(community)),
							_Utils_Tuple2(
							'lg:col-span-2',
							$author$project$Page$Community$About$showNewsCard(community))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mb-4 opacity-0 pointer-events-none hidden lg:block')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('hidden text')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-col bg-white rounded relative px-4 pt-4 pb-6')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('absolute w-full top-0 left-0 flex justify-center -translate-y-1/2 pointer-events-none')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('h-21 w-21 bg-white p-4 flex items-center justify-center rounded-full shadow-sm')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$img,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$src(community.hC),
													$elm$html$Html$Attributes$class('max-w-full max-h-full'),
													$elm$html$Html$Attributes$alt(
													A2(
														translators.iu,
														'community.index.logo',
														_List_fromArray(
															[
																_Utils_Tuple2('community', community.ki)
															])))
												]),
											_List_Nil)
										]))
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('bg-gray-100 p-2 rounded-full ml-auto focus-ring hover:opacity-60 active:opacity-80'),
									$elm$html$Html$Events$onClick($author$project$Page$Community$About$ClickedShareCommunity),
									$fapian$elm_html_aria$Html$Attributes$Aria$ariaLabel(
									translators.il('community.share'))
								]),
							_List_fromArray(
								[
									$author$project$Icons$share('')
								])),
							(!shared.iW) ? A2(
							$author$project$Form$Text$view,
							A2(
								$author$project$Form$Text$withInputElement,
								$author$project$Form$Text$TextareaInput(
									{pn: false}),
								A2(
									$author$project$Form$Text$withContainerAttrs,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('mb-0 overflow-hidden')
										]),
									A2(
										$author$project$Form$Text$withExtraAttrs,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('absolute opacity-0 left-[-9999em]'),
												$elm$html$Html$Attributes$tabindex(-1),
												$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
											]),
										$author$project$Form$Text$init(
											{R: 'share-fallback-input', nC: ''})))),
							{
								mM: $elm$html$Html$text(''),
								m$: false,
								nx: false,
								od: $author$project$Page$Community$About$NoOp,
								oe: function (_v0) {
									return $author$project$Page$Community$About$NoOp;
								},
								iw: shared.iw,
								pO: A2(
									translators.iu,
									'community.learn_about',
									_List_fromArray(
										[
											_Utils_Tuple2('community_name', community.ki),
											_Utils_Tuple2(
											'url',
											$elm$url$Url$toString(
												$author$project$Page$Community$About$urlToShareable(shared.gL)))
										]))
							}) : $elm$html$Html$text(''),
							A2(
							$elm$html$Html$h1,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-lg font-bold text-center'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('mt-10', !shared.iW)
										]))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(community.ki)
								])),
							function () {
							var _v1 = community.cQ;
							if (_v1.$ === 1) {
								return $elm$html$Html$text('');
							} else {
								var website = _v1.a;
								var removeTrailingSlash = function (site) {
									return A2($elm$core$String$endsWith, '/', site) ? A2($elm$core$String$dropRight, 1, site) : site;
								};
								var removeProtocol = function (site) {
									return A2($elm$core$String$startsWith, 'http://', site) ? A2($elm$core$String$dropLeft, 7, site) : (A2($elm$core$String$startsWith, 'https://', website) ? A2($elm$core$String$dropLeft, 8, site) : site);
								};
								return A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href(website),
											$elm$html$Html$Attributes$class('mx-auto text-sm font-bold text-gray-900 hover:underline focus-ring')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											removeTrailingSlash(
												removeProtocol(website)))
										]));
							}
						}(),
							A2(
							$author$project$Markdown$view,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mt-6')
								]),
							community.bc),
							A2(
							$elm$html$Html$ul,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex flex-wrap mt-8 gap-6 items-start justify-center')
								]),
							A2(
								$elm$core$List$map,
								function (contact) {
									return A2(
										$elm$html$Html$li,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('w-10')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$a,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('flex flex-col items-center hover:opacity-60'),
														$elm$html$Html$Attributes$href(
														$author$project$Contact$toHref(contact)),
														$elm$html$Html$Attributes$target('blank'),
														$elm$html$Html$Attributes$title(
														A2($author$project$Contact$toLabel, translators, contact))
													]),
												_List_fromArray(
													[
														A3(
														$author$project$Contact$circularIconWithGrayBg,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('w-10 h-10')
															]),
														translators,
														contact),
														A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('text-gray-900 text-sm text-center mt-2 font-semibold line-clamp-2')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(
																A2($author$project$Contact$toLabel, translators, contact))
															]))
													]))
											]));
								},
								community.aq)),
							community.cl ? A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('button button-secondary w-full mt-8'),
									$author$project$Route$href(
									$author$project$Route$CommunityObjectives($author$project$Route$WithNoObjectiveSelected))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										translators.iu,
										'community.earn',
										_List_fromArray(
											[
												_Utils_Tuple2(
												'symbol',
												$author$project$Eos$symbolToSymbolCodeString(community.e9))
											])))
								])) : $elm$html$Html$text('')
						]))
				]));
	});
var $author$project$Community$News$isPublished = F2(
	function (now, model) {
		var _v0 = model.h9;
		if (_v0.$ === 1) {
			return true;
		} else {
			var scheduling = _v0.a;
			return _Utils_cmp(
				$elm$time$Time$posixToMillis(now),
				$elm$time$Time$posixToMillis(scheduling)) > -1;
		}
	});
var $author$project$Utils$areSameDay = F3(
	function (timezone, first, second) {
		return _Utils_eq(
			A2($justinmimbs$date$Date$fromPosix, timezone, first),
			A2($justinmimbs$date$Date$fromPosix, timezone, second));
	});
var $author$project$View$Components$dateFormatter = F2(
	function (attrs, _v0) {
		var language = _v0.hy;
		var date = _v0.c7;
		var translationString = _v0.lv;
		return A3(
			$elm$html$Html$node,
			'date-formatter',
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$Attributes$attribute,
					'elm-locale',
					$author$project$Translation$languageToLocale(language)),
				A2(
					$elm$core$List$cons,
					A2(
						$elm$html$Html$Attributes$attribute,
						'elm-date',
						$elm$core$String$fromInt(
							$elm$time$Time$posixToMillis(date))),
					A2(
						$elm$core$List$cons,
						A2($elm$html$Html$Attributes$attribute, 'elm-translation', translationString),
						attrs))),
			_List_Nil);
	});
var $author$project$Utils$previousDay = function (time) {
	var day = ((1000 * 60) * 60) * 24;
	return $elm$time$Time$millisToPosix(
		$elm$time$Time$posixToMillis(time) - day);
};
var $author$project$View$Components$dateViewer = F4(
	function (attrs, fillInTranslations, shared, time) {
		var yesterday = $author$project$Utils$previousDay(shared.gh);
		var translations = fillInTranslations(
			{
				ow: '{{date}}',
				pB: $elm$core$Maybe$Just(
					shared.iw.il('dates.today')),
				pY: $elm$core$Maybe$Just(
					shared.iw.il('dates.yesterday'))
			});
		var translationString = A3($author$project$Utils$areSameDay, shared.ll, shared.gh, time) ? A2($elm$core$Maybe$withDefault, translations.ow, translations.pB) : (A3($author$project$Utils$areSameDay, shared.ll, shared.gh, yesterday) ? A2($elm$core$Maybe$withDefault, translations.ow, translations.pY) : translations.ow);
		return A2($elm$core$String$contains, '{{date}}', translationString) ? A2(
			$author$project$View$Components$dateFormatter,
			attrs,
			{c7: time, hy: shared.hy, lv: translationString}) : (A3($author$project$Utils$areSameDay, shared.ll, shared.gh, time) ? A2(
			$elm$html$Html$span,
			attrs,
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2($elm$core$Maybe$withDefault, translations.ow, translations.pB))
				])) : (A3($author$project$Utils$areSameDay, shared.ll, shared.gh, yesterday) ? A2(
			$elm$html$Html$span,
			attrs,
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2($elm$core$Maybe$withDefault, translations.ow, translations.pY))
				])) : $elm$html$Html$text('')));
	});
var $elm_community$list_extra$List$Extra$groupWhile = F2(
	function (isSameGroup, items) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					if (!acc.b) {
						return _List_fromArray(
							[
								_Utils_Tuple2(x, _List_Nil)
							]);
					} else {
						var _v1 = acc.a;
						var y = _v1.a;
						var restOfGroup = _v1.b;
						var groups = acc.b;
						return A2(isSameGroup, x, y) ? A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								x,
								A2($elm$core$List$cons, y, restOfGroup)),
							groups) : A2(
							$elm$core$List$cons,
							_Utils_Tuple2(x, _List_Nil),
							acc);
					}
				}),
			_List_Nil,
			items);
	});
var $author$project$Icons$arrowDown = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('32'),
				$elm$svg$Svg$Attributes$height('32'),
				$elm$svg$Svg$Attributes$viewBox('0 0 32 32'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M14.9881 19.8182C15.0302 19.8496 15.0749 19.8773 15.1217 19.9009C15.1713 19.9401 15.2246 19.9742 15.2808 20.0028C15.3388 20.0213 15.3985 20.0341 15.459 20.0409C15.5747 20.0793 15.6997 20.0793 15.8154 20.0409C15.8759 20.0341 15.9356 20.0213 15.9935 20.0028C16.0498 19.9742 16.1031 19.9401 16.1526 19.9009C16.1995 19.8773 16.2442 19.8496 16.2863 19.8182L21.059 14.7273C21.4113 14.3414 21.3878 13.7439 21.0064 13.3869C20.6249 13.0298 20.0272 13.0458 19.6654 13.4228L15.5863 17.7691L11.5072 13.4228C11.1454 13.0458 10.5477 13.0298 10.1662 13.3869C9.78469 13.7439 9.76124 14.3414 10.1135 14.7273L14.9881 19.8182Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Icons$speechBubble = F2(
	function (attrs, class_) {
		return A2(
			$elm$svg$Svg$svg,
			A2(
				$elm$core$List$cons,
				$elm$svg$Svg$Attributes$width('28'),
				A2(
					$elm$core$List$cons,
					$elm$svg$Svg$Attributes$height('28'),
					A2(
						$elm$core$List$cons,
						$elm$svg$Svg$Attributes$viewBox('0 0 28 28'),
						A2(
							$elm$core$List$cons,
							$elm$svg$Svg$Attributes$fill('none'),
							A2(
								$elm$core$List$cons,
								$elm$svg$Svg$Attributes$class(class_),
								attrs))))),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M24.5 13.4167C24.504 14.9565 24.1442 16.4756 23.45 17.85C22.6268 19.4971 21.3614 20.8824 19.7954 21.8509C18.2293 22.8193 16.4246 23.3327 14.5833 23.3334C13.0435 23.3374 11.5245 22.9776 10.15 22.2834L3.5 24.5L5.71667 17.85C5.02242 16.4756 4.66265 14.9565 4.66667 13.4167C4.66738 11.5754 5.18071 9.77069 6.14917 8.20467C7.11763 6.63866 8.50296 5.37319 10.15 4.55003C11.5245 3.85579 13.0435 3.49602 14.5833 3.50003H15.1667C17.5984 3.63419 19.8952 4.66059 21.6173 6.3827C23.3394 8.10482 24.3658 10.4016 24.5 12.8334V13.4167Z'),
							$elm$svg$Svg$Attributes$strokeWidth('2'),
							$elm$svg$Svg$Attributes$strokeLinecap('round'),
							$elm$svg$Svg$Attributes$strokeLinejoin('round')
						]),
					_List_Nil)
				]));
	});
var $author$project$Community$News$viewSummary = F3(
	function (_v0, hasRead, news) {
		var t = _v0.il;
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('grid items-center py-4 focus-ring rounded-sm hover:opacity-70'),
					A2($elm$html$Html$Attributes$style, 'grid-template-columns', '32px 1fr 80px'),
					$elm$html$Html$Attributes$title(news.fb),
					$author$project$Route$href(
					$author$project$Route$News(
						{
							o8: $elm$core$Maybe$Just(news.R),
							pe: false
						}))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Icons$speechBubble,
					_List_fromArray(
						[
							$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
						]),
					'h-8 w-8 stroke-current text-blue bg-gray-100 rounded-full p-[6px] overflow-visible'),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('truncate mx-4')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h4,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('font-bold truncate'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('text-purple-500', !hasRead),
											_Utils_Tuple2('text-gray-333', hasRead)
										]))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(news.fb)
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('truncate text-gray-333'),
									$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Markdown$toUnformattedString(news.bc))
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('sr-only')
								]),
							_List_fromArray(
								[
									hasRead ? $elm$html$Html$text(
									t('news.already_read')) : $elm$html$Html$text(
									t('news.not_read_yet'))
								]))
						])),
					$author$project$Icons$arrowDown('-rotate-90 fill-current text-orange-300 ml-auto rounded-full bg-gray-100')
				]));
	});
var $author$project$Community$News$viewList = F3(
	function (shared, attrs, news) {
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('divide-y divide-gray-100 space-y-4'),
				attrs),
			A2(
				$elm$core$List$map,
				function (_v0) {
					var firstNews = _v0.a;
					var otherNews = _v0.b;
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pt-4 first:pt-0')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h3,
								_List_Nil,
								_List_fromArray(
									[
										A4(
										$author$project$View$Components$dateViewer,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-black text-sm font-bold uppercase')
											]),
										$elm$core$Basics$identity,
										shared,
										firstNews.f_)
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('divide-y divide-gray-100')
									]),
								A2(
									$elm$core$List$map,
									function (theseNews) {
										return A3(
											$author$project$Community$News$viewSummary,
											shared.iw,
											$elm_community$maybe_extra$Maybe$Extra$isJust(theseNews.h5),
											theseNews);
									},
									A2($elm$core$List$cons, firstNews, otherNews)))
							]));
				},
				A2(
					$elm_community$list_extra$List$Extra$groupWhile,
					F2(
						function (news1, news2) {
							return A3($author$project$Utils$areSameDay, shared.ll, news1.f_, news2.f_);
						}),
					news)));
	});
var $author$project$Page$Community$About$viewNewsCard = F2(
	function (shared, community) {
		var translators = shared.iw;
		var _v0 = translators;
		var t = _v0.il;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mt-4 lg:mt-0')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							$fapian$elm_html_aria$Html$Attributes$Aria$ariaLabel(
							t('community.index.our_messages') + (' ' + t('community.index.messages')))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('community.index.our_messages'))
								])),
							$elm$html$Html$text(' '),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('font-bold'),
									$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('community.index.messages'))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('bg-white rounded px-4 pt-4 pb-6 mt-4 relative')
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$src('/images/doggo-announcing.svg'),
									$elm$html$Html$Attributes$class('absolute top-0 right-0 -translate-y-full'),
									$elm$html$Html$Attributes$alt('')
								]),
							_List_Nil),
						function () {
							var _v1 = community.eO;
							switch (_v1.$) {
								case 3:
									var news = _v1.a;
									return $elm$core$List$isEmpty(news) ? _List_fromArray(
										[
											A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('text-center text-gray-900 pt-10 pb-8')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													t('menu.coming_soon'))
												]))
										]) : _List_fromArray(
										[
											A3(
											$author$project$Community$News$viewList,
											shared,
											_List_Nil,
											A2(
												$elm$core$List$take,
												3,
												A2(
													$elm$core$List$filter,
													$author$project$Community$News$isPublished(shared.gh),
													news))),
											A2(
											$elm$html$Html$hr,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('mb-4 border-gray-100'),
													$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
												]),
											_List_Nil),
											A2(
											$elm$html$Html$a,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('button button-secondary w-full'),
													$author$project$Route$href(
													$author$project$Route$News(
														{o8: $elm$core$Maybe$Nothing, pe: true}))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													t('news.view_more'))
												]))
										]);
								case 1:
									return _List_fromArray(
										[
											A2($author$project$View$Components$loadingLogoAnimated, translators, 'mb-10')
										]);
								case 0:
									return _List_fromArray(
										[
											A2($author$project$View$Components$loadingLogoAnimated, translators, 'mb-10')
										]);
								default:
									return _List_fromArray(
										[
											A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('text-center text-gray-900 pt-10 pb-8')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													t('news.error_fetching'))
												]))
										]);
							}
						}()))
				]));
	});
var $author$project$Utils$formatInt = F2(
	function (maybeTranslators, number) {
		return A3($author$project$Utils$formatFloat, maybeTranslators, 0, number);
	});
var $author$project$Page$Community$About$viewStatsCard = F2(
	function (translators, _v0) {
		var number = _v0.ay;
		var description = _v0.bc;
		var imgSrc = _v0.cp;
		var imgClass = _v0.co;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('grid grid-cols-3 bg-white rounded')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$src(imgSrc),
							$elm$html$Html$Attributes$alt(''),
							$elm$html$Html$Attributes$class(imgClass)
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('col-span-2 py-6 text-center')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('sr-only')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									translators.il(description) + (': ' + $elm$core$String$fromInt(number)))
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-xl font-bold text-green'),
									$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$author$project$Utils$formatInt,
										$elm$core$Maybe$Just(translators),
										number))
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('uppercase text-sm font-bold text-gray-900'),
									$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(description)
								]))
						]))
				]));
	});
var $author$project$Page$Community$About$view = F2(
	function (loggedIn, model) {
		var defaultCoverPhoto = A3(
			$elm$html$Html$node,
			'picture',
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$source,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$attribute, 'srcset', '/images/community-bg-mobile.svg'),
							$elm$html$Html$Attributes$media('(min-width:768px)')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$src('/images/community-bg-desktop.svg'),
							$elm$html$Html$Attributes$class('mb-6 object-cover min-w-full max-h-43 sm:max-h-60 lg:max-h-80'),
							A2($elm$html$Html$Attributes$style, 'object-position', '50% 62%'),
							$elm$html$Html$Attributes$alt('')
						]),
					_List_Nil)
				]));
		var _v0 = loggedIn.aM.iw;
		var t = _v0.il;
		var tr = _v0.iu;
		return {
			mk: function () {
				var _v1 = loggedIn.o7;
				switch (_v1.$) {
					case 3:
						var community = _v1.a;
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mb-20')
								]),
							_List_fromArray(
								[
									function () {
									var _v2 = A2($krisajenkins$remotedata$RemoteData$map, $elm$core$List$head, community.bs);
									_v2$2:
									while (true) {
										switch (_v2.$) {
											case 3:
												if (!_v2.a.$) {
													var upload = _v2.a.a;
													return A2(
														$elm$html$Html$img,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$src(upload),
																$elm$html$Html$Attributes$class('mb-6 object-cover min-w-full max-h-43 sm:max-h-60 lg:max-h-80'),
																$elm$html$Html$Attributes$alt('')
															]),
														_List_Nil);
												} else {
													break _v2$2;
												}
											case 1:
												return A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('w-full h-43 sm:h-60 lg:h-80 animate-skeleton-loading')
														]),
													_List_Nil);
											default:
												break _v2$2;
										}
									}
									return defaultCoverPhoto;
								}(),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('container mx-auto px-4 py-10')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('grid grid-cols-1 lg:grid-cols-3 gap-6'),
													$elm$html$Html$Attributes$classList(
													_List_fromArray(
														[
															_Utils_Tuple2(
															'lg:grid-cols-6',
															!$author$project$Page$Community$About$showNewsCard(community))
														]))
												]),
											_List_fromArray(
												[
													A2($author$project$Page$Community$About$viewCommunityCard, loggedIn.aM, community),
													$author$project$Page$Community$About$showNewsCard(community) ? A2($author$project$Page$Community$About$viewNewsCard, loggedIn.aM, community) : $elm$html$Html$text('')
												])),
											A2(
											$elm$html$Html$h2,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('mt-6'),
													$fapian$elm_html_aria$Html$Attributes$Aria$ariaLabel(
													t('community.index.our_numbers') + (' ' + t('community.index.numbers')))
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															t('community.index.our_numbers'))
														])),
													$elm$html$Html$text(' '),
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('font-bold'),
															$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															t('community.index.numbers'))
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('mt-4 grid sm:grid-cols-2 md:grid-cols-3 gap-x-6 gap-y-4')
												]),
											_List_fromArray(
												[
													function () {
													var _v3 = model.ff;
													switch (_v3.$) {
														case 3:
															var tokenInfo = _v3.a;
															return A2(
																$author$project$Page$Community$About$viewStatsCard,
																loggedIn.aM.iw,
																{
																	bc: A2(
																		tr,
																		'community.index.amount_in_circulation',
																		_List_fromArray(
																			[
																				_Utils_Tuple2(
																				'currency_name',
																				$author$project$Eos$symbolToSymbolCodeString(community.e9))
																			])),
																	co: 'place-self-center',
																	cp: '/images/three_coins.svg',
																	ay: $elm$core$Basics$round(tokenInfo.pq.lU)
																});
														case 1:
															return A2(
																$elm$html$Html$div,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('rounded animate-skeleton-loading')
																	]),
																_List_Nil);
														default:
															return $elm$html$Html$text('');
													}
												}(),
													A2(
													$author$project$Page$Community$About$viewStatsCard,
													loggedIn.aM.iw,
													{
														bc: t('community.index.members'),
														co: 'mt-auto mx-auto',
														cp: '/images/man_sipping_coconut_water.svg',
														ay: community.gc
													}),
													A2(
													$author$project$Page$Community$About$viewStatsCard,
													loggedIn.aM.iw,
													{
														bc: t('community.index.claims'),
														co: 'self-center',
														cp: '/images/woman_driving_truck.svg',
														ay: community.l5
													}),
													A2(
													$author$project$Page$Community$About$viewStatsCard,
													loggedIn.aM.iw,
													{
														bc: t('community.index.transfers'),
														co: 'mt-auto mx-auto',
														cp: '/images/people_trading_bread.svg',
														ay: community.pF
													}),
													A2(
													$author$project$Page$Community$About$viewStatsCard,
													loggedIn.aM.iw,
													{
														bc: t('community.index.products'),
														co: 'mt-auto',
														cp: '/images/man_in_shop.svg',
														ay: community.oQ
													}),
													A2(
													$author$project$Page$Community$About$viewStatsCard,
													loggedIn.aM.iw,
													{
														bc: t('community.index.orders'),
														co: 'place-self-center',
														cp: '/images/dog_walking_with_purse.svg',
														ay: community.ov
													})
												]))
										]))
								]));
					case 1:
						return $author$project$Page$fullPageLoading(loggedIn.aM);
					case 0:
						return $author$project$Page$fullPageLoading(loggedIn.aM);
					default:
						var e = _v1.a;
						return A2(
							$author$project$Page$fullPageGraphQLError,
							t('community.index.about_title'),
							e);
				}
			}(),
			fb: t('community.index.about_title')
		};
	});
var $author$project$Profile$EditKycForm$Submitted = function (a) {
	return {$: 1, a: a};
};
var $author$project$Profile$EditKycForm$DimexDoc = 1;
var $author$project$Profile$EditKycForm$FormOutput = F3(
	function (documentType, document, phoneNumber) {
		return {eq: document, er: documentType, oC: phoneNumber};
	});
var $author$project$Profile$EditKycForm$NiteDoc = 2;
var $author$project$Form$Text$Telephone = 1;
var $author$project$Form$Text$asNumeric = $author$project$Form$Text$withExtraAttrs(
	_List_fromArray(
		[
			A2($elm$html$Html$Attributes$attribute, 'inputmode', 'numeric')
		]));
var $author$project$Profile$EditKycForm$docFromString = function (docType) {
	switch (docType) {
		case 'DIMEX':
			return $elm$core$Maybe$Just(1);
		case 'NITE':
			return $elm$core$Maybe$Just(2);
		case 'cedula_de_identidad':
			return $elm$core$Maybe$Just(0);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Form$Select$Options = $elm$core$Basics$identity;
var $author$project$Form$Select$init = function (_v0) {
	var label = _v0.nC;
	var id = _v0.R;
	var optionToString = _v0.dG;
	return {mg: _List_Nil, cf: false, R: id, nC: label, f4: _List_Nil, dG: optionToString, gk: _List_Nil};
};
var $author$project$Form$introspect = function (buildForm) {
	return function (values) {
		return A2(
			$author$project$Form$fill,
			buildForm(values),
			values);
	};
};
var $author$project$Kyc$CostaRica$CedulaDeIdentidad$validNumber = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^[1-9]-?\\d{4}-?\\d{4}$'));
var $author$project$Kyc$CostaRica$CedulaDeIdentidad$isValid = function (n) {
	return A2($elm$regex$Regex$contains, $author$project$Kyc$CostaRica$CedulaDeIdentidad$validNumber, n);
};
var $author$project$Kyc$CostaRica$Dimex$validNumber = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^[1-9]{1}\\d{10,11}$'));
var $author$project$Kyc$CostaRica$Dimex$isValid = function (n) {
	return A2($elm$regex$Regex$contains, $author$project$Kyc$CostaRica$Dimex$validNumber, n);
};
var $author$project$Kyc$CostaRica$Nite$validNumber = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^[1-9]{1}\\d{9}$'));
var $author$project$Kyc$CostaRica$Nite$isValid = function (n) {
	return A2($elm$regex$Regex$contains, $author$project$Kyc$CostaRica$Nite$validNumber, n);
};
var $author$project$Kyc$CostaRica$Phone$validPhone = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^[1-9]{1}\\d{3}-?\\d{4}$'));
var $author$project$Kyc$CostaRica$Phone$isValid = function (phone) {
	return A2($elm$regex$Regex$contains, $author$project$Kyc$CostaRica$Phone$validPhone, phone);
};
var $author$project$Form$Select = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Form$Select$getOptionToString = function (_v0) {
	var options = _v0;
	return options.dG;
};
var $author$project$Form$Select$map = F3(
	function (fn, reverseFn, _v0) {
		var options = _v0;
		return {
			mg: options.mg,
			cf: options.cf,
			R: options.R,
			nC: options.nC,
			f4: options.f4,
			dG: A2($elm$core$Basics$composeR, reverseFn, options.dG),
			gk: A2(
				$elm$core$List$map,
				function (_v1) {
					var option = _v1.gj;
					var label = _v1.nC;
					return {
						nC: label,
						gj: fn(option)
					};
				},
				options.gk)
		};
	});
var $author$project$Form$select = F3(
	function (optionFromString, config, options) {
		var optionToString = $author$project$Form$Select$getOptionToString(options);
		return A2(
			$author$project$Form$field,
			$author$project$Form$Select(
				A3($author$project$Form$Select$map, optionToString, optionFromString, options)),
			A3($author$project$Form$mapFieldConfig, optionToString, optionFromString, config));
	});
var $author$project$Form$Validate$stringLengthExactly = function (length) {
	return $author$project$Form$Validate$custom(
		function (stringInput) {
			return _Utils_eq(
				$elm$core$String$length(stringInput),
				length) ? $elm$core$Result$Ok(stringInput) : $elm$core$Result$Err(
				function (_v0) {
					var tr = _v0.iu;
					return A2(
						tr,
						'error.validator.text.exactly',
						_List_fromArray(
							[
								_Utils_Tuple2(
								'base',
								$elm$core$String$fromInt(length))
							]));
				});
		});
};
var $author$project$Form$Select$withContainerAttrs = F2(
	function (attrs, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				mg: _Utils_ap(options.mg, attrs)
			});
	});
var $author$project$Form$Select$withOption = F3(
	function (optionValue, optionLabel, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				gk: A2(
					$elm$core$List$cons,
					{nC: optionLabel, gj: optionValue},
					options.gk)
			});
	});
var $author$project$Form$Text$withType = F2(
	function (type_, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{d0: type_});
	});
var $author$project$Profile$EditKycForm$createForm = function (translators) {
	var t = translators.il;
	return A2(
		$author$project$Form$with,
		A2(
			$author$project$Form$textField,
			{
				ab: $elm$core$Basics$always($elm$core$Maybe$Nothing),
				af: A2(
					$elm$core$Basics$composeR,
					$author$project$Form$Validate$succeed,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Form$Validate$stringLengthExactly(8),
						A2(
							$elm$core$Basics$composeR,
							$author$project$Form$Validate$custom(
								function (stringPhone) {
									return $author$project$Kyc$CostaRica$Phone$isValid(stringPhone) ? $elm$core$Result$Ok(stringPhone) : $elm$core$Result$Err(
										function (translators_) {
											return translators_.il('error.phone');
										});
								}),
							$author$project$Form$Validate$validate(translators)))),
				n: F2(
					function (phoneNumber, input) {
						return _Utils_update(
							input,
							{
								oC: A2($elm$core$String$filter, $elm$core$Char$isDigit, phoneNumber)
							});
					}),
				pO: function ($) {
					return $.oC;
				}
			},
			A2(
				$author$project$Form$Text$withExtraAttrs,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$maxlength(8)
					]),
				$author$project$Form$Text$asNumeric(
					A2(
						$author$project$Form$Text$withType,
						1,
						A2(
							$author$project$Form$Text$withPlaceholder,
							t('register.form.phone.placeholder'),
							$author$project$Form$Text$init(
								{
									R: 'phone_number_field',
									nC: t('register.form.phone.label')
								})))))),
		A2(
			$author$project$Form$with,
			$author$project$Form$introspect(
				function (_v0) {
					var documentType = _v0.er;
					var _v1 = function () {
						switch (documentType) {
							case 0:
								return {
									f1: $author$project$Kyc$CostaRica$CedulaDeIdentidad$isValid,
									nC: t('register.form.document.cedula_de_identidad.label'),
									gb: 9,
									oG: t('register.form.document.cedula_de_identidad.placeholder')
								};
							case 1:
								return {
									f1: $author$project$Kyc$CostaRica$Dimex$isValid,
									nC: t('register.form.document.dimex.label'),
									gb: 12,
									oG: t('register.form.document.dimex.placeholder')
								};
							default:
								return {
									f1: $author$project$Kyc$CostaRica$Nite$isValid,
									nC: t('register.form.document.nite.label'),
									gb: 10,
									oG: t('register.form.document.nite.placeholder')
								};
						}
					}();
					var label = _v1.nC;
					var placeholder = _v1.oG;
					var maxLength = _v1.gb;
					var isValid = _v1.f1;
					return A2(
						$author$project$Form$textField,
						{
							ab: $elm$core$Basics$always($elm$core$Maybe$Nothing),
							af: A2(
								$elm$core$Basics$composeR,
								$author$project$Form$Validate$succeed,
								A2(
									$elm$core$Basics$composeR,
									$author$project$Form$Validate$stringLongerThan(0),
									A2(
										$elm$core$Basics$composeR,
										$author$project$Form$Validate$custom(
											function (stringInput) {
												return isValid(stringInput) ? $elm$core$Result$Ok(stringInput) : $elm$core$Result$Err(
													function (translators_) {
														return translators_.il('register.form.document.errorInvalid');
													});
											}),
										$author$project$Form$Validate$validate(translators)))),
							n: F2(
								function (document, input) {
									return _Utils_update(
										input,
										{
											eq: A2($elm$core$String$filter, $elm$core$Char$isDigit, document)
										});
								}),
							pO: function ($) {
								return $.eq;
							}
						},
						A2(
							$author$project$Form$Text$withExtraAttrs,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$maxlength(maxLength)
								]),
							$author$project$Form$Text$asNumeric(
								A2(
									$author$project$Form$Text$withPlaceholder,
									placeholder,
									$author$project$Form$Text$init(
										{R: 'document.input', nC: label})))));
				}),
			A2(
				$author$project$Form$with,
				A3(
					$author$project$Form$select,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Profile$EditKycForm$docFromString,
						$elm$core$Maybe$withDefault(0)),
					{
						ab: $elm$core$Basics$always($elm$core$Maybe$Nothing),
						af: $elm$core$Result$Ok,
						n: F2(
							function (documentType, input) {
								return _Utils_update(
									input,
									{er: documentType});
							}),
						pO: function ($) {
							return $.er;
						}
					},
					A2(
						$author$project$Form$Select$withContainerAttrs,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('mb-10')
							]),
						A3(
							$author$project$Form$Select$withOption,
							2,
							t('register.form.document.nite.label'),
							A3(
								$author$project$Form$Select$withOption,
								1,
								t('register.form.document.dimex.label'),
								A3(
									$author$project$Form$Select$withOption,
									0,
									t('register.form.document.cedula_de_identidad.label'),
									$author$project$Form$Select$init(
										{
											R: 'document-type-select',
											nC: t('register.form.document.type'),
											dG: $author$project$Profile$EditKycForm$docToString
										})))))),
				$author$project$Form$succeed($author$project$Profile$EditKycForm$FormOutput))));
};
var $elm$html$Html$form = _VirtualDom_node('form');
var $elm$core$Dict$isEmpty = function (dict) {
	if (dict.$ === -2) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Set$isEmpty = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$isEmpty(dict);
};
var $author$project$Form$hasFieldsLoading = function (_v0) {
	var model = _v0;
	return !$elm$core$Set$isEmpty(model.f7);
};
var $elm$html$Html$Attributes$novalidate = $elm$html$Html$Attributes$boolProperty('noValidate');
var $elm$html$Html$Events$alwaysPreventDefault = function (msg) {
	return _Utils_Tuple2(msg, true);
};
var $elm$virtual_dom$VirtualDom$MayPreventDefault = function (a) {
	return {$: 2, a: a};
};
var $elm$html$Html$Events$preventDefaultOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayPreventDefault(decoder));
	});
var $elm$html$Html$Events$onSubmit = function (msg) {
	return A2(
		$elm$html$Html$Events$preventDefaultOn,
		'submit',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysPreventDefault,
			$elm$json$Json$Decode$succeed(msg)));
};
var $elm$core$Set$member = F2(
	function (key, _v0) {
		var dict = _v0;
		return A2($elm$core$Dict$member, key, dict);
	});
var $author$project$Form$BlurredField = function (a) {
	return {$: 6, a: a};
};
var $author$project$Form$ChangedValues = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Form$Text$getErrorAttrs = function (_v0) {
	var options = _v0;
	return options.fM;
};
var $author$project$Form$Text$getSubmitOnEnter = function (_v0) {
	var options = _v0;
	var _v1 = options.fZ;
	if (_v1.$ === 1) {
		var submitOnEnter = _v1.a.pn;
		return submitOnEnter;
	} else {
		return false;
	}
};
var $author$project$Form$File$isUrlStatusEmpty = function (urlStatus) {
	switch (urlStatus.$) {
		case 0:
			return true;
		case 1:
			return false;
		case 2:
			return true;
		case 3:
			return true;
		case 4:
			return false;
		default:
			return true;
	}
};
var $author$project$Form$File$isEmpty = function (_v0) {
	var model = _v0;
	var _v1 = model.f;
	if (!_v1.$) {
		if (_v1.a.$ === 1) {
			var _v2 = _v1.a;
			return true;
		} else {
			var entry = _v1.a.a;
			return $author$project$Form$File$isUrlStatusEmpty(entry.gL);
		}
	} else {
		var entries = _v1.a;
		return $elm$core$List$isEmpty(entries) || A2(
			$elm$core$List$any,
			function (entry) {
				return !$author$project$Form$File$isUrlStatusEmpty(entry.gL);
			},
			entries);
	}
};
var $author$project$Form$UserPicker$isEmpty = function (_v0) {
	var model = _v0;
	var _v1 = model.W;
	var maybeProfile = _v1;
	return $elm_community$maybe_extra$Maybe$Extra$isNothing(maybeProfile);
};
var $author$project$Form$isEmpty = function (field_) {
	switch (field_.$) {
		case 0:
			var value = field_.b.pO;
			return $elm$core$String$isEmpty(value);
		case 1:
			var value = field_.b.pO;
			return $elm$core$String$isEmpty(
				$author$project$Markdown$toUnformattedString(
					$author$project$Form$RichText$getMarkdownContent(value)));
		case 2:
			return false;
		case 3:
			return false;
		case 4:
			return false;
		case 5:
			var value = field_.b.pO;
			return $author$project$Form$File$isEmpty(value);
		case 6:
			return false;
		case 7:
			var value = field_.b.pO;
			return $elm_community$maybe_extra$Maybe$Extra$isNothing(
				$author$project$Form$DatePicker$getDate(value));
		case 8:
			var value = field_.b.pO;
			return $author$project$Form$UserPicker$isEmpty(value);
		case 9:
			var fields = field_.b;
			return A2(
				$elm$core$List$any,
				$author$project$Form$isEmpty,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.X;
					},
					fields));
		case 10:
			return false;
		default:
			return false;
	}
};
var $elm$virtual_dom$VirtualDom$Custom = function (a) {
	return {$: 3, a: a};
};
var $elm$html$Html$Events$custom = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Custom(decoder));
	});
var $elm$html$Html$Events$keyCode = A2($elm$json$Json$Decode$field, 'keyCode', $elm$json$Json$Decode$int);
var $author$project$Form$submitOnEnter = F3(
	function (form, model, msgs) {
		var enterKeyCode = 13;
		return A2(
			$elm$html$Html$Events$custom,
			'keyup',
			A2(
				$elm$json$Json$Decode$map,
				function (code) {
					return _Utils_eq(code, enterKeyCode) ? {
						nS: A3($author$project$Form$parse, form, model, msgs),
						kF: true,
						le: true
					} : {
						nS: msgs.gi($author$project$Form$NoOp),
						kF: false,
						le: false
					};
				},
				$elm$html$Html$Events$keyCode));
	});
var $elm$html$Html$Attributes$autocomplete = function (bool) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'autocomplete',
		bool ? 'on' : 'off');
};
var $elm$html$Html$Events$targetChecked = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'checked']),
	$elm$json$Json$Decode$bool);
var $elm$html$Html$Events$onCheck = function (tagger) {
	return A2(
		$elm$html$Html$Events$on,
		'change',
		A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetChecked));
};
var $author$project$Form$Checkbox$view = F2(
	function (_v0, viewConfig) {
		var options = _v0;
		return A2(
			$elm$html$Html$div,
			options.mg,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('checkbox'),
							$elm$html$Html$Attributes$class('form-checkbox mr-2'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('with-error', viewConfig.m$)
								])),
							$elm$html$Html$Attributes$checked(viewConfig.pO),
							$elm$html$Html$Events$onCheck(viewConfig.of),
							$elm$html$Html$Attributes$id(options.R),
							$elm$html$Html$Attributes$disabled(options.cf),
							$elm$html$Html$Events$onBlur(viewConfig.od),
							$elm$html$Html$Attributes$required(viewConfig.nx),
							$elm$html$Html$Attributes$autocomplete(false)
						]),
					_List_Nil),
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$for(options.R),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('text-green', viewConfig.pO),
									_Utils_Tuple2('text-gray-900', options.cf),
									_Utils_Tuple2('with-error', viewConfig.m$)
								]))
						]),
					_List_fromArray(
						[options.nC])),
					viewConfig.mM
				]));
	});
var $author$project$View$Components$ArrowDown = 4;
var $author$project$View$Components$ArrowLeft = 5;
var $author$project$View$Components$ArrowRight = 6;
var $author$project$View$Components$ArrowUp = 3;
var $author$project$Form$DatePicker$ClickedCalendarIcon = {$: 2};
var $author$project$Form$DatePicker$ClickedClear = {$: 3};
var $author$project$Form$DatePicker$ClickedKey = function (a) {
	return {$: 4, a: a};
};
var $author$project$View$Components$Enter = 1;
var $author$project$Form$DatePicker$GotDatePickerMsg = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$View$Components$Space = 2;
var $elm$svg$Svg$Attributes$enableBackground = _VirtualDom_attribute('enable-background');
var $author$project$Icons$calendar = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$enableBackground('new 0 0 24 24'),
				$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fill('#999')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$d('m18.1 7.6h-2.5v-1.6h-.9v1.6h-5.4v-1.6h-.9v1.6h-2.5c-.4 0-.7.3-.7.7v9.4c0 .4.3.7.7.7h12.2c.4 0 .7-.3.7-.7v-9.5c-.1-.3-.4-.6-.7-.6zm-.2 9.9h-11.7v-9h2.2v1.1h.9v-1.1h5.4v1.1h.9v-1.1h2.2v9z')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$d('m7.9 11.2h.9v.9h-.9z')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$d('m10.4 11.2h.9v.9h-.9z')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$d('m12.7 11.2h.9v.9h-.9z')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$d('m15.1 11.2h.9v.9h-.9z')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$d('m7.9 13.2h.9v.9h-.9z')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$d('m10.4 13.2h.9v.9h-.9z')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$d('m12.7 13.2h.9v.9h-.9z')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$d('m15.1 13.2h.9v.9h-.9z')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$d('m7.9 15.2h.9v.9h-.9z')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$d('m10.4 15.2h.9v.9h-.9z')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$d('m12.7 15.2h.9v.9h-.9z')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$d('m15.1 15.2h.9v.9h-.9z')
							]),
						_List_Nil)
					]))
			]));
};
var $author$project$View$Components$Escape = 0;
var $author$project$View$Components$boolToString = function (b) {
	return b ? 'true' : 'false';
};
var $author$project$View$Components$keyListener = function (_v0) {
	var acceptedKeys = _v0.lL;
	var toMsg = _v0.pA;
	var stopPropagation = _v0.le;
	var preventDefault = _v0.kF;
	var keyToString = function (key) {
		switch (key) {
			case 0:
				return _List_fromArray(
					['esc', 'escape']);
			case 2:
				return _List_fromArray(
					[' ']);
			case 1:
				return _List_fromArray(
					['enter']);
			case 3:
				return _List_fromArray(
					['arrowup']);
			case 4:
				return _List_fromArray(
					['arrowdown']);
			case 5:
				return _List_fromArray(
					['arrowleft']);
			default:
				return _List_fromArray(
					['arrowright']);
		}
	};
	var keyFromString = function (rawKey) {
		var _v2 = $elm$core$String$toLower(rawKey);
		switch (_v2) {
			case 'esc':
				return $elm$core$Maybe$Just(0);
			case 'escape':
				return $elm$core$Maybe$Just(0);
			case ' ':
				return $elm$core$Maybe$Just(2);
			case 'enter':
				return $elm$core$Maybe$Just(1);
			case 'arrowup':
				return $elm$core$Maybe$Just(3);
			case 'arrowdown':
				return $elm$core$Maybe$Just(4);
			case 'arrowleft':
				return $elm$core$Maybe$Just(5);
			case 'arrowright':
				return $elm$core$Maybe$Just(6);
			default:
				return $elm$core$Maybe$Nothing;
		}
	};
	var keyDecoder = F2(
		function (acceptedKeys_, toMsg_) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (rawKey) {
					var _v1 = keyFromString(rawKey);
					if (!_v1.$) {
						var key = _v1.a;
						return A2($elm$core$List$member, key, acceptedKeys_) ? $elm$json$Json$Decode$succeed(
							toMsg_(key)) : $elm$json$Json$Decode$fail('This key is not being listened to');
					} else {
						return $elm$json$Json$Decode$fail('The given key is not registered as a Key that the keyListener can listen to');
					}
				},
				A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['detail', 'key']),
					$elm$json$Json$Decode$string));
		});
	return A3(
		$elm$html$Html$node,
		'key-listener',
		_List_fromArray(
			[
				A2(
				$elm$html$Html$Events$on,
				'listener-keydown',
				A2(keyDecoder, acceptedKeys, toMsg)),
				A2(
				$elm$html$Html$Attributes$attribute,
				'keydown-stop-propagation',
				$author$project$View$Components$boolToString(stopPropagation)),
				A2(
				$elm$html$Html$Attributes$attribute,
				'keydown-prevent-default',
				$author$project$View$Components$boolToString(preventDefault)),
				A2(
				$elm$html$Html$Attributes$attribute,
				'accepted-keys',
				A2(
					$elm$core$String$join,
					',',
					A2($elm$core$List$concatMap, keyToString, acceptedKeys)))
			]),
		_List_Nil);
};
var $author$project$Icons$trash = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('24'),
				$elm$svg$Svg$Attributes$height('24'),
				$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenOdd'),
						$elm$svg$Svg$Attributes$d('M20.3077 5.16788H16.3477C15.6644 3.41192 13.9331 2.25 12 2.25C10.0669 2.25 8.33558 3.41192 7.65231 5.16788H3.69231C3.30996 5.16788 3 5.46885 3 5.84013C3 6.2114 3.30996 6.51237 3.69231 6.51237H4.15385V20.4055C4.15385 21.148 4.77376 21.75 5.53846 21.75H18C18.7647 21.75 19.3846 21.148 19.3846 20.4055V6.51237H20.3077C20.69 6.51237 21 6.2114 21 5.84013C21 5.46885 20.69 5.16788 20.3077 5.16788ZM12 3.5993C13.26 3.5993 14.3538 4.04746 14.8938 5.16788H9.10615C9.64615 4.04298 10.74 3.5993 12 3.5993ZM18 20.4055H16.1538V12.7867C16.1538 12.4154 15.8439 12.1144 15.4615 12.1144C15.0792 12.1144 14.7692 12.4154 14.7692 12.7867V20.4055H12.4615V10.0977C12.4615 9.72643 12.1516 9.42545 11.7692 9.42545C11.3869 9.42545 11.0769 9.72643 11.0769 10.0977V20.4055H8.76923V12.7867C8.76923 12.4154 8.45927 12.1144 8.07692 12.1144C7.69457 12.1144 7.38462 12.4154 7.38462 12.7867V20.4055H5.53846V6.51237H18V20.4055Z'),
						$elm$svg$Svg$Attributes$fill('currentColor')
					]),
				_List_Nil)
			]));
};
var $CurrySoftware$elm_datepicker$DatePicker$Blur = {$: 6};
var $CurrySoftware$elm_datepicker$DatePicker$SubmitText = {$: 4};
var $CurrySoftware$elm_datepicker$DatePicker$Text = function (a) {
	return {$: 3, a: a};
};
var $CurrySoftware$elm_datepicker$DatePicker$ChangeFocus = function (a) {
	return {$: 1, a: a};
};
var $CurrySoftware$elm_datepicker$DatePicker$MouseDown = {$: 7};
var $CurrySoftware$elm_datepicker$DatePicker$MouseUp = {$: 8};
var $CurrySoftware$elm_datepicker$DatePicker$Date$changeYear = F2(
	function (current, newYear) {
		var _v0 = $elm$core$String$toInt(newYear);
		if (!_v0.$) {
			var year = _v0.a;
			return A3(
				$justinmimbs$date$Date$fromCalendarDate,
				year,
				$justinmimbs$date$Date$month(current),
				$justinmimbs$date$Date$day(current));
		} else {
			return current;
		}
	});
var $CurrySoftware$elm_datepicker$DatePicker$groupDates = function (dates) {
	var go = F4(
		function (i, xs, racc, acc) {
			go:
			while (true) {
				if (!xs.b) {
					return $elm$core$List$reverse(acc);
				} else {
					var x = xs.a;
					var xxs = xs.b;
					if (i === 6) {
						var $temp$i = 0,
							$temp$xs = xxs,
							$temp$racc = _List_Nil,
							$temp$acc = A2(
							$elm$core$List$cons,
							$elm$core$List$reverse(
								A2($elm$core$List$cons, x, racc)),
							acc);
						i = $temp$i;
						xs = $temp$xs;
						racc = $temp$racc;
						acc = $temp$acc;
						continue go;
					} else {
						var $temp$i = i + 1,
							$temp$xs = xxs,
							$temp$racc = A2($elm$core$List$cons, x, racc),
							$temp$acc = acc;
						i = $temp$i;
						xs = $temp$xs;
						racc = $temp$racc;
						acc = $temp$acc;
						continue go;
					}
				}
			}
		});
	return A4(go, 0, dates, _List_Nil, _List_Nil);
};
var $CurrySoftware$elm_datepicker$DatePicker$maybeOr = F2(
	function (lhs, rhs) {
		if (!rhs.$) {
			return rhs;
		} else {
			return lhs;
		}
	});
var $CurrySoftware$elm_datepicker$DatePicker$mkClass = F2(
	function (_v0, c) {
		var classNamespace = _v0.c0;
		return $elm$html$Html$Attributes$class(
			_Utils_ap(classNamespace, c));
	});
var $elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
	return _VirtualDom_keyedNode(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$Keyed$node = $elm$virtual_dom$VirtualDom$keyedNode;
var $elm$html$Html$option = _VirtualDom_node('option');
var $justinmimbs$date$Date$Day = 11;
var $justinmimbs$date$Date$weekdayToNumber = function (wd) {
	switch (wd) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		default:
			return 7;
	}
};
var $justinmimbs$date$Date$daysSincePreviousWeekday = F2(
	function (wd, date) {
		return A2(
			$elm$core$Basics$modBy,
			7,
			($justinmimbs$date$Date$weekdayNumber(date) + 7) - $justinmimbs$date$Date$weekdayToNumber(wd));
	});
var $justinmimbs$date$Date$firstOfMonth = F2(
	function (y, m) {
		return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + 1;
	});
var $justinmimbs$date$Date$quarterToMonth = function (q) {
	return $justinmimbs$date$Date$numberToMonth((q * 3) - 2);
};
var $justinmimbs$date$Date$floor = F2(
	function (interval, date) {
		var rd = date;
		switch (interval) {
			case 0:
				return $justinmimbs$date$Date$firstOfYear(
					$justinmimbs$date$Date$year(date));
			case 1:
				return A2(
					$justinmimbs$date$Date$firstOfMonth,
					$justinmimbs$date$Date$year(date),
					$justinmimbs$date$Date$quarterToMonth(
						$justinmimbs$date$Date$quarter(date)));
			case 2:
				return A2(
					$justinmimbs$date$Date$firstOfMonth,
					$justinmimbs$date$Date$year(date),
					$justinmimbs$date$Date$month(date));
			case 3:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 0, date);
			case 4:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 0, date);
			case 5:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 1, date);
			case 6:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 2, date);
			case 7:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 3, date);
			case 8:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 4, date);
			case 9:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 5, date);
			case 10:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 6, date);
			default:
				return date;
		}
	});
var $justinmimbs$date$Date$Weeks = 2;
var $justinmimbs$date$Date$Years = 0;
var $justinmimbs$date$Date$intervalToUnits = function (interval) {
	switch (interval) {
		case 0:
			return _Utils_Tuple2(1, 0);
		case 1:
			return _Utils_Tuple2(3, 1);
		case 2:
			return _Utils_Tuple2(1, 1);
		case 11:
			return _Utils_Tuple2(1, 3);
		default:
			var week = interval;
			return _Utils_Tuple2(1, 2);
	}
};
var $justinmimbs$date$Date$ceiling = F2(
	function (interval, date) {
		var floored = A2($justinmimbs$date$Date$floor, interval, date);
		if (_Utils_eq(date, floored)) {
			return date;
		} else {
			var _v0 = $justinmimbs$date$Date$intervalToUnits(interval);
			var n = _v0.a;
			var unit = _v0.b;
			return A3($justinmimbs$date$Date$add, unit, n, floored);
		}
	});
var $justinmimbs$date$Date$rangeHelp = F5(
	function (unit, step, until, revList, current) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(current, until) < 0) {
				var _v0 = A3($justinmimbs$date$Date$add, unit, step, current);
				var next = _v0;
				var $temp$unit = unit,
					$temp$step = step,
					$temp$until = until,
					$temp$revList = A2($elm$core$List$cons, current, revList),
					$temp$current = next;
				unit = $temp$unit;
				step = $temp$step;
				until = $temp$until;
				revList = $temp$revList;
				current = $temp$current;
				continue rangeHelp;
			} else {
				return $elm$core$List$reverse(revList);
			}
		}
	});
var $justinmimbs$date$Date$range = F4(
	function (interval, step, _v0, _v1) {
		var start = _v0;
		var until = _v1;
		var _v2 = $justinmimbs$date$Date$intervalToUnits(interval);
		var n = _v2.a;
		var unit = _v2.b;
		var _v3 = A2($justinmimbs$date$Date$ceiling, interval, start);
		var first = _v3;
		return (_Utils_cmp(first, until) < 0) ? A5(
			$justinmimbs$date$Date$rangeHelp,
			unit,
			A2($elm$core$Basics$max, 1, step) * n,
			until,
			_List_Nil,
			first) : _List_Nil;
	});
var $justinmimbs$date$Date$Friday = 8;
var $justinmimbs$date$Date$Monday = 4;
var $justinmimbs$date$Date$Saturday = 9;
var $justinmimbs$date$Date$Sunday = 10;
var $justinmimbs$date$Date$Thursday = 7;
var $justinmimbs$date$Date$Tuesday = 5;
var $justinmimbs$date$Date$Wednesday = 6;
var $CurrySoftware$elm_datepicker$DatePicker$Date$weekdayToInterval = function (weekday) {
	switch (weekday) {
		case 0:
			return 4;
		case 1:
			return 5;
		case 2:
			return 6;
		case 3:
			return 7;
		case 4:
			return 8;
		case 5:
			return 9;
		default:
			return 10;
	}
};
var $CurrySoftware$elm_datepicker$DatePicker$prepareDates = F2(
	function (date, firstDayOfWeek) {
		var weekdayAsInterval = $CurrySoftware$elm_datepicker$DatePicker$Date$weekdayToInterval(firstDayOfWeek);
		var start = A2(
			$justinmimbs$date$Date$floor,
			weekdayAsInterval,
			A3(
				$justinmimbs$date$Date$fromCalendarDate,
				$justinmimbs$date$Date$year(date),
				$justinmimbs$date$Date$month(date),
				1));
		var firstOfMonth = A3(
			$justinmimbs$date$Date$fromCalendarDate,
			$justinmimbs$date$Date$year(date),
			$justinmimbs$date$Date$month(date),
			1);
		var end = A2(
			$justinmimbs$date$Date$ceiling,
			weekdayAsInterval,
			A3($justinmimbs$date$Date$add, 1, 1, firstOfMonth));
		return {
			i7: A4($justinmimbs$date$Date$range, 11, 1, start, end),
			g7: date
		};
	});
var $elm$html$Html$Attributes$selected = $elm$html$Html$Attributes$boolProperty('selected');
var $justinmimbs$date$Date$toRataDie = function (_v0) {
	var rd = _v0;
	return rd;
};
var $CurrySoftware$elm_datepicker$DatePicker$mkClassList = F2(
	function (_v0, cs) {
		var classNamespace = _v0.c0;
		return $elm$html$Html$Attributes$classList(
			A2(
				$elm$core$List$map,
				function (_v1) {
					var c = _v1.a;
					var b = _v1.b;
					return _Utils_Tuple2(
						_Utils_ap(classNamespace, c),
						b);
				},
				cs));
	});
var $CurrySoftware$elm_datepicker$DatePicker$viewDay = F5(
	function (settings, picked, isOtherMonth, isToday, d) {
		var disabled = settings.ns(d);
		var props = (!disabled) ? _List_fromArray(
			[
				$elm$html$Html$Events$onClick(
				$CurrySoftware$elm_datepicker$DatePicker$Pick(d))
			]) : _List_Nil;
		var classList = $CurrySoftware$elm_datepicker$DatePicker$mkClassList(settings);
		return A2(
			$elm$html$Html$td,
			_Utils_ap(
				_List_fromArray(
					[
						classList(
						_List_fromArray(
							[
								_Utils_Tuple2('day', true),
								_Utils_Tuple2('disabled', disabled),
								_Utils_Tuple2(
								'picked',
								picked(d)),
								_Utils_Tuple2(
								'today',
								isToday(d)),
								_Utils_Tuple2(
								'other-month',
								isOtherMonth(d))
							]))
					]),
				props),
			_List_fromArray(
				[
					settings.gZ(
					$elm$core$String$fromInt(
						$justinmimbs$date$Date$day(d)))
				]));
	});
var $CurrySoftware$elm_datepicker$DatePicker$Date$yearRange = F2(
	function (_v0, range) {
		var currentMonth = _v0.g7;
		var today = _v0.pB;
		switch (range.$) {
			case 1:
				var num = range.a;
				return A2(
					$elm$core$List$range,
					$justinmimbs$date$Date$year(currentMonth) - num,
					$justinmimbs$date$Date$year(currentMonth) + num);
			case 2:
				var start = range.a;
				var end = range.b;
				return A2($elm$core$List$range, start, end);
			case 3:
				var year_ = range.a;
				return A2(
					$elm$core$List$range,
					year_,
					$justinmimbs$date$Date$year(today));
			case 4:
				var year_ = range.a;
				return A2(
					$elm$core$List$range,
					$justinmimbs$date$Date$year(today),
					year_);
			default:
				return _List_Nil;
		}
	});
var $CurrySoftware$elm_datepicker$DatePicker$yearRangeActive = function (yearRange) {
	return !_Utils_eq(yearRange, $CurrySoftware$elm_datepicker$DatePicker$Date$Off);
};
var $CurrySoftware$elm_datepicker$DatePicker$datePicker = F3(
	function (pickedDate, settings, model) {
		var focused = model.av;
		var today = model.pB;
		var picked = function (d) {
			return A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					function (pdate) {
						return _Utils_eq(
							$justinmimbs$date$Date$toRataDie(pdate),
							$justinmimbs$date$Date$toRataDie(d));
					},
					pickedDate));
		};
		var onChange = function (handler) {
			return A2(
				$elm$html$Html$Events$on,
				'change',
				A2($elm$json$Json$Decode$map, handler, $elm$html$Html$Events$targetValue));
		};
		var isToday = function (d) {
			return _Utils_eq(
				$justinmimbs$date$Date$toRataDie(d),
				$justinmimbs$date$Date$toRataDie(today));
		};
		var firstDayOffset = $justinmimbs$date$Date$weekdayToNumber(settings.fP) - 1;
		var dpClass = $CurrySoftware$elm_datepicker$DatePicker$mkClass(settings);
		var currentDate = A2(
			$elm$core$Maybe$withDefault,
			today,
			A2($CurrySoftware$elm_datepicker$DatePicker$maybeOr, pickedDate, focused));
		var isOtherMonth = function (d) {
			return !_Utils_eq(
				$justinmimbs$date$Date$month(currentDate),
				$justinmimbs$date$Date$month(d));
		};
		var arrow = F2(
			function (className, message) {
				return A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							dpClass(className),
							$elm$html$Html$Events$onClick(message),
							$elm$html$Html$Attributes$tabindex(-1),
							$elm$html$Html$Attributes$type_('button')
						]),
					_List_Nil);
			});
		var _v0 = A2($CurrySoftware$elm_datepicker$DatePicker$prepareDates, currentDate, settings.fP);
		var currentMonth = _v0.g7;
		var currentDates = _v0.i7;
		var dayList = A2(
			$elm$core$List$map,
			function (rowDays) {
				return A2(
					$elm$html$Html$tr,
					_List_fromArray(
						[
							dpClass('row')
						]),
					A2(
						$elm$core$List$map,
						A4($CurrySoftware$elm_datepicker$DatePicker$viewDay, settings, picked, isOtherMonth, isToday),
						rowDays));
			},
			$CurrySoftware$elm_datepicker$DatePicker$groupDates(currentDates));
		var isCurrentYear = function (selectedYear) {
			return _Utils_eq(
				$justinmimbs$date$Date$year(currentMonth),
				selectedYear);
		};
		var yearOption = F2(
			function (index, selectedYear) {
				return _Utils_Tuple2(
					$elm$core$String$fromInt(index),
					A2(
						$elm$html$Html$option,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$value(
								$elm$core$String$fromInt(selectedYear)),
								$elm$html$Html$Attributes$selected(
								isCurrentYear(selectedYear))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm$core$String$fromInt(selectedYear))
							])));
			});
		var _v1 = function () {
			var front = function (to_) {
				return A2(
					$elm$core$List$range,
					$justinmimbs$date$Date$year(currentMonth),
					to_);
			};
			var back = function (from_) {
				return A2(
					$elm$core$List$range,
					from_,
					$justinmimbs$date$Date$year(currentMonth));
			};
			var _v2 = settings.l2;
			switch (_v2.$) {
				case 3:
					var from_ = _v2.a;
					return _Utils_Tuple2(
						front(from_ - 1),
						back(
							$justinmimbs$date$Date$year(today) + 1));
				case 4:
					var to_ = _v2.a;
					return _Utils_Tuple2(
						front(
							$justinmimbs$date$Date$year(today) - 1),
						back(to_ + 1));
				case 2:
					var from_ = _v2.a;
					var to_ = _v2.b;
					return _Utils_Tuple2(
						front(from_ - 1),
						back(to_ + 1));
				case 1:
					var y = _v2.a;
					return _Utils_Tuple2(_List_Nil, _List_Nil);
				default:
					return _Utils_Tuple2(_List_Nil, _List_Nil);
			}
		}();
		var addedYearsFront = _v1.a;
		var addedYearsBack = _v1.b;
		var dropdownYear = A3(
			$elm$html$Html$Keyed$node,
			'select',
			_List_fromArray(
				[
					onChange(
					A2(
						$elm$core$Basics$composeR,
						$CurrySoftware$elm_datepicker$DatePicker$Date$changeYear(currentDate),
						$CurrySoftware$elm_datepicker$DatePicker$ChangeFocus)),
					dpClass('year-menu')
				]),
			A2(
				$elm$core$List$indexedMap,
				yearOption,
				$elm$core$List$concat(
					_List_fromArray(
						[
							addedYearsFront,
							A2(
							$CurrySoftware$elm_datepicker$DatePicker$Date$yearRange,
							{g7: currentMonth, pB: today},
							settings.l2),
							addedYearsBack
						]))));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					dpClass('picker'),
					A2(
					$elm$html$Html$Events$stopPropagationOn,
					'mousedown',
					$elm$json$Json$Decode$succeed(
						_Utils_Tuple2($CurrySoftware$elm_datepicker$DatePicker$MouseDown, true))),
					A2(
					$elm$html$Html$Events$stopPropagationOn,
					'mouseup',
					$elm$json$Json$Decode$succeed(
						_Utils_Tuple2($CurrySoftware$elm_datepicker$DatePicker$MouseUp, true)))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							dpClass('picker-header')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									dpClass('prev-container')
								]),
							_List_fromArray(
								[
									A2(
									arrow,
									'prev',
									$CurrySoftware$elm_datepicker$DatePicker$ChangeFocus(
										A3($justinmimbs$date$Date$add, 1, -1, currentDate)))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									dpClass('month-container')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											dpClass('month')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											settings.hL(
												$justinmimbs$date$Date$month(currentMonth)))
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											dpClass('year')
										]),
									_List_fromArray(
										[
											(!$CurrySoftware$elm_datepicker$DatePicker$yearRangeActive(settings.l2)) ? $elm$html$Html$text(
											settings.iF(
												$justinmimbs$date$Date$year(currentMonth))) : A3(
											$elm$html$Html$Keyed$node,
											'span',
											_List_Nil,
											_List_fromArray(
												[
													_Utils_Tuple2(
													$elm$core$String$fromInt(
														$justinmimbs$date$Date$year(currentMonth)),
													dropdownYear)
												]))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									dpClass('next-container')
								]),
							_List_fromArray(
								[
									A2(
									arrow,
									'next',
									$CurrySoftware$elm_datepicker$DatePicker$ChangeFocus(
										A3($justinmimbs$date$Date$add, 1, 1, currentDate)))
								]))
						])),
					A2(
					$elm$html$Html$table,
					_List_fromArray(
						[
							dpClass('table')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$thead,
							_List_fromArray(
								[
									dpClass('weekdays')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									A2(
										$elm$core$List$map,
										function (d) {
											return A2(
												$elm$html$Html$td,
												_List_fromArray(
													[
														dpClass('dow')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														settings.g8(d))
													]));
										},
										A2(
											$elm$core$List$take,
											7,
											A2(
												$elm$core$List$drop,
												firstDayOffset,
												$elm$core$List$concat(
													A2(
														$elm$core$List$repeat,
														2,
														_List_fromArray(
															[0, 1, 2, 3, 4, 5, 6])))))))
								])),
							A2(
							$elm$html$Html$tbody,
							_List_fromArray(
								[
									dpClass('days')
								]),
							dayList)
						]))
				]));
	});
var $elm$html$Html$Attributes$name = $elm$html$Html$Attributes$stringProperty('name');
var $elm$html$Html$Events$onFocus = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'focus',
		$elm$json$Json$Decode$succeed(msg));
};
var $CurrySoftware$elm_datepicker$DatePicker$view = F3(
	function (pickedDate, settings, _v0) {
		var datepicker = _v0;
		var model = datepicker;
		var potentialInputId = A3(
			$elm$core$Basics$composeR,
			$elm$core$List$singleton,
			$elm$core$List$filterMap($elm$core$Basics$identity),
			A2($elm$core$Maybe$map, $elm$html$Html$Attributes$id, settings.np));
		var inputClasses = _Utils_ap(
			_List_fromArray(
				[
					_Utils_Tuple2(settings.c0 + 'input', true)
				]),
			settings.no);
		var inputCommon = function (xs) {
			return A2(
				$elm$html$Html$input,
				_Utils_ap(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(inputClasses),
							$elm$html$Html$Attributes$name(
							A2($elm$core$Maybe$withDefault, '', settings.ht)),
							$elm$html$Html$Attributes$type_('text'),
							A2(
							$elm$html$Html$Events$on,
							'change',
							$elm$json$Json$Decode$succeed($CurrySoftware$elm_datepicker$DatePicker$SubmitText)),
							$elm$html$Html$Events$onInput($CurrySoftware$elm_datepicker$DatePicker$Text),
							$elm$html$Html$Events$onBlur($CurrySoftware$elm_datepicker$DatePicker$Blur),
							$elm$html$Html$Events$onClick($CurrySoftware$elm_datepicker$DatePicker$Focus),
							$elm$html$Html$Events$onFocus($CurrySoftware$elm_datepicker$DatePicker$Focus)
						]),
					_Utils_ap(
						settings.nm,
						_Utils_ap(potentialInputId, xs))),
				_List_Nil);
		};
		var dateInput = inputCommon(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$placeholder(settings.oG),
					$elm$html$Html$Attributes$value(
					A2(
						$elm$core$Maybe$withDefault,
						A2(
							$elm$core$Maybe$withDefault,
							'',
							A2($elm$core$Maybe$map, settings.mx, pickedDate)),
						model.aY))
				]));
		var containerClassList = A2(
			$elm$core$List$cons,
			_Utils_Tuple2(settings.c0 + 'container', true),
			settings.mi);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(containerClassList)
				]),
			_List_fromArray(
				[
					dateInput,
					model.bj ? A3($CurrySoftware$elm_datepicker$DatePicker$datePicker, pickedDate, settings, model) : $elm$html$Html$text('')
				]));
	});
var $author$project$Form$DatePicker$view = F3(
	function (wrappedOptions, viewConfig, toMsg) {
		var options = wrappedOptions;
		var _v0 = viewConfig.pO;
		var model = _v0;
		return A2(
			$elm$html$Html$div,
			options.mg,
			_List_fromArray(
				[
					A2(
					$author$project$View$Components$label,
					_List_Nil,
					{nD: options.nC, pv: options.R}),
					A2(
					$elm$html$Html$map,
					toMsg,
					A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('relative w-full')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$Form$DatePicker$GotDatePickerMsg(
											{d2: false}),
										A3(
											$CurrySoftware$elm_datepicker$DatePicker$view,
											model.bQ,
											A2($author$project$Form$DatePicker$settings, wrappedOptions, viewConfig),
											model.cC)),
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('absolute right-0 top-0 focus:outline-none'),
												$elm$html$Html$Attributes$tabindex(-1),
												$elm$html$Html$Events$onClick($author$project$Form$DatePicker$ClickedCalendarIcon),
												$fapian$elm_html_aria$Html$Attributes$Aria$ariaLabel(
												viewConfig.iw.il('dates.select')),
												$elm$html$Html$Attributes$type_('button'),
												$elm$html$Html$Attributes$disabled(options.cf)
											]),
										_List_fromArray(
											[
												$author$project$Icons$calendar('h-12')
											]))
									])),
								$elm_community$maybe_extra$Maybe$Extra$isJust(model.bQ) ? A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('h-12 ml-4 group focus-ring rounded-sm focus-visible:ring-red focus-visible:ring-opacity-30'),
										$elm$html$Html$Events$onClick($author$project$Form$DatePicker$ClickedClear),
										$fapian$elm_html_aria$Html$Attributes$Aria$ariaLabel(
										viewConfig.iw.il('dates.clear')),
										$elm$html$Html$Attributes$type_('button'),
										$elm$html$Html$Attributes$disabled(options.cf)
									]),
								_List_fromArray(
									[
										$author$project$Icons$trash('text-red group-hover:opacity-80')
									])) : $elm$html$Html$text('')
							]))),
					viewConfig.mM,
					$CurrySoftware$elm_datepicker$DatePicker$isOpen(model.cC) ? $author$project$View$Components$keyListener(
					{
						lL: _List_fromArray(
							[2, 1, 3, 4, 5, 6]),
						kF: true,
						le: true,
						pA: A2($elm$core$Basics$composeR, $author$project$Form$DatePicker$ClickedKey, toMsg)
					}) : $elm$html$Html$text('')
				]));
	});
var $author$project$Form$File$toSingleModel = function (_v0) {
	var model = _v0;
	return {
		q: model.q,
		ev: function () {
			var _v1 = model.f;
			if (!_v1.$) {
				var maybeEntry = _v1.a;
				return maybeEntry;
			} else {
				var entries = _v1.a;
				return $elm$core$List$head(entries);
			}
		}(),
		hv: model.G > 0,
		f$: $elm_community$maybe_extra$Maybe$Extra$isJust(model.t),
		ae: model.ae,
		j: model.j
	};
};
var $author$project$Form$File$fromNeverAttributes = $elm$core$List$map(
	$elm$html$Html$Attributes$map($elm$core$Basics$never));
var $elm$html$Html$Keyed$ul = $elm$html$Html$Keyed$node('ul');
var $author$project$Form$File$ClickedEntry = function (a) {
	return {$: 3, a: a};
};
var $author$project$Icons$plus = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$class(class_),
				$elm$svg$Svg$Attributes$width('26'),
				$elm$svg$Svg$Attributes$height('26'),
				$elm$svg$Svg$Attributes$viewBox('0 0 26 26'),
				$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M24.2829 12.0329H13.9671V1.71711C13.9671 1.18299 13.5341 0.75 13 0.75C12.4659 0.75 12.0329 1.18299 12.0329 1.71711V12.0329H1.71711C1.18299 12.0329 0.75 12.4659 0.75 13C0.75 13.5341 1.18299 13.9671 1.71711 13.9671H12.0329V24.2829C12.0329 24.817 12.4659 25.25 13 25.25C13.5341 25.25 13.9671 24.817 13.9671 24.2829V13.9671H24.2829C24.817 13.9671 25.25 13.5341 25.25 13C25.25 12.4659 24.817 12.0329 24.2829 12.0329Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Form$File$defaultAddImagesView = function (attrs) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('p-2 bg-gray-100 flex items-center justify-center w-24 h-24 rounded hover:bg-gray-200'),
				attrs),
			_List_fromArray(
				[
					$author$project$Icons$plus('text-orange-300 fill-current')
				]))
		]);
};
var $author$project$Form$File$RequestedUploadFiles = function (a) {
	return {$: 0, a: a};
};
var $elm$html$Html$Attributes$accept = $elm$html$Html$Attributes$stringProperty('accept');
var $author$project$Form$File$fileTypeToString = function (fileType) {
	if (fileType === 1) {
		return 'image/*';
	} else {
		return 'application/pdf';
	}
};
var $author$project$Form$File$acceptFileTypes = function (fileTypes) {
	return $elm$html$Html$Attributes$accept(
		A2(
			$elm$core$String$join,
			',',
			A2($elm$core$List$map, $author$project$Form$File$fileTypeToString, fileTypes)));
};
var $elm$file$File$decoder = _File_decoder;
var $elm$html$Html$Attributes$multiple = $elm$html$Html$Attributes$boolProperty('multiple');
var $author$project$Form$File$viewInput = F3(
	function (_v0, viewConfig, _v1) {
		var options = _v0;
		var allowMultiple = _v1.d8;
		return A2(
			$elm$html$Html$input,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$type_('file'),
					$elm$html$Html$Attributes$id(options.R),
					$elm$html$Html$Attributes$class('sr-only form-file'),
					A2(
					$elm$html$Html$Events$on,
					'change',
					A2(
						$elm$json$Json$Decode$map,
						$author$project$Form$File$RequestedUploadFiles,
						A2(
							$elm$json$Json$Decode$at,
							_List_fromArray(
								['target', 'files']),
							$elm$json$Json$Decode$list($elm$file$File$decoder)))),
					$elm$html$Html$Attributes$multiple(allowMultiple),
					$author$project$Form$File$acceptFileTypes(options.hg),
					$elm$html$Html$Attributes$disabled(options.cf),
					$elm$html$Html$Attributes$required(viewConfig.nx)
				]),
			_List_Nil);
	});
var $author$project$Form$File$viewAddImages = F4(
	function (_v0, _v1, viewConfig, toMsg) {
		var allowMultiple = _v0.d8;
		var options = _v1;
		return A2(
			$elm$html$Html$map,
			toMsg,
			A2(
				$elm$html$Html$div,
				allowMultiple ? _List_Nil : A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$class('flex flex-col'),
					$author$project$Form$File$fromNeverAttributes(options.c4)),
				_List_fromArray(
					[
						function () {
						if (allowMultiple) {
							return $elm$html$Html$text('');
						} else {
							var _v2 = options.nC;
							if (_v2.$ === 1) {
								return $elm$html$Html$text('');
							} else {
								var label = _v2.a;
								return A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('label w-max focus-ring'),
											$elm$html$Html$Events$onClick(
											$author$project$Form$File$ClickedEntry(0)),
											$elm$html$Html$Attributes$disabled(options.cf),
											$elm$html$Html$Attributes$type_('button')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(label)
										]));
							}
						}
					}(),
						A3(
						$author$project$Form$File$viewInput,
						options,
						viewConfig,
						{d8: allowMultiple}),
						A2(
						$elm$html$Html$label,
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$for(options.R),
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$class('cursor-pointer flex file-decoration w-max'),
								$author$project$Form$File$fromNeverAttributes(options.iI))),
						A2(
							$elm$core$List$map,
							$elm$html$Html$map($elm$core$Basics$never),
							A2(
								$elm$core$Maybe$withDefault,
								$author$project$Form$File$defaultAddImagesView(_List_Nil),
								options.gO)))
					])));
	});
var $author$project$Form$File$DiscoveredFileType = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Icons$exclamation = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('24'),
				$elm$svg$Svg$Attributes$height('24'),
				$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
				$elm$svg$Svg$Attributes$class(class_),
				$elm$svg$Svg$Attributes$fill('currentColor')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20101 17.799 1.5 12 1.5ZM12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21Z')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M12.25 5.75C11.8358 5.75 11.5 6.08579 11.5 6.5V13.5C11.5 13.9142 11.8358 14.25 12.25 14.25C12.6642 14.25 13 13.9142 13 13.5V6.5C13 6.08579 12.6642 5.75 12.25 5.75Z')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M12.25 17C12.6642 17 13 16.6642 13 16.25C13 15.8358 12.6642 15.5 12.25 15.5C11.8358 15.5 11.5 15.8358 11.5 16.25C11.5 16.6642 11.8358 17 12.25 17Z')
					]),
				_List_Nil)
			]));
};
var $author$project$View$Components$loadingLogoWithNoText = function (class_) {
	return A2(
		$elm$html$Html$img,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class(class_),
				$elm$html$Html$Attributes$src('/images/loading.svg')
			]),
		_List_Nil);
};
var $author$project$View$Components$Image = 1;
var $author$project$View$Components$Pdf = 0;
var $author$project$View$Components$pdfViewer = F2(
	function (attrs, _v0) {
		var url = _v0.gL;
		var childClass = _v0.g$;
		var maybeTranslators = _v0.hF;
		var onFileTypeDiscovered = _v0.hW;
		var loadingAttributes = function () {
			if (maybeTranslators.$ === 1) {
				return _List_Nil;
			} else {
				var t = maybeTranslators.a.il;
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$Attributes$attribute,
						'elm-loading-title',
						t('loading.title')),
						A2(
						$elm$html$Html$Attributes$attribute,
						'elm-loading-subtitle',
						t('loading.subtitle'))
					]);
			}
		}();
		var fileTypeDiscoveredListener = function () {
			if (onFileTypeDiscovered.$ === 1) {
				return $elm$html$Html$Attributes$class('');
			} else {
				var eventListener = onFileTypeDiscovered.a;
				return A2(
					$elm$html$Html$Events$on,
					'file-type-discovered',
					A2(
						$elm$json$Json$Decode$andThen,
						function (stringFileType) {
							switch (stringFileType) {
								case 'image':
									return $elm$json$Json$Decode$succeed(
										eventListener(1));
								case 'pdf':
									return $elm$json$Json$Decode$succeed(
										eventListener(0));
								default:
									return $elm$json$Json$Decode$fail('I was expecting either `image` or `pdf`, but got ' + (stringFileType + ' instead'));
							}
						},
						A2($elm$json$Json$Decode$field, 'detail', $elm$json$Json$Decode$string)));
			}
		}();
		return A3(
			$elm$html$Html$node,
			'pdf-viewer',
			A2(
				$elm$core$List$cons,
				A2($elm$html$Html$Attributes$attribute, 'elm-url', url),
				A2(
					$elm$core$List$cons,
					A2($elm$html$Html$Attributes$attribute, 'elm-child-class', childClass),
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$class('flex flex-col items-center justify-center'),
						A2(
							$elm$core$List$cons,
							fileTypeDiscoveredListener,
							_Utils_ap(loadingAttributes, attrs))))),
			_List_Nil);
	});
var $author$project$Form$File$viewEntry = F4(
	function (translators, _v0, index, entry) {
		var options = _v0;
		var buttonAriaLabel = function () {
			var _v5 = entry.aH;
			if ((_v5.$ === 1) && (_v5.a === 1)) {
				var _v6 = _v5.a;
				var _v7 = entry.ad;
				if (_v7.$ === 1) {
					return translators.il('form.file.edit_image');
				} else {
					return translators.il('form.file.edit_file');
				}
			} else {
				return translators.il('form.file.edit_file');
			}
		}();
		var viewWithUrl = function (url) {
			return A2(
				$elm$html$Html$button,
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Events$onClick(
						$author$project$Form$File$ClickedEntry(index)),
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$type_('button'),
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$class('hover:opacity-60 focus-ring'),
							A2(
								$elm$core$List$cons,
								$fapian$elm_html_aria$Html$Attributes$Aria$ariaLabel(buttonAriaLabel),
								$author$project$Form$File$fromNeverAttributes(
									options.ch(index)))))),
				_List_fromArray(
					[
						function () {
						var _v2 = entry.aH;
						if (_v2.$ === 1) {
							if (_v2.a === 1) {
								var _v3 = _v2.a;
								return A2(
									$elm$html$Html$img,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$src(url),
											$elm$html$Html$Attributes$alt(''),
											$elm$html$Html$Attributes$class(options.bG)
										]),
									_List_Nil);
							} else {
								var _v4 = _v2.a;
								return A2(
									$author$project$View$Components$pdfViewer,
									_List_Nil,
									{
										g$: options.bG,
										hF: $elm$core$Maybe$Just(translators),
										hW: $elm$core$Maybe$Nothing,
										gL: url
									});
							}
						} else {
							return A2(
								$author$project$View$Components$pdfViewer,
								_List_Nil,
								{
									g$: options.bG,
									hF: $elm$core$Maybe$Just(translators),
									hW: $elm$core$Maybe$Just(
										$author$project$Form$File$DiscoveredFileType(index)),
									gL: url
								});
						}
					}(),
						A2(
						$elm$html$Html$map,
						$elm$core$Basics$never,
						A2(
							$elm$core$Maybe$withDefault,
							$elm$html$Html$text(''),
							options.hp))
					]));
		};
		var _v1 = entry.gL;
		switch (_v1.$) {
			case 0:
				return A2(
					$elm$html$Html$div,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$class('p-4 bg-gray-100 grid place-items-center'),
						$author$project$Form$File$fromNeverAttributes(
							options.ch(index))),
					_List_fromArray(
						[
							$author$project$View$Components$loadingLogoWithNoText('max-w-27')
						]));
			case 1:
				var url = _v1.a;
				return viewWithUrl(url);
			case 2:
				var original = _v1.a.u;
				return viewWithUrl(original);
			case 3:
				return A2(
					$elm$html$Html$div,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$class('p-4 bg-gray-100 grid place-items-center'),
						$author$project$Form$File$fromNeverAttributes(
							options.ch(index))),
					_List_fromArray(
						[
							$author$project$View$Components$loadingLogoWithNoText('w-full h-full max-w-27')
						]));
			case 4:
				var croppedUrl = _v1.a.c6;
				return viewWithUrl(croppedUrl);
			default:
				return A2(
					$elm$html$Html$button,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Events$onClick(
							$author$project$Form$File$ClickedEntry(index)),
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$type_('button'),
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$class('grid place-items-center bg-gray-100'),
								$author$project$Form$File$fromNeverAttributes(
									options.ch(index))))),
					_List_fromArray(
						[
							$author$project$Icons$exclamation('text-red w-1/2 h-1/2 ' + options.bG)
						]));
		}
	});
var $author$project$Form$File$ClickedCloseEntryModal = {$: 4};
var $author$project$View$Modal$FullScreen = 1;
var $author$project$Form$File$OpenEntry = {$: 1};
var $author$project$Form$File$ClickedDeleteEntry = {$: 7};
var $author$project$Form$File$isImageCropperLoading = function (entry) {
	var _v0 = entry.ad;
	if (!_v0.$) {
		return false;
	} else {
		var imageCropper = _v0.a;
		return imageCropper.nw;
	}
};
var $author$project$Form$File$isUrlStatusLoading = function (urlStatus) {
	switch (urlStatus.$) {
		case 0:
			return true;
		case 1:
			return false;
		case 2:
			return false;
		case 3:
			return true;
		case 4:
			return false;
		default:
			return false;
	}
};
var $author$project$Form$File$isEntryLoading = function (entry) {
	return $author$project$Form$File$isUrlStatusLoading(entry.gL) || $author$project$Form$File$isImageCropperLoading(entry);
};
var $author$project$Form$File$deleteEntryAction = F2(
	function (_v0, entry) {
		var t = _v0.il;
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-center w-full md:w-auto uppercase text-orange-300 font-bold md:mr-auto focus-ring rounded-sm hover:opacity-60'),
					$elm$html$Html$Events$onClick($author$project$Form$File$ClickedDeleteEntry),
					$elm$html$Html$Attributes$disabled(
					$author$project$Form$File$isEntryLoading(entry)),
					$elm$html$Html$Attributes$type_('button')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					t('form.file.delete'))
				]));
	});
var $author$project$View$Modal$Default = 2;
var $author$project$View$Modal$Modal = $elm$core$Basics$identity;
var $author$project$View$Components$PreventScrollAlways = 1;
var $author$project$View$Modal$initWith = function (reqOpts) {
	return {aQ: _List_Nil, fv: $elm$core$Maybe$Nothing, i$: reqOpts.i$, fR: $elm$core$Maybe$Nothing, ey: $elm$core$Maybe$Nothing, jW: reqOpts.jW, gp: 1, gC: 2};
};
var $author$project$Icons$externalLink = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$class(class_),
				$elm$svg$Svg$Attributes$viewBox('0 0 20 20')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('m16 10a1 1 0 0 0 -1 1v6a1 1 0 0 1 -1 1h-11a1 1 0 0 1 -1-1v-11a1 1 0 0 1 1-1h6a1 1 0 0 0 0-2h-6a3 3 0 0 0 -3 3v11a3 3 0 0 0 3 3h11a3 3 0 0 0 3-3v-6a1 1 0 0 0 -1-1z')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('m19.92.62a1 1 0 0 0 -.54-.54 1 1 0 0 0 -.38-.08h-6a1 1 0 0 0 0 2h3.59l-9.3 9.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l9.29-9.3v3.59a1 1 0 0 0 2 0v-6a1 1 0 0 0 -.08-.38z')
					]),
				_List_Nil)
			]));
};
var $author$project$Form$File$openEntryAction = F2(
	function (_v0, entry) {
		var t = _v0.il;
		var maybeUrl = function () {
			var _v2 = entry.gL;
			switch (_v2.$) {
				case 1:
					var url = _v2.a;
					return $elm$core$Maybe$Just(url);
				case 2:
					var original = _v2.a.u;
					return $elm$core$Maybe$Just(original);
				case 4:
					var croppedUrl = _v2.a.c6;
					return $elm$core$Maybe$Just(croppedUrl);
				default:
					return $elm$core$Maybe$Nothing;
			}
		}();
		if (maybeUrl.$ === 1) {
			return $elm$html$Html$text('');
		} else {
			var url = maybeUrl.a;
			return A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex items-center justify-center gap-2 w-full md:w-auto uppercase text-orange-300 font-bold focus-ring rounded-sm hover:opacity-60'),
						$elm$html$Html$Attributes$target('_blank'),
						$elm$html$Html$Attributes$href(url)
					]),
				_List_fromArray(
					[
						$author$project$Icons$externalLink('w-4 h-4 fill-current'),
						$elm$html$Html$text(
						t('form.file.open'))
					]));
		}
	});
var $elm$svg$Svg$clipPath = $elm$svg$Svg$trustedNode('clipPath');
var $elm$svg$Svg$Attributes$clipPath = _VirtualDom_attribute('clip-path');
var $elm$svg$Svg$Attributes$id = _VirtualDom_attribute('id');
var $elm$svg$Svg$Attributes$style = _VirtualDom_attribute('style');
var $author$project$Icons$camera = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$viewBox('0 0 16 16'),
				$elm$svg$Svg$Attributes$style('fill: none'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$clipPath,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$id('a')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$d('m0 0h16v16h-16z')
							]),
						_List_Nil)
					])),
				A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$clipPath('url(#a)'),
						$elm$svg$Svg$Attributes$stroke('currentColor'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round'),
						$elm$svg$Svg$Attributes$strokeWidth('2')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$d('m15.3334 12.6667c0 .3536-.1405.6927-.3906.9428-.25.25-.5892.3905-.9428.3905h-11.99998c-.35362 0-.69276-.1405-.94281-.3905-.250047-.2501-.390523-.5892-.390523-.9428v-7.33337c0-.35362.140476-.69276.390523-.94281.25005-.25004.58919-.39052.94281-.39052h2.66667l1.33333-2h3.99998l1.3334 2h2.6666c.3536 0 .6928.14048.9428.39052.2501.25005.3906.58919.3906.94281z')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$d('m7.99998 11.3333c1.47276 0 2.66662-1.1939 2.66662-2.66663 0-1.47276-1.19386-2.66667-2.66662-2.66667s-2.66667 1.19391-2.66667 2.66667c0 1.47273 1.19391 2.66663 2.66667 2.66663z')
							]),
						_List_Nil)
					]))
			]));
};
var $author$project$Form$File$replaceInputId = F2(
	function (_v0, index) {
		var options = _v0;
		return options.R + ('-replace-image-' + $elm$core$String$fromInt(index));
	});
var $author$project$Form$File$RequestedReplaceFile = function (a) {
	return {$: 1, a: a};
};
var $author$project$Form$File$viewReplaceImageInput = F2(
	function (_v0, _v1) {
		var options = _v0;
		var isDisabled = _v1.ns;
		var index = _v1.eB;
		return A2(
			$elm$html$Html$input,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$type_('file'),
					$elm$html$Html$Attributes$id(
					A2($author$project$Form$File$replaceInputId, options, index)),
					$elm$html$Html$Attributes$class('sr-only form-file'),
					A2(
					$elm$html$Html$Events$on,
					'change',
					A2(
						$elm$json$Json$Decode$map,
						$author$project$Form$File$RequestedReplaceFile,
						A2(
							$elm$json$Json$Decode$at,
							_List_fromArray(
								['target', 'files']),
							A2($elm$json$Json$Decode$index, 0, $elm$file$File$decoder)))),
					$elm$html$Html$Attributes$multiple(false),
					$author$project$Form$File$acceptFileTypes(options.hg),
					$elm$html$Html$Attributes$disabled(isDisabled || options.cf)
				]),
			_List_Nil);
	});
var $author$project$Form$File$replaceEntryAction = F4(
	function (_v0, options, index, entry) {
		var t = _v0.il;
		var _v1 = options;
		var unwrappedOptions = _v1;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('w-full md:w-40 flex-shrink-0')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Form$File$viewReplaceImageInput,
					options,
					{
						eB: index,
						ns: $author$project$Form$File$isEntryLoading(entry)
					}),
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$for(
							A2($author$project$Form$File$replaceInputId, options, index)),
							$elm$html$Html$Attributes$class('cursor-pointer file-decoration button button-secondary w-full'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'button-disabled',
									unwrappedOptions.cf || $author$project$Form$File$isEntryLoading(entry)),
									_Utils_Tuple2(
									'!bg-white !text-orange-300',
									$author$project$Form$File$isImageCropperLoading(entry))
								]))
						]),
					_List_fromArray(
						[
							$author$project$Icons$camera('w-4 mr-1'),
							$elm$html$Html$text(
							t('form.file.change'))
						]))
				]));
	});
var $author$project$Form$File$ClickedSaveEntry = {$: 8};
var $author$project$Form$File$saveEntryAction = F2(
	function (_v0, entry) {
		var t = _v0.il;
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('button button-primary w-full flex-shrink-0 md:w-40'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'!bg-orange-300 !text-white cursor-wait',
							$author$project$Form$File$isImageCropperLoading(entry))
						])),
					$elm$html$Html$Events$onClick($author$project$Form$File$ClickedSaveEntry),
					$elm$html$Html$Attributes$disabled(
					$author$project$Form$File$isEntryLoading(entry)),
					$elm$html$Html$Attributes$type_('button')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					t('form.file.save'))
				]));
	});
var $author$project$View$Components$bgNoScroll = F2(
	function (attrs, preventScroll) {
		var preventScrollClass = function () {
			if (!preventScroll) {
				return 'overflow-hidden fixed w-full h-full md:overflow-auto md:static md:w-auto md:h-auto';
			} else {
				return 'overflow-hidden fixed w-full h-full md:static md:w-auto md:h-auto';
			}
		}();
		return A3(
			$elm$html$Html$node,
			'bg-no-scroll',
			A2(
				$elm$core$List$cons,
				A2($elm$html$Html$Attributes$attribute, 'elm-prevent-scroll-class', preventScrollClass),
				attrs),
			_List_Nil);
	});
var $author$project$Icons$close = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$class(class_),
				$elm$svg$Svg$Attributes$width('24'),
				$elm$svg$Svg$Attributes$height('24'),
				$elm$svg$Svg$Attributes$viewBox('0 0 24 24')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M13.6299 12.0242L22.2329 3.25164C22.603 2.84787 22.5865 2.22339 22.1956 1.83974C21.8046 1.4561 21.18 1.45137 20.7833 1.82906L12.1938 10.5881L3.25206 1.81551C2.99607 1.54661 2.6138 1.43874 2.25501 1.53415C1.89622 1.62956 1.61802 1.91306 1.5294 2.2736C1.44078 2.63414 1.55584 3.01431 1.82951 3.26519L10.7577 12.0242L1.82951 20.7832C1.45184 21.1799 1.45656 21.8046 1.8402 22.1956C2.22383 22.5865 2.8483 22.603 3.25206 22.2329L12.1938 13.4603L20.7833 22.2194C21.18 22.597 21.8046 22.5923 22.1956 22.2087C22.5865 21.825 22.603 21.2005 22.2329 20.7968L13.6299 12.0242Z')
					]),
				_List_Nil)
			]));
};
var $author$project$View$Components$optionalAttr = F2(
	function (attr, maybeAttr) {
		if (maybeAttr.$ === 1) {
			return $elm$html$Html$Attributes$class('');
		} else {
			var attrValue = maybeAttr.a;
			return A2($elm$html$Html$Attributes$attribute, attr, attrValue);
		}
	});
var $author$project$View$Components$focusTrap = F3(
	function (_v0, attrs, children) {
		var initialFocusId = _v0.nk;
		return A3(
			$elm$html$Html$node,
			'focus-trap',
			A2(
				$elm$core$List$cons,
				A2($author$project$View$Components$optionalAttr, 'initial-focus-id', initialFocusId),
				attrs),
			children);
	});
var $author$project$Utils$onClickNoBubble = function (message) {
	return A2(
		$elm$html$Html$Events$custom,
		'click',
		$elm$json$Json$Decode$succeed(
			{nS: message, kF: false, le: true}));
};
var $author$project$Utils$preventAll = F2(
	function (eventName, message) {
		return A2(
			$elm$html$Html$Events$custom,
			eventName,
			$elm$json$Json$Decode$succeed(
				{nS: message, kF: true, le: true}));
	});
var $author$project$Utils$onClickPreventAll = $author$project$Utils$preventAll('click');
var $author$project$View$Modal$viewModalDetails = function (options) {
	var header = A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('modal-header')
			]),
		_List_fromArray(
			[
				function () {
				var _v4 = options.ey;
				if (!_v4.$) {
					var headerElement = _v4.a;
					return headerElement;
				} else {
					return $elm$html$Html$text('');
				}
			}(),
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('ml-auto text-gray-400 hover:text-red focus:text-red focus:outline-none'),
						$author$project$Utils$onClickNoBubble(options.i$)
					]),
				_List_fromArray(
					[
						$author$project$Icons$close('fill-current')
					]))
			]));
	var footer = function () {
		var _v3 = options.fR;
		if (!_v3.$) {
			var f = _v3.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('modal-footer')
					]),
				f);
		} else {
			return $elm$html$Html$text('');
		}
	}();
	var content = function () {
		var _v2 = options.gC;
		switch (_v2) {
			case 2:
				return 'modal-content';
			case 0:
				return 'modal-content modal-content-lg';
			default:
				return 'modal-content modal-content-full';
		}
	}();
	var body = function () {
		var _v1 = options.fv;
		if (!_v1.$) {
			var b = _v1.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('modal-body'),
						$elm$html$Html$Attributes$tabindex(-1)
					]),
				b);
		} else {
			return $elm$html$Html$text('');
		}
	}();
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('modal fade-in')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$View$Components$bgNoScroll,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('modal-bg'),
						$author$project$Utils$onClickPreventAll(options.i$)
					]),
				options.gp),
				A3(
				$author$project$View$Components$focusTrap,
				{
					nk: $elm$core$Maybe$Just('modal-first-focus')
				},
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$class(content),
					options.aQ),
				_List_fromArray(
					[
						header,
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$id('modal-first-focus'),
								$elm$html$Html$Attributes$tabindex(-1),
								$elm$html$Html$Attributes$class('sr-only'),
								$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
							]),
						_List_Nil),
						body,
						footer
					])),
				$author$project$View$Components$keyListener(
				{
					lL: _List_fromArray(
						[0]),
					kF: false,
					le: true,
					pA: function (_v0) {
						return options.i$;
					}
				})
			]));
};
var $author$project$View$Modal$toHtml = function (_v0) {
	var options = _v0;
	return options.jW ? $author$project$View$Modal$viewModalDetails(options) : $elm$html$Html$text('');
};
var $author$project$View$ImageCropper$ImageLoaded = {$: 0};
var $author$project$View$ImageCropper$Dragged = function (a) {
	return {$: 4, a: a};
};
var $author$project$View$ImageCropper$GotCroppedImage = function (a) {
	return {$: 8, a: a};
};
var $author$project$View$ImageCropper$StoppedDragging = {$: 3};
var $elm$html$Html$Attributes$draggable = _VirtualDom_attribute('draggable');
var $elm$json$Json$Decode$map4 = _Json_map4;
var $author$project$View$Components$optionalListener = F2(
	function (eventName, maybeMsg) {
		if (maybeMsg.$ === 1) {
			return $elm$html$Html$Attributes$class('');
		} else {
			var msg = maybeMsg.a;
			return A2(
				$elm$html$Html$Events$on,
				eventName,
				$elm$json$Json$Decode$succeed(msg));
		}
	});
var $author$project$View$Components$optionalListenerWithArgs = F3(
	function (eventName, maybeMsg, decoder) {
		if (maybeMsg.$ === 1) {
			return $elm$html$Html$Attributes$class('');
		} else {
			var msg = maybeMsg.a;
			return A2(
				$elm$html$Html$Events$on,
				eventName,
				A2($elm$json$Json$Decode$map, msg, decoder));
		}
	});
var $author$project$View$Components$pointerListener = F3(
	function (_v0, attrs, children) {
		var document = _v0.eq;
		var element = _v0.jg;
		return A3(
			$elm$html$Html$node,
			'pointer-listener',
			A2(
				$elm$core$List$cons,
				A3(
					$author$project$View$Components$optionalListenerWithArgs,
					'document-dragover',
					document.oi,
					A2(
						$elm$json$Json$Decode$field,
						'detail',
						A5(
							$elm$json$Json$Decode$map4,
							F4(
								function (x, y, previousX, previousY) {
									return {oL: previousX, oM: previousY, pW: x, pX: y};
								}),
							A2($elm$json$Json$Decode$field, 'clientX', $elm$json$Json$Decode$float),
							A2($elm$json$Json$Decode$field, 'clientY', $elm$json$Json$Decode$float),
							A2($elm$json$Json$Decode$field, 'previousX', $elm$json$Json$Decode$float),
							A2($elm$json$Json$Decode$field, 'previousY', $elm$json$Json$Decode$float)))),
				A2(
					$elm$core$List$cons,
					A2($author$project$View$Components$optionalListener, 'element-dragend', element.oh),
					A2(
						$elm$core$List$cons,
						A2(
							$author$project$View$Components$optionalListener,
							'element-dragstart',
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.nL;
								},
								element.kr)),
						A2(
							$elm$core$List$cons,
							A2(
								$author$project$View$Components$optionalAttr,
								'element-pointerdown-drag-image',
								A2(
									$elm$core$Maybe$andThen,
									function ($) {
										return $.mE;
									},
									element.kr)),
							attrs)))),
			children);
	});
var $author$project$View$ImageCropper$viewCropper = F3(
	function (model, dimmensions, _v0) {
		var imageUrl = _v0.nh;
		var cropperAttributes = _v0.ms;
		var selection = A2($author$project$View$ImageCropper$calculateSelectionDimmensions, model, dimmensions);
		var topOffset = A3($elm$core$Basics$clamp, 0, dimmensions.K.fW - selection.fW, dimmensions.bY - dimmensions.K.bp);
		var leftOffset = A3($elm$core$Basics$clamp, 0, dimmensions.K.y - selection.y, dimmensions.bK - dimmensions.K.j1);
		var floatToPx = function (offset) {
			return $elm$core$String$fromFloat(offset) + 'px';
		};
		return _List_fromArray(
			[
				A3(
				$author$project$View$Components$pointerListener,
				{
					eq: {
						oi: model.bI ? $elm$core$Maybe$Just($author$project$View$ImageCropper$Dragged) : $elm$core$Maybe$Nothing
					},
					jg: {
						oh: $elm$core$Maybe$Just($author$project$View$ImageCropper$StoppedDragging),
						kr: $elm$core$Maybe$Just(
							{mE: $elm$core$Maybe$Nothing, nL: $author$project$View$ImageCropper$StartedDragging})
					}
				},
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$class('absolute overflow-hidden border border-dashed border-gray-400 cursor-move z-20 select-none mx-auto'),
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('transition-all origin-center', (!model.bI) && ((!model.dn) && (!model.eE)))
								])),
						A2(
							$elm$core$List$cons,
							A2(
								$elm$html$Html$Attributes$style,
								'top',
								floatToPx(topOffset)),
							A2(
								$elm$core$List$cons,
								A2(
									$elm$html$Html$Attributes$style,
									'left',
									floatToPx(leftOffset)),
								A2(
									$elm$core$List$cons,
									A2(
										$elm$html$Html$Attributes$style,
										'width',
										floatToPx(selection.y)),
									A2(
										$elm$core$List$cons,
										A2(
											$elm$html$Html$Attributes$style,
											'height',
											floatToPx(selection.fW)),
										A2(
											$elm$core$List$cons,
											$elm$html$Html$Attributes$draggable('true'),
											A2(
												$elm$core$List$map,
												$elm$html$Html$Attributes$map($elm$core$Basics$never),
												cropperAttributes)))))))),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$img,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$src(imageUrl),
								$elm$html$Html$Attributes$alt(''),
								$elm$html$Html$Attributes$class('absolute object-cover max-w-none pointer-events-none select-none'),
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('transition-all origin-center', (!model.bI) && ((!model.dn) && (!model.eE)))
									])),
								A2(
								$elm$html$Html$Attributes$style,
								'width',
								floatToPx(dimmensions.jH.y)),
								A2(
								$elm$html$Html$Attributes$style,
								'height',
								floatToPx(dimmensions.jH.fW)),
								A2(
								$elm$html$Html$Attributes$style,
								'top',
								floatToPx(((dimmensions.jH.bp - dimmensions.K.bp) - topOffset) - 1)),
								A2(
								$elm$html$Html$Attributes$style,
								'left',
								floatToPx(((dimmensions.jH.j1 - dimmensions.K.j1) - leftOffset) - 1))
							]),
						_List_Nil)
					])),
				A3(
				$elm$html$Html$node,
				'image-cropper',
				_List_fromArray(
					[
						model.nw ? A2($elm$html$Html$Attributes$attribute, 'elm-generate-new-cropped-image', 'true') : $elm$html$Html$Attributes$class(''),
						A2($elm$html$Html$Attributes$attribute, 'elm-url', imageUrl),
						A2(
						$elm$html$Html$Attributes$attribute,
						'elm-image-width',
						$elm$core$String$fromFloat(dimmensions.jH.y)),
						A2(
						$elm$html$Html$Attributes$attribute,
						'elm-image-height',
						$elm$core$String$fromFloat(dimmensions.jH.fW)),
						A2(
						$elm$html$Html$Attributes$attribute,
						'elm-image-left',
						$elm$core$String$fromFloat(dimmensions.jH.j1)),
						A2(
						$elm$html$Html$Attributes$attribute,
						'elm-image-top',
						$elm$core$String$fromFloat(dimmensions.jH.bp)),
						A2(
						$elm$html$Html$Attributes$attribute,
						'elm-container-left',
						$elm$core$String$fromFloat(dimmensions.K.j1)),
						A2(
						$elm$html$Html$Attributes$attribute,
						'elm-container-top',
						$elm$core$String$fromFloat(dimmensions.K.bp)),
						A2(
						$elm$html$Html$Attributes$attribute,
						'elm-selection-left',
						$elm$core$String$fromFloat(leftOffset)),
						A2(
						$elm$html$Html$Attributes$attribute,
						'elm-selection-top',
						$elm$core$String$fromFloat(topOffset)),
						A2(
						$elm$html$Html$Attributes$attribute,
						'elm-selection-width',
						$elm$core$String$fromFloat(selection.y)),
						A2(
						$elm$html$Html$Attributes$attribute,
						'elm-selection-height',
						$elm$core$String$fromFloat(selection.fW)),
						A2(
						$elm$html$Html$Events$on,
						'crop-image',
						A2(
							$elm$json$Json$Decode$map,
							$author$project$View$ImageCropper$GotCroppedImage,
							A2(
								$elm$json$Json$Decode$at,
								_List_fromArray(
									['detail', 'image']),
								$elm$file$File$decoder))),
						A2(
						$elm$html$Html$Events$on,
						'document-resize',
						$elm$json$Json$Decode$succeed($author$project$View$ImageCropper$ImageLoaded))
					]),
				_List_Nil)
			]);
	});
var $author$project$View$ImageCropper$ChangedDimmensions = function (a) {
	return {$: 5, a: a};
};
var $author$project$View$ImageCropper$ClickedZoomOperation = function (a) {
	return {$: 7, a: a};
};
var $author$project$View$ImageCropper$CompletedChangingDimmensions = {$: 6};
var $author$project$View$ImageCropper$Minus = 0;
var $author$project$View$ImageCropper$Plus = 1;
var $author$project$Icons$magnifyingGlassWithMinus = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('24'),
				$elm$svg$Svg$Attributes$height('24'),
				$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M10 17C13.866 17 17 13.866 17 10C17 6.13401 13.866 3 10 3C6.13401 3 3 6.13401 3 10C3 13.866 6.13401 17 10 17Z'),
						$elm$svg$Svg$Attributes$stroke('#333333'),
						$elm$svg$Svg$Attributes$strokeWidth('1.5'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M7 10H13'),
						$elm$svg$Svg$Attributes$stroke('#333333'),
						$elm$svg$Svg$Attributes$strokeWidth('1.5'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M21 21L15 15'),
						$elm$svg$Svg$Attributes$stroke('#333333'),
						$elm$svg$Svg$Attributes$strokeWidth('1.5'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_Nil)
			]));
};
var $author$project$Icons$magnifyingGlassWithPlus = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('24'),
				$elm$svg$Svg$Attributes$height('24'),
				$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M10 17C13.866 17 17 13.866 17 10C17 6.13401 13.866 3 10 3C6.13401 3 3 6.13401 3 10C3 13.866 6.13401 17 10 17Z'),
						$elm$svg$Svg$Attributes$stroke('#333333'),
						$elm$svg$Svg$Attributes$strokeWidth('1.5'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M7 10H13'),
						$elm$svg$Svg$Attributes$stroke('#333333'),
						$elm$svg$Svg$Attributes$strokeWidth('1.5'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M10 7V13'),
						$elm$svg$Svg$Attributes$stroke('#333333'),
						$elm$svg$Svg$Attributes$strokeWidth('1.5'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M21 21L15 15'),
						$elm$svg$Svg$Attributes$stroke('#333333'),
						$elm$svg$Svg$Attributes$strokeWidth('1.5'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_Nil)
			]));
};
var $elm$html$Html$Attributes$max = $elm$html$Html$Attributes$stringProperty('max');
var $elm$html$Html$Attributes$min = $elm$html$Html$Attributes$stringProperty('min');
var $elm$html$Html$Attributes$step = function (n) {
	return A2($elm$html$Html$Attributes$stringProperty, 'step', n);
};
var $author$project$View$ImageCropper$viewSlider = function (dimmensions) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex mt-6 flex-grow-0')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(
						$author$project$View$ImageCropper$ClickedZoomOperation(0)),
						$elm$html$Html$Attributes$class('flex-shrink-0 bg-gray-100 p-2 w-10 h-10 rounded-full focus-ring'),
						$elm$html$Html$Attributes$type_('button')
					]),
				_List_fromArray(
					[
						$author$project$Icons$magnifyingGlassWithMinus('')
					])),
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$type_('range'),
						$elm$html$Html$Attributes$class('w-full mx-2'),
						$elm$html$Html$Attributes$value(
						$elm$core$String$fromFloat(dimmensions.aL)),
						$elm$html$Html$Events$onInput($author$project$View$ImageCropper$ChangedDimmensions),
						A2(
						$elm$html$Html$Events$on,
						'change',
						$elm$json$Json$Decode$succeed($author$project$View$ImageCropper$CompletedChangingDimmensions)),
						$elm$html$Html$Attributes$min('0.1'),
						$elm$html$Html$Attributes$max(
						$elm$core$String$fromFloat(dimmensions.eL)),
						$elm$html$Html$Attributes$step('0.001')
					]),
				_List_Nil),
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(
						$author$project$View$ImageCropper$ClickedZoomOperation(1)),
						$elm$html$Html$Attributes$class('flex-shrink-0 bg-gray-100 p-2 w-10 h-10 rounded-full focus-ring'),
						$elm$html$Html$Attributes$type_('button')
					]),
				_List_fromArray(
					[
						$author$project$Icons$magnifyingGlassWithPlus('')
					]))
			]));
};
var $author$project$View$ImageCropper$view = F2(
	function (model, _v0) {
		var imageUrl = _v0.nh;
		var cropperAttributes = _v0.ms;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mx-auto w-full md:flex md:flex-col md:w-auto')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('relative max-w-max mx-auto flex items-center justify-center max-h-[35vh] lg:max-h-[60vh]'),
							A2(
							$elm$html$Html$Attributes$style,
							'aspect-ratio',
							$elm$core$String$fromFloat(model.q)),
							$elm$html$Html$Attributes$id($author$project$View$ImageCropper$imageContainerId)
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$src(imageUrl),
									$elm$html$Html$Attributes$alt(''),
									$elm$html$Html$Attributes$id($author$project$View$ImageCropper$entireImageId),
									$elm$html$Html$Attributes$class('opacity-20 pointer-events-none select-none max-w-full max-h-[35vh] lg:max-h-[60vh]'),
									A2(
									$elm$html$Html$Events$on,
									'load',
									$elm$json$Json$Decode$succeed($author$project$View$ImageCropper$ImageLoaded))
								]),
							_List_Nil),
						function () {
							var _v1 = model.aa;
							if (!_v1.$) {
								return _List_Nil;
							} else {
								var dimmensions = _v1.a;
								return A3(
									$author$project$View$ImageCropper$viewCropper,
									model,
									dimmensions,
									{ms: cropperAttributes, nh: imageUrl});
							}
						}())),
					function () {
					var _v2 = model.aa;
					if (!_v2.$) {
						return $elm$html$Html$text('');
					} else {
						var dimmensions = _v2.a;
						return $author$project$View$ImageCropper$viewSlider(dimmensions);
					}
				}()
				]));
	});
var $author$project$View$Modal$withBody = F2(
	function (body, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				fv: $elm$core$Maybe$Just(body)
			});
	});
var $author$project$View$Modal$withFooter = F2(
	function (footer, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				fR: $elm$core$Maybe$Just(footer)
			});
	});
var $author$project$View$Modal$withHeader = F2(
	function (header, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				ey: $elm$core$Maybe$Just(
					A2(
						$elm$html$Html$h3,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(header)
							])))
			});
	});
var $author$project$View$Modal$withSize = F2(
	function (size, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{gC: size});
	});
var $author$project$Form$File$viewEntryModal = F5(
	function (_v0, viewConfig, _v1, entry, toMsg) {
		var options = _v0;
		var isVisible = _v1.jW;
		var index = _v1.eB;
		var addOpenEntryAction = function (actions) {
			return _Utils_ap(
				A2(
					$elm_community$list_extra$List$Extra$takeWhile,
					function (action) {
						return !_Utils_eq(action, $author$project$Form$File$ReplaceEntry);
					},
					actions),
				A2(
					$elm$core$List$cons,
					$author$project$Form$File$OpenEntry,
					A2(
						$elm_community$list_extra$List$Extra$dropWhile,
						function (action) {
							return !_Utils_eq(action, $author$project$Form$File$ReplaceEntry);
						},
						actions)));
		};
		var actionsWithOpenAction = A2(
			$elm$core$List$member,
			$author$project$Form$File$OpenEntry,
			options.db(index)) ? options.db(index) : (_Utils_eq(
			entry.aH,
			$author$project$Form$File$LoadedFileType(0)) ? addOpenEntryAction(
			options.db(index)) : options.db(index));
		var _v2 = viewConfig;
		var translators = _v2.iw;
		var viewWithUrl = function (url) {
			var _v10 = entry.aH;
			if (_v10.$ === 1) {
				if (_v10.a === 1) {
					var _v11 = _v10.a;
					var _v12 = entry.ad;
					if (!_v12.$) {
						return A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$src(url),
									$elm$html$Html$Attributes$alt(''),
									$elm$html$Html$Attributes$class('mx-auto w-full md:w-auto max-h-[35vh] lg:max-h-[60vh]')
								]),
							_List_Nil);
					} else {
						var imageCropper = _v12.a;
						return A2(
							$elm$html$Html$map,
							A2($elm$core$Basics$composeR, $author$project$Form$File$GotImageCropperMsg, toMsg),
							A2(
								$author$project$View$ImageCropper$view,
								imageCropper,
								{ms: options.fX, nh: url}));
					}
				} else {
					var _v13 = _v10.a;
					return A2(
						$author$project$View$Components$pdfViewer,
						_List_Nil,
						{
							g$: 'mx-auto w-full md:w-auto max-h-full max-h-[35vh] lg:max-h-[60vh]',
							hF: $elm$core$Maybe$Just(translators),
							hW: $elm$core$Maybe$Nothing,
							gL: url
						});
				}
			} else {
				return A2(
					$author$project$View$Components$pdfViewer,
					_List_Nil,
					{
						g$: 'mx-auto w-full md:w-auto max-h-full max-h-[35vh] lg:max-h-[60vh]',
						hF: $elm$core$Maybe$Just(translators),
						hW: $elm$core$Maybe$Nothing,
						gL: url
					});
			}
		};
		var _v3 = function () {
			var _v4 = entry.aH;
			if (_v4.$ === 1) {
				if (_v4.a === 1) {
					var _v5 = _v4.a;
					var _v6 = entry.ad;
					if (_v6.$ === 1) {
						return _Utils_Tuple2(
							translators.il('form.file.edit_image'),
							translators.il('form.file.body_image'));
					} else {
						return _Utils_Tuple2(
							translators.il('form.file.edit_file'),
							translators.il('form.file.body_file'));
					}
				} else {
					var _v7 = _v4.a;
					return _Utils_Tuple2(
						translators.il('form.file.edit_file'),
						translators.il('form.file.body_file'));
				}
			} else {
				return _Utils_Tuple2('', '');
			}
		}();
		var header = _v3.a;
		var bodyText = _v3.b;
		return $author$project$View$Modal$toHtml(
			A2(
				$author$project$View$Modal$withSize,
				1,
				A2(
					$author$project$View$Modal$withFooter,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex flex-wrap items-center justify-center md:flex gap-6 w-full px-10')
								]),
							A3(
								$elm$core$List$foldr,
								F2(
									function (action, actions) {
										var viewAction = function () {
											switch (action.$) {
												case 0:
													return A2(
														$elm$html$Html$map,
														toMsg,
														A2($author$project$Form$File$deleteEntryAction, translators, entry));
												case 1:
													return A2(
														$elm$html$Html$map,
														toMsg,
														A2($author$project$Form$File$openEntryAction, translators, entry));
												case 2:
													return A2(
														$elm$html$Html$map,
														toMsg,
														A4($author$project$Form$File$replaceEntryAction, translators, options, index, entry));
												case 3:
													return A2(
														$elm$html$Html$map,
														toMsg,
														A2($author$project$Form$File$saveEntryAction, translators, entry));
												default:
													var customView = action.a;
													return customView;
											}
										}();
										return A2($elm$core$List$cons, viewAction, actions);
									}),
								_List_Nil,
								actionsWithOpenAction))
						]),
					A2(
						$author$project$View$Modal$withBody,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(bodyText)
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('flex items-center justify-center mt-4')
									]),
								_List_fromArray(
									[
										function () {
										var _v8 = entry.gL;
										switch (_v8.$) {
											case 0:
												return A2($author$project$View$Components$loadingLogoAnimated, translators, '');
											case 1:
												var url = _v8.a;
												return viewWithUrl(url);
											case 2:
												var original = _v8.a.u;
												return viewWithUrl(original);
											case 3:
												var original = _v8.a.u;
												return viewWithUrl(original);
											case 4:
												var original = _v8.a.u;
												return viewWithUrl(original);
											default:
												return A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('w-full')
														]),
													_List_fromArray(
														[
															$author$project$Icons$exclamation('mb-4 mx-auto bg-gray-100 p-4 w-1/4 text-red w-full h-full rounded-sm'),
															A2(
															$elm$html$Html$p,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('form-error text-center')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	translators.il('error.file_upload'))
																]))
														]));
										}
									}()
									]))
							]),
						A2(
							$author$project$View$Modal$withHeader,
							header,
							$author$project$View$Modal$initWith(
								{
									i$: toMsg($author$project$Form$File$ClickedCloseEntryModal),
									jW: isVisible
								}))))));
	});
var $author$project$Form$File$viewMultiple = F4(
	function (_v0, _v1, viewConfig, toMsg) {
		var model = _v0;
		var options = _v1;
		var maybeOpenEntry = A2(
			$elm$core$Maybe$andThen,
			function (index) {
				return A2($elm_community$list_extra$List$Extra$getAt, index, model.f);
			},
			model.t);
		return A2(
			$elm$html$Html$div,
			$author$project$Form$File$fromNeverAttributes(options.c4),
			_List_fromArray(
				[
					function () {
					var _v2 = options.nC;
					if (_v2.$ === 1) {
						return $elm$html$Html$text('');
					} else {
						var label = _v2.a;
						return A2(
							$author$project$View$Components$label,
							_List_Nil,
							{nD: label, pv: options.R});
					}
				}(),
					A2(
					$elm$html$Html$Keyed$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-wrap gap-4')
						]),
					_Utils_ap(
						A2(
							$elm$core$List$indexedMap,
							F2(
								function (index, entry) {
									return _Utils_Tuple2(
										'entry-' + $elm$core$String$fromInt(index),
										A2(
											$elm$html$Html$li,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$map,
													toMsg,
													A4($author$project$Form$File$viewEntry, viewConfig.iw, options, index, entry))
												])));
								}),
							model.f),
						_List_fromArray(
							[
								_Utils_Tuple2(
								'add-images-input',
								A4(
									$author$project$Form$File$viewAddImages,
									{d8: true},
									options,
									viewConfig,
									toMsg))
							]))),
					function () {
					if (maybeOpenEntry.$ === 1) {
						return $elm$html$Html$text('');
					} else {
						var entry = maybeOpenEntry.a;
						return A5(
							$author$project$Form$File$viewEntryModal,
							options,
							viewConfig,
							{
								eB: A2($elm$core$Maybe$withDefault, 0, model.t),
								jW: true
							},
							entry,
							toMsg);
					}
				}()
				]));
	});
var $author$project$Form$File$viewSingle = F4(
	function (_v0, _v1, viewConfig, toMsg) {
		var model = _v0;
		var options = _v1;
		var _v2 = model.ev;
		if (_v2.$ === 1) {
			return A4(
				$author$project$Form$File$viewAddImages,
				{d8: false},
				options,
				viewConfig,
				toMsg);
		} else {
			var entry = _v2.a;
			return A2(
				$elm$html$Html$div,
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$class('flex flex-col'),
					$author$project$Form$File$fromNeverAttributes(options.c4)),
				_List_fromArray(
					[
						function () {
						var _v3 = options.nC;
						if (_v3.$ === 1) {
							return $elm$html$Html$text('');
						} else {
							var label = _v3.a;
							return A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('label w-max focus-ring'),
										$elm$html$Html$Events$onClick(
										toMsg(
											$author$project$Form$File$ClickedEntry(0))),
										$elm$html$Html$Attributes$disabled(options.cf),
										$elm$html$Html$Attributes$type_('button')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(label)
									]));
						}
					}(),
						A2(
						$elm$html$Html$map,
						toMsg,
						A4($author$project$Form$File$viewEntry, viewConfig.iw, options, 0, entry)),
						A5(
						$author$project$Form$File$viewEntryModal,
						options,
						viewConfig,
						{eB: 0, jW: model.f$},
						entry,
						toMsg)
					]));
		}
	});
var $author$project$Form$File$view = F3(
	function (options, viewConfig, toMsg) {
		var _v0 = viewConfig.pO;
		var model = _v0;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					function () {
					var _v1 = model.f;
					if (!_v1.$) {
						return A4(
							$author$project$Form$File$viewSingle,
							$author$project$Form$File$toSingleModel(model),
							options,
							viewConfig,
							toMsg);
					} else {
						return A4(
							$author$project$Form$File$viewMultiple,
							$author$project$Form$File$toMultipleModel(model),
							options,
							viewConfig,
							toMsg);
					}
				}(),
					viewConfig.m$ ? viewConfig.mM : $elm$html$Html$text('')
				]));
	});
var $author$project$Form$Radio$Vertical = 1;
var $elm$html$Html$fieldset = _VirtualDom_node('fieldset');
var $elm$html$Html$legend = _VirtualDom_node('legend');
var $author$project$Form$Radio$view = F2(
	function (_v0, viewConfig) {
		var options = _v0;
		var viewOption = function (_v1) {
			var option = _v1.gj;
			var label = _v1.nC;
			var isSelected = _Utils_eq(option, viewConfig.pO);
			return A2(
				$elm$html$Html$label,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex items-center transition-colors duration-100'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('text-green', isSelected && (!options.cf)),
								_Utils_Tuple2('text-red', isSelected && viewConfig.m$),
								_Utils_Tuple2('text-gray-900', options.cf)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('radio'),
								$elm$html$Html$Attributes$name(options.R),
								$elm$html$Html$Attributes$value(
								options.dG(option)),
								$elm$html$Html$Attributes$checked(isSelected),
								$elm$html$Html$Events$onClick(
								viewConfig.kv(option)),
								$elm$html$Html$Events$onBlur(viewConfig.od),
								$elm$html$Html$Attributes$class('form-radio mr-2 shadow-form-control'),
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('with-error', isSelected && viewConfig.m$),
										_Utils_Tuple2('hover:border-green', (!viewConfig.m$) && (!options.cf)),
										_Utils_Tuple2('hover:border-red', viewConfig.m$ && (!options.cf)),
										_Utils_Tuple2('sr-only', options.dh)
									]))
							]),
						_List_Nil),
						label
					]));
		};
		return A2(
			$elm$html$Html$fieldset,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$disabled(options.cf),
				options.mg),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$legend,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$class('label'),
						options.f4),
					_List_fromArray(
						[
							$elm$html$Html$text(options.nC)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-wrap'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('flex-col gap-4', options.F === 1),
									_Utils_Tuple2('gap-4', (!options.F) && options.dh),
									_Utils_Tuple2('gap-x-8 gap-y-4', (!options.F) && (!options.dh))
								]))
						]),
					A2(
						$elm$core$List$map,
						viewOption,
						$elm$core$List$reverse(options.gk))),
					viewConfig.mM
				]));
	});
var $author$project$Form$RichText$ChangedText = function (a) {
	return {$: 6, a: a};
};
var $author$project$Form$RichText$ClickedAcceptLink = {$: 5};
var $author$project$Form$RichText$ClickedIncludeLink = function (a) {
	return {$: 1, a: a};
};
var $author$project$Form$RichText$ClosedLinkModal = {$: 2};
var $author$project$Form$RichText$ComponentLoaded = {$: 7};
var $author$project$Form$RichText$EnteredLinkLabel = function (a) {
	return {$: 3, a: a};
};
var $author$project$Form$RichText$EnteredLinkUrl = function (a) {
	return {$: 4, a: a};
};
var $author$project$Form$RichText$NoOp = {$: 0};
var $author$project$Form$Text$Url = 3;
var $author$project$Form$RichText$Link = F2(
	function (label, url) {
		return {nC: label, gL: url};
	});
var $author$project$Form$RichText$linkDecoder = A2(
	$elm$json$Json$Decode$field,
	'detail',
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'url',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'label',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Form$RichText$Link))));
var $author$project$Utils$onSubmitPreventAll = $author$project$Utils$preventAll('submit');
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder = F3(
	function (path, valDecoder, fallback) {
		var nullOr = function (decoder) {
			return $elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						decoder,
						$elm$json$Json$Decode$null(fallback)
					]));
		};
		var handleResult = function (input) {
			var _v0 = A2(
				$elm$json$Json$Decode$decodeValue,
				A2($elm$json$Json$Decode$at, path, $elm$json$Json$Decode$value),
				input);
			if (!_v0.$) {
				var rawValue = _v0.a;
				var _v1 = A2(
					$elm$json$Json$Decode$decodeValue,
					nullOr(valDecoder),
					rawValue);
				if (!_v1.$) {
					var finalResult = _v1.a;
					return $elm$json$Json$Decode$succeed(finalResult);
				} else {
					return A2(
						$elm$json$Json$Decode$at,
						path,
						nullOr(valDecoder));
				}
			} else {
				return $elm$json$Json$Decode$succeed(fallback);
			}
		};
		return A2($elm$json$Json$Decode$andThen, handleResult, $elm$json$Json$Decode$value);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional = F4(
	function (key, valDecoder, fallback, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder,
				_List_fromArray(
					[key]),
				valDecoder,
				fallback),
			decoder);
	});
var $author$project$Markdown$formattingObjectDecoder = function () {
	var baseDecoder = F2(
		function (key, formattingDecoder) {
			return A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				key,
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, formattingDecoder),
				$elm$core$Maybe$Nothing);
		});
	var simpleFormatting = F2(
		function (key, formatting) {
			return A2(
				baseDecoder,
				key,
				$elm$json$Json$Decode$succeed(formatting));
		});
	return A3(
		baseDecoder,
		'list',
		A2(
			$elm$json$Json$Decode$andThen,
			function (decodedString) {
				switch (decodedString) {
					case 'bullet':
						return $elm$json$Json$Decode$succeed($author$project$Markdown$UnorderedList);
					case 'ordered':
						return $elm$json$Json$Decode$succeed($author$project$Markdown$OrderedList);
					default:
						return $elm$json$Json$Decode$fail('Expected either `bullet` or `ordered` as a list type');
				}
			},
			$elm$json$Json$Decode$string),
		A3(
			baseDecoder,
			'header',
			A2($elm$json$Json$Decode$map, $author$project$Markdown$Header, $elm$json$Json$Decode$int),
			A3(
				baseDecoder,
				'link',
				A2($elm$json$Json$Decode$map, $author$project$Markdown$LinkFormatting, $elm$json$Json$Decode$string),
				A3(
					simpleFormatting,
					'underline',
					$author$project$Markdown$Underline,
					A3(
						simpleFormatting,
						'strike',
						$author$project$Markdown$Strike,
						A3(
							simpleFormatting,
							'italic',
							$author$project$Markdown$Italic,
							A3(
								simpleFormatting,
								'bold',
								$author$project$Markdown$Bold,
								$elm$json$Json$Decode$succeed(
									F7(
										function (bold, italic, strike, underline, link, header, list) {
											return A2(
												$elm$core$List$filterMap,
												$elm$core$Basics$identity,
												_List_fromArray(
													[bold, italic, strike, underline, link, header, list]));
										})))))))));
}();
var $author$project$Markdown$quillOpDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'attributes',
	$author$project$Markdown$formattingObjectDecoder,
	_List_Nil,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'insert',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed(
			F2(
				function (insert, attributes) {
					return {A: attributes, aw: insert};
				}))));
var $author$project$Form$RichText$textChangeDecoder = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['detail', 'ops']),
	$elm$json$Json$Decode$list($author$project$Markdown$quillOpDecoder));
var $author$project$Form$RichText$view = F3(
	function (_v0, viewConfig, toMsg) {
		var options = _v0;
		var model = function () {
			var _v3 = viewConfig.pO;
			var model_ = _v3;
			return model_;
		}();
		var boolToString = function (x) {
			return x ? 'true' : 'false';
		};
		var _v1 = viewConfig.iw;
		var t = _v1.il;
		return A2(
			$elm$html$Html$div,
			options.mg,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					options.fK,
					_List_fromArray(
						[
							$elm$core$String$isEmpty(options.nC) ? $elm$html$Html$text('') : A2(
							$author$project$View$Components$label,
							_List_Nil,
							{nD: options.nC, pv: model.R}),
							A2(
							$elm$html$Html$map,
							toMsg,
							A3(
								$elm$html$Html$node,
								'richtext-editor',
								_List_fromArray(
									[
										A2(
										$elm$html$Html$Attributes$attribute,
										'elm-placeholder',
										A2($elm$core$Maybe$withDefault, '', options.oG)),
										A2($elm$html$Html$Attributes$attribute, 'elm-id', model.R),
										A2(
										$elm$html$Html$Attributes$attribute,
										'elm-has-error',
										boolToString(viewConfig.m$)),
										A2(
										$elm$html$Html$Attributes$attribute,
										'elm-edit-text',
										t('markdown.link_tooltip.edit')),
										A2(
										$elm$html$Html$Attributes$attribute,
										'elm-remove-text',
										t('markdown.link_tooltip.remove')),
										A2(
										$elm$html$Html$Attributes$attribute,
										'elm-disabled',
										boolToString(options.cf)),
										A2(
										$elm$html$Html$Events$on,
										'clicked-include-link',
										A2($elm$json$Json$Decode$map, $author$project$Form$RichText$ClickedIncludeLink, $author$project$Form$RichText$linkDecoder)),
										A2(
										$elm$html$Html$Events$on,
										'text-change',
										A2($elm$json$Json$Decode$map, $author$project$Form$RichText$ChangedText, $author$project$Form$RichText$textChangeDecoder)),
										A2(
										$elm$html$Html$Events$on,
										'component-loaded',
										$elm$json$Json$Decode$succeed($author$project$Form$RichText$ComponentLoaded))
									]),
								_List_Nil)),
							viewConfig.mM
						])),
					function () {
					var _v2 = model.a0;
					if (!_v2.$) {
						return $elm$html$Html$text('');
					} else {
						var linkModal = _v2.a;
						return A2(
							$elm$html$Html$map,
							toMsg,
							$author$project$View$Modal$toHtml(
								A2(
									$author$project$View$Modal$withBody,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$form,
											_List_fromArray(
												[
													$author$project$Utils$onSubmitPreventAll($author$project$Form$RichText$ClickedAcceptLink),
													$elm$html$Html$Attributes$novalidate(true)
												]),
											_List_fromArray(
												[
													function (config) {
													return A2(
														$author$project$Form$Text$view,
														config,
														{
															mM: $elm$html$Html$text(''),
															m$: false,
															nx: true,
															od: $author$project$Form$RichText$NoOp,
															oe: $author$project$Form$RichText$EnteredLinkLabel,
															iw: viewConfig.iw,
															pO: linkModal.nC
														});
												}(
													$author$project$Form$Text$init(
														{
															R: model.R + '-link-modal-label',
															nC: t('markdown.link_form.label')
														})),
													function (config) {
													return A2(
														$author$project$Form$Text$view,
														config,
														{
															mM: $elm$html$Html$text(''),
															m$: false,
															nx: true,
															od: $author$project$Form$RichText$NoOp,
															oe: $author$project$Form$RichText$EnteredLinkUrl,
															iw: viewConfig.iw,
															pO: linkModal.gL
														});
												}(
													A2(
														$author$project$Form$Text$withType,
														3,
														$author$project$Form$Text$init(
															{
																R: model.R + '-link-modal-url',
																nC: t('markdown.link_form.url')
															}))),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('flex justify-center items-center')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$button,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('modal-cancel'),
																	$elm$html$Html$Events$onClick($author$project$Form$RichText$ClosedLinkModal),
																	$elm$html$Html$Attributes$type_('button')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	t('menu.cancel'))
																])),
															A2(
															$elm$html$Html$button,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('modal-accept'),
																	$elm$html$Html$Attributes$type_('submit')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	t('menu.save'))
																]))
														]))
												]))
										]),
									A2(
										$author$project$View$Modal$withHeader,
										t('markdown.link_form.header'),
										$author$project$View$Modal$initWith(
											{i$: $author$project$Form$RichText$ClosedLinkModal, jW: true})))));
					}
				}()
				]));
	});
var $author$project$Form$Select$customOnInput = F2(
	function (optionFromString, optionToMsg) {
		return A2(
			$elm$html$Html$Events$stopPropagationOn,
			'input',
			A2(
				$elm$json$Json$Decode$map,
				function (optionMsg) {
					return _Utils_Tuple2(optionMsg, true);
				},
				A2(
					$elm$json$Json$Decode$andThen,
					function (targetValue) {
						var _v0 = optionFromString(targetValue);
						if (_v0.$ === 1) {
							return $elm$json$Json$Decode$fail('The selected value is not a valid option');
						} else {
							var optionValue = _v0.a;
							return $elm$json$Json$Decode$succeed(
								optionToMsg(optionValue));
						}
					},
					$elm$html$Html$Events$targetValue)));
	});
var $elm_community$list_extra$List$Extra$findMap = F2(
	function (f, list) {
		findMap:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var a = list.a;
				var tail = list.b;
				var _v1 = f(a);
				if (!_v1.$) {
					var b = _v1.a;
					return $elm$core$Maybe$Just(b);
				} else {
					var $temp$f = f,
						$temp$list = tail;
					f = $temp$f;
					list = $temp$list;
					continue findMap;
				}
			}
		}
	});
var $elm$html$Html$select = _VirtualDom_node('select');
var $author$project$Form$Select$view = F2(
	function (_v0, viewConfig) {
		var options = _v0;
		var viewOption = function (_v2) {
			var option = _v2.gj;
			var label = _v2.nC;
			return A2(
				$elm$html$Html$option,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$value(
						options.dG(option)),
						$elm$html$Html$Attributes$selected(
						_Utils_eq(viewConfig.pO, option))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(label)
					]));
		};
		var optionFromValue = function (newValue) {
			return A2(
				$elm_community$list_extra$List$Extra$findMap,
				function (_v1) {
					var option = _v1.gj;
					return _Utils_eq(
						options.dG(option),
						newValue) ? $elm$core$Maybe$Just(option) : $elm$core$Maybe$Nothing;
				},
				options.gk);
		};
		return A2(
			$elm$html$Html$div,
			options.mg,
			_List_fromArray(
				[
					A2(
					$author$project$View$Components$label,
					options.f4,
					{nD: options.nC, pv: options.R}),
					A2(
					$elm$html$Html$select,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('input pr-10 form-select-icon w-full'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('with-error', viewConfig.m$)
								])),
							$elm$html$Html$Attributes$required(viewConfig.nx),
							$elm$html$Html$Attributes$disabled(options.cf),
							$elm$html$Html$Events$onBlur(viewConfig.od),
							A2($author$project$Form$Select$customOnInput, optionFromValue, viewConfig.kv)
						]),
					A2(
						$elm$core$List$map,
						viewOption,
						$elm$core$List$reverse(options.gk))),
					viewConfig.mM
				]));
	});
var $author$project$Icons$question = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$class(class_),
				$elm$svg$Svg$Attributes$height('16'),
				$elm$svg$Svg$Attributes$viewBox('0 0 16 16'),
				$elm$svg$Svg$Attributes$fill('none')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1ZM8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8C14 11.3137 11.3137 14 8 14Z'),
						$elm$svg$Svg$Attributes$fill('currentColor')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M8 4C6.02353 4 5.5 5.44412 5.5 6.20588C5.5 6.44954 5.69752 6.64706 5.94118 6.64706C6.18483 6.64706 6.38235 6.44954 6.38235 6.20588C6.38235 6.07059 6.42647 4.88235 8 4.88235C9.49706 4.88235 9.61765 5.71176 9.61765 6.79412C9.61765 6.96176 9.20588 7.22647 8.90294 7.41765C8.31471 7.8 7.55882 8.27353 7.55882 9.14706C7.55882 9.39071 7.75635 9.58823 8 9.58823C8.24366 9.58823 8.44118 9.39071 8.44118 9.14706C8.44118 8.78529 8.81176 8.52353 9.37647 8.16176C9.94118 7.8 10.5 7.44706 10.5 6.79412C10.5 5.95882 10.5 4 8 4Z'),
						$elm$svg$Svg$Attributes$fill('currentColor')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M7.85329 11.5C8.09694 11.5 8.29446 11.3025 8.29446 11.0589C8.29446 10.8152 8.09694 10.6177 7.85329 10.6177C7.60963 10.6177 7.41211 10.8152 7.41211 11.0589C7.41211 11.3025 7.60963 11.5 7.85329 11.5Z'),
						$elm$svg$Svg$Attributes$fill('currentColor')
					]),
				_List_Nil)
			]));
};
var $author$project$View$Components$tooltip = function (_v0) {
	var message = _v0.nS;
	var iconClass = _v0.nc;
	var containerClass = _v0.mh;
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('icon-tooltip ml-1 z-10 ' + containerClass)
			]),
		_List_fromArray(
			[
				$author$project$Icons$question('inline-block ' + iconClass),
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('icon-tooltip-content')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(message)
					]))
			]));
};
var $author$project$Form$Toggle$viewLabel = function (_v0) {
	var options = _v0;
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex items-center')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$for(options.R),
						$elm$html$Html$Attributes$class('cursor-pointer')
					]),
				_List_fromArray(
					[options.nC])),
				function () {
				var _v1 = options.is;
				if (_v1.$ === 1) {
					return $elm$html$Html$text('');
				} else {
					var tooltip = _v1.a;
					return $author$project$View$Components$tooltip(tooltip);
				}
			}()
			]));
};
var $author$project$Form$Toggle$statusText = F2(
	function (_v0, viewConfig) {
		var options = _v0;
		var _v1 = options.ld;
		return viewConfig.pO ? viewConfig.iw.il('settings.features.enabled') : viewConfig.iw.il('settings.features.disabled');
	});
var $author$project$Form$Toggle$viewStatusText = F2(
	function (_v0, viewConfig) {
		var options = _v0;
		return A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('font-semibold lowercase text-sm my-auto'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('text-indigo-500', viewConfig.pO && ((!options.cf) && (!viewConfig.m$))),
							_Utils_Tuple2('text-gray-600', ((!viewConfig.pO) || options.cf) && (!viewConfig.m$)),
							_Utils_Tuple2('text-red', viewConfig.m$)
						]))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2($author$project$Form$Toggle$statusText, options, viewConfig))
				]));
	});
var $author$project$Form$Toggle$viewToggle = F2(
	function (_v0, viewConfig) {
		var options = _v0;
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('select-none')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('checkbox'),
							$elm$html$Html$Attributes$id(options.R),
							$elm$html$Html$Attributes$checked(viewConfig.pO),
							$elm$html$Html$Events$onCheck(viewConfig.or),
							$elm$html$Html$Events$onBlur(viewConfig.od),
							$elm$html$Html$Attributes$disabled(options.cf),
							$elm$html$Html$Attributes$required(viewConfig.nx),
							$elm$html$Html$Attributes$class('sr-only')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('relative block border-2 border-gray-100 rounded-full h-6 w-12 transition-colors ease-in duration-200 input form-switch-label2'),
							$elm$html$Html$Attributes$class('before:block before:bg-gray-900 before:w-4 before:h-4 before:rounded-full before:absolute before:inset-y-0.5 before:mx-0.5 before:transition-all before:duration-200 before:ease-in before:right-6'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('bg-indigo-500 before:bg-white before:right-0', viewConfig.pO),
									_Utils_Tuple2('bg-white', !viewConfig.pO),
									_Utils_Tuple2('border-red with-error', viewConfig.m$)
								]))
						]),
					_List_Nil)
				]));
	});
var $author$project$Form$Toggle$view = F2(
	function (_v0, viewConfig) {
		var options = _v0;
		return A2(
			$elm$html$Html$div,
			options.mg,
			_List_fromArray(
				[
					function () {
					var _v1 = options.it;
					if (_v1.$ === 1) {
						return $elm$html$Html$text('');
					} else {
						var topLabel = _v1.a;
						return A2(
							$author$project$View$Components$label,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mb-6')
								]),
							{nD: topLabel, pv: options.R});
					}
				}(),
					function () {
					var _v2 = options.id;
					var invert = _v2.jS;
					return A2(
						$elm$html$Html$div,
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$class('flex'),
							$elm_community$maybe_extra$Maybe$Extra$isNothing(options.it) ? options.mg : _List_Nil),
						_List_fromArray(
							[
								$author$project$Form$Toggle$viewLabel(options),
								A2(
								$elm$html$Html$label,
								A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$class('flex cursor-pointer ml-auto space-x-7 pl-4'),
									A2(
										$elm$core$List$cons,
										$elm$html$Html$Attributes$for(options.R),
										options.gH)),
								invert ? _List_fromArray(
									[
										A2($author$project$Form$Toggle$viewToggle, options, viewConfig),
										A2($author$project$Form$Toggle$viewStatusText, options, viewConfig)
									]) : _List_fromArray(
									[
										A2($author$project$Form$Toggle$viewStatusText, options, viewConfig),
										A2($author$project$Form$Toggle$viewToggle, options, viewConfig)
									]))
							]));
				}(),
					viewConfig.mM
				]));
	});
var $author$project$Form$UserPicker$GotSelectMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$View$Select$PrivateMsg = $elm$core$Basics$identity;
var $fapian$elm_html_aria$Html$Attributes$Aria$ariaExpanded = $elm$html$Html$Attributes$attribute('aria-expanded');
var $author$project$View$Select$Styles$inputControlClass = 'elm-select-input-control ';
var $author$project$View$Select$Styles$inputControlStyles = _List_fromArray(
	[
		_Utils_Tuple2('position', 'relative'),
		_Utils_Tuple2('background', 'white')
	]);
var $author$project$View$Select$Styles$inputWrapperClass = 'elm-select-input-wrapper ';
var $author$project$View$Select$Styles$inputWrapperStyles = _List_fromArray(
	[
		_Utils_Tuple2('display', 'flex'),
		_Utils_Tuple2('flex', '1'),
		_Utils_Tuple2('flex-direction', 'row'),
		_Utils_Tuple2('flex-wrap', 'wrap')
	]);
var $author$project$View$Select$Utils$difference = F2(
	function (listA, listB) {
		return A2(
			$elm$core$List$filter,
			function (x) {
				return !A2(
					$elm$core$List$any,
					function (y) {
						return _Utils_eq(x, y);
					},
					listB);
			},
			listA);
	});
var $author$project$View$Select$Search$filterItems = F3(
	function (config, availableItems, selectedItems) {
		return config.jV ? A2($author$project$View$Select$Utils$difference, availableItems, selectedItems) : availableItems;
	});
var $author$project$View$Select$Search$maybeCuttoff = F2(
	function (config, items) {
		var _v0 = config.i8;
		if (!_v0.$) {
			var cutoff = _v0.a;
			return A2($elm$core$List$take, cutoff, items);
		} else {
			return items;
		}
	});
var $author$project$View$Select$Search$matchedItemsWithCutoff = F4(
	function (config, maybeQuery, availableItems, selectedItems) {
		if (!maybeQuery.$) {
			if (maybeQuery.a === '') {
				return config.mH ? $elm$core$Maybe$Just(
					A2(
						$author$project$View$Select$Search$maybeCuttoff,
						config,
						A3($author$project$View$Select$Search$filterItems, config, availableItems, selectedItems))) : $elm$core$Maybe$Nothing;
			} else {
				var query = maybeQuery.a;
				return A2(
					$elm$core$Maybe$map,
					$author$project$View$Select$Search$maybeCuttoff(config),
					A2(
						config.hh,
						query,
						A3($author$project$View$Select$Search$filterItems, config, availableItems, selectedItems)));
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$View$Select$Messages$OnRemoveItem = function (a) {
	return {$: 3, a: a};
};
var $author$project$View$Select$Messages$OnFocus = {$: 1};
var $author$project$View$Select$Messages$OnQueryChange = function (a) {
	return {$: 8, a: a};
};
var $fapian$elm_html_aria$Html$Attributes$Aria$ariaActiveDescendant = $elm$html$Html$Attributes$attribute('aria-activedescendant');
var $author$project$View$Select$Styles$inputClass = 'elm-select-input input';
var $author$project$View$Select$Styles$inputStyles = _List_Nil;
var $author$project$View$Select$Utils$menuItemId = F2(
	function (config, index) {
		return config.np + ('-menu-item-' + $elm$core$String$fromInt(index));
	});
var $author$project$View$Select$Messages$OnBlur = {$: 2};
var $author$project$View$Select$Events$onBlurAttribute = F2(
	function (config, state) {
		var dataDecoder = A2(
			$elm$json$Json$Decode$andThen,
			function (targetId) {
				if (A2($elm$core$String$startsWith, config.np + '-menu-item-', targetId)) {
					var _v0 = state.m7;
					if (_v0.$ === 1) {
						return $elm$json$Json$Decode$fail('Focus is not leaving select container');
					} else {
						var highlightedItem = _v0.a;
						return A2(
							$elm$core$String$endsWith,
							$elm$core$String$fromInt(highlightedItem),
							targetId) ? $elm$json$Json$Decode$fail('Focus is not leaving select container') : $elm$json$Json$Decode$succeed($author$project$View$Select$Messages$OnBlur);
					}
				} else {
					return $elm$json$Json$Decode$succeed($author$project$View$Select$Messages$OnBlur);
				}
			},
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['relatedTarget', 'id']),
				$elm$json$Json$Decode$string));
		return A2($elm$html$Html$Events$on, 'focusout', dataDecoder);
	});
var $author$project$View$Select$Messages$OnSelect = function (a) {
	return {$: 9, a: a};
};
var $author$project$View$Select$Internal$Input$onKeyPressAttribute = function (maybeItem) {
	var fn = function (code) {
		switch (code) {
			case 9:
				return A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Decode$fail('nothing selected'),
					A2(
						$elm$core$Maybe$map,
						A2($elm$core$Basics$composeL, $elm$json$Json$Decode$succeed, $author$project$View$Select$Messages$OnSelect),
						maybeItem));
			case 13:
				return A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Decode$fail('nothing selected'),
					A2(
						$elm$core$Maybe$map,
						A2($elm$core$Basics$composeL, $elm$json$Json$Decode$succeed, $author$project$View$Select$Messages$OnSelect),
						maybeItem));
			default:
				return $elm$json$Json$Decode$fail('not TAB or ENTER');
		}
	};
	return A2(
		$elm$html$Html$Events$on,
		'keypress',
		A2($elm$json$Json$Decode$andThen, fn, $elm$html$Html$Events$keyCode));
};
var $author$project$View$Select$Messages$OnDownArrow = {$: 5};
var $author$project$View$Select$Messages$OnEsc = {$: 4};
var $author$project$View$Select$Messages$OnUpArrow = {$: 6};
var $author$project$View$Select$Internal$Input$onKeyUpAttribute = function (maybeItem) {
	var selectItem = function () {
		if (maybeItem.$ === 1) {
			return $elm$json$Json$Decode$fail('not Enter');
		} else {
			var item = maybeItem.a;
			return $elm$json$Json$Decode$succeed(
				$author$project$View$Select$Messages$OnSelect(item));
		}
	}();
	var fn = function (code) {
		switch (code) {
			case 13:
				return selectItem;
			case 38:
				return $elm$json$Json$Decode$succeed($author$project$View$Select$Messages$OnUpArrow);
			case 40:
				return $elm$json$Json$Decode$succeed($author$project$View$Select$Messages$OnDownArrow);
			case 27:
				return $elm$json$Json$Decode$succeed($author$project$View$Select$Messages$OnEsc);
			default:
				return $elm$json$Json$Decode$fail('not ENTER');
		}
	};
	return A2(
		$elm$html$Html$Events$on,
		'keyup',
		A2($elm$json$Json$Decode$andThen, fn, $elm$html$Html$Events$keyCode));
};
var $fapian$elm_html_aria$Html$Attributes$Aria$role = $elm$html$Html$Attributes$attribute('role');
var $author$project$View$Select$Utils$stylesToAttrs = function (styles) {
	return A2(
		$elm$core$List$map,
		function (_v0) {
			var k = _v0.a;
			var v = _v0.b;
			return A2($elm$html$Html$Attributes$style, k, v);
		},
		styles);
};
var $author$project$View$Select$Internal$Input$inputAttributes = F5(
	function (config, model, _v0, selectedItems, maybeMatchedItems) {
		var preselectedItem = function () {
			if (!maybeMatchedItems.$) {
				var matchedItems = maybeMatchedItems.a;
				if (config.jV) {
					var _v4 = model.m7;
					if (_v4.$ === 1) {
						return $elm$core$List$head(matchedItems);
					} else {
						var n = _v4.a;
						return A2(
							$elm$core$Array$get,
							n % $elm$core$List$length(matchedItems),
							$elm$core$Array$fromList(matchedItems));
					}
				} else {
					return $elm$core$List$head(matchedItems);
				}
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var activeDescendant = function () {
			var _v2 = model.m7;
			if (_v2.$ === 1) {
				return $elm$html$Html$Attributes$class('');
			} else {
				var highlightedItem = _v2.a;
				return $fapian$elm_html_aria$Html$Attributes$Aria$ariaActiveDescendant(
					A2($author$project$View$Select$Utils$menuItemId, config, highlightedItem));
			}
		}();
		var _v1 = $elm$core$List$isEmpty(selectedItems) ? _Utils_Tuple2(config.kL, config.kM) : _Utils_Tuple2('', _List_Nil);
		var promptClass = _v1.a;
		var promptStyles = _v1.b;
		var inputClasses = A2(
			$elm$core$String$join,
			' ',
			_List_fromArray(
				[$author$project$View$Select$Styles$inputClass, config.nn, promptClass]));
		var inputStyles = $elm$core$List$concat(
			_List_fromArray(
				[$author$project$View$Select$Styles$inputStyles, config.jM, promptStyles]));
		var inputStylesAttrs = $author$project$View$Select$Utils$stylesToAttrs(inputStyles);
		return A2(
			$elm$core$List$cons,
			$elm$html$Html$Attributes$autocomplete(false),
			A2(
				$elm$core$List$cons,
				A2($elm$html$Html$Attributes$attribute, 'autocorrect', 'off'),
				A2(
					$elm$core$List$cons,
					A2($elm$html$Html$Attributes$attribute, 'autocomplete', 'off'),
					A2(
						$elm$core$List$cons,
						A2($elm$html$Html$Attributes$attribute, 'autocapitalize', 'off'),
						A2(
							$elm$core$List$cons,
							A2($elm$html$Html$Attributes$attribute, 'spellcheck', 'false'),
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$id(config.np),
								A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$disabled(config.cf),
									A2(
										$elm$core$List$cons,
										A2($author$project$View$Select$Events$onBlurAttribute, config, model),
										A2(
											$elm$core$List$cons,
											$author$project$View$Select$Internal$Input$onKeyUpAttribute(preselectedItem),
											A2(
												$elm$core$List$cons,
												$author$project$View$Select$Internal$Input$onKeyPressAttribute(preselectedItem),
												A2(
													$elm$core$List$cons,
													$elm$html$Html$Events$onInput($author$project$View$Select$Messages$OnQueryChange),
													A2(
														$elm$core$List$cons,
														$elm$html$Html$Events$onFocus($author$project$View$Select$Messages$OnFocus),
														A2(
															$elm$core$List$cons,
															$elm$html$Html$Attributes$class(inputClasses),
															A2(
																$elm$core$List$cons,
																$elm$html$Html$Attributes$classList(config.no),
																A2(
																	$elm$core$List$cons,
																	$fapian$elm_html_aria$Html$Attributes$Aria$role('combobox'),
																	A2(
																		$elm$core$List$cons,
																		activeDescendant,
																		A2(
																			$elm$core$List$cons,
																			A2($elm$html$Html$Attributes$attribute, 'aria-owns', model.R + '-items-list'),
																			A2(
																				$elm$core$List$cons,
																				$fapian$elm_html_aria$Html$Attributes$Aria$ariaExpanded(
																					model.pc ? 'true' : 'false'),
																				A2(
																					$elm$core$List$cons,
																					A2($elm$html$Html$Attributes$attribute, 'aria-autocomplete', 'list'),
																					inputStylesAttrs)))))))))))))))))));
	});
var $author$project$View$Select$Styles$multiInputItemClass = 'elm-select-multi-input-item ';
var $author$project$View$Select$Styles$multiInputItemContainerClass = 'elm-select-multi-input-item-container ';
var $author$project$View$Select$Styles$multiInputItemContainerStyles = _List_fromArray(
	[
		_Utils_Tuple2('display', 'flex'),
		_Utils_Tuple2('flex-direction', 'row'),
		_Utils_Tuple2('align-items', 'center'),
		_Utils_Tuple2('justify-content', 'center')
	]);
var $author$project$View$Select$Styles$multiInputItemStyles = _List_fromArray(
	[
		_Utils_Tuple2('display', 'flex'),
		_Utils_Tuple2('border-width', '0.1rem'),
		_Utils_Tuple2('border-radius', '0.2em'),
		_Utils_Tuple2('border-color', '#E3E5E8'),
		_Utils_Tuple2('background-color', '#E3E5E8'),
		_Utils_Tuple2('font-size', '.75rem'),
		_Utils_Tuple2('margin-right', '.2rem')
	]);
var $author$project$View$Select$Styles$multiInputItemText = _List_fromArray(
	[
		_Utils_Tuple2('text-overflow', 'ellipsis'),
		_Utils_Tuple2('padding-left', '.5rem'),
		_Utils_Tuple2('padding-right', '.3rem'),
		_Utils_Tuple2('padding-top', '.05rem'),
		_Utils_Tuple2('padding-bottom', '.05rem'),
		_Utils_Tuple2('display', 'none')
	]);
var $author$project$View$Select$Styles$multiInputRemoveItem = _List_fromArray(
	[
		_Utils_Tuple2('display', 'flex'),
		_Utils_Tuple2('alignItems', 'center'),
		_Utils_Tuple2('justifyContent', 'center'),
		_Utils_Tuple2('padding-right', '.1rem')
	]);
var $author$project$View$Select$Internal$Input$onClickWithoutPropagation = function (msg) {
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'click',
		$elm$json$Json$Decode$succeed(
			_Utils_Tuple2(msg, false)));
};
var $author$project$View$Select$Styles$removeItemSvgStyles = _List_fromArray(
	[
		_Utils_Tuple2('cursor', 'pointer')
	]);
var $author$project$View$Select$Internal$RemoveItem$svgPath = 'M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z';
var $author$project$View$Select$Internal$RemoveItem$view = function (config) {
	return A2(
		$elm$svg$Svg$svg,
		A2(
			$elm$core$List$cons,
			$elm$svg$Svg$Attributes$class(config.kS),
			A2(
				$elm$core$List$cons,
				$elm$svg$Svg$Attributes$width('14'),
				A2(
					$elm$core$List$cons,
					$elm$svg$Svg$Attributes$height('14'),
					A2(
						$elm$core$List$cons,
						$elm$svg$Svg$Attributes$viewBox('0 0 20 20'),
						A2(
							$elm$core$List$map,
							function (_v0) {
								var f = _v0.a;
								var s = _v0.b;
								return A2($elm$html$Html$Attributes$style, f, s);
							},
							_Utils_ap(config.kT, $author$project$View$Select$Styles$removeItemSvgStyles)))))),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d($author$project$View$Select$Internal$RemoveItem$svgPath)
					]),
				_List_Nil)
			]));
};
var $author$project$View$Select$Internal$Input$multiInput = F5(
	function (config, model, availableItems, selected, maybeMatchedItems) {
		var val = A2($elm$core$Maybe$withDefault, '', model.dO);
		var multiInputItemStyles = A2($elm$core$List$append, $author$project$View$Select$Styles$multiInputItemStyles, config.kh);
		var multiInputItemStylesAttrs = $author$project$View$Select$Utils$stylesToAttrs(multiInputItemStyles);
		var multiInputItemContainerStyles = A2($elm$core$List$append, $author$project$View$Select$Styles$multiInputItemContainerStyles, config.kg);
		var multiInputItemContainerStylesAttrs = $author$project$View$Select$Utils$stylesToAttrs(multiInputItemContainerStyles);
		var multiInputItemContainerClasses = _Utils_ap($author$project$View$Select$Styles$multiInputItemContainerClass, config.kf);
		var multiInputItemClasses = _Utils_ap($author$project$View$Select$Styles$multiInputItemClass, config.ke);
		var viewMultiItems = function (subItems) {
			return A2(
				$elm$html$Html$div,
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$class(multiInputItemContainerClasses),
					multiInputItemContainerStylesAttrs),
				A2(
					$elm$core$List$map,
					function (item) {
						return A2(
							$elm$html$Html$div,
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$class(multiInputItemClasses),
								multiInputItemStylesAttrs),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									A2(
										$elm$core$List$map,
										function (_v0) {
											var f = _v0.a;
											var s = _v0.b;
											return A2($elm$html$Html$Attributes$style, f, s);
										},
										$author$project$View$Select$Styles$multiInputItemText),
									_List_fromArray(
										[
											$elm$html$Html$text(
											config.pz(item))
										])),
									A2(
									$elm$core$Maybe$withDefault,
									A2($elm$html$Html$span, _List_Nil, _List_Nil),
									A2(
										$elm$core$Maybe$map,
										function (_v1) {
											return A2(
												$elm$html$Html$div,
												A2(
													$elm$core$List$cons,
													$author$project$View$Select$Internal$Input$onClickWithoutPropagation(
														$author$project$View$Select$Messages$OnRemoveItem(item)),
													A2(
														$elm$core$List$map,
														function (_v2) {
															var f = _v2.a;
															var s = _v2.b;
															return A2($elm$html$Html$Attributes$style, f, s);
														},
														$author$project$View$Select$Styles$multiInputRemoveItem)),
												_List_fromArray(
													[
														$author$project$View$Select$Internal$RemoveItem$view(config)
													]));
										},
										config.ku))
								]));
					},
					subItems));
		};
		return _List_fromArray(
			[
				viewMultiItems(selected),
				A2(
				$elm$html$Html$input,
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$value(val),
					_Utils_ap(
						A5($author$project$View$Select$Internal$Input$inputAttributes, config, model, availableItems, selected, maybeMatchedItems),
						$elm$core$List$isEmpty(selected) ? _List_fromArray(
							[
								$elm$html$Html$Attributes$placeholder(config.oT)
							]) : _List_Nil)),
				_List_Nil)
			]);
	});
var $author$project$View$Select$Internal$Input$singleInput = F5(
	function (config, model, availableItems, selectedItems, maybeMatchedItems) {
		var val = A2($elm$core$Maybe$withDefault, '', model.dO);
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$input,
				_Utils_ap(
					A5($author$project$View$Select$Internal$Input$inputAttributes, config, model, availableItems, selectedItems, maybeMatchedItems),
					_List_fromArray(
						[
							$elm$html$Html$Attributes$value(val),
							$elm$html$Html$Attributes$placeholder(config.oT)
						])),
				_List_Nil)
			]);
	});
var $author$project$View$Select$Styles$underlineStyles = _List_Nil;
var $author$project$View$Select$Internal$Input$view = F4(
	function (config, model, availableItems, selectedItems) {
		var underlineStyles = A2($elm$core$List$append, $author$project$View$Select$Styles$underlineStyles, config.ly);
		var underline = A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class(config.lx),
				A2(
					$elm$core$List$map,
					function (_v0) {
						var f = _v0.a;
						var s = _v0.b;
						return A2($elm$html$Html$Attributes$style, f, s);
					},
					underlineStyles)),
			_List_Nil);
		var maybeMatchedItems = A4($author$project$View$Select$Search$matchedItemsWithCutoff, config, model.dO, availableItems, selectedItems);
		var inputWrapperStyles = A2($elm$core$List$append, $author$project$View$Select$Styles$inputWrapperStyles, config.jO);
		var inputWrapperStylesAttrs = $author$project$View$Select$Utils$stylesToAttrs(inputWrapperStyles);
		var inputWrapperClass = _Utils_ap($author$project$View$Select$Styles$inputWrapperClass, config.jN);
		var inputControlStyles = A2($elm$core$List$append, $author$project$View$Select$Styles$inputControlStyles, config.jL);
		var inputControlStylesAttrs = $author$project$View$Select$Utils$stylesToAttrs(inputControlStyles);
		var inputControlClass = _Utils_ap($author$project$View$Select$Styles$inputControlClass, config.jK);
		var input = config.jV ? A5($author$project$View$Select$Internal$Input$multiInput, config, model, availableItems, selectedItems, maybeMatchedItems) : A5($author$project$View$Select$Internal$Input$singleInput, config, model, availableItems, selectedItems, maybeMatchedItems);
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class(inputControlClass),
				inputControlStylesAttrs),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$class(inputWrapperClass),
						inputWrapperStylesAttrs),
					input),
					underline
				]));
	});
var $author$project$View$Select$Styles$hiddenMenuStyles = _List_fromArray(
	[
		_Utils_Tuple2('display', 'none')
	]);
var $author$project$View$Select$Messages$OnResetFocusToFirstItem = {$: 7};
var $author$project$View$Select$Internal$Menu$keyListener = F2(
	function (model, itemCount) {
		return $author$project$View$Components$keyListener(
			{
				lL: _List_fromArray(
					[0, 3, 4]),
				kF: true,
				le: false,
				pA: function (key) {
					switch (key) {
						case 0:
							return $author$project$View$Select$Messages$OnEsc;
						case 3:
							return $author$project$View$Select$Messages$OnUpArrow;
						case 4:
							var _v1 = model.m7;
							if (_v1.$ === 1) {
								return $author$project$View$Select$Messages$OnDownArrow;
							} else {
								var highlightedItem = _v1.a;
								return (_Utils_cmp(highlightedItem, itemCount - 1) > -1) ? $author$project$View$Select$Messages$OnResetFocusToFirstItem : $author$project$View$Select$Messages$OnDownArrow;
							}
						default:
							return $author$project$View$Select$Messages$OnDownArrow;
					}
				}
			});
	});
var $author$project$View$Select$Messages$NoOp = {$: 0};
var $author$project$View$Select$Internal$Item$baseItemStyles = function (config) {
	return config.jY;
};
var $author$project$View$Select$Styles$menuItemStyles = _List_fromArray(
	[
		_Utils_Tuple2('cursor', 'pointer')
	]);
var $author$project$View$Select$Internal$Item$view = F5(
	function (config, state, itemCount, index, item) {
		var itemHtml = function () {
			var _v3 = config.nB;
			if (_v3.$ === 1) {
				return $elm$html$Html$text(
					config.pz(item));
			} else {
				var fn = _v3.a;
				return A2(
					$elm$html$Html$map,
					function (_v4) {
						return $author$project$View$Select$Messages$NoOp;
					},
					fn(item));
			}
		}();
		var _v0 = function () {
			var _v1 = state.m7;
			if (_v1.$ === 1) {
				return _Utils_Tuple2('', _List_Nil);
			} else {
				var highlighted = _v1.a;
				return _Utils_eq(highlighted % itemCount, index) ? _Utils_Tuple2(config.jE, config.jF) : _Utils_Tuple2('', _List_Nil);
			}
		}();
		var highlightedItemClass = _v0.a;
		var highlightedItemStyles = _v0.b;
		var classes = A2(
			$elm$core$String$join,
			' ',
			_List_fromArray(
				[config.nA, 'w-full', highlightedItemClass]));
		var styles = $elm$core$List$concat(
			_List_fromArray(
				[
					$author$project$View$Select$Styles$menuItemStyles,
					$author$project$View$Select$Internal$Item$baseItemStyles(config),
					highlightedItemStyles
				]));
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('block w-full'),
					$fapian$elm_html_aria$Html$Attributes$Aria$role('option')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$class(classes),
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Events$onClick(
								$author$project$View$Select$Messages$OnSelect(item)),
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$tabindex(-1),
								A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$type_('button'),
									A2(
										$elm$core$List$cons,
										$elm$html$Html$Attributes$id(
											A2($author$project$View$Select$Utils$menuItemId, config, index)),
										A2(
											$elm$core$List$map,
											function (_v2) {
												var f = _v2.a;
												var s = _v2.b;
												return A2($elm$html$Html$Attributes$style, f, s);
											},
											styles)))))),
					_List_fromArray(
						[itemHtml]))
				]));
	});
var $author$project$View$Select$Internal$Item$viewNotFound = function (config) {
	var styles = A2(
		$elm$core$List$append,
		$author$project$View$Select$Internal$Item$baseItemStyles(config),
		config.kn);
	var classes = A2(
		$elm$core$String$join,
		' ',
		_List_fromArray(
			[config.nA, config.n9]));
	return (config.kl === '') ? $elm$html$Html$text('') : A2(
		$elm$html$Html$div,
		A2(
			$elm$core$List$cons,
			$elm$html$Html$Attributes$class(classes),
			A2(
				$elm$core$List$map,
				function (_v0) {
					var f = _v0.a;
					var s = _v0.b;
					return A2($elm$html$Html$Attributes$style, f, s);
				},
				styles)),
		_List_fromArray(
			[
				$elm$html$Html$text(config.kl)
			]));
};
var $author$project$View$Select$Styles$visibleMenuStyles = _List_fromArray(
	[
		_Utils_Tuple2('position', 'absolute')
	]);
var $author$project$View$Select$Internal$Menu$viewStyles = function (config) {
	return A2($elm$core$List$append, $author$project$View$Select$Styles$visibleMenuStyles, config.kb);
};
var $author$project$View$Select$Internal$Menu$menu = F3(
	function (config, model, matchedItems) {
		var noResultElement = _Utils_eq(matchedItems, _List_Nil) ? $author$project$View$Select$Internal$Item$viewNotFound(config) : $elm$html$Html$text('');
		var itemCount = $elm$core$List$length(matchedItems);
		var hideWhenNotFound = (!config.km) && _Utils_eq(matchedItems, _List_Nil);
		var menuStyle = hideWhenNotFound ? A2(
			$elm$core$List$map,
			function (_v0) {
				var f = _v0.a;
				var s = _v0.b;
				return A2($elm$html$Html$Attributes$style, f, s);
			},
			$author$project$View$Select$Styles$hiddenMenuStyles) : A2(
			$elm$core$List$map,
			function (_v1) {
				var f = _v1.a;
				var s = _v1.b;
				return A2($elm$html$Html$Attributes$style, f, s);
			},
			$author$project$View$Select$Internal$Menu$viewStyles(config));
		var elements = A2(
			$elm$core$List$indexedMap,
			A3($author$project$View$Select$Internal$Item$view, config, model, itemCount),
			matchedItems);
		return model.pc ? A2(
			$elm$html$Html$ul,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class(config.dB),
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2(config.ji, !itemCount)
							])),
					A2(
						$elm$core$List$cons,
						A2($author$project$View$Select$Events$onBlurAttribute, config, model),
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$id(model.R + '-items-list'),
							menuStyle)))),
			A2(
				$elm$core$List$cons,
				noResultElement,
				A2(
					$elm$core$List$cons,
					A2($author$project$View$Select$Internal$Menu$keyListener, model, itemCount),
					elements))) : $elm$html$Html$text('');
	});
var $author$project$View$Select$Internal$Menu$view = F4(
	function (config, model, availableItems, selectedItems) {
		var searchResult = A4($author$project$View$Select$Search$matchedItemsWithCutoff, config, model.dO, availableItems, selectedItems);
		if (searchResult.$ === 1) {
			return $elm$html$Html$text('');
		} else {
			var matchedItems = searchResult.a;
			return A3($author$project$View$Select$Internal$Menu$menu, config, model, matchedItems);
		}
	});
var $author$project$View$Select$Internal$view = F4(
	function (config, model, availableItems, selectedItems) {
		var classes = 'elm-select';
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id(model.R),
					$elm$html$Html$Attributes$class(classes),
					A2($elm$html$Html$Attributes$style, 'position', 'relative'),
					A2($elm$html$Html$Attributes$style, 'width', '100%'),
					$fapian$elm_html_aria$Html$Attributes$Aria$ariaExpanded(
					model.pc ? 'true' : 'false')
				]),
			_List_fromArray(
				[
					A4($author$project$View$Select$Internal$Input$view, config, model, availableItems, selectedItems),
					A4($author$project$View$Select$Internal$Menu$view, config, model, availableItems, selectedItems)
				]));
	});
var $author$project$View$Select$view = F4(
	function (config, model, items, selected) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			A4(
				$author$project$View$Select$Internal$view,
				$author$project$View$Select$unwrapConfig(config),
				$author$project$View$Select$unwrapModel(model),
				items,
				selected));
	});
var $author$project$Form$UserPicker$ClickedRemoveProfile = function (a) {
	return {$: 4, a: a};
};
var $author$project$Form$UserPicker$GotProfileSummaryMsg = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Profile$Summary$Ignored = 0;
var $author$project$Profile$Summary$ClosedInfo = 2;
var $author$project$Profile$Summary$OpenedInfo = 1;
var $elm$html$Html$Events$onMouseEnter = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseenter',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$Events$onMouseLeave = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseleave',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$View$Components$dialogBubble = F2(
	function (_v0, elements) {
		var class_ = _v0.l8;
		var relativeSelector = _v0.e$;
		var scrollSelector = _v0.e0;
		return A3(
			$elm$html$Html$node,
			'dialog-bubble',
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'elm-class', class_),
					A2($author$project$View$Components$optionalAttr, 'elm-relative-selector', relativeSelector),
					A2($author$project$View$Components$optionalAttr, 'elm-scroll-selector', scrollSelector)
				]),
			elements);
	});
var $author$project$Icons$phone = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('20'),
				$elm$svg$Svg$Attributes$height('20'),
				$elm$svg$Svg$Attributes$viewBox('0 0 20 20'),
				$elm$svg$Svg$Attributes$fill('black'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M18.5789 13.6387L16.2657 11.317C15.8014 10.8358 15.24 10.5783 14.6406 10.5783C14.0454 10.5783 13.4797 10.8316 13.0027 11.3086L11.8124 12.4947C11.7997 12.4863 11.787 12.4821 11.7701 12.4736C11.7322 12.4567 11.6984 12.4356 11.6604 12.4145C11.5127 12.3428 11.3776 12.271 11.2678 12.2035C10.0437 11.4268 8.92928 10.4095 7.86132 9.10088C7.40121 8.51836 7.0804 8.03292 6.83979 7.53904C7.10151 7.28999 7.35056 7.04094 7.59116 6.79611L7.67981 6.70747C7.73891 6.64837 7.798 6.58505 7.8571 6.52596C7.9162 6.46686 7.97529 6.40776 8.03439 6.34867C8.51983 5.86323 8.78154 5.28915 8.78154 4.69396C8.78154 4.09877 8.52405 3.52891 8.03439 3.03926L6.882 1.88687C6.75115 1.75601 6.62029 1.62516 6.49366 1.49008C6.24461 1.23259 5.97445 0.95821 5.69163 0.696496C5.23152 0.240608 4.67432 0 4.08758 0C3.50083 0 2.93519 0.240608 2.4582 0.700717L1.01455 2.15703C0.427805 2.74377 0.0943304 3.46137 0.018349 4.29295C-0.0871808 5.57619 0.284284 6.76234 0.575546 7.54326C1.27204 9.42591 2.31468 11.1608 3.85119 13.0097C5.7254 15.2512 7.98374 17.0156 10.5587 18.2609C11.5591 18.7336 12.893 19.2908 14.3788 19.3837C14.4759 19.3879 14.5688 19.3921 14.6574 19.3921C15.7127 19.3921 16.5992 19.0122 17.2957 18.2566L17.3252 18.2229V18.2186C17.3252 18.2144 17.3295 18.2144 17.3295 18.2102C17.5194 17.978 17.7431 17.7628 17.9795 17.5348L18.0344 17.4799C18.2539 17.2689 18.4312 17.0916 18.5916 16.927C19.0601 16.4415 19.305 15.8717 19.305 15.2765C19.3092 14.6813 19.0559 14.1114 18.5789 13.6387ZM6.48521 5.51709L6.48099 5.52131C6.10531 5.90544 5.78449 6.22203 5.43414 6.54284C5.42569 6.55128 5.40881 6.56395 5.39192 6.58505C4.89382 7.09582 5.06267 7.63191 5.12177 7.8092L5.13865 7.85563L5.14287 7.86407C5.45102 8.607 5.88158 9.31194 6.54431 10.152L6.55697 10.1688C7.74313 11.6252 8.98838 12.7607 10.3645 13.6302C10.5502 13.7484 10.7317 13.8371 10.909 13.9257C11.0568 13.9975 11.1918 14.0692 11.3058 14.1368L11.3311 14.1494C11.348 14.1579 11.3649 14.1705 11.3776 14.179C11.5591 14.2676 11.7364 14.314 11.9179 14.314C12.3822 14.314 12.6608 14.0354 12.7537 13.9426L14.1973 12.4989C14.3071 12.3892 14.4675 12.2626 14.6406 12.2626C14.8178 12.2626 14.9698 12.3976 15.0458 12.4821L17.3885 14.8248C17.6883 15.1203 17.7094 15.3778 17.4603 15.6775C17.4603 15.6775 16.3206 16.8088 16.0504 17.1254C15.679 17.5222 15.24 17.7037 14.6659 17.7037C14.6068 17.7037 14.5435 17.7037 14.4886 17.6994C13.2813 17.6235 12.15 17.1465 11.2974 16.737C8.94195 15.5973 6.87356 13.9764 5.15976 11.9291C3.74566 10.2237 2.79167 8.64077 2.16693 6.94808C1.79125 5.93921 1.65195 5.16251 1.71105 4.42381C1.74904 3.99747 1.91366 3.64289 2.21337 3.33896L3.64857 1.90376C3.80476 1.75601 3.96094 1.68003 4.10024 1.68003C4.27331 1.68003 4.42527 1.79823 4.52236 1.89531L4.53924 1.9122C4.77985 2.13592 5.01202 2.37231 5.29062 2.65935C5.35393 2.72689 5.42147 2.79443 5.48479 2.85774L5.49323 2.86619C5.56077 2.93373 5.62409 3.00127 5.69585 3.07303L6.84824 4.22541C7.19015 4.56733 7.19015 4.80793 6.84824 5.14563C6.80602 5.18784 6.76381 5.23005 6.72582 5.26804C6.6414 5.36091 6.56542 5.43689 6.48521 5.51709Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Icons$telegram = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('30'),
				$elm$svg$Svg$Attributes$height('30'),
				$elm$svg$Svg$Attributes$viewBox('0 0 30 30'),
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30Z'),
						$elm$svg$Svg$Attributes$fill('#30A8DB')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M12.25 21.875C11.764 21.875 11.8466 21.6915 11.679 21.2287L10.25 16.5259L21.25 10'),
						$elm$svg$Svg$Attributes$fill('#C8DAEA')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M12.25 21.875C12.625 21.875 12.7906 21.7035 13 21.5L15 19.5552L12.5052 18.0509'),
						$elm$svg$Svg$Attributes$fill('#A9C9DD')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M12.505 18.0513L18.55 22.5174C19.2398 22.898 19.7376 22.7009 19.9095 21.877L22.3701 10.2816C22.622 9.27163 21.9851 8.81338 21.3251 9.113L6.87635 14.6844C5.8901 15.08 5.89597 15.6303 6.6966 15.8754L10.4045 17.0328L18.9886 11.6171C19.3938 11.3714 19.7658 11.5034 19.4606 11.7744'),
						$elm$svg$Svg$Attributes$fill('#FFFFFF')
					]),
				_List_Nil)
			]));
};
var $author$project$Icons$whatsapp = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('32'),
				$elm$svg$Svg$Attributes$height('32'),
				$elm$svg$Svg$Attributes$viewBox('0 0 32 32'),
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M16 28C23.1797 28 29 22.4036 29 15.5C29 8.59644 23.1797 3 16 3C8.8203 3 3 8.59644 3 15.5C3 22.4036 8.8203 28 16 28Z'),
						$elm$svg$Svg$Attributes$fill('#25D366')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M8.71997 22.5337L9.74829 18.9204C9.11267 17.8608 8.77882 16.6588 8.7804 15.4355C8.7804 11.5923 12.034 8.46533 16.0299 8.46533C16.9825 8.46546 17.9257 8.64606 18.8056 8.9968C19.6856 9.34755 20.485 9.86157 21.1583 10.5095C21.8316 11.1574 22.3655 11.9266 22.7296 12.773C23.0936 13.6194 23.2806 14.5265 23.28 15.4424C23.28 19.2856 20.0259 22.4131 16.0304 22.4131H16.0274C14.817 22.413 13.626 22.1213 12.5631 21.5645L8.71997 22.5337ZM12.7408 20.3022L12.9612 20.4277C13.8896 20.9565 14.9488 21.2354 16.0279 21.2354H16.0304C19.3515 21.2354 22.0546 18.6362 22.0561 15.4414C22.0562 14.5437 21.8393 13.6583 21.4225 12.855C21.0058 12.0517 20.4007 11.3525 19.6548 10.8125C18.909 10.2726 18.0429 9.90662 17.1248 9.74358C16.2067 9.58054 15.2618 9.62485 14.3646 9.87302C13.4674 10.1212 12.6424 10.5664 11.9548 11.1736C11.2671 11.7808 10.7356 12.5333 10.4022 13.3718C10.0687 14.2103 9.94247 15.1118 10.0334 16.0052C10.1242 16.8987 10.4298 17.7596 10.9259 18.52L11.0691 18.7393L10.4597 20.8774L12.7408 20.3022Z'),
						$elm$svg$Svg$Attributes$fill('white')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M19.6826 17.0996C19.6374 17.0268 19.5165 16.9834 19.3353 16.896C19.154 16.8086 18.2638 16.3877 18.0977 16.3301C17.9317 16.2724 17.8108 16.2427 17.6915 16.4175C17.5721 16.5923 17.2238 16.9844 17.1182 17.1011C17.0125 17.2178 16.9069 17.2319 16.7256 17.1445C16.5443 17.0571 15.9608 16.8735 15.2692 16.2798C14.7304 15.8179 14.3668 15.2475 14.2617 15.0732C14.1566 14.8989 14.2505 14.8047 14.3409 14.7178C14.4227 14.6396 14.5222 14.5141 14.6126 14.4126C14.6873 14.3238 14.7483 14.2251 14.7939 14.1196C14.8179 14.0715 14.8291 14.0185 14.8264 13.9652C14.8238 13.9119 14.8073 13.8601 14.7787 13.8144C14.7335 13.727 14.3724 12.8701 14.2201 12.5215C14.0733 12.1797 13.9235 12.2285 13.8138 12.2222C13.7041 12.2158 13.5873 12.2163 13.4665 12.2163C13.3747 12.2186 13.2844 12.2392 13.2013 12.2767C13.1182 12.3141 13.0441 12.3677 12.9835 12.4341C12.8175 12.6084 12.3498 13.0298 12.3498 13.8872C12.3498 14.7446 12.9988 15.5727 13.0897 15.689C13.1806 15.8052 14.3668 17.5644 16.1843 18.3188C16.5216 18.4587 16.8664 18.5812 17.2172 18.686C17.5866 18.7939 17.9771 18.8175 18.3577 18.7549C18.7061 18.706 19.4297 18.3335 19.5805 17.9248C19.7314 17.5161 19.7278 17.1723 19.6826 17.0996Z'),
						$elm$svg$Svg$Attributes$fill('white')
					]),
				_List_Nil)
			]));
};
var $author$project$Profile$Contact$contactTypeToIcon = F3(
	function (class_, isInverted, contactType) {
		switch (contactType) {
			case 3:
				return isInverted ? $author$project$Icons$phoneInverted(class_) : $author$project$Icons$phone(class_);
			case 1:
				return $author$project$Icons$instagram(class_);
			case 4:
				return isInverted ? $author$project$Icons$telegramInverted(class_) : $author$project$Icons$telegram(class_);
			case 5:
				return isInverted ? $author$project$Icons$whatsappInverted(class_) : $author$project$Icons$whatsapp(class_);
			case 0:
				return $author$project$Icons$mail(class_);
			default:
				return $author$project$Icons$link(class_);
		}
	});
var $author$project$Profile$Contact$toHref = function (_v0) {
	var contactType = _v0.mf;
	var contact = _v0.me;
	switch (contactType) {
		case 3:
			return $elm$html$Html$Attributes$href('tel:' + contact);
		case 1:
			return $elm$html$Html$Attributes$href(contact);
		case 4:
			return $elm$html$Html$Attributes$href(contact);
		case 5:
			return $elm$html$Html$Attributes$href(
				'https://api.whatsapp.com/send?phone=' + A2(
					$elm$core$String$filter,
					$elm$core$Char$isAlphaNum,
					A2($elm$core$String$dropLeft, 1, contact)));
		case 0:
			return $elm$html$Html$Attributes$href('mailto:' + contact);
		default:
			return $elm$html$Html$Attributes$href(contact);
	}
};
var $author$project$Profile$Contact$circularIcon = F2(
	function (class_, _v0) {
		var normalized = _v0;
		var _v1 = function () {
			var _v2 = normalized.mf;
			switch (_v2) {
				case 3:
					return _Utils_Tuple2('bg-orange-300', 'fill-current text-white');
				case 1:
					return _Utils_Tuple2('bg-instagram', '');
				case 4:
					return _Utils_Tuple2('bg-telegram', '');
				case 5:
					return _Utils_Tuple2('bg-whatsapp', '');
				case 0:
					return _Utils_Tuple2('bg-gray-500', 'fill-current text-orange-300');
				default:
					return _Utils_Tuple2('bg-gray-500', '');
			}
		}();
		var bgColor = _v1.a;
		var textColor = _v1.b;
		var _v3 = normalized.mf;
		if (_v3 === 4) {
			return A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$author$project$Profile$Contact$toHref(normalized),
						$elm$html$Html$Attributes$class('hover:opacity-80')
					]),
				_List_fromArray(
					[
						A3($author$project$Profile$Contact$contactTypeToIcon, class_, false, normalized.mf)
					]));
		} else {
			return A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(
						A2(
							$elm$core$String$join,
							' ',
							_List_fromArray(
								['p-2 rounded-full flex items-center justify-center hover:opacity-80', textColor, bgColor, class_]))),
						$author$project$Profile$Contact$toHref(normalized)
					]),
				_List_fromArray(
					[
						A3($author$project$Profile$Contact$contactTypeToIcon, 'fill-current text-white object-contain', true, normalized.mf)
					]));
		}
	});
var $author$project$Profile$Summary$viewUserInfo = function (profile) {
	var userName = A2($elm$core$Maybe$withDefault, '', profile.ki);
	var email = A2($elm$core$Maybe$withDefault, '', profile.jh);
	var bio = A2($elm$core$Maybe$withDefault, $author$project$Markdown$empty, profile.cW);
	var account = $author$project$Eos$Account$nameToString(profile.fl);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex flex-col w-full')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex mb-4 items-center justify-center')
					]),
				_List_fromArray(
					[
						A2($author$project$Avatar$view, profile.cV, 'w-20 h-20 mr-6 flex-shrink-0'),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex items-center justify-between')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$ul,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-sm text-gray-900')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$li,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('font-semibold text-body-black text-2xl xs-max:text-xl')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(userName)
											])),
										A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$a,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$href('mailto:' + email),
														$elm$html$Html$Attributes$class('hover:underline hover:text-orange-300 focus:outline-none focus:underline focus:text-orange-300')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(email)
													]))
											])),
										A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(account)
											]))
									]))
							]))
					])),
				A2(
				$author$project$Markdown$view,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-sm text-gray-900')
					]),
				bio),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex justify-evenly mt-6')
					]),
				A2(
					$elm$core$List$map,
					$author$project$Profile$Contact$circularIcon('w-9 h-9 hover:opacity-75'),
					profile.aq)),
				A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('button button-primary w-full mt-6 cursor-pointer'),
						$author$project$Route$href(
						$author$project$Route$Profile(profile.fl))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('View full profile')
					]))
			]));
};
var $author$project$Profile$Summary$viewUserImg = F5(
	function (_v0, profile, loggedInAccount, isMobile, model) {
		var t = _v0.il;
		var tr = _v0.iu;
		var container = function (attrs) {
			return isMobile ? $elm$html$Html$button(
				A2(
					$elm$core$List$cons,
					$author$project$Utils$onClickNoBubble(1),
					_Utils_ap(model.fO, attrs))) : $elm$html$Html$a(
				A2(
					$elm$core$List$cons,
					$author$project$Route$href(
						$author$project$Route$Profile(profile.fl)),
					_Utils_ap(model.fO, attrs)));
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-col items-center')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('rounded-full ' + model.eA)
						]),
					_List_fromArray(
						[
							A2(
							container,
							_List_fromArray(
								[
									$fapian$elm_html_aria$Html$Attributes$Aria$ariaLabel(
									_Utils_eq(loggedInAccount, profile.fl) ? t('profile.summary.your_summary') : A2(
										tr,
										'profile.summary.user_summary',
										_List_fromArray(
											[
												_Utils_Tuple2(
												'user',
												A2(
													$elm$core$Maybe$withDefault,
													$author$project$Eos$Account$nameToString(profile.fl),
													profile.ki))
											])))
								]),
							_List_fromArray(
								[
									A2($author$project$Avatar$view, profile.cV, model.eA)
								])),
							((!isMobile) && model.dr) ? A2(
							$author$project$View$Components$dialogBubble,
							{l8: 'w-120 animate-fade-in opacity-0', e$: model.e$, e0: model.e0},
							_List_fromArray(
								[
									$author$project$Profile$Summary$viewUserInfo(profile)
								])) : $elm$html$Html$text('')
						]))
				]));
	});
var $author$project$Eos$Account$viewName = function (_v0) {
	var name = _v0;
	return $elm$html$Html$text(name);
};
var $author$project$Profile$viewProfileName = F4(
	function (translators, showYou, loggedInAccount, profile) {
		if (showYou && _Utils_eq(profile.fl, loggedInAccount)) {
			return $elm$html$Html$text(
				translators.il('transfer_result.you'));
		} else {
			var _v0 = profile.ki;
			if (!_v0.$) {
				var u = _v0.a;
				return $elm$html$Html$text(u);
			} else {
				return $author$project$Eos$Account$viewName(profile.fl);
			}
		}
	});
var $author$project$Profile$viewProfileNameTag = F4(
	function (shared, _v0, loggedInAccount, profile) {
		var showBg = _v0.pb;
		var showYou = _v0.pf;
		return A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('py-1 px-3 uppercase font-bold text-xs text-center truncate'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('bg-black text-white rounded-label', showBg)
						]))
				]),
			_List_fromArray(
				[
					A4($author$project$Profile$viewProfileName, shared, showYou, loggedInAccount, profile)
				]));
	});
var $author$project$Profile$Summary$viewUserNameTag = F4(
	function (translators, loggedInAccount, profile, model) {
		return model.gz ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mt-2 w-20'),
					$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
				]),
			_List_fromArray(
				[
					A4(
					$author$project$Profile$viewProfileNameTag,
					translators,
					{pb: model.gA, pf: model.gB},
					loggedInAccount,
					profile)
				])) : $elm$html$Html$text('');
	});
var $author$project$Profile$Summary$desktopView = F4(
	function (translators, loggedInAccount, profile, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mx-auto hidden md:block')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Events$onMouseEnter(1),
							$elm$html$Html$Events$onMouseLeave(2)
						]),
					_List_fromArray(
						[
							A5($author$project$Profile$Summary$viewUserImg, translators, profile, loggedInAccount, false, model)
						])),
					A4($author$project$Profile$Summary$viewUserNameTag, translators, loggedInAccount, profile, model)
				]));
	});
var $author$project$View$Modal$withPreventScrolling = F2(
	function (preventScrolling, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{gp: preventScrolling});
	});
var $author$project$Profile$Summary$mobileView = F4(
	function (translators, loggedInAccount, profile, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('md:hidden cursor-auto')
				]),
			_List_fromArray(
				[
					A5($author$project$Profile$Summary$viewUserImg, translators, profile, loggedInAccount, true, model),
					A4($author$project$Profile$Summary$viewUserNameTag, translators, loggedInAccount, profile, model),
					$author$project$View$Modal$toHtml(
					A2(
						$author$project$View$Modal$withPreventScrolling,
						model.gp,
						A2(
							$author$project$View$Modal$withBody,
							_List_fromArray(
								[
									$author$project$Profile$Summary$viewUserInfo(profile)
								]),
							$author$project$View$Modal$initWith(
								{i$: 2, jW: model.dr}))))
				]));
	});
var $author$project$Profile$Summary$view = F4(
	function (translators, loggedInAccount, profile, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$onClickPreventAll(0)
				]),
			_List_fromArray(
				[
					A4($author$project$Profile$Summary$desktopView, translators, loggedInAccount, profile, model),
					A4($author$project$Profile$Summary$mobileView, translators, loggedInAccount, profile, model)
				]));
	});
var $author$project$Profile$Summary$withRelativeSelector = F2(
	function (relativeSelector, model) {
		return _Utils_update(
			model,
			{
				e$: $elm$core$Maybe$Just(relativeSelector)
			});
	});
var $author$project$Profile$Summary$withScrollSelector = F2(
	function (scrollSelector, model) {
		return _Utils_update(
			model,
			{
				e0: $elm$core$Maybe$Just(scrollSelector)
			});
	});
var $author$project$Form$UserPicker$viewSelectedProfile = F4(
	function (index, _v0, viewConfig, _v1) {
		var options = _v0;
		var profile = _v1.kJ;
		var summary = _v1.dZ;
		var addScrollSelector = function () {
			var _v4 = options.eW.dP;
			if (_v4.$ === 1) {
				return $elm$core$Basics$identity;
			} else {
				var selector = _v4.a;
				return $author$project$Profile$Summary$withScrollSelector(selector);
			}
		}();
		var _v2 = viewConfig.pO;
		var model = _v2;
		var addRelativeSelector = function () {
			var _v3 = options.eW.dP;
			if (_v3.$ === 1) {
				return $author$project$Profile$Summary$withRelativeSelector(
					'#' + (model.R + ('-' + $elm$core$String$fromInt(index))));
			} else {
				var selector = _v3.a;
				return $author$project$Profile$Summary$withRelativeSelector(selector);
			}
		}();
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-col items-center'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('relative', options.d9)
						])),
					$elm$html$Html$Attributes$id(
					model.R + ('-' + $elm$core$String$fromInt(index)))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$Form$UserPicker$GotProfileSummaryMsg(profile),
					A4(
						$author$project$Profile$Summary$view,
						viewConfig.iw,
						options.eo,
						profile,
						addScrollSelector(
							addRelativeSelector(summary)))),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('hover:opacity-80 focus-ring focus:ring-red focus:ring-opacity-30 rounded-sm mt-2'),
							$elm$html$Html$Events$onClick(
							$author$project$Form$UserPicker$ClickedRemoveProfile(profile)),
							$elm$html$Html$Attributes$type_('button'),
							$fapian$elm_html_aria$Html$Attributes$Aria$ariaLabel(
							A2(
								viewConfig.iw.iu,
								'community.actions.form.unselect_user',
								_List_fromArray(
									[
										_Utils_Tuple2(
										'username',
										A2(
											$elm$core$Maybe$withDefault,
											$author$project$Eos$Account$nameToString(profile.fl),
											profile.ki))
									])))
						]),
					_List_fromArray(
						[
							$author$project$Icons$trash('text-red')
						]))
				]));
	});
var $author$project$Form$UserPicker$view = F3(
	function (wrappedOptions, viewConfig, toMsg) {
		var options = wrappedOptions;
		var _v0 = viewConfig.pO;
		var model = _v0;
		var selectedProfiles = function () {
			var _v1 = model.W;
			if (_v1.$ === 1) {
				var _v2 = _v1;
				return _List_Nil;
			} else {
				var profile = _v1.a;
				return _List_fromArray(
					[profile]);
			}
		}();
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('mb-10'),
				options.mg),
			_List_fromArray(
				[
					A2(
					$author$project$View$Components$label,
					_List_Nil,
					{nD: options.nC, pv: model.R}),
					A2(
					$elm$html$Html$map,
					A2($elm$core$Basics$composeL, toMsg, $author$project$Form$UserPicker$GotSelectMsg),
					A4(
						$author$project$View$Select$view,
						A2($author$project$Form$UserPicker$settings, wrappedOptions, viewConfig),
						model.dT,
						A2(
							$elm$core$List$filter,
							function (profile) {
								return !A2(
									$elm$core$List$member,
									profile,
									A2(
										$elm$core$List$map,
										function ($) {
											return $.kJ;
										},
										selectedProfiles));
							},
							options.eX),
						A2(
							$elm$core$List$map,
							function ($) {
								return $.kJ;
							},
							selectedProfiles))),
					viewConfig.mM,
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mt-4 flex flex-wrap gap-6')
						]),
					A2(
						$elm$core$List$indexedMap,
						F2(
							function (index, profile) {
								return A2(
									$elm$html$Html$map,
									toMsg,
									A4($author$project$Form$UserPicker$viewSelectedProfile, index, wrappedOptions, viewConfig, profile));
							}),
						selectedProfiles))
				]));
	});
var $author$project$Form$viewError = F3(
	function (attributes, showError, maybeError) {
		if (maybeError.$ === 1) {
			return $elm$html$Html$text('');
		} else {
			var error = maybeError.a;
			return showError ? A2(
				$elm$html$Html$p,
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$class('form-error'),
					attributes),
				_List_fromArray(
					[
						$elm$html$Html$text(error)
					])) : $elm$html$Html$text('');
		}
	});
var $author$project$Form$Checkbox$withDisabled = F2(
	function (disabled, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{cf: disabled});
	});
var $author$project$Form$DatePicker$withDisabled = F2(
	function (disabled, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{cf: disabled});
	});
var $author$project$Form$File$withDisabled = F2(
	function (disabled, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{cf: disabled});
	});
var $author$project$Form$Radio$withDisabled = F2(
	function (disabled, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{cf: disabled});
	});
var $author$project$Form$RichText$withDisabled = F2(
	function (disabled, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{cf: disabled});
	});
var $author$project$Form$Select$withDisabled = F2(
	function (disabled, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{cf: disabled});
	});
var $author$project$Form$Text$withDisabled = F2(
	function (disabled, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{cf: disabled});
	});
var $author$project$Form$Toggle$withDisabled = F2(
	function (disabled, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{cf: disabled});
	});
var $author$project$Form$UserPicker$withDisabled = F2(
	function (disabled, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{cf: disabled});
	});
var $author$project$Form$viewField = F2(
	function (_v0, _v1) {
		var showError = _v0.ic;
		var translators = _v0.iw;
		var disabled = _v0.cf;
		var values = _v0.s;
		var model = _v0.nV;
		var form = _v0.hk;
		var toMsg = _v0.pA;
		var onSuccess = _v0.dE;
		var state = _v1.X;
		var error = _v1.mM;
		var isRequired = _v1.nx;
		var hasError = showError && $elm_community$maybe_extra$Maybe$Extra$isJust(error);
		var fieldId = $author$project$Form$getId(state);
		var onBlur = toMsg(
			$author$project$Form$BlurredField(
				{
					ac: fieldId,
					hu: $author$project$Form$isEmpty(state)
				}));
		var disableIfNotAlreadyDisabled = F2(
			function (options, setDisabled) {
				return disabled ? A2(setDisabled, true, options) : options;
			});
		var _v2 = function () {
			var model_ = model;
			return model_.aG;
		}();
		var errorTracking = _v2;
		switch (state.$) {
			case 0:
				var options = state.a;
				var baseField = state.b;
				var addSubmitOnEnter = $author$project$Form$Text$getSubmitOnEnter(options) ? $author$project$Form$Text$withExtraAttrs(
					_List_fromArray(
						[
							A3(
							$author$project$Form$submitOnEnter,
							form,
							model,
							{gi: toMsg, dE: onSuccess})
						])) : $elm$core$Basics$identity;
				var transformedOptions = addSubmitOnEnter(
					A2(disableIfNotAlreadyDisabled, options, $author$project$Form$Text$withDisabled));
				return A2(
					$author$project$Form$Text$view,
					transformedOptions,
					{
						mM: A3(
							$author$project$Form$viewError,
							$author$project$Form$Text$getErrorAttrs(options),
							showError,
							error),
						m$: hasError,
						nx: isRequired,
						od: onBlur,
						oe: A2(
							$elm$core$Basics$composeR,
							baseField.n,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Form$ChangedValues(
									{ac: fieldId}),
								toMsg)),
						iw: translators,
						pO: baseField.pO
					});
			case 1:
				var options = state.a;
				var baseField = state.b;
				return A3(
					$author$project$Form$RichText$view,
					A2(disableIfNotAlreadyDisabled, options, $author$project$Form$RichText$withDisabled),
					{
						mM: A3($author$project$Form$viewError, _List_Nil, showError, error),
						m$: hasError,
						nx: isRequired,
						od: onBlur,
						iw: translators,
						pO: baseField.pO
					},
					A2(
						$elm$core$Basics$composeR,
						A2($author$project$Form$GotRichTextMsg, baseField.aX, baseField.bb),
						toMsg));
			case 2:
				var options = state.a;
				var baseField = state.b;
				return A2(
					$author$project$Form$Toggle$view,
					A2(disableIfNotAlreadyDisabled, options, $author$project$Form$Toggle$withDisabled),
					{
						mM: A3($author$project$Form$viewError, _List_Nil, showError, error),
						m$: hasError,
						nx: isRequired,
						od: onBlur,
						or: A2(
							$elm$core$Basics$composeR,
							baseField.n,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Form$ChangedValues(
									{ac: fieldId}),
								toMsg)),
						iw: translators,
						pO: baseField.pO
					});
			case 3:
				var options = state.a;
				var baseField = state.b;
				return A2(
					$author$project$Form$Checkbox$view,
					A2(disableIfNotAlreadyDisabled, options, $author$project$Form$Checkbox$withDisabled),
					{
						mM: A3($author$project$Form$viewError, _List_Nil, showError, error),
						m$: hasError,
						nx: isRequired,
						od: onBlur,
						of: A2(
							$elm$core$Basics$composeR,
							baseField.n,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Form$ChangedValues(
									{ac: fieldId}),
								toMsg)),
						pO: baseField.pO
					});
			case 4:
				var options = state.a;
				var baseField = state.b;
				return A2(
					$author$project$Form$Radio$view,
					A2(disableIfNotAlreadyDisabled, options, $author$project$Form$Radio$withDisabled),
					{
						mM: A3($author$project$Form$viewError, _List_Nil, showError, error),
						m$: hasError,
						od: onBlur,
						kv: A2(
							$elm$core$Basics$composeR,
							baseField.n,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Form$ChangedValues(
									{ac: fieldId}),
								toMsg)),
						pO: baseField.pO
					});
			case 5:
				var options = state.a;
				var baseField = state.b;
				return A3(
					$author$project$Form$File$view,
					A2(disableIfNotAlreadyDisabled, options, $author$project$Form$File$withDisabled),
					{
						mM: A3($author$project$Form$viewError, _List_Nil, showError, error),
						m$: hasError,
						nx: isRequired,
						iw: translators,
						pO: baseField.pO
					},
					A2(
						$elm$core$Basics$composeR,
						A3(
							$author$project$Form$GotFileMsg,
							{
								ac: $author$project$Form$File$getId(options)
							},
							baseField.aX,
							baseField.bb),
						toMsg));
			case 6:
				var options = state.a;
				var baseField = state.b;
				return A2(
					$author$project$Form$Select$view,
					A2(disableIfNotAlreadyDisabled, options, $author$project$Form$Select$withDisabled),
					{
						mM: A3($author$project$Form$viewError, _List_Nil, showError, error),
						m$: hasError,
						nx: isRequired,
						od: onBlur,
						kv: A2(
							$elm$core$Basics$composeR,
							baseField.n,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Form$ChangedValues(
									{ac: fieldId}),
								toMsg)),
						pO: baseField.pO
					});
			case 7:
				var options = state.a;
				var baseField = state.b;
				var viewConfig = {
					mM: A3($author$project$Form$viewError, _List_Nil, showError, error),
					m$: hasError,
					nx: isRequired,
					iw: translators,
					pO: baseField.pO
				};
				return A2(
					$elm$html$Html$map,
					toMsg,
					A3(
						$author$project$Form$DatePicker$view,
						A2(disableIfNotAlreadyDisabled, options, $author$project$Form$DatePicker$withDisabled),
						viewConfig,
						A4($author$project$Form$GotDatePickerMsg, options, viewConfig, baseField.aX, baseField.bb)));
			case 8:
				var options = state.a;
				var baseField = state.b;
				var viewConfig = {
					mM: A3($author$project$Form$viewError, _List_Nil, showError, error),
					m$: hasError,
					od: $author$project$Form$BlurredField(
						{
							ac: $author$project$Form$getId(state),
							hu: $author$project$Form$isEmpty(state)
						}),
					iw: translators,
					pO: baseField.pO
				};
				return A2(
					$elm$html$Html$map,
					toMsg,
					A3(
						$author$project$Form$UserPicker$view,
						A2(disableIfNotAlreadyDisabled, options, $author$project$Form$UserPicker$withDisabled),
						viewConfig,
						A4($author$project$Form$GotUserPickerMsg, options, viewConfig, baseField.aX, baseField.bb)));
			case 9:
				var attrs = state.a;
				var fields = state.b;
				return A2(
					$elm$html$Html$div,
					A2(
						$elm$core$List$map,
						$elm$html$Html$Attributes$map(
							function (_v5) {
								return toMsg($author$project$Form$NoOp);
							}),
						attrs),
					A2(
						$elm$core$List$map,
						function (field_) {
							var showChildError = A2(
								$elm$core$Set$member,
								$author$project$Form$getId(field_.X),
								errorTracking.bU) && (!field_.aP);
							return A2(
								$author$project$Form$viewField,
								{cf: disabled, hk: form, nV: model, dE: onSuccess, ic: showError || showChildError, pA: toMsg, iw: translators, s: values},
								field_);
						},
						fields));
			case 10:
				var html = state.a;
				return A2(
					$elm$html$Html$map,
					function (fn) {
						return toMsg(
							A2(
								$author$project$Form$ChangedValues,
								{ac: fieldId},
								fn(values)));
					},
					html);
			default:
				var html = state.a;
				return html;
		}
	});
var $author$project$Form$viewFields = F5(
	function (translators, form, _v0, toMsg, onSuccess) {
		var model = _v0;
		var filledForm = A2($author$project$Form$fill, form, model.s);
		var _v1 = model.aG;
		var errorTracking = _v1;
		return A2(
			$elm$core$List$map,
			function (field_) {
				var shouldShowFieldError = A2(
					$elm$core$Set$member,
					$author$project$Form$getId(field_.X),
					errorTracking.bU) && (!field_.aP);
				return A2(
					$author$project$Form$viewField,
					{cf: model.cf, hk: form, nV: model, dE: onSuccess, ic: shouldShowFieldError || errorTracking.e2, pA: toMsg, iw: translators, s: model.s},
					field_);
			},
			$elm$core$List$reverse(filledForm.l));
	});
var $author$project$Form$view = F6(
	function (formAttrs, translators, footer, form, _v0, _v1) {
		var model = _v0;
		var toMsg = _v1.pA;
		var onSubmit = _v1.oq;
		return A2(
			$elm$html$Html$form,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$novalidate(true),
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Events$onSubmit(
						A3(
							$author$project$Form$parse,
							form,
							model,
							{gi: toMsg, dE: onSubmit})),
					formAttrs)),
			_Utils_ap(
				A5($author$project$Form$viewFields, translators, form, model, toMsg, onSubmit),
				footer(
					function (attrs) {
						return $elm$html$Html$button(
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$type_('submit'),
								A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$disabled(
										model.cf || $author$project$Form$hasFieldsLoading(model)),
									A2(
										$elm$core$List$map,
										$elm$html$Html$Attributes$map(
											function (_v2) {
												return toMsg($author$project$Form$NoOp);
											}),
										attrs))));
					})));
	});
var $author$project$Profile$EditKycForm$view = F2(
	function (translators, model) {
		var t = translators.il;
		return A6(
			$author$project$Form$view,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('md:max-w-sm md:mx-auto py-6')
				]),
			translators,
			function (submitButton) {
				return _List_fromArray(
					[
						A2(
						submitButton,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('button button-primary w-full')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								t('profile.edit.submit'))
							]))
					]);
			},
			$author$project$Profile$EditKycForm$createForm(translators),
			model.hk,
			{oq: $author$project$Profile$EditKycForm$Submitted, pA: $author$project$Profile$EditKycForm$GotFormMsg});
	});
var $author$project$Page$Community$Invite$viewContent = F3(
	function (_v0, _v1, innerContent) {
		var t = _v0.il;
		var creator = _v1.mq;
		var community = _v1.b9;
		var inviter = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Eos$Account$nameToString(creator.fl),
			creator.ki);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bg-white pb-20')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-wrap content-end')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex overflow-hidden items-center justify-center h-24 w-24 rounded-full mx-auto -mt-12 bg-white')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$img,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$src(community.hC),
											$elm$html$Html$Attributes$class('object-scale-down h-20 w-20')
										]),
									_List_Nil)
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('px-4')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mt-6')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-lg text-center')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('font-semibold')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(inviter)
												])),
											$elm$html$Html$text(' '),
											$elm$html$Html$text(
											t('community.invitation.title')),
											$elm$html$Html$text(' '),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('font-semibold')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(community.ki)
												]))
										]))
								])),
							innerContent
						]))
				]));
	});
var $author$project$Page$Community$Invite$viewExistingMemberNotice = F2(
	function (_v0, communityTitle) {
		var t = _v0.il;
		var tr = _v0.iu;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mt-6 text-center')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							t('community.invitation.already_member'))
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('max-w-lg md:mx-auto mt-3')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								tr,
								'community.invitation.choose_community_tip',
								_List_fromArray(
									[
										_Utils_Tuple2('communityTitle', communityTitle)
									])))
						]))
				]));
	});
var $author$project$Page$Community$Invite$viewHeader = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('w-full h-16 flex px-4 items-center bg-indigo-500')
		]),
	_List_Nil);
var $author$project$Page$Community$Invite$CloseConfirmationModal = {$: 3};
var $author$project$Page$Community$Invite$InvitationAccepted = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Page$Community$Invite$InvitationRejected = {$: 4};
var $author$project$Page$Community$Invite$viewModal = F4(
	function (_v0, modalStatus, invitationId, invite) {
		var t = _v0.il;
		var isModalVisible = function () {
			if (!modalStatus) {
				return false;
			} else {
				return true;
			}
		}();
		return $author$project$View$Modal$toHtml(
			A2(
				$author$project$View$Modal$withFooter,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('modal-cancel'),
								$elm$html$Html$Events$onClick($author$project$Page$Community$Invite$InvitationRejected)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								t('community.invitation.modal.no'))
							])),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('modal-accept'),
								$elm$html$Html$Events$onClick(
								A2($author$project$Page$Community$Invite$InvitationAccepted, invitationId, invite))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								t('community.invitation.modal.yes'))
							]))
					]),
				A2(
					$author$project$View$Modal$withBody,
					_List_fromArray(
						[
							$elm$html$Html$text(
							t('community.invitation.modal.body'))
						]),
					A2(
						$author$project$View$Modal$withHeader,
						t('community.invitation.modal.title'),
						$author$project$View$Modal$initWith(
							{i$: $author$project$Page$Community$Invite$CloseConfirmationModal, jW: isModalVisible})))));
	});
var $author$project$Page$Community$Invite$OpenConfirmationModal = {$: 2};
var $author$project$Page$Community$Invite$viewNewMemberConfirmation = F3(
	function (_v0, invitationId, invite) {
		var t = _v0.il;
		var community = invite.b9;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mt-6 px-4 text-center')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mr-1')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('community.invitation.subtitle'))
								])),
							$elm$html$Html$text(community.ki),
							$elm$html$Html$text('?')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-wrap justify-center w-full mt-6')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('button button-secondary w-full md:w-48 uppercase mb-4 md:mr-8'),
									$elm$html$Html$Events$onClick($author$project$Page$Community$Invite$OpenConfirmationModal)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('community.invitation.no'))
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('button button-primary w-full md:w-48 uppercase'),
									$elm$html$Html$Events$onClick(
									A2($author$project$Page$Community$Invite$InvitationAccepted, invitationId, invite))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('community.invitation.yes'))
								]))
						]))
				]));
	});
var $author$project$Page$Community$Invite$view = F2(
	function (session, model) {
		var shared = $author$project$Page$toShared(session);
		var _v0 = shared.iw;
		var t = _v0.il;
		var content = function () {
			var _v2 = model.bk;
			switch (_v2.$) {
				case 0:
					return $elm$html$Html$text('');
				case 1:
					return $elm$html$Html$text('');
				case 2:
					var e = _v2.a;
					return A2(
						$author$project$Page$fullPageGraphQLError,
						t(''),
						e);
				case 4:
					var invite = _v2.a;
					var inner = A2($author$project$Page$Community$Invite$viewExistingMemberNotice, shared.iw, invite.b9.ki);
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Page$Community$Invite$viewHeader,
								A3($author$project$Page$Community$Invite$viewContent, shared.iw, invite, inner)
							]));
				case 3:
					var invite = _v2.a;
					var inner = A3($author$project$Page$Community$Invite$viewNewMemberConfirmation, shared.iw, model.jT, invite);
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Page$Community$Invite$viewHeader,
								A3($author$project$Page$Community$Invite$viewContent, shared.iw, invite, inner),
								A4($author$project$Page$Community$Invite$viewModal, shared.iw, model.ej, model.jT, invite)
							]));
				default:
					var invite = _v2.a;
					var formData = A2($elm$core$Maybe$withDefault, $author$project$Profile$EditKycForm$init, model.eH);
					var inner = A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('md:max-w-sm md:mx-auto my-6')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										t('community.invite.kycRequired'))
									])),
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('mt-2 mb-6')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										t('community.kyc.add.canRemove'))
									])),
								A2(
								$elm$html$Html$map,
								$author$project$Page$Community$Invite$FormMsg,
								A2($author$project$Profile$EditKycForm$view, shared.iw, formData))
							]));
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Page$Community$Invite$viewHeader,
								A3($author$project$Page$Community$Invite$viewContent, shared.iw, invite, inner)
							]));
			}
		}();
		var title = function () {
			var _v1 = model.bk;
			if (_v1.$ === 3) {
				var invite = _v1.a;
				var inviter = A2(
					$elm$core$Maybe$withDefault,
					$author$project$Eos$Account$nameToString(invite.mq.fl),
					invite.mq.ki);
				return inviter + (' ' + (t('community.invitation.title') + (' ' + invite.b9.ki)));
			} else {
				return '';
			}
		}();
		return {mk: content, fb: title};
	});
var $author$project$Page$Community$New$SubmittedForm = function (a) {
	return {$: 2, a: a};
};
var $author$project$Form$File$CustomAction = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$Community$New$FormOutput = function (description) {
	return function (name) {
		return function (url) {
			return function (symbol) {
				return function (invitedReward) {
					return function (inviterReward) {
						return function (minimumBalance) {
							return function (website) {
								return function (requireInvitation) {
									return function (logo) {
										return {bc: description, dl: invitedReward, dm: inviterReward, hC: logo, dC: minimumBalance, ki: name, dQ: requireInvitation, e9: symbol, gL: url, cQ: website};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Form$Text$Number = 2;
var $author$project$Page$Community$New$SelectedEntry = function (a) {
	return {$: 1, a: a};
};
var $author$project$Route$addEnvironmentToUrl = F2(
	function (environment, url) {
		var environmentString = function () {
			switch (environment) {
				case 0:
					return '.staging.cambiatus.io';
				case 1:
					return '.staging.cambiatus.io';
				case 2:
					return '.demo.cambiatus.io';
				default:
					return '.cambiatus.io';
			}
		}();
		return _Utils_update(
			url,
			{
				ez: _Utils_ap(url.ez, environmentString)
			});
	});
var $author$project$Form$Validate$map = F2(
	function (fn, _v0) {
		var validator = _v0;
		return A2($elm$core$Result$map, fn, validator);
	});
var $author$project$Form$Validate$number = function (fromString) {
	return $author$project$Form$Validate$custom(
		A2(
			$elm$core$Basics$composeR,
			fromString,
			$elm$core$Result$fromMaybe(
				function (_v0) {
					var t = _v0.il;
					return t('error.validator.text.only_numbers');
				})));
};
var $author$project$Form$Validate$float = $author$project$Form$Validate$number($elm$core$String$toFloat);
var $author$project$Translation$floatStringFromSeparatedString = function (translators) {
	return $henriquecbuss$elm_mask$Mask$removeFloat(
		$author$project$Translation$decimalSeparators(translators));
};
var $author$project$Form$Validate$mapValidation = F2(
	function (fn, _v0) {
		var validator = _v0;
		return A2($elm$core$Result$map, fn, validator);
	});
var $author$project$Form$Validate$maskedFloat = function (translators) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Form$Validate$mapValidation(
			$author$project$Translation$floatStringFromSeparatedString(translators)),
		$author$project$Form$Validate$float);
};
var $author$project$Form$optional = function (form) {
	return function (values) {
		var filledForm = A2($author$project$Form$fill, form, values);
		var isFilledFormEmpty = A2(
			$elm$core$List$all,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.X;
				},
				$author$project$Form$isEmpty),
			filledForm.l);
		return {
			l: A2(
				$elm$core$List$map,
				function (field_) {
					return _Utils_update(
						field_,
						{
							mM: isFilledFormEmpty ? $elm$core$Maybe$Nothing : field_.mM,
							nx: false
						});
				},
				filledForm.l),
			m: function () {
				if (isFilledFormEmpty) {
					return $author$project$OptionalResult$OptOk($elm$core$Maybe$Nothing);
				} else {
					var _v0 = filledForm.m;
					switch (_v0.$) {
						case 1:
							var ok = _v0.a;
							return $author$project$OptionalResult$OptOk(
								$elm$core$Maybe$Just(ok));
						case 0:
							return $author$project$OptionalResult$OptNothing;
						default:
							return $author$project$OptionalResult$OptNothing;
					}
				}
			}()
		};
	};
};
var $author$project$Form$arbitraryWith = F2(
	function (succeedValue, html) {
		return function (_v0) {
			return {
				l: _List_fromArray(
					[
						{
						mM: $elm$core$Maybe$Nothing,
						nx: false,
						X: $author$project$Form$Arbitrary(html),
						aP: 0
					}
					]),
				m: $author$project$OptionalResult$OptOk(succeedValue)
			};
		};
	});
var $author$project$Form$Toggle$withTooltip = F2(
	function (tooltip, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				is: $elm$core$Maybe$Just(tooltip)
			});
	});
var $author$project$Page$Community$New$requireInvitationToggle = function (_v0) {
	var t = _v0.il;
	return A4(
		$author$project$Form$withGroup,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('border rounded-md px-3 py-2')
			]),
		A2(
			$author$project$Form$arbitraryWith,
			0,
			A2(
				$author$project$View$Components$label,
				_List_Nil,
				{
					nD: t('settings.community_info.invitation.title'),
					pv: 'require-invitation-toggle'
				})),
		A2(
			$author$project$Form$toggle,
			{
				ab: $elm$core$Basics$always($elm$core$Maybe$Nothing),
				af: $elm$core$Result$Ok,
				n: F2(
					function (requireInvitation, input) {
						return _Utils_update(
							input,
							{dQ: requireInvitation});
					}),
				pO: function ($) {
					return $.dQ;
				}
			},
			A2(
				$author$project$Form$Toggle$withContainerAttrs,
				_List_Nil,
				A2(
					$author$project$Form$Toggle$withTooltip,
					{
						mh: '',
						nc: 'text-orange-300',
						nS: t('settings.community_info.invitation.description')
					},
					$author$project$Form$Toggle$init(
						{
							R: 'require-invitation-toggle',
							nC: $elm$html$Html$text(
								t('settings.community_info.fields.invitation'))
						})))),
		$author$project$Form$succeed(
			F2(
				function (_v1, requiresInvitation) {
					return requiresInvitation;
				})));
};
var $author$project$Form$Validate$url = $author$project$Form$Validate$custom(
	function (stringInput) {
		var withProtocol = $elm$core$String$isEmpty(stringInput) ? '' : ((A2($elm$core$String$startsWith, 'https://', stringInput) || A2($elm$core$String$startsWith, 'http://', stringInput)) ? stringInput : ('http://' + stringInput));
		var _v0 = $elm$url$Url$fromString(withProtocol);
		if (_v0.$ === 1) {
			return $elm$core$Result$Err(
				function (_v1) {
					var t = _v1.il;
					return t('settings.community_info.errors.website.invalid');
				});
		} else {
			var url_ = _v0.a;
			return $elm$core$Result$Ok(url_);
		}
	});
var $author$project$Form$File$withAddImagesView = F2(
	function (newView, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				gO: $elm$core$Maybe$Just(newView)
			});
	});
var $author$project$Form$File$withContainerAttributes = F2(
	function (attributes, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				c4: _Utils_ap(options.c4, attributes)
			});
	});
var $author$project$Form$RichText$withEditorContainerAttrs = F2(
	function (attrs, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				fK: _Utils_ap(options.fK, attrs)
			});
	});
var $author$project$Form$Text$withElements = F2(
	function (elements, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				dd: _Utils_ap(
					options.dd,
					A2($elm$core$List$map, $elm$core$Basics$always, elements))
			});
	});
var $author$project$Form$File$withEntryActions = F2(
	function (buildActions, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{db: buildActions});
	});
var $author$project$Form$File$withLabel = F2(
	function (label, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				nC: $elm$core$Maybe$Just(label)
			});
	});
var $author$project$Form$Text$StringMask = {$: 1};
var $elm$core$String$reverse = _String_reverse;
var $henriquecbuss$elm_mask$Mask$stringHelp = F3(
	function (replaceChar, sourceChar, _v0) {
		var currentString = _v0.ar;
		var currentMask = _v0.aU;
		var _v1 = $elm$core$String$toList(currentMask);
		if (!_v1.b) {
			return {aU: currentMask, ar: currentString};
		} else {
			var firstOfMask = _v1.a;
			var restOfMask = _v1.b;
			return _Utils_eq(firstOfMask, replaceChar) ? {
				aU: $elm$core$String$fromList(restOfMask),
				ar: A2($elm$core$String$cons, sourceChar, currentString)
			} : A3(
				$henriquecbuss$elm_mask$Mask$stringHelp,
				replaceChar,
				sourceChar,
				{
					aU: $elm$core$String$fromList(restOfMask),
					ar: A2($elm$core$String$cons, firstOfMask, currentString)
				});
		}
	});
var $henriquecbuss$elm_mask$Mask$string = F2(
	function (_v0, source) {
		var mask = _v0.ga;
		var replace = _v0.o0;
		var forbiddenChars = $elm$core$String$toList(
			A2(
				$elm$core$String$filter,
				function (maskChar) {
					return (!_Utils_eq(maskChar, replace)) && (!$elm$core$Char$isAlphaNum(maskChar));
				},
				mask));
		return $elm$core$String$reverse(
			A3(
				$elm$core$String$foldl,
				$henriquecbuss$elm_mask$Mask$stringHelp(replace),
				{aU: mask, ar: ''},
				A2(
					$elm$core$String$filter,
					function (x) {
						return !A2($elm$core$List$member, x, forbiddenChars);
					},
					source)).ar);
	});
var $author$project$Form$Text$withMask = F2(
	function (mask, _v0) {
		var options = _v0;
		return A2(
			$author$project$Form$Text$withElements,
			_List_fromArray(
				[
					A3(
					$elm$html$Html$node,
					'masked-input-helper',
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$attribute, 'target-id', options.R),
							A2($elm$html$Html$Attributes$attribute, 'mask-type', 'string')
						]),
					_List_Nil)
				]),
			_Utils_update(
				options,
				{
					bz: A2(
						$elm$core$Basics$composeR,
						$henriquecbuss$elm_mask$Mask$string(mask),
						options.bz),
					gX: $henriquecbuss$elm_mask$Mask$string(mask),
					ga: $elm$core$Maybe$Just($author$project$Form$Text$StringMask)
				}));
	});
var $author$project$Page$Community$New$createForm = F3(
	function (translators, environment, _v0) {
		var t = translators.il;
		var isDisabled = _v0.ns;
		return A2(
			$author$project$Form$with,
			$author$project$Form$introspect(
				function (_v1) {
					var selectedLogoIndex = _v1.gw;
					return A2(
						$author$project$Form$fileMultiple,
						{
							ab: $elm$core$Basics$always($elm$core$Maybe$Nothing),
							af: A2(
								$elm$core$Basics$composeR,
								$elm_community$list_extra$List$Extra$getAt(selectedLogoIndex),
								$elm$core$Result$fromMaybe(
									t('settings.community_info.logo.choose_one'))),
							iw: translators,
							n: F2(
								function (logo, input) {
									return _Utils_update(
										input,
										{hC: logo});
								}),
							pO: function ($) {
								return $.hC;
							}
						},
						A2(
							$author$project$Form$File$withEntryActions,
							function (entryIndex) {
								return _List_fromArray(
									[
										$author$project$Form$File$DeleteEntry,
										$author$project$Form$File$CustomAction(
										A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('uppercase text-orange-300 font-bold focus-ring rounded-sm hover:opacity-60'),
													$elm$html$Html$Events$onClick(
													$author$project$Page$Community$New$SelectedEntry(entryIndex)),
													$elm$html$Html$Attributes$type_('button')
												]),
											_List_fromArray(
												[
													_Utils_eq(entryIndex, selectedLogoIndex) ? $elm$html$Html$text(
													t('settings.community_info.logo.selected')) : $elm$html$Html$text(
													t('settings.community_info.logo.select'))
												]))),
										$author$project$Form$File$ReplaceEntry,
										$author$project$Form$File$SaveEntry
									]);
							},
							A2(
								$author$project$Form$File$withAddImagesView,
								$author$project$Form$File$defaultAddImagesView(
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('!w-22 !h-22')
										])),
								A2(
									$author$project$Form$File$withImageClass,
									'max-w-16 max-h-16',
									A2(
										$author$project$Form$File$withEntryContainerAttributes,
										function (index) {
											return _List_fromArray(
												[
													$elm$html$Html$Attributes$class('w-22 h-22 p-2 grid place-items-center border rounded-md'),
													$elm$html$Html$Attributes$classList(
													_List_fromArray(
														[
															_Utils_Tuple2(
															'border-gray-900 shadow-lg',
															_Utils_eq(index, selectedLogoIndex)),
															_Utils_Tuple2(
															'border-transparent',
															!_Utils_eq(index, selectedLogoIndex))
														]))
												]);
										},
										A2(
											$author$project$Form$File$withContainerAttributes,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('w-full mt-10')
												]),
											A2(
												$author$project$Form$File$withLabel,
												t('settings.community_info.logo.title'),
												$author$project$Form$File$init(
													{R: 'logo-input'}))))))));
				}),
			A2(
				$author$project$Form$with,
				$author$project$Page$Community$New$requireInvitationToggle(translators),
				A2(
					$author$project$Form$with,
					$author$project$Form$optional(
						A2(
							$author$project$Form$textField,
							{
								ab: $elm$core$Basics$always($elm$core$Maybe$Nothing),
								af: $elm$core$Result$Ok,
								n: F2(
									function (website, input) {
										return _Utils_update(
											input,
											{cQ: website});
									}),
								pO: function ($) {
									return $.cQ;
								}
							},
							A2(
								$author$project$Form$Text$withPlaceholder,
								'cambiatus.com',
								$author$project$Form$Text$init(
									{
										R: 'website-input',
										nC: t('settings.community_info.fields.website')
									})))),
					A4(
						$author$project$Form$withGroup,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('grid grid-cols-2 gap-4')
							]),
						A2(
							$author$project$Form$textField,
							{
								ab: $elm$core$Basics$always($elm$core$Maybe$Nothing),
								af: A2(
									$elm$core$Basics$composeR,
									$author$project$Form$Validate$succeed,
									A2(
										$elm$core$Basics$composeR,
										$author$project$Form$Validate$maskedFloat(translators),
										$author$project$Form$Validate$validate(translators))),
								n: F2(
									function (inviterReward, input) {
										return _Utils_update(
											input,
											{dm: inviterReward});
									}),
								pO: function ($) {
									return $.dm;
								}
							},
							A2(
								$author$project$Form$Text$withType,
								2,
								$author$project$Form$Text$asNumeric(
									$author$project$Form$Text$init(
										{
											R: 'inviter-reward-input',
											nC: t('community.create.labels.inviter_reward')
										})))),
						A2(
							$author$project$Form$textField,
							{
								ab: $elm$core$Basics$always($elm$core$Maybe$Nothing),
								af: A2(
									$elm$core$Basics$composeR,
									$author$project$Form$Validate$succeed,
									A2(
										$elm$core$Basics$composeR,
										$author$project$Form$Validate$maskedFloat(translators),
										$author$project$Form$Validate$validate(translators))),
								n: F2(
									function (minimumBalance, input) {
										return _Utils_update(
											input,
											{dC: minimumBalance});
									}),
								pO: function ($) {
									return $.dC;
								}
							},
							A2(
								$author$project$Form$Text$withType,
								2,
								$author$project$Form$Text$asNumeric(
									$author$project$Form$Text$init(
										{
											R: 'minimum-balance-input',
											nC: t('community.create.labels.min_balance')
										})))),
						A4(
							$author$project$Form$withGroup,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('grid grid-cols-2 gap-4')
								]),
							A2(
								$author$project$Form$textField,
								{
									ab: $elm$core$Basics$always($elm$core$Maybe$Nothing),
									af: A2(
										$elm$core$Basics$composeR,
										$author$project$Eos$symbolFromString,
										$elm$core$Result$fromMaybe(
											t('error.invalidSymbol'))),
									n: F2(
										function (symbol, input) {
											return _Utils_update(
												input,
												{e9: symbol});
										}),
									pO: function ($) {
										return $.e9;
									}
								},
								A2(
									$author$project$Form$Text$withExtraAttrs,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('uppercase')
										]),
									A2(
										$author$project$Form$Text$withMask,
										{
											ga: '#,' + $elm$core$String$concat(
												A2($elm$core$List$repeat, $author$project$Eos$maxSymbolLength, '#')),
											o0: '#'
										},
										A2(
											$author$project$Form$Text$withPlaceholder,
											'_, ' + A2(
												$elm$core$String$join,
												' ',
												A2($elm$core$List$repeat, $author$project$Eos$maxSymbolLength, '_')),
											$author$project$Form$Text$init(
												{
													R: 'community-symbol-input',
													nC: t('community.create.labels.currency_symbol')
												}))))),
							A2(
								$author$project$Form$textField,
								{
									ab: $elm$core$Basics$always($elm$core$Maybe$Nothing),
									af: A2(
										$elm$core$Basics$composeR,
										$author$project$Form$Validate$succeed,
										A2(
											$elm$core$Basics$composeR,
											$author$project$Form$Validate$maskedFloat(translators),
											$author$project$Form$Validate$validate(translators))),
									n: F2(
										function (invitedReward, input) {
											return _Utils_update(
												input,
												{dl: invitedReward});
										}),
									pO: function ($) {
										return $.dl;
									}
								},
								A2(
									$author$project$Form$Text$withType,
									2,
									$author$project$Form$Text$asNumeric(
										$author$project$Form$Text$init(
											{
												R: 'invited-reward-input',
												nC: t('community.create.labels.invited_reward')
											})))),
							A2(
								$author$project$Form$with,
								A2(
									$author$project$Form$textField,
									{
										ab: $elm$core$Basics$always($elm$core$Maybe$Nothing),
										af: A2(
											$elm$core$Basics$composeR,
											$author$project$Form$Validate$succeed,
											A2(
												$elm$core$Basics$composeR,
												$author$project$Form$Validate$map($elm$core$String$toLower),
												A2(
													$elm$core$Basics$composeR,
													$author$project$Form$Validate$url,
													A2(
														$elm$core$Basics$composeR,
														$author$project$Form$Validate$map(
															$author$project$Route$addEnvironmentToUrl(environment)),
														$author$project$Form$Validate$validate(translators))))),
										n: F2(
											function (url, input) {
												return _Utils_update(
													input,
													{gL: url});
											}),
										pO: function ($) {
											return $.gL;
										}
									},
									A2(
										$author$project$Form$Text$withElements,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('absolute inset-y-0 right-4 flex items-center bg-white pl-1 my-2'),
														$elm$html$Html$Attributes$classList(
														_List_fromArray(
															[
																_Utils_Tuple2('bg-gray-500', isDisabled)
															]))
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('.cambiatus.io')
													]))
											]),
										$author$project$Form$Text$init(
											{
												R: 'subdomain-input',
												nC: t('settings.community_info.url.title')
											}))),
								A2(
									$author$project$Form$with,
									A2(
										$author$project$Form$textField,
										{
											ab: $elm$core$Basics$always($elm$core$Maybe$Nothing),
											af: A2(
												$elm$core$Basics$composeR,
												$author$project$Form$Validate$succeed,
												A2(
													$elm$core$Basics$composeR,
													$author$project$Form$Validate$stringLongerThan(1),
													$author$project$Form$Validate$validate(translators))),
											n: F2(
												function (name, input) {
													return _Utils_update(
														input,
														{ki: name});
												}),
											pO: function ($) {
												return $.ki;
											}
										},
										$author$project$Form$Text$init(
											{
												R: 'currency-name-input',
												nC: t('community.create.labels.currency_name')
											})),
									A2(
										$author$project$Form$with,
										A2(
											$author$project$Form$richText,
											{
												ab: $elm$core$Basics$always($elm$core$Maybe$Nothing),
												af: $elm$core$Result$Ok,
												n: F2(
													function (description, input) {
														return _Utils_update(
															input,
															{bc: description});
													}),
												pO: function ($) {
													return $.bc;
												}
											},
											A2(
												$author$project$Form$RichText$withEditorContainerAttrs,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('mb-10')
													]),
												$author$project$Form$RichText$init(
													{
														nC: t('community.create.labels.description')
													}))),
										$author$project$Form$succeed($author$project$Page$Community$New$FormOutput)))))))));
	});
var $fapian$elm_html_aria$Html$Attributes$Aria$ariaLabelledby = $elm$html$Html$Attributes$attribute('aria-labelledby');
var $author$project$Icons$back = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('28'),
				$elm$svg$Svg$Attributes$height('28'),
				$elm$svg$Svg$Attributes$viewBox('0 0 28 28'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M0 14C0 21.732 6.26801 28 14 28C21.732 28 28 21.732 28 14C28 6.26801 21.732 0 14 0C6.26801 0 0 6.26801 0 14Z'),
						$elm$svg$Svg$Attributes$fill('white')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M10.1818 12.9881C10.1504 13.0302 10.1227 13.0749 10.0991 13.1217C10.0599 13.1713 10.0258 13.2246 9.99724 13.2808C9.97866 13.3388 9.96587 13.3985 9.95906 13.459C9.92071 13.5747 9.92071 13.6997 9.95906 13.8154C9.96587 13.8759 9.97866 13.9356 9.99724 13.9935C10.0258 14.0498 10.0599 14.1031 10.0991 14.1526C10.1227 14.1995 10.1504 14.2442 10.1818 14.2863L15.2727 19.059C15.6586 19.4113 16.2561 19.3878 16.6131 19.0064C16.9702 18.6249 16.9542 18.0272 16.5772 17.6654L12.2309 13.5863L16.5772 9.50718C16.9542 9.14536 16.9702 8.54766 16.6131 8.16617C16.2561 7.78469 15.6586 7.76124 15.2727 8.11354L10.1818 12.9881Z')
					]),
				_List_Nil)
			]));
};
var $elm$html$Html$nav = _VirtualDom_node('nav');
var $author$project$Page$viewHeader = F2(
	function (_v0, title) {
		var shared = _v0.aM;
		var routeHistory = _v0.gs;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('w-full h-16 flex items-center bg-indigo-500')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$nav,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex items-center container mx-auto px-4 relative')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex items-center sm:w-full'),
									$author$project$Route$href(
									A2(
										$elm$core$Maybe$withDefault,
										$author$project$Route$Dashboard,
										$elm$core$List$head(
											A2($elm$core$List$drop, 1, routeHistory)))),
									$fapian$elm_html_aria$Html$Attributes$Aria$ariaLabelledby('previous-page-button')
								]),
							_List_fromArray(
								[
									$author$project$Icons$back(''),
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('ml-2 text-white text-sm hidden md:visible md:flex'),
											$elm$html$Html$Attributes$id('previous-page-button')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											shared.iw.il('back'))
										]))
								])),
							A2(
							$elm$html$Html$h1,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-white truncate w-full text-center ml-1 mr-8 sm:ml-0 sm:mr-0')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(title)
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('w-full hidden sm:inline'),
									$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
								]),
							_List_Nil)
						]))
				]));
	});
var $author$project$Page$Community$New$view = F2(
	function (loggedIn, model) {
		var shared = loggedIn.aM;
		var t = shared.iw.il;
		return {
			mk: A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('bg-white pb-10')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Page$viewHeader,
						loggedIn,
						t('community.create.title')),
						A6(
						$author$project$Form$view,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('container mx-auto px-4 mt-10')
							]),
						shared.iw,
						function (submitButton) {
							return _List_fromArray(
								[
									A2(
									submitButton,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('button button-primary w-full mt-10'),
											$elm$html$Html$Attributes$disabled(!loggedIn.mZ)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											t('community.create.submit'))
										]))
								]);
						},
						A3(
							$author$project$Page$Community$New$createForm,
							shared.iw,
							shared.mK,
							{ns: model.ns}),
						model.hk,
						{oq: $author$project$Page$Community$New$SubmittedForm, pA: $author$project$Page$Community$New$GotFormMsg})
					])),
			fb: t('community.create.title')
		};
	});
var $author$project$Page$fullPageNotFound = F2(
	function (title, subTitle) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mx-auto container p-8 md:p-24 flex flex-wrap')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('w-full')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-2xl font-bold text-center')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(title)
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-center')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(subTitle)
								]))
						])),
					A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('w-full md:w-auto md:mx-auto mt-4'),
							$elm$html$Html$Attributes$src('/images/not_found.svg')
						]),
					_List_Nil)
				]));
	});
var $author$project$View$Components$Lg = 1;
var $author$project$Page$Community$Objectives$StartedIntersecting = function (a) {
	return {$: 10, a: a};
};
var $author$project$Page$Community$Objectives$StoppedIntersecting = function (a) {
	return {$: 11, a: a};
};
var $elm$html$Html$b = _VirtualDom_node('b');
var $author$project$View$Components$breakpointToPixels = function (breakpoint) {
	switch (breakpoint) {
		case 0:
			return 640;
		case 1:
			return 1024;
		default:
			return 1280;
	}
};
var $author$project$View$Components$intersectionObserver = function (options) {
	var decodeTargetId = function (toMsg) {
		return A2(
			$elm$json$Json$Decode$map,
			toMsg,
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['detail', 'targetId']),
				$elm$json$Json$Decode$string));
	};
	var optionalEvent = F2(
		function (eventName, maybeToMsg) {
			if (maybeToMsg.$ === 1) {
				return $elm$html$Html$Attributes$class('');
			} else {
				var toMsg = maybeToMsg.a;
				return A2(
					$elm$html$Html$Events$on,
					eventName,
					decodeTargetId(toMsg));
			}
		});
	return A3(
		$elm$html$Html$node,
		'intersection-observer',
		_List_fromArray(
			[
				A2(
				$elm$html$Html$Attributes$attribute,
				'elm-target',
				A2($elm$core$String$join, ' ', options.pw)),
				A2(
				$elm$html$Html$Attributes$attribute,
				'elm-threshold',
				$elm$core$String$fromFloat(options.py)),
				A2(
				$elm$html$Html$Attributes$attribute,
				'elm-max-width',
				function () {
					var _v0 = options.lZ;
					if (_v0.$ === 1) {
						return 'none';
					} else {
						var breakpointToExclude = _v0.a;
						return $elm$core$String$fromInt(
							$author$project$View$Components$breakpointToPixels(breakpointToExclude));
					}
				}()),
				A2(optionalEvent, 'started-intersecting', options.oo),
				A2(optionalEvent, 'stopped-intersecting', options.op)
			]),
		_List_Nil);
};
var $pzp1997$assoc_list$AssocList$keys = function (_v0) {
	var alist = _v0;
	return A2($elm$core$List$map, $elm$core$Tuple$first, alist);
};
var $author$project$Page$Community$Objectives$ClickedScrollToAction = function (a) {
	return {$: 8, a: a};
};
var $author$project$Page$Community$Objectives$ClickedToggleObjectiveVisibility = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Community$Objectives$FinishedClosingObjective = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$Community$Objectives$FinishedOpeningActions = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$Community$Objectives$GotActionMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$View$Components$Xl = 2;
var $fapian$elm_html_aria$Html$Attributes$Aria$ariaHasPopup = $elm$html$Html$Attributes$attribute('aria-haspopup');
var $author$project$Icons$cambiatusCoin = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('22'),
				$elm$svg$Svg$Attributes$height('24'),
				$elm$svg$Svg$Attributes$viewBox('0 0 22 24'),
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M21.9997 10.3713C22.0307 6.50581 19.745 2.94991 16.0815 1.16421C12.418 -0.621488 7.99431 -0.335942 4.6275 1.90356C1.26068 4.14306 -0.481678 7.95897 0.116109 11.7839C0.0403256 12.2629 0.00152199 12.7465 0 13.2308C0 18.916 4.9248 23.5248 10.9998 23.5248C17.0749 23.5248 21.9997 18.916 21.9997 13.2308C21.9982 12.7465 21.9594 12.2629 21.8836 11.7839C21.9569 11.3161 21.9957 10.8441 21.9997 10.3713ZM10.9998 1.7929C16.0624 1.7929 20.1664 5.63358 20.1664 10.3713C20.1664 15.109 16.0624 18.9497 10.9998 18.9497C5.93729 18.9497 1.83329 15.109 1.83329 10.3713C1.83329 5.63358 5.93729 1.7929 10.9998 1.7929ZM10.9998 21.8092C7.70509 21.7947 4.6721 20.1266 3.0555 17.4399C5.12481 19.496 8.00917 20.6617 11.0273 20.6617C14.0455 20.6617 16.9298 19.496 18.9992 17.4399C17.3729 20.1426 14.3143 21.8133 10.9998 21.8092Z')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M8.2872 9.25496C8.8104 9.25496 9.23455 8.84746 9.23455 8.34479C9.23455 7.84211 8.8104 7.43461 8.2872 7.43461C7.76399 7.43461 7.33984 7.84211 7.33984 8.34479C7.33984 8.84746 7.76399 9.25496 8.2872 9.25496Z')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M11.004 9.25496C11.5272 9.25496 11.9513 8.84746 11.9513 8.34479C11.9513 7.84211 11.5272 7.43461 11.004 7.43461C10.4808 7.43461 10.0566 7.84211 10.0566 8.34479C10.0566 8.84746 10.4808 9.25496 11.004 9.25496Z')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M15.5217 9.72133C15.3808 9.63106 15.2242 9.58593 15.0598 9.58593C15.005 9.58593 14.9502 9.59345 14.8875 9.60097C14.6683 9.64611 14.4804 9.76646 14.3551 9.94699L13.0085 11.9027C12.8832 12.0833 12.8441 12.2939 12.8832 12.5045C12.9302 12.7151 13.0555 12.8957 13.2434 13.016C13.4313 13.1364 13.6505 13.174 13.8697 13.1364C14.0889 13.0912 14.2768 12.9709 14.4021 12.7904L15.7488 10.8346C15.874 10.6541 15.9132 10.4435 15.874 10.2328C15.8349 10.0222 15.7096 9.84168 15.5217 9.72133Z')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M6.25166 10.8346L7.5983 12.7904C7.72357 12.9709 7.91148 13.0912 8.1307 13.1364C8.34992 13.1815 8.56914 13.1364 8.75705 13.016C9.14069 12.7678 9.2503 12.2713 8.99193 11.9027L7.64528 9.94699C7.52001 9.76646 7.33211 9.64611 7.11288 9.60097C7.05808 9.59345 7.00327 9.58593 6.94064 9.58593C6.77622 9.58593 6.61963 9.63106 6.47871 9.72133C6.1029 9.96956 5.99329 10.466 6.25166 10.8346Z')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M13.7286 9.25496C14.2518 9.25496 14.676 8.84746 14.676 8.34479C14.676 7.84211 14.2518 7.43461 13.7286 7.43461C13.2054 7.43461 12.7812 7.84211 12.7812 8.34479C12.7812 8.84746 13.2054 9.25496 13.7286 9.25496Z')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M10.1037 9.72133C9.96281 9.63106 9.80622 9.58593 9.6418 9.58593C9.587 9.58593 9.53219 9.59345 9.46956 9.60097C9.25034 9.64611 9.06243 9.76646 8.93716 9.94699L7.59051 11.9027C7.46524 12.0833 7.4261 12.2939 7.46524 12.5045C7.51222 12.7151 7.63749 12.8957 7.82539 13.016C8.0133 13.1364 8.23252 13.174 8.45174 13.1364C8.67096 13.0912 8.85887 12.9709 8.98414 12.7904L10.3308 10.8346C10.4561 10.6541 10.4952 10.4435 10.4561 10.2328C10.4169 10.0222 10.2916 9.84168 10.1037 9.72133Z')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M8.83525 10.2328C8.78828 10.4435 8.83525 10.6541 8.96052 10.8346L10.3072 12.7904C10.4324 12.9709 10.6203 13.0912 10.8396 13.1364C11.0588 13.1815 11.2858 13.1364 11.4659 13.016C11.8496 12.7678 11.9592 12.2713 11.7008 11.9027L10.3541 9.94699C10.2289 9.76646 10.041 9.64611 9.82175 9.60097C9.76694 9.59345 9.71214 9.58593 9.6495 9.58593C9.48509 9.58593 9.3285 9.63106 9.18757 9.72133C9.0075 9.84168 8.88223 10.0222 8.83525 10.2328Z')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M11.654 9.94699L10.3073 11.9027C10.182 12.0833 10.1429 12.2939 10.182 12.5045C10.229 12.7151 10.3543 12.8957 10.5422 13.016C10.7301 13.1364 10.9493 13.174 11.1685 13.1364C11.3878 13.0912 11.5757 12.9709 11.7009 12.7904L13.0476 10.8346C13.2981 10.466 13.1963 9.96204 12.8127 9.72133C12.6718 9.63106 12.5152 9.58593 12.3508 9.58593C12.296 9.58593 12.2412 9.59345 12.1785 9.60097C11.9593 9.64611 11.7714 9.76646 11.654 9.94699Z')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M11.6618 10.8346L13.0084 12.7904C13.1337 12.9709 13.3216 13.0912 13.5408 13.1364C13.76 13.1815 13.9871 13.1364 14.1672 13.016C14.5508 12.7678 14.6604 12.2713 14.4021 11.9027L13.0554 9.94699C12.9301 9.76646 12.7422 9.64611 12.523 9.60097C12.4682 9.59345 12.4134 9.58593 12.3508 9.58593C12.1863 9.58593 12.0298 9.63106 11.8888 9.72133C11.513 9.96956 11.4112 10.466 11.6618 10.8346Z')
					]),
				_List_Nil)
			]));
};
var $elm$html$Html$details = _VirtualDom_node('details');
var $author$project$View$Components$masonryLayoutAttributes = F3(
	function (breakpoints, _v0, attrs) {
		var transitionWithParent = _v0.pG;
		var classesForBreakpoint = function (breakpoint) {
			switch (breakpoint) {
				case 0:
					return 'sm:gap-y-0 sm:grid sm:auto-rows-[1px]';
				case 1:
					return 'lg:gap-y-0 lg:grid lg:auto-rows-[1px]';
				default:
					return 'xl:gap-y-0 xl:grid xl:auto-rows-[1px]';
			}
		};
		return A2(
			$elm$core$List$cons,
			$elm$html$Html$Attributes$class(
				A2(
					$elm$core$String$join,
					' ',
					A2($elm$core$List$map, classesForBreakpoint, breakpoints))),
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$Attributes$attribute,
					'elm-transition-with-parent',
					$author$project$View$Components$boolToString(transitionWithParent)),
				attrs));
	});
var $author$project$View$Components$masonryLayout = F4(
	function (breakpoints, transitionWithParent, attrs, children) {
		return A3(
			$elm$html$Html$node,
			'masonry-layout',
			A3($author$project$View$Components$masonryLayoutAttributes, breakpoints, transitionWithParent, attrs),
			children);
	});
var $elm$html$Html$summary = _VirtualDom_node('summary');
var $author$project$Action$ClickedShareAction = function (a) {
	return {$: 1, a: a};
};
var $author$project$Eos$assetToString = F2(
	function (translators, asset) {
		return A3($author$project$Eos$formatSymbolAmount, translators, asset.e9, asset.lU) + (' ' + $author$project$Eos$symbolToSymbolCodeString(asset.e9));
	});
var $author$project$Icons$flag = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('40'),
				$elm$svg$Svg$Attributes$height('46'),
				$elm$svg$Svg$Attributes$viewBox('0 0 40 46'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M0.439542 11.1667L19.5604 0.110077C19.829 -0.0366924 20.1709 -0.0366924 20.4395 0.110077L39.5604 11.1667C39.829 11.3135 40 11.607 40 11.925V34.0628C40 34.3808 39.829 34.6743 39.5604 34.8211L20.4395 45.8777C20.293 45.9511 20.1465 46 20 46C19.8535 46 19.7069 45.9511 19.5604 45.8777L0.439542 34.8211C0.170922 34.6743 0 34.3808 0 34.0628V11.925C0 11.607 0.170922 11.3135 0.439542 11.1667Z')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M27.0759 19.7659L29.3273 16.2036C29.6024 15.7688 29.599 15.2358 29.3182 14.8039C29.0375 14.372 28.5217 14.1064 27.9639 14.1065H13.2858C13.2858 13.7187 12.935 13.4043 12.5023 13.4043C12.0695 13.4043 11.7188 13.7187 11.7188 14.1065V31.8947C11.7188 32.2825 12.0695 32.5969 12.5023 32.5969C12.935 32.5969 13.2858 32.2825 13.2858 31.8947V25.8092H27.9117C28.4543 25.8086 28.9578 25.5565 29.2429 25.1428C29.528 24.7291 29.554 24.2127 29.3116 23.7776L27.0759 19.7659ZM13.2858 24.4049V15.5108H27.9117L25.2634 19.7238L27.8751 24.4049H13.2858Z'),
						$elm$svg$Svg$Attributes$fill('white')
					]),
				_List_Nil)
			]));
};
var $author$project$Action$isClaimable = function (action) {
	return action.lE === 1;
};
var $author$project$Utils$fromMaybeDateTime = function (maybeDateTime) {
	if (maybeDateTime.$ === 1) {
		return $elm$time$Time$millisToPosix(0);
	} else {
		var dateTime = maybeDateTime.a;
		return $author$project$Utils$fromDateTime(dateTime);
	}
};
var $author$project$Action$isPastDeadline = F2(
	function (action, now) {
		var _v0 = action.ha;
		if (!_v0.$) {
			return _Utils_cmp(
				$elm$time$Time$posixToMillis(now),
				$elm$time$Time$posixToMillis(
					$author$project$Utils$fromMaybeDateTime(action.ha))) > 0;
		} else {
			return false;
		}
	});
var $author$project$Action$isClosed = F2(
	function (action, now) {
		return A2($author$project$Action$isPastDeadline, action, now) || ((action.lB > 0) && (!action.lC));
	});
var $author$project$Action$isOpenForNewClaims = F2(
	function (action, now) {
		return (!A2($author$project$Action$isClosed, action, now)) && ((!action.$7) && (!$author$project$Action$isObjectiveClosed(action)));
	});
var $author$project$Action$daysLeft = F2(
	function (now, availableAt) {
		var msLeft = $elm$time$Time$posixToMillis(availableAt) - $elm$time$Time$posixToMillis(now);
		return A2(
			$elm$core$Basics$max,
			1,
			$elm$core$Basics$ceiling(msLeft / 86400000));
	});
var $author$project$Action$limitNotice = F3(
	function (_v0, now, action) {
		var t = _v0.il;
		var tr = _v0.iu;
		var _v1 = action.hP;
		if (_v1.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var eligibility = _v1.a;
			var _v2 = eligibility.gE;
			switch (_v2) {
				case 1:
					return $elm$core$Maybe$Just(
						t('community.objectives.claim_limit.completed'));
				case 3:
					return $elm$core$Maybe$Just(
						t('community.objectives.claim_limit.pending'));
				case 2:
					var _v3 = eligibility.gU;
					if (_v3.$ === 1) {
						return $elm$core$Maybe$Just(
							A2(tr, 'community.objectives.claim_limit.cooldown_one', _List_Nil));
					} else {
						var availableAt = $author$project$Utils$fromMaybeDateTime(eligibility.gU);
						if (_Utils_cmp(
							$elm$time$Time$posixToMillis(availableAt),
							$elm$time$Time$posixToMillis(now)) < 1) {
							return $elm$core$Maybe$Nothing;
						} else {
							var _v4 = A2($author$project$Action$daysLeft, now, availableAt);
							if (_v4 === 1) {
								return $elm$core$Maybe$Just(
									A2(tr, 'community.objectives.claim_limit.cooldown_one', _List_Nil));
							} else {
								var days = _v4;
								return $elm$core$Maybe$Just(
									A2(
										tr,
										'community.objectives.claim_limit.cooldown',
										_List_fromArray(
											[
												_Utils_Tuple2(
												'count',
												$elm$core$String$fromInt(days))
											])));
							}
						}
					}
				default:
					return $elm$core$Maybe$Nothing;
			}
		}
	});
var $author$project$ReviewMoved$appUrl = F2(
	function (apiUrl, path) {
		var base = A2($elm$core$String$endsWith, '/', apiUrl) ? A2($elm$core$String$dropRight, 1, apiUrl) : apiUrl;
		return _Utils_ap(base, path);
	});
var $author$project$ClaimMoved$claimUrl = F2(
	function (apiUrl, actionId) {
		return A2(
			$author$project$ReviewMoved$appUrl,
			apiUrl,
			'/app/community/objectives?action=' + $elm$core$String$fromInt(actionId));
	});
var $author$project$ClaimMoved$viewClaimLink = F3(
	function (_v0, apiUrl, actionId) {
		var t = _v0.il;
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id(
					'claim-in-new-app-' + $elm$core$String$fromInt(actionId)),
					$elm$html$Html$Attributes$href(
					A2($author$project$ClaimMoved$claimUrl, apiUrl, actionId)),
					$elm$html$Html$Attributes$target('_self'),
					$elm$html$Html$Attributes$class('button button-primary w-full sm:col-span-1')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					t('claim_moved.go'))
				]));
	});
var $author$project$Action$viewClaimProgress = F2(
	function (_v0, action) {
		var tr = _v0.iu;
		var _v1 = _Utils_Tuple2(action.j5, action.hP);
		if ((!_v1.a.$) && (!_v1.b.$)) {
			var maxClaims = _v1.a.a;
			var eligibility = _v1.b.a;
			return ((maxClaims > 1) && ((!eligibility.gE) && (eligibility.gS > 0))) ? A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-sm text-gray-900')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2(
							tr,
							'community.objectives.claim_limit.progress',
							_List_fromArray(
								[
									_Utils_Tuple2(
									'done',
									$elm$core$String$fromInt(eligibility.gS)),
									_Utils_Tuple2(
									'max',
									$elm$core$String$fromInt(maxClaims))
								])))
					])) : $elm$html$Html$text('');
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Action$viewNotAbleToClaimNotice = function (noticeText) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex items-center bg-gray-100 rounded-sm p-2 mb-4')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$img,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$src('/images/transfer-doggo.svg'),
						$elm$html$Html$Attributes$alt(''),
						$elm$html$Html$Attributes$class('w-8 mr-2')
					]),
				_List_Nil),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-sm text-gray-900')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(noticeText)
					]))
			]));
};
var $author$project$Action$viewCard = F3(
	function (loggedIn, _v0, action) {
		var containerAttrs = _v0.mg;
		var position = _v0.kC;
		var toMsg = _v0.pA;
		var translators = loggedIn.aM.iw;
		var t = translators.il;
		var tr = translators.iu;
		var maybeLimitNotice = A3($author$project$Action$limitNotice, translators, loggedIn.aM.gh, action);
		var canBeClaimed = $author$project$Action$isClaimable(action) && (A2($author$project$Action$isOpenForNewClaims, action, loggedIn.aM.gh) && _Utils_eq(maybeLimitNotice, $elm$core$Maybe$Nothing));
		return A2(
			$elm$html$Html$li,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('bg-white rounded self-start w-full flex-shrink-0'),
				containerAttrs),
			_List_fromArray(
				[
					function () {
					var _v1 = action.jH;
					if (_v1.$ === 1) {
						return $elm$html$Html$text('');
					} else {
						if (_v1.a === '') {
							return $elm$html$Html$text('');
						} else {
							var image = _v1.a;
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('mt-2 mx-2 relative h-36 flex')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$img,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$src(image),
												$elm$html$Html$Attributes$alt(''),
												$elm$html$Html$Attributes$class('rounded object-cover mx-auto')
											]),
										_List_Nil),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('bg-gradient-to-t from-[#01003a14] to-[#01003a00] absolute top-0 left-0 w-full h-full rounded')
											]),
										_List_Nil)
									]));
						}
					}
				}(),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('px-4 pt-4 pb-6')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex mb-6')
								]),
							_List_fromArray(
								[
									function () {
									if (position.$ === 1) {
										return A2($author$project$Action$isOpenForNewClaims, action, loggedIn.aM.gh) ? $author$project$Icons$flag('w-8 text-green fill-current') : $author$project$Icons$flag('w-8 text-gray-900 fill-current');
									} else {
										var validPosition = position.a;
										return A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('text-lg text-gray-500 font-bold'),
													$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$elm$core$String$fromInt(validPosition) + '.')
												]));
									}
								}(),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('ml-5 mt-1 min-w-0 w-full')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$h4,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$title(
													$author$project$Markdown$toRawString(action.bc))
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Markdown$view,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('line-clamp-3 hide-children-from-2')
														]),
													action.bc)
												])),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('sr-only')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													t('community.objectives.reward') + (': ' + A2(
														$author$project$Eos$assetToString,
														translators,
														{lU: action.h7, e9: action.bi.b9.e9})))
												])),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('font-bold text-sm text-gray-900 uppercase block mt-6'),
													$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													t('community.objectives.reward'))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('mt-1 text-green font-bold'),
													$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('text-2xl mr-1')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															A3($author$project$Eos$formatSymbolAmount, translators, action.bi.b9.e9, action.h7))
														])),
													$elm$html$Html$text(
													$author$project$Eos$symbolToSymbolCodeString(action.bi.b9.e9))
												])),
											A2($author$project$Action$viewClaimProgress, translators, action)
										]))
								])),
							function () {
							if (!maybeLimitNotice.$) {
								var notice = maybeLimitNotice.a;
								return $author$project$Action$viewNotAbleToClaimNotice(notice);
							} else {
								return (!A2($author$project$Action$isOpenForNewClaims, action, loggedIn.aM.gh)) ? $author$project$Action$viewNotAbleToClaimNotice(
									t('community.objectives.action_completed_notice')) : ((!$author$project$Action$isClaimable(action)) ? $author$project$Action$viewNotAbleToClaimNotice(
									t('community.objectives.action_automatic_notice')) : $elm$html$Html$text(''));
							}
						}(),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-2'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('sm:grid-cols-1', !canBeClaimed)
										]))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('button button-secondary w-full'),
											$elm$html$Html$Events$onClick(
											toMsg(
												$author$project$Action$ClickedShareAction(action))),
											$elm$html$Html$Attributes$id(
											$author$project$Action$shareActionButtonId(action.R))
										]),
									_List_fromArray(
										[
											$author$project$Icons$share('mr-2 flex-shrink-0'),
											$elm$html$Html$text(
											t('share'))
										])),
									canBeClaimed ? A3(
									$author$project$ClaimMoved$viewClaimLink,
									translators,
									loggedIn.aM.mJ.lW,
									$author$project$Action$idToInt(action.R)) : $elm$html$Html$text('')
								]))
						])),
					(!loggedIn.aM.iW) ? A2(
					$elm$html$Html$map,
					toMsg,
					A2(
						$author$project$Form$Text$view,
						A2(
							$author$project$Form$Text$withInputElement,
							$author$project$Form$Text$TextareaInput(
								{pn: false}),
							A2(
								$author$project$Form$Text$withContainerAttrs,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('h-0 absolute opacity-0 left-[-9999em] !mb-0 overflow-hidden'),
										$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
									]),
								A2(
									$author$project$Form$Text$withExtraAttrs,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$tabindex(-1),
											$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
										]),
									$author$project$Form$Text$init(
										{
											R: $author$project$Action$shareActionFallbackId(action.R),
											nC: ''
										})))),
						{
							mM: $elm$html$Html$text(''),
							m$: false,
							nx: false,
							od: $author$project$Action$NoOp,
							oe: function (_v4) {
								return $author$project$Action$NoOp;
							},
							iw: translators,
							pO: A2(
								tr,
								'community.objectives.share_action',
								_List_fromArray(
									[
										_Utils_Tuple2('community_name', action.bi.b9.ki),
										_Utils_Tuple2(
										'objective_description',
										$author$project$Markdown$toRawString(action.bi.bc)),
										_Utils_Tuple2(
										'action_description',
										$author$project$Markdown$toRawString(action.bc)),
										_Utils_Tuple2(
										'url',
										$elm$url$Url$toString(
											A2(
												$author$project$Route$addRouteToUrl,
												loggedIn.aM,
												$author$project$Route$CommunityObjectives(
													$author$project$Route$WithObjectiveSelected(
														{
															iG: $elm$core$Maybe$Just(
																$author$project$Action$idToInt(action.R)),
															R: $author$project$Action$objectiveIdToInt(action.bi.R)
														})))))
									]))
						})) : $elm$html$Html$text('')
				]));
	});
var $author$project$Page$Community$Objectives$viewObjective = F3(
	function (loggedIn, model, objective) {
		var maybeShownObjectivesInfo = A2($pzp1997$assoc_list$AssocList$get, objective.R, model.E);
		var openHeight = A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.a4;
			},
			maybeShownObjectivesInfo);
		var previousVisibleActionHeight = A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.bm;
			},
			maybeShownObjectivesInfo);
		var visibleActionHeight = A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.bu;
			},
			maybeShownObjectivesInfo);
		var visibleActionId = A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.bt;
			},
			maybeShownObjectivesInfo);
		var isOpen = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (_v7) {
					var isClosing = _v7.a_;
					return !isClosing;
				},
				A2($pzp1997$assoc_list$AssocList$get, objective.R, model.E)));
		var isObjectiveHighlighted = function () {
			var _v6 = model.cn;
			if (_v6.$ === 1) {
				return false;
			} else {
				var objectiveId = _v6.a.cx;
				var actionId = _v6.a.cT;
				return _Utils_eq(objectiveId, objective.R) && $elm_community$maybe_extra$Maybe$Extra$isNothing(actionId);
			}
		}();
		var isActionHighlighted = function (action) {
			var _v5 = model.cn;
			if (_v5.$ === 1) {
				return false;
			} else {
				var objectiveId = _v5.a.cx;
				var actionId = _v5.a.cT;
				return _Utils_eq(objectiveId, objective.R) && _Utils_eq(
					actionId,
					$elm$core$Maybe$Just(action.R));
			}
		};
		var filteredActions = A2(
			$elm$core$List$filter,
			function (action) {
				return !action.$7;
			},
			objective.lP);
		var closedHeight = A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.aR;
			},
			maybeShownObjectivesInfo);
		var _v0 = loggedIn.aM;
		var translators = _v0.iw;
		return A2(
			$elm$html$Html$li,
			_List_Nil,
			_List_fromArray(
				[
					function () {
					var _v1 = _Utils_Tuple2(
						openHeight,
						A2($elm_community$maybe_extra$Maybe$Extra$or, closedHeight, visibleActionHeight));
					if ((!_v1.a.$) && (!_v1.b.$)) {
						var open = _v1.a.a;
						var closed = _v1.b.a;
						return A3(
							$elm$html$Html$node,
							'style',
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A3(
										$elm$core$String$replace,
										'{{closed-height}}',
										$elm$core$String$fromFloat(closed),
										A3(
											$elm$core$String$replace,
											'{{open-height}}',
											$elm$core$String$fromFloat(open),
											A3(
												$elm$core$String$replace,
												'{{id}}',
												$elm$core$String$fromInt(
													$author$project$Action$objectiveIdToInt(objective.R)),
												'\n                    @keyframes shrink-details-{{id}} {\n                        0% { height: calc({{open-height}}px - 16px); }\n                        100% { height: {{closed-height}}px; }\n                    }\n                    '))))
								]));
					} else {
						return $elm$html$Html$text('');
					}
				}(),
					A2(
					$elm$html$Html$details,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id(
							$author$project$Page$Community$Objectives$objectiveDetailsId(objective)),
							isOpen ? A2($elm$html$Html$Attributes$attribute, 'open', 'true') : $elm$html$Html$Attributes$class(''),
							A2($elm$html$Html$Attributes$style, 'animation-duration', '300ms'),
							A2($elm$html$Html$Attributes$style, 'animation-timing-function', 'ease-in-out'),
							isOpen ? $elm$html$Html$Attributes$class('') : A2(
							$elm$html$Html$Attributes$style,
							'animation-name',
							'shrink-details-' + $elm$core$String$fromInt(
								$author$project$Action$objectiveIdToInt(objective.R))),
							A2(
							$elm$html$Html$Events$on,
							'animationend',
							A2(
								$elm$json$Json$Decode$andThen,
								function (animationName) {
									return _Utils_eq(
										animationName,
										'shrink-details-' + $elm$core$String$fromInt(
											$author$project$Action$objectiveIdToInt(objective.R))) ? $elm$json$Json$Decode$succeed(
										$author$project$Page$Community$Objectives$FinishedClosingObjective(objective)) : $elm$json$Json$Decode$fail('animationName did not match');
								},
								A2($elm$json$Json$Decode$field, 'animationName', $elm$json$Json$Decode$string)))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$summary,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$id(
									$author$project$Page$Community$Objectives$objectiveSummaryId(objective)),
									$elm$html$Html$Attributes$class('marker-hidden lg:w-2/3 lg:mx-auto focus-ring rounded'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('border border-green ring ring-green ring-opacity-30', isObjectiveHighlighted)
										])),
									$fapian$elm_html_aria$Html$Attributes$Aria$role('button'),
									$fapian$elm_html_aria$Html$Attributes$Aria$ariaHasPopup('true'),
									$elm$html$Html$Events$onClick(
									$author$project$Page$Community$Objectives$ClickedToggleObjectiveVisibility(objective))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('flex marker-hidden items-center bg-white rounded px-4 py-6 cursor-pointer')
										]),
									_List_fromArray(
										[
											$author$project$Icons$cambiatusCoin('text-blue fill-current flex-shrink-0 self-start mt-1'),
											A2(
											$elm$html$Html$h3,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$title(
													$author$project$Markdown$toRawString(objective.bc)),
													$elm$html$Html$Attributes$class('max-w-[calc(100%-64px)]')
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Markdown$view,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('font-bold px-4 self-start mt-1'),
															$elm$html$Html$Attributes$classList(
															_List_fromArray(
																[
																	_Utils_Tuple2('line-clamp-4 hide-children-from-2', !isOpen)
																]))
														]),
													objective.bc)
												])),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('ml-auto flex-shrink-0 transition-transform duration-150 motion-reduce:transition-none'),
													$elm$html$Html$Attributes$classList(
													_List_fromArray(
														[
															_Utils_Tuple2('rotate-180', isOpen),
															_Utils_Tuple2('rotate-0', !isOpen)
														]))
												]),
											_List_fromArray(
												[
													$author$project$Icons$arrowDown('text-gray-900 fill-current')
												]))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									function () {
									if (visibleActionHeight.$ === 1) {
										if (previousVisibleActionHeight.$ === 1) {
											return $elm$html$Html$Attributes$class('');
										} else {
											var height = previousVisibleActionHeight.a;
											return A2(
												$elm$html$Html$Attributes$style,
												'height',
												'calc(' + ($elm$core$String$fromInt(
													$elm$core$Basics$ceiling(height)) + 'px + 32px)'));
										}
									} else {
										var height = visibleActionHeight.a;
										return A2(
											$elm$html$Html$Attributes$style,
											'height',
											function (heightString) {
												return 'calc(' + (heightString + 'px + 32px');
											}(
												$elm$core$String$fromInt(
													A2(
														$elm$core$Basics$max,
														$elm$core$Basics$ceiling(height),
														$elm$core$Basics$ceiling(
															A2($elm$core$Maybe$withDefault, 0, previousVisibleActionHeight))))));
									}
								}(),
									$elm$html$Html$Attributes$class('overflow-y-hidden duration-300 ease-in-out origin-top motion-reduce:transition-none'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'transition-all',
											$elm_community$maybe_extra$Maybe$Extra$isJust(visibleActionHeight))
										])),
									$elm$html$Html$Attributes$tabindex(-1)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('duration-300 ease-in-out origin-top lg:!h-full motion-reduce:transition-none'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('lg:scale-0', !isOpen),
													_Utils_Tuple2('lg:scale-1', isOpen),
													_Utils_Tuple2(
													'transition-transform',
													$elm_community$maybe_extra$Maybe$Extra$isNothing(visibleActionHeight))
												]))
										]),
									_List_fromArray(
										[
											(!isOpen) ? $elm$html$Html$text('') : ($elm$core$List$isEmpty(filteredActions) ? A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('lg:w-1/2 xl:w-1/3 lg:mx-auto flex flex-col items-center pt-4 pb-6 animate-fade-in-from-above'),
													A2(
													$elm$html$Html$Events$on,
													'animationend',
													$elm$json$Json$Decode$succeed(
														$author$project$Page$Community$Objectives$FinishedOpeningActions(objective))),
													A2(
													$elm$html$Html$Events$on,
													'animationcancel',
													$elm$json$Json$Decode$succeed(
														$author$project$Page$Community$Objectives$FinishedOpeningActions(objective)))
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$img,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$src('/images/doggo-laying-down.svg'),
															$elm$html$Html$Attributes$alt(
															translators.il('community.objectives.empty_dog_alt'))
														]),
													_List_Nil),
													A2(
													$elm$html$Html$p,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('mt-4 text-black font-bold text-center')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															translators.il('community.objectives.empty_title'))
														])),
													A2(
													$elm$html$Html$p,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('text-center mt-4')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															translators.il('community.objectives.empty_line_1')),
															A2($elm$html$Html$br, _List_Nil, _List_Nil),
															A2($elm$html$Html$br, _List_Nil, _List_Nil),
															$elm$html$Html$text(
															A2(
																translators.iu,
																'community.objectives.empty_line_2',
																_List_fromArray(
																	[
																		_Utils_Tuple2(
																		'symbol',
																		$author$project$Eos$symbolToSymbolCodeString(objective.b9.e9))
																	])))
														]))
												])) : A4(
											$author$project$View$Components$masonryLayout,
											_List_fromArray(
												[1, 2]),
											{
												pG: function () {
													var _v4 = model.cn;
													if (_v4.$ === 1) {
														return true;
													} else {
														var objectiveId = _v4.a.cx;
														return !_Utils_eq(objectiveId, objective.R);
													}
												}()
											},
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('mt-4 mb-2 flex h-full overflow-y-hidden overflow-x-scroll snap-x scrollbar-hidden gap-4 transition-all lg:gap-x-6 lg:overflow-visible lg:-mb-4'),
													$elm$html$Html$Attributes$classList(
													_List_fromArray(
														[
															_Utils_Tuple2(
															'lg:grid-cols-1 lg:w-1/2 lg:mx-auto xl:w-1/3',
															$elm$core$List$length(filteredActions) === 1),
															_Utils_Tuple2(
															'lg:grid-cols-2 xl:grid-cols-2 xl:w-2/3 xl:mx-auto',
															$elm$core$List$length(filteredActions) === 2),
															_Utils_Tuple2(
															'lg:grid-cols-2 xl:grid-cols-3',
															$elm$core$List$length(filteredActions) > 2)
														])),
													$elm$html$Html$Attributes$id(
													$author$project$Page$Community$Objectives$objectiveContainerId(objective)),
													$fapian$elm_html_aria$Html$Attributes$Aria$role('list')
												]),
											A2(
												$elm$core$List$indexedMap,
												F2(
													function (index, action) {
														return A3(
															$author$project$Action$viewCard,
															loggedIn,
															{
																mg: _List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('mb-6 snap-center snap-always animate-fade-in-from-above motion-reduce:animate-none'),
																		$elm$html$Html$Attributes$classList(
																		_List_fromArray(
																			[
																				_Utils_Tuple2(
																				'border border-green ring ring-green ring-opacity-30',
																				isActionHighlighted(action))
																			])),
																		A2(
																		$elm$html$Html$Attributes$style,
																		'animation-delay',
																		'calc(75ms * ' + ($elm$core$String$fromInt(index) + ')')),
																		$elm$html$Html$Attributes$id(
																		$author$project$Page$Community$Objectives$actionCardId(action.R)),
																		A2(
																		$elm$html$Html$Events$on,
																		'animationend',
																		$elm$json$Json$Decode$succeed(
																			$author$project$Page$Community$Objectives$FinishedOpeningActions(objective)))
																	]),
																kC: $elm$core$Maybe$Just(index + 1),
																pA: $author$project$Page$Community$Objectives$GotActionMsg
															},
															action);
													}),
												filteredActions)))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex justify-center gap-2 lg:hidden')
								]),
							A2(
								$elm$core$List$indexedMap,
								F2(
									function (index, action) {
										return A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('border border-gray-900 rounded-full w-3 h-3 transition-colors focus-ring'),
													$elm$html$Html$Attributes$classList(
													_List_fromArray(
														[
															_Utils_Tuple2(
															'border-orange-300 bg-orange-300',
															_Utils_eq(
																$elm$core$Maybe$Just(action.R),
																visibleActionId)),
															_Utils_Tuple2(
															'hover:bg-orange-300/50 hover:border-orange-300/50',
															!_Utils_eq(
																$elm$core$Maybe$Just(action.R),
																visibleActionId))
														])),
													$elm$html$Html$Attributes$id(
													'go-to-action-' + $author$project$Action$idToString(action.R)),
													$elm$html$Html$Events$onClick(
													$author$project$Page$Community$Objectives$ClickedScrollToAction(action)),
													$fapian$elm_html_aria$Html$Attributes$Aria$ariaLabel(
													A2(
														translators.iu,
														'community.objectives.go_to_action',
														_List_fromArray(
															[
																_Utils_Tuple2(
																'index',
																$elm$core$String$fromInt(index + 1))
															]))),
													$fapian$elm_html_aria$Html$Attributes$Aria$role('link')
												]),
											_List_Nil);
									}),
								filteredActions))
						]))
				]));
	});
var $author$project$Page$Community$Objectives$viewPage = F3(
	function (loggedIn, community, model) {
		var _v0 = loggedIn.aM.iw;
		var t = _v0.il;
		var tr = _v0.iu;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container mx-auto px-4 pt-8 mb-20')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('lg:w-2/3 lg:mx-auto'),
							$fapian$elm_html_aria$Html$Attributes$Aria$ariaLabel(
							t('community.objectives.earn') + (' ' + $author$project$Eos$symbolToSymbolCodeString(community.e9)))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('community.objectives.earn'))
								])),
							$elm$html$Html$text(' '),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('font-bold'),
									$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Eos$symbolToSymbolCodeString(community.e9))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mt-4 bg-white rounded relative lg:w-2/3 lg:mx-auto')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('p-4')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('sr-only')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											t('community.objectives.complete_actions') + (' ' + $author$project$Eos$symbolToSymbolCodeString(community.e9)))
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											t('community.objectives.complete_actions'))
										])),
									$elm$html$Html$text(' '),
									A2(
									$elm$html$Html$b,
									_List_fromArray(
										[
											$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Eos$symbolToSymbolCodeString(community.e9))
										]))
								])),
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$src('/images/doggo_holding_coins.svg'),
									$elm$html$Html$Attributes$alt(''),
									$elm$html$Html$Attributes$class('absolute right-1 top-0 -translate-y-2/3')
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mt-6 lg:w-2/3 lg:mx-auto'),
							$fapian$elm_html_aria$Html$Attributes$Aria$ariaLabel(
							t('community.objectives.objectives_and') + (' ' + t('community.objectives.actions')))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('community.objectives.objectives_and'))
								])),
							$elm$html$Html$text(' '),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('font-bold'),
									$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('community.objectives.actions'))
								]))
						])),
					function () {
					var _v1 = community.cy;
					switch (_v1.$) {
						case 3:
							var objectives = _v1.a;
							var filteredObjectives = A2(
								$elm$core$List$filter,
								function (objective) {
									return !objective.$7;
								},
								objectives);
							return A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										$elm$core$List$isEmpty(filteredObjectives) ? A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('lg:w-1/2 xl:w-1/3 lg:mx-auto flex flex-col items-center pt-4 pb-6')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$img,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$src('/images/doggo-laying-down.svg'),
														$elm$html$Html$Attributes$alt(
														t('community.objectives.empty_dog_alt'))
													]),
												_List_Nil),
												A2(
												$elm$html$Html$p,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('mt-4 text-black font-bold')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														t('community.objectives.empty_title'))
													])),
												A2(
												$elm$html$Html$p,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('text-center mt-4')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														t('community.objectives.empty_objectives_line_1')),
														A2($elm$html$Html$br, _List_Nil, _List_Nil),
														A2($elm$html$Html$br, _List_Nil, _List_Nil),
														$elm$html$Html$text(
														t('community.objectives.empty_objectives_line_2'))
													]))
											])) : A2(
										$elm$html$Html$ul,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('space-y-4 mt-4')
											]),
										A2(
											$elm$core$List$map,
											A2($author$project$Page$Community$Objectives$viewObjective, loggedIn, model),
											filteredObjectives)),
										$author$project$View$Components$intersectionObserver(
										{
											lZ: $elm$core$Maybe$Just(1),
											oo: $elm$core$Maybe$Just($author$project$Page$Community$Objectives$StartedIntersecting),
											op: $elm$core$Maybe$Just($author$project$Page$Community$Objectives$StoppedIntersecting),
											pw: A2(
												$elm$core$List$filterMap,
												function (action) {
													return action.$7 ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
														'#' + $author$project$Page$Community$Objectives$actionCardId(action.R));
												},
												A2(
													$elm$core$List$concatMap,
													function ($) {
														return $.lP;
													},
													A2(
														$elm$core$List$filter,
														function (objective) {
															return A2(
																$elm$core$List$member,
																objective.R,
																$pzp1997$assoc_list$AssocList$keys(model.E));
														},
														filteredObjectives))),
											py: 0.01
										})
									]));
						case 1:
							return A2(
								$elm$html$Html$ul,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('space-y-4 mt-4')
									]),
								A2(
									$elm$core$List$map,
									function (_v2) {
										return A2(
											$elm$html$Html$li,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('bg-white py-10 rounded animate-skeleton-loading lg:w-2/3 lg:mx-auto')
												]),
											_List_Nil);
									},
									A2($elm$core$List$range, 0, 4)));
						case 0:
							return A2(
								$elm$html$Html$ul,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('space-y-4 mt-4')
									]),
								A2(
									$elm$core$List$map,
									function (_v3) {
										return A2(
											$elm$html$Html$li,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('bg-white py-10 rounded animate-skeleton-loading lg:w-2/3 lg:mx-auto')
												]),
											_List_Nil);
									},
									A2($elm$core$List$range, 0, 4)));
						default:
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('mt-4 bg-white rounded py-6 px-4 flex flex-col items-center lg:w-2/3 lg:mx-auto')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$img,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$alt(''),
												$elm$html$Html$Attributes$src('/images/not_found.svg'),
												$elm$html$Html$Attributes$class('max-h-40')
											]),
										_List_Nil),
										A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-center mt-4')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												t('community.objectives.error_loading'))
											]))
									]));
					}
				}(),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('bg-white rounded p-4 pb-6 relative mt-18 lg:w-2/3 lg:mx-auto')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-center mt-2')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('community.objectives.visit_community_page'))
								])),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$author$project$Route$href($author$project$Route$CommunityAbout),
									$elm$html$Html$Attributes$class('button button-secondary w-full mt-4')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('community.objectives.go_to_community_page'))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('absolute top-0 left-0 w-full flex justify-center')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$img,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$src('/images/success-doggo.svg'),
											$elm$html$Html$Attributes$alt(''),
											$elm$html$Html$Attributes$class('-translate-y-3/4')
										]),
									_List_Nil)
								]))
						]))
				]));
	});
var $author$project$Page$Community$Objectives$view = F2(
	function (loggedIn, model) {
		var title = loggedIn.aM.iw.il('community.objectives.title');
		return {
			mk: function () {
				var _v0 = loggedIn.o7;
				switch (_v0.$) {
					case 3:
						var community = _v0.a;
						return community.cl ? A3($author$project$Page$Community$Objectives$viewPage, loggedIn, community, model) : A2(
							$author$project$Page$fullPageNotFound,
							title,
							loggedIn.aM.iw.il('community.objectives.disabled_objectives_description'));
					case 1:
						return $author$project$Page$fullPageLoading(loggedIn.aM);
					case 0:
						return $author$project$Page$fullPageLoading(loggedIn.aM);
					default:
						var err = _v0.a;
						return A2($author$project$Page$fullPageGraphQLError, title, err);
				}
			}(),
			fb: title
		};
	});
var $author$project$Route$externalHref = F3(
	function (shared, community, route) {
		return $elm$html$Html$Attributes$href(
			$elm$url$Url$toString(
				A3($author$project$Route$externalCommunityLink, shared, community.pl, route)));
	});
var $author$project$Page$Community$Selector$viewCommunity = F3(
	function (shared, model, community) {
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex justify-between items-center py-6 text-black hover:text-orange-300'),
					A3(
					$author$project$Route$externalHref,
					shared,
					community,
					A2($elm$core$Maybe$withDefault, $author$project$Route$Dashboard, model.j9))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex items-center')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('w-10 h-10'),
									$elm$html$Html$Attributes$src(community.hC)
								]),
							_List_Nil),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('ml-4 text-sm')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(community.ki)
								]))
						])),
					$author$project$Icons$arrowDown('-rotate-90 fill-current')
				]));
	});
var $author$project$Page$Community$Selector$view_ = F3(
	function (shared, model, profile) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex-grow flex flex-col')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-col items-center')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$src('/images/map.svg')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('font-semibold text-black text-xl')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Welcome')
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-black text-sm')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Choose the community you would like to join')
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('bg-white flex-grow mt-8')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('container mx-auto px-4 divide-y divide-solid divide-gray-500')
								]),
							A2(
								$elm$core$List$map,
								A2($author$project$Page$Community$Selector$viewCommunity, shared, model),
								profile.ei))
						]))
				]));
	});
var $author$project$Page$Community$Selector$view = F2(
	function (loggedIn, model) {
		var title = 'Select community';
		var content = function () {
			var _v0 = loggedIn.kJ;
			switch (_v0.$) {
				case 1:
					return $author$project$Page$fullPageLoading(loggedIn.aM);
				case 0:
					return $author$project$Page$fullPageLoading(loggedIn.aM);
				case 2:
					var err = _v0.a;
					return A2($author$project$Page$fullPageGraphQLError, title, err);
				default:
					var profile = _v0.a;
					return A3($author$project$Page$Community$Selector$view_, loggedIn.aM, model, profile);
			}
		}();
		return {mk: content, fb: title};
	});
var $author$project$Page$fullPageError = F2(
	function (title_, _v0) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Page$viewTitle(title_),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('card')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Something wrong happened.')
						]))
				]));
	});
var $author$project$Page$Community$Transfer$BalanceError = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Community$Transfer$TokenError = function (a) {
	return {$: 0, a: a};
};
var $krisajenkins$remotedata$RemoteData$andMap = F2(
	function (wrappedValue, wrappedFunction) {
		var _v0 = _Utils_Tuple2(wrappedFunction, wrappedValue);
		_v0$2:
		while (true) {
			_v0$3:
			while (true) {
				_v0$4:
				while (true) {
					_v0$5:
					while (true) {
						switch (_v0.a.$) {
							case 3:
								switch (_v0.b.$) {
									case 3:
										var f = _v0.a.a;
										var value = _v0.b.a;
										return $krisajenkins$remotedata$RemoteData$Success(
											f(value));
									case 2:
										break _v0$2;
									case 1:
										break _v0$4;
									default:
										var _v4 = _v0.b;
										return $krisajenkins$remotedata$RemoteData$NotAsked;
								}
							case 2:
								var error = _v0.a.a;
								return $krisajenkins$remotedata$RemoteData$Failure(error);
							case 1:
								switch (_v0.b.$) {
									case 2:
										break _v0$2;
									case 1:
										break _v0$3;
									case 0:
										break _v0$3;
									default:
										break _v0$3;
								}
							default:
								switch (_v0.b.$) {
									case 2:
										break _v0$2;
									case 1:
										break _v0$4;
									case 0:
										break _v0$5;
									default:
										break _v0$5;
								}
						}
					}
					var _v3 = _v0.a;
					return $krisajenkins$remotedata$RemoteData$NotAsked;
				}
				var _v2 = _v0.b;
				return $krisajenkins$remotedata$RemoteData$Loading;
			}
			var _v1 = _v0.a;
			return $krisajenkins$remotedata$RemoteData$Loading;
		}
		var error = _v0.b.a;
		return $krisajenkins$remotedata$RemoteData$Failure(error);
	});
var $krisajenkins$remotedata$RemoteData$map2 = F3(
	function (f, a, b) {
		return A2(
			$krisajenkins$remotedata$RemoteData$andMap,
			b,
			A2($krisajenkins$remotedata$RemoteData$map, f, a));
	});
var $author$project$Page$Community$Transfer$getMaxTransferAmount = function (model) {
	return A3(
		$krisajenkins$remotedata$RemoteData$map2,
		F2(
			function (balance, token) {
				return balance.lY.lU - token.nT.lU;
			}),
		A2($krisajenkins$remotedata$RemoteData$mapError, $author$project$Page$Community$Transfer$BalanceError, model.b5),
		A2($krisajenkins$remotedata$RemoteData$mapError, $author$project$Page$Community$Transfer$TokenError, model.pC));
};
var $author$project$Page$Community$Transfer$FormOutput = F3(
	function (selectedProfile, amount, memo) {
		return {lU: amount, ka: memo, W: selectedProfile};
	});
var $author$project$Form$Validate$numberLowerThanOrEqualTo = F2(
	function (numberToString, upperBound) {
		return $author$project$Form$Validate$custom(
			function (x) {
				return (_Utils_cmp(x, upperBound) < 1) ? $elm$core$Result$Ok(x) : $elm$core$Result$Err(
					function (_v0) {
						var tr = _v0.iu;
						return A2(
							tr,
							'error.validator.number.lower_than_or_equal',
							_List_fromArray(
								[
									_Utils_Tuple2(
									'base',
									numberToString(upperBound))
								]));
					});
			});
	});
var $author$project$Form$Validate$floatLowerThanOrEqualTo = $author$project$Form$Validate$numberLowerThanOrEqualTo($elm$core$String$fromFloat);
var $author$project$Form$UserPicker = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Form$userPicker = F2(
	function (config, options) {
		return A2(
			$author$project$Form$field,
			A2(
				$elm$core$Basics$composeR,
				A2($author$project$Form$mapBaseField, $author$project$Form$UserPicker$fromSinglePicker, $author$project$Form$UserPicker$toSinglePicker),
				$author$project$Form$UserPicker(options)),
			{
				ab: config.ab,
				af: A2($elm$core$Basics$composeR, $author$project$Form$UserPicker$getSingleProfile, config.af),
				n: config.n,
				pO: config.pO
			});
	});
var $author$project$Form$Text$viewCurrencyElement = F2(
	function (symbol, _v0) {
		var hasError = _v0.m$;
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('\n            absolute right-0 inset-y-0 ml-px\n            bg-purple-500 text-white uppercase\n            px-4 flex items-center rounded-r-md\n            border-r border-t border-b\n            '),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('border-red', hasError),
							_Utils_Tuple2('border-gray-500 peer-focus:border-green', !hasError)
						])),
					$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Eos$symbolToSymbolCodeString(symbol))
				]));
	});
var $author$project$Form$Text$withElementsWithConfig = F2(
	function (elements, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				dd: _Utils_ap(options.dd, elements)
			});
	});
var $author$project$Form$Text$NumberMask = function (a) {
	return {$: 0, a: a};
};
var $author$project$Form$Text$withNumberMask = F2(
	function (decimalDigits, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				ga: $elm$core$Maybe$Just(
					$author$project$Form$Text$NumberMask(decimalDigits))
			});
	});
var $author$project$Form$Text$withCurrency = F2(
	function (symbol, options) {
		return $author$project$Form$Text$asNumeric(
			A2(
				$author$project$Form$Text$withNumberMask,
				$henriquecbuss$elm_mask$Mask$Precisely(
					$author$project$Eos$getSymbolPrecision(symbol)),
				A2(
					$author$project$Form$Text$withExtraAttrs,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pr-20')
						]),
					A2(
						$author$project$Form$Text$withElementsWithConfig,
						_List_fromArray(
							[
								$author$project$Form$Text$viewCurrencyElement(symbol)
							]),
						options))));
	});
var $author$project$Form$Validate$withCustomError = F2(
	function (newError, _v0) {
		var validator = _v0;
		if (!validator.$) {
			var ok = validator.a;
			return $elm$core$Result$Ok(ok);
		} else {
			return $elm$core$Result$Err(newError);
		}
	});
var $author$project$Page$Community$Transfer$createForm = F4(
	function (loggedIn, community, balance, maxTransferAmount) {
		var _v0 = loggedIn.aM;
		var translators = _v0.iw;
		return A2(
			$author$project$Form$with,
			A2(
				$author$project$Form$richText,
				{
					ab: $elm$core$Basics$always($elm$core$Maybe$Nothing),
					af: $elm$core$Result$Ok,
					n: F2(
						function (memo, input) {
							return _Utils_update(
								input,
								{ka: memo});
						}),
					pO: function ($) {
						return $.ka;
					}
				},
				$author$project$Form$RichText$init(
					{
						nC: translators.il('account.my_wallet.transfer.memo')
					})),
			A2(
				$author$project$Form$withNoOutput,
				$author$project$Form$arbitrary(
					A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('bg-gray-100 uppercase text-sm px-2 inline-block mb-10')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2(
									translators.iu,
									'account.my_wallet.your_current_balance',
									_List_fromArray(
										[
											_Utils_Tuple2(
											'balance',
											A2($author$project$Eos$assetToString, translators, balance))
										])))
							]))),
				A2(
					$author$project$Form$with,
					A2(
						$author$project$Form$textField,
						{
							ab: $elm$core$Basics$always($elm$core$Maybe$Nothing),
							af: A2(
								$elm$core$Basics$composeR,
								$author$project$Form$Validate$succeed,
								A2(
									$elm$core$Basics$composeR,
									$author$project$Form$Validate$maskedFloat(translators),
									A2(
										$elm$core$Basics$composeR,
										$author$project$Form$Validate$floatLowerThanOrEqualTo(maxTransferAmount),
										A2(
											$elm$core$Basics$composeR,
											$author$project$Form$Validate$withCustomError(
												function (translators_) {
													return A2(
														translators_.iu,
														'transfer.too_much',
														_List_fromArray(
															[
																_Utils_Tuple2(
																'token',
																$author$project$Eos$symbolToSymbolCodeString(balance.e9)),
																_Utils_Tuple2(
																'max_asset',
																A2(
																	$author$project$Eos$assetToString,
																	translators_,
																	{lU: maxTransferAmount, e9: balance.e9}))
															]));
												}),
											A2(
												$elm$core$Basics$composeR,
												$author$project$Form$Validate$map(
													function (amount) {
														return {lU: amount, e9: community.e9};
													}),
												$author$project$Form$Validate$validate(translators)))))),
							n: F2(
								function (amount, input) {
									return _Utils_update(
										input,
										{lU: amount});
								}),
							pO: function ($) {
								return $.lU;
							}
						},
						A2(
							$author$project$Form$Text$withCurrency,
							balance.e9,
							A2(
								$author$project$Form$Text$withContainerAttrs,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('mb-4')
									]),
								$author$project$Form$Text$init(
									{
										R: 'transfer-amount-field',
										nC: A2(
											translators.iu,
											'account.my_wallet.transfer.amount',
											_List_fromArray(
												[
													_Utils_Tuple2(
													'symbol',
													$author$project$Eos$symbolToSymbolCodeString(community.e9))
												]))
									})))),
					A2(
						$author$project$Form$with,
						A2(
							$author$project$Form$userPicker,
							{
								ab: $elm$core$Basics$always($elm$core$Maybe$Nothing),
								af: function (maybeUser) {
									if (maybeUser.$ === 1) {
										return $elm$core$Result$Err(
											translators.il('transfer.no_profile'));
									} else {
										var user = maybeUser.a;
										return _Utils_eq(user.fl, loggedIn.lM) ? $elm$core$Result$Err(
											translators.il('transfer.to_self')) : $elm$core$Result$Ok(user);
									}
								},
								n: F2(
									function (selectedProfile, input) {
										return _Utils_update(
											input,
											{W: selectedProfile});
									}),
								pO: function ($) {
									return $.W;
								}
							},
							$author$project$Form$UserPicker$init(
								{
									eo: loggedIn.lM,
									nC: translators.il('account.my_wallet.transfer.send_to'),
									eX: community.hG
								})),
						$author$project$Form$succeed($author$project$Page$Community$Transfer$FormOutput)))));
	});
var $author$project$Form$withDisabled = F2(
	function (disabled, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{cf: disabled});
	});
var $author$project$Page$Community$Transfer$viewForm = F4(
	function (loggedIn, model, community, maxTransferAmount) {
		var shared = loggedIn.aM;
		var text_ = function (s) {
			return $elm$html$Html$text(
				loggedIn.aM.iw.il(s));
		};
		var isDisabled = function () {
			var _v0 = model.aN;
			switch (_v0.$) {
				case 0:
					return false;
				case 1:
					return true;
				default:
					return true;
			}
		}();
		var currBalance = A2(
			$krisajenkins$remotedata$RemoteData$withDefault,
			{lU: 0, e9: community.e9},
			A2(
				$krisajenkins$remotedata$RemoteData$map,
				function ($) {
					return $.lY;
				},
				model.b5));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bg-white')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Page$viewHeader,
					loggedIn,
					shared.iw.il('transfer.title')),
					A6(
					$author$project$Form$view,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('container mx-auto p-4')
						]),
					shared.iw,
					function (submitButton) {
						return _List_fromArray(
							[
								A2(
								submitButton,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('w-full mt-6 button button-primary'),
										$elm$html$Html$Attributes$disabled(!loggedIn.mZ)
									]),
								_List_fromArray(
									[
										text_('account.my_wallet.transfer.submit')
									]))
							]);
					},
					A4($author$project$Page$Community$Transfer$createForm, loggedIn, community, currBalance, maxTransferAmount),
					A2($author$project$Form$withDisabled, isDisabled, model.hk),
					{oq: $author$project$Page$Community$Transfer$SubmittedForm, pA: $author$project$Page$Community$Transfer$GotFormMsg})
				]));
	});
var $author$project$Page$Community$Transfer$view = F2(
	function (loggedIn, model) {
		var shared = loggedIn.aM;
		var content = function () {
			var _v0 = _Utils_Tuple2(
				loggedIn.o7,
				$author$project$Page$Community$Transfer$getMaxTransferAmount(model));
			_v0$2:
			while (true) {
				_v0$3:
				while (true) {
					_v0$4:
					while (true) {
						switch (_v0.a.$) {
							case 0:
								var _v1 = _v0.a;
								return $author$project$Page$fullPageLoading(shared);
							case 1:
								var _v2 = _v0.a;
								return $author$project$Page$fullPageLoading(shared);
							case 2:
								switch (_v0.b.$) {
									case 0:
										break _v0$2;
									case 1:
										break _v0$3;
									case 2:
										break _v0$4;
									default:
										break _v0$4;
								}
							default:
								switch (_v0.b.$) {
									case 0:
										break _v0$2;
									case 1:
										break _v0$3;
									case 2:
										var e = _v0.b.a;
										var httpError = function () {
											if (!e.$) {
												var error = e.a;
												return error;
											} else {
												if (e.a.$ === 1) {
													var error = e.a.a;
													return error;
												} else {
													var _v6 = e.a;
													return $elm$http$Http$Timeout;
												}
											}
										}();
										return A2(
											$author$project$Page$fullPageError,
											shared.iw.il('community.objectives.title_plural'),
											httpError);
									default:
										var community = _v0.a.a;
										var maxTransferAmount = _v0.b.a;
										return A4($author$project$Page$Community$Transfer$viewForm, loggedIn, model, community, maxTransferAmount);
								}
						}
					}
					var e = _v0.a.a;
					return A2(
						$author$project$Page$fullPageGraphQLError,
						shared.iw.il('community.objectives.title_plural'),
						e);
				}
				var _v4 = _v0.b;
				return $author$project$Page$fullPageLoading(shared);
			}
			var _v3 = _v0.b;
			return $author$project$Page$fullPageLoading(shared);
		}();
		return {
			mk: content,
			fb: shared.iw.il('transfer.title')
		};
	});
var $author$project$Page$Dashboard$ClickedAcceptCodeOfConduct = {$: 19};
var $author$project$Page$Dashboard$ClosedAddContactModal = {$: 14};
var $author$project$Profile$Contact$ClickedSubmit = {$: 8};
var $author$project$Profile$Contact$ClosedDeleteModal = {$: 5};
var $author$project$Profile$Contact$ConfirmedDeleteContact = function (a) {
	return {$: 6, a: a};
};
var $krisajenkins$remotedata$RemoteData$isFailure = function (data) {
	if (data.$ === 2) {
		var x = data.a;
		return true;
	} else {
		return false;
	}
};
var $author$project$Profile$Contact$isMultiple = function (kind) {
	if (kind.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $krisajenkins$remotedata$RemoteData$isSuccess = function (data) {
	if (data.$ === 3) {
		var x = data.a;
		return true;
	} else {
		return false;
	}
};
var $author$project$View$Components$loadingLogoAnimatedFluid = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('w-full text-center h-full py-2')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$img,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mx-auto h-full'),
					$elm$html$Html$Attributes$src('/images/loading.svg')
				]),
			_List_Nil)
		]));
var $author$project$Profile$Contact$EnteredContactOption = function (a) {
	return {$: 7, a: a};
};
var $author$project$Profile$Contact$contactTypeToString = F2(
	function (translators, contactType) {
		return translators.il(
			function (asString) {
				return 'contact_form.types.' + asString;
			}(
				$elm$core$String$toLower(
					$author$project$Cambiatus$Enum$ContactType$toString(contactType))));
	});
var $author$project$Form$Select$withOptions = F2(
	function (newOptions, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				gk: _Utils_ap(newOptions, options.gk)
			});
	});
var $author$project$Profile$Contact$viewContactTypeSelect = F2(
	function (translators, contactType) {
		var t = translators.il;
		var makeOption = function (contactType_) {
			return {
				nC: A2($author$project$Profile$Contact$contactTypeToString, translators, contactType_),
				gj: contactType_
			};
		};
		return function (options) {
			return A2(
				$author$project$Form$Select$view,
				options,
				{
					mM: $elm$html$Html$text(''),
					m$: false,
					nx: false,
					od: $author$project$Profile$Contact$NoOp,
					kv: $author$project$Profile$Contact$EnteredContactOption,
					pO: contactType
				});
		}(
			A2(
				$author$project$Form$Select$withContainerAttrs,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mb-10')
					]),
				A2(
					$author$project$Form$Select$withOptions,
					A2($elm$core$List$map, makeOption, $author$project$Cambiatus$Enum$ContactType$list),
					$author$project$Form$Select$init(
						{
							R: 'contact-type',
							nC: t('contact_form.contact_type'),
							dG: $author$project$Cambiatus$Enum$ContactType$toString
						}))));
	});
var $author$project$Profile$Contact$ClickedToggleContactFlags = function (a) {
	return {$: 2, a: a};
};
var $author$project$Profile$Contact$PressedDownArrowOnFlagSelect = function (a) {
	return {$: 12, a: a};
};
var $author$project$Profile$Contact$PressedUpArrowOnFlagSelect = function (a) {
	return {$: 11, a: a};
};
var $author$project$Profile$Contact$SelectedCountry = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Profile$Contact$viewFlagsSelect = F2(
	function (_v0, basic) {
		var t = _v0.il;
		var withPreventAll = function (message) {
			return {nS: message, kF: true, le: true};
		};
		var escListener = A2(
			$elm$html$Html$Events$custom,
			'keydown',
			A2(
				$elm$json$Json$Decode$andThen,
				function (key) {
					return ((key === 'Esc') || (key === 'Escape')) ? $elm$json$Json$Decode$succeed(
						{
							nS: $author$project$Profile$Contact$ClickedToggleContactFlags(basic.mf),
							kF: true,
							le: true
						}) : $elm$json$Json$Decode$fail('Expecting Esc');
				},
				A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string)));
		var flag = F3(
			function (addId, classes, supportedCountry) {
				return A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('w-full flex items-center space-x-2 text-menu rounded-sm focus:outline-none focus:ring focus:ring-offset-2 ' + classes),
							$elm$html$Html$Events$onClick(
							A2($author$project$Profile$Contact$SelectedCountry, basic.mf, supportedCountry)),
							$elm$html$Html$Attributes$type_('button'),
							$elm$html$Html$Attributes$tabindex(-1),
							escListener,
							addId ? $elm$html$Html$Attributes$id(
							A2($author$project$Profile$Contact$flagId, supportedCountry, basic.mf)) : $elm$html$Html$Attributes$class('')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('w-7'),
									$elm$html$Html$Attributes$src(supportedCountry.aI)
								]),
							_List_Nil),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('justify-self-center text-left'),
									A2($elm$html$Html$Attributes$style, 'min-width', '4ch')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('+' + supportedCountry.g5.el)
								]))
						]));
			});
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mb-10 flex-shrink-0')
				]),
			_List_fromArray(
				[
					basic.bV ? A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('fixed top-0 left-0 w-full h-full cursor-default z-40'),
							$elm$html$Html$Events$onClick(
							$author$project$Profile$Contact$ClickedToggleContactFlags(basic.mf)),
							$elm$html$Html$Attributes$type_('button'),
							$elm$html$Html$Attributes$tabindex(-1)
						]),
					_List_Nil) : $elm$html$Html$text(''),
					A2(
					$author$project$View$Components$label,
					_List_Nil,
					{
						nD: t('contact_form.country'),
						pv: $author$project$Profile$Contact$flagSelectorId(basic.mf)
					}),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('form-select relative'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('border-none mx-px', basic.bV)
								])),
							$elm$html$Html$Events$onClick(
							$author$project$Profile$Contact$ClickedToggleContactFlags(basic.mf)),
							$elm$html$Html$Attributes$id(
							$author$project$Profile$Contact$flagSelectorId(basic.mf)),
							$elm$html$Html$Attributes$type_('button'),
							A2(
							$elm$html$Html$Events$custom,
							'keydown',
							A2(
								$elm$json$Json$Decode$andThen,
								function (key) {
									switch (key) {
										case 'ArrowUp':
											return $elm$json$Json$Decode$succeed(
												withPreventAll(
													$author$project$Profile$Contact$PressedUpArrowOnFlagSelect(basic.mf)));
										case 'ArrowDown':
											return $elm$json$Json$Decode$succeed(
												withPreventAll(
													$author$project$Profile$Contact$PressedDownArrowOnFlagSelect(basic.mf)));
										case 'Esc':
											return $elm$json$Json$Decode$succeed(
												withPreventAll(
													$author$project$Profile$Contact$ClickedToggleContactFlags(basic.mf)));
										case 'Escape':
											return $elm$json$Json$Decode$succeed(
												withPreventAll(
													$author$project$Profile$Contact$ClickedToggleContactFlags(basic.mf)));
										case 'Tab':
											return basic.bV ? $elm$json$Json$Decode$succeed(
												{
													nS: $author$project$Profile$Contact$ClickedToggleContactFlags(basic.mf),
													kF: false,
													le: false
												}) : $elm$json$Json$Decode$fail('Only listen to tab when dropdown is open');
										default:
											return $elm$json$Json$Decode$fail('Expected arrow up or arrow down');
									}
								},
								A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string)))
						]),
					_List_fromArray(
						[
							A3(flag, false, '', basic.aC),
							basic.bV ? A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('absolute input -mx-px inset-x-0 top-0 space-y-4 z-50 h-44 overflow-auto'),
									$elm$html$Html$Attributes$tabindex(-1)
								]),
							A2(
								$elm$core$List$map,
								A2(flag, true, 'mt-1'),
								$author$project$Profile$Contact$countryOptions(basic.aC))) : $elm$html$Html$text('')
						]))
				]));
	});
var $author$project$Profile$Contact$EnteredContactText = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Profile$Contact$phoneMask = function (basic) {
	return {
		ga: A2(
			$elm$core$String$map,
			function (phoneChar) {
				return $elm$core$Char$isDigit(phoneChar) ? '#' : phoneChar;
			},
			basic.aC.az),
		o0: '#'
	};
};
var $author$project$Form$Text$withAllowedChars = F2(
	function (isAllowed, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				bz: A2(
					$elm$core$Basics$composeR,
					$elm$core$String$filter(isAllowed),
					options.bz)
			});
	});
var $author$project$Profile$Contact$viewPhoneInput = F2(
	function (translators, basic) {
		var t = translators.il;
		var tr = translators.iu;
		return function (options) {
			return A2(
				$author$project$Form$Text$view,
				options,
				{
					mM: function () {
						var _v0 = basic.jk;
						if (!_v0.$) {
							if (_v0.a.b) {
								var _v1 = _v0.a;
								var firstError = _v1.a;
								return A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('form-error')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(firstError)
										]));
							} else {
								return $elm$html$Html$text('');
							}
						} else {
							return $elm$html$Html$text('');
						}
					}(),
					m$: $elm_community$maybe_extra$Maybe$Extra$isJust(basic.jk),
					nx: false,
					od: $author$project$Profile$Contact$NoOp,
					oe: $author$project$Profile$Contact$EnteredContactText(basic.mf),
					iw: translators,
					pO: basic.me
				});
		}(
			A2(
				$author$project$Form$Text$withContainerAttrs,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('w-full')
					]),
				A2(
					$author$project$Form$Text$withAllowedChars,
					$elm$core$Char$isDigit,
					A2(
						$author$project$Form$Text$withType,
						1,
						A2(
							$author$project$Form$Text$withMask,
							$author$project$Profile$Contact$phoneMask(basic),
							A2(
								$author$project$Form$Text$withPlaceholder,
								A2(
									tr,
									'contact_form.phone.placeholder',
									_List_fromArray(
										[
											_Utils_Tuple2('example_number', basic.aC.az)
										])),
								$author$project$Form$Text$init(
									{
										R: $author$project$Cambiatus$Enum$ContactType$toString(basic.mf) + '-input',
										nC: t('contact_form.phone.label')
									})))))));
	});
var $author$project$Profile$Contact$viewTextInput = F2(
	function (translators, basic) {
		var t = translators.il;
		var contactKey = function () {
			var _v2 = basic.mf;
			switch (_v2) {
				case 1:
					return 'username';
				case 4:
					return 'username';
				case 2:
					return 'link';
				case 0:
					return 'email';
				case 5:
					return 'phone';
				default:
					return 'phone';
			}
		}();
		return function (options) {
			return A2(
				$author$project$Form$Text$view,
				options,
				{
					mM: function () {
						var _v0 = basic.jk;
						if (!_v0.$) {
							if (_v0.a.b) {
								var _v1 = _v0.a;
								var firstError = _v1.a;
								return A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('form-error')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(firstError)
										]));
							} else {
								return $elm$html$Html$text('');
							}
						} else {
							return $elm$html$Html$text('');
						}
					}(),
					m$: $elm_community$maybe_extra$Maybe$Extra$isJust(basic.jk),
					nx: false,
					od: $author$project$Profile$Contact$NoOp,
					oe: $author$project$Profile$Contact$EnteredContactText(basic.mf),
					iw: translators,
					pO: basic.me
				});
		}(
			A2(
				$author$project$Form$Text$withContainerAttrs,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('w-full')
					]),
				A2(
					$author$project$Form$Text$withPlaceholder,
					t('contact_form.' + (contactKey + '.placeholder')),
					$author$project$Form$Text$init(
						{
							R: $author$project$Cambiatus$Enum$ContactType$toString(basic.mf) + '-input',
							nC: t('contact_form.' + (contactKey + '.label'))
						}))));
	});
var $author$project$Profile$Contact$viewInput = F2(
	function (translators, basic) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex space-x-4')
				]),
			$author$project$Profile$Contact$usesPhone(basic.mf) ? _List_fromArray(
				[
					A2($author$project$Profile$Contact$viewFlagsSelect, translators, basic),
					A2($author$project$Profile$Contact$viewPhoneInput, translators, basic)
				]) : _List_fromArray(
				[
					A2($author$project$Profile$Contact$viewTextInput, translators, basic)
				]));
	});
var $author$project$Profile$Contact$ClickedDeleteContact = function (a) {
	return {$: 4, a: a};
};
var $author$project$Profile$Contact$viewInputWithBackground = F2(
	function (translators, basic) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bg-gray-100 p-4 pb-0 rounded mb-4')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('font-menu font-semibold flex items-center mb-4 justify-between')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex items-center')
								]),
							_List_fromArray(
								[
									A3($author$project$Profile$Contact$contactTypeToIcon, 'mr-2', false, basic.mf),
									$elm$html$Html$text(
									A2($author$project$Profile$Contact$contactTypeToString, translators, basic.mf))
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$Profile$Contact$ClickedDeleteContact(basic.mf)),
									$elm$html$Html$Attributes$type_('button')
								]),
							_List_fromArray(
								[
									$author$project$Icons$trash('text-red')
								]))
						])),
					A2($author$project$Profile$Contact$viewInput, translators, basic)
				]));
	});
var $author$project$Profile$Contact$view = F2(
	function (translators, model) {
		var submitText = $elm$html$Html$text(
			translators.il(
				function () {
					var _v3 = model.eG;
					if (!_v3.$) {
						var contact = _v3.a;
						var _v4 = contact.mf;
						switch (_v4) {
							case 1:
								return 'contact_form.username.submit';
							case 4:
								return 'contact_form.username.submit';
							case 2:
								return 'contact_form.link.submit';
							case 0:
								return 'contact_form.email.submit';
							case 5:
								return 'contact_form.phone.submit';
							default:
								return 'contact_form.phone.submit';
						}
					} else {
						return 'contact_form.submit_multiple';
					}
				}()));
		var isDisabled = $krisajenkins$remotedata$RemoteData$isLoading(model.X) || $krisajenkins$remotedata$RemoteData$isSuccess(model.X);
		var submitButton = A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('button w-full'),
					$elm$html$Html$Attributes$type_('submit'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'button-success',
							$krisajenkins$remotedata$RemoteData$isSuccess(model.X)),
							_Utils_Tuple2(
							'button-primary',
							!$krisajenkins$remotedata$RemoteData$isSuccess(model.X)),
							_Utils_Tuple2(
							'mt-7',
							$author$project$Profile$Contact$isMultiple(model.eG))
						])),
					$elm$html$Html$Attributes$disabled(isDisabled)
				]),
			_List_fromArray(
				[
					function () {
					var _v2 = model.X;
					if (_v2.$ === 1) {
						return $author$project$View$Components$loadingLogoAnimatedFluid;
					} else {
						return submitText;
					}
				}()
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'container mx-auto',
							$author$project$Profile$Contact$isMultiple(model.eG))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$form,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mt-12'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'px-4',
									$author$project$Profile$Contact$isMultiple(model.eG)),
									_Utils_Tuple2(
									'w-full md:w-5/6 mx-auto lg:w-2/3',
									!$author$project$Profile$Contact$isMultiple(model.eG))
								])),
							$elm$html$Html$Events$onSubmit($author$project$Profile$Contact$ClickedSubmit)
						]),
					_Utils_ap(
						function () {
							var _v0 = model.eG;
							if (!_v0.$) {
								var contact = _v0.a;
								return _List_fromArray(
									[
										A2($author$project$Profile$Contact$viewContactTypeSelect, translators, contact.mf),
										A2($author$project$Profile$Contact$viewInput, translators, contact)
									]);
							} else {
								var contacts = _v0.a;
								return A2(
									$elm$core$List$map,
									$author$project$Profile$Contact$viewInputWithBackground(translators),
									contacts);
							}
						}(),
						_List_fromArray(
							[
								submitButton,
								$krisajenkins$remotedata$RemoteData$isFailure(model.X) ? $elm$html$Html$text(
								translators.il('contact_form.error')) : $elm$html$Html$text('')
							]))),
					function () {
					var _v1 = model.ca;
					if (!_v1.$) {
						var contactType = _v1.a;
						return $author$project$View$Modal$toHtml(
							A2(
								$author$project$View$Modal$withFooter,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('modal-cancel'),
												$elm$html$Html$Events$onClick($author$project$Profile$Contact$ClosedDeleteModal)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												translators.il('contact_form.delete.cancel'))
											])),
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('modal-accept'),
												$elm$html$Html$Events$onClick(
												$author$project$Profile$Contact$ConfirmedDeleteContact(contactType))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												translators.il('contact_form.delete.accept'))
											]))
									]),
								A2(
									$author$project$View$Modal$withBody,
									_List_fromArray(
										[
											$elm$html$Html$text(
											translators.il('contact_form.delete.body'))
										]),
									A2(
										$author$project$View$Modal$withHeader,
										translators.il('contact_form.delete.title'),
										$author$project$View$Modal$initWith(
											{i$: $author$project$Profile$Contact$ClosedDeleteModal, jW: true})))));
					} else {
						return $elm$html$Html$text('');
					}
				}()
				]));
	});
var $author$project$View$Modal$withHeaderElement = F2(
	function (header, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				ey: $elm$core$Maybe$Just(header)
			});
	});
var $author$project$Page$Dashboard$addContactModal = F2(
	function (shared, model) {
		var contactModel = model.ek;
		var text_ = function (s) {
			return $elm$html$Html$text(
				shared.iw.il(s));
		};
		var header = A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('inline bg-purple-100 text-white rounded-full py-0.5 px-2 text-sm uppercase')
						]),
					_List_fromArray(
						[
							text_('contact_modal.new')
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-lg font-bold mt-2')
						]),
					_List_fromArray(
						[
							text_('contact_modal.title')
						]))
				]));
		var form = A2(
			$elm$html$Html$map,
			$author$project$Page$Dashboard$GotContactMsg,
			A2($author$project$Profile$Contact$view, shared.iw, contactModel));
		return $author$project$View$Modal$toHtml(
			A2(
				$author$project$View$Modal$withSize,
				1,
				A2(
					$author$project$View$Modal$withBody,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mx-auto mt-10'),
									$elm$html$Html$Attributes$src('/images/girl-with-phone.svg')
								]),
							_List_Nil),
							form,
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-sm text-center uppercase my-4')
								]),
							_List_fromArray(
								[
									text_('contact_modal.footer')
								]))
						]),
					A2(
						$author$project$View$Modal$withHeaderElement,
						header,
						$author$project$View$Modal$initWith(
							{i$: $author$project$Page$Dashboard$ClosedAddContactModal, jW: model.bT})))));
	});
var $author$project$Session$LoggedIn$permissions = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.o5;
				},
				$elm$core$List$concatMap(
					function ($) {
						return $.oB;
					})),
			$author$project$Session$LoggedIn$profile(model)));
};
var $author$project$ReviewMoved$cardCountKey = function (amount) {
	return (amount === 1) ? 'review_moved.card_count_one' : 'review_moved.card_count';
};
var $author$project$Markdown$fromTranslationWithReplacements = F3(
	function (_v0, key, replacements) {
		var tr = _v0.iu;
		return A2(tr, key, replacements);
	});
var $author$project$ReviewMoved$reviewUrl = F2(
	function (apiUrl, maybeClaimId) {
		if (!maybeClaimId.$) {
			var claimId = maybeClaimId.a;
			return A2(
				$author$project$ReviewMoved$appUrl,
				apiUrl,
				'/app/review?claim=' + $elm$core$String$fromInt(claimId));
		} else {
			return A2($author$project$ReviewMoved$appUrl, apiUrl, '/app/review');
		}
	});
var $elm$core$List$sortWith = _List_sortWith;
var $author$project$Page$Dashboard$viewActionsForAnalysisCard = F2(
	function (loggedIn, model) {
		var _v0 = loggedIn.aM.iw;
		var t = _v0.il;
		var text_ = A2($elm$core$Basics$composeL, $elm$html$Html$text, t);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('md:animate-fade-in-from-above-lg md:animation-delay-150 md:motion-reduce:animate-none', !loggedIn.fV)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-gray-333 mt-6 mb-4 md:mb-7 lg:mt-0')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$strong,
							_List_Nil,
							_List_fromArray(
								[
									text_('dashboard.analysis.title.1')
								])),
							$elm$html$Html$text(' '),
							text_('dashboard.analysis.title.2')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('bg-white rounded py-6')
						]),
					_List_fromArray(
						[
							function () {
							var _v1 = model.b2;
							switch (_v1.$) {
								case 0:
									return A2($author$project$View$Components$loadingLogoAnimated, loggedIn.aM.iw, '-mt-8');
								case 2:
									return A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('px-6')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$img,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('w-2/3 mx-auto'),
														$elm$html$Html$Attributes$src('/images/error.svg')
													]),
												_List_Nil),
												A2(
												$elm$html$Html$p,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('text-center mt-4')
													]),
												_List_fromArray(
													[
														text_('dashboard.analysis.error_fetching')
													]))
											]));
								default:
									var analysis = _v1.a;
									var claims = analysis.i_;
									var compareAvatars = F2(
										function (first, second) {
											var _v2 = _Utils_Tuple2(
												$author$project$Avatar$toMaybeString(first),
												$author$project$Avatar$toMaybeString(second));
											if (!_v2.a.$) {
												if (!_v2.b.$) {
													var x = _v2.a.a;
													var y = _v2.b.a;
													return _Utils_eq(x, y) ? 0 : 1;
												} else {
													var _v3 = _v2.b;
													return 0;
												}
											} else {
												if (!_v2.b.$) {
													var _v4 = _v2.a;
													return 2;
												} else {
													var _v5 = _v2.a;
													var _v6 = _v2.b;
													return 1;
												}
											}
										});
									return (analysis.mo > 0) ? A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('w-2/3 mx-auto')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('flex justify-center space-x-2 mb-4')
													]),
												A2(
													$elm$core$List$map,
													function (avatar) {
														return A2($author$project$Avatar$view, avatar, 'w-7 h-7');
													},
													A2(
														$elm$core$List$take,
														5,
														A2(
															$elm$core$List$sortWith,
															compareAvatars,
															A2(
																$elm$core$List$map,
																A2(
																	$elm$core$Basics$composeR,
																	function ($) {
																		return $.c$;
																	},
																	function ($) {
																		return $.cV;
																	}),
																claims))))),
												A2(
												$author$project$Markdown$view,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('mb-4 text-center')
													]),
												A3(
													$author$project$Markdown$fromTranslationWithReplacements,
													loggedIn.aM.iw,
													$author$project$ReviewMoved$cardCountKey(analysis.mo),
													_List_fromArray(
														[
															_Utils_Tuple2(
															'amount',
															$elm$core$String$fromInt(analysis.mo))
														]))),
												A2(
												$elm$html$Html$a,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('button button-primary w-full'),
														$elm$html$Html$Attributes$href(
														A2($author$project$ReviewMoved$reviewUrl, loggedIn.aM.mJ.lW, $elm$core$Maybe$Nothing)),
														$elm$html$Html$Attributes$target('_self')
													]),
												_List_fromArray(
													[
														text_('review_moved.go')
													]))
											])) : A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('py-4')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$img,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('mx-auto'),
														$elm$html$Html$Attributes$src('/images/empty-analysis.svg')
													]),
												_List_Nil),
												A2(
												$elm$html$Html$p,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('mt-5 text-center text-gray-333')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$strong,
														_List_Nil,
														_List_fromArray(
															[
																text_('dashboard.analysis.empty.1')
															])),
														A2($elm$html$Html$br, _List_Nil, _List_Nil),
														text_('dashboard.analysis.empty.2')
													]))
											]));
							}
						}()
						]))
				]));
	});
var $author$project$Page$Dashboard$ClickedDismissAddressNote = {$: 24};
var $elm$html$Html$section = _VirtualDom_node('section');
var $author$project$PlaceLocation$showAddressNote = F2(
	function (_v0, maybeStatus) {
		var dismissed = _v0.mA;
		if (!maybeStatus.$) {
			var hasDefaultAddress = maybeStatus.a.jz;
			return (!hasDefaultAddress) && (!dismissed);
		} else {
			return false;
		}
	});
var $author$project$Page$Dashboard$viewAddressNote = F2(
	function (_v0, model) {
		var translators = _v0.iw;
		return A2(
			$author$project$PlaceLocation$showAddressNote,
			{mA: model.d6},
			model.eU) ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container mx-auto mt-8 px-4')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$section,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id('address-note'),
							$elm$html$Html$Attributes$class('rounded-lg bg-orange-100/20 p-4 flex flex-col md:flex-row md:items-center gap-4'),
							A2(
							$elm$html$Html$Attributes$attribute,
							'aria-label',
							translators.il('dashboard.address_note.title'))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex-grow')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h2,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('font-bold')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											translators.il('dashboard.address_note.title'))
										])),
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-gray-333 mt-1')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											translators.il('dashboard.address_note.body'))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex flex-col sm:flex-row gap-2 md:flex-shrink-0')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('button button-primary w-full sm:w-auto'),
											$elm$html$Html$Attributes$id('address-note-add'),
											$author$project$Route$href($author$project$Route$ProfileEditor)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											translators.il('dashboard.address_note.action'))
										])),
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('button button-secondary w-full sm:w-auto'),
											$elm$html$Html$Attributes$type_('button'),
											$elm$html$Html$Attributes$id('address-note-dismiss'),
											$elm$html$Html$Events$onClick($author$project$Page$Dashboard$ClickedDismissAddressNote)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											translators.il('dashboard.address_note.dismiss'))
										]))
								]))
						]))
				])) : $elm$html$Html$text('');
	});
var $author$project$Session$LoggedIn$viewFrozenAccountCard = F3(
	function (_v0, options, attrs) {
		var t = _v0.il;
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('bg-white rounded py-10 px-4'),
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('md:flex md:space-x-6 lg:max-w-2xl md:py-6 md:px-10', options.nu)
							])),
					attrs)),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$src('/images/girl-with-ice-cube.svg'),
							$elm$html$Html$Attributes$alt(''),
							$elm$html$Html$Attributes$class('mx-auto mb-8'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('md:mb-0', options.nu)
								]))
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-col')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h2,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('font-bold text-black text-lg mb-6')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('account_frozen.title'))
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-black mb-3')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('account_frozen.why'))
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('account_frozen.solve')),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-orange-300 hover:underline focus-ring focus-visible:ring-orange-300 focus-visible:ring-opacity-30 rounded-sm'),
											$elm$html$Html$Attributes$href('#'),
											$elm$html$Html$Events$onClick(options.og)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											t('account_frozen.solve_link'))
										]))
								]))
						]))
				]));
	});
var $author$project$Page$Dashboard$CloseInviteModal = {$: 15};
var $author$project$Page$Dashboard$CopyToClipboard = function (a) {
	return {$: 17, a: a};
};
var $author$project$Page$Dashboard$viewInvitationModal = F2(
	function (_v0, model) {
		var shared = _v0.aM;
		var t = shared.iw.il;
		var text_ = function (s) {
			return $elm$html$Html$text(
				t(s));
		};
		var protocol = function () {
			var _v6 = shared.gL.oU;
			if (!_v6) {
				return 'http://';
			} else {
				return 'https://';
			}
		}();
		var url = function (invitationId) {
			var portStr = function () {
				var _v5 = shared.gL.oI;
				if (!_v5.$) {
					var p = _v5.a;
					return ':' + $elm$core$String$fromInt(p);
				} else {
					return '';
				}
			}();
			return protocol + (shared.gL.ez + (portStr + ('/invite/' + invitationId)));
		};
		var isInviteModalVisible = function () {
			var _v4 = model.aZ;
			if (!_v4.$) {
				return false;
			} else {
				return true;
			}
		}();
		var header = t('community.invite.title');
		var footer = function () {
			var _v3 = model.aZ;
			switch (_v3.$) {
				case 3:
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('button-primary', !model.cb),
											_Utils_Tuple2('button-success', model.cb)
										])),
									$elm$html$Html$Attributes$class('button w-full md:w-48 select-all'),
									$elm$html$Html$Attributes$id('copy-invite-button'),
									$elm$html$Html$Events$onClick(
									$author$project$Page$Dashboard$CopyToClipboard('invitation-id'))
								]),
							_List_fromArray(
								[
									model.cb ? text_('community.invite.copied') : text_('community.invite.copy')
								]))
						]);
				case 2:
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('button button-primary'),
									$elm$html$Html$Events$onClick($author$project$Page$Dashboard$CloseInviteModal)
								]),
							_List_fromArray(
								[
									text_('menu.close')
								]))
						]);
				default:
					return _List_Nil;
			}
		}();
		var body = function () {
			var _v1 = model.aZ;
			switch (_v1.$) {
				case 0:
					return _List_Nil;
				case 1:
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('spinner m-auto')
								]),
							_List_Nil)
						]);
				case 2:
					var err = _v1.a;
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-center text-red')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(err)
								]))
						]);
				default:
					var invitationId = _v1.a;
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mt-3 label')
								]),
							_List_fromArray(
								[
									text_('community.invite.label')
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('py-2 md:text-lg text-black')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									url(invitationId))
								])),
							A2(
							$author$project$Form$Text$view,
							A2(
								$author$project$Form$Text$withContainerAttrs,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('mb-0 overflow-hidden')
									]),
								A2(
									$author$project$Form$Text$withExtraAttrs,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('absolute opacity-0 left-[-9999em]'),
											$elm$html$Html$Attributes$tabindex(-1)
										]),
									$author$project$Form$Text$init(
										{R: 'invitation-id', nC: ''}))),
							{
								mM: $elm$html$Html$text(''),
								m$: false,
								nx: false,
								od: $author$project$Page$Dashboard$NoOp,
								oe: function (_v2) {
									return $author$project$Page$Dashboard$NoOp;
								},
								iw: shared.iw,
								pO: url(invitationId)
							})
						]);
			}
		}();
		return $author$project$View$Modal$toHtml(
			A2(
				$author$project$View$Modal$withFooter,
				footer,
				A2(
					$author$project$View$Modal$withBody,
					body,
					A2(
						$author$project$View$Modal$withHeader,
						header,
						$author$project$View$Modal$initWith(
							{i$: $author$project$Page$Dashboard$CloseInviteModal, jW: isInviteModalVisible})))));
	});
var $author$project$Page$Dashboard$ClickedOpenTransferFilters = {$: 7};
var $author$project$Page$Dashboard$RequestedMoreTransfers = {$: 6};
var $author$project$View$Components$TrackSelf = {$: 0};
var $author$project$View$Components$TrackWindow = {$: 1};
var $author$project$Page$Dashboard$hasModalsOpen = function (model) {
	var isShowingInviteModal = function () {
		var _v1 = model.aZ;
		if (!_v1.$) {
			return false;
		} else {
			return true;
		}
	}();
	var isShowingClaimModal = function () {
		var _v0 = model.iZ;
		if (_v0.$ === 1) {
			return false;
		} else {
			return true;
		}
	}();
	return model.cK || (model.bT || (isShowingInviteModal || isShowingClaimModal));
};
var $author$project$View$Components$infiniteList = F3(
	function (options, attrs, children) {
		var requestedItemsListener = function () {
			var _v1 = options.ol;
			if (_v1.$ === 1) {
				return $elm$html$Html$Attributes$class('');
			} else {
				var onRequestedItems = _v1.a;
				return A2(
					$elm$html$Html$Events$on,
					'requested-items',
					$elm$json$Json$Decode$succeed(onRequestedItems));
			}
		}();
		var elementToTrackToString = function (elementToTrack) {
			switch (elementToTrack.$) {
				case 1:
					return 'track-window';
				case 0:
					return 'track-self';
				default:
					var selector = elementToTrack.a;
					return selector;
			}
		};
		return A3(
			$elm$html$Html$node,
			'infinite-list',
			A2(
				$elm$core$List$cons,
				requestedItemsListener,
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$class('overflow-y-auto inline-block'),
					A2(
						$elm$core$List$cons,
						A2(
							$elm$html$Html$Attributes$attribute,
							'elm-distance-to-request',
							$elm$core$String$fromInt(options.mB)),
						A2(
							$elm$core$List$cons,
							A2(
								$elm$html$Html$Attributes$attribute,
								'elm-element-to-track',
								elementToTrackToString(options.mG)),
							attrs)))),
			children);
	});
var $author$project$Page$Dashboard$ClickedTransferCard = function (a) {
	return {$: 11, a: a};
};
var $author$project$Page$Dashboard$GotTransferCardProfileSummaryMsg = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Profile$Summary$withImageSize = F2(
	function (imageSize, model) {
		return _Utils_update(
			model,
			{eA: imageSize});
	});
var $author$project$Profile$Summary$withPreventScrolling = F2(
	function (preventScrolling, model) {
		return _Utils_update(
			model,
			{gp: preventScrolling});
	});
var $author$project$Profile$Summary$withoutName = function (model) {
	return _Utils_update(
		model,
		{gz: false});
};
var $author$project$Page$Dashboard$viewTransfer = F3(
	function (loggedIn, transfer, profileSummary) {
		var addRelativeSelector = loggedIn.fV ? $elm$core$Basics$identity : $author$project$Profile$Summary$withRelativeSelector('#transfer-list-container');
		var _v0 = loggedIn.aM.iw;
		var t = _v0.il;
		var _v1 = _Utils_eq(transfer.ew.fl, loggedIn.lM) ? _Utils_Tuple2(transfer.fc, true) : _Utils_Tuple2(transfer.ew, false);
		var otherProfile = _v1.a;
		var isFromUser = _v1.b;
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex w-full px-6 py-4 focus-ring ring-inset focus-visible:rounded-sm hover:bg-gray-200'),
					$elm$html$Html$Events$onClick(
					$author$project$Page$Dashboard$ClickedTransferCard(transfer.R))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$Page$Dashboard$GotTransferCardProfileSummaryMsg(transfer.R),
					A4(
						$author$project$Profile$Summary$view,
						loggedIn.aM.iw,
						loggedIn.lM,
						otherProfile,
						A2(
							$author$project$Profile$Summary$withScrollSelector,
							'#transfer-list-container',
							addRelativeSelector(
								A2(
									$author$project$Profile$Summary$withPreventScrolling,
									1,
									A2(
										$author$project$Profile$Summary$withImageSize,
										'w-8 h-8',
										$author$project$Profile$Summary$withoutName(profileSummary))))))),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('ml-4 text-left')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mb-1')
								]),
							_List_fromArray(
								[
									isFromUser ? $elm$html$Html$text(
									t('transfer.sent_to')) : $elm$html$Html$text(
									t('transfer.received_from')),
									$elm$html$Html$text(' '),
									A2(
									$elm$html$Html$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$elm$core$Maybe$withDefault,
												$author$project$Eos$Account$nameToString(otherProfile.fl),
												otherProfile.ki))
										]))
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-green')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$author$project$Eos$assetToString,
												loggedIn.aM.iw,
												{lU: transfer.pO, e9: transfer.b9.e9}))
										]))
								]))
						]))
				]));
	});
var $author$project$Page$Dashboard$viewTransferList = F5(
	function (loggedIn, model, transfers, maybePageInfo, isLoading) {
		var infiniteList = function (isMobile_) {
			return $author$project$View$Components$infiniteList(
				{
					mB: 800,
					mG: isMobile_ ? $author$project$View$Components$TrackWindow : $author$project$View$Components$TrackSelf,
					ol: A2(
						$elm$core$Maybe$andThen,
						function (pageInfo) {
							return pageInfo.m0 ? $elm$core$Maybe$Just($author$project$Page$Dashboard$RequestedMoreTransfers) : $elm$core$Maybe$Nothing;
						},
						maybePageInfo)
				});
		};
		var container = F2(
			function (attrs, children) {
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							infiniteList,
							true,
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$class('md:hidden'),
								attrs),
							children),
							A3(
							infiniteList,
							false,
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$class('hidden md:block'),
								A2(
									$elm$core$List$cons,
									A2($elm$html$Html$Attributes$style, 'height', 'max(60vh, 400px)'),
									attrs)),
							children)
						]));
			});
		var addLoading = function (transfers_) {
			return isLoading ? _Utils_ap(
				transfers_,
				_List_fromArray(
					[
						A2($author$project$View$Components$loadingLogoAnimated, loggedIn.aM.iw, 'mb-8')
					])) : transfers_;
		};
		return A2(
			container,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$tabindex(-1),
					$elm$html$Html$Attributes$class('w-full'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'md:overflow-y-hidden',
							$author$project$Page$Dashboard$hasModalsOpen(model))
						]))
				]),
			addLoading(
				A2(
					$elm$core$List$map,
					function (_v2) {
						var first = _v2.a;
						var t1 = first.a;
						var rest = _v2.b;
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pb-6 first:pt-4 last:pb-2')
								]),
							$elm$core$List$concat(
								A2(
									$elm$core$List$cons,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('uppercase text-sm font-bold px-6')
												]),
											_List_fromArray(
												[
													A4(
													$author$project$View$Components$dateViewer,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('text-black')
														]),
													$elm$core$Basics$identity,
													loggedIn.aM,
													$author$project$Utils$fromDateTime(t1.fu)),
													$elm$html$Html$text(' '),
													A4(
													$author$project$View$Components$dateViewer,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('text-gray-333')
														]),
													function (translations) {
														return _Utils_update(
															translations,
															{
																ow: '',
																pB: $elm$core$Maybe$Just('{{date}}'),
																pY: $elm$core$Maybe$Just('{{date}}')
															});
													},
													loggedIn.aM,
													$author$project$Utils$fromDateTime(t1.fu))
												]))
										]),
									A2(
										$elm$core$List$map,
										function (_v3) {
											var transfer = _v3.a;
											var profileSummary = _v3.b;
											return _List_fromArray(
												[
													A3($author$project$Page$Dashboard$viewTransfer, loggedIn, transfer, profileSummary),
													A2(
													$elm$html$Html$hr,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('mx-6 border-gray-100')
														]),
													_List_Nil)
												]);
										},
										A2($elm$core$List$cons, first, rest)))));
					},
					A2(
						$elm_community$list_extra$List$Extra$groupWhile,
						F2(
							function (_v0, _v1) {
								var t1 = _v0.a;
								var t2 = _v1.a;
								return A3(
									$author$project$Utils$areSameDay,
									loggedIn.aM.ll,
									$author$project$Utils$fromDateTime(t1.fu),
									$author$project$Utils$fromDateTime(t2.fu));
							}),
						transfers))));
	});
var $author$project$Page$Dashboard$viewTimelineCard = F3(
	function (loggedIn, isValidator, model) {
		var translators = loggedIn.aM.iw;
		var text_ = A2($elm$core$Basics$composeL, $elm$html$Html$text, translators.il);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('md:animate-fade-in-from-above-lg md:motion-reduce:animate-none', !loggedIn.fV),
							_Utils_Tuple2('md:animation-delay-300', (!loggedIn.fV) && isValidator),
							_Utils_Tuple2('md:animation-delay-150', (!loggedIn.fV) && (!isValidator))
						])),
					$elm$html$Html$Attributes$id('transfer-list-container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex justify-between items-center mt-6 mb-4 lg:mt-0')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h2,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-gray-333')
								]),
							_List_fromArray(
								[
									text_('transfer.transfers_latest'),
									$elm$html$Html$text(' '),
									A2(
									$elm$html$Html$strong,
									_List_Nil,
									_List_fromArray(
										[
											text_('transfer.transfers')
										]))
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('button button-secondary w-auto h-auto pl-4 flex'),
									$elm$html$Html$Events$onClick($author$project$Page$Dashboard$ClickedOpenTransferFilters)
								]),
							_List_fromArray(
								[
									text_('all_analysis.filter.title'),
									$author$project$Icons$arrowDown('fill-current')
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('bg-white rounded md:overflow-hidden')
						]),
					_List_fromArray(
						[
							function () {
							var _v0 = model.an;
							switch (_v0.$) {
								case 2:
									return A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-gray-900 text-sm py-20 px-6 text-center')
											]),
										_List_fromArray(
											[
												text_('transfer.loading_error')
											]));
								case 0:
									if (_v0.a.$ === 1) {
										var _v1 = _v0.a;
										return A2($author$project$View$Components$loadingLogoAnimated, translators, 'px-6 mb-8');
									} else {
										var transfers = _v0.a.a;
										return A5($author$project$Page$Dashboard$viewTransferList, loggedIn, model, transfers, $elm$core$Maybe$Nothing, true);
									}
								default:
									if (!_v0.a.b) {
										return A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('text-gray-900 text-sm py-20 px-6 text-center')
												]),
											_List_fromArray(
												[
													text_('transfer.no_transfers_yet')
												]));
									} else {
										var transfers = _v0.a;
										var maybePageInfo = _v0.b;
										return A5($author$project$Page$Dashboard$viewTransferList, loggedIn, model, transfers, maybePageInfo, false);
									}
							}
						}()
						]))
				]));
	});
var $author$project$Page$Dashboard$ClosedTransfersFilters = {$: 8};
var $author$project$Page$Dashboard$SubmittedTransfersFiltersForm = function (a) {
	return {$: 10, a: a};
};
var $author$project$Page$Dashboard$TransfersFilters = F3(
	function (date, direction, otherAccount) {
		return {c7: date, F: direction, dJ: otherAccount};
	});
var $author$project$Form$DatePicker = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Form$datePicker = F2(
	function (config, options) {
		return A2(
			$author$project$Form$field,
			$author$project$Form$DatePicker(options),
			{
				ab: config.ab,
				af: A2($elm$core$Basics$composeR, $author$project$Form$DatePicker$getDate, config.af),
				n: config.n,
				pO: config.pO
			});
	});
var $author$project$Cambiatus$Enum$TransferDirectionValue$fromString = function (enumString____) {
	switch (enumString____) {
		case 'RECEIVING':
			return $elm$core$Maybe$Just(0);
		case 'SENDING':
			return $elm$core$Maybe$Just(1);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Form$DatePicker$withAbsolutePositioning = F2(
	function (absolutePositioning, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{d5: absolutePositioning});
	});
var $author$project$Form$UserPicker$withMenuClass = F2(
	function (menuClass, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{dB: options.dB + (' ' + menuClass)});
	});
var $author$project$Form$UserPicker$withModalSelectors = F2(
	function (useModalSelectors, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				d9: !useModalSelectors,
				eW: useModalSelectors ? {
					dP: $elm$core$Maybe$Just('.modal-content'),
					gv: $elm$core$Maybe$Just('.modal-body')
				} : {dP: $elm$core$Maybe$Nothing, gv: $elm$core$Maybe$Nothing}
			});
	});
var $author$project$Page$Dashboard$transferFiltersForm = F2(
	function (loggedIn, users) {
		var _v0 = loggedIn.aM.iw;
		var t = _v0.il;
		return A2(
			$author$project$Form$with,
			$author$project$Form$introspect(
				function (_v1) {
					var direction = _v1.F;
					var directionText = function () {
						if (direction.$ === 1) {
							return 'transfer.direction.other_user';
						} else {
							if (!direction.a) {
								var _v3 = direction.a;
								return 'transfer.direction.user_who_sent';
							} else {
								var _v4 = direction.a;
								return 'transfer.direction.user_who_received';
							}
						}
					}();
					return A2(
						$author$project$Form$userPicker,
						{
							ab: $elm$core$Basics$always($elm$core$Maybe$Nothing),
							af: $elm$core$Result$Ok,
							n: F2(
								function (user, input) {
									return _Utils_update(
										input,
										{gM: user});
								}),
							pO: function ($) {
								return $.gM;
							}
						},
						A2(
							$author$project$Form$UserPicker$withModalSelectors,
							true,
							A2(
								$author$project$Form$UserPicker$withMenuClass,
								'max-h-44 overflow-y-auto !relative',
								$author$project$Form$UserPicker$init(
									{
										eo: loggedIn.lM,
										nC: t(directionText),
										eX: users
									}))));
				}),
			A2(
				$author$project$Form$with,
				A3(
					$author$project$Form$select,
					$author$project$Cambiatus$Enum$TransferDirectionValue$fromString,
					{
						ab: $elm$core$Basics$always($elm$core$Maybe$Nothing),
						af: $elm$core$Result$Ok,
						n: F2(
							function (direction, input) {
								return _Utils_update(
									input,
									{F: direction});
							}),
						pO: function ($) {
							return $.F;
						}
					},
					A2(
						$author$project$Form$Select$withContainerAttrs,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('mb-10')
							]),
						A3(
							$author$project$Form$Select$withOption,
							$elm$core$Maybe$Just(0),
							t('transfer.direction.receiving'),
							A3(
								$author$project$Form$Select$withOption,
								$elm$core$Maybe$Just(1),
								t('transfer.direction.sending'),
								A3(
									$author$project$Form$Select$withOption,
									$elm$core$Maybe$Nothing,
									t('transfer.direction.both'),
									$author$project$Form$Select$init(
										{
											R: 'transfer-filters-direction-select',
											nC: t('transfer.direction.title'),
											dG: A2(
												$elm$core$Basics$composeR,
												$elm$core$Maybe$map($author$project$Cambiatus$Enum$TransferDirectionValue$toString),
												$elm$core$Maybe$withDefault('BOTH'))
										})))))),
				A2(
					$author$project$Form$with,
					A2(
						$author$project$Form$datePicker,
						{
							ab: $elm$core$Basics$always($elm$core$Maybe$Nothing),
							af: $elm$core$Result$Ok,
							n: F2(
								function (date, input) {
									return _Utils_update(
										input,
										{c7: date});
								}),
							pO: function ($) {
								return $.c7;
							}
						},
						A2(
							$author$project$Form$DatePicker$withAbsolutePositioning,
							false,
							A2(
								$author$project$Form$DatePicker$withContainerAttrs,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('mb-10')
									]),
								$author$project$Form$DatePicker$init(
									{
										R: 'transfer-filters-date-picker',
										nC: t('payment_history.pick_date')
									})))),
					$author$project$Form$succeed($author$project$Page$Dashboard$TransfersFilters))));
	});
var $author$project$Page$Dashboard$viewTransferFilters = F3(
	function (loggedIn, users, model) {
		var shared = loggedIn.aM;
		var _v0 = shared.iw;
		var t = _v0.il;
		return $author$project$View$Modal$toHtml(
			A2(
				$author$project$View$Modal$withBody,
				_List_fromArray(
					[
						A6(
						$author$project$Form$view,
						_List_Nil,
						shared.iw,
						function (submitButton) {
							return _List_fromArray(
								[
									A2(
									submitButton,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('button button-primary w-full')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											t('all_analysis.filter.apply'))
										]))
								]);
						},
						A2($author$project$Page$Dashboard$transferFiltersForm, loggedIn, users),
						model.fh,
						{oq: $author$project$Page$Dashboard$SubmittedTransfersFiltersForm, pA: $author$project$Page$Dashboard$GotTransfersFiltersFormMsg})
					]),
				A2(
					$author$project$View$Modal$withHeader,
					t('all_analysis.filter.title'),
					$author$project$View$Modal$initWith(
						{i$: $author$project$Page$Dashboard$ClosedTransfersFilters, jW: model.cK}))));
	});
var $author$project$Page$Dashboard$CreateInvite = {$: 12};
var $author$project$View$Components$disablableLink = function (_v0) {
	var isDisabled = _v0.ns;
	return isDisabled ? $elm$html$Html$span : $elm$html$Html$a;
};
var $author$project$Icons$flagWithoutBackground = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('19'),
				$elm$svg$Svg$Attributes$height('20'),
				$elm$svg$Svg$Attributes$viewBox('0 0 19 20'),
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M15.9168 6.62927L18.2501 2.91707C18.5353 2.46401 18.5317 1.90851 18.2407 1.45845C17.9497 1.0084 17.4152 0.731624 16.8371 0.731707H1.62416C1.62416 0.327597 1.26058 0 0.81208 0C0.36358 0 0 0.327597 0 0.731707V19.2683C0 19.6724 0.36358 20 0.81208 20C1.26058 20 1.62416 19.6724 1.62416 19.2683V12.9268H16.783C17.3453 12.9261 17.8672 12.6634 18.1627 12.2323C18.4581 11.8012 18.4851 11.2631 18.2339 10.8098L15.9168 6.62927ZM1.6241 11.4634V2.19512H16.7829L14.0381 6.58536L16.745 11.4634H1.6241Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Icons$globe = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('24'),
				$elm$svg$Svg$Attributes$height('24'),
				$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M12 14C9.79086 14 8 12.2091 8 10C8 7.79086 9.79086 6 12 6C14.2091 6 16 7.79086 16 10C16 12.2091 14.2091 14 12 14Z'),
						$elm$svg$Svg$Attributes$stroke('currentColor'),
						$elm$svg$Svg$Attributes$strokeWidth('1.5'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round'),
						$elm$svg$Svg$Attributes$fill('none')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M17.25 16C16.4061 16.733 15.4181 17.2814 14.3497 17.61C13.2812 17.9385 12.1558 18.0399 11.0458 17.9076C9.93582 17.7754 8.86577 17.4124 7.9044 16.842C6.94303 16.2716 6.1116 15.5065 5.46353 14.5957C4.81545 13.6849 4.36507 12.6486 4.1413 11.5533C3.91753 10.4581 3.92534 9.32822 4.16421 8.2362C4.40308 7.14418 4.86774 6.1142 5.52833 5.21243C6.18892 4.31066 7.03084 3.55705 8 3'),
						$elm$svg$Svg$Attributes$stroke('currentColor'),
						$elm$svg$Svg$Attributes$strokeWidth('1.5'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round'),
						$elm$svg$Svg$Attributes$fill('none')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M12 18V22'),
						$elm$svg$Svg$Attributes$stroke('currentColor'),
						$elm$svg$Svg$Attributes$strokeWidth('1.5'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M16 22H8'),
						$elm$svg$Svg$Attributes$stroke('currentColor'),
						$elm$svg$Svg$Attributes$strokeWidth('1.5'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_Nil)
			]));
};
var $author$project$Icons$profile = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('32'),
				$elm$svg$Svg$Attributes$height('32'),
				$elm$svg$Svg$Attributes$viewBox('0 0 32 32'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M16 3C8.8203 3 3 8.8203 3 16C3 23.1797 8.8203 29 16 29C23.1797 29 29 23.1797 29 16C29 8.8203 23.1797 3 16 3ZM4.77273 16C4.77237 11.0828 7.9718 6.7375 12.6674 5.27792C17.363 3.81834 22.462 5.58413 25.2493 9.63505C28.0366 13.686 27.8635 19.0793 24.8223 22.9432C23.4677 20.9257 21.5024 19.3953 19.2145 18.5764C20.2033 17.518 20.7452 16.1187 20.7273 14.6705C20.7273 11.7159 18.6059 9.35227 16 9.35227C13.3941 9.35227 11.2727 11.7159 11.2727 14.6705C11.258 16.1704 11.8455 17.6136 12.9036 18.6768C10.5995 19.5039 8.65606 21.1088 7.40818 23.215C5.70471 21.197 4.77102 18.6409 4.77273 16ZM16.2955 18.0682C15.9717 18.0695 15.6483 18.0873 15.3264 18.1214C13.8883 17.5999 12.9616 16.1979 13.0455 14.6705C13.0455 12.7145 14.3691 11.125 16 11.125C17.6309 11.125 18.9545 12.7145 18.9545 14.6705C19.0274 16.1549 18.1558 17.5238 16.78 18.0859C16.6205 18.08 16.4609 18.0682 16.2955 18.0682ZM8.72 24.5682C10.0043 22.0608 12.4298 20.3365 15.22 19.9473C15.7952 20.0596 16.388 20.0455 16.9573 19.9059C19.7148 20.2783 22.1494 21.8941 23.5636 24.2905C19.3964 28.1368 13.0103 28.2562 8.70227 24.5682H8.72Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Icons$shop = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$class(class_),
				$elm$svg$Svg$Attributes$width('26'),
				$elm$svg$Svg$Attributes$height('26'),
				$elm$svg$Svg$Attributes$viewBox('0 0 26 26'),
				$elm$svg$Svg$Attributes$fill('none')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M24.1537 1.85143C23.8514 1.54952 23.3617 1.54952 23.0594 1.85143L21.6813 3.22956C21.5519 3.19346 21.4183 3.17438 21.2839 3.17278H13.4538C13.0433 3.17314 12.6497 3.33652 12.3596 3.62699L2.07785 13.9036C1.47405 14.5082 1.47405 15.4875 2.07785 16.0921L9.90788 23.9221C10.5124 24.5259 11.4918 24.5259 12.0964 23.9221L22.373 13.6455C22.6615 13.3546 22.823 12.9611 22.822 12.5513V4.72124C22.8204 4.58686 22.8013 4.45326 22.7652 4.3238L24.1434 2.94567C24.4481 2.64625 24.4528 2.15654 24.1537 1.85143ZM21.2787 12.5513L11.0021 22.8279L3.1721 14.9979L13.4539 4.72124H20.1896L17.8257 7.08522C17.4617 6.89131 17.0561 6.78858 16.6437 6.78585C15.2184 6.78585 14.0629 7.9413 14.0629 9.36662C14.0629 10.7919 15.2184 11.9474 16.6437 11.9474C18.069 11.9474 19.2244 10.7919 19.2244 9.36662C19.2201 8.95378 19.1156 8.54816 18.9199 8.18463L21.2839 5.82064L21.2787 12.5513ZM17.6657 9.36662C17.6657 9.93675 17.2035 10.3989 16.6333 10.3989C16.0632 10.3989 15.601 9.93675 15.601 9.36662C15.601 8.79649 16.0632 8.33431 16.6333 8.33431C16.908 8.33294 17.1719 8.4411 17.3666 8.63484C17.5613 8.82858 17.6708 9.09194 17.6708 9.36662H17.6657Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Page$Dashboard$viewWelcomeCard = F3(
	function (loggedIn, community, balance) {
		var shared = loggedIn.aM;
		var listItem = F6(
			function (icon, isDisabled, iconSize, description, element, attrs) {
				return A2(
					$elm$html$Html$li,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							element,
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$class('py-2 flex items-center w-full'),
								A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('group hover:text-orange-300 focus-visible:text-orange-300 focus-ring focus:ring-orange-300 focus:ring-opacity-50 focus:ring-offset-4 rounded-sm', !isDisabled),
												_Utils_Tuple2('text-gray-900', isDisabled)
											])),
									attrs)),
							_List_fromArray(
								[
									icon(iconSize + ' mr-4 text-gray-500 fill-current group-hover:text-orange-300 group-focus-visible:text-orange-300'),
									$elm$html$Html$text(description),
									$author$project$Icons$arrowDown('-rotate-90 ml-auto text-gray-900 fill-current group-hover:text-orange-300 group-focus-visible:text-orange-300')
								]))
						]));
			});
		var _v0 = shared.iw;
		var t = _v0.il;
		var tr = _v0.iu;
		var text_ = A2($elm$core$Basics$composeL, $elm$html$Html$text, t);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('relative'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('md:animate-fade-in-from-above-lg md:motion-reduce:animate-none', !loggedIn.fV)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-gray-333 mb-4 md:mb-7')
						]),
					_List_fromArray(
						[
							text_('menu.my_communities'),
							A2(
							$elm$html$Html$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(community.ki)
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('bg-white rounded flex flex-col pt-4 pb-2')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex flex-col px-4 pb-6 border-b border-gray-100')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-green text-xl font-bold text-center')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A3($author$project$Eos$formatSymbolAmount, shared.iw, balance.lY.e9, balance.lY.lU))
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-gray-900 text-sm font-bold uppercase text-center')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												tr,
												'dashboard.your_balance',
												_List_fromArray(
													[
														_Utils_Tuple2(
														'symbol',
														$author$project$Eos$symbolToSymbolCodeString(community.e9))
													])))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('flex space-x-4 mt-4')
										]),
									_List_fromArray(
										[
											A3(
											$author$project$View$Components$disablableLink,
											{ns: !loggedIn.mZ},
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('button button-primary w-full'),
													$elm$html$Html$Attributes$classList(
													_List_fromArray(
														[
															_Utils_Tuple2('button-disabled', !loggedIn.mZ)
														])),
													$author$project$Route$href(
													$author$project$Route$Transfer($elm$core$Maybe$Nothing))
												]),
											_List_fromArray(
												[
													text_('dashboard.transfer')
												]))
										]))
								])),
							A2(
							$elm$html$Html$ul,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('px-4 pt-2 divide-y divide-y-gray-100')
								]),
							_List_fromArray(
								[
									community.cl ? A6(
									listItem,
									$author$project$Icons$cambiatusCoin,
									!loggedIn.mZ,
									'w-5',
									A2(
										tr,
										'dashboard.how_to_earn',
										_List_fromArray(
											[
												_Utils_Tuple2(
												'symbol',
												$author$project$Eos$symbolToSymbolCodeString(community.e9))
											])),
									function (attrs) {
										return A2(
											$author$project$View$Components$disablableLink,
											{ns: !loggedIn.mZ},
											A2(
												$elm$core$List$cons,
												$author$project$Route$href(
													$author$project$Route$CommunityObjectives($author$project$Route$WithNoObjectiveSelected)),
												attrs));
									},
									_List_Nil) : $elm$html$Html$text(''),
									A6(
									listItem,
									$author$project$Icons$profile,
									!loggedIn.mZ,
									'w-5 h-5',
									t('dashboard.invite'),
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Events$onClick($author$project$Page$Dashboard$CreateInvite),
											$elm$html$Html$Attributes$disabled(!loggedIn.mZ),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('cursor-default', !loggedIn.mZ)
												]))
										])),
									community.cl ? A6(
									listItem,
									$author$project$Icons$flagWithoutBackground,
									false,
									'h-5',
									t('dashboard.my_claims'),
									$elm$html$Html$a,
									_List_fromArray(
										[
											$author$project$Route$href(
											$author$project$Route$ProfileClaims(
												$author$project$Eos$Account$nameToString(loggedIn.lM)))
										])) : $elm$html$Html$text(''),
									community.cm ? A6(
									listItem,
									$author$project$Icons$shop,
									false,
									'w-5 h-5',
									t('dashboard.my_offers'),
									$elm$html$Html$a,
									_List_fromArray(
										[
											$author$project$Route$href(
											$author$project$Route$Shop(
												{
													cX: _List_Nil,
													oy: $elm$core$Maybe$Just(loggedIn.lM)
												}))
										])) : $elm$html$Html$text(''),
									A6(
									listItem,
									$author$project$Icons$globe,
									false,
									'w-5 h-5',
									t('dashboard.about_community'),
									$elm$html$Html$a,
									_List_fromArray(
										[
											$author$project$Route$href($author$project$Route$CommunityAbout)
										]))
								]))
						])),
					A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('absolute -top-2 md:top-0 right-2 md:right-4'),
							$elm$html$Html$Attributes$alt(''),
							$elm$html$Html$Attributes$src('/images/success-doggo.svg')
						]),
					_List_Nil)
				]));
	});
var $author$project$Page$Dashboard$view = F2(
	function (loggedIn, model) {
		var shared = loggedIn.aM;
		var t = shared.iw.il;
		var content = function () {
			var _v0 = _Utils_Tuple2(model.b5, loggedIn.o7);
			switch (_v0.a.$) {
				case 1:
					var _v1 = _v0.a;
					return $author$project$Page$fullPageLoading(shared);
				case 0:
					var _v2 = _v0.a;
					return $author$project$Page$fullPageLoading(shared);
				case 2:
					var e = _v0.a.a;
					return A2(
						$author$project$Page$fullPageError,
						t('dashboard.sorry'),
						e);
				default:
					if ((!_v0.a.a.$) && (_v0.b.$ === 3)) {
						var balance = _v0.a.a.a;
						var community = _v0.b.a;
						var isExplicitValidator = A2(
							$elm$core$List$any,
							$elm$core$Basics$eq(loggedIn.lM),
							community.pN);
						var hasVerifyPermission = A2(
							$elm$core$List$member,
							7,
							$author$project$Session$LoggedIn$permissions(loggedIn));
						var hasAvailableClaims = function () {
							var _v3 = model.b2;
							if (_v3.$ === 1) {
								var count = _v3.a.mo;
								return count > 0;
							} else {
								return false;
							}
						}();
						var isValidator = isExplicitValidator || (hasVerifyPermission && hasAvailableClaims);
						return A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2($author$project$Page$Dashboard$viewAddressNote, shared, model),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('container mx-auto my-8 px-4 lg:grid lg:grid-cols-3 lg:gap-7')
										]),
									_List_fromArray(
										[
											(!loggedIn.mZ) ? A3(
											$author$project$Session$LoggedIn$viewFrozenAccountCard,
											shared.iw,
											{nu: false, og: $author$project$Page$Dashboard$ClickedAcceptCodeOfConduct},
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('mb-6 lg:mb-0 self-start')
												])) : $elm$html$Html$text(''),
											A3($author$project$Page$Dashboard$viewWelcomeCard, loggedIn, community, balance),
											(community.cl && (isValidator && loggedIn.mZ)) ? A2($author$project$Page$Dashboard$viewActionsForAnalysisCard, loggedIn, model) : $elm$html$Html$text(''),
											A3($author$project$Page$Dashboard$viewTimelineCard, loggedIn, community.cl && isValidator, model)
										])),
									A2($author$project$Page$Dashboard$viewInvitationModal, loggedIn, model),
									A2($author$project$Page$Dashboard$addContactModal, shared, model),
									A3($author$project$Page$Dashboard$viewTransferFilters, loggedIn, community.hG, model)
								]));
					} else {
						return A2(
							$author$project$Page$fullPageNotFound,
							t('dashboard.sorry'),
							'');
					}
			}
		}();
		return {
			mk: content,
			fb: t('menu.dashboard')
		};
	});
var $author$project$ReviewMoved$viewMovedContent = F2(
	function (_v0, apiUrl) {
		var t = _v0.il;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container mx-auto px-4 py-16 md:py-24 flex flex-col items-center text-center')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-2xl leading-tight font-bold text-black')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							t('review_moved.title'))
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mt-4 max-w-md text-gray-333')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							t('review_moved.body'))
						])),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id('review-moved-go'),
							$elm$html$Html$Attributes$href(
							A2($author$project$ReviewMoved$reviewUrl, apiUrl, $elm$core$Maybe$Nothing)),
							$elm$html$Html$Attributes$target('_self'),
							$elm$html$Html$Attributes$class('button button-primary w-full md:w-auto mt-8')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							t('review_moved.go'))
						])),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$author$project$Route$href($author$project$Route$Dashboard),
							$elm$html$Html$Attributes$class('button button-secondary w-full md:w-auto mt-4')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							t('admin_moved.back'))
						]))
				]));
	});
var $author$project$Page$Dashboard$Analysis$view = F2(
	function (_v0, _v1) {
		var shared = _v0.aM;
		return {
			mk: A2($author$project$ReviewMoved$viewMovedContent, shared.iw, shared.mJ.lW),
			fb: shared.iw.il('review_moved.title')
		};
	});
var $author$project$Page$Dashboard$Claim$ClaimMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Dashboard$Claim$ClaimerSummary = {$: 0};
var $author$project$Page$Dashboard$Claim$GotProfileSummaryMsg = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Claim$isValidator = F2(
	function (accountName, claim) {
		return A2(
			$elm$core$List$any,
			function (v) {
				return _Utils_eq(v.fl, accountName);
			},
			claim.iG.pN);
	});
var $author$project$Claim$canVote = F3(
	function (accountName, permissions, claim) {
		return A2($author$project$Claim$isValidator, accountName, claim) || ($elm$core$List$isEmpty(claim.iG.pN) && A2($elm$core$List$member, 7, permissions));
	});
var $author$project$Claim$isValidated = F2(
	function (claim, user) {
		return (!_Utils_eq(claim.gE, $author$project$Claim$Pending)) || A2(
			$elm$core$List$any,
			function (c) {
				return _Utils_eq(c.aE.fl, user);
			},
			claim.S);
	});
var $author$project$Claim$isVotable = F4(
	function (claim, accountName, permissions, now) {
		return A3($author$project$Claim$canVote, accountName, permissions, claim) && ((!_Utils_eq(claim.c$.fl, accountName)) && ((!A2($author$project$Claim$isValidated, claim, accountName)) && ((!A2($author$project$Action$isClosed, claim.iG, now)) && (!claim.iG.$7))));
	});
var $elm_community$string_extra$String$Extra$regexFromString = A2(
	$elm$core$Basics$composeR,
	$elm$regex$Regex$fromString,
	$elm$core$Maybe$withDefault($elm$regex$Regex$never));
var $elm_community$string_extra$String$Extra$softBreakRegexp = function (width) {
	return $elm_community$string_extra$String$Extra$regexFromString(
		'.{1,' + ($elm$core$String$fromInt(width) + '}(\\s+|$)|\\S+?(\\s+|$)'));
};
var $elm_community$string_extra$String$Extra$softEllipsis = F2(
	function (howLong, string) {
		return (_Utils_cmp(
			$elm$core$String$length(string),
			howLong) < 1) ? string : function (a) {
			return A2($elm$core$String$append, a, '...');
		}(
			A3(
				$elm$regex$Regex$replace,
				$elm_community$string_extra$String$Extra$regexFromString('([\\.,;:\\s])+$'),
				$elm$core$Basics$always(''),
				A2(
					$elm$core$String$join,
					'',
					A2(
						$elm$core$List$map,
						function ($) {
							return $.eK;
						},
						A3(
							$elm$regex$Regex$findAtMost,
							1,
							$elm_community$string_extra$String$Extra$softBreakRegexp(howLong),
							string)))));
	});
var $thaterikperson$elm_strftime$Strftime$abbreviatedMonth = F2(
	function (zone, time) {
		var _v0 = A2($elm$time$Time$toMonth, zone, time);
		switch (_v0) {
			case 0:
				return 'Jan';
			case 1:
				return 'Feb';
			case 2:
				return 'Mar';
			case 3:
				return 'Apr';
			case 4:
				return 'May';
			case 5:
				return 'Jun';
			case 6:
				return 'Jul';
			case 7:
				return 'Aug';
			case 8:
				return 'Sep';
			case 9:
				return 'Oct';
			case 10:
				return 'Nov';
			default:
				return 'Dec';
		}
	});
var $elm$time$Time$toWeekday = F2(
	function (zone, time) {
		var _v0 = A2(
			$elm$core$Basics$modBy,
			7,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60 * 24));
		switch (_v0) {
			case 0:
				return 3;
			case 1:
				return 4;
			case 2:
				return 5;
			case 3:
				return 6;
			case 4:
				return 0;
			case 5:
				return 1;
			default:
				return 2;
		}
	});
var $thaterikperson$elm_strftime$Strftime$abbreviatedWeekday = F2(
	function (zone, time) {
		var _v0 = A2($elm$time$Time$toWeekday, zone, time);
		switch (_v0) {
			case 0:
				return 'Mon';
			case 1:
				return 'Tue';
			case 2:
				return 'Wed';
			case 3:
				return 'Thu';
			case 4:
				return 'Fri';
			case 5:
				return 'Sat';
			default:
				return 'Sun';
		}
	});
var $elm$time$Time$toHour = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			24,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60));
	});
var $thaterikperson$elm_strftime$Strftime$amPmString = F2(
	function (zone, time) {
		return (A2($elm$time$Time$toHour, zone, time) > 11) ? 'PM' : 'AM';
	});
var $thaterikperson$elm_strftime$Strftime$fullMonth = F2(
	function (zone, time) {
		var _v0 = A2($elm$time$Time$toMonth, zone, time);
		switch (_v0) {
			case 0:
				return 'January';
			case 1:
				return 'February';
			case 2:
				return 'March';
			case 3:
				return 'April';
			case 4:
				return 'May';
			case 5:
				return 'June';
			case 6:
				return 'July';
			case 7:
				return 'August';
			case 8:
				return 'September';
			case 9:
				return 'October';
			case 10:
				return 'November';
			default:
				return 'December';
		}
	});
var $thaterikperson$elm_strftime$Strftime$fullWeekday = F2(
	function (zone, time) {
		var _v0 = A2($elm$time$Time$toWeekday, zone, time);
		switch (_v0) {
			case 0:
				return 'Monday';
			case 1:
				return 'Tuesday';
			case 2:
				return 'Wednesday';
			case 3:
				return 'Thursday';
			case 4:
				return 'Friday';
			case 5:
				return 'Saturday';
			default:
				return 'Sunday';
		}
	});
var $thaterikperson$elm_strftime$Strftime$numberWeekday = F2(
	function (zone, time) {
		var _v0 = A2($elm$time$Time$toWeekday, zone, time);
		switch (_v0) {
			case 6:
				return '0';
			case 0:
				return '1';
			case 1:
				return '2';
			case 2:
				return '3';
			case 3:
				return '4';
			case 4:
				return '5';
			default:
				return '6';
		}
	});
var $thaterikperson$elm_strftime$Strftime$numericMonth = F2(
	function (zone, time) {
		var _v0 = A2($elm$time$Time$toMonth, zone, time);
		switch (_v0) {
			case 0:
				return 1;
			case 1:
				return 2;
			case 2:
				return 3;
			case 3:
				return 4;
			case 4:
				return 5;
			case 5:
				return 6;
			case 6:
				return 7;
			case 7:
				return 8;
			case 8:
				return 9;
			case 9:
				return 10;
			case 10:
				return 11;
			default:
				return 12;
		}
	});
var $thaterikperson$elm_strftime$Strftime$regex = A2(
	$elm$core$Basics$composeR,
	$elm$regex$Regex$fromString,
	$elm$core$Maybe$withDefault($elm$regex$Regex$never));
var $elm$time$Time$toMinute = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2($elm$time$Time$toAdjustedMinutes, zone, time));
	});
var $elm$time$Time$toSecond = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				1000));
	});
var $thaterikperson$elm_strftime$Strftime$twentyFourHourToTwelveHour = function (hour) {
	return (!hour) ? 12 : ((hour > 12) ? (hour - 12) : hour);
};
var $thaterikperson$elm_strftime$Strftime$zeroPad = function (number) {
	return (number < 10) ? ('0' + $elm$core$String$fromInt(number)) : $elm$core$String$fromInt(number);
};
var $thaterikperson$elm_strftime$Strftime$format = F3(
	function (fmt, zone, time) {
		return A3(
			$elm$regex$Regex$replace,
			$thaterikperson$elm_strftime$Strftime$regex('%S'),
			function (_v19) {
				return $thaterikperson$elm_strftime$Strftime$zeroPad(
					A2($elm$time$Time$toSecond, zone, time));
			},
			A3(
				$elm$regex$Regex$replace,
				$thaterikperson$elm_strftime$Strftime$regex('%-S'),
				function (_v18) {
					return $elm$core$String$fromInt(
						A2($elm$time$Time$toSecond, zone, time));
				},
				A3(
					$elm$regex$Regex$replace,
					$thaterikperson$elm_strftime$Strftime$regex('%M'),
					function (_v17) {
						return $thaterikperson$elm_strftime$Strftime$zeroPad(
							A2($elm$time$Time$toMinute, zone, time));
					},
					A3(
						$elm$regex$Regex$replace,
						$thaterikperson$elm_strftime$Strftime$regex('%-M'),
						function (_v16) {
							return $elm$core$String$fromInt(
								A2($elm$time$Time$toMinute, zone, time));
						},
						A3(
							$elm$regex$Regex$replace,
							$thaterikperson$elm_strftime$Strftime$regex('%p'),
							function (_v15) {
								return A2($thaterikperson$elm_strftime$Strftime$amPmString, zone, time);
							},
							A3(
								$elm$regex$Regex$replace,
								$thaterikperson$elm_strftime$Strftime$regex('%I'),
								function (_v14) {
									return $thaterikperson$elm_strftime$Strftime$zeroPad(
										$thaterikperson$elm_strftime$Strftime$twentyFourHourToTwelveHour(
											A2($elm$time$Time$toHour, zone, time)));
								},
								A3(
									$elm$regex$Regex$replace,
									$thaterikperson$elm_strftime$Strftime$regex('%-I'),
									function (_v13) {
										return $elm$core$String$fromInt(
											$thaterikperson$elm_strftime$Strftime$twentyFourHourToTwelveHour(
												A2($elm$time$Time$toHour, zone, time)));
									},
									A3(
										$elm$regex$Regex$replace,
										$thaterikperson$elm_strftime$Strftime$regex('%H'),
										function (_v12) {
											return $thaterikperson$elm_strftime$Strftime$zeroPad(
												A2($elm$time$Time$toHour, zone, time));
										},
										A3(
											$elm$regex$Regex$replace,
											$thaterikperson$elm_strftime$Strftime$regex('%-H'),
											function (_v11) {
												return $elm$core$String$fromInt(
													A2($elm$time$Time$toHour, zone, time));
											},
											A3(
												$elm$regex$Regex$replace,
												$thaterikperson$elm_strftime$Strftime$regex('%Y'),
												function (_v10) {
													return $elm$core$String$fromInt(
														A2($elm$time$Time$toYear, zone, time));
												},
												A3(
													$elm$regex$Regex$replace,
													$thaterikperson$elm_strftime$Strftime$regex('%y'),
													function (_v9) {
														return A2(
															$elm$core$String$right,
															2,
															$elm$core$String$fromInt(
																A2($elm$time$Time$toYear, zone, time)));
													},
													A3(
														$elm$regex$Regex$replace,
														$thaterikperson$elm_strftime$Strftime$regex('%d'),
														function (_v8) {
															return $thaterikperson$elm_strftime$Strftime$zeroPad(
																A2($elm$time$Time$toDay, zone, time));
														},
														A3(
															$elm$regex$Regex$replace,
															$thaterikperson$elm_strftime$Strftime$regex('%-d'),
															function (_v7) {
																return $elm$core$String$fromInt(
																	A2($elm$time$Time$toDay, zone, time));
															},
															A3(
																$elm$regex$Regex$replace,
																$thaterikperson$elm_strftime$Strftime$regex('%w'),
																function (_v6) {
																	return A2($thaterikperson$elm_strftime$Strftime$numberWeekday, zone, time);
																},
																A3(
																	$elm$regex$Regex$replace,
																	$thaterikperson$elm_strftime$Strftime$regex('%A'),
																	function (_v5) {
																		return A2($thaterikperson$elm_strftime$Strftime$fullWeekday, zone, time);
																	},
																	A3(
																		$elm$regex$Regex$replace,
																		$thaterikperson$elm_strftime$Strftime$regex('%a'),
																		function (_v4) {
																			return A2($thaterikperson$elm_strftime$Strftime$abbreviatedWeekday, zone, time);
																		},
																		A3(
																			$elm$regex$Regex$replace,
																			$thaterikperson$elm_strftime$Strftime$regex('%m'),
																			function (_v3) {
																				return $thaterikperson$elm_strftime$Strftime$zeroPad(
																					A2($thaterikperson$elm_strftime$Strftime$numericMonth, zone, time));
																			},
																			A3(
																				$elm$regex$Regex$replace,
																				$thaterikperson$elm_strftime$Strftime$regex('%-m'),
																				function (_v2) {
																					return $elm$core$String$fromInt(
																						A2($thaterikperson$elm_strftime$Strftime$numericMonth, zone, time));
																				},
																				A3(
																					$elm$regex$Regex$replace,
																					$thaterikperson$elm_strftime$Strftime$regex('%B'),
																					function (_v1) {
																						return A2($thaterikperson$elm_strftime$Strftime$fullMonth, zone, time);
																					},
																					A3(
																						$elm$regex$Regex$replace,
																						$thaterikperson$elm_strftime$Strftime$regex('%b'),
																						function (_v0) {
																							return A2($thaterikperson$elm_strftime$Strftime$abbreviatedMonth, zone, time);
																						},
																						fmt))))))))))))))))))));
	});
var $author$project$Claim$viewVotingProgress = F2(
	function (shared, completionStatus) {
		var votingLeft = (completionStatus.pP - completionStatus.ao) - completionStatus.as;
		var totalVotes = completionStatus.pP;
		var disapprovedWidth = (completionStatus.as / totalVotes) * 100;
		var approvedWidth = (completionStatus.ao / totalVotes) * 100;
		var _v0 = shared.iw;
		var t = _v0.il;
		var viewVotesBar = function () {
			var _v2 = completionStatus.eg;
			switch (_v2.$) {
				case 2:
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('flex')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('w-full text-right text-gray-600')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												t('claim.pending'))
											]))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('w-full h-2 bg-gray-500 flex rounded-full my-2')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('flex rounded-full overflow-hidden h-2'),
												A2(
												$elm$html$Html$Attributes$style,
												'width',
												$elm$core$String$fromFloat(approvedWidth + disapprovedWidth) + '%')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('bg-green'),
														A2(
														$elm$html$Html$Attributes$style,
														'width',
														$elm$core$String$fromFloat((completionStatus.ao / (completionStatus.ao + completionStatus.as)) * 100) + '%')
													]),
												_List_Nil),
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('bg-red'),
														A2(
														$elm$html$Html$Attributes$style,
														'width',
														$elm$core$String$fromFloat((completionStatus.as / (completionStatus.ao + completionStatus.as)) * 100) + '%')
													]),
												_List_Nil)
											]))
									]))
							]));
				case 3:
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('flex')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('w-full text-right text-gray-600')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												t('claim.cancelled'))
											]))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('w-full h-2 flex bg-gray-500 rounded-full my-2')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('flex rounded-full bg-gray-900 h-2'),
												A2(
												$elm$html$Html$Attributes$style,
												'width',
												$elm$core$String$fromFloat(approvedWidth + disapprovedWidth) + '%')
											]),
										_List_Nil)
									]))
							]));
				case 0:
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('w-full text-right text-green')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										t('claim.approved'))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('w-full h-2 bg-green flex rounded-full my-2')
									]),
								_List_Nil)
							]));
				default:
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('w-full text-right text-red')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										t('claim.disapproved'))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('w-full h-2 bg-red flex rounded-full my-2')
									]),
								_List_Nil)
							]));
			}
		}();
		var voteNumberTitleConditional = function (compStatus) {
			return (compStatus === 1) ? $elm$html$Html$text(
				t('claim.vote')) : $elm$html$Html$text(
				t('claim.votes'));
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-col mb-4')
				]),
			_List_fromArray(
				[
					viewVotesBar,
					function () {
					var _v1 = completionStatus.eg;
					switch (_v1.$) {
						case 0:
							return A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('ml-auto text-green text-right')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('font-bold mr-2')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$elm$core$String$fromInt(completionStatus.ao))
											])),
										A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												voteNumberTitleConditional(completionStatus.ao)
											]))
									]));
						case 1:
							return A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('ml-auto text-red text-right')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('font-bold mr-2')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$elm$core$String$fromInt(completionStatus.as))
											])),
										A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												voteNumberTitleConditional(completionStatus.as)
											]))
									]));
						case 2:
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('flex')
									]),
								_List_fromArray(
									[
										(!completionStatus.ao) ? $elm$html$Html$text('') : A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$Attributes$style,
												'width',
												$elm$core$String$fromFloat(approvedWidth) + '%')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('font-bold text-green')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														$elm$core$String$fromInt(completionStatus.ao))
													]))
											])),
										(!completionStatus.as) ? $elm$html$Html$text('') : A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$Attributes$style,
												'width',
												$elm$core$String$fromFloat(disapprovedWidth) + '%')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('font-bold text-red')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														$elm$core$String$fromInt(completionStatus.as))
													]))
											])),
										A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('ml-auto text-gray-600 text-right')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('font-bold mr-2')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														$elm$core$String$fromInt(votingLeft))
													])),
												A2(
												$elm$html$Html$span,
												_List_Nil,
												_List_fromArray(
													[
														voteNumberTitleConditional(votingLeft)
													]))
											]))
									]));
						default:
							return A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('w-full text-gray-600 text-right space-x-1')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('font-bold')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$elm$core$String$fromInt(votingLeft))
											])),
										A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												t('claim.cancelled_voting_bar'))
											]))
									]));
					}
				}()
				]));
	});
var $author$project$Page$Dashboard$Claim$viewDetails = F3(
	function (_v0, _v1, claim) {
		var shared = _v0.aM;
		var text_ = function (s) {
			return $elm$html$Html$text(
				shared.iw.il(s));
		};
		var isRejected = _Utils_eq(claim.gE, $author$project$Claim$Rejected);
		var completionStatus = {
			ao: $elm$core$List$length(
				A2(
					$elm$core$List$filter,
					function ($) {
						return $.be;
					},
					claim.S)),
			eg: claim.gE,
			as: $elm$core$List$length(
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeL,
						$elm$core$Basics$not,
						function ($) {
							return $.be;
						}),
					claim.S)),
			pP: claim.iG.pP
		};
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$Claim$viewVotingProgress, shared, completionStatus),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mb-8')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('label')
								]),
							_List_fromArray(
								[
									text_('claim.action')
								])),
							A2(
							$author$project$Markdown$view,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mb-2')
								]),
							claim.iG.bc),
							claim.iG.$7 ? A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex mb-2')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('tag bg-green')
										]),
									_List_fromArray(
										[
											text_('community.actions.completed')
										]))
								])) : (A2($author$project$Action$isClosed, claim.iG, shared.gh) ? A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex mb-2')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('tag bg-gray-500 text-red')
										]),
									_List_fromArray(
										[
											text_('community.actions.closed')
										]))
								])) : $elm$html$Html$text(''))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mb-8')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex justify-between lg:justify-start')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('mr-6')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('label')
												]),
											_List_fromArray(
												[
													text_('claim.date')
												])),
											A2(
											$elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													A3(
														$thaterikperson$elm_strftime$Strftime$format,
														'%d %b %Y %H:%M',
														shared.ll,
														$author$project$Utils$fromDateTime(claim.fG)))
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('label')
												]),
											_List_fromArray(
												[
													text_('claim.claimer_reward')
												])),
											A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$classList(
													_List_fromArray(
														[
															_Utils_Tuple2('text-red line-through', isRejected)
														]))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$elm$core$String$fromFloat(claim.iG.h7) + (' ' + $author$project$Eos$symbolToSymbolCodeString(claim.iG.bi.b9.e9)))
												]))
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mb-8')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('label')
								]),
							_List_fromArray(
								[
									text_('claim.objective')
								])),
							A2($author$project$Markdown$view, _List_Nil, claim.iG.bi.bc)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mb-8')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('label')
								]),
							_List_fromArray(
								[
									text_('claim.your_reward')
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromFloat(claim.iG.pQ) + (' ' + $author$project$Eos$symbolToSymbolCodeString(claim.iG.bi.b9.e9)))
								]))
						]))
				]));
	});
var $author$project$Claim$CloseClaimModals = {$: 0};
var $author$project$ReviewMoved$viewClaimCta = F4(
	function (_v0, apiUrl, claimId, attributes) {
		var t = _v0.il;
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('flex flex-col items-center text-center'),
				attributes),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-gray-333 mb-2')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							t('review_moved.body'))
						])),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id(
							'vote-in-new-app-' + $elm$core$String$fromInt(claimId)),
							$elm$html$Html$Attributes$href(
							A2(
								$author$project$ReviewMoved$reviewUrl,
								apiUrl,
								$elm$core$Maybe$Just(claimId))),
							$elm$html$Html$Attributes$target('_self'),
							$elm$html$Html$Attributes$class('button button-primary w-full')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							t('review_moved.go'))
						]))
				]));
	});
var $author$project$Claim$viewPhotoModal = F2(
	function (loggedIn, claim) {
		var withPhotoModalFooter = A4(
			$author$project$Claim$isVotable,
			claim,
			loggedIn.lM,
			$author$project$Session$LoggedIn$permissions(loggedIn),
			loggedIn.aM.gh) ? $author$project$View$Modal$withFooter(
			_List_fromArray(
				[
					A4($author$project$ReviewMoved$viewClaimCta, loggedIn.aM.iw, loggedIn.aM.mJ.lW, claim.R, _List_Nil)
				])) : $elm$core$Basics$identity;
		var _v0 = loggedIn.aM.iw;
		var t = _v0.il;
		var body = _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('md:flex md:justify-start md:space-x-4')
					]),
				_List_fromArray(
					[
						function () {
						var _v1 = claim.eY;
						if (!_v1.$) {
							var url = _v1.a;
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('sm:w-1/2')
									]),
								_List_fromArray(
									[
										A2(
										$author$project$View$Components$pdfViewer,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('min-h-[100px] max-h-[42vh] rounded-sm')
											]),
										{
											g$: 'max-w-full max-h-full',
											hF: $elm$core$Maybe$Just(loggedIn.aM.iw),
											hW: $elm$core$Maybe$Nothing,
											gL: url
										}),
										A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('underline inline-block py-1 text-gray'),
												$elm$html$Html$Attributes$href(url),
												$elm$html$Html$Attributes$target('_blank')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												t('community.actions.proof.upload_full')),
												$author$project$Icons$externalLink('inline-block ml-1 h-3 fill-current')
											]))
									]));
						} else {
							return $elm$html$Html$text('');
						}
					}(),
						function () {
						var _v2 = claim.h4;
						if (!_v2.$) {
							var proofCode = _v2.a;
							return A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('mt-4 md:mt-0 label md:text-xl block')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												t('community.actions.form.verification_code'))
											])),
										A2(
										$elm$html$Html$strong,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-xl md:text-3xl')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(proofCode)
											]))
									]));
						} else {
							return $elm$html$Html$text('');
						}
					}()
					]))
			]);
		return $author$project$View$Modal$toHtml(
			withPhotoModalFooter(
				A2(
					$author$project$View$Modal$withBody,
					body,
					A2(
						$author$project$View$Modal$withHeader,
						t('dashboard.claim'),
						$author$project$View$Modal$initWith(
							{i$: $author$project$Claim$CloseClaimModals, jW: true})))));
	});
var $author$project$Claim$OpenPhotoModal = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Dashboard$Claim$viewProofs = F2(
	function (_v0, claim) {
		var t = _v0.il;
		var viewProofCode = function () {
			var _v2 = claim.h4;
			if (!_v2.$) {
				var proofCode = _v2.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('ml-4')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('label')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('community.actions.form.verification_code'))
								])),
							A2(
							$elm$html$Html$strong,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-lg block')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(proofCode)
								]))
						]));
			} else {
				return $elm$html$Html$text('');
			}
		}();
		var _v1 = claim.eY;
		if (!_v1.$) {
			var url = _v1.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mb-8 flex')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('claim-photo-thumb')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$View$Components$pdfViewer,
								_List_fromArray(
									[
										$elm$html$Html$Events$onClick(
										$author$project$Page$Dashboard$Claim$ClaimMsg(
											$author$project$Claim$OpenPhotoModal(claim))),
										$elm$html$Html$Attributes$class('h-full w-full')
									]),
								{g$: 'max-w-full max-h-full', hF: $elm$core$Maybe$Nothing, hW: $elm$core$Maybe$Nothing, gL: url})
							])),
						viewProofCode
					]));
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Page$Dashboard$Claim$viewTitle = F3(
	function (shared, _v0, claim) {
		var text_ = function (s) {
			return $elm$html$Html$text(
				shared.iw.il(s));
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-lg font-bold text-center mb-4')
				]),
			_List_fromArray(
				[
					function () {
					var _v1 = claim.gE;
					switch (_v1.$) {
						case 0:
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('inline-block')
									]),
								_List_fromArray(
									[
										text_('claim.title_approved.1'),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-green ml-1')
											]),
										_List_fromArray(
											[
												text_('claim.title_approved.2')
											]))
									]));
						case 3:
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('inline-block')
									]),
								_List_fromArray(
									[
										text_('claim.title_action_completed')
									]));
						case 1:
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('inline-block')
									]),
								_List_fromArray(
									[
										text_('claim.title_rejected.1'),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-red ml-1')
											]),
										_List_fromArray(
											[
												text_('claim.title_rejected.2')
											]))
									]));
						default:
							return A2($author$project$Action$isClosed, claim.iG, shared.gh) ? A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('inline-block')
									]),
								_List_fromArray(
									[
										text_('claim.title_action_closed')
									])) : A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('inline-block')
									]),
								_List_fromArray(
									[
										text_('claim.title_under_review.1'),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-gray ml-1')
											]),
										_List_fromArray(
											[
												text_('claim.title_under_review.2')
											])),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('mr-1')
											]),
										_List_fromArray(
											[
												text_('claim.title_under_review.3')
											]))
									]));
					}
				}()
				]));
	});
var $author$project$Page$Dashboard$Claim$viewVoteMoved = F2(
	function (loggedIn, claimId) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mb-8 border-t pt-8 mx-auto container px-4 sm:max-w-md')
				]),
			_List_fromArray(
				[
					A4($author$project$ReviewMoved$viewClaimCta, loggedIn.aM.iw, loggedIn.aM.mJ.lW, claimId, _List_Nil)
				]));
	});
var $author$project$Page$Dashboard$Claim$PendingSummary = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Dashboard$Claim$VoterSummary = function (a) {
	return {$: 2, a: a};
};
var $author$project$Claim$hidesValidatorNames = F3(
	function (communityHidesNames, viewer, claim) {
		return communityHidesNames && _Utils_eq(claim.c$.fl, viewer);
	});
var $elm$core$List$map3 = _List_map3;
var $author$project$Profile$viewEmpty = function (translators) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('uppercase text-gray-900 text-sm')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						translators.il('profile.no_one'))
					]))
			]));
};
var $author$project$Claim$viewHiddenValidator = function (_v0) {
	var t = _v0.il;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex items-center')
			]),
		_List_fromArray(
			[
				A2($author$project$Avatar$view, $author$project$Avatar$empty, 'h-10 w-10'),
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('ml-2 text-gray-900')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						t('claim.a_validator'))
					]))
			]));
};
var $author$project$Page$Dashboard$Claim$viewVoters = F3(
	function (loggedIn, profileSummaries, claim) {
		var shared = loggedIn.aM;
		var text_ = function (s) {
			return $elm$html$Html$text(
				shared.iw.il(s));
		};
		var hideValidators = function () {
			var _v0 = loggedIn.o7;
			if (_v0.$ === 3) {
				var community = _v0.a;
				return A3($author$project$Claim$hidesValidatorNames, community.m6, loggedIn.lM, claim);
			} else {
				return false;
			}
		}();
		var viewValidator = F3(
			function (validator, profileSummary, msg) {
				return hideValidators ? $author$project$Claim$viewHiddenValidator(shared.iw) : A2(
					$elm$html$Html$map,
					msg,
					A4($author$project$Profile$Summary$view, shared.iw, loggedIn.lM, validator, profileSummary));
			});
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mb-8')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('label')
								]),
							_List_fromArray(
								[
									text_('claim.approved_by')
								])),
							$elm$core$List$isEmpty(claim.S) ? A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex mb-10')
								]),
							_List_fromArray(
								[
									$author$project$Profile$viewEmpty(shared.iw)
								])) : A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex flex-wrap -mx-2')
								]),
							A4(
								$elm$core$List$map3,
								F3(
									function (profileSummary, index, c) {
										return c.be ? A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('px-2')
												]),
											_List_fromArray(
												[
													A3(
													viewValidator,
													c.aE,
													profileSummary,
													$author$project$Page$Dashboard$Claim$GotProfileSummaryMsg(
														$author$project$Page$Dashboard$Claim$VoterSummary(index)))
												])) : $elm$html$Html$text('');
									}),
								profileSummaries.b$,
								A2(
									$elm$core$List$range,
									0,
									$elm$core$List$length(profileSummaries.b$)),
								claim.S))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mb-8')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('label')
								]),
							_List_fromArray(
								[
									text_('claim.disapproved_by')
								])),
							$elm$core$List$isEmpty(
							A2(
								$elm$core$List$filter,
								function (check) {
									return !check.be;
								},
								claim.S)) ? A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex mb-10')
								]),
							_List_fromArray(
								[
									$author$project$Profile$viewEmpty(shared.iw)
								])) : A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex flex-wrap mb-10 -mx-2 pt-2')
								]),
							A4(
								$elm$core$List$map3,
								F3(
									function (profileSummary, index, c) {
										return (!c.be) ? A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('px-2')
												]),
											_List_fromArray(
												[
													A3(
													viewValidator,
													c.aE,
													profileSummary,
													$author$project$Page$Dashboard$Claim$GotProfileSummaryMsg(
														$author$project$Page$Dashboard$Claim$VoterSummary(index)))
												])) : $elm$html$Html$text('');
									}),
								profileSummaries.b$,
								A2(
									$elm$core$List$range,
									0,
									$elm$core$List$length(profileSummaries.b$)),
								claim.S))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mb-8')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('label')
								]),
							_List_fromArray(
								[
									text_('claim.pending')
								])),
							_Utils_eq(
							$elm$core$List$length(claim.S),
							claim.iG.pP) ? A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex')
								]),
							_List_fromArray(
								[
									$author$project$Profile$viewEmpty(shared.iw)
								])) : A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex flex-row flex-wrap space-x-6')
								]),
							A4(
								$elm$core$List$map3,
								F3(
									function (profileSummary, index, v) {
										return A3(
											viewValidator,
											v,
											profileSummary,
											$author$project$Page$Dashboard$Claim$GotProfileSummaryMsg(
												$author$project$Page$Dashboard$Claim$PendingSummary(index)));
									}),
								profileSummaries.dK,
								A2(
									$elm$core$List$range,
									0,
									$elm$core$List$length(profileSummaries.dK)),
								$author$project$Page$Dashboard$Claim$pendingValidators(claim)))
						]))
				]));
	});
var $author$project$Page$Dashboard$Claim$view = F2(
	function (loggedIn, model) {
		var shared = loggedIn.aM;
		var title = function () {
			var _v4 = model.a9;
			if (_v4.$ === 1) {
				var claim = _v4.a;
				return A2(
					$elm_community$string_extra$String$Extra$softEllipsis,
					20,
					$author$project$Markdown$toUnformattedString(claim.iG.bc));
			} else {
				return '';
			}
		}();
		var _v0 = shared.iw;
		var t = _v0.il;
		var content = A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					function () {
					var _v2 = model.a9;
					switch (_v2.$) {
						case 0:
							return $author$project$Page$fullPageLoading(shared);
						case 1:
							var claim = _v2.a;
							var profileSummaries = _v2.b;
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('bg-gray-100')
									]),
								_List_fromArray(
									[
										A2($author$project$Page$viewHeader, loggedIn, title),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('mt-10 mb-8 flex items-center justify-center')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Page$Dashboard$Claim$GotProfileSummaryMsg($author$project$Page$Dashboard$Claim$ClaimerSummary),
												A4($author$project$Profile$Summary$view, shared.iw, loggedIn.lM, claim.c$, profileSummaries.c$))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('mx-auto container px-4')
											]),
										_List_fromArray(
											[
												A3($author$project$Page$Dashboard$Claim$viewTitle, shared, model, claim),
												A2($author$project$Page$Dashboard$Claim$viewProofs, shared.iw, claim),
												A3($author$project$Page$Dashboard$Claim$viewDetails, loggedIn, model, claim),
												A3($author$project$Page$Dashboard$Claim$viewVoters, loggedIn, profileSummaries, claim)
											])),
										function () {
										var _v3 = model.iZ;
										if (!_v3.$) {
											var c = _v3.a;
											return A2(
												$elm$html$Html$map,
												$author$project$Page$Dashboard$Claim$ClaimMsg,
												A2($author$project$Claim$viewPhotoModal, loggedIn, c));
										} else {
											return A4(
												$author$project$Claim$isVotable,
												claim,
												loggedIn.lM,
												$author$project$Session$LoggedIn$permissions(loggedIn),
												shared.gh) ? A2($author$project$Page$Dashboard$Claim$viewVoteMoved, loggedIn, claim.R) : $elm$html$Html$text('');
										}
									}()
									]));
						default:
							var err = _v2.a;
							return A2(
								$author$project$Page$fullPageGraphQLError,
								t('error.unknown'),
								err);
					}
				}()
				]));
		return {
			mk: function () {
				var _v1 = A2(
					$krisajenkins$remotedata$RemoteData$map,
					function ($) {
						return $.cl;
					},
					loggedIn.o7);
				switch (_v1.$) {
					case 3:
						if (_v1.a) {
							return content;
						} else {
							return A2(
								$author$project$Page$fullPageNotFound,
								t('error.pageNotFound'),
								t('community.objectives.disabled.description'));
						}
					case 1:
						return $author$project$Page$fullPageLoading(shared);
					case 0:
						return $author$project$Page$fullPageLoading(shared);
					default:
						var e = _v1.a;
						return A2(
							$author$project$Page$fullPageGraphQLError,
							t('community.error_loading'),
							e);
				}
			}(),
			fb: title
		};
	});
var $author$project$Page$Join$viewLoading = function (shared) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex flex-col flex-grow items-center md:justify-center')
			]),
		_List_fromArray(
			[
				A2($author$project$View$Components$loadingLogoAnimated, shared.iw, '')
			]));
};
var $author$project$Page$Join$ClickedJoinCommunity = {$: 0};
var $author$project$Community$communityPreviewImage = F3(
	function (isLeftSide, _v0, community) {
		var translators = _v0.iw;
		var defaultImage = isLeftSide ? '/images/community-bg-desktop.svg' : '/images/community-bg-mobile.svg';
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('relative'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('md:hidden w-full', !isLeftSide),
							_Utils_Tuple2('w-1/2 flex-grow hidden md:block', isLeftSide)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('bg-black')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('w-full opacity-60'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('h-screen object-cover', isLeftSide),
											_Utils_Tuple2('min-h-25 max-h-108', !isLeftSide)
										])),
									$elm$html$Html$Attributes$src(
									A2(
										$elm$core$Maybe$withDefault,
										defaultImage,
										$elm$core$List$head(community.bs)))
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('absolute inset-0 flex flex-col items-center justify-center text-white uppercase px-5')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('font-bold text-lg')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(community.ki)
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('font-bold text-sm mt-4')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										translators.iu,
										'community.join.member_count',
										_List_fromArray(
											[
												_Utils_Tuple2(
												'member_count',
												$elm$core$String$fromInt(community.gc))
											])))
								]))
						]))
				]));
	});
var $author$project$Page$Join$view_ = F4(
	function (isGuest, shared, community, model) {
		var translators = shared.iw;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bg-purple-500 flex-grow flex flex-col md:justify-center items-center p-4 lg:p-0'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('w-1/2', !isGuest)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('bg-white rounded-b md:rounded w-full lg:w-4/5 xl:w-7/12')
						]),
					_List_fromArray(
						[
							A3($author$project$Community$communityPreviewImage, false, shared, community),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('p-4')
								]),
							A2(
								$elm$core$List$cons,
								A2(
									$author$project$Markdown$view,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-gray-333 block mb-7')
										]),
									community.bc),
								_Utils_ap(
									community.cj ? _List_fromArray(
										[
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('button button-primary w-full cursor-pointer'),
													$elm$html$Html$Events$onClick($author$project$Page$Join$ClickedJoinCommunity)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													A2(
														translators.iu,
														'community.join.title_with_community',
														_List_fromArray(
															[
																_Utils_Tuple2('community_name', community.ki)
															])))
												]))
										]) : _List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('block text-center text-black font-bold')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													translators.il('community.join.only_invited'))
												])),
											A2(
											$elm$html$Html$a,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('button button-primary w-full mt-4'),
													$author$project$Route$href(
													A2($author$project$Route$Login, $elm$core$Maybe$Nothing, model.j9))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													translators.il('community.join.already_member'))
												]))
										]),
									function () {
										var _v0 = community.cQ;
										if (_v0.$ === 1) {
											return _List_fromArray(
												[
													$elm$html$Html$text('')
												]);
										} else {
											var website = _v0.a;
											return _List_fromArray(
												[
													A2(
													$elm$html$Html$a,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('button button-secondary w-full mt-4 cursor-pointer'),
															$elm$html$Html$Attributes$href(website)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															translators.il('community.join.visit_website'))
														]))
												]);
										}
									}())))
						]))
				]));
	});
var $author$project$Page$Join$viewAsGuest = F3(
	function (title, guest, model) {
		var _v0 = guest.b9;
		switch (_v0.$) {
			case 3:
				var communityPreview = _v0.a;
				return A4($author$project$Page$Join$view_, true, guest.aM, communityPreview, model);
			case 2:
				var err = _v0.a;
				return A2($author$project$Page$fullPageGraphQLError, title, err);
			default:
				return $author$project$Page$Join$viewLoading(guest.aM);
		}
	});
var $author$project$Page$Join$viewAsLoggedIn = F3(
	function (title, loggedIn, model) {
		var _v0 = A2(
			$author$project$Community$getField,
			loggedIn.o7,
			function ($) {
				return $.bs;
			});
		switch (_v0.$) {
			case 3:
				var _v1 = _v0.a;
				var community = _v1.a;
				var uploads = _v1.b;
				var normalizedCommunity = {bc: community.bc, cj: community.cj, gc: community.gc, ki: community.ki, bs: uploads, cQ: community.cQ};
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex-grow flex')
						]),
					_List_fromArray(
						[
							A3($author$project$Community$communityPreviewImage, true, loggedIn.aM, normalizedCommunity),
							A4($author$project$Page$Join$view_, false, loggedIn.aM, normalizedCommunity, model)
						]));
			case 2:
				if (!_v0.a.$) {
					var err = _v0.a.a;
					return A2($author$project$Page$fullPageGraphQLError, title, err);
				} else {
					var err = _v0.a.a;
					return A2($author$project$Page$fullPageGraphQLError, title, err);
				}
			case 1:
				return $author$project$Page$Join$viewLoading(loggedIn.aM);
			default:
				return $author$project$Page$Join$viewLoading(loggedIn.aM);
		}
	});
var $author$project$Page$Join$view = F2(
	function (session, model) {
		var maybeCommunityName = function () {
			if (!session.$) {
				var guest = session.a;
				return $krisajenkins$remotedata$RemoteData$toMaybe(
					A2(
						$krisajenkins$remotedata$RemoteData$map,
						function ($) {
							return $.ki;
						},
						guest.b9));
			} else {
				var loggedIn = session.a;
				return $krisajenkins$remotedata$RemoteData$toMaybe(
					A2(
						$krisajenkins$remotedata$RemoteData$map,
						function ($) {
							return $.ki;
						},
						loggedIn.o7));
			}
		}();
		var _v0 = $author$project$Page$toShared(session);
		var translators = _v0.iw;
		var title = function () {
			if (maybeCommunityName.$ === 1) {
				return translators.il('community.join.title_generic');
			} else {
				var name = maybeCommunityName.a;
				return A2(
					translators.iu,
					'community.join.title_with_community',
					_List_fromArray(
						[
							_Utils_Tuple2('community_name', name)
						]));
			}
		}();
		var content = function () {
			if (!session.$) {
				var guest = session.a;
				return A3($author$project$Page$Join$viewAsGuest, title, guest, model);
			} else {
				var loggedIn = session.a;
				return A3($author$project$Page$Join$viewAsLoggedIn, title, loggedIn, model);
			}
		}();
		return {mk: content, fb: title};
	});
var $author$project$Page$Login$ClickedNextStep = function (a) {
	return {$: 5, a: a};
};
var $author$project$Form$isShowingAllErrors = function (_v0) {
	var model = _v0;
	var _v1 = model.aG;
	var errorTracking = _v1;
	return errorTracking.e2;
};
var $author$project$Form$Text$CountWords = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Login$ScrolledTextArea = function (a) {
	return {$: 3, a: a};
};
var $elm$html$Html$Attributes$autofocus = $elm$html$Html$Attributes$boolProperty('autofocus');
var $author$project$Page$Login$Passphrase = $elm$core$Basics$identity;
var $author$project$Page$Login$passphraseValidator = function (maybeBip39Wordlist) {
	var wordsHave3Letters = function (passphrase) {
		return A2(
			$elm$core$List$all,
			function (word) {
				return $elm$core$String$length(word) > 2;
			},
			$elm$core$String$words(passphrase)) ? $elm$core$Result$Ok(passphrase) : $elm$core$Result$Err(
			function (translators_) {
				return translators_.il('auth.login.wordsMode.input.atLeastThreeLettersError');
			});
	};
	var isBip39 = function (passphrase) {
		if (maybeBip39Wordlist.$ === 1) {
			return $elm$core$Result$Ok(passphrase);
		} else {
			var bip39Wordlist = maybeBip39Wordlist.a;
			var _v1 = A2(
				$elm$core$List$filter,
				function (word) {
					return (!A2($elm$core$Set$member, word, bip39Wordlist.fL)) && ((!A2($elm$core$Set$member, word, bip39Wordlist.gn)) && (!A2($elm$core$Set$member, word, bip39Wordlist.gD)));
				},
				$elm$core$String$words(passphrase));
			if (_v1.b) {
				if (!_v1.b.b) {
					var firstWord = _v1.a;
					return $elm$core$Result$Err(
						function (translators_) {
							return A2(
								translators_.iu,
								'auth.login.wordsMode.input.invalid_word',
								_List_fromArray(
									[
										_Utils_Tuple2('word', firstWord)
									]));
						});
				} else {
					var firstWord = _v1.a;
					var otherWords = _v1.b;
					return $elm$core$Result$Err(
						function (translators_) {
							return A2(
								translators_.iu,
								'auth.login.wordsMode.input.invalid_words',
								_List_fromArray(
									[
										_Utils_Tuple2(
										'words',
										A2(
											$elm$core$String$join,
											', ',
											A2($elm$core$List$cons, firstWord, otherWords)))
									]));
						});
				}
			} else {
				return $elm$core$Result$Ok(passphrase);
			}
		}
	};
	var has12Words = function (passphrase) {
		return ($elm$core$List$length(
			$elm$core$String$words(passphrase)) >= 12) ? $elm$core$Result$Ok(
			A2(
				$elm$core$String$join,
				' ',
				A2(
					$elm$core$List$take,
					12,
					$elm$core$String$words(passphrase)))) : $elm$core$Result$Err(
			function (translators_) {
				return translators_.il('auth.login.wordsMode.input.notPassphraseError');
			});
	};
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Form$Validate$map($elm$core$String$toLower),
		A2(
			$elm$core$Basics$composeR,
			$author$project$Form$Validate$custom(has12Words),
			A2(
				$elm$core$Basics$composeR,
				$author$project$Form$Validate$custom(wordsHave3Letters),
				A2(
					$elm$core$Basics$composeR,
					$author$project$Form$Validate$custom(isBip39),
					$author$project$Form$Validate$map($elm$core$Basics$identity)))));
};
var $elm$html$Html$Attributes$rows = function (n) {
	return A2(
		_VirtualDom_attribute,
		'rows',
		$elm$core$String$fromInt(n));
};
var $elm$html$Html$Attributes$spellcheck = $elm$html$Html$Attributes$boolProperty('spellcheck');
var $author$project$Page$Login$viewIllustration = function (fileName) {
	return A2(
		$elm$html$Html$img,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('h-40 mx-auto mb-6'),
				$elm$html$Html$Attributes$src('/images/' + fileName)
			]),
		_List_Nil);
};
var $author$project$Form$Text$withCounter = F2(
	function (counter, _v0) {
		var options = _v0;
		var _v1 = function () {
			if (!counter.$) {
				var maxLetters = counter.a;
				return _Utils_Tuple2(
					$author$project$Form$Text$withExtraAttrs(
						_List_fromArray(
							[
								$elm$html$Html$Attributes$maxlength(maxLetters)
							])),
					$elm$core$String$left(maxLetters));
			} else {
				var maxWords = counter.a;
				return _Utils_Tuple2(
					$elm$core$Basics$identity,
					function (value) {
						return (_Utils_cmp(
							$elm$core$List$length(
								$elm$core$String$words(value)),
							maxWords) > -1) ? A2(
							$elm$core$String$join,
							' ',
							A2(
								$elm$core$List$take,
								maxWords,
								$elm$core$String$words(value))) : value;
					});
			}
		}();
		var addMaxlength = _v1.a;
		var beforeChangeEvent = _v1.b;
		return addMaxlength(
			_Utils_update(
				options,
				{
					bz: A2($elm$core$Basics$composeR, beforeChangeEvent, options.bz),
					bA: $elm$core$Maybe$Just(counter)
				}));
	});
var $author$project$Form$Text$withCounterAttrs = F2(
	function (attrs, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				fF: _Utils_ap(options.fF, attrs)
			});
	});
var $author$project$Form$withDecoration = function (decoration) {
	return $author$project$Form$withNoOutput(
		$author$project$Form$arbitrary(
			A2(
				$elm$html$Html$map,
				function (_v0) {
					return $elm$core$Basics$identity;
				},
				decoration)));
};
var $author$project$Form$Text$withErrorAttrs = F2(
	function (attrs, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				fM: _Utils_ap(options.fM, attrs)
			});
	});
var $author$project$Form$Text$withInputContainerAttrs = F2(
	function (attrs, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				fY: _Utils_ap(options.fY, attrs)
			});
	});
var $author$project$Form$Text$withLabelAttrs = F2(
	function (attrs, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				f4: _Utils_ap(options.f4, attrs)
			});
	});
var $author$project$Page$Login$passphraseForm = F2(
	function (shared, _v0) {
		var translators = shared.iw;
		var hasPasted = _v0.bd;
		var hasTriedSubmitting = _v0.jB;
		var viewHighlights = function (currentText) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('absolute inset-px pointer-events-none'),
						$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$id('highlights'),
								$elm$html$Html$Attributes$class('p-4 overflow-auto h-full scrollbar-hidden')
							]),
						A2(
							$elm$core$List$map,
							function (line) {
								return $elm$core$String$isEmpty(line) ? A2($elm$html$Html$br, _List_Nil, _List_Nil) : A2(
									$elm$html$Html$p,
									_List_Nil,
									A2(
										$elm$core$List$intersperse,
										A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(' ')
												])),
										A2(
											$elm$core$List$map,
											function (word) {
												return $elm$core$String$isEmpty(word) ? A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('inline-block')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(' ')
														])) : A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															function () {
															var _v2 = shared.ft;
															if (_v2.$ === 1) {
																return $elm$html$Html$Attributes$class('transition-colors');
															} else {
																var bip39Wordlist = _v2.a;
																return (hasTriedSubmitting && ((!A2($elm$core$Set$member, word, bip39Wordlist.fL)) && ((!A2($elm$core$Set$member, word, bip39Wordlist.gn)) && (!A2($elm$core$Set$member, word, bip39Wordlist.gD))))) ? $elm$html$Html$Attributes$class('bg-red/60 text-white') : $elm$html$Html$Attributes$class('transition-colors');
															}
														}(),
															$elm$html$Html$Attributes$class('pointer-events-none rounded-sm px-0.5 -mx-0.5')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(word)
														]));
											},
											A2($elm$core$String$split, ' ', line))));
							},
							A2($elm$core$String$split, '\n', currentText)))
					]));
		};
		var _v1 = translators;
		var t = _v1.il;
		var viewPasteButton = shared.iV ? A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('absolute bottom-4 left-1/2 -translate-x-1/2 button z-10'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('button-secondary', !hasPasted),
							_Utils_Tuple2('button-primary', hasPasted)
						])),
					$elm$html$Html$Attributes$type_('button'),
					$elm$html$Html$Events$onClick($author$project$Page$Login$ClickedPaste)
				]),
			_List_fromArray(
				[
					hasPasted ? $elm$html$Html$text(
					t('auth.login.wordsMode.input.pasted')) : $elm$html$Html$text(
					t('auth.login.wordsMode.input.paste'))
				])) : $elm$html$Html$text('');
		return A2(
			$author$project$Form$with,
			$author$project$Form$introspect(
				function (values) {
					return A2(
						$author$project$Form$textField,
						{
							ab: $elm$core$Basics$always($elm$core$Maybe$Nothing),
							af: A2(
								$elm$core$Basics$composeR,
								$author$project$Form$Validate$succeed,
								A2(
									$elm$core$Basics$composeR,
									$author$project$Page$Login$passphraseValidator(shared.ft),
									$author$project$Form$Validate$validate(translators))),
							n: F2(
								function (passphrase, input) {
									return _Utils_update(
										input,
										{a6: passphrase});
								}),
							pO: function ($) {
								return $.a6;
							}
						},
						A2(
							$author$project$Form$Text$withElements,
							_List_fromArray(
								[
									viewPasteButton,
									viewHighlights(values.a6)
								]),
							A2(
								$author$project$Form$Text$withErrorAttrs,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('form-error-on-dark-bg')
									]),
								A2(
									$author$project$Form$Text$withLabelAttrs,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-white')
										]),
									A2(
										$author$project$Form$Text$withCounterAttrs,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('!text-white')
											]),
										A2(
											$author$project$Form$Text$withCounter,
											$author$project$Form$Text$CountWords(12),
											A2(
												$author$project$Form$Text$withInputContainerAttrs,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('bg-white rounded')
													]),
												A2(
													$author$project$Form$Text$withExtraAttrs,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('min-w-full block p-4 relative bg-transparent z-10 caret-black text-transparent'),
															$elm$html$Html$Attributes$classList(
															_List_fromArray(
																[
																	_Utils_Tuple2('pb-18', shared.iV)
																])),
															$elm$html$Html$Attributes$rows(2),
															$elm$html$Html$Attributes$autofocus(true),
															$elm$html$Html$Attributes$autocomplete(false),
															$elm$html$Html$Attributes$spellcheck(false),
															A2(
															$elm$html$Html$Events$on,
															'scroll',
															A2(
																$elm$json$Json$Decode$map,
																function (scrollTop) {
																	return $author$project$Page$Login$ScrolledTextArea(
																		{k5: scrollTop});
																},
																A2(
																	$elm$json$Json$Decode$at,
																	_List_fromArray(
																		['target', 'scrollTop']),
																	$elm$json$Json$Decode$int)))
														]),
													A2(
														$author$project$Form$Text$withPlaceholder,
														t('auth.login.wordsMode.input.placeholder'),
														A2(
															$author$project$Form$Text$withInputElement,
															$author$project$Form$Text$TextareaInput(
																{pn: true}),
															$author$project$Form$Text$init(
																{
																	R: 'passphrase-input',
																	nC: t('auth.login.wordsMode.input.label')
																})))))))))));
				}),
			A2(
				$author$project$Form$withDecoration,
				A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-white mb-6')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('font-bold block')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('menu.welcome_to'))
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('block')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('auth.login.wordsMode.input.description'))
								]))
						])),
				A2(
					$author$project$Form$withDecoration,
					$author$project$Page$Login$viewIllustration('login_key.svg'),
					$author$project$Form$succeed($elm$core$Basics$identity))));
	});
var $author$project$Page$Login$viewPassphrase = F2(
	function (guest, model) {
		var shared = guest.aM;
		var showRegisterLink = A2(
			$krisajenkins$remotedata$RemoteData$withDefault,
			false,
			A2(
				$krisajenkins$remotedata$RemoteData$map,
				function ($) {
					return $.cj;
				},
				guest.b9));
		var _v0 = shared.iw;
		var t = _v0.il;
		return _List_fromArray(
			[
				A6(
				$author$project$Form$view,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex flex-col justify-center')
					]),
				shared.iw,
				function (submitButton) {
					return _List_fromArray(
						[
							showRegisterLink ? A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-white text-center mb-6 block')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('auth.login.register')),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$author$project$Route$href(
											A2($author$project$Route$Register, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing)),
											$elm$html$Html$Attributes$class('text-orange-300 underline')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											t('auth.login.registerLink'))
										]))
								])) : $elm$html$Html$text(''),
							A2(
							submitButton,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('button button-primary min-w-full')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('dashboard.continue'))
								]))
						]);
				},
				A2(
					$author$project$Page$Login$passphraseForm,
					shared,
					{
						bd: model.bd,
						jB: $author$project$Form$isShowingAllErrors(model.hk)
					}),
				model.hk,
				{oq: $author$project$Page$Login$ClickedNextStep, pA: $author$project$Page$Login$GotPassphraseFormMsg})
			]);
	});
var $author$project$View$Pin$Dark = 1;
var $author$project$View$Pin$SubmittedForm = function (a) {
	return {$: 2, a: a};
};
var $author$project$Form$Text$CountLetters = function (a) {
	return {$: 0, a: a};
};
var $author$project$Form$Text$Password = 4;
var $author$project$View$Pin$isVisible = F2(
	function (field, model) {
		if (!field) {
			return model.cu;
		} else {
			return model.eD;
		}
	});
var $author$project$View$Pin$pinLength = 6;
var $author$project$View$Pin$ToggledPinVisibility = function (a) {
	return {$: 3, a: a};
};
var $author$project$View$Pin$viewToggleVisibility = F3(
	function (field, model, _v0) {
		var t = _v0.il;
		var text_ = A2($elm$core$Basics$composeR, t, $elm$html$Html$text);
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('absolute inset-y-0 uppercase text-sm font-bold right-0 mr-3 text-orange-300'),
					$elm$html$Html$Events$onClick(
					$author$project$View$Pin$ToggledPinVisibility(field)),
					A2($elm$html$Html$Attributes$attribute, 'tabindex', '-1'),
					$elm$html$Html$Attributes$type_('button')
				]),
			_List_fromArray(
				[
					A2($author$project$View$Pin$isVisible, field, model) ? text_('auth.pin.toggle.hide') : text_('auth.pin.toggle.show')
				]));
	});
var $author$project$View$Pin$createForm = F2(
	function (translators, model) {
		var t = translators.il;
		var validatePin = A2(
			$elm$core$Basics$composeR,
			$author$project$Form$Validate$succeed,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Form$Validate$stringLengthExactly($author$project$View$Pin$pinLength),
				A2(
					$elm$core$Basics$composeR,
					$author$project$Form$Validate$custom(
						function (pin) {
							return A2($elm$core$String$all, $elm$core$Char$isDigit, pin) ? $elm$core$Result$Ok(pin) : $elm$core$Result$Err(
								function (translators_) {
									return translators_.il('auth.pin.shouldHaveSixDigitsError');
								});
						}),
					$author$project$Form$Validate$validate(translators))));
		var backgroundAttrs = function () {
			var _v5 = model.fs;
			if (_v5 === 1) {
				return A2(
					$elm$core$Basics$composeR,
					$author$project$Form$Text$withLabelAttrs(
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-white')
							])),
					$author$project$Form$Text$withCounterAttrs(
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('!text-white')
							])));
			} else {
				return $elm$core$Basics$identity;
			}
		}();
		var commonOptions = function (field) {
			return A2(
				$elm$core$Basics$composeR,
				$author$project$Form$Text$withPlaceholder(
					A2($elm$core$String$repeat, $author$project$View$Pin$pinLength, '*')),
				A2(
					$elm$core$Basics$composeR,
					$author$project$Form$Text$withDisabled(model.cf || model.cv),
					A2(
						$elm$core$Basics$composeR,
						$author$project$Form$Text$withCounter(
							$author$project$Form$Text$CountLetters($author$project$View$Pin$pinLength)),
						A2(
							$elm$core$Basics$composeR,
							$author$project$Form$Text$withElements(
								_List_fromArray(
									[
										A3($author$project$View$Pin$viewToggleVisibility, field, model, translators)
									])),
							A2(
								$elm$core$Basics$composeR,
								$author$project$Form$Text$withExtraAttrs(
									_List_fromArray(
										[
											$elm$html$Html$Attributes$maxlength($author$project$View$Pin$pinLength),
											$elm$html$Html$Attributes$autocomplete(false),
											$elm$html$Html$Attributes$class('text-body-black tracking-widest')
										])),
								A2(
									$elm$core$Basics$composeR,
									backgroundAttrs,
									A2(
										$elm$core$Basics$composeR,
										$author$project$Form$Text$withType(
											A2($author$project$View$Pin$isVisible, field, model) ? 0 : 4),
										$author$project$Form$Text$asNumeric)))))));
		};
		return A2(
			$author$project$Form$with,
			model.hQ ? A2(
				$author$project$Form$textField,
				{
					ab: function (_v3) {
						var pin = _v3.oE;
						var confirmation = _v3.c3;
						var externalProblem = A2(
							$elm$core$Maybe$map,
							A2($elm$core$Basics$composeR, $elm$core$Tuple$second, t),
							A2(
								$elm_community$list_extra$List$Extra$find,
								function (_v4) {
									var problemField = _v4.a;
									return !problemField;
								},
								model.bn));
						var confirmationProblem = _Utils_eq(pin, confirmation) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
							t('auth.pinConfirmation.differsFromPinError'));
						return A2($elm_community$maybe_extra$Maybe$Extra$or, confirmationProblem, externalProblem);
					},
					af: validatePin,
					n: F2(
						function (confirmation, input) {
							return _Utils_update(
								input,
								{c3: confirmation});
						}),
					pO: function ($) {
						return $.c3;
					}
				},
				A2(
					commonOptions,
					1,
					$author$project$Form$Text$init(
						{
							R: 'pin-confirmation-input',
							nC: t(model.nC)
						}))) : $author$project$Form$succeed(''),
			A2(
				$author$project$Form$with,
				A2(
					$author$project$Form$textField,
					{
						ab: function (_v1) {
							return A2(
								$elm$core$Maybe$map,
								A2($elm$core$Basics$composeR, $elm$core$Tuple$second, t),
								A2(
									$elm_community$list_extra$List$Extra$find,
									function (_v2) {
										var problemField = _v2.a;
										return !problemField;
									},
									model.bn));
						},
						af: validatePin,
						n: F2(
							function (pin, input) {
								return _Utils_update(
									input,
									{oE: pin});
							}),
						pO: function ($) {
							return $.oE;
						}
					},
					A2(
						$author$project$Form$Text$withContainerAttrs,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('mt-6')
							]),
						A2(
							$author$project$Form$Text$withExtraAttrs,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$autofocus(true)
								]),
							A2(
								commonOptions,
								0,
								$author$project$Form$Text$init(
									{
										R: 'pin-input',
										nC: t(model.nC)
									}))))),
				$author$project$Form$succeed(
					F2(
						function (pin, _v0) {
							return {oE: pin};
						}))));
	});
var $author$project$View$Pin$view = F2(
	function (translators, model) {
		var t = translators.il;
		var text_ = A2($elm$core$Basics$composeR, t, $elm$html$Html$text);
		return A6(
			$author$project$Form$view,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-col flex-grow')
				]),
			translators,
			function (submitButton) {
				return _List_fromArray(
					[
						A2(
						submitButton,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('button button-primary min-w-full mt-auto'),
								$elm$html$Html$Attributes$disabled(model.cf || model.cv)
							]),
						_List_fromArray(
							[
								model.cv ? text_(model.po) : text_(model.pm)
							]))
					]);
			},
			A2($author$project$View$Pin$createForm, translators, model),
			model.hk,
			{oq: $author$project$View$Pin$SubmittedForm, pA: $author$project$View$Pin$GotFormMsg});
	});
var $author$project$View$Pin$withBackgroundColor = F2(
	function (background, model) {
		return _Utils_update(
			model,
			{fs: background});
	});
var $author$project$Page$Login$viewPin = F2(
	function (_v0, model) {
		var shared = _v0.aM;
		var trPrefix = function (s) {
			return 'auth.pin.instruction.' + s;
		};
		var isInputtingPin = function () {
			var _v2 = model.gE;
			if (!_v2.$) {
				return true;
			} else {
				return false;
			}
		}();
		var _v1 = shared.iw;
		var t = _v1.il;
		return _List_fromArray(
			[
				$author$project$Page$Login$viewIllustration('login_pin.svg'),
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-white')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						t(
							trPrefix('nowCreate'))),
						$elm$html$Html$text(' '),
						A2(
						$elm$html$Html$strong,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								t(
									trPrefix('sixDigitPin')))
							])),
						$elm$html$Html$text('. '),
						$elm$html$Html$text(
						t(
							trPrefix('thePin'))),
						$elm$html$Html$text(' '),
						A2(
						$elm$html$Html$strong,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								t(
									trPrefix('notPassword')))
							])),
						$elm$html$Html$text(' '),
						$elm$html$Html$text(
						t(
							trPrefix('eachLogin')))
					])),
				A2(
				$elm$html$Html$map,
				$author$project$Page$Login$GotPinComponentMsg,
				A2(
					$author$project$View$Pin$view,
					shared.iw,
					A2(
						$author$project$View$Pin$withDisabled,
						!isInputtingPin,
						A2($author$project$View$Pin$withBackgroundColor, 1, model.ag))))
			]);
	});
var $author$project$Page$Login$view = F2(
	function (guest, model) {
		return {
			mk: A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('bg-purple-500 flex-grow flex flex-col justify-center md:block')
					]),
				_List_fromArray(
					[
						A3(
						$elm$html$Html$Keyed$node,
						'div',
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex flex-col flex-grow justify-between w-full p-4 md:max-w-sm md:mx-auto md:pt-20 md:px-0')
							]),
						function () {
							if (!model.$) {
								var passphraseModel = model.a;
								return A2(
									$elm$core$List$indexedMap,
									F2(
										function (index, node) {
											return _Utils_Tuple2(
												'passphrase-' + $elm$core$String$fromInt(index),
												node);
										}),
									A2(
										$elm$core$List$map,
										$elm$html$Html$map($author$project$Page$Login$GotPassphraseMsg),
										A2($author$project$Page$Login$viewPassphrase, guest, passphraseModel)));
							} else {
								var pinModel = model.a;
								return A2(
									$elm$core$List$indexedMap,
									F2(
										function (index, node) {
											return _Utils_Tuple2(
												'pin-' + $elm$core$String$fromInt(index),
												node);
										}),
									A2(
										$elm$core$List$map,
										$elm$html$Html$map($author$project$Page$Login$GotPinMsg),
										A2($author$project$Page$Login$viewPin, guest, pinModel)));
							}
						}())
					])),
			fb: guest.aM.iw.il('auth.login.loginTab')
		};
	});
var $author$project$Page$News$GotLastEditorSummaryMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Page$News$ClickedToggleReactions = {$: 3};
var $author$project$Page$News$ToggledReaction = function (a) {
	return {$: 4, a: a};
};
var $author$project$Cambiatus$Enum$ReactionEnum$list = _List_fromArray(
	[0, 1, 2, 3, 4, 5, 6, 7, 8, 9]);
var $author$project$Community$News$listReactions = $author$project$Cambiatus$Enum$ReactionEnum$list;
var $author$project$Community$News$reactionToString = function (reaction) {
	switch (reaction) {
		case 0:
			return '👏';
		case 1:
			return '🤨';
		case 2:
			return '😃';
		case 3:
			return '🎉';
		case 4:
			return '❤️';
		case 5:
			return '🚀';
		case 6:
			return '🙁';
		case 7:
			return '😍';
		case 8:
			return '👎';
		default:
			return '👍';
	}
};
var $author$project$Icons$smilingFace = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('16'),
				$elm$svg$Svg$Attributes$height('16'),
				$elm$svg$Svg$Attributes$viewBox('0 0 16 16'),
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$class(class_),
				$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true),
				$elm$html$Html$Attributes$alt('')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M7.99998 14.6667C4.31798 14.6667 1.33331 11.682 1.33331 8.00001C1.33331 4.31801 4.31798 1.33334 7.99998 1.33334C11.682 1.33334 14.6666 4.31801 14.6666 8.00001C14.6666 11.682 11.682 14.6667 7.99998 14.6667ZM7.99998 13.3333C9.41447 13.3333 10.771 12.7714 11.7712 11.7712C12.7714 10.7711 13.3333 9.4145 13.3333 8.00001C13.3333 6.58552 12.7714 5.22897 11.7712 4.22877C10.771 3.22858 9.41447 2.66668 7.99998 2.66668C6.58549 2.66668 5.22894 3.22858 4.22874 4.22877C3.22855 5.22897 2.66665 6.58552 2.66665 8.00001C2.66665 9.4145 3.22855 10.7711 4.22874 11.7712C5.22894 12.7714 6.58549 13.3333 7.99998 13.3333ZM4.66665 8.66668H5.99998C5.99998 9.19711 6.21069 9.70582 6.58577 10.0809C6.96084 10.456 7.46955 10.6667 7.99998 10.6667C8.53041 10.6667 9.03912 10.456 9.41419 10.0809C9.78927 9.70582 9.99998 9.19711 9.99998 8.66668H11.3333C11.3333 9.55073 10.9821 10.3986 10.357 11.0237C9.73188 11.6488 8.88403 12 7.99998 12C7.11592 12 6.26808 11.6488 5.64296 11.0237C5.01784 10.3986 4.66665 9.55073 4.66665 8.66668ZM5.33331 7.33334C5.0681 7.33334 4.81374 7.22799 4.62621 7.04045C4.43867 6.85291 4.33331 6.59856 4.33331 6.33334C4.33331 6.06813 4.43867 5.81377 4.62621 5.62624C4.81374 5.4387 5.0681 5.33334 5.33331 5.33334C5.59853 5.33334 5.85288 5.4387 6.04042 5.62624C6.22796 5.81377 6.33331 6.06813 6.33331 6.33334C6.33331 6.59856 6.22796 6.85291 6.04042 7.04045C5.85288 7.22799 5.59853 7.33334 5.33331 7.33334ZM10.6666 7.33334C10.4014 7.33334 10.1471 7.22799 9.95954 7.04045C9.772 6.85291 9.66665 6.59856 9.66665 6.33334C9.66665 6.06813 9.772 5.81377 9.95954 5.62624C10.1471 5.4387 10.4014 5.33334 10.6666 5.33334C10.9319 5.33334 11.1862 5.4387 11.3738 5.62624C11.5613 5.81377 11.6666 6.06813 11.6666 6.33334C11.6666 6.59856 11.5613 6.85291 11.3738 7.04045C11.1862 7.22799 10.9319 7.33334 10.6666 7.33334Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Page$News$viewReactionPicker = F3(
	function (_v0, model, news) {
		var t = _v0.il;
		var hasReaction = function (reaction) {
			var _v2 = news.h5;
			if (_v2.$ === 1) {
				return false;
			} else {
				var receipt = _v2.a;
				return A2($elm$core$List$member, reaction, receipt.kP);
			}
		};
		return A2(
			$elm$core$List$cons,
			A2(
				$elm$html$Html$details,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('inline-block relative z-10'),
						$elm$html$Html$Attributes$id('reaction-picker'),
						$author$project$Utils$onClickPreventAll($author$project$Page$News$ClickedToggleReactions),
						model.bW ? A2($elm$html$Html$Attributes$attribute, 'open', '') : $elm$html$Html$Attributes$class('')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$summary,
						_List_fromArray(
							[
								$fapian$elm_html_aria$Html$Attributes$Aria$role('button'),
								$fapian$elm_html_aria$Html$Attributes$Aria$ariaHasPopup('true'),
								$fapian$elm_html_aria$Html$Attributes$Aria$ariaLabel(
								t('news.reaction.choose')),
								$elm$html$Html$Attributes$class('marker-hidden bg-gray-200 rounded-full p-0.5 focus-ring transition-colors hover:bg-gray-500 active:bg-gray-300')
							]),
						_List_fromArray(
							[
								$author$project$Icons$smilingFace('fill-current text-gray-900 w-6 h-6')
							])),
						A3(
						$author$project$View$Components$focusTrap,
						{nk: $elm$core$Maybe$Nothing},
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$ul,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('absolute shadow grid gap-1 p-2 rounded-sm bg-white'),
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('animate-bounce-in', model.bW)
											])),
										A2($elm$html$Html$Attributes$style, 'grid-template-columns', 'repeat(5, 1fr)')
									]),
								A2(
									$elm$core$List$indexedMap,
									F2(
										function (index, reaction) {
											return A2(
												$elm$html$Html$li,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$button,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('w-8 h-8 flex items-center justify-center rounded-sm focus-ring transition-colors'),
																$elm$html$Html$Attributes$classList(
																_List_fromArray(
																	[
																		_Utils_Tuple2(
																		'bg-green bg-opacity-80 hover:bg-opacity-60',
																		hasReaction(reaction)),
																		_Utils_Tuple2(
																		'bg-white hover:bg-gray-200 focus-visible:bg-gray-200',
																		!hasReaction(reaction))
																	])),
																$elm$html$Html$Events$onClick(
																$author$project$Page$News$ToggledReaction(reaction)),
																$elm$html$Html$Attributes$id(
																'reaction-' + $elm$core$String$fromInt(index))
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$span,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('sr-only')
																	]),
																_List_fromArray(
																	[
																		hasReaction(reaction) ? $elm$html$Html$text(
																		t('news.reaction.remove')) : $elm$html$Html$text(
																		t('news.reaction.add'))
																	])),
																$elm$html$Html$text(
																$author$project$Community$News$reactionToString(reaction))
															]))
													]));
										}),
									$author$project$Community$News$listReactions))
							]))
					])),
			model.bW ? _List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('fixed top-0 right-0 w-screen h-screen cursor-auto'),
							$elm$html$Html$Events$onClick($author$project$Page$News$ClickedToggleReactions),
							$fapian$elm_html_aria$Html$Attributes$Aria$ariaLabel(
							t('news.reaction.close')),
							$elm$html$Html$Attributes$tabindex(-1)
						]),
					_List_Nil),
					$author$project$View$Components$keyListener(
					{
						lL: _List_fromArray(
							[0]),
						kF: false,
						le: true,
						pA: function (_v1) {
							return $author$project$Page$News$ClickedToggleReactions;
						}
					})
				]) : _List_Nil);
	});
var $author$project$Community$News$reactionName = A2(
	$elm$core$Basics$composeR,
	$author$project$Cambiatus$Enum$ReactionEnum$toString,
	A2($elm$core$String$replace, '_', ' '));
var $author$project$Page$News$viewReactions = F2(
	function (_v0, news) {
		var tr = _v0.iu;
		var hasReaction = function (reaction) {
			var _v3 = news.h5;
			if (_v3.$ === 1) {
				return false;
			} else {
				var receipt = _v3.a;
				return A2($elm$core$List$member, reaction, receipt.kP);
			}
		};
		return A2(
			$elm$html$Html$Keyed$ul,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex items-center')
				]),
			A2(
				$elm$core$List$map,
				function (_v2) {
					var reaction = _v2.e_;
					var count = _v2.mo;
					return _Utils_Tuple2(
						$author$project$Community$News$reactionName(reaction),
						A2(
							$elm$html$Html$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('ml-4 rounded-full py-0.5 px-2 flex gap-1 focus-ring transition-colors'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'bg-green bg-opacity-50 border border-green hover:bg-opacity-40 active:bg-opacity-60',
													hasReaction(reaction)),
													_Utils_Tuple2(
													'bg-gray-200 hover:bg-gray-500 active:bg-gray-300',
													!hasReaction(reaction))
												])),
											$elm$html$Html$Attributes$type_('button'),
											$elm$html$Html$Events$onClick(
											$author$project$Page$News$ToggledReaction(reaction))
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('sr-only')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													A2(
														tr,
														'news.reaction.reactions',
														_List_fromArray(
															[
																_Utils_Tuple2(
																'count',
																$elm$core$String$fromInt(count))
															])))
												])),
											A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Community$News$reactionToString(reaction))
												])),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$elm$core$String$fromInt(count))
												]))
										]))
								])));
				},
				A2(
					$elm$core$List$filter,
					function (_v1) {
						var count = _v1.mo;
						return count > 0;
					},
					news.kP)));
	});
var $author$project$Page$News$viewMainNews = F3(
	function (loggedIn, model, news) {
		var shared = loggedIn.aM;
		var _v0 = shared;
		var translators = _v0.iw;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bg-white')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('container mx-auto px-4 pt-10 pb-4')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h2,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-lg text-black font-bold')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(news.fb)
								])),
							A2(
							$author$project$Markdown$view,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mt-6 text-black colored-links')
								]),
							news.bc),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex items-center mt-8')
								]),
							_Utils_ap(
								A3($author$project$Page$News$viewReactionPicker, translators, model, news),
								_List_fromArray(
									[
										A2($author$project$Page$News$viewReactions, translators, news)
									]))),
							(!_Utils_eq(news.f_, news.pK)) ? A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex items-center mt-6')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									$author$project$Page$News$GotLastEditorSummaryMsg,
									A4(
										$author$project$Profile$Summary$view,
										shared.iw,
										loggedIn.lM,
										news.mq,
										A2(
											$author$project$Profile$Summary$withImageSize,
											'h-8 w-8',
											$author$project$Profile$Summary$withoutName(model.eI)))),
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-gray-900 ml-2')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											translators.il('news.edited_by')),
											A2(
											$elm$html$Html$a,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('font-bold hover:underline'),
													$author$project$Route$href(
													$author$project$Route$Profile(news.mq.fl))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													A2(
														$elm$core$Maybe$withDefault,
														$author$project$Eos$Account$nameToString(news.mq.fl),
														news.mq.ki))
												])),
											A4(
											$author$project$View$Components$dateViewer,
											_List_Nil,
											function (translations) {
												return _Utils_update(
													translations,
													{
														ow: translators.il('news.edited_date'),
														pB: $elm$core$Maybe$Nothing,
														pY: $elm$core$Maybe$Nothing
													});
											},
											shared,
											news.pK)
										]))
								])) : $elm$html$Html$text('')
						]))
				]));
	});
var $author$project$Page$News$view_ = F4(
	function (loggedIn, model, maybeSelectedNews, news) {
		var shared = loggedIn.aM;
		var _v0 = shared.iw;
		var t = _v0.il;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			$elm$core$List$concat(
				_List_fromArray(
					[
						function () {
						if (!maybeSelectedNews.$) {
							var selectedNews = maybeSelectedNews.a;
							return _List_fromArray(
								[
									A3($author$project$Page$News$viewMainNews, loggedIn, model, selectedNews),
									($elm$core$List$isEmpty(news) || (!model.pd)) ? $elm$html$Html$text('') : A2(
									$elm$html$Html$h2,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('container mx-auto px-4 mt-16 mb-4 text-lg font-bold text-gray-900')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													t('news.read'))
												])),
											$elm$html$Html$text(' '),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('text-purple-500')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													t('news.other_news'))
												]))
										]))
								]);
						} else {
							return _List_Nil;
						}
					}(),
						_List_fromArray(
						[
							model.pd ? A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('bg-white pb-4')
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Community$News$viewList,
									shared,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('container mx-auto px-4 pt-6')
										]),
									news)
								])) : $elm$html$Html$text('')
						])
					])));
	});
var $author$project$Page$News$view = F2(
	function (loggedIn, model) {
		var _v0 = loggedIn.aM.iw;
		var t = _v0.il;
		var title = t('news.title');
		var content = function () {
			var _v1 = A2(
				$author$project$Community$getField,
				loggedIn.o7,
				function ($) {
					return $.eO;
				});
			switch (_v1.$) {
				case 3:
					var _v2 = _v1.a;
					var community = _v2.a;
					var news = _v2.b;
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$Page$viewHeader, loggedIn, title),
								((!community.df) || $elm$core$List$isEmpty(news)) ? A2(
								$author$project$Page$fullPageNotFound,
								t('news.no_news.title'),
								t('news.no_news.description')) : A4(
								$author$project$Page$News$view_,
								loggedIn,
								model,
								A2(
									$elm$core$Maybe$andThen,
									function (newsId) {
										return A2(
											$elm_community$list_extra$List$Extra$find,
											function (_v3) {
												var id = _v3.R;
												return _Utils_eq(id, newsId);
											},
											news);
									},
									model.bh),
								A2(
									$elm$core$List$filter,
									function (n) {
										return A2($author$project$Community$News$isPublished, loggedIn.aM.gh, n) && (!_Utils_eq(
											$elm$core$Maybe$Just(n.R),
											model.bh));
									},
									news))
							]));
				case 2:
					var failure = _v1.a;
					if (failure.$ === 1) {
						var err = failure.a;
						return A2($author$project$Page$fullPageGraphQLError, title, err);
					} else {
						var err = failure.a;
						return A2($author$project$Page$fullPageGraphQLError, title, err);
					}
				case 1:
					return $author$project$Page$fullPageLoading(loggedIn.aM);
				default:
					return $author$project$Page$fullPageLoading(loggedIn.aM);
			}
		}();
		return {mk: content, fb: title};
	});
var $author$project$Page$NotFound$view = function (session) {
	var shared = $author$project$Page$toShared(session);
	return {
		mk: A2(
			$author$project$Page$fullPageNotFound,
			shared.iw.il('error.pageNotFound'),
			''),
		fb: shared.iw.il('error.pageNotFound')
	};
};
var $author$project$Page$Notification$viewEmptyNotifications = function (shared) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('rounded-lg bg-white mt-5 p-8 text-center shadow')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						shared.iw.il('notifications.empty'))
					]))
			]));
};
var $author$project$Page$Notification$M = {$: 2};
var $author$project$Page$Notification$MarkAsRead = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $cuducos$elm_format_number$FormatNumber$Parser$FormattedNumber = F5(
	function (original, integers, decimals, prefix, suffix) {
		return {cd: decimals, jQ: integers, u: original, go: prefix, gF: suffix};
	});
var $cuducos$elm_format_number$FormatNumber$Parser$Negative = 2;
var $cuducos$elm_format_number$FormatNumber$Parser$Positive = 0;
var $cuducos$elm_format_number$FormatNumber$Parser$Zero = 1;
var $cuducos$elm_format_number$FormatNumber$Parser$classify = function (formatted) {
	var onlyZeros = A2(
		$elm$core$String$all,
		function (_char) {
			return _char === '0';
		},
		$elm$core$String$concat(
			A2(
				$elm$core$List$append,
				formatted.jQ,
				$elm$core$List$singleton(formatted.cd))));
	return onlyZeros ? 1 : ((formatted.u < 0) ? 2 : 0);
};
var $cuducos$elm_format_number$FormatNumber$Parser$addZerosToFit = F2(
	function (desiredLength, value) {
		var length = $elm$core$String$length(value);
		var missing = (_Utils_cmp(length, desiredLength) < 0) ? $elm$core$Basics$abs(desiredLength - length) : 0;
		return _Utils_ap(
			value,
			A2($elm$core$String$repeat, missing, '0'));
	});
var $cuducos$elm_format_number$FormatNumber$Parser$removeZeros = function (decimals) {
	return (A2($elm$core$String$right, 1, decimals) !== '0') ? decimals : $cuducos$elm_format_number$FormatNumber$Parser$removeZeros(
		A2($elm$core$String$dropRight, 1, decimals));
};
var $cuducos$elm_format_number$FormatNumber$Parser$getDecimals = F2(
	function (locale, digits) {
		var _v0 = locale.cd;
		switch (_v0.$) {
			case 1:
				return $cuducos$elm_format_number$FormatNumber$Parser$removeZeros(digits);
			case 2:
				return digits;
			default:
				var min = _v0.a;
				return A2($cuducos$elm_format_number$FormatNumber$Parser$addZerosToFit, min, digits);
		}
	});
var $myrho$elm_round$Round$addSign = F2(
	function (signed, str) {
		var isNotZero = A2(
			$elm$core$List$any,
			function (c) {
				return (c !== '0') && (c !== '.');
			},
			$elm$core$String$toList(str));
		return _Utils_ap(
			(signed && isNotZero) ? '-' : '',
			str);
	});
var $myrho$elm_round$Round$increaseNum = function (_v0) {
	var head = _v0.a;
	var tail = _v0.b;
	if (head === '9') {
		var _v1 = $elm$core$String$uncons(tail);
		if (_v1.$ === 1) {
			return '01';
		} else {
			var headtail = _v1.a;
			return A2(
				$elm$core$String$cons,
				'0',
				$myrho$elm_round$Round$increaseNum(headtail));
		}
	} else {
		var c = $elm$core$Char$toCode(head);
		return ((c >= 48) && (c < 57)) ? A2(
			$elm$core$String$cons,
			$elm$core$Char$fromCode(c + 1),
			tail) : '0';
	}
};
var $elm$core$Basics$isInfinite = _Basics_isInfinite;
var $elm$core$Basics$isNaN = _Basics_isNaN;
var $elm$core$String$padRight = F3(
	function (n, _char, string) {
		return _Utils_ap(
			string,
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)));
	});
var $myrho$elm_round$Round$splitComma = function (str) {
	var _v0 = A2($elm$core$String$split, '.', str);
	if (_v0.b) {
		if (_v0.b.b) {
			var before = _v0.a;
			var _v1 = _v0.b;
			var after = _v1.a;
			return _Utils_Tuple2(before, after);
		} else {
			var before = _v0.a;
			return _Utils_Tuple2(before, '0');
		}
	} else {
		return _Utils_Tuple2('0', '0');
	}
};
var $myrho$elm_round$Round$toDecimal = function (fl) {
	var _v0 = A2(
		$elm$core$String$split,
		'e',
		$elm$core$String$fromFloat(
			$elm$core$Basics$abs(fl)));
	if (_v0.b) {
		if (_v0.b.b) {
			var num = _v0.a;
			var _v1 = _v0.b;
			var exp = _v1.a;
			var e = A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(
					A2($elm$core$String$startsWith, '+', exp) ? A2($elm$core$String$dropLeft, 1, exp) : exp));
			var _v2 = $myrho$elm_round$Round$splitComma(num);
			var before = _v2.a;
			var after = _v2.b;
			var total = _Utils_ap(before, after);
			var zeroed = (e < 0) ? A2(
				$elm$core$Maybe$withDefault,
				'0',
				A2(
					$elm$core$Maybe$map,
					function (_v3) {
						var a = _v3.a;
						var b = _v3.b;
						return a + ('.' + b);
					},
					A2(
						$elm$core$Maybe$map,
						$elm$core$Tuple$mapFirst($elm$core$String$fromChar),
						$elm$core$String$uncons(
							_Utils_ap(
								A2(
									$elm$core$String$repeat,
									$elm$core$Basics$abs(e),
									'0'),
								total))))) : A3($elm$core$String$padRight, e + 1, '0', total);
			return _Utils_ap(
				(fl < 0) ? '-' : '',
				zeroed);
		} else {
			var num = _v0.a;
			return _Utils_ap(
				(fl < 0) ? '-' : '',
				num);
		}
	} else {
		return '';
	}
};
var $myrho$elm_round$Round$roundFun = F3(
	function (functor, s, fl) {
		if ($elm$core$Basics$isInfinite(fl) || $elm$core$Basics$isNaN(fl)) {
			return $elm$core$String$fromFloat(fl);
		} else {
			var signed = fl < 0;
			var _v0 = $myrho$elm_round$Round$splitComma(
				$myrho$elm_round$Round$toDecimal(
					$elm$core$Basics$abs(fl)));
			var before = _v0.a;
			var after = _v0.b;
			var r = $elm$core$String$length(before) + s;
			var normalized = _Utils_ap(
				A2($elm$core$String$repeat, (-r) + 1, '0'),
				A3(
					$elm$core$String$padRight,
					r,
					'0',
					_Utils_ap(before, after)));
			var totalLen = $elm$core$String$length(normalized);
			var roundDigitIndex = A2($elm$core$Basics$max, 1, r);
			var increase = A2(
				functor,
				signed,
				A3($elm$core$String$slice, roundDigitIndex, totalLen, normalized));
			var remains = A3($elm$core$String$slice, 0, roundDigitIndex, normalized);
			var num = increase ? $elm$core$String$reverse(
				A2(
					$elm$core$Maybe$withDefault,
					'1',
					A2(
						$elm$core$Maybe$map,
						$myrho$elm_round$Round$increaseNum,
						$elm$core$String$uncons(
							$elm$core$String$reverse(remains))))) : remains;
			var numLen = $elm$core$String$length(num);
			var numZeroed = (num === '0') ? num : ((s <= 0) ? _Utils_ap(
				num,
				A2(
					$elm$core$String$repeat,
					$elm$core$Basics$abs(s),
					'0')) : ((_Utils_cmp(
				s,
				$elm$core$String$length(after)) < 0) ? (A3($elm$core$String$slice, 0, numLen - s, num) + ('.' + A3($elm$core$String$slice, numLen - s, numLen, num))) : _Utils_ap(
				before + '.',
				A3($elm$core$String$padRight, s, '0', after))));
			return A2($myrho$elm_round$Round$addSign, signed, numZeroed);
		}
	});
var $myrho$elm_round$Round$round = $myrho$elm_round$Round$roundFun(
	F2(
		function (signed, str) {
			var _v0 = $elm$core$String$uncons(str);
			if (_v0.$ === 1) {
				return false;
			} else {
				if ('5' === _v0.a.a) {
					if (_v0.a.b === '') {
						var _v1 = _v0.a;
						return !signed;
					} else {
						var _v2 = _v0.a;
						return true;
					}
				} else {
					var _v3 = _v0.a;
					var _int = _v3.a;
					return function (i) {
						return ((i > 53) && signed) || ((i >= 53) && (!signed));
					}(
						$elm$core$Char$toCode(_int));
				}
			}
		}));
var $cuducos$elm_format_number$FormatNumber$Parser$splitInParts = F2(
	function (locale, value) {
		var toString = function () {
			var _v1 = locale.cd;
			switch (_v1.$) {
				case 1:
					var max = _v1.a;
					return $myrho$elm_round$Round$round(max);
				case 0:
					return $elm$core$String$fromFloat;
				default:
					var exact = _v1.a;
					return $myrho$elm_round$Round$round(exact);
			}
		}();
		var asList = A2(
			$elm$core$String$split,
			'.',
			toString(value));
		var decimals = function () {
			var _v0 = $elm$core$List$tail(asList);
			if (!_v0.$) {
				var values = _v0.a;
				return A2(
					$elm$core$Maybe$withDefault,
					'',
					$elm$core$List$head(values));
			} else {
				return '';
			}
		}();
		var integers = A2(
			$elm$core$Maybe$withDefault,
			'',
			$elm$core$List$head(asList));
		return _Utils_Tuple2(integers, decimals);
	});
var $cuducos$elm_format_number$FormatNumber$Parser$splitThousands = function (integers) {
	var reversedSplitThousands = function (value) {
		return ($elm$core$String$length(value) > 3) ? A2(
			$elm$core$List$cons,
			A2($elm$core$String$right, 3, value),
			reversedSplitThousands(
				A2($elm$core$String$dropRight, 3, value))) : _List_fromArray(
			[value]);
	};
	return $elm$core$List$reverse(
		reversedSplitThousands(integers));
};
var $cuducos$elm_format_number$FormatNumber$Parser$parse = F2(
	function (locale, original) {
		var parts = A2($cuducos$elm_format_number$FormatNumber$Parser$splitInParts, locale, original);
		var integers = $cuducos$elm_format_number$FormatNumber$Parser$splitThousands(
			A2($elm$core$String$filter, $elm$core$Char$isDigit, parts.a));
		var decimals = A2($cuducos$elm_format_number$FormatNumber$Parser$getDecimals, locale, parts.b);
		var partial = A5($cuducos$elm_format_number$FormatNumber$Parser$FormattedNumber, original, integers, decimals, '', '');
		var _v0 = $cuducos$elm_format_number$FormatNumber$Parser$classify(partial);
		switch (_v0) {
			case 2:
				return _Utils_update(
					partial,
					{go: locale.gg, gF: locale.hR});
			case 0:
				return _Utils_update(
					partial,
					{go: locale.kD, gF: locale.kE});
			default:
				return _Utils_update(
					partial,
					{go: locale.lJ, gF: locale.lK});
		}
	});
var $cuducos$elm_format_number$FormatNumber$Stringfy$formatDecimals = F2(
	function (locale, decimals) {
		return (decimals === '') ? '' : _Utils_ap(locale.jb, decimals);
	});
var $cuducos$elm_format_number$FormatNumber$Stringfy$stringfy = F2(
	function (locale, formatted) {
		var stringfyDecimals = $cuducos$elm_format_number$FormatNumber$Stringfy$formatDecimals(locale);
		var integers = A2($elm$core$String$join, locale.cL, formatted.jQ);
		var decimals = stringfyDecimals(formatted.cd);
		return $elm$core$String$concat(
			_List_fromArray(
				[formatted.go, integers, decimals, formatted.gF]));
	});
var $cuducos$elm_format_number$FormatNumber$format = F2(
	function (locale, number_) {
		return A2(
			$cuducos$elm_format_number$FormatNumber$Stringfy$stringfy,
			locale,
			A2($cuducos$elm_format_number$FormatNumber$Parser$parse, locale, number_));
	});
var $cuducos$elm_format_number$FormatNumber$Locales$Exact = function (a) {
	return {$: 2, a: a};
};
var $cuducos$elm_format_number$FormatNumber$Locales$Min = function (a) {
	return {$: 0, a: a};
};
var $cuducos$elm_format_number$FormatNumber$Locales$base = {
	jb: '.',
	cd: $cuducos$elm_format_number$FormatNumber$Locales$Min(0),
	gg: '−',
	hR: '',
	kD: '',
	kE: '',
	cL: '',
	lJ: '',
	lK: ''
};
var $cuducos$elm_format_number$FormatNumber$Locales$usLocale = _Utils_update(
	$cuducos$elm_format_number$FormatNumber$Locales$base,
	{
		cd: $cuducos$elm_format_number$FormatNumber$Locales$Exact(2),
		cL: ','
	});
var $author$project$Page$Notification$viewAmount = F2(
	function (amount, symbol) {
		var color = (amount > 0) ? 'text-green' : 'text-red';
		var amountText = A2($cuducos$elm_format_number$FormatNumber$format, $cuducos$elm_format_number$FormatNumber$Locales$usLocale, amount);
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-2xl'),
						$elm$html$Html$Attributes$class(color)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(amountText)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('uppercase text-sm font-extralight mt-3 ml-2 font-sans'),
						$elm$html$Html$Attributes$class(color)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Eos$symbolToSymbolCodeString(symbol))
					]))
			]);
	});
var $author$project$Page$Notification$viewNotificationMint = F3(
	function (shared, history, notification) {
		var maybeLogo = $elm$core$String$isEmpty(notification.b9.hC) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(notification.b9.hC);
		var description = A2(
			shared.iw.iu,
			'notifications.issue.receive',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'amount',
					$elm$core$String$fromFloat(notification.oV)),
					_Utils_Tuple2(
					'symbol',
					$author$project$Eos$symbolToSymbolCodeString(notification.b9.e9))
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex items-start lg:items-center p-4'),
					$elm$html$Html$Events$onClick(
					A2($author$project$Page$Notification$MarkAsRead, history.R, $author$project$Page$Notification$M))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex-none')
						]),
					_List_fromArray(
						[
							function () {
							if (!maybeLogo.$) {
								var logoUrl = maybeLogo.a;
								return A2(
									$elm$html$Html$img,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('w-10 h-10 object-scale-down'),
											$elm$html$Html$Attributes$src(logoUrl)
										]),
									_List_Nil);
							} else {
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('w-10 h-10 object-scale-down')
										]),
									_List_Nil);
							}
						}()
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex-col flex-grow-1 pl-4')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-black')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(description)
								])),
							A4(
							$author$project$View$Components$dateViewer,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-gray-900 text-sm uppercase')
								]),
							$elm$core$Basics$identity,
							shared,
							$author$project$Utils$fromDateTime(history.f_))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-none pl-4')
						]),
					A2($author$project$Page$Notification$viewAmount, notification.oV, notification.b9.e9))
				]));
	});
var $author$project$Page$Notification$S = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Notification$viewNotificationSaleHistoryDetail = F3(
	function (loggedIn, sale, date) {
		var shared = loggedIn.aM;
		var isBuy = _Utils_eq(loggedIn.lM, sale.js);
		var description = isBuy ? A2(
			shared.iw.iu,
			'notifications.saleHistory.buy',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'user',
					$author$project$Eos$Account$nameToString(sale.lm)),
					_Utils_Tuple2('sale', sale.oP.fb)
				])) : A2(
			shared.iw.iu,
			'notifications.saleHistory.sell',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'user',
					$author$project$Eos$Account$nameToString(sale.js)),
					_Utils_Tuple2('sale', sale.oP.fb)
				]));
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex-col flex-grow-1 pl-4')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-black')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(description)
							])),
						A4(
						$author$project$View$Components$dateViewer,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-gray-900 text-sm uppercase')
							]),
						$elm$core$Basics$identity,
						shared,
						$author$project$Utils$fromDateTime(date))
					])),
				function () {
				var _v0 = sale.oP.hr;
				if (!_v0.b) {
					return $elm$html$Html$text('');
				} else {
					var firstImage = _v0.a;
					return A2(
						$elm$html$Html$img,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$src(firstImage),
								$elm$html$Html$Attributes$class('object-scale-down rounded-full h-10 ml-4')
							]),
						_List_Nil);
				}
			}()
			]);
	});
var $author$project$Page$Notification$viewNotificationSaleHistory = F3(
	function (loggedIn, notification, sale) {
		var logoString = sale.oP.b9.hC;
		var maybeLogo = $elm$core$String$isEmpty(logoString) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(logoString);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex items-start lg:items-center p-4'),
					$elm$html$Html$Events$onClick(
					A2(
						$author$project$Page$Notification$MarkAsRead,
						notification.R,
						$author$project$Page$Notification$S(sale)))
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex-none')
						]),
					_List_fromArray(
						[
							function () {
							if (!maybeLogo.$) {
								var logoUrl = maybeLogo.a;
								return A2(
									$elm$html$Html$img,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('w-10 h-10 object-scale-down'),
											$elm$html$Html$Attributes$src(logoUrl)
										]),
									_List_Nil);
							} else {
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('w-10 h-10 object-scale-down')
										]),
									_List_Nil);
							}
						}()
						])),
				A3($author$project$Page$Notification$viewNotificationSaleHistoryDetail, loggedIn, sale, notification.f_)));
	});
var $author$project$Page$Notification$T = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Notification$viewNotificationTransfer = F3(
	function (shared, history, notification) {
		var maybeLogo = $elm$core$String$isEmpty(notification.b9.hC) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(notification.b9.hC);
		var isReceive = !_Utils_eq(
			$author$project$Eos$Account$nameToString(history.oY),
			notification.js);
		var description = isReceive ? A2(
			shared.iw.iu,
			'notifications.transfer.receive',
			_List_fromArray(
				[
					_Utils_Tuple2('user', notification.js),
					_Utils_Tuple2(
					'amount',
					$elm$core$String$fromFloat(notification.lU))
				])) : A2(
			shared.iw.iu,
			'notifications.transfer.sent',
			_List_fromArray(
				[
					_Utils_Tuple2('user', notification.lm),
					_Utils_Tuple2(
					'amount',
					$elm$core$String$fromFloat(notification.lU))
				]));
		var amount = isReceive ? notification.lU : (notification.lU * (-1));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex items-start lg:items-center p-4'),
					$elm$html$Html$Events$onClick(
					A2(
						$author$project$Page$Notification$MarkAsRead,
						history.R,
						$author$project$Page$Notification$T(notification)))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex-none')
						]),
					_List_fromArray(
						[
							function () {
							if (!maybeLogo.$) {
								var logoUrl = maybeLogo.a;
								return A2(
									$elm$html$Html$img,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('w-10 h-10 object-scale-down'),
											$elm$html$Html$Attributes$src(logoUrl)
										]),
									_List_Nil);
							} else {
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('w-10 h-10 object-scale-down')
										]),
									_List_Nil);
							}
						}()
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex-col flex-grow-1 pl-4')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-black')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(description)
								])),
							A4(
							$author$project$View$Components$dateViewer,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-gray-900 text-sm uppercase')
								]),
							$elm$core$Basics$identity,
							shared,
							$author$project$Utils$fromDateTime(history.f_))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-none pl-4')
						]),
					A2($author$project$Page$Notification$viewAmount, amount, notification.e9))
				]));
	});
var $author$project$Page$Notification$viewNotification = F2(
	function (loggedIn, notification) {
		var isReadIndicator = notification.nv ? '' : ' bg-orange-100 first:rounded-t-lg last:rounded-b-lg';
		var _v0 = notification.oA;
		switch (_v0.$) {
			case 0:
				var data = _v0.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('border-b last:border-b-0 border-gray-500 hover:bg-gray-100' + isReadIndicator)
						]),
					_List_fromArray(
						[
							A3($author$project$Page$Notification$viewNotificationTransfer, loggedIn.aM, notification, data)
						]));
			case 2:
				var data = _v0.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('border-b last:border-b-0 border-gray-500 hover:bg-gray-100' + isReadIndicator)
						]),
					_List_fromArray(
						[
							A3($author$project$Page$Notification$viewNotificationMint, loggedIn.aM, notification, data)
						]));
			default:
				var data = _v0.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('border-b last:border-b-0 border-gray-500 hover:bg-gray-100' + isReadIndicator)
						]),
					_List_fromArray(
						[
							A3($author$project$Page$Notification$viewNotificationSaleHistory, loggedIn, notification, data)
						]));
		}
	});
var $author$project$Page$Notification$viewNotifications = F2(
	function (loggedIn, notifications) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('shadow-md rounded-lg bg-white mt-5')
				]),
			A2(
				$elm$core$List$map,
				$author$project$Page$Notification$viewNotification(loggedIn),
				notifications));
	});
var $author$project$Page$Notification$view = F2(
	function (loggedIn, model) {
		var shared = loggedIn.aM;
		var content = function () {
			if (!model.$) {
				return $author$project$Page$fullPageLoading(shared);
			} else {
				var notifications = model.a;
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Page$viewHeader,
							loggedIn,
							shared.iw.il('notifications.title')),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('container mx-auto px-4 mb-6')
								]),
							_List_fromArray(
								[
									_Utils_eq(notifications, _List_Nil) ? $author$project$Page$Notification$viewEmptyNotifications(loggedIn.aM) : A2($author$project$Page$Notification$viewNotifications, loggedIn, notifications)
								]))
						]));
			}
		}();
		return {
			mk: content,
			fb: shared.iw.il('notifications.title')
		};
	});
var $author$project$Page$PaymentHistory$viewDatePicker = F2(
	function (shared, model) {
		return A3(
			$author$project$Form$DatePicker$view,
			$author$project$Page$PaymentHistory$datePickerOptions(shared),
			A2($author$project$Page$PaymentHistory$datePickerViewConfig, shared, model),
			$author$project$Page$PaymentHistory$GotDatePickerMsg);
	});
var $author$project$Page$PaymentHistory$viewSplash = function (p) {
	var name = A2(
		$elm$core$Maybe$withDefault,
		$author$project$Eos$Account$nameToString(p.fl),
		p.ki);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('bg-purple-500 bg-contain bg-center bg-no-repeat h-56 mb-6'),
				A2($elm$html$Html$Attributes$style, 'background-image', 'url(/images/cover_pic_payment_history.svg)')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h1,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-white text-center text-2xl pt-6')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(name)
					]))
			]));
};
var $author$project$Page$PaymentHistory$ShowMore = {$: 6};
var $author$project$Page$PaymentHistory$viewPagination = F2(
	function (shared, _v0) {
		var incomingTransfersPageInfo = _v0.cr;
		var isLoadingTransfers = _v0.ax;
		if (!incomingTransfersPageInfo.$) {
			var pi = incomingTransfersPageInfo.a;
			return pi.m0 ? A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pb-8')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('button m-auto button-primary w-full sm:w-40'),
								$elm$html$Html$Events$onClick($author$project$Page$PaymentHistory$ShowMore),
								$elm$html$Html$Attributes$disabled(isLoadingTransfers)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								isLoadingTransfers ? shared.iw.il('menu.loading') : shared.iw.il('payment_history.more'))
							]))
					])) : $elm$html$Html$text('');
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Emoji$alphabet = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890';
var $author$project$Emoji$alphabetEmojiMapper = function () {
	var emojis = '😄 😘 😺 🚀 🚗 🚙 🚚 🌀 🌟 🌴 🌵 🌷 🌸 🌹 🌺 🌻 🌼 🌽 🌿 🍁 🍄 🍅 🍆 🍇 🍈 🍉 🍊 🍌 🍍 🍎 🍏 🍑 🍒 🍓 🍭 🍯 🎀 🎃 🎈 🎨 🎲 🎸 🏡 🐌 🐒 🐚 🐞 🐬 🐱 🐲 🐳 🐴 🐵 🐶 🐸 🐹 💜 😎 🚘 🌳 🍋 🍐';
	return $elm$core$Dict$fromList(
		A3(
			$elm$core$List$map2,
			$elm$core$Tuple$pair,
			A2($elm$core$String$split, '', $author$project$Emoji$alphabet),
			A2($elm$core$String$split, ' ', emojis)));
}();
var $author$project$Transfer$createdTxToString = function (_v0) {
	var tx = _v0;
	return tx;
};
var $pdamoc$elm_hashids$Hashids$ordOfIdx = F2(
	function (i, str) {
		return A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Char$toCode,
				$elm$core$List$head(
					$elm$core$String$toList(
						A2($elm$core$String$dropLeft, i, str)))));
	});
var $pdamoc$elm_hashids$Hashids$forceGet = F2(
	function (i, axs) {
		return A2(
			$elm$core$Maybe$withDefault,
			' ',
			A2($elm$core$Array$get, i, axs));
	});
var $elm$core$Elm$JsArray$unsafeSet = _JsArray_unsafeSet;
var $elm$core$Array$setHelp = F4(
	function (shift, index, value, tree) {
		var pos = $elm$core$Array$bitMask & (index >>> shift);
		var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
		if (!_v0.$) {
			var subTree = _v0.a;
			var newSub = A4($elm$core$Array$setHelp, shift - $elm$core$Array$shiftStep, index, value, subTree);
			return A3(
				$elm$core$Elm$JsArray$unsafeSet,
				pos,
				$elm$core$Array$SubTree(newSub),
				tree);
		} else {
			var values = _v0.a;
			var newLeaf = A3($elm$core$Elm$JsArray$unsafeSet, $elm$core$Array$bitMask & index, value, values);
			return A3(
				$elm$core$Elm$JsArray$unsafeSet,
				pos,
				$elm$core$Array$Leaf(newLeaf),
				tree);
		}
	});
var $elm$core$Array$set = F3(
	function (index, value, array) {
		var len = array.a;
		var startShift = array.b;
		var tree = array.c;
		var tail = array.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? array : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			tree,
			A3($elm$core$Elm$JsArray$unsafeSet, $elm$core$Array$bitMask & index, value, tail)) : A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			A4($elm$core$Array$setHelp, startShift, index, value, tree),
			tail));
	});
var $pdamoc$elm_hashids$Hashids$swap = F3(
	function (i, j, str) {
		var strArray = $elm$core$Array$fromList(
			$elm$core$String$toList(str));
		var jElem = A2($pdamoc$elm_hashids$Hashids$forceGet, j, strArray);
		var iElem = A2($pdamoc$elm_hashids$Hashids$forceGet, i, strArray);
		return $elm$core$String$fromList(
			$elm$core$Array$toList(
				A3(
					$elm$core$Array$set,
					j,
					iElem,
					A3($elm$core$Array$set, i, jElem, strArray))));
	});
var $pdamoc$elm_hashids$Hashids$reorder = F2(
	function (string, salt) {
		var saltLen = $elm$core$String$length(salt);
		var saltArray = $elm$core$Array$fromList(
			$elm$core$String$toList(salt));
		var shuffle = F4(
			function (i, index, integerSum, str) {
				shuffle:
				while (true) {
					if (i > 0) {
						var newIndex = A2($elm$core$Basics$modBy, saltLen, index);
						var integer = $elm$core$Char$toCode(
							A2($pdamoc$elm_hashids$Hashids$forceGet, newIndex, saltArray));
						var newIntegerSum = integerSum + integer;
						var j = A2($elm$core$Basics$modBy, i, (integer + newIndex) + newIntegerSum);
						var newStr = A3($pdamoc$elm_hashids$Hashids$swap, i, j, str);
						var $temp$i = i - 1,
							$temp$index = newIndex + 1,
							$temp$integerSum = newIntegerSum,
							$temp$str = newStr;
						i = $temp$i;
						index = $temp$index;
						integerSum = $temp$integerSum;
						str = $temp$str;
						continue shuffle;
					} else {
						return str;
					}
				}
			});
		var alphaLen = $elm$core$String$length(string);
		return (!saltLen) ? string : A4(shuffle, alphaLen - 1, 0, 0, string);
	});
var $pdamoc$elm_hashids$Hashids$strGet = F2(
	function (i, str) {
		return A2(
			$elm$core$String$left,
			1,
			A2($elm$core$String$dropLeft, i, str));
	});
var $pdamoc$elm_hashids$Hashids$ensureLength = F5(
	function (encoded, minHashLength, alphabet, guards, valuesHash) {
		var splitAt = ($elm$core$String$length(alphabet) / 2) | 0;
		var guardsLen = $elm$core$String$length(guards);
		var guardIndex = A2(
			$elm$core$Basics$modBy,
			guardsLen,
			valuesHash + A2($pdamoc$elm_hashids$Hashids$ordOfIdx, 0, encoded));
		var extend = F2(
			function (encoded_, alpha) {
				extend:
				while (true) {
					var alpha1 = A2($pdamoc$elm_hashids$Hashids$reorder, alpha, alpha);
					var encodedPre = _Utils_ap(
						A2($elm$core$String$dropLeft, splitAt, alpha1),
						_Utils_ap(
							encoded_,
							A2($elm$core$String$left, splitAt, alpha1)));
					var excess = $elm$core$String$length(encodedPre) - minHashLength;
					var fromIndex = (excess / 2) | 0;
					var encoded1 = (excess > 0) ? A2(
						$elm$core$String$left,
						minHashLength,
						A2($elm$core$String$dropLeft, fromIndex, encodedPre)) : encodedPre;
					if (_Utils_cmp(
						$elm$core$String$length(encoded1),
						minHashLength) < 0) {
						var $temp$encoded_ = encoded1,
							$temp$alpha = alpha1;
						encoded_ = $temp$encoded_;
						alpha = $temp$alpha;
						continue extend;
					} else {
						return encoded1;
					}
				}
			});
		var acc = _Utils_ap(
			A2($pdamoc$elm_hashids$Hashids$strGet, guardIndex, guards),
			encoded);
		var guardIndex1 = A2(
			$elm$core$Basics$modBy,
			guardsLen,
			valuesHash + A2($pdamoc$elm_hashids$Hashids$ordOfIdx, 2, acc));
		var acc1 = (_Utils_cmp(
			$elm$core$String$length(acc),
			minHashLength) < 0) ? _Utils_ap(
			acc,
			A2($pdamoc$elm_hashids$Hashids$strGet, guardIndex1, guards)) : acc;
		return A2(extend, acc1, alphabet);
	});
var $elm$core$List$sum = function (numbers) {
	return A3($elm$core$List$foldl, $elm$core$Basics$add, 0, numbers);
};
var $pdamoc$elm_hashids$Hashids$encodeList = F2(
	function (context, numbers) {
		var valuesHash = $elm$core$List$sum(
			A2(
				$elm$core$List$indexedMap,
				F2(
					function (i, n) {
						return A2($elm$core$Basics$modBy, i + 100, n);
					}),
				numbers));
		var _v0 = context;
		var guards = _v0.fT;
		var seps = _v0.gx;
		var salt = _v0.gu;
		var minHashLength = _v0.gd;
		var alphabet = _v0.fo;
		var alphaLen = $elm$core$String$length(alphabet);
		var hash = F3(
			function (value, alpha, acc) {
				hash:
				while (true) {
					var value1 = (value / alphaLen) | 0;
					var alphaLen_ = $elm$core$String$length(alpha);
					var acc1 = _Utils_ap(
						A2(
							$pdamoc$elm_hashids$Hashids$strGet,
							A2($elm$core$Basics$modBy, alphaLen_, value),
							alpha),
						acc);
					if (!value1) {
						return acc1;
					} else {
						var $temp$value = value1,
							$temp$alpha = alpha,
							$temp$acc = acc1;
						value = $temp$value;
						alpha = $temp$alpha;
						acc = $temp$acc;
						continue hash;
					}
				}
			});
		var lottery = A2(
			$pdamoc$elm_hashids$Hashids$strGet,
			A2($elm$core$Basics$modBy, alphaLen, valuesHash),
			alphabet);
		var sepsLen = $elm$core$String$length(seps);
		var go = F2(
			function (_v2, _v3) {
				var i = _v2.a;
				var value = _v2.b;
				var acc = _v3.a;
				var alpha = _v3.b;
				var alphaSalt = A2(
					$elm$core$String$left,
					alphaLen,
					_Utils_ap(
						lottery,
						_Utils_ap(salt, alpha)));
				var alpha1_ = A2($pdamoc$elm_hashids$Hashids$reorder, alpha, alphaSalt);
				var last = A3(hash, value, alpha1_, '');
				var firstCode = A2($pdamoc$elm_hashids$Hashids$ordOfIdx, 0, last);
				var value1 = A2($elm$core$Basics$modBy, firstCode + i, value);
				var sepEnc = A2(
					$pdamoc$elm_hashids$Hashids$strGet,
					A2($elm$core$Basics$modBy, sepsLen, value1),
					seps);
				return _Utils_Tuple2(
					_Utils_ap(
						acc,
						_List_fromArray(
							[
								_Utils_ap(last, sepEnc)
							])),
					alpha1_);
			});
		var _v1 = A3(
			$elm$core$List$foldl,
			go,
			_Utils_Tuple2(
				_List_fromArray(
					[lottery]),
				alphabet),
			A2(
				$elm$core$List$indexedMap,
				F2(
					function (a, b) {
						return _Utils_Tuple2(a, b);
					}),
				numbers));
		var encodedList = _v1.a;
		var alpha1 = _v1.b;
		var encodedPre = $elm$core$String$concat(encodedList);
		var encoded = A2($elm$core$String$dropRight, 1, encodedPre);
		return (_Utils_cmp(
			$elm$core$String$length(encoded),
			minHashLength) > -1) ? encoded : A5($pdamoc$elm_hashids$Hashids$ensureLength, encoded, minHashLength, alpha1, guards, valuesHash);
	});
var $pdamoc$elm_hashids$Hashids$encode = F2(
	function (context, n) {
		return A2(
			$pdamoc$elm_hashids$Hashids$encodeList,
			context,
			_List_fromArray(
				[n]));
	});
var $robinheghan$murmur3$Murmur3$HashData = F4(
	function (shift, seed, hash, charsProcessed) {
		return {cZ: charsProcessed, dg: hash, cI: seed, dU: shift};
	});
var $robinheghan$murmur3$Murmur3$c1 = 3432918353;
var $robinheghan$murmur3$Murmur3$c2 = 461845907;
var $robinheghan$murmur3$Murmur3$multiplyBy = F2(
	function (b, a) {
		return ((a & 65535) * b) + ((((a >>> 16) * b) & 65535) << 16);
	});
var $robinheghan$murmur3$Murmur3$rotlBy = F2(
	function (b, a) {
		return (a << b) | (a >>> (32 - b));
	});
var $robinheghan$murmur3$Murmur3$finalize = function (data) {
	var acc = (!(!data.dg)) ? (data.cI ^ A2(
		$robinheghan$murmur3$Murmur3$multiplyBy,
		$robinheghan$murmur3$Murmur3$c2,
		A2(
			$robinheghan$murmur3$Murmur3$rotlBy,
			15,
			A2($robinheghan$murmur3$Murmur3$multiplyBy, $robinheghan$murmur3$Murmur3$c1, data.dg)))) : data.cI;
	var h0 = acc ^ data.cZ;
	var h1 = A2($robinheghan$murmur3$Murmur3$multiplyBy, 2246822507, h0 ^ (h0 >>> 16));
	var h2 = A2($robinheghan$murmur3$Murmur3$multiplyBy, 3266489909, h1 ^ (h1 >>> 13));
	return (h2 ^ (h2 >>> 16)) >>> 0;
};
var $robinheghan$murmur3$Murmur3$mix = F2(
	function (h1, k1) {
		return A2(
			$robinheghan$murmur3$Murmur3$multiplyBy,
			5,
			A2(
				$robinheghan$murmur3$Murmur3$rotlBy,
				13,
				h1 ^ A2(
					$robinheghan$murmur3$Murmur3$multiplyBy,
					$robinheghan$murmur3$Murmur3$c2,
					A2(
						$robinheghan$murmur3$Murmur3$rotlBy,
						15,
						A2($robinheghan$murmur3$Murmur3$multiplyBy, $robinheghan$murmur3$Murmur3$c1, k1))))) + 3864292196;
	});
var $robinheghan$murmur3$Murmur3$hashFold = F2(
	function (c, data) {
		var res = data.dg | ((255 & $elm$core$Char$toCode(c)) << data.dU);
		var _v0 = data.dU;
		if (_v0 === 24) {
			return {
				cZ: data.cZ + 1,
				dg: 0,
				cI: A2($robinheghan$murmur3$Murmur3$mix, data.cI, res),
				dU: 0
			};
		} else {
			return {cZ: data.cZ + 1, dg: res, cI: data.cI, dU: data.dU + 8};
		}
	});
var $robinheghan$murmur3$Murmur3$hashString = F2(
	function (seed, str) {
		return $robinheghan$murmur3$Murmur3$finalize(
			A3(
				$elm$core$String$foldl,
				$robinheghan$murmur3$Murmur3$hashFold,
				A4($robinheghan$murmur3$Murmur3$HashData, 0, seed, 0, 0),
				str));
	});
var $pdamoc$elm_hashids$Hashids$defaultAlphabet = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890';
var $pdamoc$elm_hashids$Hashids$containsChar = A2($elm$core$Basics$composeL, $elm$core$String$contains, $elm$core$String$fromChar);
var $pdamoc$elm_hashids$Hashids$exclude = F2(
	function (toBeExcluded, from) {
		var member = function (c) {
			return !A2($pdamoc$elm_hashids$Hashids$containsChar, c, toBeExcluded);
		};
		return A2($elm$core$String$filter, member, from);
	});
var $pdamoc$elm_hashids$Hashids$intersect = F2(
	function (first, second) {
		var member = function (c) {
			return A2($pdamoc$elm_hashids$Hashids$containsChar, c, second);
		};
		return A2($elm$core$String$filter, member, first);
	});
var $pdamoc$elm_hashids$Hashids$unique = function (str) {
	var addIfNotMember = F2(
		function (c, xs) {
			return A2($pdamoc$elm_hashids$Hashids$containsChar, c, xs) ? xs : A2($elm$core$String$cons, c, xs);
		});
	return A3($elm$core$String$foldr, addIfNotMember, '', str);
};
var $pdamoc$elm_hashids$Hashids$createHashidsContext = F3(
	function (salt, minHashLen, alphabet) {
		var sepDiv = 3.5;
		var validSeps = function (_v3) {
			var seps = _v3.a;
			var alpha = _v3.b;
			var seps1 = A2($pdamoc$elm_hashids$Hashids$reorder, seps, salt);
			var lenSeps = $elm$core$String$length(seps1);
			var lenAlpha = $elm$core$String$length(alpha);
			var minSeps = $elm$core$Basics$ceiling(lenAlpha / sepDiv);
			if (_Utils_cmp(lenSeps, minSeps) < 0) {
				var minSeps1 = (minSeps === 1) ? 2 : minSeps;
				if (_Utils_cmp(minSeps1, lenSeps) > 0) {
					var splitAt = minSeps1 - lenSeps;
					var seps2 = _Utils_ap(
						seps1,
						A2($elm$core$String$left, splitAt, alpha));
					var alpha1 = A2($elm$core$String$dropLeft, splitAt, alpha);
					return _Utils_Tuple2(seps2, alpha1);
				} else {
					return _Utils_Tuple2(seps1, alpha);
				}
			} else {
				return _Utils_Tuple2(seps1, alpha);
			}
		};
		var minAlphabetLength = 16;
		var guardDiv = 12;
		var withGuard = function (_v2) {
			var seps = _v2.a;
			var alpha = _v2.b;
			var lenAlpha = $elm$core$String$length(alpha);
			var numGuards = $elm$core$Basics$ceiling(lenAlpha / guardDiv);
			var alpha1 = A2($pdamoc$elm_hashids$Hashids$reorder, alpha, salt);
			return (lenAlpha < 3) ? _Utils_Tuple3(
				A2($elm$core$String$dropLeft, numGuards, seps),
				alpha1,
				A2($elm$core$String$left, numGuards, seps)) : _Utils_Tuple3(
				seps,
				A2($elm$core$String$dropLeft, numGuards, alpha1),
				A2($elm$core$String$left, numGuards, alpha1));
		};
		var clean = function (alpha) {
			var seps = 'cfhistuCFHISTU';
			var seps1 = A2($pdamoc$elm_hashids$Hashids$intersect, seps, alpha);
			var hasSpaces = A2($elm$core$String$contains, ' ', alpha);
			var alpha1 = A2(
				$pdamoc$elm_hashids$Hashids$exclude,
				seps1,
				$pdamoc$elm_hashids$Hashids$unique(alpha));
			var alphabetIsSmall = _Utils_cmp(
				$elm$core$String$length(
					_Utils_ap(alpha1, seps1)),
				minAlphabetLength) < 0;
			var _v1 = _Utils_Tuple2(hasSpaces, alphabetIsSmall);
			if (_v1.a) {
				return _Utils_Tuple2(
					seps,
					A2($pdamoc$elm_hashids$Hashids$exclude, seps, $pdamoc$elm_hashids$Hashids$defaultAlphabet));
			} else {
				if (_v1.b) {
					return _Utils_Tuple2(
						seps,
						A2($pdamoc$elm_hashids$Hashids$exclude, seps, $pdamoc$elm_hashids$Hashids$defaultAlphabet));
				} else {
					return _Utils_Tuple2(seps1, alpha1);
				}
			}
		};
		var _v0 = withGuard(
			validSeps(
				clean(alphabet)));
		var seps1b = _v0.a;
		var alphabet1 = _v0.b;
		var guards = _v0.c;
		return {fo: alphabet1, fT: guards, gd: minHashLen, gu: salt, gx: seps1b};
	});
var $author$project$Emoji$salt = 123456;
var $author$project$Emoji$hashidsCtx = A3(
	$pdamoc$elm_hashids$Hashids$createHashidsContext,
	$elm$core$String$fromInt($author$project$Emoji$salt),
	8,
	$author$project$Emoji$alphabet);
var $author$project$Emoji$encode = function (transferId) {
	return A2(
		$elm$core$String$join,
		' ',
		A2(
			$elm$core$List$map,
			function (n) {
				return A2(
					$elm$core$Maybe$withDefault,
					'',
					A2($elm$core$Dict$get, n, $author$project$Emoji$alphabetEmojiMapper));
			},
			A2(
				$elm$core$String$split,
				'',
				A2(
					$pdamoc$elm_hashids$Hashids$encode,
					$author$project$Emoji$hashidsCtx,
					A2(
						$robinheghan$murmur3$Murmur3$hashString,
						$author$project$Emoji$salt,
						$author$project$Transfer$createdTxToString(transferId))))));
};
var $author$project$Page$PaymentHistory$viewTransfer = F2(
	function (shared, payment) {
		var time = A3(
			$thaterikperson$elm_strftime$Strftime$format,
			'%d %b %Y, %H:%M',
			shared.ll,
			$author$project$Utils$fromMaybeDateTime(
				$elm$core$Maybe$Just(payment.fu)));
		var payer = payment.ew;
		var userName = $author$project$Eos$Account$nameToString(payer.fl);
		var avatarImg = A2($author$project$Avatar$view, payer.cV, 'max-w-full max-h-full');
		var amount = $elm$core$String$concat(
			_List_fromArray(
				[
					$elm$core$String$fromFloat(payment.pO),
					' ',
					$author$project$Eos$symbolToSymbolCodeString(payment.b9.e9)
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bg-gray-100 text-center py-6 my-6 rounded-lg')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('rounded-full m-auto overflow-hidden border-white border-2 bg-grey w-14 h-14')
						]),
					_List_fromArray(
						[avatarImg])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-black mt-2')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(userName)
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('uppercase text-gray-900 text-sm my-1')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(time)
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-green text-4xl my-3')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(amount)
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('tracking-widest text-2xl')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Emoji$encode(payment.mp))
						]))
				]));
	});
var $author$project$Page$PaymentHistory$viewTransfers = F2(
	function (shared, model) {
		var _v0 = model.cq;
		if (!_v0.$) {
			var transfers = _v0.a;
			return $elm$core$List$isEmpty(transfers) ? A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-center my-6')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						shared.iw.il('payment_history.no_transfers_found'))
					])) : A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pb-6')
							]),
						A2(
							$elm$core$List$map,
							$author$project$Page$PaymentHistory$viewTransfer(shared),
							transfers)),
						A2($author$project$Page$PaymentHistory$viewPagination, shared, model)
					]));
		} else {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-center h-48')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('m-auto spinner')
							]),
						_List_Nil),
						$elm$html$Html$text(
						shared.iw.il('menu.loading'))
					]));
		}
	});
var $author$project$Page$PaymentHistory$viewUserAutocomplete = F2(
	function (loggedIn, model) {
		return A3(
			$author$project$Form$UserPicker$view,
			A2($author$project$Page$PaymentHistory$userPickerOptions, loggedIn, model.eb),
			A2($author$project$Page$PaymentHistory$userPickerViewConfig, loggedIn.aM, model),
			$author$project$Page$PaymentHistory$GotUserPickerMsg);
	});
var $author$project$Page$PaymentHistory$view = F2(
	function (loggedIn, model) {
		var shared = loggedIn.aM;
		var pageTitle = shared.iw.il('payment_history.title');
		var content = function () {
			var _v0 = model.eZ;
			switch (_v0.$) {
				case 1:
					var profile = _v0.a;
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('bg-white')
							]),
						_List_fromArray(
							[
								$author$project$Page$PaymentHistory$viewSplash(profile),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('mx-4 max-w-md md:m-auto')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$h2,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-center text-black text-2xl')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												shared.iw.il('payment_history.title'))
											])),
										A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												A2($author$project$Page$PaymentHistory$viewUserAutocomplete, loggedIn, model),
												A2($author$project$Page$PaymentHistory$viewDatePicker, shared, model)
											])),
										A2($author$project$Page$PaymentHistory$viewTransfers, shared, model)
									]))
							]));
				case 2:
					var err = _v0.a;
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Page$fullPageGraphQLError,
								shared.iw.il('error.accountNotFound'),
								err)
							]));
				default:
					return $author$project$Page$fullPageLoading(shared);
			}
		}();
		return {mk: content, fb: pageTitle};
	});
var $author$project$Page$Profile$BalanceError = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Profile$GraphqlError = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Profile$ProfileError = function (a) {
	return {$: 0, a: a};
};
var $krisajenkins$remotedata$RemoteData$map3 = F4(
	function (f, a, b, c) {
		return A2(
			$krisajenkins$remotedata$RemoteData$andMap,
			c,
			A2(
				$krisajenkins$remotedata$RemoteData$andMap,
				b,
				A2($krisajenkins$remotedata$RemoteData$map, f, a)));
	});
var $author$project$Page$Profile$Center = 1;
var $author$project$Page$Profile$Top = 0;
var $author$project$Page$Profile$viewDetailsItem = F3(
	function (label, content, verticalAlign) {
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('py-4')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex justify-between'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('items-start', !verticalAlign),
									_Utils_Tuple2('items-center', verticalAlign === 1)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-sm mr-4')
								]),
							_List_fromArray(
								[label])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-indigo-500 font-semibold text-sm text-right')
								]),
							_List_fromArray(
								[content]))
						]))
				]));
	});
var $author$project$Page$Profile$viewAddress = F2(
	function (_v0, address) {
		var t = _v0.il;
		var fullAddress = A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2(
						$elm$core$String$join,
						', ',
						A2(
							$elm$core$List$filter,
							A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
							_List_fromArray(
								[address.g5, address.X, address.l4, address.n_, address.ba, address.ay])))),
					A2($elm$html$Html$br, _List_Nil, _List_Nil),
					$elm$html$Html$text(address.fk)
				]));
		return A3(
			$author$project$Page$Profile$viewDetailsItem,
			$elm$html$Html$text(
				t('Address')),
			fullAddress,
			0);
	});
var $elm$svg$Svg$Attributes$strokeMiterlimit = _VirtualDom_attribute('stroke-miterlimit');
var $author$project$Icons$coin = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('30'),
				$elm$svg$Svg$Attributes$height('43'),
				$elm$svg$Svg$Attributes$viewBox('0 0 30 43'),
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M30 21.1577C30 32.8414 23.284 42.3154 15 42.3154C6.71602 42.3154 0 32.8414 0 21.1577C0 9.47402 6.71602 -2.09352e-08 15 -2.09352e-08C23.284 -2.09352e-08 30 9.47402 30 21.1577Z'),
						$elm$svg$Svg$Attributes$fill('#FFD200')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M24.4496 21.1577C24.4496 28.5224 20.2169 34.4911 14.9977 34.4911C9.77845 34.4911 5.54567 28.5224 5.54567 21.1577C5.54567 13.7929 9.77845 7.82425 14.9977 7.82425C20.2169 7.82425 24.4496 13.7929 24.4496 21.1577Z'),
						$elm$svg$Svg$Attributes$stroke('#228C98'),
						$elm$svg$Svg$Attributes$strokeWidth('0.33'),
						$elm$svg$Svg$Attributes$strokeMiterlimit('10'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M4.31065 6.43094C5.08605 7.5261 6.46263 9.46776 8.15574 11.859'),
						$elm$svg$Svg$Attributes$stroke('#228C98'),
						$elm$svg$Svg$Attributes$strokeWidth('0.33'),
						$elm$svg$Svg$Attributes$strokeMiterlimit('10'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M21.5914 30.8027C23.417 33.3774 24.8402 35.3868 25.4929 36.3062'),
						$elm$svg$Svg$Attributes$stroke('#228C98'),
						$elm$svg$Svg$Attributes$strokeWidth('0.33'),
						$elm$svg$Svg$Attributes$strokeMiterlimit('10'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M4.22958 36.0008C4.99517 34.9207 6.42818 32.9012 8.20717 30.3894'),
						$elm$svg$Svg$Attributes$stroke('#228C98'),
						$elm$svg$Svg$Attributes$strokeWidth('0.33'),
						$elm$svg$Svg$Attributes$strokeMiterlimit('10'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M21.6439 11.4425C23.3713 9.00598 24.7332 7.08441 25.4129 6.12488'),
						$elm$svg$Svg$Attributes$stroke('#228C98'),
						$elm$svg$Svg$Attributes$strokeWidth('0.33'),
						$elm$svg$Svg$Attributes$strokeMiterlimit('10'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_Nil)
			]));
};
var $author$project$Page$Profile$viewHistory = F3(
	function (shared, balance, graphqlInfo) {
		var viewHistoryItem = F3(
			function (title, number, translation) {
				return A2(
					$elm$html$Html$li,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex items-center py-4 text-sm')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex items-center')
								]),
							title),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('ml-auto')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('mr-1 text-indigo-500 font-bold')
										]),
									_List_fromArray(
										[number])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-sm text-gray-900 uppercase')
										]),
									_List_fromArray(
										[translation]))
								]))
						]));
			});
		var _v0 = shared.iw;
		var t = _v0.il;
		var text_ = A2($elm$core$Basics$composeL, $elm$html$Html$text, t);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bg-white px-4 mb-6 md:bg-gray-100')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('container mx-auto w-full self-center divide-y divide-gray-500')
						]),
					_List_fromArray(
						[
							A3(
							viewHistoryItem,
							_List_fromArray(
								[
									$author$project$Icons$coin('mr-2'),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											text_('profile.history.balance')
										]))
								]),
							A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-3xl mr-1')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										A3($author$project$Eos$formatSymbolAmount, shared.iw, balance.lY.e9, balance.lY.lU))
									])),
							$elm$html$Html$text(
								$author$project$Eos$symbolToSymbolCodeString(balance.lY.e9))),
							A3(
							viewHistoryItem,
							_List_fromArray(
								[
									text_('profile.history.transfers_number')
								]),
							$elm$html$Html$text(
								$elm$core$String$fromInt(graphqlInfo.lq)),
							text_('profile.history.transfers')),
							A3(
							viewHistoryItem,
							_List_fromArray(
								[
									text_('profile.history.claims_number')
								]),
							$elm$html$Html$text(
								$elm$core$String$fromInt(graphqlInfo.lo)),
							text_('profile.history.claims')),
							A3(
							viewHistoryItem,
							_List_fromArray(
								[
									text_('profile.history.products')
								]),
							$elm$html$Html$text(
								$elm$core$String$fromInt(graphqlInfo.lp)),
							text_('profile.history.items')),
							function () {
							var _v1 = graphqlInfo.g6;
							if (!_v1.$) {
								var createdDate = _v1.a;
								return A3(
									viewHistoryItem,
									_List_fromArray(
										[
											text_('profile.history.registration_date')
										]),
									A4(
										$author$project$View$Components$dateViewer,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('capitalize -mr-1')
											]),
										$elm$core$Basics$identity,
										shared,
										createdDate),
									$elm$html$Html$text(''));
							} else {
								return $elm$html$Html$text('');
							}
						}(),
							A3(
							viewHistoryItem,
							_List_fromArray(
								[
									text_('profile.history.last_transaction')
								]),
							A4(
								$author$project$View$Components$dateViewer,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('capitalize -mr-1')
									]),
								$elm$core$Basics$identity,
								shared,
								balance.nE),
							$elm$html$Html$text(''))
						]))
				]));
	});
var $author$project$Page$Profile$viewKycInfo = function (kyc) {
	var documentLabel = function () {
		var _v0 = kyc.er;
		switch (_v0) {
			case 'cedula_de_identidad':
				return 'Cédula de identidad';
			case 'dimex':
				return 'DIMEX';
			case 'nite':
				return 'NITE';
			case 'gran_empresa':
				return 'Gran Empresa';
			case 'mipyme':
				return 'MIPYME';
			default:
				return 'Unknown Document';
		}
	}();
	return A3(
		$author$project$Page$Profile$viewDetailsItem,
		$elm$html$Html$text(documentLabel),
		$elm$html$Html$text(kyc.eq),
		1);
};
var $author$project$Page$Profile$RequestedMoreTransfers = {$: 7};
var $author$project$View$Components$TrackSelector = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$viewCardEmpty = function (content) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('rounded-lg bg-white mt-5 p-4')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('bg-white-smoke flex items-center justify-center p-8')
					]),
				content)
			]));
};
var $author$project$Page$Profile$ClickedTransferCard = function (a) {
	return {$: 6, a: a};
};
var $author$project$Page$Profile$GotTransferCardProfileSummaryMsg = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Transfer$view = F6(
	function (loggedIn, transfer, profileSummary, profileSummaryToMsg, onClickMsg, attrs) {
		var _v0 = loggedIn.aM.iw;
		var t = _v0.il;
		var _v1 = _Utils_eq(transfer.ew.fl, loggedIn.lM) ? _Utils_Tuple2(transfer.fc, true) : _Utils_Tuple2(transfer.ew, false);
		var otherProfile = _v1.a;
		var isFromUser = _v1.b;
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('flex hover:bg-gray-100 p-4 cursor-pointer'),
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Events$onClick(onClickMsg),
					attrs)),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					profileSummaryToMsg,
					A4(
						$author$project$Profile$Summary$view,
						loggedIn.aM.iw,
						loggedIn.lM,
						otherProfile,
						A2(
							$author$project$Profile$Summary$withImageSize,
							'w-14 h-14',
							$author$project$Profile$Summary$withoutName(profileSummary)))),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('ml-4 w-full overflow-ellipsis overflow-hidden')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('font-sm flex flex-wrap'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('text-gray-333', isFromUser),
											_Utils_Tuple2('text-indigo-500', !isFromUser)
										]))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('mr-1')
										]),
									_List_fromArray(
										[
											isFromUser ? $elm$html$Html$text(
											t('transfer.sent_to')) : $elm$html$Html$text(
											t('transfer.received_from'))
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('font-bold')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$elm$core$Maybe$withDefault,
												$author$project$Eos$Account$nameToString(otherProfile.fl),
												otherProfile.ki))
										]))
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('text-gray-333', isFromUser),
											_Utils_Tuple2('text-indigo-500', !isFromUser)
										]))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('font-bold text-lg')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A3($author$project$Eos$formatSymbolAmount, loggedIn.aM.iw, transfer.b9.e9, transfer.pO))
										])),
									$elm$html$Html$text(' '),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-sm')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Eos$symbolToSymbolCodeString(transfer.b9.e9))
										]))
								])),
							function () {
							var _v2 = transfer.ka;
							if (_v2.$ === 1) {
								return $elm$html$Html$text('');
							} else {
								var memo = _v2.a;
								return A2(
									$author$project$Markdown$view,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-sm text-gray-900 break-all')
										]),
									memo);
							}
						}()
						]))
				]));
	});
var $author$project$Page$Profile$viewTransactionList = F2(
	function (loggedIn, transfers) {
		return A2(
			$elm$core$List$map,
			function (_v2) {
				var first = _v2.a;
				var t1 = first.a;
				var rest = _v2.b;
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mt-4')
								]),
							_List_fromArray(
								[
									A4(
									$author$project$View$Components$dateViewer,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('uppercase text-sm text-black tracking-wide')
										]),
									$elm$core$Basics$identity,
									loggedIn.aM,
									$author$project$Utils$fromDateTime(t1.fu))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('divide-y divide-gray-500')
								]),
							A2(
								$elm$core$List$map,
								function (_v3) {
									var transfer = _v3.a;
									var profileSummary = _v3.b;
									return A6(
										$author$project$Transfer$view,
										loggedIn,
										transfer,
										A2(
											$author$project$Profile$Summary$withScrollSelector,
											'#transfer-scroll-container',
											A2($author$project$Profile$Summary$withRelativeSelector, '#transfer-relative-container', profileSummary)),
										$author$project$Page$Profile$GotTransferCardProfileSummaryMsg(transfer.R),
										$author$project$Page$Profile$ClickedTransferCard(transfer.R),
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('md:hover:bg-gray-200')
											]));
								},
								A2($elm$core$List$cons, first, rest)))
						]));
			},
			A2(
				$elm_community$list_extra$List$Extra$groupWhile,
				F2(
					function (_v0, _v1) {
						var t1 = _v0.a;
						var t2 = _v1.a;
						return A3(
							$author$project$Utils$areSameDay,
							loggedIn.aM.ll,
							$author$project$Utils$fromDateTime(t1.fu),
							$author$project$Utils$fromDateTime(t2.fu));
					}),
				transfers));
	});
var $author$project$Page$Profile$viewLatestTransactions = F2(
	function (loggedIn, model) {
		var viewInfiniteList = F2(
			function (maybePageInfo, children) {
				var viewList = function (isMobile) {
					return A3(
						$author$project$View$Components$infiniteList,
						{
							mB: 1000,
							mG: isMobile ? $author$project$View$Components$TrackWindow : $author$project$View$Components$TrackSelector('#transfer-scroll-container'),
							ol: A2(
								$elm$core$Maybe$andThen,
								function (pageInfo) {
									return pageInfo.m0 ? $elm$core$Maybe$Just($author$project$Page$Profile$RequestedMoreTransfers) : $elm$core$Maybe$Nothing;
								},
								maybePageInfo)
						},
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('w-full mt-2 divide-y divide-gray-500'),
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('hidden md:block', !isMobile),
										_Utils_Tuple2('md:hidden', isMobile)
									]))
							]),
						children);
				};
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							viewList(true),
							viewList(false)
						]));
			});
		var text_ = A2($elm$core$Basics$composeL, $elm$html$Html$text, loggedIn.aM.iw.il);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('p-4 bg-white max-w-screen md:px-3 md:bg-transparent')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('container mx-auto w-full')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-lg')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-gray-900 font-light')
										]),
									_List_fromArray(
										[
											text_('transfer.transfers_latest')
										])),
									$elm$html$Html$text(' '),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-indigo-500 font-semibold')
										]),
									_List_fromArray(
										[
											text_('transfer.transfers')
										]))
								])),
							function () {
							var _v0 = model.aO;
							switch (_v0.$) {
								case 2:
									return $author$project$Page$viewCardEmpty(
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('text-gray-900 text-sm')
													]),
												_List_fromArray(
													[
														text_('transfer.loading_error')
													]))
											]));
								case 1:
									var transfers = _v0.a;
									return A2(
										viewInfiniteList,
										$elm$core$Maybe$Nothing,
										_Utils_ap(
											A2($author$project$Page$Profile$viewTransactionList, loggedIn, transfers),
											_List_fromArray(
												[
													A2($author$project$View$Components$loadingLogoAnimated, loggedIn.aM.iw, '')
												])));
								default:
									var transfers = _v0.a;
									var maybePageInfo = _v0.b;
									return A2(
										viewInfiniteList,
										maybePageInfo,
										A2($author$project$Page$Profile$viewTransactionList, loggedIn, transfers));
							}
						}()
						]))
				]));
	});
var $author$project$Page$Profile$viewDetails = F5(
	function (loggedIn, profile, balance, graphqlInfo, model) {
		var text_ = A2($elm$core$Basics$composeL, $elm$html$Html$text, loggedIn.aM.iw.il);
		var isProfileOwner = _Utils_eq(loggedIn.lM, profile.fl);
		var isCommunityAdmin = function () {
			var _v2 = loggedIn.o7;
			if (_v2.$ === 3) {
				var community = _v2.a;
				return _Utils_eq(community.mq, loggedIn.lM);
			} else {
				return false;
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bg-gray-100 w-full md:flex md:flex-col')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('md:flex-basis-0 md:flex-grow-1 md:overflow-y-auto'),
							$elm$html$Html$Attributes$id('transfer-scroll-container'),
							$elm$html$Html$Attributes$tabindex(-1)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('w-full bg-white md:bg-gray-100')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('px-4')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$ul,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('container mx-auto divide-y divide-gray-500 w-full mb-4 bg-white md:bg-gray-100')
												]),
											_List_fromArray(
												[
													A3(
													$author$project$Page$Profile$viewDetailsItem,
													text_('profile.locations'),
													$elm$html$Html$text(
														A2($elm$core$Maybe$withDefault, '', profile.nM)),
													1),
													function () {
													var _v0 = profile.gP;
													if (!_v0.$) {
														var address = _v0.a;
														return A2($author$project$Page$Profile$viewAddress, loggedIn.aM.iw, address);
													} else {
														return $elm$html$Html$text('');
													}
												}(),
													A3(
													$author$project$Page$Profile$viewDetailsItem,
													text_('profile.interests'),
													$elm$html$Html$text(
														A2($elm$core$String$join, ', ', profile.dj)),
													0),
													isProfileOwner ? A3(
													$author$project$Page$Profile$viewDetailsItem,
													text_('contact_form.options'),
													A2(
														$elm$html$Html$a,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('button-secondary button-sm uppercase cursor-pointer'),
																$author$project$Route$href($author$project$Route$ProfileAddContact)
															]),
														_List_fromArray(
															[
																$elm$core$List$isEmpty(profile.aq) ? text_('menu.add') : text_('menu.edit')
															])),
													1) : $elm$html$Html$text(''),
													function () {
													if (isProfileOwner) {
														var _v1 = profile.hx;
														if (!_v1.$) {
															var kyc = _v1.a;
															return $author$project$Page$Profile$viewKycInfo(kyc);
														} else {
															return $elm$html$Html$text('');
														}
													} else {
														return $elm$html$Html$text('');
													}
												}()
												]))
										]))
								])),
							(isProfileOwner || isCommunityAdmin) ? A3($author$project$Page$Profile$viewHistory, loggedIn.aM, balance, graphqlInfo) : $elm$html$Html$text(''),
							(isProfileOwner || isCommunityAdmin) ? A2($author$project$Page$Profile$viewLatestTransactions, loggedIn, model) : $elm$html$Html$text('')
						]))
				]));
	});
var $author$project$Eos$Explorer$Profile = function (a) {
	return {$: 0, a: a};
};
var $author$project$Profile$Contact$contactTypeTextColor = function (contactType) {
	switch (contactType) {
		case 3:
			return 'text-phone';
		case 1:
			return 'text-instagram';
		case 4:
			return 'text-telegram';
		case 5:
			return 'text-whatsapp';
		case 0:
			return 'text-orange-300';
		default:
			return 'text-orange-300';
	}
};
var $author$project$Eos$Explorer$baseUrl = 'https://local.bloks.io';
var $author$project$Eos$Explorer$coreSymbol = function (environment) {
	switch (environment) {
		case 0:
			return 'SYS';
		case 1:
			return 'SYS';
		case 2:
			return 'SYS';
		default:
			return 'EOS';
	}
};
var $author$project$Eos$Explorer$nodeUrl = function (environment) {
	switch (environment) {
		case 0:
			return 'https://staging.cambiatus.io';
		case 1:
			return 'https://staging.cambiatus.io';
		case 2:
			return 'https://demo.cambiatus.io';
		default:
			return 'https://app.cambiatus.io';
	}
};
var $author$project$Eos$Explorer$path = function (subject) {
	if (!subject.$) {
		var accountName = subject.a;
		return _List_fromArray(
			[
				'account',
				$author$project$Eos$Account$nameToString(accountName)
			]);
	} else {
		var createdTx = subject.a;
		return _List_fromArray(
			[
				'transaction',
				$author$project$Transfer$createdTxToString(createdTx)
			]);
	}
};
var $author$project$Eos$Explorer$link = F2(
	function (environment, subject) {
		return A3(
			$elm$url$Url$Builder$crossOrigin,
			$author$project$Eos$Explorer$baseUrl,
			$author$project$Eos$Explorer$path(subject),
			_List_fromArray(
				[
					A2(
					$elm$url$Url$Builder$string,
					'nodeUrl',
					$author$project$Eos$Explorer$nodeUrl(environment)),
					A2($elm$url$Url$Builder$string, 'systemDomain', 'eosio'),
					A2(
					$elm$url$Url$Builder$string,
					'coreSymbol',
					$author$project$Eos$Explorer$coreSymbol(environment))
				]));
	});
var $author$project$Page$Profile$viewProfile = F2(
	function (loggedIn, profile) {
		var text_ = A2($elm$core$Basics$composeL, $elm$html$Html$text, loggedIn.aM.iw.il);
		var isProfileOwner = _Utils_eq(loggedIn.lM, profile.fl);
		var email = A2($elm$core$Maybe$withDefault, '', profile.jh);
		var blockExplorerButton = A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('button w-full mt-4'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('button-primary', isProfileOwner),
							_Utils_Tuple2('button-secondary', !isProfileOwner)
						])),
					$elm$html$Html$Attributes$target('_blank'),
					$elm$html$Html$Attributes$href(
					A2(
						$author$project$Eos$Explorer$link,
						loggedIn.aM.mK,
						$author$project$Eos$Explorer$Profile(profile.fl)))
				]),
			_List_fromArray(
				[
					text_('block_explorer.see')
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bg-white border-white border-r w-full flex md:border-gray-500')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('w-full p-4 max-w-screen container mx-auto self-center md:max-w-lg')
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pb-4 w-full')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('flex flex-wrap items-center justify-center mb-4')
										]),
									_List_fromArray(
										[
											A2($author$project$Avatar$view, profile.cV, 'w-20 h-20 mr-6 xs-max:w-16 xs-max:h-16 xs-max:mr-3'),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('flex flex-grow items-center justify-between')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$ul,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('text-sm text-gray-900')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$li,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('font-semibold text-body-black text-2xl xs-max:text-xl')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	A2($elm$core$Maybe$withDefault, '', profile.ki))
																])),
															A2(
															$elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$a,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$href('mailto:' + email)
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(email)
																		]))
																])),
															A2(
															$elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Eos$Account$nameToString(profile.fl))
																]))
														]))
												])),
											isProfileOwner ? A2(
											$elm$html$Html$a,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('ml-2 fill-current text-orange-300 hover:text-orange-100'),
													$author$project$Route$href($author$project$Route$ProfileEditor)
												]),
											_List_fromArray(
												[
													$author$project$Icons$edit('')
												])) : $elm$html$Html$text('')
										])),
									function () {
									var _v0 = profile.cW;
									if (_v0.$ === 1) {
										return $elm$html$Html$text('');
									} else {
										var bio = _v0.a;
										return A2(
											$author$project$Markdown$view,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('text-sm text-gray-900')
												]),
											bio);
									}
								}()
								])),
						isProfileOwner ? _List_fromArray(
							[blockExplorerButton]) : _List_fromArray(
							[
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('button button-primary w-full mt-4'),
										$author$project$Route$href(
										$author$project$Route$Transfer(
											$elm$core$Maybe$Just(profile.fl)))
									]),
								_List_fromArray(
									[
										text_('transfer.title')
									])),
								blockExplorerButton,
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('flex flex-col space-y-4 mt-4 mb-2')
									]),
								A2(
									$elm$core$List$map,
									function (contact) {
										var _v1 = $author$project$Profile$Contact$unwrap(contact);
										var contactType = _v1.mf;
										var contactClass = function () {
											if (contactType === 5) {
												return 'fill-current text-green';
											} else {
												return '';
											}
										}();
										return A2(
											$elm$html$Html$a,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class(
													'button-secondary uppercase bg-gray-100 py-2 flex items-center justify-center border-none hover:bg-gray-200 ' + $author$project$Profile$Contact$contactTypeTextColor(contactType)),
													$author$project$Profile$Contact$toHref(contact),
													$elm$html$Html$Attributes$target('_blank')
												]),
											_List_fromArray(
												[
													A3($author$project$Profile$Contact$contactTypeToIcon, 'mr-2 w-6 h-6 ' + contactClass, true, contactType),
													$elm$html$Html$text(
													A2($author$project$Profile$Contact$contactTypeToString, loggedIn.aM.iw, contactType))
												]));
									},
									profile.aq))
							])))
				]));
	});
var $author$project$Page$Profile$view_ = F5(
	function (loggedIn, model, profile, balance, graphqlInfo) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-grow bg-gray-100 relative'),
					$elm$html$Html$Attributes$id('transfer-relative-container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('z-10 w-full bg-grey-100 grid md:grid-cols-2 md:container md:mx-auto')
						]),
					_List_fromArray(
						[
							A2($author$project$Page$Profile$viewProfile, loggedIn, profile),
							A5($author$project$Page$Profile$viewDetails, loggedIn, profile, balance, graphqlInfo, model)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('z-0 absolute w-full h-full md:w-1/2 md:bg-white')
						]),
					_List_Nil)
				]));
	});
var $author$project$Page$Profile$view = F2(
	function (loggedIn, model) {
		var title = function () {
			var _v3 = model.kJ;
			if (_v3.$ === 3) {
				var profile = _v3.a;
				return A2(
					$elm$core$Maybe$withDefault,
					$author$project$Eos$Account$nameToString(model.oS),
					profile.ki);
			} else {
				return $author$project$Eos$Account$nameToString(model.oS);
			}
		}();
		var combinedRemoteData = A4(
			$krisajenkins$remotedata$RemoteData$map3,
			F3(
				function (profile, balance, graphqlInfo) {
					return {b5: balance, bF: graphqlInfo, kJ: profile};
				}),
			A2($krisajenkins$remotedata$RemoteData$mapError, $author$project$Page$Profile$ProfileError, model.kJ),
			A2($krisajenkins$remotedata$RemoteData$mapError, $author$project$Page$Profile$BalanceError, model.b5),
			A2($krisajenkins$remotedata$RemoteData$mapError, $author$project$Page$Profile$GraphqlError, model.bF));
		var _v0 = loggedIn.aM.iw;
		var t = _v0.il;
		var content = function () {
			switch (combinedRemoteData.$) {
				case 3:
					var profile = combinedRemoteData.a.kJ;
					var balance = combinedRemoteData.a.b5;
					var graphqlInfo = combinedRemoteData.a.bF;
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex flex-grow flex-col')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Page$viewHeader,
								loggedIn,
								t('menu.profile')),
								A5($author$project$Page$Profile$view_, loggedIn, model, profile, balance, graphqlInfo)
							]));
				case 2:
					var error = combinedRemoteData.a;
					_v2$3:
					while (true) {
						switch (error.$) {
							case 0:
								if (error.a.$ === 1) {
									var graphqlError = error.a.a;
									return A2(
										$author$project$Page$fullPageGraphQLError,
										t('error.unknown'),
										graphqlError);
								} else {
									break _v2$3;
								}
							case 1:
								if (error.a.$ === 1) {
									var httpError = error.a.a;
									return A2(
										$author$project$Page$fullPageError,
										t('error.unknown'),
										httpError);
								} else {
									break _v2$3;
								}
							default:
								if (error.a.$ === 1) {
									var graphqlError = error.a.a;
									return A2(
										$author$project$Page$fullPageGraphQLError,
										t('error.unknown'),
										graphqlError);
								} else {
									break _v2$3;
								}
						}
					}
					return A2(
						$author$project$Page$fullPageNotFound,
						t('error.unknown'),
						t('error.pageNotFound'));
				case 0:
					return $author$project$Page$fullPageLoading(loggedIn.aM);
				default:
					return $author$project$Page$fullPageLoading(loggedIn.aM);
			}
		}();
		return {mk: content, fb: title};
	});
var $author$project$Page$Profile$AddContact$view = F2(
	function (loggedIn, model) {
		var shared = loggedIn.aM;
		return {
			mk: A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('bg-white pb-8')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Page$viewHeader,
						loggedIn,
						shared.iw.il('contact_form.options')),
						function () {
						switch (model.$) {
							case 3:
								var contacts = model.a;
								return A2(
									$elm$html$Html$map,
									$author$project$Page$Profile$AddContact$GotContactMsg,
									A2($author$project$Profile$Contact$view, shared.iw, contacts));
							case 1:
								return $author$project$Page$fullPageLoading(shared);
							case 2:
								var err = model.a;
								return A2($author$project$Page$fullPageError, err, $elm$http$Http$NetworkError);
							default:
								return $elm$html$Html$text('');
						}
					}()
					])),
			fb: shared.iw.il('contact_form.options')
		};
	});
var $author$project$Page$Profile$AddKyc$view = F2(
	function (loggedIn, model) {
		var _v0 = loggedIn.aM.iw;
		var t = _v0.il;
		var pageTitle = t('community.kyc.add.title');
		var content = function () {
			var _v1 = loggedIn.kJ;
			switch (_v1.$) {
				case 1:
					return $author$project$Page$fullPageLoading(loggedIn.aM);
				case 0:
					return $author$project$Page$fullPageLoading(loggedIn.aM);
				case 2:
					var e = _v1.a;
					return A2($author$project$Page$fullPageGraphQLError, pageTitle, e);
				default:
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('bg-white')
							]),
						_List_fromArray(
							[
								A2($author$project$Page$viewHeader, loggedIn, pageTitle),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('px-4')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$elm$core$Basics$identity,
										A2($author$project$Profile$EditKycForm$view, loggedIn.aM.iw, model))
									]))
							]));
			}
		}();
		return {mk: content, fb: pageTitle};
	});
var $author$project$Page$Profile$Claims$ClaimMsg = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Page$Profile$Claims$viewClaimPhotoModal = F2(
	function (loggedIn, model) {
		var _v0 = model.iZ;
		if (!_v0.$) {
			var claim = _v0.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Page$Profile$Claims$ClaimMsg(0),
				A2($author$project$Claim$viewPhotoModal, loggedIn, claim));
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Page$Profile$Claims$Approved = 1;
var $author$project$Page$Profile$Claims$ClickedApplyFilters = {$: 9};
var $author$project$Page$Profile$Claims$ClosedFilterModal = {$: 6};
var $author$project$Page$Profile$Claims$Completed = 3;
var $author$project$Page$Profile$Claims$Disapproved = 2;
var $author$project$Page$Profile$Claims$NoOp = {$: 0};
var $author$project$Page$Profile$Claims$SelectedStatusFilter = function (a) {
	return {$: 8, a: a};
};
var $author$project$Page$Profile$Claims$viewFiltersModal = F2(
	function (shared, model) {
		var statusFilterToString = function (statusFilter) {
			switch (statusFilter) {
				case 0:
					return 'all';
				case 1:
					return 'approved';
				case 2:
					return 'disapproved';
				default:
					return 'completed';
			}
		};
		var _v0 = shared.iw;
		var t = _v0.il;
		return $author$project$View$Modal$toHtml(
			A2(
				$author$project$View$Modal$withBody,
				_List_fromArray(
					[
						function (options) {
						return A2(
							$author$project$Form$Select$view,
							options,
							{
								mM: $elm$html$Html$text(''),
								m$: false,
								nx: false,
								od: $author$project$Page$Profile$Claims$NoOp,
								kv: $author$project$Page$Profile$Claims$SelectedStatusFilter,
								pO: model.es
							});
					}(
						A2(
							$author$project$Form$Select$withContainerAttrs,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mb-10')
								]),
							A3(
								$author$project$Form$Select$withOption,
								3,
								t('community.actions.completed'),
								A3(
									$author$project$Form$Select$withOption,
									2,
									t('all_analysis.disapproved'),
									A3(
										$author$project$Form$Select$withOption,
										1,
										t('all_analysis.approved'),
										A3(
											$author$project$Form$Select$withOption,
											0,
											t('all_analysis.all'),
											$author$project$Form$Select$init(
												{
													R: 'status-filter-select',
													nC: t('all_analysis.filter.status.label'),
													dG: statusFilterToString
												}))))))),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('button button-primary w-full'),
								$elm$html$Html$Events$onClick($author$project$Page$Profile$Claims$ClickedApplyFilters)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								t('all_analysis.filter.apply'))
							]))
					]),
				A2(
					$author$project$View$Modal$withHeader,
					t('all_analysis.filter.title'),
					$author$project$View$Modal$initWith(
						{i$: $author$project$Page$Profile$Claims$ClosedFilterModal, jW: model.dX}))));
	});
var $author$project$Page$Profile$Claims$ClickedAcceptCodeOfConduct = {$: 10};
var $author$project$Page$Profile$Claims$OpenedFilterModal = {$: 5};
var $author$project$Page$Profile$Claims$ToggledSorting = {$: 7};
var $author$project$Icons$sortAscending = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('20'),
				$elm$svg$Svg$Attributes$height('20'),
				$elm$svg$Svg$Attributes$viewBox('0 0 20 20'),
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M11.1567 6.8125C11.2813 6.6875 11.406 6.5 11.406 6.25C11.406 6.0625 11.3436 5.875 11.1567 5.6875L6.66978 1.1875L2.18287 5.6875C1.99591 5.875 1.93359 6.0625 1.93359 6.25C1.93359 6.4375 1.99591 6.625 2.18287 6.8125C2.3075 6.9375 2.49446 7.0625 2.74373 7.0625C2.93069 7.0625 3.11764 7 3.30459 6.8125L5.92196 4.1875V10.75C5.92196 11.1875 6.29587 11.5 6.66978 11.5C7.04369 11.5 7.4176 11.125 7.4176 10.75V4.125L10.035 6.75C10.4089 7.0625 10.9074 7.0625 11.1567 6.8125Z'),
						$elm$svg$Svg$Attributes$fill('#F99D33')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M17.7626 12.75C17.451 12.4375 16.9525 12.4375 16.7032 12.75L14.0858 15.375V8.8125C14.0858 8.375 13.7119 8.0625 13.338 8.0625C12.9641 8.0625 12.4655 8.375 12.4655 8.8125V15.375L9.84817 12.75C9.53658 12.4375 9.03804 12.4375 8.78876 12.75C8.66413 12.875 8.53949 13.0625 8.53949 13.3125C8.53949 13.5625 8.60181 13.6875 8.78876 13.875L13.2757 18.375L17.7626 13.875C17.8872 13.75 18.0119 13.5625 18.0119 13.3125C18.0119 13.0625 17.9495 12.875 17.7626 12.75Z'),
						$elm$svg$Svg$Attributes$fill('#F99D33')
					]),
				_List_Nil)
			]));
};
var $author$project$Icons$sortDescending = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('16'),
				$elm$svg$Svg$Attributes$height('18'),
				$elm$svg$Svg$Attributes$viewBox('0 0 16 18'),
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M0.249315 4.6875C0.124678 4.8125 4.24261e-05 5 4.24042e-05 5.25C4.23879e-05 5.4375 0.0623602 5.625 0.249315 5.8125L4.73623 10.3125L9.22314 5.8125C9.41009 5.625 9.47241 5.4375 9.47241 5.25C9.47241 5.0625 9.41009 4.875 9.22314 4.6875C9.0985 4.5625 8.91155 4.4375 8.66228 4.4375C8.47532 4.4375 8.28837 4.5 8.10141 4.6875L5.48405 7.3125L5.48405 0.749998C5.48405 0.312498 5.11014 -1.33504e-06 4.73623 -1.36772e-06C4.36232 -1.40041e-06 3.98841 0.374998 3.98841 0.749998L3.98841 7.375L1.37104 4.75C0.997134 4.4375 0.498588 4.4375 0.249315 4.6875Z'),
						$elm$svg$Svg$Attributes$fill('#F99D33')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M6.24931 12.625C6.56091 12.9375 7.05945 12.9375 7.30872 12.625L9.92609 10L9.92609 16.5625C9.92609 17 10.3 17.3125 10.6739 17.3125C11.0478 17.3125 11.5464 17 11.5464 16.5625L11.5464 10L14.1637 12.625C14.4753 12.9375 14.9739 12.9375 15.2231 12.625C15.3478 12.5 15.4724 12.3125 15.4724 12.0625C15.4724 11.8125 15.4101 11.6875 15.2231 11.5L10.7362 7L6.24931 11.5C6.12468 11.625 6.00004 11.8125 6.00004 12.0625C6.00004 12.3125 6.06236 12.5 6.24931 12.625Z'),
						$elm$svg$Svg$Attributes$fill('#F99D33')
					]),
				_List_Nil)
			]));
};
var $author$project$Page$Profile$Claims$viewFilterAndOrder = F2(
	function (shared, model) {
		var viewButton = F3(
			function (label, icon, onClickMsg) {
				return A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('button button-secondary flex-grow-1 justify-between pl-4'),
							$elm$html$Html$Events$onClick(onClickMsg)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							shared.iw.il(label)),
							icon
						]));
			});
		var showFilters = function () {
			var _v2 = model.cJ;
			if (!_v2) {
				return false;
			} else {
				return true;
			}
		}();
		var _v0 = function () {
			var _v1 = model.dH;
			if (!_v1) {
				return _Utils_Tuple2($author$project$Icons$sortAscending, 'all_analysis.filter.sort.asc');
			} else {
				return _Utils_Tuple2($author$project$Icons$sortDescending, 'all_analysis.filter.sort.desc');
			}
		}();
		var filterDirectionIcon = _v0.a;
		var filterDirectionLabel = _v0.b;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('w-full md:w-2/3 xl:w-1/3 mx-auto mt-4 mb-6 flex space-x-4'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('sm:w-1/2 md:w-2/6 xl:w-1/6', !showFilters)
						]))
				]),
			_List_fromArray(
				[
					showFilters ? A3(
					viewButton,
					'all_analysis.filter.title',
					$author$project$Icons$arrowDown('fill-current'),
					$author$project$Page$Profile$Claims$OpenedFilterModal) : $elm$html$Html$text(''),
					A3(
					viewButton,
					filterDirectionLabel,
					filterDirectionIcon('mr-2'),
					$author$project$Page$Profile$Claims$ToggledSorting)
				]));
	});
var $author$project$Session$LoggedIn$codeOfConductUrl = function (language) {
	var defaultEndpoint = '/code-of-conduct';
	var endpoint = function () {
		switch (language) {
			case 0:
				return defaultEndpoint;
			case 1:
				return '/pt-br/codigo-de-conduta';
			case 2:
				return '/es/codigo-de-conducta';
			case 3:
				return defaultEndpoint;
			default:
				return defaultEndpoint;
		}
	}();
	var baseUrl = 'https://www.cambiatus.com';
	return _Utils_ap(baseUrl, endpoint);
};
var $author$project$Icons$lamp = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('28'),
				$elm$svg$Svg$Attributes$height('28'),
				$elm$svg$Svg$Attributes$viewBox('0 0 28 28'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M13.7472 5.125C14.166 5.125 14.5056 4.78921 14.5056 4.375V3.375C14.5056 2.96079 14.166 2.625 13.7472 2.625C13.3284 2.625 12.9889 2.96079 12.9889 3.375V4.375C12.9889 4.78921 13.3284 5.125 13.7472 5.125Z'),
						$elm$svg$Svg$Attributes$fill('black')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M24.6166 11.875H23.6055C23.1867 11.875 22.8472 12.2108 22.8472 12.625C22.8472 13.0392 23.1867 13.375 23.6055 13.375H24.6166C25.0354 13.375 25.3749 13.0392 25.3749 12.625C25.3749 12.2108 25.0354 11.875 24.6166 11.875Z'),
						$elm$svg$Svg$Attributes$fill('black')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M5.15278 12.625C5.15278 12.2108 4.81326 11.875 4.39444 11.875H3.38333C2.96452 11.875 2.625 12.2108 2.625 12.625C2.625 13.0392 2.96452 13.375 3.38333 13.375H4.39444C4.81326 13.375 5.15278 13.0392 5.15278 12.625Z'),
						$elm$svg$Svg$Attributes$fill('black')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M20.7897 7.65504C20.9907 7.65487 21.1835 7.57574 21.3256 7.43504L22.0434 6.73004C22.3219 6.43453 22.3137 5.97403 22.0249 5.68842C21.7361 5.40281 21.2705 5.39468 20.9717 5.67004L20.2538 6.37504C20.0372 6.58953 19.9724 6.91188 20.0897 7.19197C20.207 7.47205 20.4832 7.65478 20.7897 7.65504Z'),
						$elm$svg$Svg$Attributes$fill('black')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M7.24075 6.37504L6.52287 5.67004C6.22407 5.39468 5.75846 5.40281 5.46967 5.68842C5.18088 5.97403 5.17267 6.43453 5.45109 6.73004L6.16898 7.43504C6.46777 7.7104 6.93339 7.70228 7.22217 7.41666C7.51096 7.13105 7.51917 6.67055 7.24075 6.37504Z'),
						$elm$svg$Svg$Attributes$fill('black')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M22.3417 18.3751C22.0429 18.0998 21.5773 18.1079 21.2885 18.3935C20.9997 18.6791 20.9915 19.1396 21.2699 19.4351L21.9878 20.1401C22.2866 20.4155 22.7522 20.4074 23.041 20.1217C23.3298 19.8361 23.338 19.3756 23.0596 19.0801L22.3417 18.3751Z'),
						$elm$svg$Svg$Attributes$fill('black')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M5.15274 18.3751L4.43485 19.0801C4.15643 19.3756 4.16465 19.8361 4.45343 20.1217C4.74222 20.4074 5.20784 20.4155 5.50663 20.1401L6.22452 19.4351C6.50294 19.1396 6.49472 18.6791 6.20594 18.3935C5.91715 18.1079 5.45153 18.0998 5.15274 18.3751Z'),
						$elm$svg$Svg$Attributes$fill('black')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M21.0778 13.8747C21.0827 10.4405 18.5678 7.50991 15.1408 6.95641C11.7138 6.40292 8.38688 8.38995 7.28682 11.6473C6.18677 14.9047 7.63847 18.4702 10.7139 20.0647C10.5562 20.3061 10.472 20.5873 10.4713 20.8747V22.3747C10.4713 24.0315 11.8293 25.3747 13.5046 25.3747H14.5157C16.191 25.3747 17.549 24.0315 17.549 22.3747V20.8747C17.5483 20.5873 17.4641 20.3061 17.3064 20.0647C19.6265 18.8523 21.0781 16.4699 21.0778 13.8747ZM16.0223 20.8747V21.3747H13.4945C13.0757 21.3747 12.7361 21.7105 12.7361 22.1247C12.7361 22.5389 13.0757 22.8747 13.4945 22.8747H15.9313C15.7175 23.4726 15.1468 23.8729 14.5056 23.8747H13.4945C12.6568 23.8747 11.9778 23.2031 11.9778 22.3747V20.8747H16.0223ZM14 19.3747C10.9287 19.3747 8.43892 16.9123 8.43892 13.8747C8.43892 10.8371 10.9287 8.37469 14 8.37469C17.0714 8.37469 19.5611 10.8371 19.5611 13.8747C19.5611 15.3343 18.9745 16.734 17.9305 17.7655C16.8865 18.7971 15.4708 19.376 13.995 19.3747H14Z'),
						$elm$svg$Svg$Attributes$fill('black')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M14 9.625C13.5812 9.625 13.2417 9.96079 13.2417 10.375C13.2417 10.7892 13.5812 11.125 14 11.125C15.5345 11.1278 16.7778 12.3574 16.7806 13.875C16.7806 14.2892 17.1201 14.625 17.5389 14.625C17.9577 14.625 18.2973 14.2892 18.2973 13.875C18.2945 11.5289 16.3722 9.62776 14 9.625Z'),
						$elm$svg$Svg$Attributes$fill('black')
					]),
				_List_Nil)
			]));
};
var $author$project$Page$Profile$Claims$viewGoodPracticesCard = function (_v0) {
	var translators = _v0.iw;
	var language = _v0.hy;
	var text_ = A2($elm$core$Basics$composeR, translators.il, $elm$html$Html$text);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('rounded shadow-lg w-full md:w-3/4 lg:w-2/3 bg-white')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex items-center bg-yellow text-black font-semibold p-2 rounded-t')
					]),
				_List_fromArray(
					[
						$author$project$Icons$lamp('mr-2'),
						text_('profile.claims.good_practices.title')
					])),
				A2(
				$elm$html$Html$ul,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('list-disc p-4 pl-8 pb-4 md:pb-11 space-y-4')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$li,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pl-1')
							]),
						_List_fromArray(
							[
								text_('profile.claims.good_practices.once_a_day')
							])),
						A2(
						$elm$html$Html$li,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pl-1')
							]),
						_List_fromArray(
							[
								text_('profile.claims.good_practices.completed_action')
							])),
						A2(
						$elm$html$Html$li,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pl-1')
							]),
						_List_fromArray(
							[
								text_('profile.claims.good_practices.know_the'),
								$elm$html$Html$text(' '),
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-orange-300 hover:underline focus-ring rounded-sm'),
										$elm$html$Html$Attributes$href(
										$author$project$Session$LoggedIn$codeOfConductUrl(language))
									]),
								_List_fromArray(
									[
										text_('profile.claims.good_practices.good_practices')
									]))
							]))
					]))
			]));
};
var $author$project$Page$Profile$Claims$Analyzed = 1;
var $author$project$Page$Profile$Claims$SelectedTab = function (a) {
	return {$: 4, a: a};
};
var $author$project$Claim$isOpenForVotes = F2(
	function (now, claim) {
		var isOpen = function () {
			var _v0 = claim.gE;
			if (_v0.$ === 2) {
				return true;
			} else {
				return false;
			}
		}();
		return (!A2($author$project$Action$isClosed, claim.iG, now)) && ((!claim.iG.$7) && isOpen);
	});
var $author$project$Page$Profile$Claims$claimsToShow = F4(
	function (shared, claims, statusFilter, tab) {
		if (!tab) {
			return A2(
				$elm$core$List$filter,
				$author$project$Claim$isOpenForVotes(shared.gh),
				claims);
		} else {
			var satisfiesFilter = function (claim) {
				switch (statusFilter) {
					case 0:
						return true;
					case 1:
						return _Utils_eq(claim.gE, $author$project$Claim$Approved);
					case 2:
						return _Utils_eq(claim.gE, $author$project$Claim$Rejected);
					default:
						return _Utils_eq(claim.gE, $author$project$Claim$Pending);
				}
			};
			return A2(
				$elm$core$List$filter,
				function (claim) {
					return (!A2($author$project$Claim$isOpenForVotes, shared.gh, claim)) && satisfiesFilter(claim);
				},
				claims);
		}
	});
var $author$project$View$TabSelector$init = function (initialOptions) {
	return {mg: _List_Nil, on: initialOptions.on, cJ: initialOptions.cJ, ps: initialOptions.ps};
};
var $author$project$View$TabSelector$Center = 1;
var $author$project$View$TabSelector$Left = 0;
var $author$project$View$TabSelector$Right = 2;
var $author$project$View$TabSelector$isLeft = function (position) {
	if (!position) {
		return true;
	} else {
		return false;
	}
};
var $author$project$View$TabSelector$isRight = function (position) {
	if (position === 2) {
		return true;
	} else {
		return false;
	}
};
var $author$project$View$TabSelector$viewTab = F3(
	function (position, tabSelector, tab) {
		var maybeCount = A2(
			$elm$core$Maybe$map,
			function (c) {
				return '(' + ($elm$core$String$fromInt(c) + ')');
			},
			tab.mo);
		var isActive = _Utils_eq(tab.li, tabSelector.cJ);
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-center py-3 px-8 w-1/2 focus:outline-none flex flex-col items-center justify-center sm:flex-row'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('bg-orange-300 text-white cursor-default', isActive),
							_Utils_Tuple2('bg-gray-100 text-black hover:bg-gray-200', !isActive),
							_Utils_Tuple2(
							'rounded-l-full',
							$author$project$View$TabSelector$isLeft(position)),
							_Utils_Tuple2(
							'rounded-r-full',
							$author$project$View$TabSelector$isRight(position))
						])),
					$elm$html$Html$Events$onClick(
					tabSelector.on(tab.li))
				]),
			function () {
				if (maybeCount.$ === 1) {
					return _List_fromArray(
						[
							$elm$html$Html$text(tab.nC)
						]);
				} else {
					var count = maybeCount.a;
					return _List_fromArray(
						[
							$elm$html$Html$text(tab.nC),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('sm:ml-1')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(count)
								]))
						]);
				}
			}());
	});
var $author$project$View$TabSelector$toHtml = function (tabSelector) {
	return A2(
		$elm$html$Html$div,
		A2(
			$elm$core$List$cons,
			$elm$html$Html$Attributes$class('flex'),
			tabSelector.mg),
		A2(
			$elm$core$List$indexedMap,
			function (idx) {
				var position = (!idx) ? 0 : (_Utils_eq(
					idx,
					$elm$core$List$length(tabSelector.ps) - 1) ? 2 : 1);
				return A2($author$project$View$TabSelector$viewTab, position, tabSelector);
			},
			tabSelector.ps));
};
var $author$project$View$TabSelector$withContainerAttrs = F2(
	function (attrs, tabSelector) {
		return _Utils_update(
			tabSelector,
			{
				mg: _Utils_ap(tabSelector.mg, attrs)
			});
	});
var $author$project$Page$Profile$Claims$viewTabSelector = F3(
	function (shared, maybeClaims, model) {
		var translators = shared.iw;
		var tabCount = function (tab) {
			return A2(
				$elm$core$Maybe$map,
				function (claims) {
					return $elm$core$List$length(
						A4($author$project$Page$Profile$Claims$claimsToShow, shared, claims, 0, tab));
				},
				maybeClaims);
		};
		return $author$project$View$TabSelector$toHtml(
			A2(
				$author$project$View$TabSelector$withContainerAttrs,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('w-full md:w-2/3 xl:w-2/5 mt-6 lg:mt-8')
					]),
				$author$project$View$TabSelector$init(
					{
						on: $author$project$Page$Profile$Claims$SelectedTab,
						cJ: model.cJ,
						ps: _List_fromArray(
							[
								{
								mo: tabCount(0),
								nC: translators.il('all_analysis.tabs.waiting_vote'),
								li: 0
							},
								{
								mo: tabCount(1),
								nC: translators.il('all_analysis.tabs.analyzed'),
								li: 1
							}
							])
					})));
	});
var $author$project$Page$Profile$Claims$viewHeaderAndOptions = F3(
	function (loggedIn, maybeClaims, model) {
		var shared = loggedIn.aM;
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('bg-white pt-5 md:pt-6 pb-6')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('container mx-auto px-4 flex flex-col items-center')
							]),
						_List_fromArray(
							[
								(!loggedIn.mZ) ? A3(
								$author$project$Session$LoggedIn$viewFrozenAccountCard,
								shared.iw,
								{nu: true, og: $author$project$Page$Profile$Claims$ClickedAcceptCodeOfConduct},
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('shadow-lg')
									])) : $author$project$Page$Profile$Claims$viewGoodPracticesCard(shared),
								A3($author$project$Page$Profile$Claims$viewTabSelector, shared, maybeClaims, model)
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('container mx-auto px-4')
					]),
				_List_fromArray(
					[
						A2($author$project$Page$Profile$Claims$viewFilterAndOrder, shared, model)
					]))
			]);
	});
var $author$project$View$Components$Sm = 0;
var $author$project$View$Components$keyedMasonryLayout = F4(
	function (breakpoints, transitionWithParent, attrs, children) {
		return A3(
			$elm$html$Html$Keyed$node,
			'masonry-layout',
			A3($author$project$View$Components$masonryLayoutAttributes, breakpoints, transitionWithParent, attrs),
			children);
	});
var $author$project$Claim$CardSummary = {$: 0};
var $author$project$Claim$CloseClaimModal = {$: 1};
var $author$project$Claim$GotExternalMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Claim$GotProfileSummaryMsg = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Claim$OpenClaimModal = {$: 0};
var $justinmimbs$date$Date$toMonths = function (rd) {
	var date = $justinmimbs$date$Date$toCalendarDate(rd);
	var wholeMonths = (12 * (date.lI - 1)) + ($justinmimbs$date$Date$monthToNumber(date.kd) - 1);
	return wholeMonths + (date.ja / 100);
};
var $elm$core$Basics$truncate = _Basics_truncate;
var $justinmimbs$date$Date$diff = F3(
	function (unit, _v0, _v1) {
		var rd1 = _v0;
		var rd2 = _v1;
		switch (unit) {
			case 0:
				return ((($justinmimbs$date$Date$toMonths(rd2) - $justinmimbs$date$Date$toMonths(rd1)) | 0) / 12) | 0;
			case 1:
				return ($justinmimbs$date$Date$toMonths(rd2) - $justinmimbs$date$Date$toMonths(rd1)) | 0;
			case 2:
				return ((rd2 - rd1) / 7) | 0;
			default:
				return rd2 - rd1;
		}
	});
var $author$project$View$Modal$Large = 0;
var $author$project$Claim$PendingSummaries = function (a) {
	return {$: 3, a: a};
};
var $author$project$Claim$TopModalSummary = {$: 1};
var $author$project$Claim$VotersSummaries = function (a) {
	return {$: 2, a: a};
};
var $author$project$Claim$viewClaimModal = F3(
	function (loggedIn, profileSummaries, claim) {
		var shared = loggedIn.aM;
		var accountName = loggedIn.lM;
		var viewProfileSummary = F2(
			function (profile_, profileSummary_) {
				return A4(
					$author$project$Profile$Summary$view,
					shared.iw,
					accountName,
					profile_,
					A2(
						$author$project$Profile$Summary$withScrollSelector,
						'.modal-body-lg',
						A2(
							$author$project$Profile$Summary$withRelativeSelector,
							'.modal-content',
							A2($author$project$Profile$Summary$withPreventScrolling, 1, profileSummary_))));
			});
		var viewClaimerProfileSummary = A2(
			$elm$html$Html$map,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Claim$GotProfileSummaryMsg($author$project$Claim$TopModalSummary),
				$author$project$Claim$GotExternalMsg),
			A2(viewProfileSummary, claim.c$, profileSummaries.fg));
		var hideValidators = function () {
			var _v7 = loggedIn.o7;
			if (_v7.$ === 3) {
				var community = _v7.a;
				return A3($author$project$Claim$hidesValidatorNames, community.m6, accountName, claim);
			} else {
				return false;
			}
		}();
		var viewValidatorSummary = F2(
			function (validator, profileSummary_) {
				return hideValidators ? $author$project$Claim$viewHiddenValidator(shared.iw) : A2(viewProfileSummary, validator, profileSummary_);
			});
		var completionStatus = {
			ao: $elm$core$List$length(
				A2(
					$elm$core$List$filter,
					function ($) {
						return $.be;
					},
					claim.S)),
			eg: claim.gE,
			as: $elm$core$List$length(
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeL,
						$elm$core$Basics$not,
						function ($) {
							return $.be;
						}),
					claim.S)),
			pP: claim.iG.pP
		};
		var claimVerifiersSectionClass = 'block my-6 h-auto space-y-4';
		var claimVerifiersProfileListContainerClass = 'grid grid-cols-3 md:flex md:flex-wrap md:space-x-6 py-2';
		var claimVerifiersFewerProfiles = 'flex flex-wrap space-x-6';
		var profileSummaryEmpty = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(claimVerifiersFewerProfiles)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mb-10')
						]),
					_List_fromArray(
						[
							$author$project$Profile$viewEmpty(shared.iw)
						]))
				]));
		var claimRoute = A3(
			$author$project$Route$Claim,
			$author$project$Action$objectiveIdToInt(claim.iG.bi.R),
			$author$project$Action$idToInt(claim.iG.R),
			claim.R);
		var _v0 = shared.iw;
		var t = _v0.il;
		var claimDetailsButton = A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('button button-primary w-full mt-4'),
					$elm$html$Html$Attributes$target('_blank'),
					$author$project$Route$href(claimRoute)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					t('claim.modal.view_details')),
					$author$project$Icons$externalLink('inline-block ml-4 h-3 fill-current')
				]));
		var footer = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('block w-full my-4 sm:w-1/2 sm:mx-auto')
				]),
			_List_fromArray(
				[
					A4(
					$author$project$Claim$isVotable,
					claim,
					accountName,
					$author$project$Session$LoggedIn$permissions(loggedIn),
					shared.gh) ? A4($author$project$ReviewMoved$viewClaimCta, shared.iw, shared.mJ.lW, claim.R, _List_Nil) : $elm$html$Html$text(''),
					claimDetailsButton
				]));
		var viewActionDetails = function () {
			var proofCode = function () {
				var _v6 = claim.h4;
				if (!_v6.$) {
					var code = _v6.a;
					return code;
				} else {
					return '';
				}
			}();
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('block mt-6')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('label')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								t('claim.action'))
							])),
						A2(
						$author$project$Markdown$view,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-left mt-2 mb-6 text-lg w-full')
							]),
						claim.iG.bc),
						function () {
						var _v5 = claim.eY;
						if (!_v5.$) {
							var url = _v5.a;
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('relative h-auto w-auto text-center text-white'),
										$author$project$Utils$onClickNoBubble(
										$author$project$Claim$OpenPhotoModal(claim))
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('z-10 absolute bottom-4 left-4 bg-black bg-opacity-60 p-4')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$p,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('text-sm text-left w-full uppercase')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														t('community.actions.form.verification_code'))
													])),
												A2(
												$elm$html$Html$p,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('font-bold font-normal text-left w-full')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(proofCode)
													]))
											])),
										A2(
										$author$project$View$Components$pdfViewer,
										_List_fromArray(
											[
												$author$project$Utils$onClickNoBubble(
												$author$project$Claim$OpenPhotoModal(claim)),
												$elm$html$Html$Attributes$class('w-full h-full min-h-48 rounded-sm bg-gray-300')
											]),
										{g$: 'max-w-full max-h-full', hF: $elm$core$Maybe$Nothing, hW: $elm$core$Maybe$Nothing, gL: url})
									]));
						} else {
							return $elm$html$Html$text('');
						}
					}()
					]));
		}();
		var viewApprovedByProfileSummaryList = function () {
			var cls = ($elm$core$List$length(claim.S) > 3) ? claimVerifiersProfileListContainerClass : claimVerifiersFewerProfiles;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(claimVerifiersSectionClass)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('label')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								t('claim.approved_by'))
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								(!A2(
								$elm$core$List$any,
								function ($) {
									return $.be;
								},
								claim.S)) ? profileSummaryEmpty : A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class(cls)
									]),
								A4(
									$elm$core$List$map3,
									F3(
										function (profileSummary, index, c) {
											return c.be ? A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('mb-4')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$map,
														A2(
															$elm$core$Basics$composeR,
															$author$project$Claim$GotProfileSummaryMsg(
																$author$project$Claim$VotersSummaries(index)),
															$author$project$Claim$GotExternalMsg),
														A2(viewValidatorSummary, c.aE, profileSummary))
													])) : $elm$html$Html$text('');
										}),
									profileSummaries.b0,
									A2(
										$elm$core$List$range,
										0,
										$elm$core$List$length(profileSummaries.b0)),
									claim.S))
							]))
					]));
		}();
		var viewCancelledNotice = function () {
			var _v3 = claim.gE;
			if (_v3.$ === 3) {
				var reason = _v3.a;
				var reasonText = function () {
					switch (reason) {
						case 0:
							return 'claim.cancelled_texts.deadline_reached';
						case 1:
							return 'claim.cancelled_texts.usages_reached';
						default:
							return 'claim.cancelled_texts.action_completed';
					}
				}();
				return A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-gray-900 my-10')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-black')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('claim.attention'))
								])),
							$elm$html$Html$text(
							A2(
								$elm$core$String$join,
								'. ',
								A2(
									$elm$core$List$map,
									t,
									_List_fromArray(
										[reasonText, 'claim.cancelled_texts.not_available']))))
						]));
			} else {
				return $elm$html$Html$text('');
			}
		}();
		var viewClaimDateAndState = function () {
			var _v1 = function () {
				var _v2 = claim.gE;
				switch (_v2.$) {
					case 0:
						return _Utils_Tuple3(
							t('claim.title_approved.1'),
							t('claim.title_approved.2'),
							'text-lg font-bold lowercase text-green');
					case 1:
						return _Utils_Tuple3(
							t('claim.title_rejected.1'),
							t('claim.title_rejected.2'),
							'text-lg font-bold lowercase text-red');
					case 2:
						return _Utils_Tuple3(
							t('claim.title_under_review.1'),
							t('claim.pending'),
							'text-lg font-bold lowercase text-gray-600');
					default:
						return _Utils_Tuple3(
							t('claim.title_cancelled.1'),
							t('claim.title_cancelled.2'),
							'text-lg font-bold lowercase text-gray-900');
				}
			}();
			var claimStatusPhrase = _v1.a;
			var claimStatus = _v1.b;
			var textColor = _v1.c;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('block')
					]),
				_List_fromArray(
					[
						A4(
						$author$project$View$Components$dateViewer,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-xs uppercase block text-gray-900')
							]),
						function (translations) {
							return _Utils_update(
								translations,
								{
									ow: t('claim.claimed_on'),
									pB: $elm$core$Maybe$Just(
										t('claim.claimed_today')),
									pY: $elm$core$Maybe$Just(
										t('claim.claimed_yesterday'))
								});
						},
						shared,
						$author$project$Utils$fromDateTime(claim.fG)),
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-lg font-bold')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(claimStatusPhrase)
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class(textColor)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(claimStatus)
							]))
					]));
		}();
		var header = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex space-x-6 md:justify-center md:space-x-8 md:mt-4')
				]),
			_List_fromArray(
				[viewClaimerProfileSummary, viewClaimDateAndState]));
		var viewDisapprovedByProfileSummaryList = function () {
			var cls = ($elm$core$List$length(claim.S) > 3) ? claimVerifiersProfileListContainerClass : claimVerifiersFewerProfiles;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(claimVerifiersSectionClass)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('label')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								t('claim.disapproved_by'))
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								$elm$core$List$isEmpty(
								A2(
									$elm$core$List$filter,
									function (check) {
										return !check.be;
									},
									claim.S)) ? profileSummaryEmpty : A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class(cls)
									]),
								A4(
									$elm$core$List$map3,
									F3(
										function (profileSummary, index, c) {
											return (!c.be) ? A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('mb-4')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$map,
														A2(
															$elm$core$Basics$composeR,
															$author$project$Claim$GotProfileSummaryMsg(
																$author$project$Claim$VotersSummaries(index)),
															$author$project$Claim$GotExternalMsg),
														A2(viewValidatorSummary, c.aE, profileSummary))
													])) : $elm$html$Html$text('');
										}),
									profileSummaries.b0,
									A2(
										$elm$core$List$range,
										0,
										$elm$core$List$length(profileSummaries.b0)),
									claim.S))
							]))
					]));
		}();
		var viewPendingVotersProfileSummaryList = function () {
			var cls = ($elm$core$List$length(profileSummaries.cB) > 3) ? claimVerifiersProfileListContainerClass : claimVerifiersFewerProfiles;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(claimVerifiersSectionClass)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('label')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								t('claim.pending_vote'))
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								_Utils_eq(
								$elm$core$List$length(claim.S),
								claim.iG.pP) ? profileSummaryEmpty : A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class(cls)
									]),
								A4(
									$elm$core$List$map3,
									F3(
										function (profileSummary, index, v) {
											return A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('mb-4')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$map,
														A2(
															$elm$core$Basics$composeR,
															$author$project$Claim$GotProfileSummaryMsg(
																$author$project$Claim$PendingSummaries(index)),
															$author$project$Claim$GotExternalMsg),
														A2(viewValidatorSummary, v, profileSummary))
													]));
										}),
									profileSummaries.cB,
									A2(
										$elm$core$List$range,
										0,
										$elm$core$List$length(profileSummaries.cB)),
									$author$project$Claim$pendingValidators(claim)))
							]))
					]));
		}();
		var viewRewardInfo = function () {
			var rewardTxtClass = 'my-2 font-bold text-lg';
			var makeAsset = function (_float) {
				return {lU: _float, e9: claim.iG.bi.b9.e9};
			};
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-center flex justify-center bg-gray-100 rounded-md my-10 p-4 space-x-16')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class(rewardTxtClass)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2(
											$author$project$Eos$assetToString,
											shared.iw,
											makeAsset(claim.iG.h7)))
									])),
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-sm text-green uppercase')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										t('community.actions.reward'))
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class(rewardTxtClass)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2(
											$author$project$Eos$assetToString,
											shared.iw,
											makeAsset(claim.iG.pQ)))
									])),
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-sm text-green uppercase')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										t('claim.analyst_reward'))
									]))
							]))
					]));
		}();
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$View$Modal$toHtml(
					A2(
						$author$project$View$Modal$withSize,
						0,
						A2(
							$author$project$View$Modal$withFooter,
							_List_fromArray(
								[footer]),
							A2(
								$author$project$View$Modal$withBody,
								_List_fromArray(
									[
										header,
										viewCancelledNotice,
										A2($author$project$Claim$viewVotingProgress, shared, completionStatus),
										viewRewardInfo,
										viewApprovedByProfileSummaryList,
										viewDisapprovedByProfileSummaryList,
										viewPendingVotersProfileSummaryList,
										viewActionDetails
									]),
								$author$project$View$Modal$initWith(
									{
										i$: $author$project$Claim$GotExternalMsg($author$project$Claim$CloseClaimModal),
										jW: profileSummaries.e3
									})))))
				]));
	});
var $author$project$Claim$viewClaimCard = F4(
	function (attributes, loggedIn, profileSummaries, claim) {
		var isCancelled = function () {
			var _v5 = claim.gE;
			if (_v5.$ === 3) {
				return true;
			} else {
				return false;
			}
		}();
		var completionStatus = {
			ao: $elm$core$List$length(
				A2(
					$elm$core$List$filter,
					function ($) {
						return $.be;
					},
					claim.S)),
			eg: claim.gE,
			as: $elm$core$List$length(
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeL,
						$elm$core$Basics$not,
						function ($) {
							return $.be;
						}),
					claim.S)),
			pP: claim.iG.pP
		};
		var claimAging = function () {
			var createdAtDate = A2(
				$justinmimbs$date$Date$fromPosix,
				loggedIn.aM.ll,
				$author$project$Utils$fromDateTime(claim.fG));
			return A3(
				$justinmimbs$date$Date$diff,
				3,
				createdAtDate,
				A2($justinmimbs$date$Date$fromPosix, loggedIn.aM.ll, loggedIn.aM.gh));
		}();
		var _v0 = loggedIn.aM.iw;
		var t = _v0.il;
		var tr = _v0.iu;
		var claimAgingText = (claimAging < 1) ? t('claim.opened_today') : ((claimAging === 1) ? A2(
			tr,
			'claim.day_ago',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'day_count',
					$elm$core$String$fromInt(claimAging))
				])) : A2(
			tr,
			'claim.days_ago',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'day_count',
					$elm$core$String$fromInt(claimAging))
				])));
		return A2(
			$elm$html$Html$div,
			attributes,
			_List_fromArray(
				[
					A3($author$project$Claim$viewClaimModal, loggedIn, profileSummaries, claim),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-col p-4 my-2 rounded-lg bg-white hover:shadow cursor-pointer'),
							$elm$html$Html$Attributes$id(
							'claim' + $elm$core$String$fromInt(claim.R)),
							$author$project$Utils$onClickNoBubble(
							$author$project$Claim$GotExternalMsg($author$project$Claim$OpenClaimModal))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex mb-4'),
									function () {
									var _v1 = claim.eY;
									if (!_v1.$) {
										return $elm$html$Html$Attributes$class('justify-between');
									} else {
										return $elm$html$Html$Attributes$class('justify-center');
									}
								}()
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									A2(
										$elm$core$Basics$composeR,
										$author$project$Claim$GotProfileSummaryMsg($author$project$Claim$CardSummary),
										$author$project$Claim$GotExternalMsg),
									A4($author$project$Profile$Summary$view, loggedIn.aM.iw, loggedIn.lM, claim.c$, profileSummaries.ed)),
									function () {
									var _v2 = claim.eY;
									if (!_v2.$) {
										var url = _v2.a;
										return A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('claim-photo-thumb')
												]),
											_List_fromArray(
												[
													A2(
													$author$project$View$Components$pdfViewer,
													_List_fromArray(
														[
															$author$project$Utils$onClickNoBubble(
															$author$project$Claim$OpenPhotoModal(claim)),
															$elm$html$Html$Attributes$class('w-full h-full rounded-sm')
														]),
													{g$: 'max-w-full max-h-full', hF: $elm$core$Maybe$Nothing, hW: $elm$core$Maybe$Nothing, gL: url})
												]));
									} else {
										return $elm$html$Html$text('');
									}
								}()
								])),
							isCancelled ? A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('bg-gray-900 text-white font-bold uppercase text-sm py-1 px-5 rounded-label self-center')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('claim.cancelled_texts.cancelled_claim'))
								])) : A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-purple-500 font-bold uppercase text-sm self-center')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(claimAgingText)
								])),
							A2(
							$author$project$Markdown$view,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('truncate-children mb-2 mt-6'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('text-gray-900', isCancelled)
										]))
								]),
							claim.iG.bc),
							A4(
							$author$project$View$Components$dateViewer,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-gray-900 font-bold text-sm uppercase flex mb-6')
								]),
							$elm$core$Basics$identity,
							loggedIn.aM,
							$author$project$Utils$fromDateTime(claim.fG)),
							function () {
							var _v3 = claim.gE;
							if (_v3.$ === 3) {
								var reason = _v3.a;
								var reasonText = function () {
									switch (reason) {
										case 0:
											return 'claim.cancelled_texts.deadline_reached';
										case 1:
											return 'claim.cancelled_texts.usages_reached';
										default:
											return 'claim.cancelled_texts.action_completed';
									}
								}();
								return A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('bg-gray-900 rounded p-4 text-white mb-6')
										]),
									$elm$core$List$singleton(
										$elm$html$Html$text(
											A2(
												$elm$core$String$join,
												'. ',
												A2(
													$elm$core$List$map,
													t,
													_List_fromArray(
														['claim.cancelled_texts.was_cancelled', reasonText, 'claim.cancelled_texts.not_available']))))));
							} else {
								return A2($author$project$Claim$viewVotingProgress, loggedIn.aM, completionStatus);
							}
						}(),
							(!A4(
							$author$project$Claim$isVotable,
							claim,
							loggedIn.lM,
							$author$project$Session$LoggedIn$permissions(loggedIn),
							loggedIn.aM.gh)) ? A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('button button-secondary w-full font-semibold mb-2'),
									$author$project$Utils$onClickNoBubble(
									$author$project$Claim$GotExternalMsg($author$project$Claim$OpenClaimModal))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('all_analysis.more_details'))
								])) : A4(
							$author$project$ReviewMoved$viewClaimCta,
							loggedIn.aM.iw,
							loggedIn.aM.mJ.lW,
							claim.R,
							_List_fromArray(
								[
									$author$project$Utils$onClickNoBubble(
									$author$project$Claim$GotExternalMsg($author$project$Claim$CloseClaimModal))
								]))
						]))
				]));
	});
var $author$project$Page$Profile$Claims$viewEmptyResults = function (_v0) {
	var shared = _v0.aM;
	var text_ = function (s) {
		return $elm$html$Html$text(
			shared.iw.il(s));
	};
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('w-full text-center')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('w-full flex justify-center')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$img,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$src('/images/empty-analysis.svg'),
								$elm$html$Html$Attributes$class('object-contain h-32 mb-3')
							]),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('inline-block text-gray')
					]),
				_List_fromArray(
					[
						text_('profile.claims.empty_results')
					]))
			]));
};
var $author$project$Page$Profile$Claims$viewResults = F4(
	function (loggedIn, profileSummaries, claims, model) {
		var viewClaim = F3(
			function (profileSummary, claimIndex, claim) {
				return _Utils_Tuple2(
					$elm$core$String$fromInt(claim.R),
					A2(
						$elm$html$Html$map,
						$author$project$Page$Profile$Claims$ClaimMsg(claimIndex),
						A4(
							$author$project$Claim$viewClaimCard,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('w-full self-start')
								]),
							loggedIn,
							profileSummary,
							claim)));
			});
		var orderFunction = function () {
			var _v0 = model.dH;
			if (_v0 === 1) {
				return $elm$core$List$reverse;
			} else {
				return $elm$core$Basics$identity;
			}
		}();
		var claimsList = A4($author$project$Page$Profile$Claims$claimsToShow, loggedIn.aM, claims, model.fI, model.cJ);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container mx-auto px-4 mb-10')
				]),
			_List_fromArray(
				[
					($elm$core$List$length(claimsList) > 0) ? A4(
					$author$project$View$Components$keyedMasonryLayout,
					_List_fromArray(
						[0]),
					{pG: false},
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-x-4 mb-4 sm:auto-rows-[5px]')
						]),
					A4(
						$elm$core$List$map3,
						viewClaim,
						profileSummaries,
						A2(
							$elm$core$List$range,
							0,
							$elm$core$List$length(profileSummaries)),
						orderFunction(claimsList))) : $author$project$Page$Profile$Claims$viewEmptyResults(loggedIn)
				]));
	});
var $author$project$Page$Profile$Claims$view = F2(
	function (loggedIn, model) {
		var maybeClaims = function () {
			var _v2 = model.gE;
			if (_v2.$ === 1) {
				var profileClaims = _v2.b;
				return $elm$core$Maybe$Just(profileClaims);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var _v0 = loggedIn.aM.iw;
		var t = _v0.il;
		var pageTitle = t('profile.claims.title');
		var content = function () {
			var _v1 = model.gE;
			switch (_v1.$) {
				case 0:
					return _List_fromArray(
						[
							$author$project$Page$fullPageLoading(loggedIn.aM)
						]);
				case 1:
					var profileSummaries = _v1.a;
					var profileClaims = _v1.b;
					return _List_fromArray(
						[
							A4($author$project$Page$Profile$Claims$viewResults, loggedIn, profileSummaries, profileClaims, model),
							A2($author$project$Page$Profile$Claims$viewClaimPhotoModal, loggedIn, model)
						]);
				case 2:
					return _List_fromArray(
						[
							A2(
							$author$project$Page$fullPageNotFound,
							t('profile.claims.not_found.title'),
							t('profile.claims.not_found.subtitle'))
						]);
				default:
					var e = _v1.a;
					return _List_fromArray(
						[
							A2($author$project$Page$fullPageGraphQLError, pageTitle, e)
						]);
			}
		}();
		return {
			mk: A2(
				$elm$html$Html$div,
				_List_Nil,
				A2(
					$elm$core$List$cons,
					A2($author$project$Page$viewHeader, loggedIn, pageTitle),
					A2(
						$elm$core$List$cons,
						A2($author$project$Page$Profile$Claims$viewFiltersModal, loggedIn.aM, model),
						_Utils_ap(
							A3($author$project$Page$Profile$Claims$viewHeaderAndOptions, loggedIn, maybeClaims, model),
							content)))),
			fb: pageTitle
		};
	});
var $author$project$Page$Profile$Editor$ClickedSave = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$Profile$Editor$FormOutput = F6(
	function (avatar, fullName, email, bio, location, interests) {
		return {cV: avatar, cW: bio, jh: email, de: fullName, dj: interests, nN: location};
	});
var $author$project$Form$File$fromSingleModel = function (_v0) {
	var model = _v0;
	return {
		q: model.q,
		f: $author$project$Form$File$SingleEntry(model.ev),
		ae: model.ae,
		j: model.j,
		G: model.hv ? 1 : 0,
		t: model.f$ ? $elm$core$Maybe$Just(0) : $elm$core$Maybe$Nothing
	};
};
var $author$project$Form$File$parser = F2(
	function (translators, _v0) {
		var t = translators.il;
		var model = _v0;
		var _v1 = model.ev;
		if (_v1.$ === 1) {
			return $elm$core$Result$Err(
				t('error.required'));
		} else {
			var entry = _v1.a;
			return A2($author$project$Form$File$parseUrlStatus, translators, entry.gL);
		}
	});
var $author$project$Form$file = F2(
	function (config, options) {
		return A2(
			$author$project$Form$field,
			A2(
				$elm$core$Basics$composeR,
				A2($author$project$Form$mapBaseField, $author$project$Form$File$fromSingleModel, $author$project$Form$File$toSingleModel),
				$author$project$Form$File(options)),
			{
				ab: config.ab,
				af: A2(
					$elm$core$Basics$composeR,
					$author$project$Form$File$parser(config.iw),
					$elm$core$Result$andThen(config.af)),
				n: config.n,
				pO: config.pO
			});
	});
var $author$project$Page$Profile$Editor$interestsForm = function (_v0) {
	var t = _v0.il;
	var viewInterest = function (interest) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bg-green px-3 h-8 rounded-sm text-sm flex text-white')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('m-auto mr-3 uppercase')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(interest)
						])),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('button'),
							$elm$html$Html$Events$onClick(
							function (values) {
								return _Utils_update(
									values,
									{
										dj: A2(
											$elm$core$List$filter,
											function (x) {
												return !_Utils_eq(x, interest);
											},
											values.dj)
									});
							})
						]),
					_List_fromArray(
						[
							$author$project$Icons$close('w-4 h-4 fill-current')
						]))
				]));
	};
	return A2(
		$author$project$Form$withNoOutput,
		$author$project$Form$introspect(
			function (values) {
				return $author$project$Form$arbitrary(
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex flex-wrap mb-10 gap-x-4 gap-y-2')
							]),
						A2($elm$core$List$map, viewInterest, values.dj)));
			}),
		A2(
			$author$project$Form$withNoOutput,
			A4(
				$author$project$Form$withGroup,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex')
					]),
				A2(
					$author$project$Form$textField,
					{
						ab: $elm$core$Basics$always($elm$core$Maybe$Nothing),
						af: $elm$core$Result$Ok,
						n: F2(
							function (interest, input) {
								return _Utils_update(
									input,
									{bH: interest});
							}),
						pO: function ($) {
							return $.bH;
						}
					},
					A2(
						$author$project$Form$Text$withContainerAttrs,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('w-full !mb-4')
							]),
						$author$project$Form$Text$init(
							{
								R: 'interest-input',
								nC: t('profile.edit.labels.interests')
							}))),
				$author$project$Form$arbitrary(
					A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('button'),
								$elm$html$Html$Attributes$class('button button-secondary px-4 h-12 ml-4 mb-4 mt-auto max-w-min'),
								$elm$html$Html$Events$onClick(
								function (values) {
									return ($elm$core$String$isEmpty(values.bH) || A2($elm$core$List$member, values.bH, values.dj)) ? values : _Utils_update(
										values,
										{
											bH: '',
											dj: A2($elm$core$List$cons, values.bH, values.dj)
										});
								})
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								t('menu.add'))
							]))),
				$author$project$Form$succeed($elm$core$Basics$always)),
			$author$project$Form$introspect(
				function (values) {
					return $author$project$Form$succeed(values.dj);
				})));
};
var $author$project$Page$Profile$Editor$createForm = F2(
	function (translators, _v0) {
		var t = translators.il;
		var hasKyc = _v0.ck;
		var hasLocationPicker = _v0.jA;
		return A2(
			$author$project$Form$with,
			$author$project$Page$Profile$Editor$interestsForm(translators),
			A2(
				$author$project$Form$with,
				hasLocationPicker ? $author$project$Form$succeed('') : A2(
					$author$project$Form$textField,
					{
						ab: $elm$core$Basics$always($elm$core$Maybe$Nothing),
						af: $elm$core$Result$Ok,
						n: F2(
							function (location, input) {
								return _Utils_update(
									input,
									{nN: location});
							}),
						pO: function ($) {
							return $.nN;
						}
					},
					$author$project$Form$Text$init(
						{
							R: 'location-input',
							nC: t('profile.edit.labels.localization')
						})),
				A2(
					$author$project$Form$with,
					A2(
						$author$project$Form$richText,
						{
							ab: $elm$core$Basics$always($elm$core$Maybe$Nothing),
							af: $elm$core$Result$Ok,
							n: F2(
								function (bio, input) {
									return _Utils_update(
										input,
										{cW: bio});
								}),
							pO: function ($) {
								return $.cW;
							}
						},
						A2(
							$author$project$Form$RichText$withEditorContainerAttrs,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mb-10')
								]),
							$author$project$Form$RichText$init(
								{
									nC: t('profile.edit.labels.bio')
								}))),
					A2(
						$author$project$Form$with,
						A2(
							$author$project$Form$textField,
							{
								ab: $elm$core$Basics$always($elm$core$Maybe$Nothing),
								af: $elm$core$Result$Ok,
								n: F2(
									function (email, input) {
										return _Utils_update(
											input,
											{jh: email});
									}),
								pO: function ($) {
									return $.jh;
								}
							},
							$author$project$Form$Text$init(
								{
									R: 'email-input',
									nC: t('profile.edit.labels.email')
								})),
						A2(
							$author$project$Form$with,
							A2(
								$author$project$Form$textField,
								{
									ab: $elm$core$Basics$always($elm$core$Maybe$Nothing),
									af: $elm$core$Result$Ok,
									n: F2(
										function (name, input) {
											return _Utils_update(
												input,
												{de: name});
										}),
									pO: function ($) {
										return $.de;
									}
								},
								A2(
									$author$project$Form$Text$withDisabled,
									hasKyc,
									$author$project$Form$Text$init(
										{
											R: 'name-input',
											nC: t('profile.edit.labels.name')
										}))),
							A2(
								$author$project$Form$with,
								$author$project$Form$optional(
									A2(
										$author$project$Form$file,
										{
											ab: $elm$core$Basics$always($elm$core$Maybe$Nothing),
											af: $elm$core$Result$Ok,
											iw: translators,
											n: F2(
												function (avatar, input) {
													return _Utils_update(
														input,
														{cV: avatar});
												}),
											pO: function ($) {
												return $.cV;
											}
										},
										A2(
											$author$project$Form$File$withImageCropperAttributes,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('rounded-full')
												]),
											A2(
												$author$project$Form$File$withAddImagesView,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('bg-orange-300 rounded-full p-4 w-20 h-20')
															]),
														_List_fromArray(
															[
																$author$project$Icons$camera('text-white')
															]))
													]),
												$author$project$Form$File$withEditIconOverlay(
													A2(
														$author$project$Form$File$withEntryContainerAttributes,
														function (_v1) {
															return _List_fromArray(
																[
																	$elm$html$Html$Attributes$class('mx-auto rounded-full w-20 h-20')
																]);
														},
														A2(
															$author$project$Form$File$withImageClass,
															'object-cover rounded-full mx-auto w-20 h-20',
															A2(
																$author$project$Form$File$withContainerAttributes,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('grid place-items-center')
																	]),
																$author$project$Form$File$init(
																	{R: 'avatar-input'}))))))))),
								$author$project$Form$succeed($author$project$Page$Profile$Editor$FormOutput)))))));
	});
var $author$project$Page$Profile$Editor$ChangedAddress = F2(
	function (a, b) {
		return {$: 17, a: a, b: b};
	});
var $author$project$Page$Profile$Editor$PostalCode = 3;
var $author$project$Page$Profile$Editor$Street = 0;
var $author$project$Page$Profile$Editor$Complement = 2;
var $author$project$Page$Profile$Editor$Number = 1;
var $author$project$Page$Profile$Editor$viewTextInput = function (config) {
	return function (options) {
		return A2(
			$author$project$Form$Text$view,
			options,
			{
				mM: function () {
					var _v0 = config.mM;
					if (!_v0.$) {
						var error = _v0.a;
						return A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('form-error normal-case tracking-normal')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(error)
								]));
					} else {
						return $elm$html$Html$text('');
					}
				}(),
				m$: !_Utils_eq(config.mM, $elm$core$Maybe$Nothing),
				nx: false,
				od: $author$project$Page$Profile$Editor$NoOp,
				oe: config.a3,
				iw: config.iw,
				pO: config.pO
			});
	}(
		(config.a$ ? $author$project$Form$Text$withInputElement(
			$author$project$Form$Text$TextareaInput(
				{pn: false})) : $elm$core$Basics$identity)(
			A2(
				$author$project$Form$Text$withExtraAttrs,
				config.aQ,
				A2(
					$author$project$Form$Text$withPlaceholder,
					config.oG,
					A2(
						$author$project$Form$Text$withContainerAttrs,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('!mb-4')
							]),
						$author$project$Form$Text$init(
							{R: config.R, nC: config.nC}))))));
};
var $author$project$Page$Profile$Editor$viewBrazilAddressFields = F3(
	function (translators, state, errorFor) {
		var streetInput = $author$project$Page$Profile$Editor$viewTextInput(
			{
				aQ: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'autocomplete', 'address-line1')
					]),
				mM: A2(errorFor, 0, 'errors.street_required'),
				R: 'address-street-input',
				a$: false,
				nC: A2($author$project$Page$Profile$Editor$tl, translators, 'address.street'),
				a3: $author$project$Page$Profile$Editor$ChangedAddress(0),
				oG: '',
				iw: translators,
				pO: state.gP.ba
			});
		var numberAndComplement = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('grid grid-cols-1 sm:grid-cols-2 sm:gap-x-4')
				]),
			_List_fromArray(
				[
					$author$project$Page$Profile$Editor$viewTextInput(
					{
						aQ: _List_Nil,
						mM: A2(errorFor, 1, 'errors.number_required'),
						R: 'address-number-input',
						a$: false,
						nC: A2($author$project$Page$Profile$Editor$tl, translators, 'address.number'),
						a3: $author$project$Page$Profile$Editor$ChangedAddress(1),
						oG: '',
						iw: translators,
						pO: state.gP.ay
					}),
					$author$project$Page$Profile$Editor$viewTextInput(
					{
						aQ: _List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'autocomplete', 'address-line2')
							]),
						mM: $elm$core$Maybe$Nothing,
						R: 'address-complement-input',
						a$: false,
						nC: A2($author$project$Page$Profile$Editor$tl, translators, 'address.complement'),
						a3: $author$project$Page$Profile$Editor$ChangedAddress(2),
						oG: '',
						iw: translators,
						pO: state.gP.c2
					})
				]));
		var _v0 = state.Z;
		if (_v0.$ === 2) {
			var lookup = _v0.a.f8;
			var folded = _v0.a.fQ;
			return (folded && (!_Utils_eq(lookup.ba, $elm$core$Maybe$Nothing))) ? numberAndComplement : A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[streetInput, numberAndComplement]));
		} else {
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[streetInput, numberAndComplement]));
		}
	});
var $author$project$Page$Profile$Editor$ClickedEditAddress = {$: 19};
var $author$project$Profile$Location$foundLine = function (_v0) {
	var street = _v0.ba;
	var place = _v0.e;
	var stateCode = _v0.lc;
	var cityName = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.ki;
			},
			place.cw));
	var bairroName = function () {
		var _v2 = place.by;
		if (!_v2.$) {
			var bairro = _v2.a;
			return bairro.ki;
		} else {
			return $author$project$Profile$Location$cleanText(place.aF);
		}
	}();
	var line = A2(
		$elm$core$String$join,
		', ',
		A2(
			$elm$core$List$filter,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
			_List_fromArray(
				[
					$author$project$Profile$Location$cleanText(street),
					bairroName,
					cityName
				])));
	if (!stateCode.$) {
		var code = stateCode.a;
		return (line === '') ? line : (line + (' - ' + code));
	} else {
		return line;
	}
};
var $author$project$Page$Profile$Editor$viewCepField = F3(
	function (translators, state, errorFor) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Page$Profile$Editor$viewTextInput(
					{
						aQ: _List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'inputmode', 'numeric'),
								A2($elm$html$Html$Attributes$attribute, 'autocomplete', 'postal-code'),
								$elm$html$Html$Attributes$maxlength(9)
							]),
						mM: function () {
							var _v0 = A2(errorFor, 3, 'errors.cep_required');
							if (!_v0.$) {
								var required = _v0.a;
								return $elm$core$Maybe$Just(required);
							} else {
								return (state.gy && $elm$core$String$isEmpty(
									$elm$core$String$trim(state.gP.dM))) ? $elm$core$Maybe$Just(
									A2($author$project$Page$Profile$Editor$tl, translators, 'errors.cep_required')) : A2(errorFor, 2, 'errors.cep_invalid');
							}
						}(),
						R: 'address-postal-code-input',
						a$: false,
						nC: (state.e.g5 === 2) ? A2($author$project$Page$Profile$Editor$tl, translators, 'address.cep_required_label') : A2($author$project$Page$Profile$Editor$tl, translators, 'address.cep'),
						a3: $author$project$Page$Profile$Editor$ChangedAddress(3),
						oG: '00000-000',
						iw: translators,
						pO: state.gP.dM
					}),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id('cep-status'),
							A2($elm$html$Html$Attributes$attribute, 'role', 'status'),
							A2($elm$html$Html$Attributes$attribute, 'aria-live', 'polite'),
							$elm$html$Html$Attributes$class('-mt-2 mb-4')
						]),
					_List_fromArray(
						[
							function () {
							var _v1 = state.Z;
							switch (_v1.$) {
								case 0:
									return A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-gray-700 text-sm')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												(state.e.g5 === 2) ? A2($author$project$Page$Profile$Editor$tl, translators, 'address.cep_hint_other') : A2($author$project$Page$Profile$Editor$tl, translators, 'address.cep_hint'))
											]));
								case 1:
									return A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-gray-700 text-sm')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												A2($author$project$Page$Profile$Editor$tl, translators, 'address.cep_loading'))
											]));
								case 2:
									var lookup = _v1.a.f8;
									var folded = _v1.a.fQ;
									return A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$id('cep-found'),
												$elm$html$Html$Attributes$class('flex flex-wrap items-center justify-between gap-x-4 gap-y-1 p-4 rounded bg-green/20 text-gray-333')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('font-bold break-words')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														$author$project$Profile$Location$foundLine(
															{e: state.e, lc: lookup.lc, ba: state.gP.ba}))
													])),
												folded ? A2(
												$elm$html$Html$button,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$type_('button'),
														$elm$html$Html$Attributes$id('cep-edit-address'),
														$elm$html$Html$Attributes$class('text-orange-500 font-bold hover:underline focus-ring'),
														$elm$html$Html$Events$onClick($author$project$Page$Profile$Editor$ClickedEditAddress)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														A2($author$project$Page$Profile$Editor$tl, translators, 'address.edit_address'))
													])) : $elm$html$Html$text('')
											]));
								case 3:
									return A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$id('cep-not-found'),
												$elm$html$Html$Attributes$class('p-4 rounded bg-gray-100 text-gray-700')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												A2($author$project$Page$Profile$Editor$tl, translators, 'address.cep_not_found'))
											]));
								default:
									return A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$id('cep-unavailable'),
												$elm$html$Html$Attributes$class('p-4 rounded bg-gray-100 text-gray-700')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												A2($author$project$Page$Profile$Editor$tl, translators, 'address.cep_unavailable'))
											]));
							}
						}()
						]))
				]));
	});
var $author$project$Page$Profile$Editor$viewAddressSection = F2(
	function (translators, state) {
		var showPreviousText = $author$project$Profile$Location$isAddressEmpty(state.u.gP) && $author$project$Profile$Location$looksLikeAddress(state.bX);
		var isPicked = $author$project$Profile$Location$isPicked(state.e);
		var isCostaRica = state.e.g5 === 1;
		var hasOwnAddress = isPicked || (state.e.g5 === 2);
		var errors = function () {
			if (state.dW && hasOwnAddress) {
				var _v0 = A2($author$project$Profile$Location$validateAddress, state.e.g5, state.gP);
				if (!_v0.$) {
					return _List_Nil;
				} else {
					var found = _v0.a;
					return found;
				}
			} else {
				return _List_Nil;
			}
		}();
		var errorFor = F2(
			function (error, message) {
				return A2($elm$core$List$member, error, errors) ? $elm$core$Maybe$Just(
					A2($author$project$Page$Profile$Editor$tl, translators, message)) : $elm$core$Maybe$Nothing;
			});
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mb-10')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('font-bold text-lg mb-1')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$Page$Profile$Editor$tl, translators, 'address.title'))
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-gray-700 mb-4')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$Page$Profile$Editor$tl, translators, 'address.private'))
						])),
					((!state.e.g5) || (state.e.g5 === 2)) ? A3($author$project$Page$Profile$Editor$viewCepField, translators, state, errorFor) : $elm$html$Html$text(''),
					(!hasOwnAddress) ? A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id('location-address-needs-place'),
							$elm$html$Html$Attributes$class('p-4 rounded bg-gray-100 text-gray-700')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							isCostaRica ? A2($author$project$Page$Profile$Editor$tl, translators, 'address.needs_canton') : A2($author$project$Page$Profile$Editor$tl, translators, 'address.needs_city_or_cep'))
						])) : A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							showPreviousText ? A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$id('location-previous-text'),
									$elm$html$Html$Attributes$class('mb-4 p-4 rounded bg-gray-100 text-gray-333 break-words')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($author$project$Page$Profile$Editor$tl, translators, 'address.previous_text') + ' '),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('font-bold')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(state.bX)
										]))
								])) : $elm$html$Html$text(''),
							isCostaRica ? A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Page$Profile$Editor$viewTextInput(
									{
										aQ: _List_fromArray(
											[
												A2($elm$html$Html$Attributes$attribute, 'autocomplete', 'street-address')
											]),
										mM: A2(errorFor, 0, 'errors.directions_required'),
										R: 'address-street-input',
										a$: false,
										nC: A2($author$project$Page$Profile$Editor$tl, translators, 'address.directions'),
										a3: $author$project$Page$Profile$Editor$ChangedAddress(0),
										oG: '',
										iw: translators,
										pO: state.gP.ba
									}),
									$author$project$Page$Profile$Editor$viewTextInput(
									{
										aQ: _List_fromArray(
											[
												A2($elm$html$Html$Attributes$attribute, 'inputmode', 'numeric'),
												A2($elm$html$Html$Attributes$attribute, 'autocomplete', 'postal-code'),
												$elm$html$Html$Attributes$maxlength(5)
											]),
										mM: A2(errorFor, 2, 'errors.postal_code_invalid'),
										R: 'address-postal-code-input',
										a$: false,
										nC: A2($author$project$Page$Profile$Editor$tl, translators, 'address.postal_code_cr'),
										a3: $author$project$Page$Profile$Editor$ChangedAddress(3),
										oG: '',
										iw: translators,
										pO: state.gP.dM
									})
								])) : A3($author$project$Page$Profile$Editor$viewBrazilAddressFields, translators, state, errorFor)
						]))
				]));
	});
var $author$project$Page$Profile$Editor$ChangedCountry = function (a) {
	return {$: 7, a: a};
};
var $author$project$Page$Profile$Editor$ChangedOtherText = function (a) {
	return {$: 16, a: a};
};
var $author$project$Page$Profile$Editor$countryToString = function (country) {
	switch (country) {
		case 0:
			return 'BR';
		case 1:
			return 'CR';
		default:
			return 'OTHER';
	}
};
var $author$project$Page$Profile$Editor$ChangedBairroText = function (a) {
	return {$: 15, a: a};
};
var $author$project$Page$Profile$Editor$ClickedBackToList = {$: 13};
var $author$project$Page$Profile$Editor$ClickedBairroNotListed = {$: 12};
var $author$project$Page$Profile$Editor$ClickedChangeBairro = {$: 11};
var $author$project$Form$LocalityPicker$availability = function (_v0) {
	var model = _v0;
	return model.fr;
};
var $author$project$Form$LocalityPicker$GotSelectMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Form$LocalityPicker$view = F2(
	function (config, _v0) {
		var model = _v0;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mb-4')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$View$Components$label,
					_List_Nil,
					{nD: config.nC, pv: model.R}),
					A2(
					$elm$html$Html$map,
					$author$project$Form$LocalityPicker$GotSelectMsg,
					A4(
						$author$project$View$Select$view,
						A2($author$project$Form$LocalityPicker$settings, config, model.eG),
						model.dT,
						model.gk,
						_List_Nil))
				]));
	});
var $author$project$Page$Profile$Editor$viewChosen = function (config) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('mb-4')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$View$Components$label,
				_List_Nil,
				{nD: config.nC, pv: config.R}),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex items-center justify-between gap-4 input')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$id(config.R),
								$elm$html$Html$Attributes$class('truncate')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(config.pO)
							])),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('button'),
								$elm$html$Html$Attributes$class('text-orange-500 font-bold hover:underline shrink-0 focus-ring'),
								$elm$html$Html$Events$onClick(config.oe)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(config.g_)
							]))
					]))
			]));
};
var $author$project$Page$Profile$Editor$viewBairro = F2(
	function (translators, state) {
		var textError = function () {
			if (state.dW) {
				var _v5 = $author$project$Profile$Location$validateBairroText(state.e.aF);
				if (!_v5.$) {
					return $elm$core$Maybe$Nothing;
				} else {
					if (!_v5.a) {
						var _v6 = _v5.a;
						return $elm$core$Maybe$Just(
							A2($author$project$Page$Profile$Editor$tl, translators, 'errors.bairro_too_long'));
					} else {
						var _v7 = _v5.a;
						return $elm$core$Maybe$Just(
							A2($author$project$Page$Profile$Editor$tl, translators, 'errors.bairro_not_plain'));
					}
				}
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var linkButton = F2(
			function (labelKey, msg) {
				return A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('button'),
							$elm$html$Html$Attributes$class('text-orange-500 font-bold hover:underline mb-4 -mt-2 block focus-ring'),
							$elm$html$Html$Events$onClick(msg)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$Page$Profile$Editor$tl, translators, labelKey))
						]));
			});
		var isCostaRica = state.e.g5 === 1;
		var label = isCostaRica ? A2($author$project$Page$Profile$Editor$tl, translators, 'district') : A2($author$project$Page$Profile$Editor$tl, translators, 'neighborhood');
		var optionalLabel = isCostaRica ? A2($author$project$Page$Profile$Editor$tl, translators, 'district_optional') : A2($author$project$Page$Profile$Editor$tl, translators, 'neighborhood_optional');
		var textInput = $author$project$Page$Profile$Editor$viewTextInput(
			{
				aQ: _List_Nil,
				mM: textError,
				R: 'location-bairro-text-input',
				a$: false,
				nC: optionalLabel,
				a3: $author$project$Page$Profile$Editor$ChangedBairroText,
				oG: A2($author$project$Page$Profile$Editor$tl, translators, 'bairro_text_placeholder'),
				iw: translators,
				pO: state.e.aF
			});
		var _v0 = _Utils_Tuple2(state.e.by, state.b4);
		if (!_v0.a.$) {
			var bairro = _v0.a.a;
			return $author$project$Page$Profile$Editor$viewChosen(
				{
					g_: A2($author$project$Page$Profile$Editor$tl, translators, 'change'),
					R: 'location-bairro-chosen',
					nC: label,
					oe: $author$project$Page$Profile$Editor$ClickedChangeBairro,
					pO: bairro.ki
				});
		} else {
			if (_v0.b.$ === 1) {
				var _v1 = _v0.a;
				var _v2 = _v0.b;
				return textInput;
			} else {
				var _v3 = _v0.a;
				var picker = _v0.b.a;
				var _v4 = $author$project$Form$LocalityPicker$availability(picker);
				switch (_v4) {
					case 0:
						return A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mb-4 text-gray-700')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($author$project$Page$Profile$Editor$tl, translators, 'loading'))
								]));
					case 2:
						return textInput;
					default:
						return state.br ? A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									textInput,
									A2(linkButton, 'back_to_list', $author$project$Page$Profile$Editor$ClickedBackToList)
								])) : A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									$author$project$Page$Profile$Editor$GotBairroPickerMsg,
									A2(
										$author$project$Form$LocalityPicker$view,
										{
											m$: false,
											nC: label,
											kl: A2($author$project$Page$Profile$Editor$tl, translators, 'not_found'),
											oG: A2($author$project$Page$Profile$Editor$tl, translators, 'bairro_placeholder')
										},
										picker)),
									A2(
									linkButton,
									isCostaRica ? 'district_not_listed' : 'neighborhood_not_listed',
									$author$project$Page$Profile$Editor$ClickedBairroNotListed)
								]));
				}
			}
		}
	});
var $author$project$Page$Profile$Editor$ToggledFeedback = {$: 20};
var $author$project$Page$Profile$Editor$viewBeta = function (translators) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('inline-flex items-center rounded-full bg-gray-200 text-gray-333 text-sm font-bold pl-3')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				A2($author$project$Page$Profile$Editor$tl, translators, 'beta')),
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$type_('button'),
						$elm$html$Html$Attributes$class('ml-2 px-3 h-8 rounded-full hover:bg-gray-300 focus-ring'),
						$elm$html$Html$Events$onClick($author$project$Page$Profile$Editor$ToggledFeedback)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2($author$project$Page$Profile$Editor$tl, translators, 'send_feedback'))
					]))
			]));
};
var $author$project$Page$Profile$Editor$ChangedFeedbackBody = function (a) {
	return {$: 22, a: a};
};
var $author$project$Page$Profile$Editor$ChangedFeedbackKind = function (a) {
	return {$: 21, a: a};
};
var $author$project$Page$Profile$Editor$ClickedSendFeedback = {$: 23};
var $author$project$Page$Profile$Editor$viewFeedback = F2(
	function (translators, feedback) {
		var _v0 = _Utils_Tuple2(feedback.gE, feedback.dv);
		if (_v0.a === 2) {
			var _v1 = _v0.a;
			return A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mb-4 text-gray-333')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2($author$project$Page$Profile$Editor$tl, translators, 'feedback.sent'))
					]));
		} else {
			if (!_v0.b) {
				return $elm$html$Html$text('');
			} else {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mb-6 p-4 rounded bg-gray-100')
						]),
					_List_fromArray(
						[
							function (options) {
							return A2(
								$author$project$Form$Select$view,
								options,
								{
									mM: $elm$html$Html$text(''),
									m$: false,
									nx: false,
									od: $author$project$Page$Profile$Editor$NoOp,
									kv: $author$project$Page$Profile$Editor$ChangedFeedbackKind,
									pO: feedback.eG
								});
						}(
							A3(
								$author$project$Form$Select$withOption,
								'blocker',
								A2($author$project$Page$Profile$Editor$tl, translators, 'feedback.kind_blocker'),
								A3(
									$author$project$Form$Select$withOption,
									'idea',
									A2($author$project$Page$Profile$Editor$tl, translators, 'feedback.kind_idea'),
									A3(
										$author$project$Form$Select$withOption,
										'problem',
										A2($author$project$Page$Profile$Editor$tl, translators, 'feedback.kind_problem'),
										A2(
											$author$project$Form$Select$withContainerAttrs,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('!mb-4')
												]),
											$author$project$Form$Select$init(
												{
													R: 'location-feedback-kind',
													nC: A2($author$project$Page$Profile$Editor$tl, translators, 'feedback.kind'),
													dG: $elm$core$Basics$identity
												})))))),
							$author$project$Page$Profile$Editor$viewTextInput(
							{
								aQ: _List_fromArray(
									[
										$elm$html$Html$Attributes$maxlength(2000)
									]),
								mM: $elm$core$Maybe$Nothing,
								R: 'location-feedback-body',
								a$: true,
								nC: A2($author$project$Page$Profile$Editor$tl, translators, 'feedback.body'),
								a3: $author$project$Page$Profile$Editor$ChangedFeedbackBody,
								oG: '',
								iw: translators,
								pO: feedback.fv
							}),
							(feedback.gE === 3) ? A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('form-error normal-case tracking-normal mb-2 block')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($author$project$Page$Profile$Editor$tl, translators, 'feedback.error'))
								])) : $elm$html$Html$text(''),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex gap-4')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$type_('button'),
											$elm$html$Html$Attributes$class('button button-primary'),
											$elm$html$Html$Attributes$disabled(
											($elm$core$String$trim(feedback.fv) === '') || (feedback.gE === 1)),
											$elm$html$Html$Events$onClick($author$project$Page$Profile$Editor$ClickedSendFeedback)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2($author$project$Page$Profile$Editor$tl, translators, 'feedback.send'))
										])),
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$type_('button'),
											$elm$html$Html$Attributes$class('button button-secondary'),
											$elm$html$Html$Events$onClick($author$project$Page$Profile$Editor$ToggledFeedback)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2($author$project$Page$Profile$Editor$tl, translators, 'feedback.cancel'))
										]))
								]))
						]));
			}
		}
	});
var $author$project$Page$Profile$Editor$ClickedChangeMunicipality = {$: 10};
var $author$project$Page$Profile$Editor$viewMunicipality = F2(
	function (translators, state) {
		var label = (state.e.g5 === 1) ? A2($author$project$Page$Profile$Editor$tl, translators, 'canton') : A2($author$project$Page$Profile$Editor$tl, translators, 'city');
		var _v0 = state.e.cw;
		if (!_v0.$) {
			var municipality = _v0.a;
			return $author$project$Page$Profile$Editor$viewChosen(
				{
					g_: A2($author$project$Page$Profile$Editor$tl, translators, 'change'),
					R: 'location-municipality-chosen',
					nC: label,
					oe: $author$project$Page$Profile$Editor$ClickedChangeMunicipality,
					pO: A2($author$project$Profile$Location$municipalityRow, state.e.g5, municipality)
				});
		} else {
			return A2(
				$elm$html$Html$map,
				$author$project$Page$Profile$Editor$GotMunicipalityPickerMsg,
				A2(
					$author$project$Form$LocalityPicker$view,
					{
						m$: false,
						nC: label,
						kl: A2($author$project$Page$Profile$Editor$tl, translators, 'not_found'),
						oG: (state.e.g5 === 1) ? A2($author$project$Page$Profile$Editor$tl, translators, 'canton_placeholder') : A2($author$project$Page$Profile$Editor$tl, translators, 'city_placeholder')
					},
					state.dD));
		}
	});
var $author$project$Page$Profile$Editor$ClickedClearPlace = {$: 14};
var $author$project$Profile$Location$previewLabel = function (place) {
	var _v0 = place.g5;
	if (_v0 === 2) {
		return $author$project$Profile$Location$nonEmptyText(place.h0);
	} else {
		return A2(
			$elm$core$Maybe$map,
			function (municipality) {
				var stateCode = A2($elm$core$Maybe$withDefault, '', municipality.lc);
				var base = function () {
					var _v3 = place.g5;
					if (_v3 === 1) {
						return municipality.ki + (' - ' + ($author$project$Profile$Location$provinceName(stateCode) + ', Costa Rica'));
					} else {
						return municipality.ki + (' - ' + stateCode);
					}
				}();
				var bairroName = function () {
					var _v2 = place.by;
					if (!_v2.$) {
						var bairro = _v2.a;
						return $elm$core$Maybe$Just(bairro.ki);
					} else {
						return $author$project$Profile$Location$nonEmptyText(place.aF);
					}
				}();
				if (!bairroName.$) {
					var name = bairroName.a;
					return name + (', ' + base);
				} else {
					return base;
				}
			},
			place.cw);
	}
};
var $author$project$Page$Profile$Editor$viewPreview = F2(
	function (translators, place) {
		var _v0 = $author$project$Profile$Location$previewLabel(place);
		if (!_v0.$) {
			var label = _v0.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex flex-wrap items-center justify-between gap-x-4 gap-y-2 p-4 rounded bg-gray-100')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$id('location-preview')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2($author$project$Page$Profile$Editor$tl, translators, 'preview_prefix') + ' '),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('font-bold')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(label)
									]))
							])),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('button'),
								$elm$html$Html$Attributes$class('text-orange-500 font-bold hover:underline focus-ring'),
								$elm$html$Html$Events$onClick($author$project$Page$Profile$Editor$ClickedClearPlace)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2($author$project$Page$Profile$Editor$tl, translators, 'clear'))
							]))
					]));
		} else {
			return A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$id('location-preview'),
						$elm$html$Html$Attributes$class('text-gray-700')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2($author$project$Page$Profile$Editor$tl, translators, 'preview_empty'))
					]));
		}
	});
var $author$project$Page$Profile$Editor$viewPlaceSection = F2(
	function (translators, state) {
		var _v0 = state;
		var place = _v0.e;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mb-10')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-wrap items-center gap-x-3 gap-y-1 mb-4')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h2,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('font-bold text-lg')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($author$project$Page$Profile$Editor$tl, translators, 'title'))
								])),
							$author$project$Page$Profile$Editor$viewBeta(translators)
						])),
					A2($author$project$Page$Profile$Editor$viewFeedback, translators, state.hf),
					function (options) {
					return A2(
						$author$project$Form$Select$view,
						options,
						{
							mM: $elm$html$Html$text(''),
							m$: false,
							nx: false,
							od: $author$project$Page$Profile$Editor$NoOp,
							kv: $author$project$Page$Profile$Editor$ChangedCountry,
							pO: place.g5
						});
				}(
					A3(
						$author$project$Form$Select$withOption,
						2,
						A2($author$project$Page$Profile$Editor$tl, translators, 'country_other'),
						A3(
							$author$project$Form$Select$withOption,
							1,
							A2($author$project$Page$Profile$Editor$tl, translators, 'country_costa_rica'),
							A3(
								$author$project$Form$Select$withOption,
								0,
								A2($author$project$Page$Profile$Editor$tl, translators, 'country_brazil'),
								A2(
									$author$project$Form$Select$withContainerAttrs,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('!mb-4')
										]),
									$author$project$Form$Select$init(
										{
											R: 'location-country-input',
											nC: A2($author$project$Page$Profile$Editor$tl, translators, 'country'),
											dG: $author$project$Page$Profile$Editor$countryToString
										})))))),
					function () {
					var _v1 = place.g5;
					if (_v1 === 2) {
						return $author$project$Page$Profile$Editor$viewTextInput(
							{
								aQ: _List_fromArray(
									[
										$elm$html$Html$Attributes$maxlength(120)
									]),
								mM: $elm$core$Maybe$Nothing,
								R: 'location-other-input',
								a$: false,
								nC: A2($author$project$Page$Profile$Editor$tl, translators, 'other_label'),
								a3: $author$project$Page$Profile$Editor$ChangedOtherText,
								oG: A2($author$project$Page$Profile$Editor$tl, translators, 'other_placeholder'),
								iw: translators,
								pO: place.h0
							});
					} else {
						return A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2($author$project$Page$Profile$Editor$viewMunicipality, translators, state),
									(!_Utils_eq(place.cw, $elm$core$Maybe$Nothing)) ? A2($author$project$Page$Profile$Editor$viewBairro, translators, state) : $elm$html$Html$text('')
								]));
					}
				}(),
					A2($author$project$Page$Profile$Editor$viewPreview, translators, place)
				]));
	});
var $author$project$Page$Profile$Editor$view_ = F3(
	function (loggedIn, _v0, profile) {
		var form = _v0.hk;
		var location = _v0.nN;
		var translators = loggedIn.aM.iw;
		var _v1 = loggedIn.aM.iw;
		var t = _v1.il;
		var title = t('menu.edit') + (' ' + $elm$core$String$toLower(
			t('menu.profile')));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bg-white')
				]),
			_List_fromArray(
				[
					A2($author$project$Page$viewHeader, loggedIn, title),
					A6(
					$author$project$Form$view,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('container mx-auto p-4')
						]),
					translators,
					function (submitButton) {
						return _List_fromArray(
							[
								function () {
								if (!location.$) {
									var locationState = location.a;
									return A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												A2($author$project$Page$Profile$Editor$viewPlaceSection, translators, locationState),
												A2($author$project$Page$Profile$Editor$viewAddressSection, translators, locationState)
											]));
								} else {
									return $elm$html$Html$text('');
								}
							}(),
								A2(
								submitButton,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('button button-primary w-full')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										t('profile.edit.submit'))
									]))
							]);
					},
					A2(
						$author$project$Page$Profile$Editor$createForm,
						translators,
						{
							ck: A2(
								$elm$core$List$any,
								function ($) {
									return $.ck;
								},
								profile.ei),
							jA: !_Utils_eq(location, $elm$core$Maybe$Nothing)
						}),
					form,
					{oq: $author$project$Page$Profile$Editor$ClickedSave, pA: $author$project$Page$Profile$Editor$GotFormMsg})
				]));
	});
var $author$project$Page$Profile$Editor$view = F2(
	function (loggedIn, model) {
		var _v0 = loggedIn.aM.iw;
		var t = _v0.il;
		var content = function () {
			var _v1 = loggedIn.kJ;
			switch (_v1.$) {
				case 1:
					return $author$project$Page$fullPageLoading(loggedIn.aM);
				case 0:
					return $author$project$Page$fullPageLoading(loggedIn.aM);
				case 2:
					var e = _v1.a;
					return A2(
						$author$project$Page$fullPageGraphQLError,
						t('profile.title'),
						e);
				default:
					var profile = _v1.a;
					var _v2 = _Utils_Tuple2(model.cg, model.hk);
					_v2$0:
					while (true) {
						if (!_v2.b.$) {
							if (_v2.a.$ === 2) {
								break _v2$0;
							} else {
								var _v3 = _v2.b;
								return $author$project$Page$fullPageLoading(loggedIn.aM);
							}
						} else {
							if (_v2.a.$ === 2) {
								break _v2$0;
							} else {
								var loaded = _v2.b.a;
								return A3($author$project$Page$Profile$Editor$view_, loggedIn, loaded, profile);
							}
						}
					}
					var e = _v2.a.a;
					return A2(
						$author$project$Page$fullPageGraphQLError,
						t('profile.title'),
						e);
			}
		}();
		var title = t('profile.edit.title');
		return {mk: content, fb: title};
	});
var $author$project$Page$Register$AgreedToSave12Words = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$Register$CopyToClipboard = function (a) {
	return {$: 7, a: a};
};
var $author$project$Page$Register$DownloadPdf = function (a) {
	return {$: 5, a: a};
};
var $author$project$Page$Register$viewAccountCreated = F3(
	function (translators, model, keys) {
		var t = translators.il;
		var tr = translators.iu;
		var passphraseTextId = 'passphraseText';
		var passphraseInputId = 'passphraseWords';
		var name = $author$project$Eos$Account$nameToString(keys.lM);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex-grow bg-purple-500 flex md:block')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-col justify-between px-4 md:max-w-sm md:mx-auto md:pt-20 md:px-0 text-white')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('font-bold mb-2')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												tr,
												'register.account_created.greet',
												_List_fromArray(
													[
														_Utils_Tuple2('name', name)
													])))
										])),
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('mb-6')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											t('register.account_created.instructions'))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('w-1/4 m-auto relative left-4')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$img,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$src('/images/reg-passphrase-boy.svg')
												]),
											_List_Nil),
											A2(
											$elm$html$Html$img,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('absolute w-1/4 -mt-2 -ml-10'),
													$elm$html$Html$Attributes$src('/images/reg-passphrase-boy-hand.svg')
												]),
											_List_Nil)
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('bg-white text-black text-2xl p-4 rounded-lg')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('text-sm font-bold mb-4 text-black')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													t('register.account_created.twelve_words')),
													model.f0 ? A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('ml-1')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															t('register.account_created.words_copied')),
															$elm$html$Html$text(' ✔')
														])) : $elm$html$Html$text('')
												])),
											A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('pb-4')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('select-all text-lg block font-bold'),
															$elm$html$Html$Attributes$id(passphraseTextId)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(keys.gN)
														])),
													function (options) {
													return A2(
														$author$project$Form$Text$view,
														options,
														{
															mM: $elm$html$Html$text(''),
															m$: false,
															nx: false,
															od: $author$project$Page$Register$NoOp,
															oe: function (_v0) {
																return $author$project$Page$Register$NoOp;
															},
															iw: translators,
															pO: keys.gN
														});
												}(
													A2(
														$author$project$Form$Text$withContainerAttrs,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('mb-0 absolute opacity-0 left-[-9999em]')
															]),
														$author$project$Form$Text$init(
															{R: passphraseInputId, nC: ''})))
												])),
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('button m-auto button-primary button-sm'),
													$elm$html$Html$Events$onClick(
													$author$project$Page$Register$CopyToClipboard(passphraseInputId))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													t('register.account_created.copy'))
												]))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									function (options) {
									return A2(
										$author$project$Form$Checkbox$view,
										options,
										{
											mM: $elm$html$Html$text(''),
											m$: false,
											nx: true,
											od: $author$project$Page$Register$NoOp,
											of: $author$project$Page$Register$AgreedToSave12Words,
											pO: model.ex
										});
								}(
									A2(
										$author$project$Form$Checkbox$withContainerAttrs,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('my-6 font-bold')
											]),
										$author$project$Form$Checkbox$init(
											{
												R: 'agreed-save-passphrase',
												nC: $elm$html$Html$text(
													t('register.account_created.i_saved_words') + ' 💜')
											}))),
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Events$onClick(
											$author$project$Page$Register$DownloadPdf(
												{
													lM: $author$project$Eos$Account$nameToString(keys.lM),
													a6: keys.gN
												})),
											$elm$html$Html$Attributes$class('button button-primary w-full mb-4'),
											$elm$html$Html$Attributes$disabled(!model.ex)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											t('register.account_created.download'))
										]))
								]))
						]))
				]));
	});
var $author$project$Page$Register$JuridicalAccount = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Register$NaturalAccount = {$: 0};
var $author$project$Page$Register$AccountTypeSelected = function (a) {
	return {$: 11, a: a};
};
var $author$project$Page$Register$viewAccountTypeButton = F3(
	function (title, accountType, status) {
		var isSelected = function () {
			var _v0 = _Utils_Tuple2(accountType, status);
			_v0$2:
			while (true) {
				if (!_v0.a.$) {
					if ((_v0.b.$ === 2) && (!_v0.b.b.$)) {
						var _v1 = _v0.a;
						var _v2 = _v0.b;
						return true;
					} else {
						break _v0$2;
					}
				} else {
					if ((_v0.b.$ === 2) && (_v0.b.b.$ === 1)) {
						var _v3 = _v0.b;
						return true;
					} else {
						break _v0$2;
					}
				}
			}
			return false;
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('w-1/2 text-center cursor-pointer rounded-sm cursor-pointer mb-4 py-2'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('bg-orange-300 text-white font-bold', isSelected),
							_Utils_Tuple2('bg-gray-100 text-black', !isSelected)
						])),
					$elm$html$Html$Events$onClick(
					$author$project$Page$Register$AccountTypeSelected(accountType))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(title)
				]));
	});
var $author$project$Page$Register$viewAccountTypeSelector = F2(
	function (translators, model) {
		var _v0 = model.g5;
		if (!_v0.$) {
			var country = _v0.a;
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$View$Components$label,
						_List_Nil,
						{
							nD: translators.il('register.form.register_tooltip'),
							pv: 'radio'
						}),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex space-x-2 mb-4')
							]),
						_List_fromArray(
							[
								A3(
								$author$project$Page$Register$viewAccountTypeButton,
								translators.il('register.form.types.natural'),
								$author$project$Page$Register$NaturalAccount,
								model.gE),
								A3(
								$author$project$Page$Register$viewAccountTypeButton,
								translators.il('register.form.types.juridical'),
								$author$project$Page$Register$JuridicalAccount(country),
								model.gE)
							]))
					]));
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Page$Register$viewFooter = F2(
	function (guest, submitButton) {
		var _v0 = guest.aM.iw;
		var t = _v0.il;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mt-auto flex flex-col items-center text-gray-333 md:mt-0')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mb-6')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							t('register.login')),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('underline text-orange-300'),
									$author$project$Route$href(
									A2($author$project$Route$Login, guest.j8, guest.lS))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('register.authLink'))
								]))
						])),
					A2(
					submitButton,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('button button-primary w-full mb-4')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							t('auth.login.continue'))
						]))
				]));
	});
var $author$project$Eos$Account$maxNameLength = 12;
var $author$project$Eos$Account$minNameLength = 12;
var $author$project$Eos$Account$errorToString = F2(
	function (_v0, error) {
		var tr = _v0.iu;
		switch (error.$) {
			case 0:
				var firstInvalidCharacter = error.a;
				return A2(
					tr,
					'error.notAllowedChar',
					_List_fromArray(
						[
							_Utils_Tuple2(
							'char',
							$elm$core$String$fromChar(firstInvalidCharacter))
						]));
			case 1:
				return A2(
					tr,
					'error.validator.text.exactly',
					_List_fromArray(
						[
							_Utils_Tuple2(
							'base',
							$elm$core$String$fromInt($author$project$Eos$Account$minNameLength))
						]));
			default:
				return A2(
					tr,
					'error.validator.text.exactly',
					_List_fromArray(
						[
							_Utils_Tuple2(
							'base',
							$elm$core$String$fromInt($author$project$Eos$Account$maxNameLength))
						]));
		}
	});
var $author$project$Eos$Account$InvalidCharacters = function (a) {
	return {$: 0, a: a};
};
var $author$project$Eos$Account$TooLong = {$: 2};
var $author$project$Eos$Account$TooShort = {$: 1};
var $author$project$Eos$Account$fromString = function (string) {
	var sanitizedString = $elm$core$String$toLower(
		$elm$core$String$trim(string));
	var isCharacterAllowed = function (_char) {
		return $elm$core$Char$isAlpha(_char) || A2(
			$elm$core$List$member,
			_char,
			_List_fromArray(
				['1', '2', '3', '4', '5']));
	};
	var _v0 = $elm$core$List$head(
		$elm$core$String$toList(
			A2(
				$elm$core$String$filter,
				A2($elm$core$Basics$composeL, $elm$core$Basics$not, isCharacterAllowed),
				sanitizedString)));
	if (!_v0.$) {
		var firstInvalidCharacter = _v0.a;
		return $elm$core$Result$Err(
			$author$project$Eos$Account$InvalidCharacters(firstInvalidCharacter));
	} else {
		return (_Utils_cmp(
			$elm$core$String$length(sanitizedString),
			$author$project$Eos$Account$minNameLength) < 0) ? $elm$core$Result$Err($author$project$Eos$Account$TooShort) : ((_Utils_cmp(
			$elm$core$String$length(sanitizedString),
			$author$project$Eos$Account$maxNameLength) > 0) ? $elm$core$Result$Err($author$project$Eos$Account$TooLong) : $elm$core$Result$Ok(sanitizedString));
	}
};
var $author$project$Form$Validate$eosName = $author$project$Form$Validate$custom(
	function (stringInput) {
		var _v0 = $author$project$Eos$Account$fromString(stringInput);
		if (!_v0.$) {
			var account = _v0.a;
			return $elm$core$Result$Ok(account);
		} else {
			var error = _v0.a;
			return $elm$core$Result$Err(
				function (translators) {
					return A2($author$project$Eos$Account$errorToString, translators, error);
				});
		}
	});
var $author$project$Page$Register$Common$accountNameField = F2(
	function (translators, _v0) {
		var t = translators.il;
		var unavailableAccounts = _v0.gJ;
		return A2(
			$author$project$Form$textField,
			{
				ab: $elm$core$Basics$always($elm$core$Maybe$Nothing),
				af: A2(
					$elm$core$Basics$composeR,
					$author$project$Form$Validate$succeed,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Form$Validate$eosName,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Form$Validate$custom(
								function (accountName) {
									return A2(
										$elm$core$Set$member,
										$author$project$Eos$Account$nameToString(accountName),
										unavailableAccounts) ? $elm$core$Result$Err(
										function (translators_) {
											return translators_.il('error.alreadyTaken');
										}) : $elm$core$Result$Ok(accountName);
								}),
							$author$project$Form$Validate$validate(translators)))),
				n: F2(
					function (account, input) {
						return _Utils_update(
							input,
							{fl: account});
					}),
				pO: function ($) {
					return $.fl;
				}
			},
			A2(
				$author$project$Form$Text$withCounter,
				$author$project$Form$Text$CountLetters(12),
				A2(
					$author$project$Form$Text$withPlaceholder,
					t('register.form.account.placeholder'),
					$author$project$Form$Text$init(
						{
							R: 'account-input',
							nC: t('register.form.account.label')
						}))));
	});
var $author$project$Form$Validate$isValidEmail = function () {
	var validEmailRegex = A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		A2(
			$elm$regex$Regex$fromStringWith,
			{l0: true, nX: false},
			'^[a-zA-Z0-9.!#$%&\'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$'));
	return $elm$regex$Regex$contains(validEmailRegex);
}();
var $author$project$Form$Validate$email = $author$project$Form$Validate$custom(
	function (stringInput) {
		return $author$project$Form$Validate$isValidEmail(stringInput) ? $elm$core$Result$Ok(stringInput) : $elm$core$Result$Err(
			function (_v0) {
				var t = _v0.il;
				return t('error.email');
			});
	});
var $author$project$Page$Register$Common$emailField = function (translators) {
	var t = translators.il;
	return A2(
		$author$project$Form$textField,
		{
			ab: $elm$core$Basics$always($elm$core$Maybe$Nothing),
			af: A2(
				$elm$core$Basics$composeR,
				$author$project$Form$Validate$succeed,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Form$Validate$email,
					$author$project$Form$Validate$validate(translators))),
			n: F2(
				function (email, input) {
					return _Utils_update(
						input,
						{jh: email});
				}),
			pO: function ($) {
				return $.jh;
			}
		},
		A2(
			$author$project$Form$Text$withPlaceholder,
			t('register.form.email.placeholder'),
			$author$project$Form$Text$init(
				{
					R: 'email-input',
					nC: t('register.form.email.label')
				})));
};
var $author$project$Page$Register$Common$personNameField = function (_v0) {
	var t = _v0.il;
	return A2(
		$author$project$Form$textField,
		{
			ab: $elm$core$Basics$always($elm$core$Maybe$Nothing),
			af: $elm$core$Result$Ok,
			n: F2(
				function (name, input) {
					return _Utils_update(
						input,
						{ki: name});
				}),
			pO: function ($) {
				return $.ki;
			}
		},
		A2(
			$author$project$Form$Text$withPlaceholder,
			t('register.form.name.placeholder'),
			$author$project$Form$Text$init(
				{
					R: 'name-input',
					nC: t('register.form.name.label')
				})));
};
var $author$project$Page$Register$DefaultForm$form = F2(
	function (translators, unavailableAccounts) {
		return A2(
			$author$project$Form$with,
			$author$project$Page$Register$Common$emailField(translators),
			A2(
				$author$project$Form$with,
				A2($author$project$Page$Register$Common$accountNameField, translators, unavailableAccounts),
				A2(
					$author$project$Form$with,
					$author$project$Page$Register$Common$personNameField(translators),
					$author$project$Form$succeed($author$project$Page$Register$DefaultForm$FormOutput))));
	});
var $elm_community$maybe_extra$Maybe$Extra$andThen2 = F3(
	function (func, ma, mb) {
		if (!ma.$) {
			var a = ma.a;
			if (!mb.$) {
				var b = mb.a;
				return A2(func, a, b);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Page$Register$JuridicalForm$costaRicaZipcodes = _List_fromArray(
	['10101', '10102', '10103', '10104', '10105', '10106', '10107', '10108', '10109', '10110', '10111', '10201', '10202', '10203', '10301', '10302', '10303', '10304', '10305', '10306', '10307', '10308', '10309', '10310', '10311', '10312', '10313', '10401', '10402', '10403', '10404', '10405', '10406', '10407', '10408', '10409', '10501', '10502', '10503', '10601', '10602', '10603', '10604', '10605', '10606', '10607', '10701', '10702', '10703', '10704', '10705', '10706', '10707', '10801', '10802', '10803', '10804', '10805', '10806', '10807', '10901', '10902', '10903', '10904', '10905', '10906', '11001', '11002', '11003', '11004', '11005', '11101', '11102', '11103', '11104', '11105', '11201', '11202', '11203', '11204', '11205', '11301', '11302', '11303', '11304', '11305', '11401', '11402', '11403', '11501', '11502', '11503', '11504', '11601', '11602', '11603', '11604', '11605', '11701', '11702', '11703', '11801', '11802', '11803', '11804', '11901', '11902', '11903', '11904', '11905', '11906', '11907', '11908', '11909', '11910', '11911', '11912', '12001', '12002', '12003', '12004', '12005', '12006', '20101', '20102', '20103', '20104', '20105', '20106', '20107', '20108', '20109', '20110', '20111', '20112', '20113', '20114', '20201', '20202', '20203', '20204', '20205', '20206', '20207', '20208', '20209', '20210', '20211', '20212', '20213', '20214', '20301', '20302', '20303', '20304', '20305', '20307', '20308', '20401', '20402', '20403', '20404', '20501', '20502', '20503', '20504', '20505', '20506', '20507', '20508', '20601', '20602', '20603', '20604', '20605', '20606', '20607', '20608', '20701', '20702', '20703', '20704', '20705', '20706', '20707', '20801', '20802', '20803', '20804', '20805', '20901', '20902', '20903', '20904', '20905', '21001', '21002', '21003', '21004', '21005', '21006', '21007', '21008', '21009', '21010', '21011', '21012', '21013', '21101', '21102', '21103', '21104', '21105', '21106', '21107', '21201', '21202', '21203', '21204', '21205', '21301', '21302', '21303', '21304', '21305', '21306', '21307', '21308', '21401', '21402', '21403', '21404', '21501', '21502', '21503', '21504', '21601', '21602', '21603', '30101', '30102', '30103', '30104', '30105', '30106', '30107', '30108', '30109', '30110', '30111', '30201', '30202', '30203', '30204', '30205', '30301', '30302', '30303', '30304', '30305', '30306', '30307', '30308', '30401', '30402', '30403', '30501', '30502', '30503', '30504', '30505', '30506', '30507', '30508', '30509', '30510', '30511', '30512', '30601', '30602', '30603', '30701', '30702', '30703', '30704', '30705', '30801', '30802', '30803', '30804', '40101', '40102', '40103', '40104', '40105', '40201', '40202', '40203', '40204', '40205', '40206', '40301', '40302', '40303', '40304', '40305', '40306', '40307', '40308', '40401', '40402', '40403', '40404', '40405', '40406', '40501', '40502', '40503', '40504', '40505', '40601', '40602', '40603', '40604', '40701', '40702', '40703', '40801', '40802', '40803', '40901', '40902', '41001', '41002', '41003', '41004', '41005', '50101', '50102', '50103', '50104', '50105', '50201', '50202', '50203', '50204', '50205', '50206', '50207', '50301', '50302', '50303', '50304', '50305', '50306', '50307', '50308', '50309', '50401', '50402', '50403', '50404', '50501', '50502', '50503', '50504', '50601', '50602', '50603', '50604', '50605', '50701', '50702', '50703', '50704', '50801', '50802', '50803', '50804', '50805', '50806', '50807', '50808', '50901', '50902', '50903', '50904', '50905', '50906', '51001', '51002', '51003', '51004', '51101', '51102', '51103', '51104', '51105', '60101', '60102', '60103', '60104', '60105', '60106', '60107', '60108', '60109', '60110', '60111', '60112', '60113', '60114', '60115', '60116', '60201', '60202', '60203', '60204', '60205', '60206', '60301', '60302', '60303', '60304', '60305', '60306', '60307', '60308', '60309', '60401', '60402', '60403', '60501', '60502', '60503', '60504', '60505', '60506', '60601', '60602', '60603', '60701', '60702', '60703', '60704', '60801', '60802', '60803', '60804', '60805', '60806', '60901', '61001', '61002', '61003', '61004', '61101', '61102', '70101', '70102', '70103', '70104', '70201', '70202', '70203', '70204', '70205', '70206', '70207', '70301', '70302', '70303', '70304', '70305', '70306', '70307', '70401', '70402', '70403', '70404', '70501', '70502', '70503', '70601', '70602', '70603', '70604', '70605']);
var $author$project$Form$fail = function (_v0) {
	return {l: _List_Nil, m: $author$project$OptionalResult$OptNothing};
};
var $author$project$Page$Register$JuridicalForm$nameAndIdFromString = function (nameAndId) {
	var _v0 = A2($elm$core$String$split, ';', nameAndId);
	if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
		var id = _v0.a;
		var _v1 = _v0.b;
		var name = _v1.a;
		return $elm$core$Maybe$Just(
			{R: id, ki: name});
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Page$Register$JuridicalForm$nameAndIdToString = function (_v0) {
	var id = _v0.R;
	var name = _v0.ki;
	return id + (';' + name);
};
var $author$project$Page$Register$Common$phoneNumberField = function (_v0) {
	var t = _v0.il;
	return A2(
		$author$project$Form$textField,
		{
			ab: $elm$core$Basics$always($elm$core$Maybe$Nothing),
			af: function (phoneNumber) {
				return $author$project$Kyc$CostaRica$Phone$isValid(phoneNumber) ? $elm$core$Result$Ok(phoneNumber) : $elm$core$Result$Err(
					t('error.phone'));
			},
			n: F2(
				function (phoneNumber, input) {
					return _Utils_update(
						input,
						{oC: phoneNumber});
				}),
			pO: function ($) {
				return $.oC;
			}
		},
		A2(
			$author$project$Form$Text$withType,
			1,
			A2(
				$author$project$Form$Text$withCounter,
				$author$project$Form$Text$CountLetters(8),
				A2(
					$author$project$Form$Text$withPlaceholder,
					t('register.form.phone.placeholder'),
					$author$project$Form$Text$init(
						{
							R: 'phone-input',
							nC: t('register.form.phone.label')
						})))));
};
var $author$project$Form$Validate$required = $author$project$Form$Validate$custom(
	$elm$core$Result$fromMaybe(
		function (_v0) {
			var t = _v0.il;
			return t('error.required');
		}));
var $author$project$Page$Register$JuridicalForm$form = F2(
	function (translators, unavailableAccounts) {
		var t = translators.il;
		var unwrapId = function (_v11) {
			var id = _v11;
			return id;
		};
		return A2(
			$author$project$Form$with,
			A2(
				$author$project$Form$textField,
				{
					ab: $elm$core$Basics$always($elm$core$Maybe$Nothing),
					af: function (zip) {
						return A2($elm$core$List$member, zip, $author$project$Page$Register$JuridicalForm$costaRicaZipcodes) ? $elm$core$Result$Ok(zip) : $elm$core$Result$Err(
							t('error.zipcode'));
					},
					n: F2(
						function (zip, input) {
							return _Utils_update(
								input,
								{fk: zip});
						}),
					pO: function ($) {
						return $.fk;
					}
				},
				A2(
					$author$project$Form$Text$withCounter,
					$author$project$Form$Text$CountLetters(5),
					$author$project$Form$Text$init(
						{
							R: 'zip-input',
							nC: t('register.form.zip.label')
						}))),
			A2(
				$author$project$Form$with,
				A2(
					$author$project$Form$textField,
					{
						ab: $elm$core$Basics$always($elm$core$Maybe$Nothing),
						af: $elm$core$Result$Ok,
						n: F2(
							function (number, input) {
								return _Utils_update(
									input,
									{ay: number});
							}),
						pO: function ($) {
							return $.ay;
						}
					},
					$author$project$Form$Text$init(
						{
							R: 'address-number-input',
							nC: t('register.form.number.label')
						})),
				A2(
					$author$project$Form$with,
					A2(
						$author$project$Form$textField,
						{
							ab: $elm$core$Basics$always($elm$core$Maybe$Nothing),
							af: $elm$core$Result$Ok,
							n: F2(
								function (street, input) {
									return _Utils_update(
										input,
										{ba: street});
								}),
							pO: function ($) {
								return $.ba;
							}
						},
						$author$project$Form$Text$init(
							{
								R: 'street-input',
								nC: t('register.form.street.label')
							})),
					A2(
						$author$project$Form$with,
						$author$project$Form$introspect(
							function (_v6) {
								var city = _v6.l4;
								var state = _v6.X;
								var country = _v6.g5;
								var availableDistricts = A3(
									$elm_community$maybe_extra$Maybe$Extra$andThen2,
									F2(
										function (validState, validCity) {
											return A2(
												$elm$core$Maybe$map,
												function ($) {
													return $.n$;
												},
												A2(
													$elm$core$Maybe$andThen,
													function (_v9) {
														var cities = _v9.l3;
														return A2(
															$elm_community$list_extra$List$Extra$find,
															function (_v10) {
																var id = _v10.R;
																return _Utils_eq(
																	unwrapId(id),
																	validCity.R);
															},
															cities);
													},
													A2(
														$elm_community$list_extra$List$Extra$find,
														function (_v8) {
															var id = _v8.R;
															return _Utils_eq(
																unwrapId(id),
																validState.R);
														},
														country.pj)));
										}),
									state,
									city);
								if (availableDistricts.$ === 1) {
									return $author$project$Form$fail;
								} else {
									var districts = availableDistricts.a;
									return A3(
										$author$project$Form$select,
										$author$project$Page$Register$JuridicalForm$nameAndIdFromString,
										{
											ab: $elm$core$Basics$always($elm$core$Maybe$Nothing),
											af: A2(
												$elm$core$Basics$composeR,
												$author$project$Form$Validate$succeed,
												A2(
													$elm$core$Basics$composeR,
													$author$project$Form$Validate$required,
													$author$project$Form$Validate$validate(translators))),
											n: F2(
												function (district, input) {
													return _Utils_update(
														input,
														{mC: district});
												}),
											pO: function ($) {
												return $.mC;
											}
										},
										A2(
											$author$project$Form$Select$withContainerAttrs,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('mb-10')
												]),
											A2(
												$author$project$Form$Select$withOptions,
												A2(
													$elm$core$List$map,
													function (district) {
														return {
															nC: district.ki,
															gj: $elm$core$Maybe$Just(
																{
																	R: unwrapId(district.R),
																	ki: district.ki
																})
														};
													},
													districts),
												A3(
													$author$project$Form$Select$withOption,
													$elm$core$Maybe$Nothing,
													t('register.form.select.district'),
													$author$project$Form$Select$init(
														{
															R: 'district-select',
															nC: t('register.form.district'),
															dG: A2(
																$elm$core$Basics$composeR,
																$elm$core$Maybe$map($author$project$Page$Register$JuridicalForm$nameAndIdToString),
																$elm$core$Maybe$withDefault(''))
														})))));
								}
							}),
						A2(
							$author$project$Form$with,
							$author$project$Form$introspect(
								function (_v2) {
									var state = _v2.X;
									var country = _v2.g5;
									if (state.$ === 1) {
										return $author$project$Form$fail;
									} else {
										var validState = state.a;
										var _v4 = A2(
											$elm_community$list_extra$List$Extra$find,
											function (_v5) {
												var id = _v5.R;
												return _Utils_eq(
													unwrapId(id),
													validState.R);
											},
											country.pj);
										if (_v4.$ === 1) {
											return $author$project$Form$fail;
										} else {
											var stateFromCountry = _v4.a;
											return A3(
												$author$project$Form$select,
												$author$project$Page$Register$JuridicalForm$nameAndIdFromString,
												{
													ab: $elm$core$Basics$always($elm$core$Maybe$Nothing),
													af: A2(
														$elm$core$Basics$composeR,
														$author$project$Form$Validate$succeed,
														A2(
															$elm$core$Basics$composeR,
															$author$project$Form$Validate$required,
															$author$project$Form$Validate$validate(translators))),
													n: F2(
														function (city, input) {
															return _Utils_update(
																input,
																{l4: city});
														}),
													pO: function ($) {
														return $.l4;
													}
												},
												A2(
													$author$project$Form$Select$withContainerAttrs,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('mb-10')
														]),
													A2(
														$author$project$Form$Select$withOptions,
														A2(
															$elm$core$List$map,
															function (city) {
																return {
																	nC: city.ki,
																	gj: $elm$core$Maybe$Just(
																		{
																			R: unwrapId(city.R),
																			ki: city.ki
																		})
																};
															},
															stateFromCountry.l3),
														A3(
															$author$project$Form$Select$withOption,
															$elm$core$Maybe$Nothing,
															t('register.form.select.city'),
															$author$project$Form$Select$init(
																{
																	R: 'city-select',
																	nC: t('register.form.city'),
																	dG: A2(
																		$elm$core$Basics$composeR,
																		$elm$core$Maybe$map($author$project$Page$Register$JuridicalForm$nameAndIdToString),
																		$elm$core$Maybe$withDefault(''))
																})))));
										}
									}
								}),
							A2(
								$author$project$Form$with,
								$author$project$Form$introspect(
									function (_v1) {
										var country = _v1.g5;
										return A3(
											$author$project$Form$select,
											$author$project$Page$Register$JuridicalForm$nameAndIdFromString,
											{
												ab: $elm$core$Basics$always($elm$core$Maybe$Nothing),
												af: A2(
													$elm$core$Basics$composeR,
													$author$project$Form$Validate$succeed,
													A2(
														$elm$core$Basics$composeR,
														$author$project$Form$Validate$required,
														$author$project$Form$Validate$validate(translators))),
												n: F2(
													function (state, input) {
														return _Utils_update(
															input,
															{X: state});
													}),
												pO: function ($) {
													return $.X;
												}
											},
											A2(
												$author$project$Form$Select$withContainerAttrs,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('mb-10')
													]),
												A2(
													$author$project$Form$Select$withOptions,
													A2(
														$elm$core$List$map,
														function (state) {
															return {
																nC: state.ki,
																gj: $elm$core$Maybe$Just(
																	{
																		R: unwrapId(state.R),
																		ki: state.ki
																	})
															};
														},
														country.pj),
													A3(
														$author$project$Form$Select$withOption,
														$elm$core$Maybe$Nothing,
														t('register.form.select.state'),
														$author$project$Form$Select$init(
															{
																R: 'state-select',
																nC: t('register.form.state'),
																dG: A2(
																	$elm$core$Basics$composeR,
																	$elm$core$Maybe$map($author$project$Page$Register$JuridicalForm$nameAndIdToString),
																	$elm$core$Maybe$withDefault(''))
															})))));
									}),
								A2(
									$author$project$Form$with,
									A2($author$project$Page$Register$Common$accountNameField, translators, unavailableAccounts),
									A2(
										$author$project$Form$with,
										$author$project$Page$Register$Common$phoneNumberField(translators),
										A2(
											$author$project$Form$with,
											$author$project$Page$Register$Common$emailField(translators),
											A2(
												$author$project$Form$with,
												A2(
													$author$project$Form$textField,
													{
														ab: $elm$core$Basics$always($elm$core$Maybe$Nothing),
														af: $elm$core$Result$Ok,
														n: F2(
															function (name, input) {
																return _Utils_update(
																	input,
																	{ki: name});
															}),
														pO: function ($) {
															return $.ki;
														}
													},
													A2(
														$author$project$Form$Text$withPlaceholder,
														t('register.form.name_example'),
														$author$project$Form$Text$init(
															{
																R: 'company-name-input',
																nC: t('register.form.company_name')
															}))),
												A2(
													$author$project$Form$with,
													$author$project$Form$introspect(
														function (_v0) {
															var companyType = _v0.md;
															return A2(
																$author$project$Form$textField,
																{
																	ab: $elm$core$Basics$always($elm$core$Maybe$Nothing),
																	af: $elm$core$Result$Ok,
																	n: F2(
																		function (document, input) {
																			return _Utils_update(
																				input,
																				{eq: document});
																		}),
																	pO: function ($) {
																		return $.eq;
																	}
																},
																A2(
																	$author$project$Form$Text$withCounter,
																	$author$project$Form$Text$CountLetters(10),
																	A2(
																		$author$project$Form$Text$withPlaceholder,
																		t(
																			'register.form.company.' + ($author$project$Page$Register$JuridicalForm$companyTypeToString(companyType) + '.placeholder')),
																		$author$project$Form$Text$init(
																			{
																				R: 'document-input',
																				nC: t(
																					'register.form.company.' + ($author$project$Page$Register$JuridicalForm$companyTypeToString(companyType) + '.label'))
																			}))));
														}),
													A2(
														$author$project$Form$with,
														A3(
															$author$project$Form$select,
															A2(
																$elm$core$Basics$composeR,
																$author$project$Page$Register$JuridicalForm$companyTypeFromString,
																$elm$core$Maybe$withDefault(0)),
															{
																ab: $elm$core$Basics$always($elm$core$Maybe$Nothing),
																af: $elm$core$Result$Ok,
																n: F2(
																	function (companyType, input) {
																		return _Utils_update(
																			input,
																			{md: companyType});
																	}),
																pO: function ($) {
																	return $.md;
																}
															},
															A2(
																$author$project$Form$Select$withContainerAttrs,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('mb-10')
																	]),
																A3(
																	$author$project$Form$Select$withOption,
																	1,
																	t('register.form.company.gran_empresa.label'),
																	A3(
																		$author$project$Form$Select$withOption,
																		0,
																		t('register.form.company.mipyme.label'),
																		$author$project$Form$Select$init(
																			{
																				R: 'company-type-select',
																				nC: t('register.form.company_type'),
																				dG: $author$project$Page$Register$JuridicalForm$companyTypeToString
																			}))))),
														$author$project$Form$succeed($author$project$Page$Register$JuridicalForm$FormOutput)))))))))))));
	});
var $author$project$Page$Register$NaturalForm$form = F2(
	function (translators, unavailableAccounts) {
		var t = translators.il;
		return A2(
			$author$project$Form$with,
			A2($author$project$Page$Register$Common$accountNameField, translators, unavailableAccounts),
			A2(
				$author$project$Form$with,
				$author$project$Page$Register$Common$phoneNumberField(translators),
				A2(
					$author$project$Form$with,
					$author$project$Page$Register$Common$emailField(translators),
					A2(
						$author$project$Form$with,
						$author$project$Page$Register$Common$personNameField(translators),
						A2(
							$author$project$Form$with,
							$author$project$Form$introspect(
								function (_v0) {
									var documentType = _v0.er;
									var documentLength = function () {
										switch (documentType) {
											case 0:
												return 9;
											case 2:
												return 10;
											default:
												return 12;
										}
									}();
									return A2(
										$author$project$Form$textField,
										{
											ab: $elm$core$Basics$always($elm$core$Maybe$Nothing),
											af: $elm$core$Result$Ok,
											n: F2(
												function (document, input) {
													return _Utils_update(
														input,
														{eq: document});
												}),
											pO: function ($) {
												return $.eq;
											}
										},
										A2(
											$author$project$Form$Text$withPlaceholder,
											t(
												'register.form.document.' + ($author$project$Page$Register$NaturalForm$documentTypeToString(documentType) + '.placeholder')),
											A2(
												$author$project$Form$Text$withCounter,
												$author$project$Form$Text$CountLetters(documentLength),
												$author$project$Form$Text$init(
													{
														R: 'document-input',
														nC: t(
															'register.form.document.' + ($author$project$Page$Register$NaturalForm$documentTypeToString(documentType) + '.label'))
													}))));
								}),
							A2(
								$author$project$Form$with,
								A3(
									$author$project$Form$select,
									A2(
										$elm$core$Basics$composeR,
										$author$project$Page$Register$NaturalForm$documentTypeFromString,
										$elm$core$Maybe$withDefault(0)),
									{
										ab: $elm$core$Basics$always($elm$core$Maybe$Nothing),
										af: $elm$core$Result$Ok,
										n: F2(
											function (documentType, input) {
												return _Utils_update(
													input,
													{er: documentType});
											}),
										pO: function ($) {
											return $.er;
										}
									},
									A2(
										$author$project$Form$Select$withContainerAttrs,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('mb-10')
											]),
										A3(
											$author$project$Form$Select$withOption,
											1,
											t('register.form.document.dimex.label'),
											A3(
												$author$project$Form$Select$withOption,
												2,
												t('register.form.document.nite.label'),
												A3(
													$author$project$Form$Select$withOption,
													0,
													t('register.form.document.cedula_de_identidad.label'),
													$author$project$Form$Select$init(
														{
															R: 'document-type-select',
															nC: t('register.form.document.type'),
															dG: $author$project$Page$Register$NaturalForm$documentTypeToString
														})))))),
								$author$project$Form$succeed($author$project$Page$Register$NaturalForm$FormOutput)))))));
	});
var $author$project$Page$Register$viewForm = F3(
	function (guest, unavailableAccounts, currentForm) {
		var _v0 = guest.aM;
		var translators = _v0.iw;
		var helper = F4(
			function (formModel, form, toFormMsg, toFormOutput) {
				return A6(
					$author$project$Form$view,
					_List_Nil,
					translators,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Page$Register$viewFooter(guest),
						$elm$core$List$singleton),
					form,
					formModel,
					{
						oq: A2($elm$core$Basics$composeR, toFormOutput, $author$project$Page$Register$SubmittedForm),
						pA: A2($elm$core$Basics$composeR, toFormMsg, $author$project$Page$Register$GotFormMsg)
					});
			});
		switch (currentForm.$) {
			case 0:
				var form = currentForm.a;
				return A4(
					helper,
					form,
					A2($author$project$Page$Register$NaturalForm$form, translators, unavailableAccounts),
					$author$project$Page$Register$NaturalFormMsg,
					$author$project$Page$Register$NaturalFormOutput);
			case 1:
				var form = currentForm.a;
				return A4(
					helper,
					form,
					A2($author$project$Page$Register$JuridicalForm$form, translators, unavailableAccounts),
					$author$project$Page$Register$JuridicalFormMsg,
					$author$project$Page$Register$JuridicalFormOutput);
			default:
				var form = currentForm.a;
				return A4(
					helper,
					form,
					A2($author$project$Page$Register$DefaultForm$form, translators, unavailableAccounts),
					$author$project$Page$Register$DefaultFormMsg,
					$author$project$Page$Register$DefaultFormOutput);
		}
	});
var $author$project$Page$Register$viewTitleForStep = F2(
	function (_v0, s) {
		var t = _v0.il;
		var tr = _v0.iu;
		var stepNum = function () {
			if (!s) {
				return '1';
			} else {
				return '2';
			}
		}();
		var isSavingPassphrase = function () {
			if (!s) {
				return false;
			} else {
				return true;
			}
		}();
		return A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mx-4 py-4 font-bold md:mx-6'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('text-gray-333 border-t border-gray-500', !isSavingPassphrase),
							_Utils_Tuple2('text-white', isSavingPassphrase)
						]))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2(
						tr,
						'register.form.step',
						_List_fromArray(
							[
								_Utils_Tuple2('stepNum', stepNum)
							]))),
					$elm$html$Html$text(' / '),
					$elm$html$Html$text(
					t('register.form.step' + (stepNum + '_title')))
				]));
	});
var $author$project$Page$Register$viewCreateAccount = F2(
	function (guest, model) {
		var formClasses = 'flex flex-grow flex-col bg-white px-4 md:px-0 md:pt-20 md:max-w-sm self-center w-full';
		var backgroundColor = function () {
			var _v2 = model.e8;
			if (!_v2) {
				return 'bg-white';
			} else {
				return 'bg-purple-500';
			}
		}();
		var _v0 = guest.aM;
		var translators = _v0.iw;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id('registrationPage'),
					$elm$html$Html$Attributes$class('flex flex-grow flex-col ' + backgroundColor)
				]),
			_List_fromArray(
				[
					A2($author$project$Page$Register$viewTitleForStep, translators, model.e8),
					function () {
					var _v1 = model.gE;
					switch (_v1.$) {
						case 0:
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('h-full full-spinner-container')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('spinner spinner-light')
											]),
										_List_Nil)
									]));
						case 1:
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class(formClasses)
									]),
								_List_fromArray(
									[
										A2($author$project$Page$Register$viewAccountTypeSelector, translators, model),
										A2(
										$author$project$Page$Register$viewFooter,
										guest,
										function (attrs) {
											return $elm$html$Html$button(
												A2(
													$elm$core$List$cons,
													$elm$html$Html$Attributes$disabled(true),
													attrs));
										})
									]));
						case 2:
							var unavailableAccounts = _v1.a;
							var formModel = _v1.b;
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class(formClasses)
									]),
								_List_fromArray(
									[
										A2($author$project$Page$Register$viewAccountTypeSelector, translators, model),
										A3($author$project$Page$Register$viewForm, guest, unavailableAccounts, formModel)
									]));
						case 3:
							var accountKeys = _v1.a;
							return A3($author$project$Page$Register$viewAccountCreated, translators, model, accountKeys);
						case 4:
							return A2(
								$author$project$Page$fullPageNotFound,
								translators.il('error.unknown'),
								'');
						default:
							return A2(
								$author$project$Page$fullPageNotFound,
								translators.il('error.pageNotFound'),
								'');
					}
				}()
				]));
	});
var $author$project$Page$Register$view = F2(
	function (guest, model) {
		var shared = guest.aM;
		var _v0 = shared.iw;
		var t = _v0.il;
		var content = function () {
			var _v1 = guest.b9;
			switch (_v1.$) {
				case 3:
					var community = _v1.a;
					var hasInvite = function () {
						var _v2 = model.dk;
						if (!_v2.$) {
							return true;
						} else {
							return false;
						}
					}();
					return (community.cj || hasInvite) ? A2($author$project$Page$Register$viewCreateAccount, guest, model) : $author$project$Page$fullPageLoading(shared);
				case 0:
					return $author$project$Page$fullPageLoading(shared);
				case 1:
					return $author$project$Page$fullPageLoading(shared);
				default:
					var e = _v1.a;
					return A2(
						$author$project$Page$fullPageGraphQLError,
						t('register.registerTab'),
						e);
			}
		}();
		return {
			mk: content,
			fb: t('register.registerTab')
		};
	});
var $author$project$Page$Settings$ClickedChangePin = {$: 6};
var $author$project$Page$Settings$ClickedDeleteKyc = {$: 11};
var $author$project$Page$Settings$ClickedDownloadPdf = {$: 1};
var $author$project$Page$Settings$ClickedExportToSimpleos = {$: 2};
var $author$project$Markdown$fromTranslation = F2(
	function (_v0, key) {
		var t = _v0.il;
		return t(key);
	});
var $author$project$Page$Settings$viewCardItem = function (body) {
	return A2(
		$elm$html$Html$li,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex items-center justify-between py-4 first:pt-0 last:pb-0')
			]),
		body);
};
var $author$project$Page$Settings$viewAccountSettings = function (loggedIn) {
	var _v0 = loggedIn.aM.iw;
	var t = _v0.il;
	var tr = _v0.iu;
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$h2,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mb-4')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Markdown$view,
					_List_Nil,
					A2($author$project$Markdown$fromTranslation, loggedIn.aM.iw, 'settings.account.account_settings'))
				])),
			A2(
			$elm$html$Html$ul,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bg-white rounded-md p-4 divide-y')
				]),
			_List_fromArray(
				[
					$author$project$Page$Settings$viewCardItem(
					_List_fromArray(
						[
							$elm$html$Html$text(
							t('profile.12words.title')),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('button button-secondary flex-shrink-0 ml-4'),
									$elm$html$Html$Events$onClick($author$project$Page$Settings$ClickedDownloadPdf)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('profile.12words.button'))
								]))
						])),
					$author$project$Page$Settings$viewCardItem(
					_List_fromArray(
						[
							$elm$html$Html$text(
							t('settings.account.my_private_key')),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('button button-secondary flex-shrink-0 ml-4'),
									$elm$html$Html$Events$onClick($author$project$Page$Settings$ClickedExportToSimpleos)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('menu.export'))
								]))
						])),
					$author$project$Page$Settings$viewCardItem(
					_List_fromArray(
						[
							$elm$html$Html$text(
							t('profile.pin.title')),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('button button-secondary flex-shrink-0 ml-4'),
									$elm$html$Html$Events$onClick($author$project$Page$Settings$ClickedChangePin)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('profile.pin.button'))
								]))
						])),
					function () {
					var _v1 = loggedIn.kJ;
					switch (_v1.$) {
						case 3:
							var profile = _v1.a;
							return $author$project$Page$Settings$viewCardItem(
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('flex items-center')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														t('community.kyc.dataTitle')),
														$author$project$View$Components$tooltip(
														{
															mh: '',
															nc: 'text-orange-300',
															nS: t('community.kyc.info')
														})
													])),
												function () {
												var _v2 = profile.hx;
												if (!_v2.$) {
													return A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('uppercase text-red mt-2 text-sm')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(
																t('community.kyc.delete.warning'))
															]));
												} else {
													return $elm$html$Html$text('');
												}
											}()
											])),
										function () {
										var _v3 = profile.hx;
										if (!_v3.$) {
											return A2(
												$elm$html$Html$button,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('button button-danger flex-shrink-0 ml-4'),
														$elm$html$Html$Events$onClick($author$project$Page$Settings$ClickedDeleteKyc)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														t('community.kyc.delete.label'))
													]));
										} else {
											return A2(
												$elm$html$Html$a,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('button button-secondary ml-4'),
														$author$project$Route$href($author$project$Route$ProfileAddKyc)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														t('menu.add'))
													]));
										}
									}()
									]));
						case 1:
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('w-full max-w-xs h-6 rounded-md mt-4 mb-4 animate-skeleton-loading')
									]),
								_List_Nil);
						case 0:
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('w-full max-w-xs h-6 rounded-md mt-4 mb-4 animate-skeleton-loading')
									]),
								_List_Nil);
						default:
							return $elm$html$Html$text('');
					}
				}()
				]))
		]);
};
var $author$project$Page$Settings$AcceptedDeleteKyc = {$: 13};
var $author$project$Page$Settings$ClosedDeleteKycModal = {$: 12};
var $author$project$Page$Settings$viewDeleteKycModal = F2(
	function (_v0, model) {
		var t = _v0.il;
		return $author$project$View$Modal$toHtml(
			A2(
				$author$project$View$Modal$withFooter,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('modal-cancel'),
								$elm$html$Html$Events$onClick($author$project$Page$Settings$ClosedDeleteKycModal)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								t('community.kyc.delete.cancel'))
							])),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('modal-accept'),
								$elm$html$Html$Events$onClick($author$project$Page$Settings$AcceptedDeleteKyc)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								t('community.kyc.delete.confirm'))
							]))
					]),
				A2(
					$author$project$View$Modal$withBody,
					_List_fromArray(
						[
							$elm$html$Html$text(
							t('community.kyc.delete.confirmationBody'))
						]),
					A2(
						$author$project$View$Modal$withHeader,
						t('community.kyc.delete.confirmationHeader'),
						$author$project$View$Modal$initWith(
							{i$: $author$project$Page$Settings$ClosedDeleteKycModal, jW: model.dp})))));
	});
var $author$project$Page$Settings$ClickedCopyPrivateKey = {$: 3};
var $author$project$Page$Settings$ClosedExportToSimpleosModal = {$: 5};
var $author$project$Eos$Account$privateKeyToString = function (_v0) {
	var pk = _v0;
	return pk;
};
var $elm$html$Html$Attributes$rel = _VirtualDom_attribute('rel');
var $author$project$Page$Settings$viewExportToSimpleosModal = F2(
	function (loggedIn, model) {
		var _v0 = loggedIn.fp.gE;
		if (_v0.$ === 1) {
			var privateKey = _v0.a;
			var _v1 = loggedIn.aM.iw;
			var t = _v1.il;
			return $author$project$View$Modal$toHtml(
				A2(
					$author$project$View$Modal$withFooter,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('modal-cancel'),
									$elm$html$Html$Events$onClick($author$project$Page$Settings$ClosedExportToSimpleosModal)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('menu.close'))
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('modal-accept'),
									$elm$html$Html$Events$onClick($author$project$Page$Settings$ClickedCopyPrivateKey)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('menu.copy'))
								]))
						]),
					A2(
						$author$project$View$Modal$withBody,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										t('settings.account.export_private_key_details')),
										A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('hover:underline text-orange-300'),
												$elm$html$Html$Attributes$href('https://eosrio.io/simpleos/'),
												$elm$html$Html$Attributes$target('_blank'),
												$elm$html$Html$Attributes$rel('noopener')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Simpleos')
											]))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('flex w-full items-center justify-center p-4 bg-gray-200 rounded mt-4 select-all')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Eos$Account$privateKeyToString(privateKey))
									])),
								A2(
								$author$project$Form$Text$view,
								A2(
									$author$project$Form$Text$withInputElement,
									$author$project$Form$Text$TextareaInput(
										{pn: false}),
									A2(
										$author$project$Form$Text$withContainerAttrs,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('h-0 absolute opacity-0 left-[-9999em] !mb-0 overflow-hidden'),
												$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
											]),
										A2(
											$author$project$Form$Text$withExtraAttrs,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$tabindex(-1),
													$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
												]),
											$author$project$Form$Text$init(
												{R: 'private-key-copy-input', nC: ''})))),
								{
									mM: $elm$html$Html$text(''),
									m$: false,
									nx: false,
									od: $author$project$Page$Settings$NoOp,
									oe: function (_v2) {
										return $author$project$Page$Settings$NoOp;
									},
									iw: loggedIn.aM.iw,
									pO: $author$project$Eos$Account$privateKeyToString(privateKey)
								})
							]),
						A2(
							$author$project$View$Modal$withHeader,
							t('settings.account.export_private_key'),
							$author$project$View$Modal$initWith(
								{i$: $author$project$Page$Settings$ClosedExportToSimpleosModal, jW: model.ds})))));
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Page$Settings$ClosedNewPinModal = {$: 7};
var $author$project$Page$Settings$viewNewPinModal = F2(
	function (translators, model) {
		return $author$project$View$Modal$toHtml(
			A2(
				$author$project$View$Modal$withBody,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-sm')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								translators.il('profile.changePinPrompt'))
							])),
						A2(
						$elm$html$Html$map,
						$author$project$Page$Settings$GotPinMsg,
						A2($author$project$View$Pin$view, translators, model.cD))
					]),
				A2(
					$author$project$View$Modal$withHeader,
					translators.il('profile.changePin'),
					$author$project$View$Modal$initWith(
						{i$: $author$project$Page$Settings$ClosedNewPinModal, jW: model.du}))));
	});
var $author$project$Page$Settings$ToggledClaimNotification = function (a) {
	return {$: 15, a: a};
};
var $author$project$Page$Settings$ToggledDigestNotification = function (a) {
	return {$: 17, a: a};
};
var $author$project$Page$Settings$ToggledTransferNotification = function (a) {
	return {$: 16, a: a};
};
var $author$project$Page$Settings$viewNotificationToggle = F2(
	function (translators, _v0) {
		var label = _v0.nC;
		var id = _v0.R;
		var onToggle = _v0.or;
		var value = _v0.pO;
		return function (options) {
			return A2(
				$author$project$Form$Toggle$view,
				options,
				{
					mM: $elm$html$Html$text(''),
					m$: false,
					nx: false,
					od: $author$project$Page$Settings$NoOp,
					or: onToggle,
					iw: translators,
					pO: value
				});
		}(
			A2(
				$author$project$Form$Toggle$withToggleContainerAttrs,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('w-40 flex items-center flex-shrink-0')
					]),
				A2(
					$author$project$Form$Toggle$withContainerAttrs,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('w-full')
						]),
					$author$project$Form$Toggle$init(
						{
							R: id,
							nC: $elm$html$Html$text(label)
						}))));
	});
var $author$project$Page$Settings$viewNotificationPreferences = F2(
	function (loggedIn, model) {
		var _v0 = loggedIn.aM.iw;
		var t = _v0.il;
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$h2,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mb-4 mt-10')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Markdown$view,
						_List_Nil,
						A2($author$project$Markdown$fromTranslation, loggedIn.aM.iw, 'settings.account.notification_settings'))
					])),
				function () {
				var _v1 = loggedIn.kJ;
				switch (_v1.$) {
					case 3:
						var profile = _v1.a;
						var updatingOrProfile = F2(
							function (modelGetter, profileGetter) {
								var _v2 = modelGetter(model);
								if (_v2.$ === 1) {
									var newValue = _v2.a;
									return newValue;
								} else {
									return profileGetter(profile);
								}
							});
						return A2(
							$elm$html$Html$ul,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('bg-white rounded-md p-4 divide-y')
								]),
							_List_fromArray(
								[
									$author$project$Page$Settings$viewCardItem(
									_List_fromArray(
										[
											A2(
											$author$project$Page$Settings$viewNotificationToggle,
											loggedIn.aM.iw,
											{
												R: 'claim_notification',
												nC: t('profile.preferences.claim_notification'),
												or: $author$project$Page$Settings$ToggledClaimNotification,
												pO: A2(
													updatingOrProfile,
													function ($) {
														return $.b8;
													},
													function ($) {
														return $.c_;
													})
											})
										])),
									$author$project$Page$Settings$viewCardItem(
									_List_fromArray(
										[
											A2(
											$author$project$Page$Settings$viewNotificationToggle,
											loggedIn.aM.iw,
											{
												R: 'transfer_notification',
												nC: t('profile.preferences.transfer_notification'),
												or: $author$project$Page$Settings$ToggledTransferNotification,
												pO: A2(
													updatingOrProfile,
													function ($) {
														return $.cM;
													},
													function ($) {
														return $.d$;
													})
											})
										])),
									$author$project$Page$Settings$viewCardItem(
									_List_fromArray(
										[
											A2(
											$author$project$Page$Settings$viewNotificationToggle,
											loggedIn.aM.iw,
											{
												R: 'digest_notification',
												nC: t('profile.preferences.digest'),
												or: $author$project$Page$Settings$ToggledDigestNotification,
												pO: A2(
													updatingOrProfile,
													function ($) {
														return $.ce;
													},
													function ($) {
														return $.c9;
													})
											})
										]))
								]));
					case 1:
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('bg-white rounded-md p-4 divide-y')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('w-full max-w-xs h-4 mb-4 animate-skeleton-loading')
										]),
									_List_Nil),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('w-full max-w-sm h-4 my-4 animate-skeleton-loading')
										]),
									_List_Nil),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('w-full max-w-27 h-4 mt-4 animate-skeleton-loading')
										]),
									_List_Nil)
								]));
					case 0:
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('bg-white rounded-md p-4 divide-y')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('w-full max-w-xs h-4 mb-4 animate-skeleton-loading')
										]),
									_List_Nil),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('w-full max-w-sm h-4 my-4 animate-skeleton-loading')
										]),
									_List_Nil),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('w-full max-w-27 h-4 mt-4 animate-skeleton-loading')
										]),
									_List_Nil)
								]));
					default:
						var err = _v1.a;
						return $elm$html$Html$text('');
				}
			}()
			]);
	});
var $author$project$Page$Settings$view = F2(
	function (loggedIn, model) {
		var title = loggedIn.aM.iw.il('settings.account.title');
		return {
			mk: A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2($author$project$Page$viewHeader, loggedIn, title),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('container mx-auto px-4 mt-6 mb-20')
							]),
						$elm$core$List$concat(
							_List_fromArray(
								[
									$author$project$Page$Settings$viewAccountSettings(loggedIn),
									A2($author$project$Page$Settings$viewNotificationPreferences, loggedIn, model),
									_List_fromArray(
									[
										A2($author$project$Page$Settings$viewExportToSimpleosModal, loggedIn, model),
										A2($author$project$Page$Settings$viewNewPinModal, loggedIn.aM.iw, model),
										A2($author$project$Page$Settings$viewDeleteKycModal, loggedIn.aM.iw, model)
									])
								])))
					])),
			fb: title
		};
	});
var $author$project$Page$Shop$ClickedAcceptCodeOfConduct = {$: 8};
var $author$project$Shop$Where$isChosen = function (chosen) {
	return !_Utils_eq(chosen, $author$project$Shop$Where$Anywhere);
};
var $author$project$Page$Shop$viewEmptyState = F3(
	function (loggedIn, communitySymbol, model) {
		var _v0 = loggedIn.aM.iw;
		var t = _v0.il;
		var tr = _v0.iu;
		var title = function () {
			var _v2 = model.z.oy;
			if (!_v2.$) {
				var userName = _v2.a;
				return _Utils_eq(userName, loggedIn.lM) ? $elm$html$Html$text(
					t('shop.empty.user_title')) : $elm$html$Html$text(
					t('shop.empty.all_title'));
			} else {
				return $elm$html$Html$text(
					t('shop.empty.all_title'));
			}
		}();
		var description = function () {
			var _v1 = model.z.oy;
			if (!_v1.$) {
				var userName = _v1.a;
				return _Utils_eq(userName, loggedIn.lM) ? _List_fromArray(
					[
						$elm$html$Html$text(
						A2(
							tr,
							'shop.empty.you_can_offer',
							_List_fromArray(
								[
									_Utils_Tuple2(
									'symbol',
									$author$project$Eos$symbolToSymbolCodeString(communitySymbol))
								])))
					]) : _List_fromArray(
					[
						$elm$html$Html$text(
						A2(
							tr,
							'shop.empty.user_is_not_selling',
							_List_fromArray(
								[
									_Utils_Tuple2(
									'user',
									$author$project$Eos$Account$nameToString(userName))
								]))),
						A2($elm$html$Html$br, _List_Nil, _List_Nil),
						A2($elm$html$Html$br, _List_Nil, _List_Nil),
						$elm$html$Html$text(
						t('shop.empty.offer_something'))
					]);
			} else {
				return _List_fromArray(
					[
						$elm$html$Html$text(
						t('shop.empty.no_one_is_selling')),
						A2($elm$html$Html$br, _List_Nil, _List_Nil),
						A2($elm$html$Html$br, _List_Nil, _List_Nil),
						$elm$html$Html$text(
						t('shop.empty.offer_something'))
					]);
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-col items-center justify-center my-10')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$src('/images/seller_confused.svg'),
							$elm$html$Html$Attributes$alt('')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('font-bold text-black mt-4 text-center')
						]),
					_List_fromArray(
						[title])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-black text-center mt-4')
						]),
					description),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('button button-primary mt-6 md:px-6 w-full md:w-max'),
							$author$project$Route$href(
							$author$project$Route$NewSale(0))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							t('shop.empty.create_new'))
						]))
				]));
	});
var $author$project$Page$Shop$viewEmptyStateWithFilters = function (_v0) {
	var t = _v0.il;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex flex-col items-center mt-16 mb-10')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$img,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$alt(''),
						$elm$html$Html$Attributes$src('/images/not_found.svg'),
						$elm$html$Html$Attributes$class('w-1/2 md:w-40')
					]),
				_List_Nil),
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mt-6 text-gray-900')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						t('shop.empty.no_results_found'))
					])),
				A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('button button-secondary mt-2'),
						$author$project$Route$href(
						$author$project$Route$Shop(
							{cX: _List_Nil, oy: $elm$core$Maybe$Nothing}))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						t('shop.empty.clear_filters'))
					]))
			]));
};
var $author$project$Page$Shop$viewFilterTags = F2(
	function (community, model) {
		var getCategory = function (categoryId) {
			return A2(
				$elm$core$Maybe$andThen,
				$author$project$Utils$Tree$findInForest(
					function (category) {
						return _Utils_eq(category.R, categoryId);
					}),
				$krisajenkins$remotedata$RemoteData$toMaybe(community.e1));
		};
		var viewAppliedFilter = function (categoryId) {
			var _v0 = getCategory(categoryId);
			if (_v0.$ === 1) {
				return $elm$html$Html$text('');
			} else {
				var category = _v0.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('bg-white text-orange-300 rounded-sm flex items-center justify-center font-bold p-2 gap-4 flex-shrink-0 mr-4 sm:last:mr-0')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(category.ki),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('focus-ring focus:ring-offset-4 rounded-sm'),
									$author$project$Route$href(
									$author$project$Route$Shop(
										{
											cX: A2(
												$elm$core$List$filter,
												function (id) {
													return !_Utils_eq(id, categoryId);
												},
												model.z.cX),
											oy: model.z.oy
										}))
								]),
							_List_fromArray(
								[
									$author$project$Icons$close('fill-current w-3.5')
								]))
						]));
			}
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container mx-auto pl-4 mt-4 sm:pr-4')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex overflow-auto focus-ring rounded-sm')
						]),
					A2($elm$core$List$map, viewAppliedFilter, model.z.cX))
				]));
	});
var $author$project$Page$Shop$ClosedFiltersModal = {$: 13};
var $author$project$Page$Shop$SubmittedFiltersForm = function (a) {
	return {$: 15, a: a};
};
var $author$project$Page$Shop$FiltersFormOutput = F2(
	function (owner, categories) {
		return {cX: categories, oy: owner};
	});
var $author$project$Form$UnsafeArbitrary = function (a) {
	return {$: 11, a: a};
};
var $author$project$Form$DatePicker$map = F2(
	function (fn, _v0) {
		var options = _v0;
		return {
			d5: options.d5,
			mg: A2(
				$elm$core$List$map,
				$elm$html$Html$Attributes$map(fn),
				options.mg),
			cf: options.cf,
			R: options.R,
			nC: options.nC
		};
	});
var $author$project$Form$UserPicker$map = F2(
	function (fn, _v0) {
		var options = _v0;
		return {
			d9: options.d9,
			mg: A2(
				$elm$core$List$map,
				$elm$html$Html$Attributes$map(fn),
				options.mg),
			eo: options.eo,
			cf: options.cf,
			nC: options.nC,
			dB: options.dB,
			eW: {dP: $elm$core$Maybe$Nothing, gv: $elm$core$Maybe$Nothing},
			eX: options.eX
		};
	});
var $author$project$Form$mapBaseFieldValues = F3(
	function (fn, reverseFn, baseField) {
		return {
			aX: A2($elm$core$Basics$composeR, reverseFn, baseField.aX),
			n: A2($elm$core$Basics$composeR, baseField.n, fn),
			bb: F2(
				function (value, values) {
					return fn(
						A2(
							baseField.bb,
							value,
							reverseFn(values)));
				}),
			pO: baseField.pO
		};
	});
var $author$project$Form$DatePicker$mapViewConfig = F2(
	function (fn, viewConfig) {
		return {
			mM: A2($elm$html$Html$map, fn, viewConfig.mM),
			m$: viewConfig.m$,
			nx: viewConfig.nx,
			iw: viewConfig.iw,
			pO: viewConfig.pO
		};
	});
var $author$project$Form$UserPicker$mapViewConfig = F2(
	function (fn, viewConfig) {
		return {
			mM: A2($elm$html$Html$map, fn, viewConfig.mM),
			m$: viewConfig.m$,
			od: fn(viewConfig.od),
			iw: viewConfig.iw,
			pO: viewConfig.pO
		};
	});
var $author$project$Form$mapMsg = F3(
	function (fn, reverseFn, msg) {
		switch (msg.$) {
			case 0:
				return $author$project$Form$NoOp;
			case 1:
				var fieldId = msg.a;
				var values = msg.b;
				return A2(
					$author$project$Form$ChangedValues,
					fieldId,
					fn(values));
			case 2:
				var getModel = msg.a;
				var updateFn = msg.b;
				var subMsg = msg.c;
				return A3(
					$author$project$Form$GotRichTextMsg,
					A2($elm$core$Basics$composeR, reverseFn, getModel),
					F2(
						function (value, values) {
							return fn(
								A2(
									updateFn,
									value,
									reverseFn(values)));
						}),
					subMsg);
			case 3:
				var fieldId = msg.a;
				var getModel = msg.b;
				var updateFn = msg.c;
				var subMsg = msg.d;
				return A4(
					$author$project$Form$GotFileMsg,
					fieldId,
					A2($elm$core$Basics$composeR, reverseFn, getModel),
					F2(
						function (value, values) {
							return fn(
								A2(
									updateFn,
									value,
									reverseFn(values)));
						}),
					subMsg);
			case 4:
				var options = msg.a;
				var viewConfig = msg.b;
				var getModel = msg.c;
				var updateFn = msg.d;
				var subMsg = msg.e;
				return A5(
					$author$project$Form$GotDatePickerMsg,
					A2(
						$author$project$Form$DatePicker$map,
						A2($author$project$Form$mapMsg, fn, reverseFn),
						options),
					A2(
						$author$project$Form$DatePicker$mapViewConfig,
						A2($author$project$Form$mapMsg, fn, reverseFn),
						viewConfig),
					A2($elm$core$Basics$composeR, reverseFn, getModel),
					F2(
						function (value, values) {
							return fn(
								A2(
									updateFn,
									value,
									reverseFn(values)));
						}),
					subMsg);
			case 5:
				var options = msg.a;
				var viewConfig = msg.b;
				var getModel = msg.c;
				var updateFn = msg.d;
				var subMsg = msg.e;
				return A5(
					$author$project$Form$GotUserPickerMsg,
					A2(
						$author$project$Form$UserPicker$map,
						A2($author$project$Form$mapMsg, fn, reverseFn),
						options),
					A2(
						$author$project$Form$UserPicker$mapViewConfig,
						A2($author$project$Form$mapMsg, fn, reverseFn),
						viewConfig),
					A2($elm$core$Basics$composeR, reverseFn, getModel),
					F2(
						function (value, values) {
							return fn(
								A2(
									updateFn,
									value,
									reverseFn(values)));
						}),
					subMsg);
			case 6:
				var fieldInfo = msg.a;
				return $author$project$Form$BlurredField(fieldInfo);
			default:
				var errors = msg.a;
				return $author$project$Form$ClickedSubmitWithErrors(errors);
		}
	});
var $author$project$Form$mapField = F3(
	function (fn, reverseFn, field_) {
		var mapWithMsg = F4(
			function (fieldType, specificMap, options, baseField) {
				return A2(
					fieldType,
					A2(
						specificMap,
						A2($author$project$Form$mapMsg, fn, reverseFn),
						options),
					A3($author$project$Form$mapBaseFieldValues, fn, reverseFn, baseField));
			});
		var baseMap = F3(
			function (fieldType, options, baseField) {
				return A2(
					fieldType,
					options,
					A3($author$project$Form$mapBaseFieldValues, fn, reverseFn, baseField));
			});
		switch (field_.$) {
			case 0:
				var options = field_.a;
				var baseField = field_.b;
				return A3(baseMap, $author$project$Form$Text, options, baseField);
			case 1:
				var options = field_.a;
				var baseField = field_.b;
				return A3(baseMap, $author$project$Form$RichText, options, baseField);
			case 2:
				var options = field_.a;
				var baseField = field_.b;
				return A3(baseMap, $author$project$Form$Toggle, options, baseField);
			case 3:
				var options = field_.a;
				var baseField = field_.b;
				return A3(baseMap, $author$project$Form$Checkbox, options, baseField);
			case 4:
				var options = field_.a;
				var baseField = field_.b;
				return A3(baseMap, $author$project$Form$Radio, options, baseField);
			case 5:
				var options = field_.a;
				var baseField = field_.b;
				return A3(baseMap, $author$project$Form$File, options, baseField);
			case 6:
				var options = field_.a;
				var baseField = field_.b;
				return A3(baseMap, $author$project$Form$Select, options, baseField);
			case 7:
				var options = field_.a;
				var baseField = field_.b;
				return A4(mapWithMsg, $author$project$Form$DatePicker, $author$project$Form$DatePicker$map, options, baseField);
			case 8:
				var options = field_.a;
				var baseField = field_.b;
				return A4(mapWithMsg, $author$project$Form$UserPicker, $author$project$Form$UserPicker$map, options, baseField);
			case 9:
				var attributes = field_.a;
				var fields = field_.b;
				return A2(
					$author$project$Form$Group,
					attributes,
					A2(
						$elm$core$List$map,
						A2($author$project$Form$mapFilledField, fn, reverseFn),
						fields));
			case 10:
				var html = field_.a;
				return $author$project$Form$Arbitrary(
					A2(
						$elm$html$Html$map,
						function (htmlFn) {
							return A2(
								$elm$core$Basics$composeR,
								reverseFn,
								A2($elm$core$Basics$composeR, htmlFn, fn));
						},
						html));
			default:
				var html = field_.a;
				return $author$project$Form$UnsafeArbitrary(html);
		}
	});
var $author$project$Form$mapFilledField = F3(
	function (fn, reverseFn, filledField) {
		return {
			mM: filledField.mM,
			nx: filledField.nx,
			X: A3($author$project$Form$mapField, fn, reverseFn, filledField.X),
			aP: filledField.aP
		};
	});
var $author$project$Form$mapValues = F2(
	function (mappings, child) {
		return function (values) {
			var filledChild = A2(
				$author$project$Form$fill,
				child,
				mappings.pO(values));
			return {
				l: A2(
					$elm$core$List$map,
					A2(
						$author$project$Form$mapFilledField,
						function (child_) {
							return A2(mappings.n, child_, values);
						},
						mappings.pO),
					filledChild.l),
				m: filledChild.m
			};
		};
	});
var $author$project$Page$Shop$categoriesForm = F2(
	function (_v0, allCategories) {
		var t = _v0.il;
		var checkbox = function (category) {
			return A2(
				$author$project$Form$checkbox,
				{
					ab: $elm$core$Basics$always($elm$core$Maybe$Nothing),
					af: function (value) {
						return value ? $elm$core$Result$Ok(
							$elm$core$Maybe$Just(category.R)) : $elm$core$Result$Ok($elm$core$Maybe$Nothing);
					},
					n: $pzp1997$assoc_list$AssocList$insert(category),
					pO: function (input) {
						return A2(
							$elm$core$Maybe$withDefault,
							false,
							A2($pzp1997$assoc_list$AssocList$get, category, input));
					}
				},
				A2(
					$author$project$Form$Checkbox$withContainerAttrs,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex')
						]),
					$author$project$Form$Checkbox$init(
						{
							R: 'category-' + $author$project$Shop$Category$idToString(category.R),
							nC: A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('flex items-center gap-x-2')
									]),
								_List_fromArray(
									[
										function () {
										var _v2 = category.nb;
										if (_v2.$ === 1) {
											return $elm$html$Html$text('');
										} else {
											var icon = _v2.a;
											return A2(
												$elm$html$Html$img,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('w-5 h-5 rounded-full'),
														$elm$html$Html$Attributes$alt(''),
														$elm$html$Html$Attributes$src(icon)
													]),
												_List_Nil);
										}
									}(),
										$elm$html$Html$text(category.ki)
									]))
						})));
		};
		var treeToForm = function (tree) {
			return A4(
				$author$project$Form$withGroup,
				_List_Nil,
				checkbox(
					$zwilias$elm_rosetree$Tree$label(tree)),
				$elm$core$List$isEmpty(
					$zwilias$elm_rosetree$Tree$children(tree)) ? $author$project$Form$succeed(_List_Nil) : A2(
					$author$project$Form$mapOutput,
					$elm$core$List$concat,
					A2(
						$author$project$Form$list,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('ml-4 mt-4 flex flex-col gap-y-4')
							]),
						A2(
							$elm$core$List$map,
							treeToForm,
							$zwilias$elm_rosetree$Tree$children(tree)))),
				$author$project$Form$succeed(
					F2(
						function (label, children) {
							if (label.$ === 1) {
								return children;
							} else {
								var head = label.a;
								return A2($elm$core$List$cons, head, children);
							}
						})));
		};
		return A2(
			$author$project$Form$with,
			A2(
				$author$project$Form$mapValues,
				{
					n: F2(
						function (newChild, parent) {
							return _Utils_update(
								parent,
								{cX: newChild});
						}),
					pO: function ($) {
						return $.cX;
					}
				},
				A2(
					$author$project$Form$mapOutput,
					$elm$core$List$concat,
					A2(
						$author$project$Form$list,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex flex-col gap-y-4')
							]),
						A2($elm$core$List$map, treeToForm, allCategories)))),
			$author$project$Form$succeed($elm$core$Basics$identity));
	});
var $author$project$Page$Shop$ownerForm = F2(
	function (_v0, currentUser) {
		var t = _v0.il;
		return A3(
			$author$project$Form$radio,
			function (account) {
				return $elm$core$String$isEmpty(account) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					$author$project$Eos$Account$stringToName(account));
			},
			{
				ab: $elm$core$Basics$always($elm$core$Maybe$Nothing),
				af: $elm$core$Result$Ok,
				n: F2(
					function (owner, values) {
						return _Utils_update(
							values,
							{oy: owner});
					}),
				pO: function ($) {
					return $.oy;
				}
			},
			A2(
				$author$project$Form$Radio$withContainerAttrs,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mb-6')
					]),
				A2(
					$author$project$Form$Radio$withDirection,
					1,
					A3(
						$author$project$Form$Radio$withOption,
						$elm$core$Maybe$Just(currentUser),
						$elm$html$Html$text(
							t('shop.filters.offers.mine')),
						A3(
							$author$project$Form$Radio$withOption,
							$elm$core$Maybe$Nothing,
							$elm$html$Html$text(
								t('shop.filters.offers.all')),
							$author$project$Form$Radio$init(
								{
									R: 'offers-radio',
									nC: t('shop.filters.offers.label'),
									dG: function (maybeAccount) {
										if (maybeAccount.$ === 1) {
											return '';
										} else {
											var account = maybeAccount.a;
											return $author$project$Eos$Account$nameToString(account);
										}
									}
								}))))));
	});
var $author$project$Page$Shop$filtersForm = F2(
	function (loggedIn, allCategories) {
		var loadingItem = function (width) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex items-center gap-x-2')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('animate-skeleton-loading h-5 rounded w-5')
							]),
						_List_Nil),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('animate-skeleton-loading h-5 rounded-full w-5')
							]),
						_List_Nil),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('animate-skeleton-loading h-5 rounded-sm'),
								$elm$html$Html$Attributes$class(width)
							]),
						_List_Nil)
					]));
		};
		var loadingForm = A2(
			$author$project$Form$arbitraryWith,
			_List_Nil,
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex flex-col gap-y-4')
					]),
				_List_fromArray(
					[
						loadingItem('w-1/2'),
						loadingItem('w-2/3'),
						loadingItem('w-1/3'),
						loadingItem('w-1/2')
					])));
		return A2(
			$author$project$Form$with,
			function () {
				switch (allCategories.$) {
					case 3:
						var categories = allCategories.a;
						return $elm$core$List$isEmpty(categories) ? $author$project$Form$succeed(_List_Nil) : A2($author$project$Page$Shop$categoriesForm, loggedIn.aM.iw, categories);
					case 1:
						return loadingForm;
					case 0:
						return loadingForm;
					default:
						return A2(
							$author$project$Form$arbitraryWith,
							_List_Nil,
							A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('form-error')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										loggedIn.aM.iw.il('shop.filters.categories.error_fetching'))
									])));
				}
			}(),
			A2(
				$author$project$Form$withNoOutput,
				function () {
					if (allCategories.$ === 3) {
						var categories = allCategories.a;
						return $elm$core$List$isEmpty(categories) ? $author$project$Form$succeed(_List_Nil) : $author$project$Form$arbitrary(
							A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('label')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										loggedIn.aM.iw.il('settings.shop.categories.title'))
									])));
					} else {
						return $author$project$Form$arbitrary(
							A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('label')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										loggedIn.aM.iw.il('settings.shop.categories.title'))
									])));
					}
				}(),
				A2(
					$author$project$Form$with,
					A2($author$project$Page$Shop$ownerForm, loggedIn.aM.iw, loggedIn.lM),
					$author$project$Form$succeed($author$project$Page$Shop$FiltersFormOutput))));
	});
var $author$project$Form$viewWithoutSubmit = F6(
	function (formAttrs, translators, footer, form, _v0, _v1) {
		var model = _v0;
		var toMsg = _v1.pA;
		return A2(
			$elm$html$Html$form,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$novalidate(true),
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Events$onSubmit(
						toMsg($author$project$Form$NoOp)),
					formAttrs)),
			_Utils_ap(
				A5(
					$author$project$Form$viewFields,
					translators,
					form,
					model,
					toMsg,
					function (_v2) {
						return toMsg($author$project$Form$NoOp);
					}),
				footer(model.s)));
	});
var $author$project$Page$Shop$viewFiltersModal = F2(
	function (loggedIn, model) {
		var categories = A2(
			$krisajenkins$remotedata$RemoteData$map,
			$elm$core$Tuple$second,
			A2(
				$author$project$Community$getField,
				loggedIn.o7,
				function ($) {
					return $.e1;
				}));
		return $author$project$View$Modal$toHtml(
			A2(
				$author$project$View$Modal$withSize,
				0,
				A2(
					$author$project$View$Modal$withFooter,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('button button-primary w-full'),
									$elm$html$Html$Events$onClick(
									A3(
										$author$project$Form$parse,
										A2($author$project$Page$Shop$filtersForm, loggedIn, categories),
										model.bC,
										{gi: $author$project$Page$Shop$GotFiltersFormMsg, dE: $author$project$Page$Shop$SubmittedFiltersForm}))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									loggedIn.aM.iw.il('shop.filters.apply'))
								]))
						]),
					A2(
						$author$project$View$Modal$withBody,
						_List_fromArray(
							[
								A6(
								$author$project$Form$viewWithoutSubmit,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('mt-4')
									]),
								loggedIn.aM.iw,
								function (_v0) {
									return _List_Nil;
								},
								A2($author$project$Page$Shop$filtersForm, loggedIn, categories),
								model.bC,
								{pA: $author$project$Page$Shop$GotFiltersFormMsg})
							]),
						A2(
							$author$project$View$Modal$withHeader,
							loggedIn.aM.iw.il('shop.filters.title'),
							$author$project$View$Modal$initWith(
								{i$: $author$project$Page$Shop$ClosedFiltersModal, jW: model.dt}))))));
	});
var $author$project$Page$Shop$viewFoundOffersAmount = F3(
	function (translators, community, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bg-white w-full py-4 mt-4')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('container mx-auto flex w-full justify-between px-4')
						]),
					_List_fromArray(
						[
							function () {
							var _v0 = model.ap;
							if (_v0.$ === 1) {
								var cards = _v0.a;
								return ($elm$core$List$length(cards) === 1) ? A2(
									$author$project$Markdown$view,
									_List_Nil,
									A2($author$project$Markdown$fromTranslation, translators, 'shop.filters.found_single_offer')) : A2(
									$author$project$Markdown$view,
									_List_Nil,
									A3(
										$author$project$Markdown$fromTranslationWithReplacements,
										translators,
										'shop.filters.found_offers',
										_List_fromArray(
											[
												_Utils_Tuple2(
												'count',
												$elm$core$String$fromInt(
													$elm$core$List$length(cards)))
											])));
							} else {
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('w-44 rounded-md animate-skeleton-loading')
										]),
									_List_Nil);
							}
						}(),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-orange-300 hover:underline flex-shrink-0 focus-ring rounded-sm focus:ring-offset-2'),
									$author$project$Route$href(
									$author$project$Route$Shop(
										{cX: _List_Nil, oy: model.z.oy}))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									translators.il('shop.empty.clear_filters'))
								]))
						]))
				]));
	});
var $author$project$Page$Shop$ClickedScrollToImage = function (a) {
	return {$: 9, a: a};
};
var $author$project$Page$Shop$ImageStartedIntersecting = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Page$Shop$ImageStoppedIntersecting = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Shop$ImageId = $elm$core$Basics$identity;
var $author$project$Shop$viewImageCarrousel = F4(
	function (_v0, _v1, options, _v2) {
		var t = _v0.il;
		var tr = _v0.iu;
		var containerAttrs = _v1.mg;
		var listAttrs = _v1.nK;
		var imageContainerAttrs = _v1.ne;
		var imageOverlayAttrs = _v1.ng;
		var imageAttrs = _v1.nd;
		var firstImage = _v2.a;
		var otherImages = _v2.b;
		var maybeProductId = A2(
			$elm$core$Maybe$map,
			function (_v12) {
				var opaqueId = _v12;
				return opaqueId;
			},
			options.oR);
		var indexFromImageId = function (_v11) {
			var imgId = _v11;
			if (maybeProductId.$ === 1) {
				return $elm$core$String$toInt(
					A2($elm$core$String$dropLeft, 14, imgId));
			} else {
				var productId = maybeProductId.a;
				return $elm$core$String$toInt(
					A2(
						$elm$core$String$dropLeft,
						$elm$core$String$length(
							'product-image-' + ($elm$core$String$fromInt(productId) + '-')),
						imgId));
			}
		};
		var maybeCurrentIntersectingIndex = A2($elm$core$Maybe$andThen, indexFromImageId, options.mu);
		var imageUrls = A2($elm$core$List$cons, firstImage, otherImages);
		var imageId = function (index) {
			if (maybeProductId.$ === 1) {
				return 'product-image-' + $elm$core$String$fromInt(index);
			} else {
				var productId = maybeProductId.a;
				return 'product-image-' + ($elm$core$String$fromInt(productId) + ('-' + $elm$core$String$fromInt(index)));
			}
		};
		var isCurrentIntersecting = function (imageIndex) {
			var _v8 = options.mu;
			if (_v8.$ === 1) {
				return false;
			} else {
				var currentIntersecting = _v8.a;
				return _Utils_eq(
					currentIntersecting,
					imageId(imageIndex));
			}
		};
		var containerId = function () {
			if (maybeProductId.$ === 1) {
				return 'image-carrousel';
			} else {
				var productId = maybeProductId.a;
				return 'image-carrousel-' + $elm$core$String$fromInt(productId);
			}
		}();
		var clickedScrollToImage = function (imageIndex) {
			return options.om(
				{
					mj: containerId,
					nf: imageId(imageIndex)
				});
		};
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('relative'),
				containerAttrs),
			_List_fromArray(
				[
					function () {
					if (maybeCurrentIntersectingIndex.$ === 1) {
						return $elm$html$Html$text('');
					} else {
						var currentIntersectingIndex = maybeCurrentIntersectingIndex.a;
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('absolute left-4 bottom-1/2 translate-y-1/2')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('bg-white/80 rounded-full transition-all origin-left'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('hidden', !options.pa),
													_Utils_Tuple2('opacity-0 scale-50 pointer-events-none', !currentIntersectingIndex)
												])),
											$elm$html$Html$Events$onClick(
											clickedScrollToImage(currentIntersectingIndex - 1)),
											$fapian$elm_html_aria$Html$Attributes$Aria$ariaLabel(
											t('shop.carrousel.previous')),
											$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(!currentIntersectingIndex)
										]),
									_List_fromArray(
										[
											$author$project$Icons$arrowDown('rotate-90')
										]))
								]));
					}
				}(),
					A2(
					$elm$html$Html$ul,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$class('flex h-full min-w-full overflow-x-scroll overflow-y-hidden snap-x scrollbar-hidden'),
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$id(containerId),
							listAttrs)),
					A2(
						$elm$core$List$indexedMap,
						F2(
							function (index, image) {
								return A2(
									$elm$html$Html$div,
									A2(
										$elm$core$List$cons,
										$elm$html$Html$Attributes$class('w-full h-full flex-shrink-0 snap-center snap-always grid place-items-center'),
										A2(
											$elm$core$List$cons,
											$elm$html$Html$Attributes$id(
												imageId(index)),
											imageContainerAttrs)),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$img,
											A2(
												$elm$core$List$cons,
												$elm$html$Html$Attributes$src(image),
												A2(
													$elm$core$List$cons,
													$elm$html$Html$Attributes$alt(''),
													A2(
														$elm$core$List$cons,
														$elm$html$Html$Attributes$class('object-cover object-center max-w-full max-h-full'),
														imageAttrs))),
											_List_Nil)
										]));
							}),
						imageUrls)),
					function () {
					if (maybeCurrentIntersectingIndex.$ === 1) {
						return $elm$html$Html$text('');
					} else {
						var currentIntersectingIndex = maybeCurrentIntersectingIndex.a;
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('absolute right-4 bottom-1/2 translate-y-1/2')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('bg-white/80 rounded-full transition-all origin-right'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('hidden', !options.pa),
													_Utils_Tuple2(
													'opacity-0 scale-50 pointer-events-none',
													_Utils_eq(
														currentIntersectingIndex,
														$elm$core$List$length(imageUrls) - 1))
												])),
											$elm$html$Html$Events$onClick(
											clickedScrollToImage(currentIntersectingIndex + 1)),
											$fapian$elm_html_aria$Html$Attributes$Aria$ariaLabel(
											t('shop.carrousel.next')),
											$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(
											_Utils_eq(
												currentIntersectingIndex,
												$elm$core$List$length(imageUrls) - 1))
										]),
									_List_fromArray(
										[
											$author$project$Icons$arrowDown('-rotate-90')
										]))
								]));
					}
				}(),
					($elm$core$List$length(imageUrls) === 1) ? $elm$html$Html$text('') : A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('absolute bottom-4 left-1/2 -translate-x-1/2 flex items-center gap-2 z-10')
						]),
					A2(
						$elm$core$List$indexedMap,
						F2(
							function (index, _v5) {
								return A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('border-2 w-2 h-2 rounded-full transition-colors'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'bg-white border-orange-500',
													isCurrentIntersecting(index)),
													_Utils_Tuple2(
													'bg-white border-white',
													!isCurrentIntersecting(index))
												])),
											$author$project$Utils$onClickPreventAll(
											clickedScrollToImage(index)),
											$fapian$elm_html_aria$Html$Attributes$Aria$ariaLabel(
											A2(
												tr,
												'shop.carrousel.index',
												_List_fromArray(
													[
														_Utils_Tuple2(
														'index',
														$elm$core$String$fromInt(index + 1))
													])))
										]),
									_List_Nil);
							}),
						imageUrls)),
					($elm$core$List$length(imageUrls) === 1) ? $elm$html$Html$text('') : A2(
					$elm$html$Html$div,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$class('bg-gradient-to-t from-black/40 to-transparent absolute bottom-0 left-0 right-0 h-10'),
						imageOverlayAttrs),
					_List_Nil),
					$author$project$View$Components$intersectionObserver(
					{
						lZ: $elm$core$Maybe$Nothing,
						oo: $elm$core$Maybe$Just(
							A2($elm$core$Basics$composeR, $elm$core$Basics$identity, options.oo)),
						op: $elm$core$Maybe$Just(
							A2($elm$core$Basics$composeR, $elm$core$Basics$identity, options.op)),
						pw: A2(
							$elm$core$List$indexedMap,
							F2(
								function (index, _v6) {
									return '#' + imageId(index);
								}),
							imageUrls),
						py: 0.01
					})
				]));
	});
var $author$project$Page$Shop$viewCard = F3(
	function (loggedIn, index, card) {
		var isFree = !card.oP.h3;
		var translators = loggedIn.aM.iw;
		var t = translators.il;
		var tr = translators.iu;
		var images = function () {
			var _v0 = card.oP.hr;
			if (!_v0.b) {
				return A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('h-32 rounded-t object-cover'),
							$elm$html$Html$Attributes$alt(''),
							$elm$html$Html$Attributes$src(
							'/icons/shop-placeholder' + ($elm$core$String$fromInt(
								A2($elm$core$Basics$modBy, 3, index)) + '.svg'))
						]),
					_List_Nil);
			} else {
				var firstImage = _v0.a;
				var otherImages = _v0.b;
				return A4(
					$author$project$Shop$viewImageCarrousel,
					translators,
					{
						mg: _List_fromArray(
							[
								$elm$html$Html$Attributes$class('h-32')
							]),
						nd: _List_fromArray(
							[
								$elm$html$Html$Attributes$class('w-full h-full')
							]),
						ne: _List_fromArray(
							[
								$elm$html$Html$Attributes$class('bg-white rounded-t')
							]),
						ng: _List_Nil,
						nK: _List_fromArray(
							[
								$elm$html$Html$Attributes$class('gap-x-4 rounded-t bg-gray-100')
							])
					},
					{
						mu: card.cc,
						om: $author$project$Page$Shop$ClickedScrollToImage,
						oo: $author$project$Page$Shop$ImageStartedIntersecting(card.oP.R),
						op: $author$project$Page$Shop$ImageStoppedIntersecting(card.oP.R),
						oR: $elm$core$Maybe$Just(card.oP.R),
						pa: false
					},
					_Utils_Tuple2(firstImage, otherImages));
			}
		}();
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('rounded bg-white')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('h-full flex flex-col hover:shadow-md transition-shadow duration-300'),
							$elm$html$Html$Attributes$title(card.oP.fb),
							$author$project$Route$href(
							$author$project$Route$ViewSale(card.oP.R))
						]),
					_List_fromArray(
						[
							images,
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('p-4 flex flex-col flex-grow')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h2,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('line-clamp-3 text-black')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(card.oP.fb)
										])),
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('font-bold text-gray-900 text-sm uppercase mb-auto line-clamp-2 mt-1')
										]),
									_List_fromArray(
										[
											_Utils_eq(loggedIn.lM, card.oP.mr) ? $elm$html$Html$text(
											t('shop.by_you')) : $elm$html$Html$text(
											A2(
												tr,
												'shop.by_user',
												_List_fromArray(
													[
														_Utils_Tuple2(
														'user',
														A2(
															$elm$core$Maybe$withDefault,
															$author$project$Eos$Account$nameToString(card.oP.mq.fl),
															card.oP.mq.ki))
													])))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('font-bold flex flex-col mt-4')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('text-lg'),
													$elm$html$Html$Attributes$classList(
													_List_fromArray(
														[
															_Utils_Tuple2('text-green', card.bf),
															_Utils_Tuple2('text-gray-900', !card.bf),
															_Utils_Tuple2('lowercase', isFree)
														]))
												]),
											_List_fromArray(
												[
													isFree ? $elm$html$Html$text(
													t('shop.free')) : $elm$html$Html$text(
													A3($author$project$Eos$formatSymbolAmount, translators, card.oP.e9, card.oP.h3))
												])),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$classList(
													_List_fromArray(
														[
															_Utils_Tuple2('text-sm text-gray-333 uppercase', card.bf),
															_Utils_Tuple2('text-red font-normal lowercase', !card.bf)
														]))
												]),
											_List_fromArray(
												[
													(!card.bf) ? $elm$html$Html$text(
													t('shop.sold_out')) : (isFree ? $elm$html$Html$text(
													t('shop.enjoy')) : $elm$html$Html$text(
													$author$project$Eos$symbolToSymbolCodeString(card.oP.e9)))
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Page$Shop$viewGrid = F2(
	function (loggedIn, cards) {
		var outOfStockCards = A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.bf;
				},
				$elm$core$Basics$not),
			cards);
		var availableCards = A2(
			$elm$core$List$filter,
			function ($) {
				return $.bf;
			},
			cards);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mt-6 mb-10')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('grid gap-4 xs-max:grid-cols-1 grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5')
						]),
					A2(
						$elm$core$List$indexedMap,
						$author$project$Page$Shop$viewCard(loggedIn),
						_Utils_ap(availableCards, outOfStockCards)))
				]));
	});
var $author$project$Page$Shop$viewHeader = function (_v0) {
	var t = _v0.il;
	return A2(
		$elm$html$Html$h1,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('font-bold text-lg'),
				$fapian$elm_html_aria$Html$Attributes$Aria$ariaLabel(
				t('shop.headline_no_emoji'))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				t('shop.headline'))
			]));
};
var $author$project$Page$Shop$ClickedOfferType = function (a) {
	return {$: 6, a: a};
};
var $author$project$Page$Shop$viewChip = function (_v0) {
	var isSelected = _v0.hw;
	var label = _v0.nC;
	var count = _v0.mo;
	var msg = _v0.hN;
	return A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex items-center gap-x-2 px-4 py-2 rounded-full whitespace-nowrap flex-shrink-0 focus-ring transition-colors'),
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('bg-orange-100/30 text-orange-500 font-bold', isSelected),
						_Utils_Tuple2('bg-gray-200 text-gray-333 hover:bg-gray-300', !isSelected)
					])),
				$elm$html$Html$Attributes$type_('button'),
				A2(
				$elm$html$Html$Attributes$attribute,
				'aria-pressed',
				isSelected ? 'true' : 'false'),
				$elm$html$Html$Events$onClick(msg)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(label),
				function () {
				if (!count.$) {
					var amount = count.a;
					return A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-sm text-gray-700 font-normal')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm$core$String$fromInt(amount))
							]));
				} else {
					return $elm$html$Html$text('');
				}
			}()
			]));
};
var $author$project$Page$Shop$viewOfferType = F2(
	function (_v0, model) {
		var t = _v0.il;
		var chip = F2(
			function (chosen, label) {
				return $author$project$Page$Shop$viewChip(
					{
						mo: $elm$core$Maybe$Nothing,
						hw: _Utils_eq(model.b6, chosen),
						nC: label,
						hN: $author$project$Page$Shop$ClickedOfferType(chosen)
					});
			});
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id('shop-offer-type'),
					$elm$html$Html$Attributes$class('mt-4')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex gap-2 overflow-x-auto pb-2 -mx-4 px-4 md:mx-0 md:px-0 md:flex-wrap')
						]),
					_List_fromArray(
						[
							A2(
							chip,
							$elm$core$Maybe$Nothing,
							t('shop.type.all')),
							A2(
							chip,
							$elm$core$Maybe$Just(2),
							t('shop.type.products')),
							A2(
							chip,
							$elm$core$Maybe$Just(1),
							t('shop.type.services'))
						]))
				]));
	});
var $author$project$Page$Shop$ClickedOpenFiltersModal = {$: 12};
var $author$project$Page$Shop$viewShopButtons = F2(
	function (loggedIn, model) {
		var numberOfFiltersApplied = $elm$core$List$length(model.z.cX);
		var canSell = function () {
			var _v1 = loggedIn.kJ;
			if (_v1.$ === 3) {
				var profile = _v1.a;
				return A2(
					$author$project$Session$LoggedIn$hasPermissions,
					profile,
					_List_fromArray(
						[5]));
			} else {
				return false;
			}
		}();
		var _v0 = loggedIn.aM.iw;
		var t = _v0.il;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('grid xs-max:grid-cols-1 grid-cols-2 md:flex mt-4 gap-4')
				]),
			_List_fromArray(
				[
					A3(
					$author$project$View$Components$disablableLink,
					{ns: (!loggedIn.mZ) || (!canSell)},
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('w-full md:w-40 button button-primary'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('button-disabled', !loggedIn.mZ)
								])),
							$author$project$Route$href(
							$author$project$Route$NewSale(0))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							t('shop.create_new_offer'))
						])),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('w-full md:w-40 button button-secondary'),
							$elm$html$Html$Events$onClick($author$project$Page$Shop$ClickedOpenFiltersModal)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							t('shop.filters.title')),
							(numberOfFiltersApplied > 0) ? A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('ml-2 bg-orange-300 rounded-full px-2 h-6 min-w-6 text-white flex items-center justify-center text-center')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(numberOfFiltersApplied))
								])) : $elm$html$Html$text('')
						]))
				]));
	});
var $author$project$Page$Shop$ClickedWhere = function (a) {
	return {$: 5, a: a};
};
var $author$project$Shop$Where$InPlace = function (a) {
	return {$: 1, a: a};
};
var $author$project$Shop$Where$Online = {$: 2};
var $author$project$Shop$Where$chips = F2(
	function (limit, _v0) {
		var home = _v0.m9;
		var places = _v0.oH;
		var online = _v0.dF;
		var offered = A2(
			$elm$core$List$filter,
			function (chip) {
				return chip.mo > 0;
			},
			places);
		var homeId = A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.R;
			},
			home);
		return {
			m9: A2(
				$elm$core$Maybe$andThen,
				function (place) {
					return $elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (chip) {
								return _Utils_eq(chip.e.R, place.R);
							},
							offered));
				},
				home),
			dF: online,
			oH: A2(
				$elm$core$List$take,
				limit,
				A2(
					$elm$core$List$sortBy,
					function (chip) {
						return _Utils_Tuple2(-chip.mo, chip.e.ki);
					},
					A2(
						$elm$core$List$filter,
						function (chip) {
							return !_Utils_eq(
								$elm$core$Maybe$Just(chip.e.R),
								homeId);
						},
						offered)))
		};
	});
var $author$project$Shop$Where$chipsIf = F2(
	function (_v0, maybeOptions) {
		var released = _v0.o$;
		var limit = _v0.j2;
		var _v1 = _Utils_Tuple2(released, maybeOptions);
		if (_v1.a && (!_v1.b.$)) {
			var options = _v1.b.a;
			var found = A2($author$project$Shop$Where$chips, limit, options);
			return ((!_Utils_eq(found.m9, $elm$core$Maybe$Nothing)) || ((!$elm$core$List$isEmpty(found.oH)) || (found.dF > 0))) ? $elm$core$Maybe$Just(found) : $elm$core$Maybe$Nothing;
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Page$Shop$whereChipLimit = 8;
var $author$project$Page$Shop$whereChips = function (model) {
	return A2(
		$author$project$Shop$Where$chipsIf,
		{j2: $author$project$Page$Shop$whereChipLimit, o$: model.eV},
		$krisajenkins$remotedata$RemoteData$toMaybe(model.d4));
};
var $author$project$Page$Shop$viewWhere = F2(
	function (_v0, model) {
		var t = _v0.il;
		var placeLabel = function (place) {
			var _v7 = place.lc;
			if (!_v7.$) {
				var stateCode = _v7.a;
				return place.ki + (' - ' + stateCode);
			} else {
				return place.ki;
			}
		};
		var chip = function (_v6) {
			var chosen = _v6.ee;
			var label = _v6.nC;
			var count = _v6.mo;
			return $author$project$Page$Shop$viewChip(
				{
					mo: count,
					hw: _Utils_eq(model.b7, chosen),
					nC: label,
					hN: $author$project$Page$Shop$ClickedWhere(chosen)
				});
		};
		var _v1 = _Utils_Tuple2(model.eV, model.d4);
		if (_v1.a && (_v1.b.$ === 1)) {
			var _v2 = _v1.b;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mt-4')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('animate-skeleton-loading h-9 w-2/3 rounded-full')
							]),
						_List_Nil)
					]));
		} else {
			var _v3 = $author$project$Page$Shop$whereChips(model);
			if (_v3.$ === 1) {
				return $elm$html$Html$text('');
			} else {
				var home = _v3.a.m9;
				var places = _v3.a.oH;
				var online = _v3.a.dF;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id('shop-where'),
							$elm$html$Html$Attributes$class('mt-4')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-sm font-bold text-gray-700 mb-2')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('shop.where.title'))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex gap-2 overflow-x-auto pb-2 -mx-4 px-4 md:mx-0 md:px-0 md:flex-wrap')
								]),
							_Utils_ap(
								A2(
									$elm$core$List$filterMap,
									$elm$core$Basics$identity,
									_List_fromArray(
										[
											$elm$core$Maybe$Just(
											chip(
												{
													ee: $author$project$Shop$Where$Anywhere,
													mo: $elm$core$Maybe$Nothing,
													nC: t('shop.where.anywhere')
												})),
											A2(
											$elm$core$Maybe$map,
											function (_v4) {
												var place = _v4.e;
												var count = _v4.mo;
												return chip(
													{
														ee: $author$project$Shop$Where$InPlace(place.R),
														mo: $elm$core$Maybe$Just(count),
														nC: t('shop.where.near_you')
													});
											},
											home),
											(online > 0) ? $elm$core$Maybe$Just(
											chip(
												{
													ee: $author$project$Shop$Where$Online,
													mo: $elm$core$Maybe$Just(online),
													nC: t('shop.where.online')
												})) : $elm$core$Maybe$Nothing
										])),
								A2(
									$elm$core$List$map,
									function (_v5) {
										var place = _v5.e;
										var count = _v5.mo;
										return chip(
											{
												ee: $author$project$Shop$Where$InPlace(place.R),
												mo: $elm$core$Maybe$Just(count),
												nC: placeLabel(place)
											});
									},
									places)))
						]));
			}
		}
	});
var $author$project$Page$Shop$viewShopFilter = F2(
	function (loggedIn, model) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$Page$Shop$viewShopButtons, loggedIn, model),
					A2($author$project$Page$Shop$viewOfferType, loggedIn.aM.iw, model),
					A2($author$project$Page$Shop$viewWhere, loggedIn.aM.iw, model)
				]));
	});
var $author$project$Page$Shop$view = F2(
	function (loggedIn, model) {
		var viewFrozenAccountCard = (!loggedIn.mZ) ? A3(
			$author$project$Session$LoggedIn$viewFrozenAccountCard,
			loggedIn.aM.iw,
			{nu: true, og: $author$project$Page$Shop$ClickedAcceptCodeOfConduct},
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mx-auto shadow-lg mb-6')
				])) : $elm$html$Html$text('');
		var selectedCommunityName = function () {
			var _v3 = loggedIn.o7;
			if (_v3.$ === 3) {
				var community = _v3.a;
				return community.ki;
			} else {
				return '';
			}
		}();
		var _v0 = loggedIn.aM.iw;
		var t = _v0.il;
		var content = function (community) {
			var _v2 = model.ap;
			switch (_v2.$) {
				case 0:
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('mt-6 mb-10')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('container mx-auto px-4')
									]),
								_List_fromArray(
									[
										viewFrozenAccountCard,
										$author$project$Page$Shop$viewHeader(loggedIn.aM.iw),
										A2($author$project$Page$Shop$viewShopFilter, loggedIn, model)
									])),
								$elm$core$List$isEmpty(model.z.cX) ? $elm$html$Html$text('') : A2($author$project$Page$Shop$viewFilterTags, community, model),
								$elm$core$List$isEmpty(model.z.cX) ? $elm$html$Html$text('') : A3($author$project$Page$Shop$viewFoundOffersAmount, loggedIn.aM.iw, community, model),
								A2($author$project$Page$Shop$viewFiltersModal, loggedIn, model),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('container mx-auto px-4')
									]),
								_List_fromArray(
									[
										$author$project$Page$fullPageLoading(loggedIn.aM)
									]))
							]));
				case 2:
					var e = _v2.a;
					return A2(
						$author$project$Page$fullPageGraphQLError,
						t('shop.title'),
						e);
				default:
					var cards = _v2.a;
					return $elm$core$List$isEmpty(cards) ? ((_Utils_eq(model.z.oy, $elm$core$Maybe$Nothing) && ($elm$core$List$isEmpty(model.z.cX) && ((!$author$project$Shop$Where$isChosen(model.b7)) && _Utils_eq(model.b6, $elm$core$Maybe$Nothing)))) ? A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('container mx-auto px-4 mt-6')
							]),
						_List_fromArray(
							[
								viewFrozenAccountCard,
								A3($author$project$Page$Shop$viewEmptyState, loggedIn, community.e9, model)
							])) : A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('mt-6')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('container mx-auto px-4')
									]),
								_List_fromArray(
									[
										viewFrozenAccountCard,
										$author$project$Page$Shop$viewHeader(loggedIn.aM.iw),
										A2($author$project$Page$Shop$viewShopFilter, loggedIn, model)
									])),
								$elm$core$List$isEmpty(model.z.cX) ? $elm$html$Html$text('') : A2($author$project$Page$Shop$viewFilterTags, community, model),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('container mx-auto px-4')
									]),
								_List_fromArray(
									[
										$author$project$Page$Shop$viewEmptyStateWithFilters(loggedIn.aM.iw)
									])),
								A2($author$project$Page$Shop$viewFiltersModal, loggedIn, model)
							]))) : A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('mt-6')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('container mx-auto px-4')
									]),
								_List_fromArray(
									[
										viewFrozenAccountCard,
										$author$project$Page$Shop$viewHeader(loggedIn.aM.iw),
										A2($author$project$Page$Shop$viewShopFilter, loggedIn, model)
									])),
								$elm$core$List$isEmpty(model.z.cX) ? $elm$html$Html$text('') : A2($author$project$Page$Shop$viewFilterTags, community, model),
								$elm$core$List$isEmpty(model.z.cX) ? $elm$html$Html$text('') : A3($author$project$Page$Shop$viewFoundOffersAmount, loggedIn.aM.iw, community, model),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('container mx-auto px-4')
									]),
								_List_fromArray(
									[
										A2($author$project$Page$Shop$viewGrid, loggedIn, cards)
									])),
								A2($author$project$Page$Shop$viewFiltersModal, loggedIn, model)
							]));
			}
		};
		var title = selectedCommunityName + (' ' + t('shop.title'));
		return {
			mk: function () {
				var _v1 = loggedIn.o7;
				switch (_v1.$) {
					case 3:
						var community = _v1.a;
						return community.cm ? content(community) : A2(
							$author$project$Page$fullPageNotFound,
							t('error.pageNotFound'),
							t('shop.disabled.description'));
					case 1:
						return $author$project$Page$fullPageLoading(loggedIn.aM);
					case 0:
						return $author$project$Page$fullPageLoading(loggedIn.aM);
					default:
						var e = _v1.a;
						return A2(
							$author$project$Page$fullPageGraphQLError,
							t('community.error_loading'),
							e);
				}
			}(),
			fb: title
		};
	});
var $author$project$Page$Shop$Editor$allRouteSteps = _List_fromArray(
	[0, 1, 2, 3]);
var $author$project$Page$Shop$Editor$SubmittedPriceAndInventory = function (a) {
	return {$: 7, a: a};
};
var $author$project$Icons$checkmark = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('14'),
				$elm$svg$Svg$Attributes$height('10'),
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M5.662 9.5c-.266 0-.521-.102-.71-.284L.27 4.704a.942.942 0 0 1 .025-1.342 1.031 1.031 0 0 1 1.394-.024l3.974 3.829 6.65-6.408a1.031 1.031 0 0 1 1.394.024.942.942 0 0 1 .025 1.343l-7.36 7.09a1.023 1.023 0 0 1-.71.284Z'),
						$elm$svg$Svg$Attributes$fill('#fff')
					]),
				_List_Nil)
			]));
};
var $author$project$Page$Shop$Editor$PriceAndInventoryFormOutput = F2(
	function (price, unitTracking) {
		return {h3: price, ix: unitTracking};
	});
var $author$project$Form$Validate$numberGreaterThan = F2(
	function (numberToString, lowerBound) {
		return $author$project$Form$Validate$custom(
			function (x) {
				return (_Utils_cmp(x, lowerBound) > 0) ? $elm$core$Result$Ok(x) : $elm$core$Result$Err(
					function (_v0) {
						var tr = _v0.iu;
						return A2(
							tr,
							'error.validator.number.greater_than',
							_List_fromArray(
								[
									_Utils_Tuple2(
									'base',
									numberToString(lowerBound))
								]));
					});
			});
	});
var $author$project$Form$Validate$floatGreaterThan = $author$project$Form$Validate$numberGreaterThan($elm$core$String$fromFloat);
var $author$project$Page$Shop$Editor$ClickedDecrementStockUnits = {$: 9};
var $author$project$Page$Shop$Editor$ClickedIncrementStockUnits = {$: 10};
var $author$project$Form$Validate$int = $author$project$Form$Validate$number($elm$core$String$toInt);
var $author$project$Form$Validate$numberGreaterThanOrEqualTo = F2(
	function (numberToString, lowerBound) {
		return $author$project$Form$Validate$custom(
			function (x) {
				return (_Utils_cmp(x, lowerBound) > -1) ? $elm$core$Result$Ok(x) : $elm$core$Result$Err(
					function (_v0) {
						var tr = _v0.iu;
						return A2(
							tr,
							'error.validator.number.greater_than_or_equal',
							_List_fromArray(
								[
									_Utils_Tuple2(
									'base',
									numberToString(lowerBound))
								]));
					});
			});
	});
var $author$project$Form$Validate$intGreaterThanOrEqualTo = $author$project$Form$Validate$numberGreaterThanOrEqualTo($elm$core$String$fromInt);
var $author$project$Icons$minus = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$class(class_),
				$elm$svg$Svg$Attributes$width('26'),
				$elm$svg$Svg$Attributes$height('2'),
				$elm$svg$Svg$Attributes$viewBox('0 0 26 2'),
				$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M1.71711 0.032959H24.2829C24.817 0.032959 25.25 0.465947 25.25 1.00006C25.25 1.53418 24.817 1.96717 24.2829 1.96717H1.71711C1.18299 1.96717 0.75 1.53418 0.75 1.00006C0.75 0.465947 1.18299 0.032959 1.71711 0.032959Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Page$Shop$Editor$stockTrackingForm = F2(
	function (translators, _v0) {
		var isDisabled = _v0.ns;
		return A4(
			$author$project$Form$withGroup,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bg-gray-100 rounded-sm p-4')
				]),
			A2(
				$author$project$Form$toggle,
				{
					ab: $elm$core$Basics$always($elm$core$Maybe$Nothing),
					af: $elm$core$Result$Ok,
					n: F2(
						function (newTrackUnits, values) {
							return _Utils_update(
								values,
								{d_: newTrackUnits});
						}),
					pO: function ($) {
						return $.d_;
					}
				},
				A2(
					$author$project$Form$Toggle$withToggleSide,
					{jS: true},
					A2(
						$author$project$Form$Toggle$withToggleContainerAttrs,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('ml-0 pl-0')
							]),
						A2(
							$author$project$Form$Toggle$withContainerAttrs,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex flex-col')
								]),
							$author$project$Form$Toggle$init(
								{
									R: 'product-track-units-toggle',
									nC: A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-gray-333 text-base mb-4')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('font-bold')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														translators.il('shop.steps.price_and_inventory.inventory_management'))
													])),
												A2(
												$elm$html$Html$p,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('mt-2')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														translators.il('shop.steps.price_and_inventory.inventory_management_description'))
													]))
											]))
								}))))),
			$author$project$Form$introspect(
				function (_v1) {
					var trackUnits = _v1.d_;
					return trackUnits ? A2(
						$author$project$Form$textField,
						{
							ab: $elm$core$Basics$always($elm$core$Maybe$Nothing),
							af: A2(
								$elm$core$Basics$composeR,
								$author$project$Form$Validate$succeed,
								A2(
									$elm$core$Basics$composeR,
									$author$project$Form$Validate$int,
									A2(
										$elm$core$Basics$composeR,
										$author$project$Form$Validate$intGreaterThanOrEqualTo(0),
										$author$project$Form$Validate$validate(translators)))),
							n: F2(
								function (newUnitsInStock, values) {
									return _Utils_update(
										values,
										{cN: newUnitsInStock});
								}),
							pO: function ($) {
								return $.cN;
							}
						},
						A2(
							$author$project$Form$Text$withElements,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('absolute top-1 bottom-1 left-1 px-4 rounded focus-ring text-orange-300 hover:text-orange-300/70'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('bg-white', !isDisabled),
													_Utils_Tuple2('bg-gray-500', isDisabled)
												])),
											$elm$html$Html$Attributes$type_('button'),
											$fapian$elm_html_aria$Html$Attributes$Aria$ariaLabel(
											translators.il('shop.subtract_unit')),
											$elm$html$Html$Events$onClick($author$project$Page$Shop$Editor$ClickedDecrementStockUnits)
										]),
									_List_fromArray(
										[
											$author$project$Icons$minus('fill-current')
										])),
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('absolute top-1 bottom-1 right-1 px-4 rounded focus-ring text-orange-300 hover:text-orange-300/70'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('bg-white', !isDisabled),
													_Utils_Tuple2('bg-gray-500', isDisabled)
												])),
											$elm$html$Html$Attributes$type_('button'),
											$fapian$elm_html_aria$Html$Attributes$Aria$ariaLabel(
											translators.il('shop.add_unit')),
											$elm$html$Html$Events$onClick($author$project$Page$Shop$Editor$ClickedIncrementStockUnits)
										]),
									_List_fromArray(
										[
											$author$project$Icons$plus('fill-current')
										]))
								]),
							A2(
								$author$project$Form$Text$withExtraAttrs,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$min('0'),
										$elm$html$Html$Attributes$class('text-center')
									]),
								A2(
									$author$project$Form$Text$withContainerAttrs,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('mb-0 mt-10')
										]),
									A2(
										$author$project$Form$Text$withType,
										2,
										$author$project$Form$Text$asNumeric(
											A2(
												$author$project$Form$Text$withPlaceholder,
												'0',
												$author$project$Form$Text$init(
													{
														R: 'product-quantity-input',
														nC: translators.il('shop.steps.price_and_inventory.quantity_label')
													})))))))) : $author$project$Form$succeed(0);
				}),
			$author$project$Form$succeed(
				F2(
					function (trackStock, availableUnits) {
						return trackStock ? $author$project$Shop$UnitTracking(
							{iQ: availableUnits}) : $author$project$Shop$NoTracking;
					})));
	});
var $author$project$Page$Shop$Editor$priceAndInventoryForm = F3(
	function (translators, isDisabled, symbol) {
		return A4(
			$author$project$Form$withGroup,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('grid lg:grid-cols-2 gap-8')
				]),
			A2(
				$author$project$Form$textField,
				{
					ab: $elm$core$Basics$always($elm$core$Maybe$Nothing),
					af: A2(
						$elm$core$Basics$composeR,
						$author$project$Form$Validate$succeed,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Form$Validate$maskedFloat(translators),
							A2(
								$elm$core$Basics$composeR,
								$author$project$Form$Validate$floatGreaterThan(0),
								A2(
									$elm$core$Basics$composeR,
									$author$project$Form$Validate$map(
										function (price) {
											return {lU: price, e9: symbol};
										}),
									$author$project$Form$Validate$validate(translators))))),
					n: F2(
						function (newPrice, values) {
							return _Utils_update(
								values,
								{h3: newPrice});
						}),
					pO: function ($) {
						return $.h3;
					}
				},
				A2(
					$author$project$Form$Text$withContainerAttrs,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('bg-gray-100 rounded-sm p-4 mb-0 self-start')
						]),
					A2(
						$author$project$Form$Text$withExtraAttrs,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$min('0')
							]),
						A2(
							$author$project$Form$Text$withCurrency,
							symbol,
							$author$project$Form$Text$init(
								{
									R: 'product-price-input',
									nC: translators.il('shop.steps.price_and_inventory.price_label')
								}))))),
			A2($author$project$Page$Shop$Editor$stockTrackingForm, translators, isDisabled),
			$author$project$Form$succeed($author$project$Page$Shop$Editor$PriceAndInventoryFormOutput));
	});
var $author$project$Page$Shop$Editor$viewForm = F6(
	function (loggedIn, community, allCategories, _v0, model, formData) {
		var shared = loggedIn.aM;
		var isEdit = _v0.ct;
		var isDisabled = _v0.ns;
		var availableSteps = _v0.b3;
		var totalSteps = $elm$core$List$length(availableSteps);
		var isStepCompleted = function (step) {
			var _v10 = _Utils_Tuple2(step, formData.C);
			_v10$6:
			while (true) {
				switch (_v10.a) {
					case 0:
						switch (_v10.b.$) {
							case 1:
								var _v11 = _v10.a;
								return true;
							case 2:
								var _v12 = _v10.a;
								var _v13 = _v10.b;
								return true;
							case 3:
								var _v14 = _v10.a;
								var _v15 = _v10.b;
								return true;
							default:
								break _v10$6;
						}
					case 1:
						switch (_v10.b.$) {
							case 2:
								var _v16 = _v10.a;
								var _v17 = _v10.b;
								return true;
							case 3:
								var _v18 = _v10.a;
								var _v19 = _v10.b;
								return true;
							default:
								break _v10$6;
						}
					case 2:
						if (_v10.b.$ === 3) {
							var _v20 = _v10.a;
							var _v21 = _v10.b;
							return true;
						} else {
							break _v10$6;
						}
					default:
						break _v10$6;
				}
			}
			return false;
		};
		var stepLine = function (step) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('w-full h-px bg-gray-900 relative')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('bg-orange-300 w-full absolute left-0 top-0 bottom-0 transition-transform ease-out origin-left duration-300'),
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'scale-x-0 delay-300',
										!isStepCompleted(step)),
										_Utils_Tuple2(
										'scale-x-100',
										isStepCompleted(step))
									]))
							]),
						_List_Nil)
					]));
		};
		var findRouteStepIndex = F2(
			function (routeStep, _default) {
				return A2(
					$elm$core$Maybe$withDefault,
					_default,
					A2(
						$elm$core$Maybe$map,
						$elm$core$Basics$add(1),
						A2(
							$elm_community$list_extra$List$Extra$findIndex,
							$elm$core$Basics$eq(routeStep),
							availableSteps)));
			});
		var _v1 = shared.iw;
		var t = _v1.il;
		var tr = _v1.iu;
		var stepBall = function (step) {
			var maybeNewRoute = A2($author$project$Page$Shop$Editor$setCurrentStepInRoute, model, step);
			var isCurrent = function () {
				var _v9 = formData.C;
				switch (_v9.$) {
					case 0:
						return !step;
					case 1:
						return step === 1;
					case 2:
						return step === 2;
					default:
						return step === 3;
				}
			}();
			var _v6 = function () {
				switch (step) {
					case 0:
						return _Utils_Tuple2(
							1,
							t('shop.steps.main_information.title'));
					case 1:
						return _Utils_Tuple2(
							2,
							t('shop.steps.images.title'));
					case 2:
						return _Utils_Tuple2(
							3,
							t('shop.steps.categories.title'));
					default:
						return _Utils_Tuple2(
							totalSteps,
							t('shop.steps.price_and_inventory.title'));
				}
			}();
			var defaultStepIndex = _v6.a;
			var linkStepName = _v6.b;
			var linkStepIndex = A2(findRouteStepIndex, step, defaultStepIndex);
			return A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('w-6 h-6 rounded-full flex-shrink-0 flex items-center justify-center transition-colors duration-300'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'bg-orange-300 delay-300',
								isStepCompleted(step) || isCurrent),
								_Utils_Tuple2(
								'bg-gray-900',
								!(isStepCompleted(step) || isCurrent))
							])),
						function () {
						if (!maybeNewRoute.$) {
							var newRoute = maybeNewRoute.a;
							return $author$project$Route$href(newRoute);
						} else {
							return $elm$html$Html$Attributes$class('');
						}
					}(),
						$fapian$elm_html_aria$Html$Attributes$Aria$ariaLabel(
						A2(
							tr,
							'shop.steps.step_link',
							_List_fromArray(
								[
									_Utils_Tuple2(
									'index',
									$elm$core$String$fromInt(linkStepIndex)),
									_Utils_Tuple2('step_title', linkStepName)
								])))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('transition-opacity duration-300'),
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'opacity-0',
										!isStepCompleted(step))
									]))
							]),
						_List_fromArray(
							[
								$author$project$Icons$checkmark('')
							]))
					]));
		};
		var _v2 = function () {
			var _v3 = formData.C;
			switch (_v3.$) {
				case 0:
					return _Utils_Tuple2(
						A2(findRouteStepIndex, 0, 1),
						t('shop.steps.main_information.title'));
				case 1:
					return _Utils_Tuple2(
						A2(findRouteStepIndex, 1, 2),
						t('shop.steps.images.title'));
				case 2:
					return _Utils_Tuple2(
						A2(findRouteStepIndex, 2, 3),
						t('shop.steps.categories.title'));
				default:
					return _Utils_Tuple2(
						A2(findRouteStepIndex, 3, 4),
						t('shop.steps.price_and_inventory.title'));
			}
		}();
		var stepNumber = _v2.a;
		var stepName = _v2.b;
		var viewHeader = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container mx-auto px-4 lg:max-w-none lg:mx-0 lg:px-6')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mb-4 flex items-center')
						]),
					A2(
						$elm$core$List$concatMap,
						function (step) {
							return _Utils_eq(
								$elm_community$list_extra$List$Extra$last(availableSteps),
								$elm$core$Maybe$Just(step)) ? _List_fromArray(
								[
									stepBall(step)
								]) : _List_fromArray(
								[
									stepBall(step),
									stepLine(step)
								]);
						},
						availableSteps)),
					A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('font-bold text-black mb-2')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								tr,
								'shop.steps.index',
								_List_fromArray(
									[
										_Utils_Tuple2(
										'current',
										$elm$core$String$fromInt(stepNumber)),
										_Utils_Tuple2(
										'total',
										$elm$core$String$fromInt(totalSteps))
									])))
						])),
					$elm$html$Html$text(stepName)
				]));
		var _v4 = isEdit ? _Utils_Tuple2(
			t('menu.save'),
			t('shop.edit_offer')) : _Utils_Tuple2(
			t('menu.create'),
			t('shop.create_offer'));
		var actionText = _v4.a;
		var pageTitle = _v4.b;
		var viewForm_ = F5(
			function (formFn, formModel, routeStep, toFormMsg, onSubmitMsg) {
				var submitText = _Utils_eq(
					$elm_community$list_extra$List$Extra$last(availableSteps),
					$elm$core$Maybe$Just(routeStep)) ? actionText : t('shop.steps.continue');
				return A6(
					$author$project$Form$view,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('container mx-auto px-4 flex-grow flex flex-col lg:max-w-none lg:mx-0 lg:px-6')
						]),
					shared.iw,
					function (submitButton) {
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('mt-auto')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('mt-10 flex gap-x-4')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('grid grid-cols-2 w-full gap-6 lg:w-1/2 lg:mx-auto'),
														$elm$html$Html$Attributes$classList(
														_List_fromArray(
															[
																_Utils_Tuple2('grid-cols-3', isEdit)
															]))
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$a,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('button button-secondary w-full'),
																$author$project$Route$href(
																$author$project$Route$Shop(
																	{cX: _List_Nil, oy: $elm$core$Maybe$Nothing}))
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(
																t('menu.cancel'))
															])),
														A2(
														submitButton,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('button button-primary w-full'),
																$elm$html$Html$Attributes$disabled(
																isDisabled || $author$project$Form$hasFieldsLoading(formModel))
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(submitText)
															]))
													]))
											]))
									]))
							]);
					},
					formFn,
					A2($author$project$Form$withDisabled, isDisabled, formModel),
					{
						oq: onSubmitMsg,
						pA: A2($elm$core$Basics$composeR, toFormMsg, $author$project$Page$Shop$Editor$GotFormMsg)
					});
			});
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-col flex-grow')
				]),
			_List_fromArray(
				[
					A2($author$project$Page$viewHeader, loggedIn, pageTitle),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('lg:container lg:mx-auto lg:px-4 lg:mt-6 lg:mb-20')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('bg-white pt-4 pb-8 flex-grow flex flex-col lg:w-2/3 lg:mx-auto lg:rounded lg:shadow-lg lg:animate-fade-in-from-above-lg lg:fill-mode-none lg:motion-reduce:animate-none'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'min-h-150',
											$elm$core$List$length(availableSteps) > 1)
										]))
								]),
							_List_fromArray(
								[
									($elm$core$List$length(availableSteps) > 1) ? viewHeader : A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('font-bold px-4')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(stepName)
										])),
									A2(
									$elm$html$Html$hr,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('mt-4 mb-6 border-gray-500 lg:mx-4 lg:mb-10'),
											$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
										]),
									_List_Nil),
									function () {
									var _v5 = formData.C;
									switch (_v5.$) {
										case 0:
											return A5(
												viewForm_,
												$author$project$Page$Shop$Editor$mainInformationForm(shared.iw),
												formData.bg,
												0,
												$author$project$Page$Shop$Editor$MainInformationMsg,
												$author$project$Page$Shop$Editor$SubmittedMainInformation(0));
										case 1:
											return A5(
												viewForm_,
												$author$project$Page$Shop$Editor$imagesForm(shared.iw),
												formData.hr,
												1,
												$author$project$Page$Shop$Editor$ImagesMsg,
												$author$project$Page$Shop$Editor$SubmittedImages(
													A2($elm$core$List$member, 2, availableSteps) ? 0 : 1));
										case 2:
											return A5(
												viewForm_,
												A2($author$project$Page$Shop$Editor$categoriesForm, shared.iw, allCategories),
												formData.cX,
												2,
												$author$project$Page$Shop$Editor$CategoriesMsg,
												$author$project$Page$Shop$Editor$SubmittedCategories);
										default:
											return A5(
												viewForm_,
												A3(
													$author$project$Page$Shop$Editor$priceAndInventoryForm,
													shared.iw,
													{ns: isDisabled},
													community.e9),
												formData.bN,
												3,
												$author$project$Page$Shop$Editor$PriceAndInventoryMsg,
												$author$project$Page$Shop$Editor$SubmittedPriceAndInventory);
									}
								}()
								]))
						]))
				]));
	});
var $author$project$Page$Shop$Editor$view = F2(
	function (loggedIn, model) {
		var shared = loggedIn.aM;
		var t = shared.iw.il;
		var isEdit = function () {
			var _v4 = model.gE;
			switch (_v4.$) {
				case 3:
					return true;
				case 4:
					return true;
				case 5:
					return true;
				case 6:
					return true;
				default:
					return false;
			}
		}();
		var title = isEdit ? t('shop.edit_offer') : t('shop.create_offer');
		var content = F2(
			function (community, shopCategories) {
				var _v3 = model.gE;
				switch (_v3.$) {
					case 2:
						return $author$project$Page$fullPageLoading(shared);
					case 7:
						var error = _v3.a;
						return A2(
							$author$project$Page$fullPageGraphQLError,
							t('shop.title'),
							error);
					case 8:
						return A2(
							$author$project$Page$fullPageNotFound,
							t('shop.unauthorized'),
							'');
					case 0:
						var formData = _v3.a;
						return A6(
							$author$project$Page$Shop$Editor$viewForm,
							loggedIn,
							community,
							shopCategories,
							{b3: $author$project$Page$Shop$Editor$allRouteSteps, ns: false, ct: false},
							model,
							formData);
					case 1:
						var formData = _v3.a;
						return A6(
							$author$project$Page$Shop$Editor$viewForm,
							loggedIn,
							community,
							shopCategories,
							{b3: $author$project$Page$Shop$Editor$allRouteSteps, ns: true, ct: false},
							model,
							formData);
					case 3:
						var formData = _v3.b;
						return A6(
							$author$project$Page$Shop$Editor$viewForm,
							loggedIn,
							community,
							shopCategories,
							{b3: $author$project$Page$Shop$Editor$allRouteSteps, ns: false, ct: true},
							model,
							formData);
					case 4:
						var formData = _v3.b;
						return A6(
							$author$project$Page$Shop$Editor$viewForm,
							loggedIn,
							community,
							shopCategories,
							{b3: $author$project$Page$Shop$Editor$allRouteSteps, ns: true, ct: true},
							model,
							formData);
					case 5:
						var formData = _v3.b;
						return A6(
							$author$project$Page$Shop$Editor$viewForm,
							loggedIn,
							community,
							shopCategories,
							{
								b3: _List_fromArray(
									[2]),
								ns: false,
								ct: true
							},
							model,
							formData);
					default:
						var formData = _v3.b;
						return A6(
							$author$project$Page$Shop$Editor$viewForm,
							loggedIn,
							community,
							shopCategories,
							{
								b3: _List_fromArray(
									[2]),
								ns: true,
								ct: true
							},
							model,
							formData);
				}
			});
		return {
			mk: function () {
				var _v0 = A2(
					$author$project$Community$getField,
					loggedIn.o7,
					function ($) {
						return $.e1;
					});
				switch (_v0.$) {
					case 3:
						var _v1 = _v0.a;
						var community = _v1.a;
						var shopCategories = _v1.b;
						return community.cm ? A2(content, community, shopCategories) : A2(
							$author$project$Page$fullPageNotFound,
							t('error.pageNotFound'),
							t('shop.disabled.description'));
					case 1:
						return $author$project$Page$fullPageLoading(shared);
					case 0:
						return $author$project$Page$fullPageLoading(shared);
					default:
						var fieldError = _v0.a;
						if (!fieldError.$) {
							var err = fieldError.a;
							return A2(
								$author$project$Page$fullPageGraphQLError,
								t('community.error_loading'),
								err);
						} else {
							var err = fieldError.a;
							return A2(
								$author$project$Page$fullPageGraphQLError,
								t('community.error_loading'),
								err);
						}
				}
			}(),
			fb: title
		};
	});
var $author$project$Page$Shop$Viewer$ClickedEditSale = {$: 7};
var $author$project$Page$Shop$Viewer$ClickedOpenDetails = {$: 4};
var $author$project$Page$Shop$Viewer$ClickedScrollToImage = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Shop$Viewer$ClickedShareOffer = function (a) {
	return {$: 6, a: a};
};
var $author$project$Page$Shop$Viewer$GotFormInteractionMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Page$Shop$Viewer$GotFormInteractionMsgAsGuest = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Shop$Viewer$ImageStartedIntersecting = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Shop$Viewer$ImageStoppedIntersecting = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$Shop$Viewer$communityHasCategories = function (session) {
	if (!session.$) {
		return false;
	} else {
		var loggedIn = session.a;
		var _v1 = A2(
			$author$project$Community$getField,
			loggedIn.o7,
			function ($) {
				return $.e1;
			});
		if (_v1.$ === 3) {
			var _v2 = _v1.a;
			var categories = _v2.b;
			return !$elm$core$List$isEmpty(categories);
		} else {
			return false;
		}
	}
};
var $author$project$Page$Shop$Viewer$ClickedDecrementUnits = 0;
var $author$project$Page$Shop$Viewer$ClickedIncrementUnits = 1;
var $author$project$Page$Shop$Viewer$FormOutput = F2(
	function (units, memo) {
		return {ka: memo, iy: units};
	});
var $author$project$Form$Validate$intLowerThanOrEqualTo = $author$project$Form$Validate$numberLowerThanOrEqualTo($elm$core$String$fromInt);
var $author$project$Form$RichText$withContainerAttrs = F2(
	function (attrs, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				mg: _Utils_ap(options.mg, attrs)
			});
	});
var $author$project$Page$Shop$Viewer$createForm = F5(
	function (translators, product, maybeBalance, _v0, toFormInteractionMsg) {
		var t = translators.il;
		var tr = translators.iu;
		var isDisabled = _v0.ns;
		var communityMinBalance = _v0.g4;
		return A2(
			$author$project$Form$with,
			A2(
				$author$project$Form$richText,
				{
					ab: $elm$core$Basics$always($elm$core$Maybe$Nothing),
					af: $elm$core$Result$Ok,
					n: F2(
						function (memo, input) {
							return _Utils_update(
								input,
								{ka: memo});
						}),
					pO: function ($) {
						return $.ka;
					}
				},
				A2(
					$author$project$Form$RichText$withContainerAttrs,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mb-6')
						]),
					$author$project$Form$RichText$init(
						{
							nC: t('shop.transfer.memo_label')
						}))),
			A2(
				$author$project$Form$withNoOutput,
				$author$project$Form$introspect(
					function (values) {
						return $author$project$Form$arbitrary(
							A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('bg-green pt-4 mb-6 rounded-sm flex flex-col text-white font-bold text-center')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-xl px-4'),
												$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
											]),
										_List_fromArray(
											[
												function () {
												var _v2 = $elm$core$String$toInt(values.iy);
												if (_v2.$ === 1) {
													return $elm$html$Html$text('0');
												} else {
													var unitsValue = _v2.a;
													return $elm$html$Html$text(
														$elm$core$String$fromFloat(unitsValue * product.h3));
												}
											}()
											])),
										function () {
										var _v3 = $elm$core$String$toInt(values.iy);
										if (_v3.$ === 1) {
											return $elm$html$Html$text('');
										} else {
											var unitsValue = _v3.a;
											return A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('sr-only')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														A2(
															tr,
															'shop.total_price',
															_List_fromArray(
																[
																	_Utils_Tuple2(
																	'amount',
																	$elm$core$String$fromFloat(unitsValue * product.h3)),
																	_Utils_Tuple2(
																	'symbol',
																	$author$project$Eos$symbolToSymbolCodeString(product.e9))
																])))
													]));
										}
									}(),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('px-4 mb-4'),
												$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												A2(
													tr,
													'shop.transfer.price',
													_List_fromArray(
														[
															_Utils_Tuple2(
															'symbol',
															$author$project$Eos$symbolToSymbolCodeString(product.e9))
														])))
											])),
										function () {
										if (maybeBalance.$ === 1) {
											return $elm$html$Html$text('');
										} else {
											var balance = maybeBalance.a;
											return A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('text-sm py-3 px-4 bg-black bg-opacity-20 rounded-b-sm uppercase')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														A2(
															tr,
															'shop.transfer.balance',
															_List_fromArray(
																[
																	_Utils_Tuple2(
																	'asset',
																	A2($author$project$Eos$assetToString, translators, balance.lY))
																])))
													]));
										}
									}()
									])));
					}),
				A2(
					$author$project$Form$with,
					A2(
						$author$project$Form$textField,
						{
							ab: function (values) {
								var minBalance = A2($elm$core$Maybe$withDefault, 0, communityMinBalance);
								var maybeTotalBeingSpent = A2(
									$elm$core$Maybe$map,
									function (units) {
										return units * product.h3;
									},
									$elm$core$String$toInt(values.iy));
								var isSpendingTooMuch = A2(
									$elm$core$Maybe$withDefault,
									false,
									A3(
										$elm$core$Maybe$map2,
										F2(
											function (balance, totalBeingSpent) {
												return _Utils_cmp(balance.lY.lU - totalBeingSpent, minBalance) < 0;
											}),
										maybeBalance,
										maybeTotalBeingSpent));
								return isSpendingTooMuch ? $elm$core$Maybe$Just(
									A2(
										tr,
										'shop.transfer.errors.balanceTooLow',
										_List_fromArray(
											[
												_Utils_Tuple2(
												'symbol',
												$author$project$Eos$symbolToSymbolCodeString(product.e9))
											]))) : $elm$core$Maybe$Nothing;
							},
							af: A2(
								$elm$core$Basics$composeR,
								$author$project$Form$Validate$succeed,
								A2(
									$elm$core$Basics$composeR,
									$author$project$Form$Validate$int,
									A2(
										$elm$core$Basics$composeR,
										$author$project$Form$Validate$intGreaterThanOrEqualTo(1),
										A2(
											$elm$core$Basics$composeR,
											$author$project$Form$Validate$withCustomError(
												function (translators_) {
													return translators_.il('shop.transfer.errors.unitTooLow');
												}),
											A2(
												$elm$core$Basics$composeR,
												function () {
													var _v1 = product.ig;
													if (!_v1.$) {
														return $elm$core$Basics$identity;
													} else {
														var availableUnits = _v1.a.iQ;
														return A2(
															$elm$core$Basics$composeR,
															$author$project$Form$Validate$intLowerThanOrEqualTo(availableUnits),
															$author$project$Form$Validate$withCustomError(
																function (translators_) {
																	return translators_.il('shop.transfer.errors.unitTooHigh');
																}));
													}
												}(),
												$author$project$Form$Validate$validate(translators)))))),
							n: F2(
								function (units, input) {
									return _Utils_update(
										input,
										{iy: units});
								}),
							pO: function ($) {
								return $.iy;
							}
						},
						A2(
							$author$project$Form$Text$withElements,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('absolute top-1 bottom-1 left-1 px-4 rounded focus-ring text-orange-300'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('bg-white hover:text-orange-300/70', !isDisabled),
													_Utils_Tuple2('bg-gray-500 cursor-default', isDisabled)
												])),
											$elm$html$Html$Attributes$type_('button'),
											$elm$html$Html$Attributes$disabled(isDisabled),
											$elm$html$Html$Events$onClick(
											toFormInteractionMsg(0)),
											$fapian$elm_html_aria$Html$Attributes$Aria$ariaLabel(
											t('shop.subtract_unit'))
										]),
									_List_fromArray(
										[
											$author$project$Icons$minus('fill-current')
										])),
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('absolute top-1 bottom-1 right-1 px-4 rounded focus-ring text-orange-300'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('bg-white hover:text-orange-300/70', !isDisabled),
													_Utils_Tuple2('bg-gray-500 cursor-default', isDisabled)
												])),
											$elm$html$Html$Attributes$type_('button'),
											$elm$html$Html$Attributes$disabled(isDisabled),
											$elm$html$Html$Events$onClick(
											toFormInteractionMsg(1)),
											$fapian$elm_html_aria$Html$Attributes$Aria$ariaLabel(
											t('shop.add_unit'))
										]),
									_List_fromArray(
										[
											$author$project$Icons$plus('fill-current')
										]))
								]),
							A2(
								$author$project$Form$Text$withContainerAttrs,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('mb-6')
									]),
								A2(
									$author$project$Form$Text$withExtraAttrs,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$autocomplete(false),
											$elm$html$Html$Attributes$min('0'),
											$elm$html$Html$Attributes$class('text-center')
										]),
									A2(
										$author$project$Form$Text$withType,
										2,
										$author$project$Form$Text$asNumeric(
											$author$project$Form$Text$init(
												{
													R: 'units-input',
													nC: t('shop.transfer.units_label')
												}))))))),
					$author$project$Form$succeed($author$project$Page$Shop$Viewer$FormOutput))));
	});
var $author$project$Icons$ellipsis = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('16'),
				$elm$svg$Svg$Attributes$height('16'),
				$elm$svg$Svg$Attributes$viewBox('0 0 16 16'),
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M7.33334 8.00001C7.33334 8.3682 7.63182 8.66668 8.00001 8.66668C8.36819 8.66668 8.66667 8.3682 8.66667 8.00001C8.66667 7.63182 8.36819 7.33334 8.00001 7.33334C7.63182 7.33334 7.33334 7.63182 7.33334 8.00001Z'),
						$elm$svg$Svg$Attributes$fill('currentColor'),
						$elm$svg$Svg$Attributes$stroke('currentColor'),
						$elm$svg$Svg$Attributes$strokeWidth('1.75'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M2.66667 8.00001C2.66667 8.3682 2.96514 8.66668 3.33333 8.66668C3.70152 8.66668 4 8.3682 4 8.00001C4 7.63182 3.70152 7.33334 3.33333 7.33334C2.96514 7.33334 2.66667 7.63182 2.66667 8.00001Z'),
						$elm$svg$Svg$Attributes$fill('currentColor'),
						$elm$svg$Svg$Attributes$stroke('currentColor'),
						$elm$svg$Svg$Attributes$strokeWidth('1.75'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M12 8.00001C12 8.3682 12.2985 8.66668 12.6667 8.66668C13.0349 8.66668 13.3333 8.3682 13.3333 8.00001C13.3333 7.63182 13.0349 7.33334 12.6667 7.33334C12.2985 7.33334 12 7.63182 12 8.00001Z'),
						$elm$svg$Svg$Attributes$fill('currentColor'),
						$elm$svg$Svg$Attributes$stroke('currentColor'),
						$elm$svg$Svg$Attributes$strokeWidth('1.75'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_Nil)
			]));
};
var $author$project$Icons$image = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$class(class_),
				$elm$svg$Svg$Attributes$width('32'),
				$elm$svg$Svg$Attributes$height('32'),
				$elm$svg$Svg$Attributes$viewBox('0 0 32 32'),
				$elm$svg$Svg$Attributes$fill('none')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M27.3897 8.32158L21.9872 2.90308C21.648 2.35116 21.0536 2.01092 20.4094 2H5.89339C4.8477 2 4 2.85421 4 3.90792V28.0749C4 29.1286 4.8477 29.9828 5.89339 29.9828H26.0896C26.6111 30.0584 27.1375 29.8818 27.5101 29.5064C27.8827 29.1309 28.0579 28.6005 27.983 28.0749V10.2677C28.0316 9.56727 27.8202 8.87366 27.3897 8.32158ZM22.3028 5.89216L24.7516 8.35974H22.3028V5.89216ZM20.3463 3.90792V3.94608L20.3842 3.98424V10.2677H26.0643V17.0726L22.7446 15.1647C22.3575 14.9418 21.8686 15.0213 21.5707 15.3554L16.3134 21.2064L11.8954 19.5529C11.5484 19.4245 11.159 19.5115 10.8983 19.7755L5.88708 24.8251V3.90792H20.3463ZM5.89339 28.0749V27.5025H5.93126L11.8134 21.5753L16.2881 23.2415C16.6504 23.3761 17.0575 23.2754 17.3169 22.9871L22.4921 17.2252L26.0896 19.2985V28.0749H5.89339Z'),
						$elm$svg$Svg$Attributes$fill('black')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M11.5798 15.3555C13.3227 15.3555 14.7355 13.9318 14.7355 12.1756C14.7355 10.4194 13.3227 8.99571 11.5798 8.99571C9.83703 8.99571 8.42419 10.4194 8.42419 12.1756C8.42419 13.9318 9.83703 15.3555 11.5798 15.3555ZM11.5798 10.9036C12.277 10.9036 12.8421 11.4731 12.8421 12.1756C12.8421 12.8781 12.277 13.4475 11.5798 13.4475C10.8827 13.4475 10.3176 12.8781 10.3176 12.1756C10.3176 11.4731 10.8827 10.9036 11.5798 10.9036Z'),
						$elm$svg$Svg$Attributes$fill('black')
					]),
				_List_Nil)
			]));
};
var $author$project$Page$Shop$Viewer$isAdmin = function (session) {
	if (!session.$) {
		return false;
	} else {
		var loggedIn = session.a;
		var _v1 = loggedIn.o7;
		if (_v1.$ === 3) {
			var community = _v1.a;
			return _Utils_eq(community.mq, loggedIn.lM);
		} else {
			return false;
		}
	}
};
var $author$project$Page$Shop$Viewer$ClickedConfirmDelete = {$: 11};
var $author$project$Page$Shop$Viewer$ClosedConfirmDeleteModal = {$: 10};
var $author$project$Page$Shop$Viewer$viewConfirmDeleteModal = F2(
	function (_v0, model) {
		var t = _v0.il;
		return $author$project$View$Modal$toHtml(
			A2(
				$author$project$View$Modal$withFooter,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('button button-secondary'),
								$elm$html$Html$Events$onClick($author$project$Page$Shop$Viewer$ClosedConfirmDeleteModal),
								$elm$html$Html$Attributes$disabled(model.aS === 2)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								t('shop.delete_modal.cancel'))
							])),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('button button-primary ml-4'),
								$elm$html$Html$Events$onClick($author$project$Page$Shop$Viewer$ClickedConfirmDelete),
								$elm$html$Html$Attributes$disabled(model.aS === 2)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								t('shop.delete_modal.confirm'))
							]))
					]),
				A2(
					$author$project$View$Modal$withBody,
					_List_fromArray(
						[
							$elm$html$Html$text(
							t('shop.delete_modal.body'))
						]),
					A2(
						$author$project$View$Modal$withHeader,
						t('shop.delete_modal.title'),
						$author$project$View$Modal$initWith(
							{
								i$: $author$project$Page$Shop$Viewer$ClosedConfirmDeleteModal,
								jW: function () {
									var _v1 = model.aS;
									switch (_v1) {
										case 0:
											return false;
										case 1:
											return true;
										default:
											return true;
									}
								}()
							})))));
	});
var $author$project$Profile$Contact$ariaLabelForContactType = F2(
	function (_v0, contactType) {
		var t = _v0.il;
		switch (contactType) {
			case 3:
				return t('contact_form.reach_out.phone');
			case 1:
				return t('contact_form.reach_out.instagram');
			case 4:
				return t('contact_form.reach_out.telegram');
			case 5:
				return t('contact_form.reach_out.whatsapp');
			case 0:
				return t('contact_form.reach_out.email');
			default:
				return t('contact_form.reach_out.link');
		}
	});
var $author$project$Profile$Contact$circularLinkWithGrayBg = F3(
	function (translators, class_, _v0) {
		var normalized = _v0;
		var defaultClass = function () {
			var _v1 = normalized.mf;
			switch (_v1) {
				case 5:
					return 'fill-current text-green ';
				case 3:
					return 'fill-current text-orange-500';
				default:
					return '';
			}
		}();
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$author$project$Profile$Contact$toHref(normalized),
					$elm$html$Html$Attributes$class('w-10 h-10 flex-shrink-0 bg-gray-100 rounded-full flex items-center justify-center hover:opacity-70 focus-ring'),
					$fapian$elm_html_aria$Html$Attributes$Aria$ariaLabel(
					A2($author$project$Profile$Contact$ariaLabelForContactType, translators, normalized.mf))
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Profile$Contact$contactTypeToIcon,
					_Utils_ap(defaultClass, class_),
					true,
					normalized.mf)
				]));
	});
var $author$project$Page$Shop$Viewer$viewContactTheSeller = F3(
	function (translators, _v0, profile) {
		var t = translators.il;
		var tr = translators.iu;
		var isGuest = _v0.jU;
		var name = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Eos$Account$nameToString(profile.fl),
			profile.ki);
		var makeHref = function (originalRoute) {
			return isGuest ? $author$project$Route$href(
				$author$project$Route$Join(
					$elm$core$Maybe$Just(originalRoute))) : $author$project$Route$href(originalRoute);
		};
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex items-center')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									makeHref(
									$author$project$Route$Profile(profile.fl)),
									$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
								]),
							_List_fromArray(
								[
									A2($author$project$Avatar$view, profile.cV, 'w-14 h-14')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('ml-4 flex flex-col text-gray-333')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h3,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('font-bold lowercase')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											t('shop.transfer.contact_seller'))
										])),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											makeHref(
											$author$project$Route$Profile(profile.fl)),
											$elm$html$Html$Attributes$class('hover:underline'),
											$fapian$elm_html_aria$Html$Attributes$Aria$ariaLabel(
											A2(
												tr,
												'shop.transfer.visit_seller',
												_List_fromArray(
													[
														_Utils_Tuple2('seller', name)
													])))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(name)
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('ml-18 mt-2 flex flex-wrap gap-4')
						]),
					function (contacts) {
						var _v1 = profile.jh;
						if (_v1.$ === 1) {
							return contacts;
						} else {
							var email = _v1.a;
							return _Utils_ap(
								contacts,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$href('mailto:' + email),
												$elm$html$Html$Attributes$class('w-10 h-10 flex-shrink-0 bg-gray-100 rounded-full flex items-center justify-center hover:opacity-70'),
												$fapian$elm_html_aria$Html$Attributes$Aria$ariaLabel(
												t('contact_form.reach_out.email'))
											]),
										_List_fromArray(
											[
												$author$project$Icons$mail('')
											]))
									]));
						}
					}(
						A2(
							$elm$core$List$map,
							A2($author$project$Profile$Contact$circularLinkWithGrayBg, translators, ''),
							profile.aq)))
				]));
	});
var $author$project$Page$Shop$Viewer$ClosedDetailsModal = {$: 5};
var $author$project$Page$Shop$Viewer$viewDetailsModal = F3(
	function (session, sale, model) {
		var viewItem = F4(
			function (icon, element, action, itemText) {
				return A2(
					$elm$html$Html$li,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('w-[calc(100%+2rem)] -mx-4 px-2 py-1')
						]),
					_List_fromArray(
						[
							A2(
							element,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex items-center w-full px-2 py-4 hover:bg-gray-100 focus-ring rounded-sm group transition-colors'),
									action
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center group-hover:bg-white transition-colors')
										]),
									_List_fromArray(
										[
											icon('text-orange-300 w-4 h-4')
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('ml-3 text-gray-333')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(itemText)
										]))
								]))
						]));
			});
		var shared = $author$project$Page$toShared(session);
		return $author$project$View$Modal$toHtml(
			A2(
				$author$project$View$Modal$withBody,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('divide-y divide-gray-100')
							]),
						_List_fromArray(
							[
								$author$project$Page$Shop$Viewer$isAdmin(session) ? A4(
								viewItem,
								$author$project$Icons$edit,
								$elm$html$Html$a,
								$author$project$Route$href(
									A2($author$project$Route$EditSale, sale.R, 2)),
								shared.iw.il('shop.edit_categories')) : $elm$html$Html$text(''),
								A4(
								viewItem,
								$author$project$Icons$share,
								$elm$html$Html$button,
								$elm$html$Html$Events$onClick(
									$author$project$Page$Shop$Viewer$ClickedShareOffer(sale)),
								shared.iw.il('share'))
							]))
					]),
				A2(
					$author$project$View$Modal$withHeader,
					shared.iw.il('shop.action_options'),
					$author$project$View$Modal$initWith(
						{i$: $author$project$Page$Shop$Viewer$ClosedDetailsModal, jW: model.cs}))));
	});
var $author$project$Page$Shop$Viewer$ClickedDelete = {$: 9};
var $author$project$Page$Shop$Viewer$ClosedEditSaleModal = {$: 8};
var $author$project$Page$Shop$Viewer$viewEditSaleModal = F4(
	function (_v0, model, shopCategories, product) {
		var t = _v0.il;
		var item = F2(
			function (step, name) {
				return A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('py-4 flex items-center hover:opacity-70 focus-ring rounded-sm'),
							$author$project$Route$href(
							A2($author$project$Route$EditSale, product.R, step))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(name),
							$author$project$Icons$arrowDown('-rotate-90 ml-auto')
						]));
			});
		return $author$project$View$Modal$toHtml(
			A2(
				$author$project$View$Modal$withBody,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex flex-col divide-y divide-gray-500 mt-1')
							]),
						_List_fromArray(
							[
								A2(
								item,
								0,
								t('shop.steps.main_information.title')),
								A2(
								item,
								1,
								t('shop.steps.images.title')),
								$elm$core$List$isEmpty(shopCategories) ? $elm$html$Html$text('') : A2(
								item,
								2,
								t('shop.steps.categories.title')),
								A2(
								item,
								3,
								t('shop.steps.price_and_inventory.title')),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-red py-4 flex items-center hover:opacity-60 focus-ring rounded-sm'),
										$elm$html$Html$Events$onClick($author$project$Page$Shop$Viewer$ClickedDelete)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										t('shop.delete')),
										$author$project$Icons$arrowDown('-rotate-90 ml-auto')
									]))
							]))
					]),
				A2(
					$author$project$View$Modal$withHeader,
					t('shop.edit_offer'),
					$author$project$View$Modal$initWith(
						{i$: $author$project$Page$Shop$Viewer$ClosedEditSaleModal, jW: model.dq}))));
	});
var $author$project$Page$Shop$Viewer$view = F2(
	function (session, model) {
		var shared = $author$project$Page$toShared(session);
		var translators = shared.iw;
		var t = translators.il;
		var shopTitle = t('shop.title');
		var title = function () {
			var _v11 = model.gE;
			if (_v11.$ === 1) {
				var status = _v11.a.gE;
				if (status.$ === 3) {
					var sale = status.a;
					return sale.fb + (' - ' + shopTitle);
				} else {
					return shopTitle;
				}
			} else {
				var productPreview = _v11.a.dN;
				if (productPreview.$ === 3) {
					var sale = productPreview.a;
					return sale.fb + (' - ' + shopTitle);
				} else {
					return shopTitle;
				}
			}
		}();
		var viewContent = F3(
			function (sale, categories, formView) {
				var isGuest = function () {
					if (!session.$) {
						return true;
					} else {
						return false;
					}
				}();
				var isCreator = function () {
					if (!session.$) {
						return false;
					} else {
						var loggedIn = session.a;
						return _Utils_eq(loggedIn.lM, sale.mq.fl);
					}
				}();
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-grow items-center relative bg-white md:bg-gray-100')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('absolute bg-white top-0 bottom-0 left-0 right-1/2 hidden md:block')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('container mx-auto px-4 my-4 md:my-10 md:isolate grid grid-cols-1 md:grid-cols-2')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('mb-6 md:mb-0 md:w-2/3 md:mx-auto')
										]),
									_List_fromArray(
										[
											function () {
											var _v7 = sale.hr;
											if (!_v7.b) {
												return A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('h-68 w-full bg-gray-100 flex flex-col items-center justify-center rounded')
														]),
													_List_fromArray(
														[
															$author$project$Icons$image(''),
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('font-bold uppercase text-black text-sm mt-2')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	t('shop.no_image'))
																]))
														]));
											} else {
												var firstImage = _v7.a;
												var otherImages = _v7.b;
												return A4(
													$author$project$Shop$viewImageCarrousel,
													translators,
													{
														mg: _List_fromArray(
															[
																$elm$html$Html$Attributes$class('h-68')
															]),
														nd: _List_Nil,
														ne: _List_fromArray(
															[
																$elm$html$Html$Attributes$class('bg-gray-100 rounded')
															]),
														ng: _List_fromArray(
															[
																$elm$html$Html$Attributes$class('rounded-b')
															]),
														nK: _List_fromArray(
															[
																$elm$html$Html$Attributes$class('gap-x-4 rounded')
															])
													},
													{mu: model.cc, om: $author$project$Page$Shop$Viewer$ClickedScrollToImage, oo: $author$project$Page$Shop$Viewer$ImageStartedIntersecting, op: $author$project$Page$Shop$Viewer$ImageStoppedIntersecting, oR: $elm$core$Maybe$Nothing, pa: true},
													_Utils_Tuple2(firstImage, otherImages));
											}
										}(),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('flex justify-between mt-4')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$h2,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('font-bold text-lg text-black'),
															$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(sale.fb)
														])),
													A2(
													$elm$html$Html$button,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('ml-4 self-start w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center hover:bg-gray-200'),
															($author$project$Page$Shop$Viewer$isAdmin(session) && $author$project$Page$Shop$Viewer$communityHasCategories(session)) ? $elm$html$Html$Events$onClick($author$project$Page$Shop$Viewer$ClickedOpenDetails) : $elm$html$Html$Events$onClick(
															$author$project$Page$Shop$Viewer$ClickedShareOffer(
																{bc: sale.bc, R: sale.R, fb: sale.fb}))
														]),
													_List_fromArray(
														[
															($author$project$Page$Shop$Viewer$isAdmin(session) && $author$project$Page$Shop$Viewer$communityHasCategories(session)) ? $author$project$Icons$ellipsis('text-orange-300') : $author$project$Icons$share('text-orange-300')
														]))
												])),
											A2(
											$author$project$Markdown$view,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('mt-2 mb-4 text-gray-333')
												]),
											sale.bc),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('flex flex-wrap gap-2'),
													$elm$html$Html$Attributes$classList(
													_List_fromArray(
														[
															_Utils_Tuple2(
															'mb-6',
															!$elm$core$List$isEmpty(categories)),
															_Utils_Tuple2(
															'mb-2',
															$elm$core$List$isEmpty(categories))
														]))
												]),
											A2(
												$elm$core$List$map,
												function (category) {
													return A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('bg-gray-100 px-2 py-1 text-black font-bold text-sm uppercase')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(category.ki)
															]));
												},
												categories)),
											isCreator ? $elm$html$Html$text('') : A3(
											$author$project$Page$Shop$Viewer$viewContactTheSeller,
											translators,
											{jU: isGuest},
											sale.mq)
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('bg-gray-100 px-4 pt-6 pb-4 w-full rounded-lg md:p-0 md:w-2/3 md:mx-auto md:place-self-start')
										]),
									_List_fromArray(
										[formView]))
								])),
							A3(
							$author$project$Page$Shop$Viewer$viewDetailsModal,
							session,
							{bc: sale.bc, R: sale.R, fb: sale.fb},
							model),
							(!shared.iW) ? A2(
							$author$project$Form$Text$view,
							A2(
								$author$project$Form$Text$withInputElement,
								$author$project$Form$Text$TextareaInput(
									{pn: false}),
								A2(
									$author$project$Form$Text$withContainerAttrs,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('mb-0 overflow-hidden')
										]),
									A2(
										$author$project$Form$Text$withExtraAttrs,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('sr-only'),
												$elm$html$Html$Attributes$tabindex(-1),
												$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
											]),
										$author$project$Form$Text$init(
											{R: 'share-fallback-input', nC: ''})))),
							{
								mM: $elm$html$Html$text(''),
								m$: false,
								nx: false,
								od: $author$project$Page$Shop$Viewer$NoOp,
								oe: function (_v8) {
									return $author$project$Page$Shop$Viewer$NoOp;
								},
								iw: shared.iw,
								pO: $elm$url$Url$toString(
									A2(
										$author$project$Route$addRouteToUrl,
										shared,
										$author$project$Route$ViewSale(sale.R)))
							}) : $elm$html$Html$text('')
						]));
			});
		var content = function () {
			var _v0 = _Utils_Tuple2(model.gE, session);
			_v0$2:
			while (true) {
				if (!_v0.a.$) {
					if (!_v0.b.$) {
						var model_ = _v0.a.a;
						var guest = _v0.b.a;
						var _v1 = model_.dN;
						switch (_v1.$) {
							case 3:
								var sale = _v1.a;
								return A3(
									viewContent,
									sale,
									_List_Nil,
									A2(
										$elm$html$Html$map,
										$author$project$Page$Shop$Viewer$AsGuestMsg,
										A6(
											$author$project$Form$viewWithoutSubmit,
											_List_Nil,
											guest.aM.iw,
											function (_v2) {
												return _List_fromArray(
													[
														A2(
														$elm$html$Html$a,
														_List_fromArray(
															[
																$author$project$Route$href(
																$author$project$Route$Join(
																	$elm$core$Maybe$Just(
																		$author$project$Route$ViewSale(sale.R)))),
																$elm$html$Html$Attributes$class('button button-primary w-full')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(
																t('shop.buy'))
															]))
													]);
											},
											A5(
												$author$project$Page$Shop$Viewer$createForm,
												guest.aM.iw,
												{h3: sale.h3, ig: $author$project$Shop$NoTracking, e9: sale.e9},
												$elm$core$Maybe$Nothing,
												{g4: $elm$core$Maybe$Nothing, ns: false},
												$author$project$Page$Shop$Viewer$GotFormInteractionMsgAsGuest),
											model_.hk,
											{pA: $author$project$Page$Shop$Viewer$GotFormMsgAsGuest})));
							case 2:
								var err = _v1.a;
								return A2(
									$author$project$Page$fullPageGraphQLError,
									t('shop.title'),
									err);
							case 1:
								return $author$project$Page$fullPageLoading(guest.aM);
							default:
								return $author$project$Page$fullPageLoading(guest.aM);
						}
					} else {
						break _v0$2;
					}
				} else {
					if (_v0.b.$ === 1) {
						var model_ = _v0.a.a;
						var loggedIn = _v0.b.a;
						var _v3 = A2(
							$author$project$Community$getField,
							loggedIn.o7,
							function ($) {
								return $.e1;
							});
						switch (_v3.$) {
							case 1:
								return $author$project$Page$fullPageLoading(loggedIn.aM);
							case 0:
								return $author$project$Page$fullPageLoading(loggedIn.aM);
							case 2:
								var fieldError = _v3.a;
								if (!fieldError.$) {
									var err = fieldError.a;
									return A2(
										$author$project$Page$fullPageGraphQLError,
										t('community.error_loading'),
										err);
								} else {
									var err = fieldError.a;
									return A2(
										$author$project$Page$fullPageGraphQLError,
										t('community.error_loading'),
										err);
								}
							default:
								var _v5 = _v3.a;
								var community = _v5.a;
								var shopCategories = _v5.b;
								if (!community.cm) {
									return A2(
										$author$project$Page$fullPageNotFound,
										t('error.pageNotFound'),
										t('shop.disabled.description'));
								} else {
									var _v6 = model_.gE;
									switch (_v6.$) {
										case 1:
											return A2(
												$elm$html$Html$div,
												_List_Nil,
												_List_fromArray(
													[
														A2($author$project$Page$viewHeader, loggedIn, ''),
														$author$project$Page$fullPageLoading(loggedIn.aM)
													]));
										case 0:
											return A2(
												$elm$html$Html$div,
												_List_Nil,
												_List_fromArray(
													[
														A2($author$project$Page$viewHeader, loggedIn, ''),
														$author$project$Page$fullPageLoading(loggedIn.aM)
													]));
										case 2:
											var e = _v6.a;
											return A2(
												$author$project$Page$fullPageGraphQLError,
												t('shop.title'),
												e);
										default:
											var sale = _v6.a;
											var maybeBalance = A2(
												$elm_community$list_extra$List$Extra$find,
												function (bal) {
													return _Utils_eq(bal.lY.e9, sale.e9);
												},
												model_.gV);
											var isOwner = _Utils_eq(sale.mq.fl, loggedIn.lM);
											var isOutOfStock = $author$project$Shop$isOutOfStock(sale);
											var isDisabled = isOwner || isOutOfStock;
											return A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('flex-grow flex flex-col')
													]),
												_List_fromArray(
													[
														A2($author$project$Page$viewHeader, loggedIn, sale.fb),
														A3(
														viewContent,
														sale,
														sale.cX,
														A2(
															$elm$html$Html$map,
															$author$project$Page$Shop$Viewer$AsLoggedInMsg,
															A6(
																$author$project$Form$view,
																_List_Nil,
																loggedIn.aM.iw,
																function (submitButton) {
																	return _List_fromArray(
																		[
																			isOwner ? A2(
																			$elm$html$Html$button,
																			_List_fromArray(
																				[
																					$elm$html$Html$Attributes$class('button button-primary w-full'),
																					$elm$html$Html$Attributes$disabled(!loggedIn.mZ),
																					$elm$html$Html$Events$onClick($author$project$Page$Shop$Viewer$ClickedEditSale),
																					$elm$html$Html$Attributes$type_('button')
																				]),
																			_List_fromArray(
																				[
																					$elm$html$Html$text(
																					t('shop.edit'))
																				])) : A2(
																			submitButton,
																			_List_fromArray(
																				[
																					$elm$html$Html$Attributes$class('button button-primary w-full'),
																					$elm$html$Html$Attributes$disabled(isOutOfStock || (!loggedIn.mZ))
																				]),
																			_List_fromArray(
																				[
																					isOutOfStock ? $elm$html$Html$text(
																					t('shop.sold_out')) : $elm$html$Html$text(
																					t('shop.buy'))
																				]))
																		]);
																},
																A5(
																	$author$project$Page$Shop$Viewer$createForm,
																	loggedIn.aM.iw,
																	sale,
																	maybeBalance,
																	{g4: community.nT, ns: isDisabled},
																	$author$project$Page$Shop$Viewer$GotFormInteractionMsg),
																A2($author$project$Form$withDisabled, isDisabled, model_.hk),
																{
																	oq: $author$project$Page$Shop$Viewer$ClickedTransfer(sale),
																	pA: $author$project$Page$Shop$Viewer$GotFormMsg
																}))),
														A2(
														$elm$html$Html$map,
														$author$project$Page$Shop$Viewer$AsLoggedInMsg,
														A4($author$project$Page$Shop$Viewer$viewEditSaleModal, translators, model_, shopCategories, sale)),
														A2(
														$elm$html$Html$map,
														$author$project$Page$Shop$Viewer$AsLoggedInMsg,
														A2($author$project$Page$Shop$Viewer$viewConfirmDeleteModal, translators, model_))
													]));
									}
								}
						}
					} else {
						break _v0$2;
					}
				}
			}
			return A2(
				$author$project$Page$fullPageError,
				t('shop.title'),
				$elm$http$Http$Timeout);
		}();
		return {mk: content, fb: title};
	});
var $author$project$Page$ViewTransfer$GotProfileSummaryMsg = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Eos$Explorer$Transfer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$ViewTransfer$viewDetail = F3(
	function (containerAttrs, title, content) {
		return A2(
			$elm$html$Html$div,
			containerAttrs,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('label')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(title)
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[content]))
				]));
	});
var $author$project$Profile$Summary$withNameBg = F2(
	function (showNameTagBg, model) {
		return _Utils_update(
			model,
			{gA: showNameTagBg});
	});
var $author$project$Profile$Summary$withoutYouLabel = function (model) {
	return _Utils_update(
		model,
		{gB: false});
};
var $author$project$Page$ViewTransfer$viewTransferCard = F6(
	function (loggedIn, transfer, transferDirection, profileSummaries, profileSummaryToMsg, attrs) {
		var _v0 = loggedIn.aM.iw;
		var t = _v0.il;
		var _v1 = function () {
			if (!transferDirection) {
				return _Utils_Tuple3(transfer.fc, transfer.ew, 'rotate-90');
			} else {
				return _Utils_Tuple3(transfer.ew, transfer.fc, '-rotate-90');
			}
		}();
		var leftProfile = _v1.a;
		var rightProfile = _v1.b;
		var rotateClass = _v1.c;
		var viewSummary = F2(
			function (profile, summary) {
				return A2(
					$elm$html$Html$map,
					profileSummaryToMsg(
						_Utils_eq(profile, leftProfile)),
					A4(
						$author$project$Profile$Summary$view,
						loggedIn.aM.iw,
						loggedIn.lM,
						profile,
						A2(
							$author$project$Profile$Summary$withRelativeSelector,
							'#content-container',
							$author$project$Profile$Summary$withoutYouLabel(
								A2($author$project$Profile$Summary$withNameBg, false, summary)))));
			});
		var arrowClass = 'fill-current text-black ' + rotateClass;
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('flex justify-between'),
				attrs),
			_List_fromArray(
				[
					A2(viewSummary, leftProfile, profileSummaries.j1),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex mt-2 space-x-2 justify-self-center')
						]),
					_List_fromArray(
						[
							$author$project$Icons$arrowDown(arrowClass),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex flex-col px-2 font-bold')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-black text-sm uppercase')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											function () {
												if (!transferDirection) {
													return t('transfer_result.received');
												} else {
													return t('transfer_result.transferred');
												}
											}())
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-green')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$author$project$Eos$assetToString,
												loggedIn.aM.iw,
												{lU: transfer.pO, e9: transfer.b9.e9}))
										]))
								])),
							$author$project$Icons$arrowDown(arrowClass)
						])),
					A2(viewSummary, rightProfile, profileSummaries.k_)
				]));
	});
var $author$project$Page$ViewTransfer$viewDetails = F4(
	function (loggedIn, transfer, profileSummaries, direction) {
		var shared = loggedIn.aM;
		var t = function (str) {
			return $elm$core$String$toUpper(
				shared.iw.il(str));
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bg-white pt-6 pb-10 lg:pt-0 lg:pb-0 lg:w-2/3 lg:mx-auto lg:self-center')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('container mx-auto px-4 lg:mx-0 lg:px-0 lg:max-w-none')
						]),
					_List_fromArray(
						[
							A6(
							$author$project$Page$ViewTransfer$viewTransferCard,
							loggedIn,
							transfer,
							direction,
							profileSummaries,
							$author$project$Page$ViewTransfer$GotProfileSummaryMsg,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pb-6 border-b border-gray-500')
								])),
							A3(
							$author$project$Page$ViewTransfer$viewDetail,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mt-6')
								]),
							t('transfer_result.date'),
							A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										A4(
										$author$project$View$Components$dateViewer,
										_List_Nil,
										$elm$core$Basics$identity,
										shared,
										$author$project$Utils$fromDateTime(transfer.fu)),
										A4(
										$author$project$View$Components$dateViewer,
										_List_Nil,
										function (translations) {
											return _Utils_update(
												translations,
												{
													ow: '',
													pB: $elm$core$Maybe$Just(', {{date}}'),
													pY: $elm$core$Maybe$Just(', {{date}}')
												});
										},
										shared,
										$author$project$Utils$fromDateTime(transfer.fu))
									]))),
							function () {
							var _v0 = transfer.ka;
							if (_v0.$ === 1) {
								return $elm$html$Html$text('');
							} else {
								var memo = _v0.a;
								return _Utils_eq(memo, $author$project$Markdown$empty) ? $elm$html$Html$text('') : A3(
									$author$project$Page$ViewTransfer$viewDetail,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('mt-6')
										]),
									t('transfer_result.message'),
									A2($author$project$Markdown$view, _List_Nil, memo));
							}
						}(),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('button button-primary w-full mt-6'),
									$elm$html$Html$Attributes$href(
									A2(
										$author$project$Eos$Explorer$link,
										shared.mK,
										$author$project$Eos$Explorer$Transfer(transfer.mp))),
									$elm$html$Html$Attributes$target('_blank')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('block_explorer.see'))
								])),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('button button-secondary w-full mt-4'),
									$author$project$Route$href($author$project$Route$Dashboard)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('transfer_result.my_balance'))
								]))
						]))
				]));
	});
var $author$project$Page$ViewTransfer$viewTransfer = F3(
	function (loggedIn, transfer, direction) {
		var t = loggedIn.aM.iw.il;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('isolate text-white text-center bg-purple-500 pt-4 pb-6 lg:pb-0 lg:pt-0 lg:w-2/3 lg:mx-auto')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('container mx-auto px-4 lg:mx-0 lg:px-0 lg:max-w-none')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('h-64 w-full'),
									$elm$html$Html$Attributes$src('/images/transfer-doggo.svg'),
									$elm$html$Html$Attributes$alt('')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$h2,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('font-bold text-xl mt-7 mb-4')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									function () {
										if (direction === 1) {
											return t('transfer_result.transfer_success');
										} else {
											return t('transfer_result.receive_success');
										}
									}())
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('transfer_result.transaction_id.body'))
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-xl md:text-2xl mt-4')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Emoji$encode(transfer.mp))
								]))
						]))
				]));
	});
var $author$project$Page$ViewTransfer$view = F2(
	function (loggedIn, model) {
		var _v0 = loggedIn.aM.iw;
		var t = _v0.il;
		var content = function () {
			var _v3 = model.gE;
			switch (_v3.$) {
				case 0:
					return $author$project$Page$fullPageLoading(loggedIn.aM);
				case 1:
					var error = _v3.a;
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Page$viewHeader,
								loggedIn,
								t('transfer_result.title')),
								A2(
								$author$project$Page$fullPageGraphQLError,
								t('transfer_result.title'),
								error)
							]));
				default:
					var maybeTransfer = _v3.a;
					var direction = _v3.b;
					var profileSummaries = _v3.c;
					if (!maybeTransfer.$) {
						var transfer = maybeTransfer.a;
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex-grow flex flex-col')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Page$viewHeader,
									loggedIn,
									t('transfer_result.title')),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('relative flex-grow flex items-center')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('bg-purple-500 absolute top-0 bottom-0 left-0 right-1/2 hidden lg:block')
												]),
											_List_Nil),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('bg-white absolute top-0 bottom-0 left-1/2 right-0 hidden lg:block')
												]),
											_List_Nil),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('relative flex-grow grid grid-cols-1 mb-10 lg:container lg:mx-auto lg:px-4 lg:grid-cols-2 lg:py-10 lg:mb-0'),
													$elm$html$Html$Attributes$id('content-container')
												]),
											_List_fromArray(
												[
													A3($author$project$Page$ViewTransfer$viewTransfer, loggedIn, transfer, direction),
													A4($author$project$Page$ViewTransfer$viewDetails, loggedIn, transfer, profileSummaries, direction)
												]))
										]))
								]));
					} else {
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('container mx-auto px-4')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Could not load the transfer')
										]))
								]));
					}
			}
		}();
		var title = function () {
			var _v1 = model.gE;
			if (_v1.$ === 2) {
				var maybeTransfer = _v1.a;
				if (!maybeTransfer.$) {
					return t('transfer_result.title');
				} else {
					return '';
				}
			} else {
				return '';
			}
		}();
		return {mk: content, fb: title};
	});
var $author$project$Session$Guest$ClickedTryAgainTranslation = {$: 1};
var $author$project$Session$Guest$GotFeedbackMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Session$Guest$loginLeftCol = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('hidden md:block md:visible md:w-2/5 h-screen sticky top-0 bg-bottom bg-no-repeat'),
			A2($elm$html$Html$Attributes$style, 'background-color', '#EFF9FB'),
			A2($elm$html$Html$Attributes$style, 'background-size', 'auto 80%'),
			A2($elm$html$Html$Attributes$style, 'background-image', 'url(/images/auth_bg_full.png)')
		]),
	_List_Nil);
var $author$project$Session$Shared$translationStatus = function (shared) {
	return shared.bq;
};
var $author$project$View$Feedback$ClickedClose = 0;
var $author$project$View$Feedback$view = function (model) {
	if (!model.$) {
		return $elm$html$Html$text('');
	} else {
		var status = model.a;
		var content = model.b;
		var bgColor = function () {
			if (!status) {
				return 'bg-green';
			} else {
				return 'bg-red';
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('w-full sticky top-0 text-white py-2 grid grid-cols-10 z-40 ' + bgColor),
					$fapian$elm_html_aria$Html$Attributes$Aria$role('alert')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-center text-white font-bold col-start-2 col-end-10')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(content)
						])),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('ml-auto mr-6 cursor-pointer'),
							$elm$html$Html$Events$onClick(0)
						]),
					_List_fromArray(
						[
							$author$project$Icons$close('fill-current text-white w-4 h-4')
						]))
				]));
	}
};
var $author$project$Session$Shared$viewFullError = F4(
	function (shared, _v0, msg, msgText) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('full-page-loading full-spinner-container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(msgText)
						])),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(msg)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$I18Next$t, shared.fi, 'menu.try_again'))
						]))
				]));
	});
var $author$project$Session$Shared$viewFullLoading = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('full-page-loading full-spinner-container')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('spinner')
				]),
			_List_Nil)
		]));
var $author$project$Session$Guest$ClickedLanguage = function (a) {
	return {$: 3, a: a};
};
var $author$project$Session$Guest$ShowLanguageNav = function (a) {
	return {$: 2, a: a};
};
var $elm$html$Html$header = _VirtualDom_node('header');
var $author$project$Session$Shared$langFlag = F2(
	function (attrs, language) {
		var iconLink = function () {
			switch (language) {
				case 0:
					return '/icons/flag-usa.svg';
				case 1:
					return '/icons/flag-brazil.svg';
				case 2:
					return '/icons/flag-spain.svg';
				case 3:
					return '/icons/flag-catalan.svg';
				default:
					return '/icons/flag-ethiopia.svg';
			}
		}();
		return A2(
			$elm$html$Html$img,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('object-cover rounded-full'),
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$src(iconLink),
					attrs)),
			_List_Nil);
	});
var $author$project$Translation$languageToLanguageCode = function (language) {
	switch (language) {
		case 0:
			return 'en-US';
		case 1:
			return 'pt-br';
		case 2:
			return 'es';
		case 3:
			return 'cat';
		default:
			return 'amh';
	}
};
var $author$project$Translation$allLanguages = _List_fromArray(
	[0, 1, 2, 3, 4]);
var $author$project$Session$Shared$viewLanguageItems = F3(
	function (_v0, shared, toMsg) {
		var containerAttrs = _v0.mg;
		var flagIconAttrs = _v0.mV;
		return A2(
			$elm$core$List$map,
			function (lang) {
				return A2(
					$elm$html$Html$button,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Events$onClick(
							toMsg(lang)),
						containerAttrs),
					_List_fromArray(
						[
							A2($author$project$Session$Shared$langFlag, flagIconAttrs, lang),
							$elm$html$Html$text(
							$author$project$Translation$languageToLanguageCode(lang))
						]));
			},
			A2(
				$elm$core$List$sortBy,
				$author$project$Translation$languageToLocale,
				A2(
					$elm$core$List$filter,
					function (l) {
						return !_Utils_eq(l, shared.hy);
					},
					$author$project$Translation$allLanguages)));
	});
var $author$project$Session$Guest$viewPageHeader = F2(
	function (model, shared) {
		var logo = function () {
			var _v0 = model.b9;
			switch (_v0.$) {
				case 1:
					return '';
				case 0:
					return '';
				case 3:
					var comm = _v0.a;
					return comm.hC;
				default:
					return shared.hC;
			}
		}();
		return A2(
			$elm$html$Html$header,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex items-center justify-between pl-4 py-4 md:pl-6 bg-white')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$author$project$Route$href(
							A2($author$project$Route$Login, model.j8, model.lS))
						]),
					_List_fromArray(
						[
							$elm$core$String$isEmpty(logo) ? $elm$html$Html$text('') : A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('h-10'),
									$elm$html$Html$Attributes$src(logo)
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('relative z-50')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('button'),
									$elm$html$Html$Attributes$tabindex(-1),
									$elm$html$Html$Attributes$class('flex block relative z-20 items-center px-4 py-2 bg-white text-sm focus:outline-none'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('rounded-tr-lg rounded-tl-lg justify-between lang-menu-open', model.a8)
										])),
									$elm$html$Html$Events$onClick(
									$author$project$Session$Guest$ShowLanguageNav(!model.a8)),
									$elm$html$Html$Events$onMouseEnter(
									$author$project$Session$Guest$ShowLanguageNav(true))
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Session$Shared$langFlag,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('w-6 h-6 mr-2')
										]),
									shared.hy),
									model.a8 ? A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('flex-grow whitespace-nowrap uppercase')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Translation$languageToLanguageCode(model.aM.hy))
										])) : $elm$html$Html$text(''),
									$author$project$Icons$arrowDown('flex-none')
								])),
							model.a8 ? A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fixed h-full w-full inset-0 bg-black opacity-50 cursor-default'),
									$elm$html$Html$Events$onClick(
									$author$project$Session$Guest$ShowLanguageNav(false)),
									$elm$html$Html$Events$onMouseEnter(
									$author$project$Session$Guest$ShowLanguageNav(false))
								]),
							_List_Nil) : $elm$html$Html$text(''),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('absolute right-0 w-full py-2 bg-white border-t rounded-br-lg rounded-bl-lg shadow-lg'),
									$elm$html$Html$Attributes$class('lang-menu-open'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('hidden', !model.a8)
										]))
								]),
							A3(
								$author$project$Session$Shared$viewLanguageItems,
								{
									mg: _List_fromArray(
										[
											$elm$html$Html$Attributes$class('flex w-full px-4 py-2 text-gray items-center text-sm uppercase focus-ring rounded-sm hover:text-indigo-500 focus-visible:text-indigo-500')
										]),
									mV: _List_fromArray(
										[
											$elm$html$Html$Attributes$class('w-6 h-6 mr-2')
										])
								},
								shared,
								$author$project$Session$Guest$ClickedLanguage))
						]))
				]));
	});
var $author$project$Session$Guest$view = F4(
	function (thisMsg, page, model, content) {
		var shared = model.aM;
		var _v0 = function () {
			switch (page) {
				case 5:
					return _Utils_Tuple2(
						$elm$core$Maybe$Just($author$project$Session$Guest$loginLeftCol),
						'md:w-3/5');
				case 4:
					return _Utils_Tuple2(
						$elm$core$Maybe$Just($author$project$Session$Guest$loginLeftCol),
						'md:w-3/5');
				case 6:
					return _Utils_Tuple2($elm$core$Maybe$Nothing, 'md:w-full');
				case 7:
					return A2(
						$elm$core$Maybe$withDefault,
						_Utils_Tuple2($elm$core$Maybe$Nothing, 'md:w-full'),
						A2(
							$elm$core$Maybe$map,
							function (community) {
								return _Utils_Tuple2(
									$elm$core$Maybe$Just(
										A3($author$project$Community$communityPreviewImage, true, model.aM, community)),
									'md:w-1/2');
							},
							$krisajenkins$remotedata$RemoteData$toMaybe(model.b9)));
				case 8:
					return _Utils_Tuple2($elm$core$Maybe$Nothing, 'md:w-full');
				case 0:
					return _Utils_Tuple2($elm$core$Maybe$Nothing, 'md:w-full');
				case 1:
					return _Utils_Tuple2($elm$core$Maybe$Nothing, 'md:w-full');
				case 2:
					return _Utils_Tuple2($elm$core$Maybe$Nothing, 'md:w-full');
				default:
					return _Utils_Tuple2($elm$core$Maybe$Nothing, 'md:w-full');
			}
		}();
		var maybeLeftArt = _v0.a;
		var rightColWidth = _v0.b;
		var _v2 = $author$project$Session$Shared$translationStatus(shared);
		switch (_v2.$) {
			case 0:
				return $author$project$Session$Shared$viewFullLoading;
			case 1:
				var err = _v2.a;
				return A2(
					$elm$html$Html$map,
					thisMsg,
					A4($author$project$Session$Shared$viewFullError, shared, err, $author$project$Session$Guest$ClickedTryAgainTranslation, 'An error occurred while loading translation.'));
			default:
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('md:flex')
						]),
					_List_fromArray(
						[
							function () {
							if (!maybeLeftArt.$) {
								var leftArt = maybeLeftArt.a;
								return leftArt;
							} else {
								return $elm$html$Html$text('');
							}
						}(),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('min-h-screen flex flex-col'),
									$elm$html$Html$Attributes$class(rightColWidth)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									thisMsg,
									A2($author$project$Session$Guest$viewPageHeader, model, shared)),
									A2(
									$elm$html$Html$map,
									A2($elm$core$Basics$composeR, $author$project$Session$Guest$GotFeedbackMsg, thisMsg),
									$author$project$View$Feedback$view(model.hf)),
									content
								]))
						]));
		}
	});
var $author$project$Page$viewGuest = F4(
	function (thisMsg, page, model, content) {
		return A4(
			$author$project$Session$Guest$view,
			A2($elm$core$Basics$composeL, thisMsg, $author$project$Page$GotGuestMsg),
			page,
			model,
			content);
	});
var $author$project$Auth$view = F2(
	function (shared, model) {
		var _v0 = shared.iw;
		var t = _v0.il;
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-sm')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						t('auth.login.enterPinToContinue'))
					])),
				A2(
				$elm$html$Html$map,
				$author$project$Auth$GotPinMsg,
				A2($author$project$View$Pin$view, shared.iw, model.ag))
			]);
	});
var $author$project$Session$LoggedIn$viewAuthModal = F2(
	function (pageMsg, model) {
		var shared = model.aM;
		return A2(
			$elm$html$Html$map,
			pageMsg,
			$author$project$View$Modal$toHtml(
				A2(
					$author$project$View$Modal$withBody,
					A2(
						$elm$core$List$map,
						$elm$html$Html$map($author$project$Session$LoggedIn$GotAuthMsg),
						A2($author$project$Auth$view, shared, model.fp)),
					A2(
						$author$project$View$Modal$withHeader,
						shared.iw.il('auth.login.modalFormTitle'),
						$author$project$View$Modal$initWith(
							{i$: $author$project$Session$LoggedIn$ClosedAuthModal, jW: model.dV})))));
	});
var $author$project$Session$Shared$viewFullGraphqlError = F4(
	function (shared, _v0, msg, msgText) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('full-page-loading full-spinner-container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(msgText)
						])),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(msg)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$I18Next$t, shared.fi, 'menu.try_again'))
						]))
				]));
	});
var $author$project$Session$LoggedIn$codeOfConductVersion = '1.0';
var $author$project$Session$LoggedIn$codeOfConductModal = function (model) {
	var needsToWaitBeforeDenyingAgain = function () {
		var _v3 = model.T;
		if (_v3.$ === 2) {
			var hasCompletedAnimation = _v3.a.fU;
			return !hasCompletedAnimation;
		} else {
			return false;
		}
	}();
	var _v0 = model.aM.iw;
	var t = _v0.il;
	var tr = _v0.iu;
	return $author$project$View$Modal$toHtml(
		A2(
			$author$project$View$Modal$withFooter,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('w-full grid gap-4 md:grid-cols-2')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick($author$project$Session$LoggedIn$ClickedAcceptCodeOfConduct),
									$elm$html$Html$Attributes$class('button button-primary w-full')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('terms_of_conduct.accept'))
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick($author$project$Session$LoggedIn$ClickedDenyCodeOfConduct),
									$elm$html$Html$Attributes$class('button button-secondary !bg-white w-full relative overflow-hidden'),
									$elm$html$Html$Attributes$disabled(needsToWaitBeforeDenyingAgain)
								]),
							_List_fromArray(
								[
									function () {
									var _v2 = model.T;
									if (_v2.$ === 2) {
										return A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('absolute top-0 left-0 bottom-0 bg-gray-500 w-full origin-left animate-scale-down'),
													A2(
													$elm$html$Html$Events$on,
													'animationend',
													$elm$json$Json$Decode$succeed($author$project$Session$LoggedIn$EndedCodeOfConductWarningAnimation))
												]),
											_List_Nil);
									} else {
										return $elm$html$Html$text('');
									}
								}(),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('z-10')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											t('terms_of_conduct.deny'))
										]))
								]))
						]))
				]),
			A2(
				$author$project$View$Modal$withBody,
				function () {
					var _v1 = model.T;
					switch (_v1.$) {
						case 0:
							return _List_Nil;
						case 1:
							return _List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('mt-4')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											t('terms_of_conduct.description'))
										])),
									A2($elm$html$Html$br, _List_Nil, _List_Nil),
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											t('terms_of_conduct.to_have_good_experience'))
										])),
									A2($elm$html$Html$br, _List_Nil, _List_Nil),
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('mb-6')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$a,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$href(
													$author$project$Session$LoggedIn$codeOfConductUrl(model.aM.hy)),
													$elm$html$Html$Attributes$target('_blank'),
													$elm$html$Html$Attributes$class('text-orange-300 hover:underline focus-visible:underline focus-visible:outline-none rounded-sm')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													A2(
														tr,
														'terms_of_conduct.link',
														_List_fromArray(
															[
																_Utils_Tuple2('version', $author$project$Session$LoggedIn$codeOfConductVersion)
															])))
												]))
										]))
								]);
						default:
							return _List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-red mt-4')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$strong,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('uppercase')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													t('terms_of_conduct.attention'))
												])),
											$elm$html$Html$text(
											t('terms_of_conduct.not_accepting'))
										])),
									A2($elm$html$Html$br, _List_Nil, _List_Nil),
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												tr,
												'terms_of_conduct.to_participate',
												_List_fromArray(
													[
														_Utils_Tuple2('version', $author$project$Session$LoggedIn$codeOfConductVersion)
													])))
										])),
									A2($elm$html$Html$br, _List_Nil, _List_Nil),
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											t('terms_of_conduct.are_you_sure'))
										])),
									A2($elm$html$Html$br, _List_Nil, _List_Nil),
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('mb-6')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$a,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$href(
													$author$project$Session$LoggedIn$codeOfConductUrl(model.aM.hy)),
													$elm$html$Html$Attributes$target('_blank'),
													$elm$html$Html$Attributes$class('text-orange-300 hover:underline')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													A2(
														tr,
														'terms_of_conduct.link',
														_List_fromArray(
															[
																_Utils_Tuple2('version', $author$project$Session$LoggedIn$codeOfConductVersion)
															])))
												]))
										]))
								]);
					}
				}(),
				A2(
					$author$project$View$Modal$withHeader,
					A2(
						tr,
						'terms_of_conduct.title',
						_List_fromArray(
							[
								_Utils_Tuple2('version', $author$project$Session$LoggedIn$codeOfConductVersion)
							])),
					$author$project$View$Modal$initWith(
						{
							i$: $author$project$Session$LoggedIn$ClickedDenyCodeOfConduct,
							jW: !_Utils_eq(model.T, $author$project$Session$LoggedIn$CodeOfConductNotShown)
						})))));
};
var $author$project$Session$LoggedIn$communitySelectorModal = function (model) {
	var viewCommunityItem = function (c) {
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('w-full flex items-center p-3 m-1 text-body rounded-sm hover:text-black hover:bg-gray-100 focus:outline-none focus:ring'),
							$elm$html$Html$Events$onClick(
							$author$project$Session$LoggedIn$SelectedCommunity(c))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$src(c.hC),
									$elm$html$Html$Attributes$class('h-16 w-16 mr-5 object-scale-down')
								]),
							_List_Nil),
							$elm$html$Html$text(c.ki)
						]))
				]));
	};
	var t = function (s) {
		return model.aM.iw.il(s);
	};
	var text_ = function (s) {
		return $elm$html$Html$text(
			t(s));
	};
	if (model.bS) {
		var _v0 = model.kJ;
		if (_v0.$ === 3) {
			var pro = _v0.a;
			return $elm$core$List$isEmpty(pro.ei) ? $elm$html$Html$text('') : $author$project$View$Modal$toHtml(
				A2(
					$author$project$View$Modal$withBody,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									text_('menu.community_selector.body')
								])),
							A2(
							$elm$html$Html$ul,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('w-full flex flex-col overflow-y-auto divide-y divide-gray-300')
								]),
							A2($elm$core$List$map, viewCommunityItem, pro.ei))
						]),
					A2(
						$author$project$View$Modal$withHeader,
						t('menu.community_selector.title'),
						$author$project$View$Modal$initWith(
							{i$: $author$project$Session$LoggedIn$CloseCommunitySelector, jW: true}))));
		} else {
			return $elm$html$Html$text('');
		}
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Session$LoggedIn$isCommunityMember = function (model) {
	var _v0 = _Utils_Tuple2(
		$author$project$Session$LoggedIn$profile(model),
		model.o7);
	_v0$2:
	while (true) {
		if (!_v0.a.$) {
			if (_v0.b.$ === 3) {
				var profile_ = _v0.a.a;
				var community = _v0.b.a;
				return A2(
					$elm$core$List$any,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.e9;
						},
						$elm$core$Basics$eq(community.e9)),
					profile_.ei) || A2(
					$elm$core$List$any,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.fl;
						},
						$elm$core$Basics$eq(profile_.fl)),
					community.hG);
			} else {
				break _v0$2;
			}
		} else {
			if (_v0.b.$ === 3) {
				var _v1 = _v0.a;
				var community = _v0.b.a;
				return A2(
					$elm$core$List$any,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.fl;
						},
						$elm$core$Basics$eq(model.lM)),
					community.hG);
			} else {
				break _v0$2;
			}
		}
	}
	return false;
};
var $author$project$Session$LoggedIn$hideCommunityAndSearch = F2(
	function (currentPage, model) {
		var hiddenPages = _List_fromArray(
			[$author$project$Session$LoggedIn$CommunitySelector]);
		return A2($elm$core$List$member, currentPage, hiddenPages) || (!$author$project$Session$LoggedIn$isCommunityMember(model));
	});
var $author$project$Session$LoggedIn$insufficientPermissionsModal = function (model) {
	var _v0 = model.aM.iw;
	var t = _v0.il;
	return $author$project$View$Modal$toHtml(
		A2(
			$author$project$View$Modal$withSize,
			0,
			A2(
				$author$project$View$Modal$withFooter,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('button button-primary w-full mt-2'),
								$elm$html$Html$Events$onClick($author$project$Session$LoggedIn$ClosedInsufficientPermissionsModal)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								t('permissions.insufficient.ok'))
							]))
					]),
				A2(
					$author$project$View$Modal$withBody,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$src('/images/girl-with-ice-cube.svg'),
									$elm$html$Html$Attributes$alt(''),
									$elm$html$Html$Attributes$class('mx-auto mt-4 mb-6')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('md:max-w-md md:mx-auto md:text-center')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('permissions.insufficient.explanation'))
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('my-4 md:max-w-md md:mx-auto md:text-center')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('permissions.insufficient.try_again'))
								]))
						]),
					A2(
						$author$project$View$Modal$withHeader,
						t('permissions.insufficient.title'),
						$author$project$View$Modal$initWith(
							{i$: $author$project$Session$LoggedIn$ClosedInsufficientPermissionsModal, jW: model.bo}))))));
};
var $author$project$Search$isActive = function (model) {
	var _v0 = model.X;
	if (!_v0.$) {
		return false;
	} else {
		return true;
	}
};
var $author$project$Session$LoggedIn$viewCommunityContactsModal = function (model) {
	var _v0 = model.o7;
	if (_v0.$ === 3) {
		var community = _v0.a;
		var _v1 = model.aM.iw;
		var t = _v1.il;
		return $author$project$View$Modal$toHtml(
			A2(
				$author$project$View$Modal$withBody,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								t('footer.choose_contact'))
							])),
						A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex flex-wrap gap-6 items-start justify-center mt-6 mb-10')
							]),
						A2(
							$elm$core$List$map,
							function (contact) {
								return A2(
									$elm$html$Html$li,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('w-10')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$a,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('flex flex-col items-center hover:opacity-60'),
													$elm$html$Html$Attributes$href(
													$author$project$Contact$toHref(contact)),
													$elm$html$Html$Attributes$target('blank'),
													$elm$html$Html$Attributes$title(
													A2($author$project$Contact$toLabel, model.aM.iw, contact)),
													$elm$html$Html$Events$onClick($author$project$Session$LoggedIn$ClosedCommunityContactsModal)
												]),
											_List_fromArray(
												[
													A3(
													$author$project$Contact$circularIconWithGrayBg,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('w-10 h-10')
														]),
													model.aM.iw,
													contact),
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('text-gray-900 text-sm text-center mt-2 font-semibold line-clamp-2')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															A2($author$project$Contact$toLabel, model.aM.iw, contact))
														]))
												]))
										]));
							},
							community.aq))
					]),
				A2(
					$author$project$View$Modal$withHeader,
					t('footer.need_help'),
					$author$project$View$Modal$initWith(
						{i$: $author$project$Session$LoggedIn$ClosedCommunityContactsModal, jW: model.bR}))));
	} else {
		return $elm$html$Html$text('');
	}
};
var $elm$html$Html$footer = _VirtualDom_node('footer');
var $author$project$Icons$heartSolid = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('49'),
				$elm$svg$Svg$Attributes$height('32'),
				$elm$svg$Svg$Attributes$viewBox('0 0 49 32'),
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M24.4692 27.1195C24.4692 27.1195 12.3218 19.4394 12.3218 10.6168C12.3218 7.20833 14.4914 4.9043 17.8298 4.9043C21.1681 4.9043 24.1335 9.34734 24.7552 9.34734C25.3768 9.34734 28.2552 4.9043 31.5935 4.9043C34.9319 4.9043 36.5669 7.20833 36.5669 10.6168C36.5918 19.3569 24.4692 27.1195 24.4692 27.1195Z'),
						$elm$svg$Svg$Attributes$fill('#DB1B1B')
					]),
				_List_Nil)
			]));
};
var $author$project$Session$LoggedIn$viewFooter = function (model) {
	var shared = model.aM;
	var _v0 = shared.iw;
	var t = _v0.il;
	var tr = _v0.iu;
	var viewContactSupport = function () {
		var _v1 = model.o7;
		if (_v1.$ === 3) {
			var community = _v1.a;
			if ($elm$core$List$isEmpty(community.aq)) {
				return $elm$html$Html$text('');
			} else {
				var linkContainer = function (attrs) {
					var _v2 = community.aq;
					if (_v2.b && (!_v2.b.b)) {
						var contact = _v2.a;
						return $elm$html$Html$a(
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$href(
									$author$project$Contact$toHref(contact)),
								A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$target('blank'),
									attrs)));
					} else {
						return $elm$html$Html$button(
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Events$onClick($author$project$Session$LoggedIn$ClickedOpenCommunityContactsModal),
								attrs));
					}
				};
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('footer.need_help'))
								])),
							A2(
							linkContainer,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-orange-300 hover:underline text-left')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('footer.contact_support'))
								]))
						]));
			}
		} else {
			return $elm$html$Html$text('');
		}
	}();
	return A2(
		$elm$html$Html$footer,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('bg-white w-full border-t border-grey-500 relative overflow-hidden'),
				$fapian$elm_html_aria$Html$Attributes$Aria$role('contentinfo')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('container mx-auto px-4 pb-6 pt-12 flex flex-col lg:flex-row lg:py-4 lg:relative lg:overflow-hidden')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex flex-col lg:flex-row lg:items-center lg:flex-grow after:h-px after:w-1/4 after:mx-auto after:mt-12 after:bg-gray-500 lg:after:w-px lg:after:h-full lg:after:mr-8 lg:after:mt-0 lg:after:ml-auto')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('sr-only')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										t('footer.created_with_love'))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('flex items-center lg:flex-shrink-0')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-center flex justify-center items-center'),
												$fapian$elm_html_aria$Html$Attributes$Aria$ariaHidden(true)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(
														t('footer.created_with'))
													])),
												$author$project$Icons$heartSolid('w-7'),
												A2(
												$elm$html$Html$span,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(
														t('footer.created_by'))
													]))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('flex items-center ml-8')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$img,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('h-8'),
														$elm$html$Html$Attributes$src('/images/logo-cambiatus-mobile.svg'),
														$elm$html$Html$Attributes$alt('')
													]),
												_List_Nil),
												A2(
												$elm$html$Html$img,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('h-12 ml-8'),
														$elm$html$Html$Attributes$src('/images/satisfied-vagabonds.svg'),
														$elm$html$Html$Attributes$alt('')
													]),
												_List_Nil)
											]))
									])),
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$href(
										$author$project$Session$LoggedIn$codeOfConductUrl(shared.hy)),
										$elm$html$Html$Attributes$target('_blank'),
										$elm$html$Html$Attributes$class('text-orange-300 mt-6 hover:underline lg:mt-0 lg:ml-10 lg:mr-4')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2(
											tr,
											'terms_of_conduct.title',
											_List_fromArray(
												[
													_Utils_Tuple2('version', $author$project$Session$LoggedIn$codeOfConductVersion)
												])))
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('mt-4 lg:mt-0 lg:flex-shrink-0')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('mr-32 md:mr-20 lg:mr-52 md:pt-6')
									]),
								_List_fromArray(
									[
										viewContactSupport,
										A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-xs mt-6 text-gray-900')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												A2(
													tr,
													'footer.version',
													_List_fromArray(
														[
															_Utils_Tuple2(
															'version',
															$author$project$Version$toString(shared.lF))
														])))
											]))
									])),
								A2(
								$elm$html$Html$img,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$src('/images/man-with-envelope.svg'),
										$elm$html$Html$Attributes$alt(''),
										$elm$html$Html$Attributes$class('pointer-events-none absolute w-40 -bottom-12 -right-8 lg:right-4 md:-bottom-13 md:w-44')
									]),
								_List_Nil)
							]))
					]))
			]));
};
var $author$project$Icons$languages = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('32'),
				$elm$svg$Svg$Attributes$height('32'),
				$elm$svg$Svg$Attributes$viewBox('0 0 32 32'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M24.2727 4.09979C26.3815 4.09979 28.0909 5.98001 28.0909 8.29937V19.4983C28.0909 21.8176 26.3815 23.6978 24.2727 23.6978H12.6591L8.36364 27.8974V23.6978H7.72728C5.61855 23.6978 3.90909 21.8176 3.90909 19.4983V8.29937C3.90909 5.98001 5.61855 4.09979 7.72728 4.09979H24.2727ZM24.2727 2H7.72727C4.56419 2 2 4.82032 2 8.29937V19.4983C1.9985 22.4393 3.84747 24.9901 6.45455 25.6436V27.8974C6.45356 28.726 6.89564 29.4777 7.58311 29.8165C8.27058 30.1552 9.07488 30.0176 9.63636 29.4653L13.3909 25.7976H24.2727C27.4358 25.7976 30 22.9773 30 19.4983V8.29937C30 4.82032 27.4358 2 24.2727 2V2Z')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M16 14.9487C16.5271 14.9487 16.9545 14.4786 16.9545 13.8988C16.9545 13.3189 16.5271 12.8489 16 12.8489C15.4728 12.8489 15.0454 13.3189 15.0454 13.8988C15.0454 14.4786 15.4728 14.9487 16 14.9487Z')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M22.3636 14.9487C22.8908 14.9487 23.3181 14.4786 23.3181 13.8988C23.3181 13.3189 22.8908 12.8489 22.3636 12.8489C21.8364 12.8489 21.4091 13.3189 21.4091 13.8988C21.4091 14.4786 21.8364 14.9487 22.3636 14.9487Z')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M9.71272 14.9487C10.2399 14.9487 10.6673 14.4786 10.6673 13.8988C10.6673 13.3189 10.2399 12.8489 9.71272 12.8489C9.18554 12.8489 8.75818 13.3189 8.75818 13.8988C8.75818 14.4786 9.18554 14.9487 9.71272 14.9487Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Icons$notification = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$viewBox('0 0 32 32'),
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M27.4525 23.6028C27.1921 23.3615 25.0769 21.1955 25.0769 14.3608C25.0272 12.0243 24.1647 9.77815 22.6378 8.0089C21.8183 7.02925 20.8037 6.23102 19.6587 5.66505C19.6639 5.608 19.6639 5.5506 19.6587 5.49355C19.6587 3.56411 18.0946 2 16.1652 2C14.2358 2 12.6716 3.56411 12.6716 5.49355C12.6665 5.5506 12.6665 5.608 12.6716 5.66505C11.5267 6.23102 10.5121 7.02925 9.69261 8.0089C8.16566 9.77815 7.30314 12.0243 7.25347 14.3608C7.25347 21.1828 5.14464 23.3424 4.88421 23.5838C4.16959 24.0113 3.83712 24.8699 4.07752 25.6672C4.33116 26.5024 5.11046 27.0661 5.98309 27.0456H12.1953C11.8452 27.4115 11.8452 27.9881 12.1953 28.3541C13.22 29.4064 14.6265 30 16.0953 30C17.5642 30 18.9707 29.4064 19.9954 28.3541C20.3218 27.9935 20.3218 27.4442 19.9954 27.0837H26.2901C27.1628 27.1042 27.9421 26.5405 28.1957 25.7053C28.4555 24.917 28.15 24.0528 27.4525 23.6028ZM16.0576 3.88017C16.7226 3.93687 17.2982 4.36491 17.544 4.9854C16.5636 4.78128 15.5517 4.78128 14.5713 4.9854C14.817 4.36491 15.3927 3.93687 16.0576 3.88017ZM16.1315 6.73852C20.1586 6.73852 23.1186 10.8037 23.1186 14.3608C23.0829 16.5017 23.3328 18.6379 23.8618 20.7127H8.40127C8.93022 18.6379 9.18015 16.5017 9.14444 14.3608C9.14444 10.8037 12.1044 6.73852 16.1315 6.73852ZM16.0262 28.1063C15.0721 28.1166 14.1548 27.7382 13.4854 27.0583H18.5034C17.8498 27.7231 16.9584 28.1002 16.0262 28.1063ZM5.99728 25.159C6.7918 24.4755 7.39945 23.6012 7.76311 22.6183H24.5639C24.9276 23.6012 25.5352 24.4755 26.3297 25.159H5.99728Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Icons$settings = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$height('28'),
				$elm$svg$Svg$Attributes$viewBox('0 0 28 28'),
				$elm$svg$Svg$Attributes$width('28'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M14 8.90906C11.1884 8.90906 8.90909 11.1883 8.90909 14C8.90909 16.8116 11.1884 19.0909 14 19.0909C16.8116 19.0909 19.0909 16.8116 19.0909 14C19.0909 11.1883 16.8116 8.90906 14 8.90906ZM14 17.1818C12.2427 17.1818 10.8182 15.7572 10.8182 14C10.8182 12.2427 12.2427 10.8181 14 10.8181C15.7573 10.8181 17.1818 12.2427 17.1818 14C17.1818 15.7572 15.7573 17.1818 14 17.1818Z'),
						$elm$svg$Svg$Attributes$fillRule('evenodd')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M26.0909 10.1818H25.4545C25.2812 9.63475 25.0685 9.10093 24.8182 8.58455L25.2573 8.14545C26.0017 7.4001 26.0017 6.19263 25.2573 5.44727L22.5591 2.74909C21.8137 2.00466 20.6063 2.00466 19.8609 2.74909L19.4091 3.18182C18.8927 2.93148 18.3589 2.71881 17.8118 2.54545V1.90909C17.8118 0.854729 16.9571 0 15.9027 0H12.0845C11.0302 0 10.1755 0.854729 10.1755 1.90909V2.54545C9.62839 2.71881 9.09457 2.93148 8.57818 3.18182L8.13909 2.74273C7.39373 1.9983 6.18626 1.9983 5.44091 2.74273L2.74273 5.44091C1.9983 6.18626 1.9983 7.39374 2.74273 8.13909L3.18182 8.57818C2.93146 9.09456 2.71878 9.62838 2.54545 10.1755H1.90909C0.854729 10.1755 0 11.0302 0 12.0845V15.9027C0 16.9571 0.854729 17.8118 1.90909 17.8118H2.54545C2.71878 18.3589 2.93146 18.8927 3.18182 19.4091L2.74273 19.8482C1.9983 20.5935 1.9983 21.801 2.74273 22.5464L5.44091 25.2445C6.18626 25.989 7.39373 25.989 8.13909 25.2445L8.59091 24.8182C9.1073 25.0685 9.64111 25.2812 10.1882 25.4545V26.0909C10.1882 27.1453 11.0429 28 12.0973 28H15.9154C16.9698 28 17.8245 27.1453 17.8245 26.0909V25.4545C18.3716 25.2812 18.9054 25.0685 19.4218 24.8182L19.8609 25.2573C20.6063 26.0017 21.8137 26.0017 22.5591 25.2573L25.2573 22.5591C26.0017 21.8137 26.0017 20.6063 25.2573 19.8609L24.8182 19.4218C25.0685 18.9054 25.2812 18.3716 25.4545 17.8245H26.0909C27.1453 17.8245 28 16.9698 28 15.9155V12.0973C28.0017 11.5898 27.8013 11.1026 27.4431 10.7432C27.0849 10.3838 26.5983 10.1818 26.0909 10.1818ZM26.0909 15.9091H23.9973C23.7392 17.2768 23.202 18.5765 22.4191 19.7273L23.8954 21.2036L21.1973 23.9018L19.7209 22.4255C18.5703 23.2085 17.2704 23.7458 15.9027 24.0036V26.0909H12.0845V23.9973C10.7168 23.7394 9.417 23.2022 8.26636 22.4191L6.79 23.8955L4.09181 21.1973L5.56818 19.7209C4.78527 18.5702 4.24803 17.2704 3.99 15.9027H1.90909V12.0845H4.00272C4.26075 10.7169 4.798 9.41709 5.58091 8.26636L4.10454 6.79L6.80272 4.09182L8.27909 5.56818C9.42981 4.78527 10.7296 4.24803 12.0973 3.99V1.90909H15.9154V4.00273C17.2831 4.26076 18.5829 4.798 19.7336 5.58091L21.21 4.10455L23.9082 6.80273L22.4191 8.27273C23.202 9.42345 23.7392 10.7232 23.9973 12.0909H26.0909V15.9091Z'),
						$elm$svg$Svg$Attributes$fillRule('evenodd')
					]),
				_List_Nil)
			]));
};
var $author$project$Session$LoggedIn$viewCommunitySelector = function (model) {
	var hasMultipleCommunities = function () {
		var _v1 = model.kJ;
		if (_v1.$ === 3) {
			var p = _v1.a;
			return ($elm$core$List$length(p.ei) > 1) || (!$author$project$Session$LoggedIn$isCommunityMember(model));
		} else {
			return false;
		}
	}();
	var _v0 = model.o7;
	if (_v0.$ === 3) {
		var community = _v0.a;
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex items-center rounded-sm focus-ring focus:ring-offset-4'),
					$elm$html$Html$Events$onClick($author$project$Session$LoggedIn$OpenCommunitySelector)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('h-8 w-8 object-scale-down'),
							$elm$html$Html$Attributes$src(community.hC)
						]),
					_List_Nil),
					hasMultipleCommunities ? $author$project$Icons$arrowDown('fill-current text-gray-900') : $elm$html$Html$text('')
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Search$ClearSearchIconClicked = {$: 11};
var $author$project$Search$FormOutput = function (query) {
	return {dO: query};
};
var $author$project$Search$InputFocused = {$: 3};
var $author$project$Icons$clearInput = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$height('20'),
				$elm$svg$Svg$Attributes$viewBox('0 0 20 20'),
				$elm$svg$Svg$Attributes$width('20'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$d('m10 18.3334c4.6024 0 8.3333-3.7309 8.3333-8.3333 0-4.60239-3.7309-8.33335-8.3333-8.33335-4.60237 0-8.33333 3.73096-8.33333 8.33335 0 4.6024 3.73096 8.3333 8.33333 8.3333z'),
								$elm$svg$Svg$Attributes$strokeWidth('2')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$stroke('#fff')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$d('m12.5 7.5-5 5')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$d('m7.5 7.5 5 5')
									]),
								_List_Nil)
							]))
					]))
			]));
};
var $elm$html$Html$Attributes$minlength = function (n) {
	return A2(
		_VirtualDom_attribute,
		'minLength',
		$elm$core$String$fromInt(n));
};
var $author$project$Icons$search = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('28'),
				$elm$svg$Svg$Attributes$height('28'),
				$elm$svg$Svg$Attributes$viewBox('0 0 28 28'),
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M25.9969 24.7134L20.1885 19.2244C24.2584 15.3336 24.3824 9.08776 20.4699 5.05379C16.5574 1.01982 9.99564 0.628044 5.58244 4.16492C1.16924 7.70179 0.469389 13.9132 3.9946 18.2576C7.51981 22.6019 14.0201 23.5388 18.7427 20.3832L24.6643 26.0095C25.0358 26.3385 25.6147 26.3288 25.9738 25.9876C26.3329 25.6464 26.3431 25.0963 25.9969 24.7433V24.7134ZM3.80046 12.0571C3.80046 7.43892 7.74064 3.69516 12.6011 3.69516C17.4616 3.69516 21.4018 7.43892 21.4018 12.0571C21.4018 16.6752 17.4616 20.419 12.6011 20.419C7.74064 20.419 3.80046 16.6752 3.80046 12.0571Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Form$unsafeArbitrary = function (html) {
	return function (_v0) {
		return {
			l: _List_fromArray(
				[
					{
					mM: $elm$core$Maybe$Nothing,
					nx: false,
					X: $author$project$Form$UnsafeArbitrary(html),
					aP: 0
				}
				]),
			m: $author$project$OptionalResult$OptNothing
		};
	};
};
var $author$project$Search$createForm = F2(
	function (_v0, model) {
		var t = _v0.il;
		var isSearchOpen = function () {
			var _v4 = model.X;
			if (!_v4.$) {
				return false;
			} else {
				return true;
			}
		}();
		var viewClearSearchIcon = (isSearchOpen && (!$elm$core$String$isEmpty(
			A2(
				$author$project$Form$getValue,
				function ($) {
					return $.dO;
				},
				model.hk)))) ? A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('absolute right-3 flex items-center top-1/2 -translate-y-1/2 focus-ring focus-visible:ring-red focus-visible:ring-opacity-50 rounded-full group'),
					$elm$html$Html$Events$onClick($author$project$Search$ClearSearchIconClicked),
					$elm$html$Html$Attributes$type_('button')
				]),
			_List_fromArray(
				[
					$author$project$Icons$clearInput('fill-current text-gray-400 hover:text-red group-focus:text-red')
				])) : $elm$html$Html$text('');
		var isLoading = function () {
			var _v2 = model.X;
			if ((_v2.$ === 2) && (_v2.a.$ === 1)) {
				var _v3 = _v2.a;
				return true;
			} else {
				return false;
			}
		}();
		var iconColor = function () {
			var _v1 = model.X;
			if (!_v1.$) {
				return 'text-gray-400';
			} else {
				return 'text-indigo-500';
			}
		}();
		return A2(
			$author$project$Form$withNoOutput,
			$author$project$Form$unsafeArbitrary(
				A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-orange-300 ml-3 lowercase hover:underline focus:outline-none focus:underline'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('hidden', !isSearchOpen)
								])),
							$elm$html$Html$Events$onClick($author$project$Search$CancelClicked),
							$elm$html$Html$Attributes$type_('button')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							t('menu.cancel'))
						]))),
			A2(
				$author$project$Form$with,
				A2(
					$author$project$Form$textField,
					{
						ab: $elm$core$Basics$always($elm$core$Maybe$Nothing),
						af: $elm$core$Result$Ok,
						n: F2(
							function (query, input) {
								return _Utils_update(
									input,
									{dO: query});
							}),
						pO: function ($) {
							return $.dO;
						}
					},
					A2(
						$author$project$Form$Text$withElements,
						_List_fromArray(
							[
								viewClearSearchIcon,
								$author$project$Icons$search('absolute top-0 mt-[10px] left-4 fill-current ' + iconColor)
							]),
						A2(
							$author$project$Form$Text$withExtraAttrs,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('rounded-full bg-gray-100 border-0 pl-12 h-12'),
									$elm$html$Html$Events$onFocus($author$project$Search$InputFocused),
									$elm$html$Html$Attributes$minlength(3),
									$elm$html$Html$Attributes$autocomplete(false)
								]),
							A2(
								$author$project$Form$Text$withContainerAttrs,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('!m-0 w-full')
									]),
								A2(
									$author$project$Form$Text$withDisabled,
									isLoading,
									A2(
										$author$project$Form$Text$withPlaceholder,
										t('menu.search.placeholder'),
										$author$project$Form$Text$init(
											{R: 'search-input', nC: ''}))))))),
				$author$project$Form$succeed($author$project$Search$FormOutput)));
	});
var $author$project$Search$viewForm = F3(
	function (attrs, translators, model) {
		return A6(
			$author$project$Form$viewWithoutSubmit,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('flex items-center'),
				attrs),
			translators,
			function (_v0) {
				return _List_Nil;
			},
			A2($author$project$Search$createForm, translators, model),
			model.hk,
			{pA: $author$project$Search$GotFormMsg});
	});
var $author$project$Session$LoggedIn$viewHeader = F3(
	function (page, model, profile_) {
		var shared = model.aM;
		var tr = F2(
			function (str, values) {
				return A2(shared.iw.iu, str, values);
			});
		var text_ = function (str) {
			return $elm$html$Html$text(
				shared.iw.il(str));
		};
		var showSettingsGear = function () {
			var _v1 = model.o7;
			if (_v1.$ === 3) {
				var community = _v1.a;
				return _Utils_eq(community.mq, model.lM) || ($author$project$Eos$Account$nameToString(model.lM) === 'lucca');
			} else {
				return false;
			}
		}();
		var isSearchOpen = function () {
			var _v0 = model.ah.X;
			if (!_v0.$) {
				return false;
			} else {
				return true;
			}
		}();
		var hideCommunitySelectorPages = _List_fromArray(
			[$author$project$Session$LoggedIn$CommunitySelector]);
		var hideCommunitySelector = A2($elm$core$List$member, page, hideCommunitySelectorPages);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-wrap items-center justify-between p-4 md:flex-nowrap')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex-shrink-0'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('md:flex-shrink md:w-full lg:w-2/3 xl:w-full', !isSearchOpen),
									_Utils_Tuple2('lg:w-full', (!showSettingsGear) && (!isSearchOpen))
								]))
						]),
					hideCommunitySelector ? _List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('hidden sm:block h-5'),
									$elm$html$Html$Attributes$src(shared.hC)
								]),
							_List_Nil),
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('sm:hidden h-5'),
									$elm$html$Html$Attributes$src(shared.j3)
								]),
							_List_Nil)
						]) : _List_fromArray(
						[
							$author$project$Session$LoggedIn$viewCommunitySelector(model)
						])),
					A2($author$project$Session$LoggedIn$hideCommunityAndSearch, page, model) ? A2($elm$html$Html$div, _List_Nil, _List_Nil) : A2(
					$elm$html$Html$map,
					$author$project$Session$LoggedIn$GotSearchMsg,
					A3(
						$author$project$Search$viewForm,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('order-last w-full md:order-none mt-4 md:mt-0 md:mx-4'),
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('md:w-96 md:flex-shrink-0', !isSearchOpen),
										_Utils_Tuple2('w-full', isSearchOpen)
									]))
							]),
						shared.iw,
						model.ah)),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex items-center justify-end space-x-8 my-auto flex-shrink-0'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('md:flex-shrink md:w-full', !isSearchOpen)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('relative rounded-sm group focus-ring focus-visible:ring-orange-300 focus-visible:ring-opacity-50'),
									$author$project$Route$href($author$project$Route$Notification),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('mr-4', model.d1 > 0)
										])),
									$elm$html$Html$Events$onClick($author$project$Session$LoggedIn$ClosedSearch)
								]),
							_List_fromArray(
								[
									$author$project$Icons$notification('fill-current text-gray-900 h-6 md:h-7 group-hover:text-orange-300'),
									(model.d1 > 0) ? A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('absolute top-0 right-0 -mr-2 px-1 py-0.5 bg-orange-500 text-white font-semibold text-xs rounded-full md:-mr-4 md:px-2 md:py-1 md:text-sm')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$elm$core$String$fromInt(model.d1))
										])) : $elm$html$Html$text('')
								])),
							showSettingsGear ? A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('rounded-sm group focus-ring focus:ring-orange-300 focus:ring-opacity-50 focus:ring-offset-4'),
									$author$project$Route$href($author$project$Route$CommunitySettings),
									$elm$html$Html$Events$onClick($author$project$Session$LoggedIn$ClosedSearch)
								]),
							_List_fromArray(
								[
									$author$project$Icons$settings('fill-current h-6 text-gray-900 md:h-7 group-hover:text-orange-300')
								])) : $elm$html$Html$text(''),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('relative z-50 lg:min-w-50')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('z-10 pt-3 -mt-3 px-3 relative rounded-t hidden lg:w-full lg:visible lg:flex lg:items-center lg:bg-white lg:focus-ring lg:focus-visible:ring-orange-300 lg:focus-visible:ring-opacity-50'),
											$elm$html$Html$Attributes$type_('button'),
											$elm$html$Html$Events$onClick(
											$author$project$Session$LoggedIn$ShowUserNav(!model.aB)),
											$elm$html$Html$Events$onMouseEnter(
											$author$project$Session$LoggedIn$ShowUserNav(true))
										]),
									_List_fromArray(
										[
											A2($author$project$Avatar$view, profile_.cV, 'h-8 w-8'),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('flex flex-col items-center text-left pl-2')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$p,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('w-full text-gray-333 overflow-x-hidden')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															A2(
																tr,
																'menu.welcome_message',
																_List_fromArray(
																	[
																		_Utils_Tuple2(
																		'user_name',
																		$author$project$Eos$Account$nameToString(profile_.fl))
																	])))
														])),
													A2(
													$elm$html$Html$p,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('w-full text-orange-300')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															shared.iw.il('menu.my_account'))
														]))
												]))
										])),
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('z-10 flex relative rounded focus-ring focus-visible:ring-orange-300 focus-visible:ring-opacity-50 focus-visible:ring-offset-4 lg:hidden'),
											$elm$html$Html$Attributes$type_('button'),
											$elm$html$Html$Events$onClick(
											$author$project$Session$LoggedIn$ShowUserNav(!model.aB)),
											$elm$html$Html$Events$onMouseEnter(
											$author$project$Session$LoggedIn$ShowUserNav(true))
										]),
									_List_fromArray(
										[
											A2($author$project$Avatar$view, profile_.cV, 'h-6 w-6 md:h-7 md:w-7')
										])),
									model.aB ? A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('fixed h-full w-full inset-0 bg-black opacity-50 cursor-default'),
											$elm$html$Html$Events$onClick(
											$author$project$Session$LoggedIn$ShowUserNav(false)),
											$elm$html$Html$Events$onMouseEnter(
											$author$project$Session$LoggedIn$ShowUserNav(false))
										]),
									_List_Nil) : $elm$html$Html$text(''),
									function () {
									if (model.aB) {
										var menuItemClass = 'flex w-full py-4 lg:py-2 pl-2.5 pr-8 lg:pr-2 justify-start items-center text-base lg:text-sm focus-ring rounded first:rounded-t lg:first:rounded-t last:rounded-b hover:bg-gray-200 focus-visible:bg-gray-200 transition-colors';
										var menuIcon = function (icon) {
											return A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('w-6 md:w-7 lg:w-8 flex items-center justify-center mr-2')
													]),
												_List_fromArray(
													[
														icon('h-5 lg:h-4 fill-current')
													]));
										};
										return A3(
											$author$project$View$Components$focusTrap,
											{nk: $elm$core$Maybe$Nothing},
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$nav,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('absolute right-0 lg:w-full py-1 px-1 shadow-lg bg-white rounded lg:rounded-t-none z-50')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$a,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class(menuItemClass),
																	$author$project$Route$href(
																	$author$project$Route$Profile(model.lM)),
																	$elm$html$Html$Events$onClick($author$project$Session$LoggedIn$ClickedNavLink)
																]),
															_List_fromArray(
																[
																	menuIcon($author$project$Icons$profile),
																	text_('menu.profile')
																])),
															A2(
															$elm$html$Html$a,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class(menuItemClass),
																	$author$project$Route$href($author$project$Route$Settings),
																	$elm$html$Html$Events$onClick($author$project$Session$LoggedIn$ClickedNavLink)
																]),
															_List_fromArray(
																[
																	menuIcon($author$project$Icons$settings),
																	text_('settings.account.title')
																])),
															A2(
															$elm$html$Html$button,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class(menuItemClass),
																	$elm$html$Html$Events$onClick($author$project$Session$LoggedIn$ToggleLanguageItems)
																]),
															_List_fromArray(
																[
																	menuIcon($author$project$Icons$languages),
																	text_('menu.languages')
																])),
															model.e4 ? A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('ml-4 mb-2')
																]),
															A2(
																$elm$core$List$cons,
																A2(
																	$elm$html$Html$button,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class(menuItemClass),
																			$elm$html$Html$Attributes$class('uppercase !rounded !text-sm lg:!text-xs')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			$author$project$Session$Shared$langFlag,
																			_List_fromArray(
																				[
																					$elm$html$Html$Attributes$class('w-4 h-4 mr-2')
																				]),
																			shared.hy),
																			$elm$html$Html$text(
																			$author$project$Translation$languageToLanguageCode(shared.hy))
																		])),
																A3(
																	$author$project$Session$Shared$viewLanguageItems,
																	{
																		mg: _List_fromArray(
																			[
																				$elm$html$Html$Attributes$class(menuItemClass),
																				$elm$html$Html$Attributes$class('uppercase !rounded !text-sm lg:!text-xs')
																			]),
																		mV: _List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('w-4 h-4 mr-2')
																			])
																	},
																	shared,
																	$author$project$Session$LoggedIn$ClickedLanguage))) : $elm$html$Html$text(''),
															A2(
															$elm$html$Html$button,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class(menuItemClass),
																	$elm$html$Html$Attributes$class('text-red hover:bg-red/10 focus:bg-red/10'),
																	$elm$html$Html$Events$onClick($author$project$Session$LoggedIn$ClickedLogout)
																]),
															_List_fromArray(
																[
																	menuIcon($author$project$Icons$close),
																	text_('menu.logout')
																]))
														]))
												]));
									} else {
										return $elm$html$Html$text('');
									}
								}()
								]))
						]))
				]));
	});
var $fapian$elm_html_aria$Html$Attributes$Aria$ariaLive = $elm$html$Html$Attributes$attribute('aria-live');
var $author$project$Session$LoggedIn$viewHighlightedNews = F3(
	function (_v0, toPageMsg, news) {
		var t = _v0.il;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bg-purple-500 py-4 sticky top-0 z-10')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('container mx-auto px-4 text-white flex items-center')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Icons$speechBubble,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$alt('')
								]),
							'stroke-current flex-shrink-0'),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('truncate ml-4 mr-8')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h2,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('font-bold truncate'),
											$fapian$elm_html_aria$Html$Attributes$Aria$ariaLive('polite')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('sr-only')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													t('news.got_community_news'))
												])),
											$elm$html$Html$text(news.fb)
										])),
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('truncate')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Markdown$toUnformattedString(news.bc))
										]))
								])),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('button button-primary w-auto px-4 ml-auto mr-6'),
									$author$project$Route$href(
									$author$project$Route$News(
										{
											o8: $elm$core$Maybe$Just(news.R),
											pe: true
										})),
									$elm$html$Html$Events$onClick(
									toPageMsg($author$project$Session$LoggedIn$ClickedReadHighlightedNews))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('news.read'))
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('hover:text-red focus:text-red focus:outline-none'),
									$fapian$elm_html_aria$Html$Attributes$Aria$ariaLabel(
									t('menu.close')),
									$elm$html$Html$Events$onClick(
									toPageMsg($author$project$Session$LoggedIn$ClosedHighlightedNews))
								]),
							_List_fromArray(
								[
									$author$project$Icons$close('fill-current')
								]))
						]))
				]));
	});
var $author$project$Session$LoggedIn$isActive = F2(
	function (page, route) {
		var _v0 = _Utils_Tuple2(page, route);
		_v0$2:
		while (true) {
			switch (_v0.a.$) {
				case 5:
					if (_v0.b.$ === 12) {
						var _v1 = _v0.a;
						var _v2 = _v0.b;
						return true;
					} else {
						break _v0$2;
					}
				case 14:
					if (_v0.b.$ === 36) {
						var _v3 = _v0.a;
						return true;
					} else {
						break _v0$2;
					}
				default:
					break _v0$2;
			}
		}
		return false;
	});
var $author$project$Session$LoggedIn$viewMainMenu = F2(
	function (page, model) {
		var menuItem = F2(
			function (title, route) {
				return A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-center uppercase py-2 hover:text-orange-300 focus-ring focus-visible:ring-orange-300 focus-visible:ring-opacity-50 rounded-sm'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'text-orange-300 font-bold',
									A2($author$project$Session$LoggedIn$isActive, page, route)),
									_Utils_Tuple2(
									'text-gray-900',
									!A2($author$project$Session$LoggedIn$isActive, page, route))
								])),
							$author$project$Route$href(route)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							model.aM.iw.il(title))
						]));
			});
		var isInShop = A2(
			$author$project$Session$LoggedIn$isActive,
			page,
			$author$project$Route$Shop(
				{cX: _List_Nil, oy: $elm$core$Maybe$Nothing}));
		var isInDashboard = A2($author$project$Session$LoggedIn$isActive, page, $author$project$Route$Dashboard);
		var hasShop = A2(
			$krisajenkins$remotedata$RemoteData$withDefault,
			false,
			A2(
				$krisajenkins$remotedata$RemoteData$map,
				function ($) {
					return $.cm;
				},
				model.o7));
		return A2(
			$elm$html$Html$nav,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('grid relative md:mx-4'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('grid-cols-2 md:w-96', hasShop),
							_Utils_Tuple2('md:w-48', !hasShop)
						]))
				]),
			_List_fromArray(
				[
					A2(menuItem, 'menu.dashboard', $author$project$Route$Dashboard),
					hasShop ? A2(
					menuItem,
					'menu.shop',
					$author$project$Route$Shop(
						{cX: _List_Nil, oy: $elm$core$Maybe$Nothing})) : $elm$html$Html$text(''),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('absolute bottom-0 h-3px'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('w-1/2 transform transition-transform motion-reduce:transition-none', hasShop),
									_Utils_Tuple2('w-full', !hasShop),
									_Utils_Tuple2('translate-x-0', isInDashboard),
									_Utils_Tuple2('translate-x-full', isInShop),
									_Utils_Tuple2('bg-orange-300', isInDashboard || isInShop)
								]))
						]),
					_List_Nil)
				]));
	});
var $author$project$Session$LoggedIn$ProfilePublic = {$: 18};
var $author$project$Session$LoggedIn$viewPageBody = F4(
	function (model, profile_, page, content) {
		var shared = model.aM;
		var hasUserKycFilled = function () {
			var _v2 = profile_.hx;
			if (!_v2.$) {
				return true;
			} else {
				return false;
			}
		}();
		var availableWithoutKyc = _List_fromArray(
			[$author$project$Session$LoggedIn$Redirect, $author$project$Session$LoggedIn$NotFound, $author$project$Session$LoggedIn$ComingSoon, $author$project$Session$LoggedIn$AdminMoved, $author$project$Session$LoggedIn$Invite, $author$project$Session$LoggedIn$CommunitySelector, $author$project$Session$LoggedIn$Profile, $author$project$Session$LoggedIn$Notification, $author$project$Session$LoggedIn$ProfilePublic, $author$project$Session$LoggedIn$ProfileEditor, $author$project$Session$LoggedIn$ProfileAddKyc, $author$project$Session$LoggedIn$PaymentHistory, $author$project$Session$LoggedIn$ViewTransfer, $author$project$Session$LoggedIn$Join]);
		var _v0 = shared.iw;
		var t = _v0.il;
		var viewKycRestriction = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mx-auto container max-w-sm')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('my-6 mx-4 text-center')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-2xl font-bold')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('community.kyc.restriction.title'))
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mt-2 mb-6')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('community.kyc.restriction.description'))
								])),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('button button-primary m-auto w-full'),
									$author$project$Route$href($author$project$Route$ProfileAddKyc)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('community.kyc.restriction.link'))
								]))
						])),
					A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('w-full mx-auto md:w-64 mt-6 mb-8'),
							$elm$html$Html$Attributes$src('/images/not_found.svg')
						]),
					_List_Nil)
				]));
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex-grow flex flex-col')
					]),
				_List_fromArray(
					[
						function () {
						var _v1 = model.o7;
						switch (_v1.$) {
							case 1:
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('full-spinner-container h-full')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('spinner spinner--delay mt-8')
												]),
											_List_Nil)
										]));
							case 0:
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('full-spinner-container h-full')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('spinner spinner--delay mt-8')
												]),
											_List_Nil)
										]));
							case 3:
								var hasKyc = _v1.a.ck;
								var isContentAllowed = A2($elm$core$List$member, page, availableWithoutKyc) || ((!hasKyc) || (hasKyc && hasUserKycFilled));
								return isContentAllowed ? content : viewKycRestriction;
							default:
								var isContentAllowed = A2($elm$core$List$member, page, availableWithoutKyc);
								return isContentAllowed ? content : $elm$html$Html$text('');
						}
					}()
					]))
			]);
	});
var $author$project$Search$ActionsTab = 1;
var $author$project$Search$MembersTab = 2;
var $author$project$Search$OffersTab = 0;
var $author$project$Search$viewEmptyResults = F2(
	function (_v0, queryText) {
		var t = _v0.il;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex-grow bg-white text-center')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h3,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mt-20 text-xl font-bold')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							t('menu.search.notFoundLabel') + (' \"' + (queryText + '\"')))
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('w-2/3 mx-auto md:w-64 mt-6 mb-8'),
									$elm$html$Html$Attributes$src('/images/not_found.svg')
								]),
							_List_Nil),
							$elm$html$Html$text(
							t('menu.search.notFoundResults'))
						]))
				]));
	});
var $author$project$Search$FoundItemClicked = {$: 12};
var $author$project$Search$viewMembers = F2(
	function (_v0, members) {
		var t = _v0.il;
		var viewMember = function (member) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('bg-white rounded flex flex-col p-4 space-y-4 justify-between')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('grid grid-cols-3 px-4')
							]),
						_List_fromArray(
							[
								A2($author$project$Avatar$view, member.cV, 'h-20 w-20 my-auto'),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('flex flex-col col-span-2')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-lg font-bold capitalize')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												A2($elm$core$Maybe$withDefault, '', member.ki))
											])),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-sm text-gray-900')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												A2($elm$core$Maybe$withDefault, '', member.jh))
											])),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-sm text-gray-900')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Eos$Account$nameToString(member.fl))
											]))
									]))
							])),
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('w-full button button-secondary cursor-pointer'),
								$elm$html$Html$Events$onClick($author$project$Search$FoundItemClicked),
								$author$project$Route$href(
								$author$project$Route$Profile(member.fl))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								t('all_analysis.more_details'))
							]))
					]));
		};
		return A2(
			$elm$html$Html$ul,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-6 mb-8 mx-2')
				]),
			A2($elm$core$List$map, viewMember, members));
	});
var $author$project$Search$ClickedScrollToImage = function (a) {
	return {$: 13, a: a};
};
var $author$project$Search$ImageStartedIntersecting = F2(
	function (a, b) {
		return {$: 14, a: a, b: b};
	});
var $author$project$Search$ImageStoppedIntersecting = F2(
	function (a, b) {
		return {$: 15, a: a, b: b};
	});
var $author$project$Search$viewOffers = F3(
	function (translators, symbol, offers) {
		var viewOffer = function (productInfo) {
			var images = function () {
				var _v0 = productInfo.oP.hr;
				if (!_v0.b) {
					return A2(
						$elm$html$Html$img,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$src('/icons/shop-placeholder1.svg'),
								$elm$html$Html$Attributes$alt(''),
								$elm$html$Html$Attributes$class('h-32')
							]),
						_List_Nil);
				} else {
					var firstImage = _v0.a;
					var otherImages = _v0.b;
					return A4(
						$author$project$Shop$viewImageCarrousel,
						translators,
						{
							mg: _List_fromArray(
								[
									$elm$html$Html$Attributes$class('h-32')
								]),
							nd: _List_fromArray(
								[
									$elm$html$Html$Attributes$class('w-full h-full')
								]),
							ne: _List_fromArray(
								[
									$elm$html$Html$Attributes$class('bg-white rounded-t')
								]),
							ng: _List_Nil,
							nK: _List_fromArray(
								[
									$elm$html$Html$Attributes$class('gap-x-4 rounded-t bg-gray-100')
								])
						},
						{
							mu: productInfo.cc,
							om: $author$project$Search$ClickedScrollToImage,
							oo: $author$project$Search$ImageStartedIntersecting(productInfo.oP.R),
							op: $author$project$Search$ImageStoppedIntersecting(productInfo.oP.R),
							oR: $elm$core$Maybe$Just(productInfo.oP.R),
							pa: false
						},
						_Utils_Tuple2(firstImage, otherImages));
				}
			}();
			return A2(
				$elm$html$Html$li,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex px-2 w-1/2 sm:w-1/3 md:w-1/4')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('rounded-md overflow-hidden bg-white flex-grow mb-4 pb-4 cursor-pointer hover:shadow focus:shadow focus:outline-none focus:ring focus:ring-gray-400'),
								$elm$html$Html$Events$onClick($author$project$Search$FoundItemClicked),
								$author$project$Route$href(
								$author$project$Route$ViewSale(productInfo.oP.R))
							]),
						_List_fromArray(
							[
								images,
								A2(
								$elm$html$Html$h3,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('p-3')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(productInfo.oP.fb)
									])),
								$author$project$Shop$isOutOfStock(productInfo.oP) ? A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('px-3 text-xl text-red')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										translators.il('shop.out_of_stock'))
									])) : A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('px-3')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-xl text-green font-semibold')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$elm$core$String$fromFloat(productInfo.oP.h3))
											])),
										A2($elm$html$Html$br, _List_Nil, _List_Nil),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-gray-900 text-sm')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Eos$symbolToSymbolCodeString(symbol))
											]))
									]))
							]))
					]));
		};
		return A2(
			$elm$html$Html$ul,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-wrap mt-6 mb-8 mx-2 justify-left')
				]),
			A2($elm$core$List$map, viewOffer, offers));
	});
var $author$project$Search$RecentQueryClicked = function (a) {
	return {$: 5, a: a};
};
var $author$project$Icons$clock = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$height('20'),
				$elm$svg$Svg$Attributes$viewBox('0 0 20 20'),
				$elm$svg$Svg$Attributes$width('20'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('m19.4141 9.41404c-.3236 0-.5859.26235-.5859.58594 0 4.86782-3.9603 8.82812-8.8281 8.82812-4.86779 0-8.82804-3.9603-8.82804-8.82812 0-4.86783 3.96025-8.82808 8.82804-8.82808 1.4844 0 2.9282.36856 4.2172 1.07082l-.7326.73253c-.1676.16758-.2177.41957-.127.63855.0907.21895.3043.36172.5413.36172h2.8036c.3236 0 .586-.26234.586-.58593v-2.803619c0-.236991-.1428-.450623-.3617-.5413252-.2191-.0907417-.4711-.04058572-.6386.1270302l-1.2116 1.211594c-1.5347-.906127-3.2796-1.38319428-5.0766-1.38319428-2.67108 0-5.18232 1.04018428-7.07106 2.92888428-1.88874 1.88878-2.92888741 4.39998-2.92888741 7.07104 0 2.6711 1.04014741 5.1823 2.92888741 7.071 1.88878 1.8888 4.39998 2.929 7.07106 2.929 2.6711 0 5.1823-1.0402 7.071-2.929 1.8888-1.8887 2.9289-4.3999 2.9289-7.071.0001-.32361-.2623-.58596-.5859-.58596z')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('m13.7656 9.41403h-3.1796v-3.17966c0-.32359-.2623-.58593-.5859-.58593-.32363 0-.58598.26234-.58598.58593v3.76559c0 .32364.26235.58594.58598.58594h3.7655c.3236 0 .586-.2623.586-.58594 0-.32359-.2624-.58593-.586-.58593z')
					]),
				_List_Nil)
			]));
};
var $author$project$Search$viewRecentQueries = F2(
	function (_v0, recentQueries) {
		var t = _v0.il;
		var viewItem = function (q) {
			return A2(
				$elm$html$Html$li,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex items-center w-full hover:text-orange-500 focus:text-orange-500 focus:outline-none'),
								$elm$html$Html$Events$onClick(
								$author$project$Search$RecentQueryClicked(q))
							]),
						_List_fromArray(
							[
								$author$project$Icons$clock('mr-3 fill-current'),
								A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(q)
									]))
							]))
					]));
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('w-full p-4 bg-white')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$strong,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							t('menu.search.recentlyHeader'))
						])),
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-gray-900 mt-4 space-y-2')
						]),
					A2($elm$core$List$map, viewItem, recentQueries))
				]));
	});
var $author$project$Search$TabActivated = function (a) {
	return {$: 8, a: a};
};
var $author$project$Icons$accountCircle = function (class_) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('24'),
				$elm$svg$Svg$Attributes$height('24'),
				$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$class(class_)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0ZM1.63635 12C1.63601 7.46102 4.58934 3.44999 8.92373 2.10268C13.2581 0.755376 17.9649 2.38534 20.5378 6.12465C23.1107 9.86395 22.9509 14.8424 20.1436 18.4091C18.8933 16.5468 17.0792 15.1341 14.9673 14.3782C15.8799 13.4012 16.3802 12.1096 16.3636 10.7727C16.3636 8.04544 14.4054 5.86362 12 5.86362C9.59453 5.86362 7.63635 8.04544 7.63635 10.7727C7.62279 12.1573 8.16508 13.4894 9.1418 14.4709C7.01491 15.2344 5.22096 16.7158 4.06907 18.66C2.49663 16.7972 1.63477 14.4377 1.63635 12ZM12.2727 13.9091C11.9739 13.9103 11.6753 13.9267 11.3781 13.9582C10.0507 13.4768 9.19531 12.1826 9.27269 10.7727C9.27269 8.96727 10.4945 7.5 12 7.5C13.5054 7.5 14.7272 8.96727 14.7272 10.7727C14.7944 12.143 13.9899 13.4066 12.72 13.9255C12.5727 13.92 12.4254 13.9091 12.2727 13.9091ZM5.28 19.9091C6.46553 17.5946 8.70447 16.0029 11.28 15.6436C11.811 15.7473 12.3582 15.7343 12.8836 15.6054C15.429 15.9491 17.6764 17.4407 18.9818 19.6527C15.1352 23.2032 9.24024 23.3134 5.26363 19.9091H5.28Z'),
						$elm$svg$Svg$Attributes$fill('black')
					]),
				_List_Nil)
			]));
};
var $author$project$Search$viewResultsOverview = F2(
	function (_v0, _v1) {
		var t = _v0.il;
		var tr = _v0.iu;
		var offers = _v1.a2;
		var actions = _v1.lP;
		var members = _v1.hG;
		var viewItem = F5(
			function (icon, count, singular, plural, showMsg) {
				return A2(
					$elm$html$Html$li,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('py-4 flex items-center')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex-grow flex items-center')
								]),
							_List_fromArray(
								[
									icon('w-6 h-6 text-black fill-current mr-3'),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											t('menu.search.overviewFound')),
											$elm$html$Html$text(' '),
											A2(
											$elm$html$Html$strong,
											_List_Nil,
											_List_fromArray(
												[
													(count === 1) ? $elm$html$Html$text(
													t(singular)) : $elm$html$Html$text(
													A2(
														tr,
														plural,
														_List_fromArray(
															[
																_Utils_Tuple2(
																'count',
																$elm$core$String$fromInt(count))
															])))
												]))
										]))
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('button w-auto button-sm px-6'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('button-disabled', !count),
											_Utils_Tuple2('button-primary', !(!count))
										])),
									$elm$html$Html$Attributes$disabled(!count),
									$elm$html$Html$Events$onClick(showMsg)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('menu.search.overviewShow'))
								]))
						]));
			});
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$strong,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('block pb-2')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							t('menu.search.overviewHeader'))
						])),
					A2(
					$elm$html$Html$ul,
					_List_Nil,
					_List_fromArray(
						[
							A5(
							viewItem,
							$author$project$Icons$shop,
							$elm$core$List$length(offers),
							'menu.search.offer',
							'menu.search.offers',
							$author$project$Search$TabActivated(0)),
							A5(
							viewItem,
							$author$project$Icons$flag,
							$elm$core$List$length(actions),
							'menu.search.action',
							'menu.search.actions',
							$author$project$Search$TabActivated(1)),
							A5(
							viewItem,
							$author$project$Icons$accountCircle,
							$elm$core$List$length(members),
							'menu.search.member',
							'menu.search.members',
							$author$project$Search$TabActivated(2))
						]))
				]));
	});
var $author$project$Search$viewTabs = F3(
	function (_v0, results, activeTab) {
		var tr = _v0.iu;
		var viewTab = F4(
			function (tabKind, label, foundItems, clickMsg) {
				var count = $elm$core$List$length(foundItems);
				return A2(
					$elm$html$Html$li,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('w-full')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('rounded-sm text-center capitalize w-full py-3 focus-ring focus-visible:ring-gray-300'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'bg-orange-300 text-white font-bold',
											_Utils_eq(activeTab, tabKind)),
											_Utils_Tuple2(
											'bg-gray-100 hover:bg-gray-200 focus:bg-gray-200',
											!_Utils_eq(activeTab, tabKind)),
											_Utils_Tuple2('cursor-not-allowed text-gray-300', count <= 0)
										])),
									(count > 0) ? $elm$html$Html$Events$onClick(clickMsg) : $elm$html$Html$Attributes$tabindex(-1),
									_Utils_eq(activeTab, tabKind) ? $elm$html$Html$Attributes$tabindex(-1) : $elm$html$Html$Attributes$class('')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										tr,
										label,
										_List_fromArray(
											[
												_Utils_Tuple2(
												'count',
												$elm$core$String$fromInt(count))
											])))
								]))
						]));
			});
		return A2(
			$elm$html$Html$ul,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('space-x-2 flex items-stretch p-4 pb-2 bg-white')
				]),
			_List_fromArray(
				[
					A4(
					viewTab,
					0,
					'menu.search.offers_title',
					results.a2,
					$author$project$Search$TabActivated(0)),
					A4(
					viewTab,
					1,
					'menu.search.actions_title',
					results.lP,
					$author$project$Search$TabActivated(1)),
					A4(
					viewTab,
					2,
					'menu.search.members_title',
					results.hG,
					$author$project$Search$TabActivated(2))
				]));
	});
var $author$project$Search$viewSearchBody = F6(
	function (loggedIn, selectedCommunity, today, searchToMsg, actionToMsg, searchModel) {
		var translators = loggedIn.aM.iw;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container mx-auto flex flex-grow')
				]),
			_List_fromArray(
				[
					function () {
					var _v0 = searchModel.X;
					_v0$2:
					while (true) {
						if (_v0.$ === 2) {
							switch (_v0.a.$) {
								case 3:
									var results = _v0.a.a;
									var activeTab = _v0.b;
									if ($elm$core$List$isEmpty(results.lP) && ($elm$core$List$isEmpty(results.a2) && $elm$core$List$isEmpty(results.hG))) {
										return A2(
											$elm$html$Html$map,
											searchToMsg,
											A2(
												$author$project$Search$viewEmptyResults,
												translators,
												A2(
													$author$project$Form$getValue,
													function ($) {
														return $.dO;
													},
													searchModel.hk)));
									} else {
										if (!activeTab.$) {
											switch (activeTab.a) {
												case 0:
													var _v2 = activeTab.a;
													return A2(
														$elm$html$Html$map,
														searchToMsg,
														A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('w-full')
																]),
															_List_fromArray(
																[
																	A3($author$project$Search$viewTabs, translators, results, 0),
																	A3($author$project$Search$viewOffers, translators, selectedCommunity, results.a2)
																])));
												case 1:
													var _v3 = activeTab.a;
													return A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('w-full')
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$map,
																searchToMsg,
																A3($author$project$Search$viewTabs, translators, results, 1)),
																A4(
																$author$project$View$Components$masonryLayout,
																_List_fromArray(
																	[0]),
																{pG: false},
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('grid mt-4 lg:mt-6 marker-hidden gap-4 lg:gap-x-6 sm:grid-cols-2 lg:grid-cols-3'),
																		$fapian$elm_html_aria$Html$Attributes$Aria$role('list')
																	]),
																A2(
																	$elm$core$List$map,
																	A2(
																		$author$project$Action$viewCard,
																		loggedIn,
																		{
																			mg: _List_fromArray(
																				[
																					$elm$html$Html$Attributes$class('mb-4 lg:mb-6')
																				]),
																			kC: $elm$core$Maybe$Nothing,
																			pA: actionToMsg
																		}),
																	results.lP))
															]));
												default:
													var _v4 = activeTab.a;
													return A2(
														$elm$html$Html$map,
														searchToMsg,
														A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('w-full')
																]),
															_List_fromArray(
																[
																	A3($author$project$Search$viewTabs, translators, results, 2),
																	A2($author$project$Search$viewMembers, translators, results.hG)
																])));
											}
										} else {
											return A2(
												$elm$html$Html$map,
												searchToMsg,
												A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('bg-white w-full p-4')
														]),
													_List_fromArray(
														[
															A2($author$project$Search$viewResultsOverview, translators, results)
														])));
										}
									}
								case 1:
									var _v5 = _v0.a;
									return A2($author$project$View$Components$loadingLogoAnimated, translators, '');
								default:
									break _v0$2;
							}
						} else {
							break _v0$2;
						}
					}
					return A2(
						$elm$html$Html$map,
						searchToMsg,
						A2($author$project$Search$viewRecentQueries, translators, searchModel.bP));
				}()
				]));
	});
var $author$project$Session$LoggedIn$viewHelper = F5(
	function (pageMsg, page, profile_, model, content) {
		var shared = model.aM;
		var mainView = function () {
			if ($author$project$Search$isActive(model.ah)) {
				var _v2 = model.o7;
				if (_v2.$ === 3) {
					var community = _v2.a;
					return _List_fromArray(
						[
							A6(
							$author$project$Search$viewSearchBody,
							model,
							community.e9,
							shared.gh,
							A2($elm$core$Basics$composeR, $author$project$Session$LoggedIn$GotSearchMsg, pageMsg),
							A2($elm$core$Basics$composeR, $author$project$Session$LoggedIn$GotActionMsg, pageMsg),
							model.ah)
						]);
				} else {
					return _List_Nil;
				}
			} else {
				return A4($author$project$Session$LoggedIn$viewPageBody, model, profile_, page, content);
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('min-h-screen flex flex-col')
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('bg-white')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('container mx-auto')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									pageMsg,
									A3($author$project$Session$LoggedIn$viewHeader, page, model, profile_)),
									(A2($author$project$Session$LoggedIn$hideCommunityAndSearch, page, model) || $author$project$Search$isActive(model.ah)) ? $elm$html$Html$text('') : A2(
									$elm$html$Html$map,
									pageMsg,
									A2($author$project$Session$LoggedIn$viewMainMenu, page, model))
								]))
						])),
				A2(
					$elm$core$List$cons,
					A2(
						$elm$html$Html$map,
						A2($elm$core$Basics$composeR, $author$project$Session$LoggedIn$GotFeedbackMsg, pageMsg),
						$author$project$View$Feedback$view(model.hf)),
					A2(
						$elm$core$List$cons,
						function () {
							var _v0 = model.j7;
							if (!_v0.$) {
								var news = _v0.a;
								var isInNewsPage = function () {
									if (page.$ === 6) {
										var maybeNewsId = page.a;
										return _Utils_eq(
											maybeNewsId,
											$elm$core$Maybe$Just(news.R));
									} else {
										return false;
									}
								}();
								var showHighlightedNews = (!$elm_community$maybe_extra$Maybe$Extra$isJust(news.h5)) && ((!_Utils_eq(page, $author$project$Session$LoggedIn$AdminMoved)) && ((!isInNewsPage) && (!A2(
									$elm$core$List$member,
									page,
									_List_fromArray(
										[$author$project$Session$LoggedIn$Join, $author$project$Session$LoggedIn$Invite])))));
								return showHighlightedNews ? A3($author$project$Session$LoggedIn$viewHighlightedNews, shared.iw, pageMsg, news) : $elm$html$Html$text('');
							} else {
								return $elm$html$Html$text('');
							}
						}(),
						_Utils_ap(
							mainView,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									pageMsg,
									$author$project$Session$LoggedIn$viewFooter(model)),
									A2(
									$elm$html$Html$map,
									pageMsg,
									$author$project$Session$LoggedIn$viewCommunityContactsModal(model)),
									A2($author$project$Session$LoggedIn$viewAuthModal, pageMsg, model),
									A2(
									$elm$html$Html$map,
									pageMsg,
									$author$project$Session$LoggedIn$communitySelectorModal(model)),
									A2(
									$elm$html$Html$map,
									pageMsg,
									$author$project$Session$LoggedIn$insufficientPermissionsModal(model)),
									A2(
									$elm$html$Html$map,
									pageMsg,
									$author$project$Session$LoggedIn$codeOfConductModal(model))
								]))))));
	});
var $author$project$Session$LoggedIn$view = F4(
	function (thisMsg, page, model, content) {
		var shared = model.aM;
		var _v0 = _Utils_Tuple2(
			$author$project$Session$Shared$translationStatus(shared),
			model.kJ);
		_v0$0:
		while (true) {
			_v0$1:
			while (true) {
				switch (_v0.b.$) {
					case 1:
						switch (_v0.a.$) {
							case 0:
								break _v0$0;
							case 1:
								break _v0$1;
							default:
								var _v2 = _v0.b;
								return A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2($author$project$View$Components$loadingLogoAnimated, shared.iw, ''),
											A2($author$project$Session$LoggedIn$viewAuthModal, thisMsg, model)
										]));
						}
					case 0:
						switch (_v0.a.$) {
							case 0:
								break _v0$0;
							case 1:
								break _v0$1;
							default:
								var _v3 = _v0.b;
								return A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2($author$project$View$Components$loadingLogoAnimated, shared.iw, ''),
											A2($author$project$Session$LoggedIn$viewAuthModal, thisMsg, model)
										]));
						}
					case 2:
						switch (_v0.a.$) {
							case 0:
								break _v0$0;
							case 1:
								break _v0$1;
							default:
								var err = _v0.b.a;
								return A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$map,
											thisMsg,
											A4(
												$author$project$Session$Shared$viewFullGraphqlError,
												shared,
												err,
												$author$project$Session$LoggedIn$ClickedTryAgainProfile(model.lM),
												'An error occurred while loading profile.')),
											A2($author$project$Session$LoggedIn$viewAuthModal, thisMsg, model)
										]));
						}
					default:
						switch (_v0.a.$) {
							case 0:
								break _v0$0;
							case 1:
								break _v0$1;
							default:
								var profile_ = _v0.b.a;
								return A5($author$project$Session$LoggedIn$viewHelper, thisMsg, page, profile_, model, content);
						}
				}
			}
			var err = _v0.a.a;
			return A2(
				$elm$html$Html$map,
				thisMsg,
				A4($author$project$Session$Shared$viewFullError, shared, err, $author$project$Session$LoggedIn$ClickedTryAgainTranslation, 'An error occurred while loading translation.'));
		}
		var _v1 = _v0.a;
		return $author$project$Session$Shared$viewFullLoading;
	});
var $author$project$Page$viewLoggedIn = F4(
	function (thisMsg, page, model, content) {
		return A4(
			$author$project$Session$LoggedIn$view,
			A2($elm$core$Basics$composeL, thisMsg, $author$project$Page$GotLoggedInMsg),
			page,
			model,
			content);
	});
var $author$project$Main$view = function (model) {
	var baseTitle = 'Cambiatus';
	var fullPageTitle = function (subTitle) {
		return (subTitle === '') ? baseTitle : (subTitle + (' | ' + baseTitle));
	};
	var viewGuest = F4(
		function (subModel, page, toMsg, subView) {
			var _v10 = model.c;
			if (!_v10.$) {
				var guest = _v10.a;
				var _v11 = A2(subView, guest, subModel);
				var title = _v11.fb;
				var content = _v11.mk;
				return A2(
					$elm$browser$Browser$Document,
					fullPageTitle(title),
					_List_fromArray(
						[
							A4(
							$author$project$Page$viewGuest,
							$author$project$Main$GotPageMsg,
							page,
							guest,
							A2($elm$html$Html$map, toMsg, content))
						]));
			} else {
				return A2(
					$elm$browser$Browser$Document,
					fullPageTitle(''),
					_List_fromArray(
						[
							$elm$html$Html$text('')
						]));
			}
		});
	var viewLoggedIn = F4(
		function (subModel, page, toMsg, subView) {
			var _v8 = model.c;
			if (!_v8.$) {
				return A2(
					$elm$browser$Browser$Document,
					fullPageTitle(''),
					_List_fromArray(
						[
							$elm$html$Html$text('')
						]));
			} else {
				var loggedIn = _v8.a;
				var _v9 = A2(subView, loggedIn, subModel);
				var title = _v9.fb;
				var content = _v9.mk;
				return A2(
					$elm$browser$Browser$Document,
					fullPageTitle(title),
					_List_fromArray(
						[
							A4(
							$author$project$Page$viewLoggedIn,
							$author$project$Main$GotPageMsg,
							page,
							loggedIn,
							A2($elm$html$Html$map, toMsg, content))
						]));
			}
		});
	var viewPage = F4(
		function (guestPage, loggedInPage, toMsg, _v7) {
			var title = _v7.fb;
			var content = _v7.mk;
			var _v6 = model.c;
			if (!_v6.$) {
				var guest = _v6.a;
				return A2(
					$elm$browser$Browser$Document,
					fullPageTitle(title),
					_List_fromArray(
						[
							A4(
							$author$project$Page$viewGuest,
							$author$project$Main$GotPageMsg,
							guestPage,
							guest,
							A2($elm$html$Html$map, toMsg, content))
						]));
			} else {
				var loggedIn = _v6.a;
				return A2(
					$elm$browser$Browser$Document,
					fullPageTitle(title),
					_List_fromArray(
						[
							A4(
							$author$project$Page$viewLoggedIn,
							$author$project$Main$GotPageMsg,
							loggedInPage,
							loggedIn,
							A2($elm$html$Html$map, toMsg, content))
						]));
			}
		});
	var _v0 = model.gE;
	switch (_v0.$) {
		case 0:
			return A4(
				viewPage,
				0,
				$author$project$Session$LoggedIn$Redirect,
				function (_v1) {
					return $author$project$Main$Ignored;
				},
				{
					mk: $elm$html$Html$text(''),
					fb: ''
				});
		case 1:
			return A4(
				viewPage,
				1,
				$author$project$Session$LoggedIn$NotFound,
				function (_v2) {
					return $author$project$Main$Ignored;
				},
				$author$project$Page$NotFound$view(model.c));
		case 2:
			return A4(
				viewPage,
				2,
				$author$project$Session$LoggedIn$ComingSoon,
				function (_v3) {
					return $author$project$Main$Ignored;
				},
				$author$project$Page$ComingSoon$view(model.c));
		case 3:
			return A4(
				viewPage,
				3,
				$author$project$Session$LoggedIn$AdminMoved,
				function (_v4) {
					return $author$project$Main$Ignored;
				},
				$author$project$Page$AdminMoved$view(model.c));
		case 25:
			var subModel = _v0.a;
			return A4(
				viewPage,
				6,
				$author$project$Session$LoggedIn$Invite,
				$author$project$Main$GotInviteMsg,
				A2($author$project$Page$Community$Invite$view, model.c, subModel));
		case 26:
			var subModel = _v0.a;
			return A4(
				viewPage,
				7,
				$author$project$Session$LoggedIn$Join,
				$author$project$Main$GotJoinMsg,
				A2($author$project$Page$Join$view, model.c, subModel));
		case 4:
			var subModel = _v0.a;
			return A4(viewLoggedIn, subModel, $author$project$Session$LoggedIn$PaymentHistory, $author$project$Main$GotPaymentHistoryMsg, $author$project$Page$PaymentHistory$view);
		case 19:
			var subModel = _v0.c;
			return A4(viewGuest, subModel, 4, $author$project$Main$GotRegisterMsg, $author$project$Page$Register$view);
		case 20:
			var subModel = _v0.a;
			return A4(viewLoggedIn, subModel, $author$project$Session$LoggedIn$Settings, $author$project$Main$GotSettingsMsg, $author$project$Page$Settings$view);
		case 12:
			var subModel = _v0.b;
			return A4(viewGuest, subModel, 5, $author$project$Main$GotLoginMsg, $author$project$Page$Login$view);
		case 13:
			var subModel = _v0.a;
			return A4(
				viewLoggedIn,
				subModel,
				$author$project$Session$LoggedIn$News(subModel.bh),
				$author$project$Main$GotNewsMsg,
				$author$project$Page$News$view);
		case 10:
			var subModel = _v0.a;
			return A4(viewLoggedIn, subModel, $author$project$Session$LoggedIn$Notification, $author$project$Main$GotNotificationMsg, $author$project$Page$Notification$view);
		case 5:
			var subModel = _v0.a;
			return A4(viewLoggedIn, subModel, $author$project$Session$LoggedIn$CommunityAbout, $author$project$Main$GotCommunityAboutMsg, $author$project$Page$Community$About$view);
		case 6:
			var subModel = _v0.a;
			return A4(viewLoggedIn, subModel, $author$project$Session$LoggedIn$CommunityObjectives, $author$project$Main$GotCommunityObjectivesMsg, $author$project$Page$Community$Objectives$view);
		case 8:
			var subModel = _v0.a;
			return A4(
				viewLoggedIn,
				subModel,
				$author$project$Session$LoggedIn$CommunitySelector,
				function (_v5) {
					return $author$project$Main$Ignored;
				},
				$author$project$Page$Community$Selector$view);
		case 7:
			var subModel = _v0.a;
			return A4(viewLoggedIn, subModel, $author$project$Session$LoggedIn$CommunityEditor, $author$project$Main$GotCommunityEditorMsg, $author$project$Page$Community$New$view);
		case 9:
			var subModel = _v0.c;
			return A4(viewLoggedIn, subModel, $author$project$Session$LoggedIn$Claim, $author$project$Main$GotVerifyClaimMsg, $author$project$Page$Dashboard$Claim$view);
		case 11:
			var subModel = _v0.a;
			return A4(viewLoggedIn, subModel, $author$project$Session$LoggedIn$Dashboard, $author$project$Main$GotDashboardMsg, $author$project$Page$Dashboard$view);
		case 14:
			var subModel = _v0.a;
			return A4(viewLoggedIn, subModel, $author$project$Session$LoggedIn$Profile, $author$project$Main$GotProfileMsg, $author$project$Page$Profile$view);
		case 15:
			var subModel = _v0.a;
			return A4(viewLoggedIn, subModel, $author$project$Session$LoggedIn$ProfileEditor, $author$project$Main$GotProfileEditorMsg, $author$project$Page$Profile$Editor$view);
		case 16:
			var subModel = _v0.a;
			return A4(viewLoggedIn, subModel, $author$project$Session$LoggedIn$ProfileAddKyc, $author$project$Main$GotProfileAddKycMsg, $author$project$Page$Profile$AddKyc$view);
		case 17:
			var subModel = _v0.a;
			return A4(viewLoggedIn, subModel, $author$project$Session$LoggedIn$ProfileClaims, $author$project$Main$GotProfileClaimsMsg, $author$project$Page$Profile$Claims$view);
		case 18:
			var subModel = _v0.a;
			return A4(viewLoggedIn, subModel, $author$project$Session$LoggedIn$ProfileAddContact, $author$project$Main$GotProfileAddContactMsg, $author$project$Page$Profile$AddContact$view);
		case 21:
			var subModel = _v0.b;
			return A4(viewLoggedIn, subModel, $author$project$Session$LoggedIn$Shop, $author$project$Main$GotShopMsg, $author$project$Page$Shop$view);
		case 22:
			var subModel = _v0.b;
			return A4(viewLoggedIn, subModel, $author$project$Session$LoggedIn$ShopEditor, $author$project$Main$GotShopEditorMsg, $author$project$Page$Shop$Editor$view);
		case 23:
			var subModel = _v0.b;
			return A4(
				viewPage,
				8,
				$author$project$Session$LoggedIn$ShopViewer,
				$author$project$Main$GotShopViewerMsg,
				A2($author$project$Page$Shop$Viewer$view, model.c, subModel));
		case 24:
			var subModel = _v0.b;
			return A4(viewLoggedIn, subModel, $author$project$Session$LoggedIn$ViewTransfer, $author$project$Main$GotViewTransferScreenMsg, $author$project$Page$ViewTransfer$view);
		case 27:
			var subModel = _v0.a;
			return A4(viewLoggedIn, subModel, $author$project$Session$LoggedIn$Transfer, $author$project$Main$GotTransferMsg, $author$project$Page$Community$Transfer$view);
		default:
			var subModel = _v0.a;
			return A4(viewLoggedIn, subModel, $author$project$Session$LoggedIn$Analysis, $author$project$Main$GotAnalysisMsg, $author$project$Page$Dashboard$Analysis$view);
	}
};
var $author$project$Main$main = $elm$browser$Browser$application(
	{nj: $author$project$Main$init, os: $author$project$Main$ChangedUrl, ot: $author$project$Main$ClickedLink, pp: $author$project$Main$subscriptions, n: $author$project$Main$update, pR: $author$project$Main$view});
/*
_Platform_export({'Main':{'init':$author$project$Main$main($elm$json$Json$Decode$value)(0)}});}(this));
*/
export const Elm = {'Main':{'init':$author$project$Main$main($elm$json$Json$Decode$value)(0)}};
  